// thoothukudi/frontend/src/App.js
// import React, { useEffect, useState, useRef, useLayoutEffect, useMemo } from 'react';
import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback
} from 'react';

import axios from 'axios';
import { io } from 'socket.io-client';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './App.css';
import SimulationPage from './SimulationPage';
import * as turf from '@turf/turf';

// ---- Assets in src/assets ----
import userIcon from './assets/user-icon.png';
import stopIconImg from './assets/bus-stop.png';
// import iitmLogo from './assets/iitm-logo.png';
import iitmLogo from './assets/mint_logo.png';

// ---- Backend base URL ----
const BACKEND = process.env.REACT_APP_BACKEND_URL;
// API key is not needed on the frontend after removing ETA polling.
const FEEDBACK_URL = process.env.REACT_APP_FEEDBACK_URL || '';


// ---- Static roads URL (public/roads.geojson) ----
const ROADS_URL = `${process.env.PUBLIC_URL || ''}/roads.geojson`;

// ---- Map zoom param ----
const DEFAULT_ZOOM = 16;

// ---- Smoothing / Snap params ----
const SMOOTH_ALPHA = 0.3;
const HEADING_ALPHA = 0.35;
const SNAP_MAX_DIST_M = 20;

// Staleness threshold for under-maintenance banner
const STALE_MS = 150_000; // ~2.5 minutes

// Initial center (fallback)
// const center = { lat: 12.9915, lng: 80.2336 };
const center = { lat: 8.7642, lng: 78.1348 };

// ---------------- STOPS WITH IDS (for route math) ----------------
// const busStops = [
//   { name: 'Velachery Gate IIT Campus Stop', lat: 12.988763557585395, lng: 80.22367960515129, id: 1 },
//   { name: 'NAC2 Stop Towards GC', lat: 12.990236, lng: 80.227548, id: 2 },
//   { name: 'Nac2 Towards Velachery Stop', lat: 12.9898636, lng: 80.2271109, id: 3 },
//   { name: 'CRC Towards GC Stop', lat: 12.99089, lng: 80.230274, id: 4 },
//   { name: 'CRC Towards Velachery Stop', lat: 12.99079680, lng: 80.23016660, id: 5 },  
//   { name: 'HSB Stop Towards Velachery Stop', lat: 12.99076780, lng: 80.23168950, id: 6},
//   { name: 'HSB Stop Towards GC', lat: 12.991037, lng: 80.232065, id: 7},
//   { name: 'KV Stop Towards Main Gate', lat: 12.991868573807471, lng: 80.23367454352295, id: 8 },
//   { name: 'KV Stop Towards GC', lat: 12.991910, lng: 80.233785, id: 9 },
//   { name: 'Postoffice Stop Towards Main Gate', lat: 12.99388680, lng: 80.23428760, id: 10 },
//   { name: 'Postoffice Stop Towards GC', lat: 12.99393340, lng: 80.23459350, id: 11 },
//   { name: 'E1 Stop Towards Main Gate', lat: 12.9960173, lng: 80.2359173, id: 12 },
//   { name: 'E1 Stop Towards GC', lat: 12.996117, lng: 80.236184, id: 13},
//   { name: 'Vana Vani Stop Towards Main Gate', lat: 12.998704, lng: 80.2391799, id: 14 },
//   { name: 'Vana Vani Stop Towards GC', lat: 12.999084,   lng:  80.239380, id: 15 },
//   { name: 'D1 Stop Towards Main Gate', lat:13.002546, lng: 80.240091, id: 16},
//   { name: 'D1 Stop Towards GC', lat: 13.002679,  lng: 80.240219, id: 17 },
//   { name: 'Main Gate', lat: 13.00612964850378, lng: 80.24191299117685, id: 18 },
//   { name: 'GC Stop Towards Hostel', lat: 12.991342, lng: 80.233637, id: 19 },
//   { name: 'Library Stop', lat: 12.9907517, lng: 80.2334554, id: 20 },
//   { name: 'OAT Stop Towards Hostel', lat: 12.989257,  lng: 80.233031, id: 21},
//   { name: 'Gymkhana Stop Towards GC', lat: 12.9866372, lng: 80.2332951, id: 22},
//   { name: 'Gymkhana Stop Towards Hostel', lat: 12.986615, lng: 80.233366, id: 23 },
//   { name: 'Narmada Stop Towards GC', lat: 12.9862759, lng: 80.2350107, id: 24 },
//   { name: 'Narmada Stop Towards Hostel', lat: 12.986546, lng: 80.235301, id: 25 },
//   { name: 'Jamuna and Ganga Stand', lat: 12.986566332825637, lng: 80.23855704439099, id: 26 },
//   { name: 'RP Stand', lat: 12.990088, lng: 80.241799, id: 28},
//   { name: 'ED Stand', lat: 12.989874633072303, lng: 80.22646042038593, id: 29},
// ];

const busStops = [
  { name: "THOOTHUKUDI OLD B/S", lat: 8.803153, lng: 78.140603, id: 1 },
  { name: "VOC COLLEGE", lat: 8.795628, lng: 78.126712, id: 2 },
  { name: "3RD MILE", lat: 8.790018, lng: 78.115506, id: 3 },
  { name: "KORAMPALLAM", lat: 8.778041, lng: 78.092443, id: 4 },
  { name: "ANTHONIYARPURAM", lat: 8.773973, lng: 78.085733, id: 5 },
  { name: "THATTAPARAI JUNCTION", lat: 8.755951, lng: 78.065920, id: 6 },
  { name: "PUDHUKOTTAI", lat: 8.745961, lng: 78.053331, id: 7 },
  { name: "SIRUPADU JUNCTION", lat: 8.741241, lng: 78.057561, id: 8 },
  { name: "KOOTTAMPULI", lat: 8.721905, lng: 78.065464, id: 9 },
  { name: "SERVAIKARANMADAM", lat: 8.706851, lng: 78.055434, id: 10 },
  { name: "JAKKAMMALPURAM", lat: 8.696665, lng: 78.048089, id: 11 },
  { name: "SEBATHAIAHPURAM", lat: 8.685897, lng: 78.043820, id: 12 },
  { name: "SAWYERPURAM", lat: 8.683487, lng: 78.031302, id: 13 },
  { name: "SUBRAMANIYAPURAM", lat: 8.674211, lng: 78.026536, id: 14 },
  { name: "RAMASAMYPURAM BRIDGE", lat: 8.669235, lng: 78.031267, id: 15 },
  { name: "PERUMPADAI SASTHA KOVIL", lat: 8.671132, lng: 78.041593, id: 16 },
  { name: "RAMASAMYPURAM", lat: 8.669235, lng: 78.031267, id: 17 },
  { name: "ZAKKAMMALPURAM", lat: 8.653646, lng: 78.025552, id: 18 },
  { name: "SIRUTHONDANALLUR", lat: 8.634397, lng: 78.019538, id: 19 },
  { name: "ERAL", lat: 8.625024, lng: 78.025350, id: 20 },
  { name: "MANGALAGIRI", lat: 8.740194, lng: 78.037454, id: 21 },
  { name: "ALLIKULAM", lat: 8.761745, lng: 78.027343, id: 22 },
  { name: "THIRUVANANDHA PURAM", lat: 8.770303, lng: 78.018599, id: 23 },
  { name: "PEROORANI", lat: 8.766952, lng: 78.001463, id: 24 },
  { name: "UZHAVAR SANTHAI", lat: 8.809685, lng: 78.137081, id: 25 },
  { name: "4TH GATE", lat: 8.809664, lng: 78.133561, id: 26 },
  { name: "THRES PURAM", lat: 8.815399, lng: 78.160791, id: 27 },
  { name: "SUB COLLECTOR OFFICE", lat: 8.803112, lng: 78.158268, id: 28 },
  { name: "MILLER PURAM", lat: 8.795547, lng: 78.125969, id: 29 },
  { name: "NATTATTHI", lat: 8.668795, lng: 78.009948, id: 30 },
  { name: "PANDARAVILAI", lat: 8.657570, lng: 77.999515, id: 31 },
  { name: "PERUNKULAM", lat: 8.642502, lng: 77.997765, id: 32 },
  { name: "SIVAKALAI", lat: 8.640133, lng: 77.977687, id: 33 },
  { name: "KULAIYANKARISAL", lat: 8.719266, lng: 78.077173, id: 34 },
  { name: "SIRUPADU", lat: 8.739285, lng: 78.067272, id: 35 },
  { name: "PEIKULAM", lat: 8.706840, lng: 78.055406, id: 36 },
  { name: "SALAI", lat: 8.696664, lng: 78.048079, id: 37 },
  { name: "MANGALAKURICHI", lat: 8.625375, lng: 77.997223, id: 38 },
  { name: "THIRD MILE", lat: 8.790018, lng: 78.115506, id: 39 },
  { name: "SUBRAMANIAPURAM", lat: 8.674211, lng: 78.026536, id: 40 },
  { name: "MARKET", lat: 8.801757, lng: 78.139084, id: 41 },
  { name: "LEVANJIPURAM", lat: 8.789036, lng: 78.141181, id: 42 },
  { name: "UPPATTHU ODAI", lat: 8.771189, lng: 78.134295, id: 43 },
  { name: "MUTHAIAHPURAM", lat: 8.742466, lng: 78.123763, id: 44 },
  { name: "SPIC NAGAR", lat: 8.739716, lng: 78.122362, id: 45 },
  { name: "MULLAKADU", lat: 8.727742, lng: 78.116493, id: 46 },
  { name: "MADHIKETTAN ODAI", lat: 8.702375, lng: 78.106893, id: 47 },
  { name: "KOVANKADU JUNCTION", lat: 8.690703, lng: 78.103970, id: 48 },
  { name: "PALAIYA KAYAL", lat: 8.671247, lng: 78.094375, id: 49 },
  { name: "CHAMBER", lat: 8.649106, lng: 78.083705, id: 50 },
  { name: "MUKKANI", lat: 8.634530, lng: 78.073992, id: 51 },
  { name: "UMARIKADU", lat: 8.626411, lng: 78.059076, id: 52 },
  { name: "VAZHAVALLAN", lat: 8.631211, lng: 78.047511, id: 53 },
  { name: "WATER TANK", lat: 8.625474, lng: 78.052962, id: 54 },
  { name: "SETHUSUBRAMANIAPURAM", lat: 8.616498, lng: 78.029879, id: 55 },
  { name: "KURUMBUR", lat: 8.591328, lng: 78.044404, id: 56 },
  { name: "KURUMBUR R/S", lat: 8.585888, lng: 78.039294, id: 57 },
  { name: "AMERICAN HOSPITAL", lat: 8.813731, lng: 78.146898, id: 58 },
  { name: "KEBI", lat: 8.814688, lng: 78.151524, id: 59 },
  { name: "MURUGAN THEATRE", lat: 8.819765, lng: 78.155648, id: 60 },
  { name: "RAJA PALAIYAM", lat: 8.827343, lng: 78.153629, id: 61 },
  { name: "THALAMUTHU NAGAR", lat: 8.834404, lng: 78.152257, id: 62 },
  { name: "AROCKIAPURAM", lat: 8.825379, lng: 78.149005, id: 63 },
  { name: "SAVARAIYARPURAM", lat: 8.834448, lng: 78.144850, id: 64 },
  { name: "SAVARAIYARPURAM JUNCTION", lat: 8.839360, lng: 78.143028, id: 65 },
  { name: "STATE BANK COLONY", lat: 8.817087, lng: 78.132907, id: 66 },
  { name: "MAPPILLAIYOORANI", lat: 8.831674, lng: 78.127735, id: 67 },
  { name: "KALI KOVIL JUNCTION", lat: 8.836141, lng: 78.126243, id: 68 },
  { name: "ODAIPATTI PUDHUR", lat: 8.853648, lng: 78.120200, id: 69 },
  { name: "VELAYUTHAPURAM", lat: 8.859844, lng: 78.107125, id: 70 },
  { name: "NAINAR PURAM", lat: 8.866548, lng: 78.091527, id: 71 },
  { name: "CHILLANATTHAM", lat: 8.873462, lng: 78.071265, id: 72 },
  { name: "RAJAVIN KOVIL", lat: 8.873143, lng: 78.048237, id: 73 },
  { name: "PUTHIYAMPUTHUR", lat: 8.872962, lng: 78.032288, id: 74 },
  { name: "MUPPULIPATI", lat: 8.900392, lng: 78.025670, id: 75 },
  { name: "OTTAPIDARAM", lat: 8.909341, lng: 78.022479, id: 76 },
  { name: "THOOTHUKUDI NEW B/S", lat: 8.810793, lng: 78.138305, id: 77 },
  { name: "BYPASS", lat: 8.785154, lng: 78.106127, id: 78 },
  { name: "MADATTHOOR", lat: 8.794360, lng: 78.097304, id: 79 },
  { name: "SIPCOT COMPLEX", lat: 8.804587, lng: 78.084655, id: 80 },
  { name: "RAILWAY GATE", lat: 8.812567, lng: 78.080637, id: 81 },
  { name: "VEERAPANDIAPURAM", lat: 8.827254, lng: 78.065695, id: 82 },
  { name: "KAYALOORANI", lat: 8.840263, lng: 78.061390, id: 83 },
  { name: "SAMYNATTHAM", lat: 8.864407, lng: 78.055924, id: 84 },
  { name: "OSANOOTTHU", lat: 8.891915, lng: 77.982711, id: 85 },
  { name: "KOMBADI", lat: 8.879422, lng: 77.963106, id: 86 },
  { name: "PANDIAPURAM", lat: 8.862311, lng: 77.934601, id: 87 },
  { name: "PARAIKUTTAM", lat: 8.858671, lng: 77.924877, id: 88 },
  { name: "VADAMALAPURAM", lat: 8.860927, lng: 77.906750, id: 89 },
  { name: "MANIYACCHI", lat: 8.863306, lng: 77.894711, id: 90 },
  { name: "OTTANATTHAM", lat: 8.903988, lng: 77.898311, id: 91 },
  { name: "KALLATTHIKINARU", lat: 8.919118, lng: 77.885396, id: 92 },
  { name: "MALAIPATTI", lat: 8.936648, lng: 77.888163, id: 93 },
  { name: "ILAVELANKAL", lat: 8.946648, lng: 77.864022, id: 94 },
  { name: "IYRAVIPATTI", lat: 8.932030, lng: 77.864758, id: 95 },
  { name: "PARIVALLIKOTTAI", lat: 8.923368, lng: 77.874054, id: 96 },
  { name: "THANNEER PANDHAL", lat: 8.862521, lng: 78.116944, id: 97 },
  { name: "ARASADI JUNCTION", lat: 8.879929, lng: 78.111422, id: 98 },
  { name: "VALASAMUTHIRAM", lat: 8.902361, lng: 78.102086, id: 99 },
  { name: "KURUKKUSALAI", lat: 8.931410, lng: 78.088196, id: 100 },
  { name: "RAMACHANDRAPURAM", lat: 8.927895, lng: 78.077923, id: 101 },
  { name: "KAKKARAMPATTI JUNCTION", lat: 8.925977, lng: 78.064895, id: 102 },
  { name: "MEENAKSHIPURAM", lat: 8.923832, lng: 78.057035, id: 103 },
  { name: "OTTAPIDARAM TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 104 },
  { name: "AYYANAR KOVIL", lat: 8.902593, lng: 78.012899, id: 105 },
  { name: "KULASEKARANALLOOR", lat: 8.899773, lng: 77.981243, id: 106 },
  { name: "SOUTH AARAIKULAM", lat: 8.916444, lng: 77.974949, id: 107 },
  { name: "NORTH AARAIKULAM", lat: 8.923940, lng: 77.973027, id: 108 },
  { name: "TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 109 },
  { name: "THERKKU ARAIKULAM", lat: 8.916444, lng: 77.974949, id: 110 },
  { name: "THOMAS NAGAR", lat: 8.839335, lng: 78.143038, id: 111 },
  { name: "AYYANAR PURAM", lat: 8.859083, lng: 78.145946, id: 112 },
  { name: "JOTHI SALT", lat: 8.863746, lng: 78.147926, id: 113 },
  { name: "THARUVAIKULAM", lat: 8.896085, lng: 78.162889, id: 114 },
  { name: "PATTINAMARUTHUR", lat: 8.923039, lng: 78.179675, id: 115 },
  { name: "KALMEDU", lat: 8.943135, lng: 78.180943, id: 116 },
  { name: "CHEMICAL", lat: 8.961828, lng: 78.180195, id: 117 },
  { name: "VEPPALODAI", lat: 8.966764, lng: 78.180558, id: 118 },
  { name: "PANAIYOOR JUNCTION", lat: 8.979427, lng: 78.200198, id: 119 },
  { name: "SALT FACTORY", lat: 8.993585, lng: 78.216936, id: 120 },
  { name: "KALLOORANI", lat: 8.990696, lng: 78.231998, id: 121 },
  { name: "KEELA VAIPPAR", lat: 8.999548, lng: 78.251410, id: 122 },
  { name: "THULUKKANKULAM", lat: 9.031660, lng: 78.272640, id: 123 },
  { name: "KALAIGNANAPURAM", lat: 9.032364, lng: 78.266939, id: 124 },
  { name: "KALAIGNANAPURAM JUNCTION", lat: 9.035342, lng: 78.258363, id: 125 },
  { name: "VAIPPAR", lat: 9.025940, lng: 78.245625, id: 126 },
  { name: "SOUTHERN SALT", lat: 8.705618, lng: 78.108039, id: 127 },
  { name: "NORTH AUTHOOR", lat: 8.622425, lng: 78.070322, id: 128 },
  { name: "SOUTH AUTHOOR", lat: 8.614603, lng: 78.070710, id: 129 },
  { name: "AYYANKOVIL JUNCTION", lat: 8.598784, lng: 78.072198, id: 130 },
  { name: "MICHEAL NADAR KUDIYIRUPPU", lat: 8.601003, lng: 78.053355, id: 131 },
  { name: "PANAIYOOR GATE", lat: 8.979427, lng: 78.200198, id: 132 },
  { name: "AM PATTI", lat: 8.901119, lng: 78.144213, id: 133 },
  { name: "THERMAL STATION", lat: 8.902320, lng: 78.138007, id: 134 },
  { name: "AM PATTI JUNCTION", lat: 8.907276, lng: 78.126656, id: 135 },
  { name: "MELA MARUTHUR", lat: 8.914773, lng: 78.137694, id: 136 },
  { name: "DURAISAMYPURAM", lat: 8.938686, lng: 78.156320, id: 137 },
  { name: "SOUTH KALMEDU", lat: 8.951746, lng: 78.168851, id: 138 },
  { name: "NORTH KALMEDU", lat: 8.954783, lng: 78.170766, id: 139 },
  { name: "PANAIYOOR", lat: 8.992923, lng: 78.196242, id: 140 },
  { name: "KULATTHOOR", lat: 9.004578, lng: 78.194272, id: 141 },
  { name: "COLONY", lat: 9.008341, lng: 78.204491, id: 142 },
  { name: "ARASADI", lat: 8.870406, lng: 78.127151, id: 143 },
  { name: "KEELA ARASADI", lat: 8.877666, lng: 78.127424, id: 144 },
  { name: "KUMARAPURAM", lat: 8.899629, lng: 78.119815, id: 145 },
  { name: "PUDHUR", lat: 8.949025, lng: 78.149634, id: 146 },
  { name: "VEDANATTHAM", lat: 8.968335, lng: 78.145818, id: 147 },
  { name: "VENKATACHALAPURAM", lat: 8.979063, lng: 78.157313, id: 148 },
  { name: "MUTHUKUMARAPURAM", lat: 8.992612, lng: 78.145428, id: 149 },
  { name: "SUBRAMANIYAPURAM JUNCTION", lat: 9.015801, lng: 78.225924, id: 150 },
  { name: "THULUKKANKULAM JUNCTION", lat: 9.035332, lng: 78.258348, id: 151 },
  { name: "CHANDRAGIRI JUNCTION", lat: 8.959742, lng: 78.092867, id: 152 },
  { name: "CHANDRAGIRI", lat: 8.963758, lng: 78.074077, id: 153 },
  { name: "KOLLAMPARAMBU", lat: 8.981801, lng: 78.119157, id: 154 },
  { name: "SEITHALAI JUNCTION", lat: 8.979604, lng: 78.068883, id: 155 },
  { name: "KEELA SEITHALAI", lat: 8.988456, lng: 78.093180, id: 156 },
  { name: "KOVANKADU", lat: 8.690829, lng: 78.104060, id: 157 },
  { name: "SOUTH KOVANKADU", lat: 8.690280, lng: 78.089963, id: 158 },
  { name: "SAMBADI", lat: 8.669595, lng: 78.078838, id: 159 },
  { name: "IDAYARKADU", lat: 8.664261, lng: 78.064077, id: 160 },
  { name: "MARAMANGALAM", lat: 8.657852, lng: 78.060310, id: 161 },
  { name: "ARUMUGAMANGALAM", lat: 8.649895, lng: 78.042699, id: 162 },
  { name: "POTTALKADU", lat: 8.719686, lng: 78.102315, id: 163 },
  { name: "KATTALANKULAM", lat: 8.698745, lng: 78.007000, id: 164 },
  { name: "M. PUDHUR", lat: 8.722007, lng: 78.002788, id: 165 },
  { name: "MUDIVAITHANENDAL", lat: 8.723319, lng: 77.990336, id: 166 },
  { name: "VAGAIKULAM", lat: 8.734730, lng: 78.001301, id: 167 },
  { name: "CHETTIKULAM", lat: 8.662797, lng: 78.029329, id: 168 },
  { name: "AGARAM BRIDGE", lat: 8.661354, lng: 78.088323, id: 169 },
  { name: "AGARAM", lat: 8.659921, lng: 78.075828, id: 170 },
  { name: "KORKAI", lat: 8.642078, lng: 78.058734, id: 171 },
  { name: "AUTHOOR", lat: 8.622355, lng: 78.070341, id: 172 },
  { name: "CHERNTHAMARAM", lat: 8.634982, lng: 78.087918, id: 173 },
  { name: "DCW COLONY", lat: 8.632673, lng: 78.101623, id: 174 },
  { name: "PUNNAKAYAL", lat: 8.634945, lng: 78.117073, id: 175 },
  { name: "ATTHIMARAPATTI JUNCTION", lat: 8.741554, lng: 78.123287, id: 176 },
  { name: "ATTHIMARAPATTI", lat: 8.742208, lng: 78.104441, id: 177 },
  { name: "PON NAGAR", lat: 8.734551, lng: 78.104669, id: 178 },
  { name: "THERMAL NAGAR", lat: 8.759198, lng: 78.147347, id: 179 },
  { name: "THERMAL NAGAR JUNCTION", lat: 8.758436, lng: 78.155625, id: 180 },
  { name: "TTPP", lat: 8.755276, lng: 78.175103, id: 181 },
  { name: "CHILDREN'S PARK", lat: 8.746429, lng: 78.168838, id: 182 },
  { name: "CAMP-II", lat: 8.742206, lng: 78.163757, id: 183 },
  { name: "BULK", lat: 8.745284, lng: 78.125352, id: 184 },
  { name: "ROCH PARK", lat: 8.787746, lng: 78.159250, id: 185 },
  { name: "TTPP JUNCTION", lat: 8.755763, lng: 78.170323, id: 186 },
  { name: "VELLAPATTI", lat: 8.857643, lng: 78.160709, id: 187 },
  { name: "KAKKARAMPATTI", lat: 8.928274, lng: 78.058146, id: 188 },
  { name: "AGILANDAPURAM", lat: 8.933352, lng: 78.050208, id: 189 },
  { name: "PANCHALANKURICHI", lat: 8.932598, lng: 78.032564, id: 190 },
  { name: "KUMARAPURAM JUNCTION", lat: 8.947900, lng: 78.080564, id: 191 },
  { name: "VELLARAM JUNCTION", lat: 8.963494, lng: 78.073969, id: 192 },
  { name: "KACCHERI THALAVAIPURAM", lat: 8.965258, lng: 78.047346, id: 193 },
  { name: "VELLARAM", lat: 8.964344, lng: 78.023572, id: 194 },
  { name: "GOVERNORGIRI", lat: 8.950111, lng: 78.029486, id: 195 },
  { name: "VALLINAYAGIPURAM", lat: 8.865224, lng: 78.027444, id: 196 },
  { name: "JAMBULINGAPURAM", lat: 8.868732, lng: 78.018645, id: 197 },
  { name: "KAILASAPURAM", lat: 8.852519, lng: 77.991350, id: 198 },
  { name: "SAVARIMANGALAM", lat: 8.863055, lng: 77.985917, id: 199 },
  { name: "MELA SEITHALAI", lat: 8.981610, lng: 78.077327, id: 200 },
  { name: "JEGAVEERAPANDIAPURAM", lat: 8.983220, lng: 78.066958, id: 201 },
  { name: "THANNEER MADAM", lat: 9.009252, lng: 78.052432, id: 202 },
  { name: "KAYATHAR JUNCTION", lat: 9.012578, lng: 78.050241, id: 203 },
  { name: "EPPODHUMVENDRAN", lat: 9.020908, lng: 78.047522, id: 204 },
  { name: "KATTUNAICKENPATTI", lat: 9.014206, lng: 78.062348, id: 205 },
  { name: "ADHANOOR", lat: 9.010078, lng: 78.084646, id: 206 },
  { name: "MILAGU NATTHAM", lat: 9.012843, lng: 78.104929, id: 207 },
  { name: "MURAMBAN", lat: 8.899828, lng: 77.937996, id: 208 },
  { name: "SANGAMPATTI", lat: 8.917985, lng: 77.930898, id: 209 },
  { name: "CEYLON COLONY", lat: 8.924832, lng: 78.018458, id: 210 },
  { name: "PUTRU MURUGAN KOVIL", lat: 8.941288, lng: 78.011421, id: 211 },
  { name: "VENKETESHVARAPURAM JUNCTION", lat: 8.955754, lng: 78.003576, id: 212 },
  { name: "KEELA MUDIMAN", lat: 8.961449, lng: 77.999854, id: 213 },
  { name: "POOLNAYAKKANOOR", lat: 8.978090, lng: 77.991323, id: 214 },
  { name: "PASUVANTHANAI", lat: 8.999829, lng: 77.962640, id: 215 },
  { name: "MELA MUDIMAN", lat: 8.956969, lng: 77.986192, id: 216 },
  { name: "THALAVAIPURAM", lat: 8.877120, lng: 77.956196, id: 217 },
  { name: "KANTHASAMYPURAM", lat: 8.867032, lng: 77.949334, id: 218 },
  { name: "APC COLLEGE", lat: 8.827144, lng: 78.129349, id: 219 },
  { name: "CHINNAKANNUPURAM", lat: 8.810596, lng: 78.125385, id: 220 },
  { name: "SILVERPURAM", lat: 8.814569, lng: 78.115786, id: 221 },
  { name: "PANDARAMPATTI", lat: 8.826827, lng: 78.104347, id: 222 },
  { name: "MEELAVITTAN", lat: 8.816812, lng: 78.100737, id: 223 },
  { name: "STERLITE", lat: 8.816372, lng: 78.081444, id: 224 },
  { name: "SIPCOT", lat: 8.804587, lng: 78.084655, id: 225 },
  { name: "MADATTHOOR JUNCTION", lat: 8.794126, lng: 78.097222, id: 226 },
  { name: "THOOTHUKUDI COLLECTORATE", lat: 8.782470, lng: 78.100772, id: 227 },
  { name: "PUDHUPACCHERI COLONY", lat: 8.878480, lng: 78.007704, id: 228 },
  { name: "PUDHUPACCHERI", lat: 8.879461, lng: 78.001300, id: 229 },
  { name: "SIVALKULAM", lat: 8.879800, lng: 77.995998, id: 230 },
  { name: "PACCHAIPERUMALPURAM", lat: 8.885974, lng: 77.992908, id: 231 },
  { name: "SANKARARAJAPURAM", lat: 8.891225, lng: 77.991277, id: 232 },
  { name: "KUPPANAPURAM", lat: 8.933090, lng: 77.971928, id: 233 },
  { name: "KEELA MANGALM", lat: 8.953179, lng: 77.969344, id: 234 },
  { name: "RAMANACCHIYARPURAM", lat: 8.784893, lng: 78.061561, id: 235 },
  { name: "MUTHUSAMYPURAM", lat: 8.804241, lng: 78.049425, id: 236 },
  { name: "MADATTHUPATTI", lat: 8.807399, lng: 78.047393, id: 237 },
  { name: "NORTH SILUKKANPATTI", lat: 8.812890, lng: 78.047949, id: 238 },
  { name: "THALAIVANVADALI", lat: 8.602420, lng: 78.087655, id: 239 },
  { name: "THOOTHUKUDI RAILWAY STATION", lat: 8.805524, lng: 78.155200, id: 240 },
  { name: "KOOTTUDANKADU", lat: 8.740251, lng: 78.037525, id: 241 },
  { name: "THIRUVANANTHAPURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 242 },
  { name: "SAMATTHUVAPURAM", lat: 8.774679, lng: 77.998832, id: 243 },
  { name: "MAHILAMPURAM", lat: 8.794964, lng: 77.961453, id: 244 },
  { name: "CHEKKARAKUDI", lat: 8.794750, lng: 77.951655, id: 245 },
  { name: "THIRUVANANTHAPURAM", lat: 8.770659, lng: 78.019169, id: 246 },
  { name: "MELA CHEKKARAKUDI", lat: 8.801626, lng: 77.937492, id: 247 },
  { name: "ALLIKULAM JUNCTION", lat: 8.757367, lng: 78.025019, id: 248 },
  { name: "THIRUVANANDHA PURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 249 },
  { name: "SILUKKAN PATTI", lat: 8.768811, lng: 78.052367, id: 250 },
  { name: "KEELA THATTAPARAI", lat: 8.796529, lng: 78.027674, id: 251 },
  { name: "MELA THATTAPARAI", lat: 8.815826, lng: 78.017498, id: 252 },
  { name: "CHETTIYOORANI", lat: 8.832629, lng: 78.008857, id: 253 },
  { name: "CAMP THATTAPARAI", lat: 8.826042, lng: 78.020524, id: 254 },
  { name: "RAMACHANDRAPURAM JUNCTION", lat: 8.738491, lng: 78.031969, id: 255 },
  { name: "POTTALOORANI JUNCTION", lat: 8.735812, lng: 77.935660, id: 256 },
  { name: "POTTALOORANI VILLAGE", lat: 8.748338, lng: 77.936312, id: 257 },
  { name: "NATTHAM", lat: 8.778333, lng: 77.946701, id: 258 },
  { name: "AZHAGAPURI", lat: 8.783882, lng: 77.947625, id: 259 },
  { name: "KALLAMPARAMBU", lat: 8.806659, lng: 77.982150, id: 260 },
  { name: "VARTHAGAREDDIPATTI", lat: 8.734957, lng: 77.992819, id: 261 },
  { name: "THIMMARAJAPURAM", lat: 8.763797, lng: 77.989995, id: 262 },
  { name: "MEENAKSHIPATTI", lat: 8.690932, lng: 77.965207, id: 263 },
  { name: "ADAIKKALAPURAM", lat: 8.678001, lng: 77.969954, id: 264 },
  { name: "ANIYABARANALLUR", lat: 8.693574, lng: 77.950283, id: 265 },
  { name: "PUDHUPATTI", lat: 8.710504, lng: 77.936336, id: 266 },
  { name: "CHETTIMALLANPATTI", lat: 8.720235, lng: 77.929900, id: 267 },
  { name: "RAMANATHAPURAM", lat: 8.728507, lng: 77.925542, id: 268 },
  { name: "ELLANAICKENPATTI", lat: 8.733465, lng: 77.921950, id: 269 },
  { name: "DEIVASEYALPURAM", lat: 8.737467, lng: 77.918961, id: 270 },
  { name: "THATTAPARAI VILLAGE", lat: 8.755998, lng: 78.065854, id: 271 },
  { name: "ST. MARY'S COLLEGE", lat: 8.811006, lng: 78.161694, id: 272 },
  { name: "NEW HARBOUR", lat: 8.754486, lng: 78.192477, id: 273 },
  { name: "UMARIKOTTAI", lat: 8.822473, lng: 77.990482, id: 274 },
  { name: "VARADHARAJAPURAM", lat: 8.843064, lng: 77.979707, id: 275 },
  { name: "CHOCKALINGAPURAM", lat: 8.812871, lng: 77.966345, id: 276 },
  { name: "KALANKARAI", lat: 8.756500, lng: 78.095112, id: 277 },
  { name: "PUDHUKOTTAI 2", lat: 8.747258, lng: 78.054971, id: 278 },
  { name: "4TH GATE 2", lat: 8.812727, lng: 78.136672, id: 279 },
  { name: "ST. ANN'S HOSPITAL", lat: 8.877320, lng: 78.025851, id: 280 },
  { name: "SUBRAMANIYAPURAM 2", lat: 8.918478, lng: 78.094426, id: 281 },
  { name: "AMERICAN HOSPITAL 2", lat: 8.813561, lng: 78.148444, id: 282 },
  { name: "ZAKKAMMALPURAM 2", lat: 8.916639, lng: 78.175262, id: 283 },
  { name: "KALLOORANI", lat: 8.992222, lng: 78.233057, id: 284 },
  { name: "THULUKKANKULAM", lat: 9.031716, lng: 78.272534, id: 285 },
  { name: "SALT FACTORY 2", lat: 8.996121, lng: 78.240638, id: 286 },
  { name: "ZAKKAMMALPURAM 3", lat: 8.926665, lng: 78.149020, id: 287 },
  { name: "SUBRAMANIYAPURAM 3", lat: 9.025170, lng: 78.225853, id: 288 },
  { name: "CHANDRAGIRI", lat: 8.964871, lng: 78.096262, id: 289 },
  { name: "WATER TANK 2", lat: 8.669583, lng: 78.078905, id: 290 },
  { name: "KUMARAPURAM 2", lat: 8.688057, lng: 78.016423, id: 291 },
  { name: "ARASADI JUNCTION 2", lat: 8.868788, lng: 78.115271, id: 292 },
  { name: "THERMAL NAGAR", lat: 8.759213, lng: 78.147452, id: 293 },
  { name: "CHEMICAL", lat: 8.766517, lng: 78.156992, id: 294 },
  { name: "CHANDRAGIRI JUNCTION 2", lat: 8.963747, lng: 78.074074, id: 295 },
  { name: "S.PUTHUR", lat: 8.869224, lng: 77.997689, id: 296 },
  { name: "KAILASAPURAM", lat: 8.786357, lng: 78.077069, id: 297 },
  { name: "MUTHUSAMYPURAM", lat: 8.803626, lng: 78.050614, id: 298 },
  { name: "ARASADI JUNCTION 3", lat: 8.873258, lng: 78.152850, id: 299 },
  { name: "ARASADI 2", lat: 8.878458, lng: 78.118427, id: 300 },
  { name: "DURAISAMYPURAM 2", lat: 8.938193, lng: 78.156085, id: 301 },
  { name: "KULATTHOOR 2", lat: 9.002945, lng: 78.194484, id: 302 },
  { name: "PUDHUR 2", lat: 8.794559, lng: 77.993581, id: 303 },
  { name: "THALAVAIPURAM 2", lat: 8.798284, lng: 77.974711, id: 304 },
  { name: "RAMACHANDRAPURAM 2", lat: 8.731531, lng: 78.030510, id: 305 },
  { name: "PUDHUR 3", lat: 8.709596, lng: 78.002355, id: 306 }
];

// // Route sequences by stop id
// const Hostel_to_Main   = [26, 24, 22, 20, 6, 5, 3, 1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// const Main_to_Hostel   = [18, 17, 15, 13, 11, 9, 6, 5, 3, 1, 2, 4, 7, 19, 21, 23, 25, 26];
// const Velachery_to_Main= [1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// const Velachery_to_Hostel=[1, 2, 4, 7, 19, 21, 23, 25, 26];
// const Hotel_to_Velachery=[26, 24, 22, 20, 6, 5, 3, 1];
// const Main_to_Velachery=[18, 17, 15, 13, 11, 9, 6, 5, 3, 1];
// const RP_to_ED         = [28, 22, 21, 20, 6, 5, 3, 29];
// const ED_to_RP         = [29, 2, 4, 7, 19, 21, 23, 28];

// const ROUTES = [
//   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate", ids: Hostel_to_Main },
//   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel", ids: Main_to_Hostel },
//   { code: "VG_MAIN",     label: "Velachery Gate → Main Gate", ids: Velachery_to_Main },
//   { code: "VG_HOSTEL",   label: "Velachery Gate → Hostel", ids: Velachery_to_Hostel },
//   { code: "MAIN_VG",     label: "Main Gate → Velachery Gate", ids: Main_to_Velachery },
//   { code: "HOSTEL_VG",   label: "Hostel → Velachery Gate", ids: Hotel_to_Velachery },
//   { code: "RP_ED",       label: "Research Park → ED", ids: RP_to_ED },
//   { code: "ED_RP",       label: "ED → Research Park", ids: ED_to_RP },
// ];

// // ---- Route aliases (frontend only) ----
// // Backend only knows canonical codes: HOSTEL_MAIN, MAIN_HOSTEL, RP_ED, ED_RP
// // But filters can still expose Velachery labels.
// // Aliases map to canonical backend codes.
// const ROUTE_ALIAS_TO_CANONICAL = {
//   VG_MAIN: "HOSTEL_MAIN",
//   HOSTEL_VG: "HOSTEL_MAIN",
//   MAIN_VG: "MAIN_HOSTEL",
//   VG_HOSTEL: "MAIN_HOSTEL",
// };

// function canonicalRoute(code) {
//   return ROUTE_ALIAS_TO_CANONICAL[code] || code;
// }
// // Routes the admin can assign in backend (only canonical codes)
// const ADMIN_ROUTES = [
//   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate" },
//   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel" },
//   { code: "RP_ED", label: "Research Park → ED" },
//   { code: "ED_RP", label: "ED → Research Park" },
// ];


// // ---- Vehicles for driverRoute select ----
// const VEHICLES = [
//   "TN07DH1368","TN07DH1317","TN07DH1315","EV09","TN07DH1360","TN07DH1391","EV08","TN07DD5574",
//   "TN07CX8698","TN07DD3376","TN07CX8200","TN07DD3360","EV-12","EV-14","EV-15","EV-10","EV-05",
//   "EV-07","EV-06","EV-02","EV-03","EV-11","EV-01","EV-13","TN07CX8119"
// ];

// ---------------- VEHICLE ROUTES + ROUTE SCHEDULE DATA ----------------
// Generated from your TCNC route table and the uploaded stop-timesheet ZIP.
// ROUTES = user-facing route numbers (52-B, 53-A, ...)
// ROUTE_TRIPS = detailed stop-by-stop trips used for schedule display and route progress.
const VEHICLE_ROUTE_MAP = {
  "TN72N2675": "4",
  "TN72N2656": "52-B",
  "TN72N2460": "52-C",
  "TN72N1895": "52-D",
  "TN72N2589": "52-E",
  "TN72N2368": "52-F",
  "TN72N2682": "52-G",
  "TN72N1905": "52-K",
  "TN72N1774": "53-A",
  "TN72N2556": "53-B",
  "TN72N2684": "53-C",
  "TN72N1903": "53-D",
  "TN72N2526": "53-E",
  "TN72N1737": "53-F",
  "TN72N1751": "54-A",
  "TN72N1854": "54-B",
  "TN72N2643": "54-C",
  "TN72N1910": "54-D",
  "TN72N2536": "54-F",
  "TN72N1912": "54-G",
  "TN72N2706": "55-A",
  "TN72N2700": "55-B",
  "TN72N2549": "55-C",
  "TN72N2416": "55-D",
  "TN72N1757": "55-E",
  "TN72N2541": "55-F",
  "TN72N1906": "55-G",
  "TN72N1688": "55-H",
  "TN72N2671": "55-I",
  "TN72N1919": "55-J",
  "TN72N2568": "56-A",
  "TN72N1884": "56-B",
  "TN72N2617": "56-C",
  "TN72N2622": "56-D",
  "TN72N2016": "56-E",
  "TN68N0707": "56-F",
  "TN72N2562": "56-G",
  "TN72N1875": "57-A",
  "TN72N2687": "57-D",
  "TN72N2022": "58-A",
  "TN72N2570": "58-B",
  "TN72N2620": "58-C"
};

const ROUTES = [
  {
    "code": "52-A",
    "label": "52-A — 13 scheduled trips",
    "tripCount": 13
  },
  {
    "code": "52-B",
    "label": "52-B — 10 scheduled trips",
    "tripCount": 10
  },
  {
    "code": "52-C",
    "label": "52-C — 18 scheduled trips",
    "tripCount": 18
  },
  {
    "code": "52-D",
    "label": "52-D — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "52-E",
    "label": "52-E — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "52-F",
    "label": "52-F — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "52-G",
    "label": "52-G — 18 scheduled trips",
    "tripCount": 18
  },
  {
    "code": "52-K",
    "label": "52-K — 17 scheduled trips",
    "tripCount": 17
  },
  {
    "code": "53-A",
    "label": "53-A — 16 scheduled trips",
    "tripCount": 16
  },
  {
    "code": "53-B",
    "label": "53-B — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "53-C",
    "label": "53-C — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "53-D",
    "label": "53-D — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "53-E",
    "label": "53-E — 10 scheduled trips",
    "tripCount": 10
  },
  {
    "code": "53-F",
    "label": "53-F — 16 scheduled trips",
    "tripCount": 16
  },
  {
    "code": "54-A",
    "label": "54-A — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "54-B",
    "label": "54-B — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "54-C",
    "label": "54-C — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "54-D",
    "label": "54-D — 16 scheduled trips",
    "tripCount": 16
  },
  {
    "code": "54-F",
    "label": "54-F — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "54-G",
    "label": "54-G — 20 scheduled trips",
    "tripCount": 20
  },
  {
    "code": "55-A",
    "label": "55-A — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "55-B",
    "label": "55-B — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "55-C",
    "label": "55-C — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "55-D",
    "label": "55-D — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "55-E",
    "label": "55-E — 10 scheduled trips",
    "tripCount": 10
  },
  {
    "code": "55-F",
    "label": "55-F — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "55-G",
    "label": "55-G — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "55-H",
    "label": "55-H — 20 scheduled trips",
    "tripCount": 20
  },
  {
    "code": "55-I",
    "label": "55-I — 10 scheduled trips",
    "tripCount": 10
  },
  {
    "code": "55-J",
    "label": "55-J — 20 scheduled trips",
    "tripCount": 20
  },
  {
    "code": "56-A",
    "label": "56-A — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "56-B",
    "label": "56-B — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "56-C",
    "label": "56-C — 10 scheduled trips",
    "tripCount": 10
  },
  {
    "code": "56-D",
    "label": "56-D — 10 scheduled trips",
    "tripCount": 10
  },
  {
    "code": "56-E",
    "label": "56-E — 13 scheduled trips",
    "tripCount": 13
  },
  {
    "code": "56-F",
    "label": "56-F — 19 scheduled trips",
    "tripCount": 19
  },
  {
    "code": "56-G",
    "label": "56-G — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "57-A",
    "label": "57-A — 22 scheduled trips",
    "tripCount": 22
  },
  {
    "code": "57-D",
    "label": "57-D — 24 scheduled trips",
    "tripCount": 24
  },
  {
    "code": "58-A",
    "label": "58-A — 14 scheduled trips",
    "tripCount": 14
  },
  {
    "code": "58-B",
    "label": "58-B — 16 scheduled trips",
    "tripCount": 16
  },
  {
    "code": "58-C",
    "label": "58-C — 12 scheduled trips",
    "tripCount": 12
  },
  {
    "code": "4",
    "label": "4 — schedule not available",
    "tripCount": 0
  }
];

const ADMIN_ROUTES = ROUTES;

const ROUTE_TRIPS = [
  {
    "id": "52-A-1-1",
    "routeNo": "52-A",
    "code": "52/P52A-1",
    "tripCode": "52/P52A-152-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PERUMPADAI SASTHA KOVIL",
    "service": "TOWN ORDINARY",
    "startTime": "11:45 AM",
    "endTime": "01:00 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      16
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "11:50 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:54 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:03 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:06 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:15 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 1",
        "time": "12:21 PM",
        "id": 7
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "12:23 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:31 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "12:37 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "12:41 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "12:45 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "12:50 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "12:53 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "12:56 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "PERUMPADAI SASTHA KOVIL",
        "time": "01:00 PM",
        "id": 16
      }
    ]
  },
  {
    "id": "52-A-2-2",
    "routeNo": "52-A",
    "code": "52/P52A-1",
    "tripCode": "52/P52A-152-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "PERUMPADAI SASTHA KOVIL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:05 PM",
    "endTime": "02:00 PM",
    "ids": [
      16,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      7,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PERUMPADAI SASTHA KOVIL",
        "time": "01:05 PM",
        "id": 16
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "01:07 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "01:09 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "01:12 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "01:15 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "01:18 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "01:21 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "01:26 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "01:31 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 1",
        "time": "01:33 PM",
        "id": 7
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:37 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:44 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:46 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:52 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "01:55 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-A-3-3",
    "routeNo": "52-A",
    "code": "52/P52A-2",
    "tripCode": "52/P52A-252-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "02:05 PM",
    "endTime": "03:00 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "02:09 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:12 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:20 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:22 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:29 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:33 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:35 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:41 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "02:46 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "02:50 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "02:53 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "02:57 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "03:00 PM",
        "id": 40
      }
    ]
  },
  {
    "id": "52-A-4-4",
    "routeNo": "52-A",
    "code": "52/P52A-3",
    "tripCode": "52/P52A-352-ATORD18U4",
    "order": 4,
    "direction": "U",
    "from": "SUBRAMANIYAPURAM",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "03:05 PM",
    "endTime": "04:30 PM",
    "ids": [
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "SUBRAMANIAPURAM 1",
        "time": "03:05 PM",
        "id": 40
      },
      {
        "no": 2,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "03:15 PM",
        "id": 17
      },
      {
        "no": 3,
        "name": "ZAKKAMMALPURAM 1",
        "time": "03:41 PM",
        "id": 18
      },
      {
        "no": 4,
        "name": "SIRUTHONDANALLUR",
        "time": "04:12 PM",
        "id": 19
      },
      {
        "no": 5,
        "name": "ERAL",
        "time": "04:30 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-A-5-5",
    "routeNo": "52-A",
    "code": "52/P52A-4",
    "tripCode": "52/P52A-452-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "ERAL",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "04:40 PM",
    "endTime": "06:00 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      21,
      22,
      23,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "04:40 PM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SIRUTHONDANALLUR",
        "time": "04:44 PM",
        "id": 19
      },
      {
        "no": 3,
        "name": "ZAKKAMMALPURAM 1",
        "time": "04:51 PM",
        "id": 18
      },
      {
        "no": 4,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "04:57 PM",
        "id": 17
      },
      {
        "no": 5,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:59 PM",
        "id": 40
      },
      {
        "no": 6,
        "name": "SAWYERPURAM",
        "time": "05:03 PM",
        "id": 13
      },
      {
        "no": 7,
        "name": "SEBATHAIAHPURAM",
        "time": "05:08 PM",
        "id": 12
      },
      {
        "no": 8,
        "name": "SALAI",
        "time": "05:12 PM",
        "id": 37
      },
      {
        "no": 9,
        "name": "SERVAIKARANMADAM",
        "time": "05:17 PM",
        "id": 10
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "05:23 PM",
        "id": 9
      },
      {
        "no": 11,
        "name": "SIRUPADU JUNCTION",
        "time": "05:31 PM",
        "id": 8
      },
      {
        "no": 12,
        "name": "PUDHUKOTTAI 2",
        "time": "05:33 PM",
        "id": 278
      },
      {
        "no": 13,
        "name": "MANGALAGIRI",
        "time": "05:40 PM",
        "id": 21
      },
      {
        "no": 14,
        "name": "ALLIKULAM",
        "time": "05:49 PM",
        "id": 22
      },
      {
        "no": 15,
        "name": "THIRUVANANDHA PURAM",
        "time": "05:53 PM",
        "id": 23
      },
      {
        "no": 16,
        "name": "PEROORANI",
        "time": "06:00 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "52-A-6-6",
    "routeNo": "52-A",
    "code": "52/P52A-5",
    "tripCode": "52/P52A-552-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "PERRORANI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 PM",
    "endTime": "07:20 PM",
    "ids": [
      24,
      23,
      22,
      21,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40
    ],
    "stops": [
      {
        "no": 12,
        "name": "PEROORANI",
        "time": "06:15 PM",
        "id": 24
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "06:21 PM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "06:26 PM",
        "id": 22
      },
      {
        "no": 9,
        "name": "MANGALAGIRI",
        "time": "06:36 PM",
        "id": 21
      },
      {
        "no": 8,
        "name": "PUDHUKOTTAI 2",
        "time": "06:43 PM",
        "id": 278
      },
      {
        "no": 7,
        "name": "SIRUPADU JUNCTION",
        "time": "06:46 PM",
        "id": 8
      },
      {
        "no": 6,
        "name": "KOOTTAMPULI",
        "time": "06:54 PM",
        "id": 9
      },
      {
        "no": 5,
        "name": "SERVAIKARANMADAM",
        "time": "07:01 PM",
        "id": 10
      },
      {
        "no": 4,
        "name": "SALAI",
        "time": "07:06 PM",
        "id": 37
      },
      {
        "no": 3,
        "name": "SEBATHAIAHPURAM",
        "time": "07:10 PM",
        "id": 12
      },
      {
        "no": 2,
        "name": "SAWYERPURAM",
        "time": "07:15 PM",
        "id": 13
      },
      {
        "no": 1,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:20 PM",
        "id": 40
      }
    ]
  },
  {
    "id": "52-A-7-7",
    "routeNo": "52-A",
    "code": "52/P52A-2",
    "tripCode": "52/P52A-252-ATORD18D7",
    "order": 7,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 PM",
    "endTime": "08:45 PM",
    "ids": [
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:30 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:34 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "07:38 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:43 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:48 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:55 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:03 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:05 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:11 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:21 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:24 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:34 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:38 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-A-8-8",
    "routeNo": "52-A",
    "code": "52/P52A-1",
    "tripCode": "52/P52A-152-ATORD18U8",
    "order": 8,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PERUMPADAI SASTHA KOVIL",
    "service": "TOWN ORDINARY",
    "startTime": "09:30 PM",
    "endTime": "10:30 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      16
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:34 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:37 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:45 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:47 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:54 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 1",
        "time": "09:59 PM",
        "id": 7
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:01 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "10:06 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "10:11 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "10:15 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "10:18 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "10:22 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "10:25 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "10:27 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "PERUMPADAI SASTHA KOVIL",
        "time": "10:30 PM",
        "id": 16
      }
    ]
  },
  {
    "id": "52-A-9-9",
    "routeNo": "52-A",
    "code": "52/P52A-6",
    "tripCode": "52/P52A-652-ATORD18D9",
    "order": 9,
    "direction": "D",
    "from": "PERUMPADAI SASTHA KOVIL",
    "to": "UZHAVAR SANTHAI",
    "service": "TOWN ORDINARY",
    "startTime": "04:30 AM",
    "endTime": "06:40 AM",
    "ids": [
      16,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1,
      26,
      25
    ],
    "stops": [
      {
        "no": 18,
        "name": "PERUMPADAI SASTHA KOVIL",
        "time": "04:30 AM",
        "id": 16
      },
      {
        "no": 17,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "04:36 AM",
        "id": 17
      },
      {
        "no": 16,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:39 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "04:45 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SEBATHAIAHPURAM",
        "time": "04:53 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SALAI",
        "time": "04:59 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SERVAIKARANMADAM",
        "time": "05:07 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "KOOTTAMPULI",
        "time": "05:17 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SIRUPADU JUNCTION",
        "time": "05:29 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "05:33 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:41 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "05:56 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "06:01 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "06:16 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "VOC COLLEGE",
        "time": "06:23 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:32 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:37 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "UZHAVAR SANTHAI",
        "time": "06:40 AM",
        "id": 25
      }
    ]
  },
  {
    "id": "52-A-10-10",
    "routeNo": "52-A",
    "code": "52/P52A-8",
    "tripCode": "52/P52A-852-ATORD18U10",
    "order": 10,
    "direction": "U",
    "from": "UZHAVAR SANTHAI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:55 AM",
    "endTime": "08:00 AM",
    "ids": [
      25,
      26,
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40
    ],
    "stops": [
      {
        "no": 1,
        "name": "UZHAVAR SANTHAI",
        "time": "06:55 AM",
        "id": 25
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:56 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:59 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "VOC COLLEGE",
        "time": "07:03 AM",
        "id": 2
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "07:07 AM",
        "id": 39
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "07:15 AM",
        "id": 4
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "07:18 AM",
        "id": 5
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:26 AM",
        "id": 6
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "07:31 AM",
        "id": 278
      },
      {
        "no": 10,
        "name": "SIRUPADU JUNCTION",
        "time": "07:33 AM",
        "id": 8
      },
      {
        "no": 11,
        "name": "KOOTTAMPULI",
        "time": "07:39 AM",
        "id": 9
      },
      {
        "no": 12,
        "name": "SERVAIKARANMADAM",
        "time": "07:45 AM",
        "id": 10
      },
      {
        "no": 13,
        "name": "SALAI",
        "time": "07:49 AM",
        "id": 37
      },
      {
        "no": 14,
        "name": "SEBATHAIAHPURAM",
        "time": "07:52 AM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "07:56 AM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:00 AM",
        "id": 40
      }
    ]
  },
  {
    "id": "52-A-11-11",
    "routeNo": "52-A",
    "code": "52/P52A-7",
    "tripCode": "52/P52A-752-ATORD18D11",
    "order": 11,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THRES PURAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 AM",
    "endTime": "09:10 AM",
    "ids": [
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1,
      28,
      27
    ],
    "stops": [
      {
        "no": 16,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:05 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "08:08 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SEBATHAIAHPURAM",
        "time": "08:11 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SALAI",
        "time": "08:15 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SERVAIKARANMADAM",
        "time": "08:18 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "KOOTTAMPULI",
        "time": "08:23 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SIRUPADU JUNCTION",
        "time": "08:29 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "08:31 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:35 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "08:43 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "08:45 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "08:53 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "VOC COLLEGE",
        "time": "08:56 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:01 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:06 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "09:10 AM",
        "id": 27
      }
    ]
  },
  {
    "id": "52-A-12-12",
    "routeNo": "52-A",
    "code": "52/P52A-7",
    "tripCode": "52/P52A-752-ATORD18U12",
    "order": 12,
    "direction": "U",
    "from": "THRES PURAM",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:20 AM",
    "endTime": "10:20 AM",
    "ids": [
      27,
      28,
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40
    ],
    "stops": [
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "09:20 AM",
        "id": 27
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:23 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:28 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "VOC COLLEGE",
        "time": "09:32 AM",
        "id": 2
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "09:35 AM",
        "id": 39
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "09:42 AM",
        "id": 4
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "09:44 AM",
        "id": 5
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:51 AM",
        "id": 6
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "09:55 AM",
        "id": 278
      },
      {
        "no": 10,
        "name": "SIRUPADU JUNCTION",
        "time": "09:57 AM",
        "id": 8
      },
      {
        "no": 11,
        "name": "KOOTTAMPULI",
        "time": "10:02 AM",
        "id": 9
      },
      {
        "no": 12,
        "name": "SERVAIKARANMADAM",
        "time": "10:07 AM",
        "id": 10
      },
      {
        "no": 13,
        "name": "SALAI",
        "time": "10:10 AM",
        "id": 37
      },
      {
        "no": 14,
        "name": "SEBATHAIAHPURAM",
        "time": "10:13 AM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "10:17 AM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SUBRAMANIAPURAM 1",
        "time": "10:20 AM",
        "id": 40
      }
    ]
  },
  {
    "id": "52-A-13-13",
    "routeNo": "52-A",
    "code": "52/P52A-2",
    "tripCode": "52/P52A-252-ATORD18D13",
    "order": 13,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 AM",
    "endTime": "11:30 AM",
    "ids": [
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "10:30 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "10:33 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "10:37 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "10:40 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "10:44 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "10:50 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:56 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:58 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:02 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:11 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:13 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:21 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "11:25 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-B-1-14",
    "routeNo": "52-B",
    "code": "52/P52B-2",
    "tripCode": "52/P52B-252-BTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PERUNKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "02:15 PM",
    "endTime": "03:25 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:19 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:23 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:30 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:32 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:40 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:44 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:46 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:52 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "02:57 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "03:01 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "03:04 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "03:08 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "03:11 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "03:16 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "03:20 PM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "03:25 PM",
        "id": 32
      }
    ]
  },
  {
    "id": "52-B-2-15",
    "routeNo": "52-B",
    "code": "52/P52B-2",
    "tripCode": "52/P52B-252-BTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "PERUNKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:40 PM",
    "endTime": "04:50 PM",
    "ids": [
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "03:40 PM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "03:44 PM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "03:48 PM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "03:53 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "03:56 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "04:00 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "04:03 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "04:07 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "04:12 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "04:18 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:20 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:24 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:32 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:34 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:41 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:45 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-B-3-16",
    "routeNo": "52-B",
    "code": "52/P52B-1",
    "tripCode": "52/P52B-152-BTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SIVAKALAI",
    "service": "TOWN ORDINARY",
    "startTime": "05:05 PM",
    "endTime": "06:20 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      33
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:09 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:13 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:20 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:22 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:30 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:34 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "05:36 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "05:42 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "05:47 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "05:50 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "05:54 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "05:57 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "06:00 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "06:05 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "06:09 PM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "06:14 PM",
        "id": 32
      },
      {
        "no": 19,
        "name": "SIVAKALAI",
        "time": "06:20 PM",
        "id": 33
      }
    ]
  },
  {
    "id": "52-B-4-17",
    "routeNo": "52-B",
    "code": "52/P52B-1",
    "tripCode": "52/P52B-152-BTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SIVAKALAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:35 PM",
    "endTime": "07:40 PM",
    "ids": [
      33,
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "SIVAKALAI",
        "time": "06:35 PM",
        "id": 33
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "06:39 PM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "06:43 PM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "06:47 PM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "06:51 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "06:54 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "06:57 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:00 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:03 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:07 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:13 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:14 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:18 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:24 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:26 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:33 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:35 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-B-5-18",
    "routeNo": "52-B",
    "code": "52/P52B-1",
    "tripCode": "52/P52B-152-BTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SIVAKALAI",
    "service": "TOWN ORDINARY",
    "startTime": "07:55 PM",
    "endTime": "09:25 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      33
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:55 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:00 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:04 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:13 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:16 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:25 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:30 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:32 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "08:39 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "08:45 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "08:49 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "08:53 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "08:58 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:01 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "09:07 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "09:12 PM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "09:18 PM",
        "id": 32
      },
      {
        "no": 19,
        "name": "SIVAKALAI",
        "time": "09:25 PM",
        "id": 33
      }
    ]
  },
  {
    "id": "52-B-6-19",
    "routeNo": "52-B",
    "code": "52/P52B-1",
    "tripCode": "52/P52B-152-BTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "SIVAKALAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 AM",
    "endTime": "08:30 AM",
    "ids": [
      33,
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "SIVAKALAI",
        "time": "07:10 AM",
        "id": 33
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "07:16 AM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "07:20 AM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "07:25 AM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:30 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:33 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "07:37 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:41 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:45 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:50 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:56 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:58 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:03 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:11 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:13 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:21 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:25 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-B-7-20",
    "routeNo": "52-B",
    "code": "52/P52B-2",
    "tripCode": "52/P52B-252-BTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PERUNKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:45 AM",
    "endTime": "10:00 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:50 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:53 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:01 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:04 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:12 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:16 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "09:18 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "09:25 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "09:30 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "09:34 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "09:38 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "09:42 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:45 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "09:50 AM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "09:55 AM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "10:00 AM",
        "id": 32
      }
    ]
  },
  {
    "id": "52-B-8-21",
    "routeNo": "52-B",
    "code": "52/P52B-2",
    "tripCode": "52/P52B-252-BTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PERUNKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:15 AM",
    "endTime": "11:20 AM",
    "ids": [
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "10:15 AM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "10:19 AM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "10:23 AM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "10:27 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "10:30 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "10:33 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "10:37 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "10:40 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "10:45 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:50 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:52 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:56 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:03 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:05 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:12 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:15 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-B-9-22",
    "routeNo": "52-B",
    "code": "52/P52B-2",
    "tripCode": "52/P52B-252-BTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PERUNKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:35 AM",
    "endTime": "12:45 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:39 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:43 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:50 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:52 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:00 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:04 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "12:06 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:12 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "12:17 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "12:21 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "12:24 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "12:28 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "12:31 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "12:36 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "12:40 PM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "12:45 PM",
        "id": 32
      }
    ]
  },
  {
    "id": "52-B-10-23",
    "routeNo": "52-B",
    "code": "52/P52B-2",
    "tripCode": "52/P52B-252-BTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "PERUNKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:00 PM",
    "endTime": "02:10 PM",
    "ids": [
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "01:00 PM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "01:04 PM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "01:08 PM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "01:13 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "01:16 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "01:20 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "01:23 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "01:27 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "01:32 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "01:38 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:40 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:44 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:52 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:54 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:01 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:05 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-C-1-24",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 AM",
    "endTime": "06:45 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:18 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:20 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:26 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:28 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:33 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:36 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "06:38 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "06:42 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "06:45 AM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-2-25",
    "routeNo": "52-C",
    "code": "52/P52C-2",
    "tripCode": "52/P52C-252-CTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THRES PURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:55 AM",
    "endTime": "07:45 AM",
    "ids": [
      34,
      9,
      35,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1,
      28,
      27
    ],
    "stops": [
      {
        "no": 13,
        "name": "KULAIYANKARISAL",
        "time": "06:55 AM",
        "id": 34
      },
      {
        "no": 12,
        "name": "KOOTTAMPULI",
        "time": "06:58 AM",
        "id": 9
      },
      {
        "no": 11,
        "name": "SIRUPADU",
        "time": "07:03 AM",
        "id": 35
      },
      {
        "no": 10,
        "name": "SIRUPADU JUNCTION",
        "time": "07:06 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "07:07 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:11 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "07:19 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "07:21 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "07:28 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "MILLER PURAM",
        "time": "07:31 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:36 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:41 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "07:45 AM",
        "id": 27
      }
    ]
  },
  {
    "id": "52-C-3-26",
    "routeNo": "52-C",
    "code": "52/P52C-4",
    "tripCode": "52/P52C-452-CTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THRES PURAM",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:55 AM",
    "endTime": "09:05 AM",
    "ids": [
      27,
      28,
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      35,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "07:55 AM",
        "id": 27
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:59 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:06 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "MILLER PURAM",
        "time": "08:13 AM",
        "id": 29
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "08:18 AM",
        "id": 39
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "08:28 AM",
        "id": 4
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "08:31 AM",
        "id": 5
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:42 AM",
        "id": 6
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "08:47 AM",
        "id": 278
      },
      {
        "no": 10,
        "name": "SIRUPADU",
        "time": "08:53 AM",
        "id": 35
      },
      {
        "no": 11,
        "name": "KOOTTAMPULI",
        "time": "09:00 AM",
        "id": 9
      },
      {
        "no": 12,
        "name": "KULAIYANKARISAL",
        "time": "09:05 AM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-4-27",
    "routeNo": "52-C",
    "code": "52/P52C-3",
    "tripCode": "52/P52C-352-CTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "SUB COLLECTOR OFFICE",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 AM",
    "endTime": "10:00 AM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1,
      28
    ],
    "stops": [
      {
        "no": 11,
        "name": "KULAIYANKARISAL",
        "time": "09:10 AM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "09:13 AM",
        "id": 9
      },
      {
        "no": 9,
        "name": "SIRUPADU JUNCTION",
        "time": "09:20 AM",
        "id": 8
      },
      {
        "no": 8,
        "name": "PUDHUKOTTAI 2",
        "time": "09:22 AM",
        "id": 278
      },
      {
        "no": 7,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:26 AM",
        "id": 6
      },
      {
        "no": 6,
        "name": "ANTHONIYARPURAM",
        "time": "09:35 AM",
        "id": 5
      },
      {
        "no": 5,
        "name": "KORAMPALLAM",
        "time": "09:37 AM",
        "id": 4
      },
      {
        "no": 4,
        "name": "3RD MILE",
        "time": "09:45 AM",
        "id": 39
      },
      {
        "no": 3,
        "name": "MILLER PURAM",
        "time": "09:49 AM",
        "id": 29
      },
      {
        "no": 2,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:54 AM",
        "id": 1
      },
      {
        "no": 1,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:00 AM",
        "id": 28
      }
    ]
  },
  {
    "id": "52-C-5-28",
    "routeNo": "52-C",
    "code": "52/P52C-3",
    "tripCode": "52/P52C-352-CTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "SUB COLLECTOR OFFICE",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "10:05 AM",
    "endTime": "11:10 AM",
    "ids": [
      28,
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:05 AM",
        "id": 28
      },
      {
        "no": 2,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:12 AM",
        "id": 1
      },
      {
        "no": 3,
        "name": "MILLER PURAM",
        "time": "10:18 AM",
        "id": 29
      },
      {
        "no": 4,
        "name": "3RD MILE",
        "time": "10:23 AM",
        "id": 39
      },
      {
        "no": 5,
        "name": "KORAMPALLAM",
        "time": "10:34 AM",
        "id": 4
      },
      {
        "no": 6,
        "name": "ANTHONIYARPURAM",
        "time": "10:37 AM",
        "id": 5
      },
      {
        "no": 7,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:48 AM",
        "id": 6
      },
      {
        "no": 8,
        "name": "PUDHUKOTTAI 2",
        "time": "10:53 AM",
        "id": 278
      },
      {
        "no": 9,
        "name": "SIRUPADU JUNCTION",
        "time": "10:56 AM",
        "id": 8
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "11:05 AM",
        "id": 9
      },
      {
        "no": 11,
        "name": "KULAIYANKARISAL",
        "time": "11:10 AM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-6-29",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:15 AM",
    "endTime": "11:55 AM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "11:15 AM",
        "id": 34
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "11:18 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "11:24 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:26 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:30 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:37 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:39 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:47 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:50 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:55 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-C-7-30",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "12:00 PM",
    "endTime": "12:40 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "12:04 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:07 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:15 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:17 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:24 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:28 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "12:30 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:36 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "12:40 PM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-8-31",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:45 PM",
    "endTime": "01:20 PM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "12:45 PM",
        "id": 34
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:47 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "12:53 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:54 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:58 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:04 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:06 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:13 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:15 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-C-9-32",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "01:35 PM",
    "endTime": "02:25 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:40 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:44 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:54 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:56 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:06 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:11 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:13 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:20 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "02:25 PM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-10-33",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:30 PM",
    "endTime": "03:10 PM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "02:30 PM",
        "id": 34
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:33 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:39 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:41 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:45 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:52 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:54 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:02 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:05 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-C-11-34",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "03:15 PM",
    "endTime": "04:00 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:20 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:23 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:32 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:34 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:43 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:47 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "03:49 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "03:56 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "04:00 PM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-12-35",
    "routeNo": "52-C",
    "code": "52/P52C-4",
    "tripCode": "52/P52C-452-CTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THRES PURAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:10 PM",
    "endTime": "05:25 PM",
    "ids": [
      34,
      9,
      35,
      278,
      6,
      5,
      4,
      39,
      29,
      1,
      28,
      27
    ],
    "stops": [
      {
        "no": 12,
        "name": "KULAIYANKARISAL",
        "time": "04:10 PM",
        "id": 34
      },
      {
        "no": 11,
        "name": "KOOTTAMPULI",
        "time": "04:15 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SIRUPADU",
        "time": "04:22 PM",
        "id": 35
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "04:28 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:34 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "04:45 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "04:49 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "05:00 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "MILLER PURAM",
        "time": "05:05 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:12 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:19 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "05:25 PM",
        "id": 27
      }
    ]
  },
  {
    "id": "52-C-13-36",
    "routeNo": "52-C",
    "code": "52/P52C-2",
    "tripCode": "52/P52C-252-CTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THRES PURAM",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 PM",
    "endTime": "06:10 PM",
    "ids": [
      27,
      28,
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      35,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "05:30 PM",
        "id": 27
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:32 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:36 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "MILLER PURAM",
        "time": "05:40 PM",
        "id": 29
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "05:43 PM",
        "id": 39
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "05:48 PM",
        "id": 4
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "05:50 PM",
        "id": 5
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:56 PM",
        "id": 6
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "05:59 PM",
        "id": 278
      },
      {
        "no": 10,
        "name": "SIRUPADU JUNCTION",
        "time": "06:01 PM",
        "id": 8
      },
      {
        "no": 11,
        "name": "SIRUPADU",
        "time": "06:03 PM",
        "id": 35
      },
      {
        "no": 12,
        "name": "KOOTTAMPULI",
        "time": "06:07 PM",
        "id": 9
      },
      {
        "no": 13,
        "name": "KULAIYANKARISAL",
        "time": "06:10 PM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-14-37",
    "routeNo": "52-C",
    "code": "52/P52C-3",
    "tripCode": "52/P52C-352-CTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "SUB COLLECTOR OFFICE",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 PM",
    "endTime": "07:00 PM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1,
      28
    ],
    "stops": [
      {
        "no": 11,
        "name": "KULAIYANKARISAL",
        "time": "06:15 PM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "06:18 PM",
        "id": 9
      },
      {
        "no": 9,
        "name": "SIRUPADU JUNCTION",
        "time": "06:24 PM",
        "id": 8
      },
      {
        "no": 8,
        "name": "PUDHUKOTTAI 2",
        "time": "06:26 PM",
        "id": 278
      },
      {
        "no": 7,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:30 PM",
        "id": 6
      },
      {
        "no": 6,
        "name": "ANTHONIYARPURAM",
        "time": "06:37 PM",
        "id": 5
      },
      {
        "no": 5,
        "name": "KORAMPALLAM",
        "time": "06:39 PM",
        "id": 4
      },
      {
        "no": 4,
        "name": "3RD MILE",
        "time": "06:47 PM",
        "id": 39
      },
      {
        "no": 3,
        "name": "MILLER PURAM",
        "time": "06:50 PM",
        "id": 29
      },
      {
        "no": 2,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:55 PM",
        "id": 1
      },
      {
        "no": 1,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:00 PM",
        "id": 28
      }
    ]
  },
  {
    "id": "52-C-15-38",
    "routeNo": "52-C",
    "code": "52/P52C-3",
    "tripCode": "52/P52C-352-CTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "SUB COLLECTOR OFFICE",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 PM",
    "endTime": "08:25 PM",
    "ids": [
      28,
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:10 PM",
        "id": 28
      },
      {
        "no": 2,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:18 PM",
        "id": 1
      },
      {
        "no": 3,
        "name": "MILLER PURAM",
        "time": "07:25 PM",
        "id": 29
      },
      {
        "no": 4,
        "name": "3RD MILE",
        "time": "07:31 PM",
        "id": 39
      },
      {
        "no": 5,
        "name": "KORAMPALLAM",
        "time": "07:43 PM",
        "id": 4
      },
      {
        "no": 6,
        "name": "ANTHONIYARPURAM",
        "time": "07:47 PM",
        "id": 5
      },
      {
        "no": 7,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:59 PM",
        "id": 6
      },
      {
        "no": 8,
        "name": "PUDHUKOTTAI 2",
        "time": "08:06 PM",
        "id": 278
      },
      {
        "no": 9,
        "name": "SIRUPADU JUNCTION",
        "time": "08:09 PM",
        "id": 8
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "08:19 PM",
        "id": 9
      },
      {
        "no": 11,
        "name": "KULAIYANKARISAL",
        "time": "08:25 PM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-16-39",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:30 PM",
    "endTime": "09:35 PM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "08:30 PM",
        "id": 34
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "08:35 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:45 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:48 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:54 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:06 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:10 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:22 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:27 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-C-17-40",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18U17",
    "order": 17,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULAIYANKARISAL",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 PM",
    "endTime": "10:30 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      34
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:45 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:49 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:59 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:01 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:11 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:16 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:18 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "10:25 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "10:30 PM",
        "id": 34
      }
    ]
  },
  {
    "id": "52-C-18-41",
    "routeNo": "52-C",
    "code": "52/P52C-1",
    "tripCode": "52/P52C-152-CTORD18D18",
    "order": 18,
    "direction": "D",
    "from": "KULAIYANKARISAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:25 PM",
    "endTime": "06:10 AM",
    "ids": [
      34,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KULAIYANKARISAL",
        "time": "10:25 PM",
        "id": 34
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "11:04 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "12:12 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:34 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:19 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:47 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:12 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:37 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:16 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-D-1-42",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "06:45 AM",
    "endTime": "08:00 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:49 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:53 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:01 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:03 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:11 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:15 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:17 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:23 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:29 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:33 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "07:36 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:40 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:43 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:45 AM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "07:50 AM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "07:56 AM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "08:00 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-D-2-43",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:30 AM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "08:15 AM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "08:18 AM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "08:24 AM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "08:29 AM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:31 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "08:34 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "08:38 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "08:41 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "08:45 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "08:51 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:57 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:59 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:03 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:11 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:13 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:21 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:25 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-D-3-44",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "11:05 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:40 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:45 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:54 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:57 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:06 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:11 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:14 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "10:21 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "10:28 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "10:32 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "10:36 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "10:41 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "10:45 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "10:47 AM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "10:53 AM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "11:01 AM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "11:05 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-D-4-45",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:10 AM",
    "endTime": "12:30 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "11:10 AM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "11:13 AM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "11:19 AM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "11:25 AM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "11:27 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "11:30 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "11:34 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "11:38 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "11:42 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "11:48 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "11:55 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:57 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:01 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:10 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:12 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:20 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "12:24 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-D-5-46",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "12:50 PM",
    "endTime": "02:05 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "12:54 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:58 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:06 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:08 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:16 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:20 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "01:22 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "01:28 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "01:34 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "01:38 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "01:41 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "01:45 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "01:48 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "01:50 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "01:55 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "02:01 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "02:05 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-D-6-47",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:10 PM",
    "endTime": "03:25 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "02:10 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "02:13 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "02:19 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "02:24 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "02:26 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "02:29 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "02:33 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "02:36 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "02:40 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:46 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:52 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:54 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:58 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:06 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:08 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:16 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "03:20 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-D-7-48",
    "routeNo": "52-D",
    "code": "52/P52D-2",
    "tripCode": "52/P52D-252-DTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PANDARAVILAI",
    "service": "TOWN ORDINARY",
    "startTime": "03:30 PM",
    "endTime": "04:35 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "03:34 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:38 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:45 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:47 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:55 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:59 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "04:01 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "04:07 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "04:12 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "04:15 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "04:19 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "04:22 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:25 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "04:30 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "04:35 PM",
        "id": 31
      }
    ]
  },
  {
    "id": "52-D-8-49",
    "routeNo": "52-D",
    "code": "52/P52D-2",
    "tripCode": "52/P52D-252-DTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PANDARAVILAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:45 PM",
    "endTime": "05:50 PM",
    "ids": [
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "04:45 PM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "04:49 PM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:54 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "04:57 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "05:00 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "05:04 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "05:07 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "05:12 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "05:18 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:20 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:24 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:32 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:34 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:41 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:45 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-D-9-50",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "05:55 PM",
    "endTime": "07:25 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:55 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:00 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:05 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:14 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:17 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:26 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:31 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "06:34 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "06:41 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "06:48 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "06:52 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "06:56 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:01 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:05 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:07 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "07:13 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "07:21 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "07:25 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-D-10-51",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 PM",
    "endTime": "08:45 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "07:50 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "07:52 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "07:56 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "08:00 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:02 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "08:04 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "08:07 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "08:09 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "08:12 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "08:16 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:21 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:22 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:25 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:31 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:33 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:38 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:41 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-D-11-52",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "08:50 PM",
    "endTime": "10:05 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:54 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:58 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:06 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:08 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:16 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:20 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "09:22 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "09:28 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "09:34 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "09:38 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "09:41 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "09:45 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:48 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "09:50 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "09:55 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "10:01 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "10:05 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-D-12-53",
    "routeNo": "52-D",
    "code": "52/P52D-1",
    "tripCode": "52/P52D-152-DTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:10 PM",
    "endTime": "06:30 AM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "10:10 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "10:32 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "11:12 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "11:45 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "11:59 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "12:20 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "12:45 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "01:08 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "01:33 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:10 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:51 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:05 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:32 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:26 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:41 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:33 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:58 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-E-1-54",
    "routeNo": "52-E",
    "code": "52/P52E-1",
    "tripCode": "52/P52E-152-ETORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "05:35 AM",
    "endTime": "06:45 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:39 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:42 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:50 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:52 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:59 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:03 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "06:05 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "06:11 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "06:16 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "06:19 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "06:23 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "06:26 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "06:29 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "06:31 AM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "06:36 AM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "06:41 AM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "06:45 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-E-2-55",
    "routeNo": "52-E",
    "code": "52/P52E-1",
    "tripCode": "52/P52E-152-ETORD18D2",
    "order": 2,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:05 AM",
    "endTime": "08:15 AM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "07:05 AM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "07:08 AM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "07:13 AM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:18 AM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:20 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:23 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "07:26 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:30 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:33 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:38 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:44 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:46 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:50 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:57 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:59 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:07 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:10 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-E-3-56",
    "routeNo": "52-E",
    "code": "52/P52E-3",
    "tripCode": "52/P52E-352-ETORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "08:35 AM",
    "endTime": "10:00 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      38,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:39 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:43 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:50 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:53 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:01 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:05 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "09:07 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "09:13 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "09:18 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "09:22 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "09:25 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "09:29 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:32 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "09:37 AM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "09:42 AM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "09:46 AM",
        "id": 32
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "09:51 AM",
        "id": 38
      },
      {
        "no": 20,
        "name": "ERAL",
        "time": "10:00 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-E-4-57",
    "routeNo": "52-E",
    "code": "52/P52E-3",
    "tripCode": "52/P52E-352-ETORD18D4",
    "order": 4,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:10 AM",
    "endTime": "11:40 AM",
    "ids": [
      20,
      38,
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "ERAL",
        "time": "10:10 AM",
        "id": 20
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "10:18 AM",
        "id": 38
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "10:24 AM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "10:28 AM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "10:33 AM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "10:39 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "10:42 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "10:46 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "10:49 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "10:53 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "10:59 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "11:05 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:08 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:12 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:20 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:23 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:31 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:34 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-E-5-58",
    "routeNo": "52-E",
    "code": "52/P52E-3",
    "tripCode": "52/P52E-352-ETORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "11:45 AM",
    "endTime": "01:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      38,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:49 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:53 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:00 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:03 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:11 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:15 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "12:17 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:23 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "12:28 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "12:32 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "12:35 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "12:39 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "12:42 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "12:47 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "12:52 PM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "12:56 PM",
        "id": 32
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "01:01 PM",
        "id": 38
      },
      {
        "no": 20,
        "name": "ERAL",
        "time": "01:10 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-E-6-59",
    "routeNo": "52-E",
    "code": "52/P52E-3",
    "tripCode": "52/P52E-352-ETORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:15 PM",
    "endTime": "02:45 PM",
    "ids": [
      20,
      38,
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "ERAL",
        "time": "01:15 PM",
        "id": 20
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "01:23 PM",
        "id": 38
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "01:29 PM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "01:33 PM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "01:38 PM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "01:44 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "01:47 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "01:51 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "01:54 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "01:58 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "02:04 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "02:10 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:13 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:17 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:25 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:28 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:36 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:39 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-E-7-60",
    "routeNo": "52-E",
    "code": "52/P52E-2",
    "tripCode": "52/P52E-252-ETORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "02:50 PM",
    "endTime": "04:15 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      37,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:54 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:57 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:04 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:06 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:13 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:17 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "03:19 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "03:25 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "03:30 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "03:33 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "03:36 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "03:40 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "03:42 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "03:44 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "SALAI",
        "time": "03:53 PM",
        "id": 37
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "04:12 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "04:15 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-E-8-61",
    "routeNo": "52-E",
    "code": "52/P52E-2",
    "tripCode": "52/P52E-252-ETORD18D8",
    "order": 8,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:20 PM",
    "endTime": "05:40 PM",
    "ids": [
      20,
      19,
      37,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "04:20 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "04:22 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "SALAI",
        "time": "04:40 PM",
        "id": 37
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "04:48 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:50 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "04:52 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "04:56 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "04:59 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "05:02 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "05:06 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "05:12 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:13 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:17 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:24 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:26 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:32 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:35 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-E-9-62",
    "routeNo": "52-E",
    "code": "52/P52E-4",
    "tripCode": "52/P52E-452-ETORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:50 PM",
    "endTime": "06:45 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:54 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:57 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:05 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:07 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:14 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:18 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "06:20 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "06:26 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "06:31 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "06:35 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "06:38 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "06:42 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "06:45 PM",
        "id": 40
      }
    ]
  },
  {
    "id": "52-E-10-63",
    "routeNo": "52-E",
    "code": "52/P52E-4",
    "tripCode": "52/P52E-452-ETORD18D10",
    "order": 10,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 PM",
    "endTime": "07:45 PM",
    "ids": [
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "06:50 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "06:52 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "06:56 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "06:59 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:03 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:08 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:14 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:16 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:20 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:27 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:29 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:37 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:40 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-E-11-64",
    "routeNo": "52-E",
    "code": "52/P52E-1",
    "tripCode": "52/P52E-152-ETORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 PM",
    "endTime": "09:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:55 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:59 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:07 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:09 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:18 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:22 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:24 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "08:31 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "08:37 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "08:41 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "08:45 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "08:49 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:52 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "08:54 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "09:00 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "09:06 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "09:10 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-E-12-65",
    "routeNo": "52-E",
    "code": "52/P52E-1",
    "tripCode": "52/P52E-152-ETORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 PM",
    "endTime": "10:30 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "09:15 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "09:18 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "09:24 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "09:29 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:31 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "09:34 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "09:38 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "09:41 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "09:45 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "09:51 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "09:57 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:59 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:03 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:11 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:13 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:21 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:25 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-F-1-66",
    "routeNo": "52-F",
    "code": "52/P52F-3",
    "tripCode": "52/P52F-352-FTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "06:20 AM",
    "endTime": "07:50 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      38,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:25 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:28 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:36 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:39 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:47 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:51 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "06:54 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:00 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:06 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:10 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "07:13 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:17 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:20 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "07:26 AM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "07:31 AM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "07:35 AM",
        "id": 32
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "07:41 AM",
        "id": 38
      },
      {
        "no": 20,
        "name": "ERAL",
        "time": "07:50 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-F-2-67",
    "routeNo": "52-F",
    "code": "52/P52F-3",
    "tripCode": "52/P52F-352-FTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 AM",
    "endTime": "09:30 AM",
    "ids": [
      20,
      38,
      32,
      31,
      30,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "ERAL",
        "time": "08:00 AM",
        "id": 20
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "08:08 AM",
        "id": 38
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "08:14 AM",
        "id": 32
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "08:18 AM",
        "id": 31
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "08:23 AM",
        "id": 30
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:29 AM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "08:32 AM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "08:36 AM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "08:39 AM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "08:43 AM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "08:49 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "08:55 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:58 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:02 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:10 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:13 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:21 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:24 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-F-3-68",
    "routeNo": "52-F",
    "code": "52/P52F-6",
    "tripCode": "52/P52F-652-FTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SIRUPADU",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "10:20 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      35
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:41 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:45 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:55 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:58 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:08 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:13 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:16 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "SIRUPADU",
        "time": "10:20 AM",
        "id": 35
      }
    ]
  },
  {
    "id": "52-F-4-69",
    "routeNo": "52-F",
    "code": "52/P52F-6",
    "tripCode": "52/P52F-652-FTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SIRUPADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:25 AM",
    "endTime": "11:15 AM",
    "ids": [
      35,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "SIRUPADU",
        "time": "10:25 AM",
        "id": 35
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "10:29 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:31 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:37 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:48 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:52 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:03 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:08 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:15 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-F-5-70",
    "routeNo": "52-F",
    "code": "52/P52F-1",
    "tripCode": "52/P52F-152-FTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "11:20 AM",
    "endTime": "12:50 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:25 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:30 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:39 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:42 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:51 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:56 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "11:59 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:06 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "12:13 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "12:17 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "12:21 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "12:26 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "12:30 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "12:32 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "12:38 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "12:46 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "12:50 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-F-6-71",
    "routeNo": "52-F",
    "code": "52/P52F-2",
    "tripCode": "52/P52F-252-FTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:00 PM",
    "endTime": "02:20 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "01:00 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "01:03 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "01:09 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "01:15 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "01:17 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "01:20 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "01:24 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "01:28 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "01:32 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "01:38 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "01:45 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:47 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:51 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:00 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:02 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:10 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:14 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-F-7-72",
    "routeNo": "52-F",
    "code": "52/P52F-2",
    "tripCode": "52/P52F-252-FTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "02:30 PM",
    "endTime": "03:45 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:34 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:38 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:46 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:48 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:56 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:00 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "03:02 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "03:08 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "03:14 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "03:18 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "03:21 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "03:25 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "03:28 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "03:30 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "03:35 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "03:41 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "03:45 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-F-8-73",
    "routeNo": "52-F",
    "code": "52/P52F-2",
    "tripCode": "52/P52F-252-FTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:40 PM",
    "endTime": "05:20 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "03:40 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "03:44 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "03:52 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "03:59 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:01 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "04:06 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "04:11 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "04:15 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "04:20 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "04:28 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "04:36 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:39 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:44 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:55 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:58 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:08 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:13 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-F-9-74",
    "routeNo": "52-F",
    "code": "52/P52F-1",
    "tripCode": "52/P52F-152-FTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 PM",
    "endTime": "06:45 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      18,
      19,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:34 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:38 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:46 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:48 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:56 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:00 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "06:02 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "06:08 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "06:14 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "06:18 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "06:21 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "06:25 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "06:28 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "06:30 PM",
        "id": 17
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "06:35 PM",
        "id": 18
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "06:41 PM",
        "id": 19
      },
      {
        "no": 18,
        "name": "ERAL",
        "time": "06:45 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-F-10-75",
    "routeNo": "52-F",
    "code": "52/P52F-1",
    "tripCode": "52/P52F-152-FTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 PM",
    "endTime": "08:00 PM",
    "ids": [
      20,
      19,
      18,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "ERAL",
        "time": "06:50 PM",
        "id": 20
      },
      {
        "no": 17,
        "name": "SIRUTHONDANALLUR",
        "time": "06:53 PM",
        "id": 19
      },
      {
        "no": 16,
        "name": "ZAKKAMMALPURAM 1",
        "time": "06:58 PM",
        "id": 18
      },
      {
        "no": 15,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:03 PM",
        "id": 17
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:05 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "07:08 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "07:11 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:15 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:18 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:23 PM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:29 PM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:31 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:35 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:42 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:44 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:52 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:55 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-F-11-76",
    "routeNo": "52-F",
    "code": "52/P52F-4",
    "tripCode": "52/P52F-452-FTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:35 PM",
    "endTime": "09:35 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:40 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:43 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:51 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:53 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:02 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:06 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "09:08 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "09:14 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "09:20 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "09:24 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "09:27 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "09:31 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:35 PM",
        "id": 40
      }
    ]
  },
  {
    "id": "52-F-12-77",
    "routeNo": "52-F",
    "code": "52/P52F-5",
    "tripCode": "52/P52F-552-FTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 PM",
    "endTime": "06:15 AM",
    "ids": [
      40,
      13,
      12,
      37,
      10,
      9,
      8,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "09:40 PM",
        "id": 40
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "10:07 PM",
        "id": 13
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "10:40 PM",
        "id": 12
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "11:11 PM",
        "id": 37
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "11:44 PM",
        "id": 10
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "12:32 AM",
        "id": 9
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "01:27 AM",
        "id": 8
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:44 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:21 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:31 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:52 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:00 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:31 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-G-1-78",
    "routeNo": "52-G",
    "code": "52/P52G-1",
    "tripCode": "52/P52G-152-GTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 AM",
    "endTime": "08:30 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      38,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:23 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:26 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:33 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:35 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:41 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:44 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "07:46 AM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "07:51 AM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "07:55 AM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "07:58 AM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "08:01 AM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "08:04 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "08:07 AM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "08:11 AM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "08:15 AM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "08:19 AM",
        "id": 32
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "08:23 AM",
        "id": 38
      },
      {
        "no": 20,
        "name": "ERAL",
        "time": "08:30 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-2-79",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "08:40 AM",
    "endTime": "09:40 AM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "08:40 AM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "08:46 AM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "08:48 AM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "08:51 AM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "08:55 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "08:59 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:05 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:10 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:13 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:20 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:23 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:24 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:31 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:36 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:39 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-G-3-80",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 AM",
    "endTime": "10:50 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      52,
      53,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:50 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:53 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:58 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:05 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:06 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:09 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "10:16 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "10:19 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "10:24 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "10:30 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "10:34 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "10:38 AM",
        "id": 52
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "10:41 AM",
        "id": 53
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "10:43 AM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "10:50 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-4-81",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18U4",
    "order": 4,
    "direction": "U",
    "from": "ERAL",
    "to": "KURUMBUR R/S",
    "service": "TOWN ORDINARY",
    "startTime": "10:55 AM",
    "endTime": "11:10 AM",
    "ids": [
      20,
      55,
      56,
      57
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "10:55 AM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "10:58 AM",
        "id": 55
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "11:07 AM",
        "id": 56
      },
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "11:10 AM",
        "id": 57
      }
    ]
  },
  {
    "id": "52-G-5-82",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18D5",
    "order": 5,
    "direction": "D",
    "from": "KURUMBUR R/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "11:20 AM",
    "endTime": "11:35 AM",
    "ids": [
      57,
      56,
      55,
      20
    ],
    "stops": [
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "11:20 AM",
        "id": 57
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "11:22 AM",
        "id": 56
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "11:31 AM",
        "id": 55
      },
      {
        "no": 1,
        "name": "ERAL",
        "time": "11:35 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-6-83",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "11:40 AM",
    "endTime": "12:40 PM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "11:40 AM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "11:46 AM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "11:48 AM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "11:51 AM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "11:55 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "11:59 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "12:05 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:10 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "12:13 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "12:20 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "12:23 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "12:24 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "12:31 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "12:36 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "12:39 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-G-7-84",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "12:50 PM",
    "endTime": "01:50 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      52,
      53,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "12:50 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "12:53 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "12:58 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:05 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:06 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:09 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "01:16 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:19 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "01:24 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "01:30 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "01:34 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "01:38 PM",
        "id": 52
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "01:41 PM",
        "id": 53
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "01:43 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "01:50 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-8-85",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18U8",
    "order": 8,
    "direction": "U",
    "from": "ERAL",
    "to": "KURUMBUR R/S",
    "service": "TOWN ORDINARY",
    "startTime": "01:55 PM",
    "endTime": "02:10 PM",
    "ids": [
      20,
      55,
      56,
      57
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "01:55 PM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "01:58 PM",
        "id": 55
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "02:07 PM",
        "id": 56
      },
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "02:10 PM",
        "id": 57
      }
    ]
  },
  {
    "id": "52-G-9-86",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18D9",
    "order": 9,
    "direction": "D",
    "from": "KURUMBUR R/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "02:30 PM",
    "endTime": "02:45 PM",
    "ids": [
      57,
      56,
      55,
      20
    ],
    "stops": [
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "02:30 PM",
        "id": 57
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "02:32 PM",
        "id": 56
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "02:41 PM",
        "id": 55
      },
      {
        "no": 1,
        "name": "ERAL",
        "time": "02:45 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-10-87",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "02:50 PM",
    "endTime": "03:50 PM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "02:50 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "02:56 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "02:58 PM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "03:01 PM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "03:05 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "03:09 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "03:15 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:20 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "03:23 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:30 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "03:33 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "03:34 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "03:41 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "03:46 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "03:49 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-G-11-88",
    "routeNo": "52-G",
    "code": "52/P52G-1",
    "tripCode": "52/P52G-152-GTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "04:00 PM",
    "endTime": "05:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      8,
      9,
      10,
      37,
      12,
      13,
      40,
      30,
      31,
      32,
      38,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:03 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:06 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:13 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:15 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:21 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:24 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "SIRUPADU JUNCTION",
        "time": "04:26 PM",
        "id": 8
      },
      {
        "no": 9,
        "name": "KOOTTAMPULI",
        "time": "04:31 PM",
        "id": 9
      },
      {
        "no": 10,
        "name": "SERVAIKARANMADAM",
        "time": "04:35 PM",
        "id": 10
      },
      {
        "no": 11,
        "name": "SALAI",
        "time": "04:38 PM",
        "id": 37
      },
      {
        "no": 12,
        "name": "SEBATHAIAHPURAM",
        "time": "04:41 PM",
        "id": 12
      },
      {
        "no": 13,
        "name": "SAWYERPURAM",
        "time": "04:44 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:47 PM",
        "id": 40
      },
      {
        "no": 15,
        "name": "NATTATTHI",
        "time": "04:51 PM",
        "id": 30
      },
      {
        "no": 16,
        "name": "PANDARAVILAI",
        "time": "04:55 PM",
        "id": 31
      },
      {
        "no": 17,
        "name": "PERUNKULAM",
        "time": "04:59 PM",
        "id": 32
      },
      {
        "no": 18,
        "name": "MANGALAKURICHI",
        "time": "05:03 PM",
        "id": 38
      },
      {
        "no": 20,
        "name": "ERAL",
        "time": "05:10 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-12-89",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18U12",
    "order": 12,
    "direction": "U",
    "from": "ERAL",
    "to": "KURUMBUR R/S",
    "service": "TOWN ORDINARY",
    "startTime": "05:15 PM",
    "endTime": "05:30 PM",
    "ids": [
      20,
      55,
      56,
      57
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "05:15 PM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "05:18 PM",
        "id": 55
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "05:27 PM",
        "id": 56
      },
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "05:30 PM",
        "id": 57
      }
    ]
  },
  {
    "id": "52-G-13-90",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18D13",
    "order": 13,
    "direction": "D",
    "from": "KURUMBUR R/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "05:40 PM",
    "endTime": "06:00 PM",
    "ids": [
      57,
      56,
      55,
      20
    ],
    "stops": [
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "05:40 PM",
        "id": 57
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "05:43 PM",
        "id": 56
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "05:55 PM",
        "id": 55
      },
      {
        "no": 1,
        "name": "ERAL",
        "time": "06:00 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-14-91",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "06:05 PM",
    "endTime": "07:00 PM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "06:05 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "06:11 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "06:12 PM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "06:15 PM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "06:19 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "06:23 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "06:28 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:33 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:36 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:42 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:45 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:45 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:52 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:56 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:59 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-G-15-92",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 PM",
    "endTime": "08:10 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      52,
      53,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:10 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:13 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:18 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:25 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:26 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:29 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:36 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:39 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "07:44 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "07:50 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "07:54 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "07:58 PM",
        "id": 52
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "08:01 PM",
        "id": 53
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "08:03 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "08:10 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-16-93",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18U16",
    "order": 16,
    "direction": "U",
    "from": "ERAL",
    "to": "KURUMBUR R/S",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 PM",
    "endTime": "08:30 PM",
    "ids": [
      20,
      55,
      56,
      57
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "08:15 PM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "08:18 PM",
        "id": 55
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "08:27 PM",
        "id": 56
      },
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "08:30 PM",
        "id": 57
      }
    ]
  },
  {
    "id": "52-G-17-94",
    "routeNo": "52-G",
    "code": "52/P52G-3",
    "tripCode": "52/P52G-352-GTORD18D17",
    "order": 17,
    "direction": "D",
    "from": "KURUMBUR R/S",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "08:35 PM",
    "endTime": "08:45 PM",
    "ids": [
      57,
      56,
      55,
      20
    ],
    "stops": [
      {
        "no": 5,
        "name": "KURUMBUR R/S",
        "time": "08:35 PM",
        "id": 57
      },
      {
        "no": 4,
        "name": "KURUMBUR",
        "time": "08:36 PM",
        "id": 56
      },
      {
        "no": 2,
        "name": "SETHUSUBRAMANIAPURAM",
        "time": "08:42 PM",
        "id": 55
      },
      {
        "no": 1,
        "name": "ERAL",
        "time": "08:45 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-G-18-95",
    "routeNo": "52-G",
    "code": "52/P52G-2",
    "tripCode": "52/P52G-252-GTORD18D18",
    "order": 18,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "08:50 PM",
    "endTime": "06:50 AM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "08:50 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "09:56 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "10:15 PM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "10:45 PM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "11:25 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "12:07 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "01:07 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:59 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "02:28 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:34 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:06 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:13 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "05:27 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:13 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:45 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-1-96",
    "routeNo": "52-K",
    "code": "52/P52K-1",
    "tripCode": "52/P52K-152-KTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "THALAMUTHU NAGAR",
    "service": "TOWN ORDINARY",
    "startTime": "06:20 AM",
    "endTime": "06:30 AM",
    "ids": [
      1,
      279,
      58,
      59,
      60,
      61,
      62
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 2",
        "time": "06:22 AM",
        "id": 279
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 1",
        "time": "06:24 AM",
        "id": 58
      },
      {
        "no": 4,
        "name": "KEBI",
        "time": "06:25 AM",
        "id": 59
      },
      {
        "no": 5,
        "name": "MURUGAN THEATRE",
        "time": "06:26 AM",
        "id": 60
      },
      {
        "no": 6,
        "name": "RAJA PALAIYAM",
        "time": "06:28 AM",
        "id": 61
      },
      {
        "no": 7,
        "name": "THALAMUTHU NAGAR",
        "time": "06:30 AM",
        "id": 62
      }
    ]
  },
  {
    "id": "52-K-2-97",
    "routeNo": "52-K",
    "code": "52/P52K-2",
    "tripCode": "52/P52K-252-KTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "THALAMUTHU NAGAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:40 AM",
    "endTime": "07:10 AM",
    "ids": [
      62,
      111,
      64,
      63,
      58,
      279,
      1
    ],
    "stops": [
      {
        "no": 7,
        "name": "THALAMUTHU NAGAR",
        "time": "06:40 AM",
        "id": 62
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:45 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:48 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:53 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 1",
        "time": "06:59 AM",
        "id": 58
      },
      {
        "no": 2,
        "name": "4TH GATE 2",
        "time": "07:04 AM",
        "id": 279
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-3-98",
    "routeNo": "52-K",
    "code": "52/P52K-3",
    "tripCode": "52/P52K-352-KTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 AM",
    "endTime": "07:50 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:21 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:23 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:26 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:27 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:31 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:34 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:37 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:42 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:46 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:50 AM",
        "id": 74
      }
    ]
  },
  {
    "id": "52-K-4-99",
    "routeNo": "52-K",
    "code": "52/P52K-3",
    "tripCode": "52/P52K-352-KTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 AM",
    "endTime": "09:00 AM",
    "ids": [
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:00 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:06 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:15 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:24 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:31 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:37 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:44 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:46 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:53 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:56 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-5-100",
    "routeNo": "52-K",
    "code": "52/P52K-4",
    "tripCode": "52/P52K-452-KTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 AM",
    "endTime": "10:15 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:18 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:20 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:25 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:26 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:32 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:37 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:42 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:49 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:56 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:02 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:04 AM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "10:11 AM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "10:15 AM",
        "id": 76
      }
    ]
  },
  {
    "id": "52-K-6-101",
    "routeNo": "52-K",
    "code": "52/P52K-4",
    "tripCode": "52/P52K-452-KTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 AM",
    "endTime": "11:30 AM",
    "ids": [
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "10:30 AM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "10:33 AM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:40 AM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:42 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:48 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:55 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:02 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:07 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:12 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:18 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:19 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:24 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:26 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-7-102",
    "routeNo": "52-K",
    "code": "52/P52K-5",
    "tripCode": "52/P52K-552-KTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "THOOTHUKUDI NEW B/S",
    "service": "TOWN ORDINARY",
    "startTime": "11:35 AM",
    "endTime": "04:00 PM",
    "ids": [
      1,
      26,
      77
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:30 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI NEW B/S",
        "time": "04:00 PM",
        "id": 77
      }
    ]
  },
  {
    "id": "52-K-8-103",
    "routeNo": "52-K",
    "code": "52/P52K-5",
    "tripCode": "52/P52K-552-KTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "THOOTHUKUDI NEW B/S",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "11:50 AM",
    "endTime": "12:00 PM",
    "ids": [
      77,
      26,
      1
    ],
    "stops": [
      {
        "no": 3,
        "name": "THOOTHUKUDI NEW B/S",
        "time": "11:50 AM",
        "id": 77
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:53 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-9-104",
    "routeNo": "52-K",
    "code": "52/P52K-6",
    "tripCode": "52/P52K-652-KTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "12:10 PM",
    "endTime": "12:55 PM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      280,
      75,
      76
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "12:13 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:16 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "12:18 PM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "12:21 PM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "12:24 PM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "12:26 PM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "12:31 PM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "12:34 PM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "12:40 PM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "12:42 PM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:46 PM",
        "id": 74
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:47 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:52 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:55 PM",
        "id": 76
      }
    ]
  },
  {
    "id": "52-K-10-105",
    "routeNo": "52-K",
    "code": "52/P52K-7",
    "tripCode": "52/P52K-752-KTORD18U10",
    "order": 10,
    "direction": "U",
    "from": "OTTAPIDARAM",
    "to": "PARIVALLIKOTTAI",
    "service": "TOWN ORDINARY",
    "startTime": "01:00 PM",
    "endTime": "02:30 PM",
    "ids": [
      76,
      85,
      86,
      87,
      88,
      89,
      90,
      91,
      92,
      93,
      94,
      95,
      96
    ],
    "stops": [
      {
        "no": 1,
        "name": "OTTAPIDARAM",
        "time": "01:00 PM",
        "id": 76
      },
      {
        "no": 2,
        "name": "OSANOOTTHU",
        "time": "01:14 PM",
        "id": 85
      },
      {
        "no": 3,
        "name": "KOMBADI",
        "time": "01:21 PM",
        "id": 86
      },
      {
        "no": 4,
        "name": "PANDIAPURAM",
        "time": "01:32 PM",
        "id": 87
      },
      {
        "no": 5,
        "name": "PARAIKUTTAM",
        "time": "01:36 PM",
        "id": 88
      },
      {
        "no": 6,
        "name": "VADAMALAPURAM",
        "time": "01:42 PM",
        "id": 89
      },
      {
        "no": 7,
        "name": "MANIYACCHI",
        "time": "01:46 PM",
        "id": 90
      },
      {
        "no": 8,
        "name": "OTTANATTHAM",
        "time": "01:59 PM",
        "id": 91
      },
      {
        "no": 9,
        "name": "KALLATTHIKINARU",
        "time": "02:06 PM",
        "id": 92
      },
      {
        "no": 10,
        "name": "MALAIPATTI",
        "time": "02:12 PM",
        "id": 93
      },
      {
        "no": 11,
        "name": "ILAVELANKAL",
        "time": "02:20 PM",
        "id": 94
      },
      {
        "no": 12,
        "name": "IYRAVIPATTI",
        "time": "02:25 PM",
        "id": 95
      },
      {
        "no": 13,
        "name": "PARIVALLIKOTTAI",
        "time": "02:30 PM",
        "id": 96
      }
    ]
  },
  {
    "id": "52-K-11-106",
    "routeNo": "52-K",
    "code": "52/P52K-7",
    "tripCode": "52/P52K-752-KTORD18D11",
    "order": 11,
    "direction": "D",
    "from": "PARIVALLIKOTTAI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "02:35 PM",
    "endTime": "03:30 PM",
    "ids": [
      96,
      95,
      94,
      93,
      92,
      91,
      90,
      89,
      88,
      87,
      86,
      85,
      76
    ],
    "stops": [
      {
        "no": 13,
        "name": "PARIVALLIKOTTAI",
        "time": "02:35 PM",
        "id": 96
      },
      {
        "no": 12,
        "name": "IYRAVIPATTI",
        "time": "02:37 PM",
        "id": 95
      },
      {
        "no": 11,
        "name": "ILAVELANKAL",
        "time": "02:40 PM",
        "id": 94
      },
      {
        "no": 10,
        "name": "MALAIPATTI",
        "time": "02:45 PM",
        "id": 93
      },
      {
        "no": 9,
        "name": "KALLATTHIKINARU",
        "time": "02:49 PM",
        "id": 92
      },
      {
        "no": 8,
        "name": "OTTANATTHAM",
        "time": "02:53 PM",
        "id": 91
      },
      {
        "no": 7,
        "name": "MANIYACCHI",
        "time": "03:01 PM",
        "id": 90
      },
      {
        "no": 6,
        "name": "VADAMALAPURAM",
        "time": "03:04 PM",
        "id": 89
      },
      {
        "no": 5,
        "name": "PARAIKUTTAM",
        "time": "03:07 PM",
        "id": 88
      },
      {
        "no": 4,
        "name": "PANDIAPURAM",
        "time": "03:09 PM",
        "id": 87
      },
      {
        "no": 3,
        "name": "KOMBADI",
        "time": "03:16 PM",
        "id": 86
      },
      {
        "no": 2,
        "name": "OSANOOTTHU",
        "time": "03:21 PM",
        "id": 85
      },
      {
        "no": 1,
        "name": "OTTAPIDARAM",
        "time": "03:30 PM",
        "id": 76
      }
    ]
  },
  {
    "id": "52-K-12-107",
    "routeNo": "52-K",
    "code": "52/P52K-4",
    "tripCode": "52/P52K-452-KTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:35 PM",
    "endTime": "04:00 PM",
    "ids": [
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "03:35 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "03:36 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "03:39 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "03:40 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "03:42 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "03:45 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "03:48 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:50 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:52 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:55 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:55 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:57 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:58 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-13-108",
    "routeNo": "52-K",
    "code": "52/P52K-8",
    "tripCode": "52/P52K-852-KTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KURUKKUSALAI",
    "service": "TOWN ORDINARY",
    "startTime": "04:10 PM",
    "endTime": "04:50 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:12 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:14 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "04:19 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "04:20 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "04:25 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "04:28 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "04:33 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "04:40 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "04:45 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "04:50 PM",
        "id": 100
      }
    ]
  },
  {
    "id": "52-K-14-109",
    "routeNo": "52-K",
    "code": "52/P52K-9",
    "tripCode": "52/P52K-952-KTORD18U14",
    "order": 14,
    "direction": "U",
    "from": "KURUKKUSALAI",
    "to": "NORTH AARAIKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 PM",
    "endTime": "05:50 PM",
    "ids": [
      100,
      101,
      102,
      103,
      76,
      109,
      105,
      85,
      106,
      110,
      108
    ],
    "stops": [
      {
        "no": 1,
        "name": "KURUKKUSALAI",
        "time": "05:00 PM",
        "id": 100
      },
      {
        "no": 2,
        "name": "RAMACHANDRAPURAM 1",
        "time": "05:03 PM",
        "id": 101
      },
      {
        "no": 3,
        "name": "KAKKARAMPATTI JUNCTION",
        "time": "05:08 PM",
        "id": 102
      },
      {
        "no": 4,
        "name": "MEENAKSHIPURAM",
        "time": "05:10 PM",
        "id": 103
      },
      {
        "no": 5,
        "name": "OTTAPIDARAM",
        "time": "05:23 PM",
        "id": 76
      },
      {
        "no": 6,
        "name": "OTTAPIDARAM TALUK OFFICE",
        "time": "05:24 PM",
        "id": 109
      },
      {
        "no": 7,
        "name": "AYYANAR KOVIL",
        "time": "05:27 PM",
        "id": 105
      },
      {
        "no": 8,
        "name": "OSANOOTTHU",
        "time": "05:38 PM",
        "id": 85
      },
      {
        "no": 9,
        "name": "KULASEKARANALLOOR",
        "time": "05:41 PM",
        "id": 106
      },
      {
        "no": 10,
        "name": "THERKKU ARAIKULAM",
        "time": "05:47 PM",
        "id": 110
      },
      {
        "no": 11,
        "name": "NORTH AARAIKULAM",
        "time": "05:50 PM",
        "id": 108
      }
    ]
  },
  {
    "id": "52-K-15-110",
    "routeNo": "52-K",
    "code": "52/P52K-10",
    "tripCode": "52/P52K-1052-KTORD18D15",
    "order": 15,
    "direction": "D",
    "from": "NORTH AARAIKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:00 PM",
    "endTime": "07:00 PM",
    "ids": [
      108,
      110,
      106,
      85,
      105,
      109,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "NORTH AARAIKULAM",
        "time": "06:00 PM",
        "id": 108
      },
      {
        "no": 19,
        "name": "THERKKU ARAIKULAM",
        "time": "06:01 PM",
        "id": 110
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "06:05 PM",
        "id": 106
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "06:07 PM",
        "id": 85
      },
      {
        "no": 16,
        "name": "AYYANAR KOVIL",
        "time": "06:14 PM",
        "id": 105
      },
      {
        "no": 15,
        "name": "TALUK OFFICE",
        "time": "06:16 PM",
        "id": 109
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "06:17 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "06:19 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "06:24 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "06:26 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "06:30 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:35 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:40 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:44 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:47 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:51 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:52 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:56 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:57 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "52-K-16-111",
    "routeNo": "52-K",
    "code": "52/P52K-11",
    "tripCode": "52/P52K-1152-KTORD18U16",
    "order": 16,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 PM",
    "endTime": "08:10 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      52,
      53,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:10 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:13 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:18 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:25 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:26 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:29 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:36 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:39 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "07:44 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "07:50 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "07:54 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "07:58 PM",
        "id": 52
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "08:01 PM",
        "id": 53
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "08:03 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "08:10 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "52-K-17-112",
    "routeNo": "52-K",
    "code": "52/P52K-11",
    "tripCode": "52/P52K-1152-KTORD18D17",
    "order": 17,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:20 PM",
    "endTime": "10:00 PM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "08:20 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "08:31 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "08:34 PM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "08:39 PM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "08:45 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "08:52 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:02 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:11 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:16 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:27 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:32 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:33 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:46 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:53 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:59 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-A-1-113",
    "routeNo": "53-A",
    "code": "53/P53A-1",
    "tripCode": "53/P53A-153-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 AM",
    "endTime": "06:40 AM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      120,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "05:30 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "05:33 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:36 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:42 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "05:45 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "05:46 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "05:51 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "05:52 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:01 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "06:07 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "06:09 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "06:14 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "06:18 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "06:20 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "06:25 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 1",
        "time": "06:31 AM",
        "id": 120
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "06:35 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "06:40 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-A-2-114",
    "routeNo": "53-A",
    "code": "53/P53A-2",
    "tripCode": "53/P53A-253-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THULUKKANKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:40 AM",
    "endTime": "06:50 AM",
    "ids": [
      122,
      126,
      125,
      124,
      285
    ],
    "stops": [
      {
        "no": 6,
        "name": "KEELA VAIPPAR",
        "time": "06:40 AM",
        "id": 122
      },
      {
        "no": 4,
        "name": "VAIPPAR",
        "time": "06:44 AM",
        "id": 126
      },
      {
        "no": 3,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "06:47 AM",
        "id": 125
      },
      {
        "no": 2,
        "name": "KALAIGNANAPURAM",
        "time": "06:49 AM",
        "id": 124
      },
      {
        "no": 1,
        "name": "THULUKKANKULAM",
        "time": "06:50 AM",
        "id": 285
      }
    ]
  },
  {
    "id": "53-A-3-115",
    "routeNo": "53-A",
    "code": "53/P53A-2",
    "tripCode": "53/P53A-253-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THULUKKANKULAM",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "07:05 AM",
    "endTime": "07:15 AM",
    "ids": [
      285,
      124,
      125,
      126,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THULUKKANKULAM",
        "time": "07:05 AM",
        "id": 285
      },
      {
        "no": 2,
        "name": "KALAIGNANAPURAM",
        "time": "07:05 AM",
        "id": 124
      },
      {
        "no": 3,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "07:07 AM",
        "id": 125
      },
      {
        "no": 4,
        "name": "VAIPPAR",
        "time": "07:10 AM",
        "id": 126
      },
      {
        "no": 6,
        "name": "KEELA VAIPPAR",
        "time": "07:15 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-A-4-116",
    "routeNo": "53-A",
    "code": "53/P53A-1",
    "tripCode": "53/P53A-153-ATORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 AM",
    "endTime": "08:35 AM",
    "ids": [
      122,
      284,
      120,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "07:20 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "07:25 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 1",
        "time": "07:29 AM",
        "id": 120
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "07:35 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "07:41 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "07:42 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "07:47 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "07:52 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "07:54 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "08:01 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:10 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:11 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:17 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:18 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:21 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:27 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:30 AM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "08:35 AM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-A-5-117",
    "routeNo": "53-A",
    "code": "53/P53A-5",
    "tripCode": "53/P53A-553-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KURUMBUR",
    "service": "TOWN ORDINARY",
    "startTime": "08:50 AM",
    "endTime": "10:00 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      127,
      157,
      49,
      50,
      51,
      172,
      129,
      130,
      131,
      56
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:50 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:54 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:59 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:07 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:08 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:12 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "09:19 AM",
        "id": 127
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:23 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:29 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "09:36 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "09:41 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "09:44 AM",
        "id": 172
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "09:46 AM",
        "id": 129
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "09:51 AM",
        "id": 130
      },
      {
        "no": 16,
        "name": "MICHEAL NADAR KUDIYIRUPPU",
        "time": "09:56 AM",
        "id": 131
      },
      {
        "no": 17,
        "name": "KURUMBUR",
        "time": "10:00 AM",
        "id": 56
      }
    ]
  },
  {
    "id": "53-A-6-118",
    "routeNo": "53-A",
    "code": "53/P53A-5",
    "tripCode": "53/P53A-553-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KURUMBUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:05 AM",
    "endTime": "11:35 AM",
    "ids": [
      56,
      131,
      130,
      129,
      172,
      51,
      50,
      49,
      157,
      127,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "KURUMBUR",
        "time": "10:05 AM",
        "id": 56
      },
      {
        "no": 16,
        "name": "MICHEAL NADAR KUDIYIRUPPU",
        "time": "10:09 AM",
        "id": 131
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "10:16 AM",
        "id": 130
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "10:22 AM",
        "id": 129
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "10:24 AM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "10:29 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "10:35 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "10:44 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "10:52 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "10:57 AM",
        "id": 127
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "11:06 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "11:10 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:11 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:22 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "11:29 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "11:34 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:35 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-A-7-119",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:40 AM",
    "endTime": "12:25 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:41 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:43 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:46 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:46 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:50 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:53 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:56 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "12:00 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:04 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:07 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "12:14 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:20 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:25 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "53-A-8-120",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18D8",
    "order": 8,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:30 PM",
    "endTime": "01:20 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:30 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:34 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "12:41 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:49 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:52 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "12:57 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:01 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:05 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:08 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:12 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:13 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:16 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:18 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-A-9-121",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "01:40 PM",
    "endTime": "02:30 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:41 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:43 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:46 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:47 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:51 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:54 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:58 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "02:02 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "02:07 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:10 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "02:18 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "02:25 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "02:30 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "53-A-10-122",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18D10",
    "order": 10,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:45 PM",
    "endTime": "03:35 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "02:45 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "02:49 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "02:56 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "03:04 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "03:07 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "03:12 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "03:16 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:20 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:23 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:27 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:28 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:31 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:33 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-A-11-123",
    "routeNo": "53-A",
    "code": "53/P53A-3",
    "tripCode": "53/P53A-353-ATORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "03:45 PM",
    "endTime": "04:55 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      52,
      53,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "03:45 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "03:49 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "03:54 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:03 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:04 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "04:07 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "04:15 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "04:18 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "04:24 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "04:31 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "04:36 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "04:41 PM",
        "id": 52
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "04:45 PM",
        "id": 53
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "04:47 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "04:55 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "53-A-12-124",
    "routeNo": "53-A",
    "code": "53/P53A-3",
    "tripCode": "53/P53A-353-ATORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:05 PM",
    "endTime": "06:20 PM",
    "ids": [
      20,
      54,
      53,
      52,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "05:05 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "05:13 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "VAZHAVALLAN",
        "time": "05:15 PM",
        "id": 53
      },
      {
        "no": 13,
        "name": "UMARIKADU",
        "time": "05:19 PM",
        "id": 52
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "05:24 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "05:29 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "05:37 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "05:43 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "05:47 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "05:55 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "05:59 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:00 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:09 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:15 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:19 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-A-13-125",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:35 PM",
    "endTime": "07:20 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:36 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:38 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:41 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:41 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:45 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:48 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:51 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:55 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "06:59 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:02 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "07:09 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:15 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:20 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "53-A-14-126",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18D14",
    "order": 14,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:25 PM",
    "endTime": "08:40 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:25 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:32 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "07:42 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:54 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:59 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:06 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:12 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:18 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:22 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:28 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:29 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:34 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:37 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-A-15-127",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:50 PM",
    "endTime": "09:40 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:51 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:53 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:56 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:57 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:01 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:04 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:08 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:12 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:17 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:20 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "09:28 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "09:35 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "09:40 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "53-A-16-128",
    "routeNo": "53-A",
    "code": "53/P53A-4",
    "tripCode": "53/P53A-453-ATORD18D16",
    "order": 16,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 PM",
    "endTime": "10:35 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "09:50 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "09:54 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "10:00 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:07 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:10 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:14 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:18 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:21 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:24 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "10:28 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "10:28 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "10:31 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:33 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-B-1-129",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "01:00 PM",
    "endTime": "02:10 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:02 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "01:06 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "01:09 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "01:11 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "01:12 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "01:17 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "01:19 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "01:27 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "01:33 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "01:35 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "01:40 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "01:45 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "01:46 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "01:52 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "02:03 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "02:05 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "02:10 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-2-130",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:15 PM",
    "endTime": "03:25 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "02:15 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "02:19 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "02:21 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "02:32 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "02:38 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "02:39 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "02:44 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "02:49 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "02:51 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "02:57 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "03:05 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "03:07 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "03:12 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "03:13 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "03:15 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "03:18 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:22 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-B-3-131",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "03:30 PM",
    "endTime": "06:15 AM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:59 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "04:47 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:24 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "05:55 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:12 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "07:14 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "07:30 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "09:22 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "10:37 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "11:01 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "12:04 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "01:03 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "01:18 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "02:31 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "04:47 AM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "05:13 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "06:15 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-4-132",
    "routeNo": "53-B",
    "code": "53/P53B-2",
    "tripCode": "53/P53B-253-BTORD18U4",
    "order": 4,
    "direction": "U",
    "from": "KEELA VAIPPAR",
    "to": "THULUKKANKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:20 PM",
    "endTime": "04:55 PM",
    "ids": [
      122,
      126,
      125,
      124,
      285
    ],
    "stops": [
      {
        "no": 1,
        "name": "KEELA VAIPPAR",
        "time": "04:20 PM",
        "id": 122
      },
      {
        "no": 3,
        "name": "VAIPPAR",
        "time": "04:36 PM",
        "id": 126
      },
      {
        "no": 4,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "04:46 PM",
        "id": 125
      },
      {
        "no": 5,
        "name": "KALAIGNANAPURAM",
        "time": "04:51 PM",
        "id": 124
      },
      {
        "no": 6,
        "name": "THULUKKANKULAM",
        "time": "04:55 PM",
        "id": 285
      }
    ]
  },
  {
    "id": "53-B-5-133",
    "routeNo": "53-B",
    "code": "53/P53B-2",
    "tripCode": "53/P53B-253-BTORD18D5",
    "order": 5,
    "direction": "D",
    "from": "THULUKKANKULAM",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 PM",
    "endTime": "05:35 PM",
    "ids": [
      285,
      124,
      125,
      126,
      122
    ],
    "stops": [
      {
        "no": 6,
        "name": "THULUKKANKULAM",
        "time": "05:00 PM",
        "id": 285
      },
      {
        "no": 5,
        "name": "KALAIGNANAPURAM",
        "time": "05:03 PM",
        "id": 124
      },
      {
        "no": 4,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "05:08 PM",
        "id": 125
      },
      {
        "no": 3,
        "name": "VAIPPAR",
        "time": "05:18 PM",
        "id": 126
      },
      {
        "no": 1,
        "name": "KEELA VAIPPAR",
        "time": "05:35 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-6-134",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:40 PM",
    "endTime": "06:30 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "05:40 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "05:43 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "05:44 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "05:52 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "05:56 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "05:57 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "06:00 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "06:04 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "06:05 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:10 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:16 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:17 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:20 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:21 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:23 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "06:25 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:28 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-B-7-135",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "06:35 PM",
    "endTime": "07:55 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:37 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "06:42 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:45 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:48 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:49 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:55 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:56 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "07:06 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "07:13 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "07:15 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "07:21 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "07:26 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "07:28 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "07:34 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "07:47 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "07:49 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "07:55 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-8-136",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 PM",
    "endTime": "09:05 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "08:00 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "08:04 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "08:06 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "08:16 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "08:21 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "08:22 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "08:27 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "08:31 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "08:33 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "08:39 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:47 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:48 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:53 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:54 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:56 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:59 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:02 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-B-9-137",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "10:20 PM",
    "endTime": "11:50 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:23 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "10:27 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "10:31 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "10:34 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "10:36 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "10:42 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "10:44 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "10:55 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "11:03 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "11:05 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "11:12 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "11:18 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "11:19 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "11:27 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "11:41 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "11:43 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "11:50 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-10-138",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:20 AM",
    "endTime": "06:30 AM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "05:20 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "05:24 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "05:26 AM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "05:37 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "05:43 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "05:44 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "05:49 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "05:54 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "05:56 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:02 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:10 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:12 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:17 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:18 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:20 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "06:23 AM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:27 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-B-11-139",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "06:45 AM",
    "endTime": "08:00 AM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:47 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "06:51 AM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:54 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:57 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:58 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "07:04 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "07:05 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "07:14 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "07:21 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "07:23 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "07:28 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "07:33 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "07:34 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "07:41 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "07:52 AM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "07:54 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "08:00 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-12-140",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:30 AM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "08:15 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "08:20 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "08:22 AM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "08:33 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "08:40 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "08:41 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "08:46 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "08:51 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "08:53 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "09:00 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "09:09 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "09:10 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "09:16 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "09:17 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "09:20 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "09:23 AM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:27 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-B-13-141",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "10:50 AM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:37 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "09:41 AM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "09:44 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "09:47 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "09:48 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "09:54 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "09:55 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "10:04 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "10:11 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "10:13 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "10:18 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "10:23 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "10:24 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "10:31 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "10:42 AM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "10:44 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "10:50 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-B-14-142",
    "routeNo": "53-B",
    "code": "53/P53B-1",
    "tripCode": "53/P53B-153-BTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:55 AM",
    "endTime": "12:05 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "10:55 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "10:59 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "11:01 AM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "11:12 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "11:18 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "11:19 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "11:24 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "11:29 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "11:31 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "11:37 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "11:45 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "11:47 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "11:52 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "11:53 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "11:55 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "11:58 AM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "12:02 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-C-1-143",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "02:00 PM",
    "endTime": "03:20 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:02 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "02:07 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "02:10 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "02:13 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "02:14 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "02:20 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "02:21 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "02:31 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "02:38 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "02:40 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "02:46 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "02:51 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "02:53 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "02:59 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "03:12 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "03:14 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "03:20 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-C-2-144",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:25 PM",
    "endTime": "04:40 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "03:25 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "03:30 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "03:32 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "03:43 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "03:50 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "03:51 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "03:56 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "04:01 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "04:03 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "04:10 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "04:19 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "04:20 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "04:26 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "04:27 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "04:30 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "04:33 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:37 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-C-3-145",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 PM",
    "endTime": "06:20 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:02 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "05:07 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:10 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "05:13 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "05:14 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "05:20 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "05:21 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "05:31 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "05:38 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "05:40 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "05:46 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "05:51 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "05:53 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "05:59 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "06:12 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "06:14 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "06:20 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-C-4-146",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 PM",
    "endTime": "07:50 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "06:30 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "06:35 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "06:37 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "06:50 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "06:56 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "06:58 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "07:03 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "07:09 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "07:11 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "07:18 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "07:28 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "07:29 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "07:35 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "07:36 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "07:39 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "07:42 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:47 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-C-5-147",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 PM",
    "endTime": "09:20 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:07 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:11 PM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:14 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:17 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:18 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:24 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:25 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "08:34 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "08:41 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "08:43 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "08:48 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "08:53 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "08:54 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "09:01 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "09:12 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "09:14 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "09:20 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-C-6-148",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:30 PM",
    "endTime": "10:30 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "09:30 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "09:34 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "09:35 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "09:45 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "09:50 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "09:51 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "09:55 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "09:59 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "10:01 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "10:06 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "10:13 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "10:14 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "10:19 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "10:20 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "10:22 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "10:24 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:27 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-C-7-149",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "05:05 AM",
    "endTime": "06:20 AM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:05 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:07 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "05:11 AM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:14 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "05:17 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "05:18 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "05:24 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "05:25 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "05:34 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "05:41 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "05:43 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "05:48 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "05:53 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "05:54 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "06:01 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "06:12 AM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "06:14 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "06:20 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-C-8-150",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 AM",
    "endTime": "07:45 AM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "06:30 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "06:35 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "06:37 AM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "06:48 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "06:55 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "06:56 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "07:01 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "07:06 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "07:08 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "07:15 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "07:24 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "07:25 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "07:31 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "07:32 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "07:35 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "07:38 AM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:42 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-C-9-151",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 AM",
    "endTime": "09:20 AM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:00 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:02 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:07 AM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:10 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:13 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:14 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:20 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:21 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "08:31 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "08:38 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "08:40 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "08:46 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "08:51 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "08:53 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "08:59 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "09:12 AM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "09:14 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "09:20 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-C-10-152",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:25 AM",
    "endTime": "10:50 AM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "09:25 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "09:30 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "09:33 AM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "09:46 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "09:53 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "09:54 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "10:00 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "10:06 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "10:08 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "10:16 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "10:26 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "10:28 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "10:34 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "10:35 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "10:38 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "10:42 AM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:47 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:50 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-C-11-153",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "11:05 AM",
    "endTime": "12:20 PM",
    "ids": [
      1,
      26,
      282,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:05 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:07 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "11:11 AM",
        "id": 282
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "11:14 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "11:17 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "11:18 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "11:24 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "11:25 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "11:34 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "11:41 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "11:43 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "11:48 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "11:53 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "11:54 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "12:01 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "12:12 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "12:14 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "12:20 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-C-12-154",
    "routeNo": "53-C",
    "code": "53/P53C-1",
    "tripCode": "53/P53C-153-CTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:30 PM",
    "endTime": "01:50 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      282,
      26,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "12:30 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "12:35 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "12:37 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "12:50 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "12:56 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "12:58 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "01:03 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "01:09 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "01:11 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "01:18 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "01:28 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "01:29 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "01:35 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "01:36 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "01:39 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "AMERICAN HOSPITAL 2",
        "time": "01:42 PM",
        "id": 282
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:47 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-D-1-155",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "12:20 PM",
    "endTime": "01:45 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "12:20 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "12:24 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:28 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "12:34 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "12:37 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "12:39 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "12:44 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "12:46 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "12:56 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "01:03 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "01:05 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "01:11 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "01:16 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "01:18 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "01:24 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "01:37 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "01:39 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "01:45 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-D-2-156",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:50 PM",
    "endTime": "03:05 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "01:50 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "01:54 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "01:57 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "02:07 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "02:13 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "02:15 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "02:19 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "02:24 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "02:26 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "02:32 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "02:41 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "02:43 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "02:48 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "02:49 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "02:51 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:57 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "03:01 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "03:05 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-D-3-157",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "03:20 PM",
    "endTime": "04:15 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "03:20 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "03:22 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:25 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "03:29 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "03:31 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "03:32 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "03:36 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "03:37 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "03:43 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "03:48 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "03:49 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "03:53 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "03:56 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "03:57 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "04:01 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "04:09 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "04:11 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "04:15 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-D-4-158",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:20 PM",
    "endTime": "05:30 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "04:20 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "04:24 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "04:26 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "04:36 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "04:42 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "04:43 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "04:47 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "04:52 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "04:54 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "04:59 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "05:08 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "05:09 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "05:14 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "05:15 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:17 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:23 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "05:26 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "05:30 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-D-5-159",
    "routeNo": "53-D",
    "code": "53/P53D-2",
    "tripCode": "53/P53D-253-DTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 PM",
    "endTime": "07:00 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      133,
      134,
      135,
      136,
      287,
      137,
      138,
      139,
      118,
      132,
      140,
      141
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "05:45 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "05:48 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:52 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:58 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:00 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:02 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:07 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:08 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:17 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "AM PATTI",
        "time": "06:22 PM",
        "id": 133
      },
      {
        "no": 11,
        "name": "THERMAL STATION",
        "time": "06:23 PM",
        "id": 134
      },
      {
        "no": 12,
        "name": "AM PATTI JUNCTION",
        "time": "06:27 PM",
        "id": 135
      },
      {
        "no": 13,
        "name": "MELA MARUTHUR",
        "time": "06:30 PM",
        "id": 136
      },
      {
        "no": 14,
        "name": "ZAKKAMMALPURAM 3",
        "time": "06:34 PM",
        "id": 287
      },
      {
        "no": 15,
        "name": "DURAISAMYPURAM 1",
        "time": "06:38 PM",
        "id": 137
      },
      {
        "no": 16,
        "name": "SOUTH KALMEDU",
        "time": "06:42 PM",
        "id": 138
      },
      {
        "no": 17,
        "name": "NORTH KALMEDU",
        "time": "06:43 PM",
        "id": 139
      },
      {
        "no": 18,
        "name": "VEPPALODAI",
        "time": "06:47 PM",
        "id": 118
      },
      {
        "no": 19,
        "name": "PANAIYOOR GATE",
        "time": "06:53 PM",
        "id": 132
      },
      {
        "no": 20,
        "name": "PANAIYOOR",
        "time": "06:56 PM",
        "id": 140
      },
      {
        "no": 21,
        "name": "KULATTHOOR 1",
        "time": "07:00 PM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-D-6-160",
    "routeNo": "53-D",
    "code": "53/P53D-3",
    "tripCode": "53/P53D-353-DTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 PM",
    "endTime": "08:30 PM",
    "ids": [
      141,
      140,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "07:20 PM",
        "id": 141
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "07:23 PM",
        "id": 140
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "07:27 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "07:33 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "07:34 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "07:40 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "07:45 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "07:47 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "07:54 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:04 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:05 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:11 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:12 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:15 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:22 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:25 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "08:30 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-D-7-161",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "09:00 PM",
    "endTime": "10:01 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "09:00 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "09:03 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:05 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "09:10 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "09:12 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "09:13 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "09:17 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "09:18 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "09:26 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "09:31 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "09:32 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "09:36 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "09:40 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "09:41 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "09:46 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "09:55 PM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "09:56 PM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "10:01 PM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-D-8-162",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:20 PM",
    "endTime": "11:30 PM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "10:20 PM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "10:24 PM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "10:26 PM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "10:36 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "10:42 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "10:43 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "10:47 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "10:52 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "10:54 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "10:59 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "11:08 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "11:09 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "11:14 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "11:15 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "11:17 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:23 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "11:26 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "11:30 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-D-9-163",
    "routeNo": "53-D",
    "code": "53/P53D-3",
    "tripCode": "53/P53D-353-DTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "06:00 AM",
    "endTime": "07:15 AM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      140,
      141
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "06:00 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "06:04 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:08 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:15 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:18 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:19 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:25 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:27 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:37 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "06:45 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "06:47 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "06:53 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "06:58 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "07:00 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "07:07 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "07:11 AM",
        "id": 140
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "07:15 AM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-D-10-164",
    "routeNo": "53-D",
    "code": "53/P53D-2",
    "tripCode": "53/P53D-253-DTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 AM",
    "endTime": "08:35 AM",
    "ids": [
      141,
      140,
      132,
      118,
      139,
      138,
      137,
      287,
      136,
      135,
      134,
      133,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 21,
        "name": "KULATTHOOR 1",
        "time": "07:20 AM",
        "id": 141
      },
      {
        "no": 20,
        "name": "PANAIYOOR",
        "time": "07:23 AM",
        "id": 140
      },
      {
        "no": 19,
        "name": "PANAIYOOR GATE",
        "time": "07:26 AM",
        "id": 132
      },
      {
        "no": 18,
        "name": "VEPPALODAI",
        "time": "07:32 AM",
        "id": 118
      },
      {
        "no": 17,
        "name": "NORTH KALMEDU",
        "time": "07:36 AM",
        "id": 139
      },
      {
        "no": 16,
        "name": "SOUTH KALMEDU",
        "time": "07:37 AM",
        "id": 138
      },
      {
        "no": 15,
        "name": "DURAISAMYPURAM 1",
        "time": "07:41 AM",
        "id": 137
      },
      {
        "no": 14,
        "name": "ZAKKAMMALPURAM 3",
        "time": "07:45 AM",
        "id": 287
      },
      {
        "no": 13,
        "name": "MELA MARUTHUR",
        "time": "07:49 AM",
        "id": 136
      },
      {
        "no": 12,
        "name": "AM PATTI JUNCTION",
        "time": "07:52 AM",
        "id": 135
      },
      {
        "no": 11,
        "name": "THERMAL STATION",
        "time": "07:56 AM",
        "id": 134
      },
      {
        "no": 10,
        "name": "AM PATTI",
        "time": "07:57 AM",
        "id": 133
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "08:02 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:11 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:12 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:17 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:19 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:21 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:27 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:31 AM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "08:35 AM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-D-11-165",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA VAIPPAR",
    "service": "TOWN ORDINARY",
    "startTime": "08:40 AM",
    "endTime": "09:55 AM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      286,
      284,
      122
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "08:40 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "08:43 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:47 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "08:53 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:55 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:56 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "09:01 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "09:03 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "09:12 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "09:18 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "09:20 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "09:25 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "09:29 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "09:31 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "09:37 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "09:47 AM",
        "id": 286
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "09:50 AM",
        "id": 284
      },
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "09:55 AM",
        "id": 122
      }
    ]
  },
  {
    "id": "53-D-12-166",
    "routeNo": "53-D",
    "code": "53/P53D-1",
    "tripCode": "53/P53D-153-DTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KEELA VAIPPAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:00 AM",
    "endTime": "11:20 AM",
    "ids": [
      122,
      284,
      286,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 18,
        "name": "KEELA VAIPPAR",
        "time": "10:00 AM",
        "id": 122
      },
      {
        "no": 17,
        "name": "KALLOORANI",
        "time": "10:05 AM",
        "id": 284
      },
      {
        "no": 16,
        "name": "SALT FACTORY 2",
        "time": "10:07 AM",
        "id": 286
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "10:19 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "10:25 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "10:26 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "10:31 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "10:37 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "10:39 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "10:45 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "10:55 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "10:56 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "11:01 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "11:03 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "11:06 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:12 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "11:15 AM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "11:20 AM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-E-1-167",
    "routeNo": "53-E",
    "code": "53/P53E-2",
    "tripCode": "53/P53E-253-ETORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "01:35 PM",
    "endTime": "02:00 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      140,
      141
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "01:35 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "01:36 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:37 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "01:40 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "01:41 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "01:41 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "01:43 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "01:44 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "01:47 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "01:50 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "01:50 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "01:52 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "01:54 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "01:55 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "01:57 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "01:58 PM",
        "id": 140
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "02:00 PM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-E-2-168",
    "routeNo": "53-E",
    "code": "53/P53E-2",
    "tripCode": "53/P53E-253-ETORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:45 PM",
    "endTime": "04:10 PM",
    "ids": [
      141,
      140,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "02:45 PM",
        "id": 141
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "02:48 PM",
        "id": 140
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "02:53 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "03:01 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "03:03 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "03:09 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "03:16 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "03:18 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "03:26 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "03:38 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "03:40 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "03:47 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "03:49 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "03:52 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "04:04 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "04:10 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-E-3-169",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:15 PM",
    "endTime": "05:30 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      140,
      141,
      142,
      288
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "04:15 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "04:18 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:22 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "04:28 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "04:31 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "04:32 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "04:37 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "04:38 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "04:48 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "04:54 PM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "04:56 PM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "05:01 PM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "05:06 PM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "05:07 PM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "05:13 PM",
        "id": 132
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "05:17 PM",
        "id": 140
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "05:20 PM",
        "id": 141
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "05:23 PM",
        "id": 142
      },
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "05:30 PM",
        "id": 288
      }
    ]
  },
  {
    "id": "53-E-4-170",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:35 PM",
    "endTime": "06:50 PM",
    "ids": [
      288,
      142,
      141,
      140,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "05:35 PM",
        "id": 288
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "05:41 PM",
        "id": 142
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "05:44 PM",
        "id": 141
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "05:47 PM",
        "id": 140
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "05:51 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "05:57 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "05:58 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "06:03 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "06:08 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "06:10 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:16 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:26 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:27 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:32 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:33 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:36 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:42 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "06:46 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "06:50 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-E-5-171",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 PM",
    "endTime": "06:00 AM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      140,
      141,
      142,
      288
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "07:15 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "07:48 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:17 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "09:10 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "09:32 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "09:44 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "10:28 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "10:39 PM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "11:59 PM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "12:52 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "01:09 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "01:54 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "02:35 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "02:46 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "03:38 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "04:09 AM",
        "id": 140
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "04:35 AM",
        "id": 141
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "04:59 AM",
        "id": 142
      },
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "06:00 AM",
        "id": 288
      }
    ]
  },
  {
    "id": "53-E-6-172",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18D6",
    "order": 6,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:10 AM",
    "endTime": "07:10 AM",
    "ids": [
      288,
      142,
      141,
      140,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "06:10 AM",
        "id": 288
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "06:15 AM",
        "id": 142
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "06:17 AM",
        "id": 141
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "06:20 AM",
        "id": 140
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "06:23 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "06:27 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "06:28 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "06:32 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "06:37 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "06:38 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "06:43 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "06:50 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "06:51 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "06:56 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "06:57 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "06:59 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:04 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "07:06 AM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "07:10 AM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-E-7-173",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:45 AM",
    "endTime": "09:05 AM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      140,
      141,
      142,
      288
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "07:45 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "07:49 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:52 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "07:59 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "08:02 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "08:03 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "08:09 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "08:10 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "08:20 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "08:26 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "08:28 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "08:34 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "08:39 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "08:41 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "08:47 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "08:51 AM",
        "id": 140
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "08:54 AM",
        "id": 141
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "08:57 AM",
        "id": 142
      },
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "09:05 AM",
        "id": 288
      }
    ]
  },
  {
    "id": "53-E-8-174",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18D8",
    "order": 8,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 AM",
    "endTime": "10:30 AM",
    "ids": [
      288,
      142,
      141,
      140,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "09:10 AM",
        "id": 288
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "09:17 AM",
        "id": 142
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "09:20 AM",
        "id": 141
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "09:23 AM",
        "id": 140
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "09:27 AM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "09:33 AM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "09:35 AM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "09:40 AM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "09:46 AM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "09:48 AM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "09:54 AM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "10:04 AM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "10:05 AM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "10:11 AM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "10:12 AM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "10:15 AM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:22 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "10:25 AM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "10:30 AM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-E-9-175",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SUBRAMANIYAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "10:45 AM",
    "endTime": "12:00 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      113,
      114,
      283,
      115,
      116,
      117,
      118,
      132,
      140,
      141,
      142,
      288
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "10:45 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "10:48 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:52 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "10:58 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "11:01 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "11:02 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "11:07 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "11:08 AM",
        "id": 113
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "11:18 AM",
        "id": 114
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "11:24 AM",
        "id": 283
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "11:26 AM",
        "id": 115
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "11:31 AM",
        "id": 116
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "11:36 AM",
        "id": 117
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "11:37 AM",
        "id": 118
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "11:43 AM",
        "id": 132
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "11:47 AM",
        "id": 140
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "11:50 AM",
        "id": 141
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "11:53 AM",
        "id": 142
      },
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "12:00 PM",
        "id": 288
      }
    ]
  },
  {
    "id": "53-E-10-176",
    "routeNo": "53-E",
    "code": "53/P53E-1",
    "tripCode": "53/P53E-153-ETORD18D10",
    "order": 10,
    "direction": "D",
    "from": "SUBRAMANIYAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:10 PM",
    "endTime": "01:30 PM",
    "ids": [
      288,
      142,
      141,
      140,
      132,
      118,
      117,
      116,
      115,
      283,
      114,
      113,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 19,
        "name": "SUBRAMANIYAPURAM 3",
        "time": "12:10 PM",
        "id": 288
      },
      {
        "no": 18,
        "name": "COLONY",
        "time": "12:17 PM",
        "id": 142
      },
      {
        "no": 17,
        "name": "KULATTHOOR 1",
        "time": "12:20 PM",
        "id": 141
      },
      {
        "no": 16,
        "name": "PANAIYOOR",
        "time": "12:23 PM",
        "id": 140
      },
      {
        "no": 15,
        "name": "PANAIYOOR GATE",
        "time": "12:27 PM",
        "id": 132
      },
      {
        "no": 14,
        "name": "VEPPALODAI",
        "time": "12:33 PM",
        "id": 118
      },
      {
        "no": 13,
        "name": "CHEMICAL X",
        "time": "12:35 PM",
        "id": 117
      },
      {
        "no": 12,
        "name": "KALMEDU",
        "time": "12:40 PM",
        "id": 116
      },
      {
        "no": 11,
        "name": "PATTINAMARUTHUR",
        "time": "12:46 PM",
        "id": 115
      },
      {
        "no": 10,
        "name": "ZAKKAMMALPURAM 2",
        "time": "12:48 PM",
        "id": 283
      },
      {
        "no": 9,
        "name": "THARUVAIKULAM",
        "time": "12:54 PM",
        "id": 114
      },
      {
        "no": 8,
        "name": "JOTHI SALT",
        "time": "01:04 PM",
        "id": 113
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "01:05 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "01:11 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "01:12 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "01:15 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:22 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "01:25 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "01:30 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "53-F-1-177",
    "routeNo": "53-F",
    "code": "53/P53F-1",
    "tripCode": "53/P53F-153-FTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 AM",
    "endTime": "07:30 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      143,
      144,
      145,
      135,
      136,
      287,
      137,
      146,
      147,
      148,
      149,
      141
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:32 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:33 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:37 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:38 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:42 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "06:44 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "06:46 AM",
        "id": 143
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "06:48 AM",
        "id": 144
      },
      {
        "no": 10,
        "name": "KUMARAPURAM 1",
        "time": "06:53 AM",
        "id": 145
      },
      {
        "no": 11,
        "name": "AM PATTI JUNCTION",
        "time": "06:55 AM",
        "id": 135
      },
      {
        "no": 12,
        "name": "MELA MARUTHUR",
        "time": "06:58 AM",
        "id": 136
      },
      {
        "no": 13,
        "name": "ZAKKAMMALPURAM 3",
        "time": "07:02 AM",
        "id": 287
      },
      {
        "no": 14,
        "name": "DURAISAMYPURAM 1",
        "time": "07:05 AM",
        "id": 137
      },
      {
        "no": 15,
        "name": "PUDHUR 1",
        "time": "07:07 AM",
        "id": 146
      },
      {
        "no": 16,
        "name": "VEDANATTHAM",
        "time": "07:11 AM",
        "id": 147
      },
      {
        "no": 17,
        "name": "VENKATACHALAPURAM",
        "time": "07:15 AM",
        "id": 148
      },
      {
        "no": 18,
        "name": "MUTHUKUMARAPURAM",
        "time": "07:19 AM",
        "id": 149
      },
      {
        "no": 20,
        "name": "KULATTHOOR 1",
        "time": "07:30 AM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-F-2-178",
    "routeNo": "53-F",
    "code": "53/P53F-2",
    "tripCode": "53/P53F-253-FTORD18U2",
    "order": 2,
    "direction": "U",
    "from": "KULATTHOOR",
    "to": "THULUKKANKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:35 AM",
    "endTime": "07:45 AM",
    "ids": [
      141,
      142,
      150,
      126,
      125,
      285
    ],
    "stops": [
      {
        "no": 1,
        "name": "KULATTHOOR 1",
        "time": "07:35 AM",
        "id": 141
      },
      {
        "no": 2,
        "name": "COLONY",
        "time": "07:36 AM",
        "id": 142
      },
      {
        "no": 3,
        "name": "SUBRAMANIYAPURAM JUNCTION",
        "time": "07:38 AM",
        "id": 150
      },
      {
        "no": 4,
        "name": "VAIPPAR",
        "time": "07:41 AM",
        "id": 126
      },
      {
        "no": 5,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "07:43 AM",
        "id": 125
      },
      {
        "no": 6,
        "name": "THULUKKANKULAM",
        "time": "07:45 AM",
        "id": 285
      }
    ]
  },
  {
    "id": "53-F-3-179",
    "routeNo": "53-F",
    "code": "53/P53F-2",
    "tripCode": "53/P53F-253-FTORD18D3",
    "order": 3,
    "direction": "D",
    "from": "THULUKKANKULAM",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 AM",
    "endTime": "08:00 AM",
    "ids": [
      285,
      125,
      126,
      150,
      142,
      141
    ],
    "stops": [
      {
        "no": 6,
        "name": "THULUKKANKULAM",
        "time": "07:50 AM",
        "id": 285
      },
      {
        "no": 5,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "07:51 AM",
        "id": 125
      },
      {
        "no": 4,
        "name": "VAIPPAR",
        "time": "07:53 AM",
        "id": 126
      },
      {
        "no": 3,
        "name": "SUBRAMANIYAPURAM JUNCTION",
        "time": "07:56 AM",
        "id": 150
      },
      {
        "no": 2,
        "name": "COLONY",
        "time": "07:58 AM",
        "id": 142
      },
      {
        "no": 1,
        "name": "KULATTHOOR 1",
        "time": "08:00 AM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-F-4-180",
    "routeNo": "53-F",
    "code": "53/P53F-1",
    "tripCode": "53/P53F-153-FTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 AM",
    "endTime": "09:25 AM",
    "ids": [
      141,
      149,
      148,
      147,
      146,
      137,
      287,
      136,
      135,
      145,
      144,
      143,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "KULATTHOOR 1",
        "time": "08:05 AM",
        "id": 141
      },
      {
        "no": 18,
        "name": "MUTHUKUMARAPURAM",
        "time": "08:19 AM",
        "id": 149
      },
      {
        "no": 17,
        "name": "VENKATACHALAPURAM",
        "time": "08:24 AM",
        "id": 148
      },
      {
        "no": 16,
        "name": "VEDANATTHAM",
        "time": "08:29 AM",
        "id": 147
      },
      {
        "no": 15,
        "name": "PUDHUR 1",
        "time": "08:34 AM",
        "id": 146
      },
      {
        "no": 14,
        "name": "DURAISAMYPURAM 1",
        "time": "08:38 AM",
        "id": 137
      },
      {
        "no": 13,
        "name": "ZAKKAMMALPURAM 3",
        "time": "08:42 AM",
        "id": 287
      },
      {
        "no": 12,
        "name": "MELA MARUTHUR",
        "time": "08:46 AM",
        "id": 136
      },
      {
        "no": 11,
        "name": "AM PATTI JUNCTION",
        "time": "08:50 AM",
        "id": 135
      },
      {
        "no": 10,
        "name": "KUMARAPURAM 1",
        "time": "08:53 AM",
        "id": 145
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "09:00 AM",
        "id": 144
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "09:02 AM",
        "id": 143
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "09:06 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:08 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:14 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:15 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:20 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:22 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-F-5-181",
    "routeNo": "53-F",
    "code": "53/P53F-4",
    "tripCode": "53/P53F-453-FTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA SEITHALAI",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "10:20 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      111,
      155,
      156
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:35 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:36 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:38 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:38 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:40 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "09:41 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "09:43 AM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "09:46 AM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "09:48 AM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "09:49 AM",
        "id": 100
      },
      {
        "no": 13,
        "name": "THOMAS NAGAR",
        "time": "10:00 AM",
        "id": 111
      },
      {
        "no": 14,
        "name": "SEITHALAI JUNCTION",
        "time": "10:17 AM",
        "id": 155
      },
      {
        "no": 15,
        "name": "KEELA SEITHALAI",
        "time": "10:20 AM",
        "id": 156
      }
    ]
  },
  {
    "id": "53-F-6-182",
    "routeNo": "53-F",
    "code": "53/P53F-4",
    "tripCode": "53/P53F-453-FTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KEELA SEITHALAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 AM",
    "endTime": "11:30 AM",
    "ids": [
      156,
      155,
      111,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "KEELA SEITHALAI",
        "time": "10:30 AM",
        "id": 156
      },
      {
        "no": 14,
        "name": "SEITHALAI JUNCTION",
        "time": "10:33 AM",
        "id": 155
      },
      {
        "no": 13,
        "name": "THOMAS NAGAR",
        "time": "10:55 AM",
        "id": 111
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "11:10 AM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "11:12 AM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "11:15 AM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "11:18 AM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "11:20 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:22 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:24 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:25 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:27 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:28 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-F-7-183",
    "routeNo": "53-F",
    "code": "53/P53F-3",
    "tripCode": "53/P53F-353-FTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KOLLAMPARAMBU",
    "service": "TOWN ORDINARY",
    "startTime": "11:35 AM",
    "endTime": "12:15 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      152,
      289,
      154
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:36 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:38 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:41 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:42 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:45 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "11:47 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "11:51 AM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "11:56 AM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "11:59 AM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "12:02 PM",
        "id": 100
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 1",
        "time": "12:08 PM",
        "id": 152
      },
      {
        "no": 14,
        "name": "CHANDRAGIRI",
        "time": "12:09 PM",
        "id": 289
      },
      {
        "no": 15,
        "name": "KOLLAMPARAMBU",
        "time": "12:15 PM",
        "id": 154
      }
    ]
  },
  {
    "id": "53-F-8-184",
    "routeNo": "53-F",
    "code": "53/P53F-3",
    "tripCode": "53/P53F-353-FTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KOLLAMPARAMBU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:20 PM",
    "endTime": "01:30 PM",
    "ids": [
      154,
      289,
      152,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "KOLLAMPARAMBU",
        "time": "12:20 PM",
        "id": 154
      },
      {
        "no": 14,
        "name": "CHANDRAGIRI",
        "time": "12:29 PM",
        "id": 289
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 1",
        "time": "12:31 PM",
        "id": 152
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "12:41 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "12:46 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "12:52 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "01:01 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "01:07 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:10 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:17 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:18 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:24 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:26 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-F-9-185",
    "routeNo": "53-F",
    "code": "53/P53F-4",
    "tripCode": "53/P53F-453-FTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA SEITHALAI",
    "service": "TOWN ORDINARY",
    "startTime": "01:35 PM",
    "endTime": "02:30 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      111,
      155,
      156
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:36 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:37 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:39 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:39 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:42 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "01:43 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "01:45 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "01:48 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "01:51 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "01:52 PM",
        "id": 100
      },
      {
        "no": 13,
        "name": "THOMAS NAGAR",
        "time": "02:06 PM",
        "id": 111
      },
      {
        "no": 14,
        "name": "SEITHALAI JUNCTION",
        "time": "02:26 PM",
        "id": 155
      },
      {
        "no": 15,
        "name": "KEELA SEITHALAI",
        "time": "02:30 PM",
        "id": 156
      }
    ]
  },
  {
    "id": "53-F-10-186",
    "routeNo": "53-F",
    "code": "53/P53F-4",
    "tripCode": "53/P53F-453-FTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KEELA SEITHALAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:40 PM",
    "endTime": "02:55 PM",
    "ids": [
      156,
      155,
      111,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "KEELA SEITHALAI",
        "time": "02:40 PM",
        "id": 156
      },
      {
        "no": 14,
        "name": "SEITHALAI JUNCTION",
        "time": "02:40 PM",
        "id": 155
      },
      {
        "no": 13,
        "name": "THOMAS NAGAR",
        "time": "02:46 PM",
        "id": 111
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "02:50 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "02:50 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "02:51 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "02:52 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "02:52 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:53 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:53 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:53 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:54 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:54 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-F-11-187",
    "routeNo": "53-F",
    "code": "53/P53F-1",
    "tripCode": "53/P53F-153-FTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "04:00 PM",
    "endTime": "05:10 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      143,
      144,
      145,
      135,
      136,
      287,
      137,
      146,
      147,
      148,
      149,
      141
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:02 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:04 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "04:08 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "04:09 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "04:14 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "04:16 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "04:19 PM",
        "id": 143
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "04:21 PM",
        "id": 144
      },
      {
        "no": 10,
        "name": "KUMARAPURAM 1",
        "time": "04:27 PM",
        "id": 145
      },
      {
        "no": 11,
        "name": "AM PATTI JUNCTION",
        "time": "04:29 PM",
        "id": 135
      },
      {
        "no": 12,
        "name": "MELA MARUTHUR",
        "time": "04:33 PM",
        "id": 136
      },
      {
        "no": 13,
        "name": "ZAKKAMMALPURAM 3",
        "time": "04:37 PM",
        "id": 287
      },
      {
        "no": 14,
        "name": "DURAISAMYPURAM 1",
        "time": "04:40 PM",
        "id": 137
      },
      {
        "no": 15,
        "name": "PUDHUR 1",
        "time": "04:44 PM",
        "id": 146
      },
      {
        "no": 16,
        "name": "VEDANATTHAM",
        "time": "04:48 PM",
        "id": 147
      },
      {
        "no": 17,
        "name": "VENKATACHALAPURAM",
        "time": "04:52 PM",
        "id": 148
      },
      {
        "no": 18,
        "name": "MUTHUKUMARAPURAM",
        "time": "04:57 PM",
        "id": 149
      },
      {
        "no": 20,
        "name": "KULATTHOOR 1",
        "time": "05:10 PM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-F-12-188",
    "routeNo": "53-F",
    "code": "53/P53F-2",
    "tripCode": "53/P53F-253-FTORD18U12",
    "order": 12,
    "direction": "U",
    "from": "KULATTHOOR",
    "to": "THULUKKANKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "03:50 PM",
    "ids": [
      141,
      142,
      150,
      126,
      125,
      285
    ],
    "stops": [
      {
        "no": 1,
        "name": "KULATTHOOR 1",
        "time": "03:00 PM",
        "id": 141
      },
      {
        "no": 2,
        "name": "COLONY",
        "time": "03:06 PM",
        "id": 142
      },
      {
        "no": 3,
        "name": "SUBRAMANIYAPURAM JUNCTION",
        "time": "03:19 PM",
        "id": 150
      },
      {
        "no": 4,
        "name": "VAIPPAR",
        "time": "03:32 PM",
        "id": 126
      },
      {
        "no": 5,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "03:41 PM",
        "id": 125
      },
      {
        "no": 6,
        "name": "THULUKKANKULAM",
        "time": "03:50 PM",
        "id": 285
      }
    ]
  },
  {
    "id": "53-F-13-189",
    "routeNo": "53-F",
    "code": "53/P53F-2",
    "tripCode": "53/P53F-253-FTORD18D13",
    "order": 13,
    "direction": "D",
    "from": "THULUKKANKULAM",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "05:15 PM",
    "endTime": "05:25 PM",
    "ids": [
      285,
      125,
      126,
      150,
      142,
      141
    ],
    "stops": [
      {
        "no": 6,
        "name": "THULUKKANKULAM",
        "time": "05:15 PM",
        "id": 285
      },
      {
        "no": 5,
        "name": "KALAIGNANAPURAM JUNCTION",
        "time": "05:16 PM",
        "id": 125
      },
      {
        "no": 4,
        "name": "VAIPPAR",
        "time": "05:18 PM",
        "id": 126
      },
      {
        "no": 3,
        "name": "SUBRAMANIYAPURAM JUNCTION",
        "time": "05:21 PM",
        "id": 150
      },
      {
        "no": 2,
        "name": "COLONY",
        "time": "05:23 PM",
        "id": 142
      },
      {
        "no": 1,
        "name": "KULATTHOOR 1",
        "time": "05:25 PM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-F-14-190",
    "routeNo": "53-F",
    "code": "53/P53F-1",
    "tripCode": "53/P53F-153-FTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 PM",
    "endTime": "06:45 PM",
    "ids": [
      141,
      149,
      148,
      147,
      146,
      137,
      287,
      136,
      135,
      145,
      144,
      143,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "KULATTHOOR 1",
        "time": "05:30 PM",
        "id": 141
      },
      {
        "no": 18,
        "name": "MUTHUKUMARAPURAM",
        "time": "05:43 PM",
        "id": 149
      },
      {
        "no": 17,
        "name": "VENKATACHALAPURAM",
        "time": "05:48 PM",
        "id": 148
      },
      {
        "no": 16,
        "name": "VEDANATTHAM",
        "time": "05:52 PM",
        "id": 147
      },
      {
        "no": 15,
        "name": "PUDHUR 1",
        "time": "05:57 PM",
        "id": 146
      },
      {
        "no": 14,
        "name": "DURAISAMYPURAM 1",
        "time": "06:01 PM",
        "id": 137
      },
      {
        "no": 13,
        "name": "ZAKKAMMALPURAM 3",
        "time": "06:04 PM",
        "id": 287
      },
      {
        "no": 12,
        "name": "MELA MARUTHUR",
        "time": "06:09 PM",
        "id": 136
      },
      {
        "no": 11,
        "name": "AM PATTI JUNCTION",
        "time": "06:12 PM",
        "id": 135
      },
      {
        "no": 10,
        "name": "KUMARAPURAM 1",
        "time": "06:15 PM",
        "id": 145
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "06:21 PM",
        "id": 144
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "06:23 PM",
        "id": 143
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "06:27 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:29 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:34 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:36 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:40 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:42 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "53-F-15-191",
    "routeNo": "53-F",
    "code": "53/P53F-1",
    "tripCode": "53/P53F-153-FTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 PM",
    "endTime": "08:05 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      143,
      144,
      145,
      135,
      136,
      287,
      137,
      146,
      147,
      148,
      149,
      141
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:52 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:54 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:58 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:00 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:05 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "07:07 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "07:11 PM",
        "id": 143
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "07:13 PM",
        "id": 144
      },
      {
        "no": 10,
        "name": "KUMARAPURAM 1",
        "time": "07:19 PM",
        "id": 145
      },
      {
        "no": 11,
        "name": "AM PATTI JUNCTION",
        "time": "07:22 PM",
        "id": 135
      },
      {
        "no": 12,
        "name": "MELA MARUTHUR",
        "time": "07:25 PM",
        "id": 136
      },
      {
        "no": 13,
        "name": "ZAKKAMMALPURAM 3",
        "time": "07:30 PM",
        "id": 287
      },
      {
        "no": 14,
        "name": "DURAISAMYPURAM 1",
        "time": "07:33 PM",
        "id": 137
      },
      {
        "no": 15,
        "name": "PUDHUR 1",
        "time": "07:37 PM",
        "id": 146
      },
      {
        "no": 16,
        "name": "VEDANATTHAM",
        "time": "07:42 PM",
        "id": 147
      },
      {
        "no": 17,
        "name": "VENKATACHALAPURAM",
        "time": "07:46 PM",
        "id": 148
      },
      {
        "no": 18,
        "name": "MUTHUKUMARAPURAM",
        "time": "07:51 PM",
        "id": 149
      },
      {
        "no": 20,
        "name": "KULATTHOOR 1",
        "time": "08:05 PM",
        "id": 141
      }
    ]
  },
  {
    "id": "53-F-16-192",
    "routeNo": "53-F",
    "code": "53/P53F-1",
    "tripCode": "53/P53F-153-FTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 PM",
    "endTime": "09:20 PM",
    "ids": [
      141,
      149,
      148,
      147,
      146,
      137,
      287,
      136,
      135,
      145,
      144,
      143,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "KULATTHOOR 1",
        "time": "08:10 PM",
        "id": 141
      },
      {
        "no": 18,
        "name": "MUTHUKUMARAPURAM",
        "time": "08:22 PM",
        "id": 149
      },
      {
        "no": 17,
        "name": "VENKATACHALAPURAM",
        "time": "08:27 PM",
        "id": 148
      },
      {
        "no": 16,
        "name": "VEDANATTHAM",
        "time": "08:31 PM",
        "id": 147
      },
      {
        "no": 15,
        "name": "PUDHUR 1",
        "time": "08:35 PM",
        "id": 146
      },
      {
        "no": 14,
        "name": "DURAISAMYPURAM 1",
        "time": "08:39 PM",
        "id": 137
      },
      {
        "no": 13,
        "name": "ZAKKAMMALPURAM 3",
        "time": "08:42 PM",
        "id": 287
      },
      {
        "no": 12,
        "name": "MELA MARUTHUR",
        "time": "08:46 PM",
        "id": 136
      },
      {
        "no": 11,
        "name": "AM PATTI JUNCTION",
        "time": "08:50 PM",
        "id": 135
      },
      {
        "no": 10,
        "name": "KUMARAPURAM 1",
        "time": "08:52 PM",
        "id": 145
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "08:58 PM",
        "id": 144
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "09:00 PM",
        "id": 143
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "09:03 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:05 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:10 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:11 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:15 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:17 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-1-193",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "02:15 PM",
    "endTime": "03:15 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "02:15 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "02:21 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "02:30 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:43 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:45 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:51 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "03:03 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:08 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "03:08 PM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "03:15 PM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-2-194",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:20 PM",
    "endTime": "04:20 PM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "03:20 PM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "03:26 PM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:26 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "03:31 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:43 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "03:49 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "03:51 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:04 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:13 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:19 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-3-195",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "04:25 PM",
    "endTime": "05:15 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:25 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:25 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:30 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:37 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:49 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:50 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "04:55 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "05:05 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "05:09 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "05:09 PM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "05:15 PM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-4-196",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:20 PM",
    "endTime": "06:20 PM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "05:20 PM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "05:26 PM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "05:26 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "05:31 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "05:43 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "05:49 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "05:51 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:04 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:13 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:19 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-5-197",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "06:25 PM",
    "endTime": "07:25 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:25 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:25 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:31 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:40 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:53 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:55 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:01 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:13 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:18 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "07:18 PM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "07:25 PM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-6-198",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 PM",
    "endTime": "08:55 PM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "07:30 PM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "07:38 PM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:38 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:46 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:03 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:12 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:13 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:33 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:45 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:53 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-7-199",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "09:00 PM",
    "endTime": "09:50 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:00 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:05 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:12 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:24 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:25 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:30 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:40 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:44 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "09:44 PM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "09:50 PM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-8-200",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D8",
    "order": 8,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:55 PM",
    "endTime": "06:10 AM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "09:55 PM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "10:46 PM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "10:46 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "11:30 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:10 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:59 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:11 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:04 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:14 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:02 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-11-201",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:05 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:15 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:20 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:27 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:39 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:40 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:45 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "08:55 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "08:59 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "08:59 AM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "09:05 AM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-12-202",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D12",
    "order": 12,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 AM",
    "endTime": "10:10 AM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "09:10 AM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "09:16 AM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:16 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:21 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:33 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:39 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:41 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:54 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:03 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:09 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-13-203",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "10:15 AM",
    "endTime": "11:05 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:15 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:20 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:27 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:39 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:40 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:45 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "10:55 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "10:59 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "10:59 AM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "11:05 AM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-14-204",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D14",
    "order": 14,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:10 AM",
    "endTime": "12:00 PM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "11:10 AM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "11:15 AM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "11:15 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "11:19 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "11:29 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "11:34 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:35 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:47 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "11:54 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "11:59 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-A-15-205",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "12:05 PM",
    "endTime": "12:55 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "12:05 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "12:10 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "12:17 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "12:29 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "12:30 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "12:35 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "12:45 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:49 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "12:49 PM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "12:55 PM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-A-16-206",
    "routeNo": "54-A",
    "code": "54/P54A-1",
    "tripCode": "54/P54A-154-ATORD18D16",
    "order": 16,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:00 PM",
    "endTime": "02:10 PM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "01:00 PM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "01:07 PM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:07 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "01:13 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:27 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:34 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:36 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:52 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "02:02 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "02:08 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-B-1-207",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ARUMUGAMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "01:45 PM",
    "endTime": "02:55 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      290,
      159,
      160,
      161,
      162
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "01:45 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "01:50 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:56 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:07 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:08 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:13 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "02:22 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "02:27 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "02:34 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "02:40 PM",
        "id": 290
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "02:40 PM",
        "id": 159
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "02:45 PM",
        "id": 160
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "02:48 PM",
        "id": 161
      },
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "02:55 PM",
        "id": 162
      }
    ]
  },
  {
    "id": "54-B-2-208",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "ARUMUGAMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "04:10 PM",
    "ids": [
      162,
      161,
      160,
      159,
      290,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "03:00 PM",
        "id": 162
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "03:06 PM",
        "id": 161
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "03:09 PM",
        "id": 160
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "03:14 PM",
        "id": 159
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "03:14 PM",
        "id": 290
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "03:20 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:27 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "03:32 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:41 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "03:46 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "03:47 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "03:58 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:04 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:09 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-B-3-209",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ARUMUGAMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:20 PM",
    "endTime": "05:35 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      290,
      159,
      160,
      161,
      162
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:20 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:25 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:32 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:44 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:45 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "04:50 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "05:00 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "05:05 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "05:13 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "05:19 PM",
        "id": 290
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "05:19 PM",
        "id": 159
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "05:25 PM",
        "id": 160
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "05:27 PM",
        "id": 161
      },
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "05:35 PM",
        "id": 162
      }
    ]
  },
  {
    "id": "54-B-4-210",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "ARUMUGAMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:40 PM",
    "endTime": "07:05 PM",
    "ids": [
      162,
      161,
      160,
      159,
      290,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "05:40 PM",
        "id": 162
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "05:48 PM",
        "id": 161
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "05:51 PM",
        "id": 160
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "05:57 PM",
        "id": 159
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "05:57 PM",
        "id": 290
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "06:04 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:13 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:18 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:30 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:36 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:37 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:50 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:58 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:04 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-B-5-211",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ARUMUGAMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 PM",
    "endTime": "08:30 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      290,
      159,
      160,
      161,
      162
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:10 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:15 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:23 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:35 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:37 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:42 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:53 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:58 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "08:06 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "08:13 PM",
        "id": 290
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "08:13 PM",
        "id": 159
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "08:19 PM",
        "id": 160
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "08:22 PM",
        "id": 161
      },
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "08:30 PM",
        "id": 162
      }
    ]
  },
  {
    "id": "54-B-6-212",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ARUMUGAMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:35 PM",
    "endTime": "05:20 AM",
    "ids": [
      162,
      161,
      160,
      159,
      290,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "08:35 PM",
        "id": 162
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "09:25 PM",
        "id": 161
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "09:44 PM",
        "id": 160
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "10:25 PM",
        "id": 159
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "10:26 PM",
        "id": 290
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "11:06 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:04 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "12:35 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:46 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:21 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:29 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "03:50 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:40 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:14 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-B-7-213",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ARUMUGAMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:25 AM",
    "endTime": "06:40 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      290,
      159,
      160,
      161,
      162
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:25 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:25 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:30 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "05:37 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "05:49 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "05:50 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "05:55 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:05 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:10 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "06:18 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "06:24 AM",
        "id": 290
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "06:24 AM",
        "id": 159
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "06:30 AM",
        "id": 160
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "06:32 AM",
        "id": 161
      },
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "06:40 AM",
        "id": 162
      }
    ]
  },
  {
    "id": "54-B-8-214",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "ARUMUGAMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:45 AM",
    "endTime": "08:05 AM",
    "ids": [
      162,
      161,
      160,
      159,
      290,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "06:45 AM",
        "id": 162
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "06:52 AM",
        "id": 161
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "06:55 AM",
        "id": 160
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "07:01 AM",
        "id": 159
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "07:01 AM",
        "id": 290
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "07:08 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:16 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:21 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:32 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:37 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:39 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:51 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:59 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:04 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:05 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-B-9-215",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ARUMUGAMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 AM",
    "endTime": "09:25 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      290,
      159,
      160,
      161,
      162
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:10 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:15 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:22 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:34 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:35 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:40 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "08:50 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "08:55 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:03 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "09:09 AM",
        "id": 290
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "09:09 AM",
        "id": 159
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "09:15 AM",
        "id": 160
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "09:17 AM",
        "id": 161
      },
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "09:25 AM",
        "id": 162
      }
    ]
  },
  {
    "id": "54-B-10-216",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "ARUMUGAMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:30 AM",
    "endTime": "10:45 AM",
    "ids": [
      162,
      161,
      160,
      159,
      290,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "09:30 AM",
        "id": 162
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "09:37 AM",
        "id": 161
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "09:39 AM",
        "id": 160
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "09:45 AM",
        "id": 159
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "09:45 AM",
        "id": 290
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:51 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:59 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "10:04 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:14 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:19 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:20 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:32 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:39 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:44 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-B-11-217",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ARUMUGAMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "10:50 AM",
    "endTime": "12:05 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      290,
      159,
      160,
      161,
      162
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:50 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:55 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:02 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:14 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "11:15 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "11:20 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "11:30 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "11:35 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "11:43 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "11:49 AM",
        "id": 290
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "11:49 AM",
        "id": 159
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "11:55 AM",
        "id": 160
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "11:57 AM",
        "id": 161
      },
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "12:05 PM",
        "id": 162
      }
    ]
  },
  {
    "id": "54-B-12-218",
    "routeNo": "54-B",
    "code": "54/P54B-1",
    "tripCode": "54/P54B-154-BTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ARUMUGAMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:10 PM",
    "endTime": "01:40 PM",
    "ids": [
      162,
      161,
      160,
      159,
      290,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ARUMUGAMANGALAM",
        "time": "12:10 PM",
        "id": 162
      },
      {
        "no": 14,
        "name": "MARAMANGALAM",
        "time": "12:18 PM",
        "id": 161
      },
      {
        "no": 13,
        "name": "IDAYARKADU",
        "time": "12:21 PM",
        "id": 160
      },
      {
        "no": 12,
        "name": "SAMBADI",
        "time": "12:29 PM",
        "id": 159
      },
      {
        "no": 11,
        "name": "WATER TANK 2",
        "time": "12:29 PM",
        "id": 290
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "12:35 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:45 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "12:51 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:03 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:09 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:10 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:24 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "01:33 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "01:39 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-C-1-219",
    "routeNo": "54-C",
    "code": "54/P54C-2",
    "tripCode": "54/P54C-254-CTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHETTIKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 AM",
    "endTime": "07:40 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163,
      34,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      168
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:30 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:34 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:41 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:51 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:52 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:56 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "07:01 AM",
        "id": 163
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "07:10 AM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "07:14 AM",
        "id": 9
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "07:20 AM",
        "id": 10
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "07:24 AM",
        "id": 37
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "07:27 AM",
        "id": 12
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "07:32 AM",
        "id": 13
      },
      {
        "no": 15,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:35 AM",
        "id": 40
      },
      {
        "no": 16,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:37 AM",
        "id": 17
      },
      {
        "no": 17,
        "name": "CHETTIKULAM",
        "time": "07:40 AM",
        "id": 168
      }
    ]
  },
  {
    "id": "54-C-2-220",
    "routeNo": "54-C",
    "code": "54/P54C-2",
    "tripCode": "54/P54C-254-CTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "CHETTIKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:55 AM",
    "endTime": "09:05 AM",
    "ids": [
      168,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      34,
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHETTIKULAM",
        "time": "07:55 AM",
        "id": 168
      },
      {
        "no": 16,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:57 AM",
        "id": 17
      },
      {
        "no": 15,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:59 AM",
        "id": 40
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "08:02 AM",
        "id": 13
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "08:07 AM",
        "id": 12
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "08:10 AM",
        "id": 37
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "08:14 AM",
        "id": 10
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "08:20 AM",
        "id": 9
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "08:24 AM",
        "id": 34
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "08:33 AM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:38 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:42 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:43 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:53 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:00 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:04 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:05 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-C-3-221",
    "routeNo": "54-C",
    "code": "54/P54C-1",
    "tripCode": "54/P54C-154-CTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "VAGAIKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:20 AM",
    "endTime": "10:50 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163,
      34,
      9,
      10,
      37,
      12,
      13,
      291,
      164,
      165,
      166,
      167
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:20 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:24 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:31 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:41 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:42 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:47 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "09:52 AM",
        "id": 163
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "10:00 AM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "10:04 AM",
        "id": 9
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "10:10 AM",
        "id": 10
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "10:14 AM",
        "id": 37
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "10:18 AM",
        "id": 12
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "10:22 AM",
        "id": 13
      },
      {
        "no": 15,
        "name": "KUMARAPURAM 2",
        "time": "10:28 AM",
        "id": 291
      },
      {
        "no": 16,
        "name": "KATTALANKULAM",
        "time": "10:32 AM",
        "id": 164
      },
      {
        "no": 17,
        "name": "M. PUDHUR",
        "time": "10:40 AM",
        "id": 165
      },
      {
        "no": 18,
        "name": "MUDIVAITHANENDAL",
        "time": "10:44 AM",
        "id": 166
      },
      {
        "no": 19,
        "name": "VAGAIKULAM",
        "time": "10:50 AM",
        "id": 167
      }
    ]
  },
  {
    "id": "54-C-4-222",
    "routeNo": "54-C",
    "code": "54/P54C-1",
    "tripCode": "54/P54C-154-CTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "VAGAIKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:05 AM",
    "endTime": "12:30 PM",
    "ids": [
      167,
      166,
      165,
      164,
      291,
      13,
      12,
      37,
      10,
      9,
      34,
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "VAGAIKULAM",
        "time": "11:05 AM",
        "id": 167
      },
      {
        "no": 18,
        "name": "MUDIVAITHANENDAL",
        "time": "11:09 AM",
        "id": 166
      },
      {
        "no": 17,
        "name": "M. PUDHUR",
        "time": "11:13 AM",
        "id": 165
      },
      {
        "no": 16,
        "name": "KATTALANKULAM",
        "time": "11:21 AM",
        "id": 164
      },
      {
        "no": 15,
        "name": "KUMARAPURAM 2",
        "time": "11:25 AM",
        "id": 291
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "11:30 AM",
        "id": 13
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "11:34 AM",
        "id": 12
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "11:38 AM",
        "id": 37
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "11:42 AM",
        "id": 10
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "11:47 AM",
        "id": 9
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "11:51 AM",
        "id": 34
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "11:59 AM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "12:04 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "12:08 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "12:09 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "12:19 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "12:25 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "12:29 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-C-5-223",
    "routeNo": "54-C",
    "code": "54/P54C-3",
    "tripCode": "54/P54C-354-CTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KOOTTAMPULI",
    "service": "TOWN ORDINARY",
    "startTime": "12:45 PM",
    "endTime": "01:55 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163,
      34,
      9
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "12:46 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "12:52 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:02 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:18 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:20 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:27 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "01:35 PM",
        "id": 163
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "01:48 PM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "01:55 PM",
        "id": 9
      }
    ]
  },
  {
    "id": "54-C-6-224",
    "routeNo": "54-C",
    "code": "54/P54C-3",
    "tripCode": "54/P54C-354-CTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KOOTTAMPULI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:00 PM",
    "endTime": "03:10 PM",
    "ids": [
      9,
      34,
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "02:00 PM",
        "id": 9
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "02:06 PM",
        "id": 34
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "02:19 PM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:27 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:34 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:36 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "02:52 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "03:02 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "03:08 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-C-7-225",
    "routeNo": "54-C",
    "code": "54/P54C-2",
    "tripCode": "54/P54C-254-CTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHETTIKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "03:15 PM",
    "endTime": "04:30 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163,
      34,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      168
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "03:15 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "03:20 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "03:27 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "03:37 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "03:38 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:43 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "03:49 PM",
        "id": 163
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "03:58 PM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "04:02 PM",
        "id": 9
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "04:08 PM",
        "id": 10
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "04:13 PM",
        "id": 37
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "04:17 PM",
        "id": 12
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "04:21 PM",
        "id": 13
      },
      {
        "no": 15,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:25 PM",
        "id": 40
      },
      {
        "no": 16,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "04:27 PM",
        "id": 17
      },
      {
        "no": 17,
        "name": "CHETTIKULAM",
        "time": "04:30 PM",
        "id": 168
      }
    ]
  },
  {
    "id": "54-C-8-226",
    "routeNo": "54-C",
    "code": "54/P54C-2",
    "tripCode": "54/P54C-254-CTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CHETTIKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:35 PM",
    "endTime": "05:50 PM",
    "ids": [
      168,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      34,
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHETTIKULAM",
        "time": "04:35 PM",
        "id": 168
      },
      {
        "no": 16,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "04:37 PM",
        "id": 17
      },
      {
        "no": 15,
        "name": "SUBRAMANIAPURAM 1",
        "time": "04:39 PM",
        "id": 40
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "04:43 PM",
        "id": 13
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "04:47 PM",
        "id": 12
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "04:51 PM",
        "id": 37
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "04:56 PM",
        "id": 10
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "05:02 PM",
        "id": 9
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "05:06 PM",
        "id": 34
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "05:15 PM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "05:21 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "05:26 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "05:27 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "05:37 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:44 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:49 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-C-9-227",
    "routeNo": "54-C",
    "code": "54/P54C-2",
    "tripCode": "54/P54C-254-CTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHETTIKULAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:55 PM",
    "endTime": "07:10 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163,
      34,
      9,
      10,
      37,
      12,
      13,
      40,
      17,
      168
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:55 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:55 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:00 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:07 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:17 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:18 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:23 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "06:29 PM",
        "id": 163
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "06:38 PM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "06:42 PM",
        "id": 9
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "06:48 PM",
        "id": 10
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "06:53 PM",
        "id": 37
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "06:57 PM",
        "id": 12
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "07:01 PM",
        "id": 13
      },
      {
        "no": 15,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:05 PM",
        "id": 40
      },
      {
        "no": 16,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:07 PM",
        "id": 17
      },
      {
        "no": 17,
        "name": "CHETTIKULAM",
        "time": "07:10 PM",
        "id": 168
      }
    ]
  },
  {
    "id": "54-C-10-228",
    "routeNo": "54-C",
    "code": "54/P54C-2",
    "tripCode": "54/P54C-254-CTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "CHETTIKULAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:25 PM",
    "endTime": "08:40 PM",
    "ids": [
      168,
      17,
      40,
      13,
      12,
      37,
      10,
      9,
      34,
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHETTIKULAM",
        "time": "07:25 PM",
        "id": 168
      },
      {
        "no": 16,
        "name": "RAMASAMYPURAM BRIDGE",
        "time": "07:27 PM",
        "id": 17
      },
      {
        "no": 15,
        "name": "SUBRAMANIAPURAM 1",
        "time": "07:29 PM",
        "id": 40
      },
      {
        "no": 14,
        "name": "SAWYERPURAM",
        "time": "07:33 PM",
        "id": 13
      },
      {
        "no": 13,
        "name": "SEBATHAIAHPURAM",
        "time": "07:37 PM",
        "id": 12
      },
      {
        "no": 12,
        "name": "SALAI",
        "time": "07:41 PM",
        "id": 37
      },
      {
        "no": 11,
        "name": "SERVAIKARANMADAM",
        "time": "07:46 PM",
        "id": 10
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "07:52 PM",
        "id": 9
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "07:56 PM",
        "id": 34
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "08:05 PM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:11 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:16 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:17 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:27 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:34 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:39 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-C-11-229",
    "routeNo": "54-C",
    "code": "54/P54C-3",
    "tripCode": "54/P54C-354-CTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KOOTTAMPULI",
    "service": "TOWN ORDINARY",
    "startTime": "08:55 PM",
    "endTime": "09:55 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163,
      34,
      9
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:55 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:55 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:01 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:10 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:23 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:25 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:31 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "09:38 PM",
        "id": 163
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "09:49 PM",
        "id": 34
      },
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "09:55 PM",
        "id": 9
      }
    ]
  },
  {
    "id": "54-C-12-230",
    "routeNo": "54-C",
    "code": "54/P54C-3",
    "tripCode": "54/P54C-354-CTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KOOTTAMPULI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:00 PM",
    "endTime": "11:00 PM",
    "ids": [
      9,
      34,
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "KOOTTAMPULI",
        "time": "10:00 PM",
        "id": 9
      },
      {
        "no": 9,
        "name": "KULAIYANKARISAL",
        "time": "10:05 PM",
        "id": 34
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "10:16 PM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:23 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:29 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:31 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:44 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:53 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:59 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-D-1-231",
    "routeNo": "54-D",
    "code": "54/P54D-3",
    "tripCode": "54/P54D-354-DTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SOUTH KOVANKADU",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 AM",
    "endTime": "07:05 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      157,
      158
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:15 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:20 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:27 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:39 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:40 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:45 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:55 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:59 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "06:59 AM",
        "id": 157
      },
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "07:05 AM",
        "id": 158
      }
    ]
  },
  {
    "id": "54-D-2-232",
    "routeNo": "54-D",
    "code": "54/P54D-3",
    "tripCode": "54/P54D-354-DTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "SOUTH KOVANKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 AM",
    "endTime": "08:00 AM",
    "ids": [
      158,
      157,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SOUTH KOVANKADU",
        "time": "07:10 AM",
        "id": 158
      },
      {
        "no": 10,
        "name": "KOVANKADU",
        "time": "07:15 AM",
        "id": 157
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:15 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:19 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:29 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:34 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:35 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:47 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:54 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:59 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-D-3-233",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 AM",
    "endTime": "09:00 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      169,
      170,
      161,
      171,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:05 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:05 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:08 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:12 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:19 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:20 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:23 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "08:29 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "08:32 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "08:37 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "08:39 AM",
        "id": 169
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "08:42 AM",
        "id": 170
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "08:46 AM",
        "id": 161
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "08:49 AM",
        "id": 171
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "08:53 AM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "09:00 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-4-234",
    "routeNo": "54-D",
    "code": "54/P54D-2",
    "tripCode": "54/P54D-254-DTORD18U4",
    "order": 4,
    "direction": "U",
    "from": "ERAL",
    "to": "SIRUTHONDANALLUR",
    "service": "TOWN ORDINARY",
    "startTime": "09:05 AM",
    "endTime": "09:00 AM",
    "ids": [
      20,
      19
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "09:05 AM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SIRUTHONDANALLUR",
        "time": "09:00 AM",
        "id": 19
      }
    ]
  },
  {
    "id": "54-D-5-235",
    "routeNo": "54-D",
    "code": "54/P54D-2",
    "tripCode": "54/P54D-254-DTORD18D5",
    "order": 5,
    "direction": "D",
    "from": "SIRUTHONDANALLUR",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 AM",
    "endTime": "09:10 AM",
    "ids": [
      19,
      20
    ],
    "stops": [
      {
        "no": 2,
        "name": "SIRUTHONDANALLUR",
        "time": "09:15 AM",
        "id": 19
      },
      {
        "no": 1,
        "name": "ERAL",
        "time": "09:10 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-6-236",
    "routeNo": "54-D",
    "code": "54/P54D-2",
    "tripCode": "54/P54D-254-DTORD18U6",
    "order": 6,
    "direction": "U",
    "from": "ERAL",
    "to": "SIRUTHONDANALLUR",
    "service": "TOWN ORDINARY",
    "startTime": "09:05 AM",
    "endTime": "09:10 AM",
    "ids": [
      20,
      19
    ],
    "stops": [
      {
        "no": 1,
        "name": "ERAL",
        "time": "09:05 AM",
        "id": 20
      },
      {
        "no": 2,
        "name": "SIRUTHONDANALLUR",
        "time": "09:10 AM",
        "id": 19
      }
    ]
  },
  {
    "id": "54-D-7-237",
    "routeNo": "54-D",
    "code": "54/P54D-2",
    "tripCode": "54/P54D-254-DTORD18D7",
    "order": 7,
    "direction": "D",
    "from": "SIRUTHONDANALLUR",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 AM",
    "endTime": "09:20 AM",
    "ids": [
      19,
      20
    ],
    "stops": [
      {
        "no": 2,
        "name": "SIRUTHONDANALLUR",
        "time": "09:15 AM",
        "id": 19
      },
      {
        "no": 1,
        "name": "ERAL",
        "time": "09:20 AM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-8-238",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 AM",
    "endTime": "11:25 AM",
    "ids": [
      20,
      54,
      171,
      161,
      170,
      169,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "09:50 AM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "10:00 AM",
        "id": 54
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "10:07 AM",
        "id": 171
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "10:13 AM",
        "id": 161
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "10:19 AM",
        "id": 170
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "10:24 AM",
        "id": 169
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "10:29 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "10:37 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "10:42 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:53 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:58 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:59 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:11 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "11:19 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "11:24 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-D-9-239",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "11:30 AM",
    "endTime": "12:50 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      169,
      170,
      161,
      171,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "11:30 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "11:34 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:41 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:51 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "11:52 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "11:56 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "12:05 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:09 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "12:16 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "12:20 PM",
        "id": 169
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "12:24 PM",
        "id": 170
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "12:29 PM",
        "id": 161
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "12:35 PM",
        "id": 171
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "12:40 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "12:50 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-10-240",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:55 PM",
    "endTime": "01:40 PM",
    "ids": [
      20,
      54,
      171,
      161,
      170,
      169,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "12:55 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "01:00 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "01:03 PM",
        "id": 171
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "01:06 PM",
        "id": 161
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "01:09 PM",
        "id": 170
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "01:11 PM",
        "id": 169
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "01:13 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:17 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "01:19 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:24 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:27 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:27 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:33 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "01:37 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "01:39 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-D-11-241",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "02:30 PM",
    "endTime": "03:40 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      169,
      170,
      161,
      171,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "02:30 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "02:34 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "02:39 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:48 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:49 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:53 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "03:01 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:04 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "03:11 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "03:14 PM",
        "id": 169
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "03:17 PM",
        "id": 170
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "03:22 PM",
        "id": 161
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "03:27 PM",
        "id": 171
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "03:32 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "03:40 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-12-242",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:45 PM",
    "endTime": "05:05 PM",
    "ids": [
      20,
      54,
      171,
      161,
      170,
      169,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "03:45 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "03:54 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "03:59 PM",
        "id": 171
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "04:05 PM",
        "id": 161
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "04:10 PM",
        "id": 170
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "04:14 PM",
        "id": 169
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "04:18 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "04:25 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "04:29 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "04:38 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:42 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:43 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:53 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:00 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:04 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-D-13-243",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "05:10 PM",
    "endTime": "06:40 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      169,
      170,
      161,
      171,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:10 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:15 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "05:22 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "05:34 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "05:35 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "05:40 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "05:50 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "05:54 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "06:02 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "06:07 PM",
        "id": 169
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "06:11 PM",
        "id": 170
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "06:17 PM",
        "id": 161
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "06:23 PM",
        "id": 171
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "06:29 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "06:40 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-14-244",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:45 PM",
    "endTime": "08:30 PM",
    "ids": [
      20,
      54,
      171,
      161,
      170,
      169,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "06:45 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "06:56 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "07:04 PM",
        "id": 171
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "07:11 PM",
        "id": 161
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "07:18 PM",
        "id": 170
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "07:23 PM",
        "id": 169
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "07:28 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:37 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:43 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:54 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:00 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:01 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:15 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:23 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:29 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-D-15-245",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ERAL",
    "service": "TOWN ORDINARY",
    "startTime": "08:20 PM",
    "endTime": "09:50 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      169,
      170,
      161,
      171,
      54,
      20
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:20 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:25 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:32 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:44 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:45 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:50 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:00 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:04 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:12 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "09:17 PM",
        "id": 169
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "09:21 PM",
        "id": 170
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "09:27 PM",
        "id": 161
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "09:33 PM",
        "id": 171
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "09:39 PM",
        "id": 54
      },
      {
        "no": 16,
        "name": "ERAL",
        "time": "09:50 PM",
        "id": 20
      }
    ]
  },
  {
    "id": "54-D-16-246",
    "routeNo": "54-D",
    "code": "54/P54D-1",
    "tripCode": "54/P54D-154-DTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "ERAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:00 PM",
    "endTime": "05:45 AM",
    "ids": [
      20,
      54,
      171,
      161,
      170,
      169,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "ERAL",
        "time": "10:00 PM",
        "id": 20
      },
      {
        "no": 15,
        "name": "WATER TANK 1",
        "time": "10:52 PM",
        "id": 54
      },
      {
        "no": 14,
        "name": "KORKAI",
        "time": "11:26 PM",
        "id": 171
      },
      {
        "no": 13,
        "name": "MARAMANGALAM",
        "time": "11:56 PM",
        "id": 161
      },
      {
        "no": 12,
        "name": "AGARAM",
        "time": "12:26 AM",
        "id": 170
      },
      {
        "no": 11,
        "name": "AGARAM BRIDGE",
        "time": "12:50 AM",
        "id": 169
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "01:12 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:54 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "02:17 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:09 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "03:34 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "03:40 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:39 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:16 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:41 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-F-1-247",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUNNAKAYAL",
    "service": "TOWN ORDINARY",
    "startTime": "01:15 PM",
    "endTime": "02:30 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172,
      173,
      174,
      175
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "01:15 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "01:19 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:25 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:34 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "01:35 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "01:39 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "01:47 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:51 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "01:58 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "02:05 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "02:10 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "02:14 PM",
        "id": 172
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "02:21 PM",
        "id": 173
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "02:25 PM",
        "id": 174
      },
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "02:30 PM",
        "id": 175
      }
    ]
  },
  {
    "id": "54-F-2-248",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "PUNNAKAYAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:35 PM",
    "endTime": "04:00 PM",
    "ids": [
      175,
      174,
      173,
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "02:35 PM",
        "id": 175
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "02:40 PM",
        "id": 174
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "02:45 PM",
        "id": 173
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "02:52 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "02:56 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "03:02 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "03:11 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:18 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "03:22 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "03:32 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "03:36 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "03:37 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "03:48 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "03:54 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "03:59 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-F-3-249",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUNNAKAYAL",
    "service": "TOWN ORDINARY",
    "startTime": "04:05 PM",
    "endTime": "05:20 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172,
      173,
      174,
      175
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:05 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:09 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:15 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:24 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:25 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "04:29 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "04:37 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "04:41 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "04:48 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "04:55 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "05:00 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "05:04 PM",
        "id": 172
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "05:11 PM",
        "id": 173
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "05:15 PM",
        "id": 174
      },
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "05:20 PM",
        "id": 175
      }
    ]
  },
  {
    "id": "54-F-4-250",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "PUNNAKAYAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:25 PM",
    "endTime": "06:40 PM",
    "ids": [
      175,
      174,
      173,
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "05:25 PM",
        "id": 175
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "05:29 PM",
        "id": 174
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "05:33 PM",
        "id": 173
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "05:40 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "05:44 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "05:49 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "05:56 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:03 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:07 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:15 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:19 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:20 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:29 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:35 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:39 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-F-5-251",
    "routeNo": "54-F",
    "code": "54/P54F-2",
    "tripCode": "54/P54F-254-FTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ATTHIMARAPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "06:45 PM",
    "endTime": "07:20 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      176,
      177
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:45 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:51 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:59 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:11 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "07:12 PM",
        "id": 176
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "07:20 PM",
        "id": 177
      }
    ]
  },
  {
    "id": "54-F-6-252",
    "routeNo": "54-F",
    "code": "54/P54F-2",
    "tripCode": "54/P54F-254-FTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ATTHIMARAPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 PM",
    "endTime": "10:00 PM",
    "ids": [
      177,
      176,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "07:30 PM",
        "id": 177
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "08:03 PM",
        "id": 176
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:05 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:59 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:33 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:56 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-F-7-253",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUNNAKAYAL",
    "service": "TOWN ORDINARY",
    "startTime": "10:15 PM",
    "endTime": "05:40 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172,
      173,
      174,
      175
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:18 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:41 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:16 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "12:11 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "12:16 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "12:40 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "01:29 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "01:51 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "02:30 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "03:14 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "03:45 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "04:08 AM",
        "id": 172
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "04:47 AM",
        "id": 173
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "05:12 AM",
        "id": 174
      },
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "05:40 AM",
        "id": 175
      }
    ]
  },
  {
    "id": "54-F-8-254",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PUNNAKAYAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 AM",
    "endTime": "07:25 AM",
    "ids": [
      175,
      174,
      173,
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "05:45 AM",
        "id": 175
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "05:51 AM",
        "id": 174
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "05:56 AM",
        "id": 173
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "06:05 AM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "06:10 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "06:17 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "06:27 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:36 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:41 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:52 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:57 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:58 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:11 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:18 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:24 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-F-9-255",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUNNAKAYAL",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 AM",
    "endTime": "08:40 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172,
      173,
      174,
      175
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:30 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:34 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:39 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:48 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:49 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:52 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "08:00 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "08:03 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "08:10 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "08:17 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "08:22 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "08:25 AM",
        "id": 172
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "08:31 AM",
        "id": 173
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "08:35 AM",
        "id": 174
      },
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "08:40 AM",
        "id": 175
      }
    ]
  },
  {
    "id": "54-F-10-256",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "PUNNAKAYAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:50 AM",
    "endTime": "10:25 AM",
    "ids": [
      175,
      174,
      173,
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "08:50 AM",
        "id": 175
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "08:55 AM",
        "id": 174
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "09:01 AM",
        "id": 173
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "09:09 AM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "09:14 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "09:21 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:30 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:38 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:43 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:53 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:58 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:00 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:11 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:19 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:24 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-F-11-257",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUNNAKAYAL",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 AM",
    "endTime": "11:40 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172,
      173,
      174,
      175
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:30 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:34 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:39 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:48 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:49 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:52 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "11:00 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "11:03 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "11:10 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "11:17 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "11:22 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "11:25 AM",
        "id": 172
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "11:31 AM",
        "id": 173
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "11:35 AM",
        "id": 174
      },
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "11:40 AM",
        "id": 175
      }
    ]
  },
  {
    "id": "54-F-12-258",
    "routeNo": "54-F",
    "code": "54/P54F-1",
    "tripCode": "54/P54F-154-FTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "PUNNAKAYAL",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:45 AM",
    "endTime": "01:10 PM",
    "ids": [
      175,
      174,
      173,
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PUNNAKAYAL",
        "time": "11:45 AM",
        "id": 175
      },
      {
        "no": 15,
        "name": "DCW COLONY",
        "time": "11:50 AM",
        "id": 174
      },
      {
        "no": 14,
        "name": "CHERNTHAMARAM",
        "time": "11:55 AM",
        "id": 173
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "12:02 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "12:06 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "12:12 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "12:21 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:28 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "12:32 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "12:42 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "12:46 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "12:47 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "12:58 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "01:04 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "01:09 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-1-259",
    "routeNo": "54-G",
    "code": "54/P54G-5",
    "tripCode": "54/P54G-554-GTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KOLLAMPARAMBU",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 AM",
    "endTime": "06:25 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      152,
      289,
      154
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:46 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:48 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:51 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:52 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:55 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "05:57 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "06:01 AM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "06:06 AM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "06:09 AM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "06:12 AM",
        "id": 100
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 1",
        "time": "06:18 AM",
        "id": 152
      },
      {
        "no": 14,
        "name": "CHANDRAGIRI",
        "time": "06:19 AM",
        "id": 289
      },
      {
        "no": 15,
        "name": "KOLLAMPARAMBU",
        "time": "06:25 AM",
        "id": 154
      }
    ]
  },
  {
    "id": "54-G-2-260",
    "routeNo": "54-G",
    "code": "54/P54G-6",
    "tripCode": "54/P54G-654-GTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KOLLAMPARAMBU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 AM",
    "endTime": "07:20 AM",
    "ids": [
      154,
      289,
      152,
      100,
      281,
      99,
      143,
      292,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "KOLLAMPARAMBU",
        "time": "06:30 AM",
        "id": 154
      },
      {
        "no": 15,
        "name": "CHANDRAGIRI",
        "time": "06:36 AM",
        "id": 289
      },
      {
        "no": 14,
        "name": "CHANDRAGIRI JUNCTION 1",
        "time": "06:37 AM",
        "id": 152
      },
      {
        "no": 12,
        "name": "KURUKKUSALAI",
        "time": "06:44 AM",
        "id": 100
      },
      {
        "no": 11,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "06:47 AM",
        "id": 281
      },
      {
        "no": 10,
        "name": "VALASAMUTHIRAM",
        "time": "06:51 AM",
        "id": 99
      },
      {
        "no": 9,
        "name": "ARASADI 1",
        "time": "07:00 AM",
        "id": 143
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 2",
        "time": "07:03 AM",
        "id": 292
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "07:05 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:07 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:11 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:12 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:16 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:17 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-3-261",
    "routeNo": "54-G",
    "code": "54/P54G-2",
    "tripCode": "54/P54G-254-GTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MULLAKADU",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 AM",
    "endTime": "08:10 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:31 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:37 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:46 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:01 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:03 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:10 AM",
        "id": 46
      }
    ]
  },
  {
    "id": "54-G-4-262",
    "routeNo": "54-G",
    "code": "54/P54G-3",
    "tripCode": "54/P54G-354-GTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "MULLAKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:15 AM",
    "ids": [
      46,
      45,
      184,
      183,
      182,
      181,
      180,
      293,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 12,
        "name": "MULLAKADU",
        "time": "08:15 AM",
        "id": 46
      },
      {
        "no": 11,
        "name": "SPIC NAGAR",
        "time": "08:20 AM",
        "id": 45
      },
      {
        "no": 10,
        "name": "BULK",
        "time": "08:22 AM",
        "id": 184
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "08:37 AM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "08:39 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:44 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:51 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:54 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:01 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:09 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:14 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:15 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-5-263",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "09:20 AM",
    "endTime": "09:50 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:24 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:28 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:34 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "09:37 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:40 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:45 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:48 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "09:50 AM",
        "id": 183
      }
    ]
  },
  {
    "id": "54-G-6-264",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:00 AM",
    "endTime": "10:40 AM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "10:00 AM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "10:02 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:06 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:13 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:16 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:20 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "10:28 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:33 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-7-265",
    "routeNo": "54-G",
    "code": "54/P54G-1",
    "tripCode": "54/P54G-154-GTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PON NAGAR",
    "service": "TOWN ORDINARY",
    "startTime": "10:45 AM",
    "endTime": "11:10 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      176,
      177,
      178
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:45 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:49 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:54 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:02 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "11:02 AM",
        "id": 176
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "11:07 AM",
        "id": 177
      },
      {
        "no": 8,
        "name": "PON NAGAR",
        "time": "11:10 AM",
        "id": 178
      }
    ]
  },
  {
    "id": "54-G-8-266",
    "routeNo": "54-G",
    "code": "54/P54G-1",
    "tripCode": "54/P54G-154-GTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PON NAGAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:20 AM",
    "endTime": "11:40 AM",
    "ids": [
      178,
      177,
      176,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 8,
        "name": "PON NAGAR",
        "time": "11:20 AM",
        "id": 178
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "11:21 AM",
        "id": 177
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "11:25 AM",
        "id": 176
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:25 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:32 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "11:36 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "11:39 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-9-267",
    "routeNo": "54-G",
    "code": "54/P54G-8",
    "tripCode": "54/P54G-854-GTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "VELLAPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "11:50 AM",
    "endTime": "12:20 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      187
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "11:50 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "11:54 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:58 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "12:05 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "12:08 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "12:09 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "12:15 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "VELLAPATTI",
        "time": "12:20 PM",
        "id": 187
      }
    ]
  },
  {
    "id": "54-G-10-268",
    "routeNo": "54-G",
    "code": "54/P54G-8",
    "tripCode": "54/P54G-854-GTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "VELLAPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:30 PM",
    "endTime": "01:25 PM",
    "ids": [
      187,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 8,
        "name": "VELLAPATTI",
        "time": "12:30 PM",
        "id": 187
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "12:37 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "12:48 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "12:51 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "12:56 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:09 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "01:16 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "01:25 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "54-G-11-269",
    "routeNo": "54-G",
    "code": "54/P54G-1",
    "tripCode": "54/P54G-154-GTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PON NAGAR",
    "service": "TOWN ORDINARY",
    "startTime": "01:30 PM",
    "endTime": "02:00 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      176,
      177,
      178
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "01:30 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "01:34 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "01:41 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "01:51 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "01:51 PM",
        "id": 176
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "01:57 PM",
        "id": 177
      },
      {
        "no": 8,
        "name": "PON NAGAR",
        "time": "02:00 PM",
        "id": 178
      }
    ]
  },
  {
    "id": "54-G-12-270",
    "routeNo": "54-G",
    "code": "54/P54G-1",
    "tripCode": "54/P54G-154-GTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "PON NAGAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:05 PM",
    "endTime": "02:35 PM",
    "ids": [
      178,
      177,
      176,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 8,
        "name": "PON NAGAR",
        "time": "02:05 PM",
        "id": 178
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "02:07 PM",
        "id": 177
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "02:13 PM",
        "id": 176
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:13 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "02:23 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "02:30 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "02:34 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-13-271",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "02:40 PM",
    "endTime": "03:25 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "02:47 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "02:53 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "03:01 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "03:06 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "03:10 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "03:17 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "03:22 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "03:25 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "54-G-14-272",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:30 PM",
    "endTime": "04:05 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "03:30 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "03:32 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "03:35 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "03:41 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "03:44 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "03:47 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "03:54 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "03:59 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-15-273",
    "routeNo": "54-G",
    "code": "54/P54G-1",
    "tripCode": "54/P54G-154-GTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PON NAGAR",
    "service": "TOWN ORDINARY",
    "startTime": "04:15 PM",
    "endTime": "04:55 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      176,
      177,
      178
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:15 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:21 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:29 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:43 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "04:43 PM",
        "id": 176
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "04:51 PM",
        "id": 177
      },
      {
        "no": 8,
        "name": "PON NAGAR",
        "time": "04:55 PM",
        "id": 178
      }
    ]
  },
  {
    "id": "54-G-16-274",
    "routeNo": "54-G",
    "code": "54/P54G-7",
    "tripCode": "54/P54G-754-GTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "PON NAGAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 PM",
    "endTime": "07:10 PM",
    "ids": [
      178,
      177,
      176,
      44,
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 13,
        "name": "PON NAGAR",
        "time": "05:00 PM",
        "id": 178
      },
      {
        "no": 12,
        "name": "ATTHIMARAPATTI",
        "time": "05:05 PM",
        "id": 177
      },
      {
        "no": 11,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "05:19 PM",
        "id": 176
      },
      {
        "no": 10,
        "name": "MUTHAIAHPURAM",
        "time": "05:19 PM",
        "id": 44
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "05:48 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "05:53 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:01 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:15 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:21 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:30 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "06:46 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "06:57 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-17-275",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18U17",
    "order": 17,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 PM",
    "endTime": "07:55 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:25 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "07:30 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "07:37 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "07:40 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "07:43 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "07:49 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "07:52 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "07:55 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "54-G-18-276",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18D18",
    "order": 18,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 PM",
    "endTime": "08:30 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "08:00 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "08:01 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:04 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:09 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:12 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:15 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:21 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:25 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "54-G-19-277",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18U19",
    "order": 19,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "08:40 PM",
    "endTime": "09:05 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:43 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:47 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:52 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:54 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:56 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:01 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:03 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "09:05 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "54-G-20-278",
    "routeNo": "54-G",
    "code": "54/P54G-4",
    "tripCode": "54/P54G-454-GTORD18D20",
    "order": 20,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 PM",
    "endTime": "10:00 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "09:10 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:12 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:17 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:26 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "09:30 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:35 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:45 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:52 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-1-279",
    "routeNo": "55-A",
    "code": "55/P55A-3",
    "tripCode": "55/P55A-355-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "GOVERNORGIRI",
    "service": "TOWN ORDINARY",
    "startTime": "12:30 PM",
    "endTime": "01:35 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      191,
      192,
      193,
      194,
      195
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "12:32 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "12:34 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "12:38 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "12:40 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "12:45 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "12:47 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "12:52 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "12:59 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "01:03 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "01:07 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "01:12 PM",
        "id": 191
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "01:17 PM",
        "id": 192
      },
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "01:24 PM",
        "id": 193
      },
      {
        "no": 15,
        "name": "VELLARAM",
        "time": "01:30 PM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "01:35 PM",
        "id": 195
      }
    ]
  },
  {
    "id": "55-A-2-280",
    "routeNo": "55-A",
    "code": "55/P55A-3",
    "tripCode": "55/P55A-355-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "GOVERNORGIRI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:40 PM",
    "endTime": "02:45 PM",
    "ids": [
      195,
      194,
      193,
      192,
      191,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "01:40 PM",
        "id": 195
      },
      {
        "no": 15,
        "name": "VELLARAM",
        "time": "01:44 PM",
        "id": 194
      },
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "01:50 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "01:57 PM",
        "id": 192
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "02:02 PM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "02:07 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "02:11 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "02:15 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "02:22 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "02:27 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:29 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:34 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:36 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:40 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:42 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-3-281",
    "routeNo": "55-A",
    "code": "55/P55A-6",
    "tripCode": "55/P55A-655-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "04:05 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      101,
      188,
      189,
      190,
      76
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:02 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:04 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:09 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:10 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:16 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "03:19 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "03:24 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "03:31 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "03:36 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "03:40 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "03:44 PM",
        "id": 101
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "03:49 PM",
        "id": 188
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "03:52 PM",
        "id": 189
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "03:57 PM",
        "id": 190
      },
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "04:05 PM",
        "id": 76
      }
    ]
  },
  {
    "id": "55-A-4-282",
    "routeNo": "55-A",
    "code": "55/P55A-6",
    "tripCode": "55/P55A-655-ATORD18D4",
    "order": 4,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:10 PM",
    "endTime": "05:20 PM",
    "ids": [
      76,
      190,
      189,
      188,
      101,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "04:10 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "04:17 PM",
        "id": 190
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "04:23 PM",
        "id": 189
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "04:26 PM",
        "id": 188
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "04:32 PM",
        "id": 101
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "04:35 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "04:40 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "04:46 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "04:53 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "04:59 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:02 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:08 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:09 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:14 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:16 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-5-283",
    "routeNo": "55-A",
    "code": "55/P55A-2",
    "tripCode": "55/P55A-255-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM TALUK OFFICE",
    "service": "TOWN ORDINARY",
    "startTime": "05:25 PM",
    "endTime": "06:25 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      101,
      188,
      189,
      190,
      76,
      109
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:25 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:27 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:29 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:33 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:34 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:39 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "05:42 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "05:47 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "05:53 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "05:58 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "06:02 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "06:05 PM",
        "id": 101
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "06:10 PM",
        "id": 188
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "06:12 PM",
        "id": 189
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "06:17 PM",
        "id": 190
      },
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "06:24 PM",
        "id": 76
      },
      {
        "no": 17,
        "name": "OTTAPIDARAM TALUK OFFICE",
        "time": "06:25 PM",
        "id": 109
      }
    ]
  },
  {
    "id": "55-A-6-284",
    "routeNo": "55-A",
    "code": "55/P55A-2",
    "tripCode": "55/P55A-255-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "OTTAPIDARAM TALUK OFFICE",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 PM",
    "endTime": "07:30 PM",
    "ids": [
      109,
      76,
      190,
      189,
      188,
      101,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "OTTAPIDARAM TALUK OFFICE",
        "time": "06:30 PM",
        "id": 109
      },
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "06:30 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "06:37 PM",
        "id": 190
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "06:42 PM",
        "id": 189
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "06:44 PM",
        "id": 188
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "06:49 PM",
        "id": 101
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "06:52 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "06:56 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "07:01 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "07:07 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "07:12 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:15 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:20 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:21 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:25 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:27 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-7-285",
    "routeNo": "55-A",
    "code": "55/P55A-3",
    "tripCode": "55/P55A-355-ATORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "GOVERNORGIRI",
    "service": "TOWN ORDINARY",
    "startTime": "07:45 PM",
    "endTime": "08:55 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      191,
      192,
      193,
      194,
      195
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:47 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:49 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:54 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:55 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:01 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "08:03 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "08:09 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "08:16 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "08:21 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "08:25 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "08:31 PM",
        "id": 191
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "08:35 PM",
        "id": 192
      },
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "08:43 PM",
        "id": 193
      },
      {
        "no": 15,
        "name": "VELLARAM",
        "time": "08:50 PM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "08:55 PM",
        "id": 195
      }
    ]
  },
  {
    "id": "55-A-8-286",
    "routeNo": "55-A",
    "code": "55/P55A-3",
    "tripCode": "55/P55A-355-ATORD18D8",
    "order": 8,
    "direction": "D",
    "from": "GOVERNORGIRI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:00 PM",
    "endTime": "10:05 PM",
    "ids": [
      195,
      194,
      193,
      192,
      191,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "09:00 PM",
        "id": 195
      },
      {
        "no": 15,
        "name": "VELLARAM",
        "time": "09:04 PM",
        "id": 194
      },
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "09:10 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "09:17 PM",
        "id": 192
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "09:22 PM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "09:27 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "09:31 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "09:35 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "09:42 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "09:47 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:49 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:54 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:56 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "10:00 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:02 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-9-287",
    "routeNo": "55-A",
    "code": "55/P55A-4",
    "tripCode": "55/P55A-455-ATORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:00 PM",
    "endTime": "12:15 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:01 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:03 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:05 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:06 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:09 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:12 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:15 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "11:19 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "11:23 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "11:26 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "11:42 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "11:59 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:03 AM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:04 AM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "12:12 AM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "12:15 AM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-A-10-288",
    "routeNo": "55-A",
    "code": "55/P55A-5",
    "tripCode": "55/P55A-555-ATORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 AM",
    "endTime": "06:25 AM",
    "ids": [
      193,
      192,
      191,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "05:30 AM",
        "id": 193
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "05:37 AM",
        "id": 192
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "05:41 AM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "05:46 AM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "05:50 AM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "05:55 AM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "06:02 AM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "06:07 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:09 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:14 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:16 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:20 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:22 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-11-289",
    "routeNo": "55-A",
    "code": "55/P55A-6",
    "tripCode": "55/P55A-655-ATORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 AM",
    "endTime": "08:00 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      101,
      188,
      189,
      190,
      76
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:53 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:55 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:00 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:01 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:07 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "07:10 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "07:16 AM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "07:23 AM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "07:29 AM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "07:34 AM",
        "id": 100
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "07:37 AM",
        "id": 101
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "07:43 AM",
        "id": 188
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "07:46 AM",
        "id": 189
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "07:52 AM",
        "id": 190
      },
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "08:00 AM",
        "id": 76
      }
    ]
  },
  {
    "id": "55-A-12-290",
    "routeNo": "55-A",
    "code": "55/P55A-6",
    "tripCode": "55/P55A-655-ATORD18D12",
    "order": 12,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 AM",
    "endTime": "09:20 AM",
    "ids": [
      76,
      190,
      189,
      188,
      101,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "08:05 AM",
        "id": 76
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "08:13 AM",
        "id": 190
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "08:19 AM",
        "id": 189
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "08:22 AM",
        "id": 188
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "08:29 AM",
        "id": 101
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "08:32 AM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "08:37 AM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "08:43 AM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "08:51 AM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "08:58 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:01 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:07 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:09 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:14 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:16 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-A-13-291",
    "routeNo": "55-A",
    "code": "55/P55A-2",
    "tripCode": "55/P55A-255-ATORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM TALUK OFFICE",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "10:30 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      101,
      188,
      189,
      190,
      76,
      109
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:37 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:39 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:42 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:44 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:48 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "09:50 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "09:55 AM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "10:01 AM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "10:05 AM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "10:09 AM",
        "id": 100
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "10:11 AM",
        "id": 101
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "10:16 AM",
        "id": 188
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "10:18 AM",
        "id": 189
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "10:23 AM",
        "id": 190
      },
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "10:29 AM",
        "id": 76
      },
      {
        "no": 17,
        "name": "OTTAPIDARAM TALUK OFFICE",
        "time": "10:30 AM",
        "id": 109
      }
    ]
  },
  {
    "id": "55-A-14-292",
    "routeNo": "55-A",
    "code": "55/P55A-2",
    "tripCode": "55/P55A-255-ATORD18D14",
    "order": 14,
    "direction": "D",
    "from": "OTTAPIDARAM TALUK OFFICE",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:35 AM",
    "endTime": "11:40 AM",
    "ids": [
      109,
      76,
      190,
      189,
      188,
      101,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "OTTAPIDARAM TALUK OFFICE",
        "time": "10:35 AM",
        "id": 109
      },
      {
        "no": 16,
        "name": "OTTAPIDARAM",
        "time": "10:35 AM",
        "id": 76
      },
      {
        "no": 15,
        "name": "PANCHALANKURICHI",
        "time": "10:43 AM",
        "id": 190
      },
      {
        "no": 14,
        "name": "AGILANDAPURAM",
        "time": "10:48 AM",
        "id": 189
      },
      {
        "no": 13,
        "name": "KAKKARAMPATTI",
        "time": "10:50 AM",
        "id": 188
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM 1",
        "time": "10:56 AM",
        "id": 101
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "10:59 AM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "11:03 AM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "11:08 AM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "11:15 AM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "11:21 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:23 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:29 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:30 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:35 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:37 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-B-1-293",
    "routeNo": "55-B",
    "code": "55/P55B-3",
    "tripCode": "55/P55B-355-BTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MILAGU NATTHAM",
    "service": "TOWN ORDINARY",
    "startTime": "12:40 PM",
    "endTime": "01:55 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      191,
      295,
      200,
      201,
      202,
      203,
      204,
      205,
      206,
      207
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "12:42 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "12:44 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "12:47 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "12:49 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "12:53 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "12:56 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "01:00 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "01:06 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "01:10 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "01:14 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "01:18 PM",
        "id": 191
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 2",
        "time": "01:23 PM",
        "id": 295
      },
      {
        "no": 14,
        "name": "MELA SEITHALAI",
        "time": "01:27 PM",
        "id": 200
      },
      {
        "no": 15,
        "name": "JEGAVEERAPANDIAPURAM",
        "time": "01:30 PM",
        "id": 201
      },
      {
        "no": 16,
        "name": "THANNEER MADAM",
        "time": "01:37 PM",
        "id": 202
      },
      {
        "no": 17,
        "name": "KAYATHAR JUNCTION",
        "time": "01:38 PM",
        "id": 203
      },
      {
        "no": 18,
        "name": "EPPODHUMVENDRAN",
        "time": "01:40 PM",
        "id": 204
      },
      {
        "no": 19,
        "name": "KATTUNAICKENPATTI",
        "time": "01:44 PM",
        "id": 205
      },
      {
        "no": 20,
        "name": "ADHANOOR",
        "time": "01:50 PM",
        "id": 206
      },
      {
        "no": 21,
        "name": "MILAGU NATTHAM",
        "time": "01:55 PM",
        "id": 207
      }
    ]
  },
  {
    "id": "55-B-2-294",
    "routeNo": "55-B",
    "code": "55/P55B-3",
    "tripCode": "55/P55B-355-BTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "MILAGU NATTHAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:00 PM",
    "endTime": "03:10 PM",
    "ids": [
      207,
      206,
      205,
      204,
      203,
      202,
      201,
      200,
      295,
      191,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 21,
        "name": "MILAGU NATTHAM",
        "time": "02:00 PM",
        "id": 207
      },
      {
        "no": 20,
        "name": "ADHANOOR",
        "time": "02:04 PM",
        "id": 206
      },
      {
        "no": 19,
        "name": "KATTUNAICKENPATTI",
        "time": "02:09 PM",
        "id": 205
      },
      {
        "no": 18,
        "name": "EPPODHUMVENDRAN",
        "time": "02:13 PM",
        "id": 204
      },
      {
        "no": 17,
        "name": "KAYATHAR JUNCTION",
        "time": "02:15 PM",
        "id": 203
      },
      {
        "no": 16,
        "name": "THANNEER MADAM",
        "time": "02:16 PM",
        "id": 202
      },
      {
        "no": 15,
        "name": "JEGAVEERAPANDIAPURAM",
        "time": "02:23 PM",
        "id": 201
      },
      {
        "no": 14,
        "name": "MELA SEITHALAI",
        "time": "02:25 PM",
        "id": 200
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 2",
        "time": "02:29 PM",
        "id": 295
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "02:33 PM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "02:37 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "02:41 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "02:45 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "02:50 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "02:55 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:57 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:01 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:02 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:06 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:07 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-B-3-295",
    "routeNo": "55-B",
    "code": "55/P55B-1",
    "tripCode": "55/P55B-155-BTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "03:15 PM",
    "endTime": "04:30 PM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "03:20 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:24 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "03:27 PM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "03:31 PM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "03:36 PM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "03:39 PM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "03:46 PM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "03:50 PM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "03:58 PM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "04:02 PM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:07 PM",
        "id": 74
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "04:10 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "04:13 PM",
        "id": 197
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "04:20 PM",
        "id": 296
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "04:26 PM",
        "id": 198
      },
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "04:30 PM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-B-4-296",
    "routeNo": "55-B",
    "code": "55/P55B-1",
    "tripCode": "55/P55B-155-BTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:35 PM",
    "endTime": "05:50 PM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      84,
      83,
      82,
      81,
      225,
      79,
      78,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "04:35 PM",
        "id": 199
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "04:38 PM",
        "id": 198
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "04:44 PM",
        "id": 296
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "04:51 PM",
        "id": 197
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "04:54 PM",
        "id": 196
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:57 PM",
        "id": 74
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "05:02 PM",
        "id": 73
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "05:06 PM",
        "id": 84
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "05:14 PM",
        "id": 83
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "05:18 PM",
        "id": 82
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "05:25 PM",
        "id": 81
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "05:28 PM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "05:33 PM",
        "id": 79
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "05:37 PM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:40 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:44 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-B-5-297",
    "routeNo": "55-B",
    "code": "55/P55B-2",
    "tripCode": "55/P55B-255-BTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MILAGU NATTHAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:00 PM",
    "endTime": "07:10 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      191,
      295,
      200,
      156,
      201,
      202,
      203,
      204,
      205,
      206,
      207
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:01 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:03 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:06 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:07 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:11 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "06:13 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "06:17 PM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "06:22 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "06:25 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "06:28 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "06:32 PM",
        "id": 191
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 2",
        "time": "06:36 PM",
        "id": 295
      },
      {
        "no": 14,
        "name": "MELA SEITHALAI",
        "time": "06:40 PM",
        "id": 200
      },
      {
        "no": 15,
        "name": "KEELA SEITHALAI",
        "time": "06:43 PM",
        "id": 156
      },
      {
        "no": 16,
        "name": "JEGAVEERAPANDIAPURAM",
        "time": "06:49 PM",
        "id": 201
      },
      {
        "no": 17,
        "name": "THANNEER MADAM",
        "time": "06:55 PM",
        "id": 202
      },
      {
        "no": 18,
        "name": "KAYATHAR JUNCTION",
        "time": "06:56 PM",
        "id": 203
      },
      {
        "no": 19,
        "name": "EPPODHUMVENDRAN",
        "time": "06:57 PM",
        "id": 204
      },
      {
        "no": 20,
        "name": "KATTUNAICKENPATTI",
        "time": "07:01 PM",
        "id": 205
      },
      {
        "no": 21,
        "name": "ADHANOOR",
        "time": "07:05 PM",
        "id": 206
      },
      {
        "no": 22,
        "name": "MILAGU NATTHAM",
        "time": "07:10 PM",
        "id": 207
      }
    ]
  },
  {
    "id": "55-B-6-298",
    "routeNo": "55-B",
    "code": "55/P55B-3",
    "tripCode": "55/P55B-355-BTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "MILAGU NATTHAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 PM",
    "endTime": "08:30 PM",
    "ids": [
      207,
      206,
      205,
      204,
      203,
      202,
      201,
      200,
      295,
      191,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 21,
        "name": "MILAGU NATTHAM",
        "time": "07:15 PM",
        "id": 207
      },
      {
        "no": 20,
        "name": "ADHANOOR",
        "time": "07:19 PM",
        "id": 206
      },
      {
        "no": 19,
        "name": "KATTUNAICKENPATTI",
        "time": "07:25 PM",
        "id": 205
      },
      {
        "no": 18,
        "name": "EPPODHUMVENDRAN",
        "time": "07:29 PM",
        "id": 204
      },
      {
        "no": 17,
        "name": "KAYATHAR JUNCTION",
        "time": "07:31 PM",
        "id": 203
      },
      {
        "no": 16,
        "name": "THANNEER MADAM",
        "time": "07:32 PM",
        "id": 202
      },
      {
        "no": 15,
        "name": "JEGAVEERAPANDIAPURAM",
        "time": "07:39 PM",
        "id": 201
      },
      {
        "no": 14,
        "name": "MELA SEITHALAI",
        "time": "07:42 PM",
        "id": 200
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 2",
        "time": "07:46 PM",
        "id": 295
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "07:51 PM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "07:55 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "07:59 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "08:03 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "08:09 PM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "08:13 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:16 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:20 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:22 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:25 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:27 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-B-7-299",
    "routeNo": "55-B",
    "code": "55/P55B-1",
    "tripCode": "55/P55B-155-BTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "10:00 PM",
    "endTime": "11:15 PM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "10:05 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:09 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "10:12 PM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "10:16 PM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "10:21 PM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "10:24 PM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "10:31 PM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "10:35 PM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "10:43 PM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "10:47 PM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:52 PM",
        "id": 74
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "10:55 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "10:58 PM",
        "id": 197
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "11:05 PM",
        "id": 296
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "11:11 PM",
        "id": 198
      },
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "11:15 PM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-B-8-300",
    "routeNo": "55-B",
    "code": "55/P55B-1",
    "tripCode": "55/P55B-155-BTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 AM",
    "endTime": "06:15 AM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      84,
      83,
      82,
      81,
      225,
      79,
      78,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "05:00 AM",
        "id": 199
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "05:03 AM",
        "id": 198
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "05:09 AM",
        "id": 296
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "05:16 AM",
        "id": 197
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "05:19 AM",
        "id": 196
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:22 AM",
        "id": 74
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "05:27 AM",
        "id": 73
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "05:31 AM",
        "id": 84
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "05:39 AM",
        "id": 83
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "05:43 AM",
        "id": 82
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "05:50 AM",
        "id": 81
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "05:53 AM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "05:58 AM",
        "id": 79
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "06:02 AM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:05 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:09 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-B-9-301",
    "routeNo": "55-B",
    "code": "55/P55B-3",
    "tripCode": "55/P55B-355-BTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MILAGU NATTHAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:45 AM",
    "endTime": "08:00 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      98,
      99,
      281,
      100,
      191,
      295,
      200,
      201,
      202,
      203,
      204,
      205,
      206,
      207
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:47 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:49 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:52 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:54 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:58 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "07:01 AM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "07:05 AM",
        "id": 98
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "07:11 AM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "07:15 AM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "07:19 AM",
        "id": 100
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "07:23 AM",
        "id": 191
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 2",
        "time": "07:28 AM",
        "id": 295
      },
      {
        "no": 14,
        "name": "MELA SEITHALAI",
        "time": "07:32 AM",
        "id": 200
      },
      {
        "no": 15,
        "name": "JEGAVEERAPANDIAPURAM",
        "time": "07:35 AM",
        "id": 201
      },
      {
        "no": 16,
        "name": "THANNEER MADAM",
        "time": "07:42 AM",
        "id": 202
      },
      {
        "no": 17,
        "name": "KAYATHAR JUNCTION",
        "time": "07:43 AM",
        "id": 203
      },
      {
        "no": 18,
        "name": "EPPODHUMVENDRAN",
        "time": "07:45 AM",
        "id": 204
      },
      {
        "no": 19,
        "name": "KATTUNAICKENPATTI",
        "time": "07:49 AM",
        "id": 205
      },
      {
        "no": 20,
        "name": "ADHANOOR",
        "time": "07:55 AM",
        "id": 206
      },
      {
        "no": 21,
        "name": "MILAGU NATTHAM",
        "time": "08:00 AM",
        "id": 207
      }
    ]
  },
  {
    "id": "55-B-10-302",
    "routeNo": "55-B",
    "code": "55/P55B-2",
    "tripCode": "55/P55B-255-BTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "MILAGU NATTHAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:25 AM",
    "ids": [
      207,
      206,
      205,
      204,
      203,
      202,
      201,
      156,
      200,
      295,
      191,
      100,
      281,
      99,
      98,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 22,
        "name": "MILAGU NATTHAM",
        "time": "08:15 AM",
        "id": 207
      },
      {
        "no": 21,
        "name": "ADHANOOR",
        "time": "08:19 AM",
        "id": 206
      },
      {
        "no": 20,
        "name": "KATTUNAICKENPATTI",
        "time": "08:23 AM",
        "id": 205
      },
      {
        "no": 19,
        "name": "EPPODHUMVENDRAN",
        "time": "08:27 AM",
        "id": 204
      },
      {
        "no": 18,
        "name": "KAYATHAR JUNCTION",
        "time": "08:28 AM",
        "id": 203
      },
      {
        "no": 17,
        "name": "THANNEER MADAM",
        "time": "08:29 AM",
        "id": 202
      },
      {
        "no": 16,
        "name": "JEGAVEERAPANDIAPURAM",
        "time": "08:35 AM",
        "id": 201
      },
      {
        "no": 15,
        "name": "KEELA SEITHALAI",
        "time": "08:41 AM",
        "id": 156
      },
      {
        "no": 14,
        "name": "MELA SEITHALAI",
        "time": "08:44 AM",
        "id": 200
      },
      {
        "no": 13,
        "name": "CHANDRAGIRI JUNCTION 2",
        "time": "08:48 AM",
        "id": 295
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "08:52 AM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "08:56 AM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "08:59 AM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "09:02 AM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 1",
        "time": "09:07 AM",
        "id": 98
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "09:11 AM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:13 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:17 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:18 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:21 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:23 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-B-11-303",
    "routeNo": "55-B",
    "code": "55/P55B-1",
    "tripCode": "55/P55B-155-BTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:30 AM",
    "endTime": "10:45 AM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:35 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:39 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "09:42 AM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "09:46 AM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "09:51 AM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "09:54 AM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "10:01 AM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "10:05 AM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "10:13 AM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "10:17 AM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:22 AM",
        "id": 74
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "10:25 AM",
        "id": 196
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "10:28 AM",
        "id": 197
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "10:35 AM",
        "id": 296
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "10:41 AM",
        "id": 198
      },
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "10:45 AM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-B-12-304",
    "routeNo": "55-B",
    "code": "55/P55B-1",
    "tripCode": "55/P55B-155-BTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:50 AM",
    "endTime": "12:05 PM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      84,
      83,
      82,
      81,
      225,
      79,
      78,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "10:50 AM",
        "id": 199
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "10:53 AM",
        "id": 198
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "10:59 AM",
        "id": 296
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "11:06 AM",
        "id": 197
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "11:09 AM",
        "id": 196
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "11:12 AM",
        "id": 74
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "11:17 AM",
        "id": 73
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "11:21 AM",
        "id": 84
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "11:29 AM",
        "id": 83
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "11:33 AM",
        "id": 82
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "11:40 AM",
        "id": 81
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "11:43 AM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "11:48 AM",
        "id": 79
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "11:52 AM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:55 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "11:59 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-C-1-305",
    "routeNo": "55-C",
    "code": "55/P55C-1",
    "tripCode": "55/P55C-155-CTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "12:10 PM",
    "endTime": "01:30 PM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "12:15 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:19 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "12:23 PM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "12:27 PM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "12:33 PM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "12:36 PM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "12:43 PM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "12:48 PM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "12:56 PM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "01:00 PM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:06 PM",
        "id": 74
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "01:09 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "01:12 PM",
        "id": 197
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "01:19 PM",
        "id": 296
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "01:25 PM",
        "id": 198
      },
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "01:30 PM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-C-2-306",
    "routeNo": "55-C",
    "code": "55/P55C-1",
    "tripCode": "55/P55C-155-CTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:40 PM",
    "endTime": "02:45 PM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      84,
      83,
      82,
      81,
      225,
      79,
      78,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "01:40 PM",
        "id": 199
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "01:43 PM",
        "id": 198
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "01:48 PM",
        "id": 296
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "01:54 PM",
        "id": 197
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "01:56 PM",
        "id": 196
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:59 PM",
        "id": 74
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "02:03 PM",
        "id": 73
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "02:06 PM",
        "id": 84
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "02:13 PM",
        "id": 83
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "02:17 PM",
        "id": 82
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "02:23 PM",
        "id": 81
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "02:26 PM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "02:30 PM",
        "id": 79
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "02:34 PM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:37 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "02:40 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-C-3-307",
    "routeNo": "55-C",
    "code": "55/P55C-2",
    "tripCode": "55/P55C-255-CTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SANGAMPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "02:50 PM",
    "endTime": "04:00 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      109,
      105,
      85,
      106,
      208,
      209
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:52 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:53 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:57 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:58 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:02 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:06 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "03:10 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "03:15 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "03:20 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "03:24 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "03:25 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "03:31 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "03:33 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "TALUK OFFICE",
        "time": "03:34 PM",
        "id": 109
      },
      {
        "no": 16,
        "name": "AYYANAR KOVIL",
        "time": "03:36 PM",
        "id": 105
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "03:43 PM",
        "id": 85
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "03:45 PM",
        "id": 106
      },
      {
        "no": 20,
        "name": "MURAMBAN",
        "time": "03:55 PM",
        "id": 208
      },
      {
        "no": 21,
        "name": "SANGAMPATTI",
        "time": "04:00 PM",
        "id": 209
      }
    ]
  },
  {
    "id": "55-C-4-308",
    "routeNo": "55-C",
    "code": "55/P55C-2",
    "tripCode": "55/P55C-255-CTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SANGAMPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:05 PM",
    "endTime": "05:35 PM",
    "ids": [
      209,
      208,
      106,
      85,
      105,
      109,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 21,
        "name": "SANGAMPATTI",
        "time": "04:05 PM",
        "id": 209
      },
      {
        "no": 20,
        "name": "MURAMBAN",
        "time": "04:10 PM",
        "id": 208
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "04:23 PM",
        "id": 106
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "04:26 PM",
        "id": 85
      },
      {
        "no": 16,
        "name": "AYYANAR KOVIL",
        "time": "04:35 PM",
        "id": 105
      },
      {
        "no": 15,
        "name": "TALUK OFFICE",
        "time": "04:38 PM",
        "id": 109
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "04:39 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "04:41 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "04:48 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:51 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "04:55 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "05:02 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "05:09 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "05:14 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:18 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:23 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:25 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:29 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:32 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-C-5-309",
    "routeNo": "55-C",
    "code": "55/P55C-1",
    "tripCode": "55/P55C-155-CTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 PM",
    "endTime": "06:55 PM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:49 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:53 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "05:56 PM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "06:00 PM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "06:05 PM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "06:08 PM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "06:14 PM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "06:18 PM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "06:25 PM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "06:29 PM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "06:34 PM",
        "id": 74
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "06:36 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "06:39 PM",
        "id": 197
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "06:46 PM",
        "id": 296
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "06:51 PM",
        "id": 198
      },
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "06:55 PM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-C-6-310",
    "routeNo": "55-C",
    "code": "55/P55C-1",
    "tripCode": "55/P55C-155-CTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 PM",
    "endTime": "08:15 PM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      84,
      83,
      82,
      81,
      225,
      79,
      78,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "07:00 PM",
        "id": 199
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "07:03 PM",
        "id": 198
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "07:09 PM",
        "id": 296
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "07:16 PM",
        "id": 197
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "07:19 PM",
        "id": 196
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:22 PM",
        "id": 74
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "07:27 PM",
        "id": 73
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "07:31 PM",
        "id": 84
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "07:39 PM",
        "id": 83
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "07:43 PM",
        "id": 82
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "07:50 PM",
        "id": 81
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "07:53 PM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "07:58 PM",
        "id": 79
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "08:02 PM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:05 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:09 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-C-7-311",
    "routeNo": "55-C",
    "code": "55/P55C-3",
    "tripCode": "55/P55C-355-CTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "VELLARAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 PM",
    "endTime": "10:55 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:42 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:45 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:49 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:51 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:57 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:01 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:06 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:13 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:20 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:25 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:27 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "10:34 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "10:37 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "GOVERNORGIRI",
        "time": "10:50 PM",
        "id": 195
      },
      {
        "no": 16,
        "name": "VELLARAM",
        "time": "10:55 PM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-C-8-312",
    "routeNo": "55-C",
    "code": "55/P55C-3",
    "tripCode": "55/P55C-355-CTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "VELLARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:30 AM",
    "endTime": "05:40 AM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "VELLARAM",
        "time": "04:30 AM",
        "id": 194
      },
      {
        "no": 15,
        "name": "GOVERNORGIRI",
        "time": "04:34 AM",
        "id": 195
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "04:46 AM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "04:49 AM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "04:55 AM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:57 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:02 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "05:08 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "05:15 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "05:19 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:24 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:29 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:30 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:35 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:37 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-C-9-313",
    "routeNo": "55-C",
    "code": "55/P55C-1",
    "tripCode": "55/P55C-155-CTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:20 AM",
    "endTime": "07:35 AM",
    "ids": [
      1,
      2,
      39,
      78,
      79,
      225,
      81,
      82,
      83,
      84,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:25 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:29 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "06:32 AM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "06:36 AM",
        "id": 79
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "06:41 AM",
        "id": 225
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "06:44 AM",
        "id": 81
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "06:51 AM",
        "id": 82
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "06:55 AM",
        "id": 83
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "07:03 AM",
        "id": 84
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "07:07 AM",
        "id": 73
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:12 AM",
        "id": 74
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "07:15 AM",
        "id": 196
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "07:18 AM",
        "id": 197
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "07:25 AM",
        "id": 296
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "07:31 AM",
        "id": 198
      },
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "07:35 AM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-C-10-314",
    "routeNo": "55-C",
    "code": "55/P55C-1",
    "tripCode": "55/P55C-155-CTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 AM",
    "endTime": "09:10 AM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      84,
      83,
      82,
      81,
      225,
      79,
      78,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "SAVARIMANGALAM",
        "time": "07:50 AM",
        "id": 199
      },
      {
        "no": 16,
        "name": "S.KAILASAPURAM",
        "time": "07:54 AM",
        "id": 198
      },
      {
        "no": 15,
        "name": "S.PUTHUR",
        "time": "08:00 AM",
        "id": 296
      },
      {
        "no": 14,
        "name": "JAMBULINGAPURAM",
        "time": "08:07 AM",
        "id": 197
      },
      {
        "no": 13,
        "name": "VALLINAYAGIPURAM",
        "time": "08:10 AM",
        "id": 196
      },
      {
        "no": 12,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:13 AM",
        "id": 74
      },
      {
        "no": 11,
        "name": "RAJAVIN KOVIL",
        "time": "08:19 AM",
        "id": 73
      },
      {
        "no": 10,
        "name": "SAMYNATTHAM",
        "time": "08:23 AM",
        "id": 84
      },
      {
        "no": 9,
        "name": "KAYALOORANI",
        "time": "08:31 AM",
        "id": 83
      },
      {
        "no": 8,
        "name": "VEERAPANDIAPURAM",
        "time": "08:36 AM",
        "id": 82
      },
      {
        "no": 7,
        "name": "RAILWAY GATE",
        "time": "08:43 AM",
        "id": 81
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "08:46 AM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR",
        "time": "08:52 AM",
        "id": 79
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "08:56 AM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:00 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:04 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-C-11-315",
    "routeNo": "55-C",
    "code": "55/P55C-2",
    "tripCode": "55/P55C-255-CTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SANGAMPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "09:20 AM",
    "endTime": "10:40 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      109,
      105,
      85,
      106,
      208,
      209
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:22 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:24 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:28 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:29 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:34 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:38 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:43 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:48 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:54 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:58 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:01 AM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "10:07 AM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "10:09 AM",
        "id": 76
      },
      {
        "no": 15,
        "name": "TALUK OFFICE",
        "time": "10:10 AM",
        "id": 109
      },
      {
        "no": 16,
        "name": "AYYANAR KOVIL",
        "time": "10:12 AM",
        "id": 105
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "10:21 AM",
        "id": 85
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "10:23 AM",
        "id": 106
      },
      {
        "no": 20,
        "name": "MURAMBAN",
        "time": "10:34 AM",
        "id": 208
      },
      {
        "no": 21,
        "name": "SANGAMPATTI",
        "time": "10:40 AM",
        "id": 209
      }
    ]
  },
  {
    "id": "55-C-12-316",
    "routeNo": "55-C",
    "code": "55/P55C-2",
    "tripCode": "55/P55C-255-CTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "SANGAMPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:45 AM",
    "endTime": "11:55 AM",
    "ids": [
      209,
      208,
      106,
      85,
      105,
      109,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 21,
        "name": "SANGAMPATTI",
        "time": "10:45 AM",
        "id": 209
      },
      {
        "no": 20,
        "name": "MURAMBAN",
        "time": "10:49 AM",
        "id": 208
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "10:59 AM",
        "id": 106
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "11:01 AM",
        "id": 85
      },
      {
        "no": 16,
        "name": "AYYANAR KOVIL",
        "time": "11:08 AM",
        "id": 105
      },
      {
        "no": 15,
        "name": "TALUK OFFICE",
        "time": "11:10 AM",
        "id": 109
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "11:11 AM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "11:13 AM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "11:19 AM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "11:20 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "11:24 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "11:29 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:34 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:38 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:42 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:46 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:47 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:51 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:52 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:55 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-1-317",
    "routeNo": "55-D",
    "code": "55/P55D-1",
    "tripCode": "55/P55D-155-DTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 AM",
    "endTime": "08:05 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:51 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:53 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:55 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:56 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:59 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:02 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:05 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:09 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:13 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:16 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "07:32 AM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:49 AM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:53 AM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "07:54 AM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "08:02 AM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "08:05 AM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-D-2-318",
    "routeNo": "55-D",
    "code": "55/P55D-1",
    "tripCode": "55/P55D-155-DTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 AM",
    "endTime": "09:25 AM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      193,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "08:10 AM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "08:12 AM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "08:20 AM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:21 AM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:25 AM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "08:42 AM",
        "id": 193
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:58 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:01 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:05 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:09 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:12 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:15 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:18 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:19 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:21 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:23 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-3-319",
    "routeNo": "55-D",
    "code": "55/P55D-3",
    "tripCode": "55/P55D-355-DTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 AM",
    "endTime": "10:40 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:51 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:53 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:56 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:57 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:01 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:04 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:08 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:12 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:17 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:20 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "10:28 AM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:35 AM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "10:40 AM",
        "id": 75
      }
    ]
  },
  {
    "id": "55-D-4-320",
    "routeNo": "55-D",
    "code": "55/P55D-3",
    "tripCode": "55/P55D-355-DTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:55 AM",
    "endTime": "11:45 AM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "10:55 AM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:59 AM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "11:06 AM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "11:14 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "11:17 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "11:22 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:26 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:30 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:33 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:37 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:38 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:41 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:43 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-5-321",
    "routeNo": "55-D",
    "code": "55/P55D-2",
    "tripCode": "55/P55D-255-DTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "AGILANDAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:50 AM",
    "endTime": "12:45 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      189,
      280,
      75,
      76,
      190
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:51 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:52 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:55 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:56 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:59 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "12:01 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "12:04 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "12:08 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:11 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:14 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "AGILANDAPURAM",
        "time": "12:25 PM",
        "id": 189
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:35 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:39 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:40 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "PANCHALANKURICHI",
        "time": "12:45 PM",
        "id": 190
      }
    ]
  },
  {
    "id": "55-D-6-322",
    "routeNo": "55-D",
    "code": "55/P55D-2",
    "tripCode": "55/P55D-255-DTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "AGILANDAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:50 PM",
    "endTime": "01:55 PM",
    "ids": [
      190,
      76,
      75,
      280,
      189,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PANCHALANKURICHI",
        "time": "12:50 PM",
        "id": 190
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:55 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:56 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "01:01 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "AGILANDAPURAM",
        "time": "01:13 PM",
        "id": 189
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:25 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "01:29 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:33 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:37 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:41 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:43 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:47 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:48 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:51 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:53 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-7-323",
    "routeNo": "55-D",
    "code": "55/P55D-3",
    "tripCode": "55/P55D-355-DTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "02:05 PM",
    "endTime": "02:55 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:06 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:08 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:11 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:12 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:16 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "02:19 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "02:23 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "02:27 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "02:32 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:35 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "02:43 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "02:50 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "02:55 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "55-D-8-324",
    "routeNo": "55-D",
    "code": "55/P55D-3",
    "tripCode": "55/P55D-355-DTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:10 PM",
    "endTime": "04:00 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "03:10 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "03:14 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "03:21 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "03:29 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "03:32 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "03:37 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "03:41 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:45 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:48 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:52 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:53 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:56 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:58 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-9-325",
    "routeNo": "55-D",
    "code": "55/P55D-1",
    "tripCode": "55/P55D-155-DTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:05 PM",
    "endTime": "05:20 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:06 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:08 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "04:10 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "04:11 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "04:14 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "04:17 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "04:20 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "04:24 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "04:28 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:31 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "04:47 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "05:04 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "05:08 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "05:09 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "05:17 PM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "05:20 PM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-D-10-326",
    "routeNo": "55-D",
    "code": "55/P55D-1",
    "tripCode": "55/P55D-155-DTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:25 PM",
    "endTime": "06:50 PM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      193,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "05:25 PM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "05:28 PM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "05:36 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "05:38 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "05:43 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "06:01 PM",
        "id": 193
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "06:20 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "06:23 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:28 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:32 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:35 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:38 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:42 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:43 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:46 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:48 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-11-327",
    "routeNo": "55-D",
    "code": "55/P55D-2",
    "tripCode": "55/P55D-255-DTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "AGILANDAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:55 PM",
    "endTime": "07:55 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      189,
      280,
      75,
      76,
      190
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:55 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:56 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:58 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:00 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:01 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:05 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:07 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:10 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:14 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:18 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:21 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "AGILANDAPURAM",
        "time": "07:33 PM",
        "id": 189
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:44 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:48 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "07:50 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "PANCHALANKURICHI",
        "time": "07:55 PM",
        "id": 190
      }
    ]
  },
  {
    "id": "55-D-12-328",
    "routeNo": "55-D",
    "code": "55/P55D-2",
    "tripCode": "55/P55D-255-DTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "AGILANDAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 PM",
    "endTime": "09:00 PM",
    "ids": [
      190,
      76,
      75,
      280,
      189,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "PANCHALANKURICHI",
        "time": "08:00 PM",
        "id": 190
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "08:04 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:06 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:10 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "AGILANDAPURAM",
        "time": "08:21 PM",
        "id": 189
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:33 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:36 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:40 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:44 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:47 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:49 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:53 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:54 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:56 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:58 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-D-13-329",
    "routeNo": "55-D",
    "code": "55/P55D-3",
    "tripCode": "55/P55D-355-DTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 PM",
    "endTime": "10:00 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:11 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:13 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:16 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:17 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:21 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:24 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:28 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:32 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:37 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:40 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "09:48 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "09:55 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "10:00 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "55-D-14-330",
    "routeNo": "55-D",
    "code": "55/P55D-3",
    "tripCode": "55/P55D-355-DTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:05 PM",
    "endTime": "10:55 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "10:05 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:09 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "10:16 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:24 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:27 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:32 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:36 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:40 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:43 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "10:47 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "10:48 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "10:51 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:53 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-E-1-331",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "02:20 PM",
    "endTime": "03:30 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:21 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:22 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:25 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:26 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:29 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "02:31 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "02:34 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "02:38 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "02:41 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:44 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "03:00 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "03:15 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "03:18 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "03:20 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "03:27 PM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "03:30 PM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-E-2-332",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18D2",
    "order": 2,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:35 PM",
    "endTime": "04:50 PM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      193,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "03:35 PM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "03:37 PM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "03:45 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "03:46 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "03:50 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "04:07 PM",
        "id": 193
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:23 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "04:26 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "04:30 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "04:34 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "04:37 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "04:40 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "04:43 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "04:44 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:46 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:48 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-E-3-333",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:05 PM",
    "endTime": "06:15 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:06 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:07 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:10 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:11 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:14 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "05:16 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "05:19 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "05:23 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:26 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:29 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "05:45 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "06:00 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "06:03 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "06:05 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "06:12 PM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "06:15 PM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-E-4-334",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:20 PM",
    "endTime": "07:35 PM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      193,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "06:20 PM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "06:22 PM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "06:30 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "06:31 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "06:35 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "06:52 PM",
        "id": 193
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:08 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:11 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:15 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:19 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:22 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:25 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:28 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:29 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:31 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:33 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-E-5-335",
    "routeNo": "55-E",
    "code": "55/P55E-2",
    "tripCode": "55/P55E-255-ETORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "VELLARAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 PM",
    "endTime": "09:10 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      194,
      280,
      75,
      76,
      195
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:51 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:53 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:56 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:57 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:01 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:04 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:07 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:11 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:16 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:19 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "VELLARAM",
        "time": "08:37 PM",
        "id": 194
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:55 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:59 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "09:01 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "09:10 PM",
        "id": 195
      }
    ]
  },
  {
    "id": "55-E-6-336",
    "routeNo": "55-E",
    "code": "55/P55E-2",
    "tripCode": "55/P55E-255-ETORD18D6",
    "order": 6,
    "direction": "D",
    "from": "VELLARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 AM",
    "endTime": "08:25 AM",
    "ids": [
      195,
      76,
      75,
      280,
      194,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "07:10 AM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "07:17 AM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:19 AM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:23 AM",
        "id": 280
      },
      {
        "no": 12,
        "name": "VELLARAM",
        "time": "07:40 AM",
        "id": 194
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:57 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:00 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:04 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:08 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:11 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:14 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:18 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:18 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:21 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:23 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-E-7-337",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:40 AM",
    "endTime": "09:50 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:41 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:42 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:45 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:46 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:49 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:51 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:54 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:58 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:01 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:04 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "09:20 AM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "09:35 AM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "09:38 AM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "09:40 AM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "09:47 AM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "09:50 AM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-E-8-338",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:55 AM",
    "endTime": "11:05 AM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      193,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "09:55 AM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "09:57 AM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "10:04 AM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "10:06 AM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:09 AM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "10:24 AM",
        "id": 193
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:40 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:43 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:46 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:50 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:53 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:55 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "10:58 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "10:59 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:02 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:03 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:05 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-E-9-339",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KACCHERI THALAVAIPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:10 AM",
    "endTime": "12:20 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      193,
      280,
      75,
      76,
      195,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:11 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:12 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:15 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:16 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:19 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:21 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:24 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "11:28 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "11:31 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "11:34 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "11:50 AM",
        "id": 193
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:05 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:08 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:10 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "12:17 PM",
        "id": 195
      },
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "12:20 PM",
        "id": 194
      }
    ]
  },
  {
    "id": "55-E-10-340",
    "routeNo": "55-E",
    "code": "55/P55E-1",
    "tripCode": "55/P55E-155-ETORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KACCHERI THALAVAIPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:25 PM",
    "endTime": "01:35 PM",
    "ids": [
      194,
      195,
      76,
      75,
      280,
      193,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "VELLARAM",
        "time": "12:25 PM",
        "id": 194
      },
      {
        "no": 16,
        "name": "GOVERNORGIRI",
        "time": "12:27 PM",
        "id": 195
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:34 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:36 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:39 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "12:54 PM",
        "id": 193
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:10 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "01:13 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:16 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:20 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:23 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:25 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:28 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:29 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:32 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:33 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-1-341",
    "routeNo": "55-F",
    "code": "55/P55F-1",
    "tripCode": "55/P55F-155-FTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CEYLON COLONY",
    "service": "TOWN ORDINARY",
    "startTime": "01:20 PM",
    "endTime": "02:05 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      210
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:22 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:23 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:27 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:28 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:32 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:35 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:39 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:43 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "01:49 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:52 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "01:54 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "01:59 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "02:01 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "02:05 PM",
        "id": 210
      }
    ]
  },
  {
    "id": "55-F-2-342",
    "routeNo": "55-F",
    "code": "55/P55F-1",
    "tripCode": "55/P55F-155-FTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "CEYLON COLONY",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:10 PM",
    "endTime": "02:55 PM",
    "ids": [
      210,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "02:10 PM",
        "id": 210
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "02:13 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "02:15 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "02:20 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:22 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "02:25 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "02:31 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "02:35 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "02:39 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:42 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:46 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:47 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:51 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:52 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-3-343",
    "routeNo": "55-F",
    "code": "55/P55F-3",
    "tripCode": "55/P55F-355-FTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA MUDIMAN",
    "service": "TOWN ORDINARY",
    "startTime": "03:10 PM",
    "endTime": "04:15 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      210,
      211,
      212,
      213,
      216
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:12 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:14 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:18 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:19 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:24 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:27 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "03:31 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "03:37 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "03:42 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "03:46 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "03:48 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "03:54 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "03:57 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "04:01 PM",
        "id": 210
      },
      {
        "no": 16,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "04:05 PM",
        "id": 211
      },
      {
        "no": 17,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "04:09 PM",
        "id": 212
      },
      {
        "no": 18,
        "name": "KEELA MUDIMAN",
        "time": "04:11 PM",
        "id": 213
      },
      {
        "no": 19,
        "name": "MELA MUDIMAN",
        "time": "04:15 PM",
        "id": 216
      }
    ]
  },
  {
    "id": "55-F-4-344",
    "routeNo": "55-F",
    "code": "55/P55F-3",
    "tripCode": "55/P55F-355-FTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "MELA MUDIMAN",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:40 PM",
    "endTime": "05:45 PM",
    "ids": [
      216,
      213,
      212,
      211,
      210,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "MELA MUDIMAN",
        "time": "04:40 PM",
        "id": 216
      },
      {
        "no": 18,
        "name": "KEELA MUDIMAN",
        "time": "04:43 PM",
        "id": 213
      },
      {
        "no": 17,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "04:45 PM",
        "id": 212
      },
      {
        "no": 16,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "04:49 PM",
        "id": 211
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "04:53 PM",
        "id": 210
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "04:57 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "05:00 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "05:06 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:08 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:12 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "05:17 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "05:23 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "05:27 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:30 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:35 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:36 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:40 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:42 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-5-345",
    "routeNo": "55-F",
    "code": "55/P55F-1",
    "tripCode": "55/P55F-155-FTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CEYLON COLONY",
    "service": "TOWN ORDINARY",
    "startTime": "05:50 PM",
    "endTime": "06:40 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      210
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:52 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:54 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:58 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:59 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:03 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:07 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:11 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:16 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "06:22 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "06:26 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "06:28 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "06:33 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "06:36 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "06:40 PM",
        "id": 210
      }
    ]
  },
  {
    "id": "55-F-6-346",
    "routeNo": "55-F",
    "code": "55/P55F-1",
    "tripCode": "55/P55F-155-FTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "CEYLON COLONY",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:55 PM",
    "endTime": "07:45 PM",
    "ids": [
      210,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "06:55 PM",
        "id": 210
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "06:58 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "07:01 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:06 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:08 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:12 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:18 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:23 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:27 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:31 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:35 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:36 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:40 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:42 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-7-347",
    "routeNo": "55-F",
    "code": "55/P55F-2",
    "tripCode": "55/P55F-255-FTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PASUVANTHANAI",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 PM",
    "endTime": "09:30 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      210,
      211,
      212,
      213,
      214,
      215
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:12 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:14 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:18 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:19 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:24 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:28 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:33 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:38 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:45 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:49 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:51 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "08:57 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "09:00 PM",
        "id": 76
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "09:04 PM",
        "id": 210
      },
      {
        "no": 16,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "09:09 PM",
        "id": 211
      },
      {
        "no": 17,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "09:13 PM",
        "id": 212
      },
      {
        "no": 18,
        "name": "KEELA MUDIMAN",
        "time": "09:15 PM",
        "id": 213
      },
      {
        "no": 19,
        "name": "POOLNAYAKKANOOR",
        "time": "09:20 PM",
        "id": 214
      },
      {
        "no": 20,
        "name": "PASUVANTHANAI",
        "time": "09:30 PM",
        "id": 215
      }
    ]
  },
  {
    "id": "55-F-8-348",
    "routeNo": "55-F",
    "code": "55/P55F-2",
    "tripCode": "55/P55F-255-FTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PASUVANTHANAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:45 PM",
    "endTime": "10:05 PM",
    "ids": [
      215,
      214,
      213,
      212,
      211,
      210,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "PASUVANTHANAI",
        "time": "09:45 PM",
        "id": 215
      },
      {
        "no": 19,
        "name": "POOLNAYAKKANOOR",
        "time": "09:47 PM",
        "id": 214
      },
      {
        "no": 18,
        "name": "KEELA MUDIMAN",
        "time": "09:48 PM",
        "id": 213
      },
      {
        "no": 17,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "09:49 PM",
        "id": 212
      },
      {
        "no": 16,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "09:50 PM",
        "id": 211
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "09:51 PM",
        "id": 210
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "09:52 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "09:53 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "09:54 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:55 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:56 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:57 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:59 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:00 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:01 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "10:02 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "10:02 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "10:03 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:04 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-9-349",
    "routeNo": "55-F",
    "code": "55/P55F-3",
    "tripCode": "55/P55F-355-FTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA MUDIMAN",
    "service": "TOWN ORDINARY",
    "startTime": "04:25 AM",
    "endTime": "05:35 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      210,
      211,
      212,
      213,
      216
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:25 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:27 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:29 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "04:33 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "04:35 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "04:40 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "04:43 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "04:48 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "04:54 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:00 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:04 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "05:06 AM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "05:13 AM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "05:15 AM",
        "id": 76
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "05:20 AM",
        "id": 210
      },
      {
        "no": 16,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "05:24 AM",
        "id": 211
      },
      {
        "no": 17,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "05:29 AM",
        "id": 212
      },
      {
        "no": 18,
        "name": "KEELA MUDIMAN",
        "time": "05:31 AM",
        "id": 213
      },
      {
        "no": 19,
        "name": "MELA MUDIMAN",
        "time": "05:35 AM",
        "id": 216
      }
    ]
  },
  {
    "id": "55-F-10-350",
    "routeNo": "55-F",
    "code": "55/P55F-3",
    "tripCode": "55/P55F-355-FTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "MELA MUDIMAN",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:05 AM",
    "endTime": "06:40 AM",
    "ids": [
      216,
      213,
      212,
      211,
      210,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "MELA MUDIMAN",
        "time": "05:05 AM",
        "id": 216
      },
      {
        "no": 18,
        "name": "KEELA MUDIMAN",
        "time": "05:10 AM",
        "id": 213
      },
      {
        "no": 17,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "05:12 AM",
        "id": 212
      },
      {
        "no": 16,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "05:18 AM",
        "id": 211
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "05:25 AM",
        "id": 210
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "05:31 AM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "05:34 AM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "05:43 AM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:46 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:51 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:00 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:08 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:14 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:19 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:26 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:28 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:33 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:36 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-11-351",
    "routeNo": "55-F",
    "code": "55/P55F-4",
    "tripCode": "55/P55F-455-FTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ATTHIMARAPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 AM",
    "endTime": "07:15 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      176,
      177
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:50 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:54 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:00 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:09 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "07:09 AM",
        "id": 176
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "07:15 AM",
        "id": 177
      }
    ]
  },
  {
    "id": "55-F-12-352",
    "routeNo": "55-F",
    "code": "55/P55F-4",
    "tripCode": "55/P55F-455-FTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ATTHIMARAPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 AM",
    "endTime": "08:10 AM",
    "ids": [
      177,
      176,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "07:20 AM",
        "id": 177
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "07:31 AM",
        "id": 176
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:31 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:49 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:01 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:08 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-F-13-353",
    "routeNo": "55-F",
    "code": "55/P55F-1",
    "tripCode": "55/P55F-155-FTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CEYLON COLONY",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:05 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76,
      210
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:17 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:19 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:23 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:24 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:28 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:32 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:36 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:41 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:47 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:51 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:53 AM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "08:58 AM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "09:01 AM",
        "id": 76
      },
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "09:05 AM",
        "id": 210
      }
    ]
  },
  {
    "id": "55-F-14-354",
    "routeNo": "55-F",
    "code": "55/P55F-1",
    "tripCode": "55/P55F-155-FTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "CEYLON COLONY",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:20 AM",
    "endTime": "12:10 PM",
    "ids": [
      210,
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "CEYLON COLONY",
        "time": "09:20 AM",
        "id": 210
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "09:33 AM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "09:41 AM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "10:00 AM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:07 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:20 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:39 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:57 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:11 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:23 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:38 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:42 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:55 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "12:02 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-G-1-355",
    "routeNo": "55-G",
    "code": "55/P55G-3",
    "tripCode": "55/P55G-355-GTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "01:15 PM",
    "endTime": "02:15 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:17 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:19 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:24 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:25 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:30 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:34 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:39 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:45 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "01:51 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:55 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "VALLINAYAGIPURAM",
        "time": "01:58 PM",
        "id": 196
      },
      {
        "no": 13,
        "name": "JAMBULINGAPURAM",
        "time": "02:00 PM",
        "id": 197
      },
      {
        "no": 14,
        "name": "S.PUTHUR",
        "time": "02:06 PM",
        "id": 296
      },
      {
        "no": 15,
        "name": "S.KAILASAPURAM",
        "time": "02:11 PM",
        "id": 198
      },
      {
        "no": 16,
        "name": "SAVARIMANGALAM",
        "time": "02:15 PM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-G-2-356",
    "routeNo": "55-G",
    "code": "55/P55G-3",
    "tripCode": "55/P55G-355-GTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:20 PM",
    "endTime": "03:20 PM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SAVARIMANGALAM",
        "time": "02:20 PM",
        "id": 199
      },
      {
        "no": 15,
        "name": "S.KAILASAPURAM",
        "time": "02:23 PM",
        "id": 198
      },
      {
        "no": 14,
        "name": "S.PUTHUR",
        "time": "02:28 PM",
        "id": 296
      },
      {
        "no": 13,
        "name": "JAMBULINGAPURAM",
        "time": "02:34 PM",
        "id": 197
      },
      {
        "no": 12,
        "name": "VALLINAYAGIPURAM",
        "time": "02:36 PM",
        "id": 196
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:39 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "02:43 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "02:49 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "02:55 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:00 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:04 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:09 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:10 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:15 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:17 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:20 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-G-3-357",
    "routeNo": "55-G",
    "code": "55/P55G-1",
    "tripCode": "55/P55G-155-GTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KANTHASAMYPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "03:35 PM",
    "endTime": "04:55 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      218,
      280,
      75,
      76,
      109,
      105,
      85,
      86,
      217
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:36 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:38 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:41 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:42 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:45 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "03:48 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "03:51 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "03:55 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "04:00 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:03 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KANTHASAMYPURAM",
        "time": "04:19 PM",
        "id": 218
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "04:34 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "04:38 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "04:40 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "04:41 PM",
        "id": 109
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "04:42 PM",
        "id": 105
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "04:49 PM",
        "id": 85
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "04:53 PM",
        "id": 86
      },
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "04:55 PM",
        "id": 217
      }
    ]
  },
  {
    "id": "55-G-4-358",
    "routeNo": "55-G",
    "code": "55/P55G-1",
    "tripCode": "55/P55G-155-GTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KANTHASAMYPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 PM",
    "endTime": "06:15 PM",
    "ids": [
      217,
      86,
      85,
      105,
      109,
      76,
      75,
      280,
      218,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "05:00 PM",
        "id": 217
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "05:01 PM",
        "id": 86
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "05:05 PM",
        "id": 85
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "05:11 PM",
        "id": 105
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "05:12 PM",
        "id": 109
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "05:13 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "05:15 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "05:19 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KANTHASAMYPURAM",
        "time": "05:33 PM",
        "id": 218
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:48 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:51 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "05:55 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "05:59 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:02 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:04 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:08 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:09 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:11 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:13 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-G-5-359",
    "routeNo": "55-G",
    "code": "55/P55G-1",
    "tripCode": "55/P55G-155-GTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KANTHASAMYPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 PM",
    "endTime": "07:40 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      218,
      280,
      75,
      76,
      109,
      105,
      85,
      86,
      217
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "06:31 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "06:32 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "06:35 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "06:36 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "06:39 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "06:41 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:44 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:48 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "06:52 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "06:54 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KANTHASAMYPURAM",
        "time": "07:08 PM",
        "id": 218
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:21 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:25 PM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "07:27 PM",
        "id": 76
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "07:27 PM",
        "id": 109
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "07:29 PM",
        "id": 105
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "07:34 PM",
        "id": 85
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "07:38 PM",
        "id": 86
      },
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "07:40 PM",
        "id": 217
      }
    ]
  },
  {
    "id": "55-G-6-360",
    "routeNo": "55-G",
    "code": "55/P55G-1",
    "tripCode": "55/P55G-155-GTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KANTHASAMYPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 PM",
    "endTime": "09:15 PM",
    "ids": [
      217,
      86,
      85,
      105,
      109,
      76,
      75,
      280,
      218,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "07:50 PM",
        "id": 217
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "07:51 PM",
        "id": 86
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "07:56 PM",
        "id": 85
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "08:02 PM",
        "id": 105
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "08:04 PM",
        "id": 109
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "08:05 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:07 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:12 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KANTHASAMYPURAM",
        "time": "08:27 PM",
        "id": 218
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:44 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:48 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:52 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:57 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:00 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:03 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:07 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:08 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:11 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:13 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-G-7-361",
    "routeNo": "55-G",
    "code": "55/P55G-2",
    "tripCode": "55/P55G-255-GTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PANDIAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 AM",
    "endTime": "06:25 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      87,
      280,
      75,
      76,
      109,
      105,
      85,
      86,
      217,
      218
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:00 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:01 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:03 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:06 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:06 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:10 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "05:13 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "05:16 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "05:20 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "05:24 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:27 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "PANDIAPURAM",
        "time": "05:45 AM",
        "id": 87
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "06:02 AM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "06:07 AM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "06:08 AM",
        "id": 76
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "06:09 AM",
        "id": 109
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "06:11 AM",
        "id": 105
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "06:17 AM",
        "id": 85
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "06:21 AM",
        "id": 86
      },
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "06:22 AM",
        "id": 217
      },
      {
        "no": 21,
        "name": "KANTHASAMYPURAM",
        "time": "06:25 AM",
        "id": 218
      }
    ]
  },
  {
    "id": "55-G-8-362",
    "routeNo": "55-G",
    "code": "55/P55G-2",
    "tripCode": "55/P55G-255-GTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PANDIAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:40 AM",
    "endTime": "07:55 AM",
    "ids": [
      218,
      217,
      86,
      85,
      105,
      109,
      76,
      75,
      280,
      87,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 21,
        "name": "KANTHASAMYPURAM",
        "time": "06:40 AM",
        "id": 218
      },
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "06:42 AM",
        "id": 217
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "06:43 AM",
        "id": 86
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "06:47 AM",
        "id": 85
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "06:52 AM",
        "id": 105
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "06:53 AM",
        "id": 109
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "06:54 AM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "06:55 AM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "06:59 AM",
        "id": 280
      },
      {
        "no": 12,
        "name": "PANDIAPURAM",
        "time": "07:14 AM",
        "id": 87
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:30 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:33 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:37 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:40 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:43 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:45 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:48 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:49 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:52 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:53 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:55 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-G-9-363",
    "routeNo": "55-G",
    "code": "55/P55G-3",
    "tripCode": "55/P55G-355-GTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SAVARIMANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 AM",
    "endTime": "09:10 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      196,
      197,
      296,
      198,
      199
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:12 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:14 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:19 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:20 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "08:25 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:29 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:34 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:40 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:46 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:50 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "VALLINAYAGIPURAM",
        "time": "08:53 AM",
        "id": 196
      },
      {
        "no": 13,
        "name": "JAMBULINGAPURAM",
        "time": "08:55 AM",
        "id": 197
      },
      {
        "no": 14,
        "name": "S.PUTHUR",
        "time": "09:01 AM",
        "id": 296
      },
      {
        "no": 15,
        "name": "S.KAILASAPURAM",
        "time": "09:06 AM",
        "id": 198
      },
      {
        "no": 16,
        "name": "SAVARIMANGALAM",
        "time": "09:10 AM",
        "id": 199
      }
    ]
  },
  {
    "id": "55-G-10-364",
    "routeNo": "55-G",
    "code": "55/P55G-3",
    "tripCode": "55/P55G-355-GTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "SAVARIMANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 AM",
    "endTime": "10:15 AM",
    "ids": [
      199,
      198,
      296,
      197,
      196,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SAVARIMANGALAM",
        "time": "09:15 AM",
        "id": 199
      },
      {
        "no": 15,
        "name": "S.KAILASAPURAM",
        "time": "09:18 AM",
        "id": 198
      },
      {
        "no": 14,
        "name": "S.PUTHUR",
        "time": "09:23 AM",
        "id": 296
      },
      {
        "no": 13,
        "name": "JAMBULINGAPURAM",
        "time": "09:29 AM",
        "id": 197
      },
      {
        "no": 12,
        "name": "VALLINAYAGIPURAM",
        "time": "09:31 AM",
        "id": 196
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:34 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:38 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:44 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:50 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:55 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:59 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "10:04 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "10:05 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "10:10 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:12 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:15 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-G-11-365",
    "routeNo": "55-G",
    "code": "55/P55G-1",
    "tripCode": "55/P55G-155-GTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KANTHASAMYPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 AM",
    "endTime": "11:50 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      218,
      280,
      75,
      76,
      109,
      105,
      85,
      86,
      217
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "10:31 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "10:33 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "10:36 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "10:37 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:40 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:43 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "10:46 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "10:50 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "10:55 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:58 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "KANTHASAMYPURAM",
        "time": "11:14 AM",
        "id": 218
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "11:29 AM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "11:33 AM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "11:35 AM",
        "id": 76
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "11:36 AM",
        "id": 109
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "11:37 AM",
        "id": 105
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "11:44 AM",
        "id": 85
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "11:48 AM",
        "id": 86
      },
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "11:50 AM",
        "id": 217
      }
    ]
  },
  {
    "id": "55-G-12-366",
    "routeNo": "55-G",
    "code": "55/P55G-1",
    "tripCode": "55/P55G-155-GTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KANTHASAMYPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:55 AM",
    "endTime": "01:10 PM",
    "ids": [
      217,
      86,
      85,
      105,
      109,
      76,
      75,
      280,
      218,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "THALAVAIPURAM 1",
        "time": "11:55 AM",
        "id": 217
      },
      {
        "no": 19,
        "name": "KOMBADI",
        "time": "11:56 AM",
        "id": 86
      },
      {
        "no": 18,
        "name": "OSANOOTTHU",
        "time": "12:00 PM",
        "id": 85
      },
      {
        "no": 17,
        "name": "AYYANAR KOVIL",
        "time": "12:06 PM",
        "id": 105
      },
      {
        "no": 16,
        "name": "TALUK OFFICE",
        "time": "12:07 PM",
        "id": 109
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "12:08 PM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "12:10 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:14 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "KANTHASAMYPURAM",
        "time": "12:28 PM",
        "id": 218
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:43 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:46 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "12:50 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "12:54 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "12:57 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "12:59 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:03 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:04 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:06 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:08 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-1-367",
    "routeNo": "55-H",
    "code": "55/P55H-1",
    "tripCode": "55/P55H-155-HTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "01:15 PM",
    "endTime": "02:05 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "01:16 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "01:18 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:21 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:22 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:26 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:29 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:33 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:37 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "01:42 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:45 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "01:53 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "02:00 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "02:05 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "55-H-2-368",
    "routeNo": "55-H",
    "code": "55/P55H-1",
    "tripCode": "55/P55H-155-HTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:15 PM",
    "endTime": "03:05 PM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "02:15 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "02:19 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "02:26 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:34 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "02:37 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "02:42 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "02:46 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "02:50 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "02:53 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "02:57 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "02:58 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:01 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:03 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-3-369",
    "routeNo": "55-H",
    "code": "55/P55H-2",
    "tripCode": "55/P55H-255-HTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "APC COLLEGE",
    "service": "TOWN ORDINARY",
    "startTime": "03:20 PM",
    "endTime": "03:20 PM",
    "ids": [
      1,
      26,
      66,
      219
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:20 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:20 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "APC COLLEGE",
        "time": "03:20 PM",
        "id": 219
      }
    ]
  },
  {
    "id": "55-H-4-370",
    "routeNo": "55-H",
    "code": "55/P55H-2",
    "tripCode": "55/P55H-255-HTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "APC COLLEGE",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:30 PM",
    "endTime": "03:45 PM",
    "ids": [
      219,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 4,
        "name": "APC COLLEGE",
        "time": "03:30 PM",
        "id": 219
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:35 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:39 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-5-371",
    "routeNo": "55-H",
    "code": "55/P55H-3",
    "tripCode": "55/P55H-355-HTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "THOOTHUKUDI NEW B/S",
    "service": "TOWN ORDINARY",
    "startTime": "03:50 PM",
    "endTime": "04:00 PM",
    "ids": [
      1,
      26,
      77
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:56 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI NEW B/S",
        "time": "04:00 PM",
        "id": 77
      }
    ]
  },
  {
    "id": "55-H-6-372",
    "routeNo": "55-H",
    "code": "55/P55H-3",
    "tripCode": "55/P55H-355-HTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "THOOTHUKUDI NEW B/S",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "04:05 PM",
    "endTime": "04:25 PM",
    "ids": [
      77,
      26,
      1
    ],
    "stops": [
      {
        "no": 3,
        "name": "THOOTHUKUDI NEW B/S",
        "time": "04:05 PM",
        "id": 77
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:11 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-7-373",
    "routeNo": "55-H",
    "code": "55/P55H-4",
    "tripCode": "55/P55H-455-HTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "VELLAPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "04:30 PM",
    "endTime": "05:05 PM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      187
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "04:30 PM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "04:35 PM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:39 PM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "04:47 PM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "04:51 PM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "04:53 PM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "04:59 PM",
        "id": 112
      },
      {
        "no": 8,
        "name": "VELLAPATTI",
        "time": "05:05 PM",
        "id": 187
      }
    ]
  },
  {
    "id": "55-H-8-374",
    "routeNo": "55-H",
    "code": "55/P55H-4",
    "tripCode": "55/P55H-455-HTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "VELLAPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:10 PM",
    "endTime": "05:35 PM",
    "ids": [
      187,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 8,
        "name": "VELLAPATTI",
        "time": "05:10 PM",
        "id": 187
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "05:13 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "05:18 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "05:19 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "05:22 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:28 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "05:31 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "05:35 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "55-H-9-375",
    "routeNo": "55-H",
    "code": "55/P55H-7",
    "tripCode": "55/P55H-755-HTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SIPCOT",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 PM",
    "endTime": "06:15 PM",
    "ids": [
      1,
      26,
      220,
      221,
      222,
      223,
      224,
      225
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:48 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "CHINNAKANNUPURAM",
        "time": "05:51 PM",
        "id": 220
      },
      {
        "no": 4,
        "name": "SILVERPURAM",
        "time": "05:54 PM",
        "id": 221
      },
      {
        "no": 5,
        "name": "PANDARAMPATTI",
        "time": "06:00 PM",
        "id": 222
      },
      {
        "no": 6,
        "name": "MEELAVITTAN",
        "time": "06:04 PM",
        "id": 223
      },
      {
        "no": 7,
        "name": "STERLITE",
        "time": "06:10 PM",
        "id": 224
      },
      {
        "no": 8,
        "name": "SIPCOT COMPLEX",
        "time": "06:15 PM",
        "id": 225
      }
    ]
  },
  {
    "id": "55-H-10-376",
    "routeNo": "55-H",
    "code": "55/P55H-8",
    "tripCode": "55/P55H-855-HTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "SIPCOT",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:30 PM",
    "endTime": "07:05 PM",
    "ids": [
      225,
      226,
      78,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "06:30 PM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR JUNCTION",
        "time": "06:38 PM",
        "id": 226
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "06:44 PM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:50 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:56 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-11-377",
    "routeNo": "55-H",
    "code": "55/P55H-1",
    "tripCode": "55/P55H-155-HTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 PM",
    "endTime": "08:20 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      76,
      280,
      75
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:17 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:19 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:23 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:25 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:30 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:33 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:38 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:44 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:50 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:54 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "08:04 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:13 PM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:20 PM",
        "id": 75
      }
    ]
  },
  {
    "id": "55-H-12-378",
    "routeNo": "55-H",
    "code": "55/P55H-1",
    "tripCode": "55/P55H-155-HTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:30 PM",
    "endTime": "05:00 AM",
    "ids": [
      75,
      280,
      76,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:30 PM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "09:19 PM",
        "id": 280
      },
      {
        "no": 12,
        "name": "OTTAPIDARAM",
        "time": "10:27 PM",
        "id": 76
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "11:47 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:21 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:10 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:55 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "02:30 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "03:01 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "03:40 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "03:50 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:23 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:39 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-13-379",
    "routeNo": "55-H",
    "code": "55/P55H-6",
    "tripCode": "55/P55H-655-HTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "AUTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "05:10 AM",
    "endTime": "05:45 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:10 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:12 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "05:16 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "05:21 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "05:22 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "05:24 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "05:29 AM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "05:31 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "05:35 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "05:39 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "05:42 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "05:45 AM",
        "id": 172
      }
    ]
  },
  {
    "id": "55-H-14-380",
    "routeNo": "55-H",
    "code": "55/P55H-6",
    "tripCode": "55/P55H-655-HTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "AUTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:00 AM",
    "endTime": "06:40 AM",
    "ids": [
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "06:00 AM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "06:02 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "06:06 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "06:11 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "06:15 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "06:17 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:23 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:26 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:26 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:33 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:36 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:39 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-15-381",
    "routeNo": "55-H",
    "code": "55/P55H-5",
    "tripCode": "55/P55H-555-HTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA MUDIMAN",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 AM",
    "endTime": "08:10 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      216,
      280,
      75,
      76,
      210,
      211,
      212,
      213
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:01 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:02 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:05 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:06 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:09 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:11 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "07:14 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "07:17 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "07:21 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:24 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "MELA MUDIMAN",
        "time": "07:40 AM",
        "id": 216
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "07:55 AM",
        "id": 280
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "07:58 AM",
        "id": 75
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "08:00 AM",
        "id": 76
      },
      {
        "no": 16,
        "name": "CEYLON COLONY",
        "time": "08:03 AM",
        "id": 210
      },
      {
        "no": 17,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "08:06 AM",
        "id": 211
      },
      {
        "no": 18,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "08:08 AM",
        "id": 212
      },
      {
        "no": 19,
        "name": "KEELA MUDIMAN",
        "time": "08:10 AM",
        "id": 213
      }
    ]
  },
  {
    "id": "55-H-16-382",
    "routeNo": "55-H",
    "code": "55/P55H-5",
    "tripCode": "55/P55H-555-HTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "MELA MUDIMAN",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "09:35 AM",
    "ids": [
      213,
      212,
      211,
      210,
      76,
      75,
      280,
      216,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "KEELA MUDIMAN",
        "time": "08:15 AM",
        "id": 213
      },
      {
        "no": 18,
        "name": "VENKETESHVARAPURAM JUNCTION",
        "time": "08:16 AM",
        "id": 212
      },
      {
        "no": 17,
        "name": "PUTRU MURUGAN KOVIL",
        "time": "08:19 AM",
        "id": 211
      },
      {
        "no": 16,
        "name": "CEYLON COLONY",
        "time": "08:22 AM",
        "id": 210
      },
      {
        "no": 15,
        "name": "OTTAPIDARAM",
        "time": "08:25 AM",
        "id": 76
      },
      {
        "no": 14,
        "name": "MUPPULIPATI",
        "time": "08:27 AM",
        "id": 75
      },
      {
        "no": 13,
        "name": "ST. ANN'S HOSPITAL",
        "time": "08:32 AM",
        "id": 280
      },
      {
        "no": 12,
        "name": "MELA MUDIMAN",
        "time": "08:48 AM",
        "id": 216
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "09:07 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "09:10 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "09:14 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "09:18 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "09:21 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:24 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:27 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:28 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:31 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:33 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-17-383",
    "routeNo": "55-H",
    "code": "55/P55H-9",
    "tripCode": "55/P55H-955-HTORD18U17",
    "order": 17,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "THOOTHUKUDI COLLECTORATE",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 AM",
    "endTime": "09:55 AM",
    "ids": [
      1,
      29,
      39,
      227
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:45 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:49 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "THOOTHUKUDI COLLECTORATE",
        "time": "09:55 AM",
        "id": 227
      }
    ]
  },
  {
    "id": "55-H-18-384",
    "routeNo": "55-H",
    "code": "55/P55H-9",
    "tripCode": "55/P55H-955-HTORD18D18",
    "order": 18,
    "direction": "D",
    "from": "THOOTHUKUDI COLLECTORATE",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "10:05 AM",
    "endTime": "10:25 AM",
    "ids": [
      227,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 4,
        "name": "THOOTHUKUDI COLLECTORATE",
        "time": "10:05 AM",
        "id": 227
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:12 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:17 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-H-19-385",
    "routeNo": "55-H",
    "code": "55/P55H-10",
    "tripCode": "55/P55H-1055-HTORD18U19",
    "order": 19,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MULLAKADU",
    "service": "TOWN ORDINARY",
    "startTime": "10:35 AM",
    "endTime": "11:20 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      180,
      182,
      183,
      184,
      45,
      46
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:40 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "10:44 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:50 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:54 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:56 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP JUNCTION",
        "time": "10:56 AM",
        "id": 180
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "11:01 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "11:03 AM",
        "id": 183
      },
      {
        "no": 10,
        "name": "BULK",
        "time": "11:14 AM",
        "id": 184
      },
      {
        "no": 11,
        "name": "SPIC NAGAR",
        "time": "11:16 AM",
        "id": 45
      },
      {
        "no": 12,
        "name": "MULLAKADU",
        "time": "11:20 AM",
        "id": 46
      }
    ]
  },
  {
    "id": "55-H-20-386",
    "routeNo": "55-H",
    "code": "55/P55H-10",
    "tripCode": "55/P55H-1055-HTORD18D20",
    "order": 20,
    "direction": "D",
    "from": "MULLAKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:25 AM",
    "endTime": "01:00 PM",
    "ids": [
      46,
      45,
      184,
      183,
      182,
      180,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 12,
        "name": "MULLAKADU",
        "time": "11:25 AM",
        "id": 46
      },
      {
        "no": 11,
        "name": "SPIC NAGAR",
        "time": "11:33 AM",
        "id": 45
      },
      {
        "no": 10,
        "name": "BULK",
        "time": "11:36 AM",
        "id": 184
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "12:00 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "12:04 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP JUNCTION",
        "time": "12:14 PM",
        "id": 180
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "12:14 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "12:19 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "12:27 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "12:40 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "12:49 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-I-1-387",
    "routeNo": "55-I",
    "code": "55/P55I-3",
    "tripCode": "55/P55I-355-ITORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "OTTAPIDARAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:40 AM",
    "endTime": "12:20 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      280,
      75,
      76
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:42 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "11:43 AM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "11:46 AM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "11:47 AM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "11:51 AM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "11:54 AM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:58 AM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "12:03 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:07 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:11 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:13 PM",
        "id": 280
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "12:17 PM",
        "id": 75
      },
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "12:20 PM",
        "id": 76
      }
    ]
  },
  {
    "id": "55-I-2-388",
    "routeNo": "55-I",
    "code": "55/P55I-3",
    "tripCode": "55/P55I-355-ITORD18D2",
    "order": 2,
    "direction": "D",
    "from": "OTTAPIDARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:25 PM",
    "endTime": "02:10 PM",
    "ids": [
      76,
      75,
      280,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "OTTAPIDARAM",
        "time": "12:25 PM",
        "id": 76
      },
      {
        "no": 13,
        "name": "MUPPULIPATI",
        "time": "12:30 PM",
        "id": 75
      },
      {
        "no": 12,
        "name": "ST. ANN'S HOSPITAL",
        "time": "12:43 PM",
        "id": 280
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "12:47 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "12:56 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "01:09 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "01:21 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "01:30 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "01:38 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "01:49 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "01:51 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:00 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:04 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-I-3-389",
    "routeNo": "55-I",
    "code": "55/P55I-2",
    "tripCode": "55/P55I-255-ITORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NORTH SILUKKANPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "02:15 PM",
    "endTime": "02:55 PM",
    "ids": [
      1,
      29,
      39,
      4,
      297,
      235,
      298,
      237,
      238
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:20 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:24 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:33 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "02:38 PM",
        "id": 297
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "02:44 PM",
        "id": 235
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "02:51 PM",
        "id": 298
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "02:53 PM",
        "id": 237
      },
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "02:55 PM",
        "id": 238
      }
    ]
  },
  {
    "id": "55-I-4-390",
    "routeNo": "55-I",
    "code": "55/P55I-2",
    "tripCode": "55/P55I-255-ITORD18D4",
    "order": 4,
    "direction": "D",
    "from": "NORTH SILUKKANPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "03:45 PM",
    "ids": [
      238,
      237,
      298,
      235,
      297,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "03:00 PM",
        "id": 238
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "03:02 PM",
        "id": 237
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "03:03 PM",
        "id": 298
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "03:12 PM",
        "id": 235
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "03:18 PM",
        "id": 297
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:24 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:34 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:38 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-I-5-391",
    "routeNo": "55-I",
    "code": "55/P55I-1",
    "tripCode": "55/P55I-155-ITORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA MANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:10 PM",
    "endTime": "05:40 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      228,
      229,
      230,
      231,
      232,
      85,
      106,
      110,
      108,
      233,
      234
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "04:13 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "04:15 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "04:20 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "04:22 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "04:28 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "04:33 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "04:39 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "04:46 PM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "04:54 PM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:59 PM",
        "id": 74
      },
      {
        "no": 12,
        "name": "PUDHUPACCHERI COLONY",
        "time": "05:07 PM",
        "id": 228
      },
      {
        "no": 13,
        "name": "PUDHUPACCHERI",
        "time": "05:09 PM",
        "id": 229
      },
      {
        "no": 14,
        "name": "SIVALKULAM",
        "time": "05:11 PM",
        "id": 230
      },
      {
        "no": 15,
        "name": "PACCHAIPERUMALPURAM",
        "time": "05:14 PM",
        "id": 231
      },
      {
        "no": 16,
        "name": "SANKARARAJAPURAM",
        "time": "05:15 PM",
        "id": 232
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "05:18 PM",
        "id": 85
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "05:21 PM",
        "id": 106
      },
      {
        "no": 19,
        "name": "THERKKU ARAIKULAM",
        "time": "05:27 PM",
        "id": 110
      },
      {
        "no": 20,
        "name": "NORTH AARAIKULAM",
        "time": "05:30 PM",
        "id": 108
      },
      {
        "no": 21,
        "name": "KUPPANAPURAM",
        "time": "05:33 PM",
        "id": 233
      },
      {
        "no": 22,
        "name": "KEELA MANGALM",
        "time": "05:40 PM",
        "id": 234
      }
    ]
  },
  {
    "id": "55-I-6-392",
    "routeNo": "55-I",
    "code": "55/P55I-1",
    "tripCode": "55/P55I-155-ITORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KEELA MANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:55 PM",
    "endTime": "07:25 PM",
    "ids": [
      234,
      233,
      108,
      110,
      106,
      85,
      232,
      231,
      230,
      229,
      228,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 22,
        "name": "KEELA MANGALM",
        "time": "05:55 PM",
        "id": 234
      },
      {
        "no": 21,
        "name": "KUPPANAPURAM",
        "time": "06:01 PM",
        "id": 233
      },
      {
        "no": 20,
        "name": "NORTH AARAIKULAM",
        "time": "06:04 PM",
        "id": 108
      },
      {
        "no": 19,
        "name": "THERKKU ARAIKULAM",
        "time": "06:07 PM",
        "id": 110
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "06:13 PM",
        "id": 106
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "06:16 PM",
        "id": 85
      },
      {
        "no": 16,
        "name": "SANKARARAJAPURAM",
        "time": "06:19 PM",
        "id": 232
      },
      {
        "no": 15,
        "name": "PACCHAIPERUMALPURAM",
        "time": "06:20 PM",
        "id": 231
      },
      {
        "no": 14,
        "name": "SIVALKULAM",
        "time": "06:23 PM",
        "id": 230
      },
      {
        "no": 13,
        "name": "PUDHUPACCHERI",
        "time": "06:25 PM",
        "id": 229
      },
      {
        "no": 12,
        "name": "PUDHUPACCHERI COLONY",
        "time": "06:27 PM",
        "id": 228
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "06:35 PM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "06:40 PM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "06:48 PM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "06:55 PM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "07:01 PM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:06 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "07:12 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "07:14 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "07:19 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:21 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-I-7-393",
    "routeNo": "55-I",
    "code": "55/P55I-1",
    "tripCode": "55/P55I-155-ITORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KEELA MANGALAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:40 PM",
    "endTime": "07:40 AM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      228,
      229,
      230,
      231,
      232,
      85,
      106,
      110,
      108,
      233,
      234
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:05 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:25 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:07 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:20 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "10:10 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "10:48 PM",
        "id": 70
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "11:34 PM",
        "id": 71
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "12:31 AM",
        "id": 72
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "01:32 AM",
        "id": 73
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "02:15 AM",
        "id": 74
      },
      {
        "no": 12,
        "name": "PUDHUPACCHERI COLONY",
        "time": "03:22 AM",
        "id": 228
      },
      {
        "no": 13,
        "name": "PUDHUPACCHERI",
        "time": "03:39 AM",
        "id": 229
      },
      {
        "no": 14,
        "name": "SIVALKULAM",
        "time": "03:53 AM",
        "id": 230
      },
      {
        "no": 15,
        "name": "PACCHAIPERUMALPURAM",
        "time": "04:12 AM",
        "id": 231
      },
      {
        "no": 16,
        "name": "SANKARARAJAPURAM",
        "time": "04:27 AM",
        "id": 232
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "04:50 AM",
        "id": 85
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "05:11 AM",
        "id": 106
      },
      {
        "no": 19,
        "name": "THERKKU ARAIKULAM",
        "time": "05:59 AM",
        "id": 110
      },
      {
        "no": 20,
        "name": "NORTH AARAIKULAM",
        "time": "06:20 AM",
        "id": 108
      },
      {
        "no": 21,
        "name": "KUPPANAPURAM",
        "time": "06:45 AM",
        "id": 233
      },
      {
        "no": 22,
        "name": "KEELA MANGALM",
        "time": "07:40 AM",
        "id": 234
      }
    ]
  },
  {
    "id": "55-I-8-394",
    "routeNo": "55-I",
    "code": "55/P55I-1",
    "tripCode": "55/P55I-155-ITORD18D8",
    "order": 8,
    "direction": "D",
    "from": "KEELA MANGALAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:55 AM",
    "endTime": "09:20 AM",
    "ids": [
      234,
      233,
      108,
      110,
      106,
      85,
      232,
      231,
      230,
      229,
      228,
      74,
      73,
      72,
      71,
      70,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 22,
        "name": "KEELA MANGALM",
        "time": "07:55 AM",
        "id": 234
      },
      {
        "no": 21,
        "name": "KUPPANAPURAM",
        "time": "08:01 AM",
        "id": 233
      },
      {
        "no": 20,
        "name": "NORTH AARAIKULAM",
        "time": "08:04 AM",
        "id": 108
      },
      {
        "no": 19,
        "name": "THERKKU ARAIKULAM",
        "time": "08:06 AM",
        "id": 110
      },
      {
        "no": 18,
        "name": "KULASEKARANALLOOR",
        "time": "08:12 AM",
        "id": 106
      },
      {
        "no": 17,
        "name": "OSANOOTTHU",
        "time": "08:15 AM",
        "id": 85
      },
      {
        "no": 16,
        "name": "SANKARARAJAPURAM",
        "time": "08:17 AM",
        "id": 232
      },
      {
        "no": 15,
        "name": "PACCHAIPERUMALPURAM",
        "time": "08:19 AM",
        "id": 231
      },
      {
        "no": 14,
        "name": "SIVALKULAM",
        "time": "08:21 AM",
        "id": 230
      },
      {
        "no": 13,
        "name": "PUDHUPACCHERI",
        "time": "08:23 AM",
        "id": 229
      },
      {
        "no": 12,
        "name": "PUDHUPACCHERI COLONY",
        "time": "08:25 AM",
        "id": 228
      },
      {
        "no": 11,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:33 AM",
        "id": 74
      },
      {
        "no": 10,
        "name": "RAJAVIN KOVIL",
        "time": "08:38 AM",
        "id": 73
      },
      {
        "no": 9,
        "name": "CHILLANATTHAM",
        "time": "08:45 AM",
        "id": 72
      },
      {
        "no": 8,
        "name": "NAINAR PURAM",
        "time": "08:52 AM",
        "id": 71
      },
      {
        "no": 7,
        "name": "VELAYUTHAPURAM",
        "time": "08:57 AM",
        "id": 70
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "09:02 AM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "09:08 AM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "09:09 AM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "09:14 AM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "09:16 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-I-9-395",
    "routeNo": "55-I",
    "code": "55/P55I-4",
    "tripCode": "55/P55I-455-ITORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "THALAIVANVADALI",
    "service": "TOWN ORDINARY",
    "startTime": "09:25 AM",
    "endTime": "10:55 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      127,
      157,
      49,
      50,
      51,
      172,
      129,
      130,
      239
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:25 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:30 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:37 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:49 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:50 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:55 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "10:04 AM",
        "id": 127
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "10:10 AM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "10:19 AM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "10:28 AM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "10:35 AM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "10:39 AM",
        "id": 172
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "10:42 AM",
        "id": 129
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "10:49 AM",
        "id": 130
      },
      {
        "no": 16,
        "name": "THALAIVANVADALI",
        "time": "10:55 AM",
        "id": 239
      }
    ]
  },
  {
    "id": "55-I-10-396",
    "routeNo": "55-I",
    "code": "55/P55I-4",
    "tripCode": "55/P55I-455-ITORD18D10",
    "order": 10,
    "direction": "D",
    "from": "THALAIVANVADALI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:30 AM",
    "endTime": "11:35 AM",
    "ids": [
      239,
      130,
      129,
      172,
      51,
      50,
      49,
      157,
      127,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "THALAIVANVADALI",
        "time": "11:30 AM",
        "id": 239
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "11:30 AM",
        "id": 130
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "11:30 AM",
        "id": 129
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "11:30 AM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "11:31 AM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "11:31 AM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "11:31 AM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "11:32 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "11:32 AM",
        "id": 127
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "11:33 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "11:33 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "11:33 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "11:34 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "11:34 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "11:34 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:35 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-1-397",
    "routeNo": "55-J",
    "code": "55/P55J-1",
    "tripCode": "55/P55J-155-JTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "THOOTHUKUDI RAILWAY STATION",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 AM",
    "endTime": "05:40 AM",
    "ids": [
      1,
      240
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "THOOTHUKUDI RAILWAY STATION",
        "time": "05:40 AM",
        "id": 240
      }
    ]
  },
  {
    "id": "55-J-2-398",
    "routeNo": "55-J",
    "code": "55/P55J-1",
    "tripCode": "55/P55J-155-JTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "THOOTHUKUDI RAILWAY STATION",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 AM",
    "endTime": "05:50 AM",
    "ids": [
      240,
      1
    ],
    "stops": [
      {
        "no": 2,
        "name": "THOOTHUKUDI RAILWAY STATION",
        "time": "05:45 AM",
        "id": 240
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-3-399",
    "routeNo": "55-J",
    "code": "55/P55J-2",
    "tripCode": "55/P55J-255-JTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MULLAKADU",
    "service": "TOWN ORDINARY",
    "startTime": "05:55 AM",
    "endTime": "06:10 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:55 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:55 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "05:57 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:01 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:06 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:07 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:10 AM",
        "id": 46
      }
    ]
  },
  {
    "id": "55-J-4-400",
    "routeNo": "55-J",
    "code": "55/P55J-2",
    "tripCode": "55/P55J-255-JTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "MULLAKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 AM",
    "endTime": "06:30 AM",
    "ids": [
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "06:15 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:17 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:18 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:23 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:27 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:29 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-5-401",
    "routeNo": "55-J",
    "code": "55/P55J-3",
    "tripCode": "55/P55J-355-JTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "POTTALKADU",
    "service": "TOWN ORDINARY",
    "startTime": "06:35 AM",
    "endTime": "07:10 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      163
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:35 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:40 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:47 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:58 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:59 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:04 AM",
        "id": 46
      },
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "07:10 AM",
        "id": 163
      }
    ]
  },
  {
    "id": "55-J-6-402",
    "routeNo": "55-J",
    "code": "55/P55J-3",
    "tripCode": "55/P55J-355-JTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "POTTALKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 AM",
    "endTime": "08:10 AM",
    "ids": [
      163,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 8,
        "name": "POTTALKADU",
        "time": "07:15 AM",
        "id": 163
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:24 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:31 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:33 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:50 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:01 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:08 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-7-403",
    "routeNo": "55-J",
    "code": "55/P55J-4",
    "tripCode": "55/P55J-455-JTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ATTHIMARAPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 AM",
    "endTime": "08:45 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      176,
      177
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:15 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:20 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:27 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:37 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "08:38 AM",
        "id": 176
      },
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "08:45 AM",
        "id": 177
      }
    ]
  },
  {
    "id": "55-J-8-404",
    "routeNo": "55-J",
    "code": "55/P55J-4",
    "tripCode": "55/P55J-455-JTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "ATTHIMARAPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:50 AM",
    "endTime": "09:25 AM",
    "ids": [
      177,
      176,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 7,
        "name": "ATTHIMARAPATTI",
        "time": "08:50 AM",
        "id": 177
      },
      {
        "no": 6,
        "name": "ATTHIMARAPATTI JUNCTION",
        "time": "08:57 AM",
        "id": 176
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:58 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:10 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:18 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:24 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-9-405",
    "routeNo": "55-J",
    "code": "55/P55J-2",
    "tripCode": "55/P55J-255-JTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MULLAKADU",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "10:00 AM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "09:35 AM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "09:39 AM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "09:45 AM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "09:54 AM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "09:55 AM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:00 AM",
        "id": 46
      }
    ]
  },
  {
    "id": "55-J-10-406",
    "routeNo": "55-J",
    "code": "55/P55J-2",
    "tripCode": "55/P55J-255-JTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "MULLAKADU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:05 AM",
    "endTime": "10:30 AM",
    "ids": [
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "10:05 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "10:09 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "10:10 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "10:19 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "10:25 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "10:29 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-11-407",
    "routeNo": "55-J",
    "code": "55/P55J-5",
    "tripCode": "55/P55J-555-JTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KULATTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "10:40 AM",
    "endTime": "11:55 AM",
    "ids": [
      26,
      282,
      1,
      63,
      64,
      111,
      112,
      299,
      144,
      300,
      145,
      135,
      136,
      287,
      301,
      138,
      139,
      118,
      132,
      140,
      302
    ],
    "stops": [
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "10:40 AM",
        "id": 26
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "10:43 AM",
        "id": 282
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:47 AM",
        "id": 1
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "10:53 AM",
        "id": 63
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "10:55 AM",
        "id": 64
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "10:56 AM",
        "id": 111
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "11:02 AM",
        "id": 112
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 3",
        "time": "11:05 AM",
        "id": 299
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "11:12 AM",
        "id": 144
      },
      {
        "no": 10,
        "name": "ARASADI 2",
        "time": "11:14 AM",
        "id": 300
      },
      {
        "no": 11,
        "name": "KUMARAPURAM 1",
        "time": "11:20 AM",
        "id": 145
      },
      {
        "no": 12,
        "name": "AM PATTI JUNCTION",
        "time": "11:22 AM",
        "id": 135
      },
      {
        "no": 13,
        "name": "MELA MARUTHUR",
        "time": "11:25 AM",
        "id": 136
      },
      {
        "no": 14,
        "name": "ZAKKAMMALPURAM 4",
        "time": "11:30 AM",
        "id": 287
      },
      {
        "no": 15,
        "name": "DURAISAMYPURAM 2",
        "time": "11:33 AM",
        "id": 301
      },
      {
        "no": 16,
        "name": "SOUTH KALMEDU",
        "time": "11:38 AM",
        "id": 138
      },
      {
        "no": 17,
        "name": "NORTH KALMEDU",
        "time": "11:39 AM",
        "id": 139
      },
      {
        "no": 18,
        "name": "VEPPALODAI",
        "time": "11:43 AM",
        "id": 118
      },
      {
        "no": 19,
        "name": "PANAIYOOR GATE",
        "time": "11:48 AM",
        "id": 132
      },
      {
        "no": 20,
        "name": "PANAIYOOR",
        "time": "11:52 AM",
        "id": 140
      },
      {
        "no": 21,
        "name": "KULATTHOOR 2",
        "time": "11:55 AM",
        "id": 302
      }
    ]
  },
  {
    "id": "55-J-12-408",
    "routeNo": "55-J",
    "code": "55/P55J-5",
    "tripCode": "55/P55J-555-JTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "KULATTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:05 PM",
    "endTime": "01:20 PM",
    "ids": [
      302,
      140,
      132,
      118,
      139,
      138,
      301,
      287,
      136,
      135,
      145,
      300,
      144,
      299,
      112,
      111,
      64,
      63,
      1,
      282,
      26
    ],
    "stops": [
      {
        "no": 21,
        "name": "KULATTHOOR 2",
        "time": "12:05 PM",
        "id": 302
      },
      {
        "no": 20,
        "name": "PANAIYOOR",
        "time": "12:07 PM",
        "id": 140
      },
      {
        "no": 19,
        "name": "PANAIYOOR GATE",
        "time": "12:11 PM",
        "id": 132
      },
      {
        "no": 18,
        "name": "VEPPALODAI",
        "time": "12:16 PM",
        "id": 118
      },
      {
        "no": 17,
        "name": "NORTH KALMEDU",
        "time": "12:20 PM",
        "id": 139
      },
      {
        "no": 16,
        "name": "SOUTH KALMEDU",
        "time": "12:21 PM",
        "id": 138
      },
      {
        "no": 15,
        "name": "DURAISAMYPURAM 2",
        "time": "12:26 PM",
        "id": 301
      },
      {
        "no": 14,
        "name": "ZAKKAMMALPURAM 4",
        "time": "12:29 PM",
        "id": 287
      },
      {
        "no": 13,
        "name": "MELA MARUTHUR",
        "time": "12:34 PM",
        "id": 136
      },
      {
        "no": 12,
        "name": "AM PATTI JUNCTION",
        "time": "12:37 PM",
        "id": 135
      },
      {
        "no": 11,
        "name": "KUMARAPURAM 1",
        "time": "12:39 PM",
        "id": 145
      },
      {
        "no": 10,
        "name": "ARASADI 2",
        "time": "12:45 PM",
        "id": 300
      },
      {
        "no": 9,
        "name": "KEELA ARASADI",
        "time": "12:47 PM",
        "id": 144
      },
      {
        "no": 8,
        "name": "ARASADI JUNCTION 3",
        "time": "12:54 PM",
        "id": 299
      },
      {
        "no": 7,
        "name": "AYYANAR PURAM",
        "time": "12:57 PM",
        "id": 112
      },
      {
        "no": 6,
        "name": "THOMAS NAGAR",
        "time": "01:03 PM",
        "id": 111
      },
      {
        "no": 5,
        "name": "SAVARAIYARPURAM",
        "time": "01:04 PM",
        "id": 64
      },
      {
        "no": 4,
        "name": "AROCKIAPURAM",
        "time": "01:06 PM",
        "id": 63
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:12 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "AMERICAN HOSPITAL 2",
        "time": "01:16 PM",
        "id": 282
      },
      {
        "no": 1,
        "name": "4TH GATE 1",
        "time": "01:20 PM",
        "id": 26
      }
    ]
  },
  {
    "id": "55-J-13-409",
    "routeNo": "55-J",
    "code": "55/P55J-8",
    "tripCode": "55/P55J-855-JTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KURUMBUR",
    "service": "TOWN ORDINARY",
    "startTime": "02:30 PM",
    "endTime": "03:40 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      127,
      157,
      49,
      50,
      51,
      172,
      129,
      130,
      131,
      56
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "02:30 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "02:34 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "02:39 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:47 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:48 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:52 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "02:59 PM",
        "id": 127
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "03:03 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "03:09 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "03:16 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "03:21 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "03:24 PM",
        "id": 172
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "03:26 PM",
        "id": 129
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "03:31 PM",
        "id": 130
      },
      {
        "no": 16,
        "name": "MICHEAL NADAR KUDIYIRUPPU",
        "time": "03:36 PM",
        "id": 131
      },
      {
        "no": 17,
        "name": "KURUMBUR",
        "time": "03:40 PM",
        "id": 56
      }
    ]
  },
  {
    "id": "55-J-14-410",
    "routeNo": "55-J",
    "code": "55/P55J-8",
    "tripCode": "55/P55J-855-JTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "KURUMBUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:45 PM",
    "endTime": "05:00 PM",
    "ids": [
      56,
      131,
      130,
      129,
      172,
      51,
      50,
      49,
      157,
      127,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "KURUMBUR",
        "time": "03:45 PM",
        "id": 56
      },
      {
        "no": 16,
        "name": "MICHEAL NADAR KUDIYIRUPPU",
        "time": "03:48 PM",
        "id": 131
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "03:54 PM",
        "id": 130
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "03:59 PM",
        "id": 129
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "04:01 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "04:05 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "04:10 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "04:17 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "04:24 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "04:28 PM",
        "id": 127
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "04:35 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "04:39 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "04:40 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:49 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:55 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "04:59 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-15-411",
    "routeNo": "55-J",
    "code": "55/P55J-7",
    "tripCode": "55/P55J-755-JTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "05:20 PM",
    "endTime": "06:05 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      180,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:27 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "05:35 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "05:44 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "05:50 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "05:53 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP JUNCTION",
        "time": "05:53 PM",
        "id": 180
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:02 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "06:05 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "55-J-16-412",
    "routeNo": "55-J",
    "code": "55/P55J-7",
    "tripCode": "55/P55J-755-JTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:10 PM",
    "endTime": "06:50 PM",
    "ids": [
      183,
      182,
      180,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "06:10 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:12 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP JUNCTION",
        "time": "06:19 PM",
        "id": 180
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:19 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:23 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:27 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "06:36 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "06:42 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-17-413",
    "routeNo": "55-J",
    "code": "55/P55J-6",
    "tripCode": "55/P55J-655-JTORD18U17",
    "order": 17,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "AUTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 PM",
    "endTime": "07:45 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "07:00 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "07:03 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "07:07 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "07:14 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "07:15 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:18 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "07:24 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:27 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "07:32 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "07:38 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "07:42 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "07:45 PM",
        "id": 172
      }
    ]
  },
  {
    "id": "55-J-18-414",
    "routeNo": "55-J",
    "code": "55/P55J-6",
    "tripCode": "55/P55J-655-JTORD18D18",
    "order": 18,
    "direction": "D",
    "from": "AUTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 PM",
    "endTime": "08:35 PM",
    "ids": [
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "07:50 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "07:52 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "07:56 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "08:02 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "08:07 PM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "08:10 PM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "08:16 PM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:19 PM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:20 PM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:27 PM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:31 PM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:34 PM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "55-J-19-415",
    "routeNo": "55-J",
    "code": "55/P55J-6",
    "tripCode": "55/P55J-655-JTORD18U19",
    "order": 19,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "AUTHOOR",
    "service": "TOWN ORDINARY",
    "startTime": "08:40 PM",
    "endTime": "09:35 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      157,
      49,
      50,
      51,
      172
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "08:40 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "08:44 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "08:49 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "08:58 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "08:58 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "09:02 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "09:10 PM",
        "id": 47
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "09:13 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "09:19 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "09:26 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "09:31 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "09:35 PM",
        "id": 172
      }
    ]
  },
  {
    "id": "55-J-20-416",
    "routeNo": "55-J",
    "code": "55/P55J-6",
    "tripCode": "55/P55J-655-JTORD18D20",
    "order": 20,
    "direction": "D",
    "from": "AUTHOOR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 PM",
    "endTime": "05:20 AM",
    "ids": [
      172,
      51,
      50,
      49,
      157,
      47,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "09:40 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "10:09 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "10:50 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "11:48 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:39 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "MADHIKETTAN ODAI",
        "time": "01:06 AM",
        "id": 47
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:10 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:41 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:48 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:00 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:45 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:15 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-A-1-417",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:50 PM",
    "endTime": "03:00 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "01:54 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:58 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:05 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:08 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:15 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:20 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "02:25 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "02:25 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "02:33 PM",
        "id": 249
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "02:39 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "02:41 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "02:47 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "02:53 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "02:57 PM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "03:00 PM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-A-2-418",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:05 PM",
    "endTime": "04:25 PM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "03:05 PM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "03:08 PM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "03:12 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "03:19 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "03:26 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "03:28 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "03:35 PM",
        "id": 249
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "03:44 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "03:44 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:50 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:55 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:04 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:06 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:15 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "04:19 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-A-3-419",
    "routeNo": "56-A",
    "code": "56/P56A-2",
    "tripCode": "56/P56A-256-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:30 PM",
    "endTime": "05:40 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      23,
      24,
      243,
      303,
      304,
      244,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "04:34 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:37 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:44 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:46 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:53 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:57 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "05:02 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "05:02 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "05:12 PM",
        "id": 23
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "05:16 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "05:18 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "05:24 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "05:29 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "05:33 PM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "05:35 PM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "05:40 PM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-A-4-420",
    "routeNo": "56-A",
    "code": "56/P56A-2",
    "tripCode": "56/P56A-256-ATORD18D4",
    "order": 4,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 PM",
    "endTime": "07:05 PM",
    "ids": [
      247,
      245,
      244,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "05:45 PM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "05:49 PM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "05:52 PM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "05:56 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "06:02 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "06:09 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "06:11 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "06:16 PM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "06:27 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:27 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:33 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:37 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:46 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:48 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:56 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "07:00 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-A-5-421",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 PM",
    "endTime": "08:20 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "07:14 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:18 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:25 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:28 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:35 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:40 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:45 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "07:45 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "07:53 PM",
        "id": 249
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "07:59 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "08:01 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "08:07 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "08:13 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "08:17 PM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "08:20 PM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-A-6-422",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:25 PM",
    "endTime": "09:45 PM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "08:25 PM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "08:28 PM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "08:32 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "08:39 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "08:46 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "08:48 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "08:55 PM",
        "id": 249
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "09:04 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:04 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:10 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:15 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:24 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:26 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:35 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:39 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-A-7-423",
    "routeNo": "56-A",
    "code": "56/P56A-3",
    "tripCode": "56/P56A-356-ATORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 PM",
    "endTime": "05:40 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      248,
      22,
      23,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "10:18 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:41 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:28 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:42 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:31 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:56 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:30 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "ALLIKULAM JUNCTION",
        "time": "02:09 AM",
        "id": 248
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "02:18 AM",
        "id": 22
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "02:40 AM",
        "id": 23
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "02:56 AM",
        "id": 249
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "03:30 AM",
        "id": 24
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "03:45 AM",
        "id": 243
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "04:22 AM",
        "id": 303
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "04:57 AM",
        "id": 304
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "05:22 AM",
        "id": 244
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "05:40 AM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-A-8-424",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 AM",
    "endTime": "07:00 AM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "05:45 AM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "05:48 AM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "05:52 AM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "05:58 AM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "06:04 AM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "06:07 AM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "06:13 AM",
        "id": 249
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "06:21 AM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:21 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:27 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:32 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:40 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:43 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:51 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:55 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-A-9-425",
    "routeNo": "56-A",
    "code": "56/P56A-2",
    "tripCode": "56/P56A-256-ATORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:10 AM",
    "endTime": "08:20 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      23,
      24,
      243,
      303,
      304,
      244,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "07:14 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:17 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:24 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:26 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:33 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:37 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:42 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "07:42 AM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "07:52 AM",
        "id": 23
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "07:56 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "07:58 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "08:04 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "08:09 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "08:13 AM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "08:15 AM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "08:20 AM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-A-10-426",
    "routeNo": "56-A",
    "code": "56/P56A-4",
    "tripCode": "56/P56A-456-ATORD18D10",
    "order": 10,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:25 AM",
    "endTime": "09:45 AM",
    "ids": [
      247,
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      23,
      22,
      248,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "MELA CHEKKARAKUDI",
        "time": "08:25 AM",
        "id": 247
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "08:29 AM",
        "id": 245
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "08:32 AM",
        "id": 244
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "08:36 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "08:41 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "08:47 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "08:50 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "08:55 AM",
        "id": 249
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "08:58 AM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "09:01 AM",
        "id": 22
      },
      {
        "no": 9,
        "name": "ALLIKULAM JUNCTION",
        "time": "09:03 AM",
        "id": 248
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:09 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:15 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:19 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:26 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:29 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:36 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:40 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-A-11-427",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 AM",
    "endTime": "11:00 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:54 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:58 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:05 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:08 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:15 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:20 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "10:25 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "10:25 AM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "10:33 AM",
        "id": 249
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "10:39 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "10:41 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "10:47 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "10:53 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "10:57 AM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "11:00 AM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-A-12-428",
    "routeNo": "56-A",
    "code": "56/P56A-1",
    "tripCode": "56/P56A-156-ATORD18D12",
    "order": 12,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:05 AM",
    "endTime": "01:45 PM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "11:05 AM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "11:11 AM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "11:20 AM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "11:33 AM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "11:47 AM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "11:52 AM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "12:05 PM",
        "id": 249
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "12:23 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "12:23 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:36 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:45 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:03 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:08 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:26 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "01:34 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-B-1-429",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 AM",
    "endTime": "07:00 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      22,
      23,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:49 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:53 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:00 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:03 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:10 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:15 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:20 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "06:20 AM",
        "id": 241
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "06:27 AM",
        "id": 22
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "06:31 AM",
        "id": 23
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "06:33 AM",
        "id": 249
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "06:39 AM",
        "id": 24
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "06:41 AM",
        "id": 243
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "06:47 AM",
        "id": 303
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "06:53 AM",
        "id": 304
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "06:57 AM",
        "id": 244
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "07:00 AM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-B-2-430",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:05 AM",
    "endTime": "08:30 AM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      23,
      22,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "07:05 AM",
        "id": 245
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "07:08 AM",
        "id": 244
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "07:12 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "07:19 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "07:25 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "07:28 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "07:34 AM",
        "id": 249
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "07:37 AM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "07:41 AM",
        "id": 22
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "07:49 AM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:49 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:55 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:00 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:09 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:12 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:20 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:24 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-B-3-431",
    "routeNo": "56-B",
    "code": "56/P56B-3",
    "tripCode": "56/P56B-356-BTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "08:35 AM",
    "endTime": "10:10 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      253,
      254,
      196,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:40 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:44 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:53 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:56 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:05 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:10 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:15 AM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "09:21 AM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "09:34 AM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "09:41 AM",
        "id": 252
      },
      {
        "no": 14,
        "name": "CHETTIYOORANI",
        "time": "09:48 AM",
        "id": 253
      },
      {
        "no": 15,
        "name": "CAMP THATTAPARAI",
        "time": "09:53 AM",
        "id": 254
      },
      {
        "no": 17,
        "name": "VALLINAYAGIPURAM",
        "time": "10:06 AM",
        "id": 196
      },
      {
        "no": 18,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:10 AM",
        "id": 74
      }
    ]
  },
  {
    "id": "56-B-4-432",
    "routeNo": "56-B",
    "code": "56/P56B-3",
    "tripCode": "56/P56B-356-BTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:15 AM",
    "endTime": "12:00 PM",
    "ids": [
      74,
      196,
      254,
      253,
      252,
      251,
      250,
      6,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "PUTHIYAMPUTHUR",
        "time": "10:15 AM",
        "id": 74
      },
      {
        "no": 17,
        "name": "VALLINAYAGIPURAM",
        "time": "10:18 AM",
        "id": 196
      },
      {
        "no": 15,
        "name": "CAMP THATTAPARAI",
        "time": "10:33 AM",
        "id": 254
      },
      {
        "no": 14,
        "name": "CHETTIYOORANI",
        "time": "10:38 AM",
        "id": 253
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "10:46 AM",
        "id": 252
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "10:54 AM",
        "id": 251
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "11:08 AM",
        "id": 250
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:15 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:20 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:26 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:36 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:39 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:49 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:53 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-B-5-433",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:05 PM",
    "endTime": "01:20 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      22,
      23,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "12:09 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:13 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:20 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:23 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:30 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:35 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "12:40 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "12:40 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "12:47 PM",
        "id": 22
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "12:51 PM",
        "id": 23
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "12:53 PM",
        "id": 249
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "12:59 PM",
        "id": 24
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "01:01 PM",
        "id": 243
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "01:07 PM",
        "id": 303
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "01:13 PM",
        "id": 304
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "01:17 PM",
        "id": 244
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "01:20 PM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-B-6-434",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:25 PM",
    "endTime": "02:40 PM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      23,
      22,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "01:25 PM",
        "id": 245
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "01:27 PM",
        "id": 244
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "01:31 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "01:37 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "01:43 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "01:45 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "01:51 PM",
        "id": 249
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "01:53 PM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "01:57 PM",
        "id": 22
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "02:04 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "02:04 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:09 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:14 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:21 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:24 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:31 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "02:35 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-B-7-435",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:45 PM",
    "endTime": "04:00 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      22,
      23,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "02:49 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:53 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:00 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:03 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:10 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:15 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "03:20 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "03:20 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "03:27 PM",
        "id": 22
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "03:31 PM",
        "id": 23
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "03:33 PM",
        "id": 249
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "03:39 PM",
        "id": 24
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "03:41 PM",
        "id": 243
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "03:47 PM",
        "id": 303
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "03:53 PM",
        "id": 304
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "03:57 PM",
        "id": 244
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "04:00 PM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-B-8-436",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:05 PM",
    "endTime": "05:30 PM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      23,
      22,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "04:05 PM",
        "id": 245
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "04:08 PM",
        "id": 244
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "04:12 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "04:19 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "04:25 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "04:28 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "04:34 PM",
        "id": 249
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "04:37 PM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "04:41 PM",
        "id": 22
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "04:49 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "04:49 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:55 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:00 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:09 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:12 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:20 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:24 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-B-9-437",
    "routeNo": "56-B",
    "code": "56/P56B-2",
    "tripCode": "56/P56B-256-BTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "VELLARAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:35 PM",
    "endTime": "06:50 PM",
    "ids": [
      1,
      26,
      66,
      67,
      68,
      69,
      97,
      143,
      99,
      281,
      100,
      191,
      192,
      193,
      194
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "05:38 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "05:40 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "05:45 PM",
        "id": 67
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "05:46 PM",
        "id": 68
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "05:52 PM",
        "id": 69
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "05:55 PM",
        "id": 97
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "05:59 PM",
        "id": 143
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "06:12 PM",
        "id": 99
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "06:18 PM",
        "id": 281
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "06:22 PM",
        "id": 100
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "06:28 PM",
        "id": 191
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "06:34 PM",
        "id": 192
      },
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "06:42 PM",
        "id": 193
      },
      {
        "no": 15,
        "name": "VELLARAM",
        "time": "06:50 PM",
        "id": 194
      }
    ]
  },
  {
    "id": "56-B-10-438",
    "routeNo": "56-B",
    "code": "56/P56B-2",
    "tripCode": "56/P56B-256-BTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "VELLARAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:55 PM",
    "endTime": "08:15 PM",
    "ids": [
      194,
      193,
      192,
      191,
      100,
      281,
      99,
      143,
      97,
      69,
      68,
      67,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "VELLARAM",
        "time": "06:55 PM",
        "id": 194
      },
      {
        "no": 14,
        "name": "KACCHERI THALAVAIPURAM",
        "time": "07:02 PM",
        "id": 193
      },
      {
        "no": 13,
        "name": "VELLARAM JUNCTION",
        "time": "07:11 PM",
        "id": 192
      },
      {
        "no": 12,
        "name": "KUMARAPURAM JUNCTION",
        "time": "07:17 PM",
        "id": 191
      },
      {
        "no": 11,
        "name": "KURUKKUSALAI",
        "time": "07:23 PM",
        "id": 100
      },
      {
        "no": 10,
        "name": "SUBRAMANIYAPURAM 2",
        "time": "07:28 PM",
        "id": 281
      },
      {
        "no": 9,
        "name": "VALASAMUTHIRAM",
        "time": "07:34 PM",
        "id": 99
      },
      {
        "no": 8,
        "name": "ARASADI 1",
        "time": "07:48 PM",
        "id": 143
      },
      {
        "no": 7,
        "name": "THANNEER PANDHAL",
        "time": "07:52 PM",
        "id": 97
      },
      {
        "no": 6,
        "name": "ODAIPATTI PUDHUR",
        "time": "07:56 PM",
        "id": 69
      },
      {
        "no": 5,
        "name": "KALI KOVIL JUNCTION",
        "time": "08:02 PM",
        "id": 68
      },
      {
        "no": 4,
        "name": "MAPPILLAIYOORANI",
        "time": "08:03 PM",
        "id": 67
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "08:09 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:11 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-B-11-439",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:20 PM",
    "endTime": "09:50 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      22,
      23,
      249,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:25 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:29 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:38 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:41 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:51 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:56 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:02 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "09:02 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "09:11 PM",
        "id": 22
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "09:15 PM",
        "id": 23
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "09:18 PM",
        "id": 249
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "09:24 PM",
        "id": 24
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "09:27 PM",
        "id": 243
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "09:35 PM",
        "id": 303
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "09:41 PM",
        "id": 304
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "09:46 PM",
        "id": 244
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "09:50 PM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-B-12-440",
    "routeNo": "56-B",
    "code": "56/P56B-1",
    "tripCode": "56/P56B-156-BTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:55 PM",
    "endTime": "05:40 AM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      23,
      22,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "09:55 PM",
        "id": 245
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "10:12 PM",
        "id": 244
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "10:37 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "11:11 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "11:49 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "12:04 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "12:37 AM",
        "id": 249
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "12:54 AM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "01:16 AM",
        "id": 22
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "01:59 AM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:59 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:33 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:59 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:47 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:01 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:48 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:11 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-C-1-441",
    "routeNo": "56-C",
    "code": "56/P56C-1",
    "tripCode": "56/P56C-156-CTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "04:35 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      256,
      257,
      258,
      259,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "03:04 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:08 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:17 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:19 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:28 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:32 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "03:38 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "03:40 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "03:49 PM",
        "id": 167
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "04:10 PM",
        "id": 256
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "04:14 PM",
        "id": 257
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "04:24 PM",
        "id": 258
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "04:26 PM",
        "id": 259
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "04:30 PM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "04:35 PM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-C-2-442",
    "routeNo": "56-C",
    "code": "56/P56C-1",
    "tripCode": "56/P56C-156-CTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:40 PM",
    "endTime": "06:15 PM",
    "ids": [
      247,
      245,
      259,
      258,
      257,
      256,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "04:40 PM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "04:44 PM",
        "id": 245
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "04:48 PM",
        "id": 259
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "04:50 PM",
        "id": 258
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "05:00 PM",
        "id": 257
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "05:04 PM",
        "id": 256
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "05:25 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "05:34 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "05:36 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:42 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:46 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:55 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:57 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:06 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:10 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-C-3-443",
    "routeNo": "56-C",
    "code": "56/P56C-2",
    "tripCode": "56/P56C-256-CTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:20 PM",
    "endTime": "07:40 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      23,
      24,
      243,
      303,
      304,
      244,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "06:24 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:28 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:36 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:38 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:47 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:51 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:57 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "06:57 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "07:08 PM",
        "id": 23
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "07:13 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "07:15 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "07:22 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "07:28 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "07:32 PM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "07:35 PM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "07:40 PM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-C-4-444",
    "routeNo": "56-C",
    "code": "56/P56C-2",
    "tripCode": "56/P56C-256-CTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:45 PM",
    "endTime": "09:10 PM",
    "ids": [
      247,
      245,
      244,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "07:45 PM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "07:50 PM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "07:53 PM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "07:57 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "08:03 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "08:10 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "08:13 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "08:18 PM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "08:30 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:30 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:36 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:41 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:49 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:52 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:00 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:04 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-C-5-445",
    "routeNo": "56-C",
    "code": "56/P56C-1",
    "tripCode": "56/P56C-156-CTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 PM",
    "endTime": "06:10 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      256,
      257,
      258,
      259,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:43 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:05 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:51 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:05 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:52 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:17 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "12:51 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "01:01 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "01:56 AM",
        "id": 167
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "03:52 AM",
        "id": 256
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "04:14 AM",
        "id": 257
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "05:11 AM",
        "id": 258
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "05:21 AM",
        "id": 259
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "05:42 AM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "06:10 AM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-C-6-446",
    "routeNo": "56-C",
    "code": "56/P56C-2",
    "tripCode": "56/P56C-256-CTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 AM",
    "endTime": "07:45 AM",
    "ids": [
      247,
      245,
      244,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "06:15 AM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "06:20 AM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "06:23 AM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "06:28 AM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "06:35 AM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "06:42 AM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "06:44 AM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "06:50 AM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "07:03 AM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:03 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:09 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:14 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:23 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:26 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:35 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "07:39 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-C-7-447",
    "routeNo": "56-C",
    "code": "56/P56C-1",
    "tripCode": "56/P56C-156-CTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 AM",
    "endTime": "09:10 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      256,
      257,
      258,
      259,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "07:54 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:57 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:04 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:06 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:13 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:17 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:22 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "08:23 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "08:32 AM",
        "id": 167
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "08:49 AM",
        "id": 256
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "08:52 AM",
        "id": 257
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "09:01 AM",
        "id": 258
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "09:02 AM",
        "id": 259
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "09:05 AM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "09:10 AM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-C-8-448",
    "routeNo": "56-C",
    "code": "56/P56C-1",
    "tripCode": "56/P56C-156-CTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 AM",
    "endTime": "10:45 AM",
    "ids": [
      247,
      245,
      259,
      258,
      257,
      256,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "09:15 AM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "09:19 AM",
        "id": 245
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "09:23 AM",
        "id": 259
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "09:24 AM",
        "id": 258
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "09:34 AM",
        "id": 257
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "09:38 AM",
        "id": 256
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "09:57 AM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "10:06 AM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "10:08 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:14 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:18 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:26 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:28 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:36 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "10:40 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-C-9-449",
    "routeNo": "56-C",
    "code": "56/P56C-2",
    "tripCode": "56/P56C-256-CTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:50 AM",
    "endTime": "12:00 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      23,
      24,
      243,
      303,
      304,
      244,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "10:54 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:57 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:04 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:06 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:13 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:17 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "11:22 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "11:22 AM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "11:32 AM",
        "id": 23
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "11:36 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "11:38 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "11:44 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "11:49 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "11:53 AM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "11:55 AM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "12:00 PM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-C-10-450",
    "routeNo": "56-C",
    "code": "56/P56C-2",
    "tripCode": "56/P56C-256-CTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:05 PM",
    "endTime": "03:15 PM",
    "ids": [
      247,
      245,
      244,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "12:05 PM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "12:16 PM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "12:23 PM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "12:33 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "12:47 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "01:02 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "01:08 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "01:20 PM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "01:46 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:46 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:00 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:10 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:29 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:35 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:54 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "03:03 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-D-1-451",
    "routeNo": "56-D",
    "code": "56/P56D-1",
    "tripCode": "56/P56D-156-DTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:10 PM",
    "endTime": "03:30 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      256,
      257,
      258,
      259,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "02:14 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:17 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:24 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:26 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:33 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:37 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "02:42 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "02:43 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "02:52 PM",
        "id": 167
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "03:09 PM",
        "id": 256
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "03:12 PM",
        "id": 257
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "03:21 PM",
        "id": 258
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "03:22 PM",
        "id": 259
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "03:25 PM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "03:30 PM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-D-2-452",
    "routeNo": "56-D",
    "code": "56/P56D-1",
    "tripCode": "56/P56D-156-DTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:45 PM",
    "endTime": "05:05 PM",
    "ids": [
      247,
      245,
      259,
      258,
      257,
      256,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "03:45 PM",
        "id": 247
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "03:49 PM",
        "id": 245
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "03:52 PM",
        "id": 259
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "03:53 PM",
        "id": 258
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "04:02 PM",
        "id": 257
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "04:05 PM",
        "id": 256
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "04:22 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "04:31 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "04:32 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:37 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:41 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:48 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:50 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:57 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:00 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-D-3-453",
    "routeNo": "56-D",
    "code": "56/P56D-2",
    "tripCode": "56/P56D-256-DTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KALLAMPARAMBU",
    "service": "TOWN ORDINARY",
    "startTime": "05:20 PM",
    "endTime": "06:35 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      22,
      23,
      249,
      24,
      243,
      303,
      304,
      260
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "05:24 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:28 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:36 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:39 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:47 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:51 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "05:57 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "05:57 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "06:04 PM",
        "id": 22
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "06:08 PM",
        "id": 23
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "06:11 PM",
        "id": 249
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "06:16 PM",
        "id": 24
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "06:19 PM",
        "id": 243
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "06:25 PM",
        "id": 303
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "06:31 PM",
        "id": 304
      },
      {
        "no": 17,
        "name": "KALLAMPARAMBU",
        "time": "06:35 PM",
        "id": 260
      }
    ]
  },
  {
    "id": "56-D-4-454",
    "routeNo": "56-D",
    "code": "56/P56D-3",
    "tripCode": "56/P56D-356-DTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "KALLAMPARAMBU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:40 PM",
    "endTime": "07:55 PM",
    "ids": [
      260,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "KALLAMPARAMBU",
        "time": "06:40 PM",
        "id": 260
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "06:43 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "06:49 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "06:56 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "06:58 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "07:04 PM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "07:15 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:16 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:22 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:26 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:35 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:37 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:45 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "07:49 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-D-5-455",
    "routeNo": "56-D",
    "code": "56/P56D-1",
    "tripCode": "56/P56D-156-DTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MELA CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 PM",
    "endTime": "07:15 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      256,
      257,
      258,
      259,
      245,
      247
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:44 PM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:12 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:09 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:27 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:26 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:57 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "12:38 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "12:51 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "01:59 AM",
        "id": 167
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "04:23 AM",
        "id": 256
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "04:51 AM",
        "id": 257
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "06:02 AM",
        "id": 258
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "06:14 AM",
        "id": 259
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "06:40 AM",
        "id": 245
      },
      {
        "no": 18,
        "name": "MELA CHEKKARAKUDI",
        "time": "07:15 AM",
        "id": 247
      }
    ]
  },
  {
    "id": "56-D-6-456",
    "routeNo": "56-D",
    "code": "56/P56D-4",
    "tripCode": "56/P56D-456-DTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "MELA CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:20 AM",
    "endTime": "08:40 AM",
    "ids": [
      247,
      245,
      244,
      304,
      303,
      243,
      24,
      249,
      23,
      22,
      248,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "MELA CHEKKARAKUDI",
        "time": "07:20 AM",
        "id": 247
      },
      {
        "no": 19,
        "name": "CHEKKARAKUDI",
        "time": "07:24 AM",
        "id": 245
      },
      {
        "no": 17,
        "name": "MAHILAMPURAM",
        "time": "07:27 AM",
        "id": 244
      },
      {
        "no": 16,
        "name": "THALAVAIPURAM 2",
        "time": "07:31 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "PUDHUR 2",
        "time": "07:36 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "SAMATTHUVAPURAM",
        "time": "07:42 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PEROORANI",
        "time": "07:45 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "THIRUVANANDHA PURAM JUNCTION",
        "time": "07:50 AM",
        "id": 249
      },
      {
        "no": 11,
        "name": "THIRUVANANDHA PURAM",
        "time": "07:53 AM",
        "id": 23
      },
      {
        "no": 10,
        "name": "ALLIKULAM",
        "time": "07:56 AM",
        "id": 22
      },
      {
        "no": 9,
        "name": "ALLIKULAM JUNCTION",
        "time": "07:58 AM",
        "id": 248
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:04 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:10 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:14 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:21 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:24 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:31 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:35 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-D-7-457",
    "routeNo": "56-D",
    "code": "56/P56D-5",
    "tripCode": "56/P56D-556-DTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:55 AM",
    "endTime": "10:05 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      256,
      257,
      258,
      259,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:55 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "08:58 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:01 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:08 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:10 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:16 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:20 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:24 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "09:26 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "09:33 AM",
        "id": 167
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "09:49 AM",
        "id": 256
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "09:52 AM",
        "id": 257
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "10:00 AM",
        "id": 258
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "10:02 AM",
        "id": 259
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "10:05 AM",
        "id": 245
      }
    ]
  },
  {
    "id": "56-D-8-458",
    "routeNo": "56-D",
    "code": "56/P56D-5",
    "tripCode": "56/P56D-556-DTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:10 AM",
    "endTime": "11:20 AM",
    "ids": [
      245,
      259,
      258,
      257,
      256,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "10:10 AM",
        "id": 245
      },
      {
        "no": 16,
        "name": "AZHAGAPURI",
        "time": "10:12 AM",
        "id": 259
      },
      {
        "no": 15,
        "name": "NATTHAM",
        "time": "10:14 AM",
        "id": 258
      },
      {
        "no": 14,
        "name": "POTTALOORANI VILLAGE",
        "time": "10:22 AM",
        "id": 257
      },
      {
        "no": 13,
        "name": "POTTALOORANI JUNCTION",
        "time": "10:25 AM",
        "id": 256
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "10:41 AM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "10:48 AM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "10:50 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "10:54 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:58 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:04 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:06 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:13 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "11:16 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:20 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-D-9-459",
    "routeNo": "56-D",
    "code": "56/P56D-3",
    "tripCode": "56/P56D-356-DTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KALLAMPARAMBU",
    "service": "TOWN ORDINARY",
    "startTime": "11:25 AM",
    "endTime": "12:40 PM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      23,
      24,
      243,
      303,
      304,
      260
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:25 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "11:30 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:34 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:42 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:44 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:53 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:57 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "12:03 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "12:04 PM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "12:15 PM",
        "id": 23
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "12:21 PM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "12:23 PM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "12:30 PM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "12:36 PM",
        "id": 304
      },
      {
        "no": 15,
        "name": "KALLAMPARAMBU",
        "time": "12:40 PM",
        "id": 260
      }
    ]
  },
  {
    "id": "56-D-10-460",
    "routeNo": "56-D",
    "code": "56/P56D-3",
    "tripCode": "56/P56D-356-DTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KALLAMPARAMBU",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:45 PM",
    "endTime": "01:55 PM",
    "ids": [
      260,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "KALLAMPARAMBU",
        "time": "12:45 PM",
        "id": 260
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "12:48 PM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "12:54 PM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "01:00 PM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "01:02 PM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "01:07 PM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "01:18 PM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:18 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:24 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:28 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:36 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:38 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:46 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "01:50 PM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-E-1-461",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "12:20 PM",
    "endTime": "01:40 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      305,
      255,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "12:25 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:30 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:39 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:42 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:52 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:57 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:04 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "01:08 PM",
        "id": 305
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "01:10 PM",
        "id": 255
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "01:22 PM",
        "id": 167
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "01:25 PM",
        "id": 261
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "01:35 PM",
        "id": 262
      },
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "01:40 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-E-2-462",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18D2",
    "order": 2,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:45 PM",
    "endTime": "02:55 PM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      305,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "01:45 PM",
        "id": 24
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "01:48 PM",
        "id": 262
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "01:58 PM",
        "id": 261
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "02:00 PM",
        "id": 167
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "02:10 PM",
        "id": 255
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "02:12 PM",
        "id": 305
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "02:16 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:22 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:26 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:35 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:37 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:46 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:49 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-E-3-463",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "04:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      305,
      255,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:05 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:08 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:17 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:19 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:28 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:32 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "03:38 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "03:42 PM",
        "id": 305
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "03:44 PM",
        "id": 255
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "03:54 PM",
        "id": 167
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "03:56 PM",
        "id": 261
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "04:06 PM",
        "id": 262
      },
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "04:10 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-E-4-464",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18D4",
    "order": 4,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:15 PM",
    "endTime": "05:40 PM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      305,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "04:15 PM",
        "id": 24
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "04:19 PM",
        "id": 262
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "04:30 PM",
        "id": 261
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "04:34 PM",
        "id": 167
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "04:45 PM",
        "id": 255
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "04:48 PM",
        "id": 305
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "04:53 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:00 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:05 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:16 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:19 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:29 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:33 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-E-5-465",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 PM",
    "endTime": "06:30 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      305,
      255,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:48 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:50 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:56 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:57 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:03 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:06 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:09 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "06:12 PM",
        "id": 305
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "06:13 PM",
        "id": 255
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "06:19 PM",
        "id": 167
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "06:21 PM",
        "id": 261
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "06:27 PM",
        "id": 262
      },
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "06:30 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-E-6-466",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18D6",
    "order": 6,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 PM",
    "endTime": "07:50 PM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      305,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "06:50 PM",
        "id": 24
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "06:53 PM",
        "id": 262
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "07:01 PM",
        "id": 261
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "07:03 PM",
        "id": 167
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "07:11 PM",
        "id": 255
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "07:13 PM",
        "id": 305
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:16 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:21 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:25 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:33 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:35 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:42 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:45 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-E-7-467",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "08:00 PM",
    "endTime": "09:05 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      305,
      255,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:04 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:08 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:15 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:18 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:26 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:30 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:35 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "08:39 PM",
        "id": 305
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "08:41 PM",
        "id": 255
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "08:50 PM",
        "id": 167
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "08:52 PM",
        "id": 261
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "09:01 PM",
        "id": 262
      },
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "09:05 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-E-8-468",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 PM",
    "endTime": "10:15 PM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      305,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "09:15 PM",
        "id": 24
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "09:18 PM",
        "id": 262
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "09:26 PM",
        "id": 261
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "09:28 PM",
        "id": 167
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "09:36 PM",
        "id": 255
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "09:38 PM",
        "id": 305
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:41 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:46 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:50 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:58 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:00 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:07 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:10 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-E-9-469",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 PM",
    "endTime": "11:40 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      305,
      255,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:35 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:38 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:47 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:49 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:58 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:02 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "11:08 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "11:12 PM",
        "id": 305
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "11:14 PM",
        "id": 255
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "11:24 PM",
        "id": 167
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "11:26 PM",
        "id": 261
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "11:36 PM",
        "id": 262
      },
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "11:40 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-E-10-470",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18D10",
    "order": 10,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:25 AM",
    "endTime": "07:30 AM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      305,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "06:25 AM",
        "id": 24
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "06:28 AM",
        "id": 262
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "06:37 AM",
        "id": 261
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "06:39 AM",
        "id": 167
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "06:48 AM",
        "id": 255
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "06:50 AM",
        "id": 305
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:54 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:59 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:03 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:11 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:14 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:21 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:25 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-E-11-471",
    "routeNo": "56-E",
    "code": "56/P56E-1",
    "tripCode": "56/P56E-156-ETORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "07:40 AM",
    "endTime": "08:40 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      305,
      255,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:44 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:47 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:54 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:56 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:04 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:08 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:13 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM 2",
        "time": "08:16 AM",
        "id": 305
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "08:18 AM",
        "id": 255
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "08:26 AM",
        "id": 167
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "08:28 AM",
        "id": 261
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "08:36 AM",
        "id": 262
      },
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "08:40 AM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-E-12-472",
    "routeNo": "56-E",
    "code": "56/P56E-2",
    "tripCode": "56/P56E-256-ETORD18D12",
    "order": 12,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:45 AM",
    "endTime": "10:00 AM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      305,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1,
      28,
      27
    ],
    "stops": [
      {
        "no": 16,
        "name": "PEROORANI",
        "time": "08:45 AM",
        "id": 24
      },
      {
        "no": 15,
        "name": "THIMMARAJAPURAM",
        "time": "08:48 AM",
        "id": 262
      },
      {
        "no": 14,
        "name": "VARTHAGAREDDIPATTI",
        "time": "08:57 AM",
        "id": 261
      },
      {
        "no": 13,
        "name": "VAGAIKULAM",
        "time": "08:59 AM",
        "id": 167
      },
      {
        "no": 12,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "09:09 AM",
        "id": 255
      },
      {
        "no": 11,
        "name": "RAMACHANDRAPURAM 2",
        "time": "09:11 AM",
        "id": 305
      },
      {
        "no": 10,
        "name": "MANGALAGIRI",
        "time": "09:14 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "PUDHUKOTTAI 2",
        "time": "09:20 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:24 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "ANTHONIYARPURAM",
        "time": "09:32 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "KORAMPALLAM",
        "time": "09:34 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "3RD MILE",
        "time": "09:42 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "MILLER PURAM",
        "time": "09:46 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:56 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THRES PURAM",
        "time": "10:00 AM",
        "id": 27
      }
    ]
  },
  {
    "id": "56-E-13-473",
    "routeNo": "56-E",
    "code": "56/P56E-3",
    "tripCode": "56/P56E-356-ETORD18D13",
    "order": 13,
    "direction": "D",
    "from": "THRES PURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:10 AM",
    "endTime": "12:10 PM",
    "ids": [
      27,
      1
    ],
    "stops": [
      {
        "no": 2,
        "name": "THRES PURAM",
        "time": "10:10 AM",
        "id": 27
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-1-474",
    "routeNo": "56-F",
    "code": "56/P56F-1",
    "tripCode": "56/P56F-156-FTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ADAIKKALAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:45 AM",
    "endTime": "06:40 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      263,
      264
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:48 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:51 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:58 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:59 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:06 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:09 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:14 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "06:15 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "06:22 AM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "06:26 AM",
        "id": 166
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "06:36 AM",
        "id": 263
      },
      {
        "no": 15,
        "name": "ADAIKKALAPURAM",
        "time": "06:40 AM",
        "id": 264
      }
    ]
  },
  {
    "id": "56-F-2-475",
    "routeNo": "56-F",
    "code": "56/P56F-1",
    "tripCode": "56/P56F-156-FTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "ADAIKKALAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 AM",
    "endTime": "07:40 AM",
    "ids": [
      264,
      263,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "ADAIKKALAPURAM",
        "time": "06:50 AM",
        "id": 264
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "06:53 AM",
        "id": 263
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "07:02 AM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "07:05 AM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "07:12 AM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:13 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:17 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:20 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:26 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:28 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:33 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:36 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-3-476",
    "routeNo": "56-F",
    "code": "56/P56F-6",
    "tripCode": "56/P56F-656-FTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "MEELAVITTAN",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 AM",
    "endTime": "08:05 AM",
    "ids": [
      1,
      26,
      220,
      221,
      222,
      223
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "07:52 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "CHINNAKANNUPURAM",
        "time": "07:54 AM",
        "id": 220
      },
      {
        "no": 4,
        "name": "SILVERPURAM",
        "time": "07:57 AM",
        "id": 221
      },
      {
        "no": 5,
        "name": "PANDARAMPATTI",
        "time": "08:02 AM",
        "id": 222
      },
      {
        "no": 6,
        "name": "MEELAVITTAN",
        "time": "08:05 AM",
        "id": 223
      }
    ]
  },
  {
    "id": "56-F-4-477",
    "routeNo": "56-F",
    "code": "56/P56F-6",
    "tripCode": "56/P56F-656-FTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "MEELAVITTAN",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 AM",
    "endTime": "08:10 AM",
    "ids": [
      223,
      222,
      221,
      220,
      26,
      1
    ],
    "stops": [
      {
        "no": 6,
        "name": "MEELAVITTAN",
        "time": "08:10 AM",
        "id": 223
      },
      {
        "no": 5,
        "name": "PANDARAMPATTI",
        "time": "08:10 AM",
        "id": 222
      },
      {
        "no": 4,
        "name": "SILVERPURAM",
        "time": "08:10 AM",
        "id": 221
      },
      {
        "no": 3,
        "name": "CHINNAKANNUPURAM",
        "time": "08:10 AM",
        "id": 220
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "08:10 AM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-5-478",
    "routeNo": "56-F",
    "code": "56/P56F-7",
    "tripCode": "56/P56F-756-FTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ST. MARYS COLLEGE",
    "service": "TOWN ORDINARY",
    "startTime": "08:20 AM",
    "endTime": "08:25 AM",
    "ids": [
      1,
      28,
      272
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:20 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:23 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ST. MARY'S COLLEGE",
        "time": "08:25 AM",
        "id": 272
      }
    ]
  },
  {
    "id": "56-F-6-479",
    "routeNo": "56-F",
    "code": "56/P56F-7",
    "tripCode": "56/P56F-756-FTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "ST. MARYS COLLEGE",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:45 AM",
    "endTime": "09:05 AM",
    "ids": [
      272,
      28,
      1
    ],
    "stops": [
      {
        "no": 3,
        "name": "ST. MARY'S COLLEGE",
        "time": "08:45 AM",
        "id": 272
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:51 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:05 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-7-480",
    "routeNo": "56-F",
    "code": "56/P56F-3",
    "tripCode": "56/P56F-356-FTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "DEIVASEYALPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 AM",
    "endTime": "10:25 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      263,
      265,
      266,
      267,
      268,
      269,
      270
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:19 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:21 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:28 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:30 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:36 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:40 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:44 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "09:46 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "09:53 AM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "09:57 AM",
        "id": 166
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "10:07 AM",
        "id": 263
      },
      {
        "no": 15,
        "name": "ANIYABARANALLUR",
        "time": "10:11 AM",
        "id": 265
      },
      {
        "no": 16,
        "name": "PUDHUPATTI",
        "time": "10:17 AM",
        "id": 266
      },
      {
        "no": 17,
        "name": "CHETTIMALLANPATTI",
        "time": "10:19 AM",
        "id": 267
      },
      {
        "no": 18,
        "name": "RAMANATHAPURAM",
        "time": "10:22 AM",
        "id": 268
      },
      {
        "no": 19,
        "name": "ELLANAICKENPATTI",
        "time": "10:23 AM",
        "id": 269
      },
      {
        "no": 20,
        "name": "DEIVASEYALPURAM",
        "time": "10:25 AM",
        "id": 270
      }
    ]
  },
  {
    "id": "56-F-8-481",
    "routeNo": "56-F",
    "code": "56/P56F-3",
    "tripCode": "56/P56F-356-FTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "DEIVASEYALPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:30 AM",
    "endTime": "11:45 AM",
    "ids": [
      270,
      269,
      268,
      267,
      266,
      265,
      263,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 20,
        "name": "DEIVASEYALPURAM",
        "time": "10:30 AM",
        "id": 270
      },
      {
        "no": 19,
        "name": "ELLANAICKENPATTI",
        "time": "10:31 AM",
        "id": 269
      },
      {
        "no": 18,
        "name": "RAMANATHAPURAM",
        "time": "10:32 AM",
        "id": 268
      },
      {
        "no": 17,
        "name": "CHETTIMALLANPATTI",
        "time": "10:35 AM",
        "id": 267
      },
      {
        "no": 16,
        "name": "PUDHUPATTI",
        "time": "10:38 AM",
        "id": 266
      },
      {
        "no": 15,
        "name": "ANIYABARANALLUR",
        "time": "10:44 AM",
        "id": 265
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "10:48 AM",
        "id": 263
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "10:59 AM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "11:03 AM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "11:11 AM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "11:12 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:17 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:21 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:28 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:30 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:37 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:40 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-9-482",
    "routeNo": "56-F",
    "code": "56/P56F-9",
    "tripCode": "56/P56F-956-FTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI OLD B/S",
    "to": "THOOTHUKUDI NEW B/S",
    "service": "TOWN ORDINARY",
    "startTime": "11:50 AM",
    "endTime": "12:00 PM",
    "ids": [
      1,
      26,
      77
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "11:56 AM",
        "id": 26
      },
      {
        "no": 3,
        "name": "THOOTHUKUDI NEW B/S",
        "time": "12:00 PM",
        "id": 77
      }
    ]
  },
  {
    "id": "56-F-10-483",
    "routeNo": "56-F",
    "code": "56/P56F-9",
    "tripCode": "56/P56F-956-FTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "THOOTHUKUDI NEW B/S",
    "to": "THOOTHUKUDI OLD B/S",
    "service": "TOWN ORDINARY",
    "startTime": "12:20 PM",
    "endTime": "12:30 PM",
    "ids": [
      77,
      26,
      1
    ],
    "stops": [
      {
        "no": 3,
        "name": "THOOTHUKUDI NEW B/S",
        "time": "12:20 PM",
        "id": 77
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "12:23 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-11-484",
    "routeNo": "56-F",
    "code": "56/P56F-1",
    "tripCode": "56/P56F-156-FTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "ADAIKKALAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "12:50 PM",
    "endTime": "01:40 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      263,
      264
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "12:53 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:56 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:01 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:03 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:09 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:12 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:16 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "01:17 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "01:24 PM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "01:27 PM",
        "id": 166
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "01:36 PM",
        "id": 263
      },
      {
        "no": 15,
        "name": "ADAIKKALAPURAM",
        "time": "01:40 PM",
        "id": 264
      }
    ]
  },
  {
    "id": "56-F-12-485",
    "routeNo": "56-F",
    "code": "56/P56F-1",
    "tripCode": "56/P56F-156-FTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "ADAIKKALAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:50 PM",
    "endTime": "02:40 PM",
    "ids": [
      264,
      263,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 15,
        "name": "ADAIKKALAPURAM",
        "time": "01:50 PM",
        "id": 264
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "01:53 PM",
        "id": 263
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "02:02 PM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "02:05 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "02:12 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "02:13 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:17 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:20 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:26 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:28 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:33 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:36 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-13-486",
    "routeNo": "56-F",
    "code": "56/P56F-8",
    "tripCode": "56/P56F-856-FTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "APC COLLEGE",
    "service": "TOWN ORDINARY",
    "startTime": "02:50 PM",
    "endTime": "03:00 PM",
    "ids": [
      1,
      26,
      66,
      219
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "02:53 PM",
        "id": 26
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "02:56 PM",
        "id": 66
      },
      {
        "no": 4,
        "name": "APC COLLEGE",
        "time": "03:00 PM",
        "id": 219
      }
    ]
  },
  {
    "id": "56-F-14-487",
    "routeNo": "56-F",
    "code": "56/P56F-8",
    "tripCode": "56/P56F-856-FTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "APC COLLEGE",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:05 PM",
    "endTime": "03:40 PM",
    "ids": [
      219,
      66,
      26,
      1
    ],
    "stops": [
      {
        "no": 4,
        "name": "APC COLLEGE",
        "time": "03:05 PM",
        "id": 219
      },
      {
        "no": 3,
        "name": "STATE BANK COLONY",
        "time": "03:18 PM",
        "id": 66
      },
      {
        "no": 2,
        "name": "4TH GATE 1",
        "time": "03:27 PM",
        "id": 26
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-15-488",
    "routeNo": "56-F",
    "code": "56/P56F-2",
    "tripCode": "56/P56F-256-FTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUDHUPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "03:50 PM",
    "endTime": "04:50 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      263,
      265,
      266
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:53 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:56 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:02 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:04 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:11 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:14 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "04:18 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "04:20 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "04:27 PM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "04:31 PM",
        "id": 166
      },
      {
        "no": 14,
        "name": "MEENAKSHIPATTI",
        "time": "04:41 PM",
        "id": 263
      },
      {
        "no": 15,
        "name": "ANIYABARANALLUR",
        "time": "04:44 PM",
        "id": 265
      },
      {
        "no": 16,
        "name": "PUDHUPATTI",
        "time": "04:50 PM",
        "id": 266
      }
    ]
  },
  {
    "id": "56-F-16-489",
    "routeNo": "56-F",
    "code": "56/P56F-4",
    "tripCode": "56/P56F-456-FTORD18U16",
    "order": 16,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PEROORANI",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 PM",
    "endTime": "05:05 PM",
    "ids": [
      266,
      265,
      263,
      166,
      167,
      261,
      262,
      24
    ],
    "stops": [
      {
        "no": 1,
        "name": "PUDHUPATTI",
        "time": "05:00 PM",
        "id": 266
      },
      {
        "no": 2,
        "name": "ANIYABARANALLUR",
        "time": "05:00 PM",
        "id": 265
      },
      {
        "no": 3,
        "name": "MEENAKSHIPATTI",
        "time": "05:01 PM",
        "id": 263
      },
      {
        "no": 6,
        "name": "MUDIVAITHANENDAL",
        "time": "05:02 PM",
        "id": 166
      },
      {
        "no": 7,
        "name": "VAGAIKULAM",
        "time": "05:03 PM",
        "id": 167
      },
      {
        "no": 8,
        "name": "VARTHAGAREDDIPATTI",
        "time": "05:03 PM",
        "id": 261
      },
      {
        "no": 9,
        "name": "THIMMARAJAPURAM",
        "time": "05:04 PM",
        "id": 262
      },
      {
        "no": 10,
        "name": "PEROORANI",
        "time": "05:05 PM",
        "id": 24
      }
    ]
  },
  {
    "id": "56-F-17-490",
    "routeNo": "56-F",
    "code": "56/P56F-5",
    "tripCode": "56/P56F-556-FTORD18D17",
    "order": 17,
    "direction": "D",
    "from": "PEROORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:55 PM",
    "endTime": "06:00 PM",
    "ids": [
      24,
      262,
      261,
      167,
      255,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 14,
        "name": "PEROORANI",
        "time": "05:55 PM",
        "id": 24
      },
      {
        "no": 13,
        "name": "THIMMARAJAPURAM",
        "time": "05:55 PM",
        "id": 262
      },
      {
        "no": 12,
        "name": "VARTHAGAREDDIPATTI",
        "time": "05:55 PM",
        "id": 261
      },
      {
        "no": 11,
        "name": "VAGAIKULAM",
        "time": "05:56 PM",
        "id": 167
      },
      {
        "no": 10,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "05:56 PM",
        "id": 255
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "05:56 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "05:57 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:57 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:57 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:58 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:58 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:59 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:59 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-F-18-491",
    "routeNo": "56-F",
    "code": "56/P56F-10",
    "tripCode": "56/P56F-1056-FTORD18U18",
    "order": 18,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "THALAIVANVADALI",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 PM",
    "endTime": "08:45 PM",
    "ids": [
      1,
      41,
      42,
      43,
      44,
      45,
      46,
      127,
      157,
      49,
      50,
      51,
      172,
      129,
      130,
      239
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "06:16 PM",
        "id": 41
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "06:24 PM",
        "id": 42
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "06:36 PM",
        "id": 43
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "06:56 PM",
        "id": 44
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "06:58 PM",
        "id": 45
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "07:06 PM",
        "id": 46
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "07:21 PM",
        "id": 127
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "07:31 PM",
        "id": 157
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "07:45 PM",
        "id": 49
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "08:00 PM",
        "id": 50
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "08:11 PM",
        "id": 51
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "08:19 PM",
        "id": 172
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "08:24 PM",
        "id": 129
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "08:35 PM",
        "id": 130
      },
      {
        "no": 16,
        "name": "THALAIVANVADALI",
        "time": "08:45 PM",
        "id": 239
      }
    ]
  },
  {
    "id": "56-F-19-492",
    "routeNo": "56-F",
    "code": "56/P56F-10",
    "tripCode": "56/P56F-1056-FTORD18D19",
    "order": 19,
    "direction": "D",
    "from": "THALAIVANVADALI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 PM",
    "endTime": "05:30 AM",
    "ids": [
      239,
      130,
      129,
      172,
      51,
      50,
      49,
      157,
      127,
      46,
      45,
      44,
      43,
      42,
      41,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "THALAIVANVADALI",
        "time": "07:30 PM",
        "id": 239
      },
      {
        "no": 15,
        "name": "AYYANKOVIL JUNCTION",
        "time": "08:09 PM",
        "id": 130
      },
      {
        "no": 14,
        "name": "SOUTH AUTHOOR",
        "time": "08:50 PM",
        "id": 129
      },
      {
        "no": 13,
        "name": "AUTHOOR",
        "time": "09:10 PM",
        "id": 172
      },
      {
        "no": 12,
        "name": "MUKKANI",
        "time": "09:42 PM",
        "id": 51
      },
      {
        "no": 11,
        "name": "CHAMBER",
        "time": "10:26 PM",
        "id": 50
      },
      {
        "no": 10,
        "name": "PALAIYA KAYAL",
        "time": "11:29 PM",
        "id": 49
      },
      {
        "no": 9,
        "name": "KOVANKADU",
        "time": "12:24 AM",
        "id": 157
      },
      {
        "no": 8,
        "name": "SOUTHERN SALT",
        "time": "01:03 AM",
        "id": 127
      },
      {
        "no": 7,
        "name": "MULLAKADU",
        "time": "02:03 AM",
        "id": 46
      },
      {
        "no": 6,
        "name": "SPIC NAGAR",
        "time": "02:37 AM",
        "id": 45
      },
      {
        "no": 5,
        "name": "MUTHAIAHPURAM",
        "time": "02:45 AM",
        "id": 44
      },
      {
        "no": 4,
        "name": "UPPATTHU ODAI",
        "time": "04:03 AM",
        "id": 43
      },
      {
        "no": 3,
        "name": "LEVANJIPURAM",
        "time": "04:51 AM",
        "id": 42
      },
      {
        "no": 2,
        "name": "MARKET",
        "time": "05:24 AM",
        "id": 41
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-1-493",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SEBATHAIAHPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "11:15 AM",
    "endTime": "12:30 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      306,
      164,
      291,
      13,
      12
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "11:20 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:23 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:31 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:33 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:42 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:46 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "11:51 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "11:53 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "12:03 PM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "12:07 PM",
        "id": 166
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "12:13 PM",
        "id": 306
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "12:17 PM",
        "id": 164
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "12:21 PM",
        "id": 291
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "12:26 PM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "12:30 PM",
        "id": 12
      }
    ]
  },
  {
    "id": "56-G-2-494",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "SEBATHAIAHPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:35 PM",
    "endTime": "01:40 PM",
    "ids": [
      12,
      13,
      291,
      164,
      306,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "12:35 PM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "12:38 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "12:42 PM",
        "id": 291
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "12:46 PM",
        "id": 164
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "12:49 PM",
        "id": 306
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "12:54 PM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "12:58 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "01:06 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "01:07 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "01:12 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:16 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:23 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:25 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:32 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:35 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-3-495",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SEBATHAIAHPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "01:45 PM",
    "endTime": "02:50 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      306,
      164,
      291,
      13,
      12
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:49 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:52 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:59 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:01 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:08 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:12 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "02:17 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "02:18 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "02:26 PM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "02:30 PM",
        "id": 166
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "02:35 PM",
        "id": 306
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "02:38 PM",
        "id": 164
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "02:42 PM",
        "id": 291
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "02:46 PM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "02:50 PM",
        "id": 12
      }
    ]
  },
  {
    "id": "56-G-4-496",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "SEBATHAIAHPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:55 PM",
    "endTime": "04:00 PM",
    "ids": [
      12,
      13,
      291,
      164,
      306,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "02:55 PM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "02:58 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "03:02 PM",
        "id": 291
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "03:06 PM",
        "id": 164
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "03:09 PM",
        "id": 306
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "03:14 PM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "03:18 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "03:26 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "03:27 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:32 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:36 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:43 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:45 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:52 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:55 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-5-497",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SEBATHAIAHPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:05 PM",
    "endTime": "05:20 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      306,
      164,
      291,
      13,
      12
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:10 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:13 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:21 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:23 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:32 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:36 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "04:41 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "04:43 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "04:53 PM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "04:57 PM",
        "id": 166
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "05:03 PM",
        "id": 306
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "05:07 PM",
        "id": 164
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "05:11 PM",
        "id": 291
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "05:16 PM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "05:20 PM",
        "id": 12
      }
    ]
  },
  {
    "id": "56-G-6-498",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "SEBATHAIAHPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:25 PM",
    "endTime": "06:40 PM",
    "ids": [
      12,
      13,
      291,
      164,
      306,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "05:25 PM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "05:28 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "05:33 PM",
        "id": 291
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "05:37 PM",
        "id": 164
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "05:41 PM",
        "id": 306
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "05:47 PM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "05:51 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "06:01 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:03 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:08 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:12 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:21 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:23 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:31 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:34 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:40 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-7-499",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SEBATHAIAHPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 PM",
    "endTime": "08:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      306,
      164,
      291,
      13,
      12
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:04 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:08 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:15 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:17 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:25 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:29 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:34 PM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "07:36 PM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "07:44 PM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "07:49 PM",
        "id": 166
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "07:54 PM",
        "id": 306
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "07:57 PM",
        "id": 164
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "08:01 PM",
        "id": 291
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "08:06 PM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "08:10 PM",
        "id": 12
      }
    ]
  },
  {
    "id": "56-G-8-500",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "SEBATHAIAHPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 PM",
    "endTime": "09:25 PM",
    "ids": [
      12,
      13,
      291,
      164,
      306,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "08:15 PM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "08:18 PM",
        "id": 13
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "08:23 PM",
        "id": 291
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "08:27 PM",
        "id": 164
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "08:30 PM",
        "id": 306
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "08:35 PM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "08:40 PM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "08:48 PM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:50 PM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:55 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:59 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:07 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:09 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:16 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:20 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-9-501",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SEBATHAIAHPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:30 AM",
    "endTime": "05:30 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      306,
      164,
      291,
      13,
      12
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:34 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:36 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:43 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:45 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:51 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:55 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "04:59 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "05:00 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "05:08 AM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "05:12 AM",
        "id": 166
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "05:16 AM",
        "id": 306
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "05:19 AM",
        "id": 164
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "05:23 AM",
        "id": 291
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "05:26 AM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "05:30 AM",
        "id": 12
      }
    ]
  },
  {
    "id": "56-G-10-502",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "SEBATHAIAHPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:40 AM",
    "endTime": "06:45 AM",
    "ids": [
      12,
      13,
      291,
      164,
      306,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "05:40 AM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "05:43 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "05:47 AM",
        "id": 291
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "05:51 AM",
        "id": 164
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "05:54 AM",
        "id": 306
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "05:59 AM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "06:03 AM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "06:11 AM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "06:12 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:17 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:21 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:28 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:30 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:37 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:40 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-11-503",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SEBATHAIAHPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 AM",
    "endTime": "08:15 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      21,
      255,
      167,
      166,
      306,
      164,
      291,
      13,
      12
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:05 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:08 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:16 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:18 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:27 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:31 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "07:36 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "07:38 AM",
        "id": 255
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "07:48 AM",
        "id": 167
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "07:52 AM",
        "id": 166
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "07:58 AM",
        "id": 306
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "08:02 AM",
        "id": 164
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "08:06 AM",
        "id": 291
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "08:11 AM",
        "id": 13
      },
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "08:15 AM",
        "id": 12
      }
    ]
  },
  {
    "id": "56-G-12-504",
    "routeNo": "56-G",
    "code": "56/P56G-1",
    "tripCode": "56/P56G-156-GTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "SEBATHAIAHPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:22 AM",
    "endTime": "09:30 AM",
    "ids": [
      12,
      13,
      291,
      164,
      306,
      166,
      167,
      255,
      21,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 16,
        "name": "SEBATHAIAHPURAM",
        "time": "08:22 AM",
        "id": 12
      },
      {
        "no": 15,
        "name": "SAWYERPURAM",
        "time": "08:25 AM",
        "id": 13
      },
      {
        "no": 14,
        "name": "KUMARAPURAM 2",
        "time": "08:29 AM",
        "id": 291
      },
      {
        "no": 13,
        "name": "KATTALANKULAM",
        "time": "08:33 AM",
        "id": 164
      },
      {
        "no": 12,
        "name": "PUDHUR 3",
        "time": "08:36 AM",
        "id": 306
      },
      {
        "no": 11,
        "name": "MUDIVAITHANENDAL",
        "time": "08:42 AM",
        "id": 166
      },
      {
        "no": 10,
        "name": "VAGAIKULAM",
        "time": "08:46 AM",
        "id": 167
      },
      {
        "no": 9,
        "name": "RAMACHANDRAPURAM JUNCTION",
        "time": "08:54 AM",
        "id": 255
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "08:56 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:01 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:05 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:12 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:15 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:22 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:25 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "56-G-13-505",
    "routeNo": "56-G",
    "code": "56/P56G-2",
    "tripCode": "56/P56G-256-GTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NORTH SILUKKANPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "09:35 AM",
    "endTime": "10:15 AM",
    "ids": [
      1,
      29,
      39,
      4,
      297,
      235,
      298,
      237,
      238
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:40 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:44 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:53 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "09:58 AM",
        "id": 297
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "10:04 AM",
        "id": 235
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "10:11 AM",
        "id": 298
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "10:13 AM",
        "id": 237
      },
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "10:15 AM",
        "id": 238
      }
    ]
  },
  {
    "id": "56-G-14-506",
    "routeNo": "56-G",
    "code": "56/P56G-2",
    "tripCode": "56/P56G-256-GTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "NORTH SILUKKANPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:20 AM",
    "endTime": "11:00 AM",
    "ids": [
      238,
      237,
      298,
      235,
      297,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "10:20 AM",
        "id": 238
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "10:21 AM",
        "id": 237
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "10:23 AM",
        "id": 298
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "10:30 AM",
        "id": 235
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "10:36 AM",
        "id": 297
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:41 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:50 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:54 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-1-507",
    "routeNo": "57-A",
    "code": "57/P57A-1",
    "tripCode": "57/P57A-157-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SPIC NAGAR",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 AM",
    "endTime": "07:20 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183,
      44,
      45
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "06:22 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "06:28 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:37 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:42 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:46 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:54 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:59 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "07:01 AM",
        "id": 183
      },
      {
        "no": 10,
        "name": "MUTHAIAHPURAM",
        "time": "07:18 AM",
        "id": 44
      },
      {
        "no": 11,
        "name": "SPIC NAGAR",
        "time": "07:20 AM",
        "id": 45
      }
    ]
  },
  {
    "id": "57-A-2-508",
    "routeNo": "57-A",
    "code": "57/P57A-1",
    "tripCode": "57/P57A-157-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "SPIC NAGAR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:25 AM",
    "endTime": "08:00 AM",
    "ids": [
      45,
      44,
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 11,
        "name": "SPIC NAGAR",
        "time": "07:25 AM",
        "id": 45
      },
      {
        "no": 10,
        "name": "MUTHAIAHPURAM",
        "time": "07:25 AM",
        "id": 44
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "07:34 AM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "07:36 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "07:38 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "07:43 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "07:44 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "07:47 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "07:52 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:56 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-3-509",
    "routeNo": "57-A",
    "code": "57/P57A-3",
    "tripCode": "57/P57A-357-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "08:10 AM",
    "endTime": "08:50 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:16 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:21 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:29 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:33 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:36 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:43 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "TTPP",
        "time": "08:43 AM",
        "id": 181
      },
      {
        "no": 9,
        "name": "CHILDREN'S PARK",
        "time": "08:47 AM",
        "id": 182
      },
      {
        "no": 10,
        "name": "CAMP-II",
        "time": "08:50 AM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-4-510",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D4",
    "order": 4,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:00 AM",
    "endTime": "09:35 AM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "09:00 AM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:02 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:05 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:11 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "09:14 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:17 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:24 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:29 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-5-511",
    "routeNo": "57-A",
    "code": "57/P57A-3",
    "tripCode": "57/P57A-357-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 AM",
    "endTime": "10:20 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:46 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:51 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:59 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:03 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:06 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:13 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "TTPP",
        "time": "10:13 AM",
        "id": 181
      },
      {
        "no": 9,
        "name": "CHILDREN'S PARK",
        "time": "10:17 AM",
        "id": 182
      },
      {
        "no": 10,
        "name": "CAMP-II",
        "time": "10:20 AM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-6-512",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:25 AM",
    "endTime": "10:55 AM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "10:25 AM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "10:26 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:29 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:34 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:37 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:40 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "10:46 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:50 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:55 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-7-513",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "11:00 AM",
    "endTime": "11:30 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:00 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "11:04 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "11:08 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "11:14 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "11:17 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "11:20 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "11:25 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "11:28 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "11:30 AM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-8-514",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:35 AM",
    "endTime": "12:05 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "11:35 AM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "11:36 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "11:39 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "11:44 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "11:47 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "11:50 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "11:56 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "12:00 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-9-515",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "12:10 PM",
    "endTime": "12:50 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "12:16 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "12:21 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "12:29 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "12:33 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "12:36 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "12:43 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "12:47 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "12:50 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-10-516",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D10",
    "order": 10,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:55 PM",
    "endTime": "01:35 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "12:55 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "12:57 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "01:01 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "01:08 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "01:11 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "01:15 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "01:23 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "01:28 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-11-517",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "01:40 PM",
    "endTime": "02:15 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "01:45 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "01:50 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "01:57 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "02:00 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "02:03 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "02:09 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "02:12 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "02:15 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-12-518",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D12",
    "order": 12,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:20 PM",
    "endTime": "02:55 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "02:20 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "02:22 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "02:25 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "02:31 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "02:34 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "02:37 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "02:44 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "02:49 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-13-519",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "03:00 PM",
    "endTime": "03:35 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "03:05 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "03:10 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "03:17 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "03:20 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "03:23 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "03:29 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "03:32 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "03:35 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-14-520",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D14",
    "order": 14,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:40 PM",
    "endTime": "04:10 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "03:40 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "03:41 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "03:44 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "03:49 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "03:52 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "03:55 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "04:01 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "04:05 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-15-521",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "04:20 PM",
    "endTime": "05:15 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "04:28 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "04:36 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "04:46 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "04:52 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "04:56 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "05:06 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "05:11 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "05:15 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-16-522",
    "routeNo": "57-A",
    "code": "57/P57A-3",
    "tripCode": "57/P57A-357-ATORD18D16",
    "order": 16,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:20 PM",
    "endTime": "05:55 PM",
    "ids": [
      183,
      182,
      181,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 10,
        "name": "CAMP-II",
        "time": "05:20 PM",
        "id": 183
      },
      {
        "no": 9,
        "name": "CHILDREN'S PARK",
        "time": "05:22 PM",
        "id": 182
      },
      {
        "no": 8,
        "name": "TTPP",
        "time": "05:25 PM",
        "id": 181
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "05:25 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "05:31 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "05:34 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "05:37 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "05:44 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:49 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-17-523",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U17",
    "order": 17,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "06:00 PM",
    "endTime": "06:35 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "06:05 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "06:10 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:17 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:20 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:23 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:29 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:32 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "06:35 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-18-524",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D18",
    "order": 18,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:40 PM",
    "endTime": "07:45 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "06:40 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:43 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:50 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "07:01 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "07:06 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "07:13 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "07:25 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:34 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-19-525",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U19",
    "order": 19,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "07:50 PM",
    "endTime": "08:20 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:54 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "07:58 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:04 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:07 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:10 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:15 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "08:18 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "08:20 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-20-526",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D20",
    "order": 20,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:25 PM",
    "endTime": "08:55 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "08:25 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "08:26 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:29 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:34 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:37 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:40 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:46 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:50 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-A-21-527",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18U21",
    "order": 21,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CAMP-II",
    "service": "TOWN ORDINARY",
    "startTime": "09:00 PM",
    "endTime": "09:35 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      183
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:05 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:10 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:17 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "09:20 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:23 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:29 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:32 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "09:35 PM",
        "id": 183
      }
    ]
  },
  {
    "id": "57-A-22-528",
    "routeNo": "57-A",
    "code": "57/P57A-2",
    "tripCode": "57/P57A-257-ATORD18D22",
    "order": 22,
    "direction": "D",
    "from": "CAMP-II",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 PM",
    "endTime": "10:30 PM",
    "ids": [
      183,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "CAMP-II",
        "time": "09:40 PM",
        "id": 183
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:42 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:47 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:56 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:00 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:05 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "10:15 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:22 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-1-529",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "01:10 PM",
    "endTime": "01:45 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "01:14 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "01:18 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "01:24 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "01:27 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "01:30 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "01:35 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "01:38 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "01:45 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-2-530",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:50 PM",
    "endTime": "02:25 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "01:50 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "01:56 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "01:59 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "02:04 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "02:07 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "02:10 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "02:16 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "02:20 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-3-531",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "02:30 PM",
    "endTime": "03:15 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "02:36 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "02:41 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "02:48 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "02:53 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "02:55 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "03:02 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "03:06 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "03:15 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-4-532",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:20 PM",
    "endTime": "03:50 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "03:20 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "03:25 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "03:28 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "03:32 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "03:34 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "03:37 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "03:42 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "03:45 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "03:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-5-533",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "04:10 PM",
    "endTime": "04:45 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:10 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "04:14 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "04:18 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "04:24 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "04:27 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "04:30 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "04:35 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "04:38 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "04:45 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-6-534",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:50 PM",
    "endTime": "05:25 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "04:50 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "04:56 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "04:59 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "05:04 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "05:07 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "05:10 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "05:16 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:20 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-7-535",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "05:40 PM",
    "endTime": "06:15 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:44 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "05:48 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "05:54 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "05:57 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:00 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:05 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:08 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "06:15 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-8-536",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:20 PM",
    "endTime": "06:55 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "06:20 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:26 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:29 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:34 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:37 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:40 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "06:46 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "06:50 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-9-537",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 PM",
    "endTime": "07:50 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:19 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "07:23 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "07:29 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "07:32 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "07:35 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "07:40 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "07:43 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "07:50 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-10-538",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:55 PM",
    "endTime": "08:30 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "07:55 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "08:01 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:04 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:09 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:12 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:15 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:21 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:25 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-11-539",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "08:35 PM",
    "endTime": "09:10 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:35 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:39 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:43 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:49 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:52 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:55 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:00 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:03 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "09:10 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-12-540",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:15 PM",
    "endTime": "09:45 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "09:15 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:20 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:23 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:27 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "09:29 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:32 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:37 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:40 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-13-541",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "10:00 PM",
    "endTime": "10:30 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:04 PM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "10:07 PM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:12 PM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:15 PM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:17 PM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:21 PM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "10:24 PM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "10:30 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-14-542",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:35 PM",
    "endTime": "11:00 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "10:35 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "10:39 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:41 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:45 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:47 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:49 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "10:53 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "10:56 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:00 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-15-543",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "05:50 AM",
    "endTime": "06:20 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "05:54 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "05:57 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:02 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:05 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:07 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:11 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:14 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "06:20 AM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-16-544",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:25 AM",
    "endTime": "07:00 AM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "06:25 AM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "06:31 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "06:34 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "06:39 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "06:42 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "06:45 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "06:51 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "06:55 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-17-545",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U17",
    "order": 17,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 AM",
    "endTime": "07:50 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:15 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "07:19 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "07:23 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "07:29 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "07:32 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "07:35 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "07:40 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "07:43 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "07:50 AM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-18-546",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D18",
    "order": 18,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:55 AM",
    "endTime": "08:25 AM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "07:55 AM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "08:00 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "08:03 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:07 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:09 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:12 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:17 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:20 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-19-547",
    "routeNo": "57-D",
    "code": "57/P57D-2",
    "tripCode": "57/P57D-257-DTORD18U19",
    "order": 19,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "08:30 AM",
    "endTime": "09:05 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "08:34 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "08:38 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "08:44 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "08:47 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "08:50 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP JUNCTION",
        "time": "08:50 AM",
        "id": 180
      },
      {
        "no": 8,
        "name": "TTPP",
        "time": "08:55 AM",
        "id": 181
      },
      {
        "no": 9,
        "name": "CHILDREN'S PARK",
        "time": "08:58 AM",
        "id": 182
      },
      {
        "no": 10,
        "name": "NEW HARBOUR",
        "time": "09:05 AM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-20-548",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D20",
    "order": 20,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 AM",
    "endTime": "09:45 AM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "09:10 AM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "09:16 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "09:19 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "09:24 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "09:27 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "09:30 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:36 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:40 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-21-549",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U21",
    "order": 21,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 AM",
    "endTime": "10:25 AM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "09:54 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "09:58 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:04 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:07 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:10 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:15 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "10:18 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "10:25 AM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-22-550",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D22",
    "order": 22,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:40 AM",
    "endTime": "11:10 AM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "10:40 AM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "10:45 AM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "10:48 AM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "10:52 AM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "10:54 AM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "10:57 AM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "11:02 AM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "11:05 AM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:10 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "57-D-23-551",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18U23",
    "order": 23,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NEW HARBOUR",
    "service": "TOWN ORDINARY",
    "startTime": "11:25 AM",
    "endTime": "12:00 PM",
    "ids": [
      1,
      28,
      185,
      294,
      293,
      180,
      181,
      182,
      273
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "11:25 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "11:29 AM",
        "id": 28
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "11:33 AM",
        "id": 185
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "11:39 AM",
        "id": 294
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "11:42 AM",
        "id": 293
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "11:45 AM",
        "id": 180
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "11:50 AM",
        "id": 181
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "11:53 AM",
        "id": 182
      },
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "12:00 PM",
        "id": 273
      }
    ]
  },
  {
    "id": "57-D-24-552",
    "routeNo": "57-D",
    "code": "57/P57D-1",
    "tripCode": "57/P57D-157-DTORD18D24",
    "order": 24,
    "direction": "D",
    "from": "NEW HARBOUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:15 PM",
    "endTime": "12:45 PM",
    "ids": [
      273,
      182,
      181,
      180,
      293,
      294,
      185,
      28,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NEW HARBOUR",
        "time": "12:15 PM",
        "id": 273
      },
      {
        "no": 8,
        "name": "CHILDREN'S PARK",
        "time": "12:20 PM",
        "id": 182
      },
      {
        "no": 7,
        "name": "TTPP",
        "time": "12:23 PM",
        "id": 181
      },
      {
        "no": 6,
        "name": "THERMAL NAGAR JUNCTION",
        "time": "12:27 PM",
        "id": 180
      },
      {
        "no": 5,
        "name": "THERMAL NAGAR",
        "time": "12:29 PM",
        "id": 293
      },
      {
        "no": 4,
        "name": "CHEMICAL",
        "time": "12:32 PM",
        "id": 294
      },
      {
        "no": 3,
        "name": "ROCH PARK",
        "time": "12:37 PM",
        "id": 185
      },
      {
        "no": 2,
        "name": "SUB COLLECTOR OFFICE",
        "time": "12:40 PM",
        "id": 28
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-1-553",
    "routeNo": "58-A",
    "code": "58/P58A-1",
    "tripCode": "58/P58A-158-ATORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHETTIYOORANI",
    "service": "TOWN ORDINARY",
    "startTime": "01:20 PM",
    "endTime": "02:30 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      254,
      253
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:26 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:30 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:39 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "01:42 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "01:52 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "01:59 PM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "02:13 PM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "02:21 PM",
        "id": 252
      },
      {
        "no": 12,
        "name": "CAMP THATTAPARAI",
        "time": "02:25 PM",
        "id": 254
      },
      {
        "no": 13,
        "name": "CHETTIYOORANI",
        "time": "02:30 PM",
        "id": 253
      }
    ]
  },
  {
    "id": "58-A-2-554",
    "routeNo": "58-A",
    "code": "58/P58A-1",
    "tripCode": "58/P58A-158-ATORD18D2",
    "order": 2,
    "direction": "D",
    "from": "CHETTIYOORANI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "02:35 PM",
    "endTime": "04:05 PM",
    "ids": [
      253,
      254,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 13,
        "name": "CHETTIYOORANI",
        "time": "02:35 PM",
        "id": 253
      },
      {
        "no": 12,
        "name": "CAMP THATTAPARAI",
        "time": "02:41 PM",
        "id": 254
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "02:46 PM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "02:56 PM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "03:14 PM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:23 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:35 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:39 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:51 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:57 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-3-555",
    "routeNo": "58-A",
    "code": "58/P58A-4",
    "tripCode": "58/P58A-458-ATORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "04:00 PM",
    "endTime": "05:25 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:05 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:08 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:16 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:18 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:27 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "04:31 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:35 PM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "04:41 PM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "04:52 PM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "04:59 PM",
        "id": 252
      },
      {
        "no": 15,
        "name": "UMARIKOTTAI",
        "time": "05:07 PM",
        "id": 274
      },
      {
        "no": 17,
        "name": "VARADHARAJAPURAM",
        "time": "05:14 PM",
        "id": 275
      },
      {
        "no": 19,
        "name": "CHOCKALINGAPURAM",
        "time": "05:25 PM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-A-4-556",
    "routeNo": "58-A",
    "code": "58/P58A-2",
    "tripCode": "58/P58A-258-ATORD18D4",
    "order": 4,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:30 PM",
    "endTime": "07:05 PM",
    "ids": [
      276,
      275,
      274,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "05:30 PM",
        "id": 276
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "05:42 PM",
        "id": 275
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "05:51 PM",
        "id": 274
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "06:01 PM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "06:10 PM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "06:24 PM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:31 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:41 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:44 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:54 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:58 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:05 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-5-557",
    "routeNo": "58-A",
    "code": "58/P58A-6",
    "tripCode": "58/P58A-658-ATORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KALANKARAI",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 PM",
    "endTime": "07:25 PM",
    "ids": [
      1,
      29,
      39,
      4,
      277
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:05 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:09 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:17 PM",
        "id": 4
      },
      {
        "no": 6,
        "name": "KALANKARAI",
        "time": "07:25 PM",
        "id": 277
      }
    ]
  },
  {
    "id": "58-A-6-558",
    "routeNo": "58-A",
    "code": "58/P58A-6",
    "tripCode": "58/P58A-658-ATORD18D6",
    "order": 6,
    "direction": "D",
    "from": "KALANKARAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:30 PM",
    "endTime": "08:10 PM",
    "ids": [
      277,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 6,
        "name": "KALANKARAI",
        "time": "07:30 PM",
        "id": 277
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:41 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:55 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:01 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:10 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-7-559",
    "routeNo": "58-A",
    "code": "58/P58A-2",
    "tripCode": "58/P58A-258-ATORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "08:15 PM",
    "endTime": "06:55 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:15 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:56 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:27 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:33 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "10:53 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:01 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "12:49 AM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "02:24 AM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "03:20 AM",
        "id": 252
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "04:30 AM",
        "id": 274
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "05:30 AM",
        "id": 275
      },
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "06:55 AM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-A-8-560",
    "routeNo": "58-A",
    "code": "58/P58A-2",
    "tripCode": "58/P58A-258-ATORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:00 AM",
    "endTime": "08:25 AM",
    "ids": [
      276,
      275,
      274,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "07:00 AM",
        "id": 276
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "07:11 AM",
        "id": 275
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "07:19 AM",
        "id": 274
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "07:28 AM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "07:35 AM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "07:48 AM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:54 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:03 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:06 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:15 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:19 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:25 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-9-561",
    "routeNo": "58-A",
    "code": "58/P58A-6",
    "tripCode": "58/P58A-658-ATORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "KALANKARAI",
    "service": "TOWN ORDINARY",
    "startTime": "08:30 AM",
    "endTime": "08:55 AM",
    "ids": [
      1,
      29,
      39,
      4,
      277
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "08:30 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:35 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:39 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:47 AM",
        "id": 4
      },
      {
        "no": 6,
        "name": "KALANKARAI",
        "time": "08:55 AM",
        "id": 277
      }
    ]
  },
  {
    "id": "58-A-10-562",
    "routeNo": "58-A",
    "code": "58/P58A-6",
    "tripCode": "58/P58A-658-ATORD18D10",
    "order": 10,
    "direction": "D",
    "from": "KALANKARAI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:00 AM",
    "endTime": "09:35 AM",
    "ids": [
      277,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 6,
        "name": "KALANKARAI",
        "time": "09:00 AM",
        "id": 277
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:10 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:21 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:27 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:35 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-11-563",
    "routeNo": "58-A",
    "code": "58/P58A-5",
    "tripCode": "58/P58A-558-ATORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "SIPCOT",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 AM",
    "endTime": "10:05 AM",
    "ids": [
      1,
      29,
      39,
      78,
      226,
      225
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:46 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:50 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "09:54 AM",
        "id": 78
      },
      {
        "no": 5,
        "name": "MADATTHOOR JUNCTION",
        "time": "09:58 AM",
        "id": 226
      },
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "10:05 AM",
        "id": 225
      }
    ]
  },
  {
    "id": "58-A-12-564",
    "routeNo": "58-A",
    "code": "58/P58A-5",
    "tripCode": "58/P58A-558-ATORD18D12",
    "order": 12,
    "direction": "D",
    "from": "SIPCOT",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:10 AM",
    "endTime": "10:40 AM",
    "ids": [
      225,
      226,
      78,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 6,
        "name": "SIPCOT COMPLEX",
        "time": "10:10 AM",
        "id": 225
      },
      {
        "no": 5,
        "name": "MADATTHOOR JUNCTION",
        "time": "10:17 AM",
        "id": 226
      },
      {
        "no": 4,
        "name": "BYPASS",
        "time": "10:22 AM",
        "id": 78
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:27 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:32 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:40 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-A-13-565",
    "routeNo": "58-A",
    "code": "58/P58A-3",
    "tripCode": "58/P58A-358-ATORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "10:45 AM",
    "endTime": "11:55 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      254,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "10:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "10:49 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:52 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:58 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:00 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:07 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "11:12 AM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "11:22 AM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "11:27 AM",
        "id": 252
      },
      {
        "no": 12,
        "name": "CAMP THATTAPARAI",
        "time": "11:30 AM",
        "id": 254
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "11:33 AM",
        "id": 252
      },
      {
        "no": 15,
        "name": "UMARIKOTTAI",
        "time": "11:40 AM",
        "id": 274
      },
      {
        "no": 17,
        "name": "VARADHARAJAPURAM",
        "time": "11:46 AM",
        "id": 275
      },
      {
        "no": 19,
        "name": "CHOCKALINGAPURAM",
        "time": "11:55 AM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-A-14-566",
    "routeNo": "58-A",
    "code": "58/P58A-3",
    "tripCode": "58/P58A-358-ATORD18D14",
    "order": 14,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "12:00 PM",
    "endTime": "01:15 PM",
    "ids": [
      276,
      275,
      274,
      252,
      254,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "CHOCKALINGAPURAM",
        "time": "12:00 PM",
        "id": 276
      },
      {
        "no": 17,
        "name": "VARADHARAJAPURAM",
        "time": "12:09 PM",
        "id": 275
      },
      {
        "no": 15,
        "name": "UMARIKOTTAI",
        "time": "12:15 PM",
        "id": 274
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "12:23 PM",
        "id": 252
      },
      {
        "no": 12,
        "name": "CAMP THATTAPARAI",
        "time": "12:26 PM",
        "id": 254
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "12:29 PM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "12:35 PM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "12:45 PM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:50 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:57 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:00 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:07 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:10 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-1-567",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NORTH SILUKKANPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "12:30 PM",
    "endTime": "01:00 PM",
    "ids": [
      1,
      29,
      39,
      4,
      297,
      235,
      298,
      237,
      238
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "12:34 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:37 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:43 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "12:47 PM",
        "id": 297
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "12:51 PM",
        "id": 235
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "12:57 PM",
        "id": 298
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "12:58 PM",
        "id": 237
      },
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "01:00 PM",
        "id": 238
      }
    ]
  },
  {
    "id": "58-B-2-568",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "NORTH SILUKKANPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:15 PM",
    "endTime": "01:55 PM",
    "ids": [
      238,
      237,
      298,
      235,
      297,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "01:15 PM",
        "id": 238
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "01:16 PM",
        "id": 237
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "01:18 PM",
        "id": 298
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "01:25 PM",
        "id": 235
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "01:31 PM",
        "id": 297
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:36 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "01:45 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "01:49 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "01:55 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-3-569",
    "routeNo": "58-B",
    "code": "58/P58B-1",
    "tripCode": "58/P58B-158-BTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "02:00 PM",
    "endTime": "03:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:00 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:04 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:07 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:15 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:17 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:24 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "02:30 PM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "02:40 PM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "02:46 PM",
        "id": 252
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "02:54 PM",
        "id": 274
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "03:00 PM",
        "id": 275
      },
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "03:10 PM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-B-4-570",
    "routeNo": "58-B",
    "code": "58/P58B-1",
    "tripCode": "58/P58B-158-BTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "03:15 PM",
    "endTime": "04:35 PM",
    "ids": [
      276,
      275,
      274,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "03:15 PM",
        "id": 276
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "03:25 PM",
        "id": 275
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "03:33 PM",
        "id": 274
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "03:41 PM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "03:48 PM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "04:00 PM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "04:06 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "04:15 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "04:17 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:25 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:29 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:35 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-5-571",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NORTH SILUKKANPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "04:45 PM",
    "endTime": "05:30 PM",
    "ids": [
      1,
      29,
      39,
      4,
      297,
      235,
      298,
      237,
      238
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:45 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "04:51 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "04:55 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:05 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "05:11 PM",
        "id": 297
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "05:17 PM",
        "id": 235
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "05:26 PM",
        "id": 298
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "05:27 PM",
        "id": 237
      },
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "05:30 PM",
        "id": 238
      }
    ]
  },
  {
    "id": "58-B-6-572",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "NORTH SILUKKANPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:35 PM",
    "endTime": "06:30 PM",
    "ids": [
      238,
      237,
      298,
      235,
      297,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "05:35 PM",
        "id": 238
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "05:37 PM",
        "id": 237
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "05:39 PM",
        "id": 298
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "05:49 PM",
        "id": 235
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "05:57 PM",
        "id": 297
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:05 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:16 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:22 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:30 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-7-573",
    "routeNo": "58-B",
    "code": "58/P58B-1",
    "tripCode": "58/P58B-158-BTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "06:40 PM",
    "endTime": "08:00 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:40 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:45 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:49 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:57 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:59 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:08 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "07:14 PM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "07:26 PM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "07:33 PM",
        "id": 252
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "07:41 PM",
        "id": 274
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "07:49 PM",
        "id": 275
      },
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "08:00 PM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-B-8-574",
    "routeNo": "58-B",
    "code": "58/P58B-1",
    "tripCode": "58/P58B-158-BTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 PM",
    "endTime": "09:15 PM",
    "ids": [
      276,
      275,
      274,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "08:05 PM",
        "id": 276
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "08:14 PM",
        "id": 275
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "08:20 PM",
        "id": 274
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "08:28 PM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "08:34 PM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "08:44 PM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:50 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:57 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:59 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:07 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:10 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-9-575",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NORTH SILUKKANPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "09:20 PM",
    "endTime": "09:45 PM",
    "ids": [
      1,
      29,
      39,
      4,
      297,
      235,
      298,
      237,
      238
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:20 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:23 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:25 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:31 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "09:34 PM",
        "id": 297
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "09:38 PM",
        "id": 235
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "09:42 PM",
        "id": 298
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "09:43 PM",
        "id": 237
      },
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "09:45 PM",
        "id": 238
      }
    ]
  },
  {
    "id": "58-B-10-576",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "NORTH SILUKKANPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:50 PM",
    "endTime": "04:55 AM",
    "ids": [
      238,
      237,
      298,
      235,
      297,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "09:50 PM",
        "id": 238
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "10:09 PM",
        "id": 237
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "10:27 PM",
        "id": 298
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "11:44 PM",
        "id": 235
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "12:40 AM",
        "id": 297
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "01:42 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:14 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "03:56 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "04:55 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-11-577",
    "routeNo": "58-B",
    "code": "58/P58B-2",
    "tripCode": "58/P58B-258-BTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "05:00 AM",
    "endTime": "06:10 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      254,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:00 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:04 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:07 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:13 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:15 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:22 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "05:27 AM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "05:37 AM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "05:42 AM",
        "id": 252
      },
      {
        "no": 12,
        "name": "CAMP THATTAPARAI",
        "time": "05:45 AM",
        "id": 254
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "05:48 AM",
        "id": 252
      },
      {
        "no": 15,
        "name": "UMARIKOTTAI",
        "time": "05:55 AM",
        "id": 274
      },
      {
        "no": 17,
        "name": "VARADHARAJAPURAM",
        "time": "06:01 AM",
        "id": 275
      },
      {
        "no": 19,
        "name": "CHOCKALINGAPURAM",
        "time": "06:10 AM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-B-12-578",
    "routeNo": "58-B",
    "code": "58/P58B-2",
    "tripCode": "58/P58B-258-BTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "06:15 AM",
    "endTime": "07:35 AM",
    "ids": [
      276,
      275,
      274,
      252,
      254,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 19,
        "name": "CHOCKALINGAPURAM",
        "time": "06:15 AM",
        "id": 276
      },
      {
        "no": 17,
        "name": "VARADHARAJAPURAM",
        "time": "06:24 AM",
        "id": 275
      },
      {
        "no": 15,
        "name": "UMARIKOTTAI",
        "time": "06:31 AM",
        "id": 274
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "06:39 AM",
        "id": 252
      },
      {
        "no": 12,
        "name": "CAMP THATTAPARAI",
        "time": "06:42 AM",
        "id": 254
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "06:46 AM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "06:52 AM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "07:03 AM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:08 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:16 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:19 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:26 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:30 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:35 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-13-579",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18U13",
    "order": 13,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "NORTH SILUKKANPATTI",
    "service": "TOWN ORDINARY",
    "startTime": "07:45 AM",
    "endTime": "08:20 AM",
    "ids": [
      1,
      29,
      39,
      4,
      297,
      235,
      298,
      237,
      238
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "07:45 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "07:49 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "07:53 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:00 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "08:05 AM",
        "id": 297
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "08:10 AM",
        "id": 235
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "08:16 AM",
        "id": 298
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "08:18 AM",
        "id": 237
      },
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "08:20 AM",
        "id": 238
      }
    ]
  },
  {
    "id": "58-B-14-580",
    "routeNo": "58-B",
    "code": "58/P58B-3",
    "tripCode": "58/P58B-358-BTORD18D14",
    "order": 14,
    "direction": "D",
    "from": "NORTH SILUKKANPATTI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:25 AM",
    "endTime": "09:30 AM",
    "ids": [
      238,
      237,
      298,
      235,
      297,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 9,
        "name": "NORTH SILUKKANPATTI",
        "time": "08:25 AM",
        "id": 238
      },
      {
        "no": 8,
        "name": "MADATTHUPATTI",
        "time": "08:28 AM",
        "id": 237
      },
      {
        "no": 7,
        "name": "MUTHUSAMYPURAM",
        "time": "08:30 AM",
        "id": 298
      },
      {
        "no": 6,
        "name": "RAMANACCHIYARPURAM",
        "time": "08:42 AM",
        "id": 235
      },
      {
        "no": 5,
        "name": "KAILASAPURAM",
        "time": "08:51 AM",
        "id": 297
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:00 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:14 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:21 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-B-15-581",
    "routeNo": "58-B",
    "code": "58/P58B-1",
    "tripCode": "58/P58B-158-BTORD18U15",
    "order": 15,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHOCKALINGAPURAM",
    "service": "TOWN ORDINARY",
    "startTime": "09:40 AM",
    "endTime": "11:00 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      250,
      251,
      252,
      274,
      275,
      276
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:40 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:45 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:49 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:57 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:59 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "10:08 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "10:14 AM",
        "id": 250
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "10:26 AM",
        "id": 251
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "10:33 AM",
        "id": 252
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "10:41 AM",
        "id": 274
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "10:49 AM",
        "id": 275
      },
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "11:00 AM",
        "id": 276
      }
    ]
  },
  {
    "id": "58-B-16-582",
    "routeNo": "58-B",
    "code": "58/P58B-1",
    "tripCode": "58/P58B-158-BTORD18D16",
    "order": 16,
    "direction": "D",
    "from": "CHOCKALINGAPURAM",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "11:10 AM",
    "endTime": "12:15 PM",
    "ids": [
      276,
      275,
      274,
      252,
      251,
      250,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHOCKALINGAPURAM",
        "time": "11:10 AM",
        "id": 276
      },
      {
        "no": 15,
        "name": "VARADHARAJAPURAM",
        "time": "11:18 AM",
        "id": 275
      },
      {
        "no": 13,
        "name": "UMARIKOTTAI",
        "time": "11:24 AM",
        "id": 274
      },
      {
        "no": 11,
        "name": "MELA THATTAPARAI",
        "time": "11:31 AM",
        "id": 252
      },
      {
        "no": 10,
        "name": "KEELA THATTAPARAI",
        "time": "11:37 AM",
        "id": 251
      },
      {
        "no": 7,
        "name": "SILUKKAN PATTI",
        "time": "11:47 AM",
        "id": 250
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:51 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:58 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:00 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:07 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "12:10 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:15 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-C-1-583",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18U1",
    "order": 1,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "12:05 PM",
    "endTime": "01:10 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      254,
      196,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:05 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "12:09 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "12:12 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "12:18 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "12:20 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:27 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:31 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:34 PM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "12:39 PM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "12:49 PM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "12:54 PM",
        "id": 252
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "12:57 PM",
        "id": 254
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "01:07 PM",
        "id": 196
      },
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:10 PM",
        "id": 74
      }
    ]
  },
  {
    "id": "58-C-2-584",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18D2",
    "order": 2,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "01:15 PM",
    "endTime": "02:45 PM",
    "ids": [
      74,
      196,
      254,
      252,
      251,
      250,
      6,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "01:15 PM",
        "id": 74
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "01:18 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "01:32 PM",
        "id": 254
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "01:36 PM",
        "id": 252
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "01:43 PM",
        "id": 251
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "01:57 PM",
        "id": 250
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:03 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "02:08 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "02:13 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "02:23 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "02:25 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "02:35 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:39 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:45 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-C-3-585",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18U3",
    "order": 3,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "02:50 PM",
    "endTime": "04:30 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      254,
      196,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "02:50 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "02:56 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "03:01 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "03:11 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "03:14 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:24 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "03:30 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "03:35 PM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "03:43 PM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "03:57 PM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "04:06 PM",
        "id": 252
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "04:10 PM",
        "id": 254
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "04:26 PM",
        "id": 196
      },
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:30 PM",
        "id": 74
      }
    ]
  },
  {
    "id": "58-C-4-586",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18D4",
    "order": 4,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "04:35 PM",
    "endTime": "05:50 PM",
    "ids": [
      74,
      196,
      254,
      252,
      251,
      250,
      6,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "04:35 PM",
        "id": 74
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "04:37 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "04:49 PM",
        "id": 254
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "04:52 PM",
        "id": 252
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "04:59 PM",
        "id": 251
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "05:10 PM",
        "id": 250
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:15 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "05:19 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "05:23 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "05:31 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "05:34 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "05:41 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:45 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:50 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-C-5-587",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18U5",
    "order": 5,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "05:55 PM",
    "endTime": "07:00 PM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      254,
      196,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "05:55 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "05:59 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:02 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:08 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:10 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:17 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:21 PM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:24 PM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "06:29 PM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "06:39 PM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "06:44 PM",
        "id": 252
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "06:47 PM",
        "id": 254
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "06:57 PM",
        "id": 196
      },
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:00 PM",
        "id": 74
      }
    ]
  },
  {
    "id": "58-C-6-588",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18D6",
    "order": 6,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "07:15 PM",
    "endTime": "09:25 PM",
    "ids": [
      74,
      196,
      254,
      252,
      251,
      250,
      6,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "07:15 PM",
        "id": 74
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "07:19 PM",
        "id": 196
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "07:40 PM",
        "id": 254
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "07:45 PM",
        "id": 252
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "07:56 PM",
        "id": 251
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "08:15 PM",
        "id": 250
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:25 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:32 PM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:39 PM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:53 PM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:57 PM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:10 PM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:16 PM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:25 PM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-C-7-589",
    "routeNo": "58-C",
    "code": "58/P58C-2",
    "tripCode": "58/P58C-258-CTORD18U7",
    "order": 7,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "09:30 PM",
    "endTime": "05:00 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      253,
      254,
      196,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:30 PM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "09:56 PM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "10:16 PM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "10:58 PM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:11 PM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:54 PM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "12:17 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "12:40 AM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "01:10 AM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "02:11 AM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "02:47 AM",
        "id": 252
      },
      {
        "no": 14,
        "name": "CHETTIYOORANI",
        "time": "03:18 AM",
        "id": 253
      },
      {
        "no": 15,
        "name": "CAMP THATTAPARAI",
        "time": "03:39 AM",
        "id": 254
      },
      {
        "no": 17,
        "name": "VALLINAYAGIPURAM",
        "time": "04:45 AM",
        "id": 196
      },
      {
        "no": 18,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:00 AM",
        "id": 74
      }
    ]
  },
  {
    "id": "58-C-8-590",
    "routeNo": "58-C",
    "code": "58/P58C-2",
    "tripCode": "58/P58C-258-CTORD18D8",
    "order": 8,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "05:15 AM",
    "endTime": "06:45 AM",
    "ids": [
      74,
      196,
      254,
      253,
      252,
      251,
      250,
      6,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 18,
        "name": "PUTHIYAMPUTHUR",
        "time": "05:15 AM",
        "id": 74
      },
      {
        "no": 17,
        "name": "VALLINAYAGIPURAM",
        "time": "05:17 AM",
        "id": 196
      },
      {
        "no": 15,
        "name": "CAMP THATTAPARAI",
        "time": "05:31 AM",
        "id": 254
      },
      {
        "no": 14,
        "name": "CHETTIYOORANI",
        "time": "05:35 AM",
        "id": 253
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "05:41 AM",
        "id": 252
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "05:48 AM",
        "id": 251
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "06:00 AM",
        "id": 250
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:06 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "06:11 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "06:16 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "06:24 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "06:27 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:35 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:39 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:45 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-C-9-591",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18U9",
    "order": 9,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "PUTHIYAMPUTHUR",
    "service": "TOWN ORDINARY",
    "startTime": "06:50 AM",
    "endTime": "08:00 AM",
    "ids": [
      1,
      29,
      39,
      4,
      5,
      6,
      278,
      6,
      250,
      251,
      252,
      254,
      196,
      74
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "06:50 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "06:54 AM",
        "id": 29
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "06:57 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "07:04 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "07:07 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:14 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "07:18 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "07:22 AM",
        "id": 6
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "07:27 AM",
        "id": 250
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "07:37 AM",
        "id": 251
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "07:43 AM",
        "id": 252
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "07:46 AM",
        "id": 254
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "07:57 AM",
        "id": 196
      },
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:00 AM",
        "id": 74
      }
    ]
  },
  {
    "id": "58-C-10-592",
    "routeNo": "58-C",
    "code": "58/P58C-1",
    "tripCode": "58/P58C-158-CTORD18D10",
    "order": 10,
    "direction": "D",
    "from": "PUTHIYAMPUTHUR",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "08:05 AM",
    "endTime": "09:00 AM",
    "ids": [
      74,
      196,
      254,
      252,
      251,
      250,
      6,
      278,
      6,
      5,
      4,
      39,
      29,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "PUTHIYAMPUTHUR",
        "time": "08:05 AM",
        "id": 74
      },
      {
        "no": 16,
        "name": "VALLINAYAGIPURAM",
        "time": "08:06 AM",
        "id": 196
      },
      {
        "no": 14,
        "name": "CAMP THATTAPARAI",
        "time": "08:15 AM",
        "id": 254
      },
      {
        "no": 13,
        "name": "MELA THATTAPARAI",
        "time": "08:17 AM",
        "id": 252
      },
      {
        "no": 12,
        "name": "KEELA THATTAPARAI",
        "time": "08:22 AM",
        "id": 251
      },
      {
        "no": 9,
        "name": "SILUKKAN PATTI",
        "time": "08:30 AM",
        "id": 250
      },
      {
        "no": 8,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:34 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "08:37 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "08:40 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "08:46 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "08:48 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "08:53 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "MILLER PURAM",
        "time": "08:56 AM",
        "id": 29
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:00 AM",
        "id": 1
      }
    ]
  },
  {
    "id": "58-C-11-593",
    "routeNo": "58-C",
    "code": "58/P58C-3",
    "tripCode": "58/P58C-358-CTORD18U11",
    "order": 11,
    "direction": "U",
    "from": "THOOTHUKUDI",
    "to": "CHEKKARAKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "09:10 AM",
    "endTime": "10:20 AM",
    "ids": [
      1,
      2,
      39,
      4,
      5,
      6,
      278,
      21,
      241,
      23,
      24,
      243,
      303,
      304,
      244,
      245
    ],
    "stops": [
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "09:10 AM",
        "id": 1
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "09:14 AM",
        "id": 2
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "09:18 AM",
        "id": 39
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "09:25 AM",
        "id": 4
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "09:27 AM",
        "id": 5
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "09:35 AM",
        "id": 6
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "09:39 AM",
        "id": 278
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "09:44 AM",
        "id": 21
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "09:44 AM",
        "id": 241
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "09:54 AM",
        "id": 23
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "09:59 AM",
        "id": 24
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "10:02 AM",
        "id": 243
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "10:07 AM",
        "id": 303
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "10:13 AM",
        "id": 304
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "10:17 AM",
        "id": 244
      },
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "10:20 AM",
        "id": 245
      }
    ]
  },
  {
    "id": "58-C-12-594",
    "routeNo": "58-C",
    "code": "58/P58C-3",
    "tripCode": "58/P58C-358-CTORD18D12",
    "order": 12,
    "direction": "D",
    "from": "CHEKKARAKUDI",
    "to": "THOOTHUKUDI",
    "service": "TOWN ORDINARY",
    "startTime": "10:25 AM",
    "endTime": "12:00 PM",
    "ids": [
      245,
      244,
      304,
      303,
      243,
      24,
      23,
      241,
      21,
      278,
      6,
      5,
      4,
      39,
      2,
      1
    ],
    "stops": [
      {
        "no": 17,
        "name": "CHEKKARAKUDI",
        "time": "10:25 AM",
        "id": 245
      },
      {
        "no": 15,
        "name": "MAHILAMPURAM",
        "time": "10:28 AM",
        "id": 244
      },
      {
        "no": 14,
        "name": "THALAVAIPURAM 2",
        "time": "10:34 AM",
        "id": 304
      },
      {
        "no": 13,
        "name": "PUDHUR 2",
        "time": "10:41 AM",
        "id": 303
      },
      {
        "no": 12,
        "name": "SAMATTHUVAPURAM",
        "time": "10:49 AM",
        "id": 243
      },
      {
        "no": 11,
        "name": "PEROORANI",
        "time": "10:52 AM",
        "id": 24
      },
      {
        "no": 10,
        "name": "THIRUVANANDHA PURAM",
        "time": "10:59 AM",
        "id": 23
      },
      {
        "no": 9,
        "name": "KOOTTUDANKADU",
        "time": "11:13 AM",
        "id": 241
      },
      {
        "no": 8,
        "name": "MANGALAGIRI",
        "time": "11:13 AM",
        "id": 21
      },
      {
        "no": 7,
        "name": "PUDHUKOTTAI 2",
        "time": "11:20 AM",
        "id": 278
      },
      {
        "no": 6,
        "name": "THATTAPARAI JUNCTION",
        "time": "11:25 AM",
        "id": 6
      },
      {
        "no": 5,
        "name": "ANTHONIYARPURAM",
        "time": "11:36 AM",
        "id": 5
      },
      {
        "no": 4,
        "name": "KORAMPALLAM",
        "time": "11:39 AM",
        "id": 4
      },
      {
        "no": 3,
        "name": "3RD MILE",
        "time": "11:49 AM",
        "id": 39
      },
      {
        "no": 2,
        "name": "VOC COLLEGE",
        "time": "11:53 AM",
        "id": 2
      },
      {
        "no": 1,
        "name": "THOOTHUKUDI OLD B/S",
        "time": "12:00 PM",
        "id": 1
      }
    ]
  }
];

const VEHICLES = Object.keys(VEHICLE_ROUTE_MAP);

function normalizeVehicleNo(v) {
  return String(v || "").trim().toUpperCase().replace(/\s+/g, "");
}

function normalizeRouteNo(v) {
  const s = String(v || "").trim().toUpperCase().replace(/\s+/g, "");
  if (!s) return "";
  const detailed = s.match(/^(\d+)\/P\d+([A-Z])-\d+/);
  if (detailed) return `${detailed[1]}-${detailed[2]}`;
  const compact = s.match(/^(\d+)[-/]?([A-Z])$/);
  if (compact) return `${compact[1]}-${compact[2]}`;
  return s;
}

function canonicalRoute(code) {
  return String(code || "").trim().toUpperCase().replace(/\s+/g, "");
}

const ROUTE_NO_BY_CODE = ROUTE_TRIPS.reduce((acc, trip) => {
  if (trip.code && trip.routeNo) acc[trip.code] = trip.routeNo;
  return acc;
}, {});

function routeNoFromRouteCode(code) {
  const raw = String(code || "").trim().toUpperCase().replace(/\s+/g, "");
  if (!raw) return "";
  if (ROUTE_NO_BY_CODE[raw]) return ROUTE_NO_BY_CODE[raw];
  return normalizeRouteNo(raw);
}

function getAssignedRouteValue(vehicleno, assignments = {}) {
  const vehicleNo = normalizeVehicleNo(vehicleno);
  return (
    assignments?.[vehicleNo] ||
    assignments?.[vehicleno] ||
    VEHICLE_ROUTE_MAP[vehicleNo] ||
    ""
  );
}

function getBusRouteNo(vehicleno, assignments = {}) {
  return routeNoFromRouteCode(getAssignedRouteValue(vehicleno, assignments));
}

function getRouteDisplayLabel(routeValue) {
  const routeNo = routeNoFromRouteCode(routeValue);
  const route = ROUTES.find((r) => r.code === routeNo);
  return route?.label || routeNo || "Unassigned";
}

function routeCandidatesForValue(routeValue) {
  const raw = String(routeValue || "").trim().toUpperCase().replace(/\s+/g, "");
  const routeNo = routeNoFromRouteCode(raw);

  const exactCodeMatches = ROUTE_TRIPS.filter((trip) => trip.code === raw);
  if (exactCodeMatches.length) return exactCodeMatches;

  return ROUTE_TRIPS.filter((trip) => trip.routeNo === routeNo);
}

// ---- Leaflet default icon fix ----
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

// ---- Utility helpers ----
const createCustomIcon = (iconUrl, size = [40, 40]) =>
  L.icon({
    iconUrl,
    iconSize: size,
    iconAnchor: [size[0] / 2, size[1]],
    popupAnchor: [0, -size[1] / 2]
  });

const userIconInstance = createCustomIcon(userIcon, [40, 40]);

const toHeading = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? ((n % 360) + 360) % 360 : null;
};

const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

function normalizeLatLng(latValue, lngValue) {
  const lat = toFiniteNumber(latValue);
  const lng = toFiniteNumber(lngValue);
  if (lat === null || lng === null) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

function hasValidLatLng(value) {
  return !!normalizeLatLng(value?.lat, value?.lng);
}

// Exponential smoothing for latitude/longitude
function smoothCoord(prev, next, alpha = SMOOTH_ALPHA) {
  const safeNext = normalizeLatLng(next?.lat, next?.lng);
  if (!safeNext) return normalizeLatLng(prev?.lat, prev?.lng);

  const safePrev = normalizeLatLng(prev?.lat, prev?.lng);
  if (!safePrev) return safeNext;

  return {
    lat: safePrev.lat + alpha * (safeNext.lat - safePrev.lat),
    lng: safePrev.lng + alpha * (safeNext.lng - safePrev.lng)
  };
}



// Circular smoothing for heading (degrees)
function smoothHeading(prevDeg, nextDeg, alpha = HEADING_ALPHA) {
  if (!Number.isFinite(prevDeg)) return nextDeg;
  if (!Number.isFinite(nextDeg)) return prevDeg;
  const p = (prevDeg * Math.PI) / 180;
  const n = (nextDeg * Math.PI) / 180;
  const x = (1 - alpha) * Math.cos(p) + alpha * Math.cos(n);
  const y = (1 - alpha) * Math.sin(p) + alpha * Math.sin(n);
  const ang = (Math.atan2(y, x) * 180) / Math.PI;
  return (((ang % 360) + 360) % 360);
}
function mBetween(a, b) {
  const aa = normalizeLatLng(a?.lat, a?.lng);
  const bb = normalizeLatLng(b?.lat, b?.lng);
  if (!aa || !bb) return Infinity;
  return L.latLng(aa.lat, aa.lng).distanceTo(L.latLng(bb.lat, bb.lng));
}

// ---- Cart classification (case-insensitive "EV") ----
function isCart(vehicleno) {
  const s = String(vehicleno || '').trim();
  return s.toUpperCase().startsWith('EV');
}

// Label: B for Bus, C for Cart
// function vehicleLabel(vehicleno) { return isCart(vehicleno) ? 'C' : 'B'; }
function vehicleLabel(vehicleno, routeCode) {
  if (!isCart(vehicleno)) return "B";

  const rc = canonicalRoute(routeCode || "");
  if (rc === "RP_ED" || rc === "ED_RP") return "CR"; // 👈 cart on RP↔ED
  return "C";
}


// ---- Block IDs starting with a digit ----
function startsWithDigit(vehicleno) { return /^[0-9]/.test(String(vehicleno || '')); }

// ---- Direction pointer “on the circle” DivIcon ----
// function createVehicleDivIcon(label, headingDeg) {
//   const circle = 20;
//   const border = 3;
//   const triH = 18;
//   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
//   const totalH = triH + circle;

//   const html = `
//     <div style="position:relative;width:${circle}px;height:${totalH}px">
//       <div style="
//         position:absolute; left:0; right:0; bottom:0;
//         width:${circle}px; height:${circle}px;
//         border:${border}px solid #0D47A1; background:#ffffff; border-radius:50%;
//         display:flex; align-items:center; justify-content:center;
//         box-shadow:0 2px 8px rgba(0,0,0,0.25);
//         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
//         letter-spacing:0.6px; user-select:none;">
//         <span style="font-size:16px; color:#0D47A1">${label}</span>
//       </div>
//       <div style="
//         position:absolute; left:50%; top:0;
//         transform: translateX(-250%) rotate(${rot}deg);
//         transform-origin: 50% ${triH * 0.7}px;
//         width:0; height:0;
//         border-left:${triH / 4}px solid transparent;
//         border-right:${triH / 4}px solid transparent;
//         border-bottom:${triH}px solid #0D47A1;
//         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
//         z-index: 2; pointer-events: none;"></div>
//     </div>
//   `;

//   return L.divIcon({
//     className: 'veh-div-icon',
//     html,
//     iconSize: [circle, totalH],
//     iconAnchor: [circle / 2, totalH - circle / 2],
//     popupAnchor: [0, -(circle / 2 + triH / 2)]
//   });
// }

function createVehicleDivIcon(label, headingDeg, palette) {
  const circle = 20;
  const border = 3;
  const triH = 18;
  const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
  const totalH = triH + circle;

  // default bus palette
  const p = palette || {
    stroke: "#0D47A1",
    fill: "#ffffff",
    text: "#0D47A1",
    pointer: "#0D47A1",
  };

  const html = `
    <div style="position:relative;width:${circle}px;height:${totalH}px">
      <div style="
        position:absolute; left:0; right:0; bottom:0;
        width:${circle}px; height:${circle}px;
        border:${border}px solid ${p.stroke};
        background:${p.fill};
        border-radius:50%;
        display:flex; align-items:center; justify-content:center;
        box-shadow:0 2px 8px rgba(0,0,0,0.25);
        font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
        letter-spacing:0.6px; user-select:none;">
        <span style="font-size:16px; color:${p.text}">${label}</span>
      </div>
      <div style="
        position:absolute; left:50%; top:0;
        transform: translateX(-250%) rotate(${rot}deg);
        transform-origin: 50% ${triH * 0.7}px;
        width:0; height:0;
        border-left:${triH / 4}px solid transparent;
        border-right:${triH / 4}px solid transparent;
        border-bottom:${triH}px solid ${p.pointer};
        filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
        z-index: 2; pointer-events: none;"></div>
    </div>
  `;

  return L.divIcon({
    className: 'veh-div-icon',
    html,
    iconSize: [circle, totalH],
    iconAnchor: [circle / 2, totalH - circle / 2],
    popupAnchor: [0, -(circle / 2 + triH / 2)]
  });
}

// const BUS_PALETTE = {
//   stroke: "#0D47A1",
//   fill: "#ffffff",
//   text: "#0D47A1",
//   pointer: "#0D47A1",
// };

// const BUS_PALETTE = {
//   stroke: "#EA580C",   // orange bus border
//   fill: "#FFF7ED",     // light orange fill
//   text: "#9A3412",
//   pointer: "#EA580C",
// };

// const CART_PALETTE = {
//   stroke: "#0F766E",  // teal border
//   fill: "#ECFEFF",    // light teal fill
//   text: "#0F766E",
//   pointer: "#0F766E",
// };
const CART_PALETTE = {
  stroke: "#111827",   // near-black border
  fill: "#FEF08A",   // bright yellow fill
  text: "#111827",   // black text
  pointer: "#111827",   // black pointer
};

const BUS_PALETTE = {
  stroke: "#111827",   // near-black border
  fill: "#FEF08A",   // bright yellow fill
  text: "#111827",   // black text
  pointer: "#111827",   // black pointer
};



function matchesFilter(vehicleno, filter, assignments) {
  const cart = isCart(vehicleno);
  if (filter === "cart") return cart;
  if (filter === "bus") return !cart;

  if (filter?.startsWith("route:")) {
    const requested = normalizeRouteNo(filter.slice(6));
    const actualRouteNo = normalizeRouteNo(getBusRouteNo(vehicleno, assignments));
    const assignedRaw = getAssignedRouteValue(vehicleno, assignments);
    const assignedRouteNo = normalizeRouteNo(routeNoFromRouteCode(assignedRaw));

    return actualRouteNo === requested || assignedRouteNo === requested;
  }
  return true;
}

// ---- Filter helper ----
// function matchesFilter(vehicleno, filter, assignments) {
//   const cart = isCart(vehicleno);
//   if (filter === 'cart') return cart;
//   if (filter === 'bus')  return !cart;
//   if (filter?.startsWith('route:')) {
//     const code = filter.slice(6);
//     return assignments[vehicleno] === code;
//   }
//   return true;
// }

// ---------------- Tiny router helpers (for /driver, /driverRoute) ----------------
function usePath() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  const navigate = (p) => { if (p !== window.location.pathname) { window.history.pushState({}, "", p); setPath(p); } };
  return { path, navigate };
}
function getToken() { return localStorage.getItem("driverToken") || ""; }
function setToken(t) { localStorage.setItem("driverToken", t || ""); }
function getUsername() { return localStorage.getItem("driverUsername") || ""; }
function setUsername(u) { localStorage.setItem("driverUsername", u || ""); }

// --- Admin auth helpers (separate from driver) ---
function getAdminToken() {
  return localStorage.getItem("adminToken") || "";
}
function setAdminToken(t) {
  localStorage.setItem("adminToken", t || "");
}


// ---------------- Driver pages ----------------
// --- small responsive hook for narrow phones ---
function useIsNarrow(bp = 380) {
  const [isNarrow, setIsNarrow] = useState(window.innerWidth <= bp);
  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth <= bp);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [bp]);
  return isNarrow;
}

function DriverLogin({ navigate }) {
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const isNarrow = useIsNarrow(380);

  useEffect(() => {
    if (getToken()) navigate("/driverRoute");
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const r = await axios.post(`${BACKEND}/api/driver/login`, { username, password });
      if (r.data?.success && r.data?.token) {
        setToken(r.data.token);
        setUsername(r.data.username);
        navigate("/driverRoute");
      } else setErr("Login failed");
    } catch (e1) {
      setErr(e1?.response?.data?.message || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div
      style={{
        padding: isNarrow ? 12 : 20,
        margin: isNarrow ? "16px auto" : "32px auto",
        width: "min(100vw - 24px, 560px)",
      }}
    >
      {/* Header with Home button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: isNarrow ? 10 : 12,
          marginBottom: isNarrow ? 10 : 14,
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
          <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Driver Login</h2>
        </div>

        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            marginLeft: "auto",
            padding: isNarrow ? "6px 10px" : "8px 12px",
            borderRadius: 10,
            border: "1px solid #D1D5DB",
            background: "#FFFFFF",
            fontWeight: 700,
            fontSize: isNarrow ? 13 : 14,
            cursor: "pointer",
          }}
          title="Go to Home"
        >
          Home
        </button>
      </div>

      {/* Card */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          padding: isNarrow ? 12 : 16,
        }}
      >
        <form onSubmit={onSubmit} style={{ display: "grid", gap: isNarrow ? 8 : 10 }}>
          <input
            value={username}
            onChange={(e) => setU(e.target.value)}
            placeholder="username"
            required
            style={{
              padding: isNarrow ? 10 : 12,
              borderRadius: 10,
              border: "1px solid #D1D5DB",
              fontWeight: 600,
              fontSize: isNarrow ? 14 : 16,
            }}
          />
          <input
            value={password}
            onChange={(e) => setP(e.target.value)}
            placeholder="password"
            type="password"
            required
            style={{
              padding: isNarrow ? 10 : 12,
              borderRadius: 10,
              border: "1px solid #D1D5DB",
              fontWeight: 600,
              fontSize: isNarrow ? 14 : 16,
            }}
          />
          <button
            disabled={busy}
            style={{
              padding: isNarrow ? "10px 12px" : "12px 14px",
              borderRadius: 10,
              border: "1px solid #0D47A1",
              background: "#0D47A1",
              color: "#fff",
              fontWeight: 800,
              cursor: "pointer",
              width: "100%",
              minHeight: 40,
              fontSize: "clamp(14px, 3.5vw, 16px)",
            }}
          >
            {busy ? "Signing in..." : "Login"}
          </button>
          {err && <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>}
        </form>
      </div>
    </div>
  );
}

function DriverRoute({ navigate }) {
  const [routeCode, setRouteCode] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [autoPilot, setAutoPilot] = useState(false); // 👈 NEW: auto-pilot flag
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const isNarrow = useIsNarrow(380);

  useEffect(() => {
    if (!getToken()) navigate("/driver");
    (async () => {
      try {
        const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        const row = r.data?.row;
        if (row) {
          setVehicleNo(row.vehicleNo);
          setRouteCode(row.routeCode);
          setAutoPilot(!!row.autopilotEnabled); // 👈 load auto-pilot state from backend
          setSaved(true);
        }
      } catch { }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await axios.post(
        `${BACKEND}/api/vehicle-route/assign`,
        {
          vehicleNo,
          routeCode,
          active: true,
          autopilotEnabled: autoPilot, // 👈 send auto-pilot choice to backend
        },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setSaved(true);
    } catch (e1) {
      setErr(e1?.response?.data?.message || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        padding: isNarrow ? 16 : 20,
        maxWidth: 640,
        margin: isNarrow ? "16px auto" : "32px auto",
        width: "min(100vw - 24px, 640px)",
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
          <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
        </div>
        <div
          style={{
            marginLeft: 'auto',
            fontWeight: 700,
            opacity: 0.8,
            fontSize: "clamp(13px, 3.2vw, 16px)",
            maxWidth: '60%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={`@${getUsername()}`}
        >
          @{getUsername()}
        </div>
      </div>

      {/* Top-right actions */}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: isNarrow ? '6px 10px' : '8px 12px',
              borderRadius: 10,
              border: '1px solid #D1D5DB',
              background: '#FFFFFF',
              fontWeight: 700,
              fontSize: isNarrow ? 13 : 14,
              cursor: 'pointer'
            }}
            title="Go to Home"
          >
            Home
          </button>
          <button
            type="button"
            onClick={() => setSaved(false)}
            disabled={!saved}
            style={{
              padding: isNarrow ? '6px 10px' : '8px 12px',
              borderRadius: 10,
              border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
              background: saved ? '#fff' : '#F9FAFB',
              color: saved ? '#111' : '#9CA3AF',
              fontWeight: 800,
              fontSize: isNarrow ? 13 : 14,
              cursor: saved ? 'pointer' : 'not-allowed'
            }}
            title="Edit selection"
          >
            Edit
          </button>
        </div>

        <button
          onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
          style={{
            padding: isNarrow ? '6px 10px' : 8,
            borderRadius: 10,
            border: '1px solid #D1D5DB',
            background: '#FFFFFF',
            fontSize: isNarrow ? 13 : 14,
            cursor: 'pointer'
          }}
          title="Logout"
        >
          Logout
        </button>
      </div>

      <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
        <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
        <select
          disabled={saved}
          value={routeCode}
          onChange={e => setRouteCode(e.target.value)}
          required
          style={{
            padding: isNarrow ? 10 : 12,
            borderRadius: 10,
            border: '1px solid #D1D5DB',
            fontSize: isNarrow ? 14 : 16
          }}
        >
          <option value="">Select route…</option>
          {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
        </select>

        <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
        <select
          disabled={saved}
          value={vehicleNo}
          onChange={e => setVehicleNo(e.target.value)}
          required
          style={{
            padding: isNarrow ? 10 : 12,
            borderRadius: 10,
            border: '1px solid #D1D5DB',
            fontSize: isNarrow ? 14 : 16
          }}
        >
          <option value="">Select vehicle…</option>
          {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
        </select>

        {/* 👇 NEW: Auto-pilot toggle */}
        <div
          style={{
            marginTop: isNarrow ? 6 : 8,
            padding: isNarrow ? 8 : 10,
            borderRadius: 10,
            border: '1px solid #E5E7EB',
            background: '#F9FAFB',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
          }}
        >
          <input
            id="autoPilot"
            type="checkbox"
            checked={autoPilot}
            disabled={saved}
            onChange={(e) => setAutoPilot(e.target.checked)}
            style={{ marginTop: 3, cursor: saved ? 'default' : 'pointer' }}
          />
          <label
            htmlFor="autoPilot"
            style={{ cursor: saved ? 'default' : 'pointer' }}
          >
            <div style={{ fontWeight: 700, fontSize: isNarrow ? 14 : 15 }}>
              Auto-pilot (auto reverse at destination)
            </div>
            <div
              style={{
                fontSize: isNarrow ? 12 : 13,
                color: '#6B7280',
                marginTop: 2,
              }}
            >
              When enabled, once you reach the last stop of this route, your
              assignment will automatically switch to the return leg.
            </div>
          </label>
        </div>

        <button
          disabled={busy || saved}
          style={{
            padding: isNarrow ? '10px 12px' : '12px 14px',
            borderRadius: 10,
            border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
            background: busy || saved ? '#F3F4F6' : '#0D47A1',
            color: busy || saved ? '#6B7280' : '#fff',
            fontWeight: 800,
            cursor: busy || saved ? 'not-allowed' : 'pointer',
            minHeight: 44,
            fontSize: "clamp(14px, 3.5vw, 16px)"
          }}
          title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
        >
          {busy ? "Saving…" : saved ? "Saved" : "Save"}
        </button>

        {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
      </form>
    </div>
  );
}


// function DriverRoute({ navigate }) {
//   const [routeCode, setRouteCode] = useState("");
//   const [vehicleNo, setVehicleNo] = useState("");
//   const [saved, setSaved] = useState(false);
//   const [busy, setBusy] = useState(false);
//   const [err, setErr] = useState("");
//   const isNarrow = useIsNarrow(380);

//   useEffect(() => {
//     if (!getToken()) navigate("/driver");
//     (async () => {
//       try {
//         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
//           headers: { Authorization: `Bearer ${getToken()}` },
//         });
//         const row = r.data?.row;
//         if (row) { setVehicleNo(row.vehicleNo); setRouteCode(row.routeCode); setSaved(true); }
//       } catch {}
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const onSave = async (e) => {
//     e.preventDefault();
//     setErr(""); setBusy(true);
//     try {
//       await axios.post(
//         `${BACKEND}/api/vehicle-route/assign`,
//         { vehicleNo, routeCode, active: true },
//         { headers: { Authorization: `Bearer ${getToken()}` } }
//       );
//       setSaved(true);
//     } catch (e1) {
//       setErr(e1?.response?.data?.message || "Save failed");
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: isNarrow ? 16 : 20,
//         maxWidth: 640,
//         margin: isNarrow ? "16px auto" : "32px auto",
//         width: "min(100vw - 24px, 640px)",
//       }}
//     >
//       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
//           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
//         </div>
//         <div
//           style={{
//             marginLeft: 'auto',
//             fontWeight: 700,
//             opacity: 0.8,
//             fontSize: "clamp(13px, 3.2vw, 16px)",
//             maxWidth: '60%',
//             overflow: 'hidden',
//             textOverflow: 'ellipsis',
//             whiteSpace: 'nowrap',
//           }}
//           title={`@${getUsername()}`}
//         >
//           @{getUsername()}
//         </div>
//       </div>

//       {/* Top-right actions */}
//       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
//         <div style={{ display: 'flex', gap: 8 }}>
//           <button
//             onClick={() => navigate('/')}
//             style={{
//               padding: isNarrow ? '6px 10px' : '8px 12px',
//               borderRadius: 10,
//               border: '1px solid #D1D5DB',
//               background: '#FFFFFF',
//               fontWeight: 700,
//               fontSize: isNarrow ? 13 : 14,
//               cursor: 'pointer'
//             }}
//             title="Go to Home"
//           >
//             Home
//           </button>
//           <button
//             type="button"
//             onClick={() => setSaved(false)}
//             disabled={!saved}
//             style={{
//               padding: isNarrow ? '6px 10px' : '8px 12px',
//               borderRadius: 10,
//               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
//               background: saved ? '#fff' : '#F9FAFB',
//               color: saved ? '#111' : '#9CA3AF',
//               fontWeight: 800,
//               fontSize: isNarrow ? 13 : 14,
//               cursor: saved ? 'pointer' : 'not-allowed'
//             }}
//             title="Edit selection"
//           >
//             Edit
//           </button>
//         </div>

//         <button
//           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
//           style={{
//             padding: isNarrow ? '6px 10px' : 8,
//             borderRadius: 10,
//             border: '1px solid #D1D5DB',
//             background: '#FFFFFF',
//             fontSize: isNarrow ? 13 : 14,
//             cursor: 'pointer'
//           }}
//           title="Logout"
//         >
//           Logout
//         </button>
//       </div>

//       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
//         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
//         <select
//           disabled={saved}
//           value={routeCode}
//           onChange={e=>setRouteCode(e.target.value)}
//           required
//           style={{
//             padding: isNarrow ? 10 : 12,
//             borderRadius: 10,
//             border: '1px solid #D1D5DB',
//             fontSize: isNarrow ? 14 : 16
//           }}
//         >
//           <option value="">Select route…</option>
//           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
//         </select>

//         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
//         <select
//           disabled={saved}
//           value={vehicleNo}
//           onChange={e=>setVehicleNo(e.target.value)}
//           required
//           style={{
//             padding: isNarrow ? 10 : 12,
//             borderRadius: 10,
//             border: '1px solid #D1D5DB',
//             fontSize: isNarrow ? 14 : 16
//           }}
//         >
//           <option value="">Select vehicle…</option>
//           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>

//         <button
//           disabled={busy || saved}
//           style={{
//             padding: isNarrow ? '10px 12px' : '12px 14px',
//             borderRadius: 10,
//             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
//             background: busy || saved ? '#F3F4F6' : '#0D47A1',
//             color: busy || saved ? '#6B7280' : '#fff',
//             fontWeight: 800,
//             cursor: busy || saved ? 'not-allowed' : 'pointer',
//             minHeight: 44,
//             fontSize: "clamp(14px, 3.5vw, 16px)"
//           }}
//           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
//         >
//           {busy ? "Saving…" : saved ? "Saved" : "Save"}
//         </button>

//         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
//       </form>
//     </div>
//   );
// }

/* ---------------------------- ADMIN PAGES ---------------------------- */

function AdminLogin({ navigate }) {
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const isNarrow = useIsNarrow(380);

  useEffect(() => {
    if (getAdminToken()) navigate("/admin");
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const r = await axios.post(`${BACKEND}/api/admin/login`, {
        username,
        password,
      });
      if (r.data?.success && r.data?.token) {
        setAdminToken(r.data.token);
        navigate("/admin");
      } else {
        setErr("Login failed");
      }
    } catch (e1) {
      setErr(e1?.response?.data?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        padding: isNarrow ? 12 : 20,
        margin: isNarrow ? "16px auto" : "32px auto",
        width: "min(100vw - 24px, 560px)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: isNarrow ? 10 : 12,
          marginBottom: isNarrow ? 10 : 14,
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={iitmLogo}
            alt="IITM"
            style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }}
          />
          <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Admin Login</h2>
        </div>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            marginLeft: "auto",
            padding: isNarrow ? "6px 10px" : "8px 12px",
            borderRadius: 10,
            border: "1px solid #D1D5DB",
            background: "#FFFFFF",
            fontWeight: 700,
            fontSize: isNarrow ? 13 : 14,
            cursor: "pointer",
          }}
          title="Go to Home"
        >
          Home
        </button>
      </div>
      <div
        style={{
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          padding: isNarrow ? 12 : 16,
        }}
      >
        <form
          onSubmit={onSubmit}
          style={{ display: "grid", gap: isNarrow ? 8 : 10 }}
        >
          <input
            value={username}
            onChange={(e) => setU(e.target.value)}
            placeholder="admin username"
            required
            style={{
              padding: isNarrow ? 10 : 12,
              borderRadius: 10,
              border: "1px solid #D1D5DB",
              fontWeight: 600,
              fontSize: isNarrow ? 14 : 16,
            }}
          />
          <input
            value={password}
            onChange={(e) => setP(e.target.value)}
            placeholder="admin password"
            type="password"
            required
            style={{
              padding: isNarrow ? 10 : 12,
              borderRadius: 10,
              border: "1px solid #D1D5DB",
              fontWeight: 600,
              fontSize: isNarrow ? 14 : 16,
            }}
          />
          <button
            disabled={busy}
            style={{
              padding: isNarrow ? "10px 12px" : "12px 14px",
              borderRadius: 10,
              border: "1px solid #0D47A1",
              background: "#0D47A1",
              color: "#fff",
              fontWeight: 800,
              cursor: "pointer",
              width: "100%",
              minHeight: 40,
              fontSize: "clamp(14px, 3.5vw, 16px)",
            }}
          >
            {busy ? "Signing in..." : "Login"}
          </button>
          {err && (
            <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>
          )}
        </form>
      </div>
    </div>
  );
}

function AdminDashboard({ navigate }) {
  const [tab, setTab] = useState("drivers"); // 'drivers' | 'routes' | 'live'
  const [drivers, setDrivers] = useState([]);
  const [assignments, setAssignments] = useState({}); // vehicleNo -> row
  const [localAssign, setLocalAssign] = useState({}); // vehicleNo -> { routeCode, driverId, autopilotEnabled }
  const [editing, setEditing] = useState({}); // vehicleNo -> true when row is in edit mode
  const [newName, setNewName] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [err, setErr] = useState("");
  const [busySave, setBusySave] = useState(null); // vehicleno while saving
  const [liveBuses, setLiveBuses] = useState([]);
  const adminToken = getAdminToken();
  const isNarrow = useIsNarrow(480);

  useEffect(() => {
    if (!adminToken) navigate("/admin/login");
  }, [adminToken, navigate]);

  const authHeader = useMemo(
    () => ({
      headers: { Authorization: `Bearer ${adminToken}` },
    }),
    [adminToken]
  );

  async function loadDrivers() {
    try {
      const r = await axios.get(`${BACKEND}/api/admin/drivers`, authHeader);
      setDrivers(r.data?.drivers || []);
    } catch (e) {
      console.warn("loadDrivers error", e?.message || e);
    }
  }

  async function loadAssignments() {
    try {
      const r = await axios.get(`${BACKEND}/api/admin/assignments`, authHeader);
      const rows = r.data?.rows || [];
      const map = {};
      for (const row of rows) {
        map[row.vehicleNo] = row;
      }
      setAssignments(map);
      // whenever we reload from backend, treat all as "saved" (not editing)
      setEditing({});
      setLocalAssign({});
    } catch (e) {
      console.warn("loadAssignments error", e?.message || e);
    }
  }

  useEffect(() => {
    if (!adminToken) return;
    loadDrivers();
    loadAssignments();
  }, [adminToken]); // eslint-disable-line react-hooks/exhaustive-deps

  // live tracking (simple polling)
  useEffect(() => {
    if (tab !== "live") return;
    let cancelled = false;

    async function loadLive() {
      try {
        const r = await axios.get(`${BACKEND}/api/vehicle-data`, {
          timeout: 8000,
        });
        if (!cancelled) {
          const arr = Array.isArray(r.data) ? r.data : [];
          setLiveBuses(arr);
        }
      } catch (e) {
        if (!cancelled) {
          console.warn("admin live map error", e?.message || e);
        }
      }
    }
    loadLive();
    const id = setInterval(loadLive, 5000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [tab]);

  const handleAddDriver = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const r = await axios.post(
        `${BACKEND}/api/admin/drivers`,
        { name: newName, phoneNumber: newPhone },
        authHeader
      );
      if (r.data?.success && r.data?.driver) {
        setDrivers((prev) => [...prev, r.data.driver]);
        setNewName("");
        setNewPhone("");
      } else {
        setErr("Failed to create driver");
      }
    } catch (e1) {
      setErr(e1?.response?.data?.message || "Failed to create driver");
    }
  };

  const handleRemoveDriver = async (id) => {
    if (!window.confirm("Remove this driver?")) return;
    try {
      await axios.delete(`${BACKEND}/api/admin/drivers/${id}`, authHeader);
      setDrivers((prev) => prev.filter((d) => d._id !== id));
      // Note: assignments that still reference this driver will continue to exist until reassigned
    } catch (e1) {
      alert(e1?.response?.data?.message || "Failed to remove driver");
    }
  };

  function getBaseAssignForVehicle(veh) {
    const row = assignments[veh];
    if (!row) {
      return {
        vehicleNo: veh,
        routeCode: "",
        driverId: "",
        autopilotEnabled: false,
      };
    }
    return {
      vehicleNo: veh,
      routeCode: row.routeCode || "",
      driverId: row.driver?._id || "",
      autopilotEnabled: !!row.autopilotEnabled,
    };
  }

  function updateLocalAssign(veh, patch) {
    setLocalAssign((prev) => ({
      ...prev,
      [veh]: { ...getBaseAssignForVehicle(veh), ...(prev[veh] || {}), ...patch },
    }));
  }

  const handleSaveAssignment = async (veh) => {
    const base = getBaseAssignForVehicle(veh);
    const row = localAssign[veh] || base;
    const hasAssignment = !!assignments[veh]; // vehicle currently has an active route?

    // RESET error first
    setErr("");

    // ---- CASE 1: Admin cleared both fields and there *was* an assignment -> CLEAR MODE ----
    if (!row.routeCode && !row.driverId && hasAssignment) {
      setBusySave(veh);
      try {
        await axios.post(
          `${BACKEND}/api/admin/vehicle-assign`,
          {
            vehicleNo: row.vehicleNo,
            clear: true,              // 👈 tells backend: deactivate assignment
          },
          authHeader
        );
        await loadAssignments();      // refresh table
        setEditing((prev) => ({ ...prev, [veh]: false }));
      } catch (e1) {
        setErr(e1?.response?.data?.message || "Failed to clear assignment");
      } finally {
        setBusySave(null);
      }
      return;
    }

    // ---- CASE 2: No assignment and still empty -> nothing to save ----
    if (!row.routeCode || !row.driverId) {
      setErr("Select both Route & Driver, or leave the row as-is.");
      return;
    }

    // ---- CASE 3: Normal ASSIGN / UPDATE ----
    setBusySave(veh);
    try {
      await axios.post(
        `${BACKEND}/api/admin/vehicle-assign`,
        {
          vehicleNo: row.vehicleNo,
          routeCode: row.routeCode,
          driverId: row.driverId,
          autopilotEnabled: !!row.autopilotEnabled,
        },
        authHeader
      );
      await loadAssignments();
      setEditing((prev) => ({ ...prev, [veh]: false }));
    } catch (e1) {
      setErr(e1?.response?.data?.message || "Failed to save assignment");
    } finally {
      setBusySave(null);
    }
  };


  const onLogout = () => {
    setAdminToken("");
    navigate("/admin/login");
  };

  // simple driver lookup for live map
  const driverByVehicle = useMemo(() => {
    const out = {};
    Object.values(assignments).forEach((row) => {
      if (row.vehicleNo && row.driver) {
        out[row.vehicleNo] = row.driver;
      }
    });
    return out;
  }, [assignments]);

  return (
    <div className="admin-layout">
      {/* left sidebar */}
      <div
        className="sidebar"
        style={{
          width: isNarrow ? 220 : 260, // responsive width override
        }}
      >
        {/* top section: logo, back button, nav */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img
              src={iitmLogo}
              alt="IITM"
              style={{ width: 32, height: 32, borderRadius: 8 }}
            />
            <div>
              <div style={{ fontWeight: 800, fontSize: 16 }}>Admin</div>
              <div style={{ fontSize: 12, opacity: 0.8 }}>Thoothukudi Bus Tracking</div>
            </div>
          </div>
          <button
            onClick={() => navigate("/")}
            style={{
              marginTop: 8,
              textAlign: "left",
              padding: "6px 10px",
              borderRadius: 10,
              border: "1px solid #4b5563",
              background: "transparent",
              color: "#e5e7eb",
              cursor: "pointer",
              fontSize: 13,
            }}
          >
            ← Back to map
          </button>
          <div
            style={{
              marginTop: 16,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            <button
              onClick={() => setTab("drivers")}
              style={{
                textAlign: "left",
                padding: "8px 10px",
                borderRadius: 10,
                border: "none",
                background: tab === "drivers" ? "#f9fafb" : "transparent",
                color: tab === "drivers" ? "#111827" : "#e5e7eb",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              + Add Driver
            </button>
            <button
              onClick={() => setTab("routes")}
              style={{
                textAlign: "left",
                padding: "8px 10px",
                borderRadius: 10,
                border: "none",
                background: tab === "routes" ? "#f9fafb" : "transparent",
                color: tab === "routes" ? "#111827" : "#e5e7eb",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Route Allocation
            </button>
            <button
              onClick={() => setTab("live")}
              style={{
                textAlign: "left",
                padding: "8px 10px",
                borderRadius: 10,
                border: "none",
                background: tab === "live" ? "#f9fafb" : "transparent",
                color: tab === "live" ? "#111827" : "#e5e7eb",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Live Tracking
            </button>
          </div>
        </div>

        {/* bottom logout – pinned to sidebar bottom */}
        <button
          onClick={onLogout}
          style={{
            marginTop: 12,
            padding: "8px 10px",
            borderRadius: 10,
            border: "1px solid #6b7280",
            background: "transparent",
            color: "#e5e7eb",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Logout
        </button>
      </div>

      {/* main content */}
      <div className="content">
        {tab === "drivers" && (
          <div style={{ maxWidth: 800, margin: "0 auto" }}>
            <h2 style={{ marginTop: 0 }}>Drivers</h2>
            <form
              onSubmit={handleAddDriver}
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 2fr auto",
                gap: 8,
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <input
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Driver name"
                required
                style={{
                  padding: 10,
                  borderRadius: 10,
                  border: "1px solid #D1D5DB",
                  fontSize: 14,
                }}
              />
              <input
                value={newPhone}
                onChange={(e) => setNewPhone(e.target.value)}
                placeholder="Phone number (unique)"
                required
                style={{
                  padding: 10,
                  borderRadius: 10,
                  border: "1px solid #D1D5DB",
                  fontSize: 14,
                }}
              />
              <button
                type="submit"
                style={{
                  padding: "10px 16px",
                  borderRadius: 10,
                  border: "1px solid #0D47A1",
                  background: "#0D47A1",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: "pointer",
                  fontSize: 14,
                }}
              >
                Add
              </button>
            </form>
            {err && (
              <div
                style={{
                  color: "#b00020",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                {err}
              </div>
            )}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                gap: 12,
              }}
            >
              {drivers.map((d) => (
                <div
                  key={d._id}
                  style={{
                    background: "#fff",
                    borderRadius: 12,
                    border: "1px solid #e5e7eb",
                    padding: 12,
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{d.name}</div>
                  <div style={{ fontSize: 13, opacity: 0.8 }}>
                    Phone: {d.phoneNumber || "—"}
                  </div>
                  <div style={{ fontSize: 12, opacity: 0.6 }}>
                    username: <code>{d.username}</code>
                  </div>
                  <button
                    onClick={() => handleRemoveDriver(d._id)}
                    style={{
                      marginTop: 8,
                      alignSelf: "flex-start",
                      padding: "6px 10px",
                      borderRadius: 8,
                      border: "1px solid #f97373",
                      background: "#fef2f2",
                      color: "#b91c1c",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    Remove
                  </button>
                </div>
              ))}
              {drivers.length === 0 && (
                <div style={{ fontSize: 14, opacity: 0.7 }}>
                  No drivers yet. Add your first driver above.
                </div>
              )}
            </div>
          </div>
        )}

        {tab === "routes" && (
          <div className="admin-route-panel" style={{ maxWidth: 1180, margin: "0 auto" }}>
            <div className="admin-section-header">
              <div>
                <h2 style={{ margin: 0 }}>Route Allocation</h2>
                <p>Assign each vehicle to a route and driver. Auto-pilot controls have been removed from this screen.</p>
              </div>
              <button
                type="button"
                onClick={loadAssignments}
                className="admin-secondary-button"
              >
                Refresh
              </button>
            </div>
            {err && (
              <div
                style={{
                  color: "#b00020",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                {err}
              </div>
            )}
            <div className="admin-table-card">
              <table className="admin-route-table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  background: "#fff",
                  borderRadius: 12,
                  overflow: "hidden",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "#f9fafb",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <th style={{ padding: 8, textAlign: "left" }}>#</th>
                    <th style={{ padding: 8, textAlign: "left" }}>Vehicle</th>
                    <th style={{ padding: 8, textAlign: "left" }}>Route</th>
                    <th style={{ padding: 8, textAlign: "left" }}>Driver</th>
                    <th style={{ padding: 8, textAlign: "left" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {VEHICLES.map((veh, idx) => {
                    const base = getBaseAssignForVehicle(veh);
                    const local = localAssign[veh] || base;
                    const hasAssignment =
                      !!base.routeCode && !!base.driverId; // existing saved row?
                    const isEditing = !!editing[veh];
                    const locked = hasAssignment && !isEditing;
                    const saving = busySave === veh;

                    return (
                      <tr
                        key={veh}
                        style={{ borderBottom: "1px solid #f3f4f6" }}
                      >
                        <td style={{ padding: 8 }}>{idx + 1}</td>
                        <td style={{ padding: 8, fontWeight: 600 }}>{veh}</td>
                        <td style={{ padding: 8 }}>
                          <select
                            value={local.routeCode}
                            onChange={(e) =>
                              updateLocalAssign(veh, {
                                routeCode: e.target.value,
                              })
                            }
                            disabled={locked || saving}
                            style={{
                              padding: 8,
                              borderRadius: 8,
                              border: "1px solid #d1d5db",
                              fontSize: 13,
                              minWidth: 220,
                              width: "100%",
                              color: "#111827",
                              backgroundColor: locked ? "#f9fafb" : "white",
                            }}
                          >
                            <option value="">Select route…</option>
                            {ADMIN_ROUTES.map((r) => (
                              <option key={r.code} value={r.code}>
                                {r.label}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td style={{ padding: 8 }}>
                          <select
                            value={local.driverId}
                            onChange={(e) =>
                              updateLocalAssign(veh, {
                                driverId: e.target.value,
                              })
                            }
                            disabled={locked || saving}
                            style={{
                              padding: 8,
                              borderRadius: 8,
                              border: "1px solid #d1d5db",
                              fontSize: 13,
                              minWidth: 220,
                              width: "100%",
                              color: "#111827",
                              backgroundColor: locked ? "#f9fafb" : "white",
                            }}
                          >
                            <option value="">Select driver…</option>
                            {drivers.map((d) => (
                              <option key={d._id} value={d._id}>
                                {d.name} ({d.phoneNumber || d.username})
                              </option>
                            ))}
                          </select>
                        </td>
                        <td style={{ padding: 8 }}>
                          <button
                            onClick={() => {
                              if (locked) {
                                // switch to edit mode
                                updateLocalAssign(veh, {}); // ensure local copy
                                setEditing((prev) => ({
                                  ...prev,
                                  [veh]: true,
                                }));
                              } else {
                                // save current data
                                handleSaveAssignment(veh);
                              }
                            }}
                            disabled={saving}
                            style={{
                              padding: "6px 12px",
                              borderRadius: 8,
                              border: "1px solid #0D47A1",
                              background: saving
                                ? "#e5e7eb"
                                : locked
                                  ? "#0D47A1"
                                  : "#0D47A1",
                              color: saving ? "#4b5563" : "#fff",
                              fontSize: 13,
                              fontWeight: 700,
                              cursor: saving ? "not-allowed" : "pointer",
                            }}
                          >
                            {saving
                              ? "Saving…"
                              : locked
                                ? "Edit"
                                : "Save"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === "live" && (
          <div style={{ height: "calc(100vh - 40px)" }}>
            <h2 style={{ marginTop: 0 }}>Live Tracking</h2>
            <div style={{ height: "calc(100% - 36px)" }}>
              <MapContainer
                center={center}
                zoom={DEFAULT_ZOOM}
                maxZoom={22}
                style={{ width: "100%", height: "100%" }}
              >
                <TileLayer
                  attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  maxNativeZoom={19}
                  maxZoom={22}
                />
                {liveBuses.map((bus) => {
                  // const label = vehicleLabel(bus.vehicleno);
                  const rc = assignments[bus.vehicleno]?.routeCode;   // admin assignments map is row objects
                  const label = vehicleLabel(bus.vehicleno, rc);
                  const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
                  const drv = driverByVehicle[bus.vehicleno];
                  return (
                    <Marker
                      key={bus.vehicleno}
                      position={{
                        lat: bus.latitude,
                        lng: bus.longitude,
                      }}
                      // icon={createVehicleDivIcon(
                      //   label,
                      //   Number(bus.heading) || 0
                      // )}
                      icon={createVehicleDivIcon(label, Number(bus.heading) || 0, palette)}
                    >
                      <Popup>
                        <div className="info-window">
                          <h4>
                            {bus.vehicleno} ({label})
                          </h4>
                          <p>
                            <strong>Speed:</strong>{" "}
                            {Number.isFinite(bus.speed)
                              ? bus.speed.toFixed(1)
                              : "N/A"}{" "}
                            km/h
                          </p>
                          {drv && (
                            <>
                              <p>
                                <strong>Driver:</strong> {drv.name}</p>
                              <p>
                                <strong>Phone:</strong>{" "}
                                {drv.phoneNumber || "—"}
                              </p>
                            </>
                          )}
                          {!drv && (
                            <p style={{ fontSize: 13, opacity: 0.7 }}>
                              No driver assigned
                            </p>
                          )}
                        </div>
                      </Popup>
                    </Marker>
                  );
                })}
              </MapContainer>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function RecenterMap({ center, zoom }) {
  const map = useMap();

  useEffect(() => {
    if (!center) return;
    map.setView([center.lat, center.lng], zoom ?? map.getZoom(), { animate: true });
  }, [center, zoom, map]);

  return null;
}



/* ---------------------------- MAP PAGE ---------------------------- */
function MapPage() {
  const [buses, setBuses] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [socketStatus, setSocketStatus] = useState('disconnected');
  const [roads, setRoads] = useState(null);
  const [filterType, setFilterType] = useState('all');
  const [mapCenter, setMapCenter] = useState(center);
  const [routeSearch, setRouteSearch] = useState('');
  const [routeSearchMsg, setRouteSearchMsg] = useState('');
  const [locError, setLocError] = useState("");
  const [geoState, setGeoState] = useState("unknown"); // "granted" | "prompt" | "denied" | "unknown"
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true);

  // maintenance banner state
  const [maintenance, setMaintenance] = useState(false);
  const [maintenanceReason, setMaintenanceReason] = useState('');
  const lastUpdateRef = useRef(0);
  // ETA endpoint calls are intentionally disabled.
  // The tracking page now uses local route + stop sequence data only.

  const flatRoadLinesRef = useRef([]);
  const lastSmoothedRef = useRef(new Map());

  // ---- Schedule Modal state ----
  const [showSchedule, setShowSchedule] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  // --- responsive helpers ---
  const [isNarrow, setIsNarrow] = useState(() => window.innerWidth <= 480);
  const clamp = (min, pref, max) => `clamp(${min}, ${pref}, ${max})`;
  const pad = isNarrow ? 12 : 16;
  const gap = isNarrow ? 8 : 12;
  const chipFS = isNarrow ? 12 : 13;

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth <= 480);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Backend ETA polling removed; stop popups now use local data only.

  // ---- stable socket + pause flag ----
  const socketRef = useRef(null);
  const ignoreUpdatesRef = useRef(false);

  // ---- assignments (vehicle -> routeCode) ----
  const [assignments, setAssignments] = useState({});
  async function refreshAssignments() {
    try {
      const r = await axios.get(`${BACKEND}/api/vehicle-route/active`);
      const map = {};
      for (const row of r.data?.rows || []) {
        const vehicleNo = normalizeVehicleNo(row.vehicleNo);
        map[vehicleNo] = row.routeCode || row.routeNo || "";
      }
      setAssignments(map);
    } catch { }
  }
  useEffect(() => { refreshAssignments(); const t = setInterval(refreshAssignments, 60000); return () => clearInterval(t); }, []);

  // Load roads
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(ROADS_URL);
        if (!cancelled && r.ok) setRoads(await r.json());
      } catch (e) {
        if (!cancelled) console.warn('Failed to load roads:', e?.message || e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // Flatten roads to LineStrings
  useEffect(() => {
    if (!roads) return;
    const lines = [];
    turf.flattenEach(roads, (feat) => {
      if (feat.geometry?.type === 'LineString') lines.push(feat);
    });
    flatRoadLinesRef.current = lines;
  }, [roads]);

  // // Geolocation
  // useEffect(() => {
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition(
  //       (pos) => setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
  //       (err) => console.warn('Geolocation error:', err?.message),
  //       { enableHighAccuracy: true, timeout: 5000 }
  //     );
  //   }
  // }, []);

  useEffect(() => {
    let perm;
    (async () => {
      try {
        if (!navigator.permissions?.query) return;
        perm = await navigator.permissions.query({ name: "geolocation" });
        setGeoState(perm.state);
        perm.onchange = () => setGeoState(perm.state);
      } catch {
        // ignore
      }
    })();
    return () => {
      if (perm) perm.onchange = null;
    };
  }, []);


  //   const requestUserLocation = useCallback(() => {
  //   setLocError("");

  //   if (!("geolocation" in navigator)) {
  //     setLocError("Geolocation not supported on this device/browser.");
  //     return;
  //   }

  //   navigator.geolocation.getCurrentPosition(
  //     (pos) => {
  //       const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
  //       setUserLocation(loc);
  //       setMapCenter(loc); // ✅ recenter map here
  //       setLocError("");
  //     },
  //     (err) => {
  //       console.warn("Geolocation error:", err?.message || err);
  //       // If user didn't allow, browser will show prompt only if not blocked.
  //       setLocError("Please allow location to center the map near you.");
  //     },
  //     { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
  //   );
  // }, []);

  const requestUserLocation = useCallback(() => {
    setLocError("");

    if (!("geolocation" in navigator)) {
      setLocError("Geolocation not supported on this device/browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setUserLocation(loc);
        setMapCenter(loc);
        setLocError("");
      },
      (err) => {
        // err.code === 1 => PERMISSION_DENIED
        if (err?.code === 1) {
          // If browser permission is truly "denied", it won't show popup again.
          setLocError(
            "Location is blocked in browser settings. Click the 🔒 icon near the URL → Site settings → Location → Allow (or Ask), then refresh."
          );
        } else {
          setLocError(err?.message || "Unable to fetch location.");
        }
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
    );
  }, []);


  useEffect(() => {
    // ✅ On every page open (and after browser refresh), request location and recenter
    requestUserLocation();
  }, [requestUserLocation]);


  // Initial fetch
  useEffect(() => {
    if (!BACKEND) {
      setMaintenance(true);
      setMaintenanceReason('Server URL not configured');
      return;
    }
    axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 })
      .then((res) => {
        const arr = Array.isArray(res.data) ? res.data : [];
        const byVeh = new Map();
        for (const d of arr) {
          const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
          byVeh.set(d.vehicleno, {
            vehicleno: d.vehicleno,
            latitude: d.latitude,
            longitude: d.longitude,
            speed: d.speed,
            heading
          });
        }
        const list = [...byVeh.values()];
        setBuses(processVehicles(list));
        lastUpdateRef.current = Date.now();
      })
      .catch((err) => {
        console.error('Initial fetch error:', err?.message || err);
        setMaintenance(true);
        setMaintenanceReason('Unable to fetch live data');
      });
  }, []);

  // ---- WebSocket packet handler ----
  const onPacket = (data) => {
    if (ignoreUpdatesRef.current) return;
    const incoming = {
      vehicleno: data.vehicleno,
      latitude: data.latitude,
      longitude: data.longitude,
      speed: data.speed,
      heading: Number.isFinite(data?.heading) ? toHeading(data.heading) : toHeading(data?.direction)
    };

    setBuses((prev) => {
      const nextByVeh = new Map(prev.map((b) => [b.vehicleno, b]));
      const processed = processVehicles([incoming], nextByVeh);
      const merged = new Map(prev.map((b) => [b.vehicleno, b]));
      for (const p of processed) merged.set(p.vehicleno, p);
      return [...merged.values()];
    });

    lastUpdateRef.current = Date.now();
  };

  // Live updates (Socket.IO)
  useEffect(() => {
    if (!BACKEND) return;

    setSocketStatus('connecting');
    const socket = io(BACKEND, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      timeout: 10000,
      withCredentials: false
    });
    socketRef.current = socket;

    socket.on('connect', () => setSocketStatus('connected'));
    socket.on('disconnect', () => setSocketStatus('disconnected'));
    socket.on('connect_error', (e) => {
      console.warn('Socket connect_error:', e?.message || e);
      setSocketStatus('disconnected');
    });

    socket.on('new-bus-data', onPacket);

    return () => {
      socket.off('new-bus-data', onPacket);
      socket.disconnect();
      socketRef.current = null;
    };
  }, [roads]); // re-connect only if roads change

  // Staleness / maintenance detector
  useEffect(() => {
    const t = setInterval(() => {
      const sinceMs = Date.now() - lastUpdateRef.current;
      const stale = sinceMs > STALE_MS;
      const downAndEmpty = socketStatus === 'disconnected' && buses.length === 0;

      if (stale || downAndEmpty) {
        const mins = Math.floor(sinceMs / 60000);
        const secs = Math.floor((sinceMs % 60000) / 1000);
        setMaintenance(true);
        setMaintenanceReason(
          stale ? `No new data for ${mins}m ${secs}s` : 'Live connection unavailable'
        );
      } else {
        setMaintenance(false);
        setMaintenanceReason('');
      }
    }, 5000);
    return () => clearInterval(t);
  }, [socketStatus, buses.length]);

  // ---- Processing pipeline: smooth then snap ----
  function snapToRoad(coord, flatLines) {
    const safeCoord = normalizeLatLng(coord?.lat, coord?.lng);
    if (!safeCoord || !flatLines || flatLines.length === 0) return null;

    let pt;
    try {
      pt = turf.point([safeCoord.lng, safeCoord.lat]);
    } catch (err) {
      console.warn('Skipping road snap because coordinates are invalid:', coord);
      return null;
    }

    let best = null;
    let bestDist = Infinity;

    for (const line of flatLines) {
      try {
        const np = turf.nearestPointOnLine(line, pt, { units: 'meters' });
        const dist = np?.properties?.dist;
        if (Number.isFinite(dist) && dist < bestDist) {
          bestDist = dist;
          const [lng, lat] = np.geometry.coordinates;
          const snapped = normalizeLatLng(lat, lng);
          if (snapped) best = { ...snapped, distM: dist };
        }
      } catch (err) {
        console.warn('Skipping invalid road line while snapping:', err?.message || err);
      }
    }
    return best;
  }

  function processVehicles(list, prevMapOpt) {
    const flatLines = flatRoadLinesRef.current;
    const last = lastSmoothedRef.current;
    const result = [];

    for (const d of list) {
      const id = String(d?.vehicleno || '').trim();
      if (!id) continue;

      const raw = normalizeLatLng(d.latitude, d.longitude);
      if (!raw) {
        console.warn('Skipping vehicle with invalid coordinates:', d?.vehicleno, d?.latitude, d?.longitude);
        continue;
      }

      const prev = last.get(id);
      const smoothedCoord = smoothCoord(prev?.coord, raw, SMOOTH_ALPHA);
      if (!smoothedCoord) continue;

      const smoothedHeading = smoothHeading(prev?.heading, d.heading, HEADING_ALPHA);
      const snapped = snapToRoad(smoothedCoord, flatLines);

      const use = snapped?.distM != null && snapped.distM <= SNAP_MAX_DIST_M
        ? { lat: snapped.lat, lng: snapped.lng }
        : smoothedCoord;

      if (!hasValidLatLng(use)) continue;

      last.set(id, { coord: use, heading: smoothedHeading });

      result.push({
        vehicleno: id,
        latitude: use.lat,
        longitude: use.lng,
        speed: d.speed,
        heading: smoothedHeading
      });
    }

    if (prevMapOpt) {
      for (const [id, b] of prevMapOpt) {
        if (list.find(x => x.vehicleno === id)) continue;
        const prev = last.get(id);
        if (prev?.coord && hasValidLatLng(prev.coord)) {
          result.push({
            vehicleno: id,
            latitude: prev.coord.lat,
            longitude: prev.coord.lng,
            speed: b.speed,
            heading: prev.heading
          });
          continue;
        }

        const fallback = normalizeLatLng(b?.latitude, b?.longitude);
        if (fallback) {
          result.push({
            ...b,
            latitude: fallback.lat,
            longitude: fallback.lng,
          });
        }
      }
    }

    return result;
  }

  // ---------------- Route geometry + ETA helpers ----------------
  const stopById = useMemo(() => Object.fromEntries(busStops.map(s => [s.id, s])), []);

  function routePolyline(ids) {
    return ids
      .map((id) => stopById[id])
      .filter(Boolean)
      .map((s) => normalizeLatLng(s.lat, s.lng))
      .filter(Boolean);
  }

  function cumDist(poly) {
    const out = [0];
    for (let i = 1; i < poly.length; i++) {
      const d = mBetween(poly[i - 1], poly[i]);
      out.push(out[i - 1] + (Number.isFinite(d) ? d : 0));
    }
    return out;
  }

  const routeGeom = useMemo(() => {
    const g = {};
    for (const trip of ROUTE_TRIPS) {
      const validIds = trip.ids.filter((id) => !!stopById[id]);
      const poly = routePolyline(validIds);
      if (poly.length >= 2) {
        g[trip.id] = { poly, cum: cumDist(poly), ids: validIds, trip };
      }
    }
    return g;
  }, [stopById]);

  function projectOnRoute(pt, poly) {
    const safePt = normalizeLatLng(pt?.lat, pt?.lng);
    if (!safePt || !poly || poly.length < 2) return null;

    let best = null;
    let pointFeature = null;

    try {
      pointFeature = turf.point([safePt.lng, safePt.lat]);
    } catch (err) {
      console.warn('Skipping route projection because bus coordinates are invalid:', pt);
      return null;
    }

    for (let i = 0; i < poly.length - 1; i++) {
      const a = normalizeLatLng(poly[i]?.lat, poly[i]?.lng);
      const b = normalizeLatLng(poly[i + 1]?.lat, poly[i + 1]?.lng);
      if (!a || !b) continue;

      try {
        const seg = turf.lineString([[a.lng, a.lat], [b.lng, b.lat]]);
        const p = turf.nearestPointOnLine(seg, pointFeature, { units: "meters" });
        const d = p.properties?.dist ?? Infinity;
        if (Number.isFinite(d) && (!best || d < best.dist)) {
          const [lng, lat] = p.geometry.coordinates;
          best = { idx: i, point: { lat, lng }, dist: d };
        }
      } catch (err) {
        console.warn('Skipping invalid route segment while projecting bus:', err?.message || err);
      }
    }
    return best;
  }

  function distanceAlong(poly, cum, proj, targetIndex) {
    if (!proj || !poly || poly.length < 2 || !cum?.length) return Infinity;
    const safeIdx = Math.max(0, Math.min(proj.idx, poly.length - 2));
    const safeTarget = Math.max(0, Math.min(targetIndex, poly.length - 1));
    const dHead = mBetween(proj.point, poly[safeIdx + 1]);
    const dTail = (cum[safeTarget] ?? 0) - (cum[safeIdx + 1] ?? 0);
    const total = dHead + Math.max(0, dTail);
    return Number.isFinite(total) ? total : Infinity;
  }

  // ---- ETA constants: match backend ----
  const AVG_SPEED_KMPH = 20;
  const AVG_SPEED_MPS = (AVG_SPEED_KMPH * 1000) / 3600;
  const WAIT_RADIUS_M = 25;
  const WAIT_SPEED_KMPH_MAX = 1.0;

  function etaFromMeters(distanceM) {
    const seconds = distanceM / AVG_SPEED_MPS;
    const minutes = Math.round(seconds / 60);
    return minutes < 0 || !Number.isFinite(minutes) ? 0 : minutes;
  }

  function nextStopIndex(routeIds, projIdx) {
    return Math.min(routeIds.length - 1, projIdx + 1);
  }

  function getBestRouteProjectionForBus(bus) {
    const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
    if (!routeValue) return null;

    const candidates = routeCandidatesForValue(routeValue);
    if (!candidates.length) return null;

    const pt = normalizeLatLng(bus.latitude, bus.longitude);
    if (!pt) return null;

    let best = null;

    for (const trip of candidates) {
      const geom = routeGeom[trip.id];
      if (!geom || geom.poly.length < 2) continue;

      const proj = projectOnRoute(pt, geom.poly);
      if (!proj) continue;

      if (!best || proj.dist < best.proj.dist) {
        best = { routeValue, trip, geom, proj };
      }
    }

    return best;
  }

  function recentlyPassedStopForBus(bus) {
    const best = getBestRouteProjectionForBus(bus);
    if (!best) return null;

    const passedIdx = Math.max(0, Math.min(best.proj.idx, best.geom.ids.length - 1));
    const stopId = best.geom.ids[passedIdx];
    const stop = stopById[stopId];

    if (!stop) return null;

    return {
      stopId,
      name: stop.name,
      routeNo: best.trip.routeNo,
      routeCode: best.trip.code,
      distanceFromRouteM: best.proj.dist,
    };
  }

  // For a given bus, find nearest upcoming stop on its route + ETA
  function nearestStopEtaForBusOnItsRoute(bus) {
    const best = getBestRouteProjectionForBus(bus);
    if (!best) return null;

    const { geom, proj, trip } = best;
    const pt = normalizeLatLng(bus.latitude, bus.longitude);
    if (!pt) return null;

    const firstStopId = geom.ids[0];
    const firstStop = stopById[firstStopId];
    let waitingAtFirstStop = false;
    if (firstStop) {
      const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
      const speed = Number(bus.speed);
      if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
        waitingAtFirstStop = true;
      }
    }

    const nextIdx = nextStopIndex(geom.ids, proj.idx);
    const distanceM = distanceAlong(geom.poly, geom.cum, proj, nextIdx);

    let etaMin = undefined;
    if (!waitingAtFirstStop) {
      etaMin = etaFromMeters(distanceM);
    }

    return {
      stopId: geom.ids[nextIdx],
      distanceM,
      etaMin,
      routeCode: trip.code,
      routeNo: trip.routeNo,
      waitingAtFirstStop,
    };
  }

  // For a given stop, find the best incoming vehicle + ETA
  function nextArrivalAtStop(stopId) {
    const candidates = [];

    for (const bus of buses) {
      if (startsWithDigit(bus.vehicleno)) continue;

      const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
      if (!routeValue) continue;

      for (const trip of routeCandidatesForValue(routeValue)) {
        const geom = routeGeom[trip.id];
        if (!geom) continue;

        const indexInRoute = geom.ids.indexOf(stopId);
        if (indexInRoute < 0) continue;

        const pt = normalizeLatLng(bus.latitude, bus.longitude);
        if (!pt) continue;

        const proj = projectOnRoute(pt, geom.poly);
        if (!proj) continue;

        const targetIndex = Math.max(indexInRoute, proj.idx + 1);
        if (targetIndex >= geom.ids.length) continue;

        const distanceM = distanceAlong(geom.poly, geom.cum, proj, targetIndex);

        const firstStopId = geom.ids[0];
        const firstStop = stopById[firstStopId];
        let waitingAtFirstStop = false;
        if (firstStop) {
          const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
          const speed = Number(bus.speed);
          if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
            waitingAtFirstStop = true;
          }
        }

        let etaMin = undefined;
        if (!waitingAtFirstStop) {
          etaMin = etaFromMeters(distanceM);
        }

        candidates.push({
          vehicle: bus.vehicleno,
          routeCode: trip.code,
          routeNo: trip.routeNo,
          etaMin,
          waitingAtFirstStop,
          distanceM,
        });
      }
    }

    if (!candidates.length) return null;

    const moving = candidates.filter(c => c.etaMin != null);
    if (moving.length) {
      return moving.reduce((a, b) => (a.etaMin <= b.etaMin ? a : b));
    }

    return candidates.reduce((a, b) => (a.distanceM <= b.distanceM ? a : b));
  }


  // ---- Derived lists ----
  const visibleBuses = buses.filter(b => !startsWithDigit(b.vehicleno) && normalizeLatLng(b.latitude, b.longitude));
  const filteredBuses = visibleBuses.filter(b => matchesFilter(b.vehicleno, filterType, assignments));

  function handleRouteSearch() {
    const requested = normalizeRouteNo(routeSearch);
    if (!requested) {
      setRouteSearchMsg("Enter a route number, for example 52-G.");
      return;
    }

    const matching = visibleBuses.filter(
      (bus) => normalizeRouteNo(getBusRouteNo(bus.vehicleno, assignments)) === requested
    );

    setFilterType(`route:${requested}`);

    if (matching.length > 0) {
      const bus = matching[0];
      setMapCenter({ lat: bus.latitude, lng: bus.longitude });
      setRouteSearchMsg(`Showing ${matching.length} vehicle(s) on route ${requested}.`);
      return;
    }

    const fallbackTrip = routeCandidatesForValue(requested)[0];
    const firstStopId = fallbackTrip?.ids?.[0];
    const firstStop = firstStopId ? stopById[firstStopId] : null;

    if (firstStop) {
      setMapCenter({ lat: firstStop.lat, lng: firstStop.lng });
      setRouteSearchMsg(`No live vehicle found on ${requested}. Zoomed to the first scheduled stop.`);
    } else {
      setRouteSearchMsg(`No live vehicle or schedule found for route ${requested}.`);
    }
  }


  // -------------- SCHEDULE UI helpers --------------
  const TABS = useMemo(() => ROUTES.map((route) => ({
    key: route.code,
    title: route.label,
    code: route.code,
    trips: ROUTE_TRIPS.filter((trip) => trip.routeNo === route.code),
  })), []);

  const ScheduleBody = useCallback(function ScheduleBody({ tab }) {
    const trips = tab.trips || [];

    if (!trips.length) {
      return (
        <div className="schedule-empty">
          Stop-wise schedule data is not available for this route in the uploaded ZIP.
        </div>
      );
    }

    return (
      <div className="schedule-trip-list">
        {trips
          .slice()
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((trip) => (
            <div className="schedule-trip-card" key={trip.id}>
              <div className="schedule-trip-header">
                <div>
                  <div className="schedule-trip-title">
                    {trip.routeNo} / Trip {trip.order}
                  </div>
                  <div className="schedule-trip-subtitle">
                    {trip.from} → {trip.to}
                  </div>
                </div>

                <div className="schedule-trip-badges">
                  <span>{trip.startTime} - {trip.endTime}</span>
                  <span>{trip.service || "Town Ordinary"}</span>
                  <span>{trip.direction === "U" ? "Up" : trip.direction === "D" ? "Down" : trip.direction}</span>
                </div>
              </div>

              <div className="schedule-stop-table-wrap">
                <table className="schedule-stop-table">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Bus stop</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trip.stops.map((stop, index) => (
                      <tr key={`${trip.id}-${stop.id}-${index}`}>
                        <td>{index + 1}</td>
                        <td>{stop.name}</td>
                        <td>{stop.time}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
      </div>
    );
  }, []);

  const ScheduleModal = useCallback(function ScheduleModal() {
    const tab = TABS[activeTab] || TABS[0];

    return (
      <div
        onClick={() => setShowSchedule(false)}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.45)',
          zIndex: 99999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isNarrow ? 8 : 16
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'relative',
            width: isNarrow ? '96vw' : 'min(1180px, 96vw)',
            height: isNarrow ? 'calc(100dvh - 16px)' : 'min(92dvh, 860px)',
            maxHeight: 'calc(100dvh - 16px)',
            minHeight: 0,
            background: '#ffffff',
            borderRadius: 16,
            boxShadow: '0 12px 30px rgba(0,0,0,0.3)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              padding: isNarrow ? '8px 10px' : '12px 16px',
              borderBottom: '1px solid #eee',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              flexShrink: 0
            }}
          >
            <img src={iitmLogo} alt="MiNT" style={{ width: isNarrow ? 26 : 32, height: isNarrow ? 26 : 32 }} />
            <div>
              <div style={{ fontWeight: 900, fontSize: isNarrow ? '14px' : '18px' }}>
                Thoothukudi Bus Schedule
              </div>
              <div style={{ color: '#64748b', fontSize: 12, fontWeight: 700 }}>
                Route-wise stop timings from the uploaded timesheet
              </div>
            </div>
            <button
              onClick={() => setShowSchedule(false)}
              style={{
                marginLeft: 'auto',
                border: 'none',
                background: '#f4f4f5',
                borderRadius: 999,
                width: 34,
                height: 34,
                cursor: 'pointer',
                fontSize: 16
              }}
              title="Close"
            >
              ✕
            </button>
          </div>

          <div
            style={{
              display: 'block',
              padding: isNarrow ? '8px 10px 10px' : '10px 14px',
              borderBottom: '1px solid #eee',
              overflowX: 'hidden',
              overflowY: 'auto',
              maxHeight: isNarrow ? 118 : 128,
              flexShrink: 0,
              WebkitOverflowScrolling: 'touch',
              scrollbarWidth: 'thin',
              overscrollBehavior: 'contain',
              touchAction: 'pan-y'
            }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, minWidth: '100%' }}>
              {TABS.map((t, i) => (
                <button
                  key={t.key}
                  onClick={() => setActiveTab(i)}
                  style={{
                    whiteSpace: 'nowrap',
                    padding: isNarrow ? '8px 10px' : '8px 12px',
                    borderRadius: 10,
                    border: i === activeTab ? '1px solid #0D47A1' : '1px solid #ddd',
                    background: i === activeTab ? '#eaf2ff' : '#ffffff',
                    fontWeight: 800,
                    cursor: 'pointer',
                    flex: '0 0 auto'
                  }}
                >
                  {t.code}
                </button>
              ))}
            </div>
          </div>

          <div
            className="schedule-modal-scroll-body"
            style={{
              padding: isNarrow ? 10 : 14,
              overflowY: 'auto',
              overflowX: 'hidden',
              flex: '1 1 auto',
              minHeight: 0,
              overscrollBehavior: 'contain',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <div className="schedule-route-summary">
              <div>
                <div className="schedule-route-title">{tab.title}</div>
                <div className="schedule-route-meta">
                  {tab.trips?.length || 0} trip(s) · click a route tab to view stop-wise timings
                </div>
              </div>
            </div>
            <ScheduleBody tab={tab} />
          </div>
        </div>
      </div>
    );
  }, [TABS, activeTab, isNarrow, ScheduleBody]);


  // Pause live updates when modal open; refresh once on close, then resume
  useEffect(() => {
    if (showSchedule) { ignoreUpdatesRef.current = true; return; }
    (async () => {
      try {
        if (!BACKEND) return;
        const res = await axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 });
        const arr = Array.isArray(res.data) ? res.data : [];
        const byVeh = new Map();
        for (const d of arr) {
          const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
          byVeh.set(d.vehicleno, {
            vehicleno: d.vehicleno,
            latitude: d.latitude,
            longitude: d.longitude,
            speed: d.speed,
            heading
          });
        }
        const list = [...byVeh.values()];
        setBuses(processVehicles(list));
        lastUpdateRef.current = Date.now();
      } catch (e) {
        console.warn('Refresh after modal close failed:', e?.message || e);
      } finally {
        ignoreUpdatesRef.current = false;
      }
    })();
  }, [showSchedule]);

  // Responsive stop icons (smaller on phones)
  const stopIconInstance = useMemo(
    () => createCustomIcon(stopIconImg, isNarrow ? [40, 40] : [50, 50]),
    [isNarrow]
  );

  // --------------------------- RENDER ---------------------------
  return (
    <div className="map-container">
      {/* Header */}
      {/* <div
        style={{
          position: 'fixed',
          top: 'max(8px, env(safe-area-inset-top))',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10000,
          background: '#ffffff',
          border: '1px solid #e6e6e7',
          borderRadius: 16,
          padding: pad,
          boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
          width: isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))',
          backdropFilter: 'blur(2px)'
        }}
      > */}
      <div
        style={{
          position: 'fixed',
          top: 'max(8px, env(safe-area-inset-top))',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10000,
          background: '#ffffff',
          border: '1px solid #e6e6e7',
          borderRadius: 16,
          padding: isHeaderCollapsed ? (isNarrow ? 8 : 10) : pad,
          boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
          width: isHeaderCollapsed
            ? (isNarrow ? 'calc(100vw - 16px)' : 'min(420px, calc(100vw - 32px))')
            : (isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))'),
          backdropFilter: 'blur(2px)',
          transition: 'width 180ms ease, padding 180ms ease'
        }}
      >
        {/* Title row */}
        {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src={iitmLogo} alt="IIT Madras" style={{ width: isNarrow ? 28 : 36, height: isNarrow ? 28 : 36 }} />
          <h2
            style={{
              margin: 0,
              fontSize: clamp('18px','3.2vw','28px'),
              lineHeight: 1.1,
              letterSpacing: 0.3,
              fontWeight: 800
            }}
          >
            Thoothukudi Bus Tracking
          </h2>
          <a href="/admin" style={{ marginLeft: 'auto', fontWeight: 700 }}>Admin ↗</a>
        </div> */}

        {/* Title row */}
        <div style={{ display: 'flex', alignItems: 'center', gap: isNarrow ? 8 : 12 }}>
          <img
            src={iitmLogo}
            alt="IIT Madras"
            style={{
              width: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
              height: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
              flex: '0 0 auto'
            }}
          />

          <h2
            style={{
              margin: 0,
              fontSize: isHeaderCollapsed
                ? clamp('15px', '3vw', '20px')
                : clamp('18px', '3.2vw', '28px'),
              lineHeight: 1.1,
              letterSpacing: 0.3,
              fontWeight: 800,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: 1
            }}
          >
            Thoothukudi Bus Tracking
          </h2>

          {isHeaderCollapsed && (
            <div
              style={{
                fontSize: isNarrow ? 12 : 13,
                fontWeight: 800,
                color: '#111827',
                whiteSpace: 'nowrap'
              }}
              title="Visible vehicles / total vehicles"
            >
              {filteredBuses.length}/{buses.length}
            </div>
          )}

          {!isHeaderCollapsed && (
            <a
              href="/admin"
              style={{
                fontWeight: 700,
                whiteSpace: 'nowrap'
              }}
            >
              Admin ↗
            </a>
          )}

          <button
            type="button"
            onClick={() => setIsHeaderCollapsed((v) => !v)}
            aria-label={isHeaderCollapsed ? 'Expand header' : 'Collapse header'}
            title={isHeaderCollapsed ? 'Expand' : 'Collapse'}
            style={{
              border: '1px solid #D1D5DB',
              background: '#ffffff',
              color: '#111827',
              borderRadius: 10,
              padding: isNarrow ? '6px 8px' : '7px 10px',
              fontWeight: 800,
              fontSize: isNarrow ? 13 : 14,
              lineHeight: 1,
              cursor: 'pointer',
              minWidth: isNarrow ? 34 : 38,
              minHeight: isNarrow ? 32 : 36
            }}
          >
            {isHeaderCollapsed ? '▾' : '▴'}
          </button>
        </div>

        {!isHeaderCollapsed && (
          <>

            {/* Status row */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: 10,
                gap: 12,
                flexWrap: 'wrap'
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  padding: '4px 10px',
                  borderRadius: 999,
                  fontSize: chipFS,
                  fontWeight: 700,
                  background:
                    socketStatus === 'connected'
                      ? '#E9F9EE'
                      : socketStatus === 'connecting'
                        ? '#FFF7E1'
                        : '#FFECEC',
                  color:
                    socketStatus === 'connected'
                      ? '#0A7A2A'
                      : socketStatus === 'connecting'
                        ? '#7A5D00'
                        : '#B00020',
                  border:
                    socketStatus === 'connected'
                      ? '1px solid #C6EBD1'
                      : socketStatus === 'connecting'
                        ? '1px solid #F4E3B0'
                        : '1px solid #FFD0D0',
                  textTransform: 'lowercase'
                }}
                title={`Socket: ${socketStatus}`}
              >
                {socketStatus}
              </span>

              <div
                style={{
                  fontSize: clamp('14px', '2.6vw', '18px'),
                  fontWeight: 700,
                  letterSpacing: 0.5,
                  color: '#111827'
                }}
              >
                {filteredBuses.length} / {buses.length}
              </div>
            </div>

            {/* Controls row */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: gap,
                marginTop: gap,
                flexWrap: 'wrap'
              }}
            >
              <div style={{ position: 'relative', flex: '1 1 200px' }}>
                <select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  title="Filter vehicles"
                  style={{
                    width: '100%',
                    padding: isNarrow ? '10px 34px 10px 12px' : '10px 40px 10px 14px',
                    borderRadius: 10,
                    border: '1px solid #D1D5DB',
                    background: '#FFFFFF',
                    fontWeight: 600,
                    cursor: 'pointer',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none'
                  }}
                >
                  <option value="all">All Vehicles</option>
                  {/* <option value="cart">Cart</option> */}
                  {/* <option value="bus">Bus</option> */}
                  <optgroup label="Filter by Route">
                    {ROUTES.map(r => (
                      <option key={r.code} value={`route:${r.code}`}>{r.label}</option>
                    ))}
                  </optgroup>
                </select>

                <div
                  style={{
                    position: 'absolute',
                    right: isNarrow ? 8 : 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 0,
                    height: 0,
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderTop: '7px solid #111',
                    pointerEvents: 'none'
                  }}
                />
              </div>

              <div className="route-search-box">
                <input
                  value={routeSearch}
                  onChange={(e) => setRouteSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleRouteSearch();
                  }}
                  placeholder="Search route e.g. 52-G"
                  aria-label="Search by route number"
                />
                <button type="button" onClick={handleRouteSearch}>
                  Search
                </button>
              </div>

              <button
                // onClick={() => window.location.reload()}
                // onClick={() => {
                //   requestUserLocation(); // ✅ recenter on refresh button click
                // }}

                // title="Reload the page"
                onClick={() => {
                  requestUserLocation();          // ✅ recenter
                  setTimeout(() => {
                    window.location.reload();     // ✅ full reload
                  }, 150);
                }}
                title="Recenter + Reload"
                style={{
                  padding: '10px 14px',
                  borderRadius: 10,
                  border: '1px solid #D1D5DB',
                  background: '#FFFFFF',
                  fontWeight: 700,
                  cursor: 'pointer',
                  minHeight: isNarrow ? 36 : 40,
                  fontSize: clamp('13px', '2.8vw', '14px')
                }}
              >
                Refresh
              </button>

              <button
                onClick={() => setShowSchedule(true)}
                title="Show route schedules"
                style={{
                  padding: '10px 16px',
                  borderRadius: 10,
                  border: '1px solid #0D47A1',
                  background: '#0D47A1',
                  color: '#FFFFFF',
                  fontWeight: 800,
                  cursor: 'pointer',
                  boxShadow: '0 6px 16px rgba(13,71,161,0.25)',
                  minHeight: isNarrow ? 36 : 40,
                  fontSize: clamp('13px','2.8vw','14px')
                }}
              >
                Schedule
              </button>
            </div>

            {routeSearchMsg && (
              <div className="route-search-message">
                {routeSearchMsg}
              </div>
            )}

            {maintenance && (
              <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#fff8e1', border: '1px solid #f0d48a', fontWeight: 600 }}>
                Under maintenance — {maintenanceReason}
              </div>
            )}

            {/* {locError && (
        <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
          {locError}
          <button
            onClick={requestUserLocation}
            style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
          >
            Allow location
          </button>
        </div>
        )} */}

            {locError && (
              <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
                {locError}

                <button
                  type="button"
                  onClick={requestUserLocation}
                  style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
                  title={geoState === "denied" ? "Enable in site settings first, then try again" : "Try again"}
                >
                  {geoState === "denied" ? "Open site settings" : "Allow location"}
                </button>
              </div>
            )}
          </>
        )}
      </div>


      {/* Schedule Modal */}
      {showSchedule && <ScheduleModal />}

      {/* Map uses dynamic viewport on mobile (100dvh) */}
      {/* <MapContainer center={center} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}> */}
      <MapContainer center={mapCenter} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}>
        <RecenterMap center={mapCenter} zoom={DEFAULT_ZOOM} />

        <TileLayer
          attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxNativeZoom={19}
          maxZoom={22}
        />

        {userLocation && (
          <Marker position={{ lat: userLocation.lat, lng: userLocation.lng }} icon={userIconInstance}>
            <Popup>
              <div className="info-window">
                <h4>You are here</h4>
              </div>
            </Popup>
          </Marker>
        )}
        {/* Bus Stops - no ETA endpoint call. */}
        {busStops.map((stop) => (
          <Marker
            key={stop.id}
            position={{ lat: stop.lat, lng: stop.lng }}
            icon={stopIconInstance}
          >
            <Popup>
              <div className="info-window">
                <h4>{stop.name}</h4>
                <p><strong>Stop ID:</strong> {stop.id}</p>
              </div>
            </Popup>
          </Marker>
        ))}



        {/* Vehicles */}
        {filteredBuses.map((bus) => {
          const assignedRouteValue = getAssignedRouteValue(bus.vehicleno, assignments);
          const routeNo = getBusRouteNo(bus.vehicleno, assignments);
          const routeLabel = getRouteDisplayLabel(assignedRouteValue || routeNo);
          const label = vehicleLabel(bus.vehicleno, assignedRouteValue);
          const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
          const info = nearestStopEtaForBusOnItsRoute(bus);
          const recentlyPassed = recentlyPassedStopForBus(bus);
          const nearestName = info ? (busStops.find(s => s.id === info.stopId)?.name) : null;
          return (
            <Marker
              key={bus.vehicleno}
              position={{ lat: bus.latitude, lng: bus.longitude }}
              // icon={createVehicleDivIcon(label, bus.heading)}
              icon={createVehicleDivIcon(label, bus.heading, palette)}

            >
              <Popup>
                <div className="info-window">
                  <h4>{bus.vehicleno} ({label})</h4>
                  {/* <p><strong>Legend:</strong> B = Bus, C = Cart</p> */}
                  {/* <p><strong>Legend:</strong> B = Bus, C = Cart, CR = Cart (RP↔ED)</p> */}
                  <p><strong>Route No:</strong> {routeNo || 'Unassigned'}</p>
                  <p><strong>Route:</strong> {routeLabel}</p>
                  <p><strong>Recently Passed:</strong> {recentlyPassed?.name || 'Not available yet'}</p>
                  {nearestName && <p><strong>Next Stop:</strong> {nearestName}</p>}
                  <p><strong>Speed:</strong> {Number.isFinite(bus.speed) ? bus.speed.toFixed(1) : 'N/A'} km/h</p>
                  {Number.isFinite(bus.heading) && <p><strong>Heading:</strong> {Math.round(bus.heading)}°</p>}
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>

      {/* Footer: Feedback link */}
      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: -5,
          display: 'flex',
          justifyContent: 'center',
          zIndex: 10000,
          pointerEvents: 'none',
          paddingBottom: 'max(6px, env(safe-area-inset-bottom))'
        }}
      >
        <div
          style={{
            width: '100vw',
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: isNarrow ? '6px 10px' : '6px 16px',
            borderRadius: 14,
            background:
              'linear-gradient(135deg, rgba(17,24,39,0.85), rgba(31,41,55,0.85))',
            color: '#F9FAFB',
            border: '1px solid rgba(255,255,255,0.14)',
            boxShadow:
              '0 12px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.06)',
            backdropFilter: 'saturate(160%) blur(10px)',
            WebkitBackdropFilter: 'saturate(160%) blur(10px)',
            fontFamily:
              '"SF Pro Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"',
            fontSize: clamp('12px', '2.8vw', '14px'),
            lineHeight: 1.4,
            fontWeight: 500,
            letterSpacing: '0.2px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              flex: 1,
              minWidth: 0,
            }}
          >
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: 9999,
                background:
                  'radial-gradient(circle at 30% 30%, #34D399, #059669)',
                boxShadow: '0 0 0 3px rgba(16,185,129,0.25)',
                flex: '0 0 auto',
              }}
            />
            <span
              style={{
                opacity: 0.95,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              MInT Lab | IIT Madras | UkPact
            </span>
          </div>

          {FEEDBACK_URL ? (
            <a
              href={FEEDBACK_URL}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px 12px',
                borderRadius: 10,
                border: '1px solid rgba(255,255,255,0.18)',
                background:
                  'linear-gradient(180deg, rgba(128, 126, 126, 0.14), rgba(221, 212, 212, 0.06))',
                color: '#F9FAFB',
                textDecoration: 'none',
                fontWeight: 600,
                letterSpacing: '0.25px',
                transform: 'translateZ(0)',
                transition: 'transform 120ms ease, opacity 120ms ease',
                cursor: 'pointer',
                boxShadow:
                  'inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 14px rgba(0,0,0,0.25)',
              }}
              onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-1px)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
            >
              Open feedback form ↗
            </a>
          ) : (
            <span
              style={{
                padding: '8px 12px',
                borderRadius: 10,
                border: '1px dashed rgba(255,255,255,0.25)',
                color: 'rgba(249,250,251,0.8)',
                fontWeight: 500,
              }}
            >
              &lt;form-link&gt;
            </span>
          )}
        </div>
      </div>

    </div>
  );
}

/* ---------------------------- HOME PAGE ---------------------------- */

const AIR_QUALITY_URL = "https://main.d2yil9slaoehou.amplifyapp.com/";

function HomePage({ navigate }) {
  const cards = [
    {
      title: "Bus Tracking",
      subtitle: "Live vehicle location using WebSocket",
      path: "/tracking",
      icon: "🚌",
      type: "internal",
    },
    {
      title: "Air Quality Sensor",
      subtitle: "View live air quality monitoring dashboard",
      url: AIR_QUALITY_URL,
      icon: "🌫️",
      type: "external",
    },
    {
      title: "Camera Data",
      subtitle: "Vehicle count analytics from camera feed",
      path: "/camera",
      icon: "📷",
      type: "internal",
    },
    {
      title: "Digital Twin Simulation",
      subtitle: "Simulate a 3rd Mile incident, bus delays, air impact and interventions",
      path: "/simulation",
      icon: "◈",
      type: "internal",
    },
  ];

  // const openCard = (card) => {
  //   if (card.type === "external") {
  //     window.location.href = card.url;
  //     return;
  //   }
  //   navigate(card.path);
  // };

  const openCard = (card) => {
  if (card.type === "external") {
    window.open(card.url, "_blank", "noopener,noreferrer");
    return;
  }

  window.open(card.path, "_blank", "noopener,noreferrer");
};

  return (
    <div className="home-page">
      <div className="home-bg-glow home-bg-glow-one" />
      <div className="home-bg-glow home-bg-glow-two" />

      <header className="home-navbar">
<div className="home-brand">
  <img
    src={iitmLogo}
    alt="MInT Lab Logo"
    className="home-brand-logo-img"
  />

  <div className="home-brand-text">
    <div className="home-brand-title">MInT Collaborative</div>
    <div className="home-brand-subtitle">IIT Madras | UKPACT</div>
  </div>
</div>

        <button className="home-nav-button" onClick={() => navigate("/tracking")}>
          Open Tracking
        </button>
      </header>

      <main className="home-main">
        <section className="home-hero">
          <div className="home-pill">Smart Mobility Dashboard</div>

          <h1>
            Real-time Transport, Sensor <br />
            and Camera Intelligence
          </h1>

          <p>
            A single access point for bus tracking, air quality monitoring,
            camera intelligence and full-stack mobility simulation.
          </p>
        </section>

        <section className="home-card-grid">
          {cards.map((card) => (
            <button
              key={card.title}
              className="home-feature-card"
              onClick={() => openCard(card)}
            >
              <div className="home-card-icon">{card.icon}</div>

              <div className="home-card-content">
                <h2>{card.title}</h2>
                <p>{card.subtitle}</p>
              </div>

              <div className="home-card-arrow">
                {card.type === "external" ? "↗" : "→"}
              </div>
            </button>
          ))}
        </section>
      </main>
    </div>
  );
}

/* ---------------------------- CAMERA DATA PAGE ---------------------------- */

const CAMERA_LOCATIONS = [
  {
    id: "camera-site-1",
    sno: 1,
    place: "Ettayapuram Rd",
    location: "Perison Plaza Signal",
    boxes: 2,
    cameras: 2,
    lat: 8.81277,
    lng: 78.13647,
  },
  {
    id: "camera-site-2",
    sno: 2,
    place: "4th Gate",
    location: "South side of Milavittan Road",
    boxes: 1,
    cameras: 1,
    lat: 8.80967,
    lng: 78.1335,
  },
  {
    id: "camera-site-3",
    sno: 3,
    place: "International Furniture Park",
    location: "Madurai - Tiruchendur Rd highway east side",
    boxes: 1,
    cameras: 1,
    lat: 8.81624,
    lng: 78.08118,
  },
  {
    id: "camera-site-4",
    sno: 4,
    place: "3rd Mile",
    location: "Near TVL-TUT-MDR Bypass Bridge",
    boxes: 2,
    cameras: 2,
    lat: 8.789608,
    lng: 78.11493,
  },
  {
    id: "camera-site-5",
    sno: 5,
    place: "Alageshapuram Road",
    location: "Roundana near St. Thomas School",
    boxes: 1,
    cameras: 2,
    lat: 8.81705,
    lng: 78.14797,
  },
  {
    id: "camera-site-6",
    sno: 6,
    place: "Tiruchendur Rd",
    location: "Muthiahpuram",
    boxes: 1,
    cameras: 1,
    lat: 8.74541,
    lng: 78.1253,
  },
];

const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

function numberSafe(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function normalizeCameraRow(row) {
  const auto = numberSafe(row.auto);
  const motorbike = numberSafe(row.motorbike);
  const bus = numberSafe(row.bus);
  const car = numberSafe(row.car);
  const truck = numberSafe(row.truck);

  return {
    id:
      row._id ||
      row.dedupeKey ||
      `${row.cameraId || "camera"}-${row.timestampText || row.timestamp}-${row.direction}`,
    dedupeKey: row.dedupeKey || "",
    sourceFile: row.sourceFile || "",
    cameraId: row.cameraId || "ALL",
    cameraName: row.cameraName || row.place || "",
    location: row.location || "",
    timestamp: row.timestampText || row.timestamp || "",
    timestampIso: row.timestamp || "",
    direction: row.direction || "All Directions",
    auto,
    motorbike,
    bus,
    car,
    truck,
    total: numberSafe(row.total) || auto + motorbike + bus + car + truck,
  };
}

function getRowSortTime(row) {
  const isoTime = row.timestampIso ? new Date(row.timestampIso).getTime() : NaN;
  if (Number.isFinite(isoTime)) return isoTime;

  const localText = String(row.timestamp || "").replace(" ", "T");
  const localTime = new Date(localText).getTime();
  if (Number.isFinite(localTime)) return localTime;

  return 0;
}

function mergeLatestCameraRows(existingRows, incomingRows, maxRows = 10) {
  const map = new Map();

  [...incomingRows, ...existingRows].forEach((row) => {
    const key =
      row.dedupeKey ||
      row.id ||
      `${row.cameraId}-${row.timestamp}-${row.direction}-${row.sourceFile}`;

    if (!map.has(key)) {
      map.set(key, row);
    }
  });

  return Array.from(map.values())
    .sort((a, b) => getRowSortTime(b) - getRowSortTime(a))
    .slice(0, maxRows);
}

function sumRows(rows) {
  return rows.reduce(
    (acc, row) => {
      acc.auto += numberSafe(row.auto);
      acc.motorbike += numberSafe(row.motorbike);
      acc.bus += numberSafe(row.bus);
      acc.car += numberSafe(row.car);
      acc.truck += numberSafe(row.truck);
      return acc;
    },
    { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
  );
}

function totalFromCounts(counts) {
  return VEHICLE_TYPES.reduce((sum, type) => sum + numberSafe(counts[type]), 0);
}

function buildDirectionData(rows) {
  const grouped = {};

  rows.forEach((row) => {
    const direction = row.direction || "All Directions";

    if (!grouped[direction]) {
      grouped[direction] = {
        direction,
        auto: 0,
        motorbike: 0,
        bus: 0,
        car: 0,
        truck: 0,
      };
    }

    VEHICLE_TYPES.forEach((type) => {
      grouped[direction][type] += numberSafe(row[type]);
    });
  });

  return Object.values(grouped)
    .map((item) => ({
      ...item,
      total: totalFromCounts(item),
    }))
    .sort((a, b) => b.total - a.total);
}

function CameraMapFlyTo({ selectedLocation }) {
  const map = useMap();

  useEffect(() => {
    if (!selectedLocation) return;

    map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
      duration: 0.8,
    });
  }, [map, selectedLocation]);

  return null;
}

function CameraDataPage({ navigate }) {
  const [rows, setRows] = useState([]);
  const [sourceLabel, setSourceLabel] = useState("Connecting to backend...");
  const [loading, setLoading] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
  const [connectionError, setConnectionError] = useState("");

  const fetchCameraData = useCallback(async () => {
    try {
      if (!BACKEND) {
        throw new Error("REACT_APP_BACKEND_URL is missing");
      }

      const res = await axios.get(`${BACKEND}/api/cameradata/latest`, {
        params: {
          limit: 10,
        },
      });

      const backendRows = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.rows)
        ? res.data.rows
        : [];

      const normalizedRows = backendRows.map(normalizeCameraRow);

      setRows((prev) => mergeLatestCameraRows(prev, normalizedRows, 10));

      setSourceLabel(
        normalizedRows.length
          ? "Live realtime data"
          : "Waiting for camera CSV data"
      );

      setConnectionError("");
    } catch (e) {
      setConnectionError(e.message || "Failed to load camera data");
      setSourceLabel("Backend not reachable");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCameraData();

    if (!BACKEND) return undefined;

    const socket = io(BACKEND, {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    socket.on("connect", () => {
      setConnectionError("");
      setSourceLabel("Live realtime data");
    });

    socket.on("connect_error", () => {
      setSourceLabel("Backend polling mode");
    });

    socket.on("new-camera-data", (payload) => {
      const incoming = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.rows)
        ? payload.rows
        : payload
        ? [payload]
        : [];

      if (!incoming.length) return;

      const normalized = incoming.map(normalizeCameraRow);

      setRows((prev) => mergeLatestCameraRows(prev, normalized, 10));
      setSourceLabel("Live camera update");
      setLoading(false);
      setConnectionError("");
    });

    const refreshTimer = setInterval(fetchCameraData, 30_000);

    return () => {
      clearInterval(refreshTimer);
      socket.disconnect();
    };
  }, [fetchCameraData]);

  const latestRows = useMemo(() => rows.slice(0, 10), [rows]);

  const selectedRows = useMemo(() => {
    const hasCameraSpecificRows = latestRows.some(
      (row) => row.cameraId && row.cameraId !== "ALL"
    );

    if (!hasCameraSpecificRows) {
      return latestRows;
    }

    return latestRows.filter((row) => row.cameraId === selectedLocation.id);
  }, [latestRows, selectedLocation]);

  const totalsByCamera = useMemo(() => {
    const grouped = {};

    latestRows.forEach((row) => {
      const key = row.cameraId || "ALL";

      if (!grouped[key]) {
        grouped[key] = {
          auto: 0,
          motorbike: 0,
          bus: 0,
          car: 0,
          truck: 0,
        };
      }

      VEHICLE_TYPES.forEach((type) => {
        grouped[key][type] += numberSafe(row[type]);
      });
    });

    return grouped;
  }, [latestRows]);

  const totals = useMemo(() => sumRows(latestRows), [latestRows]);
  const totalVehicles = totalFromCounts(totals);

  const directionData = useMemo(
    () => buildDirectionData(selectedRows),
    [selectedRows]
  );

  const latestRow = latestRows[0];

  const handleLocationClick = (location) => {
    setSelectedLocation(location);
  };

  return (
    <div className="camera-page">
      <div className="camera-bg-glow camera-bg-glow-one" />
      <div className="camera-bg-glow camera-bg-glow-two" />

      <header className="camera-navbar">
        <button className="camera-back-button" onClick={() => navigate("/")}>
          ← Home
        </button>

        <div>
          <h1>Camera Data</h1>
          <p>Realtime latest 10 rows from camera CSV feed</p>
        </div>

        <button className="camera-track-button" onClick={() => navigate("/tracking")}>
          Bus Tracking
        </button>
      </header>

      <main className="camera-content">
        <section className="camera-summary-grid">
          <div className="camera-summary-card total">
            <span>Total Vehicles</span>
            <strong>{totalVehicles}</strong>
            <small>{sourceLabel}</small>
          </div>

          <div className="camera-summary-card">
            <span>Cars</span>
            <strong>{totals.car}</strong>
          </div>

          <div className="camera-summary-card">
            <span>Motorbikes</span>
            <strong>{totals.motorbike}</strong>
          </div>

          <div className="camera-summary-card">
            <span>Buses</span>
            <strong>{totals.bus}</strong>
          </div>

          <div className="camera-summary-card">
            <span>Trucks</span>
            <strong>{totals.truck}</strong>
          </div>

          <div className="camera-summary-card">
            <span>Autos</span>
            <strong>{totals.auto}</strong>
          </div>
        </section>

        {connectionError && (
          <div className="camera-live-warning">
            {connectionError}
          </div>
        )}

        <section className="camera-map-layout">
          <aside className="camera-location-panel">
            <div className="camera-location-header">
              <h2>Camera Locations</h2>
              <p>
                {CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across{" "}
                {CAMERA_LOCATIONS.length} locations
              </p>
            </div>

            <div className="camera-location-list">
              {CAMERA_LOCATIONS.map((item) => {
                const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

                return (
                  <button
                    key={item.id}
                    className={
                      selectedLocation.id === item.id
                        ? "camera-location-item active"
                        : "camera-location-item"
                    }
                    onClick={() => handleLocationClick(item)}
                  >
                    <div>
                      <strong>{item.place}</strong>
                      <span>{item.location}</span>
                    </div>

                    <small>{cameraTotal} vehicles</small>
                  </button>
                );
              })}
            </div>
          </aside>

          <section className="camera-map-card">
            <MapContainer
              center={[selectedLocation.lat, selectedLocation.lng]}
              zoom={14}
              className="camera-osm-map"
              scrollWheelZoom={true}
            >
              <TileLayer
                attribution='&copy; OpenStreetMap contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />

              <CameraMapFlyTo selectedLocation={selectedLocation} />

              {CAMERA_LOCATIONS.map((item) => {
                const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

                return (
                  <Marker
                    key={item.id}
                    position={[item.lat, item.lng]}
                    eventHandlers={{
                      click: () => handleLocationClick(item),
                    }}
                  >
                    <Popup>
                      <div className="camera-popup">
                        <h3>{item.place}</h3>
                        <p>{item.location}</p>
                        <p>
                          <strong>Cameras:</strong> {item.cameras}
                        </p>
                        <p>
                          <strong>Latest Vehicles:</strong> {cameraTotal}
                        </p>
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            </MapContainer>
          </section>
        </section>

        <section className="camera-selected-panel">
          <div>
            <h2>{selectedLocation.place}</h2>
            <p>{selectedLocation.location}</p>
          </div>

          <div className="camera-selected-meta">
            <span>{selectedLocation.boxes} boxes</span>
            <span>{selectedLocation.cameras} cameras</span>
            <span>
              {selectedLocation.lat}, {selectedLocation.lng}
            </span>
          </div>
        </section>

        <section className="camera-direction-grid">
          {directionData.slice(0, 4).map((item) => (
            <div className="camera-direction-card" key={item.direction}>
              <span>{item.direction}</span>
              <strong>{item.total}</strong>
              <small>
                Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
              </small>
            </div>
          ))}

          {!loading && directionData.length === 0 && (
            <div className="camera-direction-card">
              <span>No direction data</span>
              <strong>0</strong>
              <small>Waiting for CSV rows</small>
            </div>
          )}
        </section>

        <section className="camera-panel">
          <div className="camera-panel-header">
            <div>
              <h2>Vehicle Count Table</h2>
              <p>
                {loading
                  ? "Loading camera data..."
                  : latestRow
                  ? `Latest timestamp: ${latestRow.timestamp}`
                  : "No camera records available"}
              </p>
            </div>

            <div className="camera-latest-badge">
              Latest 10 rows
            </div>
          </div>

          <div className="camera-table-info">
            <span>
              Showing realtime rows only. Data is not saved in backend database.
            </span>

            <span>
              Rows: {latestRows.length}/10
            </span>
          </div>

          <div className="camera-table-wrap">
            <table className="camera-table">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>Camera</th>
                  <th>Direction</th>
                  <th>Auto</th>
                  <th>Motorbike</th>
                  <th>Bus</th>
                  <th>Car</th>
                  <th>Truck</th>
                  <th>Total</th>
                </tr>
              </thead>

              <tbody>
                {latestRows.map((row, index) => (
                  <tr key={row.dedupeKey || row.id || `${row.timestamp}-${index}`}>
                    <td>{row.timestamp}</td>
                    <td>{row.cameraName || row.cameraId}</td>
                    <td>{row.direction}</td>
                    <td>{row.auto}</td>
                    <td>{row.motorbike}</td>
                    <td>{row.bus}</td>
                    <td>{row.car}</td>
                    <td>{row.truck}</td>
                    <td>{row.total}</td>
                  </tr>
                ))}

                {!loading && latestRows.length === 0 && (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center", padding: "24px" }}>
                      No camera data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
/* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// const CAMERA_LOCATIONS = [
//   {
//     id: "camera-site-1",
//     sno: 1,
//     place: "Ettayapuram Rd",
//     location: "Perison Plaza Signal",
//     boxes: 2,
//     cameras: 2,
//     lat: 8.81277,
//     lng: 78.13647,
//   },
//   {
//     id: "camera-site-2",
//     sno: 2,
//     place: "4th Gate",
//     location: "South side of Milavittan Road",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.80967,
//     lng: 78.1335,
//   },
//   {
//     id: "camera-site-3",
//     sno: 3,
//     place: "International Furniture Park",
//     location: "Madurai - Tiruchendur Rd highway east side",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.81624,
//     lng: 78.08118,
//   },
//   {
//     id: "camera-site-4",
//     sno: 4,
//     place: "3rd Mile",
//     location: "Near TVL-TUT-MDR Bypass Bridge",
//     boxes: 2,
//     cameras: 2,
//     lat: 8.789608,
//     lng: 78.11493,
//   },
//   {
//     id: "camera-site-5",
//     sno: 5,
//     place: "Alageshapuram Road",
//     location: "Roundana near St. Thomas School",
//     boxes: 1,
//     cameras: 2,
//     lat: 8.81705,
//     lng: 78.14797,
//   },
//   {
//     id: "camera-site-6",
//     sno: 6,
//     place: "Tiruchendur Rd",
//     location: "Muthiahpuram",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.74541,
//     lng: 78.1253,
//   },
// ];

// const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// function numberSafe(value) {
//   const n = Number(value);
//   return Number.isFinite(n) ? n : 0;
// }

// function normalizeCameraRow(row) {
//   const auto = numberSafe(row.auto);
//   const motorbike = numberSafe(row.motorbike);
//   const bus = numberSafe(row.bus);
//   const car = numberSafe(row.car);
//   const truck = numberSafe(row.truck);

//   return {
//     id: row._id || row.dedupeKey || `${row.cameraId}-${row.timestampText}-${row.direction}`,
//     dedupeKey: row.dedupeKey || "",
//     sourceFile: row.sourceFile || "",
//     cameraId: row.cameraId || "ALL",
//     cameraName: row.cameraName || row.place || "",
//     location: row.location || "",
//     timestamp: row.timestampText || row.timestamp || "",
//     timestampIso: row.timestamp || "",
//     direction: row.direction || "All Directions",
//     auto,
//     motorbike,
//     bus,
//     car,
//     truck,
//     total: numberSafe(row.total) || auto + motorbike + bus + car + truck,
//   };
// }

// function getRowSortTime(row) {
//   const isoTime = row.timestampIso ? new Date(row.timestampIso).getTime() : NaN;
//   if (Number.isFinite(isoTime)) return isoTime;

//   const localText = String(row.timestamp || "").replace(" ", "T");
//   const localTime = new Date(localText).getTime();
//   if (Number.isFinite(localTime)) return localTime;

//   return 0;
// }

// function mergeCameraRows(existingRows, incomingRows, maxRows = 5000) {
//   const map = new Map();

//   [...incomingRows, ...existingRows].forEach((row) => {
//     const key =
//       row.dedupeKey ||
//       row.id ||
//       `${row.cameraId}-${row.timestamp}-${row.direction}-${row.sourceFile}`;

//     if (!map.has(key)) {
//       map.set(key, row);
//     }
//   });

//   return Array.from(map.values())
//     .sort((a, b) => getRowSortTime(b) - getRowSortTime(a))
//     .slice(0, maxRows);
// }

// function sumRows(rows) {
//   return rows.reduce(
//     (acc, row) => {
//       acc.auto += numberSafe(row.auto);
//       acc.motorbike += numberSafe(row.motorbike);
//       acc.bus += numberSafe(row.bus);
//       acc.car += numberSafe(row.car);
//       acc.truck += numberSafe(row.truck);
//       return acc;
//     },
//     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
//   );
// }

// function totalFromCounts(counts) {
//   return VEHICLE_TYPES.reduce((sum, type) => sum + numberSafe(counts[type]), 0);
// }

// function getDateKey(timestamp) {
//   return String(timestamp || "").slice(0, 10);
// }

// function getWeekKey(timestamp) {
//   const datePart = getDateKey(timestamp);
//   if (!datePart) return "Unknown";

//   const date = new Date(`${datePart}T00:00:00`);
//   if (Number.isNaN(date.getTime())) return "Unknown";

//   const firstDay = new Date(date.getFullYear(), 0, 1);
//   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
//   const weekNumber = Math.ceil(dayNumber / 7);

//   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// }

// function buildChartData(rows, mode = "daily") {
//   const grouped = {};

//   rows.forEach((row) => {
//     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
//     if (!key) return;

//     if (!grouped[key]) {
//       grouped[key] = {
//         label: key,
//         auto: 0,
//         motorbike: 0,
//         bus: 0,
//         car: 0,
//         truck: 0,
//       };
//     }

//     VEHICLE_TYPES.forEach((type) => {
//       grouped[key][type] += numberSafe(row[type]);
//     });
//   });

//   return Object.values(grouped)
//     .map((item) => ({
//       ...item,
//       total: totalFromCounts(item),
//     }))
//     .sort((a, b) => a.label.localeCompare(b.label));
// }

// function buildDirectionData(rows) {
//   const grouped = {};

//   rows.forEach((row) => {
//     const direction = row.direction || "All Directions";

//     if (!grouped[direction]) {
//       grouped[direction] = {
//         direction,
//         auto: 0,
//         motorbike: 0,
//         bus: 0,
//         car: 0,
//         truck: 0,
//       };
//     }

//     VEHICLE_TYPES.forEach((type) => {
//       grouped[direction][type] += numberSafe(row[type]);
//     });
//   });

//   return Object.values(grouped)
//     .map((item) => ({
//       ...item,
//       total: totalFromCounts(item),
//     }))
//     .sort((a, b) => b.total - a.total);
// }

// function CameraMapFlyTo({ selectedLocation }) {
//   const map = useMap();

//   useEffect(() => {
//     if (!selectedLocation) return;

//     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
//       duration: 0.8,
//     });
//   }, [map, selectedLocation]);

//   return null;
// }

// function MiniBarChart({ title, data }) {
//   const maxValue = Math.max(...data.map((item) => item.total), 1);

//   return (
//     <div className="camera-chart-card">
//       <div className="camera-chart-header">
//         <h3>{title}</h3>
//       </div>

//       <div className="camera-bar-chart">
//         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

//         {data.map((item) => {
//           const height = Math.max(8, (item.total / maxValue) * 150);

//           return (
//             <div className="camera-bar-item" key={item.label}>
//               <div className="camera-bar-value">{item.total}</div>
//               <div className="camera-bar-track">
//                 <div
//                   className="camera-bar-fill"
//                   style={{ height: `${height}px` }}
//                 />
//               </div>
//               <div className="camera-bar-label">{item.label}</div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// function CameraDataPage({ navigate }) {
//   const [rows, setRows] = useState([]);
//   const [sourceLabel, setSourceLabel] = useState("Connecting to backend...");
//   const [loading, setLoading] = useState(true);
//   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
//   const [chartMode, setChartMode] = useState("daily");
//   const [connectionError, setConnectionError] = useState("");

//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(25);

//   const fetchCameraData = useCallback(async () => {
//     try {
//       if (!BACKEND) {
//         throw new Error("REACT_APP_BACKEND_URL is missing");
//       }

//       const res = await axios.get(`${BACKEND}/api/cameradata/latest`, {
//         params: {
//           limit: 5000,
//         },
//       });

//       const backendRows = Array.isArray(res.data)
//         ? res.data
//         : Array.isArray(res.data?.rows)
//         ? res.data.rows
//         : [];

//       const normalizedRows = backendRows.map(normalizeCameraRow);

//       setRows((prev) => mergeCameraRows(prev, normalizedRows));
//       setSourceLabel(
//         normalizedRows.length
//           ? "Live backend data"
//           : "Waiting for camera CSV data"
//       );
//       setConnectionError("");
//       setPage(1);
//     } catch (e) {
//       setConnectionError(e.message || "Failed to load camera data");
//       setSourceLabel("Backend not reachable");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchCameraData();

//     if (!BACKEND) return undefined;

//     const socket = io(BACKEND, {
//       transports: ["websocket", "polling"],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 1000,
//     });

//     socket.on("connect", () => {
//       setConnectionError("");
//       setSourceLabel("Live backend data");
//     });

//     socket.on("connect_error", () => {
//       setSourceLabel("Backend polling mode");
//     });

//     socket.on("new-camera-data", (payload) => {
//       const incoming = Array.isArray(payload)
//         ? payload
//         : Array.isArray(payload?.rows)
//         ? payload.rows
//         : payload
//         ? [payload]
//         : [];

//       if (!incoming.length) return;

//       const normalized = incoming.map(normalizeCameraRow);

//       setRows((prev) => mergeCameraRows(prev, normalized));
//       setSourceLabel("Live camera update");
//       setLoading(false);
//       setConnectionError("");
//     });

//     const refreshTimer = setInterval(fetchCameraData, 60_000);

//     return () => {
//       clearInterval(refreshTimer);
//       socket.disconnect();
//     };
//   }, [fetchCameraData]);

//   const selectedRows = useMemo(() => {
//     const hasCameraSpecificRows = rows.some((row) => row.cameraId && row.cameraId !== "ALL");

//     if (!hasCameraSpecificRows) {
//       return rows;
//     }

//     return rows.filter((row) => row.cameraId === selectedLocation.id);
//   }, [rows, selectedLocation]);

//   const totalsByCamera = useMemo(() => {
//     const grouped = {};

//     rows.forEach((row) => {
//       const key = row.cameraId || "ALL";

//       if (!grouped[key]) {
//         grouped[key] = {
//           auto: 0,
//           motorbike: 0,
//           bus: 0,
//           car: 0,
//           truck: 0,
//         };
//       }

//       VEHICLE_TYPES.forEach((type) => {
//         grouped[key][type] += numberSafe(row[type]);
//       });
//     });

//     return grouped;
//   }, [rows]);

//   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
//   const totalVehicles = totalFromCounts(totals);

//   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
//   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
//   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

//   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

//   const totalRows = selectedRows.length;
//   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
//   const safePage = Math.min(page, totalPages);
//   const offset = (safePage - 1) * limit;

//   const paginatedRows = useMemo(() => {
//     return selectedRows.slice(offset, offset + limit);
//   }, [selectedRows, offset, limit]);

//   const latestRow = selectedRows[0];

//   const handleLocationClick = (location) => {
//     setSelectedLocation(location);
//     setPage(1);
//   };

//   const handleLimitChange = (e) => {
//     setLimit(Number(e.target.value));
//     setPage(1);
//   };

//   return (
//     <div className="camera-page">
//       <div className="camera-bg-glow camera-bg-glow-one" />
//       <div className="camera-bg-glow camera-bg-glow-two" />

//       <header className="camera-navbar">
//         <button className="camera-back-button" onClick={() => navigate("/")}>
//           ← Home
//         </button>

//         <div>
//           <h1>Camera Data</h1>
//           <p>Live traffic counts by vehicle type and camera location</p>
//         </div>

//         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
//           Bus Tracking
//         </button>
//       </header>

//       <main className="camera-content">
//         <section className="camera-summary-grid">
//           <div className="camera-summary-card total">
//             <span>Total Vehicles</span>
//             <strong>{totalVehicles}</strong>
//             <small>{sourceLabel}</small>
//           </div>

//           <div className="camera-summary-card">
//             <span>Cars</span>
//             <strong>{totals.car}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Motorbikes</span>
//             <strong>{totals.motorbike}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Buses</span>
//             <strong>{totals.bus}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Trucks</span>
//             <strong>{totals.truck}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Autos</span>
//             <strong>{totals.auto}</strong>
//           </div>
//         </section>

//         {connectionError && (
//           <div className="camera-live-warning">
//             {connectionError}
//           </div>
//         )}

//         <section className="camera-map-layout">
//           <aside className="camera-location-panel">
//             <div className="camera-location-header">
//               <h2>Camera Locations</h2>
//               <p>
//                 {CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across{" "}
//                 {CAMERA_LOCATIONS.length} locations
//               </p>
//             </div>

//             <div className="camera-location-list">
//               {CAMERA_LOCATIONS.map((item) => {
//                 const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

//                 return (
//                   <button
//                     key={item.id}
//                     className={
//                       selectedLocation.id === item.id
//                         ? "camera-location-item active"
//                         : "camera-location-item"
//                     }
//                     onClick={() => handleLocationClick(item)}
//                   >
//                     <div>
//                       <strong>{item.place}</strong>
//                       <span>{item.location}</span>
//                     </div>

//                     <small>
//                       {cameraTotal} vehicles
//                     </small>
//                   </button>
//                 );
//               })}
//             </div>
//           </aside>

//           <section className="camera-map-card">
//             <MapContainer
//               center={[selectedLocation.lat, selectedLocation.lng]}
//               zoom={14}
//               className="camera-osm-map"
//               scrollWheelZoom={true}
//             >
//               <TileLayer
//                 attribution='&copy; OpenStreetMap contributors'
//                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//               />

//               <CameraMapFlyTo selectedLocation={selectedLocation} />

//               {CAMERA_LOCATIONS.map((item) => {
//                 const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

//                 return (
//                   <Marker
//                     key={item.id}
//                     position={[item.lat, item.lng]}
//                     eventHandlers={{
//                       click: () => handleLocationClick(item),
//                     }}
//                   >
//                     <Popup>
//                       <div className="camera-popup">
//                         <h3>{item.place}</h3>
//                         <p>{item.location}</p>
//                         <p>
//                           <strong>Cameras:</strong> {item.cameras}
//                         </p>
//                         <p>
//                           <strong>Total Vehicles:</strong> {cameraTotal}
//                         </p>
//                       </div>
//                     </Popup>
//                   </Marker>
//                 );
//               })}
//             </MapContainer>
//           </section>
//         </section>

//         <section className="camera-selected-panel">
//           <div>
//             <h2>{selectedLocation.place}</h2>
//             <p>{selectedLocation.location}</p>
//           </div>

//           <div className="camera-selected-meta">
//             <span>{selectedLocation.boxes} boxes</span>
//             <span>{selectedLocation.cameras} cameras</span>
//             <span>
//               {selectedLocation.lat}, {selectedLocation.lng}
//             </span>
//           </div>
//         </section>

//         <section className="camera-direction-grid">
//           {directionData.slice(0, 4).map((item) => (
//             <div className="camera-direction-card" key={item.direction}>
//               <span>{item.direction}</span>
//               <strong>{item.total}</strong>
//               <small>
//                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
//               </small>
//             </div>
//           ))}

//           {!loading && directionData.length === 0 && (
//             <div className="camera-direction-card">
//               <span>No direction data</span>
//               <strong>0</strong>
//               <small>Waiting for CSV rows</small>
//             </div>
//           )}
//         </section>

//         <section className="camera-chart-section">
//           <div className="camera-chart-toolbar">
//             <div>
//               <h2>Dashboard Analysis</h2>
//               <p>Daily and weekly traffic count trends</p>
//             </div>

//             <div className="camera-chart-toggle">
//               <button
//                 className={chartMode === "daily" ? "active" : ""}
//                 onClick={() => setChartMode("daily")}
//               >
//                 Daily
//               </button>
//               <button
//                 className={chartMode === "weekly" ? "active" : ""}
//                 onClick={() => setChartMode("weekly")}
//               >
//                 Weekly
//               </button>
//             </div>
//           </div>

//           <MiniBarChart
//             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
//             data={chartData}
//           />
//         </section>

//         <section className="camera-panel">
//           <div className="camera-panel-header">
//             <div>
//               <h2>Vehicle Count Table</h2>
//               <p>
//                 {loading
//                   ? "Loading camera data..."
//                   : latestRow
//                   ? `Latest timestamp: ${latestRow.timestamp}`
//                   : "No camera records available"}
//               </p>
//             </div>

//             <div className="camera-pagination-top">
//               <label>
//                 Limit
//                 <select value={limit} onChange={handleLimitChange}>
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                   <option value={100}>100</option>
//                   <option value={200}>200</option>
//                 </select>
//               </label>
//             </div>
//           </div>

//           <div className="camera-table-info">
//             <span>
//               Showing rows {totalRows === 0 ? 0 : offset + 1}-
//               {Math.min(offset + limit, totalRows)} of {totalRows}
//             </span>

//             <span>
//               Offset: {offset} | Limit: {limit}
//             </span>
//           </div>

//           <div className="camera-table-wrap">
//             <table className="camera-table">
//               <thead>
//                 <tr>
//                   <th>Timestamp</th>
//                   <th>Camera</th>
//                   <th>Direction</th>
//                   <th>Auto</th>
//                   <th>Motorbike</th>
//                   <th>Bus</th>
//                   <th>Car</th>
//                   <th>Truck</th>
//                   <th>Total</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedRows.map((row, index) => (
//                   <tr key={row.dedupeKey || row.id || `${row.timestamp}-${index}`}>
//                     <td>{row.timestamp}</td>
//                     <td>{row.cameraName || row.cameraId}</td>
//                     <td>{row.direction}</td>
//                     <td>{row.auto}</td>
//                     <td>{row.motorbike}</td>
//                     <td>{row.bus}</td>
//                     <td>{row.car}</td>
//                     <td>{row.truck}</td>
//                     <td>{row.total}</td>
//                   </tr>
//                 ))}

//                 {!loading && paginatedRows.length === 0 && (
//                   <tr>
//                     <td colSpan="9" style={{ textAlign: "center", padding: "24px" }}>
//                       No camera data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="camera-pagination-bottom">
//             <button
//               onClick={() => setPage((prev) => Math.max(1, prev - 1))}
//               disabled={safePage <= 1}
//             >
//               ← Previous
//             </button>

//             <span>
//               Page {safePage} of {totalPages}
//             </span>

//             <button
//               onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
//               disabled={safePage >= totalPages}
//             >
//               Next →
//             </button>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }

// /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// const CAMERA_FALLBACK_DATA = [
//   {
//     timestamp: "2025-11-01 00:00:06",
//     auto: 0,
//     motorbike: 0,
//     bus: 0,
//     car: 0,
//     truck: 0,
//   },
//   {
//     timestamp: "2025-11-01 00:00:11",
//     auto: 0,
//     motorbike: 4,
//     bus: 1,
//     car: 4,
//     truck: 0,
//   },
//   {
//     timestamp: "2025-11-01 00:00:16",
//     auto: 0,
//     motorbike: 2,
//     bus: 0,
//     car: 0,
//     truck: 1,
//   },
//   {
//     timestamp: "2025-11-01 00:00:21",
//     auto: 0,
//     motorbike: 1,
//     bus: 0,
//     car: 1,
//     truck: 1,
//   },
//   {
//     timestamp: "2025-11-01 00:00:26",
//     auto: 0,
//     motorbike: 3,
//     bus: 0,
//     car: 0,
//     truck: 0,
//   },
//   {
//     timestamp: "2025-11-01 00:00:31",
//     auto: 0,
//     motorbike: 0,
//     bus: 0,
//     car: 0,
//     truck: 0,
//   },
//   {
//     timestamp: "2025-11-01 00:00:36",
//     auto: 0,
//     motorbike: 5,
//     bus: 0,
//     car: 1,
//     truck: 1,
//   },
//   {
//     timestamp: "2025-11-01 00:00:41",
//     auto: 0,
//     motorbike: 4,
//     bus: 1,
//     car: 5,
//     truck: 1,
//   },
// ];

// // function parseCameraCsv(csvText) {
// //   const lines = csvText
// //     .trim()
// //     .split(/\r?\n/)
// //     .filter(Boolean);

// //   if (lines.length < 2) return [];

// //   const headers = lines[0].split(",").map((h) => h.trim());

// //   return lines.slice(1).map((line) => {
// //     const values = line.split(",").map((v) => v.trim());
// //     const row = {};

// //     headers.forEach((header, index) => {
// //       if (header === "timestamp") {
// //         row[header] = values[index];
// //       } else {
// //         row[header] = Number(values[index] || 0);
// //       }
// //     });

// //     return row;
// //   });
// // }

// const CAMERA_LOCATIONS = [
//   {
//     id: "camera-site-1",
//     sno: 1,
//     place: "Ettayapuram Rd",
//     location: "Perison Plaza Signal",
//     boxes: 2,
//     cameras: 2,
//     lat: 8.81277,
//     lng: 78.13647,
//   },
//   {
//     id: "camera-site-2",
//     sno: 2,
//     place: "4th Gate",
//     location: "South side of Milavittan Road",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.80967,
//     lng: 78.1335,
//   },
//   {
//     id: "camera-site-3",
//     sno: 3,
//     place: "International Furniture Park",
//     location: "Madurai - Tiruchendur Rd highway east side",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.81624,
//     lng: 78.08118,
//   },
//   {
//     id: "camera-site-4",
//     sno: 4,
//     place: "3rd Mile",
//     location: "Near TVL-TUT-MDR Bypass Bridge",
//     boxes: 2,
//     cameras: 2,
//     lat: 8.789608,
//     lng: 78.11493,
//   },
//   {
//     id: "camera-site-5",
//     sno: 5,
//     place: "Alageshapuram Road",
//     location: "Roundana near St. Thomas School",
//     boxes: 1,
//     cameras: 2,
//     lat: 8.81705,
//     lng: 78.14797,
//   },
//   {
//     id: "camera-site-6",
//     sno: 6,
//     place: "Tiruchendur Rd",
//     location: "Muthiahpuram",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.74541,
//     lng: 78.1253,
//   },
// ];

// const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// function parseCameraCsv(csvText) {
//   const lines = csvText
//     .trim()
//     .split(/\r?\n/)
//     .filter(Boolean);

//   if (lines.length < 2) return [];

//   const firstLine = lines[0].toLowerCase();
//   const hasHeader = firstLine.includes("timestamp");

//   const headers = hasHeader
//     ? lines[0].split(",").map((h) => h.trim().toLowerCase())
//     : ["timestamp", "auto", "motorbike", "bus", "car", "truck"];

//   const dataLines = hasHeader ? lines.slice(1) : lines;

//   return dataLines.map((line) => {
//     const values = line.split(",").map((v) => v.trim());
//     const row = {};

//     headers.forEach((header, index) => {
//       if (header === "timestamp") {
//         row.timestamp = values[index] || "";
//       } else if (
//         header === "cameraid" ||
//         header === "camera_id" ||
//         header === "camera" ||
//         header === "site"
//       ) {
//         row.cameraId = values[index] || "";
//       } else if (header === "direction") {
//         row.direction = values[index] || "All Directions";
//       } else {
//         row[header] = Number(values[index] || 0);
//       }
//     });

//     return {
//       timestamp: row.timestamp || "",
//       cameraId: row.cameraId || "ALL",
//       direction: row.direction || "All Directions",
//       auto: Number(row.auto || 0),
//       motorbike: Number(row.motorbike || 0),
//       bus: Number(row.bus || 0),
//       car: Number(row.car || 0),
//       truck: Number(row.truck || 0),
//     };
//   });
// }

// function sumRows(rows) {
//   return rows.reduce(
//     (acc, row) => {
//       acc.auto += Number(row.auto || 0);
//       acc.motorbike += Number(row.motorbike || 0);
//       acc.bus += Number(row.bus || 0);
//       acc.car += Number(row.car || 0);
//       acc.truck += Number(row.truck || 0);
//       return acc;
//     },
//     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
//   );
// }

// function totalFromCounts(counts) {
//   return VEHICLE_TYPES.reduce((sum, type) => sum + Number(counts[type] || 0), 0);
// }

// function getDateKey(timestamp) {
//   return String(timestamp || "").slice(0, 10);
// }

// function getWeekKey(timestamp) {
//   const datePart = getDateKey(timestamp);
//   if (!datePart) return "Unknown";

//   const date = new Date(`${datePart}T00:00:00`);
//   if (Number.isNaN(date.getTime())) return "Unknown";

//   const firstDay = new Date(date.getFullYear(), 0, 1);
//   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
//   const weekNumber = Math.ceil(dayNumber / 7);

//   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// }

// function buildChartData(rows, mode = "daily") {
//   const grouped = {};

//   rows.forEach((row) => {
//     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
//     if (!key) return;

//     if (!grouped[key]) {
//       grouped[key] = {
//         label: key,
//         auto: 0,
//         motorbike: 0,
//         bus: 0,
//         car: 0,
//         truck: 0,
//       };
//     }

//     VEHICLE_TYPES.forEach((type) => {
//       grouped[key][type] += Number(row[type] || 0);
//     });
//   });

//   return Object.values(grouped)
//     .map((item) => ({
//       ...item,
//       total: totalFromCounts(item),
//     }))
//     .sort((a, b) => a.label.localeCompare(b.label));
// }

// function buildDirectionData(rows) {
//   const grouped = {};

//   rows.forEach((row) => {
//     const direction = row.direction || "All Directions";

//     if (!grouped[direction]) {
//       grouped[direction] = {
//         direction,
//         auto: 0,
//         motorbike: 0,
//         bus: 0,
//         car: 0,
//         truck: 0,
//       };
//     }

//     VEHICLE_TYPES.forEach((type) => {
//       grouped[direction][type] += Number(row[type] || 0);
//     });
//   });

//   return Object.values(grouped).map((item) => ({
//     ...item,
//     total: totalFromCounts(item),
//   }));
// }

// function CameraMapFlyTo({ selectedLocation }) {
//   const map = useMap();

//   useEffect(() => {
//     if (!selectedLocation) return;

//     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
//       duration: 0.8,
//     });
//   }, [map, selectedLocation]);

//   return null;
// }

// function MiniBarChart({ title, data }) {
//   const maxValue = Math.max(...data.map((item) => item.total), 1);

//   return (
//     <div className="camera-chart-card">
//       <div className="camera-chart-header">
//         <h3>{title}</h3>
//       </div>

//       <div className="camera-bar-chart">
//         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

//         {data.map((item) => {
//           const height = Math.max(8, (item.total / maxValue) * 150);

//           return (
//             <div className="camera-bar-item" key={item.label}>
//               <div className="camera-bar-value">{item.total}</div>
//               <div className="camera-bar-track">
//                 <div
//                   className="camera-bar-fill"
//                   style={{ height: `${height}px` }}
//                 />
//               </div>
//               <div className="camera-bar-label">{item.label}</div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// function CameraDataPage({ navigate }) {
//   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
//   const [sourceLabel, setSourceLabel] = useState("Static sample data");
//   const [loading, setLoading] = useState(true);
//   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
//   const [chartMode, setChartMode] = useState("daily");

//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(25);

//   useEffect(() => {
//     const csvUrl =
//       process.env.REACT_APP_CAMERA_CSV_URL ||
//       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

//     fetch(csvUrl)
//       .then((res) => {
//         if (!res.ok) throw new Error("CSV not found");
//         return res.text();
//       })
//       .then((text) => {
//         const parsed = parseCameraCsv(text);
//         if (parsed.length > 0) {
//           setRows(parsed.reverse());
//           setSourceLabel("CSV data");
//           setPage(1);
//         }
//       })
//       .catch(() => {
//         setRows(CAMERA_FALLBACK_DATA);
//         setSourceLabel("Static sample data");
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   const selectedRows = useMemo(() => {
//     const hasCameraSpecificRows = rows.some((row) => row.cameraId !== "ALL");

//     if (!hasCameraSpecificRows) {
//       return rows;
//     }

//     return rows.filter((row) => row.cameraId === selectedLocation.id);
//   }, [rows, selectedLocation]);

//   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
//   const totalVehicles = totalFromCounts(totals);

//   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
//   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
//   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

//   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

//   const totalRows = selectedRows.length;
//   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
//   const safePage = Math.min(page, totalPages);
//   const offset = (safePage - 1) * limit;

//   const paginatedRows = useMemo(() => {
//     return selectedRows.slice(offset, offset + limit);
//   }, [selectedRows, offset, limit]);

//   const latestRow = selectedRows[0];

//   const handleLocationClick = (location) => {
//     setSelectedLocation(location);
//     setPage(1);
//   };

//   const handleLimitChange = (e) => {
//     setLimit(Number(e.target.value));
//     setPage(1);
//   };

//   return (
//     <div className="camera-page">
//       <div className="camera-bg-glow camera-bg-glow-one" />
//       <div className="camera-bg-glow camera-bg-glow-two" />

//       <header className="camera-navbar">
//         <button className="camera-back-button" onClick={() => navigate("/")}>
//           ← Home
//         </button>

//         <div>
//           <h1>Camera Data</h1>
//           <p>Traffic counts by vehicle type and camera location</p>
//         </div>

//         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
//           Bus Tracking
//         </button>
//       </header>

//       <main className="camera-content">
//         <section className="camera-summary-grid">
//           <div className="camera-summary-card total">
//             <span>Total Vehicles</span>
//             <strong>{totalVehicles}</strong>
//             <small>{sourceLabel}</small>
//           </div>

//           <div className="camera-summary-card">
//             <span>Cars</span>
//             <strong>{totals.car}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Motorbikes</span>
//             <strong>{totals.motorbike}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Buses</span>
//             <strong>{totals.bus}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Trucks</span>
//             <strong>{totals.truck}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Autos</span>
//             <strong>{totals.auto}</strong>
//           </div>
//         </section>

//         <section className="camera-map-layout">
//           <aside className="camera-location-panel">
//             <div className="camera-location-header">
//               <h2>Camera Locations</h2>
//               <p>{CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across {CAMERA_LOCATIONS.length} locations</p>
//             </div>

//             <div className="camera-location-list">
//               {CAMERA_LOCATIONS.map((item) => (
//                 <button
//                   key={item.id}
//                   className={
//                     selectedLocation.id === item.id
//                       ? "camera-location-item active"
//                       : "camera-location-item"
//                   }
//                   onClick={() => handleLocationClick(item)}
//                 >
//                   <div>
//                     <strong>{item.place}</strong>
//                     <span>{item.location}</span>
//                   </div>

//                   <small>
//                     {item.cameras} camera{item.cameras > 1 ? "s" : ""}
//                   </small>
//                 </button>
//               ))}
//             </div>
//           </aside>

//           <section className="camera-map-card">
//             <MapContainer
//               center={[selectedLocation.lat, selectedLocation.lng]}
//               zoom={14}
//               className="camera-osm-map"
//               scrollWheelZoom={true}
//             >
//               <TileLayer
//                 attribution='&copy; OpenStreetMap contributors'
//                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//               />

//               <CameraMapFlyTo selectedLocation={selectedLocation} />

//               {CAMERA_LOCATIONS.map((item) => (
//                 <Marker
//                   key={item.id}
//                   position={[item.lat, item.lng]}
//                   eventHandlers={{
//                     click: () => handleLocationClick(item),
//                   }}
//                 >
//                   <Popup>
//                     <div className="camera-popup">
//                       <h3>{item.place}</h3>
//                       <p>{item.location}</p>
//                       <p>
//                         <strong>Cameras:</strong> {item.cameras}
//                       </p>
//                       <p>
//                         <strong>Total Vehicles:</strong>{" "}
//                         {selectedLocation.id === item.id ? totalVehicles : "Click location"}
//                       </p>
//                     </div>
//                   </Popup>
//                 </Marker>
//               ))}
//             </MapContainer>
//           </section>
//         </section>

//         <section className="camera-selected-panel">
//           <div>
//             <h2>{selectedLocation.place}</h2>
//             <p>{selectedLocation.location}</p>
//           </div>

//           <div className="camera-selected-meta">
//             <span>{selectedLocation.boxes} boxes</span>
//             <span>{selectedLocation.cameras} cameras</span>
//             <span>
//               {selectedLocation.lat}, {selectedLocation.lng}
//             </span>
//           </div>
//         </section>

//         {/* <section className="camera-direction-grid">
//           {directionData.map((item) => (
//             <div className="camera-direction-card" key={item.direction}>
//               <span>{item.direction}</span>
//               <strong>{item.total}</strong>
//               <small>
//                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
//               </small>
//             </div>
//           ))}
//         </section> */}

//         <section className="camera-chart-section">
//           <div className="camera-chart-toolbar">
//             <div>
//               <h2>Dashboard Analysis</h2>
//               <p>Daily and weekly traffic count trends</p>
//             </div>

//             <div className="camera-chart-toggle">
//               <button
//                 className={chartMode === "daily" ? "active" : ""}
//                 onClick={() => setChartMode("daily")}
//               >
//                 Daily
//               </button>
//               <button
//                 className={chartMode === "weekly" ? "active" : ""}
//                 onClick={() => setChartMode("weekly")}
//               >
//                 Weekly
//               </button>
//             </div>
//           </div>

//           <MiniBarChart
//             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
//             data={chartData}
//           />
//         </section>

//         <section className="camera-panel">
//           <div className="camera-panel-header">
//             <div>
//               <h2>Vehicle Count Table</h2>
//               <p>
//                 {loading
//                   ? "Loading camera data..."
//                   : latestRow
//                   ? `Latest timestamp: ${latestRow.timestamp}`
//                   : "No camera records available"}
//               </p>
//             </div>

//             <div className="camera-pagination-top">
//               <label>
//                 Limit
//                 <select value={limit} onChange={handleLimitChange}>
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                   <option value={100}>100</option>
//                   <option value={200}>200</option>
//                 </select>
//               </label>
//             </div>
//           </div>

//           <div className="camera-table-info">
//             <span>
//               Showing rows {totalRows === 0 ? 0 : offset + 1}-
//               {Math.min(offset + limit, totalRows)} of {totalRows}
//             </span>

//             <span>
//               Offset: {offset} | Limit: {limit}
//             </span>
//           </div>

//           <div className="camera-table-wrap">
//             <table className="camera-table">
//               <thead>
//                 <tr>
//                   <th>Timestamp</th>
//                   <th>Direction</th>
//                   <th>Auto</th>
//                   <th>Motorbike</th>
//                   <th>Bus</th>
//                   <th>Car</th>
//                   <th>Truck</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedRows.map((row, index) => (
//                   <tr key={`${row.timestamp}-${index}`}>
//                     <td>{row.timestamp}</td>
//                     <td>{row.direction}</td>
//                     <td>{row.auto}</td>
//                     <td>{row.motorbike}</td>
//                     <td>{row.bus}</td>
//                     <td>{row.car}</td>
//                     <td>{row.truck}</td>
//                   </tr>
//                 ))}

//                 {!loading && paginatedRows.length === 0 && (
//                   <tr>
//                     <td colSpan="7" style={{ textAlign: "center", padding: "24px" }}>
//                       No camera data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="camera-pagination-bottom">
//             <button onClick={() => setPage((prev) => Math.max(1, prev - 1))} disabled={safePage <= 1}>
//               ← Previous
//             </button>

//             <span>
//               Page {safePage} of {totalPages}
//             </span>

//             <button onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))} disabled={safePage >= totalPages}>
//               Next →
//             </button>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }
// // function CameraDataPage({ navigate }) {
// //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// //   const [loading, setLoading] = useState(true);

// //   // Pagination states
// //   const [page, setPage] = useState(1);
// //   const [limit, setLimit] = useState(25);

// //   useEffect(() => {
// //     const csvUrl =
// //       process.env.REACT_APP_CAMERA_CSV_URL ||
// //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// //     fetch(csvUrl)
// //       .then((res) => {
// //         if (!res.ok) throw new Error("CSV not found");
// //         return res.text();
// //       })
// //       .then((text) => {
// //         const parsed = parseCameraCsv(text);
// //         if (parsed.length > 0) {
// //           // latest data first
// //           setRows(parsed.reverse());
// //           setSourceLabel("CSV data");
// //           setPage(1);
// //         }
// //       })
// //       .catch(() => {
// //         setRows(CAMERA_FALLBACK_DATA);
// //         setSourceLabel("Static sample data");
// //       })
// //       .finally(() => setLoading(false));
// //   }, []);

// //   const totals = useMemo(() => {
// //     return rows.reduce(
// //       (acc, row) => {
// //         acc.auto += Number(row.auto || 0);
// //         acc.motorbike += Number(row.motorbike || 0);
// //         acc.bus += Number(row.bus || 0);
// //         acc.car += Number(row.car || 0);
// //         acc.truck += Number(row.truck || 0);
// //         return acc;
// //       },
// //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// //     );
// //   }, [rows]);

// //   const totalVehicles =
// //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// //   const totalRows = rows.length;
// //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// //   const safePage = Math.min(page, totalPages);

// //   const offset = (safePage - 1) * limit;

// //   const paginatedRows = useMemo(() => {
// //     return rows.slice(offset, offset + limit);
// //   }, [rows, offset, limit]);

// //   const latestRow = rows[0];

// //   const goToPreviousPage = () => {
// //     setPage((prev) => Math.max(1, prev - 1));
// //   };

// //   const goToNextPage = () => {
// //     setPage((prev) => Math.min(totalPages, prev + 1));
// //   };

// //   const handleLimitChange = (e) => {
// //     setLimit(Number(e.target.value));
// //     setPage(1);
// //   };

// //   return (
// //     <div className="camera-page">
// //       <div className="camera-bg-glow camera-bg-glow-one" />
// //       <div className="camera-bg-glow camera-bg-glow-two" />

// //       <header className="camera-navbar">
// //         <button className="camera-back-button" onClick={() => navigate("/")}>
// //           ← Home
// //         </button>

// //         <div>
// //           <h1>Camera Data</h1>
// //           <p>Vehicle count analytics</p>
// //         </div>

// //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// //           Bus Tracking
// //         </button>
// //       </header>

// //       <main className="camera-content">
// //         <section className="camera-summary-grid">
// //           <div className="camera-summary-card total">
// //             <span>Total Vehicles</span>
// //             <strong>{totalVehicles}</strong>
// //             <small>{sourceLabel}</small>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Cars</span>
// //             <strong>{totals.car}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Motorbikes</span>
// //             <strong>{totals.motorbike}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Buses</span>
// //             <strong>{totals.bus}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Trucks</span>
// //             <strong>{totals.truck}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Autos</span>
// //             <strong>{totals.auto}</strong>
// //           </div>
// //         </section>

// //         <section className="camera-panel">
// //           <div className="camera-panel-header">
// //             <div>
// //               <h2>Vehicle Count Table</h2>
// //               <p>
// //                 {loading
// //                   ? "Loading camera data..."
// //                   : latestRow
// //                     ? `Latest timestamp: ${latestRow.timestamp}`
// //                     : "No camera records available"}
// //               </p>
// //             </div>

// //             <div className="camera-pagination-top">
// //               <label>
// //                 Limit
// //                 <select value={limit} onChange={handleLimitChange}>
// //                   <option value={10}>10</option>
// //                   <option value={25}>25</option>
// //                   <option value={50}>50</option>
// //                   <option value={100}>100</option>
// //                   <option value={200}>200</option>
// //                 </select>
// //               </label>
// //             </div>
// //           </div>

// //           <div className="camera-table-info">
// //             <span>
// //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// //               {Math.min(offset + limit, totalRows)} of {totalRows}
// //             </span>

// //             <span>
// //               Offset: {offset} | Limit: {limit}
// //             </span>
// //           </div>

// //           <div className="camera-table-wrap">
// //             <table className="camera-table">
// //               <thead>
// //                 <tr>
// //                   <th>Timestamp</th>
// //                   <th>Auto</th>
// //                   <th>Motorbike</th>
// //                   <th>Bus</th>
// //                   <th>Car</th>
// //                   <th>Truck</th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {paginatedRows.map((row, index) => (
// //                   <tr key={`${row.timestamp}-${index}`}>
// //                     <td>{row.timestamp}</td>
// //                     <td>{row.auto}</td>
// //                     <td>{row.motorbike}</td>
// //                     <td>{row.bus}</td>
// //                     <td>{row.car}</td>
// //                     <td>{row.truck}</td>
// //                   </tr>
// //                 ))}

// //                 {!loading && paginatedRows.length === 0 && (
// //                   <tr>
// //                     <td colSpan="6" style={{ textAlign: "center", padding: "24px" }}>
// //                       No camera data available
// //                     </td>
// //                   </tr>
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>

// //           <div className="camera-pagination-bottom">
// //             <button onClick={goToPreviousPage} disabled={safePage <= 1}>
// //               ← Previous
// //             </button>

// //             <span>
// //               Page {safePage} of {totalPages}
// //             </span>

// //             <button onClick={goToNextPage} disabled={safePage >= totalPages}>
// //               Next →
// //             </button>
// //           </div>
// //         </section>
// //       </main>
// //     </div>
// //   );
// // }
// // function CameraDataPage({ navigate }) {
// //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     const csvUrl =
// //       process.env.REACT_APP_CAMERA_CSV_URL ||
// //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// //     fetch(csvUrl)
// //       .then((res) => {
// //         if (!res.ok) throw new Error("CSV not found");
// //         return res.text();
// //       })
// //       .then((text) => {
// //         const parsed = parseCameraCsv(text);
// //         if (parsed.length > 0) {
// //           setRows(parsed);
// //           setSourceLabel("CSV data");
// //         }
// //       })
// //       .catch(() => {
// //         setRows(CAMERA_FALLBACK_DATA);
// //         setSourceLabel("Static sample data");
// //       })
// //       .finally(() => setLoading(false));
// //   }, []);

// //   const totals = useMemo(() => {
// //     return rows.reduce(
// //       (acc, row) => {
// //         acc.auto += Number(row.auto || 0);
// //         acc.motorbike += Number(row.motorbike || 0);
// //         acc.bus += Number(row.bus || 0);
// //         acc.car += Number(row.car || 0);
// //         acc.truck += Number(row.truck || 0);
// //         return acc;
// //       },
// //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// //     );
// //   }, [rows]);

// //   const totalVehicles =
// //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// //   const latestRow = rows[rows.length - 1];

// //   return (
// //     <div className="camera-page">
// //       <div className="camera-bg-glow camera-bg-glow-one" />
// //       <div className="camera-bg-glow camera-bg-glow-two" />

// //       <header className="camera-navbar">
// //         <button className="camera-back-button" onClick={() => navigate("/")}>
// //           ← Home
// //         </button>

// //         <div>
// //           <h1>Camera Data</h1>
// //           <p>Vehicle count analytics</p>
// //         </div>

// //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// //           Bus Tracking
// //         </button>
// //       </header>

// //       <main className="camera-content">
// //         <section className="camera-summary-grid">
// //           <div className="camera-summary-card total">
// //             <span>Total Vehicles</span>
// //             <strong>{totalVehicles}</strong>
// //             <small>{sourceLabel}</small>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Cars</span>
// //             <strong>{totals.car}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Motorbikes</span>
// //             <strong>{totals.motorbike}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Buses</span>
// //             <strong>{totals.bus}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Trucks</span>
// //             <strong>{totals.truck}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Autos</span>
// //             <strong>{totals.auto}</strong>
// //           </div>
// //         </section>

// //         <section className="camera-panel">
// //           <div className="camera-panel-header">
// //             <div>
// //               <h2>Vehicle Count Table</h2>
// //               <p>
// //                 {loading
// //                   ? "Loading camera data..."
// //                   : latestRow
// //                   ? `Latest timestamp: ${latestRow.timestamp}`
// //                   : "No camera records available"}
// //               </p>
// //             </div>
// //           </div>

// //           <div className="camera-table-wrap">
// //             <table className="camera-table">
// //               <thead>
// //                 <tr>
// //                   <th>Timestamp</th>
// //                   <th>Auto</th>
// //                   <th>Motorbike</th>
// //                   <th>Bus</th>
// //                   <th>Car</th>
// //                   <th>Truck</th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {rows.map((row, index) => (
// //                   <tr key={`${row.timestamp}-${index}`}>
// //                     <td>{row.timestamp}</td>
// //                     <td>{row.auto}</td>
// //                     <td>{row.motorbike}</td>
// //                     <td>{row.bus}</td>
// //                     <td>{row.car}</td>
// //                     <td>{row.truck}</td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </section>
// //       </main>
// //     </div>
// //   );
// // }

/* ---------------------------- APP (router) ---------------------------- */

function App() {
  const { path, navigate } = usePath();
  const token = getToken();
  const adminToken = getAdminToken();

  // Track page views on bus tracking page for Prometheus
  useEffect(() => {
    if (!BACKEND) return;
    if (path !== "/tracking") return;
    axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
  }, [path]);

  // Forward /driver -> /driverRoute when logged in
  useEffect(() => {
    if (path === "/driver" && token) {
      navigate("/driverRoute");
    }
  }, [path, token, navigate]);

  // Admin redirects
  useEffect(() => {
    if (path === "/admin/login" && adminToken) {
      navigate("/admin");
    } else if (path === "/admin" && !adminToken) {
      navigate("/admin/login");
    }
  }, [path, adminToken, navigate]);

  // New public pages
  if (path === "/") {
    return <HomePage navigate={navigate} />;
  }

  if (path === "/tracking") {
    return <MapPage />;
  }

  if (path === "/camera") {
    return <CameraDataPage navigate={navigate} />;
  }

  if (path === "/simulation") {
    return <SimulationPage navigate={navigate} />;
  }

  // Existing driver pages
  if (path === "/driver") {
    if (token) return null;
    return <DriverLogin navigate={navigate} />;
  }

  if (path === "/driverRoute") {
    return <DriverRoute navigate={navigate} />;
  }

  // Existing admin pages
  if (path === "/admin/login") {
    if (adminToken) return null;
    return <AdminLogin navigate={navigate} />;
  }

  if (path === "/admin") {
    return <AdminDashboard navigate={navigate} />;
  }

  // Fallback
  return <HomePage navigate={navigate} />;
}

// export default function App() {
//   const { path, navigate } = usePath();
//   const token = getToken();
//   const adminToken = getAdminToken();

//   // Track page views on main map for Prometheus
//   useEffect(() => {
//     if (!BACKEND) return;
//     if (path !== "/") return;
//     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
//   }, [path]);

//   // Forward /driver -> /driverRoute when logged in
//   useEffect(() => {
//     if (path === "/driver" && token) {
//       navigate("/driverRoute");
//     }
//   }, [path, token, navigate]);

//   // Admin redirects
//   useEffect(() => {
//     if (path === "/admin/login" && adminToken) {
//       navigate("/admin");
//     } else if (path === "/admin" && !adminToken) {
//       navigate("/admin/login");
//     }
//   }, [path, adminToken, navigate]);

//   if (path === "/driver") {
//     if (token) return null;
//     return <DriverLogin navigate={navigate} />;
//   }
//   if (path === "/driverRoute") return <DriverRoute navigate={navigate} />;

//   if (path === "/admin/login") {
//     if (adminToken) return null;
//     return <AdminLogin navigate={navigate} />;
//   }
//   if (path === "/admin") {
//     return <AdminDashboard navigate={navigate} />;
//   }

//   return <MapPage />;
// }

// export default function App() {
//   const { path, navigate } = usePath();
//   const token = getToken();

//   // Track page views on main map for Prometheus
//   useEffect(() => {
//     if (!BACKEND) return;
//     if (path !== "/") return;
//     axios.post(`${BACKEND}/api/track/page-view`).catch(() => {});
//   }, [path]);

//   // Forward /driver -> /driverRoute when logged in (no hooks called conditionally)
//   useEffect(() => {
//     if (path === '/driver' && token) {
//       navigate('/driverRoute');
//     }
//   }, [path, token, navigate]);

//   if (path === '/driver') {
//     if (token) return null;
//     return <DriverLogin navigate={navigate} />;
//   }
//   if (path === '/driverRoute') return <DriverRoute navigate={navigate} />;
//   return <MapPage />;
// }

export { App };
export default App;



// // thoothukudi/frontend/src/App.js
// // import React, { useEffect, useState, useRef, useLayoutEffect, useMemo } from 'react';
// import React, {
//   useEffect,
//   useState,
//   useRef,
//   useMemo,
//   useCallback
// } from 'react';

// import axios from 'axios';
// import { io } from 'socket.io-client';
// import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import './App.css';
// import * as turf from '@turf/turf';

// // ---- Assets in src/assets ----
// import userIcon from './assets/user-icon.png';
// import stopIconImg from './assets/bus-stop.png';
// // import iitmLogo from './assets/iitm-logo.png';
// import iitmLogo from './assets/mint_logo.png';

// // ---- Backend base URL ----
// const BACKEND = process.env.REACT_APP_BACKEND_URL;
// // API key is not needed on the frontend after removing ETA polling.
// const FEEDBACK_URL = process.env.REACT_APP_FEEDBACK_URL || '';


// // ---- Static roads URL (public/roads.geojson) ----
// const ROADS_URL = `${process.env.PUBLIC_URL || ''}/roads.geojson`;

// // ---- Map zoom param ----
// const DEFAULT_ZOOM = 16;

// // ---- Smoothing / Snap params ----
// const SMOOTH_ALPHA = 0.3;
// const HEADING_ALPHA = 0.35;
// const SNAP_MAX_DIST_M = 20;

// // Staleness threshold for under-maintenance banner
// const STALE_MS = 150_000; // ~2.5 minutes

// // Initial center (fallback)
// // const center = { lat: 12.9915, lng: 80.2336 };
// const center = { lat: 8.7642, lng: 78.1348 };

// // ---------------- STOPS WITH IDS (for route math) ----------------
// // const busStops = [
// //   { name: 'Velachery Gate IIT Campus Stop', lat: 12.988763557585395, lng: 80.22367960515129, id: 1 },
// //   { name: 'NAC2 Stop Towards GC', lat: 12.990236, lng: 80.227548, id: 2 },
// //   { name: 'Nac2 Towards Velachery Stop', lat: 12.9898636, lng: 80.2271109, id: 3 },
// //   { name: 'CRC Towards GC Stop', lat: 12.99089, lng: 80.230274, id: 4 },
// //   { name: 'CRC Towards Velachery Stop', lat: 12.99079680, lng: 80.23016660, id: 5 },  
// //   { name: 'HSB Stop Towards Velachery Stop', lat: 12.99076780, lng: 80.23168950, id: 6},
// //   { name: 'HSB Stop Towards GC', lat: 12.991037, lng: 80.232065, id: 7},
// //   { name: 'KV Stop Towards Main Gate', lat: 12.991868573807471, lng: 80.23367454352295, id: 8 },
// //   { name: 'KV Stop Towards GC', lat: 12.991910, lng: 80.233785, id: 9 },
// //   { name: 'Postoffice Stop Towards Main Gate', lat: 12.99388680, lng: 80.23428760, id: 10 },
// //   { name: 'Postoffice Stop Towards GC', lat: 12.99393340, lng: 80.23459350, id: 11 },
// //   { name: 'E1 Stop Towards Main Gate', lat: 12.9960173, lng: 80.2359173, id: 12 },
// //   { name: 'E1 Stop Towards GC', lat: 12.996117, lng: 80.236184, id: 13},
// //   { name: 'Vana Vani Stop Towards Main Gate', lat: 12.998704, lng: 80.2391799, id: 14 },
// //   { name: 'Vana Vani Stop Towards GC', lat: 12.999084,   lng:  80.239380, id: 15 },
// //   { name: 'D1 Stop Towards Main Gate', lat:13.002546, lng: 80.240091, id: 16},
// //   { name: 'D1 Stop Towards GC', lat: 13.002679,  lng: 80.240219, id: 17 },
// //   { name: 'Main Gate', lat: 13.00612964850378, lng: 80.24191299117685, id: 18 },
// //   { name: 'GC Stop Towards Hostel', lat: 12.991342, lng: 80.233637, id: 19 },
// //   { name: 'Library Stop', lat: 12.9907517, lng: 80.2334554, id: 20 },
// //   { name: 'OAT Stop Towards Hostel', lat: 12.989257,  lng: 80.233031, id: 21},
// //   { name: 'Gymkhana Stop Towards GC', lat: 12.9866372, lng: 80.2332951, id: 22},
// //   { name: 'Gymkhana Stop Towards Hostel', lat: 12.986615, lng: 80.233366, id: 23 },
// //   { name: 'Narmada Stop Towards GC', lat: 12.9862759, lng: 80.2350107, id: 24 },
// //   { name: 'Narmada Stop Towards Hostel', lat: 12.986546, lng: 80.235301, id: 25 },
// //   { name: 'Jamuna and Ganga Stand', lat: 12.986566332825637, lng: 80.23855704439099, id: 26 },
// //   { name: 'RP Stand', lat: 12.990088, lng: 80.241799, id: 28},
// //   { name: 'ED Stand', lat: 12.989874633072303, lng: 80.22646042038593, id: 29},
// // ];

// const busStops = [
//   { name: "THOOTHUKUDI OLD B/S", lat: 8.803153, lng: 78.140603, id: 1 },
//   { name: "VOC COLLEGE", lat: 8.795628, lng: 78.126712, id: 2 },
//   { name: "3RD MILE", lat: 8.790018, lng: 78.115506, id: 3 },
//   { name: "KORAMPALLAM", lat: 8.778041, lng: 78.092443, id: 4 },
//   { name: "ANTHONIYARPURAM", lat: 8.773973, lng: 78.085733, id: 5 },
//   { name: "THATTAPARAI JUNCTION", lat: 8.755951, lng: 78.065920, id: 6 },
//   { name: "PUDHUKOTTAI", lat: 8.745961, lng: 78.053331, id: 7 },
//   { name: "SIRUPADU JUNCTION", lat: 8.741241, lng: 78.057561, id: 8 },
//   { name: "KOOTTAMPULI", lat: 8.721905, lng: 78.065464, id: 9 },
//   { name: "SERVAIKARANMADAM", lat: 8.706851, lng: 78.055434, id: 10 },
//   { name: "JAKKAMMALPURAM", lat: 8.696665, lng: 78.048089, id: 11 },
//   { name: "SEBATHAIAHPURAM", lat: 8.685897, lng: 78.043820, id: 12 },
//   { name: "SAWYERPURAM", lat: 8.683487, lng: 78.031302, id: 13 },
//   { name: "SUBRAMANIYAPURAM", lat: 8.674211, lng: 78.026536, id: 14 },
//   { name: "RAMASAMYPURAM BRIDGE", lat: 8.669235, lng: 78.031267, id: 15 },
//   { name: "PERUMPADAI SASTHA KOVIL", lat: 8.671132, lng: 78.041593, id: 16 },
//   { name: "RAMASAMYPURAM", lat: 8.669235, lng: 78.031267, id: 17 },
//   { name: "ZAKKAMMALPURAM", lat: 8.653646, lng: 78.025552, id: 18 },
//   { name: "SIRUTHONDANALLUR", lat: 8.634397, lng: 78.019538, id: 19 },
//   { name: "ERAL", lat: 8.625024, lng: 78.025350, id: 20 },
//   { name: "MANGALAGIRI", lat: 8.740194, lng: 78.037454, id: 21 },
//   { name: "ALLIKULAM", lat: 8.761745, lng: 78.027343, id: 22 },
//   { name: "THIRUVANANDHA PURAM", lat: 8.770303, lng: 78.018599, id: 23 },
//   { name: "PEROORANI", lat: 8.766952, lng: 78.001463, id: 24 },
//   { name: "UZHAVAR SANTHAI", lat: 8.809685, lng: 78.137081, id: 25 },
//   { name: "4TH GATE", lat: 8.809664, lng: 78.133561, id: 26 },
//   { name: "THRES PURAM", lat: 8.815399, lng: 78.160791, id: 27 },
//   { name: "SUB COLLECTOR OFFICE", lat: 8.803112, lng: 78.158268, id: 28 },
//   { name: "MILLER PURAM", lat: 8.795547, lng: 78.125969, id: 29 },
//   { name: "NATTATTHI", lat: 8.668795, lng: 78.009948, id: 30 },
//   { name: "PANDARAVILAI", lat: 8.657570, lng: 77.999515, id: 31 },
//   { name: "PERUNKULAM", lat: 8.642502, lng: 77.997765, id: 32 },
//   { name: "SIVAKALAI", lat: 8.640133, lng: 77.977687, id: 33 },
//   { name: "KULAIYANKARISAL", lat: 8.719266, lng: 78.077173, id: 34 },
//   { name: "SIRUPADU", lat: 8.739285, lng: 78.067272, id: 35 },
//   { name: "PEIKULAM", lat: 8.706840, lng: 78.055406, id: 36 },
//   { name: "SALAI", lat: 8.696664, lng: 78.048079, id: 37 },
//   { name: "MANGALAKURICHI", lat: 8.625375, lng: 77.997223, id: 38 },
//   { name: "THIRD MILE", lat: 8.790018, lng: 78.115506, id: 39 },
//   { name: "SUBRAMANIAPURAM", lat: 8.674211, lng: 78.026536, id: 40 },
//   { name: "MARKET", lat: 8.801757, lng: 78.139084, id: 41 },
//   { name: "LEVANJIPURAM", lat: 8.789036, lng: 78.141181, id: 42 },
//   { name: "UPPATTHU ODAI", lat: 8.771189, lng: 78.134295, id: 43 },
//   { name: "MUTHAIAHPURAM", lat: 8.742466, lng: 78.123763, id: 44 },
//   { name: "SPIC NAGAR", lat: 8.739716, lng: 78.122362, id: 45 },
//   { name: "MULLAKADU", lat: 8.727742, lng: 78.116493, id: 46 },
//   { name: "MADHIKETTAN ODAI", lat: 8.702375, lng: 78.106893, id: 47 },
//   { name: "KOVANKADU JUNCTION", lat: 8.690703, lng: 78.103970, id: 48 },
//   { name: "PALAIYA KAYAL", lat: 8.671247, lng: 78.094375, id: 49 },
//   { name: "CHAMBER", lat: 8.649106, lng: 78.083705, id: 50 },
//   { name: "MUKKANI", lat: 8.634530, lng: 78.073992, id: 51 },
//   { name: "UMARIKADU", lat: 8.626411, lng: 78.059076, id: 52 },
//   { name: "VAZHAVALLAN", lat: 8.631211, lng: 78.047511, id: 53 },
//   { name: "WATER TANK", lat: 8.625474, lng: 78.052962, id: 54 },
//   { name: "SETHUSUBRAMANIAPURAM", lat: 8.616498, lng: 78.029879, id: 55 },
//   { name: "KURUMBUR", lat: 8.591328, lng: 78.044404, id: 56 },
//   { name: "KURUMBUR R/S", lat: 8.585888, lng: 78.039294, id: 57 },
//   { name: "AMERICAN HOSPITAL", lat: 8.813731, lng: 78.146898, id: 58 },
//   { name: "KEBI", lat: 8.814688, lng: 78.151524, id: 59 },
//   { name: "MURUGAN THEATRE", lat: 8.819765, lng: 78.155648, id: 60 },
//   { name: "RAJA PALAIYAM", lat: 8.827343, lng: 78.153629, id: 61 },
//   { name: "THALAMUTHU NAGAR", lat: 8.834404, lng: 78.152257, id: 62 },
//   { name: "AROCKIAPURAM", lat: 8.825379, lng: 78.149005, id: 63 },
//   { name: "SAVARAIYARPURAM", lat: 8.834448, lng: 78.144850, id: 64 },
//   { name: "SAVARAIYARPURAM JUNCTION", lat: 8.839360, lng: 78.143028, id: 65 },
//   { name: "STATE BANK COLONY", lat: 8.817087, lng: 78.132907, id: 66 },
//   { name: "MAPPILLAIYOORANI", lat: 8.831674, lng: 78.127735, id: 67 },
//   { name: "KALI KOVIL JUNCTION", lat: 8.836141, lng: 78.126243, id: 68 },
//   { name: "ODAIPATTI PUDHUR", lat: 8.853648, lng: 78.120200, id: 69 },
//   { name: "VELAYUTHAPURAM", lat: 8.859844, lng: 78.107125, id: 70 },
//   { name: "NAINAR PURAM", lat: 8.866548, lng: 78.091527, id: 71 },
//   { name: "CHILLANATTHAM", lat: 8.873462, lng: 78.071265, id: 72 },
//   { name: "RAJAVIN KOVIL", lat: 8.873143, lng: 78.048237, id: 73 },
//   { name: "PUTHIYAMPUTHUR", lat: 8.872962, lng: 78.032288, id: 74 },
//   { name: "MUPPULIPATI", lat: 8.900392, lng: 78.025670, id: 75 },
//   { name: "OTTAPIDARAM", lat: 8.909341, lng: 78.022479, id: 76 },
//   { name: "THOOTHUKUDI NEW B/S", lat: 8.810793, lng: 78.138305, id: 77 },
//   { name: "BYPASS", lat: 8.785154, lng: 78.106127, id: 78 },
//   { name: "MADATTHOOR", lat: 8.794360, lng: 78.097304, id: 79 },
//   { name: "SIPCOT COMPLEX", lat: 8.804587, lng: 78.084655, id: 80 },
//   { name: "RAILWAY GATE", lat: 8.812567, lng: 78.080637, id: 81 },
//   { name: "VEERAPANDIAPURAM", lat: 8.827254, lng: 78.065695, id: 82 },
//   { name: "KAYALOORANI", lat: 8.840263, lng: 78.061390, id: 83 },
//   { name: "SAMYNATTHAM", lat: 8.864407, lng: 78.055924, id: 84 },
//   { name: "OSANOOTTHU", lat: 8.891915, lng: 77.982711, id: 85 },
//   { name: "KOMBADI", lat: 8.879422, lng: 77.963106, id: 86 },
//   { name: "PANDIAPURAM", lat: 8.862311, lng: 77.934601, id: 87 },
//   { name: "PARAIKUTTAM", lat: 8.858671, lng: 77.924877, id: 88 },
//   { name: "VADAMALAPURAM", lat: 8.860927, lng: 77.906750, id: 89 },
//   { name: "MANIYACCHI", lat: 8.863306, lng: 77.894711, id: 90 },
//   { name: "OTTANATTHAM", lat: 8.903988, lng: 77.898311, id: 91 },
//   { name: "KALLATTHIKINARU", lat: 8.919118, lng: 77.885396, id: 92 },
//   { name: "MALAIPATTI", lat: 8.936648, lng: 77.888163, id: 93 },
//   { name: "ILAVELANKAL", lat: 8.946648, lng: 77.864022, id: 94 },
//   { name: "IYRAVIPATTI", lat: 8.932030, lng: 77.864758, id: 95 },
//   { name: "PARIVALLIKOTTAI", lat: 8.923368, lng: 77.874054, id: 96 },
//   { name: "THANNEER PANDHAL", lat: 8.862521, lng: 78.116944, id: 97 },
//   { name: "ARASADI JUNCTION", lat: 8.879929, lng: 78.111422, id: 98 },
//   { name: "VALASAMUTHIRAM", lat: 8.902361, lng: 78.102086, id: 99 },
//   { name: "KURUKKUSALAI", lat: 8.931410, lng: 78.088196, id: 100 },
//   { name: "RAMACHANDRAPURAM", lat: 8.927895, lng: 78.077923, id: 101 },
//   { name: "KAKKARAMPATTI JUNCTION", lat: 8.925977, lng: 78.064895, id: 102 },
//   { name: "MEENAKSHIPURAM", lat: 8.923832, lng: 78.057035, id: 103 },
//   { name: "OTTAPIDARAM TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 104 },
//   { name: "AYYANAR KOVIL", lat: 8.902593, lng: 78.012899, id: 105 },
//   { name: "KULASEKARANALLOOR", lat: 8.899773, lng: 77.981243, id: 106 },
//   { name: "SOUTH AARAIKULAM", lat: 8.916444, lng: 77.974949, id: 107 },
//   { name: "NORTH AARAIKULAM", lat: 8.923940, lng: 77.973027, id: 108 },
//   { name: "TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 109 },
//   { name: "THERKKU ARAIKULAM", lat: 8.916444, lng: 77.974949, id: 110 },
//   { name: "THOMAS NAGAR", lat: 8.839335, lng: 78.143038, id: 111 },
//   { name: "AYYANAR PURAM", lat: 8.859083, lng: 78.145946, id: 112 },
//   { name: "JOTHI SALT", lat: 8.863746, lng: 78.147926, id: 113 },
//   { name: "THARUVAIKULAM", lat: 8.896085, lng: 78.162889, id: 114 },
//   { name: "PATTINAMARUTHUR", lat: 8.923039, lng: 78.179675, id: 115 },
//   { name: "KALMEDU", lat: 8.943135, lng: 78.180943, id: 116 },
//   { name: "CHEMICAL", lat: 8.961828, lng: 78.180195, id: 117 },
//   { name: "VEPPALODAI", lat: 8.966764, lng: 78.180558, id: 118 },
//   { name: "PANAIYOOR JUNCTION", lat: 8.979427, lng: 78.200198, id: 119 },
//   { name: "SALT FACTORY", lat: 8.993585, lng: 78.216936, id: 120 },
//   { name: "KALLOORANI", lat: 8.990696, lng: 78.231998, id: 121 },
//   { name: "KEELA VAIPPAR", lat: 8.999548, lng: 78.251410, id: 122 },
//   { name: "THULUKKANKULAM", lat: 9.031660, lng: 78.272640, id: 123 },
//   { name: "KALAIGNANAPURAM", lat: 9.032364, lng: 78.266939, id: 124 },
//   { name: "KALAIGNANAPURAM JUNCTION", lat: 9.035342, lng: 78.258363, id: 125 },
//   { name: "VAIPPAR", lat: 9.025940, lng: 78.245625, id: 126 },
//   { name: "SOUTHERN SALT", lat: 8.705618, lng: 78.108039, id: 127 },
//   { name: "NORTH AUTHOOR", lat: 8.622425, lng: 78.070322, id: 128 },
//   { name: "SOUTH AUTHOOR", lat: 8.614603, lng: 78.070710, id: 129 },
//   { name: "AYYANKOVIL JUNCTION", lat: 8.598784, lng: 78.072198, id: 130 },
//   { name: "MICHEAL NADAR KUDIYIRUPPU", lat: 8.601003, lng: 78.053355, id: 131 },
//   { name: "PANAIYOOR GATE", lat: 8.979427, lng: 78.200198, id: 132 },
//   { name: "AM PATTI", lat: 8.901119, lng: 78.144213, id: 133 },
//   { name: "THERMAL STATION", lat: 8.902320, lng: 78.138007, id: 134 },
//   { name: "AM PATTI JUNCTION", lat: 8.907276, lng: 78.126656, id: 135 },
//   { name: "MELA MARUTHUR", lat: 8.914773, lng: 78.137694, id: 136 },
//   { name: "DURAISAMYPURAM", lat: 8.938686, lng: 78.156320, id: 137 },
//   { name: "SOUTH KALMEDU", lat: 8.951746, lng: 78.168851, id: 138 },
//   { name: "NORTH KALMEDU", lat: 8.954783, lng: 78.170766, id: 139 },
//   { name: "PANAIYOOR", lat: 8.992923, lng: 78.196242, id: 140 },
//   { name: "KULATTHOOR", lat: 9.004578, lng: 78.194272, id: 141 },
//   { name: "COLONY", lat: 9.008341, lng: 78.204491, id: 142 },
//   { name: "ARASADI", lat: 8.870406, lng: 78.127151, id: 143 },
//   { name: "KEELA ARASADI", lat: 8.877666, lng: 78.127424, id: 144 },
//   { name: "KUMARAPURAM", lat: 8.899629, lng: 78.119815, id: 145 },
//   { name: "PUDHUR", lat: 8.949025, lng: 78.149634, id: 146 },
//   { name: "VEDANATTHAM", lat: 8.968335, lng: 78.145818, id: 147 },
//   { name: "VENKATACHALAPURAM", lat: 8.979063, lng: 78.157313, id: 148 },
//   { name: "MUTHUKUMARAPURAM", lat: 8.992612, lng: 78.145428, id: 149 },
//   { name: "SUBRAMANIYAPURAM JUNCTION", lat: 9.015801, lng: 78.225924, id: 150 },
//   { name: "THULUKKANKULAM JUNCTION", lat: 9.035332, lng: 78.258348, id: 151 },
//   { name: "CHANDRAGIRI JUNCTION", lat: 8.959742, lng: 78.092867, id: 152 },
//   { name: "CHANDRAGIRI", lat: 8.963758, lng: 78.074077, id: 153 },
//   { name: "KOLLAMPARAMBU", lat: 8.981801, lng: 78.119157, id: 154 },
//   { name: "SEITHALAI JUNCTION", lat: 8.979604, lng: 78.068883, id: 155 },
//   { name: "KEELA SEITHALAI", lat: 8.988456, lng: 78.093180, id: 156 },
//   { name: "KOVANKADU", lat: 8.690829, lng: 78.104060, id: 157 },
//   { name: "SOUTH KOVANKADU", lat: 8.690280, lng: 78.089963, id: 158 },
//   { name: "SAMBADI", lat: 8.669595, lng: 78.078838, id: 159 },
//   { name: "IDAYARKADU", lat: 8.664261, lng: 78.064077, id: 160 },
//   { name: "MARAMANGALAM", lat: 8.657852, lng: 78.060310, id: 161 },
//   { name: "ARUMUGAMANGALAM", lat: 8.649895, lng: 78.042699, id: 162 },
//   { name: "POTTALKADU", lat: 8.719686, lng: 78.102315, id: 163 },
//   { name: "KATTALANKULAM", lat: 8.698745, lng: 78.007000, id: 164 },
//   { name: "M. PUDHUR", lat: 8.722007, lng: 78.002788, id: 165 },
//   { name: "MUDIVAITHANENDAL", lat: 8.723319, lng: 77.990336, id: 166 },
//   { name: "VAGAIKULAM", lat: 8.734730, lng: 78.001301, id: 167 },
//   { name: "CHETTIKULAM", lat: 8.662797, lng: 78.029329, id: 168 },
//   { name: "AGARAM BRIDGE", lat: 8.661354, lng: 78.088323, id: 169 },
//   { name: "AGARAM", lat: 8.659921, lng: 78.075828, id: 170 },
//   { name: "KORKAI", lat: 8.642078, lng: 78.058734, id: 171 },
//   { name: "AUTHOOR", lat: 8.622355, lng: 78.070341, id: 172 },
//   { name: "CHERNTHAMARAM", lat: 8.634982, lng: 78.087918, id: 173 },
//   { name: "DCW COLONY", lat: 8.632673, lng: 78.101623, id: 174 },
//   { name: "PUNNAKAYAL", lat: 8.634945, lng: 78.117073, id: 175 },
//   { name: "ATTHIMARAPATTI JUNCTION", lat: 8.741554, lng: 78.123287, id: 176 },
//   { name: "ATTHIMARAPATTI", lat: 8.742208, lng: 78.104441, id: 177 },
//   { name: "PON NAGAR", lat: 8.734551, lng: 78.104669, id: 178 },
//   { name: "THERMAL NAGAR", lat: 8.759198, lng: 78.147347, id: 179 },
//   { name: "THERMAL NAGAR JUNCTION", lat: 8.758436, lng: 78.155625, id: 180 },
//   { name: "TTPP", lat: 8.755276, lng: 78.175103, id: 181 },
//   { name: "CHILDREN'S PARK", lat: 8.746429, lng: 78.168838, id: 182 },
//   { name: "CAMP-II", lat: 8.742206, lng: 78.163757, id: 183 },
//   { name: "BULK", lat: 8.745284, lng: 78.125352, id: 184 },
//   { name: "ROCH PARK", lat: 8.787746, lng: 78.159250, id: 185 },
//   { name: "TTPP JUNCTION", lat: 8.755763, lng: 78.170323, id: 186 },
//   { name: "VELLAPATTI", lat: 8.857643, lng: 78.160709, id: 187 },
//   { name: "KAKKARAMPATTI", lat: 8.928274, lng: 78.058146, id: 188 },
//   { name: "AGILANDAPURAM", lat: 8.933352, lng: 78.050208, id: 189 },
//   { name: "PANCHALANKURICHI", lat: 8.932598, lng: 78.032564, id: 190 },
//   { name: "KUMARAPURAM JUNCTION", lat: 8.947900, lng: 78.080564, id: 191 },
//   { name: "VELLARAM JUNCTION", lat: 8.963494, lng: 78.073969, id: 192 },
//   { name: "KACCHERI THALAVAIPURAM", lat: 8.965258, lng: 78.047346, id: 193 },
//   { name: "VELLARAM", lat: 8.964344, lng: 78.023572, id: 194 },
//   { name: "GOVERNORGIRI", lat: 8.950111, lng: 78.029486, id: 195 },
//   { name: "VALLINAYAGIPURAM", lat: 8.865224, lng: 78.027444, id: 196 },
//   { name: "JAMBULINGAPURAM", lat: 8.868732, lng: 78.018645, id: 197 },
//   { name: "KAILASAPURAM", lat: 8.852519, lng: 77.991350, id: 198 },
//   { name: "SAVARIMANGALAM", lat: 8.863055, lng: 77.985917, id: 199 },
//   { name: "MELA SEITHALAI", lat: 8.981610, lng: 78.077327, id: 200 },
//   { name: "JEGAVEERAPANDIAPURAM", lat: 8.983220, lng: 78.066958, id: 201 },
//   { name: "THANNEER MADAM", lat: 9.009252, lng: 78.052432, id: 202 },
//   { name: "KAYATHAR JUNCTION", lat: 9.012578, lng: 78.050241, id: 203 },
//   { name: "EPPODHUMVENDRAN", lat: 9.020908, lng: 78.047522, id: 204 },
//   { name: "KATTUNAICKENPATTI", lat: 9.014206, lng: 78.062348, id: 205 },
//   { name: "ADHANOOR", lat: 9.010078, lng: 78.084646, id: 206 },
//   { name: "MILAGU NATTHAM", lat: 9.012843, lng: 78.104929, id: 207 },
//   { name: "MURAMBAN", lat: 8.899828, lng: 77.937996, id: 208 },
//   { name: "SANGAMPATTI", lat: 8.917985, lng: 77.930898, id: 209 },
//   { name: "CEYLON COLONY", lat: 8.924832, lng: 78.018458, id: 210 },
//   { name: "PUTRU MURUGAN KOVIL", lat: 8.941288, lng: 78.011421, id: 211 },
//   { name: "VENKETESHVARAPURAM JUNCTION", lat: 8.955754, lng: 78.003576, id: 212 },
//   { name: "KEELA MUDIMAN", lat: 8.961449, lng: 77.999854, id: 213 },
//   { name: "POOLNAYAKKANOOR", lat: 8.978090, lng: 77.991323, id: 214 },
//   { name: "PASUVANTHANAI", lat: 8.999829, lng: 77.962640, id: 215 },
//   { name: "MELA MUDIMAN", lat: 8.956969, lng: 77.986192, id: 216 },
//   { name: "THALAVAIPURAM", lat: 8.877120, lng: 77.956196, id: 217 },
//   { name: "KANTHASAMYPURAM", lat: 8.867032, lng: 77.949334, id: 218 },
//   { name: "APC COLLEGE", lat: 8.827144, lng: 78.129349, id: 219 },
//   { name: "CHINNAKANNUPURAM", lat: 8.810596, lng: 78.125385, id: 220 },
//   { name: "SILVERPURAM", lat: 8.814569, lng: 78.115786, id: 221 },
//   { name: "PANDARAMPATTI", lat: 8.826827, lng: 78.104347, id: 222 },
//   { name: "MEELAVITTAN", lat: 8.816812, lng: 78.100737, id: 223 },
//   { name: "STERLITE", lat: 8.816372, lng: 78.081444, id: 224 },
//   { name: "SIPCOT", lat: 8.804587, lng: 78.084655, id: 225 },
//   { name: "MADATTHOOR JUNCTION", lat: 8.794126, lng: 78.097222, id: 226 },
//   { name: "THOOTHUKUDI COLLECTORATE", lat: 8.782470, lng: 78.100772, id: 227 },
//   { name: "PUDHUPACCHERI COLONY", lat: 8.878480, lng: 78.007704, id: 228 },
//   { name: "PUDHUPACCHERI", lat: 8.879461, lng: 78.001300, id: 229 },
//   { name: "SIVALKULAM", lat: 8.879800, lng: 77.995998, id: 230 },
//   { name: "PACCHAIPERUMALPURAM", lat: 8.885974, lng: 77.992908, id: 231 },
//   { name: "SANKARARAJAPURAM", lat: 8.891225, lng: 77.991277, id: 232 },
//   { name: "KUPPANAPURAM", lat: 8.933090, lng: 77.971928, id: 233 },
//   { name: "KEELA MANGALM", lat: 8.953179, lng: 77.969344, id: 234 },
//   { name: "RAMANACCHIYARPURAM", lat: 8.784893, lng: 78.061561, id: 235 },
//   { name: "MUTHUSAMYPURAM", lat: 8.804241, lng: 78.049425, id: 236 },
//   { name: "MADATTHUPATTI", lat: 8.807399, lng: 78.047393, id: 237 },
//   { name: "NORTH SILUKKANPATTI", lat: 8.812890, lng: 78.047949, id: 238 },
//   { name: "THALAIVANVADALI", lat: 8.602420, lng: 78.087655, id: 239 },
//   { name: "THOOTHUKUDI RAILWAY STATION", lat: 8.805524, lng: 78.155200, id: 240 },
//   { name: "KOOTTUDANKADU", lat: 8.740251, lng: 78.037525, id: 241 },
//   { name: "THIRUVANANTHAPURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 242 },
//   { name: "SAMATTHUVAPURAM", lat: 8.774679, lng: 77.998832, id: 243 },
//   { name: "MAHILAMPURAM", lat: 8.794964, lng: 77.961453, id: 244 },
//   { name: "CHEKKARAKUDI", lat: 8.794750, lng: 77.951655, id: 245 },
//   { name: "THIRUVANANTHAPURAM", lat: 8.770659, lng: 78.019169, id: 246 },
//   { name: "MELA CHEKKARAKUDI", lat: 8.801626, lng: 77.937492, id: 247 },
//   { name: "ALLIKULAM JUNCTION", lat: 8.757367, lng: 78.025019, id: 248 },
//   { name: "THIRUVANANDHA PURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 249 },
//   { name: "SILUKKAN PATTI", lat: 8.768811, lng: 78.052367, id: 250 },
//   { name: "KEELA THATTAPARAI", lat: 8.796529, lng: 78.027674, id: 251 },
//   { name: "MELA THATTAPARAI", lat: 8.815826, lng: 78.017498, id: 252 },
//   { name: "CHETTIYOORANI", lat: 8.832629, lng: 78.008857, id: 253 },
//   { name: "CAMP THATTAPARAI", lat: 8.826042, lng: 78.020524, id: 254 },
//   { name: "RAMACHANDRAPURAM JUNCTION", lat: 8.738491, lng: 78.031969, id: 255 },
//   { name: "POTTALOORANI JUNCTION", lat: 8.735812, lng: 77.935660, id: 256 },
//   { name: "POTTALOORANI VILLAGE", lat: 8.748338, lng: 77.936312, id: 257 },
//   { name: "NATTHAM", lat: 8.778333, lng: 77.946701, id: 258 },
//   { name: "AZHAGAPURI", lat: 8.783882, lng: 77.947625, id: 259 },
//   { name: "KALLAMPARAMBU", lat: 8.806659, lng: 77.982150, id: 260 },
//   { name: "VARTHAGAREDDIPATTI", lat: 8.734957, lng: 77.992819, id: 261 },
//   { name: "THIMMARAJAPURAM", lat: 8.763797, lng: 77.989995, id: 262 },
//   { name: "MEENAKSHIPATTI", lat: 8.690932, lng: 77.965207, id: 263 },
//   { name: "ADAIKKALAPURAM", lat: 8.678001, lng: 77.969954, id: 264 },
//   { name: "ANIYABARANALLUR", lat: 8.693574, lng: 77.950283, id: 265 },
//   { name: "PUDHUPATTI", lat: 8.710504, lng: 77.936336, id: 266 },
//   { name: "CHETTIMALLANPATTI", lat: 8.720235, lng: 77.929900, id: 267 },
//   { name: "RAMANATHAPURAM", lat: 8.728507, lng: 77.925542, id: 268 },
//   { name: "ELLANAICKENPATTI", lat: 8.733465, lng: 77.921950, id: 269 },
//   { name: "DEIVASEYALPURAM", lat: 8.737467, lng: 77.918961, id: 270 },
//   { name: "THATTAPARAI VILLAGE", lat: 8.755998, lng: 78.065854, id: 271 },
//   { name: "ST. MARY'S COLLEGE", lat: 8.811006, lng: 78.161694, id: 272 },
//   { name: "NEW HARBOUR", lat: 8.754486, lng: 78.192477, id: 273 },
//   { name: "UMARIKOTTAI", lat: 8.822473, lng: 77.990482, id: 274 },
//   { name: "VARADHARAJAPURAM", lat: 8.843064, lng: 77.979707, id: 275 },
//   { name: "CHOCKALINGAPURAM", lat: 8.812871, lng: 77.966345, id: 276 },
//   { name: "KALANKARAI", lat: 8.756500, lng: 78.095112, id: 277 },
//   { name: "PUDHUKOTTAI 2", lat: 8.747258, lng: 78.054971, id: 278 },
//   { name: "4TH GATE 2", lat: 8.812727, lng: 78.136672, id: 279 },
//   { name: "ST. ANN'S HOSPITAL", lat: 8.877320, lng: 78.025851, id: 280 },
//   { name: "SUBRAMANIYAPURAM 2", lat: 8.918478, lng: 78.094426, id: 281 },
//   { name: "AMERICAN HOSPITAL 2", lat: 8.813561, lng: 78.148444, id: 282 },
//   { name: "ZAKKAMMALPURAM 2", lat: 8.916639, lng: 78.175262, id: 283 },
//   { name: "KALLOORANI", lat: 8.992222, lng: 78.233057, id: 284 },
//   { name: "THULUKKANKULAM", lat: 9.031716, lng: 78.272534, id: 285 },
//   { name: "SALT FACTORY 2", lat: 8.996121, lng: 78.240638, id: 286 },
//   { name: "ZAKKAMMALPURAM 3", lat: 8.926665, lng: 78.149020, id: 287 },
//   { name: "SUBRAMANIYAPURAM 3", lat: 9.025170, lng: 78.225853, id: 288 },
//   { name: "CHANDRAGIRI", lat: 8.964871, lng: 78.096262, id: 289 },
//   { name: "WATER TANK 2", lat: 8.669583, lng: 78.078905, id: 290 },
//   { name: "KUMARAPURAM 2", lat: 8.688057, lng: 78.016423, id: 291 },
//   { name: "ARASADI JUNCTION 2", lat: 8.868788, lng: 78.115271, id: 292 },
//   { name: "THERMAL NAGAR", lat: 8.759213, lng: 78.147452, id: 293 },
//   { name: "CHEMICAL", lat: 8.766517, lng: 78.156992, id: 294 },
//   { name: "CHANDRAGIRI JUNCTION 2", lat: 8.963747, lng: 78.074074, id: 295 },
//   { name: "S.PUTHUR", lat: 8.869224, lng: 77.997689, id: 296 },
//   { name: "KAILASAPURAM", lat: 8.786357, lng: 78.077069, id: 297 },
//   { name: "MUTHUSAMYPURAM", lat: 8.803626, lng: 78.050614, id: 298 },
//   { name: "ARASADI JUNCTION 3", lat: 8.873258, lng: 78.152850, id: 299 },
//   { name: "ARASADI 2", lat: 8.878458, lng: 78.118427, id: 300 },
//   { name: "DURAISAMYPURAM 2", lat: 8.938193, lng: 78.156085, id: 301 },
//   { name: "KULATTHOOR 2", lat: 9.002945, lng: 78.194484, id: 302 },
//   { name: "PUDHUR 2", lat: 8.794559, lng: 77.993581, id: 303 },
//   { name: "THALAVAIPURAM 2", lat: 8.798284, lng: 77.974711, id: 304 },
//   { name: "RAMACHANDRAPURAM 2", lat: 8.731531, lng: 78.030510, id: 305 },
//   { name: "PUDHUR 3", lat: 8.709596, lng: 78.002355, id: 306 }
// ];

// // // Route sequences by stop id
// // const Hostel_to_Main   = [26, 24, 22, 20, 6, 5, 3, 1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // const Main_to_Hostel   = [18, 17, 15, 13, 11, 9, 6, 5, 3, 1, 2, 4, 7, 19, 21, 23, 25, 26];
// // const Velachery_to_Main= [1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // const Velachery_to_Hostel=[1, 2, 4, 7, 19, 21, 23, 25, 26];
// // const Hotel_to_Velachery=[26, 24, 22, 20, 6, 5, 3, 1];
// // const Main_to_Velachery=[18, 17, 15, 13, 11, 9, 6, 5, 3, 1];
// // const RP_to_ED         = [28, 22, 21, 20, 6, 5, 3, 29];
// // const ED_to_RP         = [29, 2, 4, 7, 19, 21, 23, 28];

// // const ROUTES = [
// //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate", ids: Hostel_to_Main },
// //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel", ids: Main_to_Hostel },
// //   { code: "VG_MAIN",     label: "Velachery Gate → Main Gate", ids: Velachery_to_Main },
// //   { code: "VG_HOSTEL",   label: "Velachery Gate → Hostel", ids: Velachery_to_Hostel },
// //   { code: "MAIN_VG",     label: "Main Gate → Velachery Gate", ids: Main_to_Velachery },
// //   { code: "HOSTEL_VG",   label: "Hostel → Velachery Gate", ids: Hotel_to_Velachery },
// //   { code: "RP_ED",       label: "Research Park → ED", ids: RP_to_ED },
// //   { code: "ED_RP",       label: "ED → Research Park", ids: ED_to_RP },
// // ];

// // // ---- Route aliases (frontend only) ----
// // // Backend only knows canonical codes: HOSTEL_MAIN, MAIN_HOSTEL, RP_ED, ED_RP
// // // But filters can still expose Velachery labels.
// // // Aliases map to canonical backend codes.
// // const ROUTE_ALIAS_TO_CANONICAL = {
// //   VG_MAIN: "HOSTEL_MAIN",
// //   HOSTEL_VG: "HOSTEL_MAIN",
// //   MAIN_VG: "MAIN_HOSTEL",
// //   VG_HOSTEL: "MAIN_HOSTEL",
// // };

// // function canonicalRoute(code) {
// //   return ROUTE_ALIAS_TO_CANONICAL[code] || code;
// // }
// // // Routes the admin can assign in backend (only canonical codes)
// // const ADMIN_ROUTES = [
// //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate" },
// //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel" },
// //   { code: "RP_ED", label: "Research Park → ED" },
// //   { code: "ED_RP", label: "ED → Research Park" },
// // ];


// // // ---- Vehicles for driverRoute select ----
// // const VEHICLES = [
// //   "TN07DH1368","TN07DH1317","TN07DH1315","EV09","TN07DH1360","TN07DH1391","EV08","TN07DD5574",
// //   "TN07CX8698","TN07DD3376","TN07CX8200","TN07DD3360","EV-12","EV-14","EV-15","EV-10","EV-05",
// //   "EV-07","EV-06","EV-02","EV-03","EV-11","EV-01","EV-13","TN07CX8119"
// // ];

// // ---------------- VEHICLE ROUTES + ROUTE SCHEDULE DATA ----------------
// // Generated from your TCNC route table and the uploaded stop-timesheet ZIP.
// // ROUTES = user-facing route numbers (52-B, 53-A, ...)
// // ROUTE_TRIPS = detailed stop-by-stop trips used for schedule display and route progress.
// const VEHICLE_ROUTE_MAP = {
//   "TN72N2675": "4",
//   "TN72N2656": "52-B",
//   "TN72N2460": "52-C",
//   "TN72N1895": "52-D",
//   "TN72N2589": "52-E",
//   "TN72N2368": "52-F",
//   "TN72N2682": "52-G",
//   "TN72N1905": "52-K",
//   "TN72N1774": "53-A",
//   "TN72N2556": "53-B",
//   "TN72N2684": "53-C",
//   "TN72N1903": "53-D",
//   "TN72N2526": "53-E",
//   "TN72N1737": "53-F",
//   "TN72N1751": "54-A",
//   "TN72N1854": "54-B",
//   "TN72N2643": "54-C",
//   "TN72N1910": "54-D",
//   "TN72N2536": "54-F",
//   "TN72N1912": "54-G",
//   "TN72N2706": "55-A",
//   "TN72N2700": "55-B",
//   "TN72N2549": "55-C",
//   "TN72N2416": "55-D",
//   "TN72N1757": "55-E",
//   "TN72N2541": "55-F",
//   "TN72N1906": "55-G",
//   "TN72N1688": "55-H",
//   "TN72N2671": "55-I",
//   "TN72N1919": "55-J",
//   "TN72N2568": "56-A",
//   "TN72N1884": "56-B",
//   "TN72N2617": "56-C",
//   "TN72N2622": "56-D",
//   "TN72N2016": "56-E",
//   "TN68N0707": "56-F",
//   "TN72N2562": "56-G",
//   "TN72N1875": "57-A",
//   "TN72N2687": "57-D",
//   "TN72N2022": "58-A",
//   "TN72N2570": "58-B",
//   "TN72N2620": "58-C"
// };

// const ROUTES = [
//   {
//     "code": "52-A",
//     "label": "52-A — 13 scheduled trips",
//     "tripCount": 13
//   },
//   {
//     "code": "52-B",
//     "label": "52-B — 10 scheduled trips",
//     "tripCount": 10
//   },
//   {
//     "code": "52-C",
//     "label": "52-C — 18 scheduled trips",
//     "tripCount": 18
//   },
//   {
//     "code": "52-D",
//     "label": "52-D — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "52-E",
//     "label": "52-E — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "52-F",
//     "label": "52-F — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "52-G",
//     "label": "52-G — 18 scheduled trips",
//     "tripCount": 18
//   },
//   {
//     "code": "52-K",
//     "label": "52-K — 17 scheduled trips",
//     "tripCount": 17
//   },
//   {
//     "code": "53-A",
//     "label": "53-A — 16 scheduled trips",
//     "tripCount": 16
//   },
//   {
//     "code": "53-B",
//     "label": "53-B — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "53-C",
//     "label": "53-C — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "53-D",
//     "label": "53-D — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "53-E",
//     "label": "53-E — 10 scheduled trips",
//     "tripCount": 10
//   },
//   {
//     "code": "53-F",
//     "label": "53-F — 16 scheduled trips",
//     "tripCount": 16
//   },
//   {
//     "code": "54-A",
//     "label": "54-A — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "54-B",
//     "label": "54-B — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "54-C",
//     "label": "54-C — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "54-D",
//     "label": "54-D — 16 scheduled trips",
//     "tripCount": 16
//   },
//   {
//     "code": "54-F",
//     "label": "54-F — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "54-G",
//     "label": "54-G — 20 scheduled trips",
//     "tripCount": 20
//   },
//   {
//     "code": "55-A",
//     "label": "55-A — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "55-B",
//     "label": "55-B — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "55-C",
//     "label": "55-C — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "55-D",
//     "label": "55-D — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "55-E",
//     "label": "55-E — 10 scheduled trips",
//     "tripCount": 10
//   },
//   {
//     "code": "55-F",
//     "label": "55-F — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "55-G",
//     "label": "55-G — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "55-H",
//     "label": "55-H — 20 scheduled trips",
//     "tripCount": 20
//   },
//   {
//     "code": "55-I",
//     "label": "55-I — 10 scheduled trips",
//     "tripCount": 10
//   },
//   {
//     "code": "55-J",
//     "label": "55-J — 20 scheduled trips",
//     "tripCount": 20
//   },
//   {
//     "code": "56-A",
//     "label": "56-A — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "56-B",
//     "label": "56-B — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "56-C",
//     "label": "56-C — 10 scheduled trips",
//     "tripCount": 10
//   },
//   {
//     "code": "56-D",
//     "label": "56-D — 10 scheduled trips",
//     "tripCount": 10
//   },
//   {
//     "code": "56-E",
//     "label": "56-E — 13 scheduled trips",
//     "tripCount": 13
//   },
//   {
//     "code": "56-F",
//     "label": "56-F — 19 scheduled trips",
//     "tripCount": 19
//   },
//   {
//     "code": "56-G",
//     "label": "56-G — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "57-A",
//     "label": "57-A — 22 scheduled trips",
//     "tripCount": 22
//   },
//   {
//     "code": "57-D",
//     "label": "57-D — 24 scheduled trips",
//     "tripCount": 24
//   },
//   {
//     "code": "58-A",
//     "label": "58-A — 14 scheduled trips",
//     "tripCount": 14
//   },
//   {
//     "code": "58-B",
//     "label": "58-B — 16 scheduled trips",
//     "tripCount": 16
//   },
//   {
//     "code": "58-C",
//     "label": "58-C — 12 scheduled trips",
//     "tripCount": 12
//   },
//   {
//     "code": "4",
//     "label": "4 — schedule not available",
//     "tripCount": 0
//   }
// ];

// const ADMIN_ROUTES = ROUTES;

// const ROUTE_TRIPS = [
//   {
//     "id": "52-A-1-1",
//     "routeNo": "52-A",
//     "code": "52/P52A-1",
//     "tripCode": "52/P52A-152-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PERUMPADAI SASTHA KOVIL",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:45 AM",
//     "endTime": "01:00 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       7,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       16
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "11:50 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:54 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:03 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:06 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:15 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 1",
//         "time": "12:21 PM",
//         "id": 7
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "12:23 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:31 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "12:37 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "12:41 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:45 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "12:50 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "12:53 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "12:56 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "PERUMPADAI SASTHA KOVIL",
//         "time": "01:00 PM",
//         "id": 16
//       }
//     ]
//   },
//   {
//     "id": "52-A-2-2",
//     "routeNo": "52-A",
//     "code": "52/P52A-1",
//     "tripCode": "52/P52A-152-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "PERUMPADAI SASTHA KOVIL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:05 PM",
//     "endTime": "02:00 PM",
//     "ids": [
//       16,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       7,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PERUMPADAI SASTHA KOVIL",
//         "time": "01:05 PM",
//         "id": 16
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "01:07 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "01:09 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "01:12 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "01:15 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "01:18 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "01:21 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "01:26 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "01:31 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 1",
//         "time": "01:33 PM",
//         "id": 7
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:37 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:44 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:46 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:52 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "01:55 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-A-3-3",
//     "routeNo": "52-A",
//     "code": "52/P52A-2",
//     "tripCode": "52/P52A-252-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:05 PM",
//     "endTime": "03:00 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "02:09 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:12 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:20 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:22 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:29 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:33 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:35 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:41 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "02:46 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "02:50 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "02:53 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "02:57 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "03:00 PM",
//         "id": 40
//       }
//     ]
//   },
//   {
//     "id": "52-A-4-4",
//     "routeNo": "52-A",
//     "code": "52/P52A-3",
//     "tripCode": "52/P52A-352-ATORD18U4",
//     "order": 4,
//     "direction": "U",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:05 PM",
//     "endTime": "04:30 PM",
//     "ids": [
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "03:05 PM",
//         "id": 40
//       },
//       {
//         "no": 2,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "03:15 PM",
//         "id": 17
//       },
//       {
//         "no": 3,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "03:41 PM",
//         "id": 18
//       },
//       {
//         "no": 4,
//         "name": "SIRUTHONDANALLUR",
//         "time": "04:12 PM",
//         "id": 19
//       },
//       {
//         "no": 5,
//         "name": "ERAL",
//         "time": "04:30 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-A-5-5",
//     "routeNo": "52-A",
//     "code": "52/P52A-4",
//     "tripCode": "52/P52A-452-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:40 PM",
//     "endTime": "06:00 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       21,
//       22,
//       23,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "04:40 PM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SIRUTHONDANALLUR",
//         "time": "04:44 PM",
//         "id": 19
//       },
//       {
//         "no": 3,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "04:51 PM",
//         "id": 18
//       },
//       {
//         "no": 4,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "04:57 PM",
//         "id": 17
//       },
//       {
//         "no": 5,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:59 PM",
//         "id": 40
//       },
//       {
//         "no": 6,
//         "name": "SAWYERPURAM",
//         "time": "05:03 PM",
//         "id": 13
//       },
//       {
//         "no": 7,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:08 PM",
//         "id": 12
//       },
//       {
//         "no": 8,
//         "name": "SALAI",
//         "time": "05:12 PM",
//         "id": 37
//       },
//       {
//         "no": 9,
//         "name": "SERVAIKARANMADAM",
//         "time": "05:17 PM",
//         "id": 10
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "05:23 PM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "SIRUPADU JUNCTION",
//         "time": "05:31 PM",
//         "id": 8
//       },
//       {
//         "no": 12,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:33 PM",
//         "id": 278
//       },
//       {
//         "no": 13,
//         "name": "MANGALAGIRI",
//         "time": "05:40 PM",
//         "id": 21
//       },
//       {
//         "no": 14,
//         "name": "ALLIKULAM",
//         "time": "05:49 PM",
//         "id": 22
//       },
//       {
//         "no": 15,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "05:53 PM",
//         "id": 23
//       },
//       {
//         "no": 16,
//         "name": "PEROORANI",
//         "time": "06:00 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "52-A-6-6",
//     "routeNo": "52-A",
//     "code": "52/P52A-5",
//     "tripCode": "52/P52A-552-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "PERRORANI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 PM",
//     "endTime": "07:20 PM",
//     "ids": [
//       24,
//       23,
//       22,
//       21,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40
//     ],
//     "stops": [
//       {
//         "no": 12,
//         "name": "PEROORANI",
//         "time": "06:15 PM",
//         "id": 24
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "06:21 PM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "06:26 PM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "MANGALAGIRI",
//         "time": "06:36 PM",
//         "id": 21
//       },
//       {
//         "no": 8,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:43 PM",
//         "id": 278
//       },
//       {
//         "no": 7,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:46 PM",
//         "id": 8
//       },
//       {
//         "no": 6,
//         "name": "KOOTTAMPULI",
//         "time": "06:54 PM",
//         "id": 9
//       },
//       {
//         "no": 5,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:01 PM",
//         "id": 10
//       },
//       {
//         "no": 4,
//         "name": "SALAI",
//         "time": "07:06 PM",
//         "id": 37
//       },
//       {
//         "no": 3,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:10 PM",
//         "id": 12
//       },
//       {
//         "no": 2,
//         "name": "SAWYERPURAM",
//         "time": "07:15 PM",
//         "id": 13
//       },
//       {
//         "no": 1,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:20 PM",
//         "id": 40
//       }
//     ]
//   },
//   {
//     "id": "52-A-7-7",
//     "routeNo": "52-A",
//     "code": "52/P52A-2",
//     "tripCode": "52/P52A-252-ATORD18D7",
//     "order": 7,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 PM",
//     "endTime": "08:45 PM",
//     "ids": [
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:30 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:34 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:38 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:43 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:48 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:55 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:03 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:05 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:11 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:21 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:24 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:34 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:38 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-A-8-8",
//     "routeNo": "52-A",
//     "code": "52/P52A-1",
//     "tripCode": "52/P52A-152-ATORD18U8",
//     "order": 8,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PERUMPADAI SASTHA KOVIL",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:30 PM",
//     "endTime": "10:30 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       7,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       16
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:34 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:37 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:45 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:47 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:54 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 1",
//         "time": "09:59 PM",
//         "id": 7
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:01 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "10:06 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:11 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "10:15 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:18 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "10:22 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "10:25 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "10:27 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "PERUMPADAI SASTHA KOVIL",
//         "time": "10:30 PM",
//         "id": 16
//       }
//     ]
//   },
//   {
//     "id": "52-A-9-9",
//     "routeNo": "52-A",
//     "code": "52/P52A-6",
//     "tripCode": "52/P52A-652-ATORD18D9",
//     "order": 9,
//     "direction": "D",
//     "from": "PERUMPADAI SASTHA KOVIL",
//     "to": "UZHAVAR SANTHAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:30 AM",
//     "endTime": "06:40 AM",
//     "ids": [
//       16,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1,
//       26,
//       25
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "PERUMPADAI SASTHA KOVIL",
//         "time": "04:30 AM",
//         "id": 16
//       },
//       {
//         "no": 17,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "04:36 AM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:39 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "04:45 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:53 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SALAI",
//         "time": "04:59 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SERVAIKARANMADAM",
//         "time": "05:07 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "KOOTTAMPULI",
//         "time": "05:17 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU JUNCTION",
//         "time": "05:29 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:33 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:41 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:56 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "06:01 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "06:16 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "VOC COLLEGE",
//         "time": "06:23 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:32 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:37 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "UZHAVAR SANTHAI",
//         "time": "06:40 AM",
//         "id": 25
//       }
//     ]
//   },
//   {
//     "id": "52-A-10-10",
//     "routeNo": "52-A",
//     "code": "52/P52A-8",
//     "tripCode": "52/P52A-852-ATORD18U10",
//     "order": 10,
//     "direction": "U",
//     "from": "UZHAVAR SANTHAI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:55 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       25,
//       26,
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "UZHAVAR SANTHAI",
//         "time": "06:55 AM",
//         "id": 25
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:56 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:59 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "VOC COLLEGE",
//         "time": "07:03 AM",
//         "id": 2
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "07:07 AM",
//         "id": 39
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "07:15 AM",
//         "id": 4
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:18 AM",
//         "id": 5
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:26 AM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:31 AM",
//         "id": 278
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:33 AM",
//         "id": 8
//       },
//       {
//         "no": 11,
//         "name": "KOOTTAMPULI",
//         "time": "07:39 AM",
//         "id": 9
//       },
//       {
//         "no": 12,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:45 AM",
//         "id": 10
//       },
//       {
//         "no": 13,
//         "name": "SALAI",
//         "time": "07:49 AM",
//         "id": 37
//       },
//       {
//         "no": 14,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:52 AM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "07:56 AM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:00 AM",
//         "id": 40
//       }
//     ]
//   },
//   {
//     "id": "52-A-11-11",
//     "routeNo": "52-A",
//     "code": "52/P52A-7",
//     "tripCode": "52/P52A-752-ATORD18D11",
//     "order": 11,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THRES PURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 AM",
//     "endTime": "09:10 AM",
//     "ids": [
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1,
//       28,
//       27
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:05 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "08:08 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:11 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SALAI",
//         "time": "08:15 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:18 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "KOOTTAMPULI",
//         "time": "08:23 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:29 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:31 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:35 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:43 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "08:45 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "08:53 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "VOC COLLEGE",
//         "time": "08:56 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:01 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:06 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "09:10 AM",
//         "id": 27
//       }
//     ]
//   },
//   {
//     "id": "52-A-12-12",
//     "routeNo": "52-A",
//     "code": "52/P52A-7",
//     "tripCode": "52/P52A-752-ATORD18U12",
//     "order": 12,
//     "direction": "U",
//     "from": "THRES PURAM",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:20 AM",
//     "endTime": "10:20 AM",
//     "ids": [
//       27,
//       28,
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "09:20 AM",
//         "id": 27
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:23 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:28 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "VOC COLLEGE",
//         "time": "09:32 AM",
//         "id": 2
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "09:35 AM",
//         "id": 39
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "09:42 AM",
//         "id": 4
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:44 AM",
//         "id": 5
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:51 AM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:55 AM",
//         "id": 278
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:57 AM",
//         "id": 8
//       },
//       {
//         "no": 11,
//         "name": "KOOTTAMPULI",
//         "time": "10:02 AM",
//         "id": 9
//       },
//       {
//         "no": 12,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:07 AM",
//         "id": 10
//       },
//       {
//         "no": 13,
//         "name": "SALAI",
//         "time": "10:10 AM",
//         "id": 37
//       },
//       {
//         "no": 14,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:13 AM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "10:17 AM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "10:20 AM",
//         "id": 40
//       }
//     ]
//   },
//   {
//     "id": "52-A-13-13",
//     "routeNo": "52-A",
//     "code": "52/P52A-2",
//     "tripCode": "52/P52A-252-ATORD18D13",
//     "order": 13,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 AM",
//     "endTime": "11:30 AM",
//     "ids": [
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "10:30 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "10:33 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:37 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "10:40 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:44 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "10:50 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:56 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:58 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:02 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:11 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:13 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:21 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "11:25 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-B-1-14",
//     "routeNo": "52-B",
//     "code": "52/P52B-2",
//     "tripCode": "52/P52B-252-BTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PERUNKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:15 PM",
//     "endTime": "03:25 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:19 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:23 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:30 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:32 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:40 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:44 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:46 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:52 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "02:57 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "03:01 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "03:04 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "03:08 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "03:11 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "03:16 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "03:20 PM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "03:25 PM",
//         "id": 32
//       }
//     ]
//   },
//   {
//     "id": "52-B-2-15",
//     "routeNo": "52-B",
//     "code": "52/P52B-2",
//     "tripCode": "52/P52B-252-BTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "PERUNKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:40 PM",
//     "endTime": "04:50 PM",
//     "ids": [
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "03:40 PM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "03:44 PM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "03:48 PM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "03:53 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "03:56 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:00 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "04:03 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "04:07 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "04:12 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "04:18 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:20 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:24 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:32 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:34 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:41 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:45 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-B-3-16",
//     "routeNo": "52-B",
//     "code": "52/P52B-1",
//     "tripCode": "52/P52B-152-BTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SIVAKALAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:05 PM",
//     "endTime": "06:20 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       33
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:09 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:13 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:20 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:22 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:30 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:34 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "05:36 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "05:42 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "05:47 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "05:50 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:54 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "05:57 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "06:00 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "06:05 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "06:09 PM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "06:14 PM",
//         "id": 32
//       },
//       {
//         "no": 19,
//         "name": "SIVAKALAI",
//         "time": "06:20 PM",
//         "id": 33
//       }
//     ]
//   },
//   {
//     "id": "52-B-4-17",
//     "routeNo": "52-B",
//     "code": "52/P52B-1",
//     "tripCode": "52/P52B-152-BTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SIVAKALAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:35 PM",
//     "endTime": "07:40 PM",
//     "ids": [
//       33,
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "SIVAKALAI",
//         "time": "06:35 PM",
//         "id": 33
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "06:39 PM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "06:43 PM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "06:47 PM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "06:51 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "06:54 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:57 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:00 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:03 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:07 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:13 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:14 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:18 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:24 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:26 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:33 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:35 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-B-5-18",
//     "routeNo": "52-B",
//     "code": "52/P52B-1",
//     "tripCode": "52/P52B-152-BTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SIVAKALAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:55 PM",
//     "endTime": "09:25 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       33
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:55 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:00 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:04 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:13 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:16 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:25 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:30 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:32 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "08:39 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:45 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "08:49 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:53 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "08:58 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:01 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "09:07 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "09:12 PM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "09:18 PM",
//         "id": 32
//       },
//       {
//         "no": 19,
//         "name": "SIVAKALAI",
//         "time": "09:25 PM",
//         "id": 33
//       }
//     ]
//   },
//   {
//     "id": "52-B-6-19",
//     "routeNo": "52-B",
//     "code": "52/P52B-1",
//     "tripCode": "52/P52B-152-BTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "SIVAKALAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 AM",
//     "endTime": "08:30 AM",
//     "ids": [
//       33,
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "SIVAKALAI",
//         "time": "07:10 AM",
//         "id": 33
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "07:16 AM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "07:20 AM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "07:25 AM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:30 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:33 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:37 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:41 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:45 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:50 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:56 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:58 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:03 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:11 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:13 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:21 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:25 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-B-7-20",
//     "routeNo": "52-B",
//     "code": "52/P52B-2",
//     "tripCode": "52/P52B-252-BTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PERUNKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:45 AM",
//     "endTime": "10:00 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:50 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:53 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:01 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:04 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:12 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:16 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:18 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "09:25 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "09:30 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "09:34 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "09:38 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "09:42 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:45 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "09:50 AM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "09:55 AM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "10:00 AM",
//         "id": 32
//       }
//     ]
//   },
//   {
//     "id": "52-B-8-21",
//     "routeNo": "52-B",
//     "code": "52/P52B-2",
//     "tripCode": "52/P52B-252-BTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PERUNKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:15 AM",
//     "endTime": "11:20 AM",
//     "ids": [
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "10:15 AM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "10:19 AM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "10:23 AM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "10:27 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "10:30 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:33 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "10:37 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:40 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "10:45 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:50 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:52 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:56 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:03 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:05 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:12 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:15 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-B-9-22",
//     "routeNo": "52-B",
//     "code": "52/P52B-2",
//     "tripCode": "52/P52B-252-BTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PERUNKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:35 AM",
//     "endTime": "12:45 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:39 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:43 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:50 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:52 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:00 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:04 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "12:06 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:12 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "12:17 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "12:21 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:24 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "12:28 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "12:31 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "12:36 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "12:40 PM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "12:45 PM",
//         "id": 32
//       }
//     ]
//   },
//   {
//     "id": "52-B-10-23",
//     "routeNo": "52-B",
//     "code": "52/P52B-2",
//     "tripCode": "52/P52B-252-BTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "PERUNKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:00 PM",
//     "endTime": "02:10 PM",
//     "ids": [
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "01:00 PM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "01:04 PM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "01:08 PM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "01:13 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "01:16 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "01:20 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "01:23 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "01:27 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "01:32 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "01:38 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:40 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:44 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:52 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:54 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:01 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:05 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-C-1-24",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 AM",
//     "endTime": "06:45 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:18 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:20 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:26 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:28 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:33 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:36 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:38 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "06:42 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "06:45 AM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-2-25",
//     "routeNo": "52-C",
//     "code": "52/P52C-2",
//     "tripCode": "52/P52C-252-CTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THRES PURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:55 AM",
//     "endTime": "07:45 AM",
//     "ids": [
//       34,
//       9,
//       35,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1,
//       28,
//       27
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "KULAIYANKARISAL",
//         "time": "06:55 AM",
//         "id": 34
//       },
//       {
//         "no": 12,
//         "name": "KOOTTAMPULI",
//         "time": "06:58 AM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "SIRUPADU",
//         "time": "07:03 AM",
//         "id": 35
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:06 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:07 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:11 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:19 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "07:21 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "07:28 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "MILLER PURAM",
//         "time": "07:31 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:36 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:41 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "07:45 AM",
//         "id": 27
//       }
//     ]
//   },
//   {
//     "id": "52-C-3-26",
//     "routeNo": "52-C",
//     "code": "52/P52C-4",
//     "tripCode": "52/P52C-452-CTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THRES PURAM",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:55 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       27,
//       28,
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       35,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "07:55 AM",
//         "id": 27
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:59 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:06 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "MILLER PURAM",
//         "time": "08:13 AM",
//         "id": 29
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "08:18 AM",
//         "id": 39
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "08:28 AM",
//         "id": 4
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:31 AM",
//         "id": 5
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:42 AM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:47 AM",
//         "id": 278
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU",
//         "time": "08:53 AM",
//         "id": 35
//       },
//       {
//         "no": 11,
//         "name": "KOOTTAMPULI",
//         "time": "09:00 AM",
//         "id": 9
//       },
//       {
//         "no": 12,
//         "name": "KULAIYANKARISAL",
//         "time": "09:05 AM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-4-27",
//     "routeNo": "52-C",
//     "code": "52/P52C-3",
//     "tripCode": "52/P52C-352-CTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "SUB COLLECTOR OFFICE",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 AM",
//     "endTime": "10:00 AM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1,
//       28
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "KULAIYANKARISAL",
//         "time": "09:10 AM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "09:13 AM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:20 AM",
//         "id": 8
//       },
//       {
//         "no": 8,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:22 AM",
//         "id": 278
//       },
//       {
//         "no": 7,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:26 AM",
//         "id": 6
//       },
//       {
//         "no": 6,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:35 AM",
//         "id": 5
//       },
//       {
//         "no": 5,
//         "name": "KORAMPALLAM",
//         "time": "09:37 AM",
//         "id": 4
//       },
//       {
//         "no": 4,
//         "name": "3RD MILE",
//         "time": "09:45 AM",
//         "id": 39
//       },
//       {
//         "no": 3,
//         "name": "MILLER PURAM",
//         "time": "09:49 AM",
//         "id": 29
//       },
//       {
//         "no": 2,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:54 AM",
//         "id": 1
//       },
//       {
//         "no": 1,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:00 AM",
//         "id": 28
//       }
//     ]
//   },
//   {
//     "id": "52-C-5-28",
//     "routeNo": "52-C",
//     "code": "52/P52C-3",
//     "tripCode": "52/P52C-352-CTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "SUB COLLECTOR OFFICE",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:05 AM",
//     "endTime": "11:10 AM",
//     "ids": [
//       28,
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:05 AM",
//         "id": 28
//       },
//       {
//         "no": 2,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:12 AM",
//         "id": 1
//       },
//       {
//         "no": 3,
//         "name": "MILLER PURAM",
//         "time": "10:18 AM",
//         "id": 29
//       },
//       {
//         "no": 4,
//         "name": "3RD MILE",
//         "time": "10:23 AM",
//         "id": 39
//       },
//       {
//         "no": 5,
//         "name": "KORAMPALLAM",
//         "time": "10:34 AM",
//         "id": 4
//       },
//       {
//         "no": 6,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:37 AM",
//         "id": 5
//       },
//       {
//         "no": 7,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:48 AM",
//         "id": 6
//       },
//       {
//         "no": 8,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:53 AM",
//         "id": 278
//       },
//       {
//         "no": 9,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:56 AM",
//         "id": 8
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "11:05 AM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "KULAIYANKARISAL",
//         "time": "11:10 AM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-6-29",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:15 AM",
//     "endTime": "11:55 AM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "11:15 AM",
//         "id": 34
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "11:18 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "11:24 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:26 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:30 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:37 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:39 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:47 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:50 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:55 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-C-7-30",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:00 PM",
//     "endTime": "12:40 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "12:04 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:07 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:15 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:17 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:24 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:28 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "12:30 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:36 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "12:40 PM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-8-31",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:45 PM",
//     "endTime": "01:20 PM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "12:45 PM",
//         "id": 34
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:47 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "12:53 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:54 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:58 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:04 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:06 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:13 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:15 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-C-9-32",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:35 PM",
//     "endTime": "02:25 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:40 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:44 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:54 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:56 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:06 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:11 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:13 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:20 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "02:25 PM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-10-33",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:30 PM",
//     "endTime": "03:10 PM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "02:30 PM",
//         "id": 34
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:33 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:39 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:41 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:45 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:52 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:54 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:02 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:05 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-C-11-34",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:15 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:20 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:23 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:32 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:34 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:43 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:47 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "03:49 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "03:56 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "04:00 PM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-12-35",
//     "routeNo": "52-C",
//     "code": "52/P52C-4",
//     "tripCode": "52/P52C-452-CTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THRES PURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:10 PM",
//     "endTime": "05:25 PM",
//     "ids": [
//       34,
//       9,
//       35,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1,
//       28,
//       27
//     ],
//     "stops": [
//       {
//         "no": 12,
//         "name": "KULAIYANKARISAL",
//         "time": "04:10 PM",
//         "id": 34
//       },
//       {
//         "no": 11,
//         "name": "KOOTTAMPULI",
//         "time": "04:15 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU",
//         "time": "04:22 PM",
//         "id": 35
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:28 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:34 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:45 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "04:49 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "05:00 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "MILLER PURAM",
//         "time": "05:05 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:12 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:19 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "05:25 PM",
//         "id": 27
//       }
//     ]
//   },
//   {
//     "id": "52-C-13-36",
//     "routeNo": "52-C",
//     "code": "52/P52C-2",
//     "tripCode": "52/P52C-252-CTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THRES PURAM",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 PM",
//     "endTime": "06:10 PM",
//     "ids": [
//       27,
//       28,
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       35,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "05:30 PM",
//         "id": 27
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:32 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:36 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "MILLER PURAM",
//         "time": "05:40 PM",
//         "id": 29
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "05:43 PM",
//         "id": 39
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "05:48 PM",
//         "id": 4
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:50 PM",
//         "id": 5
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:56 PM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:59 PM",
//         "id": 278
//       },
//       {
//         "no": 10,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:01 PM",
//         "id": 8
//       },
//       {
//         "no": 11,
//         "name": "SIRUPADU",
//         "time": "06:03 PM",
//         "id": 35
//       },
//       {
//         "no": 12,
//         "name": "KOOTTAMPULI",
//         "time": "06:07 PM",
//         "id": 9
//       },
//       {
//         "no": 13,
//         "name": "KULAIYANKARISAL",
//         "time": "06:10 PM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-14-37",
//     "routeNo": "52-C",
//     "code": "52/P52C-3",
//     "tripCode": "52/P52C-352-CTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "SUB COLLECTOR OFFICE",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 PM",
//     "endTime": "07:00 PM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1,
//       28
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "KULAIYANKARISAL",
//         "time": "06:15 PM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "06:18 PM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:24 PM",
//         "id": 8
//       },
//       {
//         "no": 8,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:26 PM",
//         "id": 278
//       },
//       {
//         "no": 7,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:30 PM",
//         "id": 6
//       },
//       {
//         "no": 6,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:37 PM",
//         "id": 5
//       },
//       {
//         "no": 5,
//         "name": "KORAMPALLAM",
//         "time": "06:39 PM",
//         "id": 4
//       },
//       {
//         "no": 4,
//         "name": "3RD MILE",
//         "time": "06:47 PM",
//         "id": 39
//       },
//       {
//         "no": 3,
//         "name": "MILLER PURAM",
//         "time": "06:50 PM",
//         "id": 29
//       },
//       {
//         "no": 2,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:55 PM",
//         "id": 1
//       },
//       {
//         "no": 1,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:00 PM",
//         "id": 28
//       }
//     ]
//   },
//   {
//     "id": "52-C-15-38",
//     "routeNo": "52-C",
//     "code": "52/P52C-3",
//     "tripCode": "52/P52C-352-CTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "SUB COLLECTOR OFFICE",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 PM",
//     "endTime": "08:25 PM",
//     "ids": [
//       28,
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:10 PM",
//         "id": 28
//       },
//       {
//         "no": 2,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:18 PM",
//         "id": 1
//       },
//       {
//         "no": 3,
//         "name": "MILLER PURAM",
//         "time": "07:25 PM",
//         "id": 29
//       },
//       {
//         "no": 4,
//         "name": "3RD MILE",
//         "time": "07:31 PM",
//         "id": 39
//       },
//       {
//         "no": 5,
//         "name": "KORAMPALLAM",
//         "time": "07:43 PM",
//         "id": 4
//       },
//       {
//         "no": 6,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:47 PM",
//         "id": 5
//       },
//       {
//         "no": 7,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:59 PM",
//         "id": 6
//       },
//       {
//         "no": 8,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:06 PM",
//         "id": 278
//       },
//       {
//         "no": 9,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:09 PM",
//         "id": 8
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "08:19 PM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "KULAIYANKARISAL",
//         "time": "08:25 PM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-16-39",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:30 PM",
//     "endTime": "09:35 PM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "08:30 PM",
//         "id": 34
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "08:35 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:45 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:48 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:54 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:06 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:10 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:22 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:27 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-C-17-40",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18U17",
//     "order": 17,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULAIYANKARISAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 PM",
//     "endTime": "10:30 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       34
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:45 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:49 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:59 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:01 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:11 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:16 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:18 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "10:25 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "10:30 PM",
//         "id": 34
//       }
//     ]
//   },
//   {
//     "id": "52-C-18-41",
//     "routeNo": "52-C",
//     "code": "52/P52C-1",
//     "tripCode": "52/P52C-152-CTORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "KULAIYANKARISAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:25 PM",
//     "endTime": "06:10 AM",
//     "ids": [
//       34,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KULAIYANKARISAL",
//         "time": "10:25 PM",
//         "id": 34
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "11:04 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "12:12 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:34 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:19 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:47 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:12 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:37 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:16 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-D-1-42",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:45 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:49 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:53 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:01 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:03 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:11 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:15 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:17 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:23 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:29 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:33 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:36 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:40 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:43 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:45 AM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "07:50 AM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "07:56 AM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "08:00 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-D-2-43",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:30 AM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "08:15 AM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "08:18 AM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "08:24 AM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "08:29 AM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:31 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "08:34 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:38 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "08:41 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:45 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "08:51 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:57 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:59 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:03 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:11 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:13 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:21 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:25 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-D-3-44",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "11:05 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:40 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:45 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:54 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:57 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:06 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:11 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:14 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "10:21 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:28 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "10:32 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:36 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "10:41 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "10:45 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "10:47 AM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "10:53 AM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "11:01 AM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "11:05 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-D-4-45",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:10 AM",
//     "endTime": "12:30 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "11:10 AM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "11:13 AM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "11:19 AM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "11:25 AM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "11:27 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "11:30 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "11:34 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "11:38 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "11:42 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "11:48 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "11:55 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:57 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:01 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:10 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:12 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:20 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "12:24 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-D-5-46",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:50 PM",
//     "endTime": "02:05 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "12:54 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:58 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:06 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:08 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:16 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:20 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "01:22 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "01:28 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "01:34 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "01:38 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "01:41 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "01:45 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "01:48 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "01:50 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "01:55 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "02:01 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "02:05 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-D-6-47",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:10 PM",
//     "endTime": "03:25 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "02:10 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "02:13 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "02:19 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "02:24 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "02:26 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "02:29 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "02:33 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "02:36 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "02:40 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:46 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:52 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:54 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:58 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:06 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:08 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:16 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "03:20 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-D-7-48",
//     "routeNo": "52-D",
//     "code": "52/P52D-2",
//     "tripCode": "52/P52D-252-DTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PANDARAVILAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:30 PM",
//     "endTime": "04:35 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "03:34 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:38 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:45 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:47 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:55 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:59 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "04:01 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "04:07 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "04:12 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "04:15 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:19 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "04:22 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:25 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "04:30 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "04:35 PM",
//         "id": 31
//       }
//     ]
//   },
//   {
//     "id": "52-D-8-49",
//     "routeNo": "52-D",
//     "code": "52/P52D-2",
//     "tripCode": "52/P52D-252-DTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PANDARAVILAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:45 PM",
//     "endTime": "05:50 PM",
//     "ids": [
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "04:45 PM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "04:49 PM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:54 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "04:57 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:00 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "05:04 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "05:07 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "05:12 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "05:18 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:20 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:24 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:32 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:34 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:41 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:45 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-D-9-50",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:55 PM",
//     "endTime": "07:25 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:55 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:00 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:05 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:14 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:17 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:26 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:31 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:34 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "06:41 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "06:48 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "06:52 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:56 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:01 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:05 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:07 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "07:13 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "07:21 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "07:25 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-D-10-51",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 PM",
//     "endTime": "08:45 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "07:50 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "07:52 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "07:56 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "08:00 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:02 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "08:04 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:07 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "08:09 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:12 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "08:16 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:21 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:22 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:25 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:31 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:33 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:38 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:41 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-D-11-52",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:50 PM",
//     "endTime": "10:05 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:54 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:58 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:06 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:08 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:16 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:20 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:22 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "09:28 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "09:34 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "09:38 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "09:41 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "09:45 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:48 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "09:50 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "09:55 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "10:01 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "10:05 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-D-12-53",
//     "routeNo": "52-D",
//     "code": "52/P52D-1",
//     "tripCode": "52/P52D-152-DTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:10 PM",
//     "endTime": "06:30 AM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "10:10 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "10:32 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "11:12 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "11:45 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "11:59 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "12:20 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:45 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "01:08 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "01:33 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:10 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:51 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:05 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:32 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:26 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:41 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:33 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:58 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-E-1-54",
//     "routeNo": "52-E",
//     "code": "52/P52E-1",
//     "tripCode": "52/P52E-152-ETORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:35 AM",
//     "endTime": "06:45 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:39 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:42 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:50 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:52 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:59 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:03 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:05 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "06:11 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "06:16 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "06:19 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:23 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "06:26 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "06:29 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "06:31 AM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "06:36 AM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "06:41 AM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "06:45 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-E-2-55",
//     "routeNo": "52-E",
//     "code": "52/P52E-1",
//     "tripCode": "52/P52E-152-ETORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:05 AM",
//     "endTime": "08:15 AM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "07:05 AM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "07:08 AM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "07:13 AM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:18 AM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:20 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:23 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:26 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:30 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:33 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:38 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:44 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:46 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:50 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:57 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:59 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:07 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:10 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-E-3-56",
//     "routeNo": "52-E",
//     "code": "52/P52E-3",
//     "tripCode": "52/P52E-352-ETORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:35 AM",
//     "endTime": "10:00 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       38,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:39 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:43 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:50 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:53 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:01 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:05 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:07 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "09:13 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "09:18 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "09:22 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "09:25 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "09:29 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:32 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "09:37 AM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "09:42 AM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "09:46 AM",
//         "id": 32
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "09:51 AM",
//         "id": 38
//       },
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "10:00 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-E-4-57",
//     "routeNo": "52-E",
//     "code": "52/P52E-3",
//     "tripCode": "52/P52E-352-ETORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:10 AM",
//     "endTime": "11:40 AM",
//     "ids": [
//       20,
//       38,
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "10:10 AM",
//         "id": 20
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "10:18 AM",
//         "id": 38
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "10:24 AM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "10:28 AM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "10:33 AM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "10:39 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "10:42 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:46 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "10:49 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:53 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "10:59 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "11:05 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:08 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:12 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:20 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:23 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:31 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:34 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-E-5-58",
//     "routeNo": "52-E",
//     "code": "52/P52E-3",
//     "tripCode": "52/P52E-352-ETORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:45 AM",
//     "endTime": "01:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       38,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:49 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:53 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:00 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:03 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:11 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:15 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "12:17 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:23 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "12:28 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "12:32 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:35 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "12:39 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "12:42 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "12:47 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "12:52 PM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "12:56 PM",
//         "id": 32
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "01:01 PM",
//         "id": 38
//       },
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "01:10 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-E-6-59",
//     "routeNo": "52-E",
//     "code": "52/P52E-3",
//     "tripCode": "52/P52E-352-ETORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:15 PM",
//     "endTime": "02:45 PM",
//     "ids": [
//       20,
//       38,
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "01:15 PM",
//         "id": 20
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "01:23 PM",
//         "id": 38
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "01:29 PM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "01:33 PM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "01:38 PM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "01:44 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "01:47 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "01:51 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "01:54 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "01:58 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "02:04 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "02:10 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:13 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:17 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:25 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:28 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:36 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:39 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-E-7-60",
//     "routeNo": "52-E",
//     "code": "52/P52E-2",
//     "tripCode": "52/P52E-252-ETORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:50 PM",
//     "endTime": "04:15 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       37,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:54 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:57 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:04 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:06 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:13 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:17 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "03:19 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "03:25 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "03:30 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "03:33 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "03:36 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "03:40 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "03:42 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "03:44 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "SALAI",
//         "time": "03:53 PM",
//         "id": 37
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "04:12 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "04:15 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-E-8-61",
//     "routeNo": "52-E",
//     "code": "52/P52E-2",
//     "tripCode": "52/P52E-252-ETORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:20 PM",
//     "endTime": "05:40 PM",
//     "ids": [
//       20,
//       19,
//       37,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "04:20 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "04:22 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "SALAI",
//         "time": "04:40 PM",
//         "id": 37
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "04:48 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:50 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "04:52 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:56 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "04:59 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "05:02 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "05:06 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "05:12 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:13 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:17 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:24 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:26 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:32 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:35 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-E-9-62",
//     "routeNo": "52-E",
//     "code": "52/P52E-4",
//     "tripCode": "52/P52E-452-ETORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:50 PM",
//     "endTime": "06:45 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:54 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:57 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:05 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:07 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:14 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:18 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:20 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "06:26 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "06:31 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "06:35 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:38 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "06:42 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "06:45 PM",
//         "id": 40
//       }
//     ]
//   },
//   {
//     "id": "52-E-10-63",
//     "routeNo": "52-E",
//     "code": "52/P52E-4",
//     "tripCode": "52/P52E-452-ETORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 PM",
//     "endTime": "07:45 PM",
//     "ids": [
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "06:50 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "06:52 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:56 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "06:59 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:03 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:08 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:14 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:16 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:20 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:27 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:29 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:37 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:40 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-E-11-64",
//     "routeNo": "52-E",
//     "code": "52/P52E-1",
//     "tripCode": "52/P52E-152-ETORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 PM",
//     "endTime": "09:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:55 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:59 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:07 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:09 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:18 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:22 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:24 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "08:31 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:37 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "08:41 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:45 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "08:49 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:52 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "08:54 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "09:00 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "09:06 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "09:10 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-E-12-65",
//     "routeNo": "52-E",
//     "code": "52/P52E-1",
//     "tripCode": "52/P52E-152-ETORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 PM",
//     "endTime": "10:30 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "09:15 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "09:18 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "09:24 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "09:29 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:31 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "09:34 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "09:38 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "09:41 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "09:45 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "09:51 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:57 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:59 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:03 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:11 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:13 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:21 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:25 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-F-1-66",
//     "routeNo": "52-F",
//     "code": "52/P52F-3",
//     "tripCode": "52/P52F-352-FTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:20 AM",
//     "endTime": "07:50 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       38,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:25 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:28 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:36 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:39 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:47 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:51 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:54 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:00 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:06 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:10 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:13 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:17 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:20 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "07:26 AM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "07:31 AM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "07:35 AM",
//         "id": 32
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "07:41 AM",
//         "id": 38
//       },
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "07:50 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-F-2-67",
//     "routeNo": "52-F",
//     "code": "52/P52F-3",
//     "tripCode": "52/P52F-352-FTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 AM",
//     "endTime": "09:30 AM",
//     "ids": [
//       20,
//       38,
//       32,
//       31,
//       30,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "08:00 AM",
//         "id": 20
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "08:08 AM",
//         "id": 38
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "08:14 AM",
//         "id": 32
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "08:18 AM",
//         "id": 31
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "08:23 AM",
//         "id": 30
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:29 AM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "08:32 AM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:36 AM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "08:39 AM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:43 AM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "08:49 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "08:55 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:58 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:02 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:10 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:13 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:21 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:24 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-F-3-68",
//     "routeNo": "52-F",
//     "code": "52/P52F-6",
//     "tripCode": "52/P52F-652-FTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SIRUPADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "10:20 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       35
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:41 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:45 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:55 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:58 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:08 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:13 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:16 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "SIRUPADU",
//         "time": "10:20 AM",
//         "id": 35
//       }
//     ]
//   },
//   {
//     "id": "52-F-4-69",
//     "routeNo": "52-F",
//     "code": "52/P52F-6",
//     "tripCode": "52/P52F-652-FTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SIRUPADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:25 AM",
//     "endTime": "11:15 AM",
//     "ids": [
//       35,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "SIRUPADU",
//         "time": "10:25 AM",
//         "id": 35
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "10:29 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:31 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:37 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:48 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:52 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:03 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:08 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:15 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-F-5-70",
//     "routeNo": "52-F",
//     "code": "52/P52F-1",
//     "tripCode": "52/P52F-152-FTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:20 AM",
//     "endTime": "12:50 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:25 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:30 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:39 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:42 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:51 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:56 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "11:59 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:06 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "12:13 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "12:17 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:21 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "12:26 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "12:30 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "12:32 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "12:38 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "12:46 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "12:50 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-F-6-71",
//     "routeNo": "52-F",
//     "code": "52/P52F-2",
//     "tripCode": "52/P52F-252-FTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:00 PM",
//     "endTime": "02:20 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "01:00 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "01:03 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "01:09 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "01:15 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "01:17 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "01:20 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "01:24 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "01:28 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "01:32 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "01:38 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "01:45 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:47 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:51 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:00 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:02 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:10 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:14 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-F-7-72",
//     "routeNo": "52-F",
//     "code": "52/P52F-2",
//     "tripCode": "52/P52F-252-FTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:30 PM",
//     "endTime": "03:45 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:34 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:38 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:46 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:48 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:56 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:00 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "03:02 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "03:08 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "03:14 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "03:18 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "03:21 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "03:25 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "03:28 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "03:30 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "03:35 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "03:41 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "03:45 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-F-8-73",
//     "routeNo": "52-F",
//     "code": "52/P52F-2",
//     "tripCode": "52/P52F-252-FTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:40 PM",
//     "endTime": "05:20 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "03:40 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "03:44 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "03:52 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "03:59 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:01 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "04:06 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:11 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "04:15 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "04:20 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "04:28 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "04:36 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:39 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:44 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:55 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:58 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:08 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:13 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-F-9-74",
//     "routeNo": "52-F",
//     "code": "52/P52F-1",
//     "tripCode": "52/P52F-152-FTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 PM",
//     "endTime": "06:45 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       18,
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:34 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:38 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:46 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:48 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:56 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:00 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "06:02 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "06:08 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "06:14 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "06:18 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:21 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "06:25 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "06:28 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "06:30 PM",
//         "id": 17
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "06:35 PM",
//         "id": 18
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "06:41 PM",
//         "id": 19
//       },
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "06:45 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-F-10-75",
//     "routeNo": "52-F",
//     "code": "52/P52F-1",
//     "tripCode": "52/P52F-152-FTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 PM",
//     "endTime": "08:00 PM",
//     "ids": [
//       20,
//       19,
//       18,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "ERAL",
//         "time": "06:50 PM",
//         "id": 20
//       },
//       {
//         "no": 17,
//         "name": "SIRUTHONDANALLUR",
//         "time": "06:53 PM",
//         "id": 19
//       },
//       {
//         "no": 16,
//         "name": "ZAKKAMMALPURAM 1",
//         "time": "06:58 PM",
//         "id": 18
//       },
//       {
//         "no": 15,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:03 PM",
//         "id": 17
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:05 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "07:08 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:11 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:15 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:18 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:23 PM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:29 PM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:31 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:35 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:42 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:44 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:52 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:55 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-F-11-76",
//     "routeNo": "52-F",
//     "code": "52/P52F-4",
//     "tripCode": "52/P52F-452-FTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:35 PM",
//     "endTime": "09:35 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:40 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:43 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:51 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:53 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:02 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:06 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "09:08 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "09:14 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "09:20 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "09:24 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "09:27 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "09:31 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:35 PM",
//         "id": 40
//       }
//     ]
//   },
//   {
//     "id": "52-F-12-77",
//     "routeNo": "52-F",
//     "code": "52/P52F-5",
//     "tripCode": "52/P52F-552-FTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 PM",
//     "endTime": "06:15 AM",
//     "ids": [
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       8,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "09:40 PM",
//         "id": 40
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "10:07 PM",
//         "id": 13
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:40 PM",
//         "id": 12
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "11:11 PM",
//         "id": 37
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "11:44 PM",
//         "id": 10
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "12:32 AM",
//         "id": 9
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "01:27 AM",
//         "id": 8
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:44 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:21 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:31 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:52 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:00 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:31 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-G-1-78",
//     "routeNo": "52-G",
//     "code": "52/P52G-1",
//     "tripCode": "52/P52G-152-GTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 AM",
//     "endTime": "08:30 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       38,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:23 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:26 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:33 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:35 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:41 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:44 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "07:46 AM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "07:51 AM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:55 AM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "07:58 AM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:01 AM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "08:04 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "08:07 AM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "08:11 AM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "08:15 AM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "08:19 AM",
//         "id": 32
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "08:23 AM",
//         "id": 38
//       },
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "08:30 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-2-79",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:40 AM",
//     "endTime": "09:40 AM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "08:40 AM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "08:46 AM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "08:48 AM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "08:51 AM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "08:55 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "08:59 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:05 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:10 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:13 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:20 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:23 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:24 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:31 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:36 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:39 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-G-3-80",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 AM",
//     "endTime": "10:50 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       52,
//       53,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:50 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:53 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:58 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:05 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:06 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:09 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "10:16 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "10:19 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "10:24 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "10:30 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "10:34 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "10:38 AM",
//         "id": 52
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "10:41 AM",
//         "id": 53
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "10:43 AM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "10:50 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-4-81",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18U4",
//     "order": 4,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "KURUMBUR R/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:55 AM",
//     "endTime": "11:10 AM",
//     "ids": [
//       20,
//       55,
//       56,
//       57
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "10:55 AM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "10:58 AM",
//         "id": 55
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "11:07 AM",
//         "id": 56
//       },
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "11:10 AM",
//         "id": 57
//       }
//     ]
//   },
//   {
//     "id": "52-G-5-82",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18D5",
//     "order": 5,
//     "direction": "D",
//     "from": "KURUMBUR R/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:20 AM",
//     "endTime": "11:35 AM",
//     "ids": [
//       57,
//       56,
//       55,
//       20
//     ],
//     "stops": [
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "11:20 AM",
//         "id": 57
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "11:22 AM",
//         "id": 56
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "11:31 AM",
//         "id": 55
//       },
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "11:35 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-6-83",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:40 AM",
//     "endTime": "12:40 PM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "11:40 AM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "11:46 AM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "11:48 AM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "11:51 AM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "11:55 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "11:59 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "12:05 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:10 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "12:13 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "12:20 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "12:23 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "12:24 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "12:31 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "12:36 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "12:39 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-G-7-84",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:50 PM",
//     "endTime": "01:50 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       52,
//       53,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "12:50 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "12:53 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "12:58 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:05 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:06 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:09 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "01:16 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:19 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "01:24 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "01:30 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "01:34 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "01:38 PM",
//         "id": 52
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "01:41 PM",
//         "id": 53
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "01:43 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "01:50 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-8-85",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18U8",
//     "order": 8,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "KURUMBUR R/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:55 PM",
//     "endTime": "02:10 PM",
//     "ids": [
//       20,
//       55,
//       56,
//       57
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "01:55 PM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "01:58 PM",
//         "id": 55
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "02:07 PM",
//         "id": 56
//       },
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "02:10 PM",
//         "id": 57
//       }
//     ]
//   },
//   {
//     "id": "52-G-9-86",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18D9",
//     "order": 9,
//     "direction": "D",
//     "from": "KURUMBUR R/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:30 PM",
//     "endTime": "02:45 PM",
//     "ids": [
//       57,
//       56,
//       55,
//       20
//     ],
//     "stops": [
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "02:30 PM",
//         "id": 57
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "02:32 PM",
//         "id": 56
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "02:41 PM",
//         "id": 55
//       },
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "02:45 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-10-87",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:50 PM",
//     "endTime": "03:50 PM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "02:50 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "02:56 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "02:58 PM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "03:01 PM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "03:05 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "03:09 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "03:15 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:20 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "03:23 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:30 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "03:33 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "03:34 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "03:41 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "03:46 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "03:49 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-G-11-88",
//     "routeNo": "52-G",
//     "code": "52/P52G-1",
//     "tripCode": "52/P52G-152-GTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:00 PM",
//     "endTime": "05:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       8,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       30,
//       31,
//       32,
//       38,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:03 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:06 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:13 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:15 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:21 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:24 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "SIRUPADU JUNCTION",
//         "time": "04:26 PM",
//         "id": 8
//       },
//       {
//         "no": 9,
//         "name": "KOOTTAMPULI",
//         "time": "04:31 PM",
//         "id": 9
//       },
//       {
//         "no": 10,
//         "name": "SERVAIKARANMADAM",
//         "time": "04:35 PM",
//         "id": 10
//       },
//       {
//         "no": 11,
//         "name": "SALAI",
//         "time": "04:38 PM",
//         "id": 37
//       },
//       {
//         "no": 12,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:41 PM",
//         "id": 12
//       },
//       {
//         "no": 13,
//         "name": "SAWYERPURAM",
//         "time": "04:44 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:47 PM",
//         "id": 40
//       },
//       {
//         "no": 15,
//         "name": "NATTATTHI",
//         "time": "04:51 PM",
//         "id": 30
//       },
//       {
//         "no": 16,
//         "name": "PANDARAVILAI",
//         "time": "04:55 PM",
//         "id": 31
//       },
//       {
//         "no": 17,
//         "name": "PERUNKULAM",
//         "time": "04:59 PM",
//         "id": 32
//       },
//       {
//         "no": 18,
//         "name": "MANGALAKURICHI",
//         "time": "05:03 PM",
//         "id": 38
//       },
//       {
//         "no": 20,
//         "name": "ERAL",
//         "time": "05:10 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-12-89",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18U12",
//     "order": 12,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "KURUMBUR R/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:15 PM",
//     "endTime": "05:30 PM",
//     "ids": [
//       20,
//       55,
//       56,
//       57
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "05:15 PM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "05:18 PM",
//         "id": 55
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "05:27 PM",
//         "id": 56
//       },
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "05:30 PM",
//         "id": 57
//       }
//     ]
//   },
//   {
//     "id": "52-G-13-90",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18D13",
//     "order": 13,
//     "direction": "D",
//     "from": "KURUMBUR R/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:40 PM",
//     "endTime": "06:00 PM",
//     "ids": [
//       57,
//       56,
//       55,
//       20
//     ],
//     "stops": [
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "05:40 PM",
//         "id": 57
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "05:43 PM",
//         "id": 56
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "05:55 PM",
//         "id": 55
//       },
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "06:00 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-14-91",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:05 PM",
//     "endTime": "07:00 PM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "06:05 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "06:11 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "06:12 PM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "06:15 PM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "06:19 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "06:23 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "06:28 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:33 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:36 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:42 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:45 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:45 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:52 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:56 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:59 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-G-15-92",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 PM",
//     "endTime": "08:10 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       52,
//       53,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:10 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:13 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:18 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:25 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:26 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:29 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:36 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:39 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "07:44 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "07:50 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "07:54 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "07:58 PM",
//         "id": 52
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "08:01 PM",
//         "id": 53
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "08:03 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "08:10 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-16-93",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18U16",
//     "order": 16,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "KURUMBUR R/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       20,
//       55,
//       56,
//       57
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "08:15 PM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "08:18 PM",
//         "id": 55
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "08:27 PM",
//         "id": 56
//       },
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "08:30 PM",
//         "id": 57
//       }
//     ]
//   },
//   {
//     "id": "52-G-17-94",
//     "routeNo": "52-G",
//     "code": "52/P52G-3",
//     "tripCode": "52/P52G-352-GTORD18D17",
//     "order": 17,
//     "direction": "D",
//     "from": "KURUMBUR R/S",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:35 PM",
//     "endTime": "08:45 PM",
//     "ids": [
//       57,
//       56,
//       55,
//       20
//     ],
//     "stops": [
//       {
//         "no": 5,
//         "name": "KURUMBUR R/S",
//         "time": "08:35 PM",
//         "id": 57
//       },
//       {
//         "no": 4,
//         "name": "KURUMBUR",
//         "time": "08:36 PM",
//         "id": 56
//       },
//       {
//         "no": 2,
//         "name": "SETHUSUBRAMANIAPURAM",
//         "time": "08:42 PM",
//         "id": 55
//       },
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "08:45 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-G-18-95",
//     "routeNo": "52-G",
//     "code": "52/P52G-2",
//     "tripCode": "52/P52G-252-GTORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:50 PM",
//     "endTime": "06:50 AM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "08:50 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "09:56 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "10:15 PM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "10:45 PM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "11:25 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "12:07 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "01:07 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:59 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "02:28 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:34 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:06 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:13 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "05:27 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:13 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:45 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-1-96",
//     "routeNo": "52-K",
//     "code": "52/P52K-1",
//     "tripCode": "52/P52K-152-KTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "THALAMUTHU NAGAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:20 AM",
//     "endTime": "06:30 AM",
//     "ids": [
//       1,
//       279,
//       58,
//       59,
//       60,
//       61,
//       62
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 2",
//         "time": "06:22 AM",
//         "id": 279
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 1",
//         "time": "06:24 AM",
//         "id": 58
//       },
//       {
//         "no": 4,
//         "name": "KEBI",
//         "time": "06:25 AM",
//         "id": 59
//       },
//       {
//         "no": 5,
//         "name": "MURUGAN THEATRE",
//         "time": "06:26 AM",
//         "id": 60
//       },
//       {
//         "no": 6,
//         "name": "RAJA PALAIYAM",
//         "time": "06:28 AM",
//         "id": 61
//       },
//       {
//         "no": 7,
//         "name": "THALAMUTHU NAGAR",
//         "time": "06:30 AM",
//         "id": 62
//       }
//     ]
//   },
//   {
//     "id": "52-K-2-97",
//     "routeNo": "52-K",
//     "code": "52/P52K-2",
//     "tripCode": "52/P52K-252-KTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "THALAMUTHU NAGAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:40 AM",
//     "endTime": "07:10 AM",
//     "ids": [
//       62,
//       111,
//       64,
//       63,
//       58,
//       279,
//       1
//     ],
//     "stops": [
//       {
//         "no": 7,
//         "name": "THALAMUTHU NAGAR",
//         "time": "06:40 AM",
//         "id": 62
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:45 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:48 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:53 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 1",
//         "time": "06:59 AM",
//         "id": 58
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 2",
//         "time": "07:04 AM",
//         "id": 279
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-3-98",
//     "routeNo": "52-K",
//     "code": "52/P52K-3",
//     "tripCode": "52/P52K-352-KTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 AM",
//     "endTime": "07:50 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:21 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:23 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:26 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:27 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:31 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:34 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:37 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:42 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:46 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:50 AM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "52-K-4-99",
//     "routeNo": "52-K",
//     "code": "52/P52K-3",
//     "tripCode": "52/P52K-352-KTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 AM",
//     "endTime": "09:00 AM",
//     "ids": [
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:00 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:06 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:15 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:24 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:31 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:37 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:44 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:46 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:53 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:56 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-5-100",
//     "routeNo": "52-K",
//     "code": "52/P52K-4",
//     "tripCode": "52/P52K-452-KTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 AM",
//     "endTime": "10:15 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:18 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:20 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:25 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:26 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:32 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:37 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:42 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:49 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:56 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:02 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:04 AM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "10:11 AM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "10:15 AM",
//         "id": 76
//       }
//     ]
//   },
//   {
//     "id": "52-K-6-101",
//     "routeNo": "52-K",
//     "code": "52/P52K-4",
//     "tripCode": "52/P52K-452-KTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 AM",
//     "endTime": "11:30 AM",
//     "ids": [
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "10:30 AM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "10:33 AM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:40 AM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:42 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:48 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:55 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:02 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:07 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:12 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:18 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:19 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:24 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:26 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-7-102",
//     "routeNo": "52-K",
//     "code": "52/P52K-5",
//     "tripCode": "52/P52K-552-KTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "THOOTHUKUDI NEW B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:35 AM",
//     "endTime": "04:00 PM",
//     "ids": [
//       1,
//       26,
//       77
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:30 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI NEW B/S",
//         "time": "04:00 PM",
//         "id": 77
//       }
//     ]
//   },
//   {
//     "id": "52-K-8-103",
//     "routeNo": "52-K",
//     "code": "52/P52K-5",
//     "tripCode": "52/P52K-552-KTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "THOOTHUKUDI NEW B/S",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:50 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       77,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI NEW B/S",
//         "time": "11:50 AM",
//         "id": 77
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:53 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-9-104",
//     "routeNo": "52-K",
//     "code": "52/P52K-6",
//     "tripCode": "52/P52K-652-KTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:10 PM",
//     "endTime": "12:55 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       280,
//       75,
//       76
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "12:13 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:16 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "12:18 PM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "12:21 PM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "12:24 PM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "12:26 PM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "12:31 PM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "12:34 PM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "12:40 PM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:42 PM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:46 PM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:47 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:52 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:55 PM",
//         "id": 76
//       }
//     ]
//   },
//   {
//     "id": "52-K-10-105",
//     "routeNo": "52-K",
//     "code": "52/P52K-7",
//     "tripCode": "52/P52K-752-KTORD18U10",
//     "order": 10,
//     "direction": "U",
//     "from": "OTTAPIDARAM",
//     "to": "PARIVALLIKOTTAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:00 PM",
//     "endTime": "02:30 PM",
//     "ids": [
//       76,
//       85,
//       86,
//       87,
//       88,
//       89,
//       90,
//       91,
//       92,
//       93,
//       94,
//       95,
//       96
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "OTTAPIDARAM",
//         "time": "01:00 PM",
//         "id": 76
//       },
//       {
//         "no": 2,
//         "name": "OSANOOTTHU",
//         "time": "01:14 PM",
//         "id": 85
//       },
//       {
//         "no": 3,
//         "name": "KOMBADI",
//         "time": "01:21 PM",
//         "id": 86
//       },
//       {
//         "no": 4,
//         "name": "PANDIAPURAM",
//         "time": "01:32 PM",
//         "id": 87
//       },
//       {
//         "no": 5,
//         "name": "PARAIKUTTAM",
//         "time": "01:36 PM",
//         "id": 88
//       },
//       {
//         "no": 6,
//         "name": "VADAMALAPURAM",
//         "time": "01:42 PM",
//         "id": 89
//       },
//       {
//         "no": 7,
//         "name": "MANIYACCHI",
//         "time": "01:46 PM",
//         "id": 90
//       },
//       {
//         "no": 8,
//         "name": "OTTANATTHAM",
//         "time": "01:59 PM",
//         "id": 91
//       },
//       {
//         "no": 9,
//         "name": "KALLATTHIKINARU",
//         "time": "02:06 PM",
//         "id": 92
//       },
//       {
//         "no": 10,
//         "name": "MALAIPATTI",
//         "time": "02:12 PM",
//         "id": 93
//       },
//       {
//         "no": 11,
//         "name": "ILAVELANKAL",
//         "time": "02:20 PM",
//         "id": 94
//       },
//       {
//         "no": 12,
//         "name": "IYRAVIPATTI",
//         "time": "02:25 PM",
//         "id": 95
//       },
//       {
//         "no": 13,
//         "name": "PARIVALLIKOTTAI",
//         "time": "02:30 PM",
//         "id": 96
//       }
//     ]
//   },
//   {
//     "id": "52-K-11-106",
//     "routeNo": "52-K",
//     "code": "52/P52K-7",
//     "tripCode": "52/P52K-752-KTORD18D11",
//     "order": 11,
//     "direction": "D",
//     "from": "PARIVALLIKOTTAI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:35 PM",
//     "endTime": "03:30 PM",
//     "ids": [
//       96,
//       95,
//       94,
//       93,
//       92,
//       91,
//       90,
//       89,
//       88,
//       87,
//       86,
//       85,
//       76
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "PARIVALLIKOTTAI",
//         "time": "02:35 PM",
//         "id": 96
//       },
//       {
//         "no": 12,
//         "name": "IYRAVIPATTI",
//         "time": "02:37 PM",
//         "id": 95
//       },
//       {
//         "no": 11,
//         "name": "ILAVELANKAL",
//         "time": "02:40 PM",
//         "id": 94
//       },
//       {
//         "no": 10,
//         "name": "MALAIPATTI",
//         "time": "02:45 PM",
//         "id": 93
//       },
//       {
//         "no": 9,
//         "name": "KALLATTHIKINARU",
//         "time": "02:49 PM",
//         "id": 92
//       },
//       {
//         "no": 8,
//         "name": "OTTANATTHAM",
//         "time": "02:53 PM",
//         "id": 91
//       },
//       {
//         "no": 7,
//         "name": "MANIYACCHI",
//         "time": "03:01 PM",
//         "id": 90
//       },
//       {
//         "no": 6,
//         "name": "VADAMALAPURAM",
//         "time": "03:04 PM",
//         "id": 89
//       },
//       {
//         "no": 5,
//         "name": "PARAIKUTTAM",
//         "time": "03:07 PM",
//         "id": 88
//       },
//       {
//         "no": 4,
//         "name": "PANDIAPURAM",
//         "time": "03:09 PM",
//         "id": 87
//       },
//       {
//         "no": 3,
//         "name": "KOMBADI",
//         "time": "03:16 PM",
//         "id": 86
//       },
//       {
//         "no": 2,
//         "name": "OSANOOTTHU",
//         "time": "03:21 PM",
//         "id": 85
//       },
//       {
//         "no": 1,
//         "name": "OTTAPIDARAM",
//         "time": "03:30 PM",
//         "id": 76
//       }
//     ]
//   },
//   {
//     "id": "52-K-12-107",
//     "routeNo": "52-K",
//     "code": "52/P52K-4",
//     "tripCode": "52/P52K-452-KTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:35 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "03:35 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "03:36 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "03:39 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "03:40 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "03:42 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "03:45 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "03:48 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:50 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:52 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:55 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:55 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:57 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:58 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-13-108",
//     "routeNo": "52-K",
//     "code": "52/P52K-8",
//     "tripCode": "52/P52K-852-KTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KURUKKUSALAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:10 PM",
//     "endTime": "04:50 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:12 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:14 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "04:19 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "04:20 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "04:25 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "04:28 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "04:33 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "04:40 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "04:45 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "04:50 PM",
//         "id": 100
//       }
//     ]
//   },
//   {
//     "id": "52-K-14-109",
//     "routeNo": "52-K",
//     "code": "52/P52K-9",
//     "tripCode": "52/P52K-952-KTORD18U14",
//     "order": 14,
//     "direction": "U",
//     "from": "KURUKKUSALAI",
//     "to": "NORTH AARAIKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 PM",
//     "endTime": "05:50 PM",
//     "ids": [
//       100,
//       101,
//       102,
//       103,
//       76,
//       109,
//       105,
//       85,
//       106,
//       110,
//       108
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "KURUKKUSALAI",
//         "time": "05:00 PM",
//         "id": 100
//       },
//       {
//         "no": 2,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "05:03 PM",
//         "id": 101
//       },
//       {
//         "no": 3,
//         "name": "KAKKARAMPATTI JUNCTION",
//         "time": "05:08 PM",
//         "id": 102
//       },
//       {
//         "no": 4,
//         "name": "MEENAKSHIPURAM",
//         "time": "05:10 PM",
//         "id": 103
//       },
//       {
//         "no": 5,
//         "name": "OTTAPIDARAM",
//         "time": "05:23 PM",
//         "id": 76
//       },
//       {
//         "no": 6,
//         "name": "OTTAPIDARAM TALUK OFFICE",
//         "time": "05:24 PM",
//         "id": 109
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR KOVIL",
//         "time": "05:27 PM",
//         "id": 105
//       },
//       {
//         "no": 8,
//         "name": "OSANOOTTHU",
//         "time": "05:38 PM",
//         "id": 85
//       },
//       {
//         "no": 9,
//         "name": "KULASEKARANALLOOR",
//         "time": "05:41 PM",
//         "id": 106
//       },
//       {
//         "no": 10,
//         "name": "THERKKU ARAIKULAM",
//         "time": "05:47 PM",
//         "id": 110
//       },
//       {
//         "no": 11,
//         "name": "NORTH AARAIKULAM",
//         "time": "05:50 PM",
//         "id": 108
//       }
//     ]
//   },
//   {
//     "id": "52-K-15-110",
//     "routeNo": "52-K",
//     "code": "52/P52K-10",
//     "tripCode": "52/P52K-1052-KTORD18D15",
//     "order": 15,
//     "direction": "D",
//     "from": "NORTH AARAIKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:00 PM",
//     "endTime": "07:00 PM",
//     "ids": [
//       108,
//       110,
//       106,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "NORTH AARAIKULAM",
//         "time": "06:00 PM",
//         "id": 108
//       },
//       {
//         "no": 19,
//         "name": "THERKKU ARAIKULAM",
//         "time": "06:01 PM",
//         "id": 110
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "06:05 PM",
//         "id": 106
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "06:07 PM",
//         "id": 85
//       },
//       {
//         "no": 16,
//         "name": "AYYANAR KOVIL",
//         "time": "06:14 PM",
//         "id": 105
//       },
//       {
//         "no": 15,
//         "name": "TALUK OFFICE",
//         "time": "06:16 PM",
//         "id": 109
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "06:17 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "06:19 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "06:24 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "06:26 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:30 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:35 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:40 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:44 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:47 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:51 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:52 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:56 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:57 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "52-K-16-111",
//     "routeNo": "52-K",
//     "code": "52/P52K-11",
//     "tripCode": "52/P52K-1152-KTORD18U16",
//     "order": 16,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 PM",
//     "endTime": "08:10 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       52,
//       53,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:10 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:13 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:18 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:25 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:26 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:29 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:36 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:39 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "07:44 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "07:50 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "07:54 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "07:58 PM",
//         "id": 52
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "08:01 PM",
//         "id": 53
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "08:03 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "08:10 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "52-K-17-112",
//     "routeNo": "52-K",
//     "code": "52/P52K-11",
//     "tripCode": "52/P52K-1152-KTORD18D17",
//     "order": 17,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:20 PM",
//     "endTime": "10:00 PM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "08:20 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "08:31 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "08:34 PM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "08:39 PM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "08:45 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "08:52 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:02 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:11 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:16 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:27 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:32 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:33 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:46 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:53 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:59 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-A-1-113",
//     "routeNo": "53-A",
//     "code": "53/P53A-1",
//     "tripCode": "53/P53A-153-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 AM",
//     "endTime": "06:40 AM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       120,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "05:30 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "05:33 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:36 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:42 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "05:45 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "05:46 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "05:51 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "05:52 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:01 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "06:07 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "06:09 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "06:14 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "06:18 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "06:20 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "06:25 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 1",
//         "time": "06:31 AM",
//         "id": 120
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "06:35 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "06:40 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-A-2-114",
//     "routeNo": "53-A",
//     "code": "53/P53A-2",
//     "tripCode": "53/P53A-253-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THULUKKANKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:40 AM",
//     "endTime": "06:50 AM",
//     "ids": [
//       122,
//       126,
//       125,
//       124,
//       285
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "KEELA VAIPPAR",
//         "time": "06:40 AM",
//         "id": 122
//       },
//       {
//         "no": 4,
//         "name": "VAIPPAR",
//         "time": "06:44 AM",
//         "id": 126
//       },
//       {
//         "no": 3,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "06:47 AM",
//         "id": 125
//       },
//       {
//         "no": 2,
//         "name": "KALAIGNANAPURAM",
//         "time": "06:49 AM",
//         "id": 124
//       },
//       {
//         "no": 1,
//         "name": "THULUKKANKULAM",
//         "time": "06:50 AM",
//         "id": 285
//       }
//     ]
//   },
//   {
//     "id": "53-A-3-115",
//     "routeNo": "53-A",
//     "code": "53/P53A-2",
//     "tripCode": "53/P53A-253-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THULUKKANKULAM",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:05 AM",
//     "endTime": "07:15 AM",
//     "ids": [
//       285,
//       124,
//       125,
//       126,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THULUKKANKULAM",
//         "time": "07:05 AM",
//         "id": 285
//       },
//       {
//         "no": 2,
//         "name": "KALAIGNANAPURAM",
//         "time": "07:05 AM",
//         "id": 124
//       },
//       {
//         "no": 3,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "07:07 AM",
//         "id": 125
//       },
//       {
//         "no": 4,
//         "name": "VAIPPAR",
//         "time": "07:10 AM",
//         "id": 126
//       },
//       {
//         "no": 6,
//         "name": "KEELA VAIPPAR",
//         "time": "07:15 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-A-4-116",
//     "routeNo": "53-A",
//     "code": "53/P53A-1",
//     "tripCode": "53/P53A-153-ATORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 AM",
//     "endTime": "08:35 AM",
//     "ids": [
//       122,
//       284,
//       120,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "07:20 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "07:25 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 1",
//         "time": "07:29 AM",
//         "id": 120
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "07:35 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "07:41 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "07:42 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "07:47 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "07:52 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "07:54 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "08:01 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:10 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:11 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:17 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:18 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:21 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:27 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:30 AM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "08:35 AM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-A-5-117",
//     "routeNo": "53-A",
//     "code": "53/P53A-5",
//     "tripCode": "53/P53A-553-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KURUMBUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:50 AM",
//     "endTime": "10:00 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       127,
//       157,
//       49,
//       50,
//       51,
//       172,
//       129,
//       130,
//       131,
//       56
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:50 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:54 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:59 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:07 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:08 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:12 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "09:19 AM",
//         "id": 127
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:23 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:29 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "09:36 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "09:41 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "09:44 AM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "09:46 AM",
//         "id": 129
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "09:51 AM",
//         "id": 130
//       },
//       {
//         "no": 16,
//         "name": "MICHEAL NADAR KUDIYIRUPPU",
//         "time": "09:56 AM",
//         "id": 131
//       },
//       {
//         "no": 17,
//         "name": "KURUMBUR",
//         "time": "10:00 AM",
//         "id": 56
//       }
//     ]
//   },
//   {
//     "id": "53-A-6-118",
//     "routeNo": "53-A",
//     "code": "53/P53A-5",
//     "tripCode": "53/P53A-553-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KURUMBUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:05 AM",
//     "endTime": "11:35 AM",
//     "ids": [
//       56,
//       131,
//       130,
//       129,
//       172,
//       51,
//       50,
//       49,
//       157,
//       127,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "KURUMBUR",
//         "time": "10:05 AM",
//         "id": 56
//       },
//       {
//         "no": 16,
//         "name": "MICHEAL NADAR KUDIYIRUPPU",
//         "time": "10:09 AM",
//         "id": 131
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "10:16 AM",
//         "id": 130
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "10:22 AM",
//         "id": 129
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "10:24 AM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "10:29 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "10:35 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "10:44 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "10:52 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "10:57 AM",
//         "id": 127
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "11:06 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "11:10 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:11 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:22 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "11:29 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "11:34 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:35 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-A-7-119",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:40 AM",
//     "endTime": "12:25 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:41 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:43 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:46 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:46 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:50 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:53 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:56 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "12:00 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:04 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:07 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "12:14 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:20 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:25 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "53-A-8-120",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:30 PM",
//     "endTime": "01:20 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:30 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:34 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "12:41 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:49 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:52 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "12:57 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:01 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:05 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:08 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:12 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:13 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:16 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:18 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-A-9-121",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:40 PM",
//     "endTime": "02:30 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:41 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:43 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:46 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:47 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:51 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:54 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:58 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "02:02 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:07 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:10 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "02:18 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "02:25 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "02:30 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "53-A-10-122",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:45 PM",
//     "endTime": "03:35 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "02:45 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "02:49 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "02:56 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "03:04 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "03:07 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "03:12 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "03:16 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:20 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:23 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:27 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:28 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:31 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:33 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-A-11-123",
//     "routeNo": "53-A",
//     "code": "53/P53A-3",
//     "tripCode": "53/P53A-353-ATORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:45 PM",
//     "endTime": "04:55 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       52,
//       53,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "03:45 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "03:49 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "03:54 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:03 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:04 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "04:07 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "04:15 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "04:18 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "04:24 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "04:31 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "04:36 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "04:41 PM",
//         "id": 52
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "04:45 PM",
//         "id": 53
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "04:47 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "04:55 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "53-A-12-124",
//     "routeNo": "53-A",
//     "code": "53/P53A-3",
//     "tripCode": "53/P53A-353-ATORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:05 PM",
//     "endTime": "06:20 PM",
//     "ids": [
//       20,
//       54,
//       53,
//       52,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "05:05 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "05:13 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "VAZHAVALLAN",
//         "time": "05:15 PM",
//         "id": 53
//       },
//       {
//         "no": 13,
//         "name": "UMARIKADU",
//         "time": "05:19 PM",
//         "id": 52
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "05:24 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "05:29 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "05:37 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "05:43 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "05:47 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "05:55 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "05:59 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:00 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:09 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:15 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:19 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-A-13-125",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:35 PM",
//     "endTime": "07:20 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:36 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:38 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:41 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:41 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:45 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:48 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:51 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:55 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:59 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:02 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "07:09 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:15 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:20 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "53-A-14-126",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:25 PM",
//     "endTime": "08:40 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:25 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:32 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "07:42 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:54 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:59 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:06 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:12 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:18 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:22 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:28 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:29 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:34 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:37 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-A-15-127",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:50 PM",
//     "endTime": "09:40 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:51 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:53 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:56 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:57 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:01 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:04 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:08 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:12 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:17 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:20 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "09:28 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "09:35 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "09:40 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "53-A-16-128",
//     "routeNo": "53-A",
//     "code": "53/P53A-4",
//     "tripCode": "53/P53A-453-ATORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 PM",
//     "endTime": "10:35 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "09:50 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "09:54 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "10:00 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:07 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:10 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:14 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:18 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:21 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:24 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "10:28 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "10:28 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "10:31 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:33 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-B-1-129",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:00 PM",
//     "endTime": "02:10 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:02 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "01:06 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "01:09 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "01:11 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "01:12 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "01:17 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "01:19 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "01:27 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "01:33 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "01:35 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "01:40 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "01:45 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "01:46 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "01:52 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "02:03 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "02:05 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "02:10 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-2-130",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:15 PM",
//     "endTime": "03:25 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "02:15 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "02:19 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "02:21 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "02:32 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "02:38 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "02:39 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "02:44 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "02:49 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "02:51 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "02:57 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "03:05 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "03:07 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "03:12 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "03:13 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "03:15 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "03:18 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:22 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-B-3-131",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:30 PM",
//     "endTime": "06:15 AM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:59 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "04:47 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:24 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "05:55 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:12 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "07:14 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "07:30 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "09:22 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "10:37 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "11:01 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "12:04 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "01:03 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "01:18 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "02:31 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "04:47 AM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "05:13 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "06:15 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-4-132",
//     "routeNo": "53-B",
//     "code": "53/P53B-2",
//     "tripCode": "53/P53B-253-BTORD18U4",
//     "order": 4,
//     "direction": "U",
//     "from": "KEELA VAIPPAR",
//     "to": "THULUKKANKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:20 PM",
//     "endTime": "04:55 PM",
//     "ids": [
//       122,
//       126,
//       125,
//       124,
//       285
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "KEELA VAIPPAR",
//         "time": "04:20 PM",
//         "id": 122
//       },
//       {
//         "no": 3,
//         "name": "VAIPPAR",
//         "time": "04:36 PM",
//         "id": 126
//       },
//       {
//         "no": 4,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "04:46 PM",
//         "id": 125
//       },
//       {
//         "no": 5,
//         "name": "KALAIGNANAPURAM",
//         "time": "04:51 PM",
//         "id": 124
//       },
//       {
//         "no": 6,
//         "name": "THULUKKANKULAM",
//         "time": "04:55 PM",
//         "id": 285
//       }
//     ]
//   },
//   {
//     "id": "53-B-5-133",
//     "routeNo": "53-B",
//     "code": "53/P53B-2",
//     "tripCode": "53/P53B-253-BTORD18D5",
//     "order": 5,
//     "direction": "D",
//     "from": "THULUKKANKULAM",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 PM",
//     "endTime": "05:35 PM",
//     "ids": [
//       285,
//       124,
//       125,
//       126,
//       122
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "THULUKKANKULAM",
//         "time": "05:00 PM",
//         "id": 285
//       },
//       {
//         "no": 5,
//         "name": "KALAIGNANAPURAM",
//         "time": "05:03 PM",
//         "id": 124
//       },
//       {
//         "no": 4,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "05:08 PM",
//         "id": 125
//       },
//       {
//         "no": 3,
//         "name": "VAIPPAR",
//         "time": "05:18 PM",
//         "id": 126
//       },
//       {
//         "no": 1,
//         "name": "KEELA VAIPPAR",
//         "time": "05:35 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-6-134",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:40 PM",
//     "endTime": "06:30 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "05:40 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "05:43 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "05:44 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "05:52 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "05:56 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "05:57 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "06:00 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "06:04 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "06:05 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:10 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:16 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:17 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:20 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:21 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:23 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "06:25 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:28 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-B-7-135",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:35 PM",
//     "endTime": "07:55 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:37 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "06:42 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:45 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:48 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:49 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:55 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:56 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "07:06 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "07:13 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "07:15 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "07:21 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "07:26 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "07:28 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "07:34 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "07:47 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "07:49 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "07:55 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-8-136",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 PM",
//     "endTime": "09:05 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "08:00 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "08:04 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "08:06 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "08:16 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "08:21 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "08:22 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "08:27 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "08:31 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "08:33 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "08:39 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:47 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:48 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:53 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:54 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:56 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:59 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:02 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-B-9-137",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:20 PM",
//     "endTime": "11:50 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:23 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "10:27 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "10:31 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "10:34 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "10:36 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "10:42 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "10:44 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "10:55 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "11:03 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "11:05 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "11:12 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "11:18 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "11:19 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "11:27 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "11:41 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "11:43 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "11:50 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-10-138",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:20 AM",
//     "endTime": "06:30 AM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "05:20 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "05:24 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "05:26 AM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "05:37 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "05:43 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "05:44 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "05:49 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "05:54 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "05:56 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:02 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:10 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:12 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:17 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:18 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:20 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "06:23 AM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:27 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-B-11-139",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:45 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:47 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "06:51 AM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:54 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:57 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:58 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "07:04 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "07:05 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "07:14 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "07:21 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "07:23 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "07:28 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "07:33 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "07:34 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "07:41 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "07:52 AM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "07:54 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "08:00 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-12-140",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:30 AM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "08:15 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "08:20 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "08:22 AM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "08:33 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "08:40 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "08:41 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "08:46 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "08:51 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "08:53 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "09:00 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "09:09 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "09:10 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "09:16 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "09:17 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "09:20 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "09:23 AM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:27 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-B-13-141",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "10:50 AM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:37 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "09:41 AM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "09:44 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "09:47 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "09:48 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "09:54 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "09:55 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "10:04 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "10:11 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "10:13 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "10:18 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "10:23 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "10:24 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "10:31 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "10:42 AM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "10:44 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "10:50 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-B-14-142",
//     "routeNo": "53-B",
//     "code": "53/P53B-1",
//     "tripCode": "53/P53B-153-BTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:55 AM",
//     "endTime": "12:05 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "10:55 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "10:59 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "11:01 AM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "11:12 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "11:18 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "11:19 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "11:24 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "11:29 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "11:31 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "11:37 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "11:45 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "11:47 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "11:52 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "11:53 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "11:55 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "11:58 AM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "12:02 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-C-1-143",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:00 PM",
//     "endTime": "03:20 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:02 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "02:07 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "02:10 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "02:13 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "02:14 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "02:20 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "02:21 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "02:31 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "02:38 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "02:40 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "02:46 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "02:51 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "02:53 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "02:59 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "03:12 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "03:14 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "03:20 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-C-2-144",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:25 PM",
//     "endTime": "04:40 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "03:25 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "03:30 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "03:32 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "03:43 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "03:50 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "03:51 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "03:56 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "04:01 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "04:03 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "04:10 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "04:19 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "04:20 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "04:26 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "04:27 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "04:30 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "04:33 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:37 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-C-3-145",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 PM",
//     "endTime": "06:20 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:02 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "05:07 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:10 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "05:13 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "05:14 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "05:20 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "05:21 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "05:31 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "05:38 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "05:40 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "05:46 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "05:51 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "05:53 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "05:59 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "06:12 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "06:14 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "06:20 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-C-4-146",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 PM",
//     "endTime": "07:50 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "06:30 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "06:35 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "06:37 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "06:50 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "06:56 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "06:58 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "07:03 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "07:09 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "07:11 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "07:18 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "07:28 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "07:29 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "07:35 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "07:36 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "07:39 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "07:42 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:47 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-C-5-147",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 PM",
//     "endTime": "09:20 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:07 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:11 PM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:14 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:17 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:18 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:24 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:25 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "08:34 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "08:41 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "08:43 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "08:48 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "08:53 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "08:54 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "09:01 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "09:12 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "09:14 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "09:20 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-C-6-148",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:30 PM",
//     "endTime": "10:30 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "09:30 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "09:34 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "09:35 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "09:45 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "09:50 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "09:51 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "09:55 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "09:59 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "10:01 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "10:06 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "10:13 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "10:14 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "10:19 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "10:20 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "10:22 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "10:24 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:27 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-C-7-149",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:05 AM",
//     "endTime": "06:20 AM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:05 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:07 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "05:11 AM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:14 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "05:17 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "05:18 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "05:24 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "05:25 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "05:34 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "05:41 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "05:43 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "05:48 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "05:53 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "05:54 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "06:01 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "06:12 AM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "06:14 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "06:20 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-C-8-150",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 AM",
//     "endTime": "07:45 AM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "06:30 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "06:35 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "06:37 AM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "06:48 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "06:55 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "06:56 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "07:01 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "07:06 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "07:08 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "07:15 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "07:24 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "07:25 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "07:31 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "07:32 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "07:35 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "07:38 AM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:42 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-C-9-151",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 AM",
//     "endTime": "09:20 AM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:00 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:02 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:07 AM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:10 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:13 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:14 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:20 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:21 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "08:31 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "08:38 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "08:40 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "08:46 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "08:51 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "08:53 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "08:59 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "09:12 AM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "09:14 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "09:20 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-C-10-152",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:25 AM",
//     "endTime": "10:50 AM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "09:25 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "09:30 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "09:33 AM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "09:46 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "09:53 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "09:54 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "10:00 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "10:06 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "10:08 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "10:16 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "10:26 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "10:28 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "10:34 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "10:35 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "10:38 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "10:42 AM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:47 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:50 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-C-11-153",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:05 AM",
//     "endTime": "12:20 PM",
//     "ids": [
//       1,
//       26,
//       282,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:05 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:07 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "11:11 AM",
//         "id": 282
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "11:14 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "11:17 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "11:18 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "11:24 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "11:25 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "11:34 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "11:41 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "11:43 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "11:48 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "11:53 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "11:54 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "12:01 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "12:12 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "12:14 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "12:20 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-C-12-154",
//     "routeNo": "53-C",
//     "code": "53/P53C-1",
//     "tripCode": "53/P53C-153-CTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:30 PM",
//     "endTime": "01:50 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       282,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "12:30 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "12:35 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "12:37 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "12:50 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "12:56 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "12:58 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "01:03 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "01:09 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "01:11 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "01:18 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "01:28 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "01:29 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "01:35 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "01:36 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "01:39 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "01:42 PM",
//         "id": 282
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:47 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-D-1-155",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:20 PM",
//     "endTime": "01:45 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "12:20 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "12:24 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:28 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "12:34 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "12:37 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "12:39 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "12:44 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "12:46 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "12:56 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "01:03 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "01:05 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "01:11 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "01:16 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "01:18 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "01:24 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "01:37 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "01:39 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "01:45 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-D-2-156",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:50 PM",
//     "endTime": "03:05 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "01:50 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "01:54 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "01:57 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "02:07 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "02:13 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "02:15 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "02:19 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "02:24 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "02:26 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "02:32 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "02:41 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "02:43 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "02:48 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "02:49 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "02:51 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:57 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "03:01 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "03:05 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-D-3-157",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:20 PM",
//     "endTime": "04:15 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "03:20 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "03:22 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:25 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "03:29 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "03:31 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "03:32 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "03:36 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "03:37 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "03:43 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "03:48 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "03:49 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "03:53 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "03:56 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "03:57 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "04:01 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "04:09 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "04:11 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "04:15 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-D-4-158",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:20 PM",
//     "endTime": "05:30 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "04:20 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "04:24 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "04:26 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "04:36 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "04:42 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "04:43 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "04:47 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "04:52 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "04:54 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "04:59 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "05:08 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "05:09 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "05:14 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "05:15 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:17 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:23 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "05:26 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "05:30 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-D-5-159",
//     "routeNo": "53-D",
//     "code": "53/P53D-2",
//     "tripCode": "53/P53D-253-DTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 PM",
//     "endTime": "07:00 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       133,
//       134,
//       135,
//       136,
//       287,
//       137,
//       138,
//       139,
//       118,
//       132,
//       140,
//       141
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "05:45 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "05:48 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:52 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:58 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:00 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:02 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:07 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:08 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:17 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "AM PATTI",
//         "time": "06:22 PM",
//         "id": 133
//       },
//       {
//         "no": 11,
//         "name": "THERMAL STATION",
//         "time": "06:23 PM",
//         "id": 134
//       },
//       {
//         "no": 12,
//         "name": "AM PATTI JUNCTION",
//         "time": "06:27 PM",
//         "id": 135
//       },
//       {
//         "no": 13,
//         "name": "MELA MARUTHUR",
//         "time": "06:30 PM",
//         "id": 136
//       },
//       {
//         "no": 14,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "06:34 PM",
//         "id": 287
//       },
//       {
//         "no": 15,
//         "name": "DURAISAMYPURAM 1",
//         "time": "06:38 PM",
//         "id": 137
//       },
//       {
//         "no": 16,
//         "name": "SOUTH KALMEDU",
//         "time": "06:42 PM",
//         "id": 138
//       },
//       {
//         "no": 17,
//         "name": "NORTH KALMEDU",
//         "time": "06:43 PM",
//         "id": 139
//       },
//       {
//         "no": 18,
//         "name": "VEPPALODAI",
//         "time": "06:47 PM",
//         "id": 118
//       },
//       {
//         "no": 19,
//         "name": "PANAIYOOR GATE",
//         "time": "06:53 PM",
//         "id": 132
//       },
//       {
//         "no": 20,
//         "name": "PANAIYOOR",
//         "time": "06:56 PM",
//         "id": 140
//       },
//       {
//         "no": 21,
//         "name": "KULATTHOOR 1",
//         "time": "07:00 PM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-D-6-160",
//     "routeNo": "53-D",
//     "code": "53/P53D-3",
//     "tripCode": "53/P53D-353-DTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       141,
//       140,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "07:20 PM",
//         "id": 141
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "07:23 PM",
//         "id": 140
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "07:27 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "07:33 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "07:34 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "07:40 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "07:45 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "07:47 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "07:54 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:04 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:05 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:11 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:12 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:15 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:22 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:25 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "08:30 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-D-7-161",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:00 PM",
//     "endTime": "10:01 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "09:00 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "09:03 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:05 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "09:10 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "09:12 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "09:13 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "09:17 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "09:18 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "09:26 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "09:31 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "09:32 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "09:36 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "09:40 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "09:41 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "09:46 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "09:55 PM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "09:56 PM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "10:01 PM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-D-8-162",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:20 PM",
//     "endTime": "11:30 PM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "10:20 PM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "10:24 PM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "10:26 PM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "10:36 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "10:42 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "10:43 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "10:47 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "10:52 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "10:54 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "10:59 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "11:08 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "11:09 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "11:14 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "11:15 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "11:17 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:23 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "11:26 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "11:30 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-D-9-163",
//     "routeNo": "53-D",
//     "code": "53/P53D-3",
//     "tripCode": "53/P53D-353-DTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:00 AM",
//     "endTime": "07:15 AM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       140,
//       141
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "06:00 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "06:04 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:08 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:15 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:18 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:19 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:25 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:27 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:37 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "06:45 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "06:47 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "06:53 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "06:58 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "07:00 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "07:07 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "07:11 AM",
//         "id": 140
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "07:15 AM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-D-10-164",
//     "routeNo": "53-D",
//     "code": "53/P53D-2",
//     "tripCode": "53/P53D-253-DTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 AM",
//     "endTime": "08:35 AM",
//     "ids": [
//       141,
//       140,
//       132,
//       118,
//       139,
//       138,
//       137,
//       287,
//       136,
//       135,
//       134,
//       133,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "KULATTHOOR 1",
//         "time": "07:20 AM",
//         "id": 141
//       },
//       {
//         "no": 20,
//         "name": "PANAIYOOR",
//         "time": "07:23 AM",
//         "id": 140
//       },
//       {
//         "no": 19,
//         "name": "PANAIYOOR GATE",
//         "time": "07:26 AM",
//         "id": 132
//       },
//       {
//         "no": 18,
//         "name": "VEPPALODAI",
//         "time": "07:32 AM",
//         "id": 118
//       },
//       {
//         "no": 17,
//         "name": "NORTH KALMEDU",
//         "time": "07:36 AM",
//         "id": 139
//       },
//       {
//         "no": 16,
//         "name": "SOUTH KALMEDU",
//         "time": "07:37 AM",
//         "id": 138
//       },
//       {
//         "no": 15,
//         "name": "DURAISAMYPURAM 1",
//         "time": "07:41 AM",
//         "id": 137
//       },
//       {
//         "no": 14,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "07:45 AM",
//         "id": 287
//       },
//       {
//         "no": 13,
//         "name": "MELA MARUTHUR",
//         "time": "07:49 AM",
//         "id": 136
//       },
//       {
//         "no": 12,
//         "name": "AM PATTI JUNCTION",
//         "time": "07:52 AM",
//         "id": 135
//       },
//       {
//         "no": 11,
//         "name": "THERMAL STATION",
//         "time": "07:56 AM",
//         "id": 134
//       },
//       {
//         "no": 10,
//         "name": "AM PATTI",
//         "time": "07:57 AM",
//         "id": 133
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "08:02 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:11 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:12 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:17 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:19 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:21 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:27 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:31 AM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "08:35 AM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-D-11-165",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA VAIPPAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:40 AM",
//     "endTime": "09:55 AM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       286,
//       284,
//       122
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "08:40 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "08:43 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:47 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "08:53 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:55 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:56 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "09:01 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "09:03 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "09:12 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "09:18 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "09:20 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "09:25 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "09:29 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "09:31 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "09:37 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "09:47 AM",
//         "id": 286
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "09:50 AM",
//         "id": 284
//       },
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "09:55 AM",
//         "id": 122
//       }
//     ]
//   },
//   {
//     "id": "53-D-12-166",
//     "routeNo": "53-D",
//     "code": "53/P53D-1",
//     "tripCode": "53/P53D-153-DTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KEELA VAIPPAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:00 AM",
//     "endTime": "11:20 AM",
//     "ids": [
//       122,
//       284,
//       286,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "KEELA VAIPPAR",
//         "time": "10:00 AM",
//         "id": 122
//       },
//       {
//         "no": 17,
//         "name": "KALLOORANI",
//         "time": "10:05 AM",
//         "id": 284
//       },
//       {
//         "no": 16,
//         "name": "SALT FACTORY 2",
//         "time": "10:07 AM",
//         "id": 286
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "10:19 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "10:25 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "10:26 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "10:31 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "10:37 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "10:39 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "10:45 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "10:55 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "10:56 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "11:01 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "11:03 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "11:06 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:12 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "11:15 AM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "11:20 AM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-E-1-167",
//     "routeNo": "53-E",
//     "code": "53/P53E-2",
//     "tripCode": "53/P53E-253-ETORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:35 PM",
//     "endTime": "02:00 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       140,
//       141
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "01:35 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "01:36 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:37 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "01:40 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "01:41 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "01:41 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "01:43 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "01:44 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "01:47 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "01:50 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "01:50 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "01:52 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "01:54 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "01:55 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "01:57 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "01:58 PM",
//         "id": 140
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "02:00 PM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-E-2-168",
//     "routeNo": "53-E",
//     "code": "53/P53E-2",
//     "tripCode": "53/P53E-253-ETORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:45 PM",
//     "endTime": "04:10 PM",
//     "ids": [
//       141,
//       140,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "02:45 PM",
//         "id": 141
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "02:48 PM",
//         "id": 140
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "02:53 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "03:01 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "03:03 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "03:09 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "03:16 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "03:18 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "03:26 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "03:38 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "03:40 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "03:47 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "03:49 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "03:52 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "04:04 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "04:10 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-E-3-169",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:15 PM",
//     "endTime": "05:30 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       140,
//       141,
//       142,
//       288
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "04:15 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "04:18 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:22 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "04:28 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "04:31 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "04:32 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "04:37 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "04:38 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "04:48 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "04:54 PM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "04:56 PM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "05:01 PM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "05:06 PM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "05:07 PM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "05:13 PM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "05:17 PM",
//         "id": 140
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "05:20 PM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "05:23 PM",
//         "id": 142
//       },
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "05:30 PM",
//         "id": 288
//       }
//     ]
//   },
//   {
//     "id": "53-E-4-170",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:35 PM",
//     "endTime": "06:50 PM",
//     "ids": [
//       288,
//       142,
//       141,
//       140,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "05:35 PM",
//         "id": 288
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "05:41 PM",
//         "id": 142
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "05:44 PM",
//         "id": 141
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "05:47 PM",
//         "id": 140
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "05:51 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "05:57 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "05:58 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "06:03 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "06:08 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "06:10 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:16 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:26 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:27 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:32 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:33 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:36 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:42 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "06:46 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "06:50 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-E-5-171",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 PM",
//     "endTime": "06:00 AM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       140,
//       141,
//       142,
//       288
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "07:15 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "07:48 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:17 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "09:10 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "09:32 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "09:44 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "10:28 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "10:39 PM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "11:59 PM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "12:52 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "01:09 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "01:54 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "02:35 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "02:46 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "03:38 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "04:09 AM",
//         "id": 140
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "04:35 AM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "04:59 AM",
//         "id": 142
//       },
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "06:00 AM",
//         "id": 288
//       }
//     ]
//   },
//   {
//     "id": "53-E-6-172",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:10 AM",
//     "endTime": "07:10 AM",
//     "ids": [
//       288,
//       142,
//       141,
//       140,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "06:10 AM",
//         "id": 288
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "06:15 AM",
//         "id": 142
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "06:17 AM",
//         "id": 141
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "06:20 AM",
//         "id": 140
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "06:23 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "06:27 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "06:28 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "06:32 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "06:37 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "06:38 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "06:43 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "06:50 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "06:51 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "06:56 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "06:57 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "06:59 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:04 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "07:06 AM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "07:10 AM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-E-7-173",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:45 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       140,
//       141,
//       142,
//       288
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "07:45 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "07:49 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:52 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "07:59 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "08:02 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "08:03 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "08:09 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "08:10 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "08:20 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "08:26 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "08:28 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "08:34 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "08:39 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "08:41 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "08:47 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "08:51 AM",
//         "id": 140
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "08:54 AM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "08:57 AM",
//         "id": 142
//       },
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "09:05 AM",
//         "id": 288
//       }
//     ]
//   },
//   {
//     "id": "53-E-8-174",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 AM",
//     "endTime": "10:30 AM",
//     "ids": [
//       288,
//       142,
//       141,
//       140,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "09:10 AM",
//         "id": 288
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "09:17 AM",
//         "id": 142
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "09:20 AM",
//         "id": 141
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "09:23 AM",
//         "id": 140
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "09:27 AM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "09:33 AM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "09:35 AM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "09:40 AM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "09:46 AM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "09:48 AM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "09:54 AM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "10:04 AM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "10:05 AM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "10:11 AM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "10:12 AM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "10:15 AM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:22 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "10:25 AM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "10:30 AM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-E-9-175",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SUBRAMANIYAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:45 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       113,
//       114,
//       283,
//       115,
//       116,
//       117,
//       118,
//       132,
//       140,
//       141,
//       142,
//       288
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "10:45 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "10:48 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:52 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "10:58 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "11:01 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "11:02 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "11:07 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "11:08 AM",
//         "id": 113
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "11:18 AM",
//         "id": 114
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "11:24 AM",
//         "id": 283
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "11:26 AM",
//         "id": 115
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "11:31 AM",
//         "id": 116
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "11:36 AM",
//         "id": 117
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "11:37 AM",
//         "id": 118
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "11:43 AM",
//         "id": 132
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "11:47 AM",
//         "id": 140
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "11:50 AM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "11:53 AM",
//         "id": 142
//       },
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "12:00 PM",
//         "id": 288
//       }
//     ]
//   },
//   {
//     "id": "53-E-10-176",
//     "routeNo": "53-E",
//     "code": "53/P53E-1",
//     "tripCode": "53/P53E-153-ETORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "SUBRAMANIYAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:10 PM",
//     "endTime": "01:30 PM",
//     "ids": [
//       288,
//       142,
//       141,
//       140,
//       132,
//       118,
//       117,
//       116,
//       115,
//       283,
//       114,
//       113,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "SUBRAMANIYAPURAM 3",
//         "time": "12:10 PM",
//         "id": 288
//       },
//       {
//         "no": 18,
//         "name": "COLONY",
//         "time": "12:17 PM",
//         "id": 142
//       },
//       {
//         "no": 17,
//         "name": "KULATTHOOR 1",
//         "time": "12:20 PM",
//         "id": 141
//       },
//       {
//         "no": 16,
//         "name": "PANAIYOOR",
//         "time": "12:23 PM",
//         "id": 140
//       },
//       {
//         "no": 15,
//         "name": "PANAIYOOR GATE",
//         "time": "12:27 PM",
//         "id": 132
//       },
//       {
//         "no": 14,
//         "name": "VEPPALODAI",
//         "time": "12:33 PM",
//         "id": 118
//       },
//       {
//         "no": 13,
//         "name": "CHEMICAL X",
//         "time": "12:35 PM",
//         "id": 117
//       },
//       {
//         "no": 12,
//         "name": "KALMEDU",
//         "time": "12:40 PM",
//         "id": 116
//       },
//       {
//         "no": 11,
//         "name": "PATTINAMARUTHUR",
//         "time": "12:46 PM",
//         "id": 115
//       },
//       {
//         "no": 10,
//         "name": "ZAKKAMMALPURAM 2",
//         "time": "12:48 PM",
//         "id": 283
//       },
//       {
//         "no": 9,
//         "name": "THARUVAIKULAM",
//         "time": "12:54 PM",
//         "id": 114
//       },
//       {
//         "no": 8,
//         "name": "JOTHI SALT",
//         "time": "01:04 PM",
//         "id": 113
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "01:05 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "01:11 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "01:12 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "01:15 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:22 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "01:25 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "01:30 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "53-F-1-177",
//     "routeNo": "53-F",
//     "code": "53/P53F-1",
//     "tripCode": "53/P53F-153-FTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 AM",
//     "endTime": "07:30 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       143,
//       144,
//       145,
//       135,
//       136,
//       287,
//       137,
//       146,
//       147,
//       148,
//       149,
//       141
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:32 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:33 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:37 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:38 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:42 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "06:44 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "06:46 AM",
//         "id": 143
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "06:48 AM",
//         "id": 144
//       },
//       {
//         "no": 10,
//         "name": "KUMARAPURAM 1",
//         "time": "06:53 AM",
//         "id": 145
//       },
//       {
//         "no": 11,
//         "name": "AM PATTI JUNCTION",
//         "time": "06:55 AM",
//         "id": 135
//       },
//       {
//         "no": 12,
//         "name": "MELA MARUTHUR",
//         "time": "06:58 AM",
//         "id": 136
//       },
//       {
//         "no": 13,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "07:02 AM",
//         "id": 287
//       },
//       {
//         "no": 14,
//         "name": "DURAISAMYPURAM 1",
//         "time": "07:05 AM",
//         "id": 137
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 1",
//         "time": "07:07 AM",
//         "id": 146
//       },
//       {
//         "no": 16,
//         "name": "VEDANATTHAM",
//         "time": "07:11 AM",
//         "id": 147
//       },
//       {
//         "no": 17,
//         "name": "VENKATACHALAPURAM",
//         "time": "07:15 AM",
//         "id": 148
//       },
//       {
//         "no": 18,
//         "name": "MUTHUKUMARAPURAM",
//         "time": "07:19 AM",
//         "id": 149
//       },
//       {
//         "no": 20,
//         "name": "KULATTHOOR 1",
//         "time": "07:30 AM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-F-2-178",
//     "routeNo": "53-F",
//     "code": "53/P53F-2",
//     "tripCode": "53/P53F-253-FTORD18U2",
//     "order": 2,
//     "direction": "U",
//     "from": "KULATTHOOR",
//     "to": "THULUKKANKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:35 AM",
//     "endTime": "07:45 AM",
//     "ids": [
//       141,
//       142,
//       150,
//       126,
//       125,
//       285
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "KULATTHOOR 1",
//         "time": "07:35 AM",
//         "id": 141
//       },
//       {
//         "no": 2,
//         "name": "COLONY",
//         "time": "07:36 AM",
//         "id": 142
//       },
//       {
//         "no": 3,
//         "name": "SUBRAMANIYAPURAM JUNCTION",
//         "time": "07:38 AM",
//         "id": 150
//       },
//       {
//         "no": 4,
//         "name": "VAIPPAR",
//         "time": "07:41 AM",
//         "id": 126
//       },
//       {
//         "no": 5,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "07:43 AM",
//         "id": 125
//       },
//       {
//         "no": 6,
//         "name": "THULUKKANKULAM",
//         "time": "07:45 AM",
//         "id": 285
//       }
//     ]
//   },
//   {
//     "id": "53-F-3-179",
//     "routeNo": "53-F",
//     "code": "53/P53F-2",
//     "tripCode": "53/P53F-253-FTORD18D3",
//     "order": 3,
//     "direction": "D",
//     "from": "THULUKKANKULAM",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       285,
//       125,
//       126,
//       150,
//       142,
//       141
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "THULUKKANKULAM",
//         "time": "07:50 AM",
//         "id": 285
//       },
//       {
//         "no": 5,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "07:51 AM",
//         "id": 125
//       },
//       {
//         "no": 4,
//         "name": "VAIPPAR",
//         "time": "07:53 AM",
//         "id": 126
//       },
//       {
//         "no": 3,
//         "name": "SUBRAMANIYAPURAM JUNCTION",
//         "time": "07:56 AM",
//         "id": 150
//       },
//       {
//         "no": 2,
//         "name": "COLONY",
//         "time": "07:58 AM",
//         "id": 142
//       },
//       {
//         "no": 1,
//         "name": "KULATTHOOR 1",
//         "time": "08:00 AM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-F-4-180",
//     "routeNo": "53-F",
//     "code": "53/P53F-1",
//     "tripCode": "53/P53F-153-FTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 AM",
//     "endTime": "09:25 AM",
//     "ids": [
//       141,
//       149,
//       148,
//       147,
//       146,
//       137,
//       287,
//       136,
//       135,
//       145,
//       144,
//       143,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "KULATTHOOR 1",
//         "time": "08:05 AM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "MUTHUKUMARAPURAM",
//         "time": "08:19 AM",
//         "id": 149
//       },
//       {
//         "no": 17,
//         "name": "VENKATACHALAPURAM",
//         "time": "08:24 AM",
//         "id": 148
//       },
//       {
//         "no": 16,
//         "name": "VEDANATTHAM",
//         "time": "08:29 AM",
//         "id": 147
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 1",
//         "time": "08:34 AM",
//         "id": 146
//       },
//       {
//         "no": 14,
//         "name": "DURAISAMYPURAM 1",
//         "time": "08:38 AM",
//         "id": 137
//       },
//       {
//         "no": 13,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "08:42 AM",
//         "id": 287
//       },
//       {
//         "no": 12,
//         "name": "MELA MARUTHUR",
//         "time": "08:46 AM",
//         "id": 136
//       },
//       {
//         "no": 11,
//         "name": "AM PATTI JUNCTION",
//         "time": "08:50 AM",
//         "id": 135
//       },
//       {
//         "no": 10,
//         "name": "KUMARAPURAM 1",
//         "time": "08:53 AM",
//         "id": 145
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "09:00 AM",
//         "id": 144
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "09:02 AM",
//         "id": 143
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "09:06 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:08 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:14 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:15 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:20 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:22 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-F-5-181",
//     "routeNo": "53-F",
//     "code": "53/P53F-4",
//     "tripCode": "53/P53F-453-FTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA SEITHALAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "10:20 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       111,
//       155,
//       156
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:35 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:36 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:38 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:38 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:40 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "09:41 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "09:43 AM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "09:46 AM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "09:48 AM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "09:49 AM",
//         "id": 100
//       },
//       {
//         "no": 13,
//         "name": "THOMAS NAGAR",
//         "time": "10:00 AM",
//         "id": 111
//       },
//       {
//         "no": 14,
//         "name": "SEITHALAI JUNCTION",
//         "time": "10:17 AM",
//         "id": 155
//       },
//       {
//         "no": 15,
//         "name": "KEELA SEITHALAI",
//         "time": "10:20 AM",
//         "id": 156
//       }
//     ]
//   },
//   {
//     "id": "53-F-6-182",
//     "routeNo": "53-F",
//     "code": "53/P53F-4",
//     "tripCode": "53/P53F-453-FTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KEELA SEITHALAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 AM",
//     "endTime": "11:30 AM",
//     "ids": [
//       156,
//       155,
//       111,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "KEELA SEITHALAI",
//         "time": "10:30 AM",
//         "id": 156
//       },
//       {
//         "no": 14,
//         "name": "SEITHALAI JUNCTION",
//         "time": "10:33 AM",
//         "id": 155
//       },
//       {
//         "no": 13,
//         "name": "THOMAS NAGAR",
//         "time": "10:55 AM",
//         "id": 111
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "11:10 AM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "11:12 AM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "11:15 AM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "11:18 AM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "11:20 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:22 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:24 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:25 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:27 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:28 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-F-7-183",
//     "routeNo": "53-F",
//     "code": "53/P53F-3",
//     "tripCode": "53/P53F-353-FTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KOLLAMPARAMBU",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:35 AM",
//     "endTime": "12:15 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       152,
//       289,
//       154
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:36 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:38 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:41 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:42 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:45 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "11:47 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "11:51 AM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "11:56 AM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "11:59 AM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "12:02 PM",
//         "id": 100
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 1",
//         "time": "12:08 PM",
//         "id": 152
//       },
//       {
//         "no": 14,
//         "name": "CHANDRAGIRI",
//         "time": "12:09 PM",
//         "id": 289
//       },
//       {
//         "no": 15,
//         "name": "KOLLAMPARAMBU",
//         "time": "12:15 PM",
//         "id": 154
//       }
//     ]
//   },
//   {
//     "id": "53-F-8-184",
//     "routeNo": "53-F",
//     "code": "53/P53F-3",
//     "tripCode": "53/P53F-353-FTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KOLLAMPARAMBU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:20 PM",
//     "endTime": "01:30 PM",
//     "ids": [
//       154,
//       289,
//       152,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "KOLLAMPARAMBU",
//         "time": "12:20 PM",
//         "id": 154
//       },
//       {
//         "no": 14,
//         "name": "CHANDRAGIRI",
//         "time": "12:29 PM",
//         "id": 289
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 1",
//         "time": "12:31 PM",
//         "id": 152
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "12:41 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "12:46 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "12:52 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "01:01 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "01:07 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:10 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:17 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:18 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:24 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:26 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-F-9-185",
//     "routeNo": "53-F",
//     "code": "53/P53F-4",
//     "tripCode": "53/P53F-453-FTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA SEITHALAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:35 PM",
//     "endTime": "02:30 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       111,
//       155,
//       156
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:36 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:37 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:39 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:39 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:42 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "01:43 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "01:45 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "01:48 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "01:51 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "01:52 PM",
//         "id": 100
//       },
//       {
//         "no": 13,
//         "name": "THOMAS NAGAR",
//         "time": "02:06 PM",
//         "id": 111
//       },
//       {
//         "no": 14,
//         "name": "SEITHALAI JUNCTION",
//         "time": "02:26 PM",
//         "id": 155
//       },
//       {
//         "no": 15,
//         "name": "KEELA SEITHALAI",
//         "time": "02:30 PM",
//         "id": 156
//       }
//     ]
//   },
//   {
//     "id": "53-F-10-186",
//     "routeNo": "53-F",
//     "code": "53/P53F-4",
//     "tripCode": "53/P53F-453-FTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KEELA SEITHALAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:40 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       156,
//       155,
//       111,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "KEELA SEITHALAI",
//         "time": "02:40 PM",
//         "id": 156
//       },
//       {
//         "no": 14,
//         "name": "SEITHALAI JUNCTION",
//         "time": "02:40 PM",
//         "id": 155
//       },
//       {
//         "no": 13,
//         "name": "THOMAS NAGAR",
//         "time": "02:46 PM",
//         "id": 111
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "02:50 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "02:50 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "02:51 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "02:52 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "02:52 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:53 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:53 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:53 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:54 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:54 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-F-11-187",
//     "routeNo": "53-F",
//     "code": "53/P53F-1",
//     "tripCode": "53/P53F-153-FTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:00 PM",
//     "endTime": "05:10 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       143,
//       144,
//       145,
//       135,
//       136,
//       287,
//       137,
//       146,
//       147,
//       148,
//       149,
//       141
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:02 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:04 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "04:08 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "04:09 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "04:14 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "04:16 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "04:19 PM",
//         "id": 143
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "04:21 PM",
//         "id": 144
//       },
//       {
//         "no": 10,
//         "name": "KUMARAPURAM 1",
//         "time": "04:27 PM",
//         "id": 145
//       },
//       {
//         "no": 11,
//         "name": "AM PATTI JUNCTION",
//         "time": "04:29 PM",
//         "id": 135
//       },
//       {
//         "no": 12,
//         "name": "MELA MARUTHUR",
//         "time": "04:33 PM",
//         "id": 136
//       },
//       {
//         "no": 13,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "04:37 PM",
//         "id": 287
//       },
//       {
//         "no": 14,
//         "name": "DURAISAMYPURAM 1",
//         "time": "04:40 PM",
//         "id": 137
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 1",
//         "time": "04:44 PM",
//         "id": 146
//       },
//       {
//         "no": 16,
//         "name": "VEDANATTHAM",
//         "time": "04:48 PM",
//         "id": 147
//       },
//       {
//         "no": 17,
//         "name": "VENKATACHALAPURAM",
//         "time": "04:52 PM",
//         "id": 148
//       },
//       {
//         "no": 18,
//         "name": "MUTHUKUMARAPURAM",
//         "time": "04:57 PM",
//         "id": 149
//       },
//       {
//         "no": 20,
//         "name": "KULATTHOOR 1",
//         "time": "05:10 PM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-F-12-188",
//     "routeNo": "53-F",
//     "code": "53/P53F-2",
//     "tripCode": "53/P53F-253-FTORD18U12",
//     "order": 12,
//     "direction": "U",
//     "from": "KULATTHOOR",
//     "to": "THULUKKANKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "03:50 PM",
//     "ids": [
//       141,
//       142,
//       150,
//       126,
//       125,
//       285
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "KULATTHOOR 1",
//         "time": "03:00 PM",
//         "id": 141
//       },
//       {
//         "no": 2,
//         "name": "COLONY",
//         "time": "03:06 PM",
//         "id": 142
//       },
//       {
//         "no": 3,
//         "name": "SUBRAMANIYAPURAM JUNCTION",
//         "time": "03:19 PM",
//         "id": 150
//       },
//       {
//         "no": 4,
//         "name": "VAIPPAR",
//         "time": "03:32 PM",
//         "id": 126
//       },
//       {
//         "no": 5,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "03:41 PM",
//         "id": 125
//       },
//       {
//         "no": 6,
//         "name": "THULUKKANKULAM",
//         "time": "03:50 PM",
//         "id": 285
//       }
//     ]
//   },
//   {
//     "id": "53-F-13-189",
//     "routeNo": "53-F",
//     "code": "53/P53F-2",
//     "tripCode": "53/P53F-253-FTORD18D13",
//     "order": 13,
//     "direction": "D",
//     "from": "THULUKKANKULAM",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:15 PM",
//     "endTime": "05:25 PM",
//     "ids": [
//       285,
//       125,
//       126,
//       150,
//       142,
//       141
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "THULUKKANKULAM",
//         "time": "05:15 PM",
//         "id": 285
//       },
//       {
//         "no": 5,
//         "name": "KALAIGNANAPURAM JUNCTION",
//         "time": "05:16 PM",
//         "id": 125
//       },
//       {
//         "no": 4,
//         "name": "VAIPPAR",
//         "time": "05:18 PM",
//         "id": 126
//       },
//       {
//         "no": 3,
//         "name": "SUBRAMANIYAPURAM JUNCTION",
//         "time": "05:21 PM",
//         "id": 150
//       },
//       {
//         "no": 2,
//         "name": "COLONY",
//         "time": "05:23 PM",
//         "id": 142
//       },
//       {
//         "no": 1,
//         "name": "KULATTHOOR 1",
//         "time": "05:25 PM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-F-14-190",
//     "routeNo": "53-F",
//     "code": "53/P53F-1",
//     "tripCode": "53/P53F-153-FTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 PM",
//     "endTime": "06:45 PM",
//     "ids": [
//       141,
//       149,
//       148,
//       147,
//       146,
//       137,
//       287,
//       136,
//       135,
//       145,
//       144,
//       143,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "KULATTHOOR 1",
//         "time": "05:30 PM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "MUTHUKUMARAPURAM",
//         "time": "05:43 PM",
//         "id": 149
//       },
//       {
//         "no": 17,
//         "name": "VENKATACHALAPURAM",
//         "time": "05:48 PM",
//         "id": 148
//       },
//       {
//         "no": 16,
//         "name": "VEDANATTHAM",
//         "time": "05:52 PM",
//         "id": 147
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 1",
//         "time": "05:57 PM",
//         "id": 146
//       },
//       {
//         "no": 14,
//         "name": "DURAISAMYPURAM 1",
//         "time": "06:01 PM",
//         "id": 137
//       },
//       {
//         "no": 13,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "06:04 PM",
//         "id": 287
//       },
//       {
//         "no": 12,
//         "name": "MELA MARUTHUR",
//         "time": "06:09 PM",
//         "id": 136
//       },
//       {
//         "no": 11,
//         "name": "AM PATTI JUNCTION",
//         "time": "06:12 PM",
//         "id": 135
//       },
//       {
//         "no": 10,
//         "name": "KUMARAPURAM 1",
//         "time": "06:15 PM",
//         "id": 145
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "06:21 PM",
//         "id": 144
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "06:23 PM",
//         "id": 143
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "06:27 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:29 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:34 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:36 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:40 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:42 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "53-F-15-191",
//     "routeNo": "53-F",
//     "code": "53/P53F-1",
//     "tripCode": "53/P53F-153-FTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 PM",
//     "endTime": "08:05 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       143,
//       144,
//       145,
//       135,
//       136,
//       287,
//       137,
//       146,
//       147,
//       148,
//       149,
//       141
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:52 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:54 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:58 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:00 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:05 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "07:07 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "07:11 PM",
//         "id": 143
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "07:13 PM",
//         "id": 144
//       },
//       {
//         "no": 10,
//         "name": "KUMARAPURAM 1",
//         "time": "07:19 PM",
//         "id": 145
//       },
//       {
//         "no": 11,
//         "name": "AM PATTI JUNCTION",
//         "time": "07:22 PM",
//         "id": 135
//       },
//       {
//         "no": 12,
//         "name": "MELA MARUTHUR",
//         "time": "07:25 PM",
//         "id": 136
//       },
//       {
//         "no": 13,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "07:30 PM",
//         "id": 287
//       },
//       {
//         "no": 14,
//         "name": "DURAISAMYPURAM 1",
//         "time": "07:33 PM",
//         "id": 137
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 1",
//         "time": "07:37 PM",
//         "id": 146
//       },
//       {
//         "no": 16,
//         "name": "VEDANATTHAM",
//         "time": "07:42 PM",
//         "id": 147
//       },
//       {
//         "no": 17,
//         "name": "VENKATACHALAPURAM",
//         "time": "07:46 PM",
//         "id": 148
//       },
//       {
//         "no": 18,
//         "name": "MUTHUKUMARAPURAM",
//         "time": "07:51 PM",
//         "id": 149
//       },
//       {
//         "no": 20,
//         "name": "KULATTHOOR 1",
//         "time": "08:05 PM",
//         "id": 141
//       }
//     ]
//   },
//   {
//     "id": "53-F-16-192",
//     "routeNo": "53-F",
//     "code": "53/P53F-1",
//     "tripCode": "53/P53F-153-FTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 PM",
//     "endTime": "09:20 PM",
//     "ids": [
//       141,
//       149,
//       148,
//       147,
//       146,
//       137,
//       287,
//       136,
//       135,
//       145,
//       144,
//       143,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "KULATTHOOR 1",
//         "time": "08:10 PM",
//         "id": 141
//       },
//       {
//         "no": 18,
//         "name": "MUTHUKUMARAPURAM",
//         "time": "08:22 PM",
//         "id": 149
//       },
//       {
//         "no": 17,
//         "name": "VENKATACHALAPURAM",
//         "time": "08:27 PM",
//         "id": 148
//       },
//       {
//         "no": 16,
//         "name": "VEDANATTHAM",
//         "time": "08:31 PM",
//         "id": 147
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 1",
//         "time": "08:35 PM",
//         "id": 146
//       },
//       {
//         "no": 14,
//         "name": "DURAISAMYPURAM 1",
//         "time": "08:39 PM",
//         "id": 137
//       },
//       {
//         "no": 13,
//         "name": "ZAKKAMMALPURAM 3",
//         "time": "08:42 PM",
//         "id": 287
//       },
//       {
//         "no": 12,
//         "name": "MELA MARUTHUR",
//         "time": "08:46 PM",
//         "id": 136
//       },
//       {
//         "no": 11,
//         "name": "AM PATTI JUNCTION",
//         "time": "08:50 PM",
//         "id": 135
//       },
//       {
//         "no": 10,
//         "name": "KUMARAPURAM 1",
//         "time": "08:52 PM",
//         "id": 145
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "08:58 PM",
//         "id": 144
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "09:00 PM",
//         "id": 143
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "09:03 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:05 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:10 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:11 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:15 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:17 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-1-193",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:15 PM",
//     "endTime": "03:15 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "02:15 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "02:21 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "02:30 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:43 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:45 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:51 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "03:03 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:08 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "03:08 PM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "03:15 PM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-2-194",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:20 PM",
//     "endTime": "04:20 PM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "03:20 PM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "03:26 PM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:26 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "03:31 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:43 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "03:49 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "03:51 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:04 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:13 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:19 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-3-195",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:25 PM",
//     "endTime": "05:15 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:25 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:25 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:30 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:37 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:49 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:50 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "04:55 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "05:05 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "05:09 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "05:09 PM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "05:15 PM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-4-196",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:20 PM",
//     "endTime": "06:20 PM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "05:20 PM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "05:26 PM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "05:26 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "05:31 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "05:43 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "05:49 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "05:51 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:04 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:13 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:19 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-5-197",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:25 PM",
//     "endTime": "07:25 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:25 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:25 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:31 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:40 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:53 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:55 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:01 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:13 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:18 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "07:18 PM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "07:25 PM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-6-198",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 PM",
//     "endTime": "08:55 PM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "07:30 PM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "07:38 PM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:38 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:46 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:03 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:12 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:13 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:33 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:45 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:53 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-7-199",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:00 PM",
//     "endTime": "09:50 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:00 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:05 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:12 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:24 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:25 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:30 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:40 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:44 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "09:44 PM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "09:50 PM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-8-200",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:55 PM",
//     "endTime": "06:10 AM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "09:55 PM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "10:46 PM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "10:46 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "11:30 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:10 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:59 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:11 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:04 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:14 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:02 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-11-201",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:15 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:20 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:27 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:39 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:40 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:45 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "08:55 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "08:59 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "08:59 AM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "09:05 AM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-12-202",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 AM",
//     "endTime": "10:10 AM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "09:10 AM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "09:16 AM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:16 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:21 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:33 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:39 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:41 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:54 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:03 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:09 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-13-203",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:15 AM",
//     "endTime": "11:05 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:15 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:20 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:27 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:39 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:40 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:45 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "10:55 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "10:59 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "10:59 AM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "11:05 AM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-14-204",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:10 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "11:10 AM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "11:15 AM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "11:15 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "11:19 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "11:29 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "11:34 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:35 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:47 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "11:54 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "11:59 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-A-15-205",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:05 PM",
//     "endTime": "12:55 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "12:05 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "12:10 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "12:17 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "12:29 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "12:30 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "12:35 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "12:45 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:49 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "12:49 PM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "12:55 PM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-A-16-206",
//     "routeNo": "54-A",
//     "code": "54/P54A-1",
//     "tripCode": "54/P54A-154-ATORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:00 PM",
//     "endTime": "02:10 PM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "01:00 PM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "01:07 PM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:07 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "01:13 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:27 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:34 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:36 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:52 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "02:02 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "02:08 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-B-1-207",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ARUMUGAMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:45 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       290,
//       159,
//       160,
//       161,
//       162
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "01:45 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "01:50 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:56 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:07 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:08 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:13 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "02:22 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "02:27 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "02:34 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "02:40 PM",
//         "id": 290
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "02:40 PM",
//         "id": 159
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "02:45 PM",
//         "id": 160
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "02:48 PM",
//         "id": 161
//       },
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "02:55 PM",
//         "id": 162
//       }
//     ]
//   },
//   {
//     "id": "54-B-2-208",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "ARUMUGAMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "04:10 PM",
//     "ids": [
//       162,
//       161,
//       160,
//       159,
//       290,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "03:00 PM",
//         "id": 162
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "03:06 PM",
//         "id": 161
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "03:09 PM",
//         "id": 160
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "03:14 PM",
//         "id": 159
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "03:14 PM",
//         "id": 290
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "03:20 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:27 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "03:32 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:41 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "03:46 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "03:47 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "03:58 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:04 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:09 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-B-3-209",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ARUMUGAMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:20 PM",
//     "endTime": "05:35 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       290,
//       159,
//       160,
//       161,
//       162
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:20 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:25 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:32 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:44 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:45 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "04:50 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "05:00 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "05:05 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "05:13 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "05:19 PM",
//         "id": 290
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "05:19 PM",
//         "id": 159
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "05:25 PM",
//         "id": 160
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "05:27 PM",
//         "id": 161
//       },
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "05:35 PM",
//         "id": 162
//       }
//     ]
//   },
//   {
//     "id": "54-B-4-210",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "ARUMUGAMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:40 PM",
//     "endTime": "07:05 PM",
//     "ids": [
//       162,
//       161,
//       160,
//       159,
//       290,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "05:40 PM",
//         "id": 162
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "05:48 PM",
//         "id": 161
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "05:51 PM",
//         "id": 160
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "05:57 PM",
//         "id": 159
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "05:57 PM",
//         "id": 290
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "06:04 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:13 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:18 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:30 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:36 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:37 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:50 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:58 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:04 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-B-5-211",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ARUMUGAMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       290,
//       159,
//       160,
//       161,
//       162
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:10 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:15 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:23 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:35 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:37 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:42 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:53 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:58 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "08:06 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "08:13 PM",
//         "id": 290
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "08:13 PM",
//         "id": 159
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "08:19 PM",
//         "id": 160
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "08:22 PM",
//         "id": 161
//       },
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "08:30 PM",
//         "id": 162
//       }
//     ]
//   },
//   {
//     "id": "54-B-6-212",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ARUMUGAMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:35 PM",
//     "endTime": "05:20 AM",
//     "ids": [
//       162,
//       161,
//       160,
//       159,
//       290,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "08:35 PM",
//         "id": 162
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "09:25 PM",
//         "id": 161
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "09:44 PM",
//         "id": 160
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "10:25 PM",
//         "id": 159
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "10:26 PM",
//         "id": 290
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "11:06 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:04 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "12:35 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:46 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:21 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:29 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "03:50 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:40 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:14 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-B-7-213",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ARUMUGAMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:25 AM",
//     "endTime": "06:40 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       290,
//       159,
//       160,
//       161,
//       162
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:25 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:25 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:30 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "05:37 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "05:49 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "05:50 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "05:55 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:05 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:10 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "06:18 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "06:24 AM",
//         "id": 290
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "06:24 AM",
//         "id": 159
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "06:30 AM",
//         "id": 160
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "06:32 AM",
//         "id": 161
//       },
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "06:40 AM",
//         "id": 162
//       }
//     ]
//   },
//   {
//     "id": "54-B-8-214",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "ARUMUGAMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:45 AM",
//     "endTime": "08:05 AM",
//     "ids": [
//       162,
//       161,
//       160,
//       159,
//       290,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "06:45 AM",
//         "id": 162
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "06:52 AM",
//         "id": 161
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "06:55 AM",
//         "id": 160
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "07:01 AM",
//         "id": 159
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "07:01 AM",
//         "id": 290
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "07:08 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:16 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:21 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:32 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:37 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:39 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:51 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:59 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:04 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:05 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-B-9-215",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ARUMUGAMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 AM",
//     "endTime": "09:25 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       290,
//       159,
//       160,
//       161,
//       162
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:10 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:15 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:22 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:34 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:35 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:40 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "08:50 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "08:55 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:03 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "09:09 AM",
//         "id": 290
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "09:09 AM",
//         "id": 159
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "09:15 AM",
//         "id": 160
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "09:17 AM",
//         "id": 161
//       },
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "09:25 AM",
//         "id": 162
//       }
//     ]
//   },
//   {
//     "id": "54-B-10-216",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "ARUMUGAMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:30 AM",
//     "endTime": "10:45 AM",
//     "ids": [
//       162,
//       161,
//       160,
//       159,
//       290,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "09:30 AM",
//         "id": 162
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "09:37 AM",
//         "id": 161
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "09:39 AM",
//         "id": 160
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "09:45 AM",
//         "id": 159
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "09:45 AM",
//         "id": 290
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:51 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:59 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "10:04 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:14 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:19 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:20 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:32 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:39 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:44 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-B-11-217",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ARUMUGAMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:50 AM",
//     "endTime": "12:05 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       290,
//       159,
//       160,
//       161,
//       162
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:50 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:55 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:02 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:14 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "11:15 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "11:20 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "11:30 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "11:35 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "11:43 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "11:49 AM",
//         "id": 290
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "11:49 AM",
//         "id": 159
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "11:55 AM",
//         "id": 160
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "11:57 AM",
//         "id": 161
//       },
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "12:05 PM",
//         "id": 162
//       }
//     ]
//   },
//   {
//     "id": "54-B-12-218",
//     "routeNo": "54-B",
//     "code": "54/P54B-1",
//     "tripCode": "54/P54B-154-BTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ARUMUGAMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:10 PM",
//     "endTime": "01:40 PM",
//     "ids": [
//       162,
//       161,
//       160,
//       159,
//       290,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ARUMUGAMANGALAM",
//         "time": "12:10 PM",
//         "id": 162
//       },
//       {
//         "no": 14,
//         "name": "MARAMANGALAM",
//         "time": "12:18 PM",
//         "id": 161
//       },
//       {
//         "no": 13,
//         "name": "IDAYARKADU",
//         "time": "12:21 PM",
//         "id": 160
//       },
//       {
//         "no": 12,
//         "name": "SAMBADI",
//         "time": "12:29 PM",
//         "id": 159
//       },
//       {
//         "no": 11,
//         "name": "WATER TANK 2",
//         "time": "12:29 PM",
//         "id": 290
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "12:35 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:45 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "12:51 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:03 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:09 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:10 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:24 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "01:33 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "01:39 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-C-1-219",
//     "routeNo": "54-C",
//     "code": "54/P54C-2",
//     "tripCode": "54/P54C-254-CTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHETTIKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 AM",
//     "endTime": "07:40 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163,
//       34,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       168
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:30 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:34 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:41 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:51 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:52 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:56 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "07:01 AM",
//         "id": 163
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "07:10 AM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "07:14 AM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:20 AM",
//         "id": 10
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "07:24 AM",
//         "id": 37
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:27 AM",
//         "id": 12
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "07:32 AM",
//         "id": 13
//       },
//       {
//         "no": 15,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:35 AM",
//         "id": 40
//       },
//       {
//         "no": 16,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:37 AM",
//         "id": 17
//       },
//       {
//         "no": 17,
//         "name": "CHETTIKULAM",
//         "time": "07:40 AM",
//         "id": 168
//       }
//     ]
//   },
//   {
//     "id": "54-C-2-220",
//     "routeNo": "54-C",
//     "code": "54/P54C-2",
//     "tripCode": "54/P54C-254-CTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "CHETTIKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:55 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       168,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       34,
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHETTIKULAM",
//         "time": "07:55 AM",
//         "id": 168
//       },
//       {
//         "no": 16,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:57 AM",
//         "id": 17
//       },
//       {
//         "no": 15,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:59 AM",
//         "id": 40
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "08:02 AM",
//         "id": 13
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:07 AM",
//         "id": 12
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "08:10 AM",
//         "id": 37
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "08:14 AM",
//         "id": 10
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "08:20 AM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "08:24 AM",
//         "id": 34
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "08:33 AM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:38 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:42 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:43 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:53 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:00 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:04 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:05 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-C-3-221",
//     "routeNo": "54-C",
//     "code": "54/P54C-1",
//     "tripCode": "54/P54C-154-CTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "VAGAIKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:20 AM",
//     "endTime": "10:50 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163,
//       34,
//       9,
//       10,
//       37,
//       12,
//       13,
//       291,
//       164,
//       165,
//       166,
//       167
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:20 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:24 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:31 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:41 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:42 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:47 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "09:52 AM",
//         "id": 163
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "10:00 AM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "10:04 AM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "10:10 AM",
//         "id": 10
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "10:14 AM",
//         "id": 37
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "10:18 AM",
//         "id": 12
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "10:22 AM",
//         "id": 13
//       },
//       {
//         "no": 15,
//         "name": "KUMARAPURAM 2",
//         "time": "10:28 AM",
//         "id": 291
//       },
//       {
//         "no": 16,
//         "name": "KATTALANKULAM",
//         "time": "10:32 AM",
//         "id": 164
//       },
//       {
//         "no": 17,
//         "name": "M. PUDHUR",
//         "time": "10:40 AM",
//         "id": 165
//       },
//       {
//         "no": 18,
//         "name": "MUDIVAITHANENDAL",
//         "time": "10:44 AM",
//         "id": 166
//       },
//       {
//         "no": 19,
//         "name": "VAGAIKULAM",
//         "time": "10:50 AM",
//         "id": 167
//       }
//     ]
//   },
//   {
//     "id": "54-C-4-222",
//     "routeNo": "54-C",
//     "code": "54/P54C-1",
//     "tripCode": "54/P54C-154-CTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "VAGAIKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:05 AM",
//     "endTime": "12:30 PM",
//     "ids": [
//       167,
//       166,
//       165,
//       164,
//       291,
//       13,
//       12,
//       37,
//       10,
//       9,
//       34,
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "VAGAIKULAM",
//         "time": "11:05 AM",
//         "id": 167
//       },
//       {
//         "no": 18,
//         "name": "MUDIVAITHANENDAL",
//         "time": "11:09 AM",
//         "id": 166
//       },
//       {
//         "no": 17,
//         "name": "M. PUDHUR",
//         "time": "11:13 AM",
//         "id": 165
//       },
//       {
//         "no": 16,
//         "name": "KATTALANKULAM",
//         "time": "11:21 AM",
//         "id": 164
//       },
//       {
//         "no": 15,
//         "name": "KUMARAPURAM 2",
//         "time": "11:25 AM",
//         "id": 291
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "11:30 AM",
//         "id": 13
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "11:34 AM",
//         "id": 12
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "11:38 AM",
//         "id": 37
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "11:42 AM",
//         "id": 10
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "11:47 AM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "11:51 AM",
//         "id": 34
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "11:59 AM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "12:04 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "12:08 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "12:09 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "12:19 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "12:25 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "12:29 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-C-5-223",
//     "routeNo": "54-C",
//     "code": "54/P54C-3",
//     "tripCode": "54/P54C-354-CTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KOOTTAMPULI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:45 PM",
//     "endTime": "01:55 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163,
//       34,
//       9
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "12:46 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "12:52 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:02 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:18 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:20 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:27 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "01:35 PM",
//         "id": 163
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "01:48 PM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "01:55 PM",
//         "id": 9
//       }
//     ]
//   },
//   {
//     "id": "54-C-6-224",
//     "routeNo": "54-C",
//     "code": "54/P54C-3",
//     "tripCode": "54/P54C-354-CTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KOOTTAMPULI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:00 PM",
//     "endTime": "03:10 PM",
//     "ids": [
//       9,
//       34,
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "02:00 PM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "02:06 PM",
//         "id": 34
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "02:19 PM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:27 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:34 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:36 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "02:52 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "03:02 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "03:08 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-C-7-225",
//     "routeNo": "54-C",
//     "code": "54/P54C-2",
//     "tripCode": "54/P54C-254-CTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHETTIKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:15 PM",
//     "endTime": "04:30 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163,
//       34,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       168
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "03:15 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "03:20 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "03:27 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "03:37 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "03:38 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:43 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "03:49 PM",
//         "id": 163
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "03:58 PM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "04:02 PM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "04:08 PM",
//         "id": 10
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "04:13 PM",
//         "id": 37
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:17 PM",
//         "id": 12
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "04:21 PM",
//         "id": 13
//       },
//       {
//         "no": 15,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:25 PM",
//         "id": 40
//       },
//       {
//         "no": 16,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "04:27 PM",
//         "id": 17
//       },
//       {
//         "no": 17,
//         "name": "CHETTIKULAM",
//         "time": "04:30 PM",
//         "id": 168
//       }
//     ]
//   },
//   {
//     "id": "54-C-8-226",
//     "routeNo": "54-C",
//     "code": "54/P54C-2",
//     "tripCode": "54/P54C-254-CTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CHETTIKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:35 PM",
//     "endTime": "05:50 PM",
//     "ids": [
//       168,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       34,
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHETTIKULAM",
//         "time": "04:35 PM",
//         "id": 168
//       },
//       {
//         "no": 16,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "04:37 PM",
//         "id": 17
//       },
//       {
//         "no": 15,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "04:39 PM",
//         "id": 40
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "04:43 PM",
//         "id": 13
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "04:47 PM",
//         "id": 12
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "04:51 PM",
//         "id": 37
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "04:56 PM",
//         "id": 10
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "05:02 PM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "05:06 PM",
//         "id": 34
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "05:15 PM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "05:21 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "05:26 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "05:27 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "05:37 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:44 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:49 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-C-9-227",
//     "routeNo": "54-C",
//     "code": "54/P54C-2",
//     "tripCode": "54/P54C-254-CTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHETTIKULAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:55 PM",
//     "endTime": "07:10 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163,
//       34,
//       9,
//       10,
//       37,
//       12,
//       13,
//       40,
//       17,
//       168
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:55 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:55 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:00 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:07 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:17 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:18 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:23 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "06:29 PM",
//         "id": 163
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "06:38 PM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "06:42 PM",
//         "id": 9
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "06:48 PM",
//         "id": 10
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "06:53 PM",
//         "id": 37
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "06:57 PM",
//         "id": 12
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "07:01 PM",
//         "id": 13
//       },
//       {
//         "no": 15,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:05 PM",
//         "id": 40
//       },
//       {
//         "no": 16,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:07 PM",
//         "id": 17
//       },
//       {
//         "no": 17,
//         "name": "CHETTIKULAM",
//         "time": "07:10 PM",
//         "id": 168
//       }
//     ]
//   },
//   {
//     "id": "54-C-10-228",
//     "routeNo": "54-C",
//     "code": "54/P54C-2",
//     "tripCode": "54/P54C-254-CTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "CHETTIKULAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:25 PM",
//     "endTime": "08:40 PM",
//     "ids": [
//       168,
//       17,
//       40,
//       13,
//       12,
//       37,
//       10,
//       9,
//       34,
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHETTIKULAM",
//         "time": "07:25 PM",
//         "id": 168
//       },
//       {
//         "no": 16,
//         "name": "RAMASAMYPURAM BRIDGE",
//         "time": "07:27 PM",
//         "id": 17
//       },
//       {
//         "no": 15,
//         "name": "SUBRAMANIAPURAM 1",
//         "time": "07:29 PM",
//         "id": 40
//       },
//       {
//         "no": 14,
//         "name": "SAWYERPURAM",
//         "time": "07:33 PM",
//         "id": 13
//       },
//       {
//         "no": 13,
//         "name": "SEBATHAIAHPURAM",
//         "time": "07:37 PM",
//         "id": 12
//       },
//       {
//         "no": 12,
//         "name": "SALAI",
//         "time": "07:41 PM",
//         "id": 37
//       },
//       {
//         "no": 11,
//         "name": "SERVAIKARANMADAM",
//         "time": "07:46 PM",
//         "id": 10
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "07:52 PM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "07:56 PM",
//         "id": 34
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "08:05 PM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:11 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:16 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:17 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:27 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:34 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:39 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-C-11-229",
//     "routeNo": "54-C",
//     "code": "54/P54C-3",
//     "tripCode": "54/P54C-354-CTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KOOTTAMPULI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:55 PM",
//     "endTime": "09:55 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163,
//       34,
//       9
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:55 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:55 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:01 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:10 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:23 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:25 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:31 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "09:38 PM",
//         "id": 163
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "09:49 PM",
//         "id": 34
//       },
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "09:55 PM",
//         "id": 9
//       }
//     ]
//   },
//   {
//     "id": "54-C-12-230",
//     "routeNo": "54-C",
//     "code": "54/P54C-3",
//     "tripCode": "54/P54C-354-CTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KOOTTAMPULI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:00 PM",
//     "endTime": "11:00 PM",
//     "ids": [
//       9,
//       34,
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "KOOTTAMPULI",
//         "time": "10:00 PM",
//         "id": 9
//       },
//       {
//         "no": 9,
//         "name": "KULAIYANKARISAL",
//         "time": "10:05 PM",
//         "id": 34
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "10:16 PM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:23 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:29 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:31 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:44 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:53 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:59 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-D-1-231",
//     "routeNo": "54-D",
//     "code": "54/P54D-3",
//     "tripCode": "54/P54D-354-DTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SOUTH KOVANKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 AM",
//     "endTime": "07:05 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       157,
//       158
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:15 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:20 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:27 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:39 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:40 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:45 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:55 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:59 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "06:59 AM",
//         "id": 157
//       },
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "07:05 AM",
//         "id": 158
//       }
//     ]
//   },
//   {
//     "id": "54-D-2-232",
//     "routeNo": "54-D",
//     "code": "54/P54D-3",
//     "tripCode": "54/P54D-354-DTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "SOUTH KOVANKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       158,
//       157,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SOUTH KOVANKADU",
//         "time": "07:10 AM",
//         "id": 158
//       },
//       {
//         "no": 10,
//         "name": "KOVANKADU",
//         "time": "07:15 AM",
//         "id": 157
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:15 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:19 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:29 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:34 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:35 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:47 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:54 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:59 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-D-3-233",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 AM",
//     "endTime": "09:00 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       169,
//       170,
//       161,
//       171,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:05 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:05 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:08 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:12 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:19 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:20 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:23 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "08:29 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "08:32 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "08:37 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "08:39 AM",
//         "id": 169
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "08:42 AM",
//         "id": 170
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "08:46 AM",
//         "id": 161
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "08:49 AM",
//         "id": 171
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "08:53 AM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "09:00 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-4-234",
//     "routeNo": "54-D",
//     "code": "54/P54D-2",
//     "tripCode": "54/P54D-254-DTORD18U4",
//     "order": 4,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "SIRUTHONDANALLUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:05 AM",
//     "endTime": "09:00 AM",
//     "ids": [
//       20,
//       19
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "09:05 AM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SIRUTHONDANALLUR",
//         "time": "09:00 AM",
//         "id": 19
//       }
//     ]
//   },
//   {
//     "id": "54-D-5-235",
//     "routeNo": "54-D",
//     "code": "54/P54D-2",
//     "tripCode": "54/P54D-254-DTORD18D5",
//     "order": 5,
//     "direction": "D",
//     "from": "SIRUTHONDANALLUR",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 AM",
//     "endTime": "09:10 AM",
//     "ids": [
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 2,
//         "name": "SIRUTHONDANALLUR",
//         "time": "09:15 AM",
//         "id": 19
//       },
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "09:10 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-6-236",
//     "routeNo": "54-D",
//     "code": "54/P54D-2",
//     "tripCode": "54/P54D-254-DTORD18U6",
//     "order": 6,
//     "direction": "U",
//     "from": "ERAL",
//     "to": "SIRUTHONDANALLUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:05 AM",
//     "endTime": "09:10 AM",
//     "ids": [
//       20,
//       19
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "09:05 AM",
//         "id": 20
//       },
//       {
//         "no": 2,
//         "name": "SIRUTHONDANALLUR",
//         "time": "09:10 AM",
//         "id": 19
//       }
//     ]
//   },
//   {
//     "id": "54-D-7-237",
//     "routeNo": "54-D",
//     "code": "54/P54D-2",
//     "tripCode": "54/P54D-254-DTORD18D7",
//     "order": 7,
//     "direction": "D",
//     "from": "SIRUTHONDANALLUR",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 AM",
//     "endTime": "09:20 AM",
//     "ids": [
//       19,
//       20
//     ],
//     "stops": [
//       {
//         "no": 2,
//         "name": "SIRUTHONDANALLUR",
//         "time": "09:15 AM",
//         "id": 19
//       },
//       {
//         "no": 1,
//         "name": "ERAL",
//         "time": "09:20 AM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-8-238",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 AM",
//     "endTime": "11:25 AM",
//     "ids": [
//       20,
//       54,
//       171,
//       161,
//       170,
//       169,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "09:50 AM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "10:00 AM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "10:07 AM",
//         "id": 171
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "10:13 AM",
//         "id": 161
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "10:19 AM",
//         "id": 170
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "10:24 AM",
//         "id": 169
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "10:29 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "10:37 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "10:42 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:53 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:58 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:59 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:11 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "11:19 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "11:24 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-D-9-239",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:30 AM",
//     "endTime": "12:50 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       169,
//       170,
//       161,
//       171,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "11:30 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "11:34 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:41 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:51 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "11:52 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "11:56 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "12:05 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:09 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "12:16 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "12:20 PM",
//         "id": 169
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "12:24 PM",
//         "id": 170
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "12:29 PM",
//         "id": 161
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "12:35 PM",
//         "id": 171
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "12:40 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "12:50 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-10-240",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:55 PM",
//     "endTime": "01:40 PM",
//     "ids": [
//       20,
//       54,
//       171,
//       161,
//       170,
//       169,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "12:55 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "01:00 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "01:03 PM",
//         "id": 171
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "01:06 PM",
//         "id": 161
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "01:09 PM",
//         "id": 170
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "01:11 PM",
//         "id": 169
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "01:13 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:17 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "01:19 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:24 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:27 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:27 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:33 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "01:37 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "01:39 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-D-11-241",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:30 PM",
//     "endTime": "03:40 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       169,
//       170,
//       161,
//       171,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "02:30 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "02:34 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "02:39 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:48 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:49 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:53 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "03:01 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:04 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "03:11 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "03:14 PM",
//         "id": 169
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "03:17 PM",
//         "id": 170
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "03:22 PM",
//         "id": 161
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "03:27 PM",
//         "id": 171
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "03:32 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "03:40 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-12-242",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:45 PM",
//     "endTime": "05:05 PM",
//     "ids": [
//       20,
//       54,
//       171,
//       161,
//       170,
//       169,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "03:45 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "03:54 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "03:59 PM",
//         "id": 171
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "04:05 PM",
//         "id": 161
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "04:10 PM",
//         "id": 170
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "04:14 PM",
//         "id": 169
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "04:18 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "04:25 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "04:29 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "04:38 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:42 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:43 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:53 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:00 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:04 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-D-13-243",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:10 PM",
//     "endTime": "06:40 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       169,
//       170,
//       161,
//       171,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:10 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:15 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "05:22 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "05:34 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "05:35 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "05:40 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "05:50 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "05:54 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "06:02 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "06:07 PM",
//         "id": 169
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "06:11 PM",
//         "id": 170
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "06:17 PM",
//         "id": 161
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "06:23 PM",
//         "id": 171
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "06:29 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "06:40 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-14-244",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:45 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       20,
//       54,
//       171,
//       161,
//       170,
//       169,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "06:45 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "06:56 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "07:04 PM",
//         "id": 171
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "07:11 PM",
//         "id": 161
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "07:18 PM",
//         "id": 170
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "07:23 PM",
//         "id": 169
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "07:28 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:37 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:43 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:54 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:00 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:01 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:15 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:23 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:29 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-D-15-245",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ERAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:20 PM",
//     "endTime": "09:50 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       169,
//       170,
//       161,
//       171,
//       54,
//       20
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:20 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:25 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:32 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:44 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:45 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:50 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:00 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:04 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:12 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "09:17 PM",
//         "id": 169
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "09:21 PM",
//         "id": 170
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "09:27 PM",
//         "id": 161
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "09:33 PM",
//         "id": 171
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "09:39 PM",
//         "id": 54
//       },
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "09:50 PM",
//         "id": 20
//       }
//     ]
//   },
//   {
//     "id": "54-D-16-246",
//     "routeNo": "54-D",
//     "code": "54/P54D-1",
//     "tripCode": "54/P54D-154-DTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "ERAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:00 PM",
//     "endTime": "05:45 AM",
//     "ids": [
//       20,
//       54,
//       171,
//       161,
//       170,
//       169,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "ERAL",
//         "time": "10:00 PM",
//         "id": 20
//       },
//       {
//         "no": 15,
//         "name": "WATER TANK 1",
//         "time": "10:52 PM",
//         "id": 54
//       },
//       {
//         "no": 14,
//         "name": "KORKAI",
//         "time": "11:26 PM",
//         "id": 171
//       },
//       {
//         "no": 13,
//         "name": "MARAMANGALAM",
//         "time": "11:56 PM",
//         "id": 161
//       },
//       {
//         "no": 12,
//         "name": "AGARAM",
//         "time": "12:26 AM",
//         "id": 170
//       },
//       {
//         "no": 11,
//         "name": "AGARAM BRIDGE",
//         "time": "12:50 AM",
//         "id": 169
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "01:12 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:54 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "02:17 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:09 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "03:34 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "03:40 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:39 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:16 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:41 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-F-1-247",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUNNAKAYAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:15 PM",
//     "endTime": "02:30 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172,
//       173,
//       174,
//       175
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "01:15 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "01:19 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:25 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:34 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "01:35 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "01:39 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "01:47 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:51 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "01:58 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "02:05 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "02:10 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "02:14 PM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "02:21 PM",
//         "id": 173
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "02:25 PM",
//         "id": 174
//       },
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "02:30 PM",
//         "id": 175
//       }
//     ]
//   },
//   {
//     "id": "54-F-2-248",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "PUNNAKAYAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:35 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       175,
//       174,
//       173,
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "02:35 PM",
//         "id": 175
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "02:40 PM",
//         "id": 174
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "02:45 PM",
//         "id": 173
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "02:52 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "02:56 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "03:02 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "03:11 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:18 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "03:22 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "03:32 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "03:36 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "03:37 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "03:48 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "03:54 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "03:59 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-F-3-249",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUNNAKAYAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:05 PM",
//     "endTime": "05:20 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172,
//       173,
//       174,
//       175
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:05 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:09 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:15 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:24 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:25 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "04:29 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "04:37 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "04:41 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "04:48 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "04:55 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "05:00 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "05:04 PM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "05:11 PM",
//         "id": 173
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "05:15 PM",
//         "id": 174
//       },
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "05:20 PM",
//         "id": 175
//       }
//     ]
//   },
//   {
//     "id": "54-F-4-250",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "PUNNAKAYAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:25 PM",
//     "endTime": "06:40 PM",
//     "ids": [
//       175,
//       174,
//       173,
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "05:25 PM",
//         "id": 175
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "05:29 PM",
//         "id": 174
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "05:33 PM",
//         "id": 173
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "05:40 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "05:44 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "05:49 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "05:56 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:03 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:07 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:15 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:19 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:20 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:29 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:35 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:39 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-F-5-251",
//     "routeNo": "54-F",
//     "code": "54/P54F-2",
//     "tripCode": "54/P54F-254-FTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ATTHIMARAPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:45 PM",
//     "endTime": "07:20 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       176,
//       177
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:45 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:51 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:59 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:11 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "07:12 PM",
//         "id": 176
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "07:20 PM",
//         "id": 177
//       }
//     ]
//   },
//   {
//     "id": "54-F-6-252",
//     "routeNo": "54-F",
//     "code": "54/P54F-2",
//     "tripCode": "54/P54F-254-FTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ATTHIMARAPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 PM",
//     "endTime": "10:00 PM",
//     "ids": [
//       177,
//       176,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "07:30 PM",
//         "id": 177
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "08:03 PM",
//         "id": 176
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:05 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:59 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:33 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:56 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-F-7-253",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUNNAKAYAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:15 PM",
//     "endTime": "05:40 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172,
//       173,
//       174,
//       175
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:18 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:41 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:16 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "12:11 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "12:16 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "12:40 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "01:29 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "01:51 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "02:30 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "03:14 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "03:45 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "04:08 AM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "04:47 AM",
//         "id": 173
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "05:12 AM",
//         "id": 174
//       },
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "05:40 AM",
//         "id": 175
//       }
//     ]
//   },
//   {
//     "id": "54-F-8-254",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PUNNAKAYAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 AM",
//     "endTime": "07:25 AM",
//     "ids": [
//       175,
//       174,
//       173,
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "05:45 AM",
//         "id": 175
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "05:51 AM",
//         "id": 174
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "05:56 AM",
//         "id": 173
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "06:05 AM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "06:10 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "06:17 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "06:27 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:36 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:41 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:52 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:57 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:58 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:11 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:18 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:24 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-F-9-255",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUNNAKAYAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 AM",
//     "endTime": "08:40 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172,
//       173,
//       174,
//       175
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:30 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:34 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:39 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:48 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:49 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:52 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "08:00 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "08:03 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "08:10 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "08:17 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "08:22 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "08:25 AM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "08:31 AM",
//         "id": 173
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "08:35 AM",
//         "id": 174
//       },
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "08:40 AM",
//         "id": 175
//       }
//     ]
//   },
//   {
//     "id": "54-F-10-256",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "PUNNAKAYAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:50 AM",
//     "endTime": "10:25 AM",
//     "ids": [
//       175,
//       174,
//       173,
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "08:50 AM",
//         "id": 175
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "08:55 AM",
//         "id": 174
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "09:01 AM",
//         "id": 173
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "09:09 AM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "09:14 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "09:21 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:30 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:38 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:43 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:53 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:58 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:00 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:11 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:19 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:24 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-F-11-257",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUNNAKAYAL",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 AM",
//     "endTime": "11:40 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172,
//       173,
//       174,
//       175
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:30 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:34 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:39 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:48 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:49 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:52 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "11:00 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "11:03 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "11:10 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "11:17 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "11:22 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "11:25 AM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "11:31 AM",
//         "id": 173
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "11:35 AM",
//         "id": 174
//       },
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "11:40 AM",
//         "id": 175
//       }
//     ]
//   },
//   {
//     "id": "54-F-12-258",
//     "routeNo": "54-F",
//     "code": "54/P54F-1",
//     "tripCode": "54/P54F-154-FTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "PUNNAKAYAL",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:45 AM",
//     "endTime": "01:10 PM",
//     "ids": [
//       175,
//       174,
//       173,
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PUNNAKAYAL",
//         "time": "11:45 AM",
//         "id": 175
//       },
//       {
//         "no": 15,
//         "name": "DCW COLONY",
//         "time": "11:50 AM",
//         "id": 174
//       },
//       {
//         "no": 14,
//         "name": "CHERNTHAMARAM",
//         "time": "11:55 AM",
//         "id": 173
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "12:02 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "12:06 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "12:12 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "12:21 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:28 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "12:32 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "12:42 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "12:46 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "12:47 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "12:58 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "01:04 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "01:09 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-1-259",
//     "routeNo": "54-G",
//     "code": "54/P54G-5",
//     "tripCode": "54/P54G-554-GTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KOLLAMPARAMBU",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 AM",
//     "endTime": "06:25 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       152,
//       289,
//       154
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:46 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:48 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:51 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:52 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:55 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "05:57 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "06:01 AM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "06:06 AM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "06:09 AM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "06:12 AM",
//         "id": 100
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 1",
//         "time": "06:18 AM",
//         "id": 152
//       },
//       {
//         "no": 14,
//         "name": "CHANDRAGIRI",
//         "time": "06:19 AM",
//         "id": 289
//       },
//       {
//         "no": 15,
//         "name": "KOLLAMPARAMBU",
//         "time": "06:25 AM",
//         "id": 154
//       }
//     ]
//   },
//   {
//     "id": "54-G-2-260",
//     "routeNo": "54-G",
//     "code": "54/P54G-6",
//     "tripCode": "54/P54G-654-GTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KOLLAMPARAMBU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 AM",
//     "endTime": "07:20 AM",
//     "ids": [
//       154,
//       289,
//       152,
//       100,
//       281,
//       99,
//       143,
//       292,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "KOLLAMPARAMBU",
//         "time": "06:30 AM",
//         "id": 154
//       },
//       {
//         "no": 15,
//         "name": "CHANDRAGIRI",
//         "time": "06:36 AM",
//         "id": 289
//       },
//       {
//         "no": 14,
//         "name": "CHANDRAGIRI JUNCTION 1",
//         "time": "06:37 AM",
//         "id": 152
//       },
//       {
//         "no": 12,
//         "name": "KURUKKUSALAI",
//         "time": "06:44 AM",
//         "id": 100
//       },
//       {
//         "no": 11,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "06:47 AM",
//         "id": 281
//       },
//       {
//         "no": 10,
//         "name": "VALASAMUTHIRAM",
//         "time": "06:51 AM",
//         "id": 99
//       },
//       {
//         "no": 9,
//         "name": "ARASADI 1",
//         "time": "07:00 AM",
//         "id": 143
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 2",
//         "time": "07:03 AM",
//         "id": 292
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "07:05 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:07 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:11 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:12 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:16 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:17 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-3-261",
//     "routeNo": "54-G",
//     "code": "54/P54G-2",
//     "tripCode": "54/P54G-254-GTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MULLAKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 AM",
//     "endTime": "08:10 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:31 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:37 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:46 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:01 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:03 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:10 AM",
//         "id": 46
//       }
//     ]
//   },
//   {
//     "id": "54-G-4-262",
//     "routeNo": "54-G",
//     "code": "54/P54G-3",
//     "tripCode": "54/P54G-354-GTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "MULLAKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:15 AM",
//     "ids": [
//       46,
//       45,
//       184,
//       183,
//       182,
//       181,
//       180,
//       293,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 12,
//         "name": "MULLAKADU",
//         "time": "08:15 AM",
//         "id": 46
//       },
//       {
//         "no": 11,
//         "name": "SPIC NAGAR",
//         "time": "08:20 AM",
//         "id": 45
//       },
//       {
//         "no": 10,
//         "name": "BULK",
//         "time": "08:22 AM",
//         "id": 184
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "08:37 AM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "08:39 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:44 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:51 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:54 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:01 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:09 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:14 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:15 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-5-263",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:20 AM",
//     "endTime": "09:50 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:24 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:28 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:34 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "09:37 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:40 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:45 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:48 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "09:50 AM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "54-G-6-264",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:00 AM",
//     "endTime": "10:40 AM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "10:00 AM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "10:02 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:06 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:13 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:16 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:20 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "10:28 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:33 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-7-265",
//     "routeNo": "54-G",
//     "code": "54/P54G-1",
//     "tripCode": "54/P54G-154-GTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PON NAGAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:45 AM",
//     "endTime": "11:10 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       176,
//       177,
//       178
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:45 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:49 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:54 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:02 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "11:02 AM",
//         "id": 176
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "11:07 AM",
//         "id": 177
//       },
//       {
//         "no": 8,
//         "name": "PON NAGAR",
//         "time": "11:10 AM",
//         "id": 178
//       }
//     ]
//   },
//   {
//     "id": "54-G-8-266",
//     "routeNo": "54-G",
//     "code": "54/P54G-1",
//     "tripCode": "54/P54G-154-GTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PON NAGAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:20 AM",
//     "endTime": "11:40 AM",
//     "ids": [
//       178,
//       177,
//       176,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 8,
//         "name": "PON NAGAR",
//         "time": "11:20 AM",
//         "id": 178
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "11:21 AM",
//         "id": 177
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "11:25 AM",
//         "id": 176
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:25 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:32 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "11:36 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "11:39 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-9-267",
//     "routeNo": "54-G",
//     "code": "54/P54G-8",
//     "tripCode": "54/P54G-854-GTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "VELLAPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:50 AM",
//     "endTime": "12:20 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       187
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "11:50 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "11:54 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:58 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "12:05 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "12:08 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "12:09 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "12:15 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "VELLAPATTI",
//         "time": "12:20 PM",
//         "id": 187
//       }
//     ]
//   },
//   {
//     "id": "54-G-10-268",
//     "routeNo": "54-G",
//     "code": "54/P54G-8",
//     "tripCode": "54/P54G-854-GTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "VELLAPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:30 PM",
//     "endTime": "01:25 PM",
//     "ids": [
//       187,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 8,
//         "name": "VELLAPATTI",
//         "time": "12:30 PM",
//         "id": 187
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "12:37 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "12:48 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "12:51 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "12:56 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:09 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "01:16 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "01:25 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "54-G-11-269",
//     "routeNo": "54-G",
//     "code": "54/P54G-1",
//     "tripCode": "54/P54G-154-GTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PON NAGAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:30 PM",
//     "endTime": "02:00 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       176,
//       177,
//       178
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "01:30 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "01:34 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "01:41 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "01:51 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "01:51 PM",
//         "id": 176
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "01:57 PM",
//         "id": 177
//       },
//       {
//         "no": 8,
//         "name": "PON NAGAR",
//         "time": "02:00 PM",
//         "id": 178
//       }
//     ]
//   },
//   {
//     "id": "54-G-12-270",
//     "routeNo": "54-G",
//     "code": "54/P54G-1",
//     "tripCode": "54/P54G-154-GTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "PON NAGAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:05 PM",
//     "endTime": "02:35 PM",
//     "ids": [
//       178,
//       177,
//       176,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 8,
//         "name": "PON NAGAR",
//         "time": "02:05 PM",
//         "id": 178
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "02:07 PM",
//         "id": 177
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "02:13 PM",
//         "id": 176
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:13 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "02:23 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "02:30 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "02:34 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-13-271",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:40 PM",
//     "endTime": "03:25 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "02:47 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "02:53 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "03:01 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "03:06 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "03:10 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "03:17 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "03:22 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "03:25 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "54-G-14-272",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:30 PM",
//     "endTime": "04:05 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "03:30 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "03:32 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "03:35 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "03:41 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "03:44 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "03:47 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "03:54 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "03:59 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-15-273",
//     "routeNo": "54-G",
//     "code": "54/P54G-1",
//     "tripCode": "54/P54G-154-GTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PON NAGAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:15 PM",
//     "endTime": "04:55 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       176,
//       177,
//       178
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:15 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:21 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:29 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:43 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "04:43 PM",
//         "id": 176
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "04:51 PM",
//         "id": 177
//       },
//       {
//         "no": 8,
//         "name": "PON NAGAR",
//         "time": "04:55 PM",
//         "id": 178
//       }
//     ]
//   },
//   {
//     "id": "54-G-16-274",
//     "routeNo": "54-G",
//     "code": "54/P54G-7",
//     "tripCode": "54/P54G-754-GTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "PON NAGAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 PM",
//     "endTime": "07:10 PM",
//     "ids": [
//       178,
//       177,
//       176,
//       44,
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "PON NAGAR",
//         "time": "05:00 PM",
//         "id": 178
//       },
//       {
//         "no": 12,
//         "name": "ATTHIMARAPATTI",
//         "time": "05:05 PM",
//         "id": 177
//       },
//       {
//         "no": 11,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "05:19 PM",
//         "id": 176
//       },
//       {
//         "no": 10,
//         "name": "MUTHAIAHPURAM",
//         "time": "05:19 PM",
//         "id": 44
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "05:48 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "05:53 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:01 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:15 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:21 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:30 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "06:46 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "06:57 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-17-275",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18U17",
//     "order": 17,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 PM",
//     "endTime": "07:55 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:25 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "07:30 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "07:37 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "07:40 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "07:43 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "07:49 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "07:52 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "07:55 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "54-G-18-276",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "08:00 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "08:01 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:04 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:09 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:12 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:15 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:21 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:25 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "54-G-19-277",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18U19",
//     "order": 19,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:40 PM",
//     "endTime": "09:05 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:43 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:47 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:52 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:54 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:56 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:01 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:03 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "09:05 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "54-G-20-278",
//     "routeNo": "54-G",
//     "code": "54/P54G-4",
//     "tripCode": "54/P54G-454-GTORD18D20",
//     "order": 20,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 PM",
//     "endTime": "10:00 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "09:10 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:12 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:17 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:26 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "09:30 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:35 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:45 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:52 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-1-279",
//     "routeNo": "55-A",
//     "code": "55/P55A-3",
//     "tripCode": "55/P55A-355-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "GOVERNORGIRI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:30 PM",
//     "endTime": "01:35 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       191,
//       192,
//       193,
//       194,
//       195
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "12:32 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "12:34 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "12:38 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "12:40 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "12:45 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "12:47 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "12:52 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "12:59 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "01:03 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "01:07 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "01:12 PM",
//         "id": 191
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "01:17 PM",
//         "id": 192
//       },
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "01:24 PM",
//         "id": 193
//       },
//       {
//         "no": 15,
//         "name": "VELLARAM",
//         "time": "01:30 PM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "01:35 PM",
//         "id": 195
//       }
//     ]
//   },
//   {
//     "id": "55-A-2-280",
//     "routeNo": "55-A",
//     "code": "55/P55A-3",
//     "tripCode": "55/P55A-355-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "GOVERNORGIRI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:40 PM",
//     "endTime": "02:45 PM",
//     "ids": [
//       195,
//       194,
//       193,
//       192,
//       191,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "01:40 PM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "VELLARAM",
//         "time": "01:44 PM",
//         "id": 194
//       },
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "01:50 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "01:57 PM",
//         "id": 192
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "02:02 PM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "02:07 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "02:11 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "02:15 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "02:22 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "02:27 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:29 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:34 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:36 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:40 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:42 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-3-281",
//     "routeNo": "55-A",
//     "code": "55/P55A-6",
//     "tripCode": "55/P55A-655-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "04:05 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       101,
//       188,
//       189,
//       190,
//       76
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:02 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:04 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:09 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:10 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:16 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "03:19 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "03:24 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "03:31 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "03:36 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "03:40 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "03:44 PM",
//         "id": 101
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "03:49 PM",
//         "id": 188
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "03:52 PM",
//         "id": 189
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "03:57 PM",
//         "id": 190
//       },
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "04:05 PM",
//         "id": 76
//       }
//     ]
//   },
//   {
//     "id": "55-A-4-282",
//     "routeNo": "55-A",
//     "code": "55/P55A-6",
//     "tripCode": "55/P55A-655-ATORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:10 PM",
//     "endTime": "05:20 PM",
//     "ids": [
//       76,
//       190,
//       189,
//       188,
//       101,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "04:10 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "04:17 PM",
//         "id": 190
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "04:23 PM",
//         "id": 189
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "04:26 PM",
//         "id": 188
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "04:32 PM",
//         "id": 101
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "04:35 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "04:40 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "04:46 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "04:53 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "04:59 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:02 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:08 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:09 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:14 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:16 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-5-283",
//     "routeNo": "55-A",
//     "code": "55/P55A-2",
//     "tripCode": "55/P55A-255-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM TALUK OFFICE",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:25 PM",
//     "endTime": "06:25 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       101,
//       188,
//       189,
//       190,
//       76,
//       109
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:25 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:27 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:29 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:33 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:34 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:39 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "05:42 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "05:47 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "05:53 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "05:58 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "06:02 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "06:05 PM",
//         "id": 101
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "06:10 PM",
//         "id": 188
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "06:12 PM",
//         "id": 189
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "06:17 PM",
//         "id": 190
//       },
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "06:24 PM",
//         "id": 76
//       },
//       {
//         "no": 17,
//         "name": "OTTAPIDARAM TALUK OFFICE",
//         "time": "06:25 PM",
//         "id": 109
//       }
//     ]
//   },
//   {
//     "id": "55-A-6-284",
//     "routeNo": "55-A",
//     "code": "55/P55A-2",
//     "tripCode": "55/P55A-255-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "OTTAPIDARAM TALUK OFFICE",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 PM",
//     "endTime": "07:30 PM",
//     "ids": [
//       109,
//       76,
//       190,
//       189,
//       188,
//       101,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "OTTAPIDARAM TALUK OFFICE",
//         "time": "06:30 PM",
//         "id": 109
//       },
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "06:30 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "06:37 PM",
//         "id": 190
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "06:42 PM",
//         "id": 189
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "06:44 PM",
//         "id": 188
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "06:49 PM",
//         "id": 101
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "06:52 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "06:56 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "07:01 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "07:07 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "07:12 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:15 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:20 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:21 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:25 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:27 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-7-285",
//     "routeNo": "55-A",
//     "code": "55/P55A-3",
//     "tripCode": "55/P55A-355-ATORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "GOVERNORGIRI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:45 PM",
//     "endTime": "08:55 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       191,
//       192,
//       193,
//       194,
//       195
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:47 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:49 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:54 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:55 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:01 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "08:03 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "08:09 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "08:16 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "08:21 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "08:25 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "08:31 PM",
//         "id": 191
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "08:35 PM",
//         "id": 192
//       },
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "08:43 PM",
//         "id": 193
//       },
//       {
//         "no": 15,
//         "name": "VELLARAM",
//         "time": "08:50 PM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "08:55 PM",
//         "id": 195
//       }
//     ]
//   },
//   {
//     "id": "55-A-8-286",
//     "routeNo": "55-A",
//     "code": "55/P55A-3",
//     "tripCode": "55/P55A-355-ATORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "GOVERNORGIRI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:00 PM",
//     "endTime": "10:05 PM",
//     "ids": [
//       195,
//       194,
//       193,
//       192,
//       191,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "09:00 PM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "VELLARAM",
//         "time": "09:04 PM",
//         "id": 194
//       },
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "09:10 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "09:17 PM",
//         "id": 192
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "09:22 PM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "09:27 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "09:31 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "09:35 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "09:42 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "09:47 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:49 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:54 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:56 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "10:00 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:02 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-9-287",
//     "routeNo": "55-A",
//     "code": "55/P55A-4",
//     "tripCode": "55/P55A-455-ATORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:00 PM",
//     "endTime": "12:15 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:01 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:03 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:05 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:06 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:09 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:12 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:15 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "11:19 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "11:23 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "11:26 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "11:42 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "11:59 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:03 AM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:04 AM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "12:12 AM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "12:15 AM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-A-10-288",
//     "routeNo": "55-A",
//     "code": "55/P55A-5",
//     "tripCode": "55/P55A-555-ATORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 AM",
//     "endTime": "06:25 AM",
//     "ids": [
//       193,
//       192,
//       191,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "05:30 AM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "05:37 AM",
//         "id": 192
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "05:41 AM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "05:46 AM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "05:50 AM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "05:55 AM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "06:02 AM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "06:07 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:09 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:14 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:16 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:20 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:22 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-11-289",
//     "routeNo": "55-A",
//     "code": "55/P55A-6",
//     "tripCode": "55/P55A-655-ATORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       101,
//       188,
//       189,
//       190,
//       76
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:53 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:55 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:00 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:01 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:07 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "07:10 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "07:16 AM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "07:23 AM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "07:29 AM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "07:34 AM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "07:37 AM",
//         "id": 101
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "07:43 AM",
//         "id": 188
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "07:46 AM",
//         "id": 189
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "07:52 AM",
//         "id": 190
//       },
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "08:00 AM",
//         "id": 76
//       }
//     ]
//   },
//   {
//     "id": "55-A-12-290",
//     "routeNo": "55-A",
//     "code": "55/P55A-6",
//     "tripCode": "55/P55A-655-ATORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 AM",
//     "endTime": "09:20 AM",
//     "ids": [
//       76,
//       190,
//       189,
//       188,
//       101,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "08:05 AM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "08:13 AM",
//         "id": 190
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "08:19 AM",
//         "id": 189
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "08:22 AM",
//         "id": 188
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "08:29 AM",
//         "id": 101
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "08:32 AM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "08:37 AM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "08:43 AM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "08:51 AM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "08:58 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:01 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:07 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:09 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:14 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:16 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-A-13-291",
//     "routeNo": "55-A",
//     "code": "55/P55A-2",
//     "tripCode": "55/P55A-255-ATORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM TALUK OFFICE",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "10:30 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       101,
//       188,
//       189,
//       190,
//       76,
//       109
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:37 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:39 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:42 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:44 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:48 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "09:50 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "09:55 AM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "10:01 AM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "10:05 AM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "10:09 AM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "10:11 AM",
//         "id": 101
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "10:16 AM",
//         "id": 188
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "10:18 AM",
//         "id": 189
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "10:23 AM",
//         "id": 190
//       },
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "10:29 AM",
//         "id": 76
//       },
//       {
//         "no": 17,
//         "name": "OTTAPIDARAM TALUK OFFICE",
//         "time": "10:30 AM",
//         "id": 109
//       }
//     ]
//   },
//   {
//     "id": "55-A-14-292",
//     "routeNo": "55-A",
//     "code": "55/P55A-2",
//     "tripCode": "55/P55A-255-ATORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "OTTAPIDARAM TALUK OFFICE",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:35 AM",
//     "endTime": "11:40 AM",
//     "ids": [
//       109,
//       76,
//       190,
//       189,
//       188,
//       101,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "OTTAPIDARAM TALUK OFFICE",
//         "time": "10:35 AM",
//         "id": 109
//       },
//       {
//         "no": 16,
//         "name": "OTTAPIDARAM",
//         "time": "10:35 AM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "PANCHALANKURICHI",
//         "time": "10:43 AM",
//         "id": 190
//       },
//       {
//         "no": 14,
//         "name": "AGILANDAPURAM",
//         "time": "10:48 AM",
//         "id": 189
//       },
//       {
//         "no": 13,
//         "name": "KAKKARAMPATTI",
//         "time": "10:50 AM",
//         "id": 188
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM 1",
//         "time": "10:56 AM",
//         "id": 101
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "10:59 AM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "11:03 AM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "11:08 AM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "11:15 AM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "11:21 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:23 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:29 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:30 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:35 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:37 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-B-1-293",
//     "routeNo": "55-B",
//     "code": "55/P55B-3",
//     "tripCode": "55/P55B-355-BTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MILAGU NATTHAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:40 PM",
//     "endTime": "01:55 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       191,
//       295,
//       200,
//       201,
//       202,
//       203,
//       204,
//       205,
//       206,
//       207
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "12:42 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "12:44 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "12:47 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "12:49 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "12:53 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "12:56 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "01:00 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "01:06 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "01:10 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "01:14 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "01:18 PM",
//         "id": 191
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 2",
//         "time": "01:23 PM",
//         "id": 295
//       },
//       {
//         "no": 14,
//         "name": "MELA SEITHALAI",
//         "time": "01:27 PM",
//         "id": 200
//       },
//       {
//         "no": 15,
//         "name": "JEGAVEERAPANDIAPURAM",
//         "time": "01:30 PM",
//         "id": 201
//       },
//       {
//         "no": 16,
//         "name": "THANNEER MADAM",
//         "time": "01:37 PM",
//         "id": 202
//       },
//       {
//         "no": 17,
//         "name": "KAYATHAR JUNCTION",
//         "time": "01:38 PM",
//         "id": 203
//       },
//       {
//         "no": 18,
//         "name": "EPPODHUMVENDRAN",
//         "time": "01:40 PM",
//         "id": 204
//       },
//       {
//         "no": 19,
//         "name": "KATTUNAICKENPATTI",
//         "time": "01:44 PM",
//         "id": 205
//       },
//       {
//         "no": 20,
//         "name": "ADHANOOR",
//         "time": "01:50 PM",
//         "id": 206
//       },
//       {
//         "no": 21,
//         "name": "MILAGU NATTHAM",
//         "time": "01:55 PM",
//         "id": 207
//       }
//     ]
//   },
//   {
//     "id": "55-B-2-294",
//     "routeNo": "55-B",
//     "code": "55/P55B-3",
//     "tripCode": "55/P55B-355-BTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "MILAGU NATTHAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:00 PM",
//     "endTime": "03:10 PM",
//     "ids": [
//       207,
//       206,
//       205,
//       204,
//       203,
//       202,
//       201,
//       200,
//       295,
//       191,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "MILAGU NATTHAM",
//         "time": "02:00 PM",
//         "id": 207
//       },
//       {
//         "no": 20,
//         "name": "ADHANOOR",
//         "time": "02:04 PM",
//         "id": 206
//       },
//       {
//         "no": 19,
//         "name": "KATTUNAICKENPATTI",
//         "time": "02:09 PM",
//         "id": 205
//       },
//       {
//         "no": 18,
//         "name": "EPPODHUMVENDRAN",
//         "time": "02:13 PM",
//         "id": 204
//       },
//       {
//         "no": 17,
//         "name": "KAYATHAR JUNCTION",
//         "time": "02:15 PM",
//         "id": 203
//       },
//       {
//         "no": 16,
//         "name": "THANNEER MADAM",
//         "time": "02:16 PM",
//         "id": 202
//       },
//       {
//         "no": 15,
//         "name": "JEGAVEERAPANDIAPURAM",
//         "time": "02:23 PM",
//         "id": 201
//       },
//       {
//         "no": 14,
//         "name": "MELA SEITHALAI",
//         "time": "02:25 PM",
//         "id": 200
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 2",
//         "time": "02:29 PM",
//         "id": 295
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "02:33 PM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "02:37 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "02:41 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "02:45 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "02:50 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "02:55 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:57 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:01 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:02 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:06 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:07 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-B-3-295",
//     "routeNo": "55-B",
//     "code": "55/P55B-1",
//     "tripCode": "55/P55B-155-BTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:15 PM",
//     "endTime": "04:30 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "03:20 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:24 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "03:27 PM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "03:31 PM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "03:36 PM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "03:39 PM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "03:46 PM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "03:50 PM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "03:58 PM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "04:02 PM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:07 PM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "04:10 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "04:13 PM",
//         "id": 197
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "04:20 PM",
//         "id": 296
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "04:26 PM",
//         "id": 198
//       },
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "04:30 PM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-B-4-296",
//     "routeNo": "55-B",
//     "code": "55/P55B-1",
//     "tripCode": "55/P55B-155-BTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:35 PM",
//     "endTime": "05:50 PM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       84,
//       83,
//       82,
//       81,
//       225,
//       79,
//       78,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "04:35 PM",
//         "id": 199
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "04:38 PM",
//         "id": 198
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "04:44 PM",
//         "id": 296
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "04:51 PM",
//         "id": 197
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "04:54 PM",
//         "id": 196
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:57 PM",
//         "id": 74
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:02 PM",
//         "id": 73
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "05:06 PM",
//         "id": 84
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "05:14 PM",
//         "id": 83
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "05:18 PM",
//         "id": 82
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "05:25 PM",
//         "id": 81
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "05:28 PM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "05:33 PM",
//         "id": 79
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "05:37 PM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:40 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:44 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-B-5-297",
//     "routeNo": "55-B",
//     "code": "55/P55B-2",
//     "tripCode": "55/P55B-255-BTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MILAGU NATTHAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:00 PM",
//     "endTime": "07:10 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       191,
//       295,
//       200,
//       156,
//       201,
//       202,
//       203,
//       204,
//       205,
//       206,
//       207
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:01 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:03 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:06 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:07 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:11 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "06:13 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "06:17 PM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "06:22 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "06:25 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "06:28 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "06:32 PM",
//         "id": 191
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 2",
//         "time": "06:36 PM",
//         "id": 295
//       },
//       {
//         "no": 14,
//         "name": "MELA SEITHALAI",
//         "time": "06:40 PM",
//         "id": 200
//       },
//       {
//         "no": 15,
//         "name": "KEELA SEITHALAI",
//         "time": "06:43 PM",
//         "id": 156
//       },
//       {
//         "no": 16,
//         "name": "JEGAVEERAPANDIAPURAM",
//         "time": "06:49 PM",
//         "id": 201
//       },
//       {
//         "no": 17,
//         "name": "THANNEER MADAM",
//         "time": "06:55 PM",
//         "id": 202
//       },
//       {
//         "no": 18,
//         "name": "KAYATHAR JUNCTION",
//         "time": "06:56 PM",
//         "id": 203
//       },
//       {
//         "no": 19,
//         "name": "EPPODHUMVENDRAN",
//         "time": "06:57 PM",
//         "id": 204
//       },
//       {
//         "no": 20,
//         "name": "KATTUNAICKENPATTI",
//         "time": "07:01 PM",
//         "id": 205
//       },
//       {
//         "no": 21,
//         "name": "ADHANOOR",
//         "time": "07:05 PM",
//         "id": 206
//       },
//       {
//         "no": 22,
//         "name": "MILAGU NATTHAM",
//         "time": "07:10 PM",
//         "id": 207
//       }
//     ]
//   },
//   {
//     "id": "55-B-6-298",
//     "routeNo": "55-B",
//     "code": "55/P55B-3",
//     "tripCode": "55/P55B-355-BTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "MILAGU NATTHAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       207,
//       206,
//       205,
//       204,
//       203,
//       202,
//       201,
//       200,
//       295,
//       191,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "MILAGU NATTHAM",
//         "time": "07:15 PM",
//         "id": 207
//       },
//       {
//         "no": 20,
//         "name": "ADHANOOR",
//         "time": "07:19 PM",
//         "id": 206
//       },
//       {
//         "no": 19,
//         "name": "KATTUNAICKENPATTI",
//         "time": "07:25 PM",
//         "id": 205
//       },
//       {
//         "no": 18,
//         "name": "EPPODHUMVENDRAN",
//         "time": "07:29 PM",
//         "id": 204
//       },
//       {
//         "no": 17,
//         "name": "KAYATHAR JUNCTION",
//         "time": "07:31 PM",
//         "id": 203
//       },
//       {
//         "no": 16,
//         "name": "THANNEER MADAM",
//         "time": "07:32 PM",
//         "id": 202
//       },
//       {
//         "no": 15,
//         "name": "JEGAVEERAPANDIAPURAM",
//         "time": "07:39 PM",
//         "id": 201
//       },
//       {
//         "no": 14,
//         "name": "MELA SEITHALAI",
//         "time": "07:42 PM",
//         "id": 200
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 2",
//         "time": "07:46 PM",
//         "id": 295
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "07:51 PM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "07:55 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "07:59 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "08:03 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "08:09 PM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "08:13 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:16 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:20 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:22 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:25 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:27 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-B-7-299",
//     "routeNo": "55-B",
//     "code": "55/P55B-1",
//     "tripCode": "55/P55B-155-BTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:00 PM",
//     "endTime": "11:15 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "10:05 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:09 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "10:12 PM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "10:16 PM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "10:21 PM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "10:24 PM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "10:31 PM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "10:35 PM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "10:43 PM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:47 PM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:52 PM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "10:55 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "10:58 PM",
//         "id": 197
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "11:05 PM",
//         "id": 296
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "11:11 PM",
//         "id": 198
//       },
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "11:15 PM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-B-8-300",
//     "routeNo": "55-B",
//     "code": "55/P55B-1",
//     "tripCode": "55/P55B-155-BTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 AM",
//     "endTime": "06:15 AM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       84,
//       83,
//       82,
//       81,
//       225,
//       79,
//       78,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "05:00 AM",
//         "id": 199
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "05:03 AM",
//         "id": 198
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "05:09 AM",
//         "id": 296
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "05:16 AM",
//         "id": 197
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "05:19 AM",
//         "id": 196
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:22 AM",
//         "id": 74
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:27 AM",
//         "id": 73
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "05:31 AM",
//         "id": 84
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "05:39 AM",
//         "id": 83
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "05:43 AM",
//         "id": 82
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "05:50 AM",
//         "id": 81
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "05:53 AM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "05:58 AM",
//         "id": 79
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "06:02 AM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:05 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:09 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-B-9-301",
//     "routeNo": "55-B",
//     "code": "55/P55B-3",
//     "tripCode": "55/P55B-355-BTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MILAGU NATTHAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:45 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       98,
//       99,
//       281,
//       100,
//       191,
//       295,
//       200,
//       201,
//       202,
//       203,
//       204,
//       205,
//       206,
//       207
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:47 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:49 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:52 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:54 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:58 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "07:01 AM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "07:05 AM",
//         "id": 98
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "07:11 AM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "07:15 AM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "07:19 AM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "07:23 AM",
//         "id": 191
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 2",
//         "time": "07:28 AM",
//         "id": 295
//       },
//       {
//         "no": 14,
//         "name": "MELA SEITHALAI",
//         "time": "07:32 AM",
//         "id": 200
//       },
//       {
//         "no": 15,
//         "name": "JEGAVEERAPANDIAPURAM",
//         "time": "07:35 AM",
//         "id": 201
//       },
//       {
//         "no": 16,
//         "name": "THANNEER MADAM",
//         "time": "07:42 AM",
//         "id": 202
//       },
//       {
//         "no": 17,
//         "name": "KAYATHAR JUNCTION",
//         "time": "07:43 AM",
//         "id": 203
//       },
//       {
//         "no": 18,
//         "name": "EPPODHUMVENDRAN",
//         "time": "07:45 AM",
//         "id": 204
//       },
//       {
//         "no": 19,
//         "name": "KATTUNAICKENPATTI",
//         "time": "07:49 AM",
//         "id": 205
//       },
//       {
//         "no": 20,
//         "name": "ADHANOOR",
//         "time": "07:55 AM",
//         "id": 206
//       },
//       {
//         "no": 21,
//         "name": "MILAGU NATTHAM",
//         "time": "08:00 AM",
//         "id": 207
//       }
//     ]
//   },
//   {
//     "id": "55-B-10-302",
//     "routeNo": "55-B",
//     "code": "55/P55B-2",
//     "tripCode": "55/P55B-255-BTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "MILAGU NATTHAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:25 AM",
//     "ids": [
//       207,
//       206,
//       205,
//       204,
//       203,
//       202,
//       201,
//       156,
//       200,
//       295,
//       191,
//       100,
//       281,
//       99,
//       98,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 22,
//         "name": "MILAGU NATTHAM",
//         "time": "08:15 AM",
//         "id": 207
//       },
//       {
//         "no": 21,
//         "name": "ADHANOOR",
//         "time": "08:19 AM",
//         "id": 206
//       },
//       {
//         "no": 20,
//         "name": "KATTUNAICKENPATTI",
//         "time": "08:23 AM",
//         "id": 205
//       },
//       {
//         "no": 19,
//         "name": "EPPODHUMVENDRAN",
//         "time": "08:27 AM",
//         "id": 204
//       },
//       {
//         "no": 18,
//         "name": "KAYATHAR JUNCTION",
//         "time": "08:28 AM",
//         "id": 203
//       },
//       {
//         "no": 17,
//         "name": "THANNEER MADAM",
//         "time": "08:29 AM",
//         "id": 202
//       },
//       {
//         "no": 16,
//         "name": "JEGAVEERAPANDIAPURAM",
//         "time": "08:35 AM",
//         "id": 201
//       },
//       {
//         "no": 15,
//         "name": "KEELA SEITHALAI",
//         "time": "08:41 AM",
//         "id": 156
//       },
//       {
//         "no": 14,
//         "name": "MELA SEITHALAI",
//         "time": "08:44 AM",
//         "id": 200
//       },
//       {
//         "no": 13,
//         "name": "CHANDRAGIRI JUNCTION 2",
//         "time": "08:48 AM",
//         "id": 295
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "08:52 AM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "08:56 AM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "08:59 AM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "09:02 AM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 1",
//         "time": "09:07 AM",
//         "id": 98
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "09:11 AM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:13 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:17 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:18 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:21 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:23 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-B-11-303",
//     "routeNo": "55-B",
//     "code": "55/P55B-1",
//     "tripCode": "55/P55B-155-BTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:30 AM",
//     "endTime": "10:45 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:35 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:39 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "09:42 AM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "09:46 AM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "09:51 AM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "09:54 AM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "10:01 AM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "10:05 AM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "10:13 AM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:17 AM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:22 AM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "10:25 AM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "10:28 AM",
//         "id": 197
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "10:35 AM",
//         "id": 296
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "10:41 AM",
//         "id": 198
//       },
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "10:45 AM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-B-12-304",
//     "routeNo": "55-B",
//     "code": "55/P55B-1",
//     "tripCode": "55/P55B-155-BTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:50 AM",
//     "endTime": "12:05 PM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       84,
//       83,
//       82,
//       81,
//       225,
//       79,
//       78,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "10:50 AM",
//         "id": 199
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "10:53 AM",
//         "id": 198
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "10:59 AM",
//         "id": 296
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "11:06 AM",
//         "id": 197
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "11:09 AM",
//         "id": 196
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "11:12 AM",
//         "id": 74
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "11:17 AM",
//         "id": 73
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "11:21 AM",
//         "id": 84
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "11:29 AM",
//         "id": 83
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "11:33 AM",
//         "id": 82
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "11:40 AM",
//         "id": 81
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "11:43 AM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "11:48 AM",
//         "id": 79
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "11:52 AM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:55 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "11:59 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-C-1-305",
//     "routeNo": "55-C",
//     "code": "55/P55C-1",
//     "tripCode": "55/P55C-155-CTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:10 PM",
//     "endTime": "01:30 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "12:15 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:19 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "12:23 PM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "12:27 PM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "12:33 PM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "12:36 PM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "12:43 PM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "12:48 PM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "12:56 PM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:00 PM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:06 PM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "01:09 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "01:12 PM",
//         "id": 197
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "01:19 PM",
//         "id": 296
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "01:25 PM",
//         "id": 198
//       },
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "01:30 PM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-C-2-306",
//     "routeNo": "55-C",
//     "code": "55/P55C-1",
//     "tripCode": "55/P55C-155-CTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:40 PM",
//     "endTime": "02:45 PM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       84,
//       83,
//       82,
//       81,
//       225,
//       79,
//       78,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "01:40 PM",
//         "id": 199
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "01:43 PM",
//         "id": 198
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "01:48 PM",
//         "id": 296
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "01:54 PM",
//         "id": 197
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "01:56 PM",
//         "id": 196
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:59 PM",
//         "id": 74
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:03 PM",
//         "id": 73
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "02:06 PM",
//         "id": 84
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "02:13 PM",
//         "id": 83
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "02:17 PM",
//         "id": 82
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "02:23 PM",
//         "id": 81
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "02:26 PM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "02:30 PM",
//         "id": 79
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "02:34 PM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:37 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "02:40 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-C-3-307",
//     "routeNo": "55-C",
//     "code": "55/P55C-2",
//     "tripCode": "55/P55C-255-CTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SANGAMPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:50 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       109,
//       105,
//       85,
//       106,
//       208,
//       209
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:52 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:53 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:57 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:58 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:02 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:06 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "03:10 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "03:15 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "03:20 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "03:24 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "03:25 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "03:31 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "03:33 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "TALUK OFFICE",
//         "time": "03:34 PM",
//         "id": 109
//       },
//       {
//         "no": 16,
//         "name": "AYYANAR KOVIL",
//         "time": "03:36 PM",
//         "id": 105
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "03:43 PM",
//         "id": 85
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "03:45 PM",
//         "id": 106
//       },
//       {
//         "no": 20,
//         "name": "MURAMBAN",
//         "time": "03:55 PM",
//         "id": 208
//       },
//       {
//         "no": 21,
//         "name": "SANGAMPATTI",
//         "time": "04:00 PM",
//         "id": 209
//       }
//     ]
//   },
//   {
//     "id": "55-C-4-308",
//     "routeNo": "55-C",
//     "code": "55/P55C-2",
//     "tripCode": "55/P55C-255-CTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SANGAMPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:05 PM",
//     "endTime": "05:35 PM",
//     "ids": [
//       209,
//       208,
//       106,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "SANGAMPATTI",
//         "time": "04:05 PM",
//         "id": 209
//       },
//       {
//         "no": 20,
//         "name": "MURAMBAN",
//         "time": "04:10 PM",
//         "id": 208
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "04:23 PM",
//         "id": 106
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "04:26 PM",
//         "id": 85
//       },
//       {
//         "no": 16,
//         "name": "AYYANAR KOVIL",
//         "time": "04:35 PM",
//         "id": 105
//       },
//       {
//         "no": 15,
//         "name": "TALUK OFFICE",
//         "time": "04:38 PM",
//         "id": 109
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "04:39 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "04:41 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "04:48 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:51 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "04:55 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "05:02 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "05:09 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "05:14 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:18 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:23 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:25 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:29 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:32 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-C-5-309",
//     "routeNo": "55-C",
//     "code": "55/P55C-1",
//     "tripCode": "55/P55C-155-CTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 PM",
//     "endTime": "06:55 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:49 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:53 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "05:56 PM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "06:00 PM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "06:05 PM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "06:08 PM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "06:14 PM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "06:18 PM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "06:25 PM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:29 PM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "06:34 PM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "06:36 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "06:39 PM",
//         "id": 197
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "06:46 PM",
//         "id": 296
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "06:51 PM",
//         "id": 198
//       },
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "06:55 PM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-C-6-310",
//     "routeNo": "55-C",
//     "code": "55/P55C-1",
//     "tripCode": "55/P55C-155-CTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 PM",
//     "endTime": "08:15 PM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       84,
//       83,
//       82,
//       81,
//       225,
//       79,
//       78,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "07:00 PM",
//         "id": 199
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "07:03 PM",
//         "id": 198
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "07:09 PM",
//         "id": 296
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "07:16 PM",
//         "id": 197
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "07:19 PM",
//         "id": 196
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:22 PM",
//         "id": 74
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:27 PM",
//         "id": 73
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "07:31 PM",
//         "id": 84
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "07:39 PM",
//         "id": 83
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "07:43 PM",
//         "id": 82
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "07:50 PM",
//         "id": 81
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "07:53 PM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "07:58 PM",
//         "id": 79
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "08:02 PM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:05 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:09 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-C-7-311",
//     "routeNo": "55-C",
//     "code": "55/P55C-3",
//     "tripCode": "55/P55C-355-CTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "VELLARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 PM",
//     "endTime": "10:55 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:42 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:45 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:49 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:51 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:57 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:01 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:06 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:13 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:20 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:25 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:27 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "10:34 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "10:37 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "GOVERNORGIRI",
//         "time": "10:50 PM",
//         "id": 195
//       },
//       {
//         "no": 16,
//         "name": "VELLARAM",
//         "time": "10:55 PM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-C-8-312",
//     "routeNo": "55-C",
//     "code": "55/P55C-3",
//     "tripCode": "55/P55C-355-CTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "VELLARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:30 AM",
//     "endTime": "05:40 AM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "VELLARAM",
//         "time": "04:30 AM",
//         "id": 194
//       },
//       {
//         "no": 15,
//         "name": "GOVERNORGIRI",
//         "time": "04:34 AM",
//         "id": 195
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "04:46 AM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "04:49 AM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "04:55 AM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:57 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:02 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "05:08 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "05:15 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "05:19 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:24 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:29 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:30 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:35 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:37 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-C-9-313",
//     "routeNo": "55-C",
//     "code": "55/P55C-1",
//     "tripCode": "55/P55C-155-CTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:20 AM",
//     "endTime": "07:35 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       78,
//       79,
//       225,
//       81,
//       82,
//       83,
//       84,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:25 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:29 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "06:32 AM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "06:36 AM",
//         "id": 79
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "06:41 AM",
//         "id": 225
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "06:44 AM",
//         "id": 81
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "06:51 AM",
//         "id": 82
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "06:55 AM",
//         "id": 83
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "07:03 AM",
//         "id": 84
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:07 AM",
//         "id": 73
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:12 AM",
//         "id": 74
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "07:15 AM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "07:18 AM",
//         "id": 197
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "07:25 AM",
//         "id": 296
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "07:31 AM",
//         "id": 198
//       },
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "07:35 AM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-C-10-314",
//     "routeNo": "55-C",
//     "code": "55/P55C-1",
//     "tripCode": "55/P55C-155-CTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 AM",
//     "endTime": "09:10 AM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       84,
//       83,
//       82,
//       81,
//       225,
//       79,
//       78,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "SAVARIMANGALAM",
//         "time": "07:50 AM",
//         "id": 199
//       },
//       {
//         "no": 16,
//         "name": "S.KAILASAPURAM",
//         "time": "07:54 AM",
//         "id": 198
//       },
//       {
//         "no": 15,
//         "name": "S.PUTHUR",
//         "time": "08:00 AM",
//         "id": 296
//       },
//       {
//         "no": 14,
//         "name": "JAMBULINGAPURAM",
//         "time": "08:07 AM",
//         "id": 197
//       },
//       {
//         "no": 13,
//         "name": "VALLINAYAGIPURAM",
//         "time": "08:10 AM",
//         "id": 196
//       },
//       {
//         "no": 12,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:13 AM",
//         "id": 74
//       },
//       {
//         "no": 11,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:19 AM",
//         "id": 73
//       },
//       {
//         "no": 10,
//         "name": "SAMYNATTHAM",
//         "time": "08:23 AM",
//         "id": 84
//       },
//       {
//         "no": 9,
//         "name": "KAYALOORANI",
//         "time": "08:31 AM",
//         "id": 83
//       },
//       {
//         "no": 8,
//         "name": "VEERAPANDIAPURAM",
//         "time": "08:36 AM",
//         "id": 82
//       },
//       {
//         "no": 7,
//         "name": "RAILWAY GATE",
//         "time": "08:43 AM",
//         "id": 81
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "08:46 AM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR",
//         "time": "08:52 AM",
//         "id": 79
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "08:56 AM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:00 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:04 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-C-11-315",
//     "routeNo": "55-C",
//     "code": "55/P55C-2",
//     "tripCode": "55/P55C-255-CTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SANGAMPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:20 AM",
//     "endTime": "10:40 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       109,
//       105,
//       85,
//       106,
//       208,
//       209
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:22 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:24 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:28 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:29 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:34 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:38 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:43 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:48 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:54 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:58 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:01 AM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "10:07 AM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "10:09 AM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "TALUK OFFICE",
//         "time": "10:10 AM",
//         "id": 109
//       },
//       {
//         "no": 16,
//         "name": "AYYANAR KOVIL",
//         "time": "10:12 AM",
//         "id": 105
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "10:21 AM",
//         "id": 85
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "10:23 AM",
//         "id": 106
//       },
//       {
//         "no": 20,
//         "name": "MURAMBAN",
//         "time": "10:34 AM",
//         "id": 208
//       },
//       {
//         "no": 21,
//         "name": "SANGAMPATTI",
//         "time": "10:40 AM",
//         "id": 209
//       }
//     ]
//   },
//   {
//     "id": "55-C-12-316",
//     "routeNo": "55-C",
//     "code": "55/P55C-2",
//     "tripCode": "55/P55C-255-CTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "SANGAMPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:45 AM",
//     "endTime": "11:55 AM",
//     "ids": [
//       209,
//       208,
//       106,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "SANGAMPATTI",
//         "time": "10:45 AM",
//         "id": 209
//       },
//       {
//         "no": 20,
//         "name": "MURAMBAN",
//         "time": "10:49 AM",
//         "id": 208
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "10:59 AM",
//         "id": 106
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "11:01 AM",
//         "id": 85
//       },
//       {
//         "no": 16,
//         "name": "AYYANAR KOVIL",
//         "time": "11:08 AM",
//         "id": 105
//       },
//       {
//         "no": 15,
//         "name": "TALUK OFFICE",
//         "time": "11:10 AM",
//         "id": 109
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "11:11 AM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "11:13 AM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "11:19 AM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "11:20 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "11:24 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "11:29 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:34 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:38 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:42 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:46 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:47 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:51 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:52 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:55 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-1-317",
//     "routeNo": "55-D",
//     "code": "55/P55D-1",
//     "tripCode": "55/P55D-155-DTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 AM",
//     "endTime": "08:05 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:51 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:53 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:55 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:56 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:59 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:02 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:05 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:09 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:13 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:16 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "07:32 AM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:49 AM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:53 AM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "07:54 AM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "08:02 AM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "08:05 AM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-D-2-318",
//     "routeNo": "55-D",
//     "code": "55/P55D-1",
//     "tripCode": "55/P55D-155-DTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 AM",
//     "endTime": "09:25 AM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       193,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "08:10 AM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "08:12 AM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "08:20 AM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:21 AM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:25 AM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "08:42 AM",
//         "id": 193
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:58 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:01 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:05 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:09 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:12 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:15 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:18 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:19 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:21 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:23 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-3-319",
//     "routeNo": "55-D",
//     "code": "55/P55D-3",
//     "tripCode": "55/P55D-355-DTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 AM",
//     "endTime": "10:40 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:51 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:53 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:56 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:57 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:01 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:04 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:08 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:12 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:17 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:20 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "10:28 AM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:35 AM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "10:40 AM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "55-D-4-320",
//     "routeNo": "55-D",
//     "code": "55/P55D-3",
//     "tripCode": "55/P55D-355-DTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:55 AM",
//     "endTime": "11:45 AM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "10:55 AM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:59 AM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "11:06 AM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "11:14 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "11:17 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "11:22 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:26 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:30 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:33 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:37 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:38 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:41 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:43 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-5-321",
//     "routeNo": "55-D",
//     "code": "55/P55D-2",
//     "tripCode": "55/P55D-255-DTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "AGILANDAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:50 AM",
//     "endTime": "12:45 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       189,
//       280,
//       75,
//       76,
//       190
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:51 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:52 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:55 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:56 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:59 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "12:01 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "12:04 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "12:08 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:11 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:14 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "AGILANDAPURAM",
//         "time": "12:25 PM",
//         "id": 189
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:35 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:39 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:40 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "PANCHALANKURICHI",
//         "time": "12:45 PM",
//         "id": 190
//       }
//     ]
//   },
//   {
//     "id": "55-D-6-322",
//     "routeNo": "55-D",
//     "code": "55/P55D-2",
//     "tripCode": "55/P55D-255-DTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "AGILANDAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:50 PM",
//     "endTime": "01:55 PM",
//     "ids": [
//       190,
//       76,
//       75,
//       280,
//       189,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PANCHALANKURICHI",
//         "time": "12:50 PM",
//         "id": 190
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:55 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:56 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "01:01 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "AGILANDAPURAM",
//         "time": "01:13 PM",
//         "id": 189
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:25 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:29 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:33 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:37 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:41 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:43 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:47 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:48 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:51 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:53 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-7-323",
//     "routeNo": "55-D",
//     "code": "55/P55D-3",
//     "tripCode": "55/P55D-355-DTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:05 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:06 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:08 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:11 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:12 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:16 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "02:19 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "02:23 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "02:27 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:32 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:35 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "02:43 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "02:50 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "02:55 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "55-D-8-324",
//     "routeNo": "55-D",
//     "code": "55/P55D-3",
//     "tripCode": "55/P55D-355-DTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:10 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "03:10 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "03:14 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "03:21 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "03:29 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "03:32 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "03:37 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "03:41 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:45 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:48 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:52 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:53 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:56 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:58 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-9-325",
//     "routeNo": "55-D",
//     "code": "55/P55D-1",
//     "tripCode": "55/P55D-155-DTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:05 PM",
//     "endTime": "05:20 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:06 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:08 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "04:10 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "04:11 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "04:14 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "04:17 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "04:20 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "04:24 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "04:28 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:31 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "04:47 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "05:04 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "05:08 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "05:09 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "05:17 PM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "05:20 PM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-D-10-326",
//     "routeNo": "55-D",
//     "code": "55/P55D-1",
//     "tripCode": "55/P55D-155-DTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:25 PM",
//     "endTime": "06:50 PM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       193,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "05:25 PM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "05:28 PM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "05:36 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "05:38 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "05:43 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "06:01 PM",
//         "id": 193
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "06:20 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:23 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:28 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:32 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:35 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:38 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:42 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:43 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:46 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:48 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-11-327",
//     "routeNo": "55-D",
//     "code": "55/P55D-2",
//     "tripCode": "55/P55D-255-DTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "AGILANDAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:55 PM",
//     "endTime": "07:55 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       189,
//       280,
//       75,
//       76,
//       190
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:55 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:56 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:58 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:00 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:01 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:05 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:07 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:10 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:14 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:18 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:21 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "AGILANDAPURAM",
//         "time": "07:33 PM",
//         "id": 189
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:44 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:48 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "07:50 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "PANCHALANKURICHI",
//         "time": "07:55 PM",
//         "id": 190
//       }
//     ]
//   },
//   {
//     "id": "55-D-12-328",
//     "routeNo": "55-D",
//     "code": "55/P55D-2",
//     "tripCode": "55/P55D-255-DTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "AGILANDAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 PM",
//     "endTime": "09:00 PM",
//     "ids": [
//       190,
//       76,
//       75,
//       280,
//       189,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PANCHALANKURICHI",
//         "time": "08:00 PM",
//         "id": 190
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "08:04 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:06 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:10 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "AGILANDAPURAM",
//         "time": "08:21 PM",
//         "id": 189
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:33 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:36 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:40 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:44 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:47 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:49 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:53 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:54 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:56 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:58 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-D-13-329",
//     "routeNo": "55-D",
//     "code": "55/P55D-3",
//     "tripCode": "55/P55D-355-DTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 PM",
//     "endTime": "10:00 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:11 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:13 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:16 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:17 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:21 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:24 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:28 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:32 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:37 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:40 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "09:48 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "09:55 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "10:00 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "55-D-14-330",
//     "routeNo": "55-D",
//     "code": "55/P55D-3",
//     "tripCode": "55/P55D-355-DTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:05 PM",
//     "endTime": "10:55 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "10:05 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:09 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "10:16 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:24 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:27 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:32 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:36 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:40 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:43 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "10:47 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "10:48 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "10:51 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:53 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-E-1-331",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:20 PM",
//     "endTime": "03:30 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:21 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:22 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:25 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:26 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:29 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "02:31 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "02:34 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "02:38 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:41 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:44 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "03:00 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "03:15 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "03:18 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "03:20 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "03:27 PM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "03:30 PM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-E-2-332",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:35 PM",
//     "endTime": "04:50 PM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       193,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "03:35 PM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "03:37 PM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "03:45 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "03:46 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "03:50 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "04:07 PM",
//         "id": 193
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:23 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "04:26 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "04:30 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "04:34 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "04:37 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "04:40 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "04:43 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "04:44 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:46 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:48 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-E-3-333",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:05 PM",
//     "endTime": "06:15 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:06 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:07 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:10 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:11 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:14 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "05:16 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "05:19 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "05:23 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:26 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:29 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "05:45 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "06:00 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "06:03 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "06:05 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "06:12 PM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "06:15 PM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-E-4-334",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:20 PM",
//     "endTime": "07:35 PM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       193,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "06:20 PM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "06:22 PM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "06:30 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "06:31 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "06:35 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "06:52 PM",
//         "id": 193
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:08 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:11 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:15 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:19 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:22 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:25 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:28 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:29 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:31 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:33 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-E-5-335",
//     "routeNo": "55-E",
//     "code": "55/P55E-2",
//     "tripCode": "55/P55E-255-ETORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "VELLARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 PM",
//     "endTime": "09:10 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       194,
//       280,
//       75,
//       76,
//       195
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:51 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:53 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:56 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:57 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:01 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:04 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:07 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:11 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:16 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:19 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "VELLARAM",
//         "time": "08:37 PM",
//         "id": 194
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:55 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:59 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "09:01 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "09:10 PM",
//         "id": 195
//       }
//     ]
//   },
//   {
//     "id": "55-E-6-336",
//     "routeNo": "55-E",
//     "code": "55/P55E-2",
//     "tripCode": "55/P55E-255-ETORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "VELLARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 AM",
//     "endTime": "08:25 AM",
//     "ids": [
//       195,
//       76,
//       75,
//       280,
//       194,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "07:10 AM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "07:17 AM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:19 AM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:23 AM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "VELLARAM",
//         "time": "07:40 AM",
//         "id": 194
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:57 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:00 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:04 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:08 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:11 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:14 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:18 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:18 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:21 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:23 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-E-7-337",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:40 AM",
//     "endTime": "09:50 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:41 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:42 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:45 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:46 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:49 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:51 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:54 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:58 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:01 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:04 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "09:20 AM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "09:35 AM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "09:38 AM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "09:40 AM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "09:47 AM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "09:50 AM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-E-8-338",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:55 AM",
//     "endTime": "11:05 AM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       193,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "09:55 AM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "09:57 AM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "10:04 AM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "10:06 AM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:09 AM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "10:24 AM",
//         "id": 193
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:40 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:43 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:46 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:50 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:53 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:55 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "10:58 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "10:59 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:02 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:03 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:05 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-E-9-339",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KACCHERI THALAVAIPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:10 AM",
//     "endTime": "12:20 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       193,
//       280,
//       75,
//       76,
//       195,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:11 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:12 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:15 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:16 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:19 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:21 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:24 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "11:28 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "11:31 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "11:34 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "11:50 AM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:05 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:08 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:10 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "12:17 PM",
//         "id": 195
//       },
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "12:20 PM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "55-E-10-340",
//     "routeNo": "55-E",
//     "code": "55/P55E-1",
//     "tripCode": "55/P55E-155-ETORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KACCHERI THALAVAIPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:25 PM",
//     "endTime": "01:35 PM",
//     "ids": [
//       194,
//       195,
//       76,
//       75,
//       280,
//       193,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "VELLARAM",
//         "time": "12:25 PM",
//         "id": 194
//       },
//       {
//         "no": 16,
//         "name": "GOVERNORGIRI",
//         "time": "12:27 PM",
//         "id": 195
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:34 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:36 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:39 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "12:54 PM",
//         "id": 193
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:10 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:13 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:16 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:20 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:23 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:25 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:28 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:29 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:32 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:33 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-1-341",
//     "routeNo": "55-F",
//     "code": "55/P55F-1",
//     "tripCode": "55/P55F-155-FTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CEYLON COLONY",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:20 PM",
//     "endTime": "02:05 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       210
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:22 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:23 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:27 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:28 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:32 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:35 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:39 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:43 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:49 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:52 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "01:54 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "01:59 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "02:01 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "02:05 PM",
//         "id": 210
//       }
//     ]
//   },
//   {
//     "id": "55-F-2-342",
//     "routeNo": "55-F",
//     "code": "55/P55F-1",
//     "tripCode": "55/P55F-155-FTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "CEYLON COLONY",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:10 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       210,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "02:10 PM",
//         "id": 210
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "02:13 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "02:15 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "02:20 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:22 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:25 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "02:31 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "02:35 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "02:39 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:42 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:46 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:47 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:51 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:52 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-3-343",
//     "routeNo": "55-F",
//     "code": "55/P55F-3",
//     "tripCode": "55/P55F-355-FTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA MUDIMAN",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:10 PM",
//     "endTime": "04:15 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       210,
//       211,
//       212,
//       213,
//       216
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:12 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:14 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:18 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:19 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:24 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:27 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "03:31 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "03:37 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "03:42 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "03:46 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "03:48 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "03:54 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "03:57 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "04:01 PM",
//         "id": 210
//       },
//       {
//         "no": 16,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "04:05 PM",
//         "id": 211
//       },
//       {
//         "no": 17,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "04:09 PM",
//         "id": 212
//       },
//       {
//         "no": 18,
//         "name": "KEELA MUDIMAN",
//         "time": "04:11 PM",
//         "id": 213
//       },
//       {
//         "no": 19,
//         "name": "MELA MUDIMAN",
//         "time": "04:15 PM",
//         "id": 216
//       }
//     ]
//   },
//   {
//     "id": "55-F-4-344",
//     "routeNo": "55-F",
//     "code": "55/P55F-3",
//     "tripCode": "55/P55F-355-FTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "MELA MUDIMAN",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:40 PM",
//     "endTime": "05:45 PM",
//     "ids": [
//       216,
//       213,
//       212,
//       211,
//       210,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "MELA MUDIMAN",
//         "time": "04:40 PM",
//         "id": 216
//       },
//       {
//         "no": 18,
//         "name": "KEELA MUDIMAN",
//         "time": "04:43 PM",
//         "id": 213
//       },
//       {
//         "no": 17,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "04:45 PM",
//         "id": 212
//       },
//       {
//         "no": 16,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "04:49 PM",
//         "id": 211
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "04:53 PM",
//         "id": 210
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "04:57 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "05:00 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "05:06 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:08 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:12 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "05:17 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "05:23 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "05:27 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:30 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:35 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:36 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:40 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:42 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-5-345",
//     "routeNo": "55-F",
//     "code": "55/P55F-1",
//     "tripCode": "55/P55F-155-FTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CEYLON COLONY",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:50 PM",
//     "endTime": "06:40 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       210
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:52 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:54 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:58 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:59 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:03 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:07 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:11 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:16 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:22 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "06:26 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "06:28 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "06:33 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "06:36 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "06:40 PM",
//         "id": 210
//       }
//     ]
//   },
//   {
//     "id": "55-F-6-346",
//     "routeNo": "55-F",
//     "code": "55/P55F-1",
//     "tripCode": "55/P55F-155-FTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "CEYLON COLONY",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:55 PM",
//     "endTime": "07:45 PM",
//     "ids": [
//       210,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "06:55 PM",
//         "id": 210
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "06:58 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "07:01 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:06 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:08 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:12 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:18 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:23 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:27 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:31 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:35 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:36 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:40 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:42 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-7-347",
//     "routeNo": "55-F",
//     "code": "55/P55F-2",
//     "tripCode": "55/P55F-255-FTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PASUVANTHANAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 PM",
//     "endTime": "09:30 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       210,
//       211,
//       212,
//       213,
//       214,
//       215
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:12 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:14 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:18 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:19 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:24 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:28 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:33 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:38 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:45 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:49 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:51 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "08:57 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "09:00 PM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "09:04 PM",
//         "id": 210
//       },
//       {
//         "no": 16,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "09:09 PM",
//         "id": 211
//       },
//       {
//         "no": 17,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "09:13 PM",
//         "id": 212
//       },
//       {
//         "no": 18,
//         "name": "KEELA MUDIMAN",
//         "time": "09:15 PM",
//         "id": 213
//       },
//       {
//         "no": 19,
//         "name": "POOLNAYAKKANOOR",
//         "time": "09:20 PM",
//         "id": 214
//       },
//       {
//         "no": 20,
//         "name": "PASUVANTHANAI",
//         "time": "09:30 PM",
//         "id": 215
//       }
//     ]
//   },
//   {
//     "id": "55-F-8-348",
//     "routeNo": "55-F",
//     "code": "55/P55F-2",
//     "tripCode": "55/P55F-255-FTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PASUVANTHANAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:45 PM",
//     "endTime": "10:05 PM",
//     "ids": [
//       215,
//       214,
//       213,
//       212,
//       211,
//       210,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "PASUVANTHANAI",
//         "time": "09:45 PM",
//         "id": 215
//       },
//       {
//         "no": 19,
//         "name": "POOLNAYAKKANOOR",
//         "time": "09:47 PM",
//         "id": 214
//       },
//       {
//         "no": 18,
//         "name": "KEELA MUDIMAN",
//         "time": "09:48 PM",
//         "id": 213
//       },
//       {
//         "no": 17,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "09:49 PM",
//         "id": 212
//       },
//       {
//         "no": 16,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "09:50 PM",
//         "id": 211
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "09:51 PM",
//         "id": 210
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "09:52 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "09:53 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "09:54 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:55 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:56 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:57 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:59 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:00 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:01 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "10:02 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "10:02 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "10:03 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:04 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-9-349",
//     "routeNo": "55-F",
//     "code": "55/P55F-3",
//     "tripCode": "55/P55F-355-FTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA MUDIMAN",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:25 AM",
//     "endTime": "05:35 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       210,
//       211,
//       212,
//       213,
//       216
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:25 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:27 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:29 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "04:33 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "04:35 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "04:40 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "04:43 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "04:48 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "04:54 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:00 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:04 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "05:06 AM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "05:13 AM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "05:15 AM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "05:20 AM",
//         "id": 210
//       },
//       {
//         "no": 16,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "05:24 AM",
//         "id": 211
//       },
//       {
//         "no": 17,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "05:29 AM",
//         "id": 212
//       },
//       {
//         "no": 18,
//         "name": "KEELA MUDIMAN",
//         "time": "05:31 AM",
//         "id": 213
//       },
//       {
//         "no": 19,
//         "name": "MELA MUDIMAN",
//         "time": "05:35 AM",
//         "id": 216
//       }
//     ]
//   },
//   {
//     "id": "55-F-10-350",
//     "routeNo": "55-F",
//     "code": "55/P55F-3",
//     "tripCode": "55/P55F-355-FTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "MELA MUDIMAN",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:05 AM",
//     "endTime": "06:40 AM",
//     "ids": [
//       216,
//       213,
//       212,
//       211,
//       210,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "MELA MUDIMAN",
//         "time": "05:05 AM",
//         "id": 216
//       },
//       {
//         "no": 18,
//         "name": "KEELA MUDIMAN",
//         "time": "05:10 AM",
//         "id": 213
//       },
//       {
//         "no": 17,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "05:12 AM",
//         "id": 212
//       },
//       {
//         "no": 16,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "05:18 AM",
//         "id": 211
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "05:25 AM",
//         "id": 210
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "05:31 AM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "05:34 AM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "05:43 AM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:46 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:51 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:00 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:08 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:14 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:19 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:26 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:28 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:33 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:36 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-11-351",
//     "routeNo": "55-F",
//     "code": "55/P55F-4",
//     "tripCode": "55/P55F-455-FTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ATTHIMARAPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 AM",
//     "endTime": "07:15 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       176,
//       177
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:50 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:54 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:00 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:09 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "07:09 AM",
//         "id": 176
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "07:15 AM",
//         "id": 177
//       }
//     ]
//   },
//   {
//     "id": "55-F-12-352",
//     "routeNo": "55-F",
//     "code": "55/P55F-4",
//     "tripCode": "55/P55F-455-FTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ATTHIMARAPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 AM",
//     "endTime": "08:10 AM",
//     "ids": [
//       177,
//       176,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "07:20 AM",
//         "id": 177
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "07:31 AM",
//         "id": 176
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:31 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:49 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:01 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:08 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-F-13-353",
//     "routeNo": "55-F",
//     "code": "55/P55F-1",
//     "tripCode": "55/P55F-155-FTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CEYLON COLONY",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76,
//       210
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:17 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:19 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:23 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:24 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:28 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:32 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:36 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:41 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:47 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:51 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:53 AM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "08:58 AM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "09:01 AM",
//         "id": 76
//       },
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "09:05 AM",
//         "id": 210
//       }
//     ]
//   },
//   {
//     "id": "55-F-14-354",
//     "routeNo": "55-F",
//     "code": "55/P55F-1",
//     "tripCode": "55/P55F-155-FTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "CEYLON COLONY",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:20 AM",
//     "endTime": "12:10 PM",
//     "ids": [
//       210,
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "CEYLON COLONY",
//         "time": "09:20 AM",
//         "id": 210
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "09:33 AM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "09:41 AM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "10:00 AM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:07 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:20 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:39 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:57 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:11 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:23 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:38 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:42 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:55 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "12:02 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-G-1-355",
//     "routeNo": "55-G",
//     "code": "55/P55G-3",
//     "tripCode": "55/P55G-355-GTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:15 PM",
//     "endTime": "02:15 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:17 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:19 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:24 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:25 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:30 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:34 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:39 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:45 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:51 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:55 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "VALLINAYAGIPURAM",
//         "time": "01:58 PM",
//         "id": 196
//       },
//       {
//         "no": 13,
//         "name": "JAMBULINGAPURAM",
//         "time": "02:00 PM",
//         "id": 197
//       },
//       {
//         "no": 14,
//         "name": "S.PUTHUR",
//         "time": "02:06 PM",
//         "id": 296
//       },
//       {
//         "no": 15,
//         "name": "S.KAILASAPURAM",
//         "time": "02:11 PM",
//         "id": 198
//       },
//       {
//         "no": 16,
//         "name": "SAVARIMANGALAM",
//         "time": "02:15 PM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-G-2-356",
//     "routeNo": "55-G",
//     "code": "55/P55G-3",
//     "tripCode": "55/P55G-355-GTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:20 PM",
//     "endTime": "03:20 PM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SAVARIMANGALAM",
//         "time": "02:20 PM",
//         "id": 199
//       },
//       {
//         "no": 15,
//         "name": "S.KAILASAPURAM",
//         "time": "02:23 PM",
//         "id": 198
//       },
//       {
//         "no": 14,
//         "name": "S.PUTHUR",
//         "time": "02:28 PM",
//         "id": 296
//       },
//       {
//         "no": 13,
//         "name": "JAMBULINGAPURAM",
//         "time": "02:34 PM",
//         "id": 197
//       },
//       {
//         "no": 12,
//         "name": "VALLINAYAGIPURAM",
//         "time": "02:36 PM",
//         "id": 196
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:39 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:43 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "02:49 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "02:55 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:00 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:04 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:09 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:10 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:15 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:17 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:20 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-G-3-357",
//     "routeNo": "55-G",
//     "code": "55/P55G-1",
//     "tripCode": "55/P55G-155-GTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KANTHASAMYPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:35 PM",
//     "endTime": "04:55 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       218,
//       280,
//       75,
//       76,
//       109,
//       105,
//       85,
//       86,
//       217
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:36 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:38 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:41 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:42 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:45 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "03:48 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "03:51 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "03:55 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "04:00 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:03 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KANTHASAMYPURAM",
//         "time": "04:19 PM",
//         "id": 218
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "04:34 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "04:38 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "04:40 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "04:41 PM",
//         "id": 109
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "04:42 PM",
//         "id": 105
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "04:49 PM",
//         "id": 85
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "04:53 PM",
//         "id": 86
//       },
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "04:55 PM",
//         "id": 217
//       }
//     ]
//   },
//   {
//     "id": "55-G-4-358",
//     "routeNo": "55-G",
//     "code": "55/P55G-1",
//     "tripCode": "55/P55G-155-GTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KANTHASAMYPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 PM",
//     "endTime": "06:15 PM",
//     "ids": [
//       217,
//       86,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       218,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "05:00 PM",
//         "id": 217
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "05:01 PM",
//         "id": 86
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "05:05 PM",
//         "id": 85
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "05:11 PM",
//         "id": 105
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "05:12 PM",
//         "id": 109
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "05:13 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "05:15 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "05:19 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KANTHASAMYPURAM",
//         "time": "05:33 PM",
//         "id": 218
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:48 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:51 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "05:55 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "05:59 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:02 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:04 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:08 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:09 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:11 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:13 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-G-5-359",
//     "routeNo": "55-G",
//     "code": "55/P55G-1",
//     "tripCode": "55/P55G-155-GTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KANTHASAMYPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 PM",
//     "endTime": "07:40 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       218,
//       280,
//       75,
//       76,
//       109,
//       105,
//       85,
//       86,
//       217
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "06:31 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "06:32 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "06:35 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "06:36 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "06:39 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "06:41 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:44 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:48 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:52 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "06:54 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KANTHASAMYPURAM",
//         "time": "07:08 PM",
//         "id": 218
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:21 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:25 PM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "07:27 PM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "07:27 PM",
//         "id": 109
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "07:29 PM",
//         "id": 105
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "07:34 PM",
//         "id": 85
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "07:38 PM",
//         "id": 86
//       },
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "07:40 PM",
//         "id": 217
//       }
//     ]
//   },
//   {
//     "id": "55-G-6-360",
//     "routeNo": "55-G",
//     "code": "55/P55G-1",
//     "tripCode": "55/P55G-155-GTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KANTHASAMYPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 PM",
//     "endTime": "09:15 PM",
//     "ids": [
//       217,
//       86,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       218,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "07:50 PM",
//         "id": 217
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "07:51 PM",
//         "id": 86
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "07:56 PM",
//         "id": 85
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "08:02 PM",
//         "id": 105
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "08:04 PM",
//         "id": 109
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "08:05 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:07 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:12 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KANTHASAMYPURAM",
//         "time": "08:27 PM",
//         "id": 218
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:44 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:48 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:52 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:57 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:00 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:03 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:07 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:08 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:11 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:13 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-G-7-361",
//     "routeNo": "55-G",
//     "code": "55/P55G-2",
//     "tripCode": "55/P55G-255-GTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PANDIAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 AM",
//     "endTime": "06:25 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       87,
//       280,
//       75,
//       76,
//       109,
//       105,
//       85,
//       86,
//       217,
//       218
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:00 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:01 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:03 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:06 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:06 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:10 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "05:13 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "05:16 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "05:20 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "05:24 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:27 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "PANDIAPURAM",
//         "time": "05:45 AM",
//         "id": 87
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "06:02 AM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "06:07 AM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "06:08 AM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "06:09 AM",
//         "id": 109
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "06:11 AM",
//         "id": 105
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "06:17 AM",
//         "id": 85
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "06:21 AM",
//         "id": 86
//       },
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "06:22 AM",
//         "id": 217
//       },
//       {
//         "no": 21,
//         "name": "KANTHASAMYPURAM",
//         "time": "06:25 AM",
//         "id": 218
//       }
//     ]
//   },
//   {
//     "id": "55-G-8-362",
//     "routeNo": "55-G",
//     "code": "55/P55G-2",
//     "tripCode": "55/P55G-255-GTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PANDIAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:40 AM",
//     "endTime": "07:55 AM",
//     "ids": [
//       218,
//       217,
//       86,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       87,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "KANTHASAMYPURAM",
//         "time": "06:40 AM",
//         "id": 218
//       },
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "06:42 AM",
//         "id": 217
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "06:43 AM",
//         "id": 86
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "06:47 AM",
//         "id": 85
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "06:52 AM",
//         "id": 105
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "06:53 AM",
//         "id": 109
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "06:54 AM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "06:55 AM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "06:59 AM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "PANDIAPURAM",
//         "time": "07:14 AM",
//         "id": 87
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:30 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:33 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:37 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:40 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:43 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:45 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:48 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:49 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:52 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:53 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:55 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-G-9-363",
//     "routeNo": "55-G",
//     "code": "55/P55G-3",
//     "tripCode": "55/P55G-355-GTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SAVARIMANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 AM",
//     "endTime": "09:10 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       196,
//       197,
//       296,
//       198,
//       199
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:12 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:14 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:19 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:20 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "08:25 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:29 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:34 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:40 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:46 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:50 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "VALLINAYAGIPURAM",
//         "time": "08:53 AM",
//         "id": 196
//       },
//       {
//         "no": 13,
//         "name": "JAMBULINGAPURAM",
//         "time": "08:55 AM",
//         "id": 197
//       },
//       {
//         "no": 14,
//         "name": "S.PUTHUR",
//         "time": "09:01 AM",
//         "id": 296
//       },
//       {
//         "no": 15,
//         "name": "S.KAILASAPURAM",
//         "time": "09:06 AM",
//         "id": 198
//       },
//       {
//         "no": 16,
//         "name": "SAVARIMANGALAM",
//         "time": "09:10 AM",
//         "id": 199
//       }
//     ]
//   },
//   {
//     "id": "55-G-10-364",
//     "routeNo": "55-G",
//     "code": "55/P55G-3",
//     "tripCode": "55/P55G-355-GTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "SAVARIMANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 AM",
//     "endTime": "10:15 AM",
//     "ids": [
//       199,
//       198,
//       296,
//       197,
//       196,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SAVARIMANGALAM",
//         "time": "09:15 AM",
//         "id": 199
//       },
//       {
//         "no": 15,
//         "name": "S.KAILASAPURAM",
//         "time": "09:18 AM",
//         "id": 198
//       },
//       {
//         "no": 14,
//         "name": "S.PUTHUR",
//         "time": "09:23 AM",
//         "id": 296
//       },
//       {
//         "no": 13,
//         "name": "JAMBULINGAPURAM",
//         "time": "09:29 AM",
//         "id": 197
//       },
//       {
//         "no": 12,
//         "name": "VALLINAYAGIPURAM",
//         "time": "09:31 AM",
//         "id": 196
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:34 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:38 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:44 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:50 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:55 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:59 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "10:04 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "10:05 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "10:10 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:12 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:15 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-G-11-365",
//     "routeNo": "55-G",
//     "code": "55/P55G-1",
//     "tripCode": "55/P55G-155-GTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KANTHASAMYPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 AM",
//     "endTime": "11:50 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       218,
//       280,
//       75,
//       76,
//       109,
//       105,
//       85,
//       86,
//       217
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "10:31 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "10:33 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "10:36 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "10:37 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:40 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:43 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "10:46 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "10:50 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "10:55 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:58 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "KANTHASAMYPURAM",
//         "time": "11:14 AM",
//         "id": 218
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "11:29 AM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "11:33 AM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "11:35 AM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "11:36 AM",
//         "id": 109
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "11:37 AM",
//         "id": 105
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "11:44 AM",
//         "id": 85
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "11:48 AM",
//         "id": 86
//       },
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "11:50 AM",
//         "id": 217
//       }
//     ]
//   },
//   {
//     "id": "55-G-12-366",
//     "routeNo": "55-G",
//     "code": "55/P55G-1",
//     "tripCode": "55/P55G-155-GTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KANTHASAMYPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:55 AM",
//     "endTime": "01:10 PM",
//     "ids": [
//       217,
//       86,
//       85,
//       105,
//       109,
//       76,
//       75,
//       280,
//       218,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "THALAVAIPURAM 1",
//         "time": "11:55 AM",
//         "id": 217
//       },
//       {
//         "no": 19,
//         "name": "KOMBADI",
//         "time": "11:56 AM",
//         "id": 86
//       },
//       {
//         "no": 18,
//         "name": "OSANOOTTHU",
//         "time": "12:00 PM",
//         "id": 85
//       },
//       {
//         "no": 17,
//         "name": "AYYANAR KOVIL",
//         "time": "12:06 PM",
//         "id": 105
//       },
//       {
//         "no": 16,
//         "name": "TALUK OFFICE",
//         "time": "12:07 PM",
//         "id": 109
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "12:08 PM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "12:10 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:14 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "KANTHASAMYPURAM",
//         "time": "12:28 PM",
//         "id": 218
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:43 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:46 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "12:50 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "12:54 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "12:57 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "12:59 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:03 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:04 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:06 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:08 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-1-367",
//     "routeNo": "55-H",
//     "code": "55/P55H-1",
//     "tripCode": "55/P55H-155-HTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:15 PM",
//     "endTime": "02:05 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "01:16 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "01:18 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:21 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:22 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:26 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:29 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:33 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:37 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:42 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:45 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "01:53 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "02:00 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "02:05 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "55-H-2-368",
//     "routeNo": "55-H",
//     "code": "55/P55H-1",
//     "tripCode": "55/P55H-155-HTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:15 PM",
//     "endTime": "03:05 PM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "02:15 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "02:19 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "02:26 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:34 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "02:37 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "02:42 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "02:46 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "02:50 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "02:53 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "02:57 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "02:58 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:01 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:03 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-3-369",
//     "routeNo": "55-H",
//     "code": "55/P55H-2",
//     "tripCode": "55/P55H-255-HTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "APC COLLEGE",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:20 PM",
//     "endTime": "03:20 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       219
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:20 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:20 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "APC COLLEGE",
//         "time": "03:20 PM",
//         "id": 219
//       }
//     ]
//   },
//   {
//     "id": "55-H-4-370",
//     "routeNo": "55-H",
//     "code": "55/P55H-2",
//     "tripCode": "55/P55H-255-HTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "APC COLLEGE",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:30 PM",
//     "endTime": "03:45 PM",
//     "ids": [
//       219,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 4,
//         "name": "APC COLLEGE",
//         "time": "03:30 PM",
//         "id": 219
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:35 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:39 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-5-371",
//     "routeNo": "55-H",
//     "code": "55/P55H-3",
//     "tripCode": "55/P55H-355-HTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "THOOTHUKUDI NEW B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:50 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       1,
//       26,
//       77
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:56 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI NEW B/S",
//         "time": "04:00 PM",
//         "id": 77
//       }
//     ]
//   },
//   {
//     "id": "55-H-6-372",
//     "routeNo": "55-H",
//     "code": "55/P55H-3",
//     "tripCode": "55/P55H-355-HTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "THOOTHUKUDI NEW B/S",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:05 PM",
//     "endTime": "04:25 PM",
//     "ids": [
//       77,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI NEW B/S",
//         "time": "04:05 PM",
//         "id": 77
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:11 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-7-373",
//     "routeNo": "55-H",
//     "code": "55/P55H-4",
//     "tripCode": "55/P55H-455-HTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "VELLAPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:30 PM",
//     "endTime": "05:05 PM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       187
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "04:30 PM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "04:35 PM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:39 PM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "04:47 PM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "04:51 PM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "04:53 PM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "04:59 PM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "VELLAPATTI",
//         "time": "05:05 PM",
//         "id": 187
//       }
//     ]
//   },
//   {
//     "id": "55-H-8-374",
//     "routeNo": "55-H",
//     "code": "55/P55H-4",
//     "tripCode": "55/P55H-455-HTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "VELLAPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:10 PM",
//     "endTime": "05:35 PM",
//     "ids": [
//       187,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 8,
//         "name": "VELLAPATTI",
//         "time": "05:10 PM",
//         "id": 187
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "05:13 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "05:18 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "05:19 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "05:22 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:28 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "05:31 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "05:35 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "55-H-9-375",
//     "routeNo": "55-H",
//     "code": "55/P55H-7",
//     "tripCode": "55/P55H-755-HTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SIPCOT",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 PM",
//     "endTime": "06:15 PM",
//     "ids": [
//       1,
//       26,
//       220,
//       221,
//       222,
//       223,
//       224,
//       225
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:48 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "CHINNAKANNUPURAM",
//         "time": "05:51 PM",
//         "id": 220
//       },
//       {
//         "no": 4,
//         "name": "SILVERPURAM",
//         "time": "05:54 PM",
//         "id": 221
//       },
//       {
//         "no": 5,
//         "name": "PANDARAMPATTI",
//         "time": "06:00 PM",
//         "id": 222
//       },
//       {
//         "no": 6,
//         "name": "MEELAVITTAN",
//         "time": "06:04 PM",
//         "id": 223
//       },
//       {
//         "no": 7,
//         "name": "STERLITE",
//         "time": "06:10 PM",
//         "id": 224
//       },
//       {
//         "no": 8,
//         "name": "SIPCOT COMPLEX",
//         "time": "06:15 PM",
//         "id": 225
//       }
//     ]
//   },
//   {
//     "id": "55-H-10-376",
//     "routeNo": "55-H",
//     "code": "55/P55H-8",
//     "tripCode": "55/P55H-855-HTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "SIPCOT",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:30 PM",
//     "endTime": "07:05 PM",
//     "ids": [
//       225,
//       226,
//       78,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "06:30 PM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR JUNCTION",
//         "time": "06:38 PM",
//         "id": 226
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "06:44 PM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:50 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:56 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-11-377",
//     "routeNo": "55-H",
//     "code": "55/P55H-1",
//     "tripCode": "55/P55H-155-HTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 PM",
//     "endTime": "08:20 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       76,
//       280,
//       75
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:17 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:19 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:23 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:25 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:30 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:33 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:38 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:44 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:50 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:54 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "08:04 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:13 PM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:20 PM",
//         "id": 75
//       }
//     ]
//   },
//   {
//     "id": "55-H-12-378",
//     "routeNo": "55-H",
//     "code": "55/P55H-1",
//     "tripCode": "55/P55H-155-HTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:30 PM",
//     "endTime": "05:00 AM",
//     "ids": [
//       75,
//       280,
//       76,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:30 PM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "09:19 PM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "OTTAPIDARAM",
//         "time": "10:27 PM",
//         "id": 76
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "11:47 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:21 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:10 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:55 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "02:30 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "03:01 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "03:40 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "03:50 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:23 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:39 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-13-379",
//     "routeNo": "55-H",
//     "code": "55/P55H-6",
//     "tripCode": "55/P55H-655-HTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "AUTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:10 AM",
//     "endTime": "05:45 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:10 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:12 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "05:16 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "05:21 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "05:22 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "05:24 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "05:29 AM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "05:31 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "05:35 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "05:39 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "05:42 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "05:45 AM",
//         "id": 172
//       }
//     ]
//   },
//   {
//     "id": "55-H-14-380",
//     "routeNo": "55-H",
//     "code": "55/P55H-6",
//     "tripCode": "55/P55H-655-HTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "AUTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:00 AM",
//     "endTime": "06:40 AM",
//     "ids": [
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "06:00 AM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "06:02 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "06:06 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "06:11 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "06:15 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "06:17 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:23 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:26 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:26 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:33 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:36 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:39 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-15-381",
//     "routeNo": "55-H",
//     "code": "55/P55H-5",
//     "tripCode": "55/P55H-555-HTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA MUDIMAN",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 AM",
//     "endTime": "08:10 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       216,
//       280,
//       75,
//       76,
//       210,
//       211,
//       212,
//       213
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:01 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:02 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:05 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:06 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:09 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:11 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "07:14 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "07:17 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "07:21 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:24 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "MELA MUDIMAN",
//         "time": "07:40 AM",
//         "id": 216
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "07:55 AM",
//         "id": 280
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "07:58 AM",
//         "id": 75
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "08:00 AM",
//         "id": 76
//       },
//       {
//         "no": 16,
//         "name": "CEYLON COLONY",
//         "time": "08:03 AM",
//         "id": 210
//       },
//       {
//         "no": 17,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "08:06 AM",
//         "id": 211
//       },
//       {
//         "no": 18,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "08:08 AM",
//         "id": 212
//       },
//       {
//         "no": 19,
//         "name": "KEELA MUDIMAN",
//         "time": "08:10 AM",
//         "id": 213
//       }
//     ]
//   },
//   {
//     "id": "55-H-16-382",
//     "routeNo": "55-H",
//     "code": "55/P55H-5",
//     "tripCode": "55/P55H-555-HTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "MELA MUDIMAN",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "09:35 AM",
//     "ids": [
//       213,
//       212,
//       211,
//       210,
//       76,
//       75,
//       280,
//       216,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "KEELA MUDIMAN",
//         "time": "08:15 AM",
//         "id": 213
//       },
//       {
//         "no": 18,
//         "name": "VENKETESHVARAPURAM JUNCTION",
//         "time": "08:16 AM",
//         "id": 212
//       },
//       {
//         "no": 17,
//         "name": "PUTRU MURUGAN KOVIL",
//         "time": "08:19 AM",
//         "id": 211
//       },
//       {
//         "no": 16,
//         "name": "CEYLON COLONY",
//         "time": "08:22 AM",
//         "id": 210
//       },
//       {
//         "no": 15,
//         "name": "OTTAPIDARAM",
//         "time": "08:25 AM",
//         "id": 76
//       },
//       {
//         "no": 14,
//         "name": "MUPPULIPATI",
//         "time": "08:27 AM",
//         "id": 75
//       },
//       {
//         "no": 13,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "08:32 AM",
//         "id": 280
//       },
//       {
//         "no": 12,
//         "name": "MELA MUDIMAN",
//         "time": "08:48 AM",
//         "id": 216
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "09:07 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "09:10 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "09:14 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "09:18 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "09:21 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:24 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:27 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:28 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:31 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:33 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-17-383",
//     "routeNo": "55-H",
//     "code": "55/P55H-9",
//     "tripCode": "55/P55H-955-HTORD18U17",
//     "order": 17,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "THOOTHUKUDI COLLECTORATE",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 AM",
//     "endTime": "09:55 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       227
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:45 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:49 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "THOOTHUKUDI COLLECTORATE",
//         "time": "09:55 AM",
//         "id": 227
//       }
//     ]
//   },
//   {
//     "id": "55-H-18-384",
//     "routeNo": "55-H",
//     "code": "55/P55H-9",
//     "tripCode": "55/P55H-955-HTORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "THOOTHUKUDI COLLECTORATE",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:05 AM",
//     "endTime": "10:25 AM",
//     "ids": [
//       227,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 4,
//         "name": "THOOTHUKUDI COLLECTORATE",
//         "time": "10:05 AM",
//         "id": 227
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:12 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:17 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-H-19-385",
//     "routeNo": "55-H",
//     "code": "55/P55H-10",
//     "tripCode": "55/P55H-1055-HTORD18U19",
//     "order": 19,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MULLAKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:35 AM",
//     "endTime": "11:20 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       180,
//       182,
//       183,
//       184,
//       45,
//       46
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:40 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "10:44 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:50 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:54 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:56 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP JUNCTION",
//         "time": "10:56 AM",
//         "id": 180
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "11:01 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "11:03 AM",
//         "id": 183
//       },
//       {
//         "no": 10,
//         "name": "BULK",
//         "time": "11:14 AM",
//         "id": 184
//       },
//       {
//         "no": 11,
//         "name": "SPIC NAGAR",
//         "time": "11:16 AM",
//         "id": 45
//       },
//       {
//         "no": 12,
//         "name": "MULLAKADU",
//         "time": "11:20 AM",
//         "id": 46
//       }
//     ]
//   },
//   {
//     "id": "55-H-20-386",
//     "routeNo": "55-H",
//     "code": "55/P55H-10",
//     "tripCode": "55/P55H-1055-HTORD18D20",
//     "order": 20,
//     "direction": "D",
//     "from": "MULLAKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:25 AM",
//     "endTime": "01:00 PM",
//     "ids": [
//       46,
//       45,
//       184,
//       183,
//       182,
//       180,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 12,
//         "name": "MULLAKADU",
//         "time": "11:25 AM",
//         "id": 46
//       },
//       {
//         "no": 11,
//         "name": "SPIC NAGAR",
//         "time": "11:33 AM",
//         "id": 45
//       },
//       {
//         "no": 10,
//         "name": "BULK",
//         "time": "11:36 AM",
//         "id": 184
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "12:00 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "12:04 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP JUNCTION",
//         "time": "12:14 PM",
//         "id": 180
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "12:14 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "12:19 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "12:27 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "12:40 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "12:49 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-I-1-387",
//     "routeNo": "55-I",
//     "code": "55/P55I-3",
//     "tripCode": "55/P55I-355-ITORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "OTTAPIDARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:40 AM",
//     "endTime": "12:20 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       280,
//       75,
//       76
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:42 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "11:43 AM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "11:46 AM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "11:47 AM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "11:51 AM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "11:54 AM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:58 AM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "12:03 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:07 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:11 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:13 PM",
//         "id": 280
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "12:17 PM",
//         "id": 75
//       },
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "12:20 PM",
//         "id": 76
//       }
//     ]
//   },
//   {
//     "id": "55-I-2-388",
//     "routeNo": "55-I",
//     "code": "55/P55I-3",
//     "tripCode": "55/P55I-355-ITORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "OTTAPIDARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:25 PM",
//     "endTime": "02:10 PM",
//     "ids": [
//       76,
//       75,
//       280,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "OTTAPIDARAM",
//         "time": "12:25 PM",
//         "id": 76
//       },
//       {
//         "no": 13,
//         "name": "MUPPULIPATI",
//         "time": "12:30 PM",
//         "id": 75
//       },
//       {
//         "no": 12,
//         "name": "ST. ANN'S HOSPITAL",
//         "time": "12:43 PM",
//         "id": 280
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "12:47 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "12:56 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "01:09 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "01:21 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "01:30 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "01:38 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "01:49 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "01:51 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:00 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:04 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-I-3-389",
//     "routeNo": "55-I",
//     "code": "55/P55I-2",
//     "tripCode": "55/P55I-255-ITORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NORTH SILUKKANPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:15 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       297,
//       235,
//       298,
//       237,
//       238
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:20 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:24 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:33 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "02:38 PM",
//         "id": 297
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "02:44 PM",
//         "id": 235
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "02:51 PM",
//         "id": 298
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "02:53 PM",
//         "id": 237
//       },
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "02:55 PM",
//         "id": 238
//       }
//     ]
//   },
//   {
//     "id": "55-I-4-390",
//     "routeNo": "55-I",
//     "code": "55/P55I-2",
//     "tripCode": "55/P55I-255-ITORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "NORTH SILUKKANPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "03:45 PM",
//     "ids": [
//       238,
//       237,
//       298,
//       235,
//       297,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "03:00 PM",
//         "id": 238
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "03:02 PM",
//         "id": 237
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "03:03 PM",
//         "id": 298
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "03:12 PM",
//         "id": 235
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "03:18 PM",
//         "id": 297
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:24 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:34 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:38 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-I-5-391",
//     "routeNo": "55-I",
//     "code": "55/P55I-1",
//     "tripCode": "55/P55I-155-ITORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA MANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:10 PM",
//     "endTime": "05:40 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       228,
//       229,
//       230,
//       231,
//       232,
//       85,
//       106,
//       110,
//       108,
//       233,
//       234
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "04:13 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "04:15 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "04:20 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "04:22 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "04:28 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "04:33 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "04:39 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "04:46 PM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "04:54 PM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:59 PM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "PUDHUPACCHERI COLONY",
//         "time": "05:07 PM",
//         "id": 228
//       },
//       {
//         "no": 13,
//         "name": "PUDHUPACCHERI",
//         "time": "05:09 PM",
//         "id": 229
//       },
//       {
//         "no": 14,
//         "name": "SIVALKULAM",
//         "time": "05:11 PM",
//         "id": 230
//       },
//       {
//         "no": 15,
//         "name": "PACCHAIPERUMALPURAM",
//         "time": "05:14 PM",
//         "id": 231
//       },
//       {
//         "no": 16,
//         "name": "SANKARARAJAPURAM",
//         "time": "05:15 PM",
//         "id": 232
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "05:18 PM",
//         "id": 85
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "05:21 PM",
//         "id": 106
//       },
//       {
//         "no": 19,
//         "name": "THERKKU ARAIKULAM",
//         "time": "05:27 PM",
//         "id": 110
//       },
//       {
//         "no": 20,
//         "name": "NORTH AARAIKULAM",
//         "time": "05:30 PM",
//         "id": 108
//       },
//       {
//         "no": 21,
//         "name": "KUPPANAPURAM",
//         "time": "05:33 PM",
//         "id": 233
//       },
//       {
//         "no": 22,
//         "name": "KEELA MANGALM",
//         "time": "05:40 PM",
//         "id": 234
//       }
//     ]
//   },
//   {
//     "id": "55-I-6-392",
//     "routeNo": "55-I",
//     "code": "55/P55I-1",
//     "tripCode": "55/P55I-155-ITORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KEELA MANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:55 PM",
//     "endTime": "07:25 PM",
//     "ids": [
//       234,
//       233,
//       108,
//       110,
//       106,
//       85,
//       232,
//       231,
//       230,
//       229,
//       228,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 22,
//         "name": "KEELA MANGALM",
//         "time": "05:55 PM",
//         "id": 234
//       },
//       {
//         "no": 21,
//         "name": "KUPPANAPURAM",
//         "time": "06:01 PM",
//         "id": 233
//       },
//       {
//         "no": 20,
//         "name": "NORTH AARAIKULAM",
//         "time": "06:04 PM",
//         "id": 108
//       },
//       {
//         "no": 19,
//         "name": "THERKKU ARAIKULAM",
//         "time": "06:07 PM",
//         "id": 110
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "06:13 PM",
//         "id": 106
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "06:16 PM",
//         "id": 85
//       },
//       {
//         "no": 16,
//         "name": "SANKARARAJAPURAM",
//         "time": "06:19 PM",
//         "id": 232
//       },
//       {
//         "no": 15,
//         "name": "PACCHAIPERUMALPURAM",
//         "time": "06:20 PM",
//         "id": 231
//       },
//       {
//         "no": 14,
//         "name": "SIVALKULAM",
//         "time": "06:23 PM",
//         "id": 230
//       },
//       {
//         "no": 13,
//         "name": "PUDHUPACCHERI",
//         "time": "06:25 PM",
//         "id": 229
//       },
//       {
//         "no": 12,
//         "name": "PUDHUPACCHERI COLONY",
//         "time": "06:27 PM",
//         "id": 228
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "06:35 PM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "06:40 PM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "06:48 PM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "06:55 PM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "07:01 PM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:06 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "07:12 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "07:14 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "07:19 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:21 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-I-7-393",
//     "routeNo": "55-I",
//     "code": "55/P55I-1",
//     "tripCode": "55/P55I-155-ITORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KEELA MANGALAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:40 PM",
//     "endTime": "07:40 AM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       70,
//       71,
//       72,
//       73,
//       74,
//       228,
//       229,
//       230,
//       231,
//       232,
//       85,
//       106,
//       110,
//       108,
//       233,
//       234
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:05 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:25 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:07 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:20 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "10:10 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "10:48 PM",
//         "id": 70
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "11:34 PM",
//         "id": 71
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "12:31 AM",
//         "id": 72
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "01:32 AM",
//         "id": 73
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "02:15 AM",
//         "id": 74
//       },
//       {
//         "no": 12,
//         "name": "PUDHUPACCHERI COLONY",
//         "time": "03:22 AM",
//         "id": 228
//       },
//       {
//         "no": 13,
//         "name": "PUDHUPACCHERI",
//         "time": "03:39 AM",
//         "id": 229
//       },
//       {
//         "no": 14,
//         "name": "SIVALKULAM",
//         "time": "03:53 AM",
//         "id": 230
//       },
//       {
//         "no": 15,
//         "name": "PACCHAIPERUMALPURAM",
//         "time": "04:12 AM",
//         "id": 231
//       },
//       {
//         "no": 16,
//         "name": "SANKARARAJAPURAM",
//         "time": "04:27 AM",
//         "id": 232
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "04:50 AM",
//         "id": 85
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "05:11 AM",
//         "id": 106
//       },
//       {
//         "no": 19,
//         "name": "THERKKU ARAIKULAM",
//         "time": "05:59 AM",
//         "id": 110
//       },
//       {
//         "no": 20,
//         "name": "NORTH AARAIKULAM",
//         "time": "06:20 AM",
//         "id": 108
//       },
//       {
//         "no": 21,
//         "name": "KUPPANAPURAM",
//         "time": "06:45 AM",
//         "id": 233
//       },
//       {
//         "no": 22,
//         "name": "KEELA MANGALM",
//         "time": "07:40 AM",
//         "id": 234
//       }
//     ]
//   },
//   {
//     "id": "55-I-8-394",
//     "routeNo": "55-I",
//     "code": "55/P55I-1",
//     "tripCode": "55/P55I-155-ITORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "KEELA MANGALAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:55 AM",
//     "endTime": "09:20 AM",
//     "ids": [
//       234,
//       233,
//       108,
//       110,
//       106,
//       85,
//       232,
//       231,
//       230,
//       229,
//       228,
//       74,
//       73,
//       72,
//       71,
//       70,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 22,
//         "name": "KEELA MANGALM",
//         "time": "07:55 AM",
//         "id": 234
//       },
//       {
//         "no": 21,
//         "name": "KUPPANAPURAM",
//         "time": "08:01 AM",
//         "id": 233
//       },
//       {
//         "no": 20,
//         "name": "NORTH AARAIKULAM",
//         "time": "08:04 AM",
//         "id": 108
//       },
//       {
//         "no": 19,
//         "name": "THERKKU ARAIKULAM",
//         "time": "08:06 AM",
//         "id": 110
//       },
//       {
//         "no": 18,
//         "name": "KULASEKARANALLOOR",
//         "time": "08:12 AM",
//         "id": 106
//       },
//       {
//         "no": 17,
//         "name": "OSANOOTTHU",
//         "time": "08:15 AM",
//         "id": 85
//       },
//       {
//         "no": 16,
//         "name": "SANKARARAJAPURAM",
//         "time": "08:17 AM",
//         "id": 232
//       },
//       {
//         "no": 15,
//         "name": "PACCHAIPERUMALPURAM",
//         "time": "08:19 AM",
//         "id": 231
//       },
//       {
//         "no": 14,
//         "name": "SIVALKULAM",
//         "time": "08:21 AM",
//         "id": 230
//       },
//       {
//         "no": 13,
//         "name": "PUDHUPACCHERI",
//         "time": "08:23 AM",
//         "id": 229
//       },
//       {
//         "no": 12,
//         "name": "PUDHUPACCHERI COLONY",
//         "time": "08:25 AM",
//         "id": 228
//       },
//       {
//         "no": 11,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:33 AM",
//         "id": 74
//       },
//       {
//         "no": 10,
//         "name": "RAJAVIN KOVIL",
//         "time": "08:38 AM",
//         "id": 73
//       },
//       {
//         "no": 9,
//         "name": "CHILLANATTHAM",
//         "time": "08:45 AM",
//         "id": 72
//       },
//       {
//         "no": 8,
//         "name": "NAINAR PURAM",
//         "time": "08:52 AM",
//         "id": 71
//       },
//       {
//         "no": 7,
//         "name": "VELAYUTHAPURAM",
//         "time": "08:57 AM",
//         "id": 70
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "09:02 AM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "09:08 AM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "09:09 AM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "09:14 AM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "09:16 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-I-9-395",
//     "routeNo": "55-I",
//     "code": "55/P55I-4",
//     "tripCode": "55/P55I-455-ITORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "THALAIVANVADALI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:25 AM",
//     "endTime": "10:55 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       127,
//       157,
//       49,
//       50,
//       51,
//       172,
//       129,
//       130,
//       239
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:25 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:30 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:37 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:49 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:50 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:55 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "10:04 AM",
//         "id": 127
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "10:10 AM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "10:19 AM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "10:28 AM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "10:35 AM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "10:39 AM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "10:42 AM",
//         "id": 129
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "10:49 AM",
//         "id": 130
//       },
//       {
//         "no": 16,
//         "name": "THALAIVANVADALI",
//         "time": "10:55 AM",
//         "id": 239
//       }
//     ]
//   },
//   {
//     "id": "55-I-10-396",
//     "routeNo": "55-I",
//     "code": "55/P55I-4",
//     "tripCode": "55/P55I-455-ITORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "THALAIVANVADALI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:30 AM",
//     "endTime": "11:35 AM",
//     "ids": [
//       239,
//       130,
//       129,
//       172,
//       51,
//       50,
//       49,
//       157,
//       127,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "THALAIVANVADALI",
//         "time": "11:30 AM",
//         "id": 239
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "11:30 AM",
//         "id": 130
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "11:30 AM",
//         "id": 129
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "11:30 AM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "11:31 AM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "11:31 AM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "11:31 AM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "11:32 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "11:32 AM",
//         "id": 127
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "11:33 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "11:33 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "11:33 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "11:34 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "11:34 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "11:34 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:35 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-1-397",
//     "routeNo": "55-J",
//     "code": "55/P55J-1",
//     "tripCode": "55/P55J-155-JTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "THOOTHUKUDI RAILWAY STATION",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 AM",
//     "endTime": "05:40 AM",
//     "ids": [
//       1,
//       240
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "THOOTHUKUDI RAILWAY STATION",
//         "time": "05:40 AM",
//         "id": 240
//       }
//     ]
//   },
//   {
//     "id": "55-J-2-398",
//     "routeNo": "55-J",
//     "code": "55/P55J-1",
//     "tripCode": "55/P55J-155-JTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "THOOTHUKUDI RAILWAY STATION",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 AM",
//     "endTime": "05:50 AM",
//     "ids": [
//       240,
//       1
//     ],
//     "stops": [
//       {
//         "no": 2,
//         "name": "THOOTHUKUDI RAILWAY STATION",
//         "time": "05:45 AM",
//         "id": 240
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-3-399",
//     "routeNo": "55-J",
//     "code": "55/P55J-2",
//     "tripCode": "55/P55J-255-JTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MULLAKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:55 AM",
//     "endTime": "06:10 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:55 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:55 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "05:57 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:01 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:06 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:07 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:10 AM",
//         "id": 46
//       }
//     ]
//   },
//   {
//     "id": "55-J-4-400",
//     "routeNo": "55-J",
//     "code": "55/P55J-2",
//     "tripCode": "55/P55J-255-JTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "MULLAKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 AM",
//     "endTime": "06:30 AM",
//     "ids": [
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "06:15 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:17 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:18 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:23 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:27 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:29 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-5-401",
//     "routeNo": "55-J",
//     "code": "55/P55J-3",
//     "tripCode": "55/P55J-355-JTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "POTTALKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:35 AM",
//     "endTime": "07:10 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       163
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:35 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:40 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:47 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:58 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:59 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:04 AM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "07:10 AM",
//         "id": 163
//       }
//     ]
//   },
//   {
//     "id": "55-J-6-402",
//     "routeNo": "55-J",
//     "code": "55/P55J-3",
//     "tripCode": "55/P55J-355-JTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "POTTALKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 AM",
//     "endTime": "08:10 AM",
//     "ids": [
//       163,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 8,
//         "name": "POTTALKADU",
//         "time": "07:15 AM",
//         "id": 163
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:24 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:31 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:33 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:50 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:01 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:08 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-7-403",
//     "routeNo": "55-J",
//     "code": "55/P55J-4",
//     "tripCode": "55/P55J-455-JTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ATTHIMARAPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 AM",
//     "endTime": "08:45 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       176,
//       177
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:15 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:20 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:27 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:37 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "08:38 AM",
//         "id": 176
//       },
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "08:45 AM",
//         "id": 177
//       }
//     ]
//   },
//   {
//     "id": "55-J-8-404",
//     "routeNo": "55-J",
//     "code": "55/P55J-4",
//     "tripCode": "55/P55J-455-JTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "ATTHIMARAPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:50 AM",
//     "endTime": "09:25 AM",
//     "ids": [
//       177,
//       176,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 7,
//         "name": "ATTHIMARAPATTI",
//         "time": "08:50 AM",
//         "id": 177
//       },
//       {
//         "no": 6,
//         "name": "ATTHIMARAPATTI JUNCTION",
//         "time": "08:57 AM",
//         "id": 176
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:58 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:10 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:18 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:24 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-9-405",
//     "routeNo": "55-J",
//     "code": "55/P55J-2",
//     "tripCode": "55/P55J-255-JTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MULLAKADU",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "10:00 AM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "09:35 AM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "09:39 AM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "09:45 AM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "09:54 AM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "09:55 AM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:00 AM",
//         "id": 46
//       }
//     ]
//   },
//   {
//     "id": "55-J-10-406",
//     "routeNo": "55-J",
//     "code": "55/P55J-2",
//     "tripCode": "55/P55J-255-JTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "MULLAKADU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:05 AM",
//     "endTime": "10:30 AM",
//     "ids": [
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "10:05 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "10:09 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "10:10 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "10:19 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "10:25 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "10:29 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-11-407",
//     "routeNo": "55-J",
//     "code": "55/P55J-5",
//     "tripCode": "55/P55J-555-JTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KULATTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:40 AM",
//     "endTime": "11:55 AM",
//     "ids": [
//       26,
//       282,
//       1,
//       63,
//       64,
//       111,
//       112,
//       299,
//       144,
//       300,
//       145,
//       135,
//       136,
//       287,
//       301,
//       138,
//       139,
//       118,
//       132,
//       140,
//       302
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "10:40 AM",
//         "id": 26
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "10:43 AM",
//         "id": 282
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:47 AM",
//         "id": 1
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "10:53 AM",
//         "id": 63
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "10:55 AM",
//         "id": 64
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "10:56 AM",
//         "id": 111
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "11:02 AM",
//         "id": 112
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 3",
//         "time": "11:05 AM",
//         "id": 299
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "11:12 AM",
//         "id": 144
//       },
//       {
//         "no": 10,
//         "name": "ARASADI 2",
//         "time": "11:14 AM",
//         "id": 300
//       },
//       {
//         "no": 11,
//         "name": "KUMARAPURAM 1",
//         "time": "11:20 AM",
//         "id": 145
//       },
//       {
//         "no": 12,
//         "name": "AM PATTI JUNCTION",
//         "time": "11:22 AM",
//         "id": 135
//       },
//       {
//         "no": 13,
//         "name": "MELA MARUTHUR",
//         "time": "11:25 AM",
//         "id": 136
//       },
//       {
//         "no": 14,
//         "name": "ZAKKAMMALPURAM 4",
//         "time": "11:30 AM",
//         "id": 287
//       },
//       {
//         "no": 15,
//         "name": "DURAISAMYPURAM 2",
//         "time": "11:33 AM",
//         "id": 301
//       },
//       {
//         "no": 16,
//         "name": "SOUTH KALMEDU",
//         "time": "11:38 AM",
//         "id": 138
//       },
//       {
//         "no": 17,
//         "name": "NORTH KALMEDU",
//         "time": "11:39 AM",
//         "id": 139
//       },
//       {
//         "no": 18,
//         "name": "VEPPALODAI",
//         "time": "11:43 AM",
//         "id": 118
//       },
//       {
//         "no": 19,
//         "name": "PANAIYOOR GATE",
//         "time": "11:48 AM",
//         "id": 132
//       },
//       {
//         "no": 20,
//         "name": "PANAIYOOR",
//         "time": "11:52 AM",
//         "id": 140
//       },
//       {
//         "no": 21,
//         "name": "KULATTHOOR 2",
//         "time": "11:55 AM",
//         "id": 302
//       }
//     ]
//   },
//   {
//     "id": "55-J-12-408",
//     "routeNo": "55-J",
//     "code": "55/P55J-5",
//     "tripCode": "55/P55J-555-JTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "KULATTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:05 PM",
//     "endTime": "01:20 PM",
//     "ids": [
//       302,
//       140,
//       132,
//       118,
//       139,
//       138,
//       301,
//       287,
//       136,
//       135,
//       145,
//       300,
//       144,
//       299,
//       112,
//       111,
//       64,
//       63,
//       1,
//       282,
//       26
//     ],
//     "stops": [
//       {
//         "no": 21,
//         "name": "KULATTHOOR 2",
//         "time": "12:05 PM",
//         "id": 302
//       },
//       {
//         "no": 20,
//         "name": "PANAIYOOR",
//         "time": "12:07 PM",
//         "id": 140
//       },
//       {
//         "no": 19,
//         "name": "PANAIYOOR GATE",
//         "time": "12:11 PM",
//         "id": 132
//       },
//       {
//         "no": 18,
//         "name": "VEPPALODAI",
//         "time": "12:16 PM",
//         "id": 118
//       },
//       {
//         "no": 17,
//         "name": "NORTH KALMEDU",
//         "time": "12:20 PM",
//         "id": 139
//       },
//       {
//         "no": 16,
//         "name": "SOUTH KALMEDU",
//         "time": "12:21 PM",
//         "id": 138
//       },
//       {
//         "no": 15,
//         "name": "DURAISAMYPURAM 2",
//         "time": "12:26 PM",
//         "id": 301
//       },
//       {
//         "no": 14,
//         "name": "ZAKKAMMALPURAM 4",
//         "time": "12:29 PM",
//         "id": 287
//       },
//       {
//         "no": 13,
//         "name": "MELA MARUTHUR",
//         "time": "12:34 PM",
//         "id": 136
//       },
//       {
//         "no": 12,
//         "name": "AM PATTI JUNCTION",
//         "time": "12:37 PM",
//         "id": 135
//       },
//       {
//         "no": 11,
//         "name": "KUMARAPURAM 1",
//         "time": "12:39 PM",
//         "id": 145
//       },
//       {
//         "no": 10,
//         "name": "ARASADI 2",
//         "time": "12:45 PM",
//         "id": 300
//       },
//       {
//         "no": 9,
//         "name": "KEELA ARASADI",
//         "time": "12:47 PM",
//         "id": 144
//       },
//       {
//         "no": 8,
//         "name": "ARASADI JUNCTION 3",
//         "time": "12:54 PM",
//         "id": 299
//       },
//       {
//         "no": 7,
//         "name": "AYYANAR PURAM",
//         "time": "12:57 PM",
//         "id": 112
//       },
//       {
//         "no": 6,
//         "name": "THOMAS NAGAR",
//         "time": "01:03 PM",
//         "id": 111
//       },
//       {
//         "no": 5,
//         "name": "SAVARAIYARPURAM",
//         "time": "01:04 PM",
//         "id": 64
//       },
//       {
//         "no": 4,
//         "name": "AROCKIAPURAM",
//         "time": "01:06 PM",
//         "id": 63
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:12 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "AMERICAN HOSPITAL 2",
//         "time": "01:16 PM",
//         "id": 282
//       },
//       {
//         "no": 1,
//         "name": "4TH GATE 1",
//         "time": "01:20 PM",
//         "id": 26
//       }
//     ]
//   },
//   {
//     "id": "55-J-13-409",
//     "routeNo": "55-J",
//     "code": "55/P55J-8",
//     "tripCode": "55/P55J-855-JTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KURUMBUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:30 PM",
//     "endTime": "03:40 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       127,
//       157,
//       49,
//       50,
//       51,
//       172,
//       129,
//       130,
//       131,
//       56
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "02:30 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "02:34 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "02:39 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:47 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:48 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:52 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "02:59 PM",
//         "id": 127
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "03:03 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "03:09 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "03:16 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "03:21 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "03:24 PM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "03:26 PM",
//         "id": 129
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "03:31 PM",
//         "id": 130
//       },
//       {
//         "no": 16,
//         "name": "MICHEAL NADAR KUDIYIRUPPU",
//         "time": "03:36 PM",
//         "id": 131
//       },
//       {
//         "no": 17,
//         "name": "KURUMBUR",
//         "time": "03:40 PM",
//         "id": 56
//       }
//     ]
//   },
//   {
//     "id": "55-J-14-410",
//     "routeNo": "55-J",
//     "code": "55/P55J-8",
//     "tripCode": "55/P55J-855-JTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "KURUMBUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:45 PM",
//     "endTime": "05:00 PM",
//     "ids": [
//       56,
//       131,
//       130,
//       129,
//       172,
//       51,
//       50,
//       49,
//       157,
//       127,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "KURUMBUR",
//         "time": "03:45 PM",
//         "id": 56
//       },
//       {
//         "no": 16,
//         "name": "MICHEAL NADAR KUDIYIRUPPU",
//         "time": "03:48 PM",
//         "id": 131
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "03:54 PM",
//         "id": 130
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "03:59 PM",
//         "id": 129
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "04:01 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "04:05 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "04:10 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "04:17 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "04:24 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "04:28 PM",
//         "id": 127
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "04:35 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "04:39 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "04:40 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:49 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:55 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "04:59 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-15-411",
//     "routeNo": "55-J",
//     "code": "55/P55J-7",
//     "tripCode": "55/P55J-755-JTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:20 PM",
//     "endTime": "06:05 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       180,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:27 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "05:35 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "05:44 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "05:50 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "05:53 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP JUNCTION",
//         "time": "05:53 PM",
//         "id": 180
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:02 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "06:05 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "55-J-16-412",
//     "routeNo": "55-J",
//     "code": "55/P55J-7",
//     "tripCode": "55/P55J-755-JTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:10 PM",
//     "endTime": "06:50 PM",
//     "ids": [
//       183,
//       182,
//       180,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "06:10 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:12 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP JUNCTION",
//         "time": "06:19 PM",
//         "id": 180
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:19 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:23 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:27 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "06:36 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "06:42 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-17-413",
//     "routeNo": "55-J",
//     "code": "55/P55J-6",
//     "tripCode": "55/P55J-655-JTORD18U17",
//     "order": 17,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "AUTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 PM",
//     "endTime": "07:45 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "07:00 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "07:03 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "07:07 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:14 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "07:15 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:18 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "07:24 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:27 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "07:32 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "07:38 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "07:42 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "07:45 PM",
//         "id": 172
//       }
//     ]
//   },
//   {
//     "id": "55-J-18-414",
//     "routeNo": "55-J",
//     "code": "55/P55J-6",
//     "tripCode": "55/P55J-655-JTORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "AUTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 PM",
//     "endTime": "08:35 PM",
//     "ids": [
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "07:50 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "07:52 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "07:56 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "08:02 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "08:07 PM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "08:10 PM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "08:16 PM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:19 PM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:20 PM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:27 PM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:31 PM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:34 PM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "55-J-19-415",
//     "routeNo": "55-J",
//     "code": "55/P55J-6",
//     "tripCode": "55/P55J-655-JTORD18U19",
//     "order": 19,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "AUTHOOR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:40 PM",
//     "endTime": "09:35 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       47,
//       157,
//       49,
//       50,
//       51,
//       172
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "08:40 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "08:44 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "08:49 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "08:58 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "08:58 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "09:02 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "09:10 PM",
//         "id": 47
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "09:13 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "09:19 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "09:26 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "09:31 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "09:35 PM",
//         "id": 172
//       }
//     ]
//   },
//   {
//     "id": "55-J-20-416",
//     "routeNo": "55-J",
//     "code": "55/P55J-6",
//     "tripCode": "55/P55J-655-JTORD18D20",
//     "order": 20,
//     "direction": "D",
//     "from": "AUTHOOR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 PM",
//     "endTime": "05:20 AM",
//     "ids": [
//       172,
//       51,
//       50,
//       49,
//       157,
//       47,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "09:40 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "10:09 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "10:50 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "11:48 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:39 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "MADHIKETTAN ODAI",
//         "time": "01:06 AM",
//         "id": 47
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:10 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:41 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:48 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:00 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:45 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:15 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-A-1-417",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:50 PM",
//     "endTime": "03:00 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "01:54 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:58 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:05 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:08 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:15 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:20 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "02:25 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "02:25 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "02:33 PM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "02:39 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "02:41 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "02:47 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "02:53 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "02:57 PM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "03:00 PM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-A-2-418",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:05 PM",
//     "endTime": "04:25 PM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "03:05 PM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "03:08 PM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "03:12 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "03:19 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "03:26 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "03:28 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "03:35 PM",
//         "id": 249
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "03:44 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "03:44 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:50 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:55 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:04 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:06 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:15 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "04:19 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-A-3-419",
//     "routeNo": "56-A",
//     "code": "56/P56A-2",
//     "tripCode": "56/P56A-256-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:30 PM",
//     "endTime": "05:40 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       23,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "04:34 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:37 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:44 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:46 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:53 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:57 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "05:02 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "05:02 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "05:12 PM",
//         "id": 23
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "05:16 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "05:18 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "05:24 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "05:29 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "05:33 PM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "05:35 PM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "05:40 PM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-A-4-420",
//     "routeNo": "56-A",
//     "code": "56/P56A-2",
//     "tripCode": "56/P56A-256-ATORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 PM",
//     "endTime": "07:05 PM",
//     "ids": [
//       247,
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "05:45 PM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "05:49 PM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "05:52 PM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "05:56 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "06:02 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "06:09 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "06:11 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "06:16 PM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "06:27 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:27 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:33 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:37 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:46 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:48 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:56 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "07:00 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-A-5-421",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 PM",
//     "endTime": "08:20 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "07:14 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:18 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:25 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:28 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:35 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:40 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:45 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "07:45 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "07:53 PM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "07:59 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "08:01 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "08:07 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "08:13 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "08:17 PM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "08:20 PM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-A-6-422",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:25 PM",
//     "endTime": "09:45 PM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "08:25 PM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "08:28 PM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "08:32 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "08:39 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "08:46 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "08:48 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "08:55 PM",
//         "id": 249
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "09:04 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:04 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:10 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:15 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:24 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:26 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:35 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:39 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-A-7-423",
//     "routeNo": "56-A",
//     "code": "56/P56A-3",
//     "tripCode": "56/P56A-356-ATORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 PM",
//     "endTime": "05:40 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       248,
//       22,
//       23,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "10:18 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:41 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:28 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:42 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:31 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:56 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:30 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "ALLIKULAM JUNCTION",
//         "time": "02:09 AM",
//         "id": 248
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "02:18 AM",
//         "id": 22
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "02:40 AM",
//         "id": 23
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "02:56 AM",
//         "id": 249
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "03:30 AM",
//         "id": 24
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "03:45 AM",
//         "id": 243
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "04:22 AM",
//         "id": 303
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "04:57 AM",
//         "id": 304
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "05:22 AM",
//         "id": 244
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "05:40 AM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-A-8-424",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 AM",
//     "endTime": "07:00 AM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "05:45 AM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "05:48 AM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "05:52 AM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "05:58 AM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "06:04 AM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "06:07 AM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "06:13 AM",
//         "id": 249
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "06:21 AM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:21 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:27 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:32 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:40 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:43 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:51 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:55 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-A-9-425",
//     "routeNo": "56-A",
//     "code": "56/P56A-2",
//     "tripCode": "56/P56A-256-ATORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:10 AM",
//     "endTime": "08:20 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       23,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "07:14 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:17 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:24 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:26 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:33 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:37 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:42 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "07:42 AM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "07:52 AM",
//         "id": 23
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "07:56 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "07:58 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "08:04 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "08:09 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "08:13 AM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "08:15 AM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "08:20 AM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-A-10-426",
//     "routeNo": "56-A",
//     "code": "56/P56A-4",
//     "tripCode": "56/P56A-456-ATORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:25 AM",
//     "endTime": "09:45 AM",
//     "ids": [
//       247,
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       23,
//       22,
//       248,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "08:25 AM",
//         "id": 247
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "08:29 AM",
//         "id": 245
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "08:32 AM",
//         "id": 244
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "08:36 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "08:41 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "08:47 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "08:50 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "08:55 AM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "08:58 AM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "09:01 AM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "ALLIKULAM JUNCTION",
//         "time": "09:03 AM",
//         "id": 248
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:09 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:15 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:19 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:26 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:29 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:36 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:40 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-A-11-427",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 AM",
//     "endTime": "11:00 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:54 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:58 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:05 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:08 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:15 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:20 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "10:25 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "10:25 AM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "10:33 AM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "10:39 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "10:41 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "10:47 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "10:53 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "10:57 AM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "11:00 AM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-A-12-428",
//     "routeNo": "56-A",
//     "code": "56/P56A-1",
//     "tripCode": "56/P56A-156-ATORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:05 AM",
//     "endTime": "01:45 PM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "11:05 AM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "11:11 AM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "11:20 AM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "11:33 AM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "11:47 AM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "11:52 AM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "12:05 PM",
//         "id": 249
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "12:23 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "12:23 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:36 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:45 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:03 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:08 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:26 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "01:34 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-B-1-429",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 AM",
//     "endTime": "07:00 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       22,
//       23,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:49 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:53 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:00 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:03 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:10 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:15 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:20 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "06:20 AM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "06:27 AM",
//         "id": 22
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "06:31 AM",
//         "id": 23
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "06:33 AM",
//         "id": 249
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "06:39 AM",
//         "id": 24
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "06:41 AM",
//         "id": 243
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "06:47 AM",
//         "id": 303
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "06:53 AM",
//         "id": 304
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "06:57 AM",
//         "id": 244
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "07:00 AM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-B-2-430",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:05 AM",
//     "endTime": "08:30 AM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       23,
//       22,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "07:05 AM",
//         "id": 245
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "07:08 AM",
//         "id": 244
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "07:12 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "07:19 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "07:25 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "07:28 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "07:34 AM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "07:37 AM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "07:41 AM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "07:49 AM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:49 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:55 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:00 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:09 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:12 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:20 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:24 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-B-3-431",
//     "routeNo": "56-B",
//     "code": "56/P56B-3",
//     "tripCode": "56/P56B-356-BTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:35 AM",
//     "endTime": "10:10 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       253,
//       254,
//       196,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:40 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:44 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:53 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:56 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:05 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:10 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:15 AM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "09:21 AM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "09:34 AM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "09:41 AM",
//         "id": 252
//       },
//       {
//         "no": 14,
//         "name": "CHETTIYOORANI",
//         "time": "09:48 AM",
//         "id": 253
//       },
//       {
//         "no": 15,
//         "name": "CAMP THATTAPARAI",
//         "time": "09:53 AM",
//         "id": 254
//       },
//       {
//         "no": 17,
//         "name": "VALLINAYAGIPURAM",
//         "time": "10:06 AM",
//         "id": 196
//       },
//       {
//         "no": 18,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:10 AM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "56-B-4-432",
//     "routeNo": "56-B",
//     "code": "56/P56B-3",
//     "tripCode": "56/P56B-356-BTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:15 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       74,
//       196,
//       254,
//       253,
//       252,
//       251,
//       250,
//       6,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "10:15 AM",
//         "id": 74
//       },
//       {
//         "no": 17,
//         "name": "VALLINAYAGIPURAM",
//         "time": "10:18 AM",
//         "id": 196
//       },
//       {
//         "no": 15,
//         "name": "CAMP THATTAPARAI",
//         "time": "10:33 AM",
//         "id": 254
//       },
//       {
//         "no": 14,
//         "name": "CHETTIYOORANI",
//         "time": "10:38 AM",
//         "id": 253
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "10:46 AM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "10:54 AM",
//         "id": 251
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "11:08 AM",
//         "id": 250
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:15 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:20 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:26 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:36 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:39 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:49 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:53 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-B-5-433",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:05 PM",
//     "endTime": "01:20 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       22,
//       23,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "12:09 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:13 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:20 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:23 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:30 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:35 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "12:40 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "12:40 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "12:47 PM",
//         "id": 22
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "12:51 PM",
//         "id": 23
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "12:53 PM",
//         "id": 249
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "12:59 PM",
//         "id": 24
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "01:01 PM",
//         "id": 243
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "01:07 PM",
//         "id": 303
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "01:13 PM",
//         "id": 304
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "01:17 PM",
//         "id": 244
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "01:20 PM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-B-6-434",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:25 PM",
//     "endTime": "02:40 PM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       23,
//       22,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "01:25 PM",
//         "id": 245
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "01:27 PM",
//         "id": 244
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "01:31 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "01:37 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "01:43 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "01:45 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "01:51 PM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "01:53 PM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "01:57 PM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "02:04 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "02:04 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:09 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:14 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:21 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:24 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:31 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "02:35 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-B-7-435",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:45 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       22,
//       23,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "02:49 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:53 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:00 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:03 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:10 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:15 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "03:20 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "03:20 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "03:27 PM",
//         "id": 22
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "03:31 PM",
//         "id": 23
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "03:33 PM",
//         "id": 249
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "03:39 PM",
//         "id": 24
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "03:41 PM",
//         "id": 243
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "03:47 PM",
//         "id": 303
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "03:53 PM",
//         "id": 304
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "03:57 PM",
//         "id": 244
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "04:00 PM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-B-8-436",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:05 PM",
//     "endTime": "05:30 PM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       23,
//       22,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "04:05 PM",
//         "id": 245
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "04:08 PM",
//         "id": 244
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "04:12 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "04:19 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "04:25 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "04:28 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "04:34 PM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "04:37 PM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "04:41 PM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "04:49 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "04:49 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:55 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:00 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:09 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:12 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:20 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:24 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-B-9-437",
//     "routeNo": "56-B",
//     "code": "56/P56B-2",
//     "tripCode": "56/P56B-256-BTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "VELLARAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:35 PM",
//     "endTime": "06:50 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       67,
//       68,
//       69,
//       97,
//       143,
//       99,
//       281,
//       100,
//       191,
//       192,
//       193,
//       194
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "05:38 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "05:40 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "05:45 PM",
//         "id": 67
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "05:46 PM",
//         "id": 68
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "05:52 PM",
//         "id": 69
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "05:55 PM",
//         "id": 97
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "05:59 PM",
//         "id": 143
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "06:12 PM",
//         "id": 99
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "06:18 PM",
//         "id": 281
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "06:22 PM",
//         "id": 100
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "06:28 PM",
//         "id": 191
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "06:34 PM",
//         "id": 192
//       },
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "06:42 PM",
//         "id": 193
//       },
//       {
//         "no": 15,
//         "name": "VELLARAM",
//         "time": "06:50 PM",
//         "id": 194
//       }
//     ]
//   },
//   {
//     "id": "56-B-10-438",
//     "routeNo": "56-B",
//     "code": "56/P56B-2",
//     "tripCode": "56/P56B-256-BTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "VELLARAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:55 PM",
//     "endTime": "08:15 PM",
//     "ids": [
//       194,
//       193,
//       192,
//       191,
//       100,
//       281,
//       99,
//       143,
//       97,
//       69,
//       68,
//       67,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "VELLARAM",
//         "time": "06:55 PM",
//         "id": 194
//       },
//       {
//         "no": 14,
//         "name": "KACCHERI THALAVAIPURAM",
//         "time": "07:02 PM",
//         "id": 193
//       },
//       {
//         "no": 13,
//         "name": "VELLARAM JUNCTION",
//         "time": "07:11 PM",
//         "id": 192
//       },
//       {
//         "no": 12,
//         "name": "KUMARAPURAM JUNCTION",
//         "time": "07:17 PM",
//         "id": 191
//       },
//       {
//         "no": 11,
//         "name": "KURUKKUSALAI",
//         "time": "07:23 PM",
//         "id": 100
//       },
//       {
//         "no": 10,
//         "name": "SUBRAMANIYAPURAM 2",
//         "time": "07:28 PM",
//         "id": 281
//       },
//       {
//         "no": 9,
//         "name": "VALASAMUTHIRAM",
//         "time": "07:34 PM",
//         "id": 99
//       },
//       {
//         "no": 8,
//         "name": "ARASADI 1",
//         "time": "07:48 PM",
//         "id": 143
//       },
//       {
//         "no": 7,
//         "name": "THANNEER PANDHAL",
//         "time": "07:52 PM",
//         "id": 97
//       },
//       {
//         "no": 6,
//         "name": "ODAIPATTI PUDHUR",
//         "time": "07:56 PM",
//         "id": 69
//       },
//       {
//         "no": 5,
//         "name": "KALI KOVIL JUNCTION",
//         "time": "08:02 PM",
//         "id": 68
//       },
//       {
//         "no": 4,
//         "name": "MAPPILLAIYOORANI",
//         "time": "08:03 PM",
//         "id": 67
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "08:09 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:11 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-B-11-439",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:20 PM",
//     "endTime": "09:50 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       22,
//       23,
//       249,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:25 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:29 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:38 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:41 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:51 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:56 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:02 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "09:02 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "09:11 PM",
//         "id": 22
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "09:15 PM",
//         "id": 23
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "09:18 PM",
//         "id": 249
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "09:24 PM",
//         "id": 24
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "09:27 PM",
//         "id": 243
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "09:35 PM",
//         "id": 303
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "09:41 PM",
//         "id": 304
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "09:46 PM",
//         "id": 244
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "09:50 PM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-B-12-440",
//     "routeNo": "56-B",
//     "code": "56/P56B-1",
//     "tripCode": "56/P56B-156-BTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:55 PM",
//     "endTime": "05:40 AM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       23,
//       22,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "09:55 PM",
//         "id": 245
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "10:12 PM",
//         "id": 244
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "10:37 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "11:11 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "11:49 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "12:04 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "12:37 AM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "12:54 AM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "01:16 AM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "01:59 AM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:59 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:33 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:59 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:47 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:01 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:48 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:11 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-C-1-441",
//     "routeNo": "56-C",
//     "code": "56/P56C-1",
//     "tripCode": "56/P56C-156-CTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "04:35 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       256,
//       257,
//       258,
//       259,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "03:04 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:08 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:17 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:19 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:28 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:32 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "03:38 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "03:40 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "03:49 PM",
//         "id": 167
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "04:10 PM",
//         "id": 256
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "04:14 PM",
//         "id": 257
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "04:24 PM",
//         "id": 258
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "04:26 PM",
//         "id": 259
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "04:30 PM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "04:35 PM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-C-2-442",
//     "routeNo": "56-C",
//     "code": "56/P56C-1",
//     "tripCode": "56/P56C-156-CTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:40 PM",
//     "endTime": "06:15 PM",
//     "ids": [
//       247,
//       245,
//       259,
//       258,
//       257,
//       256,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "04:40 PM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "04:44 PM",
//         "id": 245
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "04:48 PM",
//         "id": 259
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "04:50 PM",
//         "id": 258
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "05:00 PM",
//         "id": 257
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "05:04 PM",
//         "id": 256
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "05:25 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "05:34 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "05:36 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:42 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:46 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:55 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:57 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:06 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:10 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-C-3-443",
//     "routeNo": "56-C",
//     "code": "56/P56C-2",
//     "tripCode": "56/P56C-256-CTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:20 PM",
//     "endTime": "07:40 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       23,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "06:24 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:28 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:36 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:38 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:47 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:51 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:57 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "06:57 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "07:08 PM",
//         "id": 23
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "07:13 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "07:15 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "07:22 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "07:28 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "07:32 PM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "07:35 PM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "07:40 PM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-C-4-444",
//     "routeNo": "56-C",
//     "code": "56/P56C-2",
//     "tripCode": "56/P56C-256-CTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:45 PM",
//     "endTime": "09:10 PM",
//     "ids": [
//       247,
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "07:45 PM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "07:50 PM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "07:53 PM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "07:57 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "08:03 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "08:10 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "08:13 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "08:18 PM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "08:30 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:30 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:36 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:41 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:49 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:52 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:00 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:04 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-C-5-445",
//     "routeNo": "56-C",
//     "code": "56/P56C-1",
//     "tripCode": "56/P56C-156-CTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 PM",
//     "endTime": "06:10 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       256,
//       257,
//       258,
//       259,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:43 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:05 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:51 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:05 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:52 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:17 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "12:51 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "01:01 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "01:56 AM",
//         "id": 167
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "03:52 AM",
//         "id": 256
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "04:14 AM",
//         "id": 257
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "05:11 AM",
//         "id": 258
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "05:21 AM",
//         "id": 259
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "05:42 AM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "06:10 AM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-C-6-446",
//     "routeNo": "56-C",
//     "code": "56/P56C-2",
//     "tripCode": "56/P56C-256-CTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 AM",
//     "endTime": "07:45 AM",
//     "ids": [
//       247,
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "06:15 AM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "06:20 AM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "06:23 AM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "06:28 AM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "06:35 AM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "06:42 AM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "06:44 AM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "06:50 AM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "07:03 AM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:03 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:09 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:14 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:23 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:26 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:35 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "07:39 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-C-7-447",
//     "routeNo": "56-C",
//     "code": "56/P56C-1",
//     "tripCode": "56/P56C-156-CTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 AM",
//     "endTime": "09:10 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       256,
//       257,
//       258,
//       259,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "07:54 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:57 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:04 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:06 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:13 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:17 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:22 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "08:23 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "08:32 AM",
//         "id": 167
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "08:49 AM",
//         "id": 256
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "08:52 AM",
//         "id": 257
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "09:01 AM",
//         "id": 258
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "09:02 AM",
//         "id": 259
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "09:05 AM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "09:10 AM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-C-8-448",
//     "routeNo": "56-C",
//     "code": "56/P56C-1",
//     "tripCode": "56/P56C-156-CTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 AM",
//     "endTime": "10:45 AM",
//     "ids": [
//       247,
//       245,
//       259,
//       258,
//       257,
//       256,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "09:15 AM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "09:19 AM",
//         "id": 245
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "09:23 AM",
//         "id": 259
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "09:24 AM",
//         "id": 258
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "09:34 AM",
//         "id": 257
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "09:38 AM",
//         "id": 256
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "09:57 AM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "10:06 AM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "10:08 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:14 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:18 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:26 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:28 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:36 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "10:40 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-C-9-449",
//     "routeNo": "56-C",
//     "code": "56/P56C-2",
//     "tripCode": "56/P56C-256-CTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:50 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       23,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "10:54 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:57 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:04 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:06 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:13 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:17 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "11:22 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "11:22 AM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "11:32 AM",
//         "id": 23
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "11:36 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "11:38 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "11:44 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "11:49 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "11:53 AM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "11:55 AM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "12:00 PM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-C-10-450",
//     "routeNo": "56-C",
//     "code": "56/P56C-2",
//     "tripCode": "56/P56C-256-CTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:05 PM",
//     "endTime": "03:15 PM",
//     "ids": [
//       247,
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "12:05 PM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "12:16 PM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "12:23 PM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "12:33 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "12:47 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "01:02 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "01:08 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "01:20 PM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "01:46 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:46 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:00 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:10 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:29 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:35 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:54 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "03:03 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-D-1-451",
//     "routeNo": "56-D",
//     "code": "56/P56D-1",
//     "tripCode": "56/P56D-156-DTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:10 PM",
//     "endTime": "03:30 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       256,
//       257,
//       258,
//       259,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "02:14 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:17 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:24 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:26 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:33 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:37 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "02:42 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "02:43 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "02:52 PM",
//         "id": 167
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "03:09 PM",
//         "id": 256
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "03:12 PM",
//         "id": 257
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "03:21 PM",
//         "id": 258
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "03:22 PM",
//         "id": 259
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "03:25 PM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "03:30 PM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-D-2-452",
//     "routeNo": "56-D",
//     "code": "56/P56D-1",
//     "tripCode": "56/P56D-156-DTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:45 PM",
//     "endTime": "05:05 PM",
//     "ids": [
//       247,
//       245,
//       259,
//       258,
//       257,
//       256,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "03:45 PM",
//         "id": 247
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "03:49 PM",
//         "id": 245
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "03:52 PM",
//         "id": 259
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "03:53 PM",
//         "id": 258
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "04:02 PM",
//         "id": 257
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "04:05 PM",
//         "id": 256
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "04:22 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "04:31 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "04:32 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:37 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:41 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:48 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:50 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:57 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:00 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-D-3-453",
//     "routeNo": "56-D",
//     "code": "56/P56D-2",
//     "tripCode": "56/P56D-256-DTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KALLAMPARAMBU",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:20 PM",
//     "endTime": "06:35 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       22,
//       23,
//       249,
//       24,
//       243,
//       303,
//       304,
//       260
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "05:24 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:28 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:36 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:39 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:47 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:51 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "05:57 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "05:57 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "06:04 PM",
//         "id": 22
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "06:08 PM",
//         "id": 23
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "06:11 PM",
//         "id": 249
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "06:16 PM",
//         "id": 24
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "06:19 PM",
//         "id": 243
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "06:25 PM",
//         "id": 303
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "06:31 PM",
//         "id": 304
//       },
//       {
//         "no": 17,
//         "name": "KALLAMPARAMBU",
//         "time": "06:35 PM",
//         "id": 260
//       }
//     ]
//   },
//   {
//     "id": "56-D-4-454",
//     "routeNo": "56-D",
//     "code": "56/P56D-3",
//     "tripCode": "56/P56D-356-DTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "KALLAMPARAMBU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:40 PM",
//     "endTime": "07:55 PM",
//     "ids": [
//       260,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "KALLAMPARAMBU",
//         "time": "06:40 PM",
//         "id": 260
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "06:43 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "06:49 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "06:56 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "06:58 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "07:04 PM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "07:15 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:16 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:22 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:26 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:35 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:37 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:45 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "07:49 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-D-5-455",
//     "routeNo": "56-D",
//     "code": "56/P56D-1",
//     "tripCode": "56/P56D-156-DTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MELA CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 PM",
//     "endTime": "07:15 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       256,
//       257,
//       258,
//       259,
//       245,
//       247
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:44 PM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:12 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:09 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:27 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:26 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:57 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "12:38 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "12:51 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "01:59 AM",
//         "id": 167
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "04:23 AM",
//         "id": 256
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "04:51 AM",
//         "id": 257
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "06:02 AM",
//         "id": 258
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "06:14 AM",
//         "id": 259
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "06:40 AM",
//         "id": 245
//       },
//       {
//         "no": 18,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "07:15 AM",
//         "id": 247
//       }
//     ]
//   },
//   {
//     "id": "56-D-6-456",
//     "routeNo": "56-D",
//     "code": "56/P56D-4",
//     "tripCode": "56/P56D-456-DTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "MELA CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:20 AM",
//     "endTime": "08:40 AM",
//     "ids": [
//       247,
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       249,
//       23,
//       22,
//       248,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "MELA CHEKKARAKUDI",
//         "time": "07:20 AM",
//         "id": 247
//       },
//       {
//         "no": 19,
//         "name": "CHEKKARAKUDI",
//         "time": "07:24 AM",
//         "id": 245
//       },
//       {
//         "no": 17,
//         "name": "MAHILAMPURAM",
//         "time": "07:27 AM",
//         "id": 244
//       },
//       {
//         "no": 16,
//         "name": "THALAVAIPURAM 2",
//         "time": "07:31 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "PUDHUR 2",
//         "time": "07:36 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "SAMATTHUVAPURAM",
//         "time": "07:42 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PEROORANI",
//         "time": "07:45 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "THIRUVANANDHA PURAM JUNCTION",
//         "time": "07:50 AM",
//         "id": 249
//       },
//       {
//         "no": 11,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "07:53 AM",
//         "id": 23
//       },
//       {
//         "no": 10,
//         "name": "ALLIKULAM",
//         "time": "07:56 AM",
//         "id": 22
//       },
//       {
//         "no": 9,
//         "name": "ALLIKULAM JUNCTION",
//         "time": "07:58 AM",
//         "id": 248
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:04 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:10 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:14 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:21 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:24 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:31 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:35 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-D-7-457",
//     "routeNo": "56-D",
//     "code": "56/P56D-5",
//     "tripCode": "56/P56D-556-DTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:55 AM",
//     "endTime": "10:05 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       256,
//       257,
//       258,
//       259,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:55 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "08:58 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:01 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:08 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:10 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:16 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:20 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:24 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "09:26 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "09:33 AM",
//         "id": 167
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "09:49 AM",
//         "id": 256
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "09:52 AM",
//         "id": 257
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "10:00 AM",
//         "id": 258
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "10:02 AM",
//         "id": 259
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "10:05 AM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "56-D-8-458",
//     "routeNo": "56-D",
//     "code": "56/P56D-5",
//     "tripCode": "56/P56D-556-DTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:10 AM",
//     "endTime": "11:20 AM",
//     "ids": [
//       245,
//       259,
//       258,
//       257,
//       256,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "10:10 AM",
//         "id": 245
//       },
//       {
//         "no": 16,
//         "name": "AZHAGAPURI",
//         "time": "10:12 AM",
//         "id": 259
//       },
//       {
//         "no": 15,
//         "name": "NATTHAM",
//         "time": "10:14 AM",
//         "id": 258
//       },
//       {
//         "no": 14,
//         "name": "POTTALOORANI VILLAGE",
//         "time": "10:22 AM",
//         "id": 257
//       },
//       {
//         "no": 13,
//         "name": "POTTALOORANI JUNCTION",
//         "time": "10:25 AM",
//         "id": 256
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "10:41 AM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "10:48 AM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "10:50 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "10:54 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:58 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:04 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:06 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:13 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "11:16 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:20 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-D-9-459",
//     "routeNo": "56-D",
//     "code": "56/P56D-3",
//     "tripCode": "56/P56D-356-DTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KALLAMPARAMBU",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:25 AM",
//     "endTime": "12:40 PM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       23,
//       24,
//       243,
//       303,
//       304,
//       260
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:25 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "11:30 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:34 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:42 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:44 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:53 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:57 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "12:03 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "12:04 PM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "12:15 PM",
//         "id": 23
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "12:21 PM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "12:23 PM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "12:30 PM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "12:36 PM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "KALLAMPARAMBU",
//         "time": "12:40 PM",
//         "id": 260
//       }
//     ]
//   },
//   {
//     "id": "56-D-10-460",
//     "routeNo": "56-D",
//     "code": "56/P56D-3",
//     "tripCode": "56/P56D-356-DTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KALLAMPARAMBU",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:45 PM",
//     "endTime": "01:55 PM",
//     "ids": [
//       260,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "KALLAMPARAMBU",
//         "time": "12:45 PM",
//         "id": 260
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "12:48 PM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "12:54 PM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "01:00 PM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "01:02 PM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "01:07 PM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "01:18 PM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:18 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:24 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:28 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:36 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:38 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:46 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "01:50 PM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-E-1-461",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:20 PM",
//     "endTime": "01:40 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       305,
//       255,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "12:25 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:30 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:39 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:42 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:52 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:57 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:04 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "01:08 PM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "01:10 PM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "01:22 PM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "01:25 PM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "01:35 PM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "01:40 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-E-2-462",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:45 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       305,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "01:45 PM",
//         "id": 24
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "01:48 PM",
//         "id": 262
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "01:58 PM",
//         "id": 261
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "02:00 PM",
//         "id": 167
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "02:10 PM",
//         "id": 255
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "02:12 PM",
//         "id": 305
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "02:16 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:22 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:26 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:35 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:37 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:46 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:49 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-E-3-463",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "04:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       305,
//       255,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:05 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:08 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:17 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:19 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:28 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:32 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "03:38 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "03:42 PM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "03:44 PM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "03:54 PM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "03:56 PM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "04:06 PM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "04:10 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-E-4-464",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:15 PM",
//     "endTime": "05:40 PM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       305,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "04:15 PM",
//         "id": 24
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "04:19 PM",
//         "id": 262
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "04:30 PM",
//         "id": 261
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "04:34 PM",
//         "id": 167
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "04:45 PM",
//         "id": 255
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "04:48 PM",
//         "id": 305
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "04:53 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:00 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:05 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:16 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:19 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:29 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:33 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-E-5-465",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 PM",
//     "endTime": "06:30 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       305,
//       255,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:48 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:50 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:56 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:57 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:03 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:06 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:09 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "06:12 PM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "06:13 PM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "06:19 PM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "06:21 PM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "06:27 PM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "06:30 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-E-6-466",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 PM",
//     "endTime": "07:50 PM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       305,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "06:50 PM",
//         "id": 24
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "06:53 PM",
//         "id": 262
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "07:01 PM",
//         "id": 261
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "07:03 PM",
//         "id": 167
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "07:11 PM",
//         "id": 255
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "07:13 PM",
//         "id": 305
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:16 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:21 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:25 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:33 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:35 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:42 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:45 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-E-7-467",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:00 PM",
//     "endTime": "09:05 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       305,
//       255,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:04 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:08 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:15 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:18 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:26 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:30 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:35 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "08:39 PM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "08:41 PM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "08:50 PM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "08:52 PM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "09:01 PM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "09:05 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-E-8-468",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 PM",
//     "endTime": "10:15 PM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       305,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "09:15 PM",
//         "id": 24
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "09:18 PM",
//         "id": 262
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "09:26 PM",
//         "id": 261
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "09:28 PM",
//         "id": 167
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "09:36 PM",
//         "id": 255
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "09:38 PM",
//         "id": 305
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:41 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:46 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:50 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:58 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:00 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:07 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:10 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-E-9-469",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 PM",
//     "endTime": "11:40 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       305,
//       255,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:35 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:38 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:47 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:49 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:58 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:02 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "11:08 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "11:12 PM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "11:14 PM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "11:24 PM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "11:26 PM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "11:36 PM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "11:40 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-E-10-470",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:25 AM",
//     "endTime": "07:30 AM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       305,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "06:25 AM",
//         "id": 24
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "06:28 AM",
//         "id": 262
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "06:37 AM",
//         "id": 261
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "06:39 AM",
//         "id": 167
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "06:48 AM",
//         "id": 255
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "06:50 AM",
//         "id": 305
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:54 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:59 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:03 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:11 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:14 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:21 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:25 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-E-11-471",
//     "routeNo": "56-E",
//     "code": "56/P56E-1",
//     "tripCode": "56/P56E-156-ETORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:40 AM",
//     "endTime": "08:40 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       305,
//       255,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:44 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:47 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:54 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:56 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:04 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:08 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:13 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "08:16 AM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "08:18 AM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "08:26 AM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "08:28 AM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "08:36 AM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "08:40 AM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-E-12-472",
//     "routeNo": "56-E",
//     "code": "56/P56E-2",
//     "tripCode": "56/P56E-256-ETORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:45 AM",
//     "endTime": "10:00 AM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       305,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1,
//       28,
//       27
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "PEROORANI",
//         "time": "08:45 AM",
//         "id": 24
//       },
//       {
//         "no": 15,
//         "name": "THIMMARAJAPURAM",
//         "time": "08:48 AM",
//         "id": 262
//       },
//       {
//         "no": 14,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "08:57 AM",
//         "id": 261
//       },
//       {
//         "no": 13,
//         "name": "VAGAIKULAM",
//         "time": "08:59 AM",
//         "id": 167
//       },
//       {
//         "no": 12,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "09:09 AM",
//         "id": 255
//       },
//       {
//         "no": 11,
//         "name": "RAMACHANDRAPURAM 2",
//         "time": "09:11 AM",
//         "id": 305
//       },
//       {
//         "no": 10,
//         "name": "MANGALAGIRI",
//         "time": "09:14 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:20 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:24 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:32 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "KORAMPALLAM",
//         "time": "09:34 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "3RD MILE",
//         "time": "09:42 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "MILLER PURAM",
//         "time": "09:46 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:56 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THRES PURAM",
//         "time": "10:00 AM",
//         "id": 27
//       }
//     ]
//   },
//   {
//     "id": "56-E-13-473",
//     "routeNo": "56-E",
//     "code": "56/P56E-3",
//     "tripCode": "56/P56E-356-ETORD18D13",
//     "order": 13,
//     "direction": "D",
//     "from": "THRES PURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:10 AM",
//     "endTime": "12:10 PM",
//     "ids": [
//       27,
//       1
//     ],
//     "stops": [
//       {
//         "no": 2,
//         "name": "THRES PURAM",
//         "time": "10:10 AM",
//         "id": 27
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-1-474",
//     "routeNo": "56-F",
//     "code": "56/P56F-1",
//     "tripCode": "56/P56F-156-FTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ADAIKKALAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:45 AM",
//     "endTime": "06:40 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       263,
//       264
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:48 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:51 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:58 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:59 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:06 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:09 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:14 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "06:15 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "06:22 AM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "06:26 AM",
//         "id": 166
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "06:36 AM",
//         "id": 263
//       },
//       {
//         "no": 15,
//         "name": "ADAIKKALAPURAM",
//         "time": "06:40 AM",
//         "id": 264
//       }
//     ]
//   },
//   {
//     "id": "56-F-2-475",
//     "routeNo": "56-F",
//     "code": "56/P56F-1",
//     "tripCode": "56/P56F-156-FTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "ADAIKKALAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 AM",
//     "endTime": "07:40 AM",
//     "ids": [
//       264,
//       263,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "ADAIKKALAPURAM",
//         "time": "06:50 AM",
//         "id": 264
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "06:53 AM",
//         "id": 263
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "07:02 AM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "07:05 AM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "07:12 AM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:13 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:17 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:20 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:26 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:28 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:33 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:36 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-3-476",
//     "routeNo": "56-F",
//     "code": "56/P56F-6",
//     "tripCode": "56/P56F-656-FTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "MEELAVITTAN",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 AM",
//     "endTime": "08:05 AM",
//     "ids": [
//       1,
//       26,
//       220,
//       221,
//       222,
//       223
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "07:52 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "CHINNAKANNUPURAM",
//         "time": "07:54 AM",
//         "id": 220
//       },
//       {
//         "no": 4,
//         "name": "SILVERPURAM",
//         "time": "07:57 AM",
//         "id": 221
//       },
//       {
//         "no": 5,
//         "name": "PANDARAMPATTI",
//         "time": "08:02 AM",
//         "id": 222
//       },
//       {
//         "no": 6,
//         "name": "MEELAVITTAN",
//         "time": "08:05 AM",
//         "id": 223
//       }
//     ]
//   },
//   {
//     "id": "56-F-4-477",
//     "routeNo": "56-F",
//     "code": "56/P56F-6",
//     "tripCode": "56/P56F-656-FTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "MEELAVITTAN",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 AM",
//     "endTime": "08:10 AM",
//     "ids": [
//       223,
//       222,
//       221,
//       220,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "MEELAVITTAN",
//         "time": "08:10 AM",
//         "id": 223
//       },
//       {
//         "no": 5,
//         "name": "PANDARAMPATTI",
//         "time": "08:10 AM",
//         "id": 222
//       },
//       {
//         "no": 4,
//         "name": "SILVERPURAM",
//         "time": "08:10 AM",
//         "id": 221
//       },
//       {
//         "no": 3,
//         "name": "CHINNAKANNUPURAM",
//         "time": "08:10 AM",
//         "id": 220
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "08:10 AM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-5-478",
//     "routeNo": "56-F",
//     "code": "56/P56F-7",
//     "tripCode": "56/P56F-756-FTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ST. MARYS COLLEGE",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:20 AM",
//     "endTime": "08:25 AM",
//     "ids": [
//       1,
//       28,
//       272
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:20 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:23 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ST. MARY'S COLLEGE",
//         "time": "08:25 AM",
//         "id": 272
//       }
//     ]
//   },
//   {
//     "id": "56-F-6-479",
//     "routeNo": "56-F",
//     "code": "56/P56F-7",
//     "tripCode": "56/P56F-756-FTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "ST. MARYS COLLEGE",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:45 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       272,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 3,
//         "name": "ST. MARY'S COLLEGE",
//         "time": "08:45 AM",
//         "id": 272
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:51 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:05 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-7-480",
//     "routeNo": "56-F",
//     "code": "56/P56F-3",
//     "tripCode": "56/P56F-356-FTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "DEIVASEYALPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 AM",
//     "endTime": "10:25 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       263,
//       265,
//       266,
//       267,
//       268,
//       269,
//       270
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:19 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:21 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:28 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:30 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:36 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:40 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:44 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "09:46 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "09:53 AM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "09:57 AM",
//         "id": 166
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "10:07 AM",
//         "id": 263
//       },
//       {
//         "no": 15,
//         "name": "ANIYABARANALLUR",
//         "time": "10:11 AM",
//         "id": 265
//       },
//       {
//         "no": 16,
//         "name": "PUDHUPATTI",
//         "time": "10:17 AM",
//         "id": 266
//       },
//       {
//         "no": 17,
//         "name": "CHETTIMALLANPATTI",
//         "time": "10:19 AM",
//         "id": 267
//       },
//       {
//         "no": 18,
//         "name": "RAMANATHAPURAM",
//         "time": "10:22 AM",
//         "id": 268
//       },
//       {
//         "no": 19,
//         "name": "ELLANAICKENPATTI",
//         "time": "10:23 AM",
//         "id": 269
//       },
//       {
//         "no": 20,
//         "name": "DEIVASEYALPURAM",
//         "time": "10:25 AM",
//         "id": 270
//       }
//     ]
//   },
//   {
//     "id": "56-F-8-481",
//     "routeNo": "56-F",
//     "code": "56/P56F-3",
//     "tripCode": "56/P56F-356-FTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "DEIVASEYALPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:30 AM",
//     "endTime": "11:45 AM",
//     "ids": [
//       270,
//       269,
//       268,
//       267,
//       266,
//       265,
//       263,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 20,
//         "name": "DEIVASEYALPURAM",
//         "time": "10:30 AM",
//         "id": 270
//       },
//       {
//         "no": 19,
//         "name": "ELLANAICKENPATTI",
//         "time": "10:31 AM",
//         "id": 269
//       },
//       {
//         "no": 18,
//         "name": "RAMANATHAPURAM",
//         "time": "10:32 AM",
//         "id": 268
//       },
//       {
//         "no": 17,
//         "name": "CHETTIMALLANPATTI",
//         "time": "10:35 AM",
//         "id": 267
//       },
//       {
//         "no": 16,
//         "name": "PUDHUPATTI",
//         "time": "10:38 AM",
//         "id": 266
//       },
//       {
//         "no": 15,
//         "name": "ANIYABARANALLUR",
//         "time": "10:44 AM",
//         "id": 265
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "10:48 AM",
//         "id": 263
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "10:59 AM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "11:03 AM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "11:11 AM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "11:12 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:17 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:21 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:28 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:30 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:37 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:40 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-9-482",
//     "routeNo": "56-F",
//     "code": "56/P56F-9",
//     "tripCode": "56/P56F-956-FTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI OLD B/S",
//     "to": "THOOTHUKUDI NEW B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:50 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       1,
//       26,
//       77
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "11:56 AM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI NEW B/S",
//         "time": "12:00 PM",
//         "id": 77
//       }
//     ]
//   },
//   {
//     "id": "56-F-10-483",
//     "routeNo": "56-F",
//     "code": "56/P56F-9",
//     "tripCode": "56/P56F-956-FTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "THOOTHUKUDI NEW B/S",
//     "to": "THOOTHUKUDI OLD B/S",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:20 PM",
//     "endTime": "12:30 PM",
//     "ids": [
//       77,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 3,
//         "name": "THOOTHUKUDI NEW B/S",
//         "time": "12:20 PM",
//         "id": 77
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "12:23 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-11-484",
//     "routeNo": "56-F",
//     "code": "56/P56F-1",
//     "tripCode": "56/P56F-156-FTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "ADAIKKALAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:50 PM",
//     "endTime": "01:40 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       263,
//       264
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "12:53 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:56 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:01 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:03 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:09 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:12 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:16 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "01:17 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "01:24 PM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "01:27 PM",
//         "id": 166
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "01:36 PM",
//         "id": 263
//       },
//       {
//         "no": 15,
//         "name": "ADAIKKALAPURAM",
//         "time": "01:40 PM",
//         "id": 264
//       }
//     ]
//   },
//   {
//     "id": "56-F-12-485",
//     "routeNo": "56-F",
//     "code": "56/P56F-1",
//     "tripCode": "56/P56F-156-FTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "ADAIKKALAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:50 PM",
//     "endTime": "02:40 PM",
//     "ids": [
//       264,
//       263,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 15,
//         "name": "ADAIKKALAPURAM",
//         "time": "01:50 PM",
//         "id": 264
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "01:53 PM",
//         "id": 263
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "02:02 PM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "02:05 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "02:12 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "02:13 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:17 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:20 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:26 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:28 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:33 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:36 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-13-486",
//     "routeNo": "56-F",
//     "code": "56/P56F-8",
//     "tripCode": "56/P56F-856-FTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "APC COLLEGE",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:50 PM",
//     "endTime": "03:00 PM",
//     "ids": [
//       1,
//       26,
//       66,
//       219
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "02:53 PM",
//         "id": 26
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "02:56 PM",
//         "id": 66
//       },
//       {
//         "no": 4,
//         "name": "APC COLLEGE",
//         "time": "03:00 PM",
//         "id": 219
//       }
//     ]
//   },
//   {
//     "id": "56-F-14-487",
//     "routeNo": "56-F",
//     "code": "56/P56F-8",
//     "tripCode": "56/P56F-856-FTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "APC COLLEGE",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:05 PM",
//     "endTime": "03:40 PM",
//     "ids": [
//       219,
//       66,
//       26,
//       1
//     ],
//     "stops": [
//       {
//         "no": 4,
//         "name": "APC COLLEGE",
//         "time": "03:05 PM",
//         "id": 219
//       },
//       {
//         "no": 3,
//         "name": "STATE BANK COLONY",
//         "time": "03:18 PM",
//         "id": 66
//       },
//       {
//         "no": 2,
//         "name": "4TH GATE 1",
//         "time": "03:27 PM",
//         "id": 26
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-15-488",
//     "routeNo": "56-F",
//     "code": "56/P56F-2",
//     "tripCode": "56/P56F-256-FTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUDHUPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:50 PM",
//     "endTime": "04:50 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       263,
//       265,
//       266
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:53 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:56 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:02 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:04 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:11 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:14 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "04:18 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "04:20 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "04:27 PM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "04:31 PM",
//         "id": 166
//       },
//       {
//         "no": 14,
//         "name": "MEENAKSHIPATTI",
//         "time": "04:41 PM",
//         "id": 263
//       },
//       {
//         "no": 15,
//         "name": "ANIYABARANALLUR",
//         "time": "04:44 PM",
//         "id": 265
//       },
//       {
//         "no": 16,
//         "name": "PUDHUPATTI",
//         "time": "04:50 PM",
//         "id": 266
//       }
//     ]
//   },
//   {
//     "id": "56-F-16-489",
//     "routeNo": "56-F",
//     "code": "56/P56F-4",
//     "tripCode": "56/P56F-456-FTORD18U16",
//     "order": 16,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PEROORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 PM",
//     "endTime": "05:05 PM",
//     "ids": [
//       266,
//       265,
//       263,
//       166,
//       167,
//       261,
//       262,
//       24
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "PUDHUPATTI",
//         "time": "05:00 PM",
//         "id": 266
//       },
//       {
//         "no": 2,
//         "name": "ANIYABARANALLUR",
//         "time": "05:00 PM",
//         "id": 265
//       },
//       {
//         "no": 3,
//         "name": "MEENAKSHIPATTI",
//         "time": "05:01 PM",
//         "id": 263
//       },
//       {
//         "no": 6,
//         "name": "MUDIVAITHANENDAL",
//         "time": "05:02 PM",
//         "id": 166
//       },
//       {
//         "no": 7,
//         "name": "VAGAIKULAM",
//         "time": "05:03 PM",
//         "id": 167
//       },
//       {
//         "no": 8,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "05:03 PM",
//         "id": 261
//       },
//       {
//         "no": 9,
//         "name": "THIMMARAJAPURAM",
//         "time": "05:04 PM",
//         "id": 262
//       },
//       {
//         "no": 10,
//         "name": "PEROORANI",
//         "time": "05:05 PM",
//         "id": 24
//       }
//     ]
//   },
//   {
//     "id": "56-F-17-490",
//     "routeNo": "56-F",
//     "code": "56/P56F-5",
//     "tripCode": "56/P56F-556-FTORD18D17",
//     "order": 17,
//     "direction": "D",
//     "from": "PEROORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:55 PM",
//     "endTime": "06:00 PM",
//     "ids": [
//       24,
//       262,
//       261,
//       167,
//       255,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 14,
//         "name": "PEROORANI",
//         "time": "05:55 PM",
//         "id": 24
//       },
//       {
//         "no": 13,
//         "name": "THIMMARAJAPURAM",
//         "time": "05:55 PM",
//         "id": 262
//       },
//       {
//         "no": 12,
//         "name": "VARTHAGAREDDIPATTI",
//         "time": "05:55 PM",
//         "id": 261
//       },
//       {
//         "no": 11,
//         "name": "VAGAIKULAM",
//         "time": "05:56 PM",
//         "id": 167
//       },
//       {
//         "no": 10,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "05:56 PM",
//         "id": 255
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "05:56 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "05:57 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:57 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:57 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:58 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:58 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:59 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:59 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-F-18-491",
//     "routeNo": "56-F",
//     "code": "56/P56F-10",
//     "tripCode": "56/P56F-1056-FTORD18U18",
//     "order": 18,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "THALAIVANVADALI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 PM",
//     "endTime": "08:45 PM",
//     "ids": [
//       1,
//       41,
//       42,
//       43,
//       44,
//       45,
//       46,
//       127,
//       157,
//       49,
//       50,
//       51,
//       172,
//       129,
//       130,
//       239
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "06:16 PM",
//         "id": 41
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "06:24 PM",
//         "id": 42
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "06:36 PM",
//         "id": 43
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "06:56 PM",
//         "id": 44
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "06:58 PM",
//         "id": 45
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "07:06 PM",
//         "id": 46
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "07:21 PM",
//         "id": 127
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "07:31 PM",
//         "id": 157
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "07:45 PM",
//         "id": 49
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "08:00 PM",
//         "id": 50
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "08:11 PM",
//         "id": 51
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "08:19 PM",
//         "id": 172
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "08:24 PM",
//         "id": 129
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "08:35 PM",
//         "id": 130
//       },
//       {
//         "no": 16,
//         "name": "THALAIVANVADALI",
//         "time": "08:45 PM",
//         "id": 239
//       }
//     ]
//   },
//   {
//     "id": "56-F-19-492",
//     "routeNo": "56-F",
//     "code": "56/P56F-10",
//     "tripCode": "56/P56F-1056-FTORD18D19",
//     "order": 19,
//     "direction": "D",
//     "from": "THALAIVANVADALI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 PM",
//     "endTime": "05:30 AM",
//     "ids": [
//       239,
//       130,
//       129,
//       172,
//       51,
//       50,
//       49,
//       157,
//       127,
//       46,
//       45,
//       44,
//       43,
//       42,
//       41,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "THALAIVANVADALI",
//         "time": "07:30 PM",
//         "id": 239
//       },
//       {
//         "no": 15,
//         "name": "AYYANKOVIL JUNCTION",
//         "time": "08:09 PM",
//         "id": 130
//       },
//       {
//         "no": 14,
//         "name": "SOUTH AUTHOOR",
//         "time": "08:50 PM",
//         "id": 129
//       },
//       {
//         "no": 13,
//         "name": "AUTHOOR",
//         "time": "09:10 PM",
//         "id": 172
//       },
//       {
//         "no": 12,
//         "name": "MUKKANI",
//         "time": "09:42 PM",
//         "id": 51
//       },
//       {
//         "no": 11,
//         "name": "CHAMBER",
//         "time": "10:26 PM",
//         "id": 50
//       },
//       {
//         "no": 10,
//         "name": "PALAIYA KAYAL",
//         "time": "11:29 PM",
//         "id": 49
//       },
//       {
//         "no": 9,
//         "name": "KOVANKADU",
//         "time": "12:24 AM",
//         "id": 157
//       },
//       {
//         "no": 8,
//         "name": "SOUTHERN SALT",
//         "time": "01:03 AM",
//         "id": 127
//       },
//       {
//         "no": 7,
//         "name": "MULLAKADU",
//         "time": "02:03 AM",
//         "id": 46
//       },
//       {
//         "no": 6,
//         "name": "SPIC NAGAR",
//         "time": "02:37 AM",
//         "id": 45
//       },
//       {
//         "no": 5,
//         "name": "MUTHAIAHPURAM",
//         "time": "02:45 AM",
//         "id": 44
//       },
//       {
//         "no": 4,
//         "name": "UPPATTHU ODAI",
//         "time": "04:03 AM",
//         "id": 43
//       },
//       {
//         "no": 3,
//         "name": "LEVANJIPURAM",
//         "time": "04:51 AM",
//         "id": 42
//       },
//       {
//         "no": 2,
//         "name": "MARKET",
//         "time": "05:24 AM",
//         "id": 41
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-1-493",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SEBATHAIAHPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:15 AM",
//     "endTime": "12:30 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       306,
//       164,
//       291,
//       13,
//       12
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "11:20 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:23 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:31 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:33 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:42 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:46 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "11:51 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "11:53 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "12:03 PM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "12:07 PM",
//         "id": 166
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "12:13 PM",
//         "id": 306
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "12:17 PM",
//         "id": 164
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "12:21 PM",
//         "id": 291
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "12:26 PM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:30 PM",
//         "id": 12
//       }
//     ]
//   },
//   {
//     "id": "56-G-2-494",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "SEBATHAIAHPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:35 PM",
//     "endTime": "01:40 PM",
//     "ids": [
//       12,
//       13,
//       291,
//       164,
//       306,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "12:35 PM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "12:38 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "12:42 PM",
//         "id": 291
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "12:46 PM",
//         "id": 164
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "12:49 PM",
//         "id": 306
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "12:54 PM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "12:58 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "01:06 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "01:07 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "01:12 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:16 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:23 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:25 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:32 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:35 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-3-495",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SEBATHAIAHPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:45 PM",
//     "endTime": "02:50 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       306,
//       164,
//       291,
//       13,
//       12
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:49 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:52 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:59 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:01 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:08 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:12 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "02:17 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "02:18 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "02:26 PM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "02:30 PM",
//         "id": 166
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "02:35 PM",
//         "id": 306
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "02:38 PM",
//         "id": 164
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "02:42 PM",
//         "id": 291
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "02:46 PM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "02:50 PM",
//         "id": 12
//       }
//     ]
//   },
//   {
//     "id": "56-G-4-496",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "SEBATHAIAHPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:55 PM",
//     "endTime": "04:00 PM",
//     "ids": [
//       12,
//       13,
//       291,
//       164,
//       306,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "02:55 PM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "02:58 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "03:02 PM",
//         "id": 291
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "03:06 PM",
//         "id": 164
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "03:09 PM",
//         "id": 306
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "03:14 PM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "03:18 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "03:26 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "03:27 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:32 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:36 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:43 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:45 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:52 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:55 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-5-497",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SEBATHAIAHPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:05 PM",
//     "endTime": "05:20 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       306,
//       164,
//       291,
//       13,
//       12
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:10 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:13 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:21 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:23 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:32 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:36 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "04:41 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "04:43 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "04:53 PM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "04:57 PM",
//         "id": 166
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "05:03 PM",
//         "id": 306
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "05:07 PM",
//         "id": 164
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "05:11 PM",
//         "id": 291
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "05:16 PM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:20 PM",
//         "id": 12
//       }
//     ]
//   },
//   {
//     "id": "56-G-6-498",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "SEBATHAIAHPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:25 PM",
//     "endTime": "06:40 PM",
//     "ids": [
//       12,
//       13,
//       291,
//       164,
//       306,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:25 PM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "05:28 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "05:33 PM",
//         "id": 291
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "05:37 PM",
//         "id": 164
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "05:41 PM",
//         "id": 306
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "05:47 PM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "05:51 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "06:01 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:03 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:08 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:12 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:21 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:23 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:31 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:34 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:40 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-7-499",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SEBATHAIAHPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 PM",
//     "endTime": "08:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       306,
//       164,
//       291,
//       13,
//       12
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:04 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:08 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:15 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:17 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:25 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:29 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:34 PM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "07:36 PM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "07:44 PM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "07:49 PM",
//         "id": 166
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "07:54 PM",
//         "id": 306
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "07:57 PM",
//         "id": 164
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "08:01 PM",
//         "id": 291
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "08:06 PM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:10 PM",
//         "id": 12
//       }
//     ]
//   },
//   {
//     "id": "56-G-8-500",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "SEBATHAIAHPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 PM",
//     "endTime": "09:25 PM",
//     "ids": [
//       12,
//       13,
//       291,
//       164,
//       306,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:15 PM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "08:18 PM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "08:23 PM",
//         "id": 291
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "08:27 PM",
//         "id": 164
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "08:30 PM",
//         "id": 306
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "08:35 PM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "08:40 PM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "08:48 PM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:50 PM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:55 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:59 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:07 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:09 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:16 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:20 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-9-501",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SEBATHAIAHPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:30 AM",
//     "endTime": "05:30 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       306,
//       164,
//       291,
//       13,
//       12
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:34 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:36 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:43 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:45 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:51 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:55 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "04:59 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "05:00 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "05:08 AM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "05:12 AM",
//         "id": 166
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "05:16 AM",
//         "id": 306
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "05:19 AM",
//         "id": 164
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "05:23 AM",
//         "id": 291
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "05:26 AM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:30 AM",
//         "id": 12
//       }
//     ]
//   },
//   {
//     "id": "56-G-10-502",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "SEBATHAIAHPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:40 AM",
//     "endTime": "06:45 AM",
//     "ids": [
//       12,
//       13,
//       291,
//       164,
//       306,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "05:40 AM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "05:43 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "05:47 AM",
//         "id": 291
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "05:51 AM",
//         "id": 164
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "05:54 AM",
//         "id": 306
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "05:59 AM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "06:03 AM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "06:11 AM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "06:12 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:17 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:21 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:28 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:30 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:37 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:40 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-11-503",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SEBATHAIAHPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 AM",
//     "endTime": "08:15 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       255,
//       167,
//       166,
//       306,
//       164,
//       291,
//       13,
//       12
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:05 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:08 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:16 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:18 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:27 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:31 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "07:36 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "07:38 AM",
//         "id": 255
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "07:48 AM",
//         "id": 167
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "07:52 AM",
//         "id": 166
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "07:58 AM",
//         "id": 306
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "08:02 AM",
//         "id": 164
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "08:06 AM",
//         "id": 291
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "08:11 AM",
//         "id": 13
//       },
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:15 AM",
//         "id": 12
//       }
//     ]
//   },
//   {
//     "id": "56-G-12-504",
//     "routeNo": "56-G",
//     "code": "56/P56G-1",
//     "tripCode": "56/P56G-156-GTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "SEBATHAIAHPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:22 AM",
//     "endTime": "09:30 AM",
//     "ids": [
//       12,
//       13,
//       291,
//       164,
//       306,
//       166,
//       167,
//       255,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 16,
//         "name": "SEBATHAIAHPURAM",
//         "time": "08:22 AM",
//         "id": 12
//       },
//       {
//         "no": 15,
//         "name": "SAWYERPURAM",
//         "time": "08:25 AM",
//         "id": 13
//       },
//       {
//         "no": 14,
//         "name": "KUMARAPURAM 2",
//         "time": "08:29 AM",
//         "id": 291
//       },
//       {
//         "no": 13,
//         "name": "KATTALANKULAM",
//         "time": "08:33 AM",
//         "id": 164
//       },
//       {
//         "no": 12,
//         "name": "PUDHUR 3",
//         "time": "08:36 AM",
//         "id": 306
//       },
//       {
//         "no": 11,
//         "name": "MUDIVAITHANENDAL",
//         "time": "08:42 AM",
//         "id": 166
//       },
//       {
//         "no": 10,
//         "name": "VAGAIKULAM",
//         "time": "08:46 AM",
//         "id": 167
//       },
//       {
//         "no": 9,
//         "name": "RAMACHANDRAPURAM JUNCTION",
//         "time": "08:54 AM",
//         "id": 255
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "08:56 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:01 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:05 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:12 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:15 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:22 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:25 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "56-G-13-505",
//     "routeNo": "56-G",
//     "code": "56/P56G-2",
//     "tripCode": "56/P56G-256-GTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NORTH SILUKKANPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:35 AM",
//     "endTime": "10:15 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       297,
//       235,
//       298,
//       237,
//       238
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:40 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:44 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:53 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "09:58 AM",
//         "id": 297
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "10:04 AM",
//         "id": 235
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "10:11 AM",
//         "id": 298
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "10:13 AM",
//         "id": 237
//       },
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "10:15 AM",
//         "id": 238
//       }
//     ]
//   },
//   {
//     "id": "56-G-14-506",
//     "routeNo": "56-G",
//     "code": "56/P56G-2",
//     "tripCode": "56/P56G-256-GTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "NORTH SILUKKANPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:20 AM",
//     "endTime": "11:00 AM",
//     "ids": [
//       238,
//       237,
//       298,
//       235,
//       297,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "10:20 AM",
//         "id": 238
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "10:21 AM",
//         "id": 237
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "10:23 AM",
//         "id": 298
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "10:30 AM",
//         "id": 235
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "10:36 AM",
//         "id": 297
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:41 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:50 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:54 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-1-507",
//     "routeNo": "57-A",
//     "code": "57/P57A-1",
//     "tripCode": "57/P57A-157-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SPIC NAGAR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 AM",
//     "endTime": "07:20 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183,
//       44,
//       45
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "06:22 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "06:28 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:37 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:42 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:46 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:54 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:59 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "07:01 AM",
//         "id": 183
//       },
//       {
//         "no": 10,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:18 AM",
//         "id": 44
//       },
//       {
//         "no": 11,
//         "name": "SPIC NAGAR",
//         "time": "07:20 AM",
//         "id": 45
//       }
//     ]
//   },
//   {
//     "id": "57-A-2-508",
//     "routeNo": "57-A",
//     "code": "57/P57A-1",
//     "tripCode": "57/P57A-157-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "SPIC NAGAR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:25 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       45,
//       44,
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 11,
//         "name": "SPIC NAGAR",
//         "time": "07:25 AM",
//         "id": 45
//       },
//       {
//         "no": 10,
//         "name": "MUTHAIAHPURAM",
//         "time": "07:25 AM",
//         "id": 44
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "07:34 AM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "07:36 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "07:38 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "07:43 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "07:44 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "07:47 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "07:52 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:56 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-3-509",
//     "routeNo": "57-A",
//     "code": "57/P57A-3",
//     "tripCode": "57/P57A-357-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:10 AM",
//     "endTime": "08:50 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:16 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:21 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:29 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:33 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:36 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:43 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "TTPP",
//         "time": "08:43 AM",
//         "id": 181
//       },
//       {
//         "no": 9,
//         "name": "CHILDREN'S PARK",
//         "time": "08:47 AM",
//         "id": 182
//       },
//       {
//         "no": 10,
//         "name": "CAMP-II",
//         "time": "08:50 AM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-4-510",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:00 AM",
//     "endTime": "09:35 AM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "09:00 AM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:02 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:05 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:11 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "09:14 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:17 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:24 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:29 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-5-511",
//     "routeNo": "57-A",
//     "code": "57/P57A-3",
//     "tripCode": "57/P57A-357-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 AM",
//     "endTime": "10:20 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:46 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:51 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:59 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:03 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:06 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:13 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "TTPP",
//         "time": "10:13 AM",
//         "id": 181
//       },
//       {
//         "no": 9,
//         "name": "CHILDREN'S PARK",
//         "time": "10:17 AM",
//         "id": 182
//       },
//       {
//         "no": 10,
//         "name": "CAMP-II",
//         "time": "10:20 AM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-6-512",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:25 AM",
//     "endTime": "10:55 AM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "10:25 AM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "10:26 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:29 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:34 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:37 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:40 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "10:46 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:50 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:55 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-7-513",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:00 AM",
//     "endTime": "11:30 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:00 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "11:04 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "11:08 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "11:14 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "11:17 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "11:20 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "11:25 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "11:28 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "11:30 AM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-8-514",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:35 AM",
//     "endTime": "12:05 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "11:35 AM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "11:36 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "11:39 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "11:44 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "11:47 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "11:50 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "11:56 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "12:00 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-9-515",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:10 PM",
//     "endTime": "12:50 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "12:16 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "12:21 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "12:29 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "12:33 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "12:36 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "12:43 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "12:47 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "12:50 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-10-516",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:55 PM",
//     "endTime": "01:35 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "12:55 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "12:57 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "01:01 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "01:08 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "01:11 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "01:15 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "01:23 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "01:28 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-11-517",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:40 PM",
//     "endTime": "02:15 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "01:45 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "01:50 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "01:57 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "02:00 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "02:03 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "02:09 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "02:12 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "02:15 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-12-518",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:20 PM",
//     "endTime": "02:55 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "02:20 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "02:22 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "02:25 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "02:31 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "02:34 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "02:37 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "02:44 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "02:49 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-13-519",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:00 PM",
//     "endTime": "03:35 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "03:05 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "03:10 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "03:17 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "03:20 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "03:23 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "03:29 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "03:32 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "03:35 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-14-520",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:40 PM",
//     "endTime": "04:10 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "03:40 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "03:41 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "03:44 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "03:49 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "03:52 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "03:55 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "04:01 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "04:05 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-15-521",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:20 PM",
//     "endTime": "05:15 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "04:28 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "04:36 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "04:46 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "04:52 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "04:56 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "05:06 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "05:11 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "05:15 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-16-522",
//     "routeNo": "57-A",
//     "code": "57/P57A-3",
//     "tripCode": "57/P57A-357-ATORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:20 PM",
//     "endTime": "05:55 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 10,
//         "name": "CAMP-II",
//         "time": "05:20 PM",
//         "id": 183
//       },
//       {
//         "no": 9,
//         "name": "CHILDREN'S PARK",
//         "time": "05:22 PM",
//         "id": 182
//       },
//       {
//         "no": 8,
//         "name": "TTPP",
//         "time": "05:25 PM",
//         "id": 181
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "05:25 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "05:31 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "05:34 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "05:37 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "05:44 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:49 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-17-523",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U17",
//     "order": 17,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:00 PM",
//     "endTime": "06:35 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "06:05 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "06:10 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:17 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:20 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:23 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:29 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:32 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "06:35 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-18-524",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:40 PM",
//     "endTime": "07:45 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "06:40 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:43 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:50 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "07:01 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "07:06 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "07:13 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "07:25 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:34 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-19-525",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U19",
//     "order": 19,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:50 PM",
//     "endTime": "08:20 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:54 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "07:58 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:04 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:07 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:10 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:15 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "08:18 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "08:20 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-20-526",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D20",
//     "order": 20,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:25 PM",
//     "endTime": "08:55 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "08:25 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "08:26 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:29 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:34 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:37 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:40 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:46 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:50 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-A-21-527",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18U21",
//     "order": 21,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CAMP-II",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:00 PM",
//     "endTime": "09:35 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       183
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:05 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:10 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:17 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "09:20 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:23 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:29 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:32 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "09:35 PM",
//         "id": 183
//       }
//     ]
//   },
//   {
//     "id": "57-A-22-528",
//     "routeNo": "57-A",
//     "code": "57/P57A-2",
//     "tripCode": "57/P57A-257-ATORD18D22",
//     "order": 22,
//     "direction": "D",
//     "from": "CAMP-II",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 PM",
//     "endTime": "10:30 PM",
//     "ids": [
//       183,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "CAMP-II",
//         "time": "09:40 PM",
//         "id": 183
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:42 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:47 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:56 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:00 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:05 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "10:15 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:22 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-1-529",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:10 PM",
//     "endTime": "01:45 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "01:14 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "01:18 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "01:24 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "01:27 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "01:30 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "01:35 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "01:38 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "01:45 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-2-530",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:50 PM",
//     "endTime": "02:25 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "01:50 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "01:56 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "01:59 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "02:04 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "02:07 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "02:10 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "02:16 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "02:20 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-3-531",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:30 PM",
//     "endTime": "03:15 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "02:36 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "02:41 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "02:48 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "02:53 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "02:55 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "03:02 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "03:06 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "03:15 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-4-532",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:20 PM",
//     "endTime": "03:50 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "03:20 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "03:25 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "03:28 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "03:32 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "03:34 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "03:37 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "03:42 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "03:45 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "03:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-5-533",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:10 PM",
//     "endTime": "04:45 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:10 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "04:14 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "04:18 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "04:24 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "04:27 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "04:30 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "04:35 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "04:38 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "04:45 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-6-534",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:50 PM",
//     "endTime": "05:25 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "04:50 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "04:56 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "04:59 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "05:04 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "05:07 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "05:10 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "05:16 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:20 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-7-535",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:40 PM",
//     "endTime": "06:15 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:44 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "05:48 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "05:54 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "05:57 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:00 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:05 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:08 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "06:15 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-8-536",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:20 PM",
//     "endTime": "06:55 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "06:20 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:26 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:29 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:34 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:37 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:40 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "06:46 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "06:50 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-9-537",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 PM",
//     "endTime": "07:50 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:19 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "07:23 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "07:29 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "07:32 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "07:35 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "07:40 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "07:43 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "07:50 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-10-538",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:55 PM",
//     "endTime": "08:30 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "07:55 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "08:01 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:04 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:09 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:12 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:15 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:21 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:25 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-11-539",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:35 PM",
//     "endTime": "09:10 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:35 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:39 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:43 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:49 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:52 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:55 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:00 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:03 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "09:10 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-12-540",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:15 PM",
//     "endTime": "09:45 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "09:15 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:20 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:23 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:27 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "09:29 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:32 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:37 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:40 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-13-541",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:00 PM",
//     "endTime": "10:30 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:04 PM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "10:07 PM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:12 PM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:15 PM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:17 PM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:21 PM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "10:24 PM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "10:30 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-14-542",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:35 PM",
//     "endTime": "11:00 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "10:35 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "10:39 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:41 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:45 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:47 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:49 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "10:53 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "10:56 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:00 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-15-543",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:50 AM",
//     "endTime": "06:20 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "05:54 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "05:57 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:02 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:05 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:07 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:11 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:14 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "06:20 AM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-16-544",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:25 AM",
//     "endTime": "07:00 AM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "06:25 AM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "06:31 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "06:34 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "06:39 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "06:42 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "06:45 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "06:51 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "06:55 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-17-545",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U17",
//     "order": 17,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 AM",
//     "endTime": "07:50 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:15 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "07:19 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "07:23 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "07:29 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "07:32 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "07:35 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "07:40 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "07:43 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "07:50 AM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-18-546",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D18",
//     "order": 18,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:55 AM",
//     "endTime": "08:25 AM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "07:55 AM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "08:00 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "08:03 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:07 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:09 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:12 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:17 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:20 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-19-547",
//     "routeNo": "57-D",
//     "code": "57/P57D-2",
//     "tripCode": "57/P57D-257-DTORD18U19",
//     "order": 19,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:30 AM",
//     "endTime": "09:05 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "08:34 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "08:38 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "08:44 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "08:47 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "08:50 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP JUNCTION",
//         "time": "08:50 AM",
//         "id": 180
//       },
//       {
//         "no": 8,
//         "name": "TTPP",
//         "time": "08:55 AM",
//         "id": 181
//       },
//       {
//         "no": 9,
//         "name": "CHILDREN'S PARK",
//         "time": "08:58 AM",
//         "id": 182
//       },
//       {
//         "no": 10,
//         "name": "NEW HARBOUR",
//         "time": "09:05 AM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-20-548",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D20",
//     "order": 20,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 AM",
//     "endTime": "09:45 AM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "09:10 AM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "09:16 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "09:19 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "09:24 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "09:27 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "09:30 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:36 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:40 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-21-549",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U21",
//     "order": 21,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 AM",
//     "endTime": "10:25 AM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "09:54 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "09:58 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:04 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:07 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:10 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:15 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "10:18 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "10:25 AM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-22-550",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D22",
//     "order": 22,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:40 AM",
//     "endTime": "11:10 AM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "10:40 AM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "10:45 AM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "10:48 AM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "10:52 AM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "10:54 AM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "10:57 AM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "11:02 AM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "11:05 AM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:10 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "57-D-23-551",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18U23",
//     "order": 23,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NEW HARBOUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:25 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       1,
//       28,
//       185,
//       294,
//       293,
//       180,
//       181,
//       182,
//       273
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "11:25 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "11:29 AM",
//         "id": 28
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "11:33 AM",
//         "id": 185
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "11:39 AM",
//         "id": 294
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "11:42 AM",
//         "id": 293
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "11:45 AM",
//         "id": 180
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "11:50 AM",
//         "id": 181
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "11:53 AM",
//         "id": 182
//       },
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "12:00 PM",
//         "id": 273
//       }
//     ]
//   },
//   {
//     "id": "57-D-24-552",
//     "routeNo": "57-D",
//     "code": "57/P57D-1",
//     "tripCode": "57/P57D-157-DTORD18D24",
//     "order": 24,
//     "direction": "D",
//     "from": "NEW HARBOUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:15 PM",
//     "endTime": "12:45 PM",
//     "ids": [
//       273,
//       182,
//       181,
//       180,
//       293,
//       294,
//       185,
//       28,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NEW HARBOUR",
//         "time": "12:15 PM",
//         "id": 273
//       },
//       {
//         "no": 8,
//         "name": "CHILDREN'S PARK",
//         "time": "12:20 PM",
//         "id": 182
//       },
//       {
//         "no": 7,
//         "name": "TTPP",
//         "time": "12:23 PM",
//         "id": 181
//       },
//       {
//         "no": 6,
//         "name": "THERMAL NAGAR JUNCTION",
//         "time": "12:27 PM",
//         "id": 180
//       },
//       {
//         "no": 5,
//         "name": "THERMAL NAGAR",
//         "time": "12:29 PM",
//         "id": 293
//       },
//       {
//         "no": 4,
//         "name": "CHEMICAL",
//         "time": "12:32 PM",
//         "id": 294
//       },
//       {
//         "no": 3,
//         "name": "ROCH PARK",
//         "time": "12:37 PM",
//         "id": 185
//       },
//       {
//         "no": 2,
//         "name": "SUB COLLECTOR OFFICE",
//         "time": "12:40 PM",
//         "id": 28
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-1-553",
//     "routeNo": "58-A",
//     "code": "58/P58A-1",
//     "tripCode": "58/P58A-158-ATORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHETTIYOORANI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:20 PM",
//     "endTime": "02:30 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       254,
//       253
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:26 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:30 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:39 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "01:42 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "01:52 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "01:59 PM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "02:13 PM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "02:21 PM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "CAMP THATTAPARAI",
//         "time": "02:25 PM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "CHETTIYOORANI",
//         "time": "02:30 PM",
//         "id": 253
//       }
//     ]
//   },
//   {
//     "id": "58-A-2-554",
//     "routeNo": "58-A",
//     "code": "58/P58A-1",
//     "tripCode": "58/P58A-158-ATORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "CHETTIYOORANI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:35 PM",
//     "endTime": "04:05 PM",
//     "ids": [
//       253,
//       254,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 13,
//         "name": "CHETTIYOORANI",
//         "time": "02:35 PM",
//         "id": 253
//       },
//       {
//         "no": 12,
//         "name": "CAMP THATTAPARAI",
//         "time": "02:41 PM",
//         "id": 254
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "02:46 PM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "02:56 PM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "03:14 PM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:23 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:35 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:39 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:51 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:57 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-3-555",
//     "routeNo": "58-A",
//     "code": "58/P58A-4",
//     "tripCode": "58/P58A-458-ATORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:00 PM",
//     "endTime": "05:25 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:05 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:08 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:16 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:18 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:27 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "04:31 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:35 PM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "04:41 PM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "04:52 PM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "04:59 PM",
//         "id": 252
//       },
//       {
//         "no": 15,
//         "name": "UMARIKOTTAI",
//         "time": "05:07 PM",
//         "id": 274
//       },
//       {
//         "no": 17,
//         "name": "VARADHARAJAPURAM",
//         "time": "05:14 PM",
//         "id": 275
//       },
//       {
//         "no": 19,
//         "name": "CHOCKALINGAPURAM",
//         "time": "05:25 PM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-A-4-556",
//     "routeNo": "58-A",
//     "code": "58/P58A-2",
//     "tripCode": "58/P58A-258-ATORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:30 PM",
//     "endTime": "07:05 PM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "05:30 PM",
//         "id": 276
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "05:42 PM",
//         "id": 275
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "05:51 PM",
//         "id": 274
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "06:01 PM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "06:10 PM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "06:24 PM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:31 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:41 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:44 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:54 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:58 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:05 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-5-557",
//     "routeNo": "58-A",
//     "code": "58/P58A-6",
//     "tripCode": "58/P58A-658-ATORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KALANKARAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 PM",
//     "endTime": "07:25 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       277
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:05 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:09 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:17 PM",
//         "id": 4
//       },
//       {
//         "no": 6,
//         "name": "KALANKARAI",
//         "time": "07:25 PM",
//         "id": 277
//       }
//     ]
//   },
//   {
//     "id": "58-A-6-558",
//     "routeNo": "58-A",
//     "code": "58/P58A-6",
//     "tripCode": "58/P58A-658-ATORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "KALANKARAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:30 PM",
//     "endTime": "08:10 PM",
//     "ids": [
//       277,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "KALANKARAI",
//         "time": "07:30 PM",
//         "id": 277
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:41 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:55 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:01 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:10 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-7-559",
//     "routeNo": "58-A",
//     "code": "58/P58A-2",
//     "tripCode": "58/P58A-258-ATORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:15 PM",
//     "endTime": "06:55 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:15 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:56 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:27 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:33 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "10:53 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:01 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "12:49 AM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "02:24 AM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "03:20 AM",
//         "id": 252
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "04:30 AM",
//         "id": 274
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "05:30 AM",
//         "id": 275
//       },
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "06:55 AM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-A-8-560",
//     "routeNo": "58-A",
//     "code": "58/P58A-2",
//     "tripCode": "58/P58A-258-ATORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:00 AM",
//     "endTime": "08:25 AM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "07:00 AM",
//         "id": 276
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "07:11 AM",
//         "id": 275
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "07:19 AM",
//         "id": 274
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "07:28 AM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "07:35 AM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "07:48 AM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:54 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:03 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:06 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:15 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:19 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:25 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-9-561",
//     "routeNo": "58-A",
//     "code": "58/P58A-6",
//     "tripCode": "58/P58A-658-ATORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "KALANKARAI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:30 AM",
//     "endTime": "08:55 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       277
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "08:30 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:35 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:39 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:47 AM",
//         "id": 4
//       },
//       {
//         "no": 6,
//         "name": "KALANKARAI",
//         "time": "08:55 AM",
//         "id": 277
//       }
//     ]
//   },
//   {
//     "id": "58-A-10-562",
//     "routeNo": "58-A",
//     "code": "58/P58A-6",
//     "tripCode": "58/P58A-658-ATORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "KALANKARAI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:00 AM",
//     "endTime": "09:35 AM",
//     "ids": [
//       277,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "KALANKARAI",
//         "time": "09:00 AM",
//         "id": 277
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:10 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:21 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:27 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:35 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-11-563",
//     "routeNo": "58-A",
//     "code": "58/P58A-5",
//     "tripCode": "58/P58A-558-ATORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "SIPCOT",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 AM",
//     "endTime": "10:05 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       78,
//       226,
//       225
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:46 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:50 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "09:54 AM",
//         "id": 78
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR JUNCTION",
//         "time": "09:58 AM",
//         "id": 226
//       },
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "10:05 AM",
//         "id": 225
//       }
//     ]
//   },
//   {
//     "id": "58-A-12-564",
//     "routeNo": "58-A",
//     "code": "58/P58A-5",
//     "tripCode": "58/P58A-558-ATORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "SIPCOT",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:10 AM",
//     "endTime": "10:40 AM",
//     "ids": [
//       225,
//       226,
//       78,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 6,
//         "name": "SIPCOT COMPLEX",
//         "time": "10:10 AM",
//         "id": 225
//       },
//       {
//         "no": 5,
//         "name": "MADATTHOOR JUNCTION",
//         "time": "10:17 AM",
//         "id": 226
//       },
//       {
//         "no": 4,
//         "name": "BYPASS",
//         "time": "10:22 AM",
//         "id": 78
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:27 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:32 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:40 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-A-13-565",
//     "routeNo": "58-A",
//     "code": "58/P58A-3",
//     "tripCode": "58/P58A-358-ATORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:45 AM",
//     "endTime": "11:55 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       254,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "10:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "10:49 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:52 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:58 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:00 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:07 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "11:12 AM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "11:22 AM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "11:27 AM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "CAMP THATTAPARAI",
//         "time": "11:30 AM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "11:33 AM",
//         "id": 252
//       },
//       {
//         "no": 15,
//         "name": "UMARIKOTTAI",
//         "time": "11:40 AM",
//         "id": 274
//       },
//       {
//         "no": 17,
//         "name": "VARADHARAJAPURAM",
//         "time": "11:46 AM",
//         "id": 275
//       },
//       {
//         "no": 19,
//         "name": "CHOCKALINGAPURAM",
//         "time": "11:55 AM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-A-14-566",
//     "routeNo": "58-A",
//     "code": "58/P58A-3",
//     "tripCode": "58/P58A-358-ATORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:00 PM",
//     "endTime": "01:15 PM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       254,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "CHOCKALINGAPURAM",
//         "time": "12:00 PM",
//         "id": 276
//       },
//       {
//         "no": 17,
//         "name": "VARADHARAJAPURAM",
//         "time": "12:09 PM",
//         "id": 275
//       },
//       {
//         "no": 15,
//         "name": "UMARIKOTTAI",
//         "time": "12:15 PM",
//         "id": 274
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "12:23 PM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "CAMP THATTAPARAI",
//         "time": "12:26 PM",
//         "id": 254
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "12:29 PM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "12:35 PM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "12:45 PM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:50 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:57 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:00 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:07 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:10 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-1-567",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NORTH SILUKKANPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:30 PM",
//     "endTime": "01:00 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       297,
//       235,
//       298,
//       237,
//       238
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "12:34 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:37 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:43 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "12:47 PM",
//         "id": 297
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "12:51 PM",
//         "id": 235
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "12:57 PM",
//         "id": 298
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "12:58 PM",
//         "id": 237
//       },
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "01:00 PM",
//         "id": 238
//       }
//     ]
//   },
//   {
//     "id": "58-B-2-568",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "NORTH SILUKKANPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:15 PM",
//     "endTime": "01:55 PM",
//     "ids": [
//       238,
//       237,
//       298,
//       235,
//       297,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "01:15 PM",
//         "id": 238
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "01:16 PM",
//         "id": 237
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "01:18 PM",
//         "id": 298
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "01:25 PM",
//         "id": 235
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "01:31 PM",
//         "id": 297
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:36 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "01:45 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "01:49 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "01:55 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-3-569",
//     "routeNo": "58-B",
//     "code": "58/P58B-1",
//     "tripCode": "58/P58B-158-BTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:00 PM",
//     "endTime": "03:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:00 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:04 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:07 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:15 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:17 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:24 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "02:30 PM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "02:40 PM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "02:46 PM",
//         "id": 252
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "02:54 PM",
//         "id": 274
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "03:00 PM",
//         "id": 275
//       },
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "03:10 PM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-B-4-570",
//     "routeNo": "58-B",
//     "code": "58/P58B-1",
//     "tripCode": "58/P58B-158-BTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "03:15 PM",
//     "endTime": "04:35 PM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "03:15 PM",
//         "id": 276
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "03:25 PM",
//         "id": 275
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "03:33 PM",
//         "id": 274
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "03:41 PM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "03:48 PM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "04:00 PM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "04:06 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "04:15 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "04:17 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:25 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:29 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:35 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-5-571",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NORTH SILUKKANPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:45 PM",
//     "endTime": "05:30 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       297,
//       235,
//       298,
//       237,
//       238
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:45 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "04:51 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "04:55 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:05 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "05:11 PM",
//         "id": 297
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "05:17 PM",
//         "id": 235
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "05:26 PM",
//         "id": 298
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "05:27 PM",
//         "id": 237
//       },
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "05:30 PM",
//         "id": 238
//       }
//     ]
//   },
//   {
//     "id": "58-B-6-572",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "NORTH SILUKKANPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:35 PM",
//     "endTime": "06:30 PM",
//     "ids": [
//       238,
//       237,
//       298,
//       235,
//       297,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "05:35 PM",
//         "id": 238
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "05:37 PM",
//         "id": 237
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "05:39 PM",
//         "id": 298
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "05:49 PM",
//         "id": 235
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "05:57 PM",
//         "id": 297
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:05 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:16 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:22 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:30 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-7-573",
//     "routeNo": "58-B",
//     "code": "58/P58B-1",
//     "tripCode": "58/P58B-158-BTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:40 PM",
//     "endTime": "08:00 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:40 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:45 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:49 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:57 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:59 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:08 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "07:14 PM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "07:26 PM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "07:33 PM",
//         "id": 252
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "07:41 PM",
//         "id": 274
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "07:49 PM",
//         "id": 275
//       },
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "08:00 PM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-B-8-574",
//     "routeNo": "58-B",
//     "code": "58/P58B-1",
//     "tripCode": "58/P58B-158-BTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 PM",
//     "endTime": "09:15 PM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "08:05 PM",
//         "id": 276
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "08:14 PM",
//         "id": 275
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "08:20 PM",
//         "id": 274
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "08:28 PM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "08:34 PM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "08:44 PM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:50 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:57 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:59 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:07 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:10 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-9-575",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NORTH SILUKKANPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:20 PM",
//     "endTime": "09:45 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       297,
//       235,
//       298,
//       237,
//       238
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:20 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:23 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:25 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:31 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "09:34 PM",
//         "id": 297
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "09:38 PM",
//         "id": 235
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "09:42 PM",
//         "id": 298
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "09:43 PM",
//         "id": 237
//       },
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "09:45 PM",
//         "id": 238
//       }
//     ]
//   },
//   {
//     "id": "58-B-10-576",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "NORTH SILUKKANPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:50 PM",
//     "endTime": "04:55 AM",
//     "ids": [
//       238,
//       237,
//       298,
//       235,
//       297,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "09:50 PM",
//         "id": 238
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "10:09 PM",
//         "id": 237
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "10:27 PM",
//         "id": 298
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "11:44 PM",
//         "id": 235
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "12:40 AM",
//         "id": 297
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "01:42 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:14 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "03:56 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "04:55 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-11-577",
//     "routeNo": "58-B",
//     "code": "58/P58B-2",
//     "tripCode": "58/P58B-258-BTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:00 AM",
//     "endTime": "06:10 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       254,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:00 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:04 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:07 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:13 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:15 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:22 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "05:27 AM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "05:37 AM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "05:42 AM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "CAMP THATTAPARAI",
//         "time": "05:45 AM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "05:48 AM",
//         "id": 252
//       },
//       {
//         "no": 15,
//         "name": "UMARIKOTTAI",
//         "time": "05:55 AM",
//         "id": 274
//       },
//       {
//         "no": 17,
//         "name": "VARADHARAJAPURAM",
//         "time": "06:01 AM",
//         "id": 275
//       },
//       {
//         "no": 19,
//         "name": "CHOCKALINGAPURAM",
//         "time": "06:10 AM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-B-12-578",
//     "routeNo": "58-B",
//     "code": "58/P58B-2",
//     "tripCode": "58/P58B-258-BTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:15 AM",
//     "endTime": "07:35 AM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       254,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 19,
//         "name": "CHOCKALINGAPURAM",
//         "time": "06:15 AM",
//         "id": 276
//       },
//       {
//         "no": 17,
//         "name": "VARADHARAJAPURAM",
//         "time": "06:24 AM",
//         "id": 275
//       },
//       {
//         "no": 15,
//         "name": "UMARIKOTTAI",
//         "time": "06:31 AM",
//         "id": 274
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "06:39 AM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "CAMP THATTAPARAI",
//         "time": "06:42 AM",
//         "id": 254
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "06:46 AM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "06:52 AM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "07:03 AM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:08 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:16 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:19 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:26 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:30 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:35 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-13-579",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18U13",
//     "order": 13,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "NORTH SILUKKANPATTI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:45 AM",
//     "endTime": "08:20 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       297,
//       235,
//       298,
//       237,
//       238
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "07:45 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "07:49 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "07:53 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:00 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "08:05 AM",
//         "id": 297
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "08:10 AM",
//         "id": 235
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "08:16 AM",
//         "id": 298
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "08:18 AM",
//         "id": 237
//       },
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "08:20 AM",
//         "id": 238
//       }
//     ]
//   },
//   {
//     "id": "58-B-14-580",
//     "routeNo": "58-B",
//     "code": "58/P58B-3",
//     "tripCode": "58/P58B-358-BTORD18D14",
//     "order": 14,
//     "direction": "D",
//     "from": "NORTH SILUKKANPATTI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:25 AM",
//     "endTime": "09:30 AM",
//     "ids": [
//       238,
//       237,
//       298,
//       235,
//       297,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 9,
//         "name": "NORTH SILUKKANPATTI",
//         "time": "08:25 AM",
//         "id": 238
//       },
//       {
//         "no": 8,
//         "name": "MADATTHUPATTI",
//         "time": "08:28 AM",
//         "id": 237
//       },
//       {
//         "no": 7,
//         "name": "MUTHUSAMYPURAM",
//         "time": "08:30 AM",
//         "id": 298
//       },
//       {
//         "no": 6,
//         "name": "RAMANACCHIYARPURAM",
//         "time": "08:42 AM",
//         "id": 235
//       },
//       {
//         "no": 5,
//         "name": "KAILASAPURAM",
//         "time": "08:51 AM",
//         "id": 297
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:00 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:14 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:21 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-B-15-581",
//     "routeNo": "58-B",
//     "code": "58/P58B-1",
//     "tripCode": "58/P58B-158-BTORD18U15",
//     "order": 15,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHOCKALINGAPURAM",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:40 AM",
//     "endTime": "11:00 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       250,
//       251,
//       252,
//       274,
//       275,
//       276
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:40 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:45 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:49 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:57 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:59 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "10:08 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "10:14 AM",
//         "id": 250
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "10:26 AM",
//         "id": 251
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "10:33 AM",
//         "id": 252
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "10:41 AM",
//         "id": 274
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "10:49 AM",
//         "id": 275
//       },
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "11:00 AM",
//         "id": 276
//       }
//     ]
//   },
//   {
//     "id": "58-B-16-582",
//     "routeNo": "58-B",
//     "code": "58/P58B-1",
//     "tripCode": "58/P58B-158-BTORD18D16",
//     "order": 16,
//     "direction": "D",
//     "from": "CHOCKALINGAPURAM",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "11:10 AM",
//     "endTime": "12:15 PM",
//     "ids": [
//       276,
//       275,
//       274,
//       252,
//       251,
//       250,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHOCKALINGAPURAM",
//         "time": "11:10 AM",
//         "id": 276
//       },
//       {
//         "no": 15,
//         "name": "VARADHARAJAPURAM",
//         "time": "11:18 AM",
//         "id": 275
//       },
//       {
//         "no": 13,
//         "name": "UMARIKOTTAI",
//         "time": "11:24 AM",
//         "id": 274
//       },
//       {
//         "no": 11,
//         "name": "MELA THATTAPARAI",
//         "time": "11:31 AM",
//         "id": 252
//       },
//       {
//         "no": 10,
//         "name": "KEELA THATTAPARAI",
//         "time": "11:37 AM",
//         "id": 251
//       },
//       {
//         "no": 7,
//         "name": "SILUKKAN PATTI",
//         "time": "11:47 AM",
//         "id": 250
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:51 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:58 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:00 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:07 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "12:10 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:15 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-C-1-583",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18U1",
//     "order": 1,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "12:05 PM",
//     "endTime": "01:10 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       254,
//       196,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:05 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "12:09 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "12:12 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "12:18 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "12:20 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:27 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:31 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:34 PM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "12:39 PM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "12:49 PM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "12:54 PM",
//         "id": 252
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "12:57 PM",
//         "id": 254
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "01:07 PM",
//         "id": 196
//       },
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:10 PM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "58-C-2-584",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18D2",
//     "order": 2,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "01:15 PM",
//     "endTime": "02:45 PM",
//     "ids": [
//       74,
//       196,
//       254,
//       252,
//       251,
//       250,
//       6,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "01:15 PM",
//         "id": 74
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "01:18 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "01:32 PM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "01:36 PM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "01:43 PM",
//         "id": 251
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "01:57 PM",
//         "id": 250
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:03 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "02:08 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "02:13 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "02:23 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "02:25 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "02:35 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:39 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:45 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-C-3-585",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18U3",
//     "order": 3,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "02:50 PM",
//     "endTime": "04:30 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       254,
//       196,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "02:50 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "02:56 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "03:01 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "03:11 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "03:14 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:24 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "03:30 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "03:35 PM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "03:43 PM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "03:57 PM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "04:06 PM",
//         "id": 252
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "04:10 PM",
//         "id": 254
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "04:26 PM",
//         "id": 196
//       },
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:30 PM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "58-C-4-586",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18D4",
//     "order": 4,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "04:35 PM",
//     "endTime": "05:50 PM",
//     "ids": [
//       74,
//       196,
//       254,
//       252,
//       251,
//       250,
//       6,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "04:35 PM",
//         "id": 74
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "04:37 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "04:49 PM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "04:52 PM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "04:59 PM",
//         "id": 251
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "05:10 PM",
//         "id": 250
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:15 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "05:19 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "05:23 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "05:31 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "05:34 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "05:41 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:45 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:50 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-C-5-587",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18U5",
//     "order": 5,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:55 PM",
//     "endTime": "07:00 PM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       254,
//       196,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "05:55 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "05:59 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:02 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:08 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:10 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:17 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:21 PM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:24 PM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "06:29 PM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "06:39 PM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "06:44 PM",
//         "id": 252
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "06:47 PM",
//         "id": 254
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "06:57 PM",
//         "id": 196
//       },
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:00 PM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "58-C-6-588",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18D6",
//     "order": 6,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "07:15 PM",
//     "endTime": "09:25 PM",
//     "ids": [
//       74,
//       196,
//       254,
//       252,
//       251,
//       250,
//       6,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "07:15 PM",
//         "id": 74
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "07:19 PM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "07:40 PM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "07:45 PM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "07:56 PM",
//         "id": 251
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "08:15 PM",
//         "id": 250
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:25 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:32 PM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:39 PM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:53 PM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:57 PM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:10 PM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:16 PM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:25 PM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-C-7-589",
//     "routeNo": "58-C",
//     "code": "58/P58C-2",
//     "tripCode": "58/P58C-258-CTORD18U7",
//     "order": 7,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:30 PM",
//     "endTime": "05:00 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       253,
//       254,
//       196,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:30 PM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "09:56 PM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "10:16 PM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "10:58 PM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:11 PM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:54 PM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "12:17 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "12:40 AM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "01:10 AM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "02:11 AM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "02:47 AM",
//         "id": 252
//       },
//       {
//         "no": 14,
//         "name": "CHETTIYOORANI",
//         "time": "03:18 AM",
//         "id": 253
//       },
//       {
//         "no": 15,
//         "name": "CAMP THATTAPARAI",
//         "time": "03:39 AM",
//         "id": 254
//       },
//       {
//         "no": 17,
//         "name": "VALLINAYAGIPURAM",
//         "time": "04:45 AM",
//         "id": 196
//       },
//       {
//         "no": 18,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:00 AM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "58-C-8-590",
//     "routeNo": "58-C",
//     "code": "58/P58C-2",
//     "tripCode": "58/P58C-258-CTORD18D8",
//     "order": 8,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "05:15 AM",
//     "endTime": "06:45 AM",
//     "ids": [
//       74,
//       196,
//       254,
//       253,
//       252,
//       251,
//       250,
//       6,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 18,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "05:15 AM",
//         "id": 74
//       },
//       {
//         "no": 17,
//         "name": "VALLINAYAGIPURAM",
//         "time": "05:17 AM",
//         "id": 196
//       },
//       {
//         "no": 15,
//         "name": "CAMP THATTAPARAI",
//         "time": "05:31 AM",
//         "id": 254
//       },
//       {
//         "no": 14,
//         "name": "CHETTIYOORANI",
//         "time": "05:35 AM",
//         "id": 253
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "05:41 AM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "05:48 AM",
//         "id": 251
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "06:00 AM",
//         "id": 250
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:06 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "06:11 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "06:16 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "06:24 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "06:27 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:35 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:39 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:45 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-C-9-591",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18U9",
//     "order": 9,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "PUTHIYAMPUTHUR",
//     "service": "TOWN ORDINARY",
//     "startTime": "06:50 AM",
//     "endTime": "08:00 AM",
//     "ids": [
//       1,
//       29,
//       39,
//       4,
//       5,
//       6,
//       278,
//       6,
//       250,
//       251,
//       252,
//       254,
//       196,
//       74
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "06:50 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "06:54 AM",
//         "id": 29
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "06:57 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "07:04 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "07:07 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:14 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "07:18 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "07:22 AM",
//         "id": 6
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "07:27 AM",
//         "id": 250
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "07:37 AM",
//         "id": 251
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "07:43 AM",
//         "id": 252
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "07:46 AM",
//         "id": 254
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "07:57 AM",
//         "id": 196
//       },
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:00 AM",
//         "id": 74
//       }
//     ]
//   },
//   {
//     "id": "58-C-10-592",
//     "routeNo": "58-C",
//     "code": "58/P58C-1",
//     "tripCode": "58/P58C-158-CTORD18D10",
//     "order": 10,
//     "direction": "D",
//     "from": "PUTHIYAMPUTHUR",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "08:05 AM",
//     "endTime": "09:00 AM",
//     "ids": [
//       74,
//       196,
//       254,
//       252,
//       251,
//       250,
//       6,
//       278,
//       6,
//       5,
//       4,
//       39,
//       29,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "PUTHIYAMPUTHUR",
//         "time": "08:05 AM",
//         "id": 74
//       },
//       {
//         "no": 16,
//         "name": "VALLINAYAGIPURAM",
//         "time": "08:06 AM",
//         "id": 196
//       },
//       {
//         "no": 14,
//         "name": "CAMP THATTAPARAI",
//         "time": "08:15 AM",
//         "id": 254
//       },
//       {
//         "no": 13,
//         "name": "MELA THATTAPARAI",
//         "time": "08:17 AM",
//         "id": 252
//       },
//       {
//         "no": 12,
//         "name": "KEELA THATTAPARAI",
//         "time": "08:22 AM",
//         "id": 251
//       },
//       {
//         "no": 9,
//         "name": "SILUKKAN PATTI",
//         "time": "08:30 AM",
//         "id": 250
//       },
//       {
//         "no": 8,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:34 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "08:37 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "08:40 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "08:46 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "08:48 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "08:53 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "MILLER PURAM",
//         "time": "08:56 AM",
//         "id": 29
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:00 AM",
//         "id": 1
//       }
//     ]
//   },
//   {
//     "id": "58-C-11-593",
//     "routeNo": "58-C",
//     "code": "58/P58C-3",
//     "tripCode": "58/P58C-358-CTORD18U11",
//     "order": 11,
//     "direction": "U",
//     "from": "THOOTHUKUDI",
//     "to": "CHEKKARAKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "09:10 AM",
//     "endTime": "10:20 AM",
//     "ids": [
//       1,
//       2,
//       39,
//       4,
//       5,
//       6,
//       278,
//       21,
//       241,
//       23,
//       24,
//       243,
//       303,
//       304,
//       244,
//       245
//     ],
//     "stops": [
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "09:10 AM",
//         "id": 1
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "09:14 AM",
//         "id": 2
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "09:18 AM",
//         "id": 39
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "09:25 AM",
//         "id": 4
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "09:27 AM",
//         "id": 5
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "09:35 AM",
//         "id": 6
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "09:39 AM",
//         "id": 278
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "09:44 AM",
//         "id": 21
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "09:44 AM",
//         "id": 241
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "09:54 AM",
//         "id": 23
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "09:59 AM",
//         "id": 24
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "10:02 AM",
//         "id": 243
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "10:07 AM",
//         "id": 303
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "10:13 AM",
//         "id": 304
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "10:17 AM",
//         "id": 244
//       },
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "10:20 AM",
//         "id": 245
//       }
//     ]
//   },
//   {
//     "id": "58-C-12-594",
//     "routeNo": "58-C",
//     "code": "58/P58C-3",
//     "tripCode": "58/P58C-358-CTORD18D12",
//     "order": 12,
//     "direction": "D",
//     "from": "CHEKKARAKUDI",
//     "to": "THOOTHUKUDI",
//     "service": "TOWN ORDINARY",
//     "startTime": "10:25 AM",
//     "endTime": "12:00 PM",
//     "ids": [
//       245,
//       244,
//       304,
//       303,
//       243,
//       24,
//       23,
//       241,
//       21,
//       278,
//       6,
//       5,
//       4,
//       39,
//       2,
//       1
//     ],
//     "stops": [
//       {
//         "no": 17,
//         "name": "CHEKKARAKUDI",
//         "time": "10:25 AM",
//         "id": 245
//       },
//       {
//         "no": 15,
//         "name": "MAHILAMPURAM",
//         "time": "10:28 AM",
//         "id": 244
//       },
//       {
//         "no": 14,
//         "name": "THALAVAIPURAM 2",
//         "time": "10:34 AM",
//         "id": 304
//       },
//       {
//         "no": 13,
//         "name": "PUDHUR 2",
//         "time": "10:41 AM",
//         "id": 303
//       },
//       {
//         "no": 12,
//         "name": "SAMATTHUVAPURAM",
//         "time": "10:49 AM",
//         "id": 243
//       },
//       {
//         "no": 11,
//         "name": "PEROORANI",
//         "time": "10:52 AM",
//         "id": 24
//       },
//       {
//         "no": 10,
//         "name": "THIRUVANANDHA PURAM",
//         "time": "10:59 AM",
//         "id": 23
//       },
//       {
//         "no": 9,
//         "name": "KOOTTUDANKADU",
//         "time": "11:13 AM",
//         "id": 241
//       },
//       {
//         "no": 8,
//         "name": "MANGALAGIRI",
//         "time": "11:13 AM",
//         "id": 21
//       },
//       {
//         "no": 7,
//         "name": "PUDHUKOTTAI 2",
//         "time": "11:20 AM",
//         "id": 278
//       },
//       {
//         "no": 6,
//         "name": "THATTAPARAI JUNCTION",
//         "time": "11:25 AM",
//         "id": 6
//       },
//       {
//         "no": 5,
//         "name": "ANTHONIYARPURAM",
//         "time": "11:36 AM",
//         "id": 5
//       },
//       {
//         "no": 4,
//         "name": "KORAMPALLAM",
//         "time": "11:39 AM",
//         "id": 4
//       },
//       {
//         "no": 3,
//         "name": "3RD MILE",
//         "time": "11:49 AM",
//         "id": 39
//       },
//       {
//         "no": 2,
//         "name": "VOC COLLEGE",
//         "time": "11:53 AM",
//         "id": 2
//       },
//       {
//         "no": 1,
//         "name": "THOOTHUKUDI OLD B/S",
//         "time": "12:00 PM",
//         "id": 1
//       }
//     ]
//   }
// ];

// const VEHICLES = Object.keys(VEHICLE_ROUTE_MAP);

// function normalizeVehicleNo(v) {
//   return String(v || "").trim().toUpperCase().replace(/\s+/g, "");
// }

// function normalizeRouteNo(v) {
//   const s = String(v || "").trim().toUpperCase().replace(/\s+/g, "");
//   if (!s) return "";
//   const detailed = s.match(/^(\d+)\/P\d+([A-Z])-\d+/);
//   if (detailed) return `${detailed[1]}-${detailed[2]}`;
//   const compact = s.match(/^(\d+)[-/]?([A-Z])$/);
//   if (compact) return `${compact[1]}-${compact[2]}`;
//   return s;
// }

// function canonicalRoute(code) {
//   return String(code || "").trim().toUpperCase().replace(/\s+/g, "");
// }

// const ROUTE_NO_BY_CODE = ROUTE_TRIPS.reduce((acc, trip) => {
//   if (trip.code && trip.routeNo) acc[trip.code] = trip.routeNo;
//   return acc;
// }, {});

// function routeNoFromRouteCode(code) {
//   const raw = String(code || "").trim().toUpperCase().replace(/\s+/g, "");
//   if (!raw) return "";
//   if (ROUTE_NO_BY_CODE[raw]) return ROUTE_NO_BY_CODE[raw];
//   return normalizeRouteNo(raw);
// }

// function getAssignedRouteValue(vehicleno, assignments = {}) {
//   const vehicleNo = normalizeVehicleNo(vehicleno);
//   return (
//     assignments?.[vehicleNo] ||
//     assignments?.[vehicleno] ||
//     VEHICLE_ROUTE_MAP[vehicleNo] ||
//     ""
//   );
// }

// function getBusRouteNo(vehicleno, assignments = {}) {
//   return routeNoFromRouteCode(getAssignedRouteValue(vehicleno, assignments));
// }

// function getRouteDisplayLabel(routeValue) {
//   const routeNo = routeNoFromRouteCode(routeValue);
//   const route = ROUTES.find((r) => r.code === routeNo);
//   return route?.label || routeNo || "Unassigned";
// }

// function routeCandidatesForValue(routeValue) {
//   const raw = String(routeValue || "").trim().toUpperCase().replace(/\s+/g, "");
//   const routeNo = routeNoFromRouteCode(raw);

//   const exactCodeMatches = ROUTE_TRIPS.filter((trip) => trip.code === raw);
//   if (exactCodeMatches.length) return exactCodeMatches;

//   return ROUTE_TRIPS.filter((trip) => trip.routeNo === routeNo);
// }

// // ---- Leaflet default icon fix ----
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });

// // ---- Utility helpers ----
// const createCustomIcon = (iconUrl, size = [40, 40]) =>
//   L.icon({
//     iconUrl,
//     iconSize: size,
//     iconAnchor: [size[0] / 2, size[1]],
//     popupAnchor: [0, -size[1] / 2]
//   });

// const userIconInstance = createCustomIcon(userIcon, [40, 40]);

// const toHeading = (v) => {
//   const n = Number(v);
//   return Number.isFinite(n) ? ((n % 360) + 360) % 360 : null;
// };

// const toFiniteNumber = (value) => {
//   if (value === null || value === undefined || value === '') return null;
//   const n = Number(value);
//   return Number.isFinite(n) ? n : null;
// };

// function normalizeLatLng(latValue, lngValue) {
//   const lat = toFiniteNumber(latValue);
//   const lng = toFiniteNumber(lngValue);
//   if (lat === null || lng === null) return null;
//   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
//   return { lat, lng };
// }

// function hasValidLatLng(value) {
//   return !!normalizeLatLng(value?.lat, value?.lng);
// }

// // Exponential smoothing for latitude/longitude
// function smoothCoord(prev, next, alpha = SMOOTH_ALPHA) {
//   const safeNext = normalizeLatLng(next?.lat, next?.lng);
//   if (!safeNext) return normalizeLatLng(prev?.lat, prev?.lng);

//   const safePrev = normalizeLatLng(prev?.lat, prev?.lng);
//   if (!safePrev) return safeNext;

//   return {
//     lat: safePrev.lat + alpha * (safeNext.lat - safePrev.lat),
//     lng: safePrev.lng + alpha * (safeNext.lng - safePrev.lng)
//   };
// }



// // Circular smoothing for heading (degrees)
// function smoothHeading(prevDeg, nextDeg, alpha = HEADING_ALPHA) {
//   if (!Number.isFinite(prevDeg)) return nextDeg;
//   if (!Number.isFinite(nextDeg)) return prevDeg;
//   const p = (prevDeg * Math.PI) / 180;
//   const n = (nextDeg * Math.PI) / 180;
//   const x = (1 - alpha) * Math.cos(p) + alpha * Math.cos(n);
//   const y = (1 - alpha) * Math.sin(p) + alpha * Math.sin(n);
//   const ang = (Math.atan2(y, x) * 180) / Math.PI;
//   return (((ang % 360) + 360) % 360);
// }
// function mBetween(a, b) {
//   const aa = normalizeLatLng(a?.lat, a?.lng);
//   const bb = normalizeLatLng(b?.lat, b?.lng);
//   if (!aa || !bb) return Infinity;
//   return L.latLng(aa.lat, aa.lng).distanceTo(L.latLng(bb.lat, bb.lng));
// }

// // ---- Cart classification (case-insensitive "EV") ----
// function isCart(vehicleno) {
//   const s = String(vehicleno || '').trim();
//   return s.toUpperCase().startsWith('EV');
// }

// // Label: B for Bus, C for Cart
// // function vehicleLabel(vehicleno) { return isCart(vehicleno) ? 'C' : 'B'; }
// function vehicleLabel(vehicleno, routeCode) {
//   if (!isCart(vehicleno)) return "B";

//   const rc = canonicalRoute(routeCode || "");
//   if (rc === "RP_ED" || rc === "ED_RP") return "CR"; // 👈 cart on RP↔ED
//   return "C";
// }


// // ---- Block IDs starting with a digit ----
// function startsWithDigit(vehicleno) { return /^[0-9]/.test(String(vehicleno || '')); }

// // ---- Direction pointer “on the circle” DivIcon ----
// // function createVehicleDivIcon(label, headingDeg) {
// //   const circle = 20;
// //   const border = 3;
// //   const triH = 18;
// //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// //   const totalH = triH + circle;

// //   const html = `
// //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// //       <div style="
// //         position:absolute; left:0; right:0; bottom:0;
// //         width:${circle}px; height:${circle}px;
// //         border:${border}px solid #0D47A1; background:#ffffff; border-radius:50%;
// //         display:flex; align-items:center; justify-content:center;
// //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// //         letter-spacing:0.6px; user-select:none;">
// //         <span style="font-size:16px; color:#0D47A1">${label}</span>
// //       </div>
// //       <div style="
// //         position:absolute; left:50%; top:0;
// //         transform: translateX(-250%) rotate(${rot}deg);
// //         transform-origin: 50% ${triH * 0.7}px;
// //         width:0; height:0;
// //         border-left:${triH / 4}px solid transparent;
// //         border-right:${triH / 4}px solid transparent;
// //         border-bottom:${triH}px solid #0D47A1;
// //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// //         z-index: 2; pointer-events: none;"></div>
// //     </div>
// //   `;

// //   return L.divIcon({
// //     className: 'veh-div-icon',
// //     html,
// //     iconSize: [circle, totalH],
// //     iconAnchor: [circle / 2, totalH - circle / 2],
// //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// //   });
// // }

// function createVehicleDivIcon(label, headingDeg, palette) {
//   const circle = 20;
//   const border = 3;
//   const triH = 18;
//   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
//   const totalH = triH + circle;

//   // default bus palette
//   const p = palette || {
//     stroke: "#0D47A1",
//     fill: "#ffffff",
//     text: "#0D47A1",
//     pointer: "#0D47A1",
//   };

//   const html = `
//     <div style="position:relative;width:${circle}px;height:${totalH}px">
//       <div style="
//         position:absolute; left:0; right:0; bottom:0;
//         width:${circle}px; height:${circle}px;
//         border:${border}px solid ${p.stroke};
//         background:${p.fill};
//         border-radius:50%;
//         display:flex; align-items:center; justify-content:center;
//         box-shadow:0 2px 8px rgba(0,0,0,0.25);
//         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
//         letter-spacing:0.6px; user-select:none;">
//         <span style="font-size:16px; color:${p.text}">${label}</span>
//       </div>
//       <div style="
//         position:absolute; left:50%; top:0;
//         transform: translateX(-250%) rotate(${rot}deg);
//         transform-origin: 50% ${triH * 0.7}px;
//         width:0; height:0;
//         border-left:${triH / 4}px solid transparent;
//         border-right:${triH / 4}px solid transparent;
//         border-bottom:${triH}px solid ${p.pointer};
//         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
//         z-index: 2; pointer-events: none;"></div>
//     </div>
//   `;

//   return L.divIcon({
//     className: 'veh-div-icon',
//     html,
//     iconSize: [circle, totalH],
//     iconAnchor: [circle / 2, totalH - circle / 2],
//     popupAnchor: [0, -(circle / 2 + triH / 2)]
//   });
// }

// // const BUS_PALETTE = {
// //   stroke: "#0D47A1",
// //   fill: "#ffffff",
// //   text: "#0D47A1",
// //   pointer: "#0D47A1",
// // };

// // const BUS_PALETTE = {
// //   stroke: "#EA580C",   // orange bus border
// //   fill: "#FFF7ED",     // light orange fill
// //   text: "#9A3412",
// //   pointer: "#EA580C",
// // };

// // const CART_PALETTE = {
// //   stroke: "#0F766E",  // teal border
// //   fill: "#ECFEFF",    // light teal fill
// //   text: "#0F766E",
// //   pointer: "#0F766E",
// // };
// const CART_PALETTE = {
//   stroke: "#111827",   // near-black border
//   fill: "#FEF08A",   // bright yellow fill
//   text: "#111827",   // black text
//   pointer: "#111827",   // black pointer
// };

// const BUS_PALETTE = {
//   stroke: "#111827",   // near-black border
//   fill: "#FEF08A",   // bright yellow fill
//   text: "#111827",   // black text
//   pointer: "#111827",   // black pointer
// };



// function matchesFilter(vehicleno, filter, assignments) {
//   const cart = isCart(vehicleno);
//   if (filter === "cart") return cart;
//   if (filter === "bus") return !cart;

//   if (filter?.startsWith("route:")) {
//     const requested = normalizeRouteNo(filter.slice(6));
//     const actualRouteNo = normalizeRouteNo(getBusRouteNo(vehicleno, assignments));
//     const assignedRaw = getAssignedRouteValue(vehicleno, assignments);
//     const assignedRouteNo = normalizeRouteNo(routeNoFromRouteCode(assignedRaw));

//     return actualRouteNo === requested || assignedRouteNo === requested;
//   }
//   return true;
// }

// // ---- Filter helper ----
// // function matchesFilter(vehicleno, filter, assignments) {
// //   const cart = isCart(vehicleno);
// //   if (filter === 'cart') return cart;
// //   if (filter === 'bus')  return !cart;
// //   if (filter?.startsWith('route:')) {
// //     const code = filter.slice(6);
// //     return assignments[vehicleno] === code;
// //   }
// //   return true;
// // }

// // ---------------- Tiny router helpers (for /driver, /driverRoute) ----------------
// function usePath() {
//   const [path, setPath] = useState(window.location.pathname);
//   useEffect(() => {
//     const onPop = () => setPath(window.location.pathname);
//     window.addEventListener('popstate', onPop);
//     return () => window.removeEventListener('popstate', onPop);
//   }, []);
//   const navigate = (p) => { if (p !== window.location.pathname) { window.history.pushState({}, "", p); setPath(p); } };
//   return { path, navigate };
// }
// function getToken() { return localStorage.getItem("driverToken") || ""; }
// function setToken(t) { localStorage.setItem("driverToken", t || ""); }
// function getUsername() { return localStorage.getItem("driverUsername") || ""; }
// function setUsername(u) { localStorage.setItem("driverUsername", u || ""); }

// // --- Admin auth helpers (separate from driver) ---
// function getAdminToken() {
//   return localStorage.getItem("adminToken") || "";
// }
// function setAdminToken(t) {
//   localStorage.setItem("adminToken", t || "");
// }


// // ---------------- Driver pages ----------------
// // --- small responsive hook for narrow phones ---
// function useIsNarrow(bp = 380) {
//   const [isNarrow, setIsNarrow] = useState(window.innerWidth <= bp);
//   useEffect(() => {
//     const onResize = () => setIsNarrow(window.innerWidth <= bp);
//     window.addEventListener('resize', onResize);
//     return () => window.removeEventListener('resize', onResize);
//   }, [bp]);
//   return isNarrow;
// }

// function DriverLogin({ navigate }) {
//   const [username, setU] = useState("");
//   const [password, setP] = useState("");
//   const [err, setErr] = useState("");
//   const [busy, setBusy] = useState(false);
//   const isNarrow = useIsNarrow(380);

//   useEffect(() => {
//     if (getToken()) navigate("/driverRoute");
//   }, [navigate]);

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setErr(""); setBusy(true);
//     try {
//       const r = await axios.post(`${BACKEND}/api/driver/login`, { username, password });
//       if (r.data?.success && r.data?.token) {
//         setToken(r.data.token);
//         setUsername(r.data.username);
//         navigate("/driverRoute");
//       } else setErr("Login failed");
//     } catch (e1) {
//       setErr(e1?.response?.data?.message || "Login failed");
//     } finally { setBusy(false); }
//   };

//   return (
//     <div
//       style={{
//         padding: isNarrow ? 12 : 20,
//         margin: isNarrow ? "16px auto" : "32px auto",
//         width: "min(100vw - 24px, 560px)",
//       }}
//     >
//       {/* Header with Home button */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: isNarrow ? 10 : 12,
//           marginBottom: isNarrow ? 10 : 14,
//           flexWrap: "wrap",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
//           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Driver Login</h2>
//         </div>

//         <button
//           type="button"
//           onClick={() => navigate("/")}
//           style={{
//             marginLeft: "auto",
//             padding: isNarrow ? "6px 10px" : "8px 12px",
//             borderRadius: 10,
//             border: "1px solid #D1D5DB",
//             background: "#FFFFFF",
//             fontWeight: 700,
//             fontSize: isNarrow ? 13 : 14,
//             cursor: "pointer",
//           }}
//           title="Go to Home"
//         >
//           Home
//         </button>
//       </div>

//       {/* Card */}
//       <div
//         style={{
//           background: "#fff",
//           border: "1px solid #E5E7EB",
//           borderRadius: 12,
//           padding: isNarrow ? 12 : 16,
//         }}
//       >
//         <form onSubmit={onSubmit} style={{ display: "grid", gap: isNarrow ? 8 : 10 }}>
//           <input
//             value={username}
//             onChange={(e) => setU(e.target.value)}
//             placeholder="username"
//             required
//             style={{
//               padding: isNarrow ? 10 : 12,
//               borderRadius: 10,
//               border: "1px solid #D1D5DB",
//               fontWeight: 600,
//               fontSize: isNarrow ? 14 : 16,
//             }}
//           />
//           <input
//             value={password}
//             onChange={(e) => setP(e.target.value)}
//             placeholder="password"
//             type="password"
//             required
//             style={{
//               padding: isNarrow ? 10 : 12,
//               borderRadius: 10,
//               border: "1px solid #D1D5DB",
//               fontWeight: 600,
//               fontSize: isNarrow ? 14 : 16,
//             }}
//           />
//           <button
//             disabled={busy}
//             style={{
//               padding: isNarrow ? "10px 12px" : "12px 14px",
//               borderRadius: 10,
//               border: "1px solid #0D47A1",
//               background: "#0D47A1",
//               color: "#fff",
//               fontWeight: 800,
//               cursor: "pointer",
//               width: "100%",
//               minHeight: 40,
//               fontSize: "clamp(14px, 3.5vw, 16px)",
//             }}
//           >
//             {busy ? "Signing in..." : "Login"}
//           </button>
//           {err && <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>}
//         </form>
//       </div>
//     </div>
//   );
// }

// function DriverRoute({ navigate }) {
//   const [routeCode, setRouteCode] = useState("");
//   const [vehicleNo, setVehicleNo] = useState("");
//   const [autoPilot, setAutoPilot] = useState(false); // 👈 NEW: auto-pilot flag
//   const [saved, setSaved] = useState(false);
//   const [busy, setBusy] = useState(false);
//   const [err, setErr] = useState("");
//   const isNarrow = useIsNarrow(380);

//   useEffect(() => {
//     if (!getToken()) navigate("/driver");
//     (async () => {
//       try {
//         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
//           headers: { Authorization: `Bearer ${getToken()}` },
//         });
//         const row = r.data?.row;
//         if (row) {
//           setVehicleNo(row.vehicleNo);
//           setRouteCode(row.routeCode);
//           setAutoPilot(!!row.autopilotEnabled); // 👈 load auto-pilot state from backend
//           setSaved(true);
//         }
//       } catch { }
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const onSave = async (e) => {
//     e.preventDefault();
//     setErr(""); setBusy(true);
//     try {
//       await axios.post(
//         `${BACKEND}/api/vehicle-route/assign`,
//         {
//           vehicleNo,
//           routeCode,
//           active: true,
//           autopilotEnabled: autoPilot, // 👈 send auto-pilot choice to backend
//         },
//         { headers: { Authorization: `Bearer ${getToken()}` } }
//       );
//       setSaved(true);
//     } catch (e1) {
//       setErr(e1?.response?.data?.message || "Save failed");
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: isNarrow ? 16 : 20,
//         maxWidth: 640,
//         margin: isNarrow ? "16px auto" : "32px auto",
//         width: "min(100vw - 24px, 640px)",
//       }}
//     >
//       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
//           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
//         </div>
//         <div
//           style={{
//             marginLeft: 'auto',
//             fontWeight: 700,
//             opacity: 0.8,
//             fontSize: "clamp(13px, 3.2vw, 16px)",
//             maxWidth: '60%',
//             overflow: 'hidden',
//             textOverflow: 'ellipsis',
//             whiteSpace: 'nowrap',
//           }}
//           title={`@${getUsername()}`}
//         >
//           @{getUsername()}
//         </div>
//       </div>

//       {/* Top-right actions */}
//       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
//         <div style={{ display: 'flex', gap: 8 }}>
//           <button
//             onClick={() => navigate('/')}
//             style={{
//               padding: isNarrow ? '6px 10px' : '8px 12px',
//               borderRadius: 10,
//               border: '1px solid #D1D5DB',
//               background: '#FFFFFF',
//               fontWeight: 700,
//               fontSize: isNarrow ? 13 : 14,
//               cursor: 'pointer'
//             }}
//             title="Go to Home"
//           >
//             Home
//           </button>
//           <button
//             type="button"
//             onClick={() => setSaved(false)}
//             disabled={!saved}
//             style={{
//               padding: isNarrow ? '6px 10px' : '8px 12px',
//               borderRadius: 10,
//               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
//               background: saved ? '#fff' : '#F9FAFB',
//               color: saved ? '#111' : '#9CA3AF',
//               fontWeight: 800,
//               fontSize: isNarrow ? 13 : 14,
//               cursor: saved ? 'pointer' : 'not-allowed'
//             }}
//             title="Edit selection"
//           >
//             Edit
//           </button>
//         </div>

//         <button
//           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
//           style={{
//             padding: isNarrow ? '6px 10px' : 8,
//             borderRadius: 10,
//             border: '1px solid #D1D5DB',
//             background: '#FFFFFF',
//             fontSize: isNarrow ? 13 : 14,
//             cursor: 'pointer'
//           }}
//           title="Logout"
//         >
//           Logout
//         </button>
//       </div>

//       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
//         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
//         <select
//           disabled={saved}
//           value={routeCode}
//           onChange={e => setRouteCode(e.target.value)}
//           required
//           style={{
//             padding: isNarrow ? 10 : 12,
//             borderRadius: 10,
//             border: '1px solid #D1D5DB',
//             fontSize: isNarrow ? 14 : 16
//           }}
//         >
//           <option value="">Select route…</option>
//           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
//         </select>

//         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
//         <select
//           disabled={saved}
//           value={vehicleNo}
//           onChange={e => setVehicleNo(e.target.value)}
//           required
//           style={{
//             padding: isNarrow ? 10 : 12,
//             borderRadius: 10,
//             border: '1px solid #D1D5DB',
//             fontSize: isNarrow ? 14 : 16
//           }}
//         >
//           <option value="">Select vehicle…</option>
//           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>

//         {/* 👇 NEW: Auto-pilot toggle */}
//         <div
//           style={{
//             marginTop: isNarrow ? 6 : 8,
//             padding: isNarrow ? 8 : 10,
//             borderRadius: 10,
//             border: '1px solid #E5E7EB',
//             background: '#F9FAFB',
//             display: 'flex',
//             alignItems: 'flex-start',
//             gap: 8,
//           }}
//         >
//           <input
//             id="autoPilot"
//             type="checkbox"
//             checked={autoPilot}
//             disabled={saved}
//             onChange={(e) => setAutoPilot(e.target.checked)}
//             style={{ marginTop: 3, cursor: saved ? 'default' : 'pointer' }}
//           />
//           <label
//             htmlFor="autoPilot"
//             style={{ cursor: saved ? 'default' : 'pointer' }}
//           >
//             <div style={{ fontWeight: 700, fontSize: isNarrow ? 14 : 15 }}>
//               Auto-pilot (auto reverse at destination)
//             </div>
//             <div
//               style={{
//                 fontSize: isNarrow ? 12 : 13,
//                 color: '#6B7280',
//                 marginTop: 2,
//               }}
//             >
//               When enabled, once you reach the last stop of this route, your
//               assignment will automatically switch to the return leg.
//             </div>
//           </label>
//         </div>

//         <button
//           disabled={busy || saved}
//           style={{
//             padding: isNarrow ? '10px 12px' : '12px 14px',
//             borderRadius: 10,
//             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
//             background: busy || saved ? '#F3F4F6' : '#0D47A1',
//             color: busy || saved ? '#6B7280' : '#fff',
//             fontWeight: 800,
//             cursor: busy || saved ? 'not-allowed' : 'pointer',
//             minHeight: 44,
//             fontSize: "clamp(14px, 3.5vw, 16px)"
//           }}
//           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
//         >
//           {busy ? "Saving…" : saved ? "Saved" : "Save"}
//         </button>

//         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
//       </form>
//     </div>
//   );
// }


// // function DriverRoute({ navigate }) {
// //   const [routeCode, setRouteCode] = useState("");
// //   const [vehicleNo, setVehicleNo] = useState("");
// //   const [saved, setSaved] = useState(false);
// //   const [busy, setBusy] = useState(false);
// //   const [err, setErr] = useState("");
// //   const isNarrow = useIsNarrow(380);

// //   useEffect(() => {
// //     if (!getToken()) navigate("/driver");
// //     (async () => {
// //       try {
// //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// //           headers: { Authorization: `Bearer ${getToken()}` },
// //         });
// //         const row = r.data?.row;
// //         if (row) { setVehicleNo(row.vehicleNo); setRouteCode(row.routeCode); setSaved(true); }
// //       } catch {}
// //     })();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const onSave = async (e) => {
// //     e.preventDefault();
// //     setErr(""); setBusy(true);
// //     try {
// //       await axios.post(
// //         `${BACKEND}/api/vehicle-route/assign`,
// //         { vehicleNo, routeCode, active: true },
// //         { headers: { Authorization: `Bearer ${getToken()}` } }
// //       );
// //       setSaved(true);
// //     } catch (e1) {
// //       setErr(e1?.response?.data?.message || "Save failed");
// //     } finally {
// //       setBusy(false);
// //     }
// //   };

// //   return (
// //     <div
// //       style={{
// //         padding: isNarrow ? 16 : 20,
// //         maxWidth: 640,
// //         margin: isNarrow ? "16px auto" : "32px auto",
// //         width: "min(100vw - 24px, 640px)",
// //       }}
// //     >
// //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// //         </div>
// //         <div
// //           style={{
// //             marginLeft: 'auto',
// //             fontWeight: 700,
// //             opacity: 0.8,
// //             fontSize: "clamp(13px, 3.2vw, 16px)",
// //             maxWidth: '60%',
// //             overflow: 'hidden',
// //             textOverflow: 'ellipsis',
// //             whiteSpace: 'nowrap',
// //           }}
// //           title={`@${getUsername()}`}
// //         >
// //           @{getUsername()}
// //         </div>
// //       </div>

// //       {/* Top-right actions */}
// //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// //         <div style={{ display: 'flex', gap: 8 }}>
// //           <button
// //             onClick={() => navigate('/')}
// //             style={{
// //               padding: isNarrow ? '6px 10px' : '8px 12px',
// //               borderRadius: 10,
// //               border: '1px solid #D1D5DB',
// //               background: '#FFFFFF',
// //               fontWeight: 700,
// //               fontSize: isNarrow ? 13 : 14,
// //               cursor: 'pointer'
// //             }}
// //             title="Go to Home"
// //           >
// //             Home
// //           </button>
// //           <button
// //             type="button"
// //             onClick={() => setSaved(false)}
// //             disabled={!saved}
// //             style={{
// //               padding: isNarrow ? '6px 10px' : '8px 12px',
// //               borderRadius: 10,
// //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// //               background: saved ? '#fff' : '#F9FAFB',
// //               color: saved ? '#111' : '#9CA3AF',
// //               fontWeight: 800,
// //               fontSize: isNarrow ? 13 : 14,
// //               cursor: saved ? 'pointer' : 'not-allowed'
// //             }}
// //             title="Edit selection"
// //           >
// //             Edit
// //           </button>
// //         </div>

// //         <button
// //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// //           style={{
// //             padding: isNarrow ? '6px 10px' : 8,
// //             borderRadius: 10,
// //             border: '1px solid #D1D5DB',
// //             background: '#FFFFFF',
// //             fontSize: isNarrow ? 13 : 14,
// //             cursor: 'pointer'
// //           }}
// //           title="Logout"
// //         >
// //           Logout
// //         </button>
// //       </div>

// //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// //         <select
// //           disabled={saved}
// //           value={routeCode}
// //           onChange={e=>setRouteCode(e.target.value)}
// //           required
// //           style={{
// //             padding: isNarrow ? 10 : 12,
// //             borderRadius: 10,
// //             border: '1px solid #D1D5DB',
// //             fontSize: isNarrow ? 14 : 16
// //           }}
// //         >
// //           <option value="">Select route…</option>
// //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// //         </select>

// //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// //         <select
// //           disabled={saved}
// //           value={vehicleNo}
// //           onChange={e=>setVehicleNo(e.target.value)}
// //           required
// //           style={{
// //             padding: isNarrow ? 10 : 12,
// //             borderRadius: 10,
// //             border: '1px solid #D1D5DB',
// //             fontSize: isNarrow ? 14 : 16
// //           }}
// //         >
// //           <option value="">Select vehicle…</option>
// //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>

// //         <button
// //           disabled={busy || saved}
// //           style={{
// //             padding: isNarrow ? '10px 12px' : '12px 14px',
// //             borderRadius: 10,
// //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// //             color: busy || saved ? '#6B7280' : '#fff',
// //             fontWeight: 800,
// //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// //             minHeight: 44,
// //             fontSize: "clamp(14px, 3.5vw, 16px)"
// //           }}
// //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// //         >
// //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// //         </button>

// //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// //       </form>
// //     </div>
// //   );
// // }

// /* ---------------------------- ADMIN PAGES ---------------------------- */

// function AdminLogin({ navigate }) {
//   const [username, setU] = useState("");
//   const [password, setP] = useState("");
//   const [err, setErr] = useState("");
//   const [busy, setBusy] = useState(false);
//   const isNarrow = useIsNarrow(380);

//   useEffect(() => {
//     if (getAdminToken()) navigate("/admin");
//   }, [navigate]);

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setErr("");
//     setBusy(true);
//     try {
//       const r = await axios.post(`${BACKEND}/api/admin/login`, {
//         username,
//         password,
//       });
//       if (r.data?.success && r.data?.token) {
//         setAdminToken(r.data.token);
//         navigate("/admin");
//       } else {
//         setErr("Login failed");
//       }
//     } catch (e1) {
//       setErr(e1?.response?.data?.message || "Login failed");
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: isNarrow ? 12 : 20,
//         margin: isNarrow ? "16px auto" : "32px auto",
//         width: "min(100vw - 24px, 560px)",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: isNarrow ? 10 : 12,
//           marginBottom: isNarrow ? 10 : 14,
//           flexWrap: "wrap",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           <img
//             src={iitmLogo}
//             alt="IITM"
//             style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }}
//           />
//           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Admin Login</h2>
//         </div>
//         <button
//           type="button"
//           onClick={() => navigate("/")}
//           style={{
//             marginLeft: "auto",
//             padding: isNarrow ? "6px 10px" : "8px 12px",
//             borderRadius: 10,
//             border: "1px solid #D1D5DB",
//             background: "#FFFFFF",
//             fontWeight: 700,
//             fontSize: isNarrow ? 13 : 14,
//             cursor: "pointer",
//           }}
//           title="Go to Home"
//         >
//           Home
//         </button>
//       </div>
//       <div
//         style={{
//           background: "#fff",
//           border: "1px solid #E5E7EB",
//           borderRadius: 12,
//           padding: isNarrow ? 12 : 16,
//         }}
//       >
//         <form
//           onSubmit={onSubmit}
//           style={{ display: "grid", gap: isNarrow ? 8 : 10 }}
//         >
//           <input
//             value={username}
//             onChange={(e) => setU(e.target.value)}
//             placeholder="admin username"
//             required
//             style={{
//               padding: isNarrow ? 10 : 12,
//               borderRadius: 10,
//               border: "1px solid #D1D5DB",
//               fontWeight: 600,
//               fontSize: isNarrow ? 14 : 16,
//             }}
//           />
//           <input
//             value={password}
//             onChange={(e) => setP(e.target.value)}
//             placeholder="admin password"
//             type="password"
//             required
//             style={{
//               padding: isNarrow ? 10 : 12,
//               borderRadius: 10,
//               border: "1px solid #D1D5DB",
//               fontWeight: 600,
//               fontSize: isNarrow ? 14 : 16,
//             }}
//           />
//           <button
//             disabled={busy}
//             style={{
//               padding: isNarrow ? "10px 12px" : "12px 14px",
//               borderRadius: 10,
//               border: "1px solid #0D47A1",
//               background: "#0D47A1",
//               color: "#fff",
//               fontWeight: 800,
//               cursor: "pointer",
//               width: "100%",
//               minHeight: 40,
//               fontSize: "clamp(14px, 3.5vw, 16px)",
//             }}
//           >
//             {busy ? "Signing in..." : "Login"}
//           </button>
//           {err && (
//             <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }

// function AdminDashboard({ navigate }) {
//   const [tab, setTab] = useState("drivers"); // 'drivers' | 'routes' | 'live'
//   const [drivers, setDrivers] = useState([]);
//   const [assignments, setAssignments] = useState({}); // vehicleNo -> row
//   const [localAssign, setLocalAssign] = useState({}); // vehicleNo -> { routeCode, driverId, autopilotEnabled }
//   const [editing, setEditing] = useState({}); // vehicleNo -> true when row is in edit mode
//   const [newName, setNewName] = useState("");
//   const [newPhone, setNewPhone] = useState("");
//   const [err, setErr] = useState("");
//   const [busySave, setBusySave] = useState(null); // vehicleno while saving
//   const [liveBuses, setLiveBuses] = useState([]);
//   const adminToken = getAdminToken();
//   const isNarrow = useIsNarrow(480);

//   useEffect(() => {
//     if (!adminToken) navigate("/admin/login");
//   }, [adminToken, navigate]);

//   const authHeader = useMemo(
//     () => ({
//       headers: { Authorization: `Bearer ${adminToken}` },
//     }),
//     [adminToken]
//   );

//   async function loadDrivers() {
//     try {
//       const r = await axios.get(`${BACKEND}/api/admin/drivers`, authHeader);
//       setDrivers(r.data?.drivers || []);
//     } catch (e) {
//       console.warn("loadDrivers error", e?.message || e);
//     }
//   }

//   async function loadAssignments() {
//     try {
//       const r = await axios.get(`${BACKEND}/api/admin/assignments`, authHeader);
//       const rows = r.data?.rows || [];
//       const map = {};
//       for (const row of rows) {
//         map[row.vehicleNo] = row;
//       }
//       setAssignments(map);
//       // whenever we reload from backend, treat all as "saved" (not editing)
//       setEditing({});
//       setLocalAssign({});
//     } catch (e) {
//       console.warn("loadAssignments error", e?.message || e);
//     }
//   }

//   useEffect(() => {
//     if (!adminToken) return;
//     loadDrivers();
//     loadAssignments();
//   }, [adminToken]); // eslint-disable-line react-hooks/exhaustive-deps

//   // live tracking (simple polling)
//   useEffect(() => {
//     if (tab !== "live") return;
//     let cancelled = false;

//     async function loadLive() {
//       try {
//         const r = await axios.get(`${BACKEND}/api/vehicle-data`, {
//           timeout: 8000,
//         });
//         if (!cancelled) {
//           const arr = Array.isArray(r.data) ? r.data : [];
//           setLiveBuses(arr);
//         }
//       } catch (e) {
//         if (!cancelled) {
//           console.warn("admin live map error", e?.message || e);
//         }
//       }
//     }
//     loadLive();
//     const id = setInterval(loadLive, 5000);
//     return () => {
//       cancelled = true;
//       clearInterval(id);
//     };
//   }, [tab]);

//   const handleAddDriver = async (e) => {
//     e.preventDefault();
//     setErr("");
//     try {
//       const r = await axios.post(
//         `${BACKEND}/api/admin/drivers`,
//         { name: newName, phoneNumber: newPhone },
//         authHeader
//       );
//       if (r.data?.success && r.data?.driver) {
//         setDrivers((prev) => [...prev, r.data.driver]);
//         setNewName("");
//         setNewPhone("");
//       } else {
//         setErr("Failed to create driver");
//       }
//     } catch (e1) {
//       setErr(e1?.response?.data?.message || "Failed to create driver");
//     }
//   };

//   const handleRemoveDriver = async (id) => {
//     if (!window.confirm("Remove this driver?")) return;
//     try {
//       await axios.delete(`${BACKEND}/api/admin/drivers/${id}`, authHeader);
//       setDrivers((prev) => prev.filter((d) => d._id !== id));
//       // Note: assignments that still reference this driver will continue to exist until reassigned
//     } catch (e1) {
//       alert(e1?.response?.data?.message || "Failed to remove driver");
//     }
//   };

//   function getBaseAssignForVehicle(veh) {
//     const row = assignments[veh];
//     if (!row) {
//       return {
//         vehicleNo: veh,
//         routeCode: "",
//         driverId: "",
//         autopilotEnabled: false,
//       };
//     }
//     return {
//       vehicleNo: veh,
//       routeCode: row.routeCode || "",
//       driverId: row.driver?._id || "",
//       autopilotEnabled: !!row.autopilotEnabled,
//     };
//   }

//   function updateLocalAssign(veh, patch) {
//     setLocalAssign((prev) => ({
//       ...prev,
//       [veh]: { ...getBaseAssignForVehicle(veh), ...(prev[veh] || {}), ...patch },
//     }));
//   }

//   const handleSaveAssignment = async (veh) => {
//     const base = getBaseAssignForVehicle(veh);
//     const row = localAssign[veh] || base;
//     const hasAssignment = !!assignments[veh]; // vehicle currently has an active route?

//     // RESET error first
//     setErr("");

//     // ---- CASE 1: Admin cleared both fields and there *was* an assignment -> CLEAR MODE ----
//     if (!row.routeCode && !row.driverId && hasAssignment) {
//       setBusySave(veh);
//       try {
//         await axios.post(
//           `${BACKEND}/api/admin/vehicle-assign`,
//           {
//             vehicleNo: row.vehicleNo,
//             clear: true,              // 👈 tells backend: deactivate assignment
//           },
//           authHeader
//         );
//         await loadAssignments();      // refresh table
//         setEditing((prev) => ({ ...prev, [veh]: false }));
//       } catch (e1) {
//         setErr(e1?.response?.data?.message || "Failed to clear assignment");
//       } finally {
//         setBusySave(null);
//       }
//       return;
//     }

//     // ---- CASE 2: No assignment and still empty -> nothing to save ----
//     if (!row.routeCode || !row.driverId) {
//       setErr("Select both Route & Driver, or leave the row as-is.");
//       return;
//     }

//     // ---- CASE 3: Normal ASSIGN / UPDATE ----
//     setBusySave(veh);
//     try {
//       await axios.post(
//         `${BACKEND}/api/admin/vehicle-assign`,
//         {
//           vehicleNo: row.vehicleNo,
//           routeCode: row.routeCode,
//           driverId: row.driverId,
//           autopilotEnabled: !!row.autopilotEnabled,
//         },
//         authHeader
//       );
//       await loadAssignments();
//       setEditing((prev) => ({ ...prev, [veh]: false }));
//     } catch (e1) {
//       setErr(e1?.response?.data?.message || "Failed to save assignment");
//     } finally {
//       setBusySave(null);
//     }
//   };


//   const onLogout = () => {
//     setAdminToken("");
//     navigate("/admin/login");
//   };

//   // simple driver lookup for live map
//   const driverByVehicle = useMemo(() => {
//     const out = {};
//     Object.values(assignments).forEach((row) => {
//       if (row.vehicleNo && row.driver) {
//         out[row.vehicleNo] = row.driver;
//       }
//     });
//     return out;
//   }, [assignments]);

//   return (
//     <div className="admin-layout">
//       {/* left sidebar */}
//       <div
//         className="sidebar"
//         style={{
//           width: isNarrow ? 220 : 260, // responsive width override
//         }}
//       >
//         {/* top section: logo, back button, nav */}
//         <div>
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <img
//               src={iitmLogo}
//               alt="IITM"
//               style={{ width: 32, height: 32, borderRadius: 8 }}
//             />
//             <div>
//               <div style={{ fontWeight: 800, fontSize: 16 }}>Admin</div>
//               <div style={{ fontSize: 12, opacity: 0.8 }}>Thoothukudi Bus Tracking</div>
//             </div>
//           </div>
//           <button
//             onClick={() => navigate("/")}
//             style={{
//               marginTop: 8,
//               textAlign: "left",
//               padding: "6px 10px",
//               borderRadius: 10,
//               border: "1px solid #4b5563",
//               background: "transparent",
//               color: "#e5e7eb",
//               cursor: "pointer",
//               fontSize: 13,
//             }}
//           >
//             ← Back to map
//           </button>
//           <div
//             style={{
//               marginTop: 16,
//               display: "flex",
//               flexDirection: "column",
//               gap: 6,
//             }}
//           >
//             <button
//               onClick={() => setTab("drivers")}
//               style={{
//                 textAlign: "left",
//                 padding: "8px 10px",
//                 borderRadius: 10,
//                 border: "none",
//                 background: tab === "drivers" ? "#f9fafb" : "transparent",
//                 color: tab === "drivers" ? "#111827" : "#e5e7eb",
//                 fontWeight: 600,
//                 cursor: "pointer",
//               }}
//             >
//               + Add Driver
//             </button>
//             <button
//               onClick={() => setTab("routes")}
//               style={{
//                 textAlign: "left",
//                 padding: "8px 10px",
//                 borderRadius: 10,
//                 border: "none",
//                 background: tab === "routes" ? "#f9fafb" : "transparent",
//                 color: tab === "routes" ? "#111827" : "#e5e7eb",
//                 fontWeight: 600,
//                 cursor: "pointer",
//               }}
//             >
//               Route Allocation
//             </button>
//             <button
//               onClick={() => setTab("live")}
//               style={{
//                 textAlign: "left",
//                 padding: "8px 10px",
//                 borderRadius: 10,
//                 border: "none",
//                 background: tab === "live" ? "#f9fafb" : "transparent",
//                 color: tab === "live" ? "#111827" : "#e5e7eb",
//                 fontWeight: 600,
//                 cursor: "pointer",
//               }}
//             >
//               Live Tracking
//             </button>
//           </div>
//         </div>

//         {/* bottom logout – pinned to sidebar bottom */}
//         <button
//           onClick={onLogout}
//           style={{
//             marginTop: 12,
//             padding: "8px 10px",
//             borderRadius: 10,
//             border: "1px solid #6b7280",
//             background: "transparent",
//             color: "#e5e7eb",
//             cursor: "pointer",
//             fontSize: 13,
//           }}
//         >
//           Logout
//         </button>
//       </div>

//       {/* main content */}
//       <div className="content">
//         {tab === "drivers" && (
//           <div style={{ maxWidth: 800, margin: "0 auto" }}>
//             <h2 style={{ marginTop: 0 }}>Drivers</h2>
//             <form
//               onSubmit={handleAddDriver}
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "2fr 2fr auto",
//                 gap: 8,
//                 alignItems: "center",
//                 marginBottom: 16,
//               }}
//             >
//               <input
//                 value={newName}
//                 onChange={(e) => setNewName(e.target.value)}
//                 placeholder="Driver name"
//                 required
//                 style={{
//                   padding: 10,
//                   borderRadius: 10,
//                   border: "1px solid #D1D5DB",
//                   fontSize: 14,
//                 }}
//               />
//               <input
//                 value={newPhone}
//                 onChange={(e) => setNewPhone(e.target.value)}
//                 placeholder="Phone number (unique)"
//                 required
//                 style={{
//                   padding: 10,
//                   borderRadius: 10,
//                   border: "1px solid #D1D5DB",
//                   fontSize: 14,
//                 }}
//               />
//               <button
//                 type="submit"
//                 style={{
//                   padding: "10px 16px",
//                   borderRadius: 10,
//                   border: "1px solid #0D47A1",
//                   background: "#0D47A1",
//                   color: "#fff",
//                   fontWeight: 700,
//                   cursor: "pointer",
//                   fontSize: 14,
//                 }}
//               >
//                 Add
//               </button>
//             </form>
//             {err && (
//               <div
//                 style={{
//                   color: "#b00020",
//                   fontWeight: 600,
//                   marginBottom: 8,
//                 }}
//               >
//                 {err}
//               </div>
//             )}
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
//                 gap: 12,
//               }}
//             >
//               {drivers.map((d) => (
//                 <div
//                   key={d._id}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 12,
//                     border: "1px solid #e5e7eb",
//                     padding: 12,
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 4,
//                   }}
//                 >
//                   <div style={{ fontWeight: 700, fontSize: 15 }}>{d.name}</div>
//                   <div style={{ fontSize: 13, opacity: 0.8 }}>
//                     Phone: {d.phoneNumber || "—"}
//                   </div>
//                   <div style={{ fontSize: 12, opacity: 0.6 }}>
//                     username: <code>{d.username}</code>
//                   </div>
//                   <button
//                     onClick={() => handleRemoveDriver(d._id)}
//                     style={{
//                       marginTop: 8,
//                       alignSelf: "flex-start",
//                       padding: "6px 10px",
//                       borderRadius: 8,
//                       border: "1px solid #f97373",
//                       background: "#fef2f2",
//                       color: "#b91c1c",
//                       fontSize: 12,
//                       fontWeight: 600,
//                       cursor: "pointer",
//                     }}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               ))}
//               {drivers.length === 0 && (
//                 <div style={{ fontSize: 14, opacity: 0.7 }}>
//                   No drivers yet. Add your first driver above.
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {tab === "routes" && (
//           <div className="admin-route-panel" style={{ maxWidth: 1180, margin: "0 auto" }}>
//             <div className="admin-section-header">
//               <div>
//                 <h2 style={{ margin: 0 }}>Route Allocation</h2>
//                 <p>Assign each vehicle to a route and driver. Auto-pilot controls have been removed from this screen.</p>
//               </div>
//               <button
//                 type="button"
//                 onClick={loadAssignments}
//                 className="admin-secondary-button"
//               >
//                 Refresh
//               </button>
//             </div>
//             {err && (
//               <div
//                 style={{
//                   color: "#b00020",
//                   fontWeight: 600,
//                   marginBottom: 8,
//                 }}
//               >
//                 {err}
//               </div>
//             )}
//             <div className="admin-table-card">
//               <table className="admin-route-table"
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   background: "#fff",
//                   borderRadius: 12,
//                   overflow: "hidden",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       background: "#f9fafb",
//                       borderBottom: "1px solid #e5e7eb",
//                     }}
//                   >
//                     <th style={{ padding: 8, textAlign: "left" }}>#</th>
//                     <th style={{ padding: 8, textAlign: "left" }}>Vehicle</th>
//                     <th style={{ padding: 8, textAlign: "left" }}>Route</th>
//                     <th style={{ padding: 8, textAlign: "left" }}>Driver</th>
//                     <th style={{ padding: 8, textAlign: "left" }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {VEHICLES.map((veh, idx) => {
//                     const base = getBaseAssignForVehicle(veh);
//                     const local = localAssign[veh] || base;
//                     const hasAssignment =
//                       !!base.routeCode && !!base.driverId; // existing saved row?
//                     const isEditing = !!editing[veh];
//                     const locked = hasAssignment && !isEditing;
//                     const saving = busySave === veh;

//                     return (
//                       <tr
//                         key={veh}
//                         style={{ borderBottom: "1px solid #f3f4f6" }}
//                       >
//                         <td style={{ padding: 8 }}>{idx + 1}</td>
//                         <td style={{ padding: 8, fontWeight: 600 }}>{veh}</td>
//                         <td style={{ padding: 8 }}>
//                           <select
//                             value={local.routeCode}
//                             onChange={(e) =>
//                               updateLocalAssign(veh, {
//                                 routeCode: e.target.value,
//                               })
//                             }
//                             disabled={locked || saving}
//                             style={{
//                               padding: 8,
//                               borderRadius: 8,
//                               border: "1px solid #d1d5db",
//                               fontSize: 13,
//                               minWidth: 220,
//                               width: "100%",
//                               color: "#111827",
//                               backgroundColor: locked ? "#f9fafb" : "white",
//                             }}
//                           >
//                             <option value="">Select route…</option>
//                             {ADMIN_ROUTES.map((r) => (
//                               <option key={r.code} value={r.code}>
//                                 {r.label}
//                               </option>
//                             ))}
//                           </select>
//                         </td>
//                         <td style={{ padding: 8 }}>
//                           <select
//                             value={local.driverId}
//                             onChange={(e) =>
//                               updateLocalAssign(veh, {
//                                 driverId: e.target.value,
//                               })
//                             }
//                             disabled={locked || saving}
//                             style={{
//                               padding: 8,
//                               borderRadius: 8,
//                               border: "1px solid #d1d5db",
//                               fontSize: 13,
//                               minWidth: 220,
//                               width: "100%",
//                               color: "#111827",
//                               backgroundColor: locked ? "#f9fafb" : "white",
//                             }}
//                           >
//                             <option value="">Select driver…</option>
//                             {drivers.map((d) => (
//                               <option key={d._id} value={d._id}>
//                                 {d.name} ({d.phoneNumber || d.username})
//                               </option>
//                             ))}
//                           </select>
//                         </td>
//                         <td style={{ padding: 8 }}>
//                           <button
//                             onClick={() => {
//                               if (locked) {
//                                 // switch to edit mode
//                                 updateLocalAssign(veh, {}); // ensure local copy
//                                 setEditing((prev) => ({
//                                   ...prev,
//                                   [veh]: true,
//                                 }));
//                               } else {
//                                 // save current data
//                                 handleSaveAssignment(veh);
//                               }
//                             }}
//                             disabled={saving}
//                             style={{
//                               padding: "6px 12px",
//                               borderRadius: 8,
//                               border: "1px solid #0D47A1",
//                               background: saving
//                                 ? "#e5e7eb"
//                                 : locked
//                                   ? "#0D47A1"
//                                   : "#0D47A1",
//                               color: saving ? "#4b5563" : "#fff",
//                               fontSize: 13,
//                               fontWeight: 700,
//                               cursor: saving ? "not-allowed" : "pointer",
//                             }}
//                           >
//                             {saving
//                               ? "Saving…"
//                               : locked
//                                 ? "Edit"
//                                 : "Save"}
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {tab === "live" && (
//           <div style={{ height: "calc(100vh - 40px)" }}>
//             <h2 style={{ marginTop: 0 }}>Live Tracking</h2>
//             <div style={{ height: "calc(100% - 36px)" }}>
//               <MapContainer
//                 center={center}
//                 zoom={DEFAULT_ZOOM}
//                 maxZoom={22}
//                 style={{ width: "100%", height: "100%" }}
//               >
//                 <TileLayer
//                   attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
//                   url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                   maxNativeZoom={19}
//                   maxZoom={22}
//                 />
//                 {liveBuses.map((bus) => {
//                   // const label = vehicleLabel(bus.vehicleno);
//                   const rc = assignments[bus.vehicleno]?.routeCode;   // admin assignments map is row objects
//                   const label = vehicleLabel(bus.vehicleno, rc);
//                   const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
//                   const drv = driverByVehicle[bus.vehicleno];
//                   return (
//                     <Marker
//                       key={bus.vehicleno}
//                       position={{
//                         lat: bus.latitude,
//                         lng: bus.longitude,
//                       }}
//                       // icon={createVehicleDivIcon(
//                       //   label,
//                       //   Number(bus.heading) || 0
//                       // )}
//                       icon={createVehicleDivIcon(label, Number(bus.heading) || 0, palette)}
//                     >
//                       <Popup>
//                         <div className="info-window">
//                           <h4>
//                             {bus.vehicleno} ({label})
//                           </h4>
//                           <p>
//                             <strong>Speed:</strong>{" "}
//                             {Number.isFinite(bus.speed)
//                               ? bus.speed.toFixed(1)
//                               : "N/A"}{" "}
//                             km/h
//                           </p>
//                           {drv && (
//                             <>
//                               <p>
//                                 <strong>Driver:</strong> {drv.name}</p>
//                               <p>
//                                 <strong>Phone:</strong>{" "}
//                                 {drv.phoneNumber || "—"}
//                               </p>
//                             </>
//                           )}
//                           {!drv && (
//                             <p style={{ fontSize: 13, opacity: 0.7 }}>
//                               No driver assigned
//                             </p>
//                           )}
//                         </div>
//                       </Popup>
//                     </Marker>
//                   );
//                 })}
//               </MapContainer>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function RecenterMap({ center, zoom }) {
//   const map = useMap();

//   useEffect(() => {
//     if (!center) return;
//     map.setView([center.lat, center.lng], zoom ?? map.getZoom(), { animate: true });
//   }, [center, zoom, map]);

//   return null;
// }



// /* ---------------------------- MAP PAGE ---------------------------- */
// function MapPage() {
//   const [buses, setBuses] = useState([]);
//   const [userLocation, setUserLocation] = useState(null);
//   const [socketStatus, setSocketStatus] = useState('disconnected');
//   const [roads, setRoads] = useState(null);
//   const [filterType, setFilterType] = useState('all');
//   const [mapCenter, setMapCenter] = useState(center);
//   const [routeSearch, setRouteSearch] = useState('');
//   const [routeSearchMsg, setRouteSearchMsg] = useState('');
//   const [locError, setLocError] = useState("");
//   const [geoState, setGeoState] = useState("unknown"); // "granted" | "prompt" | "denied" | "unknown"
//   const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true);

//   // maintenance banner state
//   const [maintenance, setMaintenance] = useState(false);
//   const [maintenanceReason, setMaintenanceReason] = useState('');
//   const lastUpdateRef = useRef(0);
//   // ETA endpoint calls are intentionally disabled.
//   // The tracking page now uses local route + stop sequence data only.

//   const flatRoadLinesRef = useRef([]);
//   const lastSmoothedRef = useRef(new Map());

//   // ---- Schedule Modal state ----
//   const [showSchedule, setShowSchedule] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);

//   // --- responsive helpers ---
//   const [isNarrow, setIsNarrow] = useState(() => window.innerWidth <= 480);
//   const clamp = (min, pref, max) => `clamp(${min}, ${pref}, ${max})`;
//   const pad = isNarrow ? 12 : 16;
//   const gap = isNarrow ? 8 : 12;
//   const chipFS = isNarrow ? 12 : 13;

//   useEffect(() => {
//     const onResize = () => setIsNarrow(window.innerWidth <= 480);
//     window.addEventListener('resize', onResize);
//     return () => window.removeEventListener('resize', onResize);
//   }, []);

//   // Backend ETA polling removed; stop popups now use local data only.

//   // ---- stable socket + pause flag ----
//   const socketRef = useRef(null);
//   const ignoreUpdatesRef = useRef(false);

//   // ---- assignments (vehicle -> routeCode) ----
//   const [assignments, setAssignments] = useState({});
//   async function refreshAssignments() {
//     try {
//       const r = await axios.get(`${BACKEND}/api/vehicle-route/active`);
//       const map = {};
//       for (const row of r.data?.rows || []) {
//         const vehicleNo = normalizeVehicleNo(row.vehicleNo);
//         map[vehicleNo] = row.routeCode || row.routeNo || "";
//       }
//       setAssignments(map);
//     } catch { }
//   }
//   useEffect(() => { refreshAssignments(); const t = setInterval(refreshAssignments, 60000); return () => clearInterval(t); }, []);

//   // Load roads
//   useEffect(() => {
//     let cancelled = false;
//     (async () => {
//       try {
//         const r = await fetch(ROADS_URL);
//         if (!cancelled && r.ok) setRoads(await r.json());
//       } catch (e) {
//         if (!cancelled) console.warn('Failed to load roads:', e?.message || e);
//       }
//     })();
//     return () => { cancelled = true; };
//   }, []);

//   // Flatten roads to LineStrings
//   useEffect(() => {
//     if (!roads) return;
//     const lines = [];
//     turf.flattenEach(roads, (feat) => {
//       if (feat.geometry?.type === 'LineString') lines.push(feat);
//     });
//     flatRoadLinesRef.current = lines;
//   }, [roads]);

//   // // Geolocation
//   // useEffect(() => {
//   //   if ('geolocation' in navigator) {
//   //     navigator.geolocation.getCurrentPosition(
//   //       (pos) => setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
//   //       (err) => console.warn('Geolocation error:', err?.message),
//   //       { enableHighAccuracy: true, timeout: 5000 }
//   //     );
//   //   }
//   // }, []);

//   useEffect(() => {
//     let perm;
//     (async () => {
//       try {
//         if (!navigator.permissions?.query) return;
//         perm = await navigator.permissions.query({ name: "geolocation" });
//         setGeoState(perm.state);
//         perm.onchange = () => setGeoState(perm.state);
//       } catch {
//         // ignore
//       }
//     })();
//     return () => {
//       if (perm) perm.onchange = null;
//     };
//   }, []);


//   //   const requestUserLocation = useCallback(() => {
//   //   setLocError("");

//   //   if (!("geolocation" in navigator)) {
//   //     setLocError("Geolocation not supported on this device/browser.");
//   //     return;
//   //   }

//   //   navigator.geolocation.getCurrentPosition(
//   //     (pos) => {
//   //       const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
//   //       setUserLocation(loc);
//   //       setMapCenter(loc); // ✅ recenter map here
//   //       setLocError("");
//   //     },
//   //     (err) => {
//   //       console.warn("Geolocation error:", err?.message || err);
//   //       // If user didn't allow, browser will show prompt only if not blocked.
//   //       setLocError("Please allow location to center the map near you.");
//   //     },
//   //     { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
//   //   );
//   // }, []);

//   const requestUserLocation = useCallback(() => {
//     setLocError("");

//     if (!("geolocation" in navigator)) {
//       setLocError("Geolocation not supported on this device/browser.");
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
//         setUserLocation(loc);
//         setMapCenter(loc);
//         setLocError("");
//       },
//       (err) => {
//         // err.code === 1 => PERMISSION_DENIED
//         if (err?.code === 1) {
//           // If browser permission is truly "denied", it won't show popup again.
//           setLocError(
//             "Location is blocked in browser settings. Click the 🔒 icon near the URL → Site settings → Location → Allow (or Ask), then refresh."
//           );
//         } else {
//           setLocError(err?.message || "Unable to fetch location.");
//         }
//       },
//       { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
//     );
//   }, []);


//   useEffect(() => {
//     // ✅ On every page open (and after browser refresh), request location and recenter
//     requestUserLocation();
//   }, [requestUserLocation]);


//   // Initial fetch
//   useEffect(() => {
//     if (!BACKEND) {
//       setMaintenance(true);
//       setMaintenanceReason('Server URL not configured');
//       return;
//     }
//     axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 })
//       .then((res) => {
//         const arr = Array.isArray(res.data) ? res.data : [];
//         const byVeh = new Map();
//         for (const d of arr) {
//           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
//           byVeh.set(d.vehicleno, {
//             vehicleno: d.vehicleno,
//             latitude: d.latitude,
//             longitude: d.longitude,
//             speed: d.speed,
//             heading
//           });
//         }
//         const list = [...byVeh.values()];
//         setBuses(processVehicles(list));
//         lastUpdateRef.current = Date.now();
//       })
//       .catch((err) => {
//         console.error('Initial fetch error:', err?.message || err);
//         setMaintenance(true);
//         setMaintenanceReason('Unable to fetch live data');
//       });
//   }, []);

//   // ---- WebSocket packet handler ----
//   const onPacket = (data) => {
//     if (ignoreUpdatesRef.current) return;
//     const incoming = {
//       vehicleno: data.vehicleno,
//       latitude: data.latitude,
//       longitude: data.longitude,
//       speed: data.speed,
//       heading: Number.isFinite(data?.heading) ? toHeading(data.heading) : toHeading(data?.direction)
//     };

//     setBuses((prev) => {
//       const nextByVeh = new Map(prev.map((b) => [b.vehicleno, b]));
//       const processed = processVehicles([incoming], nextByVeh);
//       const merged = new Map(prev.map((b) => [b.vehicleno, b]));
//       for (const p of processed) merged.set(p.vehicleno, p);
//       return [...merged.values()];
//     });

//     lastUpdateRef.current = Date.now();
//   };

//   // Live updates (Socket.IO)
//   useEffect(() => {
//     if (!BACKEND) return;

//     setSocketStatus('connecting');
//     const socket = io(BACKEND, {
//       transports: ['websocket', 'polling'],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 1000,
//       timeout: 10000,
//       withCredentials: false
//     });
//     socketRef.current = socket;

//     socket.on('connect', () => setSocketStatus('connected'));
//     socket.on('disconnect', () => setSocketStatus('disconnected'));
//     socket.on('connect_error', (e) => {
//       console.warn('Socket connect_error:', e?.message || e);
//       setSocketStatus('disconnected');
//     });

//     socket.on('new-bus-data', onPacket);

//     return () => {
//       socket.off('new-bus-data', onPacket);
//       socket.disconnect();
//       socketRef.current = null;
//     };
//   }, [roads]); // re-connect only if roads change

//   // Staleness / maintenance detector
//   useEffect(() => {
//     const t = setInterval(() => {
//       const sinceMs = Date.now() - lastUpdateRef.current;
//       const stale = sinceMs > STALE_MS;
//       const downAndEmpty = socketStatus === 'disconnected' && buses.length === 0;

//       if (stale || downAndEmpty) {
//         const mins = Math.floor(sinceMs / 60000);
//         const secs = Math.floor((sinceMs % 60000) / 1000);
//         setMaintenance(true);
//         setMaintenanceReason(
//           stale ? `No new data for ${mins}m ${secs}s` : 'Live connection unavailable'
//         );
//       } else {
//         setMaintenance(false);
//         setMaintenanceReason('');
//       }
//     }, 5000);
//     return () => clearInterval(t);
//   }, [socketStatus, buses.length]);

//   // ---- Processing pipeline: smooth then snap ----
//   function snapToRoad(coord, flatLines) {
//     const safeCoord = normalizeLatLng(coord?.lat, coord?.lng);
//     if (!safeCoord || !flatLines || flatLines.length === 0) return null;

//     let pt;
//     try {
//       pt = turf.point([safeCoord.lng, safeCoord.lat]);
//     } catch (err) {
//       console.warn('Skipping road snap because coordinates are invalid:', coord);
//       return null;
//     }

//     let best = null;
//     let bestDist = Infinity;

//     for (const line of flatLines) {
//       try {
//         const np = turf.nearestPointOnLine(line, pt, { units: 'meters' });
//         const dist = np?.properties?.dist;
//         if (Number.isFinite(dist) && dist < bestDist) {
//           bestDist = dist;
//           const [lng, lat] = np.geometry.coordinates;
//           const snapped = normalizeLatLng(lat, lng);
//           if (snapped) best = { ...snapped, distM: dist };
//         }
//       } catch (err) {
//         console.warn('Skipping invalid road line while snapping:', err?.message || err);
//       }
//     }
//     return best;
//   }

//   function processVehicles(list, prevMapOpt) {
//     const flatLines = flatRoadLinesRef.current;
//     const last = lastSmoothedRef.current;
//     const result = [];

//     for (const d of list) {
//       const id = String(d?.vehicleno || '').trim();
//       if (!id) continue;

//       const raw = normalizeLatLng(d.latitude, d.longitude);
//       if (!raw) {
//         console.warn('Skipping vehicle with invalid coordinates:', d?.vehicleno, d?.latitude, d?.longitude);
//         continue;
//       }

//       const prev = last.get(id);
//       const smoothedCoord = smoothCoord(prev?.coord, raw, SMOOTH_ALPHA);
//       if (!smoothedCoord) continue;

//       const smoothedHeading = smoothHeading(prev?.heading, d.heading, HEADING_ALPHA);
//       const snapped = snapToRoad(smoothedCoord, flatLines);

//       const use = snapped?.distM != null && snapped.distM <= SNAP_MAX_DIST_M
//         ? { lat: snapped.lat, lng: snapped.lng }
//         : smoothedCoord;

//       if (!hasValidLatLng(use)) continue;

//       last.set(id, { coord: use, heading: smoothedHeading });

//       result.push({
//         vehicleno: id,
//         latitude: use.lat,
//         longitude: use.lng,
//         speed: d.speed,
//         heading: smoothedHeading
//       });
//     }

//     if (prevMapOpt) {
//       for (const [id, b] of prevMapOpt) {
//         if (list.find(x => x.vehicleno === id)) continue;
//         const prev = last.get(id);
//         if (prev?.coord && hasValidLatLng(prev.coord)) {
//           result.push({
//             vehicleno: id,
//             latitude: prev.coord.lat,
//             longitude: prev.coord.lng,
//             speed: b.speed,
//             heading: prev.heading
//           });
//           continue;
//         }

//         const fallback = normalizeLatLng(b?.latitude, b?.longitude);
//         if (fallback) {
//           result.push({
//             ...b,
//             latitude: fallback.lat,
//             longitude: fallback.lng,
//           });
//         }
//       }
//     }

//     return result;
//   }

//   // ---------------- Route geometry + ETA helpers ----------------
//   const stopById = useMemo(() => Object.fromEntries(busStops.map(s => [s.id, s])), []);

//   function routePolyline(ids) {
//     return ids
//       .map((id) => stopById[id])
//       .filter(Boolean)
//       .map((s) => normalizeLatLng(s.lat, s.lng))
//       .filter(Boolean);
//   }

//   function cumDist(poly) {
//     const out = [0];
//     for (let i = 1; i < poly.length; i++) {
//       const d = mBetween(poly[i - 1], poly[i]);
//       out.push(out[i - 1] + (Number.isFinite(d) ? d : 0));
//     }
//     return out;
//   }

//   const routeGeom = useMemo(() => {
//     const g = {};
//     for (const trip of ROUTE_TRIPS) {
//       const validIds = trip.ids.filter((id) => !!stopById[id]);
//       const poly = routePolyline(validIds);
//       if (poly.length >= 2) {
//         g[trip.id] = { poly, cum: cumDist(poly), ids: validIds, trip };
//       }
//     }
//     return g;
//   }, [stopById]);

//   function projectOnRoute(pt, poly) {
//     const safePt = normalizeLatLng(pt?.lat, pt?.lng);
//     if (!safePt || !poly || poly.length < 2) return null;

//     let best = null;
//     let pointFeature = null;

//     try {
//       pointFeature = turf.point([safePt.lng, safePt.lat]);
//     } catch (err) {
//       console.warn('Skipping route projection because bus coordinates are invalid:', pt);
//       return null;
//     }

//     for (let i = 0; i < poly.length - 1; i++) {
//       const a = normalizeLatLng(poly[i]?.lat, poly[i]?.lng);
//       const b = normalizeLatLng(poly[i + 1]?.lat, poly[i + 1]?.lng);
//       if (!a || !b) continue;

//       try {
//         const seg = turf.lineString([[a.lng, a.lat], [b.lng, b.lat]]);
//         const p = turf.nearestPointOnLine(seg, pointFeature, { units: "meters" });
//         const d = p.properties?.dist ?? Infinity;
//         if (Number.isFinite(d) && (!best || d < best.dist)) {
//           const [lng, lat] = p.geometry.coordinates;
//           best = { idx: i, point: { lat, lng }, dist: d };
//         }
//       } catch (err) {
//         console.warn('Skipping invalid route segment while projecting bus:', err?.message || err);
//       }
//     }
//     return best;
//   }

//   function distanceAlong(poly, cum, proj, targetIndex) {
//     if (!proj || !poly || poly.length < 2 || !cum?.length) return Infinity;
//     const safeIdx = Math.max(0, Math.min(proj.idx, poly.length - 2));
//     const safeTarget = Math.max(0, Math.min(targetIndex, poly.length - 1));
//     const dHead = mBetween(proj.point, poly[safeIdx + 1]);
//     const dTail = (cum[safeTarget] ?? 0) - (cum[safeIdx + 1] ?? 0);
//     const total = dHead + Math.max(0, dTail);
//     return Number.isFinite(total) ? total : Infinity;
//   }

//   // ---- ETA constants: match backend ----
//   const AVG_SPEED_KMPH = 20;
//   const AVG_SPEED_MPS = (AVG_SPEED_KMPH * 1000) / 3600;
//   const WAIT_RADIUS_M = 25;
//   const WAIT_SPEED_KMPH_MAX = 1.0;

//   function etaFromMeters(distanceM) {
//     const seconds = distanceM / AVG_SPEED_MPS;
//     const minutes = Math.round(seconds / 60);
//     return minutes < 0 || !Number.isFinite(minutes) ? 0 : minutes;
//   }

//   function nextStopIndex(routeIds, projIdx) {
//     return Math.min(routeIds.length - 1, projIdx + 1);
//   }

//   function getBestRouteProjectionForBus(bus) {
//     const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
//     if (!routeValue) return null;

//     const candidates = routeCandidatesForValue(routeValue);
//     if (!candidates.length) return null;

//     const pt = normalizeLatLng(bus.latitude, bus.longitude);
//     if (!pt) return null;

//     let best = null;

//     for (const trip of candidates) {
//       const geom = routeGeom[trip.id];
//       if (!geom || geom.poly.length < 2) continue;

//       const proj = projectOnRoute(pt, geom.poly);
//       if (!proj) continue;

//       if (!best || proj.dist < best.proj.dist) {
//         best = { routeValue, trip, geom, proj };
//       }
//     }

//     return best;
//   }

//   function recentlyPassedStopForBus(bus) {
//     const best = getBestRouteProjectionForBus(bus);
//     if (!best) return null;

//     const passedIdx = Math.max(0, Math.min(best.proj.idx, best.geom.ids.length - 1));
//     const stopId = best.geom.ids[passedIdx];
//     const stop = stopById[stopId];

//     if (!stop) return null;

//     return {
//       stopId,
//       name: stop.name,
//       routeNo: best.trip.routeNo,
//       routeCode: best.trip.code,
//       distanceFromRouteM: best.proj.dist,
//     };
//   }

//   // For a given bus, find nearest upcoming stop on its route + ETA
//   function nearestStopEtaForBusOnItsRoute(bus) {
//     const best = getBestRouteProjectionForBus(bus);
//     if (!best) return null;

//     const { geom, proj, trip } = best;
//     const pt = normalizeLatLng(bus.latitude, bus.longitude);
//     if (!pt) return null;

//     const firstStopId = geom.ids[0];
//     const firstStop = stopById[firstStopId];
//     let waitingAtFirstStop = false;
//     if (firstStop) {
//       const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
//       const speed = Number(bus.speed);
//       if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
//         waitingAtFirstStop = true;
//       }
//     }

//     const nextIdx = nextStopIndex(geom.ids, proj.idx);
//     const distanceM = distanceAlong(geom.poly, geom.cum, proj, nextIdx);

//     let etaMin = undefined;
//     if (!waitingAtFirstStop) {
//       etaMin = etaFromMeters(distanceM);
//     }

//     return {
//       stopId: geom.ids[nextIdx],
//       distanceM,
//       etaMin,
//       routeCode: trip.code,
//       routeNo: trip.routeNo,
//       waitingAtFirstStop,
//     };
//   }

//   // For a given stop, find the best incoming vehicle + ETA
//   function nextArrivalAtStop(stopId) {
//     const candidates = [];

//     for (const bus of buses) {
//       if (startsWithDigit(bus.vehicleno)) continue;

//       const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
//       if (!routeValue) continue;

//       for (const trip of routeCandidatesForValue(routeValue)) {
//         const geom = routeGeom[trip.id];
//         if (!geom) continue;

//         const indexInRoute = geom.ids.indexOf(stopId);
//         if (indexInRoute < 0) continue;

//         const pt = normalizeLatLng(bus.latitude, bus.longitude);
//         if (!pt) continue;

//         const proj = projectOnRoute(pt, geom.poly);
//         if (!proj) continue;

//         const targetIndex = Math.max(indexInRoute, proj.idx + 1);
//         if (targetIndex >= geom.ids.length) continue;

//         const distanceM = distanceAlong(geom.poly, geom.cum, proj, targetIndex);

//         const firstStopId = geom.ids[0];
//         const firstStop = stopById[firstStopId];
//         let waitingAtFirstStop = false;
//         if (firstStop) {
//           const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
//           const speed = Number(bus.speed);
//           if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
//             waitingAtFirstStop = true;
//           }
//         }

//         let etaMin = undefined;
//         if (!waitingAtFirstStop) {
//           etaMin = etaFromMeters(distanceM);
//         }

//         candidates.push({
//           vehicle: bus.vehicleno,
//           routeCode: trip.code,
//           routeNo: trip.routeNo,
//           etaMin,
//           waitingAtFirstStop,
//           distanceM,
//         });
//       }
//     }

//     if (!candidates.length) return null;

//     const moving = candidates.filter(c => c.etaMin != null);
//     if (moving.length) {
//       return moving.reduce((a, b) => (a.etaMin <= b.etaMin ? a : b));
//     }

//     return candidates.reduce((a, b) => (a.distanceM <= b.distanceM ? a : b));
//   }


//   // ---- Derived lists ----
//   const visibleBuses = buses.filter(b => !startsWithDigit(b.vehicleno) && normalizeLatLng(b.latitude, b.longitude));
//   const filteredBuses = visibleBuses.filter(b => matchesFilter(b.vehicleno, filterType, assignments));

//   function handleRouteSearch() {
//     const requested = normalizeRouteNo(routeSearch);
//     if (!requested) {
//       setRouteSearchMsg("Enter a route number, for example 52-G.");
//       return;
//     }

//     const matching = visibleBuses.filter(
//       (bus) => normalizeRouteNo(getBusRouteNo(bus.vehicleno, assignments)) === requested
//     );

//     setFilterType(`route:${requested}`);

//     if (matching.length > 0) {
//       const bus = matching[0];
//       setMapCenter({ lat: bus.latitude, lng: bus.longitude });
//       setRouteSearchMsg(`Showing ${matching.length} vehicle(s) on route ${requested}.`);
//       return;
//     }

//     const fallbackTrip = routeCandidatesForValue(requested)[0];
//     const firstStopId = fallbackTrip?.ids?.[0];
//     const firstStop = firstStopId ? stopById[firstStopId] : null;

//     if (firstStop) {
//       setMapCenter({ lat: firstStop.lat, lng: firstStop.lng });
//       setRouteSearchMsg(`No live vehicle found on ${requested}. Zoomed to the first scheduled stop.`);
//     } else {
//       setRouteSearchMsg(`No live vehicle or schedule found for route ${requested}.`);
//     }
//   }


//   // -------------- SCHEDULE UI helpers --------------
//   const TABS = useMemo(() => ROUTES.map((route) => ({
//     key: route.code,
//     title: route.label,
//     code: route.code,
//     trips: ROUTE_TRIPS.filter((trip) => trip.routeNo === route.code),
//   })), []);

//   const ScheduleBody = useCallback(function ScheduleBody({ tab }) {
//     const trips = tab.trips || [];

//     if (!trips.length) {
//       return (
//         <div className="schedule-empty">
//           Stop-wise schedule data is not available for this route in the uploaded ZIP.
//         </div>
//       );
//     }

//     return (
//       <div className="schedule-trip-list">
//         {trips
//           .slice()
//           .sort((a, b) => (a.order || 0) - (b.order || 0))
//           .map((trip) => (
//             <div className="schedule-trip-card" key={trip.id}>
//               <div className="schedule-trip-header">
//                 <div>
//                   <div className="schedule-trip-title">
//                     {trip.routeNo} / Trip {trip.order}
//                   </div>
//                   <div className="schedule-trip-subtitle">
//                     {trip.from} → {trip.to}
//                   </div>
//                 </div>

//                 <div className="schedule-trip-badges">
//                   <span>{trip.startTime} - {trip.endTime}</span>
//                   <span>{trip.service || "Town Ordinary"}</span>
//                   <span>{trip.direction === "U" ? "Up" : trip.direction === "D" ? "Down" : trip.direction}</span>
//                 </div>
//               </div>

//               <div className="schedule-stop-table-wrap">
//                 <table className="schedule-stop-table">
//                   <thead>
//                     <tr>
//                       <th>No.</th>
//                       <th>Bus stop</th>
//                       <th>Time</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {trip.stops.map((stop, index) => (
//                       <tr key={`${trip.id}-${stop.id}-${index}`}>
//                         <td>{index + 1}</td>
//                         <td>{stop.name}</td>
//                         <td>{stop.time}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           ))}
//       </div>
//     );
//   }, []);

//   const ScheduleModal = useCallback(function ScheduleModal() {
//     const tab = TABS[activeTab] || TABS[0];

//     return (
//       <div
//         onClick={() => setShowSchedule(false)}
//         style={{
//           position: 'fixed',
//           inset: 0,
//           background: 'rgba(0,0,0,0.45)',
//           zIndex: 99999,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: isNarrow ? 8 : 16
//         }}
//       >
//         <div
//           onClick={(e) => e.stopPropagation()}
//           style={{
//             position: 'relative',
//             width: isNarrow ? '96vw' : 'min(1180px, 96vw)',
//             height: isNarrow ? 'calc(100dvh - 16px)' : 'min(92dvh, 860px)',
//             maxHeight: 'calc(100dvh - 16px)',
//             minHeight: 0,
//             background: '#ffffff',
//             borderRadius: 16,
//             boxShadow: '0 12px 30px rgba(0,0,0,0.3)',
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden'
//           }}
//         >
//           <div
//             style={{
//               padding: isNarrow ? '8px 10px' : '12px 16px',
//               borderBottom: '1px solid #eee',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 12,
//               flexShrink: 0
//             }}
//           >
//             <img src={iitmLogo} alt="MiNT" style={{ width: isNarrow ? 26 : 32, height: isNarrow ? 26 : 32 }} />
//             <div>
//               <div style={{ fontWeight: 900, fontSize: isNarrow ? '14px' : '18px' }}>
//                 Thoothukudi Bus Schedule
//               </div>
//               <div style={{ color: '#64748b', fontSize: 12, fontWeight: 700 }}>
//                 Route-wise stop timings from the uploaded timesheet
//               </div>
//             </div>
//             <button
//               onClick={() => setShowSchedule(false)}
//               style={{
//                 marginLeft: 'auto',
//                 border: 'none',
//                 background: '#f4f4f5',
//                 borderRadius: 999,
//                 width: 34,
//                 height: 34,
//                 cursor: 'pointer',
//                 fontSize: 16
//               }}
//               title="Close"
//             >
//               ✕
//             </button>
//           </div>

//           <div
//             style={{
//               display: 'block',
//               padding: isNarrow ? '8px 10px 10px' : '10px 14px',
//               borderBottom: '1px solid #eee',
//               overflowX: 'hidden',
//               overflowY: 'auto',
//               maxHeight: isNarrow ? 118 : 128,
//               flexShrink: 0,
//               WebkitOverflowScrolling: 'touch',
//               scrollbarWidth: 'thin',
//               overscrollBehavior: 'contain',
//               touchAction: 'pan-y'
//             }}
//           >
//             <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, minWidth: '100%' }}>
//               {TABS.map((t, i) => (
//                 <button
//                   key={t.key}
//                   onClick={() => setActiveTab(i)}
//                   style={{
//                     whiteSpace: 'nowrap',
//                     padding: isNarrow ? '8px 10px' : '8px 12px',
//                     borderRadius: 10,
//                     border: i === activeTab ? '1px solid #0D47A1' : '1px solid #ddd',
//                     background: i === activeTab ? '#eaf2ff' : '#ffffff',
//                     fontWeight: 800,
//                     cursor: 'pointer',
//                     flex: '0 0 auto'
//                   }}
//                 >
//                   {t.code}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div
//             className="schedule-modal-scroll-body"
//             style={{
//               padding: isNarrow ? 10 : 14,
//               overflowY: 'auto',
//               overflowX: 'hidden',
//               flex: '1 1 auto',
//               minHeight: 0,
//               overscrollBehavior: 'contain',
//               WebkitOverflowScrolling: 'touch'
//             }}
//           >
//             <div className="schedule-route-summary">
//               <div>
//                 <div className="schedule-route-title">{tab.title}</div>
//                 <div className="schedule-route-meta">
//                   {tab.trips?.length || 0} trip(s) · click a route tab to view stop-wise timings
//                 </div>
//               </div>
//             </div>
//             <ScheduleBody tab={tab} />
//           </div>
//         </div>
//       </div>
//     );
//   }, [TABS, activeTab, isNarrow, ScheduleBody]);


//   // Pause live updates when modal open; refresh once on close, then resume
//   useEffect(() => {
//     if (showSchedule) { ignoreUpdatesRef.current = true; return; }
//     (async () => {
//       try {
//         if (!BACKEND) return;
//         const res = await axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 });
//         const arr = Array.isArray(res.data) ? res.data : [];
//         const byVeh = new Map();
//         for (const d of arr) {
//           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
//           byVeh.set(d.vehicleno, {
//             vehicleno: d.vehicleno,
//             latitude: d.latitude,
//             longitude: d.longitude,
//             speed: d.speed,
//             heading
//           });
//         }
//         const list = [...byVeh.values()];
//         setBuses(processVehicles(list));
//         lastUpdateRef.current = Date.now();
//       } catch (e) {
//         console.warn('Refresh after modal close failed:', e?.message || e);
//       } finally {
//         ignoreUpdatesRef.current = false;
//       }
//     })();
//   }, [showSchedule]);

//   // Responsive stop icons (smaller on phones)
//   const stopIconInstance = useMemo(
//     () => createCustomIcon(stopIconImg, isNarrow ? [40, 40] : [50, 50]),
//     [isNarrow]
//   );

//   // --------------------------- RENDER ---------------------------
//   return (
//     <div className="map-container">
//       {/* Header */}
//       {/* <div
//         style={{
//           position: 'fixed',
//           top: 'max(8px, env(safe-area-inset-top))',
//           left: '50%',
//           transform: 'translateX(-50%)',
//           zIndex: 10000,
//           background: '#ffffff',
//           border: '1px solid #e6e6e7',
//           borderRadius: 16,
//           padding: pad,
//           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
//           width: isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))',
//           backdropFilter: 'blur(2px)'
//         }}
//       > */}
//       <div
//         style={{
//           position: 'fixed',
//           top: 'max(8px, env(safe-area-inset-top))',
//           left: '50%',
//           transform: 'translateX(-50%)',
//           zIndex: 10000,
//           background: '#ffffff',
//           border: '1px solid #e6e6e7',
//           borderRadius: 16,
//           padding: isHeaderCollapsed ? (isNarrow ? 8 : 10) : pad,
//           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
//           width: isHeaderCollapsed
//             ? (isNarrow ? 'calc(100vw - 16px)' : 'min(420px, calc(100vw - 32px))')
//             : (isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))'),
//           backdropFilter: 'blur(2px)',
//           transition: 'width 180ms ease, padding 180ms ease'
//         }}
//       >
//         {/* Title row */}
//         {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//           <img src={iitmLogo} alt="IIT Madras" style={{ width: isNarrow ? 28 : 36, height: isNarrow ? 28 : 36 }} />
//           <h2
//             style={{
//               margin: 0,
//               fontSize: clamp('18px','3.2vw','28px'),
//               lineHeight: 1.1,
//               letterSpacing: 0.3,
//               fontWeight: 800
//             }}
//           >
//             Thoothukudi Bus Tracking
//           </h2>
//           <a href="/admin" style={{ marginLeft: 'auto', fontWeight: 700 }}>Admin ↗</a>
//         </div> */}

//         {/* Title row */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: isNarrow ? 8 : 12 }}>
//           <img
//             src={iitmLogo}
//             alt="IIT Madras"
//             style={{
//               width: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
//               height: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
//               flex: '0 0 auto'
//             }}
//           />

//           <h2
//             style={{
//               margin: 0,
//               fontSize: isHeaderCollapsed
//                 ? clamp('15px', '3vw', '20px')
//                 : clamp('18px', '3.2vw', '28px'),
//               lineHeight: 1.1,
//               letterSpacing: 0.3,
//               fontWeight: 800,
//               whiteSpace: 'nowrap',
//               overflow: 'hidden',
//               textOverflow: 'ellipsis',
//               flex: 1
//             }}
//           >
//             Thoothukudi Bus Tracking
//           </h2>

//           {isHeaderCollapsed && (
//             <div
//               style={{
//                 fontSize: isNarrow ? 12 : 13,
//                 fontWeight: 800,
//                 color: '#111827',
//                 whiteSpace: 'nowrap'
//               }}
//               title="Visible vehicles / total vehicles"
//             >
//               {filteredBuses.length}/{buses.length}
//             </div>
//           )}

//           {!isHeaderCollapsed && (
//             <a
//               href="/admin"
//               style={{
//                 fontWeight: 700,
//                 whiteSpace: 'nowrap'
//               }}
//             >
//               Admin ↗
//             </a>
//           )}

//           <button
//             type="button"
//             onClick={() => setIsHeaderCollapsed((v) => !v)}
//             aria-label={isHeaderCollapsed ? 'Expand header' : 'Collapse header'}
//             title={isHeaderCollapsed ? 'Expand' : 'Collapse'}
//             style={{
//               border: '1px solid #D1D5DB',
//               background: '#ffffff',
//               color: '#111827',
//               borderRadius: 10,
//               padding: isNarrow ? '6px 8px' : '7px 10px',
//               fontWeight: 800,
//               fontSize: isNarrow ? 13 : 14,
//               lineHeight: 1,
//               cursor: 'pointer',
//               minWidth: isNarrow ? 34 : 38,
//               minHeight: isNarrow ? 32 : 36
//             }}
//           >
//             {isHeaderCollapsed ? '▾' : '▴'}
//           </button>
//         </div>

//         {!isHeaderCollapsed && (
//           <>

//             {/* Status row */}
//             <div
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 marginTop: 10,
//                 gap: 12,
//                 flexWrap: 'wrap'
//               }}
//             >
//               <span
//                 style={{
//                   display: 'inline-block',
//                   padding: '4px 10px',
//                   borderRadius: 999,
//                   fontSize: chipFS,
//                   fontWeight: 700,
//                   background:
//                     socketStatus === 'connected'
//                       ? '#E9F9EE'
//                       : socketStatus === 'connecting'
//                         ? '#FFF7E1'
//                         : '#FFECEC',
//                   color:
//                     socketStatus === 'connected'
//                       ? '#0A7A2A'
//                       : socketStatus === 'connecting'
//                         ? '#7A5D00'
//                         : '#B00020',
//                   border:
//                     socketStatus === 'connected'
//                       ? '1px solid #C6EBD1'
//                       : socketStatus === 'connecting'
//                         ? '1px solid #F4E3B0'
//                         : '1px solid #FFD0D0',
//                   textTransform: 'lowercase'
//                 }}
//                 title={`Socket: ${socketStatus}`}
//               >
//                 {socketStatus}
//               </span>

//               <div
//                 style={{
//                   fontSize: clamp('14px', '2.6vw', '18px'),
//                   fontWeight: 700,
//                   letterSpacing: 0.5,
//                   color: '#111827'
//                 }}
//               >
//                 {filteredBuses.length} / {buses.length}
//               </div>
//             </div>

//             {/* Controls row */}
//             <div
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: gap,
//                 marginTop: gap,
//                 flexWrap: 'wrap'
//               }}
//             >
//               <div style={{ position: 'relative', flex: '1 1 200px' }}>
//                 <select
//                   value={filterType}
//                   onChange={(e) => setFilterType(e.target.value)}
//                   title="Filter vehicles"
//                   style={{
//                     width: '100%',
//                     padding: isNarrow ? '10px 34px 10px 12px' : '10px 40px 10px 14px',
//                     borderRadius: 10,
//                     border: '1px solid #D1D5DB',
//                     background: '#FFFFFF',
//                     fontWeight: 600,
//                     cursor: 'pointer',
//                     appearance: 'none',
//                     WebkitAppearance: 'none',
//                     MozAppearance: 'none'
//                   }}
//                 >
//                   <option value="all">All Vehicles</option>
//                   {/* <option value="cart">Cart</option> */}
//                   {/* <option value="bus">Bus</option> */}
//                   <optgroup label="Filter by Route">
//                     {ROUTES.map(r => (
//                       <option key={r.code} value={`route:${r.code}`}>{r.label}</option>
//                     ))}
//                   </optgroup>
//                 </select>

//                 <div
//                   style={{
//                     position: 'absolute',
//                     right: isNarrow ? 8 : 12,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     width: 0,
//                     height: 0,
//                     borderLeft: '6px solid transparent',
//                     borderRight: '6px solid transparent',
//                     borderTop: '7px solid #111',
//                     pointerEvents: 'none'
//                   }}
//                 />
//               </div>

//               <div className="route-search-box">
//                 <input
//                   value={routeSearch}
//                   onChange={(e) => setRouteSearch(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleRouteSearch();
//                   }}
//                   placeholder="Search route e.g. 52-G"
//                   aria-label="Search by route number"
//                 />
//                 <button type="button" onClick={handleRouteSearch}>
//                   Search
//                 </button>
//               </div>

//               <button
//                 // onClick={() => window.location.reload()}
//                 // onClick={() => {
//                 //   requestUserLocation(); // ✅ recenter on refresh button click
//                 // }}

//                 // title="Reload the page"
//                 onClick={() => {
//                   requestUserLocation();          // ✅ recenter
//                   setTimeout(() => {
//                     window.location.reload();     // ✅ full reload
//                   }, 150);
//                 }}
//                 title="Recenter + Reload"
//                 style={{
//                   padding: '10px 14px',
//                   borderRadius: 10,
//                   border: '1px solid #D1D5DB',
//                   background: '#FFFFFF',
//                   fontWeight: 700,
//                   cursor: 'pointer',
//                   minHeight: isNarrow ? 36 : 40,
//                   fontSize: clamp('13px', '2.8vw', '14px')
//                 }}
//               >
//                 Refresh
//               </button>

//               <button
//                 onClick={() => setShowSchedule(true)}
//                 title="Show route schedules"
//                 style={{
//                   padding: '10px 16px',
//                   borderRadius: 10,
//                   border: '1px solid #0D47A1',
//                   background: '#0D47A1',
//                   color: '#FFFFFF',
//                   fontWeight: 800,
//                   cursor: 'pointer',
//                   boxShadow: '0 6px 16px rgba(13,71,161,0.25)',
//                   minHeight: isNarrow ? 36 : 40,
//                   fontSize: clamp('13px','2.8vw','14px')
//                 }}
//               >
//                 Schedule
//               </button>
//             </div>

//             {routeSearchMsg && (
//               <div className="route-search-message">
//                 {routeSearchMsg}
//               </div>
//             )}

//             {maintenance && (
//               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#fff8e1', border: '1px solid #f0d48a', fontWeight: 600 }}>
//                 Under maintenance — {maintenanceReason}
//               </div>
//             )}

//             {/* {locError && (
//         <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
//           {locError}
//           <button
//             onClick={requestUserLocation}
//             style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
//           >
//             Allow location
//           </button>
//         </div>
//         )} */}

//             {locError && (
//               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
//                 {locError}

//                 <button
//                   type="button"
//                   onClick={requestUserLocation}
//                   style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
//                   title={geoState === "denied" ? "Enable in site settings first, then try again" : "Try again"}
//                 >
//                   {geoState === "denied" ? "Open site settings" : "Allow location"}
//                 </button>
//               </div>
//             )}
//           </>
//         )}
//       </div>


//       {/* Schedule Modal */}
//       {showSchedule && <ScheduleModal />}

//       {/* Map uses dynamic viewport on mobile (100dvh) */}
//       {/* <MapContainer center={center} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}> */}
//       <MapContainer center={mapCenter} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}>
//         <RecenterMap center={mapCenter} zoom={DEFAULT_ZOOM} />

//         <TileLayer
//           attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
//           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//           maxNativeZoom={19}
//           maxZoom={22}
//         />

//         {userLocation && (
//           <Marker position={{ lat: userLocation.lat, lng: userLocation.lng }} icon={userIconInstance}>
//             <Popup>
//               <div className="info-window">
//                 <h4>You are here</h4>
//               </div>
//             </Popup>
//           </Marker>
//         )}
//         {/* Bus Stops - no ETA endpoint call. */}
//         {busStops.map((stop) => (
//           <Marker
//             key={stop.id}
//             position={{ lat: stop.lat, lng: stop.lng }}
//             icon={stopIconInstance}
//           >
//             <Popup>
//               <div className="info-window">
//                 <h4>{stop.name}</h4>
//                 <p><strong>Stop ID:</strong> {stop.id}</p>
//               </div>
//             </Popup>
//           </Marker>
//         ))}



//         {/* Vehicles */}
//         {filteredBuses.map((bus) => {
//           const assignedRouteValue = getAssignedRouteValue(bus.vehicleno, assignments);
//           const routeNo = getBusRouteNo(bus.vehicleno, assignments);
//           const routeLabel = getRouteDisplayLabel(assignedRouteValue || routeNo);
//           const label = vehicleLabel(bus.vehicleno, assignedRouteValue);
//           const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
//           const info = nearestStopEtaForBusOnItsRoute(bus);
//           const recentlyPassed = recentlyPassedStopForBus(bus);
//           const nearestName = info ? (busStops.find(s => s.id === info.stopId)?.name) : null;
//           return (
//             <Marker
//               key={bus.vehicleno}
//               position={{ lat: bus.latitude, lng: bus.longitude }}
//               // icon={createVehicleDivIcon(label, bus.heading)}
//               icon={createVehicleDivIcon(label, bus.heading, palette)}

//             >
//               <Popup>
//                 <div className="info-window">
//                   <h4>{bus.vehicleno} ({label})</h4>
//                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart</p> */}
//                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart, CR = Cart (RP↔ED)</p> */}
//                   <p><strong>Route No:</strong> {routeNo || 'Unassigned'}</p>
//                   <p><strong>Route:</strong> {routeLabel}</p>
//                   <p><strong>Recently Passed:</strong> {recentlyPassed?.name || 'Not available yet'}</p>
//                   {nearestName && <p><strong>Next Stop:</strong> {nearestName}</p>}
//                   <p><strong>Speed:</strong> {Number.isFinite(bus.speed) ? bus.speed.toFixed(1) : 'N/A'} km/h</p>
//                   {Number.isFinite(bus.heading) && <p><strong>Heading:</strong> {Math.round(bus.heading)}°</p>}
//                 </div>
//               </Popup>
//             </Marker>
//           );
//         })}
//       </MapContainer>

//       {/* Footer: Feedback link */}
//       <div
//         style={{
//           position: 'fixed',
//           left: 0,
//           right: 0,
//           bottom: -5,
//           display: 'flex',
//           justifyContent: 'center',
//           zIndex: 10000,
//           pointerEvents: 'none',
//           paddingBottom: 'max(6px, env(safe-area-inset-bottom))'
//         }}
//       >
//         <div
//           style={{
//             width: '100vw',
//             pointerEvents: 'auto',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             gap: 12,
//             padding: isNarrow ? '6px 10px' : '6px 16px',
//             borderRadius: 14,
//             background:
//               'linear-gradient(135deg, rgba(17,24,39,0.85), rgba(31,41,55,0.85))',
//             color: '#F9FAFB',
//             border: '1px solid rgba(255,255,255,0.14)',
//             boxShadow:
//               '0 12px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.06)',
//             backdropFilter: 'saturate(160%) blur(10px)',
//             WebkitBackdropFilter: 'saturate(160%) blur(10px)',
//             fontFamily:
//               '"SF Pro Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"',
//             fontSize: clamp('12px', '2.8vw', '14px'),
//             lineHeight: 1.4,
//             fontWeight: 500,
//             letterSpacing: '0.2px',
//           }}
//         >
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 10,
//               flex: 1,
//               minWidth: 0,
//             }}
//           >
//             <div
//               style={{
//                 width: 8,
//                 height: 8,
//                 borderRadius: 9999,
//                 background:
//                   'radial-gradient(circle at 30% 30%, #34D399, #059669)',
//                 boxShadow: '0 0 0 3px rgba(16,185,129,0.25)',
//                 flex: '0 0 auto',
//               }}
//             />
//             <span
//               style={{
//                 opacity: 0.95,
//                 whiteSpace: 'nowrap',
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//               }}
//             >
//               MInT Lab | IIT Madras | UkPact
//             </span>
//           </div>

//           {FEEDBACK_URL ? (
//             <a
//               href={FEEDBACK_URL}
//               target="_blank"
//               rel="noreferrer"
//               style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 padding: '8px 12px',
//                 borderRadius: 10,
//                 border: '1px solid rgba(255,255,255,0.18)',
//                 background:
//                   'linear-gradient(180deg, rgba(128, 126, 126, 0.14), rgba(221, 212, 212, 0.06))',
//                 color: '#F9FAFB',
//                 textDecoration: 'none',
//                 fontWeight: 600,
//                 letterSpacing: '0.25px',
//                 transform: 'translateZ(0)',
//                 transition: 'transform 120ms ease, opacity 120ms ease',
//                 cursor: 'pointer',
//                 boxShadow:
//                   'inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 14px rgba(0,0,0,0.25)',
//               }}
//               onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-1px)')}
//               onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
//             >
//               Open feedback form ↗
//             </a>
//           ) : (
//             <span
//               style={{
//                 padding: '8px 12px',
//                 borderRadius: 10,
//                 border: '1px dashed rgba(255,255,255,0.25)',
//                 color: 'rgba(249,250,251,0.8)',
//                 fontWeight: 500,
//               }}
//             >
//               &lt;form-link&gt;
//             </span>
//           )}
//         </div>
//       </div>

//     </div>
//   );
// }

// /* ---------------------------- HOME PAGE ---------------------------- */

// const AIR_QUALITY_URL = "https://main.d2yil9slaoehou.amplifyapp.com/";

// function HomePage({ navigate }) {
//   const cards = [
//     {
//       title: "Bus Tracking",
//       subtitle: "Live vehicle location using WebSocket",
//       path: "/tracking",
//       icon: "🚌",
//       type: "internal",
//     },
//     {
//       title: "Air Quality Sensor",
//       subtitle: "View live air quality monitoring dashboard",
//       url: AIR_QUALITY_URL,
//       icon: "🌫️",
//       type: "external",
//     },
//     {
//       title: "Camera Data",
//       subtitle: "Vehicle count analytics from camera feed",
//       path: "/camera",
//       icon: "📷",
//       type: "internal",
//     },
//   ];

//   // const openCard = (card) => {
//   //   if (card.type === "external") {
//   //     window.location.href = card.url;
//   //     return;
//   //   }
//   //   navigate(card.path);
//   // };

//   const openCard = (card) => {
//   if (card.type === "external") {
//     window.open(card.url, "_blank", "noopener,noreferrer");
//     return;
//   }

//   window.open(card.path, "_blank", "noopener,noreferrer");
// };

//   return (
//     <div className="home-page">
//       <div className="home-bg-glow home-bg-glow-one" />
//       <div className="home-bg-glow home-bg-glow-two" />

//       <header className="home-navbar">
// <div className="home-brand">
//   <img
//     src={iitmLogo}
//     alt="MInT Lab Logo"
//     className="home-brand-logo-img"
//   />

//   <div className="home-brand-text">
//     <div className="home-brand-title">MInT Collaborative</div>
//     <div className="home-brand-subtitle">IIT Madras | UKPACT</div>
//   </div>
// </div>

//         <button className="home-nav-button" onClick={() => navigate("/tracking")}>
//           Open Tracking
//         </button>
//       </header>

//       <main className="home-main">
//         <section className="home-hero">
//           <div className="home-pill">Smart Mobility Dashboard</div>

//           <h1>
//             Real-time Transport, Sensor <br />
//             and Camera Intelligence
//           </h1>

//           <p>
//             A single access point for bus tracking, air quality monitoring,
//             and vehicle count analytics.
//           </p>
//         </section>

//         <section className="home-card-grid">
//           {cards.map((card) => (
//             <button
//               key={card.title}
//               className="home-feature-card"
//               onClick={() => openCard(card)}
//             >
//               <div className="home-card-icon">{card.icon}</div>

//               <div className="home-card-content">
//                 <h2>{card.title}</h2>
//                 <p>{card.subtitle}</p>
//               </div>

//               <div className="home-card-arrow">
//                 {card.type === "external" ? "↗" : "→"}
//               </div>
//             </button>
//           ))}
//         </section>
//       </main>
//     </div>
//   );
// }

// /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// const CAMERA_LOCATIONS = [
//   {
//     id: "camera-site-1",
//     sno: 1,
//     place: "Ettayapuram Rd",
//     location: "Perison Plaza Signal",
//     boxes: 2,
//     cameras: 2,
//     lat: 8.81277,
//     lng: 78.13647,
//   },
//   {
//     id: "camera-site-2",
//     sno: 2,
//     place: "4th Gate",
//     location: "South side of Milavittan Road",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.80967,
//     lng: 78.1335,
//   },
//   {
//     id: "camera-site-3",
//     sno: 3,
//     place: "International Furniture Park",
//     location: "Madurai - Tiruchendur Rd highway east side",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.81624,
//     lng: 78.08118,
//   },
//   {
//     id: "camera-site-4",
//     sno: 4,
//     place: "3rd Mile",
//     location: "Near TVL-TUT-MDR Bypass Bridge",
//     boxes: 2,
//     cameras: 2,
//     lat: 8.789608,
//     lng: 78.11493,
//   },
//   {
//     id: "camera-site-5",
//     sno: 5,
//     place: "Alageshapuram Road",
//     location: "Roundana near St. Thomas School",
//     boxes: 1,
//     cameras: 2,
//     lat: 8.81705,
//     lng: 78.14797,
//   },
//   {
//     id: "camera-site-6",
//     sno: 6,
//     place: "Tiruchendur Rd",
//     location: "Muthiahpuram",
//     boxes: 1,
//     cameras: 1,
//     lat: 8.74541,
//     lng: 78.1253,
//   },
// ];

// const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// function numberSafe(value) {
//   const n = Number(value);
//   return Number.isFinite(n) ? n : 0;
// }

// function normalizeCameraRow(row) {
//   const auto = numberSafe(row.auto);
//   const motorbike = numberSafe(row.motorbike);
//   const bus = numberSafe(row.bus);
//   const car = numberSafe(row.car);
//   const truck = numberSafe(row.truck);

//   return {
//     id:
//       row._id ||
//       row.dedupeKey ||
//       `${row.cameraId || "camera"}-${row.timestampText || row.timestamp}-${row.direction}`,
//     dedupeKey: row.dedupeKey || "",
//     sourceFile: row.sourceFile || "",
//     cameraId: row.cameraId || "ALL",
//     cameraName: row.cameraName || row.place || "",
//     location: row.location || "",
//     timestamp: row.timestampText || row.timestamp || "",
//     timestampIso: row.timestamp || "",
//     direction: row.direction || "All Directions",
//     auto,
//     motorbike,
//     bus,
//     car,
//     truck,
//     total: numberSafe(row.total) || auto + motorbike + bus + car + truck,
//   };
// }

// function getRowSortTime(row) {
//   const isoTime = row.timestampIso ? new Date(row.timestampIso).getTime() : NaN;
//   if (Number.isFinite(isoTime)) return isoTime;

//   const localText = String(row.timestamp || "").replace(" ", "T");
//   const localTime = new Date(localText).getTime();
//   if (Number.isFinite(localTime)) return localTime;

//   return 0;
// }

// function mergeLatestCameraRows(existingRows, incomingRows, maxRows = 10) {
//   const map = new Map();

//   [...incomingRows, ...existingRows].forEach((row) => {
//     const key =
//       row.dedupeKey ||
//       row.id ||
//       `${row.cameraId}-${row.timestamp}-${row.direction}-${row.sourceFile}`;

//     if (!map.has(key)) {
//       map.set(key, row);
//     }
//   });

//   return Array.from(map.values())
//     .sort((a, b) => getRowSortTime(b) - getRowSortTime(a))
//     .slice(0, maxRows);
// }

// function sumRows(rows) {
//   return rows.reduce(
//     (acc, row) => {
//       acc.auto += numberSafe(row.auto);
//       acc.motorbike += numberSafe(row.motorbike);
//       acc.bus += numberSafe(row.bus);
//       acc.car += numberSafe(row.car);
//       acc.truck += numberSafe(row.truck);
//       return acc;
//     },
//     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
//   );
// }

// function totalFromCounts(counts) {
//   return VEHICLE_TYPES.reduce((sum, type) => sum + numberSafe(counts[type]), 0);
// }

// function buildDirectionData(rows) {
//   const grouped = {};

//   rows.forEach((row) => {
//     const direction = row.direction || "All Directions";

//     if (!grouped[direction]) {
//       grouped[direction] = {
//         direction,
//         auto: 0,
//         motorbike: 0,
//         bus: 0,
//         car: 0,
//         truck: 0,
//       };
//     }

//     VEHICLE_TYPES.forEach((type) => {
//       grouped[direction][type] += numberSafe(row[type]);
//     });
//   });

//   return Object.values(grouped)
//     .map((item) => ({
//       ...item,
//       total: totalFromCounts(item),
//     }))
//     .sort((a, b) => b.total - a.total);
// }

// function CameraMapFlyTo({ selectedLocation }) {
//   const map = useMap();

//   useEffect(() => {
//     if (!selectedLocation) return;

//     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
//       duration: 0.8,
//     });
//   }, [map, selectedLocation]);

//   return null;
// }

// function CameraDataPage({ navigate }) {
//   const [rows, setRows] = useState([]);
//   const [sourceLabel, setSourceLabel] = useState("Connecting to backend...");
//   const [loading, setLoading] = useState(true);
//   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
//   const [connectionError, setConnectionError] = useState("");

//   const fetchCameraData = useCallback(async () => {
//     try {
//       if (!BACKEND) {
//         throw new Error("REACT_APP_BACKEND_URL is missing");
//       }

//       const res = await axios.get(`${BACKEND}/api/cameradata/latest`, {
//         params: {
//           limit: 10,
//         },
//       });

//       const backendRows = Array.isArray(res.data)
//         ? res.data
//         : Array.isArray(res.data?.rows)
//         ? res.data.rows
//         : [];

//       const normalizedRows = backendRows.map(normalizeCameraRow);

//       setRows((prev) => mergeLatestCameraRows(prev, normalizedRows, 10));

//       setSourceLabel(
//         normalizedRows.length
//           ? "Live realtime data"
//           : "Waiting for camera CSV data"
//       );

//       setConnectionError("");
//     } catch (e) {
//       setConnectionError(e.message || "Failed to load camera data");
//       setSourceLabel("Backend not reachable");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchCameraData();

//     if (!BACKEND) return undefined;

//     const socket = io(BACKEND, {
//       transports: ["websocket", "polling"],
//       reconnection: true,
//       reconnectionAttempts: Infinity,
//       reconnectionDelay: 1000,
//     });

//     socket.on("connect", () => {
//       setConnectionError("");
//       setSourceLabel("Live realtime data");
//     });

//     socket.on("connect_error", () => {
//       setSourceLabel("Backend polling mode");
//     });

//     socket.on("new-camera-data", (payload) => {
//       const incoming = Array.isArray(payload)
//         ? payload
//         : Array.isArray(payload?.rows)
//         ? payload.rows
//         : payload
//         ? [payload]
//         : [];

//       if (!incoming.length) return;

//       const normalized = incoming.map(normalizeCameraRow);

//       setRows((prev) => mergeLatestCameraRows(prev, normalized, 10));
//       setSourceLabel("Live camera update");
//       setLoading(false);
//       setConnectionError("");
//     });

//     const refreshTimer = setInterval(fetchCameraData, 30_000);

//     return () => {
//       clearInterval(refreshTimer);
//       socket.disconnect();
//     };
//   }, [fetchCameraData]);

//   const latestRows = useMemo(() => rows.slice(0, 10), [rows]);

//   const selectedRows = useMemo(() => {
//     const hasCameraSpecificRows = latestRows.some(
//       (row) => row.cameraId && row.cameraId !== "ALL"
//     );

//     if (!hasCameraSpecificRows) {
//       return latestRows;
//     }

//     return latestRows.filter((row) => row.cameraId === selectedLocation.id);
//   }, [latestRows, selectedLocation]);

//   const totalsByCamera = useMemo(() => {
//     const grouped = {};

//     latestRows.forEach((row) => {
//       const key = row.cameraId || "ALL";

//       if (!grouped[key]) {
//         grouped[key] = {
//           auto: 0,
//           motorbike: 0,
//           bus: 0,
//           car: 0,
//           truck: 0,
//         };
//       }

//       VEHICLE_TYPES.forEach((type) => {
//         grouped[key][type] += numberSafe(row[type]);
//       });
//     });

//     return grouped;
//   }, [latestRows]);

//   const totals = useMemo(() => sumRows(latestRows), [latestRows]);
//   const totalVehicles = totalFromCounts(totals);

//   const directionData = useMemo(
//     () => buildDirectionData(selectedRows),
//     [selectedRows]
//   );

//   const latestRow = latestRows[0];

//   const handleLocationClick = (location) => {
//     setSelectedLocation(location);
//   };

//   return (
//     <div className="camera-page">
//       <div className="camera-bg-glow camera-bg-glow-one" />
//       <div className="camera-bg-glow camera-bg-glow-two" />

//       <header className="camera-navbar">
//         <button className="camera-back-button" onClick={() => navigate("/")}>
//           ← Home
//         </button>

//         <div>
//           <h1>Camera Data</h1>
//           <p>Realtime latest 10 rows from camera CSV feed</p>
//         </div>

//         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
//           Bus Tracking
//         </button>
//       </header>

//       <main className="camera-content">
//         <section className="camera-summary-grid">
//           <div className="camera-summary-card total">
//             <span>Total Vehicles</span>
//             <strong>{totalVehicles}</strong>
//             <small>{sourceLabel}</small>
//           </div>

//           <div className="camera-summary-card">
//             <span>Cars</span>
//             <strong>{totals.car}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Motorbikes</span>
//             <strong>{totals.motorbike}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Buses</span>
//             <strong>{totals.bus}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Trucks</span>
//             <strong>{totals.truck}</strong>
//           </div>

//           <div className="camera-summary-card">
//             <span>Autos</span>
//             <strong>{totals.auto}</strong>
//           </div>
//         </section>

//         {connectionError && (
//           <div className="camera-live-warning">
//             {connectionError}
//           </div>
//         )}

//         <section className="camera-map-layout">
//           <aside className="camera-location-panel">
//             <div className="camera-location-header">
//               <h2>Camera Locations</h2>
//               <p>
//                 {CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across{" "}
//                 {CAMERA_LOCATIONS.length} locations
//               </p>
//             </div>

//             <div className="camera-location-list">
//               {CAMERA_LOCATIONS.map((item) => {
//                 const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

//                 return (
//                   <button
//                     key={item.id}
//                     className={
//                       selectedLocation.id === item.id
//                         ? "camera-location-item active"
//                         : "camera-location-item"
//                     }
//                     onClick={() => handleLocationClick(item)}
//                   >
//                     <div>
//                       <strong>{item.place}</strong>
//                       <span>{item.location}</span>
//                     </div>

//                     <small>{cameraTotal} vehicles</small>
//                   </button>
//                 );
//               })}
//             </div>
//           </aside>

//           <section className="camera-map-card">
//             <MapContainer
//               center={[selectedLocation.lat, selectedLocation.lng]}
//               zoom={14}
//               className="camera-osm-map"
//               scrollWheelZoom={true}
//             >
//               <TileLayer
//                 attribution='&copy; OpenStreetMap contributors'
//                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//               />

//               <CameraMapFlyTo selectedLocation={selectedLocation} />

//               {CAMERA_LOCATIONS.map((item) => {
//                 const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

//                 return (
//                   <Marker
//                     key={item.id}
//                     position={[item.lat, item.lng]}
//                     eventHandlers={{
//                       click: () => handleLocationClick(item),
//                     }}
//                   >
//                     <Popup>
//                       <div className="camera-popup">
//                         <h3>{item.place}</h3>
//                         <p>{item.location}</p>
//                         <p>
//                           <strong>Cameras:</strong> {item.cameras}
//                         </p>
//                         <p>
//                           <strong>Latest Vehicles:</strong> {cameraTotal}
//                         </p>
//                       </div>
//                     </Popup>
//                   </Marker>
//                 );
//               })}
//             </MapContainer>
//           </section>
//         </section>

//         <section className="camera-selected-panel">
//           <div>
//             <h2>{selectedLocation.place}</h2>
//             <p>{selectedLocation.location}</p>
//           </div>

//           <div className="camera-selected-meta">
//             <span>{selectedLocation.boxes} boxes</span>
//             <span>{selectedLocation.cameras} cameras</span>
//             <span>
//               {selectedLocation.lat}, {selectedLocation.lng}
//             </span>
//           </div>
//         </section>

//         <section className="camera-direction-grid">
//           {directionData.slice(0, 4).map((item) => (
//             <div className="camera-direction-card" key={item.direction}>
//               <span>{item.direction}</span>
//               <strong>{item.total}</strong>
//               <small>
//                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
//               </small>
//             </div>
//           ))}

//           {!loading && directionData.length === 0 && (
//             <div className="camera-direction-card">
//               <span>No direction data</span>
//               <strong>0</strong>
//               <small>Waiting for CSV rows</small>
//             </div>
//           )}
//         </section>

//         <section className="camera-panel">
//           <div className="camera-panel-header">
//             <div>
//               <h2>Vehicle Count Table</h2>
//               <p>
//                 {loading
//                   ? "Loading camera data..."
//                   : latestRow
//                   ? `Latest timestamp: ${latestRow.timestamp}`
//                   : "No camera records available"}
//               </p>
//             </div>

//             <div className="camera-latest-badge">
//               Latest 10 rows
//             </div>
//           </div>

//           <div className="camera-table-info">
//             <span>
//               Showing realtime rows only. Data is not saved in backend database.
//             </span>

//             <span>
//               Rows: {latestRows.length}/10
//             </span>
//           </div>

//           <div className="camera-table-wrap">
//             <table className="camera-table">
//               <thead>
//                 <tr>
//                   <th>Timestamp</th>
//                   <th>Camera</th>
//                   <th>Direction</th>
//                   <th>Auto</th>
//                   <th>Motorbike</th>
//                   <th>Bus</th>
//                   <th>Car</th>
//                   <th>Truck</th>
//                   <th>Total</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {latestRows.map((row, index) => (
//                   <tr key={row.dedupeKey || row.id || `${row.timestamp}-${index}`}>
//                     <td>{row.timestamp}</td>
//                     <td>{row.cameraName || row.cameraId}</td>
//                     <td>{row.direction}</td>
//                     <td>{row.auto}</td>
//                     <td>{row.motorbike}</td>
//                     <td>{row.bus}</td>
//                     <td>{row.car}</td>
//                     <td>{row.truck}</td>
//                     <td>{row.total}</td>
//                   </tr>
//                 ))}

//                 {!loading && latestRows.length === 0 && (
//                   <tr>
//                     <td colSpan="9" style={{ textAlign: "center", padding: "24px" }}>
//                       No camera data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }
// /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// // const CAMERA_LOCATIONS = [
// //   {
// //     id: "camera-site-1",
// //     sno: 1,
// //     place: "Ettayapuram Rd",
// //     location: "Perison Plaza Signal",
// //     boxes: 2,
// //     cameras: 2,
// //     lat: 8.81277,
// //     lng: 78.13647,
// //   },
// //   {
// //     id: "camera-site-2",
// //     sno: 2,
// //     place: "4th Gate",
// //     location: "South side of Milavittan Road",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.80967,
// //     lng: 78.1335,
// //   },
// //   {
// //     id: "camera-site-3",
// //     sno: 3,
// //     place: "International Furniture Park",
// //     location: "Madurai - Tiruchendur Rd highway east side",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.81624,
// //     lng: 78.08118,
// //   },
// //   {
// //     id: "camera-site-4",
// //     sno: 4,
// //     place: "3rd Mile",
// //     location: "Near TVL-TUT-MDR Bypass Bridge",
// //     boxes: 2,
// //     cameras: 2,
// //     lat: 8.789608,
// //     lng: 78.11493,
// //   },
// //   {
// //     id: "camera-site-5",
// //     sno: 5,
// //     place: "Alageshapuram Road",
// //     location: "Roundana near St. Thomas School",
// //     boxes: 1,
// //     cameras: 2,
// //     lat: 8.81705,
// //     lng: 78.14797,
// //   },
// //   {
// //     id: "camera-site-6",
// //     sno: 6,
// //     place: "Tiruchendur Rd",
// //     location: "Muthiahpuram",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.74541,
// //     lng: 78.1253,
// //   },
// // ];

// // const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// // function numberSafe(value) {
// //   const n = Number(value);
// //   return Number.isFinite(n) ? n : 0;
// // }

// // function normalizeCameraRow(row) {
// //   const auto = numberSafe(row.auto);
// //   const motorbike = numberSafe(row.motorbike);
// //   const bus = numberSafe(row.bus);
// //   const car = numberSafe(row.car);
// //   const truck = numberSafe(row.truck);

// //   return {
// //     id: row._id || row.dedupeKey || `${row.cameraId}-${row.timestampText}-${row.direction}`,
// //     dedupeKey: row.dedupeKey || "",
// //     sourceFile: row.sourceFile || "",
// //     cameraId: row.cameraId || "ALL",
// //     cameraName: row.cameraName || row.place || "",
// //     location: row.location || "",
// //     timestamp: row.timestampText || row.timestamp || "",
// //     timestampIso: row.timestamp || "",
// //     direction: row.direction || "All Directions",
// //     auto,
// //     motorbike,
// //     bus,
// //     car,
// //     truck,
// //     total: numberSafe(row.total) || auto + motorbike + bus + car + truck,
// //   };
// // }

// // function getRowSortTime(row) {
// //   const isoTime = row.timestampIso ? new Date(row.timestampIso).getTime() : NaN;
// //   if (Number.isFinite(isoTime)) return isoTime;

// //   const localText = String(row.timestamp || "").replace(" ", "T");
// //   const localTime = new Date(localText).getTime();
// //   if (Number.isFinite(localTime)) return localTime;

// //   return 0;
// // }

// // function mergeCameraRows(existingRows, incomingRows, maxRows = 5000) {
// //   const map = new Map();

// //   [...incomingRows, ...existingRows].forEach((row) => {
// //     const key =
// //       row.dedupeKey ||
// //       row.id ||
// //       `${row.cameraId}-${row.timestamp}-${row.direction}-${row.sourceFile}`;

// //     if (!map.has(key)) {
// //       map.set(key, row);
// //     }
// //   });

// //   return Array.from(map.values())
// //     .sort((a, b) => getRowSortTime(b) - getRowSortTime(a))
// //     .slice(0, maxRows);
// // }

// // function sumRows(rows) {
// //   return rows.reduce(
// //     (acc, row) => {
// //       acc.auto += numberSafe(row.auto);
// //       acc.motorbike += numberSafe(row.motorbike);
// //       acc.bus += numberSafe(row.bus);
// //       acc.car += numberSafe(row.car);
// //       acc.truck += numberSafe(row.truck);
// //       return acc;
// //     },
// //     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// //   );
// // }

// // function totalFromCounts(counts) {
// //   return VEHICLE_TYPES.reduce((sum, type) => sum + numberSafe(counts[type]), 0);
// // }

// // function getDateKey(timestamp) {
// //   return String(timestamp || "").slice(0, 10);
// // }

// // function getWeekKey(timestamp) {
// //   const datePart = getDateKey(timestamp);
// //   if (!datePart) return "Unknown";

// //   const date = new Date(`${datePart}T00:00:00`);
// //   if (Number.isNaN(date.getTime())) return "Unknown";

// //   const firstDay = new Date(date.getFullYear(), 0, 1);
// //   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
// //   const weekNumber = Math.ceil(dayNumber / 7);

// //   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// // }

// // function buildChartData(rows, mode = "daily") {
// //   const grouped = {};

// //   rows.forEach((row) => {
// //     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
// //     if (!key) return;

// //     if (!grouped[key]) {
// //       grouped[key] = {
// //         label: key,
// //         auto: 0,
// //         motorbike: 0,
// //         bus: 0,
// //         car: 0,
// //         truck: 0,
// //       };
// //     }

// //     VEHICLE_TYPES.forEach((type) => {
// //       grouped[key][type] += numberSafe(row[type]);
// //     });
// //   });

// //   return Object.values(grouped)
// //     .map((item) => ({
// //       ...item,
// //       total: totalFromCounts(item),
// //     }))
// //     .sort((a, b) => a.label.localeCompare(b.label));
// // }

// // function buildDirectionData(rows) {
// //   const grouped = {};

// //   rows.forEach((row) => {
// //     const direction = row.direction || "All Directions";

// //     if (!grouped[direction]) {
// //       grouped[direction] = {
// //         direction,
// //         auto: 0,
// //         motorbike: 0,
// //         bus: 0,
// //         car: 0,
// //         truck: 0,
// //       };
// //     }

// //     VEHICLE_TYPES.forEach((type) => {
// //       grouped[direction][type] += numberSafe(row[type]);
// //     });
// //   });

// //   return Object.values(grouped)
// //     .map((item) => ({
// //       ...item,
// //       total: totalFromCounts(item),
// //     }))
// //     .sort((a, b) => b.total - a.total);
// // }

// // function CameraMapFlyTo({ selectedLocation }) {
// //   const map = useMap();

// //   useEffect(() => {
// //     if (!selectedLocation) return;

// //     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
// //       duration: 0.8,
// //     });
// //   }, [map, selectedLocation]);

// //   return null;
// // }

// // function MiniBarChart({ title, data }) {
// //   const maxValue = Math.max(...data.map((item) => item.total), 1);

// //   return (
// //     <div className="camera-chart-card">
// //       <div className="camera-chart-header">
// //         <h3>{title}</h3>
// //       </div>

// //       <div className="camera-bar-chart">
// //         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

// //         {data.map((item) => {
// //           const height = Math.max(8, (item.total / maxValue) * 150);

// //           return (
// //             <div className="camera-bar-item" key={item.label}>
// //               <div className="camera-bar-value">{item.total}</div>
// //               <div className="camera-bar-track">
// //                 <div
// //                   className="camera-bar-fill"
// //                   style={{ height: `${height}px` }}
// //                 />
// //               </div>
// //               <div className="camera-bar-label">{item.label}</div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // }

// // function CameraDataPage({ navigate }) {
// //   const [rows, setRows] = useState([]);
// //   const [sourceLabel, setSourceLabel] = useState("Connecting to backend...");
// //   const [loading, setLoading] = useState(true);
// //   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
// //   const [chartMode, setChartMode] = useState("daily");
// //   const [connectionError, setConnectionError] = useState("");

// //   const [page, setPage] = useState(1);
// //   const [limit, setLimit] = useState(25);

// //   const fetchCameraData = useCallback(async () => {
// //     try {
// //       if (!BACKEND) {
// //         throw new Error("REACT_APP_BACKEND_URL is missing");
// //       }

// //       const res = await axios.get(`${BACKEND}/api/cameradata/latest`, {
// //         params: {
// //           limit: 5000,
// //         },
// //       });

// //       const backendRows = Array.isArray(res.data)
// //         ? res.data
// //         : Array.isArray(res.data?.rows)
// //         ? res.data.rows
// //         : [];

// //       const normalizedRows = backendRows.map(normalizeCameraRow);

// //       setRows((prev) => mergeCameraRows(prev, normalizedRows));
// //       setSourceLabel(
// //         normalizedRows.length
// //           ? "Live backend data"
// //           : "Waiting for camera CSV data"
// //       );
// //       setConnectionError("");
// //       setPage(1);
// //     } catch (e) {
// //       setConnectionError(e.message || "Failed to load camera data");
// //       setSourceLabel("Backend not reachable");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     fetchCameraData();

// //     if (!BACKEND) return undefined;

// //     const socket = io(BACKEND, {
// //       transports: ["websocket", "polling"],
// //       reconnection: true,
// //       reconnectionAttempts: Infinity,
// //       reconnectionDelay: 1000,
// //     });

// //     socket.on("connect", () => {
// //       setConnectionError("");
// //       setSourceLabel("Live backend data");
// //     });

// //     socket.on("connect_error", () => {
// //       setSourceLabel("Backend polling mode");
// //     });

// //     socket.on("new-camera-data", (payload) => {
// //       const incoming = Array.isArray(payload)
// //         ? payload
// //         : Array.isArray(payload?.rows)
// //         ? payload.rows
// //         : payload
// //         ? [payload]
// //         : [];

// //       if (!incoming.length) return;

// //       const normalized = incoming.map(normalizeCameraRow);

// //       setRows((prev) => mergeCameraRows(prev, normalized));
// //       setSourceLabel("Live camera update");
// //       setLoading(false);
// //       setConnectionError("");
// //     });

// //     const refreshTimer = setInterval(fetchCameraData, 60_000);

// //     return () => {
// //       clearInterval(refreshTimer);
// //       socket.disconnect();
// //     };
// //   }, [fetchCameraData]);

// //   const selectedRows = useMemo(() => {
// //     const hasCameraSpecificRows = rows.some((row) => row.cameraId && row.cameraId !== "ALL");

// //     if (!hasCameraSpecificRows) {
// //       return rows;
// //     }

// //     return rows.filter((row) => row.cameraId === selectedLocation.id);
// //   }, [rows, selectedLocation]);

// //   const totalsByCamera = useMemo(() => {
// //     const grouped = {};

// //     rows.forEach((row) => {
// //       const key = row.cameraId || "ALL";

// //       if (!grouped[key]) {
// //         grouped[key] = {
// //           auto: 0,
// //           motorbike: 0,
// //           bus: 0,
// //           car: 0,
// //           truck: 0,
// //         };
// //       }

// //       VEHICLE_TYPES.forEach((type) => {
// //         grouped[key][type] += numberSafe(row[type]);
// //       });
// //     });

// //     return grouped;
// //   }, [rows]);

// //   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
// //   const totalVehicles = totalFromCounts(totals);

// //   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
// //   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
// //   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

// //   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

// //   const totalRows = selectedRows.length;
// //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// //   const safePage = Math.min(page, totalPages);
// //   const offset = (safePage - 1) * limit;

// //   const paginatedRows = useMemo(() => {
// //     return selectedRows.slice(offset, offset + limit);
// //   }, [selectedRows, offset, limit]);

// //   const latestRow = selectedRows[0];

// //   const handleLocationClick = (location) => {
// //     setSelectedLocation(location);
// //     setPage(1);
// //   };

// //   const handleLimitChange = (e) => {
// //     setLimit(Number(e.target.value));
// //     setPage(1);
// //   };

// //   return (
// //     <div className="camera-page">
// //       <div className="camera-bg-glow camera-bg-glow-one" />
// //       <div className="camera-bg-glow camera-bg-glow-two" />

// //       <header className="camera-navbar">
// //         <button className="camera-back-button" onClick={() => navigate("/")}>
// //           ← Home
// //         </button>

// //         <div>
// //           <h1>Camera Data</h1>
// //           <p>Live traffic counts by vehicle type and camera location</p>
// //         </div>

// //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// //           Bus Tracking
// //         </button>
// //       </header>

// //       <main className="camera-content">
// //         <section className="camera-summary-grid">
// //           <div className="camera-summary-card total">
// //             <span>Total Vehicles</span>
// //             <strong>{totalVehicles}</strong>
// //             <small>{sourceLabel}</small>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Cars</span>
// //             <strong>{totals.car}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Motorbikes</span>
// //             <strong>{totals.motorbike}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Buses</span>
// //             <strong>{totals.bus}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Trucks</span>
// //             <strong>{totals.truck}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Autos</span>
// //             <strong>{totals.auto}</strong>
// //           </div>
// //         </section>

// //         {connectionError && (
// //           <div className="camera-live-warning">
// //             {connectionError}
// //           </div>
// //         )}

// //         <section className="camera-map-layout">
// //           <aside className="camera-location-panel">
// //             <div className="camera-location-header">
// //               <h2>Camera Locations</h2>
// //               <p>
// //                 {CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across{" "}
// //                 {CAMERA_LOCATIONS.length} locations
// //               </p>
// //             </div>

// //             <div className="camera-location-list">
// //               {CAMERA_LOCATIONS.map((item) => {
// //                 const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

// //                 return (
// //                   <button
// //                     key={item.id}
// //                     className={
// //                       selectedLocation.id === item.id
// //                         ? "camera-location-item active"
// //                         : "camera-location-item"
// //                     }
// //                     onClick={() => handleLocationClick(item)}
// //                   >
// //                     <div>
// //                       <strong>{item.place}</strong>
// //                       <span>{item.location}</span>
// //                     </div>

// //                     <small>
// //                       {cameraTotal} vehicles
// //                     </small>
// //                   </button>
// //                 );
// //               })}
// //             </div>
// //           </aside>

// //           <section className="camera-map-card">
// //             <MapContainer
// //               center={[selectedLocation.lat, selectedLocation.lng]}
// //               zoom={14}
// //               className="camera-osm-map"
// //               scrollWheelZoom={true}
// //             >
// //               <TileLayer
// //                 attribution='&copy; OpenStreetMap contributors'
// //                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// //               />

// //               <CameraMapFlyTo selectedLocation={selectedLocation} />

// //               {CAMERA_LOCATIONS.map((item) => {
// //                 const cameraTotal = totalFromCounts(totalsByCamera[item.id] || {});

// //                 return (
// //                   <Marker
// //                     key={item.id}
// //                     position={[item.lat, item.lng]}
// //                     eventHandlers={{
// //                       click: () => handleLocationClick(item),
// //                     }}
// //                   >
// //                     <Popup>
// //                       <div className="camera-popup">
// //                         <h3>{item.place}</h3>
// //                         <p>{item.location}</p>
// //                         <p>
// //                           <strong>Cameras:</strong> {item.cameras}
// //                         </p>
// //                         <p>
// //                           <strong>Total Vehicles:</strong> {cameraTotal}
// //                         </p>
// //                       </div>
// //                     </Popup>
// //                   </Marker>
// //                 );
// //               })}
// //             </MapContainer>
// //           </section>
// //         </section>

// //         <section className="camera-selected-panel">
// //           <div>
// //             <h2>{selectedLocation.place}</h2>
// //             <p>{selectedLocation.location}</p>
// //           </div>

// //           <div className="camera-selected-meta">
// //             <span>{selectedLocation.boxes} boxes</span>
// //             <span>{selectedLocation.cameras} cameras</span>
// //             <span>
// //               {selectedLocation.lat}, {selectedLocation.lng}
// //             </span>
// //           </div>
// //         </section>

// //         <section className="camera-direction-grid">
// //           {directionData.slice(0, 4).map((item) => (
// //             <div className="camera-direction-card" key={item.direction}>
// //               <span>{item.direction}</span>
// //               <strong>{item.total}</strong>
// //               <small>
// //                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
// //               </small>
// //             </div>
// //           ))}

// //           {!loading && directionData.length === 0 && (
// //             <div className="camera-direction-card">
// //               <span>No direction data</span>
// //               <strong>0</strong>
// //               <small>Waiting for CSV rows</small>
// //             </div>
// //           )}
// //         </section>

// //         <section className="camera-chart-section">
// //           <div className="camera-chart-toolbar">
// //             <div>
// //               <h2>Dashboard Analysis</h2>
// //               <p>Daily and weekly traffic count trends</p>
// //             </div>

// //             <div className="camera-chart-toggle">
// //               <button
// //                 className={chartMode === "daily" ? "active" : ""}
// //                 onClick={() => setChartMode("daily")}
// //               >
// //                 Daily
// //               </button>
// //               <button
// //                 className={chartMode === "weekly" ? "active" : ""}
// //                 onClick={() => setChartMode("weekly")}
// //               >
// //                 Weekly
// //               </button>
// //             </div>
// //           </div>

// //           <MiniBarChart
// //             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
// //             data={chartData}
// //           />
// //         </section>

// //         <section className="camera-panel">
// //           <div className="camera-panel-header">
// //             <div>
// //               <h2>Vehicle Count Table</h2>
// //               <p>
// //                 {loading
// //                   ? "Loading camera data..."
// //                   : latestRow
// //                   ? `Latest timestamp: ${latestRow.timestamp}`
// //                   : "No camera records available"}
// //               </p>
// //             </div>

// //             <div className="camera-pagination-top">
// //               <label>
// //                 Limit
// //                 <select value={limit} onChange={handleLimitChange}>
// //                   <option value={10}>10</option>
// //                   <option value={25}>25</option>
// //                   <option value={50}>50</option>
// //                   <option value={100}>100</option>
// //                   <option value={200}>200</option>
// //                 </select>
// //               </label>
// //             </div>
// //           </div>

// //           <div className="camera-table-info">
// //             <span>
// //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// //               {Math.min(offset + limit, totalRows)} of {totalRows}
// //             </span>

// //             <span>
// //               Offset: {offset} | Limit: {limit}
// //             </span>
// //           </div>

// //           <div className="camera-table-wrap">
// //             <table className="camera-table">
// //               <thead>
// //                 <tr>
// //                   <th>Timestamp</th>
// //                   <th>Camera</th>
// //                   <th>Direction</th>
// //                   <th>Auto</th>
// //                   <th>Motorbike</th>
// //                   <th>Bus</th>
// //                   <th>Car</th>
// //                   <th>Truck</th>
// //                   <th>Total</th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {paginatedRows.map((row, index) => (
// //                   <tr key={row.dedupeKey || row.id || `${row.timestamp}-${index}`}>
// //                     <td>{row.timestamp}</td>
// //                     <td>{row.cameraName || row.cameraId}</td>
// //                     <td>{row.direction}</td>
// //                     <td>{row.auto}</td>
// //                     <td>{row.motorbike}</td>
// //                     <td>{row.bus}</td>
// //                     <td>{row.car}</td>
// //                     <td>{row.truck}</td>
// //                     <td>{row.total}</td>
// //                   </tr>
// //                 ))}

// //                 {!loading && paginatedRows.length === 0 && (
// //                   <tr>
// //                     <td colSpan="9" style={{ textAlign: "center", padding: "24px" }}>
// //                       No camera data available
// //                     </td>
// //                   </tr>
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>

// //           <div className="camera-pagination-bottom">
// //             <button
// //               onClick={() => setPage((prev) => Math.max(1, prev - 1))}
// //               disabled={safePage <= 1}
// //             >
// //               ← Previous
// //             </button>

// //             <span>
// //               Page {safePage} of {totalPages}
// //             </span>

// //             <button
// //               onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))}
// //               disabled={safePage >= totalPages}
// //             >
// //               Next →
// //             </button>
// //           </div>
// //         </section>
// //       </main>
// //     </div>
// //   );
// // }

// // /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// // const CAMERA_FALLBACK_DATA = [
// //   {
// //     timestamp: "2025-11-01 00:00:06",
// //     auto: 0,
// //     motorbike: 0,
// //     bus: 0,
// //     car: 0,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:11",
// //     auto: 0,
// //     motorbike: 4,
// //     bus: 1,
// //     car: 4,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:16",
// //     auto: 0,
// //     motorbike: 2,
// //     bus: 0,
// //     car: 0,
// //     truck: 1,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:21",
// //     auto: 0,
// //     motorbike: 1,
// //     bus: 0,
// //     car: 1,
// //     truck: 1,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:26",
// //     auto: 0,
// //     motorbike: 3,
// //     bus: 0,
// //     car: 0,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:31",
// //     auto: 0,
// //     motorbike: 0,
// //     bus: 0,
// //     car: 0,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:36",
// //     auto: 0,
// //     motorbike: 5,
// //     bus: 0,
// //     car: 1,
// //     truck: 1,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:41",
// //     auto: 0,
// //     motorbike: 4,
// //     bus: 1,
// //     car: 5,
// //     truck: 1,
// //   },
// // ];

// // // function parseCameraCsv(csvText) {
// // //   const lines = csvText
// // //     .trim()
// // //     .split(/\r?\n/)
// // //     .filter(Boolean);

// // //   if (lines.length < 2) return [];

// // //   const headers = lines[0].split(",").map((h) => h.trim());

// // //   return lines.slice(1).map((line) => {
// // //     const values = line.split(",").map((v) => v.trim());
// // //     const row = {};

// // //     headers.forEach((header, index) => {
// // //       if (header === "timestamp") {
// // //         row[header] = values[index];
// // //       } else {
// // //         row[header] = Number(values[index] || 0);
// // //       }
// // //     });

// // //     return row;
// // //   });
// // // }

// // const CAMERA_LOCATIONS = [
// //   {
// //     id: "camera-site-1",
// //     sno: 1,
// //     place: "Ettayapuram Rd",
// //     location: "Perison Plaza Signal",
// //     boxes: 2,
// //     cameras: 2,
// //     lat: 8.81277,
// //     lng: 78.13647,
// //   },
// //   {
// //     id: "camera-site-2",
// //     sno: 2,
// //     place: "4th Gate",
// //     location: "South side of Milavittan Road",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.80967,
// //     lng: 78.1335,
// //   },
// //   {
// //     id: "camera-site-3",
// //     sno: 3,
// //     place: "International Furniture Park",
// //     location: "Madurai - Tiruchendur Rd highway east side",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.81624,
// //     lng: 78.08118,
// //   },
// //   {
// //     id: "camera-site-4",
// //     sno: 4,
// //     place: "3rd Mile",
// //     location: "Near TVL-TUT-MDR Bypass Bridge",
// //     boxes: 2,
// //     cameras: 2,
// //     lat: 8.789608,
// //     lng: 78.11493,
// //   },
// //   {
// //     id: "camera-site-5",
// //     sno: 5,
// //     place: "Alageshapuram Road",
// //     location: "Roundana near St. Thomas School",
// //     boxes: 1,
// //     cameras: 2,
// //     lat: 8.81705,
// //     lng: 78.14797,
// //   },
// //   {
// //     id: "camera-site-6",
// //     sno: 6,
// //     place: "Tiruchendur Rd",
// //     location: "Muthiahpuram",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.74541,
// //     lng: 78.1253,
// //   },
// // ];

// // const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// // function parseCameraCsv(csvText) {
// //   const lines = csvText
// //     .trim()
// //     .split(/\r?\n/)
// //     .filter(Boolean);

// //   if (lines.length < 2) return [];

// //   const firstLine = lines[0].toLowerCase();
// //   const hasHeader = firstLine.includes("timestamp");

// //   const headers = hasHeader
// //     ? lines[0].split(",").map((h) => h.trim().toLowerCase())
// //     : ["timestamp", "auto", "motorbike", "bus", "car", "truck"];

// //   const dataLines = hasHeader ? lines.slice(1) : lines;

// //   return dataLines.map((line) => {
// //     const values = line.split(",").map((v) => v.trim());
// //     const row = {};

// //     headers.forEach((header, index) => {
// //       if (header === "timestamp") {
// //         row.timestamp = values[index] || "";
// //       } else if (
// //         header === "cameraid" ||
// //         header === "camera_id" ||
// //         header === "camera" ||
// //         header === "site"
// //       ) {
// //         row.cameraId = values[index] || "";
// //       } else if (header === "direction") {
// //         row.direction = values[index] || "All Directions";
// //       } else {
// //         row[header] = Number(values[index] || 0);
// //       }
// //     });

// //     return {
// //       timestamp: row.timestamp || "",
// //       cameraId: row.cameraId || "ALL",
// //       direction: row.direction || "All Directions",
// //       auto: Number(row.auto || 0),
// //       motorbike: Number(row.motorbike || 0),
// //       bus: Number(row.bus || 0),
// //       car: Number(row.car || 0),
// //       truck: Number(row.truck || 0),
// //     };
// //   });
// // }

// // function sumRows(rows) {
// //   return rows.reduce(
// //     (acc, row) => {
// //       acc.auto += Number(row.auto || 0);
// //       acc.motorbike += Number(row.motorbike || 0);
// //       acc.bus += Number(row.bus || 0);
// //       acc.car += Number(row.car || 0);
// //       acc.truck += Number(row.truck || 0);
// //       return acc;
// //     },
// //     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// //   );
// // }

// // function totalFromCounts(counts) {
// //   return VEHICLE_TYPES.reduce((sum, type) => sum + Number(counts[type] || 0), 0);
// // }

// // function getDateKey(timestamp) {
// //   return String(timestamp || "").slice(0, 10);
// // }

// // function getWeekKey(timestamp) {
// //   const datePart = getDateKey(timestamp);
// //   if (!datePart) return "Unknown";

// //   const date = new Date(`${datePart}T00:00:00`);
// //   if (Number.isNaN(date.getTime())) return "Unknown";

// //   const firstDay = new Date(date.getFullYear(), 0, 1);
// //   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
// //   const weekNumber = Math.ceil(dayNumber / 7);

// //   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// // }

// // function buildChartData(rows, mode = "daily") {
// //   const grouped = {};

// //   rows.forEach((row) => {
// //     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
// //     if (!key) return;

// //     if (!grouped[key]) {
// //       grouped[key] = {
// //         label: key,
// //         auto: 0,
// //         motorbike: 0,
// //         bus: 0,
// //         car: 0,
// //         truck: 0,
// //       };
// //     }

// //     VEHICLE_TYPES.forEach((type) => {
// //       grouped[key][type] += Number(row[type] || 0);
// //     });
// //   });

// //   return Object.values(grouped)
// //     .map((item) => ({
// //       ...item,
// //       total: totalFromCounts(item),
// //     }))
// //     .sort((a, b) => a.label.localeCompare(b.label));
// // }

// // function buildDirectionData(rows) {
// //   const grouped = {};

// //   rows.forEach((row) => {
// //     const direction = row.direction || "All Directions";

// //     if (!grouped[direction]) {
// //       grouped[direction] = {
// //         direction,
// //         auto: 0,
// //         motorbike: 0,
// //         bus: 0,
// //         car: 0,
// //         truck: 0,
// //       };
// //     }

// //     VEHICLE_TYPES.forEach((type) => {
// //       grouped[direction][type] += Number(row[type] || 0);
// //     });
// //   });

// //   return Object.values(grouped).map((item) => ({
// //     ...item,
// //     total: totalFromCounts(item),
// //   }));
// // }

// // function CameraMapFlyTo({ selectedLocation }) {
// //   const map = useMap();

// //   useEffect(() => {
// //     if (!selectedLocation) return;

// //     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
// //       duration: 0.8,
// //     });
// //   }, [map, selectedLocation]);

// //   return null;
// // }

// // function MiniBarChart({ title, data }) {
// //   const maxValue = Math.max(...data.map((item) => item.total), 1);

// //   return (
// //     <div className="camera-chart-card">
// //       <div className="camera-chart-header">
// //         <h3>{title}</h3>
// //       </div>

// //       <div className="camera-bar-chart">
// //         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

// //         {data.map((item) => {
// //           const height = Math.max(8, (item.total / maxValue) * 150);

// //           return (
// //             <div className="camera-bar-item" key={item.label}>
// //               <div className="camera-bar-value">{item.total}</div>
// //               <div className="camera-bar-track">
// //                 <div
// //                   className="camera-bar-fill"
// //                   style={{ height: `${height}px` }}
// //                 />
// //               </div>
// //               <div className="camera-bar-label">{item.label}</div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // }

// // function CameraDataPage({ navigate }) {
// //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// //   const [loading, setLoading] = useState(true);
// //   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
// //   const [chartMode, setChartMode] = useState("daily");

// //   const [page, setPage] = useState(1);
// //   const [limit, setLimit] = useState(25);

// //   useEffect(() => {
// //     const csvUrl =
// //       process.env.REACT_APP_CAMERA_CSV_URL ||
// //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// //     fetch(csvUrl)
// //       .then((res) => {
// //         if (!res.ok) throw new Error("CSV not found");
// //         return res.text();
// //       })
// //       .then((text) => {
// //         const parsed = parseCameraCsv(text);
// //         if (parsed.length > 0) {
// //           setRows(parsed.reverse());
// //           setSourceLabel("CSV data");
// //           setPage(1);
// //         }
// //       })
// //       .catch(() => {
// //         setRows(CAMERA_FALLBACK_DATA);
// //         setSourceLabel("Static sample data");
// //       })
// //       .finally(() => setLoading(false));
// //   }, []);

// //   const selectedRows = useMemo(() => {
// //     const hasCameraSpecificRows = rows.some((row) => row.cameraId !== "ALL");

// //     if (!hasCameraSpecificRows) {
// //       return rows;
// //     }

// //     return rows.filter((row) => row.cameraId === selectedLocation.id);
// //   }, [rows, selectedLocation]);

// //   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
// //   const totalVehicles = totalFromCounts(totals);

// //   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
// //   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
// //   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

// //   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

// //   const totalRows = selectedRows.length;
// //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// //   const safePage = Math.min(page, totalPages);
// //   const offset = (safePage - 1) * limit;

// //   const paginatedRows = useMemo(() => {
// //     return selectedRows.slice(offset, offset + limit);
// //   }, [selectedRows, offset, limit]);

// //   const latestRow = selectedRows[0];

// //   const handleLocationClick = (location) => {
// //     setSelectedLocation(location);
// //     setPage(1);
// //   };

// //   const handleLimitChange = (e) => {
// //     setLimit(Number(e.target.value));
// //     setPage(1);
// //   };

// //   return (
// //     <div className="camera-page">
// //       <div className="camera-bg-glow camera-bg-glow-one" />
// //       <div className="camera-bg-glow camera-bg-glow-two" />

// //       <header className="camera-navbar">
// //         <button className="camera-back-button" onClick={() => navigate("/")}>
// //           ← Home
// //         </button>

// //         <div>
// //           <h1>Camera Data</h1>
// //           <p>Traffic counts by vehicle type and camera location</p>
// //         </div>

// //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// //           Bus Tracking
// //         </button>
// //       </header>

// //       <main className="camera-content">
// //         <section className="camera-summary-grid">
// //           <div className="camera-summary-card total">
// //             <span>Total Vehicles</span>
// //             <strong>{totalVehicles}</strong>
// //             <small>{sourceLabel}</small>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Cars</span>
// //             <strong>{totals.car}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Motorbikes</span>
// //             <strong>{totals.motorbike}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Buses</span>
// //             <strong>{totals.bus}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Trucks</span>
// //             <strong>{totals.truck}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Autos</span>
// //             <strong>{totals.auto}</strong>
// //           </div>
// //         </section>

// //         <section className="camera-map-layout">
// //           <aside className="camera-location-panel">
// //             <div className="camera-location-header">
// //               <h2>Camera Locations</h2>
// //               <p>{CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across {CAMERA_LOCATIONS.length} locations</p>
// //             </div>

// //             <div className="camera-location-list">
// //               {CAMERA_LOCATIONS.map((item) => (
// //                 <button
// //                   key={item.id}
// //                   className={
// //                     selectedLocation.id === item.id
// //                       ? "camera-location-item active"
// //                       : "camera-location-item"
// //                   }
// //                   onClick={() => handleLocationClick(item)}
// //                 >
// //                   <div>
// //                     <strong>{item.place}</strong>
// //                     <span>{item.location}</span>
// //                   </div>

// //                   <small>
// //                     {item.cameras} camera{item.cameras > 1 ? "s" : ""}
// //                   </small>
// //                 </button>
// //               ))}
// //             </div>
// //           </aside>

// //           <section className="camera-map-card">
// //             <MapContainer
// //               center={[selectedLocation.lat, selectedLocation.lng]}
// //               zoom={14}
// //               className="camera-osm-map"
// //               scrollWheelZoom={true}
// //             >
// //               <TileLayer
// //                 attribution='&copy; OpenStreetMap contributors'
// //                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// //               />

// //               <CameraMapFlyTo selectedLocation={selectedLocation} />

// //               {CAMERA_LOCATIONS.map((item) => (
// //                 <Marker
// //                   key={item.id}
// //                   position={[item.lat, item.lng]}
// //                   eventHandlers={{
// //                     click: () => handleLocationClick(item),
// //                   }}
// //                 >
// //                   <Popup>
// //                     <div className="camera-popup">
// //                       <h3>{item.place}</h3>
// //                       <p>{item.location}</p>
// //                       <p>
// //                         <strong>Cameras:</strong> {item.cameras}
// //                       </p>
// //                       <p>
// //                         <strong>Total Vehicles:</strong>{" "}
// //                         {selectedLocation.id === item.id ? totalVehicles : "Click location"}
// //                       </p>
// //                     </div>
// //                   </Popup>
// //                 </Marker>
// //               ))}
// //             </MapContainer>
// //           </section>
// //         </section>

// //         <section className="camera-selected-panel">
// //           <div>
// //             <h2>{selectedLocation.place}</h2>
// //             <p>{selectedLocation.location}</p>
// //           </div>

// //           <div className="camera-selected-meta">
// //             <span>{selectedLocation.boxes} boxes</span>
// //             <span>{selectedLocation.cameras} cameras</span>
// //             <span>
// //               {selectedLocation.lat}, {selectedLocation.lng}
// //             </span>
// //           </div>
// //         </section>

// //         {/* <section className="camera-direction-grid">
// //           {directionData.map((item) => (
// //             <div className="camera-direction-card" key={item.direction}>
// //               <span>{item.direction}</span>
// //               <strong>{item.total}</strong>
// //               <small>
// //                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
// //               </small>
// //             </div>
// //           ))}
// //         </section> */}

// //         <section className="camera-chart-section">
// //           <div className="camera-chart-toolbar">
// //             <div>
// //               <h2>Dashboard Analysis</h2>
// //               <p>Daily and weekly traffic count trends</p>
// //             </div>

// //             <div className="camera-chart-toggle">
// //               <button
// //                 className={chartMode === "daily" ? "active" : ""}
// //                 onClick={() => setChartMode("daily")}
// //               >
// //                 Daily
// //               </button>
// //               <button
// //                 className={chartMode === "weekly" ? "active" : ""}
// //                 onClick={() => setChartMode("weekly")}
// //               >
// //                 Weekly
// //               </button>
// //             </div>
// //           </div>

// //           <MiniBarChart
// //             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
// //             data={chartData}
// //           />
// //         </section>

// //         <section className="camera-panel">
// //           <div className="camera-panel-header">
// //             <div>
// //               <h2>Vehicle Count Table</h2>
// //               <p>
// //                 {loading
// //                   ? "Loading camera data..."
// //                   : latestRow
// //                   ? `Latest timestamp: ${latestRow.timestamp}`
// //                   : "No camera records available"}
// //               </p>
// //             </div>

// //             <div className="camera-pagination-top">
// //               <label>
// //                 Limit
// //                 <select value={limit} onChange={handleLimitChange}>
// //                   <option value={10}>10</option>
// //                   <option value={25}>25</option>
// //                   <option value={50}>50</option>
// //                   <option value={100}>100</option>
// //                   <option value={200}>200</option>
// //                 </select>
// //               </label>
// //             </div>
// //           </div>

// //           <div className="camera-table-info">
// //             <span>
// //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// //               {Math.min(offset + limit, totalRows)} of {totalRows}
// //             </span>

// //             <span>
// //               Offset: {offset} | Limit: {limit}
// //             </span>
// //           </div>

// //           <div className="camera-table-wrap">
// //             <table className="camera-table">
// //               <thead>
// //                 <tr>
// //                   <th>Timestamp</th>
// //                   <th>Direction</th>
// //                   <th>Auto</th>
// //                   <th>Motorbike</th>
// //                   <th>Bus</th>
// //                   <th>Car</th>
// //                   <th>Truck</th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {paginatedRows.map((row, index) => (
// //                   <tr key={`${row.timestamp}-${index}`}>
// //                     <td>{row.timestamp}</td>
// //                     <td>{row.direction}</td>
// //                     <td>{row.auto}</td>
// //                     <td>{row.motorbike}</td>
// //                     <td>{row.bus}</td>
// //                     <td>{row.car}</td>
// //                     <td>{row.truck}</td>
// //                   </tr>
// //                 ))}

// //                 {!loading && paginatedRows.length === 0 && (
// //                   <tr>
// //                     <td colSpan="7" style={{ textAlign: "center", padding: "24px" }}>
// //                       No camera data available
// //                     </td>
// //                   </tr>
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>

// //           <div className="camera-pagination-bottom">
// //             <button onClick={() => setPage((prev) => Math.max(1, prev - 1))} disabled={safePage <= 1}>
// //               ← Previous
// //             </button>

// //             <span>
// //               Page {safePage} of {totalPages}
// //             </span>

// //             <button onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))} disabled={safePage >= totalPages}>
// //               Next →
// //             </button>
// //           </div>
// //         </section>
// //       </main>
// //     </div>
// //   );
// // }
// // // function CameraDataPage({ navigate }) {
// // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // //   const [loading, setLoading] = useState(true);

// // //   // Pagination states
// // //   const [page, setPage] = useState(1);
// // //   const [limit, setLimit] = useState(25);

// // //   useEffect(() => {
// // //     const csvUrl =
// // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // //     fetch(csvUrl)
// // //       .then((res) => {
// // //         if (!res.ok) throw new Error("CSV not found");
// // //         return res.text();
// // //       })
// // //       .then((text) => {
// // //         const parsed = parseCameraCsv(text);
// // //         if (parsed.length > 0) {
// // //           // latest data first
// // //           setRows(parsed.reverse());
// // //           setSourceLabel("CSV data");
// // //           setPage(1);
// // //         }
// // //       })
// // //       .catch(() => {
// // //         setRows(CAMERA_FALLBACK_DATA);
// // //         setSourceLabel("Static sample data");
// // //       })
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   const totals = useMemo(() => {
// // //     return rows.reduce(
// // //       (acc, row) => {
// // //         acc.auto += Number(row.auto || 0);
// // //         acc.motorbike += Number(row.motorbike || 0);
// // //         acc.bus += Number(row.bus || 0);
// // //         acc.car += Number(row.car || 0);
// // //         acc.truck += Number(row.truck || 0);
// // //         return acc;
// // //       },
// // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // //     );
// // //   }, [rows]);

// // //   const totalVehicles =
// // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // //   const totalRows = rows.length;
// // //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// // //   const safePage = Math.min(page, totalPages);

// // //   const offset = (safePage - 1) * limit;

// // //   const paginatedRows = useMemo(() => {
// // //     return rows.slice(offset, offset + limit);
// // //   }, [rows, offset, limit]);

// // //   const latestRow = rows[0];

// // //   const goToPreviousPage = () => {
// // //     setPage((prev) => Math.max(1, prev - 1));
// // //   };

// // //   const goToNextPage = () => {
// // //     setPage((prev) => Math.min(totalPages, prev + 1));
// // //   };

// // //   const handleLimitChange = (e) => {
// // //     setLimit(Number(e.target.value));
// // //     setPage(1);
// // //   };

// // //   return (
// // //     <div className="camera-page">
// // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // //       <header className="camera-navbar">
// // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // //           ← Home
// // //         </button>

// // //         <div>
// // //           <h1>Camera Data</h1>
// // //           <p>Vehicle count analytics</p>
// // //         </div>

// // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // //           Bus Tracking
// // //         </button>
// // //       </header>

// // //       <main className="camera-content">
// // //         <section className="camera-summary-grid">
// // //           <div className="camera-summary-card total">
// // //             <span>Total Vehicles</span>
// // //             <strong>{totalVehicles}</strong>
// // //             <small>{sourceLabel}</small>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Cars</span>
// // //             <strong>{totals.car}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Motorbikes</span>
// // //             <strong>{totals.motorbike}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Buses</span>
// // //             <strong>{totals.bus}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Trucks</span>
// // //             <strong>{totals.truck}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Autos</span>
// // //             <strong>{totals.auto}</strong>
// // //           </div>
// // //         </section>

// // //         <section className="camera-panel">
// // //           <div className="camera-panel-header">
// // //             <div>
// // //               <h2>Vehicle Count Table</h2>
// // //               <p>
// // //                 {loading
// // //                   ? "Loading camera data..."
// // //                   : latestRow
// // //                     ? `Latest timestamp: ${latestRow.timestamp}`
// // //                     : "No camera records available"}
// // //               </p>
// // //             </div>

// // //             <div className="camera-pagination-top">
// // //               <label>
// // //                 Limit
// // //                 <select value={limit} onChange={handleLimitChange}>
// // //                   <option value={10}>10</option>
// // //                   <option value={25}>25</option>
// // //                   <option value={50}>50</option>
// // //                   <option value={100}>100</option>
// // //                   <option value={200}>200</option>
// // //                 </select>
// // //               </label>
// // //             </div>
// // //           </div>

// // //           <div className="camera-table-info">
// // //             <span>
// // //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// // //               {Math.min(offset + limit, totalRows)} of {totalRows}
// // //             </span>

// // //             <span>
// // //               Offset: {offset} | Limit: {limit}
// // //             </span>
// // //           </div>

// // //           <div className="camera-table-wrap">
// // //             <table className="camera-table">
// // //               <thead>
// // //                 <tr>
// // //                   <th>Timestamp</th>
// // //                   <th>Auto</th>
// // //                   <th>Motorbike</th>
// // //                   <th>Bus</th>
// // //                   <th>Car</th>
// // //                   <th>Truck</th>
// // //                 </tr>
// // //               </thead>

// // //               <tbody>
// // //                 {paginatedRows.map((row, index) => (
// // //                   <tr key={`${row.timestamp}-${index}`}>
// // //                     <td>{row.timestamp}</td>
// // //                     <td>{row.auto}</td>
// // //                     <td>{row.motorbike}</td>
// // //                     <td>{row.bus}</td>
// // //                     <td>{row.car}</td>
// // //                     <td>{row.truck}</td>
// // //                   </tr>
// // //                 ))}

// // //                 {!loading && paginatedRows.length === 0 && (
// // //                   <tr>
// // //                     <td colSpan="6" style={{ textAlign: "center", padding: "24px" }}>
// // //                       No camera data available
// // //                     </td>
// // //                   </tr>
// // //                 )}
// // //               </tbody>
// // //             </table>
// // //           </div>

// // //           <div className="camera-pagination-bottom">
// // //             <button onClick={goToPreviousPage} disabled={safePage <= 1}>
// // //               ← Previous
// // //             </button>

// // //             <span>
// // //               Page {safePage} of {totalPages}
// // //             </span>

// // //             <button onClick={goToNextPage} disabled={safePage >= totalPages}>
// // //               Next →
// // //             </button>
// // //           </div>
// // //         </section>
// // //       </main>
// // //     </div>
// // //   );
// // // }
// // // function CameraDataPage({ navigate }) {
// // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // //   const [loading, setLoading] = useState(true);

// // //   useEffect(() => {
// // //     const csvUrl =
// // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // //     fetch(csvUrl)
// // //       .then((res) => {
// // //         if (!res.ok) throw new Error("CSV not found");
// // //         return res.text();
// // //       })
// // //       .then((text) => {
// // //         const parsed = parseCameraCsv(text);
// // //         if (parsed.length > 0) {
// // //           setRows(parsed);
// // //           setSourceLabel("CSV data");
// // //         }
// // //       })
// // //       .catch(() => {
// // //         setRows(CAMERA_FALLBACK_DATA);
// // //         setSourceLabel("Static sample data");
// // //       })
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   const totals = useMemo(() => {
// // //     return rows.reduce(
// // //       (acc, row) => {
// // //         acc.auto += Number(row.auto || 0);
// // //         acc.motorbike += Number(row.motorbike || 0);
// // //         acc.bus += Number(row.bus || 0);
// // //         acc.car += Number(row.car || 0);
// // //         acc.truck += Number(row.truck || 0);
// // //         return acc;
// // //       },
// // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // //     );
// // //   }, [rows]);

// // //   const totalVehicles =
// // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // //   const latestRow = rows[rows.length - 1];

// // //   return (
// // //     <div className="camera-page">
// // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // //       <header className="camera-navbar">
// // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // //           ← Home
// // //         </button>

// // //         <div>
// // //           <h1>Camera Data</h1>
// // //           <p>Vehicle count analytics</p>
// // //         </div>

// // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // //           Bus Tracking
// // //         </button>
// // //       </header>

// // //       <main className="camera-content">
// // //         <section className="camera-summary-grid">
// // //           <div className="camera-summary-card total">
// // //             <span>Total Vehicles</span>
// // //             <strong>{totalVehicles}</strong>
// // //             <small>{sourceLabel}</small>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Cars</span>
// // //             <strong>{totals.car}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Motorbikes</span>
// // //             <strong>{totals.motorbike}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Buses</span>
// // //             <strong>{totals.bus}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Trucks</span>
// // //             <strong>{totals.truck}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Autos</span>
// // //             <strong>{totals.auto}</strong>
// // //           </div>
// // //         </section>

// // //         <section className="camera-panel">
// // //           <div className="camera-panel-header">
// // //             <div>
// // //               <h2>Vehicle Count Table</h2>
// // //               <p>
// // //                 {loading
// // //                   ? "Loading camera data..."
// // //                   : latestRow
// // //                   ? `Latest timestamp: ${latestRow.timestamp}`
// // //                   : "No camera records available"}
// // //               </p>
// // //             </div>
// // //           </div>

// // //           <div className="camera-table-wrap">
// // //             <table className="camera-table">
// // //               <thead>
// // //                 <tr>
// // //                   <th>Timestamp</th>
// // //                   <th>Auto</th>
// // //                   <th>Motorbike</th>
// // //                   <th>Bus</th>
// // //                   <th>Car</th>
// // //                   <th>Truck</th>
// // //                 </tr>
// // //               </thead>

// // //               <tbody>
// // //                 {rows.map((row, index) => (
// // //                   <tr key={`${row.timestamp}-${index}`}>
// // //                     <td>{row.timestamp}</td>
// // //                     <td>{row.auto}</td>
// // //                     <td>{row.motorbike}</td>
// // //                     <td>{row.bus}</td>
// // //                     <td>{row.car}</td>
// // //                     <td>{row.truck}</td>
// // //                   </tr>
// // //                 ))}
// // //               </tbody>
// // //             </table>
// // //           </div>
// // //         </section>
// // //       </main>
// // //     </div>
// // //   );
// // // }

// /* ---------------------------- APP (router) ---------------------------- */

// function App() {
//   const { path, navigate } = usePath();
//   const token = getToken();
//   const adminToken = getAdminToken();

//   // Track page views on bus tracking page for Prometheus
//   useEffect(() => {
//     if (!BACKEND) return;
//     if (path !== "/tracking") return;
//     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
//   }, [path]);

//   // Forward /driver -> /driverRoute when logged in
//   useEffect(() => {
//     if (path === "/driver" && token) {
//       navigate("/driverRoute");
//     }
//   }, [path, token, navigate]);

//   // Admin redirects
//   useEffect(() => {
//     if (path === "/admin/login" && adminToken) {
//       navigate("/admin");
//     } else if (path === "/admin" && !adminToken) {
//       navigate("/admin/login");
//     }
//   }, [path, adminToken, navigate]);

//   // New public pages
//   if (path === "/") {
//     return <HomePage navigate={navigate} />;
//   }

//   if (path === "/tracking") {
//     return <MapPage />;
//   }

//   if (path === "/camera") {
//     return <CameraDataPage navigate={navigate} />;
//   }

//   // Existing driver pages
//   if (path === "/driver") {
//     if (token) return null;
//     return <DriverLogin navigate={navigate} />;
//   }

//   if (path === "/driverRoute") {
//     return <DriverRoute navigate={navigate} />;
//   }

//   // Existing admin pages
//   if (path === "/admin/login") {
//     if (adminToken) return null;
//     return <AdminLogin navigate={navigate} />;
//   }

//   if (path === "/admin") {
//     return <AdminDashboard navigate={navigate} />;
//   }

//   // Fallback
//   return <HomePage navigate={navigate} />;
// }

// // export default function App() {
// //   const { path, navigate } = usePath();
// //   const token = getToken();
// //   const adminToken = getAdminToken();

// //   // Track page views on main map for Prometheus
// //   useEffect(() => {
// //     if (!BACKEND) return;
// //     if (path !== "/") return;
// //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// //   }, [path]);

// //   // Forward /driver -> /driverRoute when logged in
// //   useEffect(() => {
// //     if (path === "/driver" && token) {
// //       navigate("/driverRoute");
// //     }
// //   }, [path, token, navigate]);

// //   // Admin redirects
// //   useEffect(() => {
// //     if (path === "/admin/login" && adminToken) {
// //       navigate("/admin");
// //     } else if (path === "/admin" && !adminToken) {
// //       navigate("/admin/login");
// //     }
// //   }, [path, adminToken, navigate]);

// //   if (path === "/driver") {
// //     if (token) return null;
// //     return <DriverLogin navigate={navigate} />;
// //   }
// //   if (path === "/driverRoute") return <DriverRoute navigate={navigate} />;

// //   if (path === "/admin/login") {
// //     if (adminToken) return null;
// //     return <AdminLogin navigate={navigate} />;
// //   }
// //   if (path === "/admin") {
// //     return <AdminDashboard navigate={navigate} />;
// //   }

// //   return <MapPage />;
// // }

// // export default function App() {
// //   const { path, navigate } = usePath();
// //   const token = getToken();

// //   // Track page views on main map for Prometheus
// //   useEffect(() => {
// //     if (!BACKEND) return;
// //     if (path !== "/") return;
// //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => {});
// //   }, [path]);

// //   // Forward /driver -> /driverRoute when logged in (no hooks called conditionally)
// //   useEffect(() => {
// //     if (path === '/driver' && token) {
// //       navigate('/driverRoute');
// //     }
// //   }, [path, token, navigate]);

// //   if (path === '/driver') {
// //     if (token) return null;
// //     return <DriverLogin navigate={navigate} />;
// //   }
// //   if (path === '/driverRoute') return <DriverRoute navigate={navigate} />;
// //   return <MapPage />;
// // }

// export { App };
// export default App;


// // // thoothukudi/frontend/src/App.js
// // // import React, { useEffect, useState, useRef, useLayoutEffect, useMemo } from 'react';
// // import React, {
// //   useEffect,
// //   useState,
// //   useRef,
// //   useMemo,
// //   useCallback
// // } from 'react';

// // import axios from 'axios';
// // import { io } from 'socket.io-client';
// // import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
// // import L from 'leaflet';
// // import 'leaflet/dist/leaflet.css';
// // import './App.css';
// // import * as turf from '@turf/turf';

// // // ---- Assets in src/assets ----
// // import userIcon from './assets/user-icon.png';
// // import stopIconImg from './assets/bus-stop.png';
// // // import iitmLogo from './assets/iitm-logo.png';
// // import iitmLogo from './assets/mint_logo.png';

// // // ---- Backend base URL ----
// // const BACKEND = process.env.REACT_APP_BACKEND_URL;
// // // API key is not needed on the frontend after removing ETA polling.
// // const FEEDBACK_URL = process.env.REACT_APP_FEEDBACK_URL || '';


// // // ---- Static roads URL (public/roads.geojson) ----
// // const ROADS_URL = `${process.env.PUBLIC_URL || ''}/roads.geojson`;

// // // ---- Map zoom param ----
// // const DEFAULT_ZOOM = 16;

// // // ---- Smoothing / Snap params ----
// // const SMOOTH_ALPHA = 0.3;
// // const HEADING_ALPHA = 0.35;
// // const SNAP_MAX_DIST_M = 20;

// // // Staleness threshold for under-maintenance banner
// // const STALE_MS = 150_000; // ~2.5 minutes

// // // Initial center (fallback)
// // // const center = { lat: 12.9915, lng: 80.2336 };
// // const center = { lat: 8.7642, lng: 78.1348 };

// // // ---------------- STOPS WITH IDS (for route math) ----------------
// // // const busStops = [
// // //   { name: 'Velachery Gate IIT Campus Stop', lat: 12.988763557585395, lng: 80.22367960515129, id: 1 },
// // //   { name: 'NAC2 Stop Towards GC', lat: 12.990236, lng: 80.227548, id: 2 },
// // //   { name: 'Nac2 Towards Velachery Stop', lat: 12.9898636, lng: 80.2271109, id: 3 },
// // //   { name: 'CRC Towards GC Stop', lat: 12.99089, lng: 80.230274, id: 4 },
// // //   { name: 'CRC Towards Velachery Stop', lat: 12.99079680, lng: 80.23016660, id: 5 },  
// // //   { name: 'HSB Stop Towards Velachery Stop', lat: 12.99076780, lng: 80.23168950, id: 6},
// // //   { name: 'HSB Stop Towards GC', lat: 12.991037, lng: 80.232065, id: 7},
// // //   { name: 'KV Stop Towards Main Gate', lat: 12.991868573807471, lng: 80.23367454352295, id: 8 },
// // //   { name: 'KV Stop Towards GC', lat: 12.991910, lng: 80.233785, id: 9 },
// // //   { name: 'Postoffice Stop Towards Main Gate', lat: 12.99388680, lng: 80.23428760, id: 10 },
// // //   { name: 'Postoffice Stop Towards GC', lat: 12.99393340, lng: 80.23459350, id: 11 },
// // //   { name: 'E1 Stop Towards Main Gate', lat: 12.9960173, lng: 80.2359173, id: 12 },
// // //   { name: 'E1 Stop Towards GC', lat: 12.996117, lng: 80.236184, id: 13},
// // //   { name: 'Vana Vani Stop Towards Main Gate', lat: 12.998704, lng: 80.2391799, id: 14 },
// // //   { name: 'Vana Vani Stop Towards GC', lat: 12.999084,   lng:  80.239380, id: 15 },
// // //   { name: 'D1 Stop Towards Main Gate', lat:13.002546, lng: 80.240091, id: 16},
// // //   { name: 'D1 Stop Towards GC', lat: 13.002679,  lng: 80.240219, id: 17 },
// // //   { name: 'Main Gate', lat: 13.00612964850378, lng: 80.24191299117685, id: 18 },
// // //   { name: 'GC Stop Towards Hostel', lat: 12.991342, lng: 80.233637, id: 19 },
// // //   { name: 'Library Stop', lat: 12.9907517, lng: 80.2334554, id: 20 },
// // //   { name: 'OAT Stop Towards Hostel', lat: 12.989257,  lng: 80.233031, id: 21},
// // //   { name: 'Gymkhana Stop Towards GC', lat: 12.9866372, lng: 80.2332951, id: 22},
// // //   { name: 'Gymkhana Stop Towards Hostel', lat: 12.986615, lng: 80.233366, id: 23 },
// // //   { name: 'Narmada Stop Towards GC', lat: 12.9862759, lng: 80.2350107, id: 24 },
// // //   { name: 'Narmada Stop Towards Hostel', lat: 12.986546, lng: 80.235301, id: 25 },
// // //   { name: 'Jamuna and Ganga Stand', lat: 12.986566332825637, lng: 80.23855704439099, id: 26 },
// // //   { name: 'RP Stand', lat: 12.990088, lng: 80.241799, id: 28},
// // //   { name: 'ED Stand', lat: 12.989874633072303, lng: 80.22646042038593, id: 29},
// // // ];

// // const busStops = [
// //   { name: "THOOTHUKUDI OLD B/S", lat: 8.803153, lng: 78.140603, id: 1 },
// //   { name: "VOC COLLEGE", lat: 8.795628, lng: 78.126712, id: 2 },
// //   { name: "3RD MILE", lat: 8.790018, lng: 78.115506, id: 3 },
// //   { name: "KORAMPALLAM", lat: 8.778041, lng: 78.092443, id: 4 },
// //   { name: "ANTHONIYARPURAM", lat: 8.773973, lng: 78.085733, id: 5 },
// //   { name: "THATTAPARAI JUNCTION", lat: 8.755951, lng: 78.065920, id: 6 },
// //   { name: "PUDHUKOTTAI", lat: 8.745961, lng: 78.053331, id: 7 },
// //   { name: "SIRUPADU JUNCTION", lat: 8.741241, lng: 78.057561, id: 8 },
// //   { name: "KOOTTAMPULI", lat: 8.721905, lng: 78.065464, id: 9 },
// //   { name: "SERVAIKARANMADAM", lat: 8.706851, lng: 78.055434, id: 10 },
// //   { name: "JAKKAMMALPURAM", lat: 8.696665, lng: 78.048089, id: 11 },
// //   { name: "SEBATHAIAHPURAM", lat: 8.685897, lng: 78.043820, id: 12 },
// //   { name: "SAWYERPURAM", lat: 8.683487, lng: 78.031302, id: 13 },
// //   { name: "SUBRAMANIYAPURAM", lat: 8.674211, lng: 78.026536, id: 14 },
// //   { name: "RAMASAMYPURAM BRIDGE", lat: 8.669235, lng: 78.031267, id: 15 },
// //   { name: "PERUMPADAI SASTHA KOVIL", lat: 8.671132, lng: 78.041593, id: 16 },
// //   { name: "RAMASAMYPURAM", lat: 8.669235, lng: 78.031267, id: 17 },
// //   { name: "ZAKKAMMALPURAM", lat: 8.653646, lng: 78.025552, id: 18 },
// //   { name: "SIRUTHONDANALLUR", lat: 8.634397, lng: 78.019538, id: 19 },
// //   { name: "ERAL", lat: 8.625024, lng: 78.025350, id: 20 },
// //   { name: "MANGALAGIRI", lat: 8.740194, lng: 78.037454, id: 21 },
// //   { name: "ALLIKULAM", lat: 8.761745, lng: 78.027343, id: 22 },
// //   { name: "THIRUVANANDHA PURAM", lat: 8.770303, lng: 78.018599, id: 23 },
// //   { name: "PEROORANI", lat: 8.766952, lng: 78.001463, id: 24 },
// //   { name: "UZHAVAR SANTHAI", lat: 8.809685, lng: 78.137081, id: 25 },
// //   { name: "4TH GATE", lat: 8.809664, lng: 78.133561, id: 26 },
// //   { name: "THRES PURAM", lat: 8.815399, lng: 78.160791, id: 27 },
// //   { name: "SUB COLLECTOR OFFICE", lat: 8.803112, lng: 78.158268, id: 28 },
// //   { name: "MILLER PURAM", lat: 8.795547, lng: 78.125969, id: 29 },
// //   { name: "NATTATTHI", lat: 8.668795, lng: 78.009948, id: 30 },
// //   { name: "PANDARAVILAI", lat: 8.657570, lng: 77.999515, id: 31 },
// //   { name: "PERUNKULAM", lat: 8.642502, lng: 77.997765, id: 32 },
// //   { name: "SIVAKALAI", lat: 8.640133, lng: 77.977687, id: 33 },
// //   { name: "KULAIYANKARISAL", lat: 8.719266, lng: 78.077173, id: 34 },
// //   { name: "SIRUPADU", lat: 8.739285, lng: 78.067272, id: 35 },
// //   { name: "PEIKULAM", lat: 8.706840, lng: 78.055406, id: 36 },
// //   { name: "SALAI", lat: 8.696664, lng: 78.048079, id: 37 },
// //   { name: "MANGALAKURICHI", lat: 8.625375, lng: 77.997223, id: 38 },
// //   { name: "THIRD MILE", lat: 8.790018, lng: 78.115506, id: 39 },
// //   { name: "SUBRAMANIAPURAM", lat: 8.674211, lng: 78.026536, id: 40 },
// //   { name: "MARKET", lat: 8.801757, lng: 78.139084, id: 41 },
// //   { name: "LEVANJIPURAM", lat: 8.789036, lng: 78.141181, id: 42 },
// //   { name: "UPPATTHU ODAI", lat: 8.771189, lng: 78.134295, id: 43 },
// //   { name: "MUTHAIAHPURAM", lat: 8.742466, lng: 78.123763, id: 44 },
// //   { name: "SPIC NAGAR", lat: 8.739716, lng: 78.122362, id: 45 },
// //   { name: "MULLAKADU", lat: 8.727742, lng: 78.116493, id: 46 },
// //   { name: "MADHIKETTAN ODAI", lat: 8.702375, lng: 78.106893, id: 47 },
// //   { name: "KOVANKADU JUNCTION", lat: 8.690703, lng: 78.103970, id: 48 },
// //   { name: "PALAIYA KAYAL", lat: 8.671247, lng: 78.094375, id: 49 },
// //   { name: "CHAMBER", lat: 8.649106, lng: 78.083705, id: 50 },
// //   { name: "MUKKANI", lat: 8.634530, lng: 78.073992, id: 51 },
// //   { name: "UMARIKADU", lat: 8.626411, lng: 78.059076, id: 52 },
// //   { name: "VAZHAVALLAN", lat: 8.631211, lng: 78.047511, id: 53 },
// //   { name: "WATER TANK", lat: 8.625474, lng: 78.052962, id: 54 },
// //   { name: "SETHUSUBRAMANIAPURAM", lat: 8.616498, lng: 78.029879, id: 55 },
// //   { name: "KURUMBUR", lat: 8.591328, lng: 78.044404, id: 56 },
// //   { name: "KURUMBUR R/S", lat: 8.585888, lng: 78.039294, id: 57 },
// //   { name: "AMERICAN HOSPITAL", lat: 8.813731, lng: 78.146898, id: 58 },
// //   { name: "KEBI", lat: 8.814688, lng: 78.151524, id: 59 },
// //   { name: "MURUGAN THEATRE", lat: 8.819765, lng: 78.155648, id: 60 },
// //   { name: "RAJA PALAIYAM", lat: 8.827343, lng: 78.153629, id: 61 },
// //   { name: "THALAMUTHU NAGAR", lat: 8.834404, lng: 78.152257, id: 62 },
// //   { name: "AROCKIAPURAM", lat: 8.825379, lng: 78.149005, id: 63 },
// //   { name: "SAVARAIYARPURAM", lat: 8.834448, lng: 78.144850, id: 64 },
// //   { name: "SAVARAIYARPURAM JUNCTION", lat: 8.839360, lng: 78.143028, id: 65 },
// //   { name: "STATE BANK COLONY", lat: 8.817087, lng: 78.132907, id: 66 },
// //   { name: "MAPPILLAIYOORANI", lat: 8.831674, lng: 78.127735, id: 67 },
// //   { name: "KALI KOVIL JUNCTION", lat: 8.836141, lng: 78.126243, id: 68 },
// //   { name: "ODAIPATTI PUDHUR", lat: 8.853648, lng: 78.120200, id: 69 },
// //   { name: "VELAYUTHAPURAM", lat: 8.859844, lng: 78.107125, id: 70 },
// //   { name: "NAINAR PURAM", lat: 8.866548, lng: 78.091527, id: 71 },
// //   { name: "CHILLANATTHAM", lat: 8.873462, lng: 78.071265, id: 72 },
// //   { name: "RAJAVIN KOVIL", lat: 8.873143, lng: 78.048237, id: 73 },
// //   { name: "PUTHIYAMPUTHUR", lat: 8.872962, lng: 78.032288, id: 74 },
// //   { name: "MUPPULIPATI", lat: 8.900392, lng: 78.025670, id: 75 },
// //   { name: "OTTAPIDARAM", lat: 8.909341, lng: 78.022479, id: 76 },
// //   { name: "THOOTHUKUDI NEW B/S", lat: 8.810793, lng: 78.138305, id: 77 },
// //   { name: "BYPASS", lat: 8.785154, lng: 78.106127, id: 78 },
// //   { name: "MADATTHOOR", lat: 8.794360, lng: 78.097304, id: 79 },
// //   { name: "SIPCOT COMPLEX", lat: 8.804587, lng: 78.084655, id: 80 },
// //   { name: "RAILWAY GATE", lat: 8.812567, lng: 78.080637, id: 81 },
// //   { name: "VEERAPANDIAPURAM", lat: 8.827254, lng: 78.065695, id: 82 },
// //   { name: "KAYALOORANI", lat: 8.840263, lng: 78.061390, id: 83 },
// //   { name: "SAMYNATTHAM", lat: 8.864407, lng: 78.055924, id: 84 },
// //   { name: "OSANOOTTHU", lat: 8.891915, lng: 77.982711, id: 85 },
// //   { name: "KOMBADI", lat: 8.879422, lng: 77.963106, id: 86 },
// //   { name: "PANDIAPURAM", lat: 8.862311, lng: 77.934601, id: 87 },
// //   { name: "PARAIKUTTAM", lat: 8.858671, lng: 77.924877, id: 88 },
// //   { name: "VADAMALAPURAM", lat: 8.860927, lng: 77.906750, id: 89 },
// //   { name: "MANIYACCHI", lat: 8.863306, lng: 77.894711, id: 90 },
// //   { name: "OTTANATTHAM", lat: 8.903988, lng: 77.898311, id: 91 },
// //   { name: "KALLATTHIKINARU", lat: 8.919118, lng: 77.885396, id: 92 },
// //   { name: "MALAIPATTI", lat: 8.936648, lng: 77.888163, id: 93 },
// //   { name: "ILAVELANKAL", lat: 8.946648, lng: 77.864022, id: 94 },
// //   { name: "IYRAVIPATTI", lat: 8.932030, lng: 77.864758, id: 95 },
// //   { name: "PARIVALLIKOTTAI", lat: 8.923368, lng: 77.874054, id: 96 },
// //   { name: "THANNEER PANDHAL", lat: 8.862521, lng: 78.116944, id: 97 },
// //   { name: "ARASADI JUNCTION", lat: 8.879929, lng: 78.111422, id: 98 },
// //   { name: "VALASAMUTHIRAM", lat: 8.902361, lng: 78.102086, id: 99 },
// //   { name: "KURUKKUSALAI", lat: 8.931410, lng: 78.088196, id: 100 },
// //   { name: "RAMACHANDRAPURAM", lat: 8.927895, lng: 78.077923, id: 101 },
// //   { name: "KAKKARAMPATTI JUNCTION", lat: 8.925977, lng: 78.064895, id: 102 },
// //   { name: "MEENAKSHIPURAM", lat: 8.923832, lng: 78.057035, id: 103 },
// //   { name: "OTTAPIDARAM TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 104 },
// //   { name: "AYYANAR KOVIL", lat: 8.902593, lng: 78.012899, id: 105 },
// //   { name: "KULASEKARANALLOOR", lat: 8.899773, lng: 77.981243, id: 106 },
// //   { name: "SOUTH AARAIKULAM", lat: 8.916444, lng: 77.974949, id: 107 },
// //   { name: "NORTH AARAIKULAM", lat: 8.923940, lng: 77.973027, id: 108 },
// //   { name: "TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 109 },
// //   { name: "THERKKU ARAIKULAM", lat: 8.916444, lng: 77.974949, id: 110 },
// //   { name: "THOMAS NAGAR", lat: 8.839335, lng: 78.143038, id: 111 },
// //   { name: "AYYANAR PURAM", lat: 8.859083, lng: 78.145946, id: 112 },
// //   { name: "JOTHI SALT", lat: 8.863746, lng: 78.147926, id: 113 },
// //   { name: "THARUVAIKULAM", lat: 8.896085, lng: 78.162889, id: 114 },
// //   { name: "PATTINAMARUTHUR", lat: 8.923039, lng: 78.179675, id: 115 },
// //   { name: "KALMEDU", lat: 8.943135, lng: 78.180943, id: 116 },
// //   { name: "CHEMICAL", lat: 8.961828, lng: 78.180195, id: 117 },
// //   { name: "VEPPALODAI", lat: 8.966764, lng: 78.180558, id: 118 },
// //   { name: "PANAIYOOR JUNCTION", lat: 8.979427, lng: 78.200198, id: 119 },
// //   { name: "SALT FACTORY", lat: 8.993585, lng: 78.216936, id: 120 },
// //   { name: "KALLOORANI", lat: 8.990696, lng: 78.231998, id: 121 },
// //   { name: "KEELA VAIPPAR", lat: 8.999548, lng: 78.251410, id: 122 },
// //   { name: "THULUKKANKULAM", lat: 9.031660, lng: 78.272640, id: 123 },
// //   { name: "KALAIGNANAPURAM", lat: 9.032364, lng: 78.266939, id: 124 },
// //   { name: "KALAIGNANAPURAM JUNCTION", lat: 9.035342, lng: 78.258363, id: 125 },
// //   { name: "VAIPPAR", lat: 9.025940, lng: 78.245625, id: 126 },
// //   { name: "SOUTHERN SALT", lat: 8.705618, lng: 78.108039, id: 127 },
// //   { name: "NORTH AUTHOOR", lat: 8.622425, lng: 78.070322, id: 128 },
// //   { name: "SOUTH AUTHOOR", lat: 8.614603, lng: 78.070710, id: 129 },
// //   { name: "AYYANKOVIL JUNCTION", lat: 8.598784, lng: 78.072198, id: 130 },
// //   { name: "MICHEAL NADAR KUDIYIRUPPU", lat: 8.601003, lng: 78.053355, id: 131 },
// //   { name: "PANAIYOOR GATE", lat: 8.979427, lng: 78.200198, id: 132 },
// //   { name: "AM PATTI", lat: 8.901119, lng: 78.144213, id: 133 },
// //   { name: "THERMAL STATION", lat: 8.902320, lng: 78.138007, id: 134 },
// //   { name: "AM PATTI JUNCTION", lat: 8.907276, lng: 78.126656, id: 135 },
// //   { name: "MELA MARUTHUR", lat: 8.914773, lng: 78.137694, id: 136 },
// //   { name: "DURAISAMYPURAM", lat: 8.938686, lng: 78.156320, id: 137 },
// //   { name: "SOUTH KALMEDU", lat: 8.951746, lng: 78.168851, id: 138 },
// //   { name: "NORTH KALMEDU", lat: 8.954783, lng: 78.170766, id: 139 },
// //   { name: "PANAIYOOR", lat: 8.992923, lng: 78.196242, id: 140 },
// //   { name: "KULATTHOOR", lat: 9.004578, lng: 78.194272, id: 141 },
// //   { name: "COLONY", lat: 9.008341, lng: 78.204491, id: 142 },
// //   { name: "ARASADI", lat: 8.870406, lng: 78.127151, id: 143 },
// //   { name: "KEELA ARASADI", lat: 8.877666, lng: 78.127424, id: 144 },
// //   { name: "KUMARAPURAM", lat: 8.899629, lng: 78.119815, id: 145 },
// //   { name: "PUDHUR", lat: 8.949025, lng: 78.149634, id: 146 },
// //   { name: "VEDANATTHAM", lat: 8.968335, lng: 78.145818, id: 147 },
// //   { name: "VENKATACHALAPURAM", lat: 8.979063, lng: 78.157313, id: 148 },
// //   { name: "MUTHUKUMARAPURAM", lat: 8.992612, lng: 78.145428, id: 149 },
// //   { name: "SUBRAMANIYAPURAM JUNCTION", lat: 9.015801, lng: 78.225924, id: 150 },
// //   { name: "THULUKKANKULAM JUNCTION", lat: 9.035332, lng: 78.258348, id: 151 },
// //   { name: "CHANDRAGIRI JUNCTION", lat: 8.959742, lng: 78.092867, id: 152 },
// //   { name: "CHANDRAGIRI", lat: 8.963758, lng: 78.074077, id: 153 },
// //   { name: "KOLLAMPARAMBU", lat: 8.981801, lng: 78.119157, id: 154 },
// //   { name: "SEITHALAI JUNCTION", lat: 8.979604, lng: 78.068883, id: 155 },
// //   { name: "KEELA SEITHALAI", lat: 8.988456, lng: 78.093180, id: 156 },
// //   { name: "KOVANKADU", lat: 8.690829, lng: 78.104060, id: 157 },
// //   { name: "SOUTH KOVANKADU", lat: 8.690280, lng: 78.089963, id: 158 },
// //   { name: "SAMBADI", lat: 8.669595, lng: 78.078838, id: 159 },
// //   { name: "IDAYARKADU", lat: 8.664261, lng: 78.064077, id: 160 },
// //   { name: "MARAMANGALAM", lat: 8.657852, lng: 78.060310, id: 161 },
// //   { name: "ARUMUGAMANGALAM", lat: 8.649895, lng: 78.042699, id: 162 },
// //   { name: "POTTALKADU", lat: 8.719686, lng: 78.102315, id: 163 },
// //   { name: "KATTALANKULAM", lat: 8.698745, lng: 78.007000, id: 164 },
// //   { name: "M. PUDHUR", lat: 8.722007, lng: 78.002788, id: 165 },
// //   { name: "MUDIVAITHANENDAL", lat: 8.723319, lng: 77.990336, id: 166 },
// //   { name: "VAGAIKULAM", lat: 8.734730, lng: 78.001301, id: 167 },
// //   { name: "CHETTIKULAM", lat: 8.662797, lng: 78.029329, id: 168 },
// //   { name: "AGARAM BRIDGE", lat: 8.661354, lng: 78.088323, id: 169 },
// //   { name: "AGARAM", lat: 8.659921, lng: 78.075828, id: 170 },
// //   { name: "KORKAI", lat: 8.642078, lng: 78.058734, id: 171 },
// //   { name: "AUTHOOR", lat: 8.622355, lng: 78.070341, id: 172 },
// //   { name: "CHERNTHAMARAM", lat: 8.634982, lng: 78.087918, id: 173 },
// //   { name: "DCW COLONY", lat: 8.632673, lng: 78.101623, id: 174 },
// //   { name: "PUNNAKAYAL", lat: 8.634945, lng: 78.117073, id: 175 },
// //   { name: "ATTHIMARAPATTI JUNCTION", lat: 8.741554, lng: 78.123287, id: 176 },
// //   { name: "ATTHIMARAPATTI", lat: 8.742208, lng: 78.104441, id: 177 },
// //   { name: "PON NAGAR", lat: 8.734551, lng: 78.104669, id: 178 },
// //   { name: "THERMAL NAGAR", lat: 8.759198, lng: 78.147347, id: 179 },
// //   { name: "THERMAL NAGAR JUNCTION", lat: 8.758436, lng: 78.155625, id: 180 },
// //   { name: "TTPP", lat: 8.755276, lng: 78.175103, id: 181 },
// //   { name: "CHILDREN'S PARK", lat: 8.746429, lng: 78.168838, id: 182 },
// //   { name: "CAMP-II", lat: 8.742206, lng: 78.163757, id: 183 },
// //   { name: "BULK", lat: 8.745284, lng: 78.125352, id: 184 },
// //   { name: "ROCH PARK", lat: 8.787746, lng: 78.159250, id: 185 },
// //   { name: "TTPP JUNCTION", lat: 8.755763, lng: 78.170323, id: 186 },
// //   { name: "VELLAPATTI", lat: 8.857643, lng: 78.160709, id: 187 },
// //   { name: "KAKKARAMPATTI", lat: 8.928274, lng: 78.058146, id: 188 },
// //   { name: "AGILANDAPURAM", lat: 8.933352, lng: 78.050208, id: 189 },
// //   { name: "PANCHALANKURICHI", lat: 8.932598, lng: 78.032564, id: 190 },
// //   { name: "KUMARAPURAM JUNCTION", lat: 8.947900, lng: 78.080564, id: 191 },
// //   { name: "VELLARAM JUNCTION", lat: 8.963494, lng: 78.073969, id: 192 },
// //   { name: "KACCHERI THALAVAIPURAM", lat: 8.965258, lng: 78.047346, id: 193 },
// //   { name: "VELLARAM", lat: 8.964344, lng: 78.023572, id: 194 },
// //   { name: "GOVERNORGIRI", lat: 8.950111, lng: 78.029486, id: 195 },
// //   { name: "VALLINAYAGIPURAM", lat: 8.865224, lng: 78.027444, id: 196 },
// //   { name: "JAMBULINGAPURAM", lat: 8.868732, lng: 78.018645, id: 197 },
// //   { name: "KAILASAPURAM", lat: 8.852519, lng: 77.991350, id: 198 },
// //   { name: "SAVARIMANGALAM", lat: 8.863055, lng: 77.985917, id: 199 },
// //   { name: "MELA SEITHALAI", lat: 8.981610, lng: 78.077327, id: 200 },
// //   { name: "JEGAVEERAPANDIAPURAM", lat: 8.983220, lng: 78.066958, id: 201 },
// //   { name: "THANNEER MADAM", lat: 9.009252, lng: 78.052432, id: 202 },
// //   { name: "KAYATHAR JUNCTION", lat: 9.012578, lng: 78.050241, id: 203 },
// //   { name: "EPPODHUMVENDRAN", lat: 9.020908, lng: 78.047522, id: 204 },
// //   { name: "KATTUNAICKENPATTI", lat: 9.014206, lng: 78.062348, id: 205 },
// //   { name: "ADHANOOR", lat: 9.010078, lng: 78.084646, id: 206 },
// //   { name: "MILAGU NATTHAM", lat: 9.012843, lng: 78.104929, id: 207 },
// //   { name: "MURAMBAN", lat: 8.899828, lng: 77.937996, id: 208 },
// //   { name: "SANGAMPATTI", lat: 8.917985, lng: 77.930898, id: 209 },
// //   { name: "CEYLON COLONY", lat: 8.924832, lng: 78.018458, id: 210 },
// //   { name: "PUTRU MURUGAN KOVIL", lat: 8.941288, lng: 78.011421, id: 211 },
// //   { name: "VENKETESHVARAPURAM JUNCTION", lat: 8.955754, lng: 78.003576, id: 212 },
// //   { name: "KEELA MUDIMAN", lat: 8.961449, lng: 77.999854, id: 213 },
// //   { name: "POOLNAYAKKANOOR", lat: 8.978090, lng: 77.991323, id: 214 },
// //   { name: "PASUVANTHANAI", lat: 8.999829, lng: 77.962640, id: 215 },
// //   { name: "MELA MUDIMAN", lat: 8.956969, lng: 77.986192, id: 216 },
// //   { name: "THALAVAIPURAM", lat: 8.877120, lng: 77.956196, id: 217 },
// //   { name: "KANTHASAMYPURAM", lat: 8.867032, lng: 77.949334, id: 218 },
// //   { name: "APC COLLEGE", lat: 8.827144, lng: 78.129349, id: 219 },
// //   { name: "CHINNAKANNUPURAM", lat: 8.810596, lng: 78.125385, id: 220 },
// //   { name: "SILVERPURAM", lat: 8.814569, lng: 78.115786, id: 221 },
// //   { name: "PANDARAMPATTI", lat: 8.826827, lng: 78.104347, id: 222 },
// //   { name: "MEELAVITTAN", lat: 8.816812, lng: 78.100737, id: 223 },
// //   { name: "STERLITE", lat: 8.816372, lng: 78.081444, id: 224 },
// //   { name: "SIPCOT", lat: 8.804587, lng: 78.084655, id: 225 },
// //   { name: "MADATTHOOR JUNCTION", lat: 8.794126, lng: 78.097222, id: 226 },
// //   { name: "THOOTHUKUDI COLLECTORATE", lat: 8.782470, lng: 78.100772, id: 227 },
// //   { name: "PUDHUPACCHERI COLONY", lat: 8.878480, lng: 78.007704, id: 228 },
// //   { name: "PUDHUPACCHERI", lat: 8.879461, lng: 78.001300, id: 229 },
// //   { name: "SIVALKULAM", lat: 8.879800, lng: 77.995998, id: 230 },
// //   { name: "PACCHAIPERUMALPURAM", lat: 8.885974, lng: 77.992908, id: 231 },
// //   { name: "SANKARARAJAPURAM", lat: 8.891225, lng: 77.991277, id: 232 },
// //   { name: "KUPPANAPURAM", lat: 8.933090, lng: 77.971928, id: 233 },
// //   { name: "KEELA MANGALM", lat: 8.953179, lng: 77.969344, id: 234 },
// //   { name: "RAMANACCHIYARPURAM", lat: 8.784893, lng: 78.061561, id: 235 },
// //   { name: "MUTHUSAMYPURAM", lat: 8.804241, lng: 78.049425, id: 236 },
// //   { name: "MADATTHUPATTI", lat: 8.807399, lng: 78.047393, id: 237 },
// //   { name: "NORTH SILUKKANPATTI", lat: 8.812890, lng: 78.047949, id: 238 },
// //   { name: "THALAIVANVADALI", lat: 8.602420, lng: 78.087655, id: 239 },
// //   { name: "THOOTHUKUDI RAILWAY STATION", lat: 8.805524, lng: 78.155200, id: 240 },
// //   { name: "KOOTTUDANKADU", lat: 8.740251, lng: 78.037525, id: 241 },
// //   { name: "THIRUVANANTHAPURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 242 },
// //   { name: "SAMATTHUVAPURAM", lat: 8.774679, lng: 77.998832, id: 243 },
// //   { name: "MAHILAMPURAM", lat: 8.794964, lng: 77.961453, id: 244 },
// //   { name: "CHEKKARAKUDI", lat: 8.794750, lng: 77.951655, id: 245 },
// //   { name: "THIRUVANANTHAPURAM", lat: 8.770659, lng: 78.019169, id: 246 },
// //   { name: "MELA CHEKKARAKUDI", lat: 8.801626, lng: 77.937492, id: 247 },
// //   { name: "ALLIKULAM JUNCTION", lat: 8.757367, lng: 78.025019, id: 248 },
// //   { name: "THIRUVANANDHA PURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 249 },
// //   { name: "SILUKKAN PATTI", lat: 8.768811, lng: 78.052367, id: 250 },
// //   { name: "KEELA THATTAPARAI", lat: 8.796529, lng: 78.027674, id: 251 },
// //   { name: "MELA THATTAPARAI", lat: 8.815826, lng: 78.017498, id: 252 },
// //   { name: "CHETTIYOORANI", lat: 8.832629, lng: 78.008857, id: 253 },
// //   { name: "CAMP THATTAPARAI", lat: 8.826042, lng: 78.020524, id: 254 },
// //   { name: "RAMACHANDRAPURAM JUNCTION", lat: 8.738491, lng: 78.031969, id: 255 },
// //   { name: "POTTALOORANI JUNCTION", lat: 8.735812, lng: 77.935660, id: 256 },
// //   { name: "POTTALOORANI VILLAGE", lat: 8.748338, lng: 77.936312, id: 257 },
// //   { name: "NATTHAM", lat: 8.778333, lng: 77.946701, id: 258 },
// //   { name: "AZHAGAPURI", lat: 8.783882, lng: 77.947625, id: 259 },
// //   { name: "KALLAMPARAMBU", lat: 8.806659, lng: 77.982150, id: 260 },
// //   { name: "VARTHAGAREDDIPATTI", lat: 8.734957, lng: 77.992819, id: 261 },
// //   { name: "THIMMARAJAPURAM", lat: 8.763797, lng: 77.989995, id: 262 },
// //   { name: "MEENAKSHIPATTI", lat: 8.690932, lng: 77.965207, id: 263 },
// //   { name: "ADAIKKALAPURAM", lat: 8.678001, lng: 77.969954, id: 264 },
// //   { name: "ANIYABARANALLUR", lat: 8.693574, lng: 77.950283, id: 265 },
// //   { name: "PUDHUPATTI", lat: 8.710504, lng: 77.936336, id: 266 },
// //   { name: "CHETTIMALLANPATTI", lat: 8.720235, lng: 77.929900, id: 267 },
// //   { name: "RAMANATHAPURAM", lat: 8.728507, lng: 77.925542, id: 268 },
// //   { name: "ELLANAICKENPATTI", lat: 8.733465, lng: 77.921950, id: 269 },
// //   { name: "DEIVASEYALPURAM", lat: 8.737467, lng: 77.918961, id: 270 },
// //   { name: "THATTAPARAI VILLAGE", lat: 8.755998, lng: 78.065854, id: 271 },
// //   { name: "ST. MARY'S COLLEGE", lat: 8.811006, lng: 78.161694, id: 272 },
// //   { name: "NEW HARBOUR", lat: 8.754486, lng: 78.192477, id: 273 },
// //   { name: "UMARIKOTTAI", lat: 8.822473, lng: 77.990482, id: 274 },
// //   { name: "VARADHARAJAPURAM", lat: 8.843064, lng: 77.979707, id: 275 },
// //   { name: "CHOCKALINGAPURAM", lat: 8.812871, lng: 77.966345, id: 276 },
// //   { name: "KALANKARAI", lat: 8.756500, lng: 78.095112, id: 277 },
// //   { name: "PUDHUKOTTAI 2", lat: 8.747258, lng: 78.054971, id: 278 },
// //   { name: "4TH GATE 2", lat: 8.812727, lng: 78.136672, id: 279 },
// //   { name: "ST. ANN'S HOSPITAL", lat: 8.877320, lng: 78.025851, id: 280 },
// //   { name: "SUBRAMANIYAPURAM 2", lat: 8.918478, lng: 78.094426, id: 281 },
// //   { name: "AMERICAN HOSPITAL 2", lat: 8.813561, lng: 78.148444, id: 282 },
// //   { name: "ZAKKAMMALPURAM 2", lat: 8.916639, lng: 78.175262, id: 283 },
// //   { name: "KALLOORANI", lat: 8.992222, lng: 78.233057, id: 284 },
// //   { name: "THULUKKANKULAM", lat: 9.031716, lng: 78.272534, id: 285 },
// //   { name: "SALT FACTORY 2", lat: 8.996121, lng: 78.240638, id: 286 },
// //   { name: "ZAKKAMMALPURAM 3", lat: 8.926665, lng: 78.149020, id: 287 },
// //   { name: "SUBRAMANIYAPURAM 3", lat: 9.025170, lng: 78.225853, id: 288 },
// //   { name: "CHANDRAGIRI", lat: 8.964871, lng: 78.096262, id: 289 },
// //   { name: "WATER TANK 2", lat: 8.669583, lng: 78.078905, id: 290 },
// //   { name: "KUMARAPURAM 2", lat: 8.688057, lng: 78.016423, id: 291 },
// //   { name: "ARASADI JUNCTION 2", lat: 8.868788, lng: 78.115271, id: 292 },
// //   { name: "THERMAL NAGAR", lat: 8.759213, lng: 78.147452, id: 293 },
// //   { name: "CHEMICAL", lat: 8.766517, lng: 78.156992, id: 294 },
// //   { name: "CHANDRAGIRI JUNCTION 2", lat: 8.963747, lng: 78.074074, id: 295 },
// //   { name: "S.PUTHUR", lat: 8.869224, lng: 77.997689, id: 296 },
// //   { name: "KAILASAPURAM", lat: 8.786357, lng: 78.077069, id: 297 },
// //   { name: "MUTHUSAMYPURAM", lat: 8.803626, lng: 78.050614, id: 298 },
// //   { name: "ARASADI JUNCTION 3", lat: 8.873258, lng: 78.152850, id: 299 },
// //   { name: "ARASADI 2", lat: 8.878458, lng: 78.118427, id: 300 },
// //   { name: "DURAISAMYPURAM 2", lat: 8.938193, lng: 78.156085, id: 301 },
// //   { name: "KULATTHOOR 2", lat: 9.002945, lng: 78.194484, id: 302 },
// //   { name: "PUDHUR 2", lat: 8.794559, lng: 77.993581, id: 303 },
// //   { name: "THALAVAIPURAM 2", lat: 8.798284, lng: 77.974711, id: 304 },
// //   { name: "RAMACHANDRAPURAM 2", lat: 8.731531, lng: 78.030510, id: 305 },
// //   { name: "PUDHUR 3", lat: 8.709596, lng: 78.002355, id: 306 }
// // ];

// // // // Route sequences by stop id
// // // const Hostel_to_Main   = [26, 24, 22, 20, 6, 5, 3, 1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // // const Main_to_Hostel   = [18, 17, 15, 13, 11, 9, 6, 5, 3, 1, 2, 4, 7, 19, 21, 23, 25, 26];
// // // const Velachery_to_Main= [1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // // const Velachery_to_Hostel=[1, 2, 4, 7, 19, 21, 23, 25, 26];
// // // const Hotel_to_Velachery=[26, 24, 22, 20, 6, 5, 3, 1];
// // // const Main_to_Velachery=[18, 17, 15, 13, 11, 9, 6, 5, 3, 1];
// // // const RP_to_ED         = [28, 22, 21, 20, 6, 5, 3, 29];
// // // const ED_to_RP         = [29, 2, 4, 7, 19, 21, 23, 28];

// // // const ROUTES = [
// // //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate", ids: Hostel_to_Main },
// // //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel", ids: Main_to_Hostel },
// // //   { code: "VG_MAIN",     label: "Velachery Gate → Main Gate", ids: Velachery_to_Main },
// // //   { code: "VG_HOSTEL",   label: "Velachery Gate → Hostel", ids: Velachery_to_Hostel },
// // //   { code: "MAIN_VG",     label: "Main Gate → Velachery Gate", ids: Main_to_Velachery },
// // //   { code: "HOSTEL_VG",   label: "Hostel → Velachery Gate", ids: Hotel_to_Velachery },
// // //   { code: "RP_ED",       label: "Research Park → ED", ids: RP_to_ED },
// // //   { code: "ED_RP",       label: "ED → Research Park", ids: ED_to_RP },
// // // ];

// // // // ---- Route aliases (frontend only) ----
// // // // Backend only knows canonical codes: HOSTEL_MAIN, MAIN_HOSTEL, RP_ED, ED_RP
// // // // But filters can still expose Velachery labels.
// // // // Aliases map to canonical backend codes.
// // // const ROUTE_ALIAS_TO_CANONICAL = {
// // //   VG_MAIN: "HOSTEL_MAIN",
// // //   HOSTEL_VG: "HOSTEL_MAIN",
// // //   MAIN_VG: "MAIN_HOSTEL",
// // //   VG_HOSTEL: "MAIN_HOSTEL",
// // // };

// // // function canonicalRoute(code) {
// // //   return ROUTE_ALIAS_TO_CANONICAL[code] || code;
// // // }
// // // // Routes the admin can assign in backend (only canonical codes)
// // // const ADMIN_ROUTES = [
// // //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate" },
// // //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel" },
// // //   { code: "RP_ED", label: "Research Park → ED" },
// // //   { code: "ED_RP", label: "ED → Research Park" },
// // // ];


// // // // ---- Vehicles for driverRoute select ----
// // // const VEHICLES = [
// // //   "TN07DH1368","TN07DH1317","TN07DH1315","EV09","TN07DH1360","TN07DH1391","EV08","TN07DD5574",
// // //   "TN07CX8698","TN07DD3376","TN07CX8200","TN07DD3360","EV-12","EV-14","EV-15","EV-10","EV-05",
// // //   "EV-07","EV-06","EV-02","EV-03","EV-11","EV-01","EV-13","TN07CX8119"
// // // ];

// // // ---------------- VEHICLE ROUTES + ROUTE SCHEDULE DATA ----------------
// // // Generated from your TCNC route table and the uploaded stop-timesheet ZIP.
// // // ROUTES = user-facing route numbers (52-B, 53-A, ...)
// // // ROUTE_TRIPS = detailed stop-by-stop trips used for schedule display and route progress.
// // const VEHICLE_ROUTE_MAP = {
// //   "TN72N2675": "4",
// //   "TN72N2656": "52-B",
// //   "TN72N2460": "52-C",
// //   "TN72N1895": "52-D",
// //   "TN72N2589": "52-E",
// //   "TN72N2368": "52-F",
// //   "TN72N2682": "52-G",
// //   "TN72N1905": "52-K",
// //   "TN72N1774": "53-A",
// //   "TN72N2556": "53-B",
// //   "TN72N2684": "53-C",
// //   "TN72N1903": "53-D",
// //   "TN72N2526": "53-E",
// //   "TN72N1737": "53-F",
// //   "TN72N1751": "54-A",
// //   "TN72N1854": "54-B",
// //   "TN72N2643": "54-C",
// //   "TN72N1910": "54-D",
// //   "TN72N2536": "54-F",
// //   "TN72N1912": "54-G",
// //   "TN72N2706": "55-A",
// //   "TN72N2700": "55-B",
// //   "TN72N2549": "55-C",
// //   "TN72N2416": "55-D",
// //   "TN72N1757": "55-E",
// //   "TN72N2541": "55-F",
// //   "TN72N1906": "55-G",
// //   "TN72N1688": "55-H",
// //   "TN72N2671": "55-I",
// //   "TN72N1919": "55-J",
// //   "TN72N2568": "56-A",
// //   "TN72N1884": "56-B",
// //   "TN72N2617": "56-C",
// //   "TN72N2622": "56-D",
// //   "TN72N2016": "56-E",
// //   "TN68N0707": "56-F",
// //   "TN72N2562": "56-G",
// //   "TN72N1875": "57-A",
// //   "TN72N2687": "57-D",
// //   "TN72N2022": "58-A",
// //   "TN72N2570": "58-B",
// //   "TN72N2620": "58-C"
// // };

// // const ROUTES = [
// //   {
// //     "code": "52-A",
// //     "label": "52-A — 13 scheduled trips",
// //     "tripCount": 13
// //   },
// //   {
// //     "code": "52-B",
// //     "label": "52-B — 10 scheduled trips",
// //     "tripCount": 10
// //   },
// //   {
// //     "code": "52-C",
// //     "label": "52-C — 18 scheduled trips",
// //     "tripCount": 18
// //   },
// //   {
// //     "code": "52-D",
// //     "label": "52-D — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "52-E",
// //     "label": "52-E — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "52-F",
// //     "label": "52-F — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "52-G",
// //     "label": "52-G — 18 scheduled trips",
// //     "tripCount": 18
// //   },
// //   {
// //     "code": "52-K",
// //     "label": "52-K — 17 scheduled trips",
// //     "tripCount": 17
// //   },
// //   {
// //     "code": "53-A",
// //     "label": "53-A — 16 scheduled trips",
// //     "tripCount": 16
// //   },
// //   {
// //     "code": "53-B",
// //     "label": "53-B — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "53-C",
// //     "label": "53-C — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "53-D",
// //     "label": "53-D — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "53-E",
// //     "label": "53-E — 10 scheduled trips",
// //     "tripCount": 10
// //   },
// //   {
// //     "code": "53-F",
// //     "label": "53-F — 16 scheduled trips",
// //     "tripCount": 16
// //   },
// //   {
// //     "code": "54-A",
// //     "label": "54-A — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "54-B",
// //     "label": "54-B — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "54-C",
// //     "label": "54-C — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "54-D",
// //     "label": "54-D — 16 scheduled trips",
// //     "tripCount": 16
// //   },
// //   {
// //     "code": "54-F",
// //     "label": "54-F — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "54-G",
// //     "label": "54-G — 20 scheduled trips",
// //     "tripCount": 20
// //   },
// //   {
// //     "code": "55-A",
// //     "label": "55-A — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "55-B",
// //     "label": "55-B — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "55-C",
// //     "label": "55-C — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "55-D",
// //     "label": "55-D — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "55-E",
// //     "label": "55-E — 10 scheduled trips",
// //     "tripCount": 10
// //   },
// //   {
// //     "code": "55-F",
// //     "label": "55-F — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "55-G",
// //     "label": "55-G — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "55-H",
// //     "label": "55-H — 20 scheduled trips",
// //     "tripCount": 20
// //   },
// //   {
// //     "code": "55-I",
// //     "label": "55-I — 10 scheduled trips",
// //     "tripCount": 10
// //   },
// //   {
// //     "code": "55-J",
// //     "label": "55-J — 20 scheduled trips",
// //     "tripCount": 20
// //   },
// //   {
// //     "code": "56-A",
// //     "label": "56-A — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "56-B",
// //     "label": "56-B — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "56-C",
// //     "label": "56-C — 10 scheduled trips",
// //     "tripCount": 10
// //   },
// //   {
// //     "code": "56-D",
// //     "label": "56-D — 10 scheduled trips",
// //     "tripCount": 10
// //   },
// //   {
// //     "code": "56-E",
// //     "label": "56-E — 13 scheduled trips",
// //     "tripCount": 13
// //   },
// //   {
// //     "code": "56-F",
// //     "label": "56-F — 19 scheduled trips",
// //     "tripCount": 19
// //   },
// //   {
// //     "code": "56-G",
// //     "label": "56-G — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "57-A",
// //     "label": "57-A — 22 scheduled trips",
// //     "tripCount": 22
// //   },
// //   {
// //     "code": "57-D",
// //     "label": "57-D — 24 scheduled trips",
// //     "tripCount": 24
// //   },
// //   {
// //     "code": "58-A",
// //     "label": "58-A — 14 scheduled trips",
// //     "tripCount": 14
// //   },
// //   {
// //     "code": "58-B",
// //     "label": "58-B — 16 scheduled trips",
// //     "tripCount": 16
// //   },
// //   {
// //     "code": "58-C",
// //     "label": "58-C — 12 scheduled trips",
// //     "tripCount": 12
// //   },
// //   {
// //     "code": "4",
// //     "label": "4 — schedule not available",
// //     "tripCount": 0
// //   }
// // ];

// // const ADMIN_ROUTES = ROUTES;

// // const ROUTE_TRIPS = [
// //   {
// //     "id": "52-A-1-1",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-1",
// //     "tripCode": "52/P52A-152-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PERUMPADAI SASTHA KOVIL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:45 AM",
// //     "endTime": "01:00 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       7,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       16
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "11:50 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:54 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:03 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:06 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:15 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 1",
// //         "time": "12:21 PM",
// //         "id": 7
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "12:23 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:31 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "12:37 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "12:41 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:45 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "12:50 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "12:53 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "12:56 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "PERUMPADAI SASTHA KOVIL",
// //         "time": "01:00 PM",
// //         "id": 16
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-2-2",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-1",
// //     "tripCode": "52/P52A-152-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "PERUMPADAI SASTHA KOVIL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:05 PM",
// //     "endTime": "02:00 PM",
// //     "ids": [
// //       16,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       7,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PERUMPADAI SASTHA KOVIL",
// //         "time": "01:05 PM",
// //         "id": 16
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "01:07 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "01:09 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "01:12 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "01:15 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "01:18 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "01:21 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "01:26 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "01:31 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 1",
// //         "time": "01:33 PM",
// //         "id": 7
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:37 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:44 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:46 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:52 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "01:55 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-3-3",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-2",
// //     "tripCode": "52/P52A-252-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:05 PM",
// //     "endTime": "03:00 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "02:09 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:12 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:20 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:22 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:29 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:33 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:35 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:41 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "02:46 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "02:50 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "02:53 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "02:57 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "03:00 PM",
// //         "id": 40
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-4-4",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-3",
// //     "tripCode": "52/P52A-352-ATORD18U4",
// //     "order": 4,
// //     "direction": "U",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:05 PM",
// //     "endTime": "04:30 PM",
// //     "ids": [
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "03:05 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 2,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "03:15 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 3,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "03:41 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 4,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "04:12 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 5,
// //         "name": "ERAL",
// //         "time": "04:30 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-5-5",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-4",
// //     "tripCode": "52/P52A-452-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:40 PM",
// //     "endTime": "06:00 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       21,
// //       22,
// //       23,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "04:40 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "04:44 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 3,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "04:51 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 4,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "04:57 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 5,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:59 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 6,
// //         "name": "SAWYERPURAM",
// //         "time": "05:03 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 7,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:08 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 8,
// //         "name": "SALAI",
// //         "time": "05:12 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 9,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "05:17 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "05:23 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "05:31 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:33 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 13,
// //         "name": "MANGALAGIRI",
// //         "time": "05:40 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 14,
// //         "name": "ALLIKULAM",
// //         "time": "05:49 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 15,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "05:53 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 16,
// //         "name": "PEROORANI",
// //         "time": "06:00 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-6-6",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-5",
// //     "tripCode": "52/P52A-552-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "PERRORANI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 PM",
// //     "endTime": "07:20 PM",
// //     "ids": [
// //       24,
// //       23,
// //       22,
// //       21,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40
// //     ],
// //     "stops": [
// //       {
// //         "no": 12,
// //         "name": "PEROORANI",
// //         "time": "06:15 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "06:21 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "06:26 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "MANGALAGIRI",
// //         "time": "06:36 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 8,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:43 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 7,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:46 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 6,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:54 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 5,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:01 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 4,
// //         "name": "SALAI",
// //         "time": "07:06 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 3,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:10 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 2,
// //         "name": "SAWYERPURAM",
// //         "time": "07:15 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 1,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:20 PM",
// //         "id": 40
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-7-7",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-2",
// //     "tripCode": "52/P52A-252-ATORD18D7",
// //     "order": 7,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 PM",
// //     "endTime": "08:45 PM",
// //     "ids": [
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:30 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:34 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:38 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:43 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:48 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:55 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:03 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:05 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:11 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:21 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:24 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:34 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:38 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-8-8",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-1",
// //     "tripCode": "52/P52A-152-ATORD18U8",
// //     "order": 8,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PERUMPADAI SASTHA KOVIL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:30 PM",
// //     "endTime": "10:30 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       7,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       16
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:34 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:37 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:45 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:47 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:54 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 1",
// //         "time": "09:59 PM",
// //         "id": 7
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:01 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:06 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:11 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "10:15 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:18 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "10:22 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "10:25 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "10:27 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "PERUMPADAI SASTHA KOVIL",
// //         "time": "10:30 PM",
// //         "id": 16
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-9-9",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-6",
// //     "tripCode": "52/P52A-652-ATORD18D9",
// //     "order": 9,
// //     "direction": "D",
// //     "from": "PERUMPADAI SASTHA KOVIL",
// //     "to": "UZHAVAR SANTHAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:30 AM",
// //     "endTime": "06:40 AM",
// //     "ids": [
// //       16,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1,
// //       26,
// //       25
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "PERUMPADAI SASTHA KOVIL",
// //         "time": "04:30 AM",
// //         "id": 16
// //       },
// //       {
// //         "no": 17,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "04:36 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:39 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "04:45 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:53 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SALAI",
// //         "time": "04:59 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "05:07 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "KOOTTAMPULI",
// //         "time": "05:17 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "05:29 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:33 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:41 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:56 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "06:01 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "06:16 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "VOC COLLEGE",
// //         "time": "06:23 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:32 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:37 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "UZHAVAR SANTHAI",
// //         "time": "06:40 AM",
// //         "id": 25
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-10-10",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-8",
// //     "tripCode": "52/P52A-852-ATORD18U10",
// //     "order": 10,
// //     "direction": "U",
// //     "from": "UZHAVAR SANTHAI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:55 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       25,
// //       26,
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "UZHAVAR SANTHAI",
// //         "time": "06:55 AM",
// //         "id": 25
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:56 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:59 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "VOC COLLEGE",
// //         "time": "07:03 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "07:07 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "07:15 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:18 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:26 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:31 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:33 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 11,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:39 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 12,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:45 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 13,
// //         "name": "SALAI",
// //         "time": "07:49 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:52 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "07:56 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:00 AM",
// //         "id": 40
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-11-11",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-7",
// //     "tripCode": "52/P52A-752-ATORD18D11",
// //     "order": 11,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THRES PURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 AM",
// //     "endTime": "09:10 AM",
// //     "ids": [
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1,
// //       28,
// //       27
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:05 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "08:08 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:11 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SALAI",
// //         "time": "08:15 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:18 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:23 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:29 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:31 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:35 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:43 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "08:45 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "08:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "VOC COLLEGE",
// //         "time": "08:56 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:01 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:06 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "09:10 AM",
// //         "id": 27
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-12-12",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-7",
// //     "tripCode": "52/P52A-752-ATORD18U12",
// //     "order": 12,
// //     "direction": "U",
// //     "from": "THRES PURAM",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:20 AM",
// //     "endTime": "10:20 AM",
// //     "ids": [
// //       27,
// //       28,
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "09:20 AM",
// //         "id": 27
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:23 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:28 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "VOC COLLEGE",
// //         "time": "09:32 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "09:35 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "09:42 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:44 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:51 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:55 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:57 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 11,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:02 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 12,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:07 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 13,
// //         "name": "SALAI",
// //         "time": "10:10 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:13 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "10:17 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "10:20 AM",
// //         "id": 40
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-A-13-13",
// //     "routeNo": "52-A",
// //     "code": "52/P52A-2",
// //     "tripCode": "52/P52A-252-ATORD18D13",
// //     "order": 13,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 AM",
// //     "endTime": "11:30 AM",
// //     "ids": [
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "10:30 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "10:33 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:37 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "10:40 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:44 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:50 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:56 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:58 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:02 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:11 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:13 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "11:25 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-1-14",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-2",
// //     "tripCode": "52/P52B-252-BTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PERUNKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:15 PM",
// //     "endTime": "03:25 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:19 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:23 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:30 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:32 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:40 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:44 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:46 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:52 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "02:57 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "03:01 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "03:04 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "03:08 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "03:11 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "03:16 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "03:20 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "03:25 PM",
// //         "id": 32
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-2-15",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-2",
// //     "tripCode": "52/P52B-252-BTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "PERUNKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:40 PM",
// //     "endTime": "04:50 PM",
// //     "ids": [
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "03:40 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "03:44 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "03:48 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "03:53 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "03:56 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:00 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "04:03 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "04:07 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "04:12 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "04:18 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:20 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:24 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:32 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:34 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:41 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:45 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-3-16",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-1",
// //     "tripCode": "52/P52B-152-BTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SIVAKALAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:05 PM",
// //     "endTime": "06:20 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       33
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:09 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:13 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:20 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:22 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:30 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:34 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "05:36 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "05:42 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "05:47 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "05:50 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:54 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "05:57 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "06:00 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "06:05 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "06:09 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "06:14 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 19,
// //         "name": "SIVAKALAI",
// //         "time": "06:20 PM",
// //         "id": 33
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-4-17",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-1",
// //     "tripCode": "52/P52B-152-BTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SIVAKALAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:35 PM",
// //     "endTime": "07:40 PM",
// //     "ids": [
// //       33,
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "SIVAKALAI",
// //         "time": "06:35 PM",
// //         "id": 33
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "06:39 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "06:43 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "06:47 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "06:51 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "06:54 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:57 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:00 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:03 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:07 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:13 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:14 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:18 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:24 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:26 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:33 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:35 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-5-18",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-1",
// //     "tripCode": "52/P52B-152-BTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SIVAKALAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:55 PM",
// //     "endTime": "09:25 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       33
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:00 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:04 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:13 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:16 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:25 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:30 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:32 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:39 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:45 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "08:49 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:53 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "08:58 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:01 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "09:07 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "09:12 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "09:18 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 19,
// //         "name": "SIVAKALAI",
// //         "time": "09:25 PM",
// //         "id": 33
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-6-19",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-1",
// //     "tripCode": "52/P52B-152-BTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "SIVAKALAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 AM",
// //     "endTime": "08:30 AM",
// //     "ids": [
// //       33,
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "SIVAKALAI",
// //         "time": "07:10 AM",
// //         "id": 33
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "07:16 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "07:20 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "07:25 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:30 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:33 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:37 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:41 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:45 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:50 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:56 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:58 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:03 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:11 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:13 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:25 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-7-20",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-2",
// //     "tripCode": "52/P52B-252-BTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PERUNKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:45 AM",
// //     "endTime": "10:00 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:50 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:01 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:04 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:12 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:16 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:18 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:25 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "09:30 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "09:34 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "09:38 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "09:42 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:45 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "09:50 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "09:55 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "10:00 AM",
// //         "id": 32
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-8-21",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-2",
// //     "tripCode": "52/P52B-252-BTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PERUNKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:15 AM",
// //     "endTime": "11:20 AM",
// //     "ids": [
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "10:15 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "10:19 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "10:23 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "10:27 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "10:30 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:33 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "10:37 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:40 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:45 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:50 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:52 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:56 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:03 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:05 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:12 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:15 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-9-22",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-2",
// //     "tripCode": "52/P52B-252-BTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PERUNKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:35 AM",
// //     "endTime": "12:45 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:39 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:43 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:50 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:52 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:00 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:04 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "12:06 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:12 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "12:17 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "12:21 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:24 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "12:28 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "12:31 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "12:36 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "12:40 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "12:45 PM",
// //         "id": 32
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-B-10-23",
// //     "routeNo": "52-B",
// //     "code": "52/P52B-2",
// //     "tripCode": "52/P52B-252-BTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "PERUNKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:00 PM",
// //     "endTime": "02:10 PM",
// //     "ids": [
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "01:00 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "01:04 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "01:08 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "01:13 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "01:16 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "01:20 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "01:23 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "01:27 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "01:32 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "01:38 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:40 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:44 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:52 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:54 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:01 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:05 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-1-24",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 AM",
// //     "endTime": "06:45 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:18 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:20 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:26 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:28 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:33 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:36 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:38 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:42 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "06:45 AM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-2-25",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-2",
// //     "tripCode": "52/P52C-252-CTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THRES PURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:55 AM",
// //     "endTime": "07:45 AM",
// //     "ids": [
// //       34,
// //       9,
// //       35,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1,
// //       28,
// //       27
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "KULAIYANKARISAL",
// //         "time": "06:55 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 12,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:58 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "SIRUPADU",
// //         "time": "07:03 AM",
// //         "id": 35
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:06 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:07 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:11 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:19 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "07:21 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "07:28 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "MILLER PURAM",
// //         "time": "07:31 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:36 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:41 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "07:45 AM",
// //         "id": 27
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-3-26",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-4",
// //     "tripCode": "52/P52C-452-CTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THRES PURAM",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:55 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       27,
// //       28,
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       35,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "07:55 AM",
// //         "id": 27
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:59 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:06 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "MILLER PURAM",
// //         "time": "08:13 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "08:18 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "08:28 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:31 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:42 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:47 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU",
// //         "time": "08:53 AM",
// //         "id": 35
// //       },
// //       {
// //         "no": 11,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:00 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 12,
// //         "name": "KULAIYANKARISAL",
// //         "time": "09:05 AM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-4-27",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-3",
// //     "tripCode": "52/P52C-352-CTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "SUB COLLECTOR OFFICE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 AM",
// //     "endTime": "10:00 AM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1,
// //       28
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "KULAIYANKARISAL",
// //         "time": "09:10 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:13 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:20 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 8,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:22 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 7,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:26 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 6,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:35 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 5,
// //         "name": "KORAMPALLAM",
// //         "time": "09:37 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 4,
// //         "name": "3RD MILE",
// //         "time": "09:45 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 3,
// //         "name": "MILLER PURAM",
// //         "time": "09:49 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 2,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:54 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 1,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:00 AM",
// //         "id": 28
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-5-28",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-3",
// //     "tripCode": "52/P52C-352-CTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "SUB COLLECTOR OFFICE",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:05 AM",
// //     "endTime": "11:10 AM",
// //     "ids": [
// //       28,
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:05 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 2,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:12 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 3,
// //         "name": "MILLER PURAM",
// //         "time": "10:18 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 4,
// //         "name": "3RD MILE",
// //         "time": "10:23 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 5,
// //         "name": "KORAMPALLAM",
// //         "time": "10:34 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 6,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:37 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 7,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:48 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 8,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:53 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 9,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:56 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "11:05 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "KULAIYANKARISAL",
// //         "time": "11:10 AM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-6-29",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:15 AM",
// //     "endTime": "11:55 AM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "11:15 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "11:18 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "11:24 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:26 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:30 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:37 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:39 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:47 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:50 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:55 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-7-30",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:00 PM",
// //     "endTime": "12:40 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "12:04 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:07 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:15 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:17 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:24 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:28 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "12:30 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:36 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "12:40 PM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-8-31",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:45 PM",
// //     "endTime": "01:20 PM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "12:45 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:47 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "12:53 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:54 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:58 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:04 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:06 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:13 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:15 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-9-32",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:35 PM",
// //     "endTime": "02:25 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:40 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:44 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:54 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:56 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:06 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:11 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:13 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:20 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "02:25 PM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-10-33",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:30 PM",
// //     "endTime": "03:10 PM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "02:30 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:33 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:39 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:41 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:45 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:52 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:54 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:02 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:05 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-11-34",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:15 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:20 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:23 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:32 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:34 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:43 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:47 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "03:49 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "03:56 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "04:00 PM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-12-35",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-4",
// //     "tripCode": "52/P52C-452-CTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THRES PURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:10 PM",
// //     "endTime": "05:25 PM",
// //     "ids": [
// //       34,
// //       9,
// //       35,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1,
// //       28,
// //       27
// //     ],
// //     "stops": [
// //       {
// //         "no": 12,
// //         "name": "KULAIYANKARISAL",
// //         "time": "04:10 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 11,
// //         "name": "KOOTTAMPULI",
// //         "time": "04:15 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU",
// //         "time": "04:22 PM",
// //         "id": 35
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:28 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:34 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:45 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "04:49 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "05:00 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "MILLER PURAM",
// //         "time": "05:05 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:12 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:19 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "05:25 PM",
// //         "id": 27
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-13-36",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-2",
// //     "tripCode": "52/P52C-252-CTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THRES PURAM",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 PM",
// //     "endTime": "06:10 PM",
// //     "ids": [
// //       27,
// //       28,
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       35,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "05:30 PM",
// //         "id": 27
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:32 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:36 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "MILLER PURAM",
// //         "time": "05:40 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "05:43 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "05:48 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:50 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:56 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:59 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 10,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:01 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 11,
// //         "name": "SIRUPADU",
// //         "time": "06:03 PM",
// //         "id": 35
// //       },
// //       {
// //         "no": 12,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:07 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 13,
// //         "name": "KULAIYANKARISAL",
// //         "time": "06:10 PM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-14-37",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-3",
// //     "tripCode": "52/P52C-352-CTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "SUB COLLECTOR OFFICE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 PM",
// //     "endTime": "07:00 PM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1,
// //       28
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "KULAIYANKARISAL",
// //         "time": "06:15 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:18 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:24 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 8,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:26 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 7,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:30 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 6,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:37 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 5,
// //         "name": "KORAMPALLAM",
// //         "time": "06:39 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 4,
// //         "name": "3RD MILE",
// //         "time": "06:47 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 3,
// //         "name": "MILLER PURAM",
// //         "time": "06:50 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 2,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 1,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:00 PM",
// //         "id": 28
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-15-38",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-3",
// //     "tripCode": "52/P52C-352-CTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "SUB COLLECTOR OFFICE",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 PM",
// //     "endTime": "08:25 PM",
// //     "ids": [
// //       28,
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:10 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 2,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:18 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 3,
// //         "name": "MILLER PURAM",
// //         "time": "07:25 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 4,
// //         "name": "3RD MILE",
// //         "time": "07:31 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 5,
// //         "name": "KORAMPALLAM",
// //         "time": "07:43 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 6,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:47 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 7,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:59 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 8,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:06 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 9,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:09 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:19 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "KULAIYANKARISAL",
// //         "time": "08:25 PM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-16-39",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:30 PM",
// //     "endTime": "09:35 PM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "08:30 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:35 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:45 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:48 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:54 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:06 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:10 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:22 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:27 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-17-40",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18U17",
// //     "order": 17,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULAIYANKARISAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 PM",
// //     "endTime": "10:30 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       34
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:45 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:49 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:59 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:01 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:11 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:16 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:18 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:25 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "10:30 PM",
// //         "id": 34
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-C-18-41",
// //     "routeNo": "52-C",
// //     "code": "52/P52C-1",
// //     "tripCode": "52/P52C-152-CTORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "KULAIYANKARISAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:25 PM",
// //     "endTime": "06:10 AM",
// //     "ids": [
// //       34,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KULAIYANKARISAL",
// //         "time": "10:25 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "11:04 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "12:12 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:34 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:19 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:47 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:12 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:37 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:16 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-1-42",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:45 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:49 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:01 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:03 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:11 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:15 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:17 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:23 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:29 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:33 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:36 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:40 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:43 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:45 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "07:50 AM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "07:56 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "08:00 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-2-43",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:30 AM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "08:15 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "08:18 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "08:24 AM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "08:29 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:31 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "08:34 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:38 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "08:41 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:45 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:51 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:57 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:59 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:03 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:11 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:13 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:25 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-3-44",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "11:05 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:40 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:45 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:54 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:57 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:06 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:11 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:14 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:21 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:28 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "10:32 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:36 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "10:41 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "10:45 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "10:47 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "10:53 AM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "11:01 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "11:05 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-4-45",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:10 AM",
// //     "endTime": "12:30 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "11:10 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "11:13 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "11:19 AM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "11:25 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "11:27 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "11:30 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "11:34 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "11:38 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "11:42 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "11:48 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "11:55 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:57 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:01 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:10 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:12 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:20 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "12:24 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-5-46",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:50 PM",
// //     "endTime": "02:05 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "12:54 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:58 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:06 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:08 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:16 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:20 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "01:22 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "01:28 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "01:34 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "01:38 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "01:41 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "01:45 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "01:48 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "01:50 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "01:55 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "02:01 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "02:05 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-6-47",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:10 PM",
// //     "endTime": "03:25 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "02:10 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "02:13 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "02:19 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "02:24 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "02:26 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "02:29 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "02:33 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "02:36 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "02:40 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:46 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:52 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:54 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:58 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:06 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:08 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:16 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "03:20 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-7-48",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-2",
// //     "tripCode": "52/P52D-252-DTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PANDARAVILAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:30 PM",
// //     "endTime": "04:35 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "03:34 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:38 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:45 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:47 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:55 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:59 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "04:01 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "04:07 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "04:12 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "04:15 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:19 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "04:22 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:25 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "04:30 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "04:35 PM",
// //         "id": 31
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-8-49",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-2",
// //     "tripCode": "52/P52D-252-DTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PANDARAVILAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:45 PM",
// //     "endTime": "05:50 PM",
// //     "ids": [
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "04:45 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "04:49 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:54 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "04:57 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:00 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "05:04 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "05:07 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "05:12 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "05:18 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:20 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:24 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:32 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:34 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:41 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:45 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-9-50",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:55 PM",
// //     "endTime": "07:25 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:00 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:05 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:14 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:17 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:26 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:31 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:34 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:41 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "06:48 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "06:52 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:56 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:01 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:05 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:07 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "07:13 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "07:21 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "07:25 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-10-51",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 PM",
// //     "endTime": "08:45 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "07:50 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "07:52 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "07:56 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "08:00 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:02 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "08:04 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:07 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "08:09 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:12 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:16 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:21 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:22 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:25 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:31 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:33 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:38 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:41 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-11-52",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:50 PM",
// //     "endTime": "10:05 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:54 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:58 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:06 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:08 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:16 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:20 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:22 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:28 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "09:34 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "09:38 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "09:41 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "09:45 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:48 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "09:50 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "09:55 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "10:01 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "10:05 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-D-12-53",
// //     "routeNo": "52-D",
// //     "code": "52/P52D-1",
// //     "tripCode": "52/P52D-152-DTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:10 PM",
// //     "endTime": "06:30 AM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "10:10 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "10:32 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "11:12 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "11:45 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "11:59 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "12:20 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:45 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "01:08 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "01:33 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:10 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:51 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:05 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:32 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:26 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:41 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:33 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:58 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-1-54",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-1",
// //     "tripCode": "52/P52E-152-ETORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:35 AM",
// //     "endTime": "06:45 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:39 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:42 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:50 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:52 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:59 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:03 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:05 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:11 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "06:16 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "06:19 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:23 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "06:26 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "06:29 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "06:31 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "06:36 AM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "06:41 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "06:45 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-2-55",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-1",
// //     "tripCode": "52/P52E-152-ETORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:05 AM",
// //     "endTime": "08:15 AM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "07:05 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "07:08 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "07:13 AM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:18 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:20 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:23 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:26 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:30 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:33 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:38 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:44 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:46 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:50 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:57 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:59 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:07 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:10 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-3-56",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-3",
// //     "tripCode": "52/P52E-352-ETORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:35 AM",
// //     "endTime": "10:00 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       38,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:39 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:43 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:50 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:53 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:01 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:05 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:07 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:13 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "09:18 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "09:22 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "09:25 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "09:29 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:32 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "09:37 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "09:42 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "09:46 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "09:51 AM",
// //         "id": 38
// //       },
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "10:00 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-4-57",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-3",
// //     "tripCode": "52/P52E-352-ETORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:10 AM",
// //     "endTime": "11:40 AM",
// //     "ids": [
// //       20,
// //       38,
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "10:10 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "10:18 AM",
// //         "id": 38
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "10:24 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "10:28 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "10:33 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "10:39 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "10:42 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:46 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "10:49 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:53 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:59 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "11:05 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:08 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:12 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:20 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:23 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:31 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:34 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-5-58",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-3",
// //     "tripCode": "52/P52E-352-ETORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:45 AM",
// //     "endTime": "01:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       38,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:49 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:00 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:03 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:11 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:15 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "12:17 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:23 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "12:28 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "12:32 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:35 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "12:39 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "12:42 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "12:47 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "12:52 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "12:56 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "01:01 PM",
// //         "id": 38
// //       },
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "01:10 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-6-59",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-3",
// //     "tripCode": "52/P52E-352-ETORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:15 PM",
// //     "endTime": "02:45 PM",
// //     "ids": [
// //       20,
// //       38,
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "01:15 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "01:23 PM",
// //         "id": 38
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "01:29 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "01:33 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "01:38 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "01:44 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "01:47 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "01:51 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "01:54 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "01:58 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:04 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "02:10 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:13 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:17 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:25 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:28 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:36 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:39 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-7-60",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-2",
// //     "tripCode": "52/P52E-252-ETORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:50 PM",
// //     "endTime": "04:15 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       37,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:54 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:57 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:04 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:06 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:13 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:17 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "03:19 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "03:25 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "03:30 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "03:33 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "03:36 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "03:40 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "03:42 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "03:44 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALAI",
// //         "time": "03:53 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "04:12 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "04:15 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-8-61",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-2",
// //     "tripCode": "52/P52E-252-ETORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:20 PM",
// //     "endTime": "05:40 PM",
// //     "ids": [
// //       20,
// //       19,
// //       37,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "04:20 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "04:22 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALAI",
// //         "time": "04:40 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "04:48 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:50 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "04:52 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:56 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "04:59 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "05:02 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "05:06 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "05:12 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:13 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:17 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:24 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:26 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:32 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:35 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-9-62",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-4",
// //     "tripCode": "52/P52E-452-ETORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:50 PM",
// //     "endTime": "06:45 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:54 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:57 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:05 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:07 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:14 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:18 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:20 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:26 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "06:31 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "06:35 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:38 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "06:42 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "06:45 PM",
// //         "id": 40
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-10-63",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-4",
// //     "tripCode": "52/P52E-452-ETORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 PM",
// //     "endTime": "07:45 PM",
// //     "ids": [
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "06:50 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "06:52 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:56 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "06:59 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:03 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:08 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:14 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:16 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:20 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:27 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:29 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:37 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:40 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-11-64",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-1",
// //     "tripCode": "52/P52E-152-ETORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 PM",
// //     "endTime": "09:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:55 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:59 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:07 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:09 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:18 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:22 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:24 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:31 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:37 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "08:41 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:45 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "08:49 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:52 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "08:54 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "09:00 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "09:06 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "09:10 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-E-12-65",
// //     "routeNo": "52-E",
// //     "code": "52/P52E-1",
// //     "tripCode": "52/P52E-152-ETORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 PM",
// //     "endTime": "10:30 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "09:15 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "09:18 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "09:24 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "09:29 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:31 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "09:34 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "09:38 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "09:41 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "09:45 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:51 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:57 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:59 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:03 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:11 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:13 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:21 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:25 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-1-66",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-3",
// //     "tripCode": "52/P52F-352-FTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:20 AM",
// //     "endTime": "07:50 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       38,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:25 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:28 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:36 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:39 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:47 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:51 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:54 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:00 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:06 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:10 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:13 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:17 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:20 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "07:26 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "07:31 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "07:35 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "07:41 AM",
// //         "id": 38
// //       },
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "07:50 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-2-67",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-3",
// //     "tripCode": "52/P52F-352-FTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 AM",
// //     "endTime": "09:30 AM",
// //     "ids": [
// //       20,
// //       38,
// //       32,
// //       31,
// //       30,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "08:00 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "08:08 AM",
// //         "id": 38
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "08:14 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "08:18 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "08:23 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:29 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "08:32 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:36 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "08:39 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:43 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:49 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "08:55 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:58 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:02 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:10 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:13 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:24 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-3-68",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-6",
// //     "tripCode": "52/P52F-652-FTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SIRUPADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "10:20 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       35
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:41 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:45 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:55 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:58 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:08 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:13 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:16 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "SIRUPADU",
// //         "time": "10:20 AM",
// //         "id": 35
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-4-69",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-6",
// //     "tripCode": "52/P52F-652-FTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SIRUPADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:25 AM",
// //     "endTime": "11:15 AM",
// //     "ids": [
// //       35,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "SIRUPADU",
// //         "time": "10:25 AM",
// //         "id": 35
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "10:29 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:31 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:37 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:48 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:52 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:03 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:08 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:15 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-5-70",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-1",
// //     "tripCode": "52/P52F-152-FTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:20 AM",
// //     "endTime": "12:50 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:25 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:30 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:39 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:42 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:51 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:56 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "11:59 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:06 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "12:13 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "12:17 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:21 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "12:26 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "12:30 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "12:32 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "12:38 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "12:46 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "12:50 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-6-71",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-2",
// //     "tripCode": "52/P52F-252-FTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:00 PM",
// //     "endTime": "02:20 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "01:00 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "01:03 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "01:09 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "01:15 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "01:17 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "01:20 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "01:24 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "01:28 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "01:32 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "01:38 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "01:45 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:47 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:51 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:00 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:02 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:10 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:14 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-7-72",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-2",
// //     "tripCode": "52/P52F-252-FTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:30 PM",
// //     "endTime": "03:45 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:34 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:38 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:46 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:48 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:56 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:00 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "03:02 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "03:08 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "03:14 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "03:18 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "03:21 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "03:25 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "03:28 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "03:30 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "03:35 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "03:41 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "03:45 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-8-73",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-2",
// //     "tripCode": "52/P52F-252-FTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:40 PM",
// //     "endTime": "05:20 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "03:40 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "03:44 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "03:52 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "03:59 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:01 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "04:06 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:11 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "04:15 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "04:20 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "04:28 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "04:36 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:39 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:44 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:55 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:58 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:08 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:13 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-9-74",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-1",
// //     "tripCode": "52/P52F-152-FTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 PM",
// //     "endTime": "06:45 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       18,
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:34 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:38 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:46 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:48 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:56 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:00 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "06:02 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:08 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "06:14 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "06:18 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:21 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "06:25 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "06:28 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "06:30 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "06:35 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "06:41 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "06:45 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-10-75",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-1",
// //     "tripCode": "52/P52F-152-FTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 PM",
// //     "endTime": "08:00 PM",
// //     "ids": [
// //       20,
// //       19,
// //       18,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "ERAL",
// //         "time": "06:50 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 17,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "06:53 PM",
// //         "id": 19
// //       },
// //       {
// //         "no": 16,
// //         "name": "ZAKKAMMALPURAM 1",
// //         "time": "06:58 PM",
// //         "id": 18
// //       },
// //       {
// //         "no": 15,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:03 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:05 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "07:08 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:11 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:15 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:18 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:23 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:29 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:31 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:35 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:42 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:44 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:52 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:55 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-11-76",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-4",
// //     "tripCode": "52/P52F-452-FTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:35 PM",
// //     "endTime": "09:35 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:40 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:43 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:51 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:53 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:02 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:06 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "09:08 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:14 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "09:20 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "09:24 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "09:27 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "09:31 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:35 PM",
// //         "id": 40
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-F-12-77",
// //     "routeNo": "52-F",
// //     "code": "52/P52F-5",
// //     "tripCode": "52/P52F-552-FTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 PM",
// //     "endTime": "06:15 AM",
// //     "ids": [
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       8,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "09:40 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "10:07 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:40 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "11:11 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "11:44 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "12:32 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "01:27 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:44 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:21 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:31 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:52 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:00 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:31 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-1-78",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-1",
// //     "tripCode": "52/P52G-152-GTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 AM",
// //     "endTime": "08:30 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       38,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:23 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:26 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:33 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:35 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:41 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:44 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "07:46 AM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:51 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:55 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "07:58 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:01 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "08:04 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "08:07 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "08:11 AM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "08:15 AM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "08:19 AM",
// //         "id": 32
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "08:23 AM",
// //         "id": 38
// //       },
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "08:30 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-2-79",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:40 AM",
// //     "endTime": "09:40 AM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "08:40 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "08:46 AM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "08:48 AM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "08:51 AM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "08:55 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "08:59 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:05 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:10 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:13 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:20 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:23 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:24 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:31 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:36 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:39 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-3-80",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 AM",
// //     "endTime": "10:50 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       52,
// //       53,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:50 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:53 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:58 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:05 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:06 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:09 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "10:16 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "10:19 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "10:24 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "10:30 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "10:34 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "10:38 AM",
// //         "id": 52
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "10:41 AM",
// //         "id": 53
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "10:43 AM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "10:50 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-4-81",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18U4",
// //     "order": 4,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "KURUMBUR R/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:55 AM",
// //     "endTime": "11:10 AM",
// //     "ids": [
// //       20,
// //       55,
// //       56,
// //       57
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "10:55 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "10:58 AM",
// //         "id": 55
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "11:07 AM",
// //         "id": 56
// //       },
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "11:10 AM",
// //         "id": 57
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-5-82",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18D5",
// //     "order": 5,
// //     "direction": "D",
// //     "from": "KURUMBUR R/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:20 AM",
// //     "endTime": "11:35 AM",
// //     "ids": [
// //       57,
// //       56,
// //       55,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "11:20 AM",
// //         "id": 57
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "11:22 AM",
// //         "id": 56
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "11:31 AM",
// //         "id": 55
// //       },
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "11:35 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-6-83",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:40 AM",
// //     "endTime": "12:40 PM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "11:40 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "11:46 AM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "11:48 AM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "11:51 AM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "11:55 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "11:59 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "12:05 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:10 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "12:13 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "12:20 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "12:23 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "12:24 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "12:31 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "12:36 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "12:39 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-7-84",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:50 PM",
// //     "endTime": "01:50 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       52,
// //       53,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "12:50 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "12:53 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "12:58 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:05 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:06 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:09 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "01:16 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:19 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "01:24 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "01:30 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "01:34 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "01:38 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "01:41 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "01:43 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "01:50 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-8-85",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18U8",
// //     "order": 8,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "KURUMBUR R/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:55 PM",
// //     "endTime": "02:10 PM",
// //     "ids": [
// //       20,
// //       55,
// //       56,
// //       57
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "01:55 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "01:58 PM",
// //         "id": 55
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "02:07 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "02:10 PM",
// //         "id": 57
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-9-86",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18D9",
// //     "order": 9,
// //     "direction": "D",
// //     "from": "KURUMBUR R/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:30 PM",
// //     "endTime": "02:45 PM",
// //     "ids": [
// //       57,
// //       56,
// //       55,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "02:30 PM",
// //         "id": 57
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "02:32 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "02:41 PM",
// //         "id": 55
// //       },
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "02:45 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-10-87",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:50 PM",
// //     "endTime": "03:50 PM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "02:50 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "02:56 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "02:58 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "03:01 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "03:05 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "03:09 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "03:15 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:20 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "03:23 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:30 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "03:33 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "03:34 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "03:41 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "03:46 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "03:49 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-11-88",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-1",
// //     "tripCode": "52/P52G-152-GTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:00 PM",
// //     "endTime": "05:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       8,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       30,
// //       31,
// //       32,
// //       38,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:03 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:06 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:13 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:15 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:21 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:24 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIRUPADU JUNCTION",
// //         "time": "04:26 PM",
// //         "id": 8
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTAMPULI",
// //         "time": "04:31 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 10,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "04:35 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 11,
// //         "name": "SALAI",
// //         "time": "04:38 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 12,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:41 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 13,
// //         "name": "SAWYERPURAM",
// //         "time": "04:44 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:47 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTATTHI",
// //         "time": "04:51 PM",
// //         "id": 30
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANDARAVILAI",
// //         "time": "04:55 PM",
// //         "id": 31
// //       },
// //       {
// //         "no": 17,
// //         "name": "PERUNKULAM",
// //         "time": "04:59 PM",
// //         "id": 32
// //       },
// //       {
// //         "no": 18,
// //         "name": "MANGALAKURICHI",
// //         "time": "05:03 PM",
// //         "id": 38
// //       },
// //       {
// //         "no": 20,
// //         "name": "ERAL",
// //         "time": "05:10 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-12-89",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18U12",
// //     "order": 12,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "KURUMBUR R/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:15 PM",
// //     "endTime": "05:30 PM",
// //     "ids": [
// //       20,
// //       55,
// //       56,
// //       57
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "05:15 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "05:18 PM",
// //         "id": 55
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "05:27 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "05:30 PM",
// //         "id": 57
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-13-90",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18D13",
// //     "order": 13,
// //     "direction": "D",
// //     "from": "KURUMBUR R/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:40 PM",
// //     "endTime": "06:00 PM",
// //     "ids": [
// //       57,
// //       56,
// //       55,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "05:40 PM",
// //         "id": 57
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "05:43 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "05:55 PM",
// //         "id": 55
// //       },
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "06:00 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-14-91",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:05 PM",
// //     "endTime": "07:00 PM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "06:05 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "06:11 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "06:12 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "06:15 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "06:19 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "06:23 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "06:28 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:33 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:36 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:42 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:45 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:45 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:52 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:56 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:59 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-15-92",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 PM",
// //     "endTime": "08:10 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       52,
// //       53,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:10 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:13 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:18 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:25 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:26 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:29 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:36 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:39 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "07:44 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "07:50 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "07:54 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "07:58 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "08:01 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "08:03 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "08:10 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-16-93",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18U16",
// //     "order": 16,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "KURUMBUR R/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       20,
// //       55,
// //       56,
// //       57
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "08:15 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "08:18 PM",
// //         "id": 55
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "08:27 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "08:30 PM",
// //         "id": 57
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-17-94",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-3",
// //     "tripCode": "52/P52G-352-GTORD18D17",
// //     "order": 17,
// //     "direction": "D",
// //     "from": "KURUMBUR R/S",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:35 PM",
// //     "endTime": "08:45 PM",
// //     "ids": [
// //       57,
// //       56,
// //       55,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 5,
// //         "name": "KURUMBUR R/S",
// //         "time": "08:35 PM",
// //         "id": 57
// //       },
// //       {
// //         "no": 4,
// //         "name": "KURUMBUR",
// //         "time": "08:36 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 2,
// //         "name": "SETHUSUBRAMANIAPURAM",
// //         "time": "08:42 PM",
// //         "id": 55
// //       },
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "08:45 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-G-18-95",
// //     "routeNo": "52-G",
// //     "code": "52/P52G-2",
// //     "tripCode": "52/P52G-252-GTORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:50 PM",
// //     "endTime": "06:50 AM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "08:50 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "09:56 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "10:15 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "10:45 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "11:25 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "12:07 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "01:07 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "02:28 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:34 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:06 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:13 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "05:27 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:13 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:45 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-1-96",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-1",
// //     "tripCode": "52/P52K-152-KTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "THALAMUTHU NAGAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:20 AM",
// //     "endTime": "06:30 AM",
// //     "ids": [
// //       1,
// //       279,
// //       58,
// //       59,
// //       60,
// //       61,
// //       62
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 2",
// //         "time": "06:22 AM",
// //         "id": 279
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 1",
// //         "time": "06:24 AM",
// //         "id": 58
// //       },
// //       {
// //         "no": 4,
// //         "name": "KEBI",
// //         "time": "06:25 AM",
// //         "id": 59
// //       },
// //       {
// //         "no": 5,
// //         "name": "MURUGAN THEATRE",
// //         "time": "06:26 AM",
// //         "id": 60
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAJA PALAIYAM",
// //         "time": "06:28 AM",
// //         "id": 61
// //       },
// //       {
// //         "no": 7,
// //         "name": "THALAMUTHU NAGAR",
// //         "time": "06:30 AM",
// //         "id": 62
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-2-97",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-2",
// //     "tripCode": "52/P52K-252-KTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "THALAMUTHU NAGAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:40 AM",
// //     "endTime": "07:10 AM",
// //     "ids": [
// //       62,
// //       111,
// //       64,
// //       63,
// //       58,
// //       279,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 7,
// //         "name": "THALAMUTHU NAGAR",
// //         "time": "06:40 AM",
// //         "id": 62
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:45 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:48 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:53 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 1",
// //         "time": "06:59 AM",
// //         "id": 58
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 2",
// //         "time": "07:04 AM",
// //         "id": 279
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-3-98",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-3",
// //     "tripCode": "52/P52K-352-KTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 AM",
// //     "endTime": "07:50 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:21 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:23 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:26 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:27 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:31 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:34 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:37 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:42 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:46 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:50 AM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-4-99",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-3",
// //     "tripCode": "52/P52K-352-KTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 AM",
// //     "endTime": "09:00 AM",
// //     "ids": [
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:00 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:06 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:15 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:24 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:31 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:37 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:44 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:46 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:53 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:56 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-5-100",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-4",
// //     "tripCode": "52/P52K-452-KTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 AM",
// //     "endTime": "10:15 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:18 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:20 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:25 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:26 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:32 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:37 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:42 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:49 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:56 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:02 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:04 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "10:11 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:15 AM",
// //         "id": 76
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-6-101",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-4",
// //     "tripCode": "52/P52K-452-KTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 AM",
// //     "endTime": "11:30 AM",
// //     "ids": [
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:30 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "10:33 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:40 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:42 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:48 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:55 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:02 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:07 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:12 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:18 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:19 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:24 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:26 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-7-102",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-5",
// //     "tripCode": "52/P52K-552-KTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "THOOTHUKUDI NEW B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:35 AM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       1,
// //       26,
// //       77
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:30 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI NEW B/S",
// //         "time": "04:00 PM",
// //         "id": 77
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-8-103",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-5",
// //     "tripCode": "52/P52K-552-KTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "THOOTHUKUDI NEW B/S",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:50 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       77,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI NEW B/S",
// //         "time": "11:50 AM",
// //         "id": 77
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:53 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-9-104",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-6",
// //     "tripCode": "52/P52K-652-KTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:10 PM",
// //     "endTime": "12:55 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "12:13 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:16 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "12:18 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "12:21 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "12:24 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "12:26 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "12:31 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "12:34 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "12:40 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:42 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:46 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:47 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:52 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:55 PM",
// //         "id": 76
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-10-105",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-7",
// //     "tripCode": "52/P52K-752-KTORD18U10",
// //     "order": 10,
// //     "direction": "U",
// //     "from": "OTTAPIDARAM",
// //     "to": "PARIVALLIKOTTAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:00 PM",
// //     "endTime": "02:30 PM",
// //     "ids": [
// //       76,
// //       85,
// //       86,
// //       87,
// //       88,
// //       89,
// //       90,
// //       91,
// //       92,
// //       93,
// //       94,
// //       95,
// //       96
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "OTTAPIDARAM",
// //         "time": "01:00 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 2,
// //         "name": "OSANOOTTHU",
// //         "time": "01:14 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 3,
// //         "name": "KOMBADI",
// //         "time": "01:21 PM",
// //         "id": 86
// //       },
// //       {
// //         "no": 4,
// //         "name": "PANDIAPURAM",
// //         "time": "01:32 PM",
// //         "id": 87
// //       },
// //       {
// //         "no": 5,
// //         "name": "PARAIKUTTAM",
// //         "time": "01:36 PM",
// //         "id": 88
// //       },
// //       {
// //         "no": 6,
// //         "name": "VADAMALAPURAM",
// //         "time": "01:42 PM",
// //         "id": 89
// //       },
// //       {
// //         "no": 7,
// //         "name": "MANIYACCHI",
// //         "time": "01:46 PM",
// //         "id": 90
// //       },
// //       {
// //         "no": 8,
// //         "name": "OTTANATTHAM",
// //         "time": "01:59 PM",
// //         "id": 91
// //       },
// //       {
// //         "no": 9,
// //         "name": "KALLATTHIKINARU",
// //         "time": "02:06 PM",
// //         "id": 92
// //       },
// //       {
// //         "no": 10,
// //         "name": "MALAIPATTI",
// //         "time": "02:12 PM",
// //         "id": 93
// //       },
// //       {
// //         "no": 11,
// //         "name": "ILAVELANKAL",
// //         "time": "02:20 PM",
// //         "id": 94
// //       },
// //       {
// //         "no": 12,
// //         "name": "IYRAVIPATTI",
// //         "time": "02:25 PM",
// //         "id": 95
// //       },
// //       {
// //         "no": 13,
// //         "name": "PARIVALLIKOTTAI",
// //         "time": "02:30 PM",
// //         "id": 96
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-11-106",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-7",
// //     "tripCode": "52/P52K-752-KTORD18D11",
// //     "order": 11,
// //     "direction": "D",
// //     "from": "PARIVALLIKOTTAI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:35 PM",
// //     "endTime": "03:30 PM",
// //     "ids": [
// //       96,
// //       95,
// //       94,
// //       93,
// //       92,
// //       91,
// //       90,
// //       89,
// //       88,
// //       87,
// //       86,
// //       85,
// //       76
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "PARIVALLIKOTTAI",
// //         "time": "02:35 PM",
// //         "id": 96
// //       },
// //       {
// //         "no": 12,
// //         "name": "IYRAVIPATTI",
// //         "time": "02:37 PM",
// //         "id": 95
// //       },
// //       {
// //         "no": 11,
// //         "name": "ILAVELANKAL",
// //         "time": "02:40 PM",
// //         "id": 94
// //       },
// //       {
// //         "no": 10,
// //         "name": "MALAIPATTI",
// //         "time": "02:45 PM",
// //         "id": 93
// //       },
// //       {
// //         "no": 9,
// //         "name": "KALLATTHIKINARU",
// //         "time": "02:49 PM",
// //         "id": 92
// //       },
// //       {
// //         "no": 8,
// //         "name": "OTTANATTHAM",
// //         "time": "02:53 PM",
// //         "id": 91
// //       },
// //       {
// //         "no": 7,
// //         "name": "MANIYACCHI",
// //         "time": "03:01 PM",
// //         "id": 90
// //       },
// //       {
// //         "no": 6,
// //         "name": "VADAMALAPURAM",
// //         "time": "03:04 PM",
// //         "id": 89
// //       },
// //       {
// //         "no": 5,
// //         "name": "PARAIKUTTAM",
// //         "time": "03:07 PM",
// //         "id": 88
// //       },
// //       {
// //         "no": 4,
// //         "name": "PANDIAPURAM",
// //         "time": "03:09 PM",
// //         "id": 87
// //       },
// //       {
// //         "no": 3,
// //         "name": "KOMBADI",
// //         "time": "03:16 PM",
// //         "id": 86
// //       },
// //       {
// //         "no": 2,
// //         "name": "OSANOOTTHU",
// //         "time": "03:21 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 1,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:30 PM",
// //         "id": 76
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-12-107",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-4",
// //     "tripCode": "52/P52K-452-KTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:35 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:35 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "03:36 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "03:39 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "03:40 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "03:42 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "03:45 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "03:48 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:50 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:52 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:55 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:55 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:57 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:58 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-13-108",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-8",
// //     "tripCode": "52/P52K-852-KTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KURUKKUSALAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:10 PM",
// //     "endTime": "04:50 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:12 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:14 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "04:19 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "04:20 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "04:25 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "04:28 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "04:33 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "04:40 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "04:45 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "04:50 PM",
// //         "id": 100
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-14-109",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-9",
// //     "tripCode": "52/P52K-952-KTORD18U14",
// //     "order": 14,
// //     "direction": "U",
// //     "from": "KURUKKUSALAI",
// //     "to": "NORTH AARAIKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 PM",
// //     "endTime": "05:50 PM",
// //     "ids": [
// //       100,
// //       101,
// //       102,
// //       103,
// //       76,
// //       109,
// //       105,
// //       85,
// //       106,
// //       110,
// //       108
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "KURUKKUSALAI",
// //         "time": "05:00 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 2,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "05:03 PM",
// //         "id": 101
// //       },
// //       {
// //         "no": 3,
// //         "name": "KAKKARAMPATTI JUNCTION",
// //         "time": "05:08 PM",
// //         "id": 102
// //       },
// //       {
// //         "no": 4,
// //         "name": "MEENAKSHIPURAM",
// //         "time": "05:10 PM",
// //         "id": 103
// //       },
// //       {
// //         "no": 5,
// //         "name": "OTTAPIDARAM",
// //         "time": "05:23 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 6,
// //         "name": "OTTAPIDARAM TALUK OFFICE",
// //         "time": "05:24 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR KOVIL",
// //         "time": "05:27 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 8,
// //         "name": "OSANOOTTHU",
// //         "time": "05:38 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "05:41 PM",
// //         "id": 106
// //       },
// //       {
// //         "no": 10,
// //         "name": "THERKKU ARAIKULAM",
// //         "time": "05:47 PM",
// //         "id": 110
// //       },
// //       {
// //         "no": 11,
// //         "name": "NORTH AARAIKULAM",
// //         "time": "05:50 PM",
// //         "id": 108
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-15-110",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-10",
// //     "tripCode": "52/P52K-1052-KTORD18D15",
// //     "order": 15,
// //     "direction": "D",
// //     "from": "NORTH AARAIKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:00 PM",
// //     "endTime": "07:00 PM",
// //     "ids": [
// //       108,
// //       110,
// //       106,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "NORTH AARAIKULAM",
// //         "time": "06:00 PM",
// //         "id": 108
// //       },
// //       {
// //         "no": 19,
// //         "name": "THERKKU ARAIKULAM",
// //         "time": "06:01 PM",
// //         "id": 110
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "06:05 PM",
// //         "id": 106
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "06:07 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 16,
// //         "name": "AYYANAR KOVIL",
// //         "time": "06:14 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 15,
// //         "name": "TALUK OFFICE",
// //         "time": "06:16 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:17 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "06:19 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "06:24 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "06:26 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:30 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:35 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:40 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:44 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:47 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:51 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:52 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:56 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:57 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-16-111",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-11",
// //     "tripCode": "52/P52K-1152-KTORD18U16",
// //     "order": 16,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 PM",
// //     "endTime": "08:10 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       52,
// //       53,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:10 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:13 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:18 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:25 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:26 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:29 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:36 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:39 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "07:44 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "07:50 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "07:54 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "07:58 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "08:01 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "08:03 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "08:10 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "52-K-17-112",
// //     "routeNo": "52-K",
// //     "code": "52/P52K-11",
// //     "tripCode": "52/P52K-1152-KTORD18D17",
// //     "order": 17,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:20 PM",
// //     "endTime": "10:00 PM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "08:20 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "08:31 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "08:34 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "08:39 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "08:45 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "08:52 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:02 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:11 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:16 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:27 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:32 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:33 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:46 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:53 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:59 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-1-113",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-1",
// //     "tripCode": "53/P53A-153-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 AM",
// //     "endTime": "06:40 AM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       120,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "05:30 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "05:33 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:36 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:42 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "05:45 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "05:46 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "05:51 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "05:52 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:01 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "06:07 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "06:09 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "06:14 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "06:18 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "06:20 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "06:25 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 1",
// //         "time": "06:31 AM",
// //         "id": 120
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "06:35 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:40 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-2-114",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-2",
// //     "tripCode": "53/P53A-253-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THULUKKANKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:40 AM",
// //     "endTime": "06:50 AM",
// //     "ids": [
// //       122,
// //       126,
// //       125,
// //       124,
// //       285
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:40 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 4,
// //         "name": "VAIPPAR",
// //         "time": "06:44 AM",
// //         "id": 126
// //       },
// //       {
// //         "no": 3,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "06:47 AM",
// //         "id": 125
// //       },
// //       {
// //         "no": 2,
// //         "name": "KALAIGNANAPURAM",
// //         "time": "06:49 AM",
// //         "id": 124
// //       },
// //       {
// //         "no": 1,
// //         "name": "THULUKKANKULAM",
// //         "time": "06:50 AM",
// //         "id": 285
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-3-115",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-2",
// //     "tripCode": "53/P53A-253-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THULUKKANKULAM",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:05 AM",
// //     "endTime": "07:15 AM",
// //     "ids": [
// //       285,
// //       124,
// //       125,
// //       126,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THULUKKANKULAM",
// //         "time": "07:05 AM",
// //         "id": 285
// //       },
// //       {
// //         "no": 2,
// //         "name": "KALAIGNANAPURAM",
// //         "time": "07:05 AM",
// //         "id": 124
// //       },
// //       {
// //         "no": 3,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "07:07 AM",
// //         "id": 125
// //       },
// //       {
// //         "no": 4,
// //         "name": "VAIPPAR",
// //         "time": "07:10 AM",
// //         "id": 126
// //       },
// //       {
// //         "no": 6,
// //         "name": "KEELA VAIPPAR",
// //         "time": "07:15 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-4-116",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-1",
// //     "tripCode": "53/P53A-153-ATORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 AM",
// //     "endTime": "08:35 AM",
// //     "ids": [
// //       122,
// //       284,
// //       120,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "07:20 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "07:25 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 1",
// //         "time": "07:29 AM",
// //         "id": 120
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "07:35 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "07:41 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "07:42 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "07:47 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "07:52 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "07:54 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "08:01 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:10 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:11 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:17 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:18 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:21 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:27 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:30 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "08:35 AM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-5-117",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-5",
// //     "tripCode": "53/P53A-553-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KURUMBUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:50 AM",
// //     "endTime": "10:00 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       127,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       129,
// //       130,
// //       131,
// //       56
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:50 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:54 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:59 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:07 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:08 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:12 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "09:19 AM",
// //         "id": 127
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:23 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:29 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "09:36 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "09:41 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "09:44 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "09:46 AM",
// //         "id": 129
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "09:51 AM",
// //         "id": 130
// //       },
// //       {
// //         "no": 16,
// //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// //         "time": "09:56 AM",
// //         "id": 131
// //       },
// //       {
// //         "no": 17,
// //         "name": "KURUMBUR",
// //         "time": "10:00 AM",
// //         "id": 56
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-6-118",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-5",
// //     "tripCode": "53/P53A-553-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KURUMBUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:05 AM",
// //     "endTime": "11:35 AM",
// //     "ids": [
// //       56,
// //       131,
// //       130,
// //       129,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       127,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "KURUMBUR",
// //         "time": "10:05 AM",
// //         "id": 56
// //       },
// //       {
// //         "no": 16,
// //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// //         "time": "10:09 AM",
// //         "id": 131
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "10:16 AM",
// //         "id": 130
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "10:22 AM",
// //         "id": 129
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "10:24 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "10:29 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "10:35 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "10:44 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "10:52 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "10:57 AM",
// //         "id": 127
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "11:06 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "11:10 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:11 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:22 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "11:29 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "11:34 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:35 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-7-119",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:40 AM",
// //     "endTime": "12:25 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:41 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:43 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:46 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:46 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:50 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:53 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:56 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "12:00 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:04 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:07 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:14 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:20 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:25 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-8-120",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:30 PM",
// //     "endTime": "01:20 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:30 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:34 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:41 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:49 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:52 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "12:57 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:01 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:05 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:08 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:12 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:13 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:16 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:18 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-9-121",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:40 PM",
// //     "endTime": "02:30 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:41 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:43 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:46 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:47 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:51 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:54 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:58 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "02:02 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:07 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:10 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "02:18 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "02:25 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "02:30 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-10-122",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:45 PM",
// //     "endTime": "03:35 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "02:45 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "02:49 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "02:56 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "03:04 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "03:07 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "03:12 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "03:16 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:20 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:23 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:27 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:28 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:31 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:33 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-11-123",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-3",
// //     "tripCode": "53/P53A-353-ATORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:45 PM",
// //     "endTime": "04:55 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       52,
// //       53,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "03:45 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "03:49 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "03:54 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:03 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:04 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "04:07 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "04:15 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "04:18 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "04:24 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "04:31 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "04:36 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "04:41 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "04:45 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "04:47 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "04:55 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-12-124",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-3",
// //     "tripCode": "53/P53A-353-ATORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:05 PM",
// //     "endTime": "06:20 PM",
// //     "ids": [
// //       20,
// //       54,
// //       53,
// //       52,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "05:05 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "05:13 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "VAZHAVALLAN",
// //         "time": "05:15 PM",
// //         "id": 53
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKADU",
// //         "time": "05:19 PM",
// //         "id": 52
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "05:24 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "05:29 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "05:37 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "05:43 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "05:47 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "05:55 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "05:59 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:00 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:09 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:15 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:19 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-13-125",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:35 PM",
// //     "endTime": "07:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:36 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:38 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:41 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:41 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:45 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:48 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:51 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:55 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:59 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:02 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "07:09 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:15 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:20 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-14-126",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:25 PM",
// //     "endTime": "08:40 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:25 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:32 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "07:42 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:54 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:59 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:06 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:12 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:18 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:22 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:28 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:29 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:34 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:37 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-15-127",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:50 PM",
// //     "endTime": "09:40 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:51 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:53 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:56 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:57 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:01 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:04 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:08 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:12 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:17 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:20 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:28 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "09:35 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "09:40 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-A-16-128",
// //     "routeNo": "53-A",
// //     "code": "53/P53A-4",
// //     "tripCode": "53/P53A-453-ATORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 PM",
// //     "endTime": "10:35 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "09:50 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "09:54 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:00 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:07 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:10 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:14 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:18 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:21 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:24 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "10:28 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "10:28 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "10:31 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:33 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-1-129",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:00 PM",
// //     "endTime": "02:10 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "01:06 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "01:09 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "01:11 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "01:12 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "01:17 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "01:19 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "01:27 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "01:33 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "01:35 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "01:40 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "01:45 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "01:46 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "01:52 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "02:03 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "02:05 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "02:10 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-2-130",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:15 PM",
// //     "endTime": "03:25 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "02:15 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "02:19 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "02:21 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "02:32 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "02:38 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "02:39 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "02:44 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "02:49 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "02:51 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "02:57 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "03:05 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "03:07 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "03:12 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "03:13 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "03:15 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "03:18 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:22 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-3-131",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:30 PM",
// //     "endTime": "06:15 AM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:59 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "04:47 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:24 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "05:55 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:12 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "07:14 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "07:30 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "09:22 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "10:37 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "11:01 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "12:04 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "01:03 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "01:18 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "02:31 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "04:47 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "05:13 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:15 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-4-132",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-2",
// //     "tripCode": "53/P53B-253-BTORD18U4",
// //     "order": 4,
// //     "direction": "U",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THULUKKANKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:20 PM",
// //     "endTime": "04:55 PM",
// //     "ids": [
// //       122,
// //       126,
// //       125,
// //       124,
// //       285
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "KEELA VAIPPAR",
// //         "time": "04:20 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 3,
// //         "name": "VAIPPAR",
// //         "time": "04:36 PM",
// //         "id": 126
// //       },
// //       {
// //         "no": 4,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "04:46 PM",
// //         "id": 125
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALAIGNANAPURAM",
// //         "time": "04:51 PM",
// //         "id": 124
// //       },
// //       {
// //         "no": 6,
// //         "name": "THULUKKANKULAM",
// //         "time": "04:55 PM",
// //         "id": 285
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-5-133",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-2",
// //     "tripCode": "53/P53B-253-BTORD18D5",
// //     "order": 5,
// //     "direction": "D",
// //     "from": "THULUKKANKULAM",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 PM",
// //     "endTime": "05:35 PM",
// //     "ids": [
// //       285,
// //       124,
// //       125,
// //       126,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "THULUKKANKULAM",
// //         "time": "05:00 PM",
// //         "id": 285
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALAIGNANAPURAM",
// //         "time": "05:03 PM",
// //         "id": 124
// //       },
// //       {
// //         "no": 4,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "05:08 PM",
// //         "id": 125
// //       },
// //       {
// //         "no": 3,
// //         "name": "VAIPPAR",
// //         "time": "05:18 PM",
// //         "id": 126
// //       },
// //       {
// //         "no": 1,
// //         "name": "KEELA VAIPPAR",
// //         "time": "05:35 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-6-134",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:40 PM",
// //     "endTime": "06:30 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "05:40 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "05:43 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "05:44 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "05:52 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "05:56 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "05:57 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "06:00 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "06:04 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "06:05 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:10 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:16 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:17 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:20 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:21 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:23 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "06:25 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:28 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-7-135",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:35 PM",
// //     "endTime": "07:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:37 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "06:42 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:45 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:48 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:49 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:55 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:56 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "07:06 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "07:13 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "07:15 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "07:21 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "07:26 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "07:28 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "07:34 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "07:47 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "07:49 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "07:55 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-8-136",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 PM",
// //     "endTime": "09:05 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "08:00 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "08:04 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "08:06 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "08:16 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "08:21 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "08:22 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "08:27 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "08:31 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "08:33 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "08:39 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:47 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:48 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:53 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:54 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:56 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:59 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-9-137",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:20 PM",
// //     "endTime": "11:50 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:23 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "10:27 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "10:31 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "10:34 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:36 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "10:42 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "10:44 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "10:55 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "11:03 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "11:05 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "11:12 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "11:18 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "11:19 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "11:27 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "11:41 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "11:43 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "11:50 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-10-138",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:20 AM",
// //     "endTime": "06:30 AM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "05:20 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "05:24 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "05:26 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "05:37 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "05:43 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "05:44 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "05:49 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "05:54 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "05:56 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:02 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:10 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:12 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:17 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:18 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:20 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "06:23 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:27 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-11-139",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:45 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:47 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "06:51 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:54 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:57 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:58 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "07:04 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "07:05 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "07:14 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "07:21 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "07:23 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "07:28 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "07:33 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "07:34 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "07:41 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "07:52 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "07:54 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "08:00 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-12-140",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:30 AM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "08:15 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "08:20 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "08:22 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "08:33 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "08:40 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "08:41 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "08:46 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "08:51 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "08:53 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "09:00 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "09:09 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "09:10 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "09:16 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "09:17 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "09:20 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "09:23 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:27 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-13-141",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "10:50 AM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:37 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "09:41 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "09:44 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "09:47 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "09:48 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "09:54 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "09:55 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "10:04 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "10:11 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "10:13 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "10:18 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "10:23 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "10:24 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "10:31 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "10:42 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "10:44 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "10:50 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-B-14-142",
// //     "routeNo": "53-B",
// //     "code": "53/P53B-1",
// //     "tripCode": "53/P53B-153-BTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:55 AM",
// //     "endTime": "12:05 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "10:55 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "10:59 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "11:01 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "11:12 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "11:18 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "11:19 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "11:24 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "11:29 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "11:31 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "11:37 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "11:45 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "11:47 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "11:52 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "11:53 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "11:55 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "11:58 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "12:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-1-143",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:00 PM",
// //     "endTime": "03:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "02:07 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "02:10 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "02:13 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "02:14 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "02:20 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "02:21 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "02:31 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "02:38 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "02:40 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "02:46 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "02:51 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "02:53 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "02:59 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "03:12 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "03:14 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "03:20 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-2-144",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:25 PM",
// //     "endTime": "04:40 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "03:25 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "03:30 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "03:32 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "03:43 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "03:50 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "03:51 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "03:56 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "04:01 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "04:03 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "04:10 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "04:19 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "04:20 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "04:26 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "04:27 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "04:30 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "04:33 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:37 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-3-145",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 PM",
// //     "endTime": "06:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "05:07 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:10 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "05:13 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "05:14 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "05:20 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "05:21 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "05:31 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "05:38 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "05:40 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "05:46 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "05:51 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "05:53 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "05:59 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "06:12 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "06:14 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:20 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-4-146",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 PM",
// //     "endTime": "07:50 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:30 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "06:35 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "06:37 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "06:50 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "06:56 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "06:58 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "07:03 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "07:09 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "07:11 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "07:18 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "07:28 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "07:29 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "07:35 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "07:36 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "07:39 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "07:42 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:47 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-5-147",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 PM",
// //     "endTime": "09:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:07 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:11 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:14 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:17 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:18 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:24 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:25 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "08:34 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "08:41 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "08:43 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "08:48 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "08:53 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "08:54 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "09:01 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "09:12 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "09:14 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "09:20 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-6-148",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:30 PM",
// //     "endTime": "10:30 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "09:30 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "09:34 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "09:35 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "09:45 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "09:50 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "09:51 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "09:55 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "09:59 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "10:01 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "10:06 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "10:13 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "10:14 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:19 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "10:20 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "10:22 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "10:24 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:27 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-7-149",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:05 AM",
// //     "endTime": "06:20 AM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:05 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:07 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "05:11 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:14 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "05:17 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "05:18 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "05:24 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "05:25 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "05:34 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "05:41 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "05:43 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "05:48 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "05:53 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "05:54 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "06:01 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "06:12 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "06:14 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:20 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-8-150",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 AM",
// //     "endTime": "07:45 AM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "06:30 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "06:35 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "06:37 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "06:48 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "06:55 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "06:56 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "07:01 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "07:06 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "07:08 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "07:15 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "07:24 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "07:25 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "07:31 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "07:32 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "07:35 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "07:38 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:42 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-9-151",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 AM",
// //     "endTime": "09:20 AM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:00 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:02 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:07 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:10 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:13 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:14 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:20 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:21 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "08:31 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "08:38 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "08:40 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "08:46 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "08:51 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "08:53 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "08:59 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "09:12 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "09:14 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "09:20 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-10-152",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:25 AM",
// //     "endTime": "10:50 AM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "09:25 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "09:30 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "09:33 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "09:46 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "09:53 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "09:54 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "10:00 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "10:06 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "10:08 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "10:16 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "10:26 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "10:28 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:34 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "10:35 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "10:38 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "10:42 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:47 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:50 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-11-153",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:05 AM",
// //     "endTime": "12:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       282,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:05 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:07 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "11:11 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "11:14 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "11:17 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "11:18 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "11:24 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "11:25 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "11:34 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "11:41 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "11:43 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "11:48 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "11:53 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "11:54 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "12:01 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "12:12 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "12:14 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "12:20 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-C-12-154",
// //     "routeNo": "53-C",
// //     "code": "53/P53C-1",
// //     "tripCode": "53/P53C-153-CTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:30 PM",
// //     "endTime": "01:50 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       282,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "12:30 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "12:35 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "12:37 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "12:50 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "12:56 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "12:58 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "01:03 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "01:09 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "01:11 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "01:18 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "01:28 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "01:29 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "01:35 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "01:36 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "01:39 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "01:42 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:47 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-1-155",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:20 PM",
// //     "endTime": "01:45 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "12:20 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "12:24 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:28 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "12:34 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "12:37 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "12:39 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "12:44 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "12:46 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "12:56 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "01:03 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "01:05 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "01:11 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "01:16 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "01:18 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "01:24 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "01:37 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "01:39 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "01:45 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-2-156",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:50 PM",
// //     "endTime": "03:05 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "01:50 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "01:54 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "01:57 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "02:07 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "02:13 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "02:15 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "02:19 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "02:24 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "02:26 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "02:32 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "02:41 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "02:43 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "02:48 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "02:49 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "02:51 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:57 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "03:01 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "03:05 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-3-157",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:20 PM",
// //     "endTime": "04:15 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "03:20 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "03:22 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:25 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "03:29 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "03:31 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "03:32 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "03:36 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "03:37 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "03:43 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "03:48 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "03:49 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "03:53 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "03:56 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "03:57 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "04:01 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "04:09 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "04:11 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "04:15 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-4-158",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:20 PM",
// //     "endTime": "05:30 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "04:20 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "04:24 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "04:26 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "04:36 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "04:42 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "04:43 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "04:47 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "04:52 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "04:54 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "04:59 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "05:08 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "05:09 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "05:14 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "05:15 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:17 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:23 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "05:26 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "05:30 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-5-159",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-2",
// //     "tripCode": "53/P53D-253-DTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 PM",
// //     "endTime": "07:00 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       133,
// //       134,
// //       135,
// //       136,
// //       287,
// //       137,
// //       138,
// //       139,
// //       118,
// //       132,
// //       140,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "05:45 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "05:48 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:52 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:58 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:00 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:02 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:07 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:08 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:17 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "AM PATTI",
// //         "time": "06:22 PM",
// //         "id": 133
// //       },
// //       {
// //         "no": 11,
// //         "name": "THERMAL STATION",
// //         "time": "06:23 PM",
// //         "id": 134
// //       },
// //       {
// //         "no": 12,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "06:27 PM",
// //         "id": 135
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA MARUTHUR",
// //         "time": "06:30 PM",
// //         "id": 136
// //       },
// //       {
// //         "no": 14,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "06:34 PM",
// //         "id": 287
// //       },
// //       {
// //         "no": 15,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "06:38 PM",
// //         "id": 137
// //       },
// //       {
// //         "no": 16,
// //         "name": "SOUTH KALMEDU",
// //         "time": "06:42 PM",
// //         "id": 138
// //       },
// //       {
// //         "no": 17,
// //         "name": "NORTH KALMEDU",
// //         "time": "06:43 PM",
// //         "id": 139
// //       },
// //       {
// //         "no": 18,
// //         "name": "VEPPALODAI",
// //         "time": "06:47 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 19,
// //         "name": "PANAIYOOR GATE",
// //         "time": "06:53 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 20,
// //         "name": "PANAIYOOR",
// //         "time": "06:56 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 21,
// //         "name": "KULATTHOOR 1",
// //         "time": "07:00 PM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-6-160",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-3",
// //     "tripCode": "53/P53D-353-DTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       141,
// //       140,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "07:20 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "07:23 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "07:27 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "07:33 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "07:34 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "07:40 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "07:45 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "07:47 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "07:54 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:04 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:05 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:11 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:12 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:15 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:22 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:25 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "08:30 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-7-161",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:00 PM",
// //     "endTime": "10:01 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "09:00 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "09:03 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "09:10 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "09:12 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "09:13 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "09:17 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "09:18 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "09:26 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "09:31 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "09:32 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "09:36 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "09:40 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "09:41 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "09:46 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "09:55 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "09:56 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "10:01 PM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-8-162",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:20 PM",
// //     "endTime": "11:30 PM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "10:20 PM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "10:24 PM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "10:26 PM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "10:36 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "10:42 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "10:43 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "10:47 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "10:52 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "10:54 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "10:59 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "11:08 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "11:09 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "11:14 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "11:15 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "11:17 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:23 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "11:26 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "11:30 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-9-163",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-3",
// //     "tripCode": "53/P53D-353-DTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:00 AM",
// //     "endTime": "07:15 AM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       140,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "06:00 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "06:04 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:08 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:15 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:18 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:19 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:25 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:27 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:37 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "06:45 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "06:47 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "06:53 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "06:58 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "07:00 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "07:07 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "07:11 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "07:15 AM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-10-164",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-2",
// //     "tripCode": "53/P53D-253-DTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 AM",
// //     "endTime": "08:35 AM",
// //     "ids": [
// //       141,
// //       140,
// //       132,
// //       118,
// //       139,
// //       138,
// //       137,
// //       287,
// //       136,
// //       135,
// //       134,
// //       133,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "KULATTHOOR 1",
// //         "time": "07:20 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 20,
// //         "name": "PANAIYOOR",
// //         "time": "07:23 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 19,
// //         "name": "PANAIYOOR GATE",
// //         "time": "07:26 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 18,
// //         "name": "VEPPALODAI",
// //         "time": "07:32 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 17,
// //         "name": "NORTH KALMEDU",
// //         "time": "07:36 AM",
// //         "id": 139
// //       },
// //       {
// //         "no": 16,
// //         "name": "SOUTH KALMEDU",
// //         "time": "07:37 AM",
// //         "id": 138
// //       },
// //       {
// //         "no": 15,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "07:41 AM",
// //         "id": 137
// //       },
// //       {
// //         "no": 14,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "07:45 AM",
// //         "id": 287
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA MARUTHUR",
// //         "time": "07:49 AM",
// //         "id": 136
// //       },
// //       {
// //         "no": 12,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "07:52 AM",
// //         "id": 135
// //       },
// //       {
// //         "no": 11,
// //         "name": "THERMAL STATION",
// //         "time": "07:56 AM",
// //         "id": 134
// //       },
// //       {
// //         "no": 10,
// //         "name": "AM PATTI",
// //         "time": "07:57 AM",
// //         "id": 133
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "08:02 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:11 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:12 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:17 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:19 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:21 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:27 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:31 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "08:35 AM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-11-165",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA VAIPPAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:40 AM",
// //     "endTime": "09:55 AM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       286,
// //       284,
// //       122
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "08:40 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "08:43 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:47 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "08:53 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:55 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:56 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "09:01 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "09:03 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "09:12 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "09:18 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "09:20 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "09:25 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "09:29 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "09:31 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "09:37 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "09:47 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "09:50 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "09:55 AM",
// //         "id": 122
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-D-12-166",
// //     "routeNo": "53-D",
// //     "code": "53/P53D-1",
// //     "tripCode": "53/P53D-153-DTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KEELA VAIPPAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:00 AM",
// //     "endTime": "11:20 AM",
// //     "ids": [
// //       122,
// //       284,
// //       286,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "KEELA VAIPPAR",
// //         "time": "10:00 AM",
// //         "id": 122
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLOORANI",
// //         "time": "10:05 AM",
// //         "id": 284
// //       },
// //       {
// //         "no": 16,
// //         "name": "SALT FACTORY 2",
// //         "time": "10:07 AM",
// //         "id": 286
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "10:19 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "10:25 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "10:26 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "10:31 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "10:37 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "10:39 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "10:45 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "10:55 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "10:56 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "11:01 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "11:03 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "11:06 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:12 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "11:15 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "11:20 AM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-1-167",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-2",
// //     "tripCode": "53/P53E-253-ETORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:35 PM",
// //     "endTime": "02:00 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       140,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "01:35 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "01:36 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:37 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "01:40 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "01:41 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "01:41 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "01:43 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "01:44 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "01:47 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "01:50 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "01:50 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "01:52 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "01:54 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "01:55 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "01:57 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "01:58 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "02:00 PM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-2-168",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-2",
// //     "tripCode": "53/P53E-253-ETORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:45 PM",
// //     "endTime": "04:10 PM",
// //     "ids": [
// //       141,
// //       140,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "02:45 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "02:48 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "02:53 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "03:01 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "03:03 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "03:09 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "03:16 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "03:18 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "03:26 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "03:38 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "03:40 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "03:47 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "03:49 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "03:52 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "04:04 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "04:10 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-3-169",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:15 PM",
// //     "endTime": "05:30 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       140,
// //       141,
// //       142,
// //       288
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "04:15 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "04:18 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:22 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "04:28 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "04:31 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "04:32 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "04:37 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "04:38 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "04:48 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "04:54 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "04:56 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "05:01 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "05:06 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "05:07 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "05:13 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "05:17 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "05:20 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "05:23 PM",
// //         "id": 142
// //       },
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "05:30 PM",
// //         "id": 288
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-4-170",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:35 PM",
// //     "endTime": "06:50 PM",
// //     "ids": [
// //       288,
// //       142,
// //       141,
// //       140,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "05:35 PM",
// //         "id": 288
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "05:41 PM",
// //         "id": 142
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "05:44 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "05:47 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "05:51 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "05:57 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "05:58 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "06:03 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "06:08 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "06:10 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:16 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:26 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:27 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:32 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:33 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:36 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:42 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "06:46 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "06:50 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-5-171",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 PM",
// //     "endTime": "06:00 AM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       140,
// //       141,
// //       142,
// //       288
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "07:15 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "07:48 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:17 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "09:10 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "09:32 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "09:44 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "10:28 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "10:39 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "11:59 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "12:52 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "01:09 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "01:54 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "02:35 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "02:46 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "03:38 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "04:09 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "04:35 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "04:59 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "06:00 AM",
// //         "id": 288
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-6-172",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:10 AM",
// //     "endTime": "07:10 AM",
// //     "ids": [
// //       288,
// //       142,
// //       141,
// //       140,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "06:10 AM",
// //         "id": 288
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "06:15 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "06:17 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "06:20 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "06:23 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "06:27 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "06:28 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "06:32 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "06:37 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "06:38 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "06:43 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "06:50 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "06:51 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "06:56 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "06:57 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "06:59 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:04 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "07:06 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "07:10 AM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-7-173",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:45 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       140,
// //       141,
// //       142,
// //       288
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "07:45 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "07:49 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:52 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "07:59 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "08:02 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "08:03 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "08:09 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "08:10 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "08:20 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "08:26 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "08:28 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "08:34 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "08:39 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "08:41 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "08:47 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "08:51 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "08:54 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "08:57 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "09:05 AM",
// //         "id": 288
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-8-174",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 AM",
// //     "endTime": "10:30 AM",
// //     "ids": [
// //       288,
// //       142,
// //       141,
// //       140,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "09:10 AM",
// //         "id": 288
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "09:17 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "09:20 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "09:23 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "09:27 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "09:33 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "09:35 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "09:40 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "09:46 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "09:48 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "09:54 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "10:04 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "10:05 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:11 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "10:12 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "10:15 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:22 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "10:25 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "10:30 AM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-9-175",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SUBRAMANIYAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:45 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       113,
// //       114,
// //       283,
// //       115,
// //       116,
// //       117,
// //       118,
// //       132,
// //       140,
// //       141,
// //       142,
// //       288
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "10:45 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "10:48 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:52 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "10:58 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "11:01 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "11:02 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "11:07 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "11:08 AM",
// //         "id": 113
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "11:18 AM",
// //         "id": 114
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "11:24 AM",
// //         "id": 283
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "11:26 AM",
// //         "id": 115
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "11:31 AM",
// //         "id": 116
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "11:36 AM",
// //         "id": 117
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "11:37 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "11:43 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "11:47 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "11:50 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "11:53 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "12:00 PM",
// //         "id": 288
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-E-10-176",
// //     "routeNo": "53-E",
// //     "code": "53/P53E-1",
// //     "tripCode": "53/P53E-153-ETORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "SUBRAMANIYAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:10 PM",
// //     "endTime": "01:30 PM",
// //     "ids": [
// //       288,
// //       142,
// //       141,
// //       140,
// //       132,
// //       118,
// //       117,
// //       116,
// //       115,
// //       283,
// //       114,
// //       113,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "SUBRAMANIYAPURAM 3",
// //         "time": "12:10 PM",
// //         "id": 288
// //       },
// //       {
// //         "no": 18,
// //         "name": "COLONY",
// //         "time": "12:17 PM",
// //         "id": 142
// //       },
// //       {
// //         "no": 17,
// //         "name": "KULATTHOOR 1",
// //         "time": "12:20 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANAIYOOR",
// //         "time": "12:23 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANAIYOOR GATE",
// //         "time": "12:27 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 14,
// //         "name": "VEPPALODAI",
// //         "time": "12:33 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHEMICAL X",
// //         "time": "12:35 PM",
// //         "id": 117
// //       },
// //       {
// //         "no": 12,
// //         "name": "KALMEDU",
// //         "time": "12:40 PM",
// //         "id": 116
// //       },
// //       {
// //         "no": 11,
// //         "name": "PATTINAMARUTHUR",
// //         "time": "12:46 PM",
// //         "id": 115
// //       },
// //       {
// //         "no": 10,
// //         "name": "ZAKKAMMALPURAM 2",
// //         "time": "12:48 PM",
// //         "id": 283
// //       },
// //       {
// //         "no": 9,
// //         "name": "THARUVAIKULAM",
// //         "time": "12:54 PM",
// //         "id": 114
// //       },
// //       {
// //         "no": 8,
// //         "name": "JOTHI SALT",
// //         "time": "01:04 PM",
// //         "id": 113
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "01:05 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "01:11 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "01:12 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "01:15 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:22 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "01:25 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "01:30 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-1-177",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-1",
// //     "tripCode": "53/P53F-153-FTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 AM",
// //     "endTime": "07:30 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       143,
// //       144,
// //       145,
// //       135,
// //       136,
// //       287,
// //       137,
// //       146,
// //       147,
// //       148,
// //       149,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:32 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:33 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:37 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:38 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:42 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "06:44 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "06:46 AM",
// //         "id": 143
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "06:48 AM",
// //         "id": 144
// //       },
// //       {
// //         "no": 10,
// //         "name": "KUMARAPURAM 1",
// //         "time": "06:53 AM",
// //         "id": 145
// //       },
// //       {
// //         "no": 11,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "06:55 AM",
// //         "id": 135
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MARUTHUR",
// //         "time": "06:58 AM",
// //         "id": 136
// //       },
// //       {
// //         "no": 13,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "07:02 AM",
// //         "id": 287
// //       },
// //       {
// //         "no": 14,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "07:05 AM",
// //         "id": 137
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 1",
// //         "time": "07:07 AM",
// //         "id": 146
// //       },
// //       {
// //         "no": 16,
// //         "name": "VEDANATTHAM",
// //         "time": "07:11 AM",
// //         "id": 147
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKATACHALAPURAM",
// //         "time": "07:15 AM",
// //         "id": 148
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUTHUKUMARAPURAM",
// //         "time": "07:19 AM",
// //         "id": 149
// //       },
// //       {
// //         "no": 20,
// //         "name": "KULATTHOOR 1",
// //         "time": "07:30 AM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-2-178",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-2",
// //     "tripCode": "53/P53F-253-FTORD18U2",
// //     "order": 2,
// //     "direction": "U",
// //     "from": "KULATTHOOR",
// //     "to": "THULUKKANKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:35 AM",
// //     "endTime": "07:45 AM",
// //     "ids": [
// //       141,
// //       142,
// //       150,
// //       126,
// //       125,
// //       285
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "KULATTHOOR 1",
// //         "time": "07:35 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 2,
// //         "name": "COLONY",
// //         "time": "07:36 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 3,
// //         "name": "SUBRAMANIYAPURAM JUNCTION",
// //         "time": "07:38 AM",
// //         "id": 150
// //       },
// //       {
// //         "no": 4,
// //         "name": "VAIPPAR",
// //         "time": "07:41 AM",
// //         "id": 126
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "07:43 AM",
// //         "id": 125
// //       },
// //       {
// //         "no": 6,
// //         "name": "THULUKKANKULAM",
// //         "time": "07:45 AM",
// //         "id": 285
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-3-179",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-2",
// //     "tripCode": "53/P53F-253-FTORD18D3",
// //     "order": 3,
// //     "direction": "D",
// //     "from": "THULUKKANKULAM",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       285,
// //       125,
// //       126,
// //       150,
// //       142,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "THULUKKANKULAM",
// //         "time": "07:50 AM",
// //         "id": 285
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "07:51 AM",
// //         "id": 125
// //       },
// //       {
// //         "no": 4,
// //         "name": "VAIPPAR",
// //         "time": "07:53 AM",
// //         "id": 126
// //       },
// //       {
// //         "no": 3,
// //         "name": "SUBRAMANIYAPURAM JUNCTION",
// //         "time": "07:56 AM",
// //         "id": 150
// //       },
// //       {
// //         "no": 2,
// //         "name": "COLONY",
// //         "time": "07:58 AM",
// //         "id": 142
// //       },
// //       {
// //         "no": 1,
// //         "name": "KULATTHOOR 1",
// //         "time": "08:00 AM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-4-180",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-1",
// //     "tripCode": "53/P53F-153-FTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 AM",
// //     "endTime": "09:25 AM",
// //     "ids": [
// //       141,
// //       149,
// //       148,
// //       147,
// //       146,
// //       137,
// //       287,
// //       136,
// //       135,
// //       145,
// //       144,
// //       143,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "KULATTHOOR 1",
// //         "time": "08:05 AM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUTHUKUMARAPURAM",
// //         "time": "08:19 AM",
// //         "id": 149
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKATACHALAPURAM",
// //         "time": "08:24 AM",
// //         "id": 148
// //       },
// //       {
// //         "no": 16,
// //         "name": "VEDANATTHAM",
// //         "time": "08:29 AM",
// //         "id": 147
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 1",
// //         "time": "08:34 AM",
// //         "id": 146
// //       },
// //       {
// //         "no": 14,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "08:38 AM",
// //         "id": 137
// //       },
// //       {
// //         "no": 13,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "08:42 AM",
// //         "id": 287
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MARUTHUR",
// //         "time": "08:46 AM",
// //         "id": 136
// //       },
// //       {
// //         "no": 11,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "08:50 AM",
// //         "id": 135
// //       },
// //       {
// //         "no": 10,
// //         "name": "KUMARAPURAM 1",
// //         "time": "08:53 AM",
// //         "id": 145
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "09:00 AM",
// //         "id": 144
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "09:02 AM",
// //         "id": 143
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "09:06 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:08 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:14 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:15 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:20 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:22 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-5-181",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-4",
// //     "tripCode": "53/P53F-453-FTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA SEITHALAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "10:20 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       111,
// //       155,
// //       156
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:35 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:36 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:38 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:38 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:40 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "09:41 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "09:43 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "09:46 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "09:48 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "09:49 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 13,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:00 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEITHALAI JUNCTION",
// //         "time": "10:17 AM",
// //         "id": 155
// //       },
// //       {
// //         "no": 15,
// //         "name": "KEELA SEITHALAI",
// //         "time": "10:20 AM",
// //         "id": 156
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-6-182",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-4",
// //     "tripCode": "53/P53F-453-FTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KEELA SEITHALAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 AM",
// //     "endTime": "11:30 AM",
// //     "ids": [
// //       156,
// //       155,
// //       111,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "KEELA SEITHALAI",
// //         "time": "10:30 AM",
// //         "id": 156
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEITHALAI JUNCTION",
// //         "time": "10:33 AM",
// //         "id": 155
// //       },
// //       {
// //         "no": 13,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:55 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "11:10 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "11:12 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "11:15 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "11:18 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "11:20 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:22 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:24 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:25 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:27 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:28 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-7-183",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-3",
// //     "tripCode": "53/P53F-353-FTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KOLLAMPARAMBU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:35 AM",
// //     "endTime": "12:15 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       152,
// //       289,
// //       154
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:36 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:38 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:41 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:42 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:45 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "11:47 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "11:51 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "11:56 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "11:59 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "12:02 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 1",
// //         "time": "12:08 PM",
// //         "id": 152
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHANDRAGIRI",
// //         "time": "12:09 PM",
// //         "id": 289
// //       },
// //       {
// //         "no": 15,
// //         "name": "KOLLAMPARAMBU",
// //         "time": "12:15 PM",
// //         "id": 154
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-8-184",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-3",
// //     "tripCode": "53/P53F-353-FTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KOLLAMPARAMBU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:20 PM",
// //     "endTime": "01:30 PM",
// //     "ids": [
// //       154,
// //       289,
// //       152,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "KOLLAMPARAMBU",
// //         "time": "12:20 PM",
// //         "id": 154
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHANDRAGIRI",
// //         "time": "12:29 PM",
// //         "id": 289
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 1",
// //         "time": "12:31 PM",
// //         "id": 152
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "12:41 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "12:46 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "12:52 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "01:01 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "01:07 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:10 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:17 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:18 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:24 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:26 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-9-185",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-4",
// //     "tripCode": "53/P53F-453-FTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA SEITHALAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:35 PM",
// //     "endTime": "02:30 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       111,
// //       155,
// //       156
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:36 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:37 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:39 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:39 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:42 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "01:43 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "01:45 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "01:48 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "01:51 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "01:52 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 13,
// //         "name": "THOMAS NAGAR",
// //         "time": "02:06 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEITHALAI JUNCTION",
// //         "time": "02:26 PM",
// //         "id": 155
// //       },
// //       {
// //         "no": 15,
// //         "name": "KEELA SEITHALAI",
// //         "time": "02:30 PM",
// //         "id": 156
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-10-186",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-4",
// //     "tripCode": "53/P53F-453-FTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KEELA SEITHALAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:40 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       156,
// //       155,
// //       111,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "KEELA SEITHALAI",
// //         "time": "02:40 PM",
// //         "id": 156
// //       },
// //       {
// //         "no": 14,
// //         "name": "SEITHALAI JUNCTION",
// //         "time": "02:40 PM",
// //         "id": 155
// //       },
// //       {
// //         "no": 13,
// //         "name": "THOMAS NAGAR",
// //         "time": "02:46 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "02:50 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "02:50 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "02:51 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "02:52 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "02:52 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:53 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:53 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:53 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:54 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:54 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-11-187",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-1",
// //     "tripCode": "53/P53F-153-FTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:00 PM",
// //     "endTime": "05:10 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       143,
// //       144,
// //       145,
// //       135,
// //       136,
// //       287,
// //       137,
// //       146,
// //       147,
// //       148,
// //       149,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:04 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "04:08 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "04:09 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "04:14 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "04:16 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "04:19 PM",
// //         "id": 143
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "04:21 PM",
// //         "id": 144
// //       },
// //       {
// //         "no": 10,
// //         "name": "KUMARAPURAM 1",
// //         "time": "04:27 PM",
// //         "id": 145
// //       },
// //       {
// //         "no": 11,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "04:29 PM",
// //         "id": 135
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MARUTHUR",
// //         "time": "04:33 PM",
// //         "id": 136
// //       },
// //       {
// //         "no": 13,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "04:37 PM",
// //         "id": 287
// //       },
// //       {
// //         "no": 14,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "04:40 PM",
// //         "id": 137
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 1",
// //         "time": "04:44 PM",
// //         "id": 146
// //       },
// //       {
// //         "no": 16,
// //         "name": "VEDANATTHAM",
// //         "time": "04:48 PM",
// //         "id": 147
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKATACHALAPURAM",
// //         "time": "04:52 PM",
// //         "id": 148
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUTHUKUMARAPURAM",
// //         "time": "04:57 PM",
// //         "id": 149
// //       },
// //       {
// //         "no": 20,
// //         "name": "KULATTHOOR 1",
// //         "time": "05:10 PM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-12-188",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-2",
// //     "tripCode": "53/P53F-253-FTORD18U12",
// //     "order": 12,
// //     "direction": "U",
// //     "from": "KULATTHOOR",
// //     "to": "THULUKKANKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "03:50 PM",
// //     "ids": [
// //       141,
// //       142,
// //       150,
// //       126,
// //       125,
// //       285
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "KULATTHOOR 1",
// //         "time": "03:00 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 2,
// //         "name": "COLONY",
// //         "time": "03:06 PM",
// //         "id": 142
// //       },
// //       {
// //         "no": 3,
// //         "name": "SUBRAMANIYAPURAM JUNCTION",
// //         "time": "03:19 PM",
// //         "id": 150
// //       },
// //       {
// //         "no": 4,
// //         "name": "VAIPPAR",
// //         "time": "03:32 PM",
// //         "id": 126
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "03:41 PM",
// //         "id": 125
// //       },
// //       {
// //         "no": 6,
// //         "name": "THULUKKANKULAM",
// //         "time": "03:50 PM",
// //         "id": 285
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-13-189",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-2",
// //     "tripCode": "53/P53F-253-FTORD18D13",
// //     "order": 13,
// //     "direction": "D",
// //     "from": "THULUKKANKULAM",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:15 PM",
// //     "endTime": "05:25 PM",
// //     "ids": [
// //       285,
// //       125,
// //       126,
// //       150,
// //       142,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "THULUKKANKULAM",
// //         "time": "05:15 PM",
// //         "id": 285
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALAIGNANAPURAM JUNCTION",
// //         "time": "05:16 PM",
// //         "id": 125
// //       },
// //       {
// //         "no": 4,
// //         "name": "VAIPPAR",
// //         "time": "05:18 PM",
// //         "id": 126
// //       },
// //       {
// //         "no": 3,
// //         "name": "SUBRAMANIYAPURAM JUNCTION",
// //         "time": "05:21 PM",
// //         "id": 150
// //       },
// //       {
// //         "no": 2,
// //         "name": "COLONY",
// //         "time": "05:23 PM",
// //         "id": 142
// //       },
// //       {
// //         "no": 1,
// //         "name": "KULATTHOOR 1",
// //         "time": "05:25 PM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-14-190",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-1",
// //     "tripCode": "53/P53F-153-FTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 PM",
// //     "endTime": "06:45 PM",
// //     "ids": [
// //       141,
// //       149,
// //       148,
// //       147,
// //       146,
// //       137,
// //       287,
// //       136,
// //       135,
// //       145,
// //       144,
// //       143,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "KULATTHOOR 1",
// //         "time": "05:30 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUTHUKUMARAPURAM",
// //         "time": "05:43 PM",
// //         "id": 149
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKATACHALAPURAM",
// //         "time": "05:48 PM",
// //         "id": 148
// //       },
// //       {
// //         "no": 16,
// //         "name": "VEDANATTHAM",
// //         "time": "05:52 PM",
// //         "id": 147
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 1",
// //         "time": "05:57 PM",
// //         "id": 146
// //       },
// //       {
// //         "no": 14,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "06:01 PM",
// //         "id": 137
// //       },
// //       {
// //         "no": 13,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "06:04 PM",
// //         "id": 287
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MARUTHUR",
// //         "time": "06:09 PM",
// //         "id": 136
// //       },
// //       {
// //         "no": 11,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "06:12 PM",
// //         "id": 135
// //       },
// //       {
// //         "no": 10,
// //         "name": "KUMARAPURAM 1",
// //         "time": "06:15 PM",
// //         "id": 145
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "06:21 PM",
// //         "id": 144
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "06:23 PM",
// //         "id": 143
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "06:27 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:29 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:34 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:36 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:40 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:42 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-15-191",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-1",
// //     "tripCode": "53/P53F-153-FTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 PM",
// //     "endTime": "08:05 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       143,
// //       144,
// //       145,
// //       135,
// //       136,
// //       287,
// //       137,
// //       146,
// //       147,
// //       148,
// //       149,
// //       141
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:52 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:54 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:58 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:00 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:05 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "07:07 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "07:11 PM",
// //         "id": 143
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "07:13 PM",
// //         "id": 144
// //       },
// //       {
// //         "no": 10,
// //         "name": "KUMARAPURAM 1",
// //         "time": "07:19 PM",
// //         "id": 145
// //       },
// //       {
// //         "no": 11,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "07:22 PM",
// //         "id": 135
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MARUTHUR",
// //         "time": "07:25 PM",
// //         "id": 136
// //       },
// //       {
// //         "no": 13,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "07:30 PM",
// //         "id": 287
// //       },
// //       {
// //         "no": 14,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "07:33 PM",
// //         "id": 137
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 1",
// //         "time": "07:37 PM",
// //         "id": 146
// //       },
// //       {
// //         "no": 16,
// //         "name": "VEDANATTHAM",
// //         "time": "07:42 PM",
// //         "id": 147
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKATACHALAPURAM",
// //         "time": "07:46 PM",
// //         "id": 148
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUTHUKUMARAPURAM",
// //         "time": "07:51 PM",
// //         "id": 149
// //       },
// //       {
// //         "no": 20,
// //         "name": "KULATTHOOR 1",
// //         "time": "08:05 PM",
// //         "id": 141
// //       }
// //     ]
// //   },
// //   {
// //     "id": "53-F-16-192",
// //     "routeNo": "53-F",
// //     "code": "53/P53F-1",
// //     "tripCode": "53/P53F-153-FTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 PM",
// //     "endTime": "09:20 PM",
// //     "ids": [
// //       141,
// //       149,
// //       148,
// //       147,
// //       146,
// //       137,
// //       287,
// //       136,
// //       135,
// //       145,
// //       144,
// //       143,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "KULATTHOOR 1",
// //         "time": "08:10 PM",
// //         "id": 141
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUTHUKUMARAPURAM",
// //         "time": "08:22 PM",
// //         "id": 149
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKATACHALAPURAM",
// //         "time": "08:27 PM",
// //         "id": 148
// //       },
// //       {
// //         "no": 16,
// //         "name": "VEDANATTHAM",
// //         "time": "08:31 PM",
// //         "id": 147
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 1",
// //         "time": "08:35 PM",
// //         "id": 146
// //       },
// //       {
// //         "no": 14,
// //         "name": "DURAISAMYPURAM 1",
// //         "time": "08:39 PM",
// //         "id": 137
// //       },
// //       {
// //         "no": 13,
// //         "name": "ZAKKAMMALPURAM 3",
// //         "time": "08:42 PM",
// //         "id": 287
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MARUTHUR",
// //         "time": "08:46 PM",
// //         "id": 136
// //       },
// //       {
// //         "no": 11,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "08:50 PM",
// //         "id": 135
// //       },
// //       {
// //         "no": 10,
// //         "name": "KUMARAPURAM 1",
// //         "time": "08:52 PM",
// //         "id": 145
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "08:58 PM",
// //         "id": 144
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "09:00 PM",
// //         "id": 143
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "09:03 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:05 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:10 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:11 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:15 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:17 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-1-193",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:15 PM",
// //     "endTime": "03:15 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "02:15 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "02:21 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "02:30 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:43 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:45 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:51 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "03:03 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:08 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "03:08 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "03:15 PM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-2-194",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:20 PM",
// //     "endTime": "04:20 PM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "03:20 PM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "03:26 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:26 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "03:31 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:43 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "03:49 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "03:51 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:04 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:13 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:19 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-3-195",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:25 PM",
// //     "endTime": "05:15 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:25 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:25 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:30 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:37 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:49 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:50 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "04:55 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "05:05 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "05:09 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "05:09 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "05:15 PM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-4-196",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:20 PM",
// //     "endTime": "06:20 PM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "05:20 PM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "05:26 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "05:26 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "05:31 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "05:43 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "05:49 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "05:51 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:04 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:13 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:19 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-5-197",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:25 PM",
// //     "endTime": "07:25 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:25 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:25 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:31 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:40 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:53 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:55 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:01 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:13 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:18 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "07:18 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "07:25 PM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-6-198",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 PM",
// //     "endTime": "08:55 PM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "07:30 PM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "07:38 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:38 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:46 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:03 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:12 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:13 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:33 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:45 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:53 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-7-199",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:00 PM",
// //     "endTime": "09:50 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:00 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:05 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:12 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:24 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:25 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:30 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:40 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:44 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "09:44 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "09:50 PM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-8-200",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:55 PM",
// //     "endTime": "06:10 AM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "09:55 PM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "10:46 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "10:46 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "11:30 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:10 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:59 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:11 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:04 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:14 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:02 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-11-201",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:15 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:20 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:27 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:39 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:40 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:45 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "08:55 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "08:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "08:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "09:05 AM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-12-202",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 AM",
// //     "endTime": "10:10 AM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "09:10 AM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "09:16 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:16 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:21 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:33 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:39 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:41 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:54 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:03 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:09 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-13-203",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:15 AM",
// //     "endTime": "11:05 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:15 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:20 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:27 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:39 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:40 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:45 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "10:55 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "10:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "10:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "11:05 AM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-14-204",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:10 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "11:10 AM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "11:15 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "11:15 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "11:19 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "11:29 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "11:34 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:35 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:47 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "11:54 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "11:59 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-15-205",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:05 PM",
// //     "endTime": "12:55 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "12:05 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "12:10 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "12:17 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "12:29 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "12:30 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "12:35 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "12:45 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:49 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "12:49 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "12:55 PM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-A-16-206",
// //     "routeNo": "54-A",
// //     "code": "54/P54A-1",
// //     "tripCode": "54/P54A-154-ATORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:00 PM",
// //     "endTime": "02:10 PM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "01:00 PM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "01:07 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:07 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "01:13 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:27 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:34 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:36 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:52 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "02:02 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "02:08 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-1-207",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ARUMUGAMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:45 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       290,
// //       159,
// //       160,
// //       161,
// //       162
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "01:45 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "01:50 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:56 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:07 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:08 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:13 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "02:22 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "02:27 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "02:34 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "02:40 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "02:40 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "02:45 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "02:48 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "02:55 PM",
// //         "id": 162
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-2-208",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "ARUMUGAMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "04:10 PM",
// //     "ids": [
// //       162,
// //       161,
// //       160,
// //       159,
// //       290,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "03:00 PM",
// //         "id": 162
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "03:06 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "03:09 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "03:14 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "03:14 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "03:20 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:27 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "03:32 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:41 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "03:46 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "03:47 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "03:58 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:04 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:09 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-3-209",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ARUMUGAMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:20 PM",
// //     "endTime": "05:35 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       290,
// //       159,
// //       160,
// //       161,
// //       162
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:20 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:25 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:32 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:44 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:45 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "04:50 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "05:00 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "05:05 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "05:13 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "05:19 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "05:19 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "05:25 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "05:27 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "05:35 PM",
// //         "id": 162
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-4-210",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "ARUMUGAMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:40 PM",
// //     "endTime": "07:05 PM",
// //     "ids": [
// //       162,
// //       161,
// //       160,
// //       159,
// //       290,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "05:40 PM",
// //         "id": 162
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "05:48 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "05:51 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "05:57 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "05:57 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "06:04 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:13 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:18 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:30 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:36 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:37 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:50 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:58 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:04 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-5-211",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ARUMUGAMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       290,
// //       159,
// //       160,
// //       161,
// //       162
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:10 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:15 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:23 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:35 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:37 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:42 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:53 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:58 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "08:06 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "08:13 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "08:13 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "08:19 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "08:22 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "08:30 PM",
// //         "id": 162
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-6-212",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ARUMUGAMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:35 PM",
// //     "endTime": "05:20 AM",
// //     "ids": [
// //       162,
// //       161,
// //       160,
// //       159,
// //       290,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "08:35 PM",
// //         "id": 162
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "09:25 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "09:44 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "10:25 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "10:26 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "11:06 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:04 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "12:35 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:46 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:21 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:29 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "03:50 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:40 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:14 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-7-213",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ARUMUGAMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:25 AM",
// //     "endTime": "06:40 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       290,
// //       159,
// //       160,
// //       161,
// //       162
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:25 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:25 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:30 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "05:37 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "05:49 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "05:50 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "05:55 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:05 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:10 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "06:18 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "06:24 AM",
// //         "id": 290
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "06:24 AM",
// //         "id": 159
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "06:30 AM",
// //         "id": 160
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "06:32 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "06:40 AM",
// //         "id": 162
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-8-214",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "ARUMUGAMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:45 AM",
// //     "endTime": "08:05 AM",
// //     "ids": [
// //       162,
// //       161,
// //       160,
// //       159,
// //       290,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "06:45 AM",
// //         "id": 162
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "06:52 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "06:55 AM",
// //         "id": 160
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "07:01 AM",
// //         "id": 159
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "07:01 AM",
// //         "id": 290
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "07:08 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:16 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:21 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:32 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:37 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:39 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:51 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:59 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:04 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:05 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-9-215",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ARUMUGAMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 AM",
// //     "endTime": "09:25 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       290,
// //       159,
// //       160,
// //       161,
// //       162
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:10 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:15 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:22 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:34 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:35 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:40 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "08:50 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "08:55 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:03 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "09:09 AM",
// //         "id": 290
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "09:09 AM",
// //         "id": 159
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "09:15 AM",
// //         "id": 160
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "09:17 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "09:25 AM",
// //         "id": 162
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-10-216",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "ARUMUGAMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:30 AM",
// //     "endTime": "10:45 AM",
// //     "ids": [
// //       162,
// //       161,
// //       160,
// //       159,
// //       290,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "09:30 AM",
// //         "id": 162
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "09:37 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "09:39 AM",
// //         "id": 160
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "09:45 AM",
// //         "id": 159
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "09:45 AM",
// //         "id": 290
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:51 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "10:04 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:14 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:19 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:20 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:32 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:39 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:44 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-11-217",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ARUMUGAMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:50 AM",
// //     "endTime": "12:05 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       290,
// //       159,
// //       160,
// //       161,
// //       162
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:50 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:55 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:02 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:14 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "11:15 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "11:20 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "11:30 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "11:35 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "11:43 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "11:49 AM",
// //         "id": 290
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "11:49 AM",
// //         "id": 159
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "11:55 AM",
// //         "id": 160
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "11:57 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "12:05 PM",
// //         "id": 162
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-B-12-218",
// //     "routeNo": "54-B",
// //     "code": "54/P54B-1",
// //     "tripCode": "54/P54B-154-BTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ARUMUGAMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:10 PM",
// //     "endTime": "01:40 PM",
// //     "ids": [
// //       162,
// //       161,
// //       160,
// //       159,
// //       290,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ARUMUGAMANGALAM",
// //         "time": "12:10 PM",
// //         "id": 162
// //       },
// //       {
// //         "no": 14,
// //         "name": "MARAMANGALAM",
// //         "time": "12:18 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 13,
// //         "name": "IDAYARKADU",
// //         "time": "12:21 PM",
// //         "id": 160
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMBADI",
// //         "time": "12:29 PM",
// //         "id": 159
// //       },
// //       {
// //         "no": 11,
// //         "name": "WATER TANK 2",
// //         "time": "12:29 PM",
// //         "id": 290
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "12:35 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:45 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "12:51 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:03 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:09 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:10 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:24 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "01:33 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "01:39 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-1-219",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-2",
// //     "tripCode": "54/P54C-254-CTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHETTIKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 AM",
// //     "endTime": "07:40 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163,
// //       34,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       168
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:30 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:34 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:41 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:51 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:52 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:56 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "07:01 AM",
// //         "id": 163
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "07:10 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:14 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:20 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "07:24 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:27 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "07:32 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 15,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:35 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 16,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:37 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHETTIKULAM",
// //         "time": "07:40 AM",
// //         "id": 168
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-2-220",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-2",
// //     "tripCode": "54/P54C-254-CTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "CHETTIKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:55 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       168,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       34,
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHETTIKULAM",
// //         "time": "07:55 AM",
// //         "id": 168
// //       },
// //       {
// //         "no": 16,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:57 AM",
// //         "id": 17
// //       },
// //       {
// //         "no": 15,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:59 AM",
// //         "id": 40
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "08:02 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:07 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "08:10 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "08:14 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "08:20 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "08:24 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "08:33 AM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:38 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:42 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:43 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:53 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:00 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:04 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:05 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-3-221",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-1",
// //     "tripCode": "54/P54C-154-CTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "VAGAIKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:20 AM",
// //     "endTime": "10:50 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163,
// //       34,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       291,
// //       164,
// //       165,
// //       166,
// //       167
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:20 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:24 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:31 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:41 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:42 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:47 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "09:52 AM",
// //         "id": 163
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "10:00 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:04 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "10:10 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "10:14 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "10:18 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "10:22 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 15,
// //         "name": "KUMARAPURAM 2",
// //         "time": "10:28 AM",
// //         "id": 291
// //       },
// //       {
// //         "no": 16,
// //         "name": "KATTALANKULAM",
// //         "time": "10:32 AM",
// //         "id": 164
// //       },
// //       {
// //         "no": 17,
// //         "name": "M. PUDHUR",
// //         "time": "10:40 AM",
// //         "id": 165
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "10:44 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 19,
// //         "name": "VAGAIKULAM",
// //         "time": "10:50 AM",
// //         "id": 167
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-4-222",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-1",
// //     "tripCode": "54/P54C-154-CTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "VAGAIKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:05 AM",
// //     "endTime": "12:30 PM",
// //     "ids": [
// //       167,
// //       166,
// //       165,
// //       164,
// //       291,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       34,
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "VAGAIKULAM",
// //         "time": "11:05 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 18,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "11:09 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 17,
// //         "name": "M. PUDHUR",
// //         "time": "11:13 AM",
// //         "id": 165
// //       },
// //       {
// //         "no": 16,
// //         "name": "KATTALANKULAM",
// //         "time": "11:21 AM",
// //         "id": 164
// //       },
// //       {
// //         "no": 15,
// //         "name": "KUMARAPURAM 2",
// //         "time": "11:25 AM",
// //         "id": 291
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "11:30 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "11:34 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "11:38 AM",
// //         "id": 37
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "11:42 AM",
// //         "id": 10
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "11:47 AM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "11:51 AM",
// //         "id": 34
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "11:59 AM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "12:04 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "12:08 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "12:09 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "12:19 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "12:25 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "12:29 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-5-223",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-3",
// //     "tripCode": "54/P54C-354-CTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KOOTTAMPULI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:45 PM",
// //     "endTime": "01:55 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163,
// //       34,
// //       9
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "12:46 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "12:52 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:02 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:18 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:20 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:27 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "01:35 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "01:48 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "01:55 PM",
// //         "id": 9
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-6-224",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-3",
// //     "tripCode": "54/P54C-354-CTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KOOTTAMPULI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:00 PM",
// //     "endTime": "03:10 PM",
// //     "ids": [
// //       9,
// //       34,
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "02:00 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "02:06 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "02:19 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:27 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:34 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:36 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "02:52 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "03:02 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "03:08 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-7-225",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-2",
// //     "tripCode": "54/P54C-254-CTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHETTIKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:15 PM",
// //     "endTime": "04:30 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163,
// //       34,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       168
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "03:15 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "03:20 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "03:27 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "03:37 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "03:38 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:43 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "03:49 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "03:58 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "04:02 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "04:08 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "04:13 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:17 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "04:21 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 15,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:25 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 16,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "04:27 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHETTIKULAM",
// //         "time": "04:30 PM",
// //         "id": 168
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-8-226",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-2",
// //     "tripCode": "54/P54C-254-CTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CHETTIKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:35 PM",
// //     "endTime": "05:50 PM",
// //     "ids": [
// //       168,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       34,
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHETTIKULAM",
// //         "time": "04:35 PM",
// //         "id": 168
// //       },
// //       {
// //         "no": 16,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "04:37 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 15,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "04:39 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "04:43 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "04:47 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "04:51 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "04:56 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "05:02 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "05:06 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "05:15 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "05:21 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "05:26 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "05:27 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "05:37 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:44 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:49 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-9-227",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-2",
// //     "tripCode": "54/P54C-254-CTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHETTIKULAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:55 PM",
// //     "endTime": "07:10 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163,
// //       34,
// //       9,
// //       10,
// //       37,
// //       12,
// //       13,
// //       40,
// //       17,
// //       168
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:55 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:00 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:07 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:17 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:18 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:23 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "06:29 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "06:38 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "06:42 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "06:48 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "06:53 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "06:57 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "07:01 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 15,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:05 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 16,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:07 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHETTIKULAM",
// //         "time": "07:10 PM",
// //         "id": 168
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-10-228",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-2",
// //     "tripCode": "54/P54C-254-CTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "CHETTIKULAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:25 PM",
// //     "endTime": "08:40 PM",
// //     "ids": [
// //       168,
// //       17,
// //       40,
// //       13,
// //       12,
// //       37,
// //       10,
// //       9,
// //       34,
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHETTIKULAM",
// //         "time": "07:25 PM",
// //         "id": 168
// //       },
// //       {
// //         "no": 16,
// //         "name": "RAMASAMYPURAM BRIDGE",
// //         "time": "07:27 PM",
// //         "id": 17
// //       },
// //       {
// //         "no": 15,
// //         "name": "SUBRAMANIAPURAM 1",
// //         "time": "07:29 PM",
// //         "id": 40
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAWYERPURAM",
// //         "time": "07:33 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 13,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "07:37 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 12,
// //         "name": "SALAI",
// //         "time": "07:41 PM",
// //         "id": 37
// //       },
// //       {
// //         "no": 11,
// //         "name": "SERVAIKARANMADAM",
// //         "time": "07:46 PM",
// //         "id": 10
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "07:52 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "07:56 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "08:05 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:11 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:16 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:17 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:27 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:34 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:39 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-11-229",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-3",
// //     "tripCode": "54/P54C-354-CTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KOOTTAMPULI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:55 PM",
// //     "endTime": "09:55 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163,
// //       34,
// //       9
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:55 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:01 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:10 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:23 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:25 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:31 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "09:38 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "09:49 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "09:55 PM",
// //         "id": 9
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-C-12-230",
// //     "routeNo": "54-C",
// //     "code": "54/P54C-3",
// //     "tripCode": "54/P54C-354-CTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KOOTTAMPULI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:00 PM",
// //     "endTime": "11:00 PM",
// //     "ids": [
// //       9,
// //       34,
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "KOOTTAMPULI",
// //         "time": "10:00 PM",
// //         "id": 9
// //       },
// //       {
// //         "no": 9,
// //         "name": "KULAIYANKARISAL",
// //         "time": "10:05 PM",
// //         "id": 34
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "10:16 PM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:23 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:29 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:31 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:44 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:53 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:59 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-1-231",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-3",
// //     "tripCode": "54/P54D-354-DTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SOUTH KOVANKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 AM",
// //     "endTime": "07:05 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       157,
// //       158
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:15 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:20 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:27 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:39 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:40 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:45 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:55 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "06:59 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "07:05 AM",
// //         "id": 158
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-2-232",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-3",
// //     "tripCode": "54/P54D-354-DTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "SOUTH KOVANKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       158,
// //       157,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SOUTH KOVANKADU",
// //         "time": "07:10 AM",
// //         "id": 158
// //       },
// //       {
// //         "no": 10,
// //         "name": "KOVANKADU",
// //         "time": "07:15 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:15 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:19 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:29 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:34 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:35 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:47 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:54 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:59 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-3-233",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 AM",
// //     "endTime": "09:00 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       169,
// //       170,
// //       161,
// //       171,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:05 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:05 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:08 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:12 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:19 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:20 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:23 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "08:29 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "08:32 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "08:37 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "08:39 AM",
// //         "id": 169
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "08:42 AM",
// //         "id": 170
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "08:46 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "08:49 AM",
// //         "id": 171
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "08:53 AM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "09:00 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-4-234",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-2",
// //     "tripCode": "54/P54D-254-DTORD18U4",
// //     "order": 4,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "SIRUTHONDANALLUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:05 AM",
// //     "endTime": "09:00 AM",
// //     "ids": [
// //       20,
// //       19
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "09:05 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "09:00 AM",
// //         "id": 19
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-5-235",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-2",
// //     "tripCode": "54/P54D-254-DTORD18D5",
// //     "order": 5,
// //     "direction": "D",
// //     "from": "SIRUTHONDANALLUR",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 AM",
// //     "endTime": "09:10 AM",
// //     "ids": [
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 2,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "09:15 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "09:10 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-6-236",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-2",
// //     "tripCode": "54/P54D-254-DTORD18U6",
// //     "order": 6,
// //     "direction": "U",
// //     "from": "ERAL",
// //     "to": "SIRUTHONDANALLUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:05 AM",
// //     "endTime": "09:10 AM",
// //     "ids": [
// //       20,
// //       19
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "09:05 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 2,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "09:10 AM",
// //         "id": 19
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-7-237",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-2",
// //     "tripCode": "54/P54D-254-DTORD18D7",
// //     "order": 7,
// //     "direction": "D",
// //     "from": "SIRUTHONDANALLUR",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 AM",
// //     "endTime": "09:20 AM",
// //     "ids": [
// //       19,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 2,
// //         "name": "SIRUTHONDANALLUR",
// //         "time": "09:15 AM",
// //         "id": 19
// //       },
// //       {
// //         "no": 1,
// //         "name": "ERAL",
// //         "time": "09:20 AM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-8-238",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 AM",
// //     "endTime": "11:25 AM",
// //     "ids": [
// //       20,
// //       54,
// //       171,
// //       161,
// //       170,
// //       169,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "09:50 AM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "10:00 AM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "10:07 AM",
// //         "id": 171
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "10:13 AM",
// //         "id": 161
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "10:19 AM",
// //         "id": 170
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "10:24 AM",
// //         "id": 169
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "10:29 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "10:37 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "10:42 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:53 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:58 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:59 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:11 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "11:19 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "11:24 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-9-239",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:30 AM",
// //     "endTime": "12:50 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       169,
// //       170,
// //       161,
// //       171,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "11:30 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "11:34 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:41 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:51 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "11:52 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "11:56 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "12:05 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:09 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "12:16 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "12:20 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "12:24 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "12:29 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "12:35 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "12:40 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "12:50 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-10-240",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:55 PM",
// //     "endTime": "01:40 PM",
// //     "ids": [
// //       20,
// //       54,
// //       171,
// //       161,
// //       170,
// //       169,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "12:55 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "01:00 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "01:03 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "01:06 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "01:09 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "01:11 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "01:13 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:17 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "01:19 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:24 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:27 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:27 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:33 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "01:37 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "01:39 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-11-241",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:30 PM",
// //     "endTime": "03:40 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       169,
// //       170,
// //       161,
// //       171,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "02:30 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "02:34 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "02:39 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:48 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:49 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:53 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "03:01 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:04 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "03:11 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "03:14 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "03:17 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "03:22 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "03:27 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "03:32 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "03:40 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-12-242",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:45 PM",
// //     "endTime": "05:05 PM",
// //     "ids": [
// //       20,
// //       54,
// //       171,
// //       161,
// //       170,
// //       169,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "03:45 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "03:54 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "03:59 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "04:05 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "04:10 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "04:14 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "04:18 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "04:25 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "04:29 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "04:38 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:42 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:43 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:53 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:00 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:04 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-13-243",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:10 PM",
// //     "endTime": "06:40 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       169,
// //       170,
// //       161,
// //       171,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:10 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:15 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "05:22 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "05:34 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "05:35 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "05:40 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "05:50 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "05:54 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "06:02 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "06:07 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "06:11 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "06:17 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "06:23 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "06:29 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "06:40 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-14-244",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:45 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       20,
// //       54,
// //       171,
// //       161,
// //       170,
// //       169,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "06:45 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "06:56 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "07:04 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "07:11 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "07:18 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "07:23 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "07:28 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:37 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:43 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:54 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:00 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:01 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:15 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:23 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:29 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-15-245",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ERAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:20 PM",
// //     "endTime": "09:50 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       169,
// //       170,
// //       161,
// //       171,
// //       54,
// //       20
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:20 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:25 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:32 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:44 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:45 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:50 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:00 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:04 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:12 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "09:17 PM",
// //         "id": 169
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "09:21 PM",
// //         "id": 170
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "09:27 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "09:33 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "09:39 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "09:50 PM",
// //         "id": 20
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-D-16-246",
// //     "routeNo": "54-D",
// //     "code": "54/P54D-1",
// //     "tripCode": "54/P54D-154-DTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "ERAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:00 PM",
// //     "endTime": "05:45 AM",
// //     "ids": [
// //       20,
// //       54,
// //       171,
// //       161,
// //       170,
// //       169,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "ERAL",
// //         "time": "10:00 PM",
// //         "id": 20
// //       },
// //       {
// //         "no": 15,
// //         "name": "WATER TANK 1",
// //         "time": "10:52 PM",
// //         "id": 54
// //       },
// //       {
// //         "no": 14,
// //         "name": "KORKAI",
// //         "time": "11:26 PM",
// //         "id": 171
// //       },
// //       {
// //         "no": 13,
// //         "name": "MARAMANGALAM",
// //         "time": "11:56 PM",
// //         "id": 161
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGARAM",
// //         "time": "12:26 AM",
// //         "id": 170
// //       },
// //       {
// //         "no": 11,
// //         "name": "AGARAM BRIDGE",
// //         "time": "12:50 AM",
// //         "id": 169
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "01:12 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:54 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "02:17 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:09 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "03:34 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "03:40 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:39 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:16 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:41 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-1-247",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUNNAKAYAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:15 PM",
// //     "endTime": "02:30 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       173,
// //       174,
// //       175
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "01:15 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "01:19 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:25 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:34 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "01:35 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "01:39 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "01:47 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:51 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "01:58 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "02:05 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "02:10 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "02:14 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "02:21 PM",
// //         "id": 173
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "02:25 PM",
// //         "id": 174
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "02:30 PM",
// //         "id": 175
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-2-248",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "PUNNAKAYAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:35 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       175,
// //       174,
// //       173,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "02:35 PM",
// //         "id": 175
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "02:40 PM",
// //         "id": 174
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "02:45 PM",
// //         "id": 173
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "02:52 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "02:56 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "03:02 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "03:11 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:18 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "03:22 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "03:32 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "03:36 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "03:37 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "03:48 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "03:54 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "03:59 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-3-249",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUNNAKAYAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:05 PM",
// //     "endTime": "05:20 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       173,
// //       174,
// //       175
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:05 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:09 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:15 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:24 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:25 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "04:29 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "04:37 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "04:41 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "04:48 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "04:55 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "05:00 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "05:04 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "05:11 PM",
// //         "id": 173
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "05:15 PM",
// //         "id": 174
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "05:20 PM",
// //         "id": 175
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-4-250",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "PUNNAKAYAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:25 PM",
// //     "endTime": "06:40 PM",
// //     "ids": [
// //       175,
// //       174,
// //       173,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "05:25 PM",
// //         "id": 175
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "05:29 PM",
// //         "id": 174
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "05:33 PM",
// //         "id": 173
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "05:40 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "05:44 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "05:49 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "05:56 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:03 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:07 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:15 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:19 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:20 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:29 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:35 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:39 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-5-251",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-2",
// //     "tripCode": "54/P54F-254-FTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ATTHIMARAPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:45 PM",
// //     "endTime": "07:20 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       176,
// //       177
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:45 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:51 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:59 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:11 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "07:12 PM",
// //         "id": 176
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "07:20 PM",
// //         "id": 177
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-6-252",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-2",
// //     "tripCode": "54/P54F-254-FTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ATTHIMARAPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 PM",
// //     "endTime": "10:00 PM",
// //     "ids": [
// //       177,
// //       176,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "07:30 PM",
// //         "id": 177
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "08:03 PM",
// //         "id": 176
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:05 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:59 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:33 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:56 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-7-253",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUNNAKAYAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:15 PM",
// //     "endTime": "05:40 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       173,
// //       174,
// //       175
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:18 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:41 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:16 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "12:11 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "12:16 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "12:40 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "01:29 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "01:51 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "02:30 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "03:14 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "03:45 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "04:08 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "04:47 AM",
// //         "id": 173
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "05:12 AM",
// //         "id": 174
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "05:40 AM",
// //         "id": 175
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-8-254",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PUNNAKAYAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 AM",
// //     "endTime": "07:25 AM",
// //     "ids": [
// //       175,
// //       174,
// //       173,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "05:45 AM",
// //         "id": 175
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "05:51 AM",
// //         "id": 174
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "05:56 AM",
// //         "id": 173
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "06:05 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "06:10 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "06:17 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "06:27 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:36 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:41 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:52 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:57 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:58 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:11 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:18 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:24 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-9-255",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUNNAKAYAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 AM",
// //     "endTime": "08:40 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       173,
// //       174,
// //       175
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:30 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:34 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:39 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:48 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:49 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:52 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "08:00 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "08:03 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "08:10 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "08:17 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "08:22 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "08:25 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "08:31 AM",
// //         "id": 173
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "08:35 AM",
// //         "id": 174
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "08:40 AM",
// //         "id": 175
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-10-256",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "PUNNAKAYAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:50 AM",
// //     "endTime": "10:25 AM",
// //     "ids": [
// //       175,
// //       174,
// //       173,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "08:50 AM",
// //         "id": 175
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "08:55 AM",
// //         "id": 174
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "09:01 AM",
// //         "id": 173
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "09:09 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "09:14 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "09:21 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:30 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:38 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:43 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:53 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:58 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:00 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:11 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:19 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:24 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-11-257",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUNNAKAYAL",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 AM",
// //     "endTime": "11:40 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       173,
// //       174,
// //       175
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:30 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:34 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:39 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:48 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:49 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:52 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "11:00 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "11:03 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "11:10 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "11:17 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "11:22 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "11:25 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "11:31 AM",
// //         "id": 173
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "11:35 AM",
// //         "id": 174
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "11:40 AM",
// //         "id": 175
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-F-12-258",
// //     "routeNo": "54-F",
// //     "code": "54/P54F-1",
// //     "tripCode": "54/P54F-154-FTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "PUNNAKAYAL",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:45 AM",
// //     "endTime": "01:10 PM",
// //     "ids": [
// //       175,
// //       174,
// //       173,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PUNNAKAYAL",
// //         "time": "11:45 AM",
// //         "id": 175
// //       },
// //       {
// //         "no": 15,
// //         "name": "DCW COLONY",
// //         "time": "11:50 AM",
// //         "id": 174
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHERNTHAMARAM",
// //         "time": "11:55 AM",
// //         "id": 173
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "12:02 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "12:06 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "12:12 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "12:21 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:28 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "12:32 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "12:42 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "12:46 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "12:47 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "12:58 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "01:04 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "01:09 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-1-259",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-5",
// //     "tripCode": "54/P54G-554-GTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KOLLAMPARAMBU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 AM",
// //     "endTime": "06:25 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       152,
// //       289,
// //       154
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:46 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:48 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:51 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:52 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:55 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "05:57 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "06:01 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "06:06 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "06:09 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "06:12 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 1",
// //         "time": "06:18 AM",
// //         "id": 152
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHANDRAGIRI",
// //         "time": "06:19 AM",
// //         "id": 289
// //       },
// //       {
// //         "no": 15,
// //         "name": "KOLLAMPARAMBU",
// //         "time": "06:25 AM",
// //         "id": 154
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-2-260",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-6",
// //     "tripCode": "54/P54G-654-GTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KOLLAMPARAMBU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 AM",
// //     "endTime": "07:20 AM",
// //     "ids": [
// //       154,
// //       289,
// //       152,
// //       100,
// //       281,
// //       99,
// //       143,
// //       292,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "KOLLAMPARAMBU",
// //         "time": "06:30 AM",
// //         "id": 154
// //       },
// //       {
// //         "no": 15,
// //         "name": "CHANDRAGIRI",
// //         "time": "06:36 AM",
// //         "id": 289
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHANDRAGIRI JUNCTION 1",
// //         "time": "06:37 AM",
// //         "id": 152
// //       },
// //       {
// //         "no": 12,
// //         "name": "KURUKKUSALAI",
// //         "time": "06:44 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 11,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "06:47 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 10,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "06:51 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 9,
// //         "name": "ARASADI 1",
// //         "time": "07:00 AM",
// //         "id": 143
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 2",
// //         "time": "07:03 AM",
// //         "id": 292
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "07:05 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:07 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:11 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:12 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:16 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:17 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-3-261",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-2",
// //     "tripCode": "54/P54G-254-GTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MULLAKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 AM",
// //     "endTime": "08:10 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:31 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:37 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:46 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:01 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:03 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:10 AM",
// //         "id": 46
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-4-262",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-3",
// //     "tripCode": "54/P54G-354-GTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "MULLAKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:15 AM",
// //     "ids": [
// //       46,
// //       45,
// //       184,
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 12,
// //         "name": "MULLAKADU",
// //         "time": "08:15 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 11,
// //         "name": "SPIC NAGAR",
// //         "time": "08:20 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 10,
// //         "name": "BULK",
// //         "time": "08:22 AM",
// //         "id": 184
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "08:37 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:39 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:44 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:51 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:54 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:01 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:09 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:14 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:15 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-5-263",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:20 AM",
// //     "endTime": "09:50 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:24 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:28 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:34 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "09:37 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:40 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:45 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:48 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "09:50 AM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-6-264",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:00 AM",
// //     "endTime": "10:40 AM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "10:00 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:02 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:06 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:13 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:16 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:20 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "10:28 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:33 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-7-265",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-1",
// //     "tripCode": "54/P54G-154-GTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PON NAGAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:45 AM",
// //     "endTime": "11:10 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       176,
// //       177,
// //       178
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:45 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:49 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:54 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:02 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "11:02 AM",
// //         "id": 176
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "11:07 AM",
// //         "id": 177
// //       },
// //       {
// //         "no": 8,
// //         "name": "PON NAGAR",
// //         "time": "11:10 AM",
// //         "id": 178
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-8-266",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-1",
// //     "tripCode": "54/P54G-154-GTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PON NAGAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:20 AM",
// //     "endTime": "11:40 AM",
// //     "ids": [
// //       178,
// //       177,
// //       176,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 8,
// //         "name": "PON NAGAR",
// //         "time": "11:20 AM",
// //         "id": 178
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "11:21 AM",
// //         "id": 177
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "11:25 AM",
// //         "id": 176
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:25 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:32 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "11:36 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "11:39 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-9-267",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-8",
// //     "tripCode": "54/P54G-854-GTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "VELLAPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:50 AM",
// //     "endTime": "12:20 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       187
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "11:50 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "11:54 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:58 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "12:05 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "12:08 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "12:09 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "12:15 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "VELLAPATTI",
// //         "time": "12:20 PM",
// //         "id": 187
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-10-268",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-8",
// //     "tripCode": "54/P54G-854-GTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "VELLAPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:30 PM",
// //     "endTime": "01:25 PM",
// //     "ids": [
// //       187,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 8,
// //         "name": "VELLAPATTI",
// //         "time": "12:30 PM",
// //         "id": 187
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "12:37 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "12:48 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "12:51 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "12:56 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:09 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "01:16 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "01:25 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-11-269",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-1",
// //     "tripCode": "54/P54G-154-GTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PON NAGAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:30 PM",
// //     "endTime": "02:00 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       176,
// //       177,
// //       178
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "01:30 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "01:34 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "01:41 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "01:51 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "01:51 PM",
// //         "id": 176
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "01:57 PM",
// //         "id": 177
// //       },
// //       {
// //         "no": 8,
// //         "name": "PON NAGAR",
// //         "time": "02:00 PM",
// //         "id": 178
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-12-270",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-1",
// //     "tripCode": "54/P54G-154-GTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "PON NAGAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:05 PM",
// //     "endTime": "02:35 PM",
// //     "ids": [
// //       178,
// //       177,
// //       176,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 8,
// //         "name": "PON NAGAR",
// //         "time": "02:05 PM",
// //         "id": 178
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "02:07 PM",
// //         "id": 177
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "02:13 PM",
// //         "id": 176
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:13 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "02:23 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "02:30 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "02:34 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-13-271",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:40 PM",
// //     "endTime": "03:25 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "02:47 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "02:53 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "03:01 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "03:06 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "03:10 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "03:17 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "03:22 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "03:25 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-14-272",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:30 PM",
// //     "endTime": "04:05 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "03:30 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "03:32 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "03:35 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "03:41 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "03:44 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "03:47 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "03:54 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "03:59 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-15-273",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-1",
// //     "tripCode": "54/P54G-154-GTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PON NAGAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:15 PM",
// //     "endTime": "04:55 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       176,
// //       177,
// //       178
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:15 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:21 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:29 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:43 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "04:43 PM",
// //         "id": 176
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "04:51 PM",
// //         "id": 177
// //       },
// //       {
// //         "no": 8,
// //         "name": "PON NAGAR",
// //         "time": "04:55 PM",
// //         "id": 178
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-16-274",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-7",
// //     "tripCode": "54/P54G-754-GTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "PON NAGAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 PM",
// //     "endTime": "07:10 PM",
// //     "ids": [
// //       178,
// //       177,
// //       176,
// //       44,
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "PON NAGAR",
// //         "time": "05:00 PM",
// //         "id": 178
// //       },
// //       {
// //         "no": 12,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "05:05 PM",
// //         "id": 177
// //       },
// //       {
// //         "no": 11,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "05:19 PM",
// //         "id": 176
// //       },
// //       {
// //         "no": 10,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "05:19 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "05:48 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "05:53 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:01 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:15 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:21 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:30 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "06:46 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "06:57 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-17-275",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18U17",
// //     "order": 17,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 PM",
// //     "endTime": "07:55 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:25 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "07:30 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "07:37 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "07:40 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "07:43 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "07:49 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "07:52 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "07:55 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-18-276",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "08:00 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:01 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:04 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:09 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:12 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:15 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:21 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:25 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-19-277",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18U19",
// //     "order": 19,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:40 PM",
// //     "endTime": "09:05 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:43 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:47 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:52 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:54 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:56 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:01 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:03 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "09:05 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "54-G-20-278",
// //     "routeNo": "54-G",
// //     "code": "54/P54G-4",
// //     "tripCode": "54/P54G-454-GTORD18D20",
// //     "order": 20,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 PM",
// //     "endTime": "10:00 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "09:10 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:12 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:17 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:26 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "09:30 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:35 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:45 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:52 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-1-279",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-3",
// //     "tripCode": "55/P55A-355-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "GOVERNORGIRI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:30 PM",
// //     "endTime": "01:35 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       191,
// //       192,
// //       193,
// //       194,
// //       195
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "12:32 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "12:34 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "12:38 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "12:40 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "12:45 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "12:47 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "12:52 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "12:59 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "01:03 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "01:07 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "01:12 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "01:17 PM",
// //         "id": 192
// //       },
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "01:24 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 15,
// //         "name": "VELLARAM",
// //         "time": "01:30 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "01:35 PM",
// //         "id": 195
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-2-280",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-3",
// //     "tripCode": "55/P55A-355-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "GOVERNORGIRI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:40 PM",
// //     "endTime": "02:45 PM",
// //     "ids": [
// //       195,
// //       194,
// //       193,
// //       192,
// //       191,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "01:40 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "VELLARAM",
// //         "time": "01:44 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "01:50 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "01:57 PM",
// //         "id": 192
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "02:02 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "02:07 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "02:11 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "02:15 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "02:22 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "02:27 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:29 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:34 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:36 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:40 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:42 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-3-281",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-6",
// //     "tripCode": "55/P55A-655-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "04:05 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       101,
// //       188,
// //       189,
// //       190,
// //       76
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:04 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:09 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:10 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:16 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "03:19 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "03:24 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "03:31 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "03:36 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "03:40 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "03:44 PM",
// //         "id": 101
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "03:49 PM",
// //         "id": 188
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "03:52 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "03:57 PM",
// //         "id": 190
// //       },
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "04:05 PM",
// //         "id": 76
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-4-282",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-6",
// //     "tripCode": "55/P55A-655-ATORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:10 PM",
// //     "endTime": "05:20 PM",
// //     "ids": [
// //       76,
// //       190,
// //       189,
// //       188,
// //       101,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "04:10 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "04:17 PM",
// //         "id": 190
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "04:23 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "04:26 PM",
// //         "id": 188
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "04:32 PM",
// //         "id": 101
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "04:35 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "04:40 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "04:46 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "04:53 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "04:59 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:02 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:08 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:09 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:14 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:16 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-5-283",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-2",
// //     "tripCode": "55/P55A-255-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM TALUK OFFICE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:25 PM",
// //     "endTime": "06:25 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       101,
// //       188,
// //       189,
// //       190,
// //       76,
// //       109
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:25 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:27 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:29 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:33 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:34 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:39 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "05:42 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "05:47 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "05:53 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "05:58 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "06:02 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "06:05 PM",
// //         "id": 101
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "06:10 PM",
// //         "id": 188
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "06:12 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "06:17 PM",
// //         "id": 190
// //       },
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:24 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 17,
// //         "name": "OTTAPIDARAM TALUK OFFICE",
// //         "time": "06:25 PM",
// //         "id": 109
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-6-284",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-2",
// //     "tripCode": "55/P55A-255-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM TALUK OFFICE",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 PM",
// //     "endTime": "07:30 PM",
// //     "ids": [
// //       109,
// //       76,
// //       190,
// //       189,
// //       188,
// //       101,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "OTTAPIDARAM TALUK OFFICE",
// //         "time": "06:30 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:30 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "06:37 PM",
// //         "id": 190
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "06:42 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "06:44 PM",
// //         "id": 188
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "06:49 PM",
// //         "id": 101
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "06:52 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "06:56 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "07:01 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "07:07 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "07:12 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:15 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:20 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:21 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:25 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:27 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-7-285",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-3",
// //     "tripCode": "55/P55A-355-ATORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "GOVERNORGIRI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:45 PM",
// //     "endTime": "08:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       191,
// //       192,
// //       193,
// //       194,
// //       195
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:47 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:49 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:54 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:55 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:01 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "08:03 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "08:09 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "08:16 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "08:21 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "08:25 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "08:31 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "08:35 PM",
// //         "id": 192
// //       },
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "08:43 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 15,
// //         "name": "VELLARAM",
// //         "time": "08:50 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "08:55 PM",
// //         "id": 195
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-8-286",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-3",
// //     "tripCode": "55/P55A-355-ATORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "GOVERNORGIRI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:00 PM",
// //     "endTime": "10:05 PM",
// //     "ids": [
// //       195,
// //       194,
// //       193,
// //       192,
// //       191,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "09:00 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "VELLARAM",
// //         "time": "09:04 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "09:10 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "09:17 PM",
// //         "id": 192
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "09:22 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "09:27 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "09:31 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "09:35 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "09:42 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "09:47 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:49 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:54 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:56 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "10:00 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-9-287",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-4",
// //     "tripCode": "55/P55A-455-ATORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:00 PM",
// //     "endTime": "12:15 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:01 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:03 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:05 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:06 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:09 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:12 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:15 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "11:19 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "11:23 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "11:26 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "11:42 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "11:59 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:03 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:04 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "12:12 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "12:15 AM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-10-288",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-5",
// //     "tripCode": "55/P55A-555-ATORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 AM",
// //     "endTime": "06:25 AM",
// //     "ids": [
// //       193,
// //       192,
// //       191,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "05:30 AM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "05:37 AM",
// //         "id": 192
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "05:41 AM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "05:46 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "05:50 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "05:55 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "06:02 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "06:07 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:09 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:14 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:16 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:20 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:22 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-11-289",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-6",
// //     "tripCode": "55/P55A-655-ATORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       101,
// //       188,
// //       189,
// //       190,
// //       76
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:53 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:55 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:00 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:01 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:07 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "07:10 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "07:16 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "07:23 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "07:29 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "07:34 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "07:37 AM",
// //         "id": 101
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "07:43 AM",
// //         "id": 188
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "07:46 AM",
// //         "id": 189
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "07:52 AM",
// //         "id": 190
// //       },
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:00 AM",
// //         "id": 76
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-12-290",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-6",
// //     "tripCode": "55/P55A-655-ATORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 AM",
// //     "endTime": "09:20 AM",
// //     "ids": [
// //       76,
// //       190,
// //       189,
// //       188,
// //       101,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:05 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "08:13 AM",
// //         "id": 190
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "08:19 AM",
// //         "id": 189
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "08:22 AM",
// //         "id": 188
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "08:29 AM",
// //         "id": 101
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "08:32 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "08:37 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "08:43 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "08:51 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "08:58 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:01 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:07 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:09 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:14 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:16 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-13-291",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-2",
// //     "tripCode": "55/P55A-255-ATORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM TALUK OFFICE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "10:30 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       101,
// //       188,
// //       189,
// //       190,
// //       76,
// //       109
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:37 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:39 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:42 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:44 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:48 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "09:50 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "09:55 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "10:01 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "10:05 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "10:09 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "10:11 AM",
// //         "id": 101
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "10:16 AM",
// //         "id": 188
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "10:18 AM",
// //         "id": 189
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "10:23 AM",
// //         "id": 190
// //       },
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:29 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 17,
// //         "name": "OTTAPIDARAM TALUK OFFICE",
// //         "time": "10:30 AM",
// //         "id": 109
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-A-14-292",
// //     "routeNo": "55-A",
// //     "code": "55/P55A-2",
// //     "tripCode": "55/P55A-255-ATORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM TALUK OFFICE",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:35 AM",
// //     "endTime": "11:40 AM",
// //     "ids": [
// //       109,
// //       76,
// //       190,
// //       189,
// //       188,
// //       101,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "OTTAPIDARAM TALUK OFFICE",
// //         "time": "10:35 AM",
// //         "id": 109
// //       },
// //       {
// //         "no": 16,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:35 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "PANCHALANKURICHI",
// //         "time": "10:43 AM",
// //         "id": 190
// //       },
// //       {
// //         "no": 14,
// //         "name": "AGILANDAPURAM",
// //         "time": "10:48 AM",
// //         "id": 189
// //       },
// //       {
// //         "no": 13,
// //         "name": "KAKKARAMPATTI",
// //         "time": "10:50 AM",
// //         "id": 188
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM 1",
// //         "time": "10:56 AM",
// //         "id": 101
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "10:59 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "11:03 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "11:08 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "11:15 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "11:21 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:23 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:29 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:30 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:35 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:37 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-1-293",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-3",
// //     "tripCode": "55/P55B-355-BTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MILAGU NATTHAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:40 PM",
// //     "endTime": "01:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       191,
// //       295,
// //       200,
// //       201,
// //       202,
// //       203,
// //       204,
// //       205,
// //       206,
// //       207
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "12:42 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "12:44 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "12:47 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "12:49 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "12:53 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "12:56 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "01:00 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "01:06 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "01:10 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "01:14 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "01:18 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 2",
// //         "time": "01:23 PM",
// //         "id": 295
// //       },
// //       {
// //         "no": 14,
// //         "name": "MELA SEITHALAI",
// //         "time": "01:27 PM",
// //         "id": 200
// //       },
// //       {
// //         "no": 15,
// //         "name": "JEGAVEERAPANDIAPURAM",
// //         "time": "01:30 PM",
// //         "id": 201
// //       },
// //       {
// //         "no": 16,
// //         "name": "THANNEER MADAM",
// //         "time": "01:37 PM",
// //         "id": 202
// //       },
// //       {
// //         "no": 17,
// //         "name": "KAYATHAR JUNCTION",
// //         "time": "01:38 PM",
// //         "id": 203
// //       },
// //       {
// //         "no": 18,
// //         "name": "EPPODHUMVENDRAN",
// //         "time": "01:40 PM",
// //         "id": 204
// //       },
// //       {
// //         "no": 19,
// //         "name": "KATTUNAICKENPATTI",
// //         "time": "01:44 PM",
// //         "id": 205
// //       },
// //       {
// //         "no": 20,
// //         "name": "ADHANOOR",
// //         "time": "01:50 PM",
// //         "id": 206
// //       },
// //       {
// //         "no": 21,
// //         "name": "MILAGU NATTHAM",
// //         "time": "01:55 PM",
// //         "id": 207
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-2-294",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-3",
// //     "tripCode": "55/P55B-355-BTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "MILAGU NATTHAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:00 PM",
// //     "endTime": "03:10 PM",
// //     "ids": [
// //       207,
// //       206,
// //       205,
// //       204,
// //       203,
// //       202,
// //       201,
// //       200,
// //       295,
// //       191,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "MILAGU NATTHAM",
// //         "time": "02:00 PM",
// //         "id": 207
// //       },
// //       {
// //         "no": 20,
// //         "name": "ADHANOOR",
// //         "time": "02:04 PM",
// //         "id": 206
// //       },
// //       {
// //         "no": 19,
// //         "name": "KATTUNAICKENPATTI",
// //         "time": "02:09 PM",
// //         "id": 205
// //       },
// //       {
// //         "no": 18,
// //         "name": "EPPODHUMVENDRAN",
// //         "time": "02:13 PM",
// //         "id": 204
// //       },
// //       {
// //         "no": 17,
// //         "name": "KAYATHAR JUNCTION",
// //         "time": "02:15 PM",
// //         "id": 203
// //       },
// //       {
// //         "no": 16,
// //         "name": "THANNEER MADAM",
// //         "time": "02:16 PM",
// //         "id": 202
// //       },
// //       {
// //         "no": 15,
// //         "name": "JEGAVEERAPANDIAPURAM",
// //         "time": "02:23 PM",
// //         "id": 201
// //       },
// //       {
// //         "no": 14,
// //         "name": "MELA SEITHALAI",
// //         "time": "02:25 PM",
// //         "id": 200
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 2",
// //         "time": "02:29 PM",
// //         "id": 295
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "02:33 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "02:37 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "02:41 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "02:45 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "02:50 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "02:55 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:57 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:01 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:02 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:06 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:07 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-3-295",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-1",
// //     "tripCode": "55/P55B-155-BTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:15 PM",
// //     "endTime": "04:30 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "03:20 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:24 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "03:27 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "03:31 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "03:36 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "03:39 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "03:46 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "03:50 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "03:58 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "04:02 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:07 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "04:10 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "04:13 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "04:20 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "04:26 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "04:30 PM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-4-296",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-1",
// //     "tripCode": "55/P55B-155-BTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:35 PM",
// //     "endTime": "05:50 PM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       84,
// //       83,
// //       82,
// //       81,
// //       225,
// //       79,
// //       78,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "04:35 PM",
// //         "id": 199
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "04:38 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "04:44 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "04:51 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "04:54 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:57 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:02 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "05:06 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "05:14 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "05:18 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "05:25 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "05:28 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "05:33 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "05:37 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:40 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:44 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-5-297",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-2",
// //     "tripCode": "55/P55B-255-BTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MILAGU NATTHAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:00 PM",
// //     "endTime": "07:10 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       191,
// //       295,
// //       200,
// //       156,
// //       201,
// //       202,
// //       203,
// //       204,
// //       205,
// //       206,
// //       207
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:01 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:03 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:06 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:07 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:11 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "06:13 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "06:17 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "06:22 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "06:25 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "06:28 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "06:32 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 2",
// //         "time": "06:36 PM",
// //         "id": 295
// //       },
// //       {
// //         "no": 14,
// //         "name": "MELA SEITHALAI",
// //         "time": "06:40 PM",
// //         "id": 200
// //       },
// //       {
// //         "no": 15,
// //         "name": "KEELA SEITHALAI",
// //         "time": "06:43 PM",
// //         "id": 156
// //       },
// //       {
// //         "no": 16,
// //         "name": "JEGAVEERAPANDIAPURAM",
// //         "time": "06:49 PM",
// //         "id": 201
// //       },
// //       {
// //         "no": 17,
// //         "name": "THANNEER MADAM",
// //         "time": "06:55 PM",
// //         "id": 202
// //       },
// //       {
// //         "no": 18,
// //         "name": "KAYATHAR JUNCTION",
// //         "time": "06:56 PM",
// //         "id": 203
// //       },
// //       {
// //         "no": 19,
// //         "name": "EPPODHUMVENDRAN",
// //         "time": "06:57 PM",
// //         "id": 204
// //       },
// //       {
// //         "no": 20,
// //         "name": "KATTUNAICKENPATTI",
// //         "time": "07:01 PM",
// //         "id": 205
// //       },
// //       {
// //         "no": 21,
// //         "name": "ADHANOOR",
// //         "time": "07:05 PM",
// //         "id": 206
// //       },
// //       {
// //         "no": 22,
// //         "name": "MILAGU NATTHAM",
// //         "time": "07:10 PM",
// //         "id": 207
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-6-298",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-3",
// //     "tripCode": "55/P55B-355-BTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "MILAGU NATTHAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       207,
// //       206,
// //       205,
// //       204,
// //       203,
// //       202,
// //       201,
// //       200,
// //       295,
// //       191,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "MILAGU NATTHAM",
// //         "time": "07:15 PM",
// //         "id": 207
// //       },
// //       {
// //         "no": 20,
// //         "name": "ADHANOOR",
// //         "time": "07:19 PM",
// //         "id": 206
// //       },
// //       {
// //         "no": 19,
// //         "name": "KATTUNAICKENPATTI",
// //         "time": "07:25 PM",
// //         "id": 205
// //       },
// //       {
// //         "no": 18,
// //         "name": "EPPODHUMVENDRAN",
// //         "time": "07:29 PM",
// //         "id": 204
// //       },
// //       {
// //         "no": 17,
// //         "name": "KAYATHAR JUNCTION",
// //         "time": "07:31 PM",
// //         "id": 203
// //       },
// //       {
// //         "no": 16,
// //         "name": "THANNEER MADAM",
// //         "time": "07:32 PM",
// //         "id": 202
// //       },
// //       {
// //         "no": 15,
// //         "name": "JEGAVEERAPANDIAPURAM",
// //         "time": "07:39 PM",
// //         "id": 201
// //       },
// //       {
// //         "no": 14,
// //         "name": "MELA SEITHALAI",
// //         "time": "07:42 PM",
// //         "id": 200
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 2",
// //         "time": "07:46 PM",
// //         "id": 295
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "07:51 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "07:55 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "07:59 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "08:03 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "08:09 PM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "08:13 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:16 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:20 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:22 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:25 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:27 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-7-299",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-1",
// //     "tripCode": "55/P55B-155-BTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:00 PM",
// //     "endTime": "11:15 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "10:05 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:09 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "10:12 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "10:16 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "10:21 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "10:24 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "10:31 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "10:35 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "10:43 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:47 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:52 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "10:55 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "10:58 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "11:05 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "11:11 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "11:15 PM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-8-300",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-1",
// //     "tripCode": "55/P55B-155-BTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 AM",
// //     "endTime": "06:15 AM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       84,
// //       83,
// //       82,
// //       81,
// //       225,
// //       79,
// //       78,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "05:00 AM",
// //         "id": 199
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "05:03 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "05:09 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "05:16 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "05:19 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:22 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:27 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "05:31 AM",
// //         "id": 84
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "05:39 AM",
// //         "id": 83
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "05:43 AM",
// //         "id": 82
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "05:50 AM",
// //         "id": 81
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "05:53 AM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "05:58 AM",
// //         "id": 79
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "06:02 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:05 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:09 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-9-301",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-3",
// //     "tripCode": "55/P55B-355-BTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MILAGU NATTHAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:45 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       98,
// //       99,
// //       281,
// //       100,
// //       191,
// //       295,
// //       200,
// //       201,
// //       202,
// //       203,
// //       204,
// //       205,
// //       206,
// //       207
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:47 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:49 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:52 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:54 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:58 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "07:01 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "07:05 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "07:11 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "07:15 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "07:19 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "07:23 AM",
// //         "id": 191
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 2",
// //         "time": "07:28 AM",
// //         "id": 295
// //       },
// //       {
// //         "no": 14,
// //         "name": "MELA SEITHALAI",
// //         "time": "07:32 AM",
// //         "id": 200
// //       },
// //       {
// //         "no": 15,
// //         "name": "JEGAVEERAPANDIAPURAM",
// //         "time": "07:35 AM",
// //         "id": 201
// //       },
// //       {
// //         "no": 16,
// //         "name": "THANNEER MADAM",
// //         "time": "07:42 AM",
// //         "id": 202
// //       },
// //       {
// //         "no": 17,
// //         "name": "KAYATHAR JUNCTION",
// //         "time": "07:43 AM",
// //         "id": 203
// //       },
// //       {
// //         "no": 18,
// //         "name": "EPPODHUMVENDRAN",
// //         "time": "07:45 AM",
// //         "id": 204
// //       },
// //       {
// //         "no": 19,
// //         "name": "KATTUNAICKENPATTI",
// //         "time": "07:49 AM",
// //         "id": 205
// //       },
// //       {
// //         "no": 20,
// //         "name": "ADHANOOR",
// //         "time": "07:55 AM",
// //         "id": 206
// //       },
// //       {
// //         "no": 21,
// //         "name": "MILAGU NATTHAM",
// //         "time": "08:00 AM",
// //         "id": 207
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-10-302",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-2",
// //     "tripCode": "55/P55B-255-BTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "MILAGU NATTHAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:25 AM",
// //     "ids": [
// //       207,
// //       206,
// //       205,
// //       204,
// //       203,
// //       202,
// //       201,
// //       156,
// //       200,
// //       295,
// //       191,
// //       100,
// //       281,
// //       99,
// //       98,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 22,
// //         "name": "MILAGU NATTHAM",
// //         "time": "08:15 AM",
// //         "id": 207
// //       },
// //       {
// //         "no": 21,
// //         "name": "ADHANOOR",
// //         "time": "08:19 AM",
// //         "id": 206
// //       },
// //       {
// //         "no": 20,
// //         "name": "KATTUNAICKENPATTI",
// //         "time": "08:23 AM",
// //         "id": 205
// //       },
// //       {
// //         "no": 19,
// //         "name": "EPPODHUMVENDRAN",
// //         "time": "08:27 AM",
// //         "id": 204
// //       },
// //       {
// //         "no": 18,
// //         "name": "KAYATHAR JUNCTION",
// //         "time": "08:28 AM",
// //         "id": 203
// //       },
// //       {
// //         "no": 17,
// //         "name": "THANNEER MADAM",
// //         "time": "08:29 AM",
// //         "id": 202
// //       },
// //       {
// //         "no": 16,
// //         "name": "JEGAVEERAPANDIAPURAM",
// //         "time": "08:35 AM",
// //         "id": 201
// //       },
// //       {
// //         "no": 15,
// //         "name": "KEELA SEITHALAI",
// //         "time": "08:41 AM",
// //         "id": 156
// //       },
// //       {
// //         "no": 14,
// //         "name": "MELA SEITHALAI",
// //         "time": "08:44 AM",
// //         "id": 200
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHANDRAGIRI JUNCTION 2",
// //         "time": "08:48 AM",
// //         "id": 295
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "08:52 AM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "08:56 AM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "08:59 AM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "09:02 AM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 1",
// //         "time": "09:07 AM",
// //         "id": 98
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "09:11 AM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:13 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:17 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:18 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:21 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:23 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-11-303",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-1",
// //     "tripCode": "55/P55B-155-BTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:30 AM",
// //     "endTime": "10:45 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:35 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:39 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "09:42 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "09:46 AM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "09:51 AM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "09:54 AM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "10:01 AM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "10:05 AM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "10:13 AM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:17 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:22 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "10:25 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "10:28 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "10:35 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "10:41 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "10:45 AM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-B-12-304",
// //     "routeNo": "55-B",
// //     "code": "55/P55B-1",
// //     "tripCode": "55/P55B-155-BTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:50 AM",
// //     "endTime": "12:05 PM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       84,
// //       83,
// //       82,
// //       81,
// //       225,
// //       79,
// //       78,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "10:50 AM",
// //         "id": 199
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "10:53 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "10:59 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "11:06 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "11:09 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "11:12 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "11:17 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "11:21 AM",
// //         "id": 84
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "11:29 AM",
// //         "id": 83
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "11:33 AM",
// //         "id": 82
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "11:40 AM",
// //         "id": 81
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "11:43 AM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "11:48 AM",
// //         "id": 79
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "11:52 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:55 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "11:59 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-1-305",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-1",
// //     "tripCode": "55/P55C-155-CTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:10 PM",
// //     "endTime": "01:30 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "12:15 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:19 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "12:23 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "12:27 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "12:33 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "12:36 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "12:43 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "12:48 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "12:56 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:00 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:06 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "01:09 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "01:12 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "01:19 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "01:25 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "01:30 PM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-2-306",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-1",
// //     "tripCode": "55/P55C-155-CTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:40 PM",
// //     "endTime": "02:45 PM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       84,
// //       83,
// //       82,
// //       81,
// //       225,
// //       79,
// //       78,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "01:40 PM",
// //         "id": 199
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "01:43 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "01:48 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "01:54 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "01:56 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:59 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:03 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "02:06 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "02:13 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "02:17 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "02:23 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "02:26 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "02:30 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "02:34 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:37 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "02:40 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-3-307",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-2",
// //     "tripCode": "55/P55C-255-CTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SANGAMPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:50 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       109,
// //       105,
// //       85,
// //       106,
// //       208,
// //       209
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:52 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:53 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:57 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:58 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:02 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:06 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "03:10 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "03:15 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "03:20 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "03:24 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "03:25 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "03:31 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:33 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "TALUK OFFICE",
// //         "time": "03:34 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 16,
// //         "name": "AYYANAR KOVIL",
// //         "time": "03:36 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "03:43 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "03:45 PM",
// //         "id": 106
// //       },
// //       {
// //         "no": 20,
// //         "name": "MURAMBAN",
// //         "time": "03:55 PM",
// //         "id": 208
// //       },
// //       {
// //         "no": 21,
// //         "name": "SANGAMPATTI",
// //         "time": "04:00 PM",
// //         "id": 209
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-4-308",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-2",
// //     "tripCode": "55/P55C-255-CTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SANGAMPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:05 PM",
// //     "endTime": "05:35 PM",
// //     "ids": [
// //       209,
// //       208,
// //       106,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "SANGAMPATTI",
// //         "time": "04:05 PM",
// //         "id": 209
// //       },
// //       {
// //         "no": 20,
// //         "name": "MURAMBAN",
// //         "time": "04:10 PM",
// //         "id": 208
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "04:23 PM",
// //         "id": 106
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "04:26 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 16,
// //         "name": "AYYANAR KOVIL",
// //         "time": "04:35 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 15,
// //         "name": "TALUK OFFICE",
// //         "time": "04:38 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "04:39 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "04:41 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "04:48 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:51 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "04:55 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "05:02 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "05:09 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "05:14 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:18 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:23 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:25 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:29 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:32 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-5-309",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-1",
// //     "tripCode": "55/P55C-155-CTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 PM",
// //     "endTime": "06:55 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:49 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:53 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "05:56 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "06:00 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "06:05 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "06:08 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "06:14 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "06:18 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "06:25 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:29 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "06:34 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "06:36 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "06:39 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "06:46 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "06:51 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "06:55 PM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-6-310",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-1",
// //     "tripCode": "55/P55C-155-CTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 PM",
// //     "endTime": "08:15 PM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       84,
// //       83,
// //       82,
// //       81,
// //       225,
// //       79,
// //       78,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "07:00 PM",
// //         "id": 199
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "07:03 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "07:09 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "07:16 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "07:19 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:22 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:27 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "07:31 PM",
// //         "id": 84
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "07:39 PM",
// //         "id": 83
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "07:43 PM",
// //         "id": 82
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "07:50 PM",
// //         "id": 81
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "07:53 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "07:58 PM",
// //         "id": 79
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "08:02 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:05 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:09 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-7-311",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-3",
// //     "tripCode": "55/P55C-355-CTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "VELLARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 PM",
// //     "endTime": "10:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:42 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:45 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:49 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:51 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:57 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:01 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:06 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:13 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:20 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:25 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:27 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "10:34 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:37 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "GOVERNORGIRI",
// //         "time": "10:50 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 16,
// //         "name": "VELLARAM",
// //         "time": "10:55 PM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-8-312",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-3",
// //     "tripCode": "55/P55C-355-CTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "VELLARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:30 AM",
// //     "endTime": "05:40 AM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "VELLARAM",
// //         "time": "04:30 AM",
// //         "id": 194
// //       },
// //       {
// //         "no": 15,
// //         "name": "GOVERNORGIRI",
// //         "time": "04:34 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "04:46 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "04:49 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "04:55 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:57 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:02 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "05:08 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "05:15 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "05:19 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:24 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:29 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:30 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:35 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:37 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-9-313",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-1",
// //     "tripCode": "55/P55C-155-CTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:20 AM",
// //     "endTime": "07:35 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       78,
// //       79,
// //       225,
// //       81,
// //       82,
// //       83,
// //       84,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:25 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:29 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "06:32 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "06:36 AM",
// //         "id": 79
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "06:41 AM",
// //         "id": 225
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "06:44 AM",
// //         "id": 81
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "06:51 AM",
// //         "id": 82
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "06:55 AM",
// //         "id": 83
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "07:03 AM",
// //         "id": 84
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:07 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:12 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "07:15 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "07:18 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "07:25 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "07:31 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "07:35 AM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-10-314",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-1",
// //     "tripCode": "55/P55C-155-CTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 AM",
// //     "endTime": "09:10 AM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       84,
// //       83,
// //       82,
// //       81,
// //       225,
// //       79,
// //       78,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "SAVARIMANGALAM",
// //         "time": "07:50 AM",
// //         "id": 199
// //       },
// //       {
// //         "no": 16,
// //         "name": "S.KAILASAPURAM",
// //         "time": "07:54 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.PUTHUR",
// //         "time": "08:00 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 14,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "08:07 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 13,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "08:10 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:13 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:19 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 10,
// //         "name": "SAMYNATTHAM",
// //         "time": "08:23 AM",
// //         "id": 84
// //       },
// //       {
// //         "no": 9,
// //         "name": "KAYALOORANI",
// //         "time": "08:31 AM",
// //         "id": 83
// //       },
// //       {
// //         "no": 8,
// //         "name": "VEERAPANDIAPURAM",
// //         "time": "08:36 AM",
// //         "id": 82
// //       },
// //       {
// //         "no": 7,
// //         "name": "RAILWAY GATE",
// //         "time": "08:43 AM",
// //         "id": 81
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "08:46 AM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR",
// //         "time": "08:52 AM",
// //         "id": 79
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "08:56 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:00 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:04 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-11-315",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-2",
// //     "tripCode": "55/P55C-255-CTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SANGAMPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:20 AM",
// //     "endTime": "10:40 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       109,
// //       105,
// //       85,
// //       106,
// //       208,
// //       209
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:22 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:24 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:28 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:29 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:34 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:38 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:43 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:48 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:54 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:58 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:01 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "10:07 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:09 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "TALUK OFFICE",
// //         "time": "10:10 AM",
// //         "id": 109
// //       },
// //       {
// //         "no": 16,
// //         "name": "AYYANAR KOVIL",
// //         "time": "10:12 AM",
// //         "id": 105
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "10:21 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "10:23 AM",
// //         "id": 106
// //       },
// //       {
// //         "no": 20,
// //         "name": "MURAMBAN",
// //         "time": "10:34 AM",
// //         "id": 208
// //       },
// //       {
// //         "no": 21,
// //         "name": "SANGAMPATTI",
// //         "time": "10:40 AM",
// //         "id": 209
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-C-12-316",
// //     "routeNo": "55-C",
// //     "code": "55/P55C-2",
// //     "tripCode": "55/P55C-255-CTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "SANGAMPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:45 AM",
// //     "endTime": "11:55 AM",
// //     "ids": [
// //       209,
// //       208,
// //       106,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "SANGAMPATTI",
// //         "time": "10:45 AM",
// //         "id": 209
// //       },
// //       {
// //         "no": 20,
// //         "name": "MURAMBAN",
// //         "time": "10:49 AM",
// //         "id": 208
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "10:59 AM",
// //         "id": 106
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "11:01 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 16,
// //         "name": "AYYANAR KOVIL",
// //         "time": "11:08 AM",
// //         "id": 105
// //       },
// //       {
// //         "no": 15,
// //         "name": "TALUK OFFICE",
// //         "time": "11:10 AM",
// //         "id": 109
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "11:11 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "11:13 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "11:19 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "11:20 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "11:24 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "11:29 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:34 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:38 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:42 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:46 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:47 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:51 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:52 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:55 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-1-317",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-1",
// //     "tripCode": "55/P55D-155-DTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 AM",
// //     "endTime": "08:05 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:51 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:53 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:55 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:56 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:59 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:02 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:05 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:09 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:13 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:16 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "07:32 AM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:49 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:53 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "07:54 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "08:02 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "08:05 AM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-2-318",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-1",
// //     "tripCode": "55/P55D-155-DTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 AM",
// //     "endTime": "09:25 AM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       193,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "08:10 AM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "08:12 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:20 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:21 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:25 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "08:42 AM",
// //         "id": 193
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:58 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:01 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:05 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:09 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:12 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:15 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:18 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:19 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:21 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:23 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-3-319",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-3",
// //     "tripCode": "55/P55D-355-DTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 AM",
// //     "endTime": "10:40 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:51 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:53 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:56 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:57 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:01 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:04 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:08 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:12 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:17 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:20 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:28 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:35 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "10:40 AM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-4-320",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-3",
// //     "tripCode": "55/P55D-355-DTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:55 AM",
// //     "endTime": "11:45 AM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "10:55 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:59 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "11:06 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "11:14 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "11:17 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "11:22 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:26 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:30 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:33 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:37 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:38 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:41 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:43 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-5-321",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-2",
// //     "tripCode": "55/P55D-255-DTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "AGILANDAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:50 AM",
// //     "endTime": "12:45 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       189,
// //       280,
// //       75,
// //       76,
// //       190
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:51 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:52 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:55 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:56 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:59 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "12:01 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "12:04 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "12:08 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:11 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:14 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGILANDAPURAM",
// //         "time": "12:25 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:35 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:39 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:40 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANCHALANKURICHI",
// //         "time": "12:45 PM",
// //         "id": 190
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-6-322",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-2",
// //     "tripCode": "55/P55D-255-DTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "AGILANDAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:50 PM",
// //     "endTime": "01:55 PM",
// //     "ids": [
// //       190,
// //       76,
// //       75,
// //       280,
// //       189,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PANCHALANKURICHI",
// //         "time": "12:50 PM",
// //         "id": 190
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:55 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:56 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "01:01 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGILANDAPURAM",
// //         "time": "01:13 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:25 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:29 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:33 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:37 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:41 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:43 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:47 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:48 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:51 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:53 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-7-323",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-3",
// //     "tripCode": "55/P55D-355-DTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:05 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:06 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:08 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:11 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:12 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:16 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "02:19 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "02:23 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "02:27 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:32 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:35 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "02:43 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "02:50 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "02:55 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-8-324",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-3",
// //     "tripCode": "55/P55D-355-DTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:10 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "03:10 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "03:14 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:21 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "03:29 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "03:32 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "03:37 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "03:41 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:45 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:48 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:52 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:53 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:56 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:58 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-9-325",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-1",
// //     "tripCode": "55/P55D-155-DTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:05 PM",
// //     "endTime": "05:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:06 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:08 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "04:10 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "04:11 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "04:14 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "04:17 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "04:20 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "04:24 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "04:28 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:31 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "04:47 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "05:04 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "05:08 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "05:09 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "05:17 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "05:20 PM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-10-326",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-1",
// //     "tripCode": "55/P55D-155-DTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:25 PM",
// //     "endTime": "06:50 PM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       193,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "05:25 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "05:28 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "05:36 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "05:38 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "05:43 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "06:01 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "06:20 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:23 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:28 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:32 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:35 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:38 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:42 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:43 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:46 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:48 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-11-327",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-2",
// //     "tripCode": "55/P55D-255-DTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "AGILANDAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:55 PM",
// //     "endTime": "07:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       189,
// //       280,
// //       75,
// //       76,
// //       190
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:56 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:58 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:00 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:01 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:05 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:07 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:10 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:14 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:18 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:21 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGILANDAPURAM",
// //         "time": "07:33 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:44 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:48 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "07:50 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "PANCHALANKURICHI",
// //         "time": "07:55 PM",
// //         "id": 190
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-12-328",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-2",
// //     "tripCode": "55/P55D-255-DTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "AGILANDAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 PM",
// //     "endTime": "09:00 PM",
// //     "ids": [
// //       190,
// //       76,
// //       75,
// //       280,
// //       189,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PANCHALANKURICHI",
// //         "time": "08:00 PM",
// //         "id": 190
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:04 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:06 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:10 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "AGILANDAPURAM",
// //         "time": "08:21 PM",
// //         "id": 189
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:33 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:36 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:40 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:44 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:47 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:49 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:53 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:54 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:56 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:58 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-13-329",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-3",
// //     "tripCode": "55/P55D-355-DTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 PM",
// //     "endTime": "10:00 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:11 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:13 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:16 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:17 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:21 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:24 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:28 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:32 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:37 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:40 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:48 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "09:55 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "10:00 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-D-14-330",
// //     "routeNo": "55-D",
// //     "code": "55/P55D-3",
// //     "tripCode": "55/P55D-355-DTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:05 PM",
// //     "endTime": "10:55 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "10:05 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:09 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:16 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:24 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:27 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:32 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:36 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:40 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:43 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "10:47 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "10:48 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "10:51 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:53 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-1-331",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:20 PM",
// //     "endTime": "03:30 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:21 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:22 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:25 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:26 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:29 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "02:31 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "02:34 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "02:38 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:41 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:44 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "03:00 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "03:15 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "03:18 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:20 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "03:27 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "03:30 PM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-2-332",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:35 PM",
// //     "endTime": "04:50 PM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       193,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "03:35 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "03:37 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:45 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "03:46 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "03:50 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "04:07 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:23 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "04:26 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "04:30 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "04:34 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "04:37 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "04:40 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "04:43 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "04:44 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:46 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:48 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-3-333",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:05 PM",
// //     "endTime": "06:15 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:06 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:07 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:10 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:11 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:14 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "05:16 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "05:19 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "05:23 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:26 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:29 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "05:45 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "06:00 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "06:03 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:05 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "06:12 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "06:15 PM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-4-334",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:20 PM",
// //     "endTime": "07:35 PM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       193,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "06:20 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "06:22 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:30 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "06:31 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "06:35 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "06:52 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:08 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:11 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:15 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:19 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:22 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:25 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:28 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:29 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:31 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:33 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-5-335",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-2",
// //     "tripCode": "55/P55E-255-ETORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "VELLARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 PM",
// //     "endTime": "09:10 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       194,
// //       280,
// //       75,
// //       76,
// //       195
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:51 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:53 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:56 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:57 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:01 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:04 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:07 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:11 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:16 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:19 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "VELLARAM",
// //         "time": "08:37 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:55 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:59 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:01 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "09:10 PM",
// //         "id": 195
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-6-336",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-2",
// //     "tripCode": "55/P55E-255-ETORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "VELLARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 AM",
// //     "endTime": "08:25 AM",
// //     "ids": [
// //       195,
// //       76,
// //       75,
// //       280,
// //       194,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "07:10 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "07:17 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:19 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:23 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "VELLARAM",
// //         "time": "07:40 AM",
// //         "id": 194
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:57 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:00 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:04 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:08 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:11 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:14 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:18 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:18 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:21 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:23 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-7-337",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:40 AM",
// //     "endTime": "09:50 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:41 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:42 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:45 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:46 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:49 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:51 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:54 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:58 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:01 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:04 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "09:20 AM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "09:35 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "09:38 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:40 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "09:47 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "09:50 AM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-8-338",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:55 AM",
// //     "endTime": "11:05 AM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       193,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "09:55 AM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "09:57 AM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:04 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "10:06 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:09 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "10:24 AM",
// //         "id": 193
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:40 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:43 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:46 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:50 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:53 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:55 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "10:58 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "10:59 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:02 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:03 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:05 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-9-339",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KACCHERI THALAVAIPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:10 AM",
// //     "endTime": "12:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       193,
// //       280,
// //       75,
// //       76,
// //       195,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:11 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:12 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:15 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:16 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:19 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:21 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:24 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "11:28 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "11:31 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "11:34 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "11:50 AM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:05 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:08 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:10 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "12:17 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "12:20 PM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-E-10-340",
// //     "routeNo": "55-E",
// //     "code": "55/P55E-1",
// //     "tripCode": "55/P55E-155-ETORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KACCHERI THALAVAIPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:25 PM",
// //     "endTime": "01:35 PM",
// //     "ids": [
// //       194,
// //       195,
// //       76,
// //       75,
// //       280,
// //       193,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "VELLARAM",
// //         "time": "12:25 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 16,
// //         "name": "GOVERNORGIRI",
// //         "time": "12:27 PM",
// //         "id": 195
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:34 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:36 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:39 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "12:54 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:10 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:13 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:16 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:20 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:23 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:25 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:28 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:29 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:32 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:33 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-1-341",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-1",
// //     "tripCode": "55/P55F-155-FTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CEYLON COLONY",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:20 PM",
// //     "endTime": "02:05 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       210
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:22 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:23 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:27 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:28 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:32 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:35 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:39 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:43 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:49 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:52 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "01:54 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "01:59 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "02:01 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "02:05 PM",
// //         "id": 210
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-2-342",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-1",
// //     "tripCode": "55/P55F-155-FTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "CEYLON COLONY",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:10 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       210,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "02:10 PM",
// //         "id": 210
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "02:13 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "02:15 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "02:20 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:22 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:25 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "02:31 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "02:35 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "02:39 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:42 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:46 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:47 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:51 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:52 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-3-343",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-3",
// //     "tripCode": "55/P55F-355-FTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA MUDIMAN",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:10 PM",
// //     "endTime": "04:15 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       210,
// //       211,
// //       212,
// //       213,
// //       216
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:12 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:14 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:18 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:19 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:24 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:27 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "03:31 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "03:37 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "03:42 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "03:46 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "03:48 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "03:54 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "03:57 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "04:01 PM",
// //         "id": 210
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "04:05 PM",
// //         "id": 211
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "04:09 PM",
// //         "id": 212
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA MUDIMAN",
// //         "time": "04:11 PM",
// //         "id": 213
// //       },
// //       {
// //         "no": 19,
// //         "name": "MELA MUDIMAN",
// //         "time": "04:15 PM",
// //         "id": 216
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-4-344",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-3",
// //     "tripCode": "55/P55F-355-FTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "MELA MUDIMAN",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:40 PM",
// //     "endTime": "05:45 PM",
// //     "ids": [
// //       216,
// //       213,
// //       212,
// //       211,
// //       210,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "MELA MUDIMAN",
// //         "time": "04:40 PM",
// //         "id": 216
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA MUDIMAN",
// //         "time": "04:43 PM",
// //         "id": 213
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "04:45 PM",
// //         "id": 212
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "04:49 PM",
// //         "id": 211
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "04:53 PM",
// //         "id": 210
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "04:57 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "05:00 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "05:06 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:08 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:12 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "05:17 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "05:23 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "05:27 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:30 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:35 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:36 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:40 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:42 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-5-345",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-1",
// //     "tripCode": "55/P55F-155-FTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CEYLON COLONY",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:50 PM",
// //     "endTime": "06:40 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       210
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:52 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:54 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:58 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:59 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:03 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:07 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:11 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:16 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:22 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "06:26 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "06:28 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "06:33 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:36 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "06:40 PM",
// //         "id": 210
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-6-346",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-1",
// //     "tripCode": "55/P55F-155-FTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "CEYLON COLONY",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:55 PM",
// //     "endTime": "07:45 PM",
// //     "ids": [
// //       210,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "06:55 PM",
// //         "id": 210
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:58 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "07:01 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:06 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:08 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:12 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:18 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:23 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:27 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:31 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:35 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:36 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:40 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:42 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-7-347",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-2",
// //     "tripCode": "55/P55F-255-FTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PASUVANTHANAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 PM",
// //     "endTime": "09:30 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       210,
// //       211,
// //       212,
// //       213,
// //       214,
// //       215
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:12 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:14 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:18 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:19 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:24 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:28 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:33 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:38 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:45 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:49 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:51 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "08:57 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:00 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "09:04 PM",
// //         "id": 210
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "09:09 PM",
// //         "id": 211
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "09:13 PM",
// //         "id": 212
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA MUDIMAN",
// //         "time": "09:15 PM",
// //         "id": 213
// //       },
// //       {
// //         "no": 19,
// //         "name": "POOLNAYAKKANOOR",
// //         "time": "09:20 PM",
// //         "id": 214
// //       },
// //       {
// //         "no": 20,
// //         "name": "PASUVANTHANAI",
// //         "time": "09:30 PM",
// //         "id": 215
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-8-348",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-2",
// //     "tripCode": "55/P55F-255-FTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PASUVANTHANAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:45 PM",
// //     "endTime": "10:05 PM",
// //     "ids": [
// //       215,
// //       214,
// //       213,
// //       212,
// //       211,
// //       210,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "PASUVANTHANAI",
// //         "time": "09:45 PM",
// //         "id": 215
// //       },
// //       {
// //         "no": 19,
// //         "name": "POOLNAYAKKANOOR",
// //         "time": "09:47 PM",
// //         "id": 214
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA MUDIMAN",
// //         "time": "09:48 PM",
// //         "id": 213
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "09:49 PM",
// //         "id": 212
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "09:50 PM",
// //         "id": 211
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "09:51 PM",
// //         "id": 210
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:52 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "09:53 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "09:54 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:55 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:56 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:57 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:59 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:00 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:01 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "10:02 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "10:02 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "10:03 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:04 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-9-349",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-3",
// //     "tripCode": "55/P55F-355-FTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA MUDIMAN",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:25 AM",
// //     "endTime": "05:35 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       210,
// //       211,
// //       212,
// //       213,
// //       216
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:25 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:27 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:29 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "04:33 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "04:35 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "04:40 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "04:43 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "04:48 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "04:54 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:00 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:04 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "05:06 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "05:13 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "05:15 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "05:20 AM",
// //         "id": 210
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "05:24 AM",
// //         "id": 211
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "05:29 AM",
// //         "id": 212
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA MUDIMAN",
// //         "time": "05:31 AM",
// //         "id": 213
// //       },
// //       {
// //         "no": 19,
// //         "name": "MELA MUDIMAN",
// //         "time": "05:35 AM",
// //         "id": 216
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-10-350",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-3",
// //     "tripCode": "55/P55F-355-FTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "MELA MUDIMAN",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:05 AM",
// //     "endTime": "06:40 AM",
// //     "ids": [
// //       216,
// //       213,
// //       212,
// //       211,
// //       210,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "MELA MUDIMAN",
// //         "time": "05:05 AM",
// //         "id": 216
// //       },
// //       {
// //         "no": 18,
// //         "name": "KEELA MUDIMAN",
// //         "time": "05:10 AM",
// //         "id": 213
// //       },
// //       {
// //         "no": 17,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "05:12 AM",
// //         "id": 212
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "05:18 AM",
// //         "id": 211
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "05:25 AM",
// //         "id": 210
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "05:31 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "05:34 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "05:43 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:46 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:51 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:00 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:08 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:14 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:19 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:26 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:28 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:33 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:36 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-11-351",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-4",
// //     "tripCode": "55/P55F-455-FTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ATTHIMARAPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 AM",
// //     "endTime": "07:15 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       176,
// //       177
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:50 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:54 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:00 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:09 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "07:09 AM",
// //         "id": 176
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "07:15 AM",
// //         "id": 177
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-12-352",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-4",
// //     "tripCode": "55/P55F-455-FTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ATTHIMARAPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 AM",
// //     "endTime": "08:10 AM",
// //     "ids": [
// //       177,
// //       176,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "07:20 AM",
// //         "id": 177
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "07:31 AM",
// //         "id": 176
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:31 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:49 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:01 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:08 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-13-353",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-1",
// //     "tripCode": "55/P55F-155-FTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CEYLON COLONY",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76,
// //       210
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:17 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:19 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:23 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:24 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:28 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:32 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:36 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:41 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:47 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:51 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:53 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "08:58 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:01 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "09:05 AM",
// //         "id": 210
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-F-14-354",
// //     "routeNo": "55-F",
// //     "code": "55/P55F-1",
// //     "tripCode": "55/P55F-155-FTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "CEYLON COLONY",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:20 AM",
// //     "endTime": "12:10 PM",
// //     "ids": [
// //       210,
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "CEYLON COLONY",
// //         "time": "09:20 AM",
// //         "id": 210
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "09:33 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "09:41 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "10:00 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:07 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:20 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:39 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:57 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:11 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:23 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:38 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:42 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:55 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "12:02 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-1-355",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-3",
// //     "tripCode": "55/P55G-355-GTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:15 PM",
// //     "endTime": "02:15 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:17 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:19 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:24 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:25 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:30 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:34 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:39 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:45 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:51 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:55 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "01:58 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 13,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "02:00 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 14,
// //         "name": "S.PUTHUR",
// //         "time": "02:06 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.KAILASAPURAM",
// //         "time": "02:11 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 16,
// //         "name": "SAVARIMANGALAM",
// //         "time": "02:15 PM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-2-356",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-3",
// //     "tripCode": "55/P55G-355-GTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:20 PM",
// //     "endTime": "03:20 PM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SAVARIMANGALAM",
// //         "time": "02:20 PM",
// //         "id": 199
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.KAILASAPURAM",
// //         "time": "02:23 PM",
// //         "id": 198
// //       },
// //       {
// //         "no": 14,
// //         "name": "S.PUTHUR",
// //         "time": "02:28 PM",
// //         "id": 296
// //       },
// //       {
// //         "no": 13,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "02:34 PM",
// //         "id": 197
// //       },
// //       {
// //         "no": 12,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "02:36 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:39 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:43 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "02:49 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "02:55 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:00 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:04 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:09 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:10 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:15 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:17 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:20 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-3-357",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-1",
// //     "tripCode": "55/P55G-155-GTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KANTHASAMYPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:35 PM",
// //     "endTime": "04:55 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       218,
// //       280,
// //       75,
// //       76,
// //       109,
// //       105,
// //       85,
// //       86,
// //       217
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:36 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:38 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:41 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:42 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:45 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "03:48 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "03:51 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "03:55 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "04:00 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:03 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "04:19 PM",
// //         "id": 218
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "04:34 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "04:38 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "04:40 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "04:41 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "04:42 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "04:49 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "04:53 PM",
// //         "id": 86
// //       },
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "04:55 PM",
// //         "id": 217
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-4-358",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-1",
// //     "tripCode": "55/P55G-155-GTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KANTHASAMYPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 PM",
// //     "endTime": "06:15 PM",
// //     "ids": [
// //       217,
// //       86,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       218,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "05:00 PM",
// //         "id": 217
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "05:01 PM",
// //         "id": 86
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "05:05 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "05:11 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "05:12 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "05:13 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "05:15 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "05:19 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "05:33 PM",
// //         "id": 218
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:48 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:51 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "05:55 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "05:59 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:02 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:04 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:08 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:09 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:11 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:13 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-5-359",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-1",
// //     "tripCode": "55/P55G-155-GTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KANTHASAMYPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 PM",
// //     "endTime": "07:40 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       218,
// //       280,
// //       75,
// //       76,
// //       109,
// //       105,
// //       85,
// //       86,
// //       217
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "06:31 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "06:32 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "06:35 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "06:36 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "06:39 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "06:41 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:44 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:48 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:52 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "06:54 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "07:08 PM",
// //         "id": 218
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:21 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:25 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "07:27 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "07:27 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "07:29 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "07:34 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "07:38 PM",
// //         "id": 86
// //       },
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "07:40 PM",
// //         "id": 217
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-6-360",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-1",
// //     "tripCode": "55/P55G-155-GTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KANTHASAMYPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 PM",
// //     "endTime": "09:15 PM",
// //     "ids": [
// //       217,
// //       86,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       218,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "07:50 PM",
// //         "id": 217
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "07:51 PM",
// //         "id": 86
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "07:56 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "08:02 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "08:04 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:05 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:07 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:12 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "08:27 PM",
// //         "id": 218
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:44 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:48 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:52 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:57 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:00 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:03 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:07 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:08 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:11 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:13 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-7-361",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-2",
// //     "tripCode": "55/P55G-255-GTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PANDIAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 AM",
// //     "endTime": "06:25 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       87,
// //       280,
// //       75,
// //       76,
// //       109,
// //       105,
// //       85,
// //       86,
// //       217,
// //       218
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:00 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:01 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:03 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:06 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:06 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:10 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "05:13 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "05:16 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "05:20 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "05:24 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:27 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "PANDIAPURAM",
// //         "time": "05:45 AM",
// //         "id": 87
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "06:02 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "06:07 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:08 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "06:09 AM",
// //         "id": 109
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "06:11 AM",
// //         "id": 105
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "06:17 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "06:21 AM",
// //         "id": 86
// //       },
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "06:22 AM",
// //         "id": 217
// //       },
// //       {
// //         "no": 21,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "06:25 AM",
// //         "id": 218
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-8-362",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-2",
// //     "tripCode": "55/P55G-255-GTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PANDIAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:40 AM",
// //     "endTime": "07:55 AM",
// //     "ids": [
// //       218,
// //       217,
// //       86,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       87,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "06:40 AM",
// //         "id": 218
// //       },
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "06:42 AM",
// //         "id": 217
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "06:43 AM",
// //         "id": 86
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "06:47 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "06:52 AM",
// //         "id": 105
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "06:53 AM",
// //         "id": 109
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "06:54 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "06:55 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "06:59 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "PANDIAPURAM",
// //         "time": "07:14 AM",
// //         "id": 87
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:30 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:33 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:37 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:40 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:43 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:45 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:48 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:49 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:52 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:53 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:55 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-9-363",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-3",
// //     "tripCode": "55/P55G-355-GTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SAVARIMANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 AM",
// //     "endTime": "09:10 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       196,
// //       197,
// //       296,
// //       198,
// //       199
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:12 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:14 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:19 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:20 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "08:25 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:29 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:34 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:40 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:46 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:50 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "08:53 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 13,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "08:55 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 14,
// //         "name": "S.PUTHUR",
// //         "time": "09:01 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.KAILASAPURAM",
// //         "time": "09:06 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 16,
// //         "name": "SAVARIMANGALAM",
// //         "time": "09:10 AM",
// //         "id": 199
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-10-364",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-3",
// //     "tripCode": "55/P55G-355-GTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "SAVARIMANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 AM",
// //     "endTime": "10:15 AM",
// //     "ids": [
// //       199,
// //       198,
// //       296,
// //       197,
// //       196,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SAVARIMANGALAM",
// //         "time": "09:15 AM",
// //         "id": 199
// //       },
// //       {
// //         "no": 15,
// //         "name": "S.KAILASAPURAM",
// //         "time": "09:18 AM",
// //         "id": 198
// //       },
// //       {
// //         "no": 14,
// //         "name": "S.PUTHUR",
// //         "time": "09:23 AM",
// //         "id": 296
// //       },
// //       {
// //         "no": 13,
// //         "name": "JAMBULINGAPURAM",
// //         "time": "09:29 AM",
// //         "id": 197
// //       },
// //       {
// //         "no": 12,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "09:31 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:34 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:38 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:44 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:50 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:55 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:59 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "10:04 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "10:05 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "10:10 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:12 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:15 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-11-365",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-1",
// //     "tripCode": "55/P55G-155-GTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KANTHASAMYPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 AM",
// //     "endTime": "11:50 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       218,
// //       280,
// //       75,
// //       76,
// //       109,
// //       105,
// //       85,
// //       86,
// //       217
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "10:31 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "10:33 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "10:36 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "10:37 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:40 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:43 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "10:46 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "10:50 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "10:55 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:58 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "11:14 AM",
// //         "id": 218
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "11:29 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "11:33 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "11:35 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "11:36 AM",
// //         "id": 109
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "11:37 AM",
// //         "id": 105
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "11:44 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "11:48 AM",
// //         "id": 86
// //       },
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "11:50 AM",
// //         "id": 217
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-G-12-366",
// //     "routeNo": "55-G",
// //     "code": "55/P55G-1",
// //     "tripCode": "55/P55G-155-GTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KANTHASAMYPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:55 AM",
// //     "endTime": "01:10 PM",
// //     "ids": [
// //       217,
// //       86,
// //       85,
// //       105,
// //       109,
// //       76,
// //       75,
// //       280,
// //       218,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "THALAVAIPURAM 1",
// //         "time": "11:55 AM",
// //         "id": 217
// //       },
// //       {
// //         "no": 19,
// //         "name": "KOMBADI",
// //         "time": "11:56 AM",
// //         "id": 86
// //       },
// //       {
// //         "no": 18,
// //         "name": "OSANOOTTHU",
// //         "time": "12:00 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 17,
// //         "name": "AYYANAR KOVIL",
// //         "time": "12:06 PM",
// //         "id": 105
// //       },
// //       {
// //         "no": 16,
// //         "name": "TALUK OFFICE",
// //         "time": "12:07 PM",
// //         "id": 109
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:08 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "12:10 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:14 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "KANTHASAMYPURAM",
// //         "time": "12:28 PM",
// //         "id": 218
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:43 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:46 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "12:50 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "12:54 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "12:57 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "12:59 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:03 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:04 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:06 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:08 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-1-367",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-1",
// //     "tripCode": "55/P55H-155-HTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:15 PM",
// //     "endTime": "02:05 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "01:16 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "01:18 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:21 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:22 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:26 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:29 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:33 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:37 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:42 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:45 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "01:53 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "02:00 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "02:05 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-2-368",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-1",
// //     "tripCode": "55/P55H-155-HTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:15 PM",
// //     "endTime": "03:05 PM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "02:15 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "02:19 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "02:26 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:34 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "02:37 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "02:42 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "02:46 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "02:50 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "02:53 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "02:57 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "02:58 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:01 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:03 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-3-369",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-2",
// //     "tripCode": "55/P55H-255-HTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "APC COLLEGE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:20 PM",
// //     "endTime": "03:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       219
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:20 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:20 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "APC COLLEGE",
// //         "time": "03:20 PM",
// //         "id": 219
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-4-370",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-2",
// //     "tripCode": "55/P55H-255-HTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "APC COLLEGE",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:30 PM",
// //     "endTime": "03:45 PM",
// //     "ids": [
// //       219,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 4,
// //         "name": "APC COLLEGE",
// //         "time": "03:30 PM",
// //         "id": 219
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:35 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:39 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-5-371",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-3",
// //     "tripCode": "55/P55H-355-HTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "THOOTHUKUDI NEW B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:50 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       1,
// //       26,
// //       77
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:56 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI NEW B/S",
// //         "time": "04:00 PM",
// //         "id": 77
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-6-372",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-3",
// //     "tripCode": "55/P55H-355-HTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "THOOTHUKUDI NEW B/S",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:05 PM",
// //     "endTime": "04:25 PM",
// //     "ids": [
// //       77,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI NEW B/S",
// //         "time": "04:05 PM",
// //         "id": 77
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:11 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-7-373",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-4",
// //     "tripCode": "55/P55H-455-HTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "VELLAPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:30 PM",
// //     "endTime": "05:05 PM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       187
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "04:30 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "04:35 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:39 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "04:47 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "04:51 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "04:53 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "04:59 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "VELLAPATTI",
// //         "time": "05:05 PM",
// //         "id": 187
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-8-374",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-4",
// //     "tripCode": "55/P55H-455-HTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "VELLAPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:10 PM",
// //     "endTime": "05:35 PM",
// //     "ids": [
// //       187,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 8,
// //         "name": "VELLAPATTI",
// //         "time": "05:10 PM",
// //         "id": 187
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "05:13 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "05:18 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "05:19 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "05:22 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:28 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "05:31 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "05:35 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-9-375",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-7",
// //     "tripCode": "55/P55H-755-HTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SIPCOT",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 PM",
// //     "endTime": "06:15 PM",
// //     "ids": [
// //       1,
// //       26,
// //       220,
// //       221,
// //       222,
// //       223,
// //       224,
// //       225
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:48 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "CHINNAKANNUPURAM",
// //         "time": "05:51 PM",
// //         "id": 220
// //       },
// //       {
// //         "no": 4,
// //         "name": "SILVERPURAM",
// //         "time": "05:54 PM",
// //         "id": 221
// //       },
// //       {
// //         "no": 5,
// //         "name": "PANDARAMPATTI",
// //         "time": "06:00 PM",
// //         "id": 222
// //       },
// //       {
// //         "no": 6,
// //         "name": "MEELAVITTAN",
// //         "time": "06:04 PM",
// //         "id": 223
// //       },
// //       {
// //         "no": 7,
// //         "name": "STERLITE",
// //         "time": "06:10 PM",
// //         "id": 224
// //       },
// //       {
// //         "no": 8,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "06:15 PM",
// //         "id": 225
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-10-376",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-8",
// //     "tripCode": "55/P55H-855-HTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "SIPCOT",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:30 PM",
// //     "endTime": "07:05 PM",
// //     "ids": [
// //       225,
// //       226,
// //       78,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "06:30 PM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR JUNCTION",
// //         "time": "06:38 PM",
// //         "id": 226
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "06:44 PM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:50 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:56 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-11-377",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-1",
// //     "tripCode": "55/P55H-155-HTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 PM",
// //     "endTime": "08:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       76,
// //       280,
// //       75
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:17 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:19 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:23 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:25 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:30 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:33 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:38 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:44 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:50 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:54 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:04 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:13 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:20 PM",
// //         "id": 75
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-12-378",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-1",
// //     "tripCode": "55/P55H-155-HTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:30 PM",
// //     "endTime": "05:00 AM",
// //     "ids": [
// //       75,
// //       280,
// //       76,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:30 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "09:19 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "OTTAPIDARAM",
// //         "time": "10:27 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "11:47 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:21 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:10 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:55 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "02:30 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "03:01 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "03:40 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "03:50 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:23 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:39 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-13-379",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-6",
// //     "tripCode": "55/P55H-655-HTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "AUTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:10 AM",
// //     "endTime": "05:45 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:10 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:12 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "05:16 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "05:21 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "05:22 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "05:24 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "05:29 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "05:31 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "05:35 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "05:39 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "05:42 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "05:45 AM",
// //         "id": 172
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-14-380",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-6",
// //     "tripCode": "55/P55H-655-HTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "AUTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:00 AM",
// //     "endTime": "06:40 AM",
// //     "ids": [
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "06:00 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "06:02 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "06:06 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "06:11 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "06:15 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "06:17 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:23 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:26 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:26 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:33 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:36 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:39 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-15-381",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-5",
// //     "tripCode": "55/P55H-555-HTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA MUDIMAN",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 AM",
// //     "endTime": "08:10 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       216,
// //       280,
// //       75,
// //       76,
// //       210,
// //       211,
// //       212,
// //       213
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:01 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:02 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:05 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:06 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:09 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:11 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "07:14 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "07:17 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "07:21 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:24 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MUDIMAN",
// //         "time": "07:40 AM",
// //         "id": 216
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "07:55 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "07:58 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:00 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 16,
// //         "name": "CEYLON COLONY",
// //         "time": "08:03 AM",
// //         "id": 210
// //       },
// //       {
// //         "no": 17,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "08:06 AM",
// //         "id": 211
// //       },
// //       {
// //         "no": 18,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "08:08 AM",
// //         "id": 212
// //       },
// //       {
// //         "no": 19,
// //         "name": "KEELA MUDIMAN",
// //         "time": "08:10 AM",
// //         "id": 213
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-16-382",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-5",
// //     "tripCode": "55/P55H-555-HTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "MELA MUDIMAN",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "09:35 AM",
// //     "ids": [
// //       213,
// //       212,
// //       211,
// //       210,
// //       76,
// //       75,
// //       280,
// //       216,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "KEELA MUDIMAN",
// //         "time": "08:15 AM",
// //         "id": 213
// //       },
// //       {
// //         "no": 18,
// //         "name": "VENKETESHVARAPURAM JUNCTION",
// //         "time": "08:16 AM",
// //         "id": 212
// //       },
// //       {
// //         "no": 17,
// //         "name": "PUTRU MURUGAN KOVIL",
// //         "time": "08:19 AM",
// //         "id": 211
// //       },
// //       {
// //         "no": 16,
// //         "name": "CEYLON COLONY",
// //         "time": "08:22 AM",
// //         "id": 210
// //       },
// //       {
// //         "no": 15,
// //         "name": "OTTAPIDARAM",
// //         "time": "08:25 AM",
// //         "id": 76
// //       },
// //       {
// //         "no": 14,
// //         "name": "MUPPULIPATI",
// //         "time": "08:27 AM",
// //         "id": 75
// //       },
// //       {
// //         "no": 13,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "08:32 AM",
// //         "id": 280
// //       },
// //       {
// //         "no": 12,
// //         "name": "MELA MUDIMAN",
// //         "time": "08:48 AM",
// //         "id": 216
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "09:07 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "09:10 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "09:14 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "09:18 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "09:21 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:24 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:27 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:28 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:31 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:33 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-17-383",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-9",
// //     "tripCode": "55/P55H-955-HTORD18U17",
// //     "order": 17,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "THOOTHUKUDI COLLECTORATE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 AM",
// //     "endTime": "09:55 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       227
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:45 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:49 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "THOOTHUKUDI COLLECTORATE",
// //         "time": "09:55 AM",
// //         "id": 227
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-18-384",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-9",
// //     "tripCode": "55/P55H-955-HTORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "THOOTHUKUDI COLLECTORATE",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:05 AM",
// //     "endTime": "10:25 AM",
// //     "ids": [
// //       227,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 4,
// //         "name": "THOOTHUKUDI COLLECTORATE",
// //         "time": "10:05 AM",
// //         "id": 227
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:12 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:17 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-19-385",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-10",
// //     "tripCode": "55/P55H-1055-HTORD18U19",
// //     "order": 19,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MULLAKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:35 AM",
// //     "endTime": "11:20 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       180,
// //       182,
// //       183,
// //       184,
// //       45,
// //       46
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:40 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "10:44 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:50 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:54 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:56 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP JUNCTION",
// //         "time": "10:56 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "11:01 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "11:03 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 10,
// //         "name": "BULK",
// //         "time": "11:14 AM",
// //         "id": 184
// //       },
// //       {
// //         "no": 11,
// //         "name": "SPIC NAGAR",
// //         "time": "11:16 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 12,
// //         "name": "MULLAKADU",
// //         "time": "11:20 AM",
// //         "id": 46
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-H-20-386",
// //     "routeNo": "55-H",
// //     "code": "55/P55H-10",
// //     "tripCode": "55/P55H-1055-HTORD18D20",
// //     "order": 20,
// //     "direction": "D",
// //     "from": "MULLAKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:25 AM",
// //     "endTime": "01:00 PM",
// //     "ids": [
// //       46,
// //       45,
// //       184,
// //       183,
// //       182,
// //       180,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 12,
// //         "name": "MULLAKADU",
// //         "time": "11:25 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 11,
// //         "name": "SPIC NAGAR",
// //         "time": "11:33 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 10,
// //         "name": "BULK",
// //         "time": "11:36 AM",
// //         "id": 184
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "12:00 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "12:04 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP JUNCTION",
// //         "time": "12:14 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "12:14 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "12:19 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "12:27 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "12:40 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "12:49 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-1-387",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-3",
// //     "tripCode": "55/P55I-355-ITORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "OTTAPIDARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:40 AM",
// //     "endTime": "12:20 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       280,
// //       75,
// //       76
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:42 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "11:43 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "11:46 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "11:47 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "11:51 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "11:54 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:58 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "12:03 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:07 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:11 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:13 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "12:17 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:20 PM",
// //         "id": 76
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-2-388",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-3",
// //     "tripCode": "55/P55I-355-ITORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "OTTAPIDARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:25 PM",
// //     "endTime": "02:10 PM",
// //     "ids": [
// //       76,
// //       75,
// //       280,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "OTTAPIDARAM",
// //         "time": "12:25 PM",
// //         "id": 76
// //       },
// //       {
// //         "no": 13,
// //         "name": "MUPPULIPATI",
// //         "time": "12:30 PM",
// //         "id": 75
// //       },
// //       {
// //         "no": 12,
// //         "name": "ST. ANN'S HOSPITAL",
// //         "time": "12:43 PM",
// //         "id": 280
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "12:47 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "12:56 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "01:09 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "01:21 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "01:30 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "01:38 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "01:49 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "01:51 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:00 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:04 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-3-389",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-2",
// //     "tripCode": "55/P55I-255-ITORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NORTH SILUKKANPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:15 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       297,
// //       235,
// //       298,
// //       237,
// //       238
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:20 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:24 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:33 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "02:38 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "02:44 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "02:51 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "02:53 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "02:55 PM",
// //         "id": 238
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-4-390",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-2",
// //     "tripCode": "55/P55I-255-ITORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "NORTH SILUKKANPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "03:45 PM",
// //     "ids": [
// //       238,
// //       237,
// //       298,
// //       235,
// //       297,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "03:00 PM",
// //         "id": 238
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "03:02 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "03:03 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "03:12 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "03:18 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:24 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:34 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:38 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-5-391",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-1",
// //     "tripCode": "55/P55I-155-ITORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA MANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:10 PM",
// //     "endTime": "05:40 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       228,
// //       229,
// //       230,
// //       231,
// //       232,
// //       85,
// //       106,
// //       110,
// //       108,
// //       233,
// //       234
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "04:13 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "04:15 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "04:20 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "04:22 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "04:28 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "04:33 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "04:39 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "04:46 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "04:54 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:59 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUPACCHERI COLONY",
// //         "time": "05:07 PM",
// //         "id": 228
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUPACCHERI",
// //         "time": "05:09 PM",
// //         "id": 229
// //       },
// //       {
// //         "no": 14,
// //         "name": "SIVALKULAM",
// //         "time": "05:11 PM",
// //         "id": 230
// //       },
// //       {
// //         "no": 15,
// //         "name": "PACCHAIPERUMALPURAM",
// //         "time": "05:14 PM",
// //         "id": 231
// //       },
// //       {
// //         "no": 16,
// //         "name": "SANKARARAJAPURAM",
// //         "time": "05:15 PM",
// //         "id": 232
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "05:18 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "05:21 PM",
// //         "id": 106
// //       },
// //       {
// //         "no": 19,
// //         "name": "THERKKU ARAIKULAM",
// //         "time": "05:27 PM",
// //         "id": 110
// //       },
// //       {
// //         "no": 20,
// //         "name": "NORTH AARAIKULAM",
// //         "time": "05:30 PM",
// //         "id": 108
// //       },
// //       {
// //         "no": 21,
// //         "name": "KUPPANAPURAM",
// //         "time": "05:33 PM",
// //         "id": 233
// //       },
// //       {
// //         "no": 22,
// //         "name": "KEELA MANGALM",
// //         "time": "05:40 PM",
// //         "id": 234
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-6-392",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-1",
// //     "tripCode": "55/P55I-155-ITORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KEELA MANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:55 PM",
// //     "endTime": "07:25 PM",
// //     "ids": [
// //       234,
// //       233,
// //       108,
// //       110,
// //       106,
// //       85,
// //       232,
// //       231,
// //       230,
// //       229,
// //       228,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 22,
// //         "name": "KEELA MANGALM",
// //         "time": "05:55 PM",
// //         "id": 234
// //       },
// //       {
// //         "no": 21,
// //         "name": "KUPPANAPURAM",
// //         "time": "06:01 PM",
// //         "id": 233
// //       },
// //       {
// //         "no": 20,
// //         "name": "NORTH AARAIKULAM",
// //         "time": "06:04 PM",
// //         "id": 108
// //       },
// //       {
// //         "no": 19,
// //         "name": "THERKKU ARAIKULAM",
// //         "time": "06:07 PM",
// //         "id": 110
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "06:13 PM",
// //         "id": 106
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "06:16 PM",
// //         "id": 85
// //       },
// //       {
// //         "no": 16,
// //         "name": "SANKARARAJAPURAM",
// //         "time": "06:19 PM",
// //         "id": 232
// //       },
// //       {
// //         "no": 15,
// //         "name": "PACCHAIPERUMALPURAM",
// //         "time": "06:20 PM",
// //         "id": 231
// //       },
// //       {
// //         "no": 14,
// //         "name": "SIVALKULAM",
// //         "time": "06:23 PM",
// //         "id": 230
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUPACCHERI",
// //         "time": "06:25 PM",
// //         "id": 229
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUPACCHERI COLONY",
// //         "time": "06:27 PM",
// //         "id": 228
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "06:35 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "06:40 PM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "06:48 PM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "06:55 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "07:01 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:06 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "07:12 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "07:14 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "07:19 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:21 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-7-393",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-1",
// //     "tripCode": "55/P55I-155-ITORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KEELA MANGALAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:40 PM",
// //     "endTime": "07:40 AM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       70,
// //       71,
// //       72,
// //       73,
// //       74,
// //       228,
// //       229,
// //       230,
// //       231,
// //       232,
// //       85,
// //       106,
// //       110,
// //       108,
// //       233,
// //       234
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:05 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:25 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:07 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:20 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "10:10 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "10:48 PM",
// //         "id": 70
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "11:34 PM",
// //         "id": 71
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "12:31 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "01:32 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "02:15 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUPACCHERI COLONY",
// //         "time": "03:22 AM",
// //         "id": 228
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUPACCHERI",
// //         "time": "03:39 AM",
// //         "id": 229
// //       },
// //       {
// //         "no": 14,
// //         "name": "SIVALKULAM",
// //         "time": "03:53 AM",
// //         "id": 230
// //       },
// //       {
// //         "no": 15,
// //         "name": "PACCHAIPERUMALPURAM",
// //         "time": "04:12 AM",
// //         "id": 231
// //       },
// //       {
// //         "no": 16,
// //         "name": "SANKARARAJAPURAM",
// //         "time": "04:27 AM",
// //         "id": 232
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "04:50 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "05:11 AM",
// //         "id": 106
// //       },
// //       {
// //         "no": 19,
// //         "name": "THERKKU ARAIKULAM",
// //         "time": "05:59 AM",
// //         "id": 110
// //       },
// //       {
// //         "no": 20,
// //         "name": "NORTH AARAIKULAM",
// //         "time": "06:20 AM",
// //         "id": 108
// //       },
// //       {
// //         "no": 21,
// //         "name": "KUPPANAPURAM",
// //         "time": "06:45 AM",
// //         "id": 233
// //       },
// //       {
// //         "no": 22,
// //         "name": "KEELA MANGALM",
// //         "time": "07:40 AM",
// //         "id": 234
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-8-394",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-1",
// //     "tripCode": "55/P55I-155-ITORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "KEELA MANGALAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:55 AM",
// //     "endTime": "09:20 AM",
// //     "ids": [
// //       234,
// //       233,
// //       108,
// //       110,
// //       106,
// //       85,
// //       232,
// //       231,
// //       230,
// //       229,
// //       228,
// //       74,
// //       73,
// //       72,
// //       71,
// //       70,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 22,
// //         "name": "KEELA MANGALM",
// //         "time": "07:55 AM",
// //         "id": 234
// //       },
// //       {
// //         "no": 21,
// //         "name": "KUPPANAPURAM",
// //         "time": "08:01 AM",
// //         "id": 233
// //       },
// //       {
// //         "no": 20,
// //         "name": "NORTH AARAIKULAM",
// //         "time": "08:04 AM",
// //         "id": 108
// //       },
// //       {
// //         "no": 19,
// //         "name": "THERKKU ARAIKULAM",
// //         "time": "08:06 AM",
// //         "id": 110
// //       },
// //       {
// //         "no": 18,
// //         "name": "KULASEKARANALLOOR",
// //         "time": "08:12 AM",
// //         "id": 106
// //       },
// //       {
// //         "no": 17,
// //         "name": "OSANOOTTHU",
// //         "time": "08:15 AM",
// //         "id": 85
// //       },
// //       {
// //         "no": 16,
// //         "name": "SANKARARAJAPURAM",
// //         "time": "08:17 AM",
// //         "id": 232
// //       },
// //       {
// //         "no": 15,
// //         "name": "PACCHAIPERUMALPURAM",
// //         "time": "08:19 AM",
// //         "id": 231
// //       },
// //       {
// //         "no": 14,
// //         "name": "SIVALKULAM",
// //         "time": "08:21 AM",
// //         "id": 230
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUPACCHERI",
// //         "time": "08:23 AM",
// //         "id": 229
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUPACCHERI COLONY",
// //         "time": "08:25 AM",
// //         "id": 228
// //       },
// //       {
// //         "no": 11,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:33 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAJAVIN KOVIL",
// //         "time": "08:38 AM",
// //         "id": 73
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILLANATTHAM",
// //         "time": "08:45 AM",
// //         "id": 72
// //       },
// //       {
// //         "no": 8,
// //         "name": "NAINAR PURAM",
// //         "time": "08:52 AM",
// //         "id": 71
// //       },
// //       {
// //         "no": 7,
// //         "name": "VELAYUTHAPURAM",
// //         "time": "08:57 AM",
// //         "id": 70
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "09:02 AM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "09:08 AM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "09:09 AM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "09:14 AM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "09:16 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-9-395",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-4",
// //     "tripCode": "55/P55I-455-ITORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "THALAIVANVADALI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:25 AM",
// //     "endTime": "10:55 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       127,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       129,
// //       130,
// //       239
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:25 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:30 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:37 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:49 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:50 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:55 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "10:04 AM",
// //         "id": 127
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "10:10 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "10:19 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "10:28 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "10:35 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "10:39 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "10:42 AM",
// //         "id": 129
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "10:49 AM",
// //         "id": 130
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAIVANVADALI",
// //         "time": "10:55 AM",
// //         "id": 239
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-I-10-396",
// //     "routeNo": "55-I",
// //     "code": "55/P55I-4",
// //     "tripCode": "55/P55I-455-ITORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "THALAIVANVADALI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:30 AM",
// //     "endTime": "11:35 AM",
// //     "ids": [
// //       239,
// //       130,
// //       129,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       127,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "THALAIVANVADALI",
// //         "time": "11:30 AM",
// //         "id": 239
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "11:30 AM",
// //         "id": 130
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "11:30 AM",
// //         "id": 129
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "11:30 AM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "11:31 AM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "11:31 AM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "11:31 AM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "11:32 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "11:32 AM",
// //         "id": 127
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "11:33 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "11:33 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "11:33 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "11:34 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "11:34 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "11:34 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:35 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-1-397",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-1",
// //     "tripCode": "55/P55J-155-JTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "THOOTHUKUDI RAILWAY STATION",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 AM",
// //     "endTime": "05:40 AM",
// //     "ids": [
// //       1,
// //       240
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "THOOTHUKUDI RAILWAY STATION",
// //         "time": "05:40 AM",
// //         "id": 240
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-2-398",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-1",
// //     "tripCode": "55/P55J-155-JTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "THOOTHUKUDI RAILWAY STATION",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 AM",
// //     "endTime": "05:50 AM",
// //     "ids": [
// //       240,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 2,
// //         "name": "THOOTHUKUDI RAILWAY STATION",
// //         "time": "05:45 AM",
// //         "id": 240
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-3-399",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-2",
// //     "tripCode": "55/P55J-255-JTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MULLAKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:55 AM",
// //     "endTime": "06:10 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:55 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:55 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "05:57 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:01 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:06 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:07 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:10 AM",
// //         "id": 46
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-4-400",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-2",
// //     "tripCode": "55/P55J-255-JTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "MULLAKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 AM",
// //     "endTime": "06:30 AM",
// //     "ids": [
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "06:15 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:17 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:18 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:23 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:27 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:29 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-5-401",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-3",
// //     "tripCode": "55/P55J-355-JTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "POTTALKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:35 AM",
// //     "endTime": "07:10 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       163
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:35 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:40 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:47 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:58 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:59 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:04 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "07:10 AM",
// //         "id": 163
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-6-402",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-3",
// //     "tripCode": "55/P55J-355-JTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "POTTALKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 AM",
// //     "endTime": "08:10 AM",
// //     "ids": [
// //       163,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 8,
// //         "name": "POTTALKADU",
// //         "time": "07:15 AM",
// //         "id": 163
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:24 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:31 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:33 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:50 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:01 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:08 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-7-403",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-4",
// //     "tripCode": "55/P55J-455-JTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ATTHIMARAPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 AM",
// //     "endTime": "08:45 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       176,
// //       177
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:15 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:20 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:27 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:37 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "08:38 AM",
// //         "id": 176
// //       },
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "08:45 AM",
// //         "id": 177
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-8-404",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-4",
// //     "tripCode": "55/P55J-455-JTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "ATTHIMARAPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:50 AM",
// //     "endTime": "09:25 AM",
// //     "ids": [
// //       177,
// //       176,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 7,
// //         "name": "ATTHIMARAPATTI",
// //         "time": "08:50 AM",
// //         "id": 177
// //       },
// //       {
// //         "no": 6,
// //         "name": "ATTHIMARAPATTI JUNCTION",
// //         "time": "08:57 AM",
// //         "id": 176
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:58 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:10 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:18 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:24 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-9-405",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-2",
// //     "tripCode": "55/P55J-255-JTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MULLAKADU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "10:00 AM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "09:35 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "09:39 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "09:45 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "09:54 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "09:55 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:00 AM",
// //         "id": 46
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-10-406",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-2",
// //     "tripCode": "55/P55J-255-JTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "MULLAKADU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:05 AM",
// //     "endTime": "10:30 AM",
// //     "ids": [
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "10:05 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "10:09 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "10:10 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "10:19 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "10:25 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "10:29 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-11-407",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-5",
// //     "tripCode": "55/P55J-555-JTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KULATTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:40 AM",
// //     "endTime": "11:55 AM",
// //     "ids": [
// //       26,
// //       282,
// //       1,
// //       63,
// //       64,
// //       111,
// //       112,
// //       299,
// //       144,
// //       300,
// //       145,
// //       135,
// //       136,
// //       287,
// //       301,
// //       138,
// //       139,
// //       118,
// //       132,
// //       140,
// //       302
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "10:40 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "10:43 AM",
// //         "id": 282
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:47 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "10:53 AM",
// //         "id": 63
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "10:55 AM",
// //         "id": 64
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "10:56 AM",
// //         "id": 111
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "11:02 AM",
// //         "id": 112
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 3",
// //         "time": "11:05 AM",
// //         "id": 299
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "11:12 AM",
// //         "id": 144
// //       },
// //       {
// //         "no": 10,
// //         "name": "ARASADI 2",
// //         "time": "11:14 AM",
// //         "id": 300
// //       },
// //       {
// //         "no": 11,
// //         "name": "KUMARAPURAM 1",
// //         "time": "11:20 AM",
// //         "id": 145
// //       },
// //       {
// //         "no": 12,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "11:22 AM",
// //         "id": 135
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA MARUTHUR",
// //         "time": "11:25 AM",
// //         "id": 136
// //       },
// //       {
// //         "no": 14,
// //         "name": "ZAKKAMMALPURAM 4",
// //         "time": "11:30 AM",
// //         "id": 287
// //       },
// //       {
// //         "no": 15,
// //         "name": "DURAISAMYPURAM 2",
// //         "time": "11:33 AM",
// //         "id": 301
// //       },
// //       {
// //         "no": 16,
// //         "name": "SOUTH KALMEDU",
// //         "time": "11:38 AM",
// //         "id": 138
// //       },
// //       {
// //         "no": 17,
// //         "name": "NORTH KALMEDU",
// //         "time": "11:39 AM",
// //         "id": 139
// //       },
// //       {
// //         "no": 18,
// //         "name": "VEPPALODAI",
// //         "time": "11:43 AM",
// //         "id": 118
// //       },
// //       {
// //         "no": 19,
// //         "name": "PANAIYOOR GATE",
// //         "time": "11:48 AM",
// //         "id": 132
// //       },
// //       {
// //         "no": 20,
// //         "name": "PANAIYOOR",
// //         "time": "11:52 AM",
// //         "id": 140
// //       },
// //       {
// //         "no": 21,
// //         "name": "KULATTHOOR 2",
// //         "time": "11:55 AM",
// //         "id": 302
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-12-408",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-5",
// //     "tripCode": "55/P55J-555-JTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "KULATTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:05 PM",
// //     "endTime": "01:20 PM",
// //     "ids": [
// //       302,
// //       140,
// //       132,
// //       118,
// //       139,
// //       138,
// //       301,
// //       287,
// //       136,
// //       135,
// //       145,
// //       300,
// //       144,
// //       299,
// //       112,
// //       111,
// //       64,
// //       63,
// //       1,
// //       282,
// //       26
// //     ],
// //     "stops": [
// //       {
// //         "no": 21,
// //         "name": "KULATTHOOR 2",
// //         "time": "12:05 PM",
// //         "id": 302
// //       },
// //       {
// //         "no": 20,
// //         "name": "PANAIYOOR",
// //         "time": "12:07 PM",
// //         "id": 140
// //       },
// //       {
// //         "no": 19,
// //         "name": "PANAIYOOR GATE",
// //         "time": "12:11 PM",
// //         "id": 132
// //       },
// //       {
// //         "no": 18,
// //         "name": "VEPPALODAI",
// //         "time": "12:16 PM",
// //         "id": 118
// //       },
// //       {
// //         "no": 17,
// //         "name": "NORTH KALMEDU",
// //         "time": "12:20 PM",
// //         "id": 139
// //       },
// //       {
// //         "no": 16,
// //         "name": "SOUTH KALMEDU",
// //         "time": "12:21 PM",
// //         "id": 138
// //       },
// //       {
// //         "no": 15,
// //         "name": "DURAISAMYPURAM 2",
// //         "time": "12:26 PM",
// //         "id": 301
// //       },
// //       {
// //         "no": 14,
// //         "name": "ZAKKAMMALPURAM 4",
// //         "time": "12:29 PM",
// //         "id": 287
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA MARUTHUR",
// //         "time": "12:34 PM",
// //         "id": 136
// //       },
// //       {
// //         "no": 12,
// //         "name": "AM PATTI JUNCTION",
// //         "time": "12:37 PM",
// //         "id": 135
// //       },
// //       {
// //         "no": 11,
// //         "name": "KUMARAPURAM 1",
// //         "time": "12:39 PM",
// //         "id": 145
// //       },
// //       {
// //         "no": 10,
// //         "name": "ARASADI 2",
// //         "time": "12:45 PM",
// //         "id": 300
// //       },
// //       {
// //         "no": 9,
// //         "name": "KEELA ARASADI",
// //         "time": "12:47 PM",
// //         "id": 144
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI JUNCTION 3",
// //         "time": "12:54 PM",
// //         "id": 299
// //       },
// //       {
// //         "no": 7,
// //         "name": "AYYANAR PURAM",
// //         "time": "12:57 PM",
// //         "id": 112
// //       },
// //       {
// //         "no": 6,
// //         "name": "THOMAS NAGAR",
// //         "time": "01:03 PM",
// //         "id": 111
// //       },
// //       {
// //         "no": 5,
// //         "name": "SAVARAIYARPURAM",
// //         "time": "01:04 PM",
// //         "id": 64
// //       },
// //       {
// //         "no": 4,
// //         "name": "AROCKIAPURAM",
// //         "time": "01:06 PM",
// //         "id": 63
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:12 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "AMERICAN HOSPITAL 2",
// //         "time": "01:16 PM",
// //         "id": 282
// //       },
// //       {
// //         "no": 1,
// //         "name": "4TH GATE 1",
// //         "time": "01:20 PM",
// //         "id": 26
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-13-409",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-8",
// //     "tripCode": "55/P55J-855-JTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KURUMBUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:30 PM",
// //     "endTime": "03:40 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       127,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       129,
// //       130,
// //       131,
// //       56
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "02:30 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "02:34 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "02:39 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:47 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:48 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:52 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "02:59 PM",
// //         "id": 127
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "03:03 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "03:09 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "03:16 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "03:21 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "03:24 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "03:26 PM",
// //         "id": 129
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "03:31 PM",
// //         "id": 130
// //       },
// //       {
// //         "no": 16,
// //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// //         "time": "03:36 PM",
// //         "id": 131
// //       },
// //       {
// //         "no": 17,
// //         "name": "KURUMBUR",
// //         "time": "03:40 PM",
// //         "id": 56
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-14-410",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-8",
// //     "tripCode": "55/P55J-855-JTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "KURUMBUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:45 PM",
// //     "endTime": "05:00 PM",
// //     "ids": [
// //       56,
// //       131,
// //       130,
// //       129,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       127,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "KURUMBUR",
// //         "time": "03:45 PM",
// //         "id": 56
// //       },
// //       {
// //         "no": 16,
// //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// //         "time": "03:48 PM",
// //         "id": 131
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "03:54 PM",
// //         "id": 130
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "03:59 PM",
// //         "id": 129
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "04:01 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "04:05 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "04:10 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "04:17 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "04:24 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "04:28 PM",
// //         "id": 127
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "04:35 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "04:39 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "04:40 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:49 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:55 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "04:59 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-15-411",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-7",
// //     "tripCode": "55/P55J-755-JTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:20 PM",
// //     "endTime": "06:05 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       180,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:27 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "05:35 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "05:44 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "05:50 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "05:53 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP JUNCTION",
// //         "time": "05:53 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:02 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "06:05 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-16-412",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-7",
// //     "tripCode": "55/P55J-755-JTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:10 PM",
// //     "endTime": "06:50 PM",
// //     "ids": [
// //       183,
// //       182,
// //       180,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "06:10 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:12 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP JUNCTION",
// //         "time": "06:19 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:19 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:23 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:27 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "06:36 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "06:42 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-17-413",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-6",
// //     "tripCode": "55/P55J-655-JTORD18U17",
// //     "order": 17,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "AUTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 PM",
// //     "endTime": "07:45 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "07:00 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "07:03 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "07:07 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:14 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "07:15 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:18 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "07:24 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:27 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "07:32 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "07:38 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "07:42 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "07:45 PM",
// //         "id": 172
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-18-414",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-6",
// //     "tripCode": "55/P55J-655-JTORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "AUTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 PM",
// //     "endTime": "08:35 PM",
// //     "ids": [
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "07:50 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "07:52 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "07:56 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "08:02 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "08:07 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "08:10 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "08:16 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:19 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:20 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:27 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:31 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:34 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-19-415",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-6",
// //     "tripCode": "55/P55J-655-JTORD18U19",
// //     "order": 19,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "AUTHOOR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:40 PM",
// //     "endTime": "09:35 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       47,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "08:40 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "08:44 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "08:49 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "08:58 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "08:58 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "09:02 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "09:10 PM",
// //         "id": 47
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "09:13 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "09:19 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "09:26 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "09:31 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "09:35 PM",
// //         "id": 172
// //       }
// //     ]
// //   },
// //   {
// //     "id": "55-J-20-416",
// //     "routeNo": "55-J",
// //     "code": "55/P55J-6",
// //     "tripCode": "55/P55J-655-JTORD18D20",
// //     "order": 20,
// //     "direction": "D",
// //     "from": "AUTHOOR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 PM",
// //     "endTime": "05:20 AM",
// //     "ids": [
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       47,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "09:40 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "10:09 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "10:50 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "11:48 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:39 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADHIKETTAN ODAI",
// //         "time": "01:06 AM",
// //         "id": 47
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:10 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:41 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:48 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:00 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:45 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:15 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-1-417",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:50 PM",
// //     "endTime": "03:00 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "01:54 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:58 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:05 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:08 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:15 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:20 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "02:25 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "02:25 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "02:33 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "02:39 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "02:41 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "02:47 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "02:53 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "02:57 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "03:00 PM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-2-418",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:05 PM",
// //     "endTime": "04:25 PM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "03:05 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "03:08 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "03:12 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "03:19 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "03:26 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "03:28 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "03:35 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "03:44 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "03:44 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:50 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:55 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:04 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:06 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:15 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "04:19 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-3-419",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-2",
// //     "tripCode": "56/P56A-256-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:30 PM",
// //     "endTime": "05:40 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       23,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "04:34 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:37 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:44 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:46 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:53 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:57 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "05:02 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "05:02 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "05:12 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "05:16 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "05:18 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "05:24 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "05:29 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "05:33 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "05:35 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "05:40 PM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-4-420",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-2",
// //     "tripCode": "56/P56A-256-ATORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 PM",
// //     "endTime": "07:05 PM",
// //     "ids": [
// //       247,
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "05:45 PM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "05:49 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "05:52 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "05:56 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "06:02 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "06:09 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "06:11 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "06:16 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "06:27 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:27 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:33 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:37 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:46 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:48 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:56 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "07:00 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-5-421",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 PM",
// //     "endTime": "08:20 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "07:14 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:18 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:25 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:28 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:35 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:40 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:45 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "07:45 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "07:53 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "07:59 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "08:01 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "08:07 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "08:13 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "08:17 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "08:20 PM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-6-422",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:25 PM",
// //     "endTime": "09:45 PM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "08:25 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "08:28 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "08:32 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "08:39 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "08:46 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "08:48 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "08:55 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "09:04 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:04 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:10 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:15 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:24 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:26 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:35 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:39 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-7-423",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-3",
// //     "tripCode": "56/P56A-356-ATORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 PM",
// //     "endTime": "05:40 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       248,
// //       22,
// //       23,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "10:18 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:41 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:28 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:42 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:31 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:56 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:30 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "ALLIKULAM JUNCTION",
// //         "time": "02:09 AM",
// //         "id": 248
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "02:18 AM",
// //         "id": 22
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "02:40 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "02:56 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "03:30 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "03:45 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "04:22 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "04:57 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "05:22 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "05:40 AM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-8-424",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 AM",
// //     "endTime": "07:00 AM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "05:45 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "05:48 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "05:52 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "05:58 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "06:04 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "06:07 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "06:13 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "06:21 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:21 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:27 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:32 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:40 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:43 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:51 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:55 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-9-425",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-2",
// //     "tripCode": "56/P56A-256-ATORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:10 AM",
// //     "endTime": "08:20 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       23,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "07:14 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:17 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:24 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:26 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:33 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:37 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:42 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "07:42 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "07:52 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "07:56 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "07:58 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "08:04 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "08:09 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "08:13 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "08:15 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "08:20 AM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-10-426",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-4",
// //     "tripCode": "56/P56A-456-ATORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:25 AM",
// //     "endTime": "09:45 AM",
// //     "ids": [
// //       247,
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       23,
// //       22,
// //       248,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "08:25 AM",
// //         "id": 247
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "08:29 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "08:32 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "08:36 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "08:41 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "08:47 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "08:50 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "08:55 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "08:58 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "09:01 AM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "ALLIKULAM JUNCTION",
// //         "time": "09:03 AM",
// //         "id": 248
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:09 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:15 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:19 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:26 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:29 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:36 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:40 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-11-427",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 AM",
// //     "endTime": "11:00 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:54 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:58 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:05 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:08 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:15 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:20 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "10:25 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "10:25 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "10:33 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "10:39 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "10:41 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "10:47 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "10:53 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "10:57 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "11:00 AM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-A-12-428",
// //     "routeNo": "56-A",
// //     "code": "56/P56A-1",
// //     "tripCode": "56/P56A-156-ATORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:05 AM",
// //     "endTime": "01:45 PM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "11:05 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "11:11 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "11:20 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "11:33 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "11:47 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "11:52 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "12:05 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "12:23 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "12:23 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:36 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:45 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:03 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:08 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:26 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "01:34 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-1-429",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 AM",
// //     "endTime": "07:00 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       22,
// //       23,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:49 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:00 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:03 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:10 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:15 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:20 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "06:20 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "06:27 AM",
// //         "id": 22
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "06:31 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "06:33 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "06:39 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "06:41 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "06:47 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "06:53 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "06:57 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "07:00 AM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-2-430",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:05 AM",
// //     "endTime": "08:30 AM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       23,
// //       22,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "07:05 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "07:08 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "07:12 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "07:19 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "07:25 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "07:28 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "07:34 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "07:37 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "07:41 AM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "07:49 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:49 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:55 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:00 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:09 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:12 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:20 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:24 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-3-431",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-3",
// //     "tripCode": "56/P56B-356-BTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:35 AM",
// //     "endTime": "10:10 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       253,
// //       254,
// //       196,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:40 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:44 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:53 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:56 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:05 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:10 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:15 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "09:21 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "09:34 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "09:41 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHETTIYOORANI",
// //         "time": "09:48 AM",
// //         "id": 253
// //       },
// //       {
// //         "no": 15,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "09:53 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 17,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "10:06 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 18,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:10 AM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-4-432",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-3",
// //     "tripCode": "56/P56B-356-BTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:15 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       74,
// //       196,
// //       254,
// //       253,
// //       252,
// //       251,
// //       250,
// //       6,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "10:15 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 17,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "10:18 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 15,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "10:33 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHETTIYOORANI",
// //         "time": "10:38 AM",
// //         "id": 253
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "10:46 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "10:54 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "11:08 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:15 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:20 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:26 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:36 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:39 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:49 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:53 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-5-433",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:05 PM",
// //     "endTime": "01:20 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       22,
// //       23,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "12:09 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:13 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:20 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:23 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:30 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:35 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "12:40 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "12:40 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "12:47 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "12:51 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "12:53 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "12:59 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "01:01 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "01:07 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "01:13 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "01:17 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "01:20 PM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-6-434",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:25 PM",
// //     "endTime": "02:40 PM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       23,
// //       22,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "01:25 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "01:27 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "01:31 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "01:37 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "01:43 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "01:45 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "01:51 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "01:53 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "01:57 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "02:04 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "02:04 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:09 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:14 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:21 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:24 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:31 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "02:35 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-7-435",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:45 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       22,
// //       23,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "02:49 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:53 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:00 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:03 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:10 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:15 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "03:20 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "03:20 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "03:27 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "03:31 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "03:33 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "03:39 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "03:41 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "03:47 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "03:53 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "03:57 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "04:00 PM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-8-436",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:05 PM",
// //     "endTime": "05:30 PM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       23,
// //       22,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "04:05 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "04:08 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "04:12 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "04:19 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "04:25 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "04:28 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "04:34 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "04:37 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "04:41 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "04:49 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "04:49 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:55 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:00 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:09 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:12 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:20 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:24 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-9-437",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-2",
// //     "tripCode": "56/P56B-256-BTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "VELLARAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:35 PM",
// //     "endTime": "06:50 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       67,
// //       68,
// //       69,
// //       97,
// //       143,
// //       99,
// //       281,
// //       100,
// //       191,
// //       192,
// //       193,
// //       194
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "05:38 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "05:40 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "05:45 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "05:46 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "05:52 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "05:55 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "05:59 PM",
// //         "id": 143
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "06:12 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "06:18 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "06:22 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "06:28 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "06:34 PM",
// //         "id": 192
// //       },
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "06:42 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 15,
// //         "name": "VELLARAM",
// //         "time": "06:50 PM",
// //         "id": 194
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-10-438",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-2",
// //     "tripCode": "56/P56B-256-BTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "VELLARAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:55 PM",
// //     "endTime": "08:15 PM",
// //     "ids": [
// //       194,
// //       193,
// //       192,
// //       191,
// //       100,
// //       281,
// //       99,
// //       143,
// //       97,
// //       69,
// //       68,
// //       67,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "VELLARAM",
// //         "time": "06:55 PM",
// //         "id": 194
// //       },
// //       {
// //         "no": 14,
// //         "name": "KACCHERI THALAVAIPURAM",
// //         "time": "07:02 PM",
// //         "id": 193
// //       },
// //       {
// //         "no": 13,
// //         "name": "VELLARAM JUNCTION",
// //         "time": "07:11 PM",
// //         "id": 192
// //       },
// //       {
// //         "no": 12,
// //         "name": "KUMARAPURAM JUNCTION",
// //         "time": "07:17 PM",
// //         "id": 191
// //       },
// //       {
// //         "no": 11,
// //         "name": "KURUKKUSALAI",
// //         "time": "07:23 PM",
// //         "id": 100
// //       },
// //       {
// //         "no": 10,
// //         "name": "SUBRAMANIYAPURAM 2",
// //         "time": "07:28 PM",
// //         "id": 281
// //       },
// //       {
// //         "no": 9,
// //         "name": "VALASAMUTHIRAM",
// //         "time": "07:34 PM",
// //         "id": 99
// //       },
// //       {
// //         "no": 8,
// //         "name": "ARASADI 1",
// //         "time": "07:48 PM",
// //         "id": 143
// //       },
// //       {
// //         "no": 7,
// //         "name": "THANNEER PANDHAL",
// //         "time": "07:52 PM",
// //         "id": 97
// //       },
// //       {
// //         "no": 6,
// //         "name": "ODAIPATTI PUDHUR",
// //         "time": "07:56 PM",
// //         "id": 69
// //       },
// //       {
// //         "no": 5,
// //         "name": "KALI KOVIL JUNCTION",
// //         "time": "08:02 PM",
// //         "id": 68
// //       },
// //       {
// //         "no": 4,
// //         "name": "MAPPILLAIYOORANI",
// //         "time": "08:03 PM",
// //         "id": 67
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "08:09 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:11 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-11-439",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:20 PM",
// //     "endTime": "09:50 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       22,
// //       23,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:25 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:29 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:38 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:41 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:51 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:56 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:02 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "09:02 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "09:11 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "09:15 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "09:18 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "09:24 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "09:27 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "09:35 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "09:41 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "09:46 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "09:50 PM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-B-12-440",
// //     "routeNo": "56-B",
// //     "code": "56/P56B-1",
// //     "tripCode": "56/P56B-156-BTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:55 PM",
// //     "endTime": "05:40 AM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       23,
// //       22,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "09:55 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "10:12 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "10:37 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "11:11 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "11:49 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "12:04 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "12:37 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "12:54 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "01:16 AM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "01:59 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:59 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:33 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:59 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:47 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:01 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:48 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:11 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-1-441",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-1",
// //     "tripCode": "56/P56C-156-CTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "04:35 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       256,
// //       257,
// //       258,
// //       259,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "03:04 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:08 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:17 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:19 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:28 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:32 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "03:38 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "03:40 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "03:49 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "04:10 PM",
// //         "id": 256
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "04:14 PM",
// //         "id": 257
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "04:24 PM",
// //         "id": 258
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "04:26 PM",
// //         "id": 259
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "04:30 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "04:35 PM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-2-442",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-1",
// //     "tripCode": "56/P56C-156-CTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:40 PM",
// //     "endTime": "06:15 PM",
// //     "ids": [
// //       247,
// //       245,
// //       259,
// //       258,
// //       257,
// //       256,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "04:40 PM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "04:44 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "04:48 PM",
// //         "id": 259
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "04:50 PM",
// //         "id": 258
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "05:00 PM",
// //         "id": 257
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "05:04 PM",
// //         "id": 256
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "05:25 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "05:34 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "05:36 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:42 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:46 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:55 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:57 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:06 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:10 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-3-443",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-2",
// //     "tripCode": "56/P56C-256-CTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:20 PM",
// //     "endTime": "07:40 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       23,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "06:24 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:28 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:36 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:38 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:47 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:51 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:57 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "06:57 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "07:08 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "07:13 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "07:15 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "07:22 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "07:28 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "07:32 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "07:35 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "07:40 PM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-4-444",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-2",
// //     "tripCode": "56/P56C-256-CTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:45 PM",
// //     "endTime": "09:10 PM",
// //     "ids": [
// //       247,
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "07:45 PM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "07:50 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "07:53 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "07:57 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "08:03 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "08:10 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "08:13 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "08:18 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "08:30 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:30 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:36 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:41 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:49 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:52 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:00 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:04 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-5-445",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-1",
// //     "tripCode": "56/P56C-156-CTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 PM",
// //     "endTime": "06:10 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       256,
// //       257,
// //       258,
// //       259,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:43 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:05 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:51 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:05 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:52 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "12:51 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "01:01 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "01:56 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "03:52 AM",
// //         "id": 256
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "04:14 AM",
// //         "id": 257
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "05:11 AM",
// //         "id": 258
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "05:21 AM",
// //         "id": 259
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "05:42 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "06:10 AM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-6-446",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-2",
// //     "tripCode": "56/P56C-256-CTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 AM",
// //     "endTime": "07:45 AM",
// //     "ids": [
// //       247,
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "06:15 AM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "06:20 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "06:23 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "06:28 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "06:35 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "06:42 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "06:44 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "06:50 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "07:03 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:03 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:09 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:14 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:23 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:26 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:35 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "07:39 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-7-447",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-1",
// //     "tripCode": "56/P56C-156-CTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 AM",
// //     "endTime": "09:10 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       256,
// //       257,
// //       258,
// //       259,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "07:54 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:57 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:04 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:06 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:13 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:22 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "08:23 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "08:32 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "08:49 AM",
// //         "id": 256
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "08:52 AM",
// //         "id": 257
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "09:01 AM",
// //         "id": 258
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "09:02 AM",
// //         "id": 259
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "09:05 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "09:10 AM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-8-448",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-1",
// //     "tripCode": "56/P56C-156-CTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 AM",
// //     "endTime": "10:45 AM",
// //     "ids": [
// //       247,
// //       245,
// //       259,
// //       258,
// //       257,
// //       256,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "09:15 AM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "09:19 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "09:23 AM",
// //         "id": 259
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "09:24 AM",
// //         "id": 258
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "09:34 AM",
// //         "id": 257
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "09:38 AM",
// //         "id": 256
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "09:57 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "10:06 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "10:08 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:14 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:18 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:26 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:28 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:36 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "10:40 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-9-449",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-2",
// //     "tripCode": "56/P56C-256-CTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:50 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       23,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "10:54 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:57 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:04 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:06 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:13 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "11:22 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "11:22 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "11:32 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "11:36 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "11:38 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "11:44 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "11:49 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "11:53 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "11:55 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "12:00 PM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-C-10-450",
// //     "routeNo": "56-C",
// //     "code": "56/P56C-2",
// //     "tripCode": "56/P56C-256-CTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:05 PM",
// //     "endTime": "03:15 PM",
// //     "ids": [
// //       247,
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "12:05 PM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "12:16 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "12:23 PM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "12:33 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "12:47 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "01:02 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "01:08 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "01:20 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "01:46 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:46 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:00 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:10 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:29 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:35 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:54 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "03:03 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-1-451",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-1",
// //     "tripCode": "56/P56D-156-DTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:10 PM",
// //     "endTime": "03:30 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       256,
// //       257,
// //       258,
// //       259,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "02:14 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:17 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:24 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:26 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:33 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:37 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "02:42 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "02:43 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "02:52 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "03:09 PM",
// //         "id": 256
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "03:12 PM",
// //         "id": 257
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "03:21 PM",
// //         "id": 258
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "03:22 PM",
// //         "id": 259
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "03:25 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "03:30 PM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-2-452",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-1",
// //     "tripCode": "56/P56D-156-DTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:45 PM",
// //     "endTime": "05:05 PM",
// //     "ids": [
// //       247,
// //       245,
// //       259,
// //       258,
// //       257,
// //       256,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "03:45 PM",
// //         "id": 247
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "03:49 PM",
// //         "id": 245
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "03:52 PM",
// //         "id": 259
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "03:53 PM",
// //         "id": 258
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "04:02 PM",
// //         "id": 257
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "04:05 PM",
// //         "id": 256
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "04:22 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "04:31 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "04:32 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:37 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:41 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:48 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:50 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:57 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:00 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-3-453",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-2",
// //     "tripCode": "56/P56D-256-DTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KALLAMPARAMBU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:20 PM",
// //     "endTime": "06:35 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       22,
// //       23,
// //       249,
// //       24,
// //       243,
// //       303,
// //       304,
// //       260
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "05:24 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:28 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:36 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:39 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:47 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:51 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "05:57 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "05:57 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "06:04 PM",
// //         "id": 22
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "06:08 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "06:11 PM",
// //         "id": 249
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "06:16 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "06:19 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "06:25 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "06:31 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 17,
// //         "name": "KALLAMPARAMBU",
// //         "time": "06:35 PM",
// //         "id": 260
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-4-454",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-3",
// //     "tripCode": "56/P56D-356-DTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "KALLAMPARAMBU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:40 PM",
// //     "endTime": "07:55 PM",
// //     "ids": [
// //       260,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "KALLAMPARAMBU",
// //         "time": "06:40 PM",
// //         "id": 260
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "06:43 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "06:49 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "06:56 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "06:58 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "07:04 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "07:15 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:16 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:22 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:26 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:35 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:37 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:45 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "07:49 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-5-455",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-1",
// //     "tripCode": "56/P56D-156-DTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MELA CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 PM",
// //     "endTime": "07:15 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       256,
// //       257,
// //       258,
// //       259,
// //       245,
// //       247
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:44 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:12 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:09 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:27 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:26 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:57 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "12:38 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "12:51 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "01:59 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "04:23 AM",
// //         "id": 256
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "04:51 AM",
// //         "id": 257
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "06:02 AM",
// //         "id": 258
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "06:14 AM",
// //         "id": 259
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "06:40 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 18,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "07:15 AM",
// //         "id": 247
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-6-456",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-4",
// //     "tripCode": "56/P56D-456-DTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "MELA CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:20 AM",
// //     "endTime": "08:40 AM",
// //     "ids": [
// //       247,
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       249,
// //       23,
// //       22,
// //       248,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "MELA CHEKKARAKUDI",
// //         "time": "07:20 AM",
// //         "id": 247
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHEKKARAKUDI",
// //         "time": "07:24 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 17,
// //         "name": "MAHILAMPURAM",
// //         "time": "07:27 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "07:31 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "PUDHUR 2",
// //         "time": "07:36 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "07:42 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PEROORANI",
// //         "time": "07:45 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "THIRUVANANDHA PURAM JUNCTION",
// //         "time": "07:50 AM",
// //         "id": 249
// //       },
// //       {
// //         "no": 11,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "07:53 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 10,
// //         "name": "ALLIKULAM",
// //         "time": "07:56 AM",
// //         "id": 22
// //       },
// //       {
// //         "no": 9,
// //         "name": "ALLIKULAM JUNCTION",
// //         "time": "07:58 AM",
// //         "id": 248
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:04 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:10 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:14 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:21 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:24 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:31 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:35 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-7-457",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-5",
// //     "tripCode": "56/P56D-556-DTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:55 AM",
// //     "endTime": "10:05 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       256,
// //       257,
// //       258,
// //       259,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:55 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "08:58 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:01 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:08 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:10 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:16 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:20 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:24 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "09:26 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "09:33 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "09:49 AM",
// //         "id": 256
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "09:52 AM",
// //         "id": 257
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "10:00 AM",
// //         "id": 258
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "10:02 AM",
// //         "id": 259
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "10:05 AM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-8-458",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-5",
// //     "tripCode": "56/P56D-556-DTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:10 AM",
// //     "endTime": "11:20 AM",
// //     "ids": [
// //       245,
// //       259,
// //       258,
// //       257,
// //       256,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "10:10 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 16,
// //         "name": "AZHAGAPURI",
// //         "time": "10:12 AM",
// //         "id": 259
// //       },
// //       {
// //         "no": 15,
// //         "name": "NATTHAM",
// //         "time": "10:14 AM",
// //         "id": 258
// //       },
// //       {
// //         "no": 14,
// //         "name": "POTTALOORANI VILLAGE",
// //         "time": "10:22 AM",
// //         "id": 257
// //       },
// //       {
// //         "no": 13,
// //         "name": "POTTALOORANI JUNCTION",
// //         "time": "10:25 AM",
// //         "id": 256
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "10:41 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "10:48 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "10:50 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "10:54 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:58 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:04 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:06 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:13 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "11:16 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:20 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-9-459",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-3",
// //     "tripCode": "56/P56D-356-DTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KALLAMPARAMBU",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:25 AM",
// //     "endTime": "12:40 PM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       23,
// //       24,
// //       243,
// //       303,
// //       304,
// //       260
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:25 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "11:30 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:34 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:42 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:44 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:53 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:57 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "12:03 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "12:04 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "12:15 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "12:21 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "12:23 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "12:30 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "12:36 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "KALLAMPARAMBU",
// //         "time": "12:40 PM",
// //         "id": 260
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-D-10-460",
// //     "routeNo": "56-D",
// //     "code": "56/P56D-3",
// //     "tripCode": "56/P56D-356-DTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KALLAMPARAMBU",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:45 PM",
// //     "endTime": "01:55 PM",
// //     "ids": [
// //       260,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "KALLAMPARAMBU",
// //         "time": "12:45 PM",
// //         "id": 260
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "12:48 PM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "12:54 PM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "01:00 PM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "01:02 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "01:07 PM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "01:18 PM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:18 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:24 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:28 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:36 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:38 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:46 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "01:50 PM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-1-461",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:20 PM",
// //     "endTime": "01:40 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       305,
// //       255,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "12:25 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:30 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:39 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:42 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:52 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:57 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:04 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "01:08 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "01:10 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "01:22 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "01:25 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "01:35 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "01:40 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-2-462",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:45 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       305,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "01:45 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "01:48 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "01:58 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "02:00 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "02:10 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "02:12 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "02:16 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:22 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:26 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:35 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:37 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:46 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:49 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-3-463",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "04:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       305,
// //       255,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:05 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:08 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:17 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:19 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:28 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:32 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "03:38 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "03:42 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "03:44 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "03:54 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "03:56 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "04:06 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "04:10 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-4-464",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:15 PM",
// //     "endTime": "05:40 PM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       305,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "04:15 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "04:19 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "04:30 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "04:34 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "04:45 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "04:48 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "04:53 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:00 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:05 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:16 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:19 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:29 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:33 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-5-465",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 PM",
// //     "endTime": "06:30 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       305,
// //       255,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:48 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:50 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:56 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:57 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:03 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:06 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:09 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "06:12 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "06:13 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "06:19 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "06:21 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "06:27 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "06:30 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-6-466",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 PM",
// //     "endTime": "07:50 PM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       305,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "06:50 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "06:53 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "07:01 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "07:03 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "07:11 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "07:13 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:16 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:21 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:25 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:33 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:35 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:42 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:45 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-7-467",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:00 PM",
// //     "endTime": "09:05 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       305,
// //       255,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:04 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:08 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:15 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:18 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:26 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:30 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:35 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "08:39 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "08:41 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "08:50 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "08:52 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "09:01 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "09:05 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-8-468",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 PM",
// //     "endTime": "10:15 PM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       305,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "09:15 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "09:18 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "09:26 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "09:28 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "09:36 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "09:38 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:41 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:46 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:50 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:58 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:00 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:07 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:10 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-9-469",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 PM",
// //     "endTime": "11:40 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       305,
// //       255,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:35 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:38 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:47 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:49 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:58 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:02 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "11:08 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "11:12 PM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "11:14 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "11:24 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "11:26 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "11:36 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "11:40 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-10-470",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:25 AM",
// //     "endTime": "07:30 AM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       305,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "06:25 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "06:28 AM",
// //         "id": 262
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "06:37 AM",
// //         "id": 261
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "06:39 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "06:48 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "06:50 AM",
// //         "id": 305
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:54 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:59 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:03 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:11 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:14 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:25 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-11-471",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-1",
// //     "tripCode": "56/P56E-156-ETORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:40 AM",
// //     "endTime": "08:40 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       305,
// //       255,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:44 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:47 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:54 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:56 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:04 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:08 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:13 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "08:16 AM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "08:18 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "08:26 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "08:28 AM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "08:36 AM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "08:40 AM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-12-472",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-2",
// //     "tripCode": "56/P56E-256-ETORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:45 AM",
// //     "endTime": "10:00 AM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       305,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1,
// //       28,
// //       27
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "PEROORANI",
// //         "time": "08:45 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 15,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "08:48 AM",
// //         "id": 262
// //       },
// //       {
// //         "no": 14,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "08:57 AM",
// //         "id": 261
// //       },
// //       {
// //         "no": 13,
// //         "name": "VAGAIKULAM",
// //         "time": "08:59 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 12,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "09:09 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 11,
// //         "name": "RAMACHANDRAPURAM 2",
// //         "time": "09:11 AM",
// //         "id": 305
// //       },
// //       {
// //         "no": 10,
// //         "name": "MANGALAGIRI",
// //         "time": "09:14 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:20 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:24 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:32 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "KORAMPALLAM",
// //         "time": "09:34 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "3RD MILE",
// //         "time": "09:42 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "MILLER PURAM",
// //         "time": "09:46 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:56 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THRES PURAM",
// //         "time": "10:00 AM",
// //         "id": 27
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-E-13-473",
// //     "routeNo": "56-E",
// //     "code": "56/P56E-3",
// //     "tripCode": "56/P56E-356-ETORD18D13",
// //     "order": 13,
// //     "direction": "D",
// //     "from": "THRES PURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:10 AM",
// //     "endTime": "12:10 PM",
// //     "ids": [
// //       27,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 2,
// //         "name": "THRES PURAM",
// //         "time": "10:10 AM",
// //         "id": 27
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-1-474",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-1",
// //     "tripCode": "56/P56F-156-FTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ADAIKKALAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:45 AM",
// //     "endTime": "06:40 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       263,
// //       264
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:48 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:51 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:58 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:59 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:06 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:09 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:14 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "06:15 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "06:22 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "06:26 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "06:36 AM",
// //         "id": 263
// //       },
// //       {
// //         "no": 15,
// //         "name": "ADAIKKALAPURAM",
// //         "time": "06:40 AM",
// //         "id": 264
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-2-475",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-1",
// //     "tripCode": "56/P56F-156-FTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "ADAIKKALAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 AM",
// //     "endTime": "07:40 AM",
// //     "ids": [
// //       264,
// //       263,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "ADAIKKALAPURAM",
// //         "time": "06:50 AM",
// //         "id": 264
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "06:53 AM",
// //         "id": 263
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "07:02 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "07:05 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "07:12 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:13 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:20 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:26 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:28 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:33 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:36 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-3-476",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-6",
// //     "tripCode": "56/P56F-656-FTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "MEELAVITTAN",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 AM",
// //     "endTime": "08:05 AM",
// //     "ids": [
// //       1,
// //       26,
// //       220,
// //       221,
// //       222,
// //       223
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "07:52 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "CHINNAKANNUPURAM",
// //         "time": "07:54 AM",
// //         "id": 220
// //       },
// //       {
// //         "no": 4,
// //         "name": "SILVERPURAM",
// //         "time": "07:57 AM",
// //         "id": 221
// //       },
// //       {
// //         "no": 5,
// //         "name": "PANDARAMPATTI",
// //         "time": "08:02 AM",
// //         "id": 222
// //       },
// //       {
// //         "no": 6,
// //         "name": "MEELAVITTAN",
// //         "time": "08:05 AM",
// //         "id": 223
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-4-477",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-6",
// //     "tripCode": "56/P56F-656-FTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "MEELAVITTAN",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 AM",
// //     "endTime": "08:10 AM",
// //     "ids": [
// //       223,
// //       222,
// //       221,
// //       220,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "MEELAVITTAN",
// //         "time": "08:10 AM",
// //         "id": 223
// //       },
// //       {
// //         "no": 5,
// //         "name": "PANDARAMPATTI",
// //         "time": "08:10 AM",
// //         "id": 222
// //       },
// //       {
// //         "no": 4,
// //         "name": "SILVERPURAM",
// //         "time": "08:10 AM",
// //         "id": 221
// //       },
// //       {
// //         "no": 3,
// //         "name": "CHINNAKANNUPURAM",
// //         "time": "08:10 AM",
// //         "id": 220
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "08:10 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-5-478",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-7",
// //     "tripCode": "56/P56F-756-FTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ST. MARYS COLLEGE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:20 AM",
// //     "endTime": "08:25 AM",
// //     "ids": [
// //       1,
// //       28,
// //       272
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:20 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:23 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ST. MARY'S COLLEGE",
// //         "time": "08:25 AM",
// //         "id": 272
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-6-479",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-7",
// //     "tripCode": "56/P56F-756-FTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "ST. MARYS COLLEGE",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:45 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       272,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 3,
// //         "name": "ST. MARY'S COLLEGE",
// //         "time": "08:45 AM",
// //         "id": 272
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:51 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:05 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-7-480",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-3",
// //     "tripCode": "56/P56F-356-FTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "DEIVASEYALPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 AM",
// //     "endTime": "10:25 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       263,
// //       265,
// //       266,
// //       267,
// //       268,
// //       269,
// //       270
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:19 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:28 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:30 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:36 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:40 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:44 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "09:46 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "09:53 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "09:57 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "10:07 AM",
// //         "id": 263
// //       },
// //       {
// //         "no": 15,
// //         "name": "ANIYABARANALLUR",
// //         "time": "10:11 AM",
// //         "id": 265
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUDHUPATTI",
// //         "time": "10:17 AM",
// //         "id": 266
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHETTIMALLANPATTI",
// //         "time": "10:19 AM",
// //         "id": 267
// //       },
// //       {
// //         "no": 18,
// //         "name": "RAMANATHAPURAM",
// //         "time": "10:22 AM",
// //         "id": 268
// //       },
// //       {
// //         "no": 19,
// //         "name": "ELLANAICKENPATTI",
// //         "time": "10:23 AM",
// //         "id": 269
// //       },
// //       {
// //         "no": 20,
// //         "name": "DEIVASEYALPURAM",
// //         "time": "10:25 AM",
// //         "id": 270
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-8-481",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-3",
// //     "tripCode": "56/P56F-356-FTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "DEIVASEYALPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:30 AM",
// //     "endTime": "11:45 AM",
// //     "ids": [
// //       270,
// //       269,
// //       268,
// //       267,
// //       266,
// //       265,
// //       263,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 20,
// //         "name": "DEIVASEYALPURAM",
// //         "time": "10:30 AM",
// //         "id": 270
// //       },
// //       {
// //         "no": 19,
// //         "name": "ELLANAICKENPATTI",
// //         "time": "10:31 AM",
// //         "id": 269
// //       },
// //       {
// //         "no": 18,
// //         "name": "RAMANATHAPURAM",
// //         "time": "10:32 AM",
// //         "id": 268
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHETTIMALLANPATTI",
// //         "time": "10:35 AM",
// //         "id": 267
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUDHUPATTI",
// //         "time": "10:38 AM",
// //         "id": 266
// //       },
// //       {
// //         "no": 15,
// //         "name": "ANIYABARANALLUR",
// //         "time": "10:44 AM",
// //         "id": 265
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "10:48 AM",
// //         "id": 263
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "10:59 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "11:03 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "11:11 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "11:12 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:21 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:28 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:30 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:37 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:40 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-9-482",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-9",
// //     "tripCode": "56/P56F-956-FTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI OLD B/S",
// //     "to": "THOOTHUKUDI NEW B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:50 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       1,
// //       26,
// //       77
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "11:56 AM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI NEW B/S",
// //         "time": "12:00 PM",
// //         "id": 77
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-10-483",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-9",
// //     "tripCode": "56/P56F-956-FTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "THOOTHUKUDI NEW B/S",
// //     "to": "THOOTHUKUDI OLD B/S",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:20 PM",
// //     "endTime": "12:30 PM",
// //     "ids": [
// //       77,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 3,
// //         "name": "THOOTHUKUDI NEW B/S",
// //         "time": "12:20 PM",
// //         "id": 77
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "12:23 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-11-484",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-1",
// //     "tripCode": "56/P56F-156-FTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "ADAIKKALAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:50 PM",
// //     "endTime": "01:40 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       263,
// //       264
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "12:53 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:56 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:01 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:03 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:09 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:12 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:16 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "01:17 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "01:24 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "01:27 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "01:36 PM",
// //         "id": 263
// //       },
// //       {
// //         "no": 15,
// //         "name": "ADAIKKALAPURAM",
// //         "time": "01:40 PM",
// //         "id": 264
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-12-485",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-1",
// //     "tripCode": "56/P56F-156-FTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "ADAIKKALAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:50 PM",
// //     "endTime": "02:40 PM",
// //     "ids": [
// //       264,
// //       263,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 15,
// //         "name": "ADAIKKALAPURAM",
// //         "time": "01:50 PM",
// //         "id": 264
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "01:53 PM",
// //         "id": 263
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "02:02 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "02:05 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "02:12 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "02:13 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:17 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:20 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:26 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:28 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:33 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:36 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-13-486",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-8",
// //     "tripCode": "56/P56F-856-FTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "APC COLLEGE",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:50 PM",
// //     "endTime": "03:00 PM",
// //     "ids": [
// //       1,
// //       26,
// //       66,
// //       219
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "02:53 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "02:56 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 4,
// //         "name": "APC COLLEGE",
// //         "time": "03:00 PM",
// //         "id": 219
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-14-487",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-8",
// //     "tripCode": "56/P56F-856-FTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "APC COLLEGE",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:05 PM",
// //     "endTime": "03:40 PM",
// //     "ids": [
// //       219,
// //       66,
// //       26,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 4,
// //         "name": "APC COLLEGE",
// //         "time": "03:05 PM",
// //         "id": 219
// //       },
// //       {
// //         "no": 3,
// //         "name": "STATE BANK COLONY",
// //         "time": "03:18 PM",
// //         "id": 66
// //       },
// //       {
// //         "no": 2,
// //         "name": "4TH GATE 1",
// //         "time": "03:27 PM",
// //         "id": 26
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-15-488",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-2",
// //     "tripCode": "56/P56F-256-FTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUDHUPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:50 PM",
// //     "endTime": "04:50 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       263,
// //       265,
// //       266
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:53 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:56 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:02 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:04 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:11 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:14 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "04:18 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "04:20 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "04:27 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "04:31 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 14,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "04:41 PM",
// //         "id": 263
// //       },
// //       {
// //         "no": 15,
// //         "name": "ANIYABARANALLUR",
// //         "time": "04:44 PM",
// //         "id": 265
// //       },
// //       {
// //         "no": 16,
// //         "name": "PUDHUPATTI",
// //         "time": "04:50 PM",
// //         "id": 266
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-16-489",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-4",
// //     "tripCode": "56/P56F-456-FTORD18U16",
// //     "order": 16,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PEROORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 PM",
// //     "endTime": "05:05 PM",
// //     "ids": [
// //       266,
// //       265,
// //       263,
// //       166,
// //       167,
// //       261,
// //       262,
// //       24
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "PUDHUPATTI",
// //         "time": "05:00 PM",
// //         "id": 266
// //       },
// //       {
// //         "no": 2,
// //         "name": "ANIYABARANALLUR",
// //         "time": "05:00 PM",
// //         "id": 265
// //       },
// //       {
// //         "no": 3,
// //         "name": "MEENAKSHIPATTI",
// //         "time": "05:01 PM",
// //         "id": 263
// //       },
// //       {
// //         "no": 6,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "05:02 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 7,
// //         "name": "VAGAIKULAM",
// //         "time": "05:03 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 8,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "05:03 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 9,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "05:04 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 10,
// //         "name": "PEROORANI",
// //         "time": "05:05 PM",
// //         "id": 24
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-17-490",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-5",
// //     "tripCode": "56/P56F-556-FTORD18D17",
// //     "order": 17,
// //     "direction": "D",
// //     "from": "PEROORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:55 PM",
// //     "endTime": "06:00 PM",
// //     "ids": [
// //       24,
// //       262,
// //       261,
// //       167,
// //       255,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 14,
// //         "name": "PEROORANI",
// //         "time": "05:55 PM",
// //         "id": 24
// //       },
// //       {
// //         "no": 13,
// //         "name": "THIMMARAJAPURAM",
// //         "time": "05:55 PM",
// //         "id": 262
// //       },
// //       {
// //         "no": 12,
// //         "name": "VARTHAGAREDDIPATTI",
// //         "time": "05:55 PM",
// //         "id": 261
// //       },
// //       {
// //         "no": 11,
// //         "name": "VAGAIKULAM",
// //         "time": "05:56 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 10,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "05:56 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "05:56 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "05:57 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:57 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:57 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:58 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:58 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:59 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:59 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-18-491",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-10",
// //     "tripCode": "56/P56F-1056-FTORD18U18",
// //     "order": 18,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "THALAIVANVADALI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 PM",
// //     "endTime": "08:45 PM",
// //     "ids": [
// //       1,
// //       41,
// //       42,
// //       43,
// //       44,
// //       45,
// //       46,
// //       127,
// //       157,
// //       49,
// //       50,
// //       51,
// //       172,
// //       129,
// //       130,
// //       239
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "06:16 PM",
// //         "id": 41
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "06:24 PM",
// //         "id": 42
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "06:36 PM",
// //         "id": 43
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "06:56 PM",
// //         "id": 44
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "06:58 PM",
// //         "id": 45
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "07:06 PM",
// //         "id": 46
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "07:21 PM",
// //         "id": 127
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "07:31 PM",
// //         "id": 157
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "07:45 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "08:00 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "08:11 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "08:19 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "08:24 PM",
// //         "id": 129
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "08:35 PM",
// //         "id": 130
// //       },
// //       {
// //         "no": 16,
// //         "name": "THALAIVANVADALI",
// //         "time": "08:45 PM",
// //         "id": 239
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-F-19-492",
// //     "routeNo": "56-F",
// //     "code": "56/P56F-10",
// //     "tripCode": "56/P56F-1056-FTORD18D19",
// //     "order": 19,
// //     "direction": "D",
// //     "from": "THALAIVANVADALI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 PM",
// //     "endTime": "05:30 AM",
// //     "ids": [
// //       239,
// //       130,
// //       129,
// //       172,
// //       51,
// //       50,
// //       49,
// //       157,
// //       127,
// //       46,
// //       45,
// //       44,
// //       43,
// //       42,
// //       41,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "THALAIVANVADALI",
// //         "time": "07:30 PM",
// //         "id": 239
// //       },
// //       {
// //         "no": 15,
// //         "name": "AYYANKOVIL JUNCTION",
// //         "time": "08:09 PM",
// //         "id": 130
// //       },
// //       {
// //         "no": 14,
// //         "name": "SOUTH AUTHOOR",
// //         "time": "08:50 PM",
// //         "id": 129
// //       },
// //       {
// //         "no": 13,
// //         "name": "AUTHOOR",
// //         "time": "09:10 PM",
// //         "id": 172
// //       },
// //       {
// //         "no": 12,
// //         "name": "MUKKANI",
// //         "time": "09:42 PM",
// //         "id": 51
// //       },
// //       {
// //         "no": 11,
// //         "name": "CHAMBER",
// //         "time": "10:26 PM",
// //         "id": 50
// //       },
// //       {
// //         "no": 10,
// //         "name": "PALAIYA KAYAL",
// //         "time": "11:29 PM",
// //         "id": 49
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOVANKADU",
// //         "time": "12:24 AM",
// //         "id": 157
// //       },
// //       {
// //         "no": 8,
// //         "name": "SOUTHERN SALT",
// //         "time": "01:03 AM",
// //         "id": 127
// //       },
// //       {
// //         "no": 7,
// //         "name": "MULLAKADU",
// //         "time": "02:03 AM",
// //         "id": 46
// //       },
// //       {
// //         "no": 6,
// //         "name": "SPIC NAGAR",
// //         "time": "02:37 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 5,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "02:45 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 4,
// //         "name": "UPPATTHU ODAI",
// //         "time": "04:03 AM",
// //         "id": 43
// //       },
// //       {
// //         "no": 3,
// //         "name": "LEVANJIPURAM",
// //         "time": "04:51 AM",
// //         "id": 42
// //       },
// //       {
// //         "no": 2,
// //         "name": "MARKET",
// //         "time": "05:24 AM",
// //         "id": 41
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-1-493",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SEBATHAIAHPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:15 AM",
// //     "endTime": "12:30 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       306,
// //       164,
// //       291,
// //       13,
// //       12
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "11:20 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:23 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:31 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:33 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:42 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:46 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "11:51 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "11:53 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "12:03 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "12:07 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "12:13 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "12:17 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "12:21 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "12:26 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:30 PM",
// //         "id": 12
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-2-494",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "SEBATHAIAHPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:35 PM",
// //     "endTime": "01:40 PM",
// //     "ids": [
// //       12,
// //       13,
// //       291,
// //       164,
// //       306,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "12:35 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "12:38 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "12:42 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "12:46 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "12:49 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "12:54 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "12:58 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "01:06 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "01:07 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "01:12 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:16 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:23 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:25 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:32 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:35 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-3-495",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SEBATHAIAHPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:45 PM",
// //     "endTime": "02:50 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       306,
// //       164,
// //       291,
// //       13,
// //       12
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:49 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:52 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:59 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:01 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:08 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:12 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "02:17 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "02:18 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "02:26 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "02:30 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "02:35 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "02:38 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "02:42 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "02:46 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "02:50 PM",
// //         "id": 12
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-4-496",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "SEBATHAIAHPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:55 PM",
// //     "endTime": "04:00 PM",
// //     "ids": [
// //       12,
// //       13,
// //       291,
// //       164,
// //       306,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "02:55 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "02:58 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "03:02 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "03:06 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "03:09 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "03:14 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "03:18 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "03:26 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "03:27 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:32 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:36 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:43 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:45 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:52 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:55 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-5-497",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SEBATHAIAHPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:05 PM",
// //     "endTime": "05:20 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       306,
// //       164,
// //       291,
// //       13,
// //       12
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:10 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:13 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:21 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:23 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:32 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:36 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "04:41 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "04:43 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "04:53 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "04:57 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "05:03 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "05:07 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "05:11 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "05:16 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:20 PM",
// //         "id": 12
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-6-498",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "SEBATHAIAHPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:25 PM",
// //     "endTime": "06:40 PM",
// //     "ids": [
// //       12,
// //       13,
// //       291,
// //       164,
// //       306,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:25 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "05:28 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "05:33 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "05:37 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "05:41 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "05:47 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "05:51 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "06:01 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:03 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:08 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:12 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:21 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:23 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:31 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:34 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:40 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-7-499",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SEBATHAIAHPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 PM",
// //     "endTime": "08:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       306,
// //       164,
// //       291,
// //       13,
// //       12
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:04 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:08 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:15 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:17 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:25 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:29 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:34 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "07:36 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "07:44 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "07:49 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "07:54 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "07:57 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "08:01 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "08:06 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:10 PM",
// //         "id": 12
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-8-500",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "SEBATHAIAHPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 PM",
// //     "endTime": "09:25 PM",
// //     "ids": [
// //       12,
// //       13,
// //       291,
// //       164,
// //       306,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:15 PM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "08:18 PM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "08:23 PM",
// //         "id": 291
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "08:27 PM",
// //         "id": 164
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "08:30 PM",
// //         "id": 306
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "08:35 PM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "08:40 PM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "08:48 PM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:50 PM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:55 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:59 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:07 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:09 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:16 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:20 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-9-501",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SEBATHAIAHPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:30 AM",
// //     "endTime": "05:30 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       306,
// //       164,
// //       291,
// //       13,
// //       12
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:34 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:36 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:43 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:45 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:51 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:55 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "04:59 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "05:00 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "05:08 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "05:12 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "05:16 AM",
// //         "id": 306
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "05:19 AM",
// //         "id": 164
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "05:23 AM",
// //         "id": 291
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "05:26 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:30 AM",
// //         "id": 12
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-10-502",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "SEBATHAIAHPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:40 AM",
// //     "endTime": "06:45 AM",
// //     "ids": [
// //       12,
// //       13,
// //       291,
// //       164,
// //       306,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "05:40 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "05:43 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "05:47 AM",
// //         "id": 291
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "05:51 AM",
// //         "id": 164
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "05:54 AM",
// //         "id": 306
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "05:59 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "06:03 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "06:11 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "06:12 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:21 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:28 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:30 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:37 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:40 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-11-503",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SEBATHAIAHPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 AM",
// //     "endTime": "08:15 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       255,
// //       167,
// //       166,
// //       306,
// //       164,
// //       291,
// //       13,
// //       12
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:05 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:08 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:16 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:18 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:27 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:31 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "07:36 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "07:38 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "07:48 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "07:52 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "07:58 AM",
// //         "id": 306
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "08:02 AM",
// //         "id": 164
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "08:06 AM",
// //         "id": 291
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "08:11 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:15 AM",
// //         "id": 12
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-12-504",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-1",
// //     "tripCode": "56/P56G-156-GTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "SEBATHAIAHPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:22 AM",
// //     "endTime": "09:30 AM",
// //     "ids": [
// //       12,
// //       13,
// //       291,
// //       164,
// //       306,
// //       166,
// //       167,
// //       255,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 16,
// //         "name": "SEBATHAIAHPURAM",
// //         "time": "08:22 AM",
// //         "id": 12
// //       },
// //       {
// //         "no": 15,
// //         "name": "SAWYERPURAM",
// //         "time": "08:25 AM",
// //         "id": 13
// //       },
// //       {
// //         "no": 14,
// //         "name": "KUMARAPURAM 2",
// //         "time": "08:29 AM",
// //         "id": 291
// //       },
// //       {
// //         "no": 13,
// //         "name": "KATTALANKULAM",
// //         "time": "08:33 AM",
// //         "id": 164
// //       },
// //       {
// //         "no": 12,
// //         "name": "PUDHUR 3",
// //         "time": "08:36 AM",
// //         "id": 306
// //       },
// //       {
// //         "no": 11,
// //         "name": "MUDIVAITHANENDAL",
// //         "time": "08:42 AM",
// //         "id": 166
// //       },
// //       {
// //         "no": 10,
// //         "name": "VAGAIKULAM",
// //         "time": "08:46 AM",
// //         "id": 167
// //       },
// //       {
// //         "no": 9,
// //         "name": "RAMACHANDRAPURAM JUNCTION",
// //         "time": "08:54 AM",
// //         "id": 255
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "08:56 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:01 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:05 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:12 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:15 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:22 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:25 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-13-505",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-2",
// //     "tripCode": "56/P56G-256-GTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NORTH SILUKKANPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:35 AM",
// //     "endTime": "10:15 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       297,
// //       235,
// //       298,
// //       237,
// //       238
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:40 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:44 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:53 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "09:58 AM",
// //         "id": 297
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "10:04 AM",
// //         "id": 235
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "10:11 AM",
// //         "id": 298
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "10:13 AM",
// //         "id": 237
// //       },
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "10:15 AM",
// //         "id": 238
// //       }
// //     ]
// //   },
// //   {
// //     "id": "56-G-14-506",
// //     "routeNo": "56-G",
// //     "code": "56/P56G-2",
// //     "tripCode": "56/P56G-256-GTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "NORTH SILUKKANPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:20 AM",
// //     "endTime": "11:00 AM",
// //     "ids": [
// //       238,
// //       237,
// //       298,
// //       235,
// //       297,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "10:20 AM",
// //         "id": 238
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "10:21 AM",
// //         "id": 237
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "10:23 AM",
// //         "id": 298
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "10:30 AM",
// //         "id": 235
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "10:36 AM",
// //         "id": 297
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:41 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:50 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:54 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-1-507",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-1",
// //     "tripCode": "57/P57A-157-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SPIC NAGAR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 AM",
// //     "endTime": "07:20 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183,
// //       44,
// //       45
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "06:22 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "06:28 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:37 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:42 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:46 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:54 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:59 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "07:01 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 10,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:18 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 11,
// //         "name": "SPIC NAGAR",
// //         "time": "07:20 AM",
// //         "id": 45
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-2-508",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-1",
// //     "tripCode": "57/P57A-157-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "SPIC NAGAR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:25 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       45,
// //       44,
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 11,
// //         "name": "SPIC NAGAR",
// //         "time": "07:25 AM",
// //         "id": 45
// //       },
// //       {
// //         "no": 10,
// //         "name": "MUTHAIAHPURAM",
// //         "time": "07:25 AM",
// //         "id": 44
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "07:34 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "07:36 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "07:38 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "07:43 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "07:44 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "07:47 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "07:52 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:56 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-3-509",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-3",
// //     "tripCode": "57/P57A-357-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:10 AM",
// //     "endTime": "08:50 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:16 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:21 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:29 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:33 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:36 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:43 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "TTPP",
// //         "time": "08:43 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:47 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 10,
// //         "name": "CAMP-II",
// //         "time": "08:50 AM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-4-510",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:00 AM",
// //     "endTime": "09:35 AM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "09:00 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:02 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:05 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:11 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "09:14 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:17 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:24 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:29 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-5-511",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-3",
// //     "tripCode": "57/P57A-357-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 AM",
// //     "endTime": "10:20 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:46 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:51 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:59 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:03 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:06 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:13 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "TTPP",
// //         "time": "10:13 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:17 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 10,
// //         "name": "CAMP-II",
// //         "time": "10:20 AM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-6-512",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:25 AM",
// //     "endTime": "10:55 AM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "10:25 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:26 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:29 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:34 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:37 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:40 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "10:46 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:50 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:55 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-7-513",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:00 AM",
// //     "endTime": "11:30 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:00 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "11:04 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "11:08 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "11:14 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "11:17 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "11:20 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "11:25 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "11:28 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "11:30 AM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-8-514",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:35 AM",
// //     "endTime": "12:05 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "11:35 AM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "11:36 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "11:39 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "11:44 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "11:47 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "11:50 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "11:56 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "12:00 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-9-515",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:10 PM",
// //     "endTime": "12:50 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "12:16 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "12:21 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "12:29 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "12:33 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "12:36 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "12:43 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "12:47 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "12:50 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-10-516",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:55 PM",
// //     "endTime": "01:35 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "12:55 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "12:57 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "01:01 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "01:08 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "01:11 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "01:15 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "01:23 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "01:28 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-11-517",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:40 PM",
// //     "endTime": "02:15 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "01:45 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "01:50 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "01:57 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "02:00 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "02:03 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "02:09 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "02:12 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "02:15 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-12-518",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:20 PM",
// //     "endTime": "02:55 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "02:20 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "02:22 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "02:25 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "02:31 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "02:34 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "02:37 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "02:44 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "02:49 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-13-519",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:00 PM",
// //     "endTime": "03:35 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "03:05 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "03:10 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "03:17 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "03:20 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "03:23 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "03:29 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "03:32 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "03:35 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-14-520",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:40 PM",
// //     "endTime": "04:10 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "03:40 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "03:41 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "03:44 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "03:49 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "03:52 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "03:55 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "04:01 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "04:05 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-15-521",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:20 PM",
// //     "endTime": "05:15 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "04:28 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "04:36 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "04:46 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "04:52 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "04:56 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "05:06 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "05:11 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "05:15 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-16-522",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-3",
// //     "tripCode": "57/P57A-357-ATORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:20 PM",
// //     "endTime": "05:55 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 10,
// //         "name": "CAMP-II",
// //         "time": "05:20 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILDREN'S PARK",
// //         "time": "05:22 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 8,
// //         "name": "TTPP",
// //         "time": "05:25 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "05:25 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "05:31 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "05:34 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "05:37 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "05:44 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:49 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-17-523",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U17",
// //     "order": 17,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:00 PM",
// //     "endTime": "06:35 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "06:05 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "06:10 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:17 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:20 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:23 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:29 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:32 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "06:35 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-18-524",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:40 PM",
// //     "endTime": "07:45 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "06:40 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:43 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:50 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "07:01 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "07:06 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "07:13 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "07:25 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:34 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-19-525",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U19",
// //     "order": 19,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:50 PM",
// //     "endTime": "08:20 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:54 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "07:58 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:04 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:07 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:10 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:15 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:18 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "08:20 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-20-526",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D20",
// //     "order": 20,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:25 PM",
// //     "endTime": "08:55 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "08:25 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:26 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:29 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:34 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:37 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:40 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:46 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:50 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-21-527",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18U21",
// //     "order": 21,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CAMP-II",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:00 PM",
// //     "endTime": "09:35 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       183
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:05 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:10 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:17 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "09:20 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:23 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:29 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:32 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "09:35 PM",
// //         "id": 183
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-A-22-528",
// //     "routeNo": "57-A",
// //     "code": "57/P57A-2",
// //     "tripCode": "57/P57A-257-ATORD18D22",
// //     "order": 22,
// //     "direction": "D",
// //     "from": "CAMP-II",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 PM",
// //     "endTime": "10:30 PM",
// //     "ids": [
// //       183,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "CAMP-II",
// //         "time": "09:40 PM",
// //         "id": 183
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:42 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:47 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:56 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:00 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:05 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "10:15 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:22 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-1-529",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:10 PM",
// //     "endTime": "01:45 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "01:14 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "01:18 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "01:24 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "01:27 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "01:30 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "01:35 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "01:38 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "01:45 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-2-530",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:50 PM",
// //     "endTime": "02:25 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "01:50 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "01:56 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "01:59 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "02:04 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "02:07 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "02:10 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "02:16 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "02:20 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-3-531",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:30 PM",
// //     "endTime": "03:15 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "02:36 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "02:41 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "02:48 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "02:53 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "02:55 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "03:02 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "03:06 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "03:15 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-4-532",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:20 PM",
// //     "endTime": "03:50 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "03:20 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "03:25 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "03:28 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "03:32 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "03:34 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "03:37 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "03:42 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "03:45 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "03:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-5-533",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:10 PM",
// //     "endTime": "04:45 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:10 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "04:14 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "04:18 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "04:24 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "04:27 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "04:30 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "04:35 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "04:38 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "04:45 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-6-534",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:50 PM",
// //     "endTime": "05:25 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "04:50 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "04:56 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "04:59 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "05:04 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "05:07 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "05:10 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "05:16 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:20 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-7-535",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:40 PM",
// //     "endTime": "06:15 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:44 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "05:48 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "05:54 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "05:57 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:00 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:05 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:08 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "06:15 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-8-536",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:20 PM",
// //     "endTime": "06:55 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "06:20 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:26 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:29 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:34 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:37 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:40 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "06:46 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "06:50 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-9-537",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 PM",
// //     "endTime": "07:50 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:19 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "07:23 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "07:29 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "07:32 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "07:35 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "07:40 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "07:43 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "07:50 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-10-538",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:55 PM",
// //     "endTime": "08:30 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "07:55 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:01 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:04 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:09 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:12 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:15 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:21 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:25 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-11-539",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:35 PM",
// //     "endTime": "09:10 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:35 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:39 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:43 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:49 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:52 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:55 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:00 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:03 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "09:10 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-12-540",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:15 PM",
// //     "endTime": "09:45 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "09:15 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:20 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:23 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:27 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "09:29 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:32 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:37 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:40 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-13-541",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:00 PM",
// //     "endTime": "10:30 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:04 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "10:07 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:12 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:15 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:17 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:21 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:24 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "10:30 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-14-542",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:35 PM",
// //     "endTime": "11:00 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "10:35 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:39 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:41 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:45 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:47 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:49 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "10:53 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "10:56 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-15-543",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:50 AM",
// //     "endTime": "06:20 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "05:54 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "05:57 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:02 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:05 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:07 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:11 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:14 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "06:20 AM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-16-544",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:25 AM",
// //     "endTime": "07:00 AM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "06:25 AM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "06:31 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "06:34 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "06:39 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "06:42 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "06:45 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "06:51 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "06:55 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-17-545",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U17",
// //     "order": 17,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 AM",
// //     "endTime": "07:50 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:15 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "07:19 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "07:23 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "07:29 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "07:32 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "07:35 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "07:40 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "07:43 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "07:50 AM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-18-546",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D18",
// //     "order": 18,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:55 AM",
// //     "endTime": "08:25 AM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "07:55 AM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:00 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "08:03 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:07 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:09 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:12 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:17 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:20 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-19-547",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-2",
// //     "tripCode": "57/P57D-257-DTORD18U19",
// //     "order": 19,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:30 AM",
// //     "endTime": "09:05 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "08:34 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "08:38 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "08:44 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "08:47 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "08:50 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP JUNCTION",
// //         "time": "08:50 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 8,
// //         "name": "TTPP",
// //         "time": "08:55 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 9,
// //         "name": "CHILDREN'S PARK",
// //         "time": "08:58 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 10,
// //         "name": "NEW HARBOUR",
// //         "time": "09:05 AM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-20-548",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D20",
// //     "order": 20,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 AM",
// //     "endTime": "09:45 AM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "09:10 AM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "09:16 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "09:19 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "09:24 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "09:27 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "09:30 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:36 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:40 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-21-549",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U21",
// //     "order": 21,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 AM",
// //     "endTime": "10:25 AM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "09:54 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "09:58 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:04 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:07 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:10 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:15 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:18 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "10:25 AM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-22-550",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D22",
// //     "order": 22,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:40 AM",
// //     "endTime": "11:10 AM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "10:40 AM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "10:45 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "10:48 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "10:52 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "10:54 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "10:57 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "11:02 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "11:05 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:10 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-23-551",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18U23",
// //     "order": 23,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NEW HARBOUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:25 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       1,
// //       28,
// //       185,
// //       294,
// //       293,
// //       180,
// //       181,
// //       182,
// //       273
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "11:25 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "11:29 AM",
// //         "id": 28
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "11:33 AM",
// //         "id": 185
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "11:39 AM",
// //         "id": 294
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "11:42 AM",
// //         "id": 293
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "11:45 AM",
// //         "id": 180
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "11:50 AM",
// //         "id": 181
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "11:53 AM",
// //         "id": 182
// //       },
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "12:00 PM",
// //         "id": 273
// //       }
// //     ]
// //   },
// //   {
// //     "id": "57-D-24-552",
// //     "routeNo": "57-D",
// //     "code": "57/P57D-1",
// //     "tripCode": "57/P57D-157-DTORD18D24",
// //     "order": 24,
// //     "direction": "D",
// //     "from": "NEW HARBOUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:15 PM",
// //     "endTime": "12:45 PM",
// //     "ids": [
// //       273,
// //       182,
// //       181,
// //       180,
// //       293,
// //       294,
// //       185,
// //       28,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NEW HARBOUR",
// //         "time": "12:15 PM",
// //         "id": 273
// //       },
// //       {
// //         "no": 8,
// //         "name": "CHILDREN'S PARK",
// //         "time": "12:20 PM",
// //         "id": 182
// //       },
// //       {
// //         "no": 7,
// //         "name": "TTPP",
// //         "time": "12:23 PM",
// //         "id": 181
// //       },
// //       {
// //         "no": 6,
// //         "name": "THERMAL NAGAR JUNCTION",
// //         "time": "12:27 PM",
// //         "id": 180
// //       },
// //       {
// //         "no": 5,
// //         "name": "THERMAL NAGAR",
// //         "time": "12:29 PM",
// //         "id": 293
// //       },
// //       {
// //         "no": 4,
// //         "name": "CHEMICAL",
// //         "time": "12:32 PM",
// //         "id": 294
// //       },
// //       {
// //         "no": 3,
// //         "name": "ROCH PARK",
// //         "time": "12:37 PM",
// //         "id": 185
// //       },
// //       {
// //         "no": 2,
// //         "name": "SUB COLLECTOR OFFICE",
// //         "time": "12:40 PM",
// //         "id": 28
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-1-553",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-1",
// //     "tripCode": "58/P58A-158-ATORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHETTIYOORANI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:20 PM",
// //     "endTime": "02:30 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       253
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:26 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:30 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:39 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "01:42 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "01:52 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "01:59 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "02:13 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "02:21 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "02:25 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "CHETTIYOORANI",
// //         "time": "02:30 PM",
// //         "id": 253
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-2-554",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-1",
// //     "tripCode": "58/P58A-158-ATORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "CHETTIYOORANI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:35 PM",
// //     "endTime": "04:05 PM",
// //     "ids": [
// //       253,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 13,
// //         "name": "CHETTIYOORANI",
// //         "time": "02:35 PM",
// //         "id": 253
// //       },
// //       {
// //         "no": 12,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "02:41 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "02:46 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "02:56 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "03:14 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:23 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:35 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:39 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:51 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:57 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-3-555",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-4",
// //     "tripCode": "58/P58A-458-ATORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:00 PM",
// //     "endTime": "05:25 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:05 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:08 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:16 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:18 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:27 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "04:31 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:35 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "04:41 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "04:52 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "04:59 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 15,
// //         "name": "UMARIKOTTAI",
// //         "time": "05:07 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 17,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "05:14 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "05:25 PM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-4-556",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-2",
// //     "tripCode": "58/P58A-258-ATORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:30 PM",
// //     "endTime": "07:05 PM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "05:30 PM",
// //         "id": 276
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "05:42 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "05:51 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "06:01 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "06:10 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "06:24 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:31 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:41 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:44 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:54 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:58 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:05 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-5-557",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-6",
// //     "tripCode": "58/P58A-658-ATORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KALANKARAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 PM",
// //     "endTime": "07:25 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       277
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:05 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:09 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:17 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 6,
// //         "name": "KALANKARAI",
// //         "time": "07:25 PM",
// //         "id": 277
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-6-558",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-6",
// //     "tripCode": "58/P58A-658-ATORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "KALANKARAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:30 PM",
// //     "endTime": "08:10 PM",
// //     "ids": [
// //       277,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "KALANKARAI",
// //         "time": "07:30 PM",
// //         "id": 277
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:41 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:55 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:01 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:10 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-7-559",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-2",
// //     "tripCode": "58/P58A-258-ATORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:15 PM",
// //     "endTime": "06:55 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:15 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:56 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:27 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:33 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "10:53 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:01 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "12:49 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "02:24 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "03:20 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "04:30 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "05:30 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "06:55 AM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-8-560",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-2",
// //     "tripCode": "58/P58A-258-ATORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:00 AM",
// //     "endTime": "08:25 AM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "07:00 AM",
// //         "id": 276
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "07:11 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "07:19 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "07:28 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "07:35 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "07:48 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:54 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:03 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:06 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:15 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:19 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:25 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-9-561",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-6",
// //     "tripCode": "58/P58A-658-ATORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "KALANKARAI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:30 AM",
// //     "endTime": "08:55 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       277
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "08:30 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:35 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:39 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:47 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 6,
// //         "name": "KALANKARAI",
// //         "time": "08:55 AM",
// //         "id": 277
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-10-562",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-6",
// //     "tripCode": "58/P58A-658-ATORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "KALANKARAI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:00 AM",
// //     "endTime": "09:35 AM",
// //     "ids": [
// //       277,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "KALANKARAI",
// //         "time": "09:00 AM",
// //         "id": 277
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:10 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:21 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:27 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:35 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-11-563",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-5",
// //     "tripCode": "58/P58A-558-ATORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "SIPCOT",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 AM",
// //     "endTime": "10:05 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       78,
// //       226,
// //       225
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:46 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:50 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "09:54 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR JUNCTION",
// //         "time": "09:58 AM",
// //         "id": 226
// //       },
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "10:05 AM",
// //         "id": 225
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-12-564",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-5",
// //     "tripCode": "58/P58A-558-ATORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "SIPCOT",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:10 AM",
// //     "endTime": "10:40 AM",
// //     "ids": [
// //       225,
// //       226,
// //       78,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 6,
// //         "name": "SIPCOT COMPLEX",
// //         "time": "10:10 AM",
// //         "id": 225
// //       },
// //       {
// //         "no": 5,
// //         "name": "MADATTHOOR JUNCTION",
// //         "time": "10:17 AM",
// //         "id": 226
// //       },
// //       {
// //         "no": 4,
// //         "name": "BYPASS",
// //         "time": "10:22 AM",
// //         "id": 78
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:27 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:32 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:40 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-13-565",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-3",
// //     "tripCode": "58/P58A-358-ATORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:45 AM",
// //     "endTime": "11:55 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "10:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "10:49 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:52 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:58 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:00 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:07 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "11:12 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "11:22 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "11:27 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "11:30 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "11:33 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 15,
// //         "name": "UMARIKOTTAI",
// //         "time": "11:40 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 17,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "11:46 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "11:55 AM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-A-14-566",
// //     "routeNo": "58-A",
// //     "code": "58/P58A-3",
// //     "tripCode": "58/P58A-358-ATORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:00 PM",
// //     "endTime": "01:15 PM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "12:00 PM",
// //         "id": 276
// //       },
// //       {
// //         "no": 17,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "12:09 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 15,
// //         "name": "UMARIKOTTAI",
// //         "time": "12:15 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "12:23 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "12:26 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "12:29 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "12:35 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "12:45 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:50 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:57 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:00 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:07 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:10 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-1-567",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NORTH SILUKKANPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:30 PM",
// //     "endTime": "01:00 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       297,
// //       235,
// //       298,
// //       237,
// //       238
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "12:34 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:37 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:43 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "12:47 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "12:51 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "12:57 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "12:58 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "01:00 PM",
// //         "id": 238
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-2-568",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "NORTH SILUKKANPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:15 PM",
// //     "endTime": "01:55 PM",
// //     "ids": [
// //       238,
// //       237,
// //       298,
// //       235,
// //       297,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "01:15 PM",
// //         "id": 238
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "01:16 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "01:18 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "01:25 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "01:31 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:36 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "01:45 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "01:49 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "01:55 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-3-569",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-1",
// //     "tripCode": "58/P58B-158-BTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:00 PM",
// //     "endTime": "03:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:00 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:04 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:07 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:15 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:17 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:24 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "02:30 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "02:40 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "02:46 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "02:54 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "03:00 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "03:10 PM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-4-570",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-1",
// //     "tripCode": "58/P58B-158-BTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "03:15 PM",
// //     "endTime": "04:35 PM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "03:15 PM",
// //         "id": 276
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "03:25 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "03:33 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "03:41 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "03:48 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "04:00 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "04:06 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "04:15 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "04:17 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:25 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:29 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:35 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-5-571",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NORTH SILUKKANPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:45 PM",
// //     "endTime": "05:30 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       297,
// //       235,
// //       298,
// //       237,
// //       238
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:45 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "04:51 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "04:55 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:05 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "05:11 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "05:17 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "05:26 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "05:27 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "05:30 PM",
// //         "id": 238
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-6-572",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "NORTH SILUKKANPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:35 PM",
// //     "endTime": "06:30 PM",
// //     "ids": [
// //       238,
// //       237,
// //       298,
// //       235,
// //       297,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "05:35 PM",
// //         "id": 238
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "05:37 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "05:39 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "05:49 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "05:57 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:05 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:16 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:22 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:30 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-7-573",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-1",
// //     "tripCode": "58/P58B-158-BTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:40 PM",
// //     "endTime": "08:00 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:40 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:45 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:49 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:57 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:59 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:08 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "07:14 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "07:26 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "07:33 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "07:41 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "07:49 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "08:00 PM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-8-574",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-1",
// //     "tripCode": "58/P58B-158-BTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 PM",
// //     "endTime": "09:15 PM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "08:05 PM",
// //         "id": 276
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "08:14 PM",
// //         "id": 275
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "08:20 PM",
// //         "id": 274
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "08:28 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "08:34 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "08:44 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:50 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:57 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:59 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:07 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:10 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-9-575",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NORTH SILUKKANPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:20 PM",
// //     "endTime": "09:45 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       297,
// //       235,
// //       298,
// //       237,
// //       238
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:20 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:23 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:25 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:31 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "09:34 PM",
// //         "id": 297
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "09:38 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "09:42 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "09:43 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "09:45 PM",
// //         "id": 238
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-10-576",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "NORTH SILUKKANPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:50 PM",
// //     "endTime": "04:55 AM",
// //     "ids": [
// //       238,
// //       237,
// //       298,
// //       235,
// //       297,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "09:50 PM",
// //         "id": 238
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "10:09 PM",
// //         "id": 237
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "10:27 PM",
// //         "id": 298
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "11:44 PM",
// //         "id": 235
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "12:40 AM",
// //         "id": 297
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "01:42 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:14 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "03:56 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "04:55 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-11-577",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-2",
// //     "tripCode": "58/P58B-258-BTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:00 AM",
// //     "endTime": "06:10 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:00 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:04 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:07 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:13 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:15 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:22 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "05:27 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "05:37 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "05:42 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "05:45 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "05:48 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 15,
// //         "name": "UMARIKOTTAI",
// //         "time": "05:55 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 17,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "06:01 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 19,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "06:10 AM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-12-578",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-2",
// //     "tripCode": "58/P58B-258-BTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:15 AM",
// //     "endTime": "07:35 AM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 19,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "06:15 AM",
// //         "id": 276
// //       },
// //       {
// //         "no": 17,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "06:24 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 15,
// //         "name": "UMARIKOTTAI",
// //         "time": "06:31 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "06:39 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "06:42 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "06:46 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "06:52 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "07:03 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:08 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:16 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:19 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:26 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:30 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:35 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-13-579",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18U13",
// //     "order": 13,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "NORTH SILUKKANPATTI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:45 AM",
// //     "endTime": "08:20 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       297,
// //       235,
// //       298,
// //       237,
// //       238
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "07:45 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "07:49 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "07:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:00 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "08:05 AM",
// //         "id": 297
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "08:10 AM",
// //         "id": 235
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "08:16 AM",
// //         "id": 298
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "08:18 AM",
// //         "id": 237
// //       },
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "08:20 AM",
// //         "id": 238
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-14-580",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-3",
// //     "tripCode": "58/P58B-358-BTORD18D14",
// //     "order": 14,
// //     "direction": "D",
// //     "from": "NORTH SILUKKANPATTI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:25 AM",
// //     "endTime": "09:30 AM",
// //     "ids": [
// //       238,
// //       237,
// //       298,
// //       235,
// //       297,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 9,
// //         "name": "NORTH SILUKKANPATTI",
// //         "time": "08:25 AM",
// //         "id": 238
// //       },
// //       {
// //         "no": 8,
// //         "name": "MADATTHUPATTI",
// //         "time": "08:28 AM",
// //         "id": 237
// //       },
// //       {
// //         "no": 7,
// //         "name": "MUTHUSAMYPURAM",
// //         "time": "08:30 AM",
// //         "id": 298
// //       },
// //       {
// //         "no": 6,
// //         "name": "RAMANACCHIYARPURAM",
// //         "time": "08:42 AM",
// //         "id": 235
// //       },
// //       {
// //         "no": 5,
// //         "name": "KAILASAPURAM",
// //         "time": "08:51 AM",
// //         "id": 297
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:00 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:14 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:21 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-15-581",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-1",
// //     "tripCode": "58/P58B-158-BTORD18U15",
// //     "order": 15,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHOCKALINGAPURAM",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:40 AM",
// //     "endTime": "11:00 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       250,
// //       251,
// //       252,
// //       274,
// //       275,
// //       276
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:40 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:45 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:49 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:57 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:59 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "10:08 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "10:14 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "10:26 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "10:33 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "10:41 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "10:49 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "11:00 AM",
// //         "id": 276
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-B-16-582",
// //     "routeNo": "58-B",
// //     "code": "58/P58B-1",
// //     "tripCode": "58/P58B-158-BTORD18D16",
// //     "order": 16,
// //     "direction": "D",
// //     "from": "CHOCKALINGAPURAM",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "11:10 AM",
// //     "endTime": "12:15 PM",
// //     "ids": [
// //       276,
// //       275,
// //       274,
// //       252,
// //       251,
// //       250,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHOCKALINGAPURAM",
// //         "time": "11:10 AM",
// //         "id": 276
// //       },
// //       {
// //         "no": 15,
// //         "name": "VARADHARAJAPURAM",
// //         "time": "11:18 AM",
// //         "id": 275
// //       },
// //       {
// //         "no": 13,
// //         "name": "UMARIKOTTAI",
// //         "time": "11:24 AM",
// //         "id": 274
// //       },
// //       {
// //         "no": 11,
// //         "name": "MELA THATTAPARAI",
// //         "time": "11:31 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 10,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "11:37 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 7,
// //         "name": "SILUKKAN PATTI",
// //         "time": "11:47 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:51 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:58 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:00 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:07 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "12:10 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:15 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-1-583",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18U1",
// //     "order": 1,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "12:05 PM",
// //     "endTime": "01:10 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       196,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:05 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "12:09 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "12:12 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "12:18 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "12:20 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:27 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:31 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:34 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "12:39 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "12:49 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "12:54 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "12:57 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "01:07 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:10 PM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-2-584",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18D2",
// //     "order": 2,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "01:15 PM",
// //     "endTime": "02:45 PM",
// //     "ids": [
// //       74,
// //       196,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "01:15 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "01:18 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "01:32 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "01:36 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "01:43 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "01:57 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:03 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "02:08 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "02:13 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "02:23 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "02:25 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "02:35 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:39 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:45 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-3-585",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18U3",
// //     "order": 3,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "02:50 PM",
// //     "endTime": "04:30 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       196,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "02:50 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "02:56 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "03:01 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "03:11 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "03:14 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:24 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "03:30 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "03:35 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "03:43 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "03:57 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "04:06 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "04:10 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "04:26 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:30 PM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-4-586",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18D4",
// //     "order": 4,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "04:35 PM",
// //     "endTime": "05:50 PM",
// //     "ids": [
// //       74,
// //       196,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "04:35 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "04:37 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "04:49 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "04:52 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "04:59 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "05:10 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:15 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "05:19 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "05:23 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "05:31 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "05:34 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "05:41 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:45 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:50 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-5-587",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18U5",
// //     "order": 5,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:55 PM",
// //     "endTime": "07:00 PM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       196,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "05:55 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "05:59 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:02 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:08 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:10 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:17 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:21 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:24 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "06:29 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "06:39 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "06:44 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "06:47 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "06:57 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:00 PM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-6-588",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18D6",
// //     "order": 6,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "07:15 PM",
// //     "endTime": "09:25 PM",
// //     "ids": [
// //       74,
// //       196,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "07:15 PM",
// //         "id": 74
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "07:19 PM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "07:40 PM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "07:45 PM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "07:56 PM",
// //         "id": 251
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "08:15 PM",
// //         "id": 250
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:25 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:32 PM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:39 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:53 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:57 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:10 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:16 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:25 PM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-7-589",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-2",
// //     "tripCode": "58/P58C-258-CTORD18U7",
// //     "order": 7,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:30 PM",
// //     "endTime": "05:00 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       253,
// //       254,
// //       196,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:30 PM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "09:56 PM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "10:16 PM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "10:58 PM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:11 PM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:54 PM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "12:17 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "12:40 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "01:10 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "02:11 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "02:47 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHETTIYOORANI",
// //         "time": "03:18 AM",
// //         "id": 253
// //       },
// //       {
// //         "no": 15,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "03:39 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 17,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "04:45 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 18,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:00 AM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-8-590",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-2",
// //     "tripCode": "58/P58C-258-CTORD18D8",
// //     "order": 8,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "05:15 AM",
// //     "endTime": "06:45 AM",
// //     "ids": [
// //       74,
// //       196,
// //       254,
// //       253,
// //       252,
// //       251,
// //       250,
// //       6,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 18,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "05:15 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 17,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "05:17 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 15,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "05:31 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 14,
// //         "name": "CHETTIYOORANI",
// //         "time": "05:35 AM",
// //         "id": 253
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "05:41 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "05:48 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "06:00 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:06 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "06:11 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "06:16 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "06:24 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "06:27 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:35 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:39 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:45 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-9-591",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18U9",
// //     "order": 9,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "PUTHIYAMPUTHUR",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "06:50 AM",
// //     "endTime": "08:00 AM",
// //     "ids": [
// //       1,
// //       29,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       6,
// //       250,
// //       251,
// //       252,
// //       254,
// //       196,
// //       74
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "06:50 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "06:54 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "06:57 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "07:04 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "07:07 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:14 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "07:18 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "07:22 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "07:27 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "07:37 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "07:43 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "07:46 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "07:57 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:00 AM",
// //         "id": 74
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-10-592",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-1",
// //     "tripCode": "58/P58C-158-CTORD18D10",
// //     "order": 10,
// //     "direction": "D",
// //     "from": "PUTHIYAMPUTHUR",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "08:05 AM",
// //     "endTime": "09:00 AM",
// //     "ids": [
// //       74,
// //       196,
// //       254,
// //       252,
// //       251,
// //       250,
// //       6,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       29,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "PUTHIYAMPUTHUR",
// //         "time": "08:05 AM",
// //         "id": 74
// //       },
// //       {
// //         "no": 16,
// //         "name": "VALLINAYAGIPURAM",
// //         "time": "08:06 AM",
// //         "id": 196
// //       },
// //       {
// //         "no": 14,
// //         "name": "CAMP THATTAPARAI",
// //         "time": "08:15 AM",
// //         "id": 254
// //       },
// //       {
// //         "no": 13,
// //         "name": "MELA THATTAPARAI",
// //         "time": "08:17 AM",
// //         "id": 252
// //       },
// //       {
// //         "no": 12,
// //         "name": "KEELA THATTAPARAI",
// //         "time": "08:22 AM",
// //         "id": 251
// //       },
// //       {
// //         "no": 9,
// //         "name": "SILUKKAN PATTI",
// //         "time": "08:30 AM",
// //         "id": 250
// //       },
// //       {
// //         "no": 8,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:34 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "08:37 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "08:40 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "08:46 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "08:48 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "08:53 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "MILLER PURAM",
// //         "time": "08:56 AM",
// //         "id": 29
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:00 AM",
// //         "id": 1
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-11-593",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-3",
// //     "tripCode": "58/P58C-358-CTORD18U11",
// //     "order": 11,
// //     "direction": "U",
// //     "from": "THOOTHUKUDI",
// //     "to": "CHEKKARAKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "09:10 AM",
// //     "endTime": "10:20 AM",
// //     "ids": [
// //       1,
// //       2,
// //       39,
// //       4,
// //       5,
// //       6,
// //       278,
// //       21,
// //       241,
// //       23,
// //       24,
// //       243,
// //       303,
// //       304,
// //       244,
// //       245
// //     ],
// //     "stops": [
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "09:10 AM",
// //         "id": 1
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "09:14 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "09:18 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "09:25 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "09:27 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "09:35 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "09:39 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "09:44 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "09:44 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "09:54 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "09:59 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "10:02 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "10:07 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "10:13 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "10:17 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "10:20 AM",
// //         "id": 245
// //       }
// //     ]
// //   },
// //   {
// //     "id": "58-C-12-594",
// //     "routeNo": "58-C",
// //     "code": "58/P58C-3",
// //     "tripCode": "58/P58C-358-CTORD18D12",
// //     "order": 12,
// //     "direction": "D",
// //     "from": "CHEKKARAKUDI",
// //     "to": "THOOTHUKUDI",
// //     "service": "TOWN ORDINARY",
// //     "startTime": "10:25 AM",
// //     "endTime": "12:00 PM",
// //     "ids": [
// //       245,
// //       244,
// //       304,
// //       303,
// //       243,
// //       24,
// //       23,
// //       241,
// //       21,
// //       278,
// //       6,
// //       5,
// //       4,
// //       39,
// //       2,
// //       1
// //     ],
// //     "stops": [
// //       {
// //         "no": 17,
// //         "name": "CHEKKARAKUDI",
// //         "time": "10:25 AM",
// //         "id": 245
// //       },
// //       {
// //         "no": 15,
// //         "name": "MAHILAMPURAM",
// //         "time": "10:28 AM",
// //         "id": 244
// //       },
// //       {
// //         "no": 14,
// //         "name": "THALAVAIPURAM 2",
// //         "time": "10:34 AM",
// //         "id": 304
// //       },
// //       {
// //         "no": 13,
// //         "name": "PUDHUR 2",
// //         "time": "10:41 AM",
// //         "id": 303
// //       },
// //       {
// //         "no": 12,
// //         "name": "SAMATTHUVAPURAM",
// //         "time": "10:49 AM",
// //         "id": 243
// //       },
// //       {
// //         "no": 11,
// //         "name": "PEROORANI",
// //         "time": "10:52 AM",
// //         "id": 24
// //       },
// //       {
// //         "no": 10,
// //         "name": "THIRUVANANDHA PURAM",
// //         "time": "10:59 AM",
// //         "id": 23
// //       },
// //       {
// //         "no": 9,
// //         "name": "KOOTTUDANKADU",
// //         "time": "11:13 AM",
// //         "id": 241
// //       },
// //       {
// //         "no": 8,
// //         "name": "MANGALAGIRI",
// //         "time": "11:13 AM",
// //         "id": 21
// //       },
// //       {
// //         "no": 7,
// //         "name": "PUDHUKOTTAI 2",
// //         "time": "11:20 AM",
// //         "id": 278
// //       },
// //       {
// //         "no": 6,
// //         "name": "THATTAPARAI JUNCTION",
// //         "time": "11:25 AM",
// //         "id": 6
// //       },
// //       {
// //         "no": 5,
// //         "name": "ANTHONIYARPURAM",
// //         "time": "11:36 AM",
// //         "id": 5
// //       },
// //       {
// //         "no": 4,
// //         "name": "KORAMPALLAM",
// //         "time": "11:39 AM",
// //         "id": 4
// //       },
// //       {
// //         "no": 3,
// //         "name": "3RD MILE",
// //         "time": "11:49 AM",
// //         "id": 39
// //       },
// //       {
// //         "no": 2,
// //         "name": "VOC COLLEGE",
// //         "time": "11:53 AM",
// //         "id": 2
// //       },
// //       {
// //         "no": 1,
// //         "name": "THOOTHUKUDI OLD B/S",
// //         "time": "12:00 PM",
// //         "id": 1
// //       }
// //     ]
// //   }
// // ];

// // const VEHICLES = Object.keys(VEHICLE_ROUTE_MAP);

// // function normalizeVehicleNo(v) {
// //   return String(v || "").trim().toUpperCase().replace(/\s+/g, "");
// // }

// // function normalizeRouteNo(v) {
// //   const s = String(v || "").trim().toUpperCase().replace(/\s+/g, "");
// //   if (!s) return "";
// //   const detailed = s.match(/^(\d+)\/P\d+([A-Z])-\d+/);
// //   if (detailed) return `${detailed[1]}-${detailed[2]}`;
// //   const compact = s.match(/^(\d+)[-/]?([A-Z])$/);
// //   if (compact) return `${compact[1]}-${compact[2]}`;
// //   return s;
// // }

// // function canonicalRoute(code) {
// //   return String(code || "").trim().toUpperCase().replace(/\s+/g, "");
// // }

// // const ROUTE_NO_BY_CODE = ROUTE_TRIPS.reduce((acc, trip) => {
// //   if (trip.code && trip.routeNo) acc[trip.code] = trip.routeNo;
// //   return acc;
// // }, {});

// // function routeNoFromRouteCode(code) {
// //   const raw = String(code || "").trim().toUpperCase().replace(/\s+/g, "");
// //   if (!raw) return "";
// //   if (ROUTE_NO_BY_CODE[raw]) return ROUTE_NO_BY_CODE[raw];
// //   return normalizeRouteNo(raw);
// // }

// // function getAssignedRouteValue(vehicleno, assignments = {}) {
// //   const vehicleNo = normalizeVehicleNo(vehicleno);
// //   return (
// //     assignments?.[vehicleNo] ||
// //     assignments?.[vehicleno] ||
// //     VEHICLE_ROUTE_MAP[vehicleNo] ||
// //     ""
// //   );
// // }

// // function getBusRouteNo(vehicleno, assignments = {}) {
// //   return routeNoFromRouteCode(getAssignedRouteValue(vehicleno, assignments));
// // }

// // function getRouteDisplayLabel(routeValue) {
// //   const routeNo = routeNoFromRouteCode(routeValue);
// //   const route = ROUTES.find((r) => r.code === routeNo);
// //   return route?.label || routeNo || "Unassigned";
// // }

// // function routeCandidatesForValue(routeValue) {
// //   const raw = String(routeValue || "").trim().toUpperCase().replace(/\s+/g, "");
// //   const routeNo = routeNoFromRouteCode(raw);

// //   const exactCodeMatches = ROUTE_TRIPS.filter((trip) => trip.code === raw);
// //   if (exactCodeMatches.length) return exactCodeMatches;

// //   return ROUTE_TRIPS.filter((trip) => trip.routeNo === routeNo);
// // }

// // // ---- Leaflet default icon fix ----
// // delete L.Icon.Default.prototype._getIconUrl;
// // L.Icon.Default.mergeOptions({
// //   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
// //   iconUrl: require('leaflet/dist/images/marker-icon.png'),
// //   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// // });

// // // ---- Utility helpers ----
// // const createCustomIcon = (iconUrl, size = [40, 40]) =>
// //   L.icon({
// //     iconUrl,
// //     iconSize: size,
// //     iconAnchor: [size[0] / 2, size[1]],
// //     popupAnchor: [0, -size[1] / 2]
// //   });

// // const userIconInstance = createCustomIcon(userIcon, [40, 40]);

// // const toHeading = (v) => {
// //   const n = Number(v);
// //   return Number.isFinite(n) ? ((n % 360) + 360) % 360 : null;
// // };

// // const toFiniteNumber = (value) => {
// //   if (value === null || value === undefined || value === '') return null;
// //   const n = Number(value);
// //   return Number.isFinite(n) ? n : null;
// // };

// // function normalizeLatLng(latValue, lngValue) {
// //   const lat = toFiniteNumber(latValue);
// //   const lng = toFiniteNumber(lngValue);
// //   if (lat === null || lng === null) return null;
// //   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
// //   return { lat, lng };
// // }

// // function hasValidLatLng(value) {
// //   return !!normalizeLatLng(value?.lat, value?.lng);
// // }

// // // Exponential smoothing for latitude/longitude
// // function smoothCoord(prev, next, alpha = SMOOTH_ALPHA) {
// //   const safeNext = normalizeLatLng(next?.lat, next?.lng);
// //   if (!safeNext) return normalizeLatLng(prev?.lat, prev?.lng);

// //   const safePrev = normalizeLatLng(prev?.lat, prev?.lng);
// //   if (!safePrev) return safeNext;

// //   return {
// //     lat: safePrev.lat + alpha * (safeNext.lat - safePrev.lat),
// //     lng: safePrev.lng + alpha * (safeNext.lng - safePrev.lng)
// //   };
// // }



// // // Circular smoothing for heading (degrees)
// // function smoothHeading(prevDeg, nextDeg, alpha = HEADING_ALPHA) {
// //   if (!Number.isFinite(prevDeg)) return nextDeg;
// //   if (!Number.isFinite(nextDeg)) return prevDeg;
// //   const p = (prevDeg * Math.PI) / 180;
// //   const n = (nextDeg * Math.PI) / 180;
// //   const x = (1 - alpha) * Math.cos(p) + alpha * Math.cos(n);
// //   const y = (1 - alpha) * Math.sin(p) + alpha * Math.sin(n);
// //   const ang = (Math.atan2(y, x) * 180) / Math.PI;
// //   return (((ang % 360) + 360) % 360);
// // }
// // function mBetween(a, b) {
// //   const aa = normalizeLatLng(a?.lat, a?.lng);
// //   const bb = normalizeLatLng(b?.lat, b?.lng);
// //   if (!aa || !bb) return Infinity;
// //   return L.latLng(aa.lat, aa.lng).distanceTo(L.latLng(bb.lat, bb.lng));
// // }

// // // ---- Cart classification (case-insensitive "EV") ----
// // function isCart(vehicleno) {
// //   const s = String(vehicleno || '').trim();
// //   return s.toUpperCase().startsWith('EV');
// // }

// // // Label: B for Bus, C for Cart
// // // function vehicleLabel(vehicleno) { return isCart(vehicleno) ? 'C' : 'B'; }
// // function vehicleLabel(vehicleno, routeCode) {
// //   if (!isCart(vehicleno)) return "B";

// //   const rc = canonicalRoute(routeCode || "");
// //   if (rc === "RP_ED" || rc === "ED_RP") return "CR"; // 👈 cart on RP↔ED
// //   return "C";
// // }


// // // ---- Block IDs starting with a digit ----
// // function startsWithDigit(vehicleno) { return /^[0-9]/.test(String(vehicleno || '')); }

// // // ---- Direction pointer “on the circle” DivIcon ----
// // // function createVehicleDivIcon(label, headingDeg) {
// // //   const circle = 20;
// // //   const border = 3;
// // //   const triH = 18;
// // //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// // //   const totalH = triH + circle;

// // //   const html = `
// // //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// // //       <div style="
// // //         position:absolute; left:0; right:0; bottom:0;
// // //         width:${circle}px; height:${circle}px;
// // //         border:${border}px solid #0D47A1; background:#ffffff; border-radius:50%;
// // //         display:flex; align-items:center; justify-content:center;
// // //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// // //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // //         letter-spacing:0.6px; user-select:none;">
// // //         <span style="font-size:16px; color:#0D47A1">${label}</span>
// // //       </div>
// // //       <div style="
// // //         position:absolute; left:50%; top:0;
// // //         transform: translateX(-250%) rotate(${rot}deg);
// // //         transform-origin: 50% ${triH * 0.7}px;
// // //         width:0; height:0;
// // //         border-left:${triH / 4}px solid transparent;
// // //         border-right:${triH / 4}px solid transparent;
// // //         border-bottom:${triH}px solid #0D47A1;
// // //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// // //         z-index: 2; pointer-events: none;"></div>
// // //     </div>
// // //   `;

// // //   return L.divIcon({
// // //     className: 'veh-div-icon',
// // //     html,
// // //     iconSize: [circle, totalH],
// // //     iconAnchor: [circle / 2, totalH - circle / 2],
// // //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// // //   });
// // // }

// // function createVehicleDivIcon(label, headingDeg, palette) {
// //   const circle = 20;
// //   const border = 3;
// //   const triH = 18;
// //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// //   const totalH = triH + circle;

// //   // default bus palette
// //   const p = palette || {
// //     stroke: "#0D47A1",
// //     fill: "#ffffff",
// //     text: "#0D47A1",
// //     pointer: "#0D47A1",
// //   };

// //   const html = `
// //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// //       <div style="
// //         position:absolute; left:0; right:0; bottom:0;
// //         width:${circle}px; height:${circle}px;
// //         border:${border}px solid ${p.stroke};
// //         background:${p.fill};
// //         border-radius:50%;
// //         display:flex; align-items:center; justify-content:center;
// //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// //         letter-spacing:0.6px; user-select:none;">
// //         <span style="font-size:16px; color:${p.text}">${label}</span>
// //       </div>
// //       <div style="
// //         position:absolute; left:50%; top:0;
// //         transform: translateX(-250%) rotate(${rot}deg);
// //         transform-origin: 50% ${triH * 0.7}px;
// //         width:0; height:0;
// //         border-left:${triH / 4}px solid transparent;
// //         border-right:${triH / 4}px solid transparent;
// //         border-bottom:${triH}px solid ${p.pointer};
// //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// //         z-index: 2; pointer-events: none;"></div>
// //     </div>
// //   `;

// //   return L.divIcon({
// //     className: 'veh-div-icon',
// //     html,
// //     iconSize: [circle, totalH],
// //     iconAnchor: [circle / 2, totalH - circle / 2],
// //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// //   });
// // }

// // // const BUS_PALETTE = {
// // //   stroke: "#0D47A1",
// // //   fill: "#ffffff",
// // //   text: "#0D47A1",
// // //   pointer: "#0D47A1",
// // // };

// // // const BUS_PALETTE = {
// // //   stroke: "#EA580C",   // orange bus border
// // //   fill: "#FFF7ED",     // light orange fill
// // //   text: "#9A3412",
// // //   pointer: "#EA580C",
// // // };

// // // const CART_PALETTE = {
// // //   stroke: "#0F766E",  // teal border
// // //   fill: "#ECFEFF",    // light teal fill
// // //   text: "#0F766E",
// // //   pointer: "#0F766E",
// // // };
// // const CART_PALETTE = {
// //   stroke: "#111827",   // near-black border
// //   fill: "#FEF08A",   // bright yellow fill
// //   text: "#111827",   // black text
// //   pointer: "#111827",   // black pointer
// // };

// // const BUS_PALETTE = {
// //   stroke: "#111827",   // near-black border
// //   fill: "#FEF08A",   // bright yellow fill
// //   text: "#111827",   // black text
// //   pointer: "#111827",   // black pointer
// // };



// // function matchesFilter(vehicleno, filter, assignments) {
// //   const cart = isCart(vehicleno);
// //   if (filter === "cart") return cart;
// //   if (filter === "bus") return !cart;

// //   if (filter?.startsWith("route:")) {
// //     const requested = normalizeRouteNo(filter.slice(6));
// //     const actualRouteNo = normalizeRouteNo(getBusRouteNo(vehicleno, assignments));
// //     const assignedRaw = getAssignedRouteValue(vehicleno, assignments);
// //     const assignedRouteNo = normalizeRouteNo(routeNoFromRouteCode(assignedRaw));

// //     return actualRouteNo === requested || assignedRouteNo === requested;
// //   }
// //   return true;
// // }

// // // ---- Filter helper ----
// // // function matchesFilter(vehicleno, filter, assignments) {
// // //   const cart = isCart(vehicleno);
// // //   if (filter === 'cart') return cart;
// // //   if (filter === 'bus')  return !cart;
// // //   if (filter?.startsWith('route:')) {
// // //     const code = filter.slice(6);
// // //     return assignments[vehicleno] === code;
// // //   }
// // //   return true;
// // // }

// // // ---------------- Tiny router helpers (for /driver, /driverRoute) ----------------
// // function usePath() {
// //   const [path, setPath] = useState(window.location.pathname);
// //   useEffect(() => {
// //     const onPop = () => setPath(window.location.pathname);
// //     window.addEventListener('popstate', onPop);
// //     return () => window.removeEventListener('popstate', onPop);
// //   }, []);
// //   const navigate = (p) => { if (p !== window.location.pathname) { window.history.pushState({}, "", p); setPath(p); } };
// //   return { path, navigate };
// // }
// // function getToken() { return localStorage.getItem("driverToken") || ""; }
// // function setToken(t) { localStorage.setItem("driverToken", t || ""); }
// // function getUsername() { return localStorage.getItem("driverUsername") || ""; }
// // function setUsername(u) { localStorage.setItem("driverUsername", u || ""); }

// // // --- Admin auth helpers (separate from driver) ---
// // function getAdminToken() {
// //   return localStorage.getItem("adminToken") || "";
// // }
// // function setAdminToken(t) {
// //   localStorage.setItem("adminToken", t || "");
// // }


// // // ---------------- Driver pages ----------------
// // // --- small responsive hook for narrow phones ---
// // function useIsNarrow(bp = 380) {
// //   const [isNarrow, setIsNarrow] = useState(window.innerWidth <= bp);
// //   useEffect(() => {
// //     const onResize = () => setIsNarrow(window.innerWidth <= bp);
// //     window.addEventListener('resize', onResize);
// //     return () => window.removeEventListener('resize', onResize);
// //   }, [bp]);
// //   return isNarrow;
// // }

// // function DriverLogin({ navigate }) {
// //   const [username, setU] = useState("");
// //   const [password, setP] = useState("");
// //   const [err, setErr] = useState("");
// //   const [busy, setBusy] = useState(false);
// //   const isNarrow = useIsNarrow(380);

// //   useEffect(() => {
// //     if (getToken()) navigate("/driverRoute");
// //   }, [navigate]);

// //   const onSubmit = async (e) => {
// //     e.preventDefault();
// //     setErr(""); setBusy(true);
// //     try {
// //       const r = await axios.post(`${BACKEND}/api/driver/login`, { username, password });
// //       if (r.data?.success && r.data?.token) {
// //         setToken(r.data.token);
// //         setUsername(r.data.username);
// //         navigate("/driverRoute");
// //       } else setErr("Login failed");
// //     } catch (e1) {
// //       setErr(e1?.response?.data?.message || "Login failed");
// //     } finally { setBusy(false); }
// //   };

// //   return (
// //     <div
// //       style={{
// //         padding: isNarrow ? 12 : 20,
// //         margin: isNarrow ? "16px auto" : "32px auto",
// //         width: "min(100vw - 24px, 560px)",
// //       }}
// //     >
// //       {/* Header with Home button */}
// //       <div
// //         style={{
// //           display: "flex",
// //           alignItems: "center",
// //           gap: isNarrow ? 10 : 12,
// //           marginBottom: isNarrow ? 10 : 14,
// //           flexWrap: "wrap",
// //         }}
// //       >
// //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// //           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Driver Login</h2>
// //         </div>

// //         <button
// //           type="button"
// //           onClick={() => navigate("/")}
// //           style={{
// //             marginLeft: "auto",
// //             padding: isNarrow ? "6px 10px" : "8px 12px",
// //             borderRadius: 10,
// //             border: "1px solid #D1D5DB",
// //             background: "#FFFFFF",
// //             fontWeight: 700,
// //             fontSize: isNarrow ? 13 : 14,
// //             cursor: "pointer",
// //           }}
// //           title="Go to Home"
// //         >
// //           Home
// //         </button>
// //       </div>

// //       {/* Card */}
// //       <div
// //         style={{
// //           background: "#fff",
// //           border: "1px solid #E5E7EB",
// //           borderRadius: 12,
// //           padding: isNarrow ? 12 : 16,
// //         }}
// //       >
// //         <form onSubmit={onSubmit} style={{ display: "grid", gap: isNarrow ? 8 : 10 }}>
// //           <input
// //             value={username}
// //             onChange={(e) => setU(e.target.value)}
// //             placeholder="username"
// //             required
// //             style={{
// //               padding: isNarrow ? 10 : 12,
// //               borderRadius: 10,
// //               border: "1px solid #D1D5DB",
// //               fontWeight: 600,
// //               fontSize: isNarrow ? 14 : 16,
// //             }}
// //           />
// //           <input
// //             value={password}
// //             onChange={(e) => setP(e.target.value)}
// //             placeholder="password"
// //             type="password"
// //             required
// //             style={{
// //               padding: isNarrow ? 10 : 12,
// //               borderRadius: 10,
// //               border: "1px solid #D1D5DB",
// //               fontWeight: 600,
// //               fontSize: isNarrow ? 14 : 16,
// //             }}
// //           />
// //           <button
// //             disabled={busy}
// //             style={{
// //               padding: isNarrow ? "10px 12px" : "12px 14px",
// //               borderRadius: 10,
// //               border: "1px solid #0D47A1",
// //               background: "#0D47A1",
// //               color: "#fff",
// //               fontWeight: 800,
// //               cursor: "pointer",
// //               width: "100%",
// //               minHeight: 40,
// //               fontSize: "clamp(14px, 3.5vw, 16px)",
// //             }}
// //           >
// //             {busy ? "Signing in..." : "Login"}
// //           </button>
// //           {err && <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>}
// //         </form>
// //       </div>
// //     </div>
// //   );
// // }

// // function DriverRoute({ navigate }) {
// //   const [routeCode, setRouteCode] = useState("");
// //   const [vehicleNo, setVehicleNo] = useState("");
// //   const [autoPilot, setAutoPilot] = useState(false); // 👈 NEW: auto-pilot flag
// //   const [saved, setSaved] = useState(false);
// //   const [busy, setBusy] = useState(false);
// //   const [err, setErr] = useState("");
// //   const isNarrow = useIsNarrow(380);

// //   useEffect(() => {
// //     if (!getToken()) navigate("/driver");
// //     (async () => {
// //       try {
// //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// //           headers: { Authorization: `Bearer ${getToken()}` },
// //         });
// //         const row = r.data?.row;
// //         if (row) {
// //           setVehicleNo(row.vehicleNo);
// //           setRouteCode(row.routeCode);
// //           setAutoPilot(!!row.autopilotEnabled); // 👈 load auto-pilot state from backend
// //           setSaved(true);
// //         }
// //       } catch { }
// //     })();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const onSave = async (e) => {
// //     e.preventDefault();
// //     setErr(""); setBusy(true);
// //     try {
// //       await axios.post(
// //         `${BACKEND}/api/vehicle-route/assign`,
// //         {
// //           vehicleNo,
// //           routeCode,
// //           active: true,
// //           autopilotEnabled: autoPilot, // 👈 send auto-pilot choice to backend
// //         },
// //         { headers: { Authorization: `Bearer ${getToken()}` } }
// //       );
// //       setSaved(true);
// //     } catch (e1) {
// //       setErr(e1?.response?.data?.message || "Save failed");
// //     } finally {
// //       setBusy(false);
// //     }
// //   };

// //   return (
// //     <div
// //       style={{
// //         padding: isNarrow ? 16 : 20,
// //         maxWidth: 640,
// //         margin: isNarrow ? "16px auto" : "32px auto",
// //         width: "min(100vw - 24px, 640px)",
// //       }}
// //     >
// //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// //         </div>
// //         <div
// //           style={{
// //             marginLeft: 'auto',
// //             fontWeight: 700,
// //             opacity: 0.8,
// //             fontSize: "clamp(13px, 3.2vw, 16px)",
// //             maxWidth: '60%',
// //             overflow: 'hidden',
// //             textOverflow: 'ellipsis',
// //             whiteSpace: 'nowrap',
// //           }}
// //           title={`@${getUsername()}`}
// //         >
// //           @{getUsername()}
// //         </div>
// //       </div>

// //       {/* Top-right actions */}
// //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// //         <div style={{ display: 'flex', gap: 8 }}>
// //           <button
// //             onClick={() => navigate('/')}
// //             style={{
// //               padding: isNarrow ? '6px 10px' : '8px 12px',
// //               borderRadius: 10,
// //               border: '1px solid #D1D5DB',
// //               background: '#FFFFFF',
// //               fontWeight: 700,
// //               fontSize: isNarrow ? 13 : 14,
// //               cursor: 'pointer'
// //             }}
// //             title="Go to Home"
// //           >
// //             Home
// //           </button>
// //           <button
// //             type="button"
// //             onClick={() => setSaved(false)}
// //             disabled={!saved}
// //             style={{
// //               padding: isNarrow ? '6px 10px' : '8px 12px',
// //               borderRadius: 10,
// //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// //               background: saved ? '#fff' : '#F9FAFB',
// //               color: saved ? '#111' : '#9CA3AF',
// //               fontWeight: 800,
// //               fontSize: isNarrow ? 13 : 14,
// //               cursor: saved ? 'pointer' : 'not-allowed'
// //             }}
// //             title="Edit selection"
// //           >
// //             Edit
// //           </button>
// //         </div>

// //         <button
// //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// //           style={{
// //             padding: isNarrow ? '6px 10px' : 8,
// //             borderRadius: 10,
// //             border: '1px solid #D1D5DB',
// //             background: '#FFFFFF',
// //             fontSize: isNarrow ? 13 : 14,
// //             cursor: 'pointer'
// //           }}
// //           title="Logout"
// //         >
// //           Logout
// //         </button>
// //       </div>

// //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// //         <select
// //           disabled={saved}
// //           value={routeCode}
// //           onChange={e => setRouteCode(e.target.value)}
// //           required
// //           style={{
// //             padding: isNarrow ? 10 : 12,
// //             borderRadius: 10,
// //             border: '1px solid #D1D5DB',
// //             fontSize: isNarrow ? 14 : 16
// //           }}
// //         >
// //           <option value="">Select route…</option>
// //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// //         </select>

// //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// //         <select
// //           disabled={saved}
// //           value={vehicleNo}
// //           onChange={e => setVehicleNo(e.target.value)}
// //           required
// //           style={{
// //             padding: isNarrow ? 10 : 12,
// //             borderRadius: 10,
// //             border: '1px solid #D1D5DB',
// //             fontSize: isNarrow ? 14 : 16
// //           }}
// //         >
// //           <option value="">Select vehicle…</option>
// //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>

// //         {/* 👇 NEW: Auto-pilot toggle */}
// //         <div
// //           style={{
// //             marginTop: isNarrow ? 6 : 8,
// //             padding: isNarrow ? 8 : 10,
// //             borderRadius: 10,
// //             border: '1px solid #E5E7EB',
// //             background: '#F9FAFB',
// //             display: 'flex',
// //             alignItems: 'flex-start',
// //             gap: 8,
// //           }}
// //         >
// //           <input
// //             id="autoPilot"
// //             type="checkbox"
// //             checked={autoPilot}
// //             disabled={saved}
// //             onChange={(e) => setAutoPilot(e.target.checked)}
// //             style={{ marginTop: 3, cursor: saved ? 'default' : 'pointer' }}
// //           />
// //           <label
// //             htmlFor="autoPilot"
// //             style={{ cursor: saved ? 'default' : 'pointer' }}
// //           >
// //             <div style={{ fontWeight: 700, fontSize: isNarrow ? 14 : 15 }}>
// //               Auto-pilot (auto reverse at destination)
// //             </div>
// //             <div
// //               style={{
// //                 fontSize: isNarrow ? 12 : 13,
// //                 color: '#6B7280',
// //                 marginTop: 2,
// //               }}
// //             >
// //               When enabled, once you reach the last stop of this route, your
// //               assignment will automatically switch to the return leg.
// //             </div>
// //           </label>
// //         </div>

// //         <button
// //           disabled={busy || saved}
// //           style={{
// //             padding: isNarrow ? '10px 12px' : '12px 14px',
// //             borderRadius: 10,
// //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// //             color: busy || saved ? '#6B7280' : '#fff',
// //             fontWeight: 800,
// //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// //             minHeight: 44,
// //             fontSize: "clamp(14px, 3.5vw, 16px)"
// //           }}
// //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// //         >
// //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// //         </button>

// //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// //       </form>
// //     </div>
// //   );
// // }


// // // function DriverRoute({ navigate }) {
// // //   const [routeCode, setRouteCode] = useState("");
// // //   const [vehicleNo, setVehicleNo] = useState("");
// // //   const [saved, setSaved] = useState(false);
// // //   const [busy, setBusy] = useState(false);
// // //   const [err, setErr] = useState("");
// // //   const isNarrow = useIsNarrow(380);

// // //   useEffect(() => {
// // //     if (!getToken()) navigate("/driver");
// // //     (async () => {
// // //       try {
// // //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// // //           headers: { Authorization: `Bearer ${getToken()}` },
// // //         });
// // //         const row = r.data?.row;
// // //         if (row) { setVehicleNo(row.vehicleNo); setRouteCode(row.routeCode); setSaved(true); }
// // //       } catch {}
// // //     })();
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, []);

// // //   const onSave = async (e) => {
// // //     e.preventDefault();
// // //     setErr(""); setBusy(true);
// // //     try {
// // //       await axios.post(
// // //         `${BACKEND}/api/vehicle-route/assign`,
// // //         { vehicleNo, routeCode, active: true },
// // //         { headers: { Authorization: `Bearer ${getToken()}` } }
// // //       );
// // //       setSaved(true);
// // //     } catch (e1) {
// // //       setErr(e1?.response?.data?.message || "Save failed");
// // //     } finally {
// // //       setBusy(false);
// // //     }
// // //   };

// // //   return (
// // //     <div
// // //       style={{
// // //         padding: isNarrow ? 16 : 20,
// // //         maxWidth: 640,
// // //         margin: isNarrow ? "16px auto" : "32px auto",
// // //         width: "min(100vw - 24px, 640px)",
// // //       }}
// // //     >
// // //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// // //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// // //         </div>
// // //         <div
// // //           style={{
// // //             marginLeft: 'auto',
// // //             fontWeight: 700,
// // //             opacity: 0.8,
// // //             fontSize: "clamp(13px, 3.2vw, 16px)",
// // //             maxWidth: '60%',
// // //             overflow: 'hidden',
// // //             textOverflow: 'ellipsis',
// // //             whiteSpace: 'nowrap',
// // //           }}
// // //           title={`@${getUsername()}`}
// // //         >
// // //           @{getUsername()}
// // //         </div>
// // //       </div>

// // //       {/* Top-right actions */}
// // //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// // //         <div style={{ display: 'flex', gap: 8 }}>
// // //           <button
// // //             onClick={() => navigate('/')}
// // //             style={{
// // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // //               borderRadius: 10,
// // //               border: '1px solid #D1D5DB',
// // //               background: '#FFFFFF',
// // //               fontWeight: 700,
// // //               fontSize: isNarrow ? 13 : 14,
// // //               cursor: 'pointer'
// // //             }}
// // //             title="Go to Home"
// // //           >
// // //             Home
// // //           </button>
// // //           <button
// // //             type="button"
// // //             onClick={() => setSaved(false)}
// // //             disabled={!saved}
// // //             style={{
// // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // //               borderRadius: 10,
// // //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// // //               background: saved ? '#fff' : '#F9FAFB',
// // //               color: saved ? '#111' : '#9CA3AF',
// // //               fontWeight: 800,
// // //               fontSize: isNarrow ? 13 : 14,
// // //               cursor: saved ? 'pointer' : 'not-allowed'
// // //             }}
// // //             title="Edit selection"
// // //           >
// // //             Edit
// // //           </button>
// // //         </div>

// // //         <button
// // //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// // //           style={{
// // //             padding: isNarrow ? '6px 10px' : 8,
// // //             borderRadius: 10,
// // //             border: '1px solid #D1D5DB',
// // //             background: '#FFFFFF',
// // //             fontSize: isNarrow ? 13 : 14,
// // //             cursor: 'pointer'
// // //           }}
// // //           title="Logout"
// // //         >
// // //           Logout
// // //         </button>
// // //       </div>

// // //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// // //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// // //         <select
// // //           disabled={saved}
// // //           value={routeCode}
// // //           onChange={e=>setRouteCode(e.target.value)}
// // //           required
// // //           style={{
// // //             padding: isNarrow ? 10 : 12,
// // //             borderRadius: 10,
// // //             border: '1px solid #D1D5DB',
// // //             fontSize: isNarrow ? 14 : 16
// // //           }}
// // //         >
// // //           <option value="">Select route…</option>
// // //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// // //         </select>

// // //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// // //         <select
// // //           disabled={saved}
// // //           value={vehicleNo}
// // //           onChange={e=>setVehicleNo(e.target.value)}
// // //           required
// // //           style={{
// // //             padding: isNarrow ? 10 : 12,
// // //             borderRadius: 10,
// // //             border: '1px solid #D1D5DB',
// // //             fontSize: isNarrow ? 14 : 16
// // //           }}
// // //         >
// // //           <option value="">Select vehicle…</option>
// // //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>

// // //         <button
// // //           disabled={busy || saved}
// // //           style={{
// // //             padding: isNarrow ? '10px 12px' : '12px 14px',
// // //             borderRadius: 10,
// // //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// // //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// // //             color: busy || saved ? '#6B7280' : '#fff',
// // //             fontWeight: 800,
// // //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// // //             minHeight: 44,
// // //             fontSize: "clamp(14px, 3.5vw, 16px)"
// // //           }}
// // //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// // //         >
// // //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// // //         </button>

// // //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// // //       </form>
// // //     </div>
// // //   );
// // // }

// // /* ---------------------------- ADMIN PAGES ---------------------------- */

// // function AdminLogin({ navigate }) {
// //   const [username, setU] = useState("");
// //   const [password, setP] = useState("");
// //   const [err, setErr] = useState("");
// //   const [busy, setBusy] = useState(false);
// //   const isNarrow = useIsNarrow(380);

// //   useEffect(() => {
// //     if (getAdminToken()) navigate("/admin");
// //   }, [navigate]);

// //   const onSubmit = async (e) => {
// //     e.preventDefault();
// //     setErr("");
// //     setBusy(true);
// //     try {
// //       const r = await axios.post(`${BACKEND}/api/admin/login`, {
// //         username,
// //         password,
// //       });
// //       if (r.data?.success && r.data?.token) {
// //         setAdminToken(r.data.token);
// //         navigate("/admin");
// //       } else {
// //         setErr("Login failed");
// //       }
// //     } catch (e1) {
// //       setErr(e1?.response?.data?.message || "Login failed");
// //     } finally {
// //       setBusy(false);
// //     }
// //   };

// //   return (
// //     <div
// //       style={{
// //         padding: isNarrow ? 12 : 20,
// //         margin: isNarrow ? "16px auto" : "32px auto",
// //         width: "min(100vw - 24px, 560px)",
// //       }}
// //     >
// //       <div
// //         style={{
// //           display: "flex",
// //           alignItems: "center",
// //           gap: isNarrow ? 10 : 12,
// //           marginBottom: isNarrow ? 10 : 14,
// //           flexWrap: "wrap",
// //         }}
// //       >
// //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// //           <img
// //             src={iitmLogo}
// //             alt="IITM"
// //             style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }}
// //           />
// //           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Admin Login</h2>
// //         </div>
// //         <button
// //           type="button"
// //           onClick={() => navigate("/")}
// //           style={{
// //             marginLeft: "auto",
// //             padding: isNarrow ? "6px 10px" : "8px 12px",
// //             borderRadius: 10,
// //             border: "1px solid #D1D5DB",
// //             background: "#FFFFFF",
// //             fontWeight: 700,
// //             fontSize: isNarrow ? 13 : 14,
// //             cursor: "pointer",
// //           }}
// //           title="Go to Home"
// //         >
// //           Home
// //         </button>
// //       </div>
// //       <div
// //         style={{
// //           background: "#fff",
// //           border: "1px solid #E5E7EB",
// //           borderRadius: 12,
// //           padding: isNarrow ? 12 : 16,
// //         }}
// //       >
// //         <form
// //           onSubmit={onSubmit}
// //           style={{ display: "grid", gap: isNarrow ? 8 : 10 }}
// //         >
// //           <input
// //             value={username}
// //             onChange={(e) => setU(e.target.value)}
// //             placeholder="admin username"
// //             required
// //             style={{
// //               padding: isNarrow ? 10 : 12,
// //               borderRadius: 10,
// //               border: "1px solid #D1D5DB",
// //               fontWeight: 600,
// //               fontSize: isNarrow ? 14 : 16,
// //             }}
// //           />
// //           <input
// //             value={password}
// //             onChange={(e) => setP(e.target.value)}
// //             placeholder="admin password"
// //             type="password"
// //             required
// //             style={{
// //               padding: isNarrow ? 10 : 12,
// //               borderRadius: 10,
// //               border: "1px solid #D1D5DB",
// //               fontWeight: 600,
// //               fontSize: isNarrow ? 14 : 16,
// //             }}
// //           />
// //           <button
// //             disabled={busy}
// //             style={{
// //               padding: isNarrow ? "10px 12px" : "12px 14px",
// //               borderRadius: 10,
// //               border: "1px solid #0D47A1",
// //               background: "#0D47A1",
// //               color: "#fff",
// //               fontWeight: 800,
// //               cursor: "pointer",
// //               width: "100%",
// //               minHeight: 40,
// //               fontSize: "clamp(14px, 3.5vw, 16px)",
// //             }}
// //           >
// //             {busy ? "Signing in..." : "Login"}
// //           </button>
// //           {err && (
// //             <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>
// //           )}
// //         </form>
// //       </div>
// //     </div>
// //   );
// // }

// // function AdminDashboard({ navigate }) {
// //   const [tab, setTab] = useState("drivers"); // 'drivers' | 'routes' | 'live'
// //   const [drivers, setDrivers] = useState([]);
// //   const [assignments, setAssignments] = useState({}); // vehicleNo -> row
// //   const [localAssign, setLocalAssign] = useState({}); // vehicleNo -> { routeCode, driverId, autopilotEnabled }
// //   const [editing, setEditing] = useState({}); // vehicleNo -> true when row is in edit mode
// //   const [newName, setNewName] = useState("");
// //   const [newPhone, setNewPhone] = useState("");
// //   const [err, setErr] = useState("");
// //   const [busySave, setBusySave] = useState(null); // vehicleno while saving
// //   const [liveBuses, setLiveBuses] = useState([]);
// //   const adminToken = getAdminToken();
// //   const isNarrow = useIsNarrow(480);

// //   useEffect(() => {
// //     if (!adminToken) navigate("/admin/login");
// //   }, [adminToken, navigate]);

// //   const authHeader = useMemo(
// //     () => ({
// //       headers: { Authorization: `Bearer ${adminToken}` },
// //     }),
// //     [adminToken]
// //   );

// //   async function loadDrivers() {
// //     try {
// //       const r = await axios.get(`${BACKEND}/api/admin/drivers`, authHeader);
// //       setDrivers(r.data?.drivers || []);
// //     } catch (e) {
// //       console.warn("loadDrivers error", e?.message || e);
// //     }
// //   }

// //   async function loadAssignments() {
// //     try {
// //       const r = await axios.get(`${BACKEND}/api/admin/assignments`, authHeader);
// //       const rows = r.data?.rows || [];
// //       const map = {};
// //       for (const row of rows) {
// //         map[row.vehicleNo] = row;
// //       }
// //       setAssignments(map);
// //       // whenever we reload from backend, treat all as "saved" (not editing)
// //       setEditing({});
// //       setLocalAssign({});
// //     } catch (e) {
// //       console.warn("loadAssignments error", e?.message || e);
// //     }
// //   }

// //   useEffect(() => {
// //     if (!adminToken) return;
// //     loadDrivers();
// //     loadAssignments();
// //   }, [adminToken]); // eslint-disable-line react-hooks/exhaustive-deps

// //   // live tracking (simple polling)
// //   useEffect(() => {
// //     if (tab !== "live") return;
// //     let cancelled = false;

// //     async function loadLive() {
// //       try {
// //         const r = await axios.get(`${BACKEND}/api/vehicle-data`, {
// //           timeout: 8000,
// //         });
// //         if (!cancelled) {
// //           const arr = Array.isArray(r.data) ? r.data : [];
// //           setLiveBuses(arr);
// //         }
// //       } catch (e) {
// //         if (!cancelled) {
// //           console.warn("admin live map error", e?.message || e);
// //         }
// //       }
// //     }
// //     loadLive();
// //     const id = setInterval(loadLive, 5000);
// //     return () => {
// //       cancelled = true;
// //       clearInterval(id);
// //     };
// //   }, [tab]);

// //   const handleAddDriver = async (e) => {
// //     e.preventDefault();
// //     setErr("");
// //     try {
// //       const r = await axios.post(
// //         `${BACKEND}/api/admin/drivers`,
// //         { name: newName, phoneNumber: newPhone },
// //         authHeader
// //       );
// //       if (r.data?.success && r.data?.driver) {
// //         setDrivers((prev) => [...prev, r.data.driver]);
// //         setNewName("");
// //         setNewPhone("");
// //       } else {
// //         setErr("Failed to create driver");
// //       }
// //     } catch (e1) {
// //       setErr(e1?.response?.data?.message || "Failed to create driver");
// //     }
// //   };

// //   const handleRemoveDriver = async (id) => {
// //     if (!window.confirm("Remove this driver?")) return;
// //     try {
// //       await axios.delete(`${BACKEND}/api/admin/drivers/${id}`, authHeader);
// //       setDrivers((prev) => prev.filter((d) => d._id !== id));
// //       // Note: assignments that still reference this driver will continue to exist until reassigned
// //     } catch (e1) {
// //       alert(e1?.response?.data?.message || "Failed to remove driver");
// //     }
// //   };

// //   function getBaseAssignForVehicle(veh) {
// //     const row = assignments[veh];
// //     if (!row) {
// //       return {
// //         vehicleNo: veh,
// //         routeCode: "",
// //         driverId: "",
// //         autopilotEnabled: false,
// //       };
// //     }
// //     return {
// //       vehicleNo: veh,
// //       routeCode: row.routeCode || "",
// //       driverId: row.driver?._id || "",
// //       autopilotEnabled: !!row.autopilotEnabled,
// //     };
// //   }

// //   function updateLocalAssign(veh, patch) {
// //     setLocalAssign((prev) => ({
// //       ...prev,
// //       [veh]: { ...getBaseAssignForVehicle(veh), ...(prev[veh] || {}), ...patch },
// //     }));
// //   }

// //   const handleSaveAssignment = async (veh) => {
// //     const base = getBaseAssignForVehicle(veh);
// //     const row = localAssign[veh] || base;
// //     const hasAssignment = !!assignments[veh]; // vehicle currently has an active route?

// //     // RESET error first
// //     setErr("");

// //     // ---- CASE 1: Admin cleared both fields and there *was* an assignment -> CLEAR MODE ----
// //     if (!row.routeCode && !row.driverId && hasAssignment) {
// //       setBusySave(veh);
// //       try {
// //         await axios.post(
// //           `${BACKEND}/api/admin/vehicle-assign`,
// //           {
// //             vehicleNo: row.vehicleNo,
// //             clear: true,              // 👈 tells backend: deactivate assignment
// //           },
// //           authHeader
// //         );
// //         await loadAssignments();      // refresh table
// //         setEditing((prev) => ({ ...prev, [veh]: false }));
// //       } catch (e1) {
// //         setErr(e1?.response?.data?.message || "Failed to clear assignment");
// //       } finally {
// //         setBusySave(null);
// //       }
// //       return;
// //     }

// //     // ---- CASE 2: No assignment and still empty -> nothing to save ----
// //     if (!row.routeCode || !row.driverId) {
// //       setErr("Select both Route & Driver, or leave the row as-is.");
// //       return;
// //     }

// //     // ---- CASE 3: Normal ASSIGN / UPDATE ----
// //     setBusySave(veh);
// //     try {
// //       await axios.post(
// //         `${BACKEND}/api/admin/vehicle-assign`,
// //         {
// //           vehicleNo: row.vehicleNo,
// //           routeCode: row.routeCode,
// //           driverId: row.driverId,
// //           autopilotEnabled: !!row.autopilotEnabled,
// //         },
// //         authHeader
// //       );
// //       await loadAssignments();
// //       setEditing((prev) => ({ ...prev, [veh]: false }));
// //     } catch (e1) {
// //       setErr(e1?.response?.data?.message || "Failed to save assignment");
// //     } finally {
// //       setBusySave(null);
// //     }
// //   };


// //   const onLogout = () => {
// //     setAdminToken("");
// //     navigate("/admin/login");
// //   };

// //   // simple driver lookup for live map
// //   const driverByVehicle = useMemo(() => {
// //     const out = {};
// //     Object.values(assignments).forEach((row) => {
// //       if (row.vehicleNo && row.driver) {
// //         out[row.vehicleNo] = row.driver;
// //       }
// //     });
// //     return out;
// //   }, [assignments]);

// //   return (
// //     <div className="admin-layout">
// //       {/* left sidebar */}
// //       <div
// //         className="sidebar"
// //         style={{
// //           width: isNarrow ? 220 : 260, // responsive width override
// //         }}
// //       >
// //         {/* top section: logo, back button, nav */}
// //         <div>
// //           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// //             <img
// //               src={iitmLogo}
// //               alt="IITM"
// //               style={{ width: 32, height: 32, borderRadius: 8 }}
// //             />
// //             <div>
// //               <div style={{ fontWeight: 800, fontSize: 16 }}>Admin</div>
// //               <div style={{ fontSize: 12, opacity: 0.8 }}>Thoothukudi Bus Tracking</div>
// //             </div>
// //           </div>
// //           <button
// //             onClick={() => navigate("/")}
// //             style={{
// //               marginTop: 8,
// //               textAlign: "left",
// //               padding: "6px 10px",
// //               borderRadius: 10,
// //               border: "1px solid #4b5563",
// //               background: "transparent",
// //               color: "#e5e7eb",
// //               cursor: "pointer",
// //               fontSize: 13,
// //             }}
// //           >
// //             ← Back to map
// //           </button>
// //           <div
// //             style={{
// //               marginTop: 16,
// //               display: "flex",
// //               flexDirection: "column",
// //               gap: 6,
// //             }}
// //           >
// //             <button
// //               onClick={() => setTab("drivers")}
// //               style={{
// //                 textAlign: "left",
// //                 padding: "8px 10px",
// //                 borderRadius: 10,
// //                 border: "none",
// //                 background: tab === "drivers" ? "#f9fafb" : "transparent",
// //                 color: tab === "drivers" ? "#111827" : "#e5e7eb",
// //                 fontWeight: 600,
// //                 cursor: "pointer",
// //               }}
// //             >
// //               + Add Driver
// //             </button>
// //             <button
// //               onClick={() => setTab("routes")}
// //               style={{
// //                 textAlign: "left",
// //                 padding: "8px 10px",
// //                 borderRadius: 10,
// //                 border: "none",
// //                 background: tab === "routes" ? "#f9fafb" : "transparent",
// //                 color: tab === "routes" ? "#111827" : "#e5e7eb",
// //                 fontWeight: 600,
// //                 cursor: "pointer",
// //               }}
// //             >
// //               Route Allocation
// //             </button>
// //             <button
// //               onClick={() => setTab("live")}
// //               style={{
// //                 textAlign: "left",
// //                 padding: "8px 10px",
// //                 borderRadius: 10,
// //                 border: "none",
// //                 background: tab === "live" ? "#f9fafb" : "transparent",
// //                 color: tab === "live" ? "#111827" : "#e5e7eb",
// //                 fontWeight: 600,
// //                 cursor: "pointer",
// //               }}
// //             >
// //               Live Tracking
// //             </button>
// //           </div>
// //         </div>

// //         {/* bottom logout – pinned to sidebar bottom */}
// //         <button
// //           onClick={onLogout}
// //           style={{
// //             marginTop: 12,
// //             padding: "8px 10px",
// //             borderRadius: 10,
// //             border: "1px solid #6b7280",
// //             background: "transparent",
// //             color: "#e5e7eb",
// //             cursor: "pointer",
// //             fontSize: 13,
// //           }}
// //         >
// //           Logout
// //         </button>
// //       </div>

// //       {/* main content */}
// //       <div className="content">
// //         {tab === "drivers" && (
// //           <div style={{ maxWidth: 800, margin: "0 auto" }}>
// //             <h2 style={{ marginTop: 0 }}>Drivers</h2>
// //             <form
// //               onSubmit={handleAddDriver}
// //               style={{
// //                 display: "grid",
// //                 gridTemplateColumns: "2fr 2fr auto",
// //                 gap: 8,
// //                 alignItems: "center",
// //                 marginBottom: 16,
// //               }}
// //             >
// //               <input
// //                 value={newName}
// //                 onChange={(e) => setNewName(e.target.value)}
// //                 placeholder="Driver name"
// //                 required
// //                 style={{
// //                   padding: 10,
// //                   borderRadius: 10,
// //                   border: "1px solid #D1D5DB",
// //                   fontSize: 14,
// //                 }}
// //               />
// //               <input
// //                 value={newPhone}
// //                 onChange={(e) => setNewPhone(e.target.value)}
// //                 placeholder="Phone number (unique)"
// //                 required
// //                 style={{
// //                   padding: 10,
// //                   borderRadius: 10,
// //                   border: "1px solid #D1D5DB",
// //                   fontSize: 14,
// //                 }}
// //               />
// //               <button
// //                 type="submit"
// //                 style={{
// //                   padding: "10px 16px",
// //                   borderRadius: 10,
// //                   border: "1px solid #0D47A1",
// //                   background: "#0D47A1",
// //                   color: "#fff",
// //                   fontWeight: 700,
// //                   cursor: "pointer",
// //                   fontSize: 14,
// //                 }}
// //               >
// //                 Add
// //               </button>
// //             </form>
// //             {err && (
// //               <div
// //                 style={{
// //                   color: "#b00020",
// //                   fontWeight: 600,
// //                   marginBottom: 8,
// //                 }}
// //               >
// //                 {err}
// //               </div>
// //             )}
// //             <div
// //               style={{
// //                 display: "grid",
// //                 gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
// //                 gap: 12,
// //               }}
// //             >
// //               {drivers.map((d) => (
// //                 <div
// //                   key={d._id}
// //                   style={{
// //                     background: "#fff",
// //                     borderRadius: 12,
// //                     border: "1px solid #e5e7eb",
// //                     padding: 12,
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     gap: 4,
// //                   }}
// //                 >
// //                   <div style={{ fontWeight: 700, fontSize: 15 }}>{d.name}</div>
// //                   <div style={{ fontSize: 13, opacity: 0.8 }}>
// //                     Phone: {d.phoneNumber || "—"}
// //                   </div>
// //                   <div style={{ fontSize: 12, opacity: 0.6 }}>
// //                     username: <code>{d.username}</code>
// //                   </div>
// //                   <button
// //                     onClick={() => handleRemoveDriver(d._id)}
// //                     style={{
// //                       marginTop: 8,
// //                       alignSelf: "flex-start",
// //                       padding: "6px 10px",
// //                       borderRadius: 8,
// //                       border: "1px solid #f97373",
// //                       background: "#fef2f2",
// //                       color: "#b91c1c",
// //                       fontSize: 12,
// //                       fontWeight: 600,
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     Remove
// //                   </button>
// //                 </div>
// //               ))}
// //               {drivers.length === 0 && (
// //                 <div style={{ fontSize: 14, opacity: 0.7 }}>
// //                   No drivers yet. Add your first driver above.
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         )}

// //         {tab === "routes" && (
// //           <div style={{ maxWidth: 1100, margin: "0 auto" }}>
// //             <h2 style={{ marginTop: 0 }}>Route Allocation</h2>
// //             {err && (
// //               <div
// //                 style={{
// //                   color: "#b00020",
// //                   fontWeight: 600,
// //                   marginBottom: 8,
// //                 }}
// //               >
// //                 {err}
// //               </div>
// //             )}
// //             <div style={{ overflowX: "auto" }}>
// //               <table
// //                 style={{
// //                   width: "100%",
// //                   borderCollapse: "collapse",
// //                   background: "#fff",
// //                   borderRadius: 12,
// //                   overflow: "hidden",
// //                 }}
// //               >
// //                 <thead>
// //                   <tr
// //                     style={{
// //                       background: "#f9fafb",
// //                       borderBottom: "1px solid #e5e7eb",
// //                     }}
// //                   >
// //                     <th style={{ padding: 8, textAlign: "left" }}>#</th>
// //                     <th style={{ padding: 8, textAlign: "left" }}>Vehicle</th>
// //                     <th style={{ padding: 8, textAlign: "left" }}>Route</th>
// //                     <th style={{ padding: 8, textAlign: "left" }}>Driver</th>
// //                     <th style={{ padding: 8, textAlign: "left" }}>Auto-pilot</th>
// //                     <th style={{ padding: 8, textAlign: "left" }} />
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {VEHICLES.map((veh, idx) => {
// //                     const base = getBaseAssignForVehicle(veh);
// //                     const local = localAssign[veh] || base;
// //                     const hasAssignment =
// //                       !!base.routeCode && !!base.driverId; // existing saved row?
// //                     const isEditing = !!editing[veh];
// //                     const locked = hasAssignment && !isEditing;
// //                     const saving = busySave === veh;

// //                     return (
// //                       <tr
// //                         key={veh}
// //                         style={{ borderBottom: "1px solid #f3f4f6" }}
// //                       >
// //                         <td style={{ padding: 8 }}>{idx + 1}</td>
// //                         <td style={{ padding: 8, fontWeight: 600 }}>{veh}</td>
// //                         <td style={{ padding: 8 }}>
// //                           <select
// //                             value={local.routeCode}
// //                             onChange={(e) =>
// //                               updateLocalAssign(veh, {
// //                                 routeCode: e.target.value,
// //                               })
// //                             }
// //                             disabled={locked || saving}
// //                             style={{
// //                               padding: 8,
// //                               borderRadius: 8,
// //                               border: "1px solid #d1d5db",
// //                               fontSize: 13,
// //                               minWidth: 180,
// //                               backgroundColor: locked ? "#f9fafb" : "white",
// //                             }}
// //                           >
// //                             <option value="">Select route…</option>
// //                             {ADMIN_ROUTES.map((r) => (
// //                               <option key={r.code} value={r.code}>
// //                                 {r.label}
// //                               </option>
// //                             ))}
// //                           </select>
// //                         </td>
// //                         <td style={{ padding: 8 }}>
// //                           <select
// //                             value={local.driverId}
// //                             onChange={(e) =>
// //                               updateLocalAssign(veh, {
// //                                 driverId: e.target.value,
// //                               })
// //                             }
// //                             disabled={locked || saving}
// //                             style={{
// //                               padding: 8,
// //                               borderRadius: 8,
// //                               border: "1px solid #d1d5db",
// //                               fontSize: 13,
// //                               minWidth: 180,
// //                               backgroundColor: locked ? "#f9fafb" : "white",
// //                             }}
// //                           >
// //                             <option value="">Select driver…</option>
// //                             {drivers.map((d) => (
// //                               <option key={d._id} value={d._id}>
// //                                 {d.name} ({d.phoneNumber || d.username})
// //                               </option>
// //                             ))}
// //                           </select>
// //                         </td>
// //                         <td style={{ padding: 8 }}>
// //                           <label
// //                             style={{
// //                               display: "inline-flex",
// //                               alignItems: "center",
// //                               gap: 6,
// //                               fontSize: 13,
// //                               opacity: locked ? 0.6 : 1,
// //                             }}
// //                           >
// //                             <input
// //                               type="checkbox"
// //                               checked={!!local.autopilotEnabled}
// //                               onChange={(e) =>
// //                                 updateLocalAssign(veh, {
// //                                   autopilotEnabled: e.target.checked,
// //                                 })
// //                               }
// //                               disabled={locked || saving}
// //                             />
// //                             On
// //                           </label>
// //                         </td>
// //                         <td style={{ padding: 8 }}>
// //                           <button
// //                             onClick={() => {
// //                               if (locked) {
// //                                 // switch to edit mode
// //                                 updateLocalAssign(veh, {}); // ensure local copy
// //                                 setEditing((prev) => ({
// //                                   ...prev,
// //                                   [veh]: true,
// //                                 }));
// //                               } else {
// //                                 // save current data
// //                                 handleSaveAssignment(veh);
// //                               }
// //                             }}
// //                             disabled={saving}
// //                             style={{
// //                               padding: "6px 12px",
// //                               borderRadius: 8,
// //                               border: "1px solid #0D47A1",
// //                               background: saving
// //                                 ? "#e5e7eb"
// //                                 : locked
// //                                   ? "#0D47A1"
// //                                   : "#0D47A1",
// //                               color: saving ? "#4b5563" : "#fff",
// //                               fontSize: 13,
// //                               fontWeight: 700,
// //                               cursor: saving ? "not-allowed" : "pointer",
// //                             }}
// //                           >
// //                             {saving
// //                               ? "Saving…"
// //                               : locked
// //                                 ? "Edit"
// //                                 : "Save"}
// //                           </button>
// //                         </td>
// //                       </tr>
// //                     );
// //                   })}
// //                 </tbody>
// //               </table>
// //             </div>
// //           </div>
// //         )}

// //         {tab === "live" && (
// //           <div style={{ height: "calc(100vh - 40px)" }}>
// //             <h2 style={{ marginTop: 0 }}>Live Tracking</h2>
// //             <div style={{ height: "calc(100% - 36px)" }}>
// //               <MapContainer
// //                 center={center}
// //                 zoom={DEFAULT_ZOOM}
// //                 maxZoom={22}
// //                 style={{ width: "100%", height: "100%" }}
// //               >
// //                 <TileLayer
// //                   attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
// //                   url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// //                   maxNativeZoom={19}
// //                   maxZoom={22}
// //                 />
// //                 {liveBuses.map((bus) => {
// //                   // const label = vehicleLabel(bus.vehicleno);
// //                   const rc = assignments[bus.vehicleno]?.routeCode;   // admin assignments map is row objects
// //                   const label = vehicleLabel(bus.vehicleno, rc);
// //                   const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
// //                   const drv = driverByVehicle[bus.vehicleno];
// //                   return (
// //                     <Marker
// //                       key={bus.vehicleno}
// //                       position={{
// //                         lat: bus.latitude,
// //                         lng: bus.longitude,
// //                       }}
// //                       // icon={createVehicleDivIcon(
// //                       //   label,
// //                       //   Number(bus.heading) || 0
// //                       // )}
// //                       icon={createVehicleDivIcon(label, Number(bus.heading) || 0, palette)}
// //                     >
// //                       <Popup>
// //                         <div className="info-window">
// //                           <h4>
// //                             {bus.vehicleno} ({label})
// //                           </h4>
// //                           <p>
// //                             <strong>Speed:</strong>{" "}
// //                             {Number.isFinite(bus.speed)
// //                               ? bus.speed.toFixed(1)
// //                               : "N/A"}{" "}
// //                             km/h
// //                           </p>
// //                           {drv && (
// //                             <>
// //                               <p>
// //                                 <strong>Driver:</strong> {drv.name}</p>
// //                               <p>
// //                                 <strong>Phone:</strong>{" "}
// //                                 {drv.phoneNumber || "—"}
// //                               </p>
// //                             </>
// //                           )}
// //                           {!drv && (
// //                             <p style={{ fontSize: 13, opacity: 0.7 }}>
// //                               No driver assigned
// //                             </p>
// //                           )}
// //                         </div>
// //                       </Popup>
// //                     </Marker>
// //                   );
// //                 })}
// //               </MapContainer>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }

// // function RecenterMap({ center, zoom }) {
// //   const map = useMap();

// //   useEffect(() => {
// //     if (!center) return;
// //     map.setView([center.lat, center.lng], zoom ?? map.getZoom(), { animate: true });
// //   }, [center, zoom, map]);

// //   return null;
// // }



// // /* ---------------------------- MAP PAGE ---------------------------- */
// // function MapPage() {
// //   const [buses, setBuses] = useState([]);
// //   const [userLocation, setUserLocation] = useState(null);
// //   const [socketStatus, setSocketStatus] = useState('disconnected');
// //   const [roads, setRoads] = useState(null);
// //   const [filterType, setFilterType] = useState('all');
// //   const [mapCenter, setMapCenter] = useState(center);
// //   const [routeSearch, setRouteSearch] = useState('');
// //   const [routeSearchMsg, setRouteSearchMsg] = useState('');
// //   const [locError, setLocError] = useState("");
// //   const [geoState, setGeoState] = useState("unknown"); // "granted" | "prompt" | "denied" | "unknown"
// //   const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true);

// //   // maintenance banner state
// //   const [maintenance, setMaintenance] = useState(false);
// //   const [maintenanceReason, setMaintenanceReason] = useState('');
// //   const lastUpdateRef = useRef(0);
// //   // ETA endpoint calls are intentionally disabled.
// //   // The tracking page now uses local route + stop sequence data only.

// //   const flatRoadLinesRef = useRef([]);
// //   const lastSmoothedRef = useRef(new Map());

// //   // ---- Schedule Modal state ----
// //   const [showSchedule, setShowSchedule] = useState(false);
// //   const [activeTab, setActiveTab] = useState(0);

// //   // --- responsive helpers ---
// //   const [isNarrow, setIsNarrow] = useState(() => window.innerWidth <= 480);
// //   const clamp = (min, pref, max) => `clamp(${min}, ${pref}, ${max})`;
// //   const pad = isNarrow ? 12 : 16;
// //   const gap = isNarrow ? 8 : 12;
// //   const chipFS = isNarrow ? 12 : 13;

// //   useEffect(() => {
// //     const onResize = () => setIsNarrow(window.innerWidth <= 480);
// //     window.addEventListener('resize', onResize);
// //     return () => window.removeEventListener('resize', onResize);
// //   }, []);

// //   // Backend ETA polling removed; stop popups now use local data only.

// //   // ---- stable socket + pause flag ----
// //   const socketRef = useRef(null);
// //   const ignoreUpdatesRef = useRef(false);

// //   // ---- assignments (vehicle -> routeCode) ----
// //   const [assignments, setAssignments] = useState({});
// //   async function refreshAssignments() {
// //     try {
// //       const r = await axios.get(`${BACKEND}/api/vehicle-route/active`);
// //       const map = {};
// //       for (const row of r.data?.rows || []) {
// //         const vehicleNo = normalizeVehicleNo(row.vehicleNo);
// //         map[vehicleNo] = row.routeCode || row.routeNo || "";
// //       }
// //       setAssignments(map);
// //     } catch { }
// //   }
// //   useEffect(() => { refreshAssignments(); const t = setInterval(refreshAssignments, 60000); return () => clearInterval(t); }, []);

// //   // Load roads
// //   useEffect(() => {
// //     let cancelled = false;
// //     (async () => {
// //       try {
// //         const r = await fetch(ROADS_URL);
// //         if (!cancelled && r.ok) setRoads(await r.json());
// //       } catch (e) {
// //         if (!cancelled) console.warn('Failed to load roads:', e?.message || e);
// //       }
// //     })();
// //     return () => { cancelled = true; };
// //   }, []);

// //   // Flatten roads to LineStrings
// //   useEffect(() => {
// //     if (!roads) return;
// //     const lines = [];
// //     turf.flattenEach(roads, (feat) => {
// //       if (feat.geometry?.type === 'LineString') lines.push(feat);
// //     });
// //     flatRoadLinesRef.current = lines;
// //   }, [roads]);

// //   // // Geolocation
// //   // useEffect(() => {
// //   //   if ('geolocation' in navigator) {
// //   //     navigator.geolocation.getCurrentPosition(
// //   //       (pos) => setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
// //   //       (err) => console.warn('Geolocation error:', err?.message),
// //   //       { enableHighAccuracy: true, timeout: 5000 }
// //   //     );
// //   //   }
// //   // }, []);

// //   useEffect(() => {
// //     let perm;
// //     (async () => {
// //       try {
// //         if (!navigator.permissions?.query) return;
// //         perm = await navigator.permissions.query({ name: "geolocation" });
// //         setGeoState(perm.state);
// //         perm.onchange = () => setGeoState(perm.state);
// //       } catch {
// //         // ignore
// //       }
// //     })();
// //     return () => {
// //       if (perm) perm.onchange = null;
// //     };
// //   }, []);


// //   //   const requestUserLocation = useCallback(() => {
// //   //   setLocError("");

// //   //   if (!("geolocation" in navigator)) {
// //   //     setLocError("Geolocation not supported on this device/browser.");
// //   //     return;
// //   //   }

// //   //   navigator.geolocation.getCurrentPosition(
// //   //     (pos) => {
// //   //       const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
// //   //       setUserLocation(loc);
// //   //       setMapCenter(loc); // ✅ recenter map here
// //   //       setLocError("");
// //   //     },
// //   //     (err) => {
// //   //       console.warn("Geolocation error:", err?.message || err);
// //   //       // If user didn't allow, browser will show prompt only if not blocked.
// //   //       setLocError("Please allow location to center the map near you.");
// //   //     },
// //   //     { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
// //   //   );
// //   // }, []);

// //   const requestUserLocation = useCallback(() => {
// //     setLocError("");

// //     if (!("geolocation" in navigator)) {
// //       setLocError("Geolocation not supported on this device/browser.");
// //       return;
// //     }

// //     navigator.geolocation.getCurrentPosition(
// //       (pos) => {
// //         const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
// //         setUserLocation(loc);
// //         setMapCenter(loc);
// //         setLocError("");
// //       },
// //       (err) => {
// //         // err.code === 1 => PERMISSION_DENIED
// //         if (err?.code === 1) {
// //           // If browser permission is truly "denied", it won't show popup again.
// //           setLocError(
// //             "Location is blocked in browser settings. Click the 🔒 icon near the URL → Site settings → Location → Allow (or Ask), then refresh."
// //           );
// //         } else {
// //           setLocError(err?.message || "Unable to fetch location.");
// //         }
// //       },
// //       { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
// //     );
// //   }, []);


// //   useEffect(() => {
// //     // ✅ On every page open (and after browser refresh), request location and recenter
// //     requestUserLocation();
// //   }, [requestUserLocation]);


// //   // Initial fetch
// //   useEffect(() => {
// //     if (!BACKEND) {
// //       setMaintenance(true);
// //       setMaintenanceReason('Server URL not configured');
// //       return;
// //     }
// //     axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 })
// //       .then((res) => {
// //         const arr = Array.isArray(res.data) ? res.data : [];
// //         const byVeh = new Map();
// //         for (const d of arr) {
// //           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
// //           byVeh.set(d.vehicleno, {
// //             vehicleno: d.vehicleno,
// //             latitude: d.latitude,
// //             longitude: d.longitude,
// //             speed: d.speed,
// //             heading
// //           });
// //         }
// //         const list = [...byVeh.values()];
// //         setBuses(processVehicles(list));
// //         lastUpdateRef.current = Date.now();
// //       })
// //       .catch((err) => {
// //         console.error('Initial fetch error:', err?.message || err);
// //         setMaintenance(true);
// //         setMaintenanceReason('Unable to fetch live data');
// //       });
// //   }, []);

// //   // ---- WebSocket packet handler ----
// //   const onPacket = (data) => {
// //     if (ignoreUpdatesRef.current) return;
// //     const incoming = {
// //       vehicleno: data.vehicleno,
// //       latitude: data.latitude,
// //       longitude: data.longitude,
// //       speed: data.speed,
// //       heading: Number.isFinite(data?.heading) ? toHeading(data.heading) : toHeading(data?.direction)
// //     };

// //     setBuses((prev) => {
// //       const nextByVeh = new Map(prev.map((b) => [b.vehicleno, b]));
// //       const processed = processVehicles([incoming], nextByVeh);
// //       const merged = new Map(prev.map((b) => [b.vehicleno, b]));
// //       for (const p of processed) merged.set(p.vehicleno, p);
// //       return [...merged.values()];
// //     });

// //     lastUpdateRef.current = Date.now();
// //   };

// //   // Live updates (Socket.IO)
// //   useEffect(() => {
// //     if (!BACKEND) return;

// //     setSocketStatus('connecting');
// //     const socket = io(BACKEND, {
// //       transports: ['websocket', 'polling'],
// //       reconnection: true,
// //       reconnectionAttempts: Infinity,
// //       reconnectionDelay: 1000,
// //       timeout: 10000,
// //       withCredentials: false
// //     });
// //     socketRef.current = socket;

// //     socket.on('connect', () => setSocketStatus('connected'));
// //     socket.on('disconnect', () => setSocketStatus('disconnected'));
// //     socket.on('connect_error', (e) => {
// //       console.warn('Socket connect_error:', e?.message || e);
// //       setSocketStatus('disconnected');
// //     });

// //     socket.on('new-bus-data', onPacket);

// //     return () => {
// //       socket.off('new-bus-data', onPacket);
// //       socket.disconnect();
// //       socketRef.current = null;
// //     };
// //   }, [roads]); // re-connect only if roads change

// //   // Staleness / maintenance detector
// //   useEffect(() => {
// //     const t = setInterval(() => {
// //       const sinceMs = Date.now() - lastUpdateRef.current;
// //       const stale = sinceMs > STALE_MS;
// //       const downAndEmpty = socketStatus === 'disconnected' && buses.length === 0;

// //       if (stale || downAndEmpty) {
// //         const mins = Math.floor(sinceMs / 60000);
// //         const secs = Math.floor((sinceMs % 60000) / 1000);
// //         setMaintenance(true);
// //         setMaintenanceReason(
// //           stale ? `No new data for ${mins}m ${secs}s` : 'Live connection unavailable'
// //         );
// //       } else {
// //         setMaintenance(false);
// //         setMaintenanceReason('');
// //       }
// //     }, 5000);
// //     return () => clearInterval(t);
// //   }, [socketStatus, buses.length]);

// //   // ---- Processing pipeline: smooth then snap ----
// //   function snapToRoad(coord, flatLines) {
// //     const safeCoord = normalizeLatLng(coord?.lat, coord?.lng);
// //     if (!safeCoord || !flatLines || flatLines.length === 0) return null;

// //     let pt;
// //     try {
// //       pt = turf.point([safeCoord.lng, safeCoord.lat]);
// //     } catch (err) {
// //       console.warn('Skipping road snap because coordinates are invalid:', coord);
// //       return null;
// //     }

// //     let best = null;
// //     let bestDist = Infinity;

// //     for (const line of flatLines) {
// //       try {
// //         const np = turf.nearestPointOnLine(line, pt, { units: 'meters' });
// //         const dist = np?.properties?.dist;
// //         if (Number.isFinite(dist) && dist < bestDist) {
// //           bestDist = dist;
// //           const [lng, lat] = np.geometry.coordinates;
// //           const snapped = normalizeLatLng(lat, lng);
// //           if (snapped) best = { ...snapped, distM: dist };
// //         }
// //       } catch (err) {
// //         console.warn('Skipping invalid road line while snapping:', err?.message || err);
// //       }
// //     }
// //     return best;
// //   }

// //   function processVehicles(list, prevMapOpt) {
// //     const flatLines = flatRoadLinesRef.current;
// //     const last = lastSmoothedRef.current;
// //     const result = [];

// //     for (const d of list) {
// //       const id = String(d?.vehicleno || '').trim();
// //       if (!id) continue;

// //       const raw = normalizeLatLng(d.latitude, d.longitude);
// //       if (!raw) {
// //         console.warn('Skipping vehicle with invalid coordinates:', d?.vehicleno, d?.latitude, d?.longitude);
// //         continue;
// //       }

// //       const prev = last.get(id);
// //       const smoothedCoord = smoothCoord(prev?.coord, raw, SMOOTH_ALPHA);
// //       if (!smoothedCoord) continue;

// //       const smoothedHeading = smoothHeading(prev?.heading, d.heading, HEADING_ALPHA);
// //       const snapped = snapToRoad(smoothedCoord, flatLines);

// //       const use = snapped?.distM != null && snapped.distM <= SNAP_MAX_DIST_M
// //         ? { lat: snapped.lat, lng: snapped.lng }
// //         : smoothedCoord;

// //       if (!hasValidLatLng(use)) continue;

// //       last.set(id, { coord: use, heading: smoothedHeading });

// //       result.push({
// //         vehicleno: id,
// //         latitude: use.lat,
// //         longitude: use.lng,
// //         speed: d.speed,
// //         heading: smoothedHeading
// //       });
// //     }

// //     if (prevMapOpt) {
// //       for (const [id, b] of prevMapOpt) {
// //         if (list.find(x => x.vehicleno === id)) continue;
// //         const prev = last.get(id);
// //         if (prev?.coord && hasValidLatLng(prev.coord)) {
// //           result.push({
// //             vehicleno: id,
// //             latitude: prev.coord.lat,
// //             longitude: prev.coord.lng,
// //             speed: b.speed,
// //             heading: prev.heading
// //           });
// //           continue;
// //         }

// //         const fallback = normalizeLatLng(b?.latitude, b?.longitude);
// //         if (fallback) {
// //           result.push({
// //             ...b,
// //             latitude: fallback.lat,
// //             longitude: fallback.lng,
// //           });
// //         }
// //       }
// //     }

// //     return result;
// //   }

// //   // ---------------- Route geometry + ETA helpers ----------------
// //   const stopById = useMemo(() => Object.fromEntries(busStops.map(s => [s.id, s])), []);

// //   function routePolyline(ids) {
// //     return ids
// //       .map((id) => stopById[id])
// //       .filter(Boolean)
// //       .map((s) => normalizeLatLng(s.lat, s.lng))
// //       .filter(Boolean);
// //   }

// //   function cumDist(poly) {
// //     const out = [0];
// //     for (let i = 1; i < poly.length; i++) {
// //       const d = mBetween(poly[i - 1], poly[i]);
// //       out.push(out[i - 1] + (Number.isFinite(d) ? d : 0));
// //     }
// //     return out;
// //   }

// //   const routeGeom = useMemo(() => {
// //     const g = {};
// //     for (const trip of ROUTE_TRIPS) {
// //       const validIds = trip.ids.filter((id) => !!stopById[id]);
// //       const poly = routePolyline(validIds);
// //       if (poly.length >= 2) {
// //         g[trip.id] = { poly, cum: cumDist(poly), ids: validIds, trip };
// //       }
// //     }
// //     return g;
// //   }, [stopById]);

// //   function projectOnRoute(pt, poly) {
// //     const safePt = normalizeLatLng(pt?.lat, pt?.lng);
// //     if (!safePt || !poly || poly.length < 2) return null;

// //     let best = null;
// //     let pointFeature = null;

// //     try {
// //       pointFeature = turf.point([safePt.lng, safePt.lat]);
// //     } catch (err) {
// //       console.warn('Skipping route projection because bus coordinates are invalid:', pt);
// //       return null;
// //     }

// //     for (let i = 0; i < poly.length - 1; i++) {
// //       const a = normalizeLatLng(poly[i]?.lat, poly[i]?.lng);
// //       const b = normalizeLatLng(poly[i + 1]?.lat, poly[i + 1]?.lng);
// //       if (!a || !b) continue;

// //       try {
// //         const seg = turf.lineString([[a.lng, a.lat], [b.lng, b.lat]]);
// //         const p = turf.nearestPointOnLine(seg, pointFeature, { units: "meters" });
// //         const d = p.properties?.dist ?? Infinity;
// //         if (Number.isFinite(d) && (!best || d < best.dist)) {
// //           const [lng, lat] = p.geometry.coordinates;
// //           best = { idx: i, point: { lat, lng }, dist: d };
// //         }
// //       } catch (err) {
// //         console.warn('Skipping invalid route segment while projecting bus:', err?.message || err);
// //       }
// //     }
// //     return best;
// //   }

// //   function distanceAlong(poly, cum, proj, targetIndex) {
// //     if (!proj || !poly || poly.length < 2 || !cum?.length) return Infinity;
// //     const safeIdx = Math.max(0, Math.min(proj.idx, poly.length - 2));
// //     const safeTarget = Math.max(0, Math.min(targetIndex, poly.length - 1));
// //     const dHead = mBetween(proj.point, poly[safeIdx + 1]);
// //     const dTail = (cum[safeTarget] ?? 0) - (cum[safeIdx + 1] ?? 0);
// //     const total = dHead + Math.max(0, dTail);
// //     return Number.isFinite(total) ? total : Infinity;
// //   }

// //   // ---- ETA constants: match backend ----
// //   const AVG_SPEED_KMPH = 20;
// //   const AVG_SPEED_MPS = (AVG_SPEED_KMPH * 1000) / 3600;
// //   const WAIT_RADIUS_M = 25;
// //   const WAIT_SPEED_KMPH_MAX = 1.0;

// //   function etaFromMeters(distanceM) {
// //     const seconds = distanceM / AVG_SPEED_MPS;
// //     const minutes = Math.round(seconds / 60);
// //     return minutes < 0 || !Number.isFinite(minutes) ? 0 : minutes;
// //   }

// //   function nextStopIndex(routeIds, projIdx) {
// //     return Math.min(routeIds.length - 1, projIdx + 1);
// //   }

// //   function getBestRouteProjectionForBus(bus) {
// //     const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
// //     if (!routeValue) return null;

// //     const candidates = routeCandidatesForValue(routeValue);
// //     if (!candidates.length) return null;

// //     const pt = normalizeLatLng(bus.latitude, bus.longitude);
// //     if (!pt) return null;

// //     let best = null;

// //     for (const trip of candidates) {
// //       const geom = routeGeom[trip.id];
// //       if (!geom || geom.poly.length < 2) continue;

// //       const proj = projectOnRoute(pt, geom.poly);
// //       if (!proj) continue;

// //       if (!best || proj.dist < best.proj.dist) {
// //         best = { routeValue, trip, geom, proj };
// //       }
// //     }

// //     return best;
// //   }

// //   function recentlyPassedStopForBus(bus) {
// //     const best = getBestRouteProjectionForBus(bus);
// //     if (!best) return null;

// //     const passedIdx = Math.max(0, Math.min(best.proj.idx, best.geom.ids.length - 1));
// //     const stopId = best.geom.ids[passedIdx];
// //     const stop = stopById[stopId];

// //     if (!stop) return null;

// //     return {
// //       stopId,
// //       name: stop.name,
// //       routeNo: best.trip.routeNo,
// //       routeCode: best.trip.code,
// //       distanceFromRouteM: best.proj.dist,
// //     };
// //   }

// //   // For a given bus, find nearest upcoming stop on its route + ETA
// //   function nearestStopEtaForBusOnItsRoute(bus) {
// //     const best = getBestRouteProjectionForBus(bus);
// //     if (!best) return null;

// //     const { geom, proj, trip } = best;
// //     const pt = normalizeLatLng(bus.latitude, bus.longitude);
// //     if (!pt) return null;

// //     const firstStopId = geom.ids[0];
// //     const firstStop = stopById[firstStopId];
// //     let waitingAtFirstStop = false;
// //     if (firstStop) {
// //       const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
// //       const speed = Number(bus.speed);
// //       if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
// //         waitingAtFirstStop = true;
// //       }
// //     }

// //     const nextIdx = nextStopIndex(geom.ids, proj.idx);
// //     const distanceM = distanceAlong(geom.poly, geom.cum, proj, nextIdx);

// //     let etaMin = undefined;
// //     if (!waitingAtFirstStop) {
// //       etaMin = etaFromMeters(distanceM);
// //     }

// //     return {
// //       stopId: geom.ids[nextIdx],
// //       distanceM,
// //       etaMin,
// //       routeCode: trip.code,
// //       routeNo: trip.routeNo,
// //       waitingAtFirstStop,
// //     };
// //   }

// //   // For a given stop, find the best incoming vehicle + ETA
// //   function nextArrivalAtStop(stopId) {
// //     const candidates = [];

// //     for (const bus of buses) {
// //       if (startsWithDigit(bus.vehicleno)) continue;

// //       const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
// //       if (!routeValue) continue;

// //       for (const trip of routeCandidatesForValue(routeValue)) {
// //         const geom = routeGeom[trip.id];
// //         if (!geom) continue;

// //         const indexInRoute = geom.ids.indexOf(stopId);
// //         if (indexInRoute < 0) continue;

// //         const pt = normalizeLatLng(bus.latitude, bus.longitude);
// //         if (!pt) continue;

// //         const proj = projectOnRoute(pt, geom.poly);
// //         if (!proj) continue;

// //         const targetIndex = Math.max(indexInRoute, proj.idx + 1);
// //         if (targetIndex >= geom.ids.length) continue;

// //         const distanceM = distanceAlong(geom.poly, geom.cum, proj, targetIndex);

// //         const firstStopId = geom.ids[0];
// //         const firstStop = stopById[firstStopId];
// //         let waitingAtFirstStop = false;
// //         if (firstStop) {
// //           const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
// //           const speed = Number(bus.speed);
// //           if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
// //             waitingAtFirstStop = true;
// //           }
// //         }

// //         let etaMin = undefined;
// //         if (!waitingAtFirstStop) {
// //           etaMin = etaFromMeters(distanceM);
// //         }

// //         candidates.push({
// //           vehicle: bus.vehicleno,
// //           routeCode: trip.code,
// //           routeNo: trip.routeNo,
// //           etaMin,
// //           waitingAtFirstStop,
// //           distanceM,
// //         });
// //       }
// //     }

// //     if (!candidates.length) return null;

// //     const moving = candidates.filter(c => c.etaMin != null);
// //     if (moving.length) {
// //       return moving.reduce((a, b) => (a.etaMin <= b.etaMin ? a : b));
// //     }

// //     return candidates.reduce((a, b) => (a.distanceM <= b.distanceM ? a : b));
// //   }


// //   // ---- Derived lists ----
// //   const visibleBuses = buses.filter(b => !startsWithDigit(b.vehicleno) && normalizeLatLng(b.latitude, b.longitude));
// //   const filteredBuses = visibleBuses.filter(b => matchesFilter(b.vehicleno, filterType, assignments));

// //   function handleRouteSearch() {
// //     const requested = normalizeRouteNo(routeSearch);
// //     if (!requested) {
// //       setRouteSearchMsg("Enter a route number, for example 52-G.");
// //       return;
// //     }

// //     const matching = visibleBuses.filter(
// //       (bus) => normalizeRouteNo(getBusRouteNo(bus.vehicleno, assignments)) === requested
// //     );

// //     setFilterType(`route:${requested}`);

// //     if (matching.length > 0) {
// //       const bus = matching[0];
// //       setMapCenter({ lat: bus.latitude, lng: bus.longitude });
// //       setRouteSearchMsg(`Showing ${matching.length} vehicle(s) on route ${requested}.`);
// //       return;
// //     }

// //     const fallbackTrip = routeCandidatesForValue(requested)[0];
// //     const firstStopId = fallbackTrip?.ids?.[0];
// //     const firstStop = firstStopId ? stopById[firstStopId] : null;

// //     if (firstStop) {
// //       setMapCenter({ lat: firstStop.lat, lng: firstStop.lng });
// //       setRouteSearchMsg(`No live vehicle found on ${requested}. Zoomed to the first scheduled stop.`);
// //     } else {
// //       setRouteSearchMsg(`No live vehicle or schedule found for route ${requested}.`);
// //     }
// //   }


// //   // -------------- SCHEDULE UI helpers --------------
// //   const TABS = useMemo(() => ROUTES.map((route) => ({
// //     key: route.code,
// //     title: route.label,
// //     code: route.code,
// //     trips: ROUTE_TRIPS.filter((trip) => trip.routeNo === route.code),
// //   })), []);

// //   const ScheduleBody = useCallback(function ScheduleBody({ tab }) {
// //     const trips = tab.trips || [];

// //     if (!trips.length) {
// //       return (
// //         <div className="schedule-empty">
// //           Stop-wise schedule data is not available for this route in the uploaded ZIP.
// //         </div>
// //       );
// //     }

// //     return (
// //       <div className="schedule-trip-list">
// //         {trips
// //           .slice()
// //           .sort((a, b) => (a.order || 0) - (b.order || 0))
// //           .map((trip) => (
// //             <div className="schedule-trip-card" key={trip.id}>
// //               <div className="schedule-trip-header">
// //                 <div>
// //                   <div className="schedule-trip-title">
// //                     {trip.routeNo} / Trip {trip.order}
// //                   </div>
// //                   <div className="schedule-trip-subtitle">
// //                     {trip.from} → {trip.to}
// //                   </div>
// //                 </div>

// //                 <div className="schedule-trip-badges">
// //                   <span>{trip.startTime} - {trip.endTime}</span>
// //                   <span>{trip.service || "Town Ordinary"}</span>
// //                   <span>{trip.direction === "U" ? "Up" : trip.direction === "D" ? "Down" : trip.direction}</span>
// //                 </div>
// //               </div>

// //               <div className="schedule-stop-table-wrap">
// //                 <table className="schedule-stop-table">
// //                   <thead>
// //                     <tr>
// //                       <th>No.</th>
// //                       <th>Bus stop</th>
// //                       <th>Time</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {trip.stops.map((stop, index) => (
// //                       <tr key={`${trip.id}-${stop.id}-${index}`}>
// //                         <td>{index + 1}</td>
// //                         <td>{stop.name}</td>
// //                         <td>{stop.time}</td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </div>
// //           ))}
// //       </div>
// //     );
// //   }, []);

// //   const ScheduleModal = useCallback(function ScheduleModal() {
// //     const tab = TABS[activeTab] || TABS[0];

// //     return (
// //       <div
// //         onClick={() => setShowSchedule(false)}
// //         style={{
// //           position: 'fixed',
// //           inset: 0,
// //           background: 'rgba(0,0,0,0.45)',
// //           zIndex: 99999,
// //           display: 'flex',
// //           alignItems: 'center',
// //           justifyContent: 'center',
// //           padding: isNarrow ? 8 : 16
// //         }}
// //       >
// //         <div
// //           onClick={(e) => e.stopPropagation()}
// //           style={{
// //             position: 'relative',
// //             width: isNarrow ? '96vw' : 'min(1180px, 96vw)',
// //             height: isNarrow ? 'calc(100dvh - 16px)' : 'min(92dvh, 860px)',
// //             maxHeight: 'calc(100dvh - 16px)',
// //             minHeight: 0,
// //             background: '#ffffff',
// //             borderRadius: 16,
// //             boxShadow: '0 12px 30px rgba(0,0,0,0.3)',
// //             display: 'flex',
// //             flexDirection: 'column',
// //             overflow: 'hidden'
// //           }}
// //         >
// //           <div
// //             style={{
// //               padding: isNarrow ? '8px 10px' : '12px 16px',
// //               borderBottom: '1px solid #eee',
// //               display: 'flex',
// //               alignItems: 'center',
// //               gap: 12,
// //               flexShrink: 0
// //             }}
// //           >
// //             <img src={iitmLogo} alt="MiNT" style={{ width: isNarrow ? 26 : 32, height: isNarrow ? 26 : 32 }} />
// //             <div>
// //               <div style={{ fontWeight: 900, fontSize: isNarrow ? '14px' : '18px' }}>
// //                 Thoothukudi Bus Schedule
// //               </div>
// //               <div style={{ color: '#64748b', fontSize: 12, fontWeight: 700 }}>
// //                 Route-wise stop timings from the uploaded timesheet
// //               </div>
// //             </div>
// //             <button
// //               onClick={() => setShowSchedule(false)}
// //               style={{
// //                 marginLeft: 'auto',
// //                 border: 'none',
// //                 background: '#f4f4f5',
// //                 borderRadius: 999,
// //                 width: 34,
// //                 height: 34,
// //                 cursor: 'pointer',
// //                 fontSize: 16
// //               }}
// //               title="Close"
// //             >
// //               ✕
// //             </button>
// //           </div>

// //           <div
// //             style={{
// //               display: 'block',
// //               padding: isNarrow ? '8px 10px 10px' : '10px 14px',
// //               borderBottom: '1px solid #eee',
// //               overflowX: 'hidden',
// //               overflowY: 'auto',
// //               maxHeight: isNarrow ? 118 : 128,
// //               flexShrink: 0,
// //               WebkitOverflowScrolling: 'touch',
// //               scrollbarWidth: 'thin',
// //               overscrollBehavior: 'contain',
// //               touchAction: 'pan-y'
// //             }}
// //           >
// //             <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, minWidth: '100%' }}>
// //               {TABS.map((t, i) => (
// //                 <button
// //                   key={t.key}
// //                   onClick={() => setActiveTab(i)}
// //                   style={{
// //                     whiteSpace: 'nowrap',
// //                     padding: isNarrow ? '8px 10px' : '8px 12px',
// //                     borderRadius: 10,
// //                     border: i === activeTab ? '1px solid #0D47A1' : '1px solid #ddd',
// //                     background: i === activeTab ? '#eaf2ff' : '#ffffff',
// //                     fontWeight: 800,
// //                     cursor: 'pointer',
// //                     flex: '0 0 auto'
// //                   }}
// //                 >
// //                   {t.code}
// //                 </button>
// //               ))}
// //             </div>
// //           </div>

// //           <div
// //             className="schedule-modal-scroll-body"
// //             style={{
// //               padding: isNarrow ? 10 : 14,
// //               overflowY: 'auto',
// //               overflowX: 'hidden',
// //               flex: '1 1 auto',
// //               minHeight: 0,
// //               overscrollBehavior: 'contain',
// //               WebkitOverflowScrolling: 'touch'
// //             }}
// //           >
// //             <div className="schedule-route-summary">
// //               <div>
// //                 <div className="schedule-route-title">{tab.title}</div>
// //                 <div className="schedule-route-meta">
// //                   {tab.trips?.length || 0} trip(s) · click a route tab to view stop-wise timings
// //                 </div>
// //               </div>
// //             </div>
// //             <ScheduleBody tab={tab} />
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   }, [TABS, activeTab, isNarrow, ScheduleBody]);


// //   // Pause live updates when modal open; refresh once on close, then resume
// //   useEffect(() => {
// //     if (showSchedule) { ignoreUpdatesRef.current = true; return; }
// //     (async () => {
// //       try {
// //         if (!BACKEND) return;
// //         const res = await axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 });
// //         const arr = Array.isArray(res.data) ? res.data : [];
// //         const byVeh = new Map();
// //         for (const d of arr) {
// //           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
// //           byVeh.set(d.vehicleno, {
// //             vehicleno: d.vehicleno,
// //             latitude: d.latitude,
// //             longitude: d.longitude,
// //             speed: d.speed,
// //             heading
// //           });
// //         }
// //         const list = [...byVeh.values()];
// //         setBuses(processVehicles(list));
// //         lastUpdateRef.current = Date.now();
// //       } catch (e) {
// //         console.warn('Refresh after modal close failed:', e?.message || e);
// //       } finally {
// //         ignoreUpdatesRef.current = false;
// //       }
// //     })();
// //   }, [showSchedule]);

// //   // Responsive stop icons (smaller on phones)
// //   const stopIconInstance = useMemo(
// //     () => createCustomIcon(stopIconImg, isNarrow ? [40, 40] : [50, 50]),
// //     [isNarrow]
// //   );

// //   // --------------------------- RENDER ---------------------------
// //   return (
// //     <div className="map-container">
// //       {/* Header */}
// //       {/* <div
// //         style={{
// //           position: 'fixed',
// //           top: 'max(8px, env(safe-area-inset-top))',
// //           left: '50%',
// //           transform: 'translateX(-50%)',
// //           zIndex: 10000,
// //           background: '#ffffff',
// //           border: '1px solid #e6e6e7',
// //           borderRadius: 16,
// //           padding: pad,
// //           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
// //           width: isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))',
// //           backdropFilter: 'blur(2px)'
// //         }}
// //       > */}
// //       <div
// //         style={{
// //           position: 'fixed',
// //           top: 'max(8px, env(safe-area-inset-top))',
// //           left: '50%',
// //           transform: 'translateX(-50%)',
// //           zIndex: 10000,
// //           background: '#ffffff',
// //           border: '1px solid #e6e6e7',
// //           borderRadius: 16,
// //           padding: isHeaderCollapsed ? (isNarrow ? 8 : 10) : pad,
// //           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
// //           width: isHeaderCollapsed
// //             ? (isNarrow ? 'calc(100vw - 16px)' : 'min(420px, calc(100vw - 32px))')
// //             : (isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))'),
// //           backdropFilter: 'blur(2px)',
// //           transition: 'width 180ms ease, padding 180ms ease'
// //         }}
// //       >
// //         {/* Title row */}
// //         {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
// //           <img src={iitmLogo} alt="IIT Madras" style={{ width: isNarrow ? 28 : 36, height: isNarrow ? 28 : 36 }} />
// //           <h2
// //             style={{
// //               margin: 0,
// //               fontSize: clamp('18px','3.2vw','28px'),
// //               lineHeight: 1.1,
// //               letterSpacing: 0.3,
// //               fontWeight: 800
// //             }}
// //           >
// //             Thoothukudi Bus Tracking
// //           </h2>
// //           <a href="/admin" style={{ marginLeft: 'auto', fontWeight: 700 }}>Admin ↗</a>
// //         </div> */}

// //         {/* Title row */}
// //         <div style={{ display: 'flex', alignItems: 'center', gap: isNarrow ? 8 : 12 }}>
// //           <img
// //             src={iitmLogo}
// //             alt="IIT Madras"
// //             style={{
// //               width: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
// //               height: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
// //               flex: '0 0 auto'
// //             }}
// //           />

// //           <h2
// //             style={{
// //               margin: 0,
// //               fontSize: isHeaderCollapsed
// //                 ? clamp('15px', '3vw', '20px')
// //                 : clamp('18px', '3.2vw', '28px'),
// //               lineHeight: 1.1,
// //               letterSpacing: 0.3,
// //               fontWeight: 800,
// //               whiteSpace: 'nowrap',
// //               overflow: 'hidden',
// //               textOverflow: 'ellipsis',
// //               flex: 1
// //             }}
// //           >
// //             Thoothukudi Bus Tracking
// //           </h2>

// //           {isHeaderCollapsed && (
// //             <div
// //               style={{
// //                 fontSize: isNarrow ? 12 : 13,
// //                 fontWeight: 800,
// //                 color: '#111827',
// //                 whiteSpace: 'nowrap'
// //               }}
// //               title="Visible vehicles / total vehicles"
// //             >
// //               {filteredBuses.length}/{buses.length}
// //             </div>
// //           )}

// //           {!isHeaderCollapsed && (
// //             <a
// //               href="/admin"
// //               style={{
// //                 fontWeight: 700,
// //                 whiteSpace: 'nowrap'
// //               }}
// //             >
// //               Admin ↗
// //             </a>
// //           )}

// //           <button
// //             type="button"
// //             onClick={() => setIsHeaderCollapsed((v) => !v)}
// //             aria-label={isHeaderCollapsed ? 'Expand header' : 'Collapse header'}
// //             title={isHeaderCollapsed ? 'Expand' : 'Collapse'}
// //             style={{
// //               border: '1px solid #D1D5DB',
// //               background: '#ffffff',
// //               color: '#111827',
// //               borderRadius: 10,
// //               padding: isNarrow ? '6px 8px' : '7px 10px',
// //               fontWeight: 800,
// //               fontSize: isNarrow ? 13 : 14,
// //               lineHeight: 1,
// //               cursor: 'pointer',
// //               minWidth: isNarrow ? 34 : 38,
// //               minHeight: isNarrow ? 32 : 36
// //             }}
// //           >
// //             {isHeaderCollapsed ? '▾' : '▴'}
// //           </button>
// //         </div>

// //         {!isHeaderCollapsed && (
// //           <>

// //             {/* Status row */}
// //             <div
// //               style={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'space-between',
// //                 marginTop: 10,
// //                 gap: 12,
// //                 flexWrap: 'wrap'
// //               }}
// //             >
// //               <span
// //                 style={{
// //                   display: 'inline-block',
// //                   padding: '4px 10px',
// //                   borderRadius: 999,
// //                   fontSize: chipFS,
// //                   fontWeight: 700,
// //                   background:
// //                     socketStatus === 'connected'
// //                       ? '#E9F9EE'
// //                       : socketStatus === 'connecting'
// //                         ? '#FFF7E1'
// //                         : '#FFECEC',
// //                   color:
// //                     socketStatus === 'connected'
// //                       ? '#0A7A2A'
// //                       : socketStatus === 'connecting'
// //                         ? '#7A5D00'
// //                         : '#B00020',
// //                   border:
// //                     socketStatus === 'connected'
// //                       ? '1px solid #C6EBD1'
// //                       : socketStatus === 'connecting'
// //                         ? '1px solid #F4E3B0'
// //                         : '1px solid #FFD0D0',
// //                   textTransform: 'lowercase'
// //                 }}
// //                 title={`Socket: ${socketStatus}`}
// //               >
// //                 {socketStatus}
// //               </span>

// //               <div
// //                 style={{
// //                   fontSize: clamp('14px', '2.6vw', '18px'),
// //                   fontWeight: 700,
// //                   letterSpacing: 0.5,
// //                   color: '#111827'
// //                 }}
// //               >
// //                 {filteredBuses.length} / {buses.length}
// //               </div>
// //             </div>

// //             {/* Controls row */}
// //             <div
// //               style={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: gap,
// //                 marginTop: gap,
// //                 flexWrap: 'wrap'
// //               }}
// //             >
// //               <div style={{ position: 'relative', flex: '1 1 200px' }}>
// //                 <select
// //                   value={filterType}
// //                   onChange={(e) => setFilterType(e.target.value)}
// //                   title="Filter vehicles"
// //                   style={{
// //                     width: '100%',
// //                     padding: isNarrow ? '10px 34px 10px 12px' : '10px 40px 10px 14px',
// //                     borderRadius: 10,
// //                     border: '1px solid #D1D5DB',
// //                     background: '#FFFFFF',
// //                     fontWeight: 600,
// //                     cursor: 'pointer',
// //                     appearance: 'none',
// //                     WebkitAppearance: 'none',
// //                     MozAppearance: 'none'
// //                   }}
// //                 >
// //                   <option value="all">All Vehicles</option>
// //                   {/* <option value="cart">Cart</option> */}
// //                   {/* <option value="bus">Bus</option> */}
// //                   <optgroup label="Filter by Route">
// //                     {ROUTES.map(r => (
// //                       <option key={r.code} value={`route:${r.code}`}>{r.label}</option>
// //                     ))}
// //                   </optgroup>
// //                 </select>

// //                 <div
// //                   style={{
// //                     position: 'absolute',
// //                     right: isNarrow ? 8 : 12,
// //                     top: '50%',
// //                     transform: 'translateY(-50%)',
// //                     width: 0,
// //                     height: 0,
// //                     borderLeft: '6px solid transparent',
// //                     borderRight: '6px solid transparent',
// //                     borderTop: '7px solid #111',
// //                     pointerEvents: 'none'
// //                   }}
// //                 />
// //               </div>

// //               <div className="route-search-box">
// //                 <input
// //                   value={routeSearch}
// //                   onChange={(e) => setRouteSearch(e.target.value)}
// //                   onKeyDown={(e) => {
// //                     if (e.key === 'Enter') handleRouteSearch();
// //                   }}
// //                   placeholder="Search route e.g. 52-G"
// //                   aria-label="Search by route number"
// //                 />
// //                 <button type="button" onClick={handleRouteSearch}>
// //                   Search
// //                 </button>
// //               </div>

// //               <button
// //                 // onClick={() => window.location.reload()}
// //                 // onClick={() => {
// //                 //   requestUserLocation(); // ✅ recenter on refresh button click
// //                 // }}

// //                 // title="Reload the page"
// //                 onClick={() => {
// //                   requestUserLocation();          // ✅ recenter
// //                   setTimeout(() => {
// //                     window.location.reload();     // ✅ full reload
// //                   }, 150);
// //                 }}
// //                 title="Recenter + Reload"
// //                 style={{
// //                   padding: '10px 14px',
// //                   borderRadius: 10,
// //                   border: '1px solid #D1D5DB',
// //                   background: '#FFFFFF',
// //                   fontWeight: 700,
// //                   cursor: 'pointer',
// //                   minHeight: isNarrow ? 36 : 40,
// //                   fontSize: clamp('13px', '2.8vw', '14px')
// //                 }}
// //               >
// //                 Refresh
// //               </button>

// //               <button
// //                 onClick={() => setShowSchedule(true)}
// //                 title="Show route schedules"
// //                 style={{
// //                   padding: '10px 16px',
// //                   borderRadius: 10,
// //                   border: '1px solid #0D47A1',
// //                   background: '#0D47A1',
// //                   color: '#FFFFFF',
// //                   fontWeight: 800,
// //                   cursor: 'pointer',
// //                   boxShadow: '0 6px 16px rgba(13,71,161,0.25)',
// //                   minHeight: isNarrow ? 36 : 40,
// //                   fontSize: clamp('13px','2.8vw','14px')
// //                 }}
// //               >
// //                 Schedule
// //               </button>
// //             </div>

// //             {routeSearchMsg && (
// //               <div className="route-search-message">
// //                 {routeSearchMsg}
// //               </div>
// //             )}

// //             {maintenance && (
// //               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#fff8e1', border: '1px solid #f0d48a', fontWeight: 600 }}>
// //                 Under maintenance — {maintenanceReason}
// //               </div>
// //             )}

// //             {/* {locError && (
// //         <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
// //           {locError}
// //           <button
// //             onClick={requestUserLocation}
// //             style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
// //           >
// //             Allow location
// //           </button>
// //         </div>
// //         )} */}

// //             {locError && (
// //               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
// //                 {locError}

// //                 <button
// //                   type="button"
// //                   onClick={requestUserLocation}
// //                   style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
// //                   title={geoState === "denied" ? "Enable in site settings first, then try again" : "Try again"}
// //                 >
// //                   {geoState === "denied" ? "Open site settings" : "Allow location"}
// //                 </button>
// //               </div>
// //             )}
// //           </>
// //         )}
// //       </div>


// //       {/* Schedule Modal */}
// //       {showSchedule && <ScheduleModal />}

// //       {/* Map uses dynamic viewport on mobile (100dvh) */}
// //       {/* <MapContainer center={center} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}> */}
// //       <MapContainer center={mapCenter} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}>
// //         <RecenterMap center={mapCenter} zoom={DEFAULT_ZOOM} />

// //         <TileLayer
// //           attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
// //           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// //           maxNativeZoom={19}
// //           maxZoom={22}
// //         />

// //         {userLocation && (
// //           <Marker position={{ lat: userLocation.lat, lng: userLocation.lng }} icon={userIconInstance}>
// //             <Popup>
// //               <div className="info-window">
// //                 <h4>You are here</h4>
// //               </div>
// //             </Popup>
// //           </Marker>
// //         )}
// //         {/* Bus Stops - no ETA endpoint call. */}
// //         {busStops.map((stop) => (
// //           <Marker
// //             key={stop.id}
// //             position={{ lat: stop.lat, lng: stop.lng }}
// //             icon={stopIconInstance}
// //           >
// //             <Popup>
// //               <div className="info-window">
// //                 <h4>{stop.name}</h4>
// //                 <p><strong>Stop ID:</strong> {stop.id}</p>
// //               </div>
// //             </Popup>
// //           </Marker>
// //         ))}



// //         {/* Vehicles */}
// //         {filteredBuses.map((bus) => {
// //           const assignedRouteValue = getAssignedRouteValue(bus.vehicleno, assignments);
// //           const routeNo = getBusRouteNo(bus.vehicleno, assignments);
// //           const routeLabel = getRouteDisplayLabel(assignedRouteValue || routeNo);
// //           const label = vehicleLabel(bus.vehicleno, assignedRouteValue);
// //           const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
// //           const info = nearestStopEtaForBusOnItsRoute(bus);
// //           const recentlyPassed = recentlyPassedStopForBus(bus);
// //           const nearestName = info ? (busStops.find(s => s.id === info.stopId)?.name) : null;
// //           return (
// //             <Marker
// //               key={bus.vehicleno}
// //               position={{ lat: bus.latitude, lng: bus.longitude }}
// //               // icon={createVehicleDivIcon(label, bus.heading)}
// //               icon={createVehicleDivIcon(label, bus.heading, palette)}

// //             >
// //               <Popup>
// //                 <div className="info-window">
// //                   <h4>{bus.vehicleno} ({label})</h4>
// //                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart</p> */}
// //                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart, CR = Cart (RP↔ED)</p> */}
// //                   <p><strong>Route No:</strong> {routeNo || 'Unassigned'}</p>
// //                   <p><strong>Route:</strong> {routeLabel}</p>
// //                   <p><strong>Recently Passed:</strong> {recentlyPassed?.name || 'Not available yet'}</p>
// //                   {nearestName && <p><strong>Next Stop:</strong> {nearestName}</p>}
// //                   <p><strong>Speed:</strong> {Number.isFinite(bus.speed) ? bus.speed.toFixed(1) : 'N/A'} km/h</p>
// //                   {Number.isFinite(bus.heading) && <p><strong>Heading:</strong> {Math.round(bus.heading)}°</p>}
// //                 </div>
// //               </Popup>
// //             </Marker>
// //           );
// //         })}
// //       </MapContainer>

// //       {/* Footer: Feedback link */}
// //       <div
// //         style={{
// //           position: 'fixed',
// //           left: 0,
// //           right: 0,
// //           bottom: -5,
// //           display: 'flex',
// //           justifyContent: 'center',
// //           zIndex: 10000,
// //           pointerEvents: 'none',
// //           paddingBottom: 'max(6px, env(safe-area-inset-bottom))'
// //         }}
// //       >
// //         <div
// //           style={{
// //             width: '100vw',
// //             pointerEvents: 'auto',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'space-between',
// //             gap: 12,
// //             padding: isNarrow ? '6px 10px' : '6px 16px',
// //             borderRadius: 14,
// //             background:
// //               'linear-gradient(135deg, rgba(17,24,39,0.85), rgba(31,41,55,0.85))',
// //             color: '#F9FAFB',
// //             border: '1px solid rgba(255,255,255,0.14)',
// //             boxShadow:
// //               '0 12px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.06)',
// //             backdropFilter: 'saturate(160%) blur(10px)',
// //             WebkitBackdropFilter: 'saturate(160%) blur(10px)',
// //             fontFamily:
// //               '"SF Pro Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"',
// //             fontSize: clamp('12px', '2.8vw', '14px'),
// //             lineHeight: 1.4,
// //             fontWeight: 500,
// //             letterSpacing: '0.2px',
// //           }}
// //         >
// //           <div
// //             style={{
// //               display: 'flex',
// //               alignItems: 'center',
// //               gap: 10,
// //               flex: 1,
// //               minWidth: 0,
// //             }}
// //           >
// //             <div
// //               style={{
// //                 width: 8,
// //                 height: 8,
// //                 borderRadius: 9999,
// //                 background:
// //                   'radial-gradient(circle at 30% 30%, #34D399, #059669)',
// //                 boxShadow: '0 0 0 3px rgba(16,185,129,0.25)',
// //                 flex: '0 0 auto',
// //               }}
// //             />
// //             <span
// //               style={{
// //                 opacity: 0.95,
// //                 whiteSpace: 'nowrap',
// //                 overflow: 'hidden',
// //                 textOverflow: 'ellipsis',
// //               }}
// //             >
// //               MInT Lab | IIT Madras | UkPact
// //             </span>
// //           </div>

// //           {FEEDBACK_URL ? (
// //             <a
// //               href={FEEDBACK_URL}
// //               target="_blank"
// //               rel="noreferrer"
// //               style={{
// //                 display: 'inline-flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 padding: '8px 12px',
// //                 borderRadius: 10,
// //                 border: '1px solid rgba(255,255,255,0.18)',
// //                 background:
// //                   'linear-gradient(180deg, rgba(128, 126, 126, 0.14), rgba(221, 212, 212, 0.06))',
// //                 color: '#F9FAFB',
// //                 textDecoration: 'none',
// //                 fontWeight: 600,
// //                 letterSpacing: '0.25px',
// //                 transform: 'translateZ(0)',
// //                 transition: 'transform 120ms ease, opacity 120ms ease',
// //                 cursor: 'pointer',
// //                 boxShadow:
// //                   'inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 14px rgba(0,0,0,0.25)',
// //               }}
// //               onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-1px)')}
// //               onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
// //             >
// //               Open feedback form ↗
// //             </a>
// //           ) : (
// //             <span
// //               style={{
// //                 padding: '8px 12px',
// //                 borderRadius: 10,
// //                 border: '1px dashed rgba(255,255,255,0.25)',
// //                 color: 'rgba(249,250,251,0.8)',
// //                 fontWeight: 500,
// //               }}
// //             >
// //               &lt;form-link&gt;
// //             </span>
// //           )}
// //         </div>
// //       </div>

// //     </div>
// //   );
// // }

// // /* ---------------------------- HOME PAGE ---------------------------- */

// // const AIR_QUALITY_URL = "https://main.d2yil9slaoehou.amplifyapp.com/";

// // function HomePage({ navigate }) {
// //   const cards = [
// //     {
// //       title: "Bus Tracking",
// //       subtitle: "Live vehicle location using WebSocket",
// //       path: "/tracking",
// //       icon: "🚌",
// //       type: "internal",
// //     },
// //     {
// //       title: "Air Quality Sensor",
// //       subtitle: "View live air quality monitoring dashboard",
// //       url: AIR_QUALITY_URL,
// //       icon: "🌫️",
// //       type: "external",
// //     },
// //     {
// //       title: "Camera Data",
// //       subtitle: "Vehicle count analytics from camera feed",
// //       path: "/camera",
// //       icon: "📷",
// //       type: "internal",
// //     },
// //   ];

// //   // const openCard = (card) => {
// //   //   if (card.type === "external") {
// //   //     window.location.href = card.url;
// //   //     return;
// //   //   }
// //   //   navigate(card.path);
// //   // };

// //   const openCard = (card) => {
// //   if (card.type === "external") {
// //     window.open(card.url, "_blank", "noopener,noreferrer");
// //     return;
// //   }

// //   window.open(card.path, "_blank", "noopener,noreferrer");
// // };

// //   return (
// //     <div className="home-page">
// //       <div className="home-bg-glow home-bg-glow-one" />
// //       <div className="home-bg-glow home-bg-glow-two" />

// //       <header className="home-navbar">
// // <div className="home-brand">
// //   <img
// //     src={iitmLogo}
// //     alt="MInT Lab Logo"
// //     className="home-brand-logo-img"
// //   />

// //   <div className="home-brand-text">
// //     <div className="home-brand-title">MInT Collaborative</div>
// //     <div className="home-brand-subtitle">IIT Madras | UKPACT</div>
// //   </div>
// // </div>

// //         <button className="home-nav-button" onClick={() => navigate("/tracking")}>
// //           Open Tracking
// //         </button>
// //       </header>

// //       <main className="home-main">
// //         <section className="home-hero">
// //           <div className="home-pill">Smart Mobility Dashboard</div>

// //           <h1>
// //             Real-time Transport, Sensor <br />
// //             and Camera Intelligence
// //           </h1>

// //           <p>
// //             A single access point for bus tracking, air quality monitoring,
// //             and vehicle count analytics.
// //           </p>
// //         </section>

// //         <section className="home-card-grid">
// //           {cards.map((card) => (
// //             <button
// //               key={card.title}
// //               className="home-feature-card"
// //               onClick={() => openCard(card)}
// //             >
// //               <div className="home-card-icon">{card.icon}</div>

// //               <div className="home-card-content">
// //                 <h2>{card.title}</h2>
// //                 <p>{card.subtitle}</p>
// //               </div>

// //               <div className="home-card-arrow">
// //                 {card.type === "external" ? "↗" : "→"}
// //               </div>
// //             </button>
// //           ))}
// //         </section>
// //       </main>
// //     </div>
// //   );
// // }


// // /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// // const CAMERA_FALLBACK_DATA = [
// //   {
// //     timestamp: "2025-11-01 00:00:06",
// //     auto: 0,
// //     motorbike: 0,
// //     bus: 0,
// //     car: 0,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:11",
// //     auto: 0,
// //     motorbike: 4,
// //     bus: 1,
// //     car: 4,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:16",
// //     auto: 0,
// //     motorbike: 2,
// //     bus: 0,
// //     car: 0,
// //     truck: 1,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:21",
// //     auto: 0,
// //     motorbike: 1,
// //     bus: 0,
// //     car: 1,
// //     truck: 1,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:26",
// //     auto: 0,
// //     motorbike: 3,
// //     bus: 0,
// //     car: 0,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:31",
// //     auto: 0,
// //     motorbike: 0,
// //     bus: 0,
// //     car: 0,
// //     truck: 0,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:36",
// //     auto: 0,
// //     motorbike: 5,
// //     bus: 0,
// //     car: 1,
// //     truck: 1,
// //   },
// //   {
// //     timestamp: "2025-11-01 00:00:41",
// //     auto: 0,
// //     motorbike: 4,
// //     bus: 1,
// //     car: 5,
// //     truck: 1,
// //   },
// // ];

// // // function parseCameraCsv(csvText) {
// // //   const lines = csvText
// // //     .trim()
// // //     .split(/\r?\n/)
// // //     .filter(Boolean);

// // //   if (lines.length < 2) return [];

// // //   const headers = lines[0].split(",").map((h) => h.trim());

// // //   return lines.slice(1).map((line) => {
// // //     const values = line.split(",").map((v) => v.trim());
// // //     const row = {};

// // //     headers.forEach((header, index) => {
// // //       if (header === "timestamp") {
// // //         row[header] = values[index];
// // //       } else {
// // //         row[header] = Number(values[index] || 0);
// // //       }
// // //     });

// // //     return row;
// // //   });
// // // }

// // const CAMERA_LOCATIONS = [
// //   {
// //     id: "camera-site-1",
// //     sno: 1,
// //     place: "Ettayapuram Rd",
// //     location: "Perison Plaza Signal",
// //     boxes: 2,
// //     cameras: 2,
// //     lat: 8.81277,
// //     lng: 78.13647,
// //   },
// //   {
// //     id: "camera-site-2",
// //     sno: 2,
// //     place: "4th Gate",
// //     location: "South side of Milavittan Road",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.80967,
// //     lng: 78.1335,
// //   },
// //   {
// //     id: "camera-site-3",
// //     sno: 3,
// //     place: "International Furniture Park",
// //     location: "Madurai - Tiruchendur Rd highway east side",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.81624,
// //     lng: 78.08118,
// //   },
// //   {
// //     id: "camera-site-4",
// //     sno: 4,
// //     place: "3rd Mile",
// //     location: "Near TVL-TUT-MDR Bypass Bridge",
// //     boxes: 2,
// //     cameras: 2,
// //     lat: 8.789608,
// //     lng: 78.11493,
// //   },
// //   {
// //     id: "camera-site-5",
// //     sno: 5,
// //     place: "Alageshapuram Road",
// //     location: "Roundana near St. Thomas School",
// //     boxes: 1,
// //     cameras: 2,
// //     lat: 8.81705,
// //     lng: 78.14797,
// //   },
// //   {
// //     id: "camera-site-6",
// //     sno: 6,
// //     place: "Tiruchendur Rd",
// //     location: "Muthiahpuram",
// //     boxes: 1,
// //     cameras: 1,
// //     lat: 8.74541,
// //     lng: 78.1253,
// //   },
// // ];

// // const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// // function parseCameraCsv(csvText) {
// //   const lines = csvText
// //     .trim()
// //     .split(/\r?\n/)
// //     .filter(Boolean);

// //   if (lines.length < 2) return [];

// //   const firstLine = lines[0].toLowerCase();
// //   const hasHeader = firstLine.includes("timestamp");

// //   const headers = hasHeader
// //     ? lines[0].split(",").map((h) => h.trim().toLowerCase())
// //     : ["timestamp", "auto", "motorbike", "bus", "car", "truck"];

// //   const dataLines = hasHeader ? lines.slice(1) : lines;

// //   return dataLines.map((line) => {
// //     const values = line.split(",").map((v) => v.trim());
// //     const row = {};

// //     headers.forEach((header, index) => {
// //       if (header === "timestamp") {
// //         row.timestamp = values[index] || "";
// //       } else if (
// //         header === "cameraid" ||
// //         header === "camera_id" ||
// //         header === "camera" ||
// //         header === "site"
// //       ) {
// //         row.cameraId = values[index] || "";
// //       } else if (header === "direction") {
// //         row.direction = values[index] || "All Directions";
// //       } else {
// //         row[header] = Number(values[index] || 0);
// //       }
// //     });

// //     return {
// //       timestamp: row.timestamp || "",
// //       cameraId: row.cameraId || "ALL",
// //       direction: row.direction || "All Directions",
// //       auto: Number(row.auto || 0),
// //       motorbike: Number(row.motorbike || 0),
// //       bus: Number(row.bus || 0),
// //       car: Number(row.car || 0),
// //       truck: Number(row.truck || 0),
// //     };
// //   });
// // }

// // function sumRows(rows) {
// //   return rows.reduce(
// //     (acc, row) => {
// //       acc.auto += Number(row.auto || 0);
// //       acc.motorbike += Number(row.motorbike || 0);
// //       acc.bus += Number(row.bus || 0);
// //       acc.car += Number(row.car || 0);
// //       acc.truck += Number(row.truck || 0);
// //       return acc;
// //     },
// //     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// //   );
// // }

// // function totalFromCounts(counts) {
// //   return VEHICLE_TYPES.reduce((sum, type) => sum + Number(counts[type] || 0), 0);
// // }

// // function getDateKey(timestamp) {
// //   return String(timestamp || "").slice(0, 10);
// // }

// // function getWeekKey(timestamp) {
// //   const datePart = getDateKey(timestamp);
// //   if (!datePart) return "Unknown";

// //   const date = new Date(`${datePart}T00:00:00`);
// //   if (Number.isNaN(date.getTime())) return "Unknown";

// //   const firstDay = new Date(date.getFullYear(), 0, 1);
// //   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
// //   const weekNumber = Math.ceil(dayNumber / 7);

// //   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// // }

// // function buildChartData(rows, mode = "daily") {
// //   const grouped = {};

// //   rows.forEach((row) => {
// //     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
// //     if (!key) return;

// //     if (!grouped[key]) {
// //       grouped[key] = {
// //         label: key,
// //         auto: 0,
// //         motorbike: 0,
// //         bus: 0,
// //         car: 0,
// //         truck: 0,
// //       };
// //     }

// //     VEHICLE_TYPES.forEach((type) => {
// //       grouped[key][type] += Number(row[type] || 0);
// //     });
// //   });

// //   return Object.values(grouped)
// //     .map((item) => ({
// //       ...item,
// //       total: totalFromCounts(item),
// //     }))
// //     .sort((a, b) => a.label.localeCompare(b.label));
// // }

// // function buildDirectionData(rows) {
// //   const grouped = {};

// //   rows.forEach((row) => {
// //     const direction = row.direction || "All Directions";

// //     if (!grouped[direction]) {
// //       grouped[direction] = {
// //         direction,
// //         auto: 0,
// //         motorbike: 0,
// //         bus: 0,
// //         car: 0,
// //         truck: 0,
// //       };
// //     }

// //     VEHICLE_TYPES.forEach((type) => {
// //       grouped[direction][type] += Number(row[type] || 0);
// //     });
// //   });

// //   return Object.values(grouped).map((item) => ({
// //     ...item,
// //     total: totalFromCounts(item),
// //   }));
// // }

// // function CameraMapFlyTo({ selectedLocation }) {
// //   const map = useMap();

// //   useEffect(() => {
// //     if (!selectedLocation) return;

// //     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
// //       duration: 0.8,
// //     });
// //   }, [map, selectedLocation]);

// //   return null;
// // }

// // function MiniBarChart({ title, data }) {
// //   const maxValue = Math.max(...data.map((item) => item.total), 1);

// //   return (
// //     <div className="camera-chart-card">
// //       <div className="camera-chart-header">
// //         <h3>{title}</h3>
// //       </div>

// //       <div className="camera-bar-chart">
// //         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

// //         {data.map((item) => {
// //           const height = Math.max(8, (item.total / maxValue) * 150);

// //           return (
// //             <div className="camera-bar-item" key={item.label}>
// //               <div className="camera-bar-value">{item.total}</div>
// //               <div className="camera-bar-track">
// //                 <div
// //                   className="camera-bar-fill"
// //                   style={{ height: `${height}px` }}
// //                 />
// //               </div>
// //               <div className="camera-bar-label">{item.label}</div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // }

// // function CameraDataPage({ navigate }) {
// //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// //   const [loading, setLoading] = useState(true);
// //   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
// //   const [chartMode, setChartMode] = useState("daily");

// //   const [page, setPage] = useState(1);
// //   const [limit, setLimit] = useState(25);

// //   useEffect(() => {
// //     const csvUrl =
// //       process.env.REACT_APP_CAMERA_CSV_URL ||
// //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// //     fetch(csvUrl)
// //       .then((res) => {
// //         if (!res.ok) throw new Error("CSV not found");
// //         return res.text();
// //       })
// //       .then((text) => {
// //         const parsed = parseCameraCsv(text);
// //         if (parsed.length > 0) {
// //           setRows(parsed.reverse());
// //           setSourceLabel("CSV data");
// //           setPage(1);
// //         }
// //       })
// //       .catch(() => {
// //         setRows(CAMERA_FALLBACK_DATA);
// //         setSourceLabel("Static sample data");
// //       })
// //       .finally(() => setLoading(false));
// //   }, []);

// //   const selectedRows = useMemo(() => {
// //     const hasCameraSpecificRows = rows.some((row) => row.cameraId !== "ALL");

// //     if (!hasCameraSpecificRows) {
// //       return rows;
// //     }

// //     return rows.filter((row) => row.cameraId === selectedLocation.id);
// //   }, [rows, selectedLocation]);

// //   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
// //   const totalVehicles = totalFromCounts(totals);

// //   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
// //   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
// //   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

// //   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

// //   const totalRows = selectedRows.length;
// //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// //   const safePage = Math.min(page, totalPages);
// //   const offset = (safePage - 1) * limit;

// //   const paginatedRows = useMemo(() => {
// //     return selectedRows.slice(offset, offset + limit);
// //   }, [selectedRows, offset, limit]);

// //   const latestRow = selectedRows[0];

// //   const handleLocationClick = (location) => {
// //     setSelectedLocation(location);
// //     setPage(1);
// //   };

// //   const handleLimitChange = (e) => {
// //     setLimit(Number(e.target.value));
// //     setPage(1);
// //   };

// //   return (
// //     <div className="camera-page">
// //       <div className="camera-bg-glow camera-bg-glow-one" />
// //       <div className="camera-bg-glow camera-bg-glow-two" />

// //       <header className="camera-navbar">
// //         <button className="camera-back-button" onClick={() => navigate("/")}>
// //           ← Home
// //         </button>

// //         <div>
// //           <h1>Camera Data</h1>
// //           <p>Traffic counts by vehicle type and camera location</p>
// //         </div>

// //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// //           Bus Tracking
// //         </button>
// //       </header>

// //       <main className="camera-content">
// //         <section className="camera-summary-grid">
// //           <div className="camera-summary-card total">
// //             <span>Total Vehicles</span>
// //             <strong>{totalVehicles}</strong>
// //             <small>{sourceLabel}</small>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Cars</span>
// //             <strong>{totals.car}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Motorbikes</span>
// //             <strong>{totals.motorbike}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Buses</span>
// //             <strong>{totals.bus}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Trucks</span>
// //             <strong>{totals.truck}</strong>
// //           </div>

// //           <div className="camera-summary-card">
// //             <span>Autos</span>
// //             <strong>{totals.auto}</strong>
// //           </div>
// //         </section>

// //         <section className="camera-map-layout">
// //           <aside className="camera-location-panel">
// //             <div className="camera-location-header">
// //               <h2>Camera Locations</h2>
// //               <p>{CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across {CAMERA_LOCATIONS.length} locations</p>
// //             </div>

// //             <div className="camera-location-list">
// //               {CAMERA_LOCATIONS.map((item) => (
// //                 <button
// //                   key={item.id}
// //                   className={
// //                     selectedLocation.id === item.id
// //                       ? "camera-location-item active"
// //                       : "camera-location-item"
// //                   }
// //                   onClick={() => handleLocationClick(item)}
// //                 >
// //                   <div>
// //                     <strong>{item.place}</strong>
// //                     <span>{item.location}</span>
// //                   </div>

// //                   <small>
// //                     {item.cameras} camera{item.cameras > 1 ? "s" : ""}
// //                   </small>
// //                 </button>
// //               ))}
// //             </div>
// //           </aside>

// //           <section className="camera-map-card">
// //             <MapContainer
// //               center={[selectedLocation.lat, selectedLocation.lng]}
// //               zoom={14}
// //               className="camera-osm-map"
// //               scrollWheelZoom={true}
// //             >
// //               <TileLayer
// //                 attribution='&copy; OpenStreetMap contributors'
// //                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// //               />

// //               <CameraMapFlyTo selectedLocation={selectedLocation} />

// //               {CAMERA_LOCATIONS.map((item) => (
// //                 <Marker
// //                   key={item.id}
// //                   position={[item.lat, item.lng]}
// //                   eventHandlers={{
// //                     click: () => handleLocationClick(item),
// //                   }}
// //                 >
// //                   <Popup>
// //                     <div className="camera-popup">
// //                       <h3>{item.place}</h3>
// //                       <p>{item.location}</p>
// //                       <p>
// //                         <strong>Cameras:</strong> {item.cameras}
// //                       </p>
// //                       <p>
// //                         <strong>Total Vehicles:</strong>{" "}
// //                         {selectedLocation.id === item.id ? totalVehicles : "Click location"}
// //                       </p>
// //                     </div>
// //                   </Popup>
// //                 </Marker>
// //               ))}
// //             </MapContainer>
// //           </section>
// //         </section>

// //         <section className="camera-selected-panel">
// //           <div>
// //             <h2>{selectedLocation.place}</h2>
// //             <p>{selectedLocation.location}</p>
// //           </div>

// //           <div className="camera-selected-meta">
// //             <span>{selectedLocation.boxes} boxes</span>
// //             <span>{selectedLocation.cameras} cameras</span>
// //             <span>
// //               {selectedLocation.lat}, {selectedLocation.lng}
// //             </span>
// //           </div>
// //         </section>

// //         {/* <section className="camera-direction-grid">
// //           {directionData.map((item) => (
// //             <div className="camera-direction-card" key={item.direction}>
// //               <span>{item.direction}</span>
// //               <strong>{item.total}</strong>
// //               <small>
// //                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
// //               </small>
// //             </div>
// //           ))}
// //         </section> */}

// //         <section className="camera-chart-section">
// //           <div className="camera-chart-toolbar">
// //             <div>
// //               <h2>Dashboard Analysis</h2>
// //               <p>Daily and weekly traffic count trends</p>
// //             </div>

// //             <div className="camera-chart-toggle">
// //               <button
// //                 className={chartMode === "daily" ? "active" : ""}
// //                 onClick={() => setChartMode("daily")}
// //               >
// //                 Daily
// //               </button>
// //               <button
// //                 className={chartMode === "weekly" ? "active" : ""}
// //                 onClick={() => setChartMode("weekly")}
// //               >
// //                 Weekly
// //               </button>
// //             </div>
// //           </div>

// //           <MiniBarChart
// //             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
// //             data={chartData}
// //           />
// //         </section>

// //         <section className="camera-panel">
// //           <div className="camera-panel-header">
// //             <div>
// //               <h2>Vehicle Count Table</h2>
// //               <p>
// //                 {loading
// //                   ? "Loading camera data..."
// //                   : latestRow
// //                   ? `Latest timestamp: ${latestRow.timestamp}`
// //                   : "No camera records available"}
// //               </p>
// //             </div>

// //             <div className="camera-pagination-top">
// //               <label>
// //                 Limit
// //                 <select value={limit} onChange={handleLimitChange}>
// //                   <option value={10}>10</option>
// //                   <option value={25}>25</option>
// //                   <option value={50}>50</option>
// //                   <option value={100}>100</option>
// //                   <option value={200}>200</option>
// //                 </select>
// //               </label>
// //             </div>
// //           </div>

// //           <div className="camera-table-info">
// //             <span>
// //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// //               {Math.min(offset + limit, totalRows)} of {totalRows}
// //             </span>

// //             <span>
// //               Offset: {offset} | Limit: {limit}
// //             </span>
// //           </div>

// //           <div className="camera-table-wrap">
// //             <table className="camera-table">
// //               <thead>
// //                 <tr>
// //                   <th>Timestamp</th>
// //                   <th>Direction</th>
// //                   <th>Auto</th>
// //                   <th>Motorbike</th>
// //                   <th>Bus</th>
// //                   <th>Car</th>
// //                   <th>Truck</th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {paginatedRows.map((row, index) => (
// //                   <tr key={`${row.timestamp}-${index}`}>
// //                     <td>{row.timestamp}</td>
// //                     <td>{row.direction}</td>
// //                     <td>{row.auto}</td>
// //                     <td>{row.motorbike}</td>
// //                     <td>{row.bus}</td>
// //                     <td>{row.car}</td>
// //                     <td>{row.truck}</td>
// //                   </tr>
// //                 ))}

// //                 {!loading && paginatedRows.length === 0 && (
// //                   <tr>
// //                     <td colSpan="7" style={{ textAlign: "center", padding: "24px" }}>
// //                       No camera data available
// //                     </td>
// //                   </tr>
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>

// //           <div className="camera-pagination-bottom">
// //             <button onClick={() => setPage((prev) => Math.max(1, prev - 1))} disabled={safePage <= 1}>
// //               ← Previous
// //             </button>

// //             <span>
// //               Page {safePage} of {totalPages}
// //             </span>

// //             <button onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))} disabled={safePage >= totalPages}>
// //               Next →
// //             </button>
// //           </div>
// //         </section>
// //       </main>
// //     </div>
// //   );
// // }
// // // function CameraDataPage({ navigate }) {
// // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // //   const [loading, setLoading] = useState(true);

// // //   // Pagination states
// // //   const [page, setPage] = useState(1);
// // //   const [limit, setLimit] = useState(25);

// // //   useEffect(() => {
// // //     const csvUrl =
// // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // //     fetch(csvUrl)
// // //       .then((res) => {
// // //         if (!res.ok) throw new Error("CSV not found");
// // //         return res.text();
// // //       })
// // //       .then((text) => {
// // //         const parsed = parseCameraCsv(text);
// // //         if (parsed.length > 0) {
// // //           // latest data first
// // //           setRows(parsed.reverse());
// // //           setSourceLabel("CSV data");
// // //           setPage(1);
// // //         }
// // //       })
// // //       .catch(() => {
// // //         setRows(CAMERA_FALLBACK_DATA);
// // //         setSourceLabel("Static sample data");
// // //       })
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   const totals = useMemo(() => {
// // //     return rows.reduce(
// // //       (acc, row) => {
// // //         acc.auto += Number(row.auto || 0);
// // //         acc.motorbike += Number(row.motorbike || 0);
// // //         acc.bus += Number(row.bus || 0);
// // //         acc.car += Number(row.car || 0);
// // //         acc.truck += Number(row.truck || 0);
// // //         return acc;
// // //       },
// // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // //     );
// // //   }, [rows]);

// // //   const totalVehicles =
// // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // //   const totalRows = rows.length;
// // //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// // //   const safePage = Math.min(page, totalPages);

// // //   const offset = (safePage - 1) * limit;

// // //   const paginatedRows = useMemo(() => {
// // //     return rows.slice(offset, offset + limit);
// // //   }, [rows, offset, limit]);

// // //   const latestRow = rows[0];

// // //   const goToPreviousPage = () => {
// // //     setPage((prev) => Math.max(1, prev - 1));
// // //   };

// // //   const goToNextPage = () => {
// // //     setPage((prev) => Math.min(totalPages, prev + 1));
// // //   };

// // //   const handleLimitChange = (e) => {
// // //     setLimit(Number(e.target.value));
// // //     setPage(1);
// // //   };

// // //   return (
// // //     <div className="camera-page">
// // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // //       <header className="camera-navbar">
// // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // //           ← Home
// // //         </button>

// // //         <div>
// // //           <h1>Camera Data</h1>
// // //           <p>Vehicle count analytics</p>
// // //         </div>

// // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // //           Bus Tracking
// // //         </button>
// // //       </header>

// // //       <main className="camera-content">
// // //         <section className="camera-summary-grid">
// // //           <div className="camera-summary-card total">
// // //             <span>Total Vehicles</span>
// // //             <strong>{totalVehicles}</strong>
// // //             <small>{sourceLabel}</small>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Cars</span>
// // //             <strong>{totals.car}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Motorbikes</span>
// // //             <strong>{totals.motorbike}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Buses</span>
// // //             <strong>{totals.bus}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Trucks</span>
// // //             <strong>{totals.truck}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Autos</span>
// // //             <strong>{totals.auto}</strong>
// // //           </div>
// // //         </section>

// // //         <section className="camera-panel">
// // //           <div className="camera-panel-header">
// // //             <div>
// // //               <h2>Vehicle Count Table</h2>
// // //               <p>
// // //                 {loading
// // //                   ? "Loading camera data..."
// // //                   : latestRow
// // //                     ? `Latest timestamp: ${latestRow.timestamp}`
// // //                     : "No camera records available"}
// // //               </p>
// // //             </div>

// // //             <div className="camera-pagination-top">
// // //               <label>
// // //                 Limit
// // //                 <select value={limit} onChange={handleLimitChange}>
// // //                   <option value={10}>10</option>
// // //                   <option value={25}>25</option>
// // //                   <option value={50}>50</option>
// // //                   <option value={100}>100</option>
// // //                   <option value={200}>200</option>
// // //                 </select>
// // //               </label>
// // //             </div>
// // //           </div>

// // //           <div className="camera-table-info">
// // //             <span>
// // //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// // //               {Math.min(offset + limit, totalRows)} of {totalRows}
// // //             </span>

// // //             <span>
// // //               Offset: {offset} | Limit: {limit}
// // //             </span>
// // //           </div>

// // //           <div className="camera-table-wrap">
// // //             <table className="camera-table">
// // //               <thead>
// // //                 <tr>
// // //                   <th>Timestamp</th>
// // //                   <th>Auto</th>
// // //                   <th>Motorbike</th>
// // //                   <th>Bus</th>
// // //                   <th>Car</th>
// // //                   <th>Truck</th>
// // //                 </tr>
// // //               </thead>

// // //               <tbody>
// // //                 {paginatedRows.map((row, index) => (
// // //                   <tr key={`${row.timestamp}-${index}`}>
// // //                     <td>{row.timestamp}</td>
// // //                     <td>{row.auto}</td>
// // //                     <td>{row.motorbike}</td>
// // //                     <td>{row.bus}</td>
// // //                     <td>{row.car}</td>
// // //                     <td>{row.truck}</td>
// // //                   </tr>
// // //                 ))}

// // //                 {!loading && paginatedRows.length === 0 && (
// // //                   <tr>
// // //                     <td colSpan="6" style={{ textAlign: "center", padding: "24px" }}>
// // //                       No camera data available
// // //                     </td>
// // //                   </tr>
// // //                 )}
// // //               </tbody>
// // //             </table>
// // //           </div>

// // //           <div className="camera-pagination-bottom">
// // //             <button onClick={goToPreviousPage} disabled={safePage <= 1}>
// // //               ← Previous
// // //             </button>

// // //             <span>
// // //               Page {safePage} of {totalPages}
// // //             </span>

// // //             <button onClick={goToNextPage} disabled={safePage >= totalPages}>
// // //               Next →
// // //             </button>
// // //           </div>
// // //         </section>
// // //       </main>
// // //     </div>
// // //   );
// // // }
// // // function CameraDataPage({ navigate }) {
// // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // //   const [loading, setLoading] = useState(true);

// // //   useEffect(() => {
// // //     const csvUrl =
// // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // //     fetch(csvUrl)
// // //       .then((res) => {
// // //         if (!res.ok) throw new Error("CSV not found");
// // //         return res.text();
// // //       })
// // //       .then((text) => {
// // //         const parsed = parseCameraCsv(text);
// // //         if (parsed.length > 0) {
// // //           setRows(parsed);
// // //           setSourceLabel("CSV data");
// // //         }
// // //       })
// // //       .catch(() => {
// // //         setRows(CAMERA_FALLBACK_DATA);
// // //         setSourceLabel("Static sample data");
// // //       })
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   const totals = useMemo(() => {
// // //     return rows.reduce(
// // //       (acc, row) => {
// // //         acc.auto += Number(row.auto || 0);
// // //         acc.motorbike += Number(row.motorbike || 0);
// // //         acc.bus += Number(row.bus || 0);
// // //         acc.car += Number(row.car || 0);
// // //         acc.truck += Number(row.truck || 0);
// // //         return acc;
// // //       },
// // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // //     );
// // //   }, [rows]);

// // //   const totalVehicles =
// // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // //   const latestRow = rows[rows.length - 1];

// // //   return (
// // //     <div className="camera-page">
// // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // //       <header className="camera-navbar">
// // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // //           ← Home
// // //         </button>

// // //         <div>
// // //           <h1>Camera Data</h1>
// // //           <p>Vehicle count analytics</p>
// // //         </div>

// // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // //           Bus Tracking
// // //         </button>
// // //       </header>

// // //       <main className="camera-content">
// // //         <section className="camera-summary-grid">
// // //           <div className="camera-summary-card total">
// // //             <span>Total Vehicles</span>
// // //             <strong>{totalVehicles}</strong>
// // //             <small>{sourceLabel}</small>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Cars</span>
// // //             <strong>{totals.car}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Motorbikes</span>
// // //             <strong>{totals.motorbike}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Buses</span>
// // //             <strong>{totals.bus}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Trucks</span>
// // //             <strong>{totals.truck}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Autos</span>
// // //             <strong>{totals.auto}</strong>
// // //           </div>
// // //         </section>

// // //         <section className="camera-panel">
// // //           <div className="camera-panel-header">
// // //             <div>
// // //               <h2>Vehicle Count Table</h2>
// // //               <p>
// // //                 {loading
// // //                   ? "Loading camera data..."
// // //                   : latestRow
// // //                   ? `Latest timestamp: ${latestRow.timestamp}`
// // //                   : "No camera records available"}
// // //               </p>
// // //             </div>
// // //           </div>

// // //           <div className="camera-table-wrap">
// // //             <table className="camera-table">
// // //               <thead>
// // //                 <tr>
// // //                   <th>Timestamp</th>
// // //                   <th>Auto</th>
// // //                   <th>Motorbike</th>
// // //                   <th>Bus</th>
// // //                   <th>Car</th>
// // //                   <th>Truck</th>
// // //                 </tr>
// // //               </thead>

// // //               <tbody>
// // //                 {rows.map((row, index) => (
// // //                   <tr key={`${row.timestamp}-${index}`}>
// // //                     <td>{row.timestamp}</td>
// // //                     <td>{row.auto}</td>
// // //                     <td>{row.motorbike}</td>
// // //                     <td>{row.bus}</td>
// // //                     <td>{row.car}</td>
// // //                     <td>{row.truck}</td>
// // //                   </tr>
// // //                 ))}
// // //               </tbody>
// // //             </table>
// // //           </div>
// // //         </section>
// // //       </main>
// // //     </div>
// // //   );
// // // }

// // /* ---------------------------- APP (router) ---------------------------- */
// // /* ---------------------------- APP (router) ---------------------------- */

// // function App() {
// //   const { path, navigate } = usePath();
// //   const token = getToken();
// //   const adminToken = getAdminToken();

// //   // Track page views on bus tracking page for Prometheus
// //   useEffect(() => {
// //     if (!BACKEND) return;
// //     if (path !== "/tracking") return;
// //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// //   }, [path]);

// //   // Forward /driver -> /driverRoute when logged in
// //   useEffect(() => {
// //     if (path === "/driver" && token) {
// //       navigate("/driverRoute");
// //     }
// //   }, [path, token, navigate]);

// //   // Admin redirects
// //   useEffect(() => {
// //     if (path === "/admin/login" && adminToken) {
// //       navigate("/admin");
// //     } else if (path === "/admin" && !adminToken) {
// //       navigate("/admin/login");
// //     }
// //   }, [path, adminToken, navigate]);

// //   // New public pages
// //   if (path === "/") {
// //     return <HomePage navigate={navigate} />;
// //   }

// //   if (path === "/tracking") {
// //     return <MapPage />;
// //   }

// //   if (path === "/camera") {
// //     return <CameraDataPage navigate={navigate} />;
// //   }

// //   // Existing driver pages
// //   if (path === "/driver") {
// //     if (token) return null;
// //     return <DriverLogin navigate={navigate} />;
// //   }

// //   if (path === "/driverRoute") {
// //     return <DriverRoute navigate={navigate} />;
// //   }

// //   // Existing admin pages
// //   if (path === "/admin/login") {
// //     if (adminToken) return null;
// //     return <AdminLogin navigate={navigate} />;
// //   }

// //   if (path === "/admin") {
// //     return <AdminDashboard navigate={navigate} />;
// //   }

// //   // Fallback
// //   return <HomePage navigate={navigate} />;
// // }

// // // export default function App() {
// // //   const { path, navigate } = usePath();
// // //   const token = getToken();
// // //   const adminToken = getAdminToken();

// // //   // Track page views on main map for Prometheus
// // //   useEffect(() => {
// // //     if (!BACKEND) return;
// // //     if (path !== "/") return;
// // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// // //   }, [path]);

// // //   // Forward /driver -> /driverRoute when logged in
// // //   useEffect(() => {
// // //     if (path === "/driver" && token) {
// // //       navigate("/driverRoute");
// // //     }
// // //   }, [path, token, navigate]);

// // //   // Admin redirects
// // //   useEffect(() => {
// // //     if (path === "/admin/login" && adminToken) {
// // //       navigate("/admin");
// // //     } else if (path === "/admin" && !adminToken) {
// // //       navigate("/admin/login");
// // //     }
// // //   }, [path, adminToken, navigate]);

// // //   if (path === "/driver") {
// // //     if (token) return null;
// // //     return <DriverLogin navigate={navigate} />;
// // //   }
// // //   if (path === "/driverRoute") return <DriverRoute navigate={navigate} />;

// // //   if (path === "/admin/login") {
// // //     if (adminToken) return null;
// // //     return <AdminLogin navigate={navigate} />;
// // //   }
// // //   if (path === "/admin") {
// // //     return <AdminDashboard navigate={navigate} />;
// // //   }

// // //   return <MapPage />;
// // // }

// // // export default function App() {
// // //   const { path, navigate } = usePath();
// // //   const token = getToken();

// // //   // Track page views on main map for Prometheus
// // //   useEffect(() => {
// // //     if (!BACKEND) return;
// // //     if (path !== "/") return;
// // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => {});
// // //   }, [path]);

// // //   // Forward /driver -> /driverRoute when logged in (no hooks called conditionally)
// // //   useEffect(() => {
// // //     if (path === '/driver' && token) {
// // //       navigate('/driverRoute');
// // //     }
// // //   }, [path, token, navigate]);

// // //   if (path === '/driver') {
// // //     if (token) return null;
// // //     return <DriverLogin navigate={navigate} />;
// // //   }
// // //   if (path === '/driverRoute') return <DriverRoute navigate={navigate} />;
// // //   return <MapPage />;
// // // }

// // export { App };
// // export default App;

// // // // thoothukudi/frontend/src/App.js
// // // // import React, { useEffect, useState, useRef, useLayoutEffect, useMemo } from 'react';
// // // import React, {
// // //   useEffect,
// // //   useState,
// // //   useRef,
// // //   useLayoutEffect,
// // //   useMemo,
// // //   useCallback
// // // } from 'react';

// // // import axios from 'axios';
// // // import { io } from 'socket.io-client';
// // // import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
// // // import L from 'leaflet';
// // // import 'leaflet/dist/leaflet.css';
// // // import './App.css';
// // // import * as turf from '@turf/turf';

// // // // ---- Assets in src/assets ----
// // // import userIcon from './assets/user-icon.png';
// // // import stopIconImg from './assets/bus-stop.png';
// // // // import iitmLogo from './assets/iitm-logo.png';
// // // import iitmLogo from './assets/mint_logo.png';

// // // // ---- Backend base URL ----
// // // const BACKEND = process.env.REACT_APP_BACKEND_URL;
// // // const API_KEY = process.env.REACT_APP_API_KEY;
// // // const FEEDBACK_URL = process.env.REACT_APP_FEEDBACK_URL || '';


// // // // ---- Static roads URL (public/roads.geojson) ----
// // // const ROADS_URL = `${process.env.PUBLIC_URL || ''}/roads.geojson`;

// // // // ---- Map zoom param ----
// // // const DEFAULT_ZOOM = 16;

// // // // ---- Smoothing / Snap params ----
// // // const SMOOTH_ALPHA = 0.3;
// // // const HEADING_ALPHA = 0.35;
// // // const SNAP_MAX_DIST_M = 20;

// // // // Staleness threshold for under-maintenance banner
// // // const STALE_MS = 150_000; // ~2.5 minutes

// // // // Initial center (fallback)
// // // // const center = { lat: 12.9915, lng: 80.2336 };
// // // const center = { lat: 8.7642, lng: 78.1348 };

// // // // ---------------- STOPS WITH IDS (for route math) ----------------
// // // // const busStops = [
// // // //   { name: 'Velachery Gate IIT Campus Stop', lat: 12.988763557585395, lng: 80.22367960515129, id: 1 },
// // // //   { name: 'NAC2 Stop Towards GC', lat: 12.990236, lng: 80.227548, id: 2 },
// // // //   { name: 'Nac2 Towards Velachery Stop', lat: 12.9898636, lng: 80.2271109, id: 3 },
// // // //   { name: 'CRC Towards GC Stop', lat: 12.99089, lng: 80.230274, id: 4 },
// // // //   { name: 'CRC Towards Velachery Stop', lat: 12.99079680, lng: 80.23016660, id: 5 },  
// // // //   { name: 'HSB Stop Towards Velachery Stop', lat: 12.99076780, lng: 80.23168950, id: 6},
// // // //   { name: 'HSB Stop Towards GC', lat: 12.991037, lng: 80.232065, id: 7},
// // // //   { name: 'KV Stop Towards Main Gate', lat: 12.991868573807471, lng: 80.23367454352295, id: 8 },
// // // //   { name: 'KV Stop Towards GC', lat: 12.991910, lng: 80.233785, id: 9 },
// // // //   { name: 'Postoffice Stop Towards Main Gate', lat: 12.99388680, lng: 80.23428760, id: 10 },
// // // //   { name: 'Postoffice Stop Towards GC', lat: 12.99393340, lng: 80.23459350, id: 11 },
// // // //   { name: 'E1 Stop Towards Main Gate', lat: 12.9960173, lng: 80.2359173, id: 12 },
// // // //   { name: 'E1 Stop Towards GC', lat: 12.996117, lng: 80.236184, id: 13},
// // // //   { name: 'Vana Vani Stop Towards Main Gate', lat: 12.998704, lng: 80.2391799, id: 14 },
// // // //   { name: 'Vana Vani Stop Towards GC', lat: 12.999084,   lng:  80.239380, id: 15 },
// // // //   { name: 'D1 Stop Towards Main Gate', lat:13.002546, lng: 80.240091, id: 16},
// // // //   { name: 'D1 Stop Towards GC', lat: 13.002679,  lng: 80.240219, id: 17 },
// // // //   { name: 'Main Gate', lat: 13.00612964850378, lng: 80.24191299117685, id: 18 },
// // // //   { name: 'GC Stop Towards Hostel', lat: 12.991342, lng: 80.233637, id: 19 },
// // // //   { name: 'Library Stop', lat: 12.9907517, lng: 80.2334554, id: 20 },
// // // //   { name: 'OAT Stop Towards Hostel', lat: 12.989257,  lng: 80.233031, id: 21},
// // // //   { name: 'Gymkhana Stop Towards GC', lat: 12.9866372, lng: 80.2332951, id: 22},
// // // //   { name: 'Gymkhana Stop Towards Hostel', lat: 12.986615, lng: 80.233366, id: 23 },
// // // //   { name: 'Narmada Stop Towards GC', lat: 12.9862759, lng: 80.2350107, id: 24 },
// // // //   { name: 'Narmada Stop Towards Hostel', lat: 12.986546, lng: 80.235301, id: 25 },
// // // //   { name: 'Jamuna and Ganga Stand', lat: 12.986566332825637, lng: 80.23855704439099, id: 26 },
// // // //   { name: 'RP Stand', lat: 12.990088, lng: 80.241799, id: 28},
// // // //   { name: 'ED Stand', lat: 12.989874633072303, lng: 80.22646042038593, id: 29},
// // // // ];

// // // const busStops = [
// // //   { name: "THOOTHUKUDI OLD B/S", lat: 8.803153, lng: 78.140603, id: 1 },
// // //   { name: "VOC COLLEGE", lat: 8.795628, lng: 78.126712, id: 2 },
// // //   { name: "3RD MILE", lat: 8.790018, lng: 78.115506, id: 3 },
// // //   { name: "KORAMPALLAM", lat: 8.778041, lng: 78.092443, id: 4 },
// // //   { name: "ANTHONIYARPURAM", lat: 8.773973, lng: 78.085733, id: 5 },
// // //   { name: "THATTAPARAI JUNCTION", lat: 8.755951, lng: 78.065920, id: 6 },
// // //   { name: "PUDHUKOTTAI", lat: 8.745961, lng: 78.053331, id: 7 },
// // //   { name: "SIRUPADU JUNCTION", lat: 8.741241, lng: 78.057561, id: 8 },
// // //   { name: "KOOTTAMPULI", lat: 8.721905, lng: 78.065464, id: 9 },
// // //   { name: "SERVAIKARANMADAM", lat: 8.706851, lng: 78.055434, id: 10 },
// // //   { name: "JAKKAMMALPURAM", lat: 8.696665, lng: 78.048089, id: 11 },
// // //   { name: "SEBATHAIAHPURAM", lat: 8.685897, lng: 78.043820, id: 12 },
// // //   { name: "SAWYERPURAM", lat: 8.683487, lng: 78.031302, id: 13 },
// // //   { name: "SUBRAMANIYAPURAM", lat: 8.674211, lng: 78.026536, id: 14 },
// // //   { name: "RAMASAMYPURAM BRIDGE", lat: 8.669235, lng: 78.031267, id: 15 },
// // //   { name: "PERUMPADAI SASTHA KOVIL", lat: 8.671132, lng: 78.041593, id: 16 },
// // //   { name: "RAMASAMYPURAM", lat: 8.669235, lng: 78.031267, id: 17 },
// // //   { name: "ZAKKAMMALPURAM", lat: 8.653646, lng: 78.025552, id: 18 },
// // //   { name: "SIRUTHONDANALLUR", lat: 8.634397, lng: 78.019538, id: 19 },
// // //   { name: "ERAL", lat: 8.625024, lng: 78.025350, id: 20 },
// // //   { name: "MANGALAGIRI", lat: 8.740194, lng: 78.037454, id: 21 },
// // //   { name: "ALLIKULAM", lat: 8.761745, lng: 78.027343, id: 22 },
// // //   { name: "THIRUVANANDHA PURAM", lat: 8.770303, lng: 78.018599, id: 23 },
// // //   { name: "PEROORANI", lat: 8.766952, lng: 78.001463, id: 24 },
// // //   { name: "UZHAVAR SANTHAI", lat: 8.809685, lng: 78.137081, id: 25 },
// // //   { name: "4TH GATE", lat: 8.809664, lng: 78.133561, id: 26 },
// // //   { name: "THRES PURAM", lat: 8.815399, lng: 78.160791, id: 27 },
// // //   { name: "SUB COLLECTOR OFFICE", lat: 8.803112, lng: 78.158268, id: 28 },
// // //   { name: "MILLER PURAM", lat: 8.795547, lng: 78.125969, id: 29 },
// // //   { name: "NATTATTHI", lat: 8.668795, lng: 78.009948, id: 30 },
// // //   { name: "PANDARAVILAI", lat: 8.657570, lng: 77.999515, id: 31 },
// // //   { name: "PERUNKULAM", lat: 8.642502, lng: 77.997765, id: 32 },
// // //   { name: "SIVAKALAI", lat: 8.640133, lng: 77.977687, id: 33 },
// // //   { name: "KULAIYANKARISAL", lat: 8.719266, lng: 78.077173, id: 34 },
// // //   { name: "SIRUPADU", lat: 8.739285, lng: 78.067272, id: 35 },
// // //   { name: "PEIKULAM", lat: 8.706840, lng: 78.055406, id: 36 },
// // //   { name: "SALAI", lat: 8.696664, lng: 78.048079, id: 37 },
// // //   { name: "MANGALAKURICHI", lat: 8.625375, lng: 77.997223, id: 38 },
// // //   { name: "THIRD MILE", lat: 8.790018, lng: 78.115506, id: 39 },
// // //   { name: "SUBRAMANIAPURAM", lat: 8.674211, lng: 78.026536, id: 40 },
// // //   { name: "MARKET", lat: 8.801757, lng: 78.139084, id: 41 },
// // //   { name: "LEVANJIPURAM", lat: 8.789036, lng: 78.141181, id: 42 },
// // //   { name: "UPPATTHU ODAI", lat: 8.771189, lng: 78.134295, id: 43 },
// // //   { name: "MUTHAIAHPURAM", lat: 8.742466, lng: 78.123763, id: 44 },
// // //   { name: "SPIC NAGAR", lat: 8.739716, lng: 78.122362, id: 45 },
// // //   { name: "MULLAKADU", lat: 8.727742, lng: 78.116493, id: 46 },
// // //   { name: "MADHIKETTAN ODAI", lat: 8.702375, lng: 78.106893, id: 47 },
// // //   { name: "KOVANKADU JUNCTION", lat: 8.690703, lng: 78.103970, id: 48 },
// // //   { name: "PALAIYA KAYAL", lat: 8.671247, lng: 78.094375, id: 49 },
// // //   { name: "CHAMBER", lat: 8.649106, lng: 78.083705, id: 50 },
// // //   { name: "MUKKANI", lat: 8.634530, lng: 78.073992, id: 51 },
// // //   { name: "UMARIKADU", lat: 8.626411, lng: 78.059076, id: 52 },
// // //   { name: "VAZHAVALLAN", lat: 8.631211, lng: 78.047511, id: 53 },
// // //   { name: "WATER TANK", lat: 8.625474, lng: 78.052962, id: 54 },
// // //   { name: "SETHUSUBRAMANIAPURAM", lat: 8.616498, lng: 78.029879, id: 55 },
// // //   { name: "KURUMBUR", lat: 8.591328, lng: 78.044404, id: 56 },
// // //   { name: "KURUMBUR R/S", lat: 8.585888, lng: 78.039294, id: 57 },
// // //   { name: "AMERICAN HOSPITAL", lat: 8.813731, lng: 78.146898, id: 58 },
// // //   { name: "KEBI", lat: 8.814688, lng: 78.151524, id: 59 },
// // //   { name: "MURUGAN THEATRE", lat: 8.819765, lng: 78.155648, id: 60 },
// // //   { name: "RAJA PALAIYAM", lat: 8.827343, lng: 78.153629, id: 61 },
// // //   { name: "THALAMUTHU NAGAR", lat: 8.834404, lng: 78.152257, id: 62 },
// // //   { name: "AROCKIAPURAM", lat: 8.825379, lng: 78.149005, id: 63 },
// // //   { name: "SAVARAIYARPURAM", lat: 8.834448, lng: 78.144850, id: 64 },
// // //   { name: "SAVARAIYARPURAM JUNCTION", lat: 8.839360, lng: 78.143028, id: 65 },
// // //   { name: "STATE BANK COLONY", lat: 8.817087, lng: 78.132907, id: 66 },
// // //   { name: "MAPPILLAIYOORANI", lat: 8.831674, lng: 78.127735, id: 67 },
// // //   { name: "KALI KOVIL JUNCTION", lat: 8.836141, lng: 78.126243, id: 68 },
// // //   { name: "ODAIPATTI PUDHUR", lat: 8.853648, lng: 78.120200, id: 69 },
// // //   { name: "VELAYUTHAPURAM", lat: 8.859844, lng: 78.107125, id: 70 },
// // //   { name: "NAINAR PURAM", lat: 8.866548, lng: 78.091527, id: 71 },
// // //   { name: "CHILLANATTHAM", lat: 8.873462, lng: 78.071265, id: 72 },
// // //   { name: "RAJAVIN KOVIL", lat: 8.873143, lng: 78.048237, id: 73 },
// // //   { name: "PUTHIYAMPUTHUR", lat: 8.872962, lng: 78.032288, id: 74 },
// // //   { name: "MUPPULIPATI", lat: 8.900392, lng: 78.025670, id: 75 },
// // //   { name: "OTTAPIDARAM", lat: 8.909341, lng: 78.022479, id: 76 },
// // //   { name: "THOOTHUKUDI NEW B/S", lat: 8.810793, lng: 78.138305, id: 77 },
// // //   { name: "BYPASS", lat: 8.785154, lng: 78.106127, id: 78 },
// // //   { name: "MADATTHOOR", lat: 8.794360, lng: 78.097304, id: 79 },
// // //   { name: "SIPCOT COMPLEX", lat: 8.804587, lng: 78.084655, id: 80 },
// // //   { name: "RAILWAY GATE", lat: 8.812567, lng: 78.080637, id: 81 },
// // //   { name: "VEERAPANDIAPURAM", lat: 8.827254, lng: 78.065695, id: 82 },
// // //   { name: "KAYALOORANI", lat: 8.840263, lng: 78.061390, id: 83 },
// // //   { name: "SAMYNATTHAM", lat: 8.864407, lng: 78.055924, id: 84 },
// // //   { name: "OSANOOTTHU", lat: 8.891915, lng: 77.982711, id: 85 },
// // //   { name: "KOMBADI", lat: 8.879422, lng: 77.963106, id: 86 },
// // //   { name: "PANDIAPURAM", lat: 8.862311, lng: 77.934601, id: 87 },
// // //   { name: "PARAIKUTTAM", lat: 8.858671, lng: 77.924877, id: 88 },
// // //   { name: "VADAMALAPURAM", lat: 8.860927, lng: 77.906750, id: 89 },
// // //   { name: "MANIYACCHI", lat: 8.863306, lng: 77.894711, id: 90 },
// // //   { name: "OTTANATTHAM", lat: 8.903988, lng: 77.898311, id: 91 },
// // //   { name: "KALLATTHIKINARU", lat: 8.919118, lng: 77.885396, id: 92 },
// // //   { name: "MALAIPATTI", lat: 8.936648, lng: 77.888163, id: 93 },
// // //   { name: "ILAVELANKAL", lat: 8.946648, lng: 77.864022, id: 94 },
// // //   { name: "IYRAVIPATTI", lat: 8.932030, lng: 77.864758, id: 95 },
// // //   { name: "PARIVALLIKOTTAI", lat: 8.923368, lng: 77.874054, id: 96 },
// // //   { name: "THANNEER PANDHAL", lat: 8.862521, lng: 78.116944, id: 97 },
// // //   { name: "ARASADI JUNCTION", lat: 8.879929, lng: 78.111422, id: 98 },
// // //   { name: "VALASAMUTHIRAM", lat: 8.902361, lng: 78.102086, id: 99 },
// // //   { name: "KURUKKUSALAI", lat: 8.931410, lng: 78.088196, id: 100 },
// // //   { name: "RAMACHANDRAPURAM", lat: 8.927895, lng: 78.077923, id: 101 },
// // //   { name: "KAKKARAMPATTI JUNCTION", lat: 8.925977, lng: 78.064895, id: 102 },
// // //   { name: "MEENAKSHIPURAM", lat: 8.923832, lng: 78.057035, id: 103 },
// // //   { name: "OTTAPIDARAM TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 104 },
// // //   { name: "AYYANAR KOVIL", lat: 8.902593, lng: 78.012899, id: 105 },
// // //   { name: "KULASEKARANALLOOR", lat: 8.899773, lng: 77.981243, id: 106 },
// // //   { name: "SOUTH AARAIKULAM", lat: 8.916444, lng: 77.974949, id: 107 },
// // //   { name: "NORTH AARAIKULAM", lat: 8.923940, lng: 77.973027, id: 108 },
// // //   { name: "TALUK OFFICE", lat: 8.906520, lng: 78.020990, id: 109 },
// // //   { name: "THERKKU ARAIKULAM", lat: 8.916444, lng: 77.974949, id: 110 },
// // //   { name: "THOMAS NAGAR", lat: 8.839335, lng: 78.143038, id: 111 },
// // //   { name: "AYYANAR PURAM", lat: 8.859083, lng: 78.145946, id: 112 },
// // //   { name: "JOTHI SALT", lat: 8.863746, lng: 78.147926, id: 113 },
// // //   { name: "THARUVAIKULAM", lat: 8.896085, lng: 78.162889, id: 114 },
// // //   { name: "PATTINAMARUTHUR", lat: 8.923039, lng: 78.179675, id: 115 },
// // //   { name: "KALMEDU", lat: 8.943135, lng: 78.180943, id: 116 },
// // //   { name: "CHEMICAL", lat: 8.961828, lng: 78.180195, id: 117 },
// // //   { name: "VEPPALODAI", lat: 8.966764, lng: 78.180558, id: 118 },
// // //   { name: "PANAIYOOR JUNCTION", lat: 8.979427, lng: 78.200198, id: 119 },
// // //   { name: "SALT FACTORY", lat: 8.993585, lng: 78.216936, id: 120 },
// // //   { name: "KALLOORANI", lat: 8.990696, lng: 78.231998, id: 121 },
// // //   { name: "KEELA VAIPPAR", lat: 8.999548, lng: 78.251410, id: 122 },
// // //   { name: "THULUKKANKULAM", lat: 9.031660, lng: 78.272640, id: 123 },
// // //   { name: "KALAIGNANAPURAM", lat: 9.032364, lng: 78.266939, id: 124 },
// // //   { name: "KALAIGNANAPURAM JUNCTION", lat: 9.035342, lng: 78.258363, id: 125 },
// // //   { name: "VAIPPAR", lat: 9.025940, lng: 78.245625, id: 126 },
// // //   { name: "SOUTHERN SALT", lat: 8.705618, lng: 78.108039, id: 127 },
// // //   { name: "NORTH AUTHOOR", lat: 8.622425, lng: 78.070322, id: 128 },
// // //   { name: "SOUTH AUTHOOR", lat: 8.614603, lng: 78.070710, id: 129 },
// // //   { name: "AYYANKOVIL JUNCTION", lat: 8.598784, lng: 78.072198, id: 130 },
// // //   { name: "MICHEAL NADAR KUDIYIRUPPU", lat: 8.601003, lng: 78.053355, id: 131 },
// // //   { name: "PANAIYOOR GATE", lat: 8.979427, lng: 78.200198, id: 132 },
// // //   { name: "AM PATTI", lat: 8.901119, lng: 78.144213, id: 133 },
// // //   { name: "THERMAL STATION", lat: 8.902320, lng: 78.138007, id: 134 },
// // //   { name: "AM PATTI JUNCTION", lat: 8.907276, lng: 78.126656, id: 135 },
// // //   { name: "MELA MARUTHUR", lat: 8.914773, lng: 78.137694, id: 136 },
// // //   { name: "DURAISAMYPURAM", lat: 8.938686, lng: 78.156320, id: 137 },
// // //   { name: "SOUTH KALMEDU", lat: 8.951746, lng: 78.168851, id: 138 },
// // //   { name: "NORTH KALMEDU", lat: 8.954783, lng: 78.170766, id: 139 },
// // //   { name: "PANAIYOOR", lat: 8.992923, lng: 78.196242, id: 140 },
// // //   { name: "KULATTHOOR", lat: 9.004578, lng: 78.194272, id: 141 },
// // //   { name: "COLONY", lat: 9.008341, lng: 78.204491, id: 142 },
// // //   { name: "ARASADI", lat: 8.870406, lng: 78.127151, id: 143 },
// // //   { name: "KEELA ARASADI", lat: 8.877666, lng: 78.127424, id: 144 },
// // //   { name: "KUMARAPURAM", lat: 8.899629, lng: 78.119815, id: 145 },
// // //   { name: "PUDHUR", lat: 8.949025, lng: 78.149634, id: 146 },
// // //   { name: "VEDANATTHAM", lat: 8.968335, lng: 78.145818, id: 147 },
// // //   { name: "VENKATACHALAPURAM", lat: 8.979063, lng: 78.157313, id: 148 },
// // //   { name: "MUTHUKUMARAPURAM", lat: 8.992612, lng: 78.145428, id: 149 },
// // //   { name: "SUBRAMANIYAPURAM JUNCTION", lat: 9.015801, lng: 78.225924, id: 150 },
// // //   { name: "THULUKKANKULAM JUNCTION", lat: 9.035332, lng: 78.258348, id: 151 },
// // //   { name: "CHANDRAGIRI JUNCTION", lat: 8.959742, lng: 78.092867, id: 152 },
// // //   { name: "CHANDRAGIRI", lat: 8.963758, lng: 78.074077, id: 153 },
// // //   { name: "KOLLAMPARAMBU", lat: 8.981801, lng: 78.119157, id: 154 },
// // //   { name: "SEITHALAI JUNCTION", lat: 8.979604, lng: 78.068883, id: 155 },
// // //   { name: "KEELA SEITHALAI", lat: 8.988456, lng: 78.093180, id: 156 },
// // //   { name: "KOVANKADU", lat: 8.690829, lng: 78.104060, id: 157 },
// // //   { name: "SOUTH KOVANKADU", lat: 8.690280, lng: 78.089963, id: 158 },
// // //   { name: "SAMBADI", lat: 8.669595, lng: 78.078838, id: 159 },
// // //   { name: "IDAYARKADU", lat: 8.664261, lng: 78.064077, id: 160 },
// // //   { name: "MARAMANGALAM", lat: 8.657852, lng: 78.060310, id: 161 },
// // //   { name: "ARUMUGAMANGALAM", lat: 8.649895, lng: 78.042699, id: 162 },
// // //   { name: "POTTALKADU", lat: 8.719686, lng: 78.102315, id: 163 },
// // //   { name: "KATTALANKULAM", lat: 8.698745, lng: 78.007000, id: 164 },
// // //   { name: "M. PUDHUR", lat: 8.722007, lng: 78.002788, id: 165 },
// // //   { name: "MUDIVAITHANENDAL", lat: 8.723319, lng: 77.990336, id: 166 },
// // //   { name: "VAGAIKULAM", lat: 8.734730, lng: 78.001301, id: 167 },
// // //   { name: "CHETTIKULAM", lat: 8.662797, lng: 78.029329, id: 168 },
// // //   { name: "AGARAM BRIDGE", lat: 8.661354, lng: 78.088323, id: 169 },
// // //   { name: "AGARAM", lat: 8.659921, lng: 78.075828, id: 170 },
// // //   { name: "KORKAI", lat: 8.642078, lng: 78.058734, id: 171 },
// // //   { name: "AUTHOOR", lat: 8.622355, lng: 78.070341, id: 172 },
// // //   { name: "CHERNTHAMARAM", lat: 8.634982, lng: 78.087918, id: 173 },
// // //   { name: "DCW COLONY", lat: 8.632673, lng: 78.101623, id: 174 },
// // //   { name: "PUNNAKAYAL", lat: 8.634945, lng: 78.117073, id: 175 },
// // //   { name: "ATTHIMARAPATTI JUNCTION", lat: 8.741554, lng: 78.123287, id: 176 },
// // //   { name: "ATTHIMARAPATTI", lat: 8.742208, lng: 78.104441, id: 177 },
// // //   { name: "PON NAGAR", lat: 8.734551, lng: 78.104669, id: 178 },
// // //   { name: "THERMAL NAGAR", lat: 8.759198, lng: 78.147347, id: 179 },
// // //   { name: "THERMAL NAGAR JUNCTION", lat: 8.758436, lng: 78.155625, id: 180 },
// // //   { name: "TTPP", lat: 8.755276, lng: 78.175103, id: 181 },
// // //   { name: "CHILDREN'S PARK", lat: 8.746429, lng: 78.168838, id: 182 },
// // //   { name: "CAMP-II", lat: 8.742206, lng: 78.163757, id: 183 },
// // //   { name: "BULK", lat: 8.745284, lng: 78.125352, id: 184 },
// // //   { name: "ROCH PARK", lat: 8.787746, lng: 78.159250, id: 185 },
// // //   { name: "TTPP JUNCTION", lat: 8.755763, lng: 78.170323, id: 186 },
// // //   { name: "VELLAPATTI", lat: 8.857643, lng: 78.160709, id: 187 },
// // //   { name: "KAKKARAMPATTI", lat: 8.928274, lng: 78.058146, id: 188 },
// // //   { name: "AGILANDAPURAM", lat: 8.933352, lng: 78.050208, id: 189 },
// // //   { name: "PANCHALANKURICHI", lat: 8.932598, lng: 78.032564, id: 190 },
// // //   { name: "KUMARAPURAM JUNCTION", lat: 8.947900, lng: 78.080564, id: 191 },
// // //   { name: "VELLARAM JUNCTION", lat: 8.963494, lng: 78.073969, id: 192 },
// // //   { name: "KACCHERI THALAVAIPURAM", lat: 8.965258, lng: 78.047346, id: 193 },
// // //   { name: "VELLARAM", lat: 8.964344, lng: 78.023572, id: 194 },
// // //   { name: "GOVERNORGIRI", lat: 8.950111, lng: 78.029486, id: 195 },
// // //   { name: "VALLINAYAGIPURAM", lat: 8.865224, lng: 78.027444, id: 196 },
// // //   { name: "JAMBULINGAPURAM", lat: 8.868732, lng: 78.018645, id: 197 },
// // //   { name: "KAILASAPURAM", lat: 8.852519, lng: 77.991350, id: 198 },
// // //   { name: "SAVARIMANGALAM", lat: 8.863055, lng: 77.985917, id: 199 },
// // //   { name: "MELA SEITHALAI", lat: 8.981610, lng: 78.077327, id: 200 },
// // //   { name: "JEGAVEERAPANDIAPURAM", lat: 8.983220, lng: 78.066958, id: 201 },
// // //   { name: "THANNEER MADAM", lat: 9.009252, lng: 78.052432, id: 202 },
// // //   { name: "KAYATHAR JUNCTION", lat: 9.012578, lng: 78.050241, id: 203 },
// // //   { name: "EPPODHUMVENDRAN", lat: 9.020908, lng: 78.047522, id: 204 },
// // //   { name: "KATTUNAICKENPATTI", lat: 9.014206, lng: 78.062348, id: 205 },
// // //   { name: "ADHANOOR", lat: 9.010078, lng: 78.084646, id: 206 },
// // //   { name: "MILAGU NATTHAM", lat: 9.012843, lng: 78.104929, id: 207 },
// // //   { name: "MURAMBAN", lat: 8.899828, lng: 77.937996, id: 208 },
// // //   { name: "SANGAMPATTI", lat: 8.917985, lng: 77.930898, id: 209 },
// // //   { name: "CEYLON COLONY", lat: 8.924832, lng: 78.018458, id: 210 },
// // //   { name: "PUTRU MURUGAN KOVIL", lat: 8.941288, lng: 78.011421, id: 211 },
// // //   { name: "VENKETESHVARAPURAM JUNCTION", lat: 8.955754, lng: 78.003576, id: 212 },
// // //   { name: "KEELA MUDIMAN", lat: 8.961449, lng: 77.999854, id: 213 },
// // //   { name: "POOLNAYAKKANOOR", lat: 8.978090, lng: 77.991323, id: 214 },
// // //   { name: "PASUVANTHANAI", lat: 8.999829, lng: 77.962640, id: 215 },
// // //   { name: "MELA MUDIMAN", lat: 8.956969, lng: 77.986192, id: 216 },
// // //   { name: "THALAVAIPURAM", lat: 8.877120, lng: 77.956196, id: 217 },
// // //   { name: "KANTHASAMYPURAM", lat: 8.867032, lng: 77.949334, id: 218 },
// // //   { name: "APC COLLEGE", lat: 8.827144, lng: 78.129349, id: 219 },
// // //   { name: "CHINNAKANNUPURAM", lat: 8.810596, lng: 78.125385, id: 220 },
// // //   { name: "SILVERPURAM", lat: 8.814569, lng: 78.115786, id: 221 },
// // //   { name: "PANDARAMPATTI", lat: 8.826827, lng: 78.104347, id: 222 },
// // //   { name: "MEELAVITTAN", lat: 8.816812, lng: 78.100737, id: 223 },
// // //   { name: "STERLITE", lat: 8.816372, lng: 78.081444, id: 224 },
// // //   { name: "SIPCOT", lat: 8.804587, lng: 78.084655, id: 225 },
// // //   { name: "MADATTHOOR JUNCTION", lat: 8.794126, lng: 78.097222, id: 226 },
// // //   { name: "THOOTHUKUDI COLLECTORATE", lat: 8.782470, lng: 78.100772, id: 227 },
// // //   { name: "PUDHUPACCHERI COLONY", lat: 8.878480, lng: 78.007704, id: 228 },
// // //   { name: "PUDHUPACCHERI", lat: 8.879461, lng: 78.001300, id: 229 },
// // //   { name: "SIVALKULAM", lat: 8.879800, lng: 77.995998, id: 230 },
// // //   { name: "PACCHAIPERUMALPURAM", lat: 8.885974, lng: 77.992908, id: 231 },
// // //   { name: "SANKARARAJAPURAM", lat: 8.891225, lng: 77.991277, id: 232 },
// // //   { name: "KUPPANAPURAM", lat: 8.933090, lng: 77.971928, id: 233 },
// // //   { name: "KEELA MANGALM", lat: 8.953179, lng: 77.969344, id: 234 },
// // //   { name: "RAMANACCHIYARPURAM", lat: 8.784893, lng: 78.061561, id: 235 },
// // //   { name: "MUTHUSAMYPURAM", lat: 8.804241, lng: 78.049425, id: 236 },
// // //   { name: "MADATTHUPATTI", lat: 8.807399, lng: 78.047393, id: 237 },
// // //   { name: "NORTH SILUKKANPATTI", lat: 8.812890, lng: 78.047949, id: 238 },
// // //   { name: "THALAIVANVADALI", lat: 8.602420, lng: 78.087655, id: 239 },
// // //   { name: "THOOTHUKUDI RAILWAY STATION", lat: 8.805524, lng: 78.155200, id: 240 },
// // //   { name: "KOOTTUDANKADU", lat: 8.740251, lng: 78.037525, id: 241 },
// // //   { name: "THIRUVANANTHAPURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 242 },
// // //   { name: "SAMATTHUVAPURAM", lat: 8.774679, lng: 77.998832, id: 243 },
// // //   { name: "MAHILAMPURAM", lat: 8.794964, lng: 77.961453, id: 244 },
// // //   { name: "CHEKKARAKUDI", lat: 8.794750, lng: 77.951655, id: 245 },
// // //   { name: "THIRUVANANTHAPURAM", lat: 8.770659, lng: 78.019169, id: 246 },
// // //   { name: "MELA CHEKKARAKUDI", lat: 8.801626, lng: 77.937492, id: 247 },
// // //   { name: "ALLIKULAM JUNCTION", lat: 8.757367, lng: 78.025019, id: 248 },
// // //   { name: "THIRUVANANDHA PURAM JUNCTION", lat: 8.761470, lng: 78.019308, id: 249 },
// // //   { name: "SILUKKAN PATTI", lat: 8.768811, lng: 78.052367, id: 250 },
// // //   { name: "KEELA THATTAPARAI", lat: 8.796529, lng: 78.027674, id: 251 },
// // //   { name: "MELA THATTAPARAI", lat: 8.815826, lng: 78.017498, id: 252 },
// // //   { name: "CHETTIYOORANI", lat: 8.832629, lng: 78.008857, id: 253 },
// // //   { name: "CAMP THATTAPARAI", lat: 8.826042, lng: 78.020524, id: 254 },
// // //   { name: "RAMACHANDRAPURAM JUNCTION", lat: 8.738491, lng: 78.031969, id: 255 },
// // //   { name: "POTTALOORANI JUNCTION", lat: 8.735812, lng: 77.935660, id: 256 },
// // //   { name: "POTTALOORANI VILLAGE", lat: 8.748338, lng: 77.936312, id: 257 },
// // //   { name: "NATTHAM", lat: 8.778333, lng: 77.946701, id: 258 },
// // //   { name: "AZHAGAPURI", lat: 8.783882, lng: 77.947625, id: 259 },
// // //   { name: "KALLAMPARAMBU", lat: 8.806659, lng: 77.982150, id: 260 },
// // //   { name: "VARTHAGAREDDIPATTI", lat: 8.734957, lng: 77.992819, id: 261 },
// // //   { name: "THIMMARAJAPURAM", lat: 8.763797, lng: 77.989995, id: 262 },
// // //   { name: "MEENAKSHIPATTI", lat: 8.690932, lng: 77.965207, id: 263 },
// // //   { name: "ADAIKKALAPURAM", lat: 8.678001, lng: 77.969954, id: 264 },
// // //   { name: "ANIYABARANALLUR", lat: 8.693574, lng: 77.950283, id: 265 },
// // //   { name: "PUDHUPATTI", lat: 8.710504, lng: 77.936336, id: 266 },
// // //   { name: "CHETTIMALLANPATTI", lat: 8.720235, lng: 77.929900, id: 267 },
// // //   { name: "RAMANATHAPURAM", lat: 8.728507, lng: 77.925542, id: 268 },
// // //   { name: "ELLANAICKENPATTI", lat: 8.733465, lng: 77.921950, id: 269 },
// // //   { name: "DEIVASEYALPURAM", lat: 8.737467, lng: 77.918961, id: 270 },
// // //   { name: "THATTAPARAI VILLAGE", lat: 8.755998, lng: 78.065854, id: 271 },
// // //   { name: "ST. MARY'S COLLEGE", lat: 8.811006, lng: 78.161694, id: 272 },
// // //   { name: "NEW HARBOUR", lat: 8.754486, lng: 78.192477, id: 273 },
// // //   { name: "UMARIKOTTAI", lat: 8.822473, lng: 77.990482, id: 274 },
// // //   { name: "VARADHARAJAPURAM", lat: 8.843064, lng: 77.979707, id: 275 },
// // //   { name: "CHOCKALINGAPURAM", lat: 8.812871, lng: 77.966345, id: 276 },
// // //   { name: "KALANKARAI", lat: 8.756500, lng: 78.095112, id: 277 },
// // //   { name: "PUDHUKOTTAI 2", lat: 8.747258, lng: 78.054971, id: 278 },
// // //   { name: "4TH GATE 2", lat: 8.812727, lng: 78.136672, id: 279 },
// // //   { name: "ST. ANN'S HOSPITAL", lat: 8.877320, lng: 78.025851, id: 280 },
// // //   { name: "SUBRAMANIYAPURAM 2", lat: 8.918478, lng: 78.094426, id: 281 },
// // //   { name: "AMERICAN HOSPITAL 2", lat: 8.813561, lng: 78.148444, id: 282 },
// // //   { name: "ZAKKAMMALPURAM 2", lat: 8.916639, lng: 78.175262, id: 283 },
// // //   { name: "KALLOORANI", lat: 8.992222, lng: 78.233057, id: 284 },
// // //   { name: "THULUKKANKULAM", lat: 9.031716, lng: 78.272534, id: 285 },
// // //   { name: "SALT FACTORY 2", lat: 8.996121, lng: 78.240638, id: 286 },
// // //   { name: "ZAKKAMMALPURAM 3", lat: 8.926665, lng: 78.149020, id: 287 },
// // //   { name: "SUBRAMANIYAPURAM 3", lat: 9.025170, lng: 78.225853, id: 288 },
// // //   { name: "CHANDRAGIRI", lat: 8.964871, lng: 78.096262, id: 289 },
// // //   { name: "WATER TANK 2", lat: 8.669583, lng: 78.078905, id: 290 },
// // //   { name: "KUMARAPURAM 2", lat: 8.688057, lng: 78.016423, id: 291 },
// // //   { name: "ARASADI JUNCTION 2", lat: 8.868788, lng: 78.115271, id: 292 },
// // //   { name: "THERMAL NAGAR", lat: 8.759213, lng: 78.147452, id: 293 },
// // //   { name: "CHEMICAL", lat: 8.766517, lng: 78.156992, id: 294 },
// // //   { name: "CHANDRAGIRI JUNCTION 2", lat: 8.963747, lng: 78.074074, id: 295 },
// // //   { name: "S.PUTHUR", lat: 8.869224, lng: 77.997689, id: 296 },
// // //   { name: "KAILASAPURAM", lat: 8.786357, lng: 78.077069, id: 297 },
// // //   { name: "MUTHUSAMYPURAM", lat: 8.803626, lng: 78.050614, id: 298 },
// // //   { name: "ARASADI JUNCTION 3", lat: 8.873258, lng: 78.152850, id: 299 },
// // //   { name: "ARASADI 2", lat: 8.878458, lng: 78.118427, id: 300 },
// // //   { name: "DURAISAMYPURAM 2", lat: 8.938193, lng: 78.156085, id: 301 },
// // //   { name: "KULATTHOOR 2", lat: 9.002945, lng: 78.194484, id: 302 },
// // //   { name: "PUDHUR 2", lat: 8.794559, lng: 77.993581, id: 303 },
// // //   { name: "THALAVAIPURAM 2", lat: 8.798284, lng: 77.974711, id: 304 },
// // //   { name: "RAMACHANDRAPURAM 2", lat: 8.731531, lng: 78.030510, id: 305 },
// // //   { name: "PUDHUR 3", lat: 8.709596, lng: 78.002355, id: 306 }
// // // ];

// // // // // Route sequences by stop id
// // // // const Hostel_to_Main   = [26, 24, 22, 20, 6, 5, 3, 1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // // // const Main_to_Hostel   = [18, 17, 15, 13, 11, 9, 6, 5, 3, 1, 2, 4, 7, 19, 21, 23, 25, 26];
// // // // const Velachery_to_Main= [1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // // // const Velachery_to_Hostel=[1, 2, 4, 7, 19, 21, 23, 25, 26];
// // // // const Hotel_to_Velachery=[26, 24, 22, 20, 6, 5, 3, 1];
// // // // const Main_to_Velachery=[18, 17, 15, 13, 11, 9, 6, 5, 3, 1];
// // // // const RP_to_ED         = [28, 22, 21, 20, 6, 5, 3, 29];
// // // // const ED_to_RP         = [29, 2, 4, 7, 19, 21, 23, 28];

// // // // const ROUTES = [
// // // //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate", ids: Hostel_to_Main },
// // // //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel", ids: Main_to_Hostel },
// // // //   { code: "VG_MAIN",     label: "Velachery Gate → Main Gate", ids: Velachery_to_Main },
// // // //   { code: "VG_HOSTEL",   label: "Velachery Gate → Hostel", ids: Velachery_to_Hostel },
// // // //   { code: "MAIN_VG",     label: "Main Gate → Velachery Gate", ids: Main_to_Velachery },
// // // //   { code: "HOSTEL_VG",   label: "Hostel → Velachery Gate", ids: Hotel_to_Velachery },
// // // //   { code: "RP_ED",       label: "Research Park → ED", ids: RP_to_ED },
// // // //   { code: "ED_RP",       label: "ED → Research Park", ids: ED_to_RP },
// // // // ];

// // // // // ---- Route aliases (frontend only) ----
// // // // // Backend only knows canonical codes: HOSTEL_MAIN, MAIN_HOSTEL, RP_ED, ED_RP
// // // // // But filters can still expose Velachery labels.
// // // // // Aliases map to canonical backend codes.
// // // // const ROUTE_ALIAS_TO_CANONICAL = {
// // // //   VG_MAIN: "HOSTEL_MAIN",
// // // //   HOSTEL_VG: "HOSTEL_MAIN",
// // // //   MAIN_VG: "MAIN_HOSTEL",
// // // //   VG_HOSTEL: "MAIN_HOSTEL",
// // // // };

// // // // function canonicalRoute(code) {
// // // //   return ROUTE_ALIAS_TO_CANONICAL[code] || code;
// // // // }
// // // // // Routes the admin can assign in backend (only canonical codes)
// // // // const ADMIN_ROUTES = [
// // // //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate" },
// // // //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel" },
// // // //   { code: "RP_ED", label: "Research Park → ED" },
// // // //   { code: "ED_RP", label: "ED → Research Park" },
// // // // ];


// // // // // ---- Vehicles for driverRoute select ----
// // // // const VEHICLES = [
// // // //   "TN07DH1368","TN07DH1317","TN07DH1315","EV09","TN07DH1360","TN07DH1391","EV08","TN07DD5574",
// // // //   "TN07CX8698","TN07DD3376","TN07CX8200","TN07DD3360","EV-12","EV-14","EV-15","EV-10","EV-05",
// // // //   "EV-07","EV-06","EV-02","EV-03","EV-11","EV-01","EV-13","TN07CX8119"
// // // // ];

// // // // ---------------- VEHICLE ROUTES + ROUTE SCHEDULE DATA ----------------
// // // // Generated from your TCNC route table and the uploaded stop-timesheet ZIP.
// // // // ROUTES = user-facing route numbers (52-B, 53-A, ...)
// // // // ROUTE_TRIPS = detailed stop-by-stop trips used for schedule display and route progress.
// // // const VEHICLE_ROUTE_MAP = {
// // //   "TN72N2675": "4",
// // //   "TN72N2656": "52-B",
// // //   "TN72N2460": "52-C",
// // //   "TN72N1895": "52-D",
// // //   "TN72N2589": "52-E",
// // //   "TN72N2368": "52-F",
// // //   "TN72N2682": "52-G",
// // //   "TN72N1905": "52-K",
// // //   "TN72N1774": "53-A",
// // //   "TN72N2556": "53-B",
// // //   "TN72N2684": "53-C",
// // //   "TN72N1903": "53-D",
// // //   "TN72N2526": "53-E",
// // //   "TN72N1737": "53-F",
// // //   "TN72N1751": "54-A",
// // //   "TN72N1854": "54-B",
// // //   "TN72N2643": "54-C",
// // //   "TN72N1910": "54-D",
// // //   "TN72N2536": "54-F",
// // //   "TN72N1912": "54-G",
// // //   "TN72N2706": "55-A",
// // //   "TN72N2700": "55-B",
// // //   "TN72N2549": "55-C",
// // //   "TN72N2416": "55-D",
// // //   "TN72N1757": "55-E",
// // //   "TN72N2541": "55-F",
// // //   "TN72N1906": "55-G",
// // //   "TN72N1688": "55-H",
// // //   "TN72N2671": "55-I",
// // //   "TN72N1919": "55-J",
// // //   "TN72N2568": "56-A",
// // //   "TN72N1884": "56-B",
// // //   "TN72N2617": "56-C",
// // //   "TN72N2622": "56-D",
// // //   "TN72N2016": "56-E",
// // //   "TN68N0707": "56-F",
// // //   "TN72N2562": "56-G",
// // //   "TN72N1875": "57-A",
// // //   "TN72N2687": "57-D",
// // //   "TN72N2022": "58-A",
// // //   "TN72N2570": "58-B",
// // //   "TN72N2620": "58-C"
// // // };

// // // const ROUTES = [
// // //   {
// // //     "code": "52-A",
// // //     "label": "52-A — 13 scheduled trips",
// // //     "tripCount": 13
// // //   },
// // //   {
// // //     "code": "52-B",
// // //     "label": "52-B — 10 scheduled trips",
// // //     "tripCount": 10
// // //   },
// // //   {
// // //     "code": "52-C",
// // //     "label": "52-C — 18 scheduled trips",
// // //     "tripCount": 18
// // //   },
// // //   {
// // //     "code": "52-D",
// // //     "label": "52-D — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "52-E",
// // //     "label": "52-E — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "52-F",
// // //     "label": "52-F — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "52-G",
// // //     "label": "52-G — 18 scheduled trips",
// // //     "tripCount": 18
// // //   },
// // //   {
// // //     "code": "52-K",
// // //     "label": "52-K — 17 scheduled trips",
// // //     "tripCount": 17
// // //   },
// // //   {
// // //     "code": "53-A",
// // //     "label": "53-A — 16 scheduled trips",
// // //     "tripCount": 16
// // //   },
// // //   {
// // //     "code": "53-B",
// // //     "label": "53-B — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "53-C",
// // //     "label": "53-C — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "53-D",
// // //     "label": "53-D — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "53-E",
// // //     "label": "53-E — 10 scheduled trips",
// // //     "tripCount": 10
// // //   },
// // //   {
// // //     "code": "53-F",
// // //     "label": "53-F — 16 scheduled trips",
// // //     "tripCount": 16
// // //   },
// // //   {
// // //     "code": "54-A",
// // //     "label": "54-A — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "54-B",
// // //     "label": "54-B — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "54-C",
// // //     "label": "54-C — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "54-D",
// // //     "label": "54-D — 16 scheduled trips",
// // //     "tripCount": 16
// // //   },
// // //   {
// // //     "code": "54-F",
// // //     "label": "54-F — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "54-G",
// // //     "label": "54-G — 20 scheduled trips",
// // //     "tripCount": 20
// // //   },
// // //   {
// // //     "code": "55-A",
// // //     "label": "55-A — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "55-B",
// // //     "label": "55-B — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "55-C",
// // //     "label": "55-C — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "55-D",
// // //     "label": "55-D — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "55-E",
// // //     "label": "55-E — 10 scheduled trips",
// // //     "tripCount": 10
// // //   },
// // //   {
// // //     "code": "55-F",
// // //     "label": "55-F — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "55-G",
// // //     "label": "55-G — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "55-H",
// // //     "label": "55-H — 20 scheduled trips",
// // //     "tripCount": 20
// // //   },
// // //   {
// // //     "code": "55-I",
// // //     "label": "55-I — 10 scheduled trips",
// // //     "tripCount": 10
// // //   },
// // //   {
// // //     "code": "55-J",
// // //     "label": "55-J — 20 scheduled trips",
// // //     "tripCount": 20
// // //   },
// // //   {
// // //     "code": "56-A",
// // //     "label": "56-A — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "56-B",
// // //     "label": "56-B — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "56-C",
// // //     "label": "56-C — 10 scheduled trips",
// // //     "tripCount": 10
// // //   },
// // //   {
// // //     "code": "56-D",
// // //     "label": "56-D — 10 scheduled trips",
// // //     "tripCount": 10
// // //   },
// // //   {
// // //     "code": "56-E",
// // //     "label": "56-E — 13 scheduled trips",
// // //     "tripCount": 13
// // //   },
// // //   {
// // //     "code": "56-F",
// // //     "label": "56-F — 19 scheduled trips",
// // //     "tripCount": 19
// // //   },
// // //   {
// // //     "code": "56-G",
// // //     "label": "56-G — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "57-A",
// // //     "label": "57-A — 22 scheduled trips",
// // //     "tripCount": 22
// // //   },
// // //   {
// // //     "code": "57-D",
// // //     "label": "57-D — 24 scheduled trips",
// // //     "tripCount": 24
// // //   },
// // //   {
// // //     "code": "58-A",
// // //     "label": "58-A — 14 scheduled trips",
// // //     "tripCount": 14
// // //   },
// // //   {
// // //     "code": "58-B",
// // //     "label": "58-B — 16 scheduled trips",
// // //     "tripCount": 16
// // //   },
// // //   {
// // //     "code": "58-C",
// // //     "label": "58-C — 12 scheduled trips",
// // //     "tripCount": 12
// // //   },
// // //   {
// // //     "code": "4",
// // //     "label": "4 — schedule not available",
// // //     "tripCount": 0
// // //   }
// // // ];

// // // const ADMIN_ROUTES = ROUTES;

// // // const ROUTE_TRIPS = [
// // //   {
// // //     "id": "52-A-1-1",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-1",
// // //     "tripCode": "52/P52A-152-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PERUMPADAI SASTHA KOVIL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:45 AM",
// // //     "endTime": "01:00 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       7,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       16
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "11:50 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:54 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:03 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:06 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:15 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 1",
// // //         "time": "12:21 PM",
// // //         "id": 7
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "12:23 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:31 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "12:37 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "12:41 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:45 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:50 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "12:53 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "12:56 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PERUMPADAI SASTHA KOVIL",
// // //         "time": "01:00 PM",
// // //         "id": 16
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-2-2",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-1",
// // //     "tripCode": "52/P52A-152-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "PERUMPADAI SASTHA KOVIL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:05 PM",
// // //     "endTime": "02:00 PM",
// // //     "ids": [
// // //       16,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       7,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PERUMPADAI SASTHA KOVIL",
// // //         "time": "01:05 PM",
// // //         "id": 16
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "01:07 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "01:09 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "01:12 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "01:15 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "01:18 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "01:21 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "01:26 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "01:31 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 1",
// // //         "time": "01:33 PM",
// // //         "id": 7
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:37 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:44 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:46 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:52 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "01:55 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-3-3",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-2",
// // //     "tripCode": "52/P52A-252-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:05 PM",
// // //     "endTime": "03:00 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "02:09 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:12 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:20 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:22 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:29 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:33 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:35 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:41 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "02:46 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "02:50 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "02:53 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "02:57 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "03:00 PM",
// // //         "id": 40
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-4-4",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-3",
// // //     "tripCode": "52/P52A-352-ATORD18U4",
// // //     "order": 4,
// // //     "direction": "U",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:05 PM",
// // //     "endTime": "04:30 PM",
// // //     "ids": [
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "03:05 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "03:15 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "03:41 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "04:12 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ERAL",
// // //         "time": "04:30 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-5-5",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-4",
// // //     "tripCode": "52/P52A-452-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:40 PM",
// // //     "endTime": "06:00 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       21,
// // //       22,
// // //       23,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "04:40 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "04:44 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "04:51 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "04:57 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:59 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SAWYERPURAM",
// // //         "time": "05:03 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:08 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SALAI",
// // //         "time": "05:12 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "05:17 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "05:23 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "05:31 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:33 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MANGALAGIRI",
// // //         "time": "05:40 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "ALLIKULAM",
// // //         "time": "05:49 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "05:53 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PEROORANI",
// // //         "time": "06:00 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-6-6",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-5",
// // //     "tripCode": "52/P52A-552-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "PERRORANI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 PM",
// // //     "endTime": "07:20 PM",
// // //     "ids": [
// // //       24,
// // //       23,
// // //       22,
// // //       21,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 12,
// // //         "name": "PEROORANI",
// // //         "time": "06:15 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "06:21 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "06:26 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:36 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:43 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:46 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:54 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:01 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "SALAI",
// // //         "time": "07:06 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:10 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:15 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:20 PM",
// // //         "id": 40
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-7-7",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-2",
// // //     "tripCode": "52/P52A-252-ATORD18D7",
// // //     "order": 7,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 PM",
// // //     "endTime": "08:45 PM",
// // //     "ids": [
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:30 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:34 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:38 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:43 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:48 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:55 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:03 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:05 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:11 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:21 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:24 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:34 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:38 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-8-8",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-1",
// // //     "tripCode": "52/P52A-152-ATORD18U8",
// // //     "order": 8,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PERUMPADAI SASTHA KOVIL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:30 PM",
// // //     "endTime": "10:30 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       7,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       16
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:34 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:37 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:45 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:47 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:54 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 1",
// // //         "time": "09:59 PM",
// // //         "id": 7
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:01 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:06 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:11 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "10:15 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:18 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:22 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "10:25 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "10:27 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PERUMPADAI SASTHA KOVIL",
// // //         "time": "10:30 PM",
// // //         "id": 16
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-9-9",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-6",
// // //     "tripCode": "52/P52A-652-ATORD18D9",
// // //     "order": 9,
// // //     "direction": "D",
// // //     "from": "PERUMPADAI SASTHA KOVIL",
// // //     "to": "UZHAVAR SANTHAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:30 AM",
// // //     "endTime": "06:40 AM",
// // //     "ids": [
// // //       16,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1,
// // //       26,
// // //       25
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "PERUMPADAI SASTHA KOVIL",
// // //         "time": "04:30 AM",
// // //         "id": 16
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "04:36 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:39 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:45 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:53 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SALAI",
// // //         "time": "04:59 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "05:07 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "05:17 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "05:29 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:33 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:41 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:56 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:01 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "06:16 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:23 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:32 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:37 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "UZHAVAR SANTHAI",
// // //         "time": "06:40 AM",
// // //         "id": 25
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-10-10",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-8",
// // //     "tripCode": "52/P52A-852-ATORD18U10",
// // //     "order": 10,
// // //     "direction": "U",
// // //     "from": "UZHAVAR SANTHAI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:55 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       25,
// // //       26,
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "UZHAVAR SANTHAI",
// // //         "time": "06:55 AM",
// // //         "id": 25
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:56 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:59 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:03 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "07:07 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:15 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:18 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:26 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:31 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:33 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:39 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:45 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SALAI",
// // //         "time": "07:49 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:52 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:56 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:00 AM",
// // //         "id": 40
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-11-11",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-7",
// // //     "tripCode": "52/P52A-752-ATORD18D11",
// // //     "order": 11,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THRES PURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 AM",
// // //     "endTime": "09:10 AM",
// // //     "ids": [
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1,
// // //       28,
// // //       27
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:05 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:08 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:11 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SALAI",
// // //         "time": "08:15 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:18 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:23 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:29 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:31 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:35 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:43 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:45 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "08:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:56 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:01 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:06 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "09:10 AM",
// // //         "id": 27
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-12-12",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-7",
// // //     "tripCode": "52/P52A-752-ATORD18U12",
// // //     "order": 12,
// // //     "direction": "U",
// // //     "from": "THRES PURAM",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:20 AM",
// // //     "endTime": "10:20 AM",
// // //     "ids": [
// // //       27,
// // //       28,
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "09:20 AM",
// // //         "id": 27
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:23 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:28 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:32 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "09:35 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:42 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:44 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:51 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:55 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:57 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:02 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:07 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SALAI",
// // //         "time": "10:10 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:13 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:17 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "10:20 AM",
// // //         "id": 40
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-A-13-13",
// // //     "routeNo": "52-A",
// // //     "code": "52/P52A-2",
// // //     "tripCode": "52/P52A-252-ATORD18D13",
// // //     "order": 13,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 AM",
// // //     "endTime": "11:30 AM",
// // //     "ids": [
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "10:30 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:33 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:37 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "10:40 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:44 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:50 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:56 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:58 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:02 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:11 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:13 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "11:25 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-1-14",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-2",
// // //     "tripCode": "52/P52B-252-BTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PERUNKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:15 PM",
// // //     "endTime": "03:25 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:19 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:23 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:30 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:32 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:40 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:44 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:46 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:52 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "02:57 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "03:01 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "03:04 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "03:08 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "03:11 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "03:16 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "03:20 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "03:25 PM",
// // //         "id": 32
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-2-15",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-2",
// // //     "tripCode": "52/P52B-252-BTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "PERUNKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:40 PM",
// // //     "endTime": "04:50 PM",
// // //     "ids": [
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "03:40 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "03:44 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "03:48 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "03:53 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "03:56 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:00 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "04:03 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "04:07 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "04:12 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "04:18 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:20 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:24 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:32 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:34 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:41 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:45 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-3-16",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-1",
// // //     "tripCode": "52/P52B-152-BTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SIVAKALAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:05 PM",
// // //     "endTime": "06:20 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       33
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:09 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:13 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:20 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:22 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:30 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:34 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "05:36 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "05:42 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "05:47 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "05:50 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:54 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "05:57 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "06:00 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "06:05 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "06:09 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "06:14 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "SIVAKALAI",
// // //         "time": "06:20 PM",
// // //         "id": 33
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-4-17",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-1",
// // //     "tripCode": "52/P52B-152-BTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SIVAKALAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:35 PM",
// // //     "endTime": "07:40 PM",
// // //     "ids": [
// // //       33,
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "SIVAKALAI",
// // //         "time": "06:35 PM",
// // //         "id": 33
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "06:39 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "06:43 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "06:47 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "06:51 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "06:54 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:57 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:00 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:03 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:07 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:13 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:14 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:18 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:24 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:26 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:33 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:35 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-5-18",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-1",
// // //     "tripCode": "52/P52B-152-BTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SIVAKALAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:55 PM",
// // //     "endTime": "09:25 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       33
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:00 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:04 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:13 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:16 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:25 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:30 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:32 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:39 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:45 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "08:49 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:53 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:58 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:01 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "09:07 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "09:12 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "09:18 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "SIVAKALAI",
// // //         "time": "09:25 PM",
// // //         "id": 33
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-6-19",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-1",
// // //     "tripCode": "52/P52B-152-BTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "SIVAKALAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 AM",
// // //     "endTime": "08:30 AM",
// // //     "ids": [
// // //       33,
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "SIVAKALAI",
// // //         "time": "07:10 AM",
// // //         "id": 33
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "07:16 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "07:20 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "07:25 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:30 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:33 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:37 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:41 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:45 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:50 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:56 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:58 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:03 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:11 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:13 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:25 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-7-20",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-2",
// // //     "tripCode": "52/P52B-252-BTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PERUNKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:45 AM",
// // //     "endTime": "10:00 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:50 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:01 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:04 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:12 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:16 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:18 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:25 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "09:30 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "09:34 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "09:38 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "09:42 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:45 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "09:50 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "09:55 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "10:00 AM",
// // //         "id": 32
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-8-21",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-2",
// // //     "tripCode": "52/P52B-252-BTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PERUNKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:15 AM",
// // //     "endTime": "11:20 AM",
// // //     "ids": [
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "10:15 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "10:19 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "10:23 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "10:27 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:30 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:33 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "10:37 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:40 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:45 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:50 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:52 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:56 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:03 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:05 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:12 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:15 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-9-22",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-2",
// // //     "tripCode": "52/P52B-252-BTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PERUNKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:35 AM",
// // //     "endTime": "12:45 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:39 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:43 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:50 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:52 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:00 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:04 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "12:06 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:12 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "12:17 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "12:21 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:24 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:28 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "12:31 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "12:36 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "12:40 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "12:45 PM",
// // //         "id": 32
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-B-10-23",
// // //     "routeNo": "52-B",
// // //     "code": "52/P52B-2",
// // //     "tripCode": "52/P52B-252-BTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "PERUNKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:00 PM",
// // //     "endTime": "02:10 PM",
// // //     "ids": [
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "01:00 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "01:04 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "01:08 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "01:13 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "01:16 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "01:20 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "01:23 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "01:27 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "01:32 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "01:38 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:40 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:44 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:52 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:54 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:01 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:05 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-1-24",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 AM",
// // //     "endTime": "06:45 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:18 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:20 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:26 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:28 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:33 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:36 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:38 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:42 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "06:45 AM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-2-25",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-2",
// // //     "tripCode": "52/P52C-252-CTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THRES PURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:55 AM",
// // //     "endTime": "07:45 AM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       35,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1,
// // //       28,
// // //       27
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "06:55 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:58 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SIRUPADU",
// // //         "time": "07:03 AM",
// // //         "id": 35
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:06 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:07 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:11 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:19 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:21 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "07:28 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:31 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:36 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:41 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "07:45 AM",
// // //         "id": 27
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-3-26",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-4",
// // //     "tripCode": "52/P52C-452-CTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THRES PURAM",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:55 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       27,
// // //       28,
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       35,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "07:55 AM",
// // //         "id": 27
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:59 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:06 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:13 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "08:18 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:28 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:31 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:42 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:47 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU",
// // //         "time": "08:53 AM",
// // //         "id": 35
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:00 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "09:05 AM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-4-27",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-3",
// // //     "tripCode": "52/P52C-352-CTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "SUB COLLECTOR OFFICE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 AM",
// // //     "endTime": "10:00 AM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1,
// // //       28
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "09:10 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:13 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:20 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:22 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:26 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:35 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:37 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "3RD MILE",
// // //         "time": "09:45 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:49 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:54 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:00 AM",
// // //         "id": 28
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-5-28",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-3",
// // //     "tripCode": "52/P52C-352-CTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "SUB COLLECTOR OFFICE",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:05 AM",
// // //     "endTime": "11:10 AM",
// // //     "ids": [
// // //       28,
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:05 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:12 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:18 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "3RD MILE",
// // //         "time": "10:23 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:34 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:37 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:48 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:53 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:56 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "11:05 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "11:10 AM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-6-29",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:15 AM",
// // //     "endTime": "11:55 AM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "11:15 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "11:18 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "11:24 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:26 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:30 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:37 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:39 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:47 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:50 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:55 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-7-30",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:00 PM",
// // //     "endTime": "12:40 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "12:04 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:07 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:15 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:17 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:24 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:28 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "12:30 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:36 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "12:40 PM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-8-31",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:45 PM",
// // //     "endTime": "01:20 PM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "12:45 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:47 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "12:53 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:54 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:58 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:04 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:06 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:13 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:15 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-9-32",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:35 PM",
// // //     "endTime": "02:25 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:40 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:44 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:54 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:56 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:06 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:11 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:13 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:20 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "02:25 PM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-10-33",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:30 PM",
// // //     "endTime": "03:10 PM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "02:30 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:33 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:39 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:41 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:45 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:52 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:54 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:02 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:05 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-11-34",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:15 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:20 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:23 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:32 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:34 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:43 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:47 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "03:49 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "03:56 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "04:00 PM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-12-35",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-4",
// // //     "tripCode": "52/P52C-452-CTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THRES PURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:10 PM",
// // //     "endTime": "05:25 PM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       35,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1,
// // //       28,
// // //       27
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 12,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "04:10 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "04:15 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU",
// // //         "time": "04:22 PM",
// // //         "id": 35
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:28 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:34 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:45 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:49 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "05:00 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:05 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:12 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:19 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "05:25 PM",
// // //         "id": 27
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-13-36",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-2",
// // //     "tripCode": "52/P52C-252-CTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THRES PURAM",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 PM",
// // //     "endTime": "06:10 PM",
// // //     "ids": [
// // //       27,
// // //       28,
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       35,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "05:30 PM",
// // //         "id": 27
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:32 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:36 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:40 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "05:43 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:48 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:50 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:56 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:59 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:01 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SIRUPADU",
// // //         "time": "06:03 PM",
// // //         "id": 35
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:07 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "06:10 PM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-14-37",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-3",
// // //     "tripCode": "52/P52C-352-CTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "SUB COLLECTOR OFFICE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 PM",
// // //     "endTime": "07:00 PM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1,
// // //       28
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "06:15 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:18 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:24 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:26 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:30 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:37 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:39 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "3RD MILE",
// // //         "time": "06:47 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:50 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:00 PM",
// // //         "id": 28
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-15-38",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-3",
// // //     "tripCode": "52/P52C-352-CTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "SUB COLLECTOR OFFICE",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 PM",
// // //     "endTime": "08:25 PM",
// // //     "ids": [
// // //       28,
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:10 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:18 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:25 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "3RD MILE",
// // //         "time": "07:31 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:43 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:47 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:59 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:06 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:09 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:19 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "08:25 PM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-16-39",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:30 PM",
// // //     "endTime": "09:35 PM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "08:30 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:35 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:45 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:48 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:54 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:06 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:10 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:22 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:27 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-17-40",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18U17",
// // //     "order": 17,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULAIYANKARISAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 PM",
// // //     "endTime": "10:30 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       34
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:45 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:49 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:59 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:01 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:11 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:16 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:18 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:25 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "10:30 PM",
// // //         "id": 34
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-C-18-41",
// // //     "routeNo": "52-C",
// // //     "code": "52/P52C-1",
// // //     "tripCode": "52/P52C-152-CTORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "KULAIYANKARISAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:25 PM",
// // //     "endTime": "06:10 AM",
// // //     "ids": [
// // //       34,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "10:25 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "11:04 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "12:12 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:34 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:19 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:47 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:12 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:37 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:16 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-1-42",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:45 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:49 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:01 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:03 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:11 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:15 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:17 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:23 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:29 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:33 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:36 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:40 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:43 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:45 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "07:50 AM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "07:56 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "08:00 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-2-43",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:30 AM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "08:15 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "08:18 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "08:24 AM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "08:29 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:31 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:34 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:38 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "08:41 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:45 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:51 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:57 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:59 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:03 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:11 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:13 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:25 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-3-44",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "11:05 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:40 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:45 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:54 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:57 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:06 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:11 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:14 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:21 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:28 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "10:32 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:36 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:41 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "10:45 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "10:47 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "10:53 AM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "11:01 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "11:05 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-4-45",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:10 AM",
// // //     "endTime": "12:30 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "11:10 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "11:13 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "11:19 AM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "11:25 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "11:27 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "11:30 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "11:34 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "11:38 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "11:42 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "11:48 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "11:55 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:57 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:01 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:10 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:12 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:20 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "12:24 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-5-46",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:50 PM",
// // //     "endTime": "02:05 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "12:54 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:58 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:06 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:08 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:16 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:20 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "01:22 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "01:28 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "01:34 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "01:38 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "01:41 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "01:45 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "01:48 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "01:50 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "01:55 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "02:01 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "02:05 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-6-47",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:10 PM",
// // //     "endTime": "03:25 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "02:10 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "02:13 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "02:19 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "02:24 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "02:26 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "02:29 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "02:33 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "02:36 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "02:40 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:46 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:52 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:54 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:58 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:06 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:08 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:16 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "03:20 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-7-48",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-2",
// // //     "tripCode": "52/P52D-252-DTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PANDARAVILAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:30 PM",
// // //     "endTime": "04:35 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "03:34 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:38 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:45 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:47 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:55 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:59 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "04:01 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "04:07 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "04:12 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "04:15 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:19 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:22 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:25 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "04:30 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "04:35 PM",
// // //         "id": 31
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-8-49",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-2",
// // //     "tripCode": "52/P52D-252-DTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PANDARAVILAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:45 PM",
// // //     "endTime": "05:50 PM",
// // //     "ids": [
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "04:45 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "04:49 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:54 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:57 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:00 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "05:04 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "05:07 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "05:12 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "05:18 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:20 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:24 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:32 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:34 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:41 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:45 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-9-50",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:55 PM",
// // //     "endTime": "07:25 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:00 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:05 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:14 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:17 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:26 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:31 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:34 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:41 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "06:48 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "06:52 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:56 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:01 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:05 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:07 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "07:13 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "07:21 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "07:25 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-10-51",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 PM",
// // //     "endTime": "08:45 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "07:50 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "07:52 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "07:56 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "08:00 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:02 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:04 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:07 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "08:09 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:12 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:16 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:21 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:22 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:25 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:31 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:33 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:38 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:41 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-11-52",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:50 PM",
// // //     "endTime": "10:05 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:54 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:58 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:06 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:08 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:16 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:20 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:22 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:28 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "09:34 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "09:38 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "09:41 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "09:45 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:48 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "09:50 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "09:55 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "10:01 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "10:05 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-D-12-53",
// // //     "routeNo": "52-D",
// // //     "code": "52/P52D-1",
// // //     "tripCode": "52/P52D-152-DTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:10 PM",
// // //     "endTime": "06:30 AM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "10:10 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "10:32 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "11:12 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "11:45 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "11:59 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:20 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:45 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "01:08 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "01:33 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:10 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:51 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:05 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:32 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:26 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:41 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:33 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:58 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-1-54",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-1",
// // //     "tripCode": "52/P52E-152-ETORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:35 AM",
// // //     "endTime": "06:45 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:39 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:42 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:50 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:52 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:59 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:03 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:05 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:11 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "06:16 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "06:19 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:23 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "06:26 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "06:29 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "06:31 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "06:36 AM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "06:41 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "06:45 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-2-55",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-1",
// // //     "tripCode": "52/P52E-152-ETORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:05 AM",
// // //     "endTime": "08:15 AM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "07:05 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "07:08 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "07:13 AM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:18 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:20 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:23 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:26 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:30 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:33 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:38 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:44 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:46 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:50 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:57 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:59 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:07 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:10 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-3-56",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-3",
// // //     "tripCode": "52/P52E-352-ETORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:35 AM",
// // //     "endTime": "10:00 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       38,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:39 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:43 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:50 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:53 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:01 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:05 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:07 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:13 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "09:18 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "09:22 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "09:25 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "09:29 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:32 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "09:37 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "09:42 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "09:46 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "09:51 AM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "10:00 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-4-57",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-3",
// // //     "tripCode": "52/P52E-352-ETORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:10 AM",
// // //     "endTime": "11:40 AM",
// // //     "ids": [
// // //       20,
// // //       38,
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "10:10 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "10:18 AM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "10:24 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "10:28 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "10:33 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "10:39 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:42 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:46 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "10:49 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:53 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:59 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "11:05 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:08 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:12 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:20 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:23 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:31 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:34 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-5-58",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-3",
// // //     "tripCode": "52/P52E-352-ETORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:45 AM",
// // //     "endTime": "01:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       38,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:49 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:00 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:03 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:11 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:15 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "12:17 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:23 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "12:28 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "12:32 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:35 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:39 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "12:42 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "12:47 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "12:52 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "12:56 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "01:01 PM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "01:10 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-6-59",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-3",
// // //     "tripCode": "52/P52E-352-ETORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:15 PM",
// // //     "endTime": "02:45 PM",
// // //     "ids": [
// // //       20,
// // //       38,
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "01:15 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "01:23 PM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "01:29 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "01:33 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "01:38 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "01:44 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "01:47 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "01:51 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "01:54 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "01:58 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:04 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "02:10 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:13 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:17 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:25 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:28 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:36 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:39 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-7-60",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-2",
// // //     "tripCode": "52/P52E-252-ETORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:50 PM",
// // //     "endTime": "04:15 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       37,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:54 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:57 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:04 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:06 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:13 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:17 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "03:19 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "03:25 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "03:30 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "03:33 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "03:36 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "03:40 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "03:42 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "03:44 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALAI",
// // //         "time": "03:53 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "04:12 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "04:15 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-8-61",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-2",
// // //     "tripCode": "52/P52E-252-ETORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:20 PM",
// // //     "endTime": "05:40 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       37,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "04:20 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "04:22 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALAI",
// // //         "time": "04:40 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "04:48 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:50 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:52 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:56 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "04:59 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "05:02 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "05:06 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "05:12 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:13 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:17 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:24 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:26 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:32 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:35 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-9-62",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-4",
// // //     "tripCode": "52/P52E-452-ETORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:50 PM",
// // //     "endTime": "06:45 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:54 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:57 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:05 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:07 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:14 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:18 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:20 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:26 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "06:31 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "06:35 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:38 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "06:42 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "06:45 PM",
// // //         "id": 40
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-10-63",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-4",
// // //     "tripCode": "52/P52E-452-ETORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 PM",
// // //     "endTime": "07:45 PM",
// // //     "ids": [
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "06:50 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "06:52 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:56 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "06:59 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:03 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:08 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:14 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:16 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:20 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:27 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:29 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:37 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:40 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-11-64",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-1",
// // //     "tripCode": "52/P52E-152-ETORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 PM",
// // //     "endTime": "09:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:55 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:59 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:07 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:09 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:18 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:22 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:24 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:31 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:37 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "08:41 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:45 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:49 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:52 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "08:54 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "09:00 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "09:06 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "09:10 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-E-12-65",
// // //     "routeNo": "52-E",
// // //     "code": "52/P52E-1",
// // //     "tripCode": "52/P52E-152-ETORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 PM",
// // //     "endTime": "10:30 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "09:15 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "09:18 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "09:24 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "09:29 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:31 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "09:34 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "09:38 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "09:41 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "09:45 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:51 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:57 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:59 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:03 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:11 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:13 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:21 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:25 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-1-66",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-3",
// // //     "tripCode": "52/P52F-352-FTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:20 AM",
// // //     "endTime": "07:50 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       38,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:25 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:28 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:36 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:39 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:47 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:51 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:54 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:00 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:06 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:10 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:13 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:17 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:20 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "07:26 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "07:31 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "07:35 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "07:41 AM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "07:50 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-2-67",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-3",
// // //     "tripCode": "52/P52F-352-FTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 AM",
// // //     "endTime": "09:30 AM",
// // //     "ids": [
// // //       20,
// // //       38,
// // //       32,
// // //       31,
// // //       30,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "08:00 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "08:08 AM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "08:14 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "08:18 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "08:23 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:29 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:32 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:36 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "08:39 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:43 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:49 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "08:55 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:58 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:02 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:10 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:13 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:24 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-3-68",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-6",
// // //     "tripCode": "52/P52F-652-FTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SIRUPADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "10:20 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       35
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:41 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:45 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:55 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:58 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:08 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:13 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:16 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SIRUPADU",
// // //         "time": "10:20 AM",
// // //         "id": 35
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-4-69",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-6",
// // //     "tripCode": "52/P52F-652-FTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SIRUPADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:25 AM",
// // //     "endTime": "11:15 AM",
// // //     "ids": [
// // //       35,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "SIRUPADU",
// // //         "time": "10:25 AM",
// // //         "id": 35
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "10:29 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:31 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:37 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:48 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:52 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:03 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:08 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:15 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-5-70",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-1",
// // //     "tripCode": "52/P52F-152-FTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:20 AM",
// // //     "endTime": "12:50 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:25 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:30 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:39 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:42 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:51 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:56 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "11:59 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:06 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "12:13 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "12:17 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:21 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:26 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "12:30 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "12:32 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "12:38 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "12:46 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "12:50 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-6-71",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-2",
// // //     "tripCode": "52/P52F-252-FTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:00 PM",
// // //     "endTime": "02:20 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "01:00 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "01:03 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "01:09 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "01:15 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "01:17 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "01:20 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "01:24 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "01:28 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "01:32 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "01:38 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "01:45 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:47 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:51 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:00 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:02 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:10 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:14 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-7-72",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-2",
// // //     "tripCode": "52/P52F-252-FTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:30 PM",
// // //     "endTime": "03:45 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:34 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:38 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:46 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:48 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:56 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:00 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "03:02 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "03:08 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "03:14 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "03:18 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "03:21 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "03:25 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "03:28 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "03:30 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "03:35 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "03:41 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "03:45 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-8-73",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-2",
// // //     "tripCode": "52/P52F-252-FTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:40 PM",
// // //     "endTime": "05:20 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "03:40 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "03:44 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "03:52 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "03:59 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:01 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:06 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:11 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "04:15 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "04:20 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "04:28 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "04:36 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:39 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:44 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:55 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:58 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:08 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:13 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-9-74",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-1",
// // //     "tripCode": "52/P52F-152-FTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 PM",
// // //     "endTime": "06:45 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       18,
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:34 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:38 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:46 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:48 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:56 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:00 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "06:02 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:08 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "06:14 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "06:18 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:21 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "06:25 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "06:28 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "06:30 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "06:35 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "06:41 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "06:45 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-10-75",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-1",
// // //     "tripCode": "52/P52F-152-FTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 PM",
// // //     "endTime": "08:00 PM",
// // //     "ids": [
// // //       20,
// // //       19,
// // //       18,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "ERAL",
// // //         "time": "06:50 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "06:53 PM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ZAKKAMMALPURAM 1",
// // //         "time": "06:58 PM",
// // //         "id": 18
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:03 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:05 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:08 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:11 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:15 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:18 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:23 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:29 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:31 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:35 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:42 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:44 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:52 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:55 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-11-76",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-4",
// // //     "tripCode": "52/P52F-452-FTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:35 PM",
// // //     "endTime": "09:35 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:40 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:43 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:51 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:53 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:02 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:06 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "09:08 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:14 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "09:20 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "09:24 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "09:27 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "09:31 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:35 PM",
// // //         "id": 40
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-F-12-77",
// // //     "routeNo": "52-F",
// // //     "code": "52/P52F-5",
// // //     "tripCode": "52/P52F-552-FTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 PM",
// // //     "endTime": "06:15 AM",
// // //     "ids": [
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       8,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "09:40 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:07 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:40 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "11:11 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "11:44 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "12:32 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "01:27 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:44 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:21 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:31 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:52 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:00 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:31 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-1-78",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-1",
// // //     "tripCode": "52/P52G-152-GTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 AM",
// // //     "endTime": "08:30 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       38,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:23 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:26 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:33 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:35 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:41 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:44 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "07:46 AM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:51 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:55 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "07:58 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:01 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:04 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "08:07 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "08:11 AM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "08:15 AM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "08:19 AM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "08:23 AM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "08:30 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-2-79",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:40 AM",
// // //     "endTime": "09:40 AM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "08:40 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "08:46 AM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "08:48 AM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "08:51 AM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "08:55 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "08:59 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:05 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:10 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:13 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:20 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:23 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:24 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:31 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:36 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:39 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-3-80",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 AM",
// // //     "endTime": "10:50 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       52,
// // //       53,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:50 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:53 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:58 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:05 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:06 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:09 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "10:16 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "10:19 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "10:24 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "10:30 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "10:34 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "10:38 AM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "10:41 AM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "10:43 AM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "10:50 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-4-81",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18U4",
// // //     "order": 4,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "KURUMBUR R/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:55 AM",
// // //     "endTime": "11:10 AM",
// // //     "ids": [
// // //       20,
// // //       55,
// // //       56,
// // //       57
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "10:55 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "10:58 AM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "11:07 AM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "11:10 AM",
// // //         "id": 57
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-5-82",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18D5",
// // //     "order": 5,
// // //     "direction": "D",
// // //     "from": "KURUMBUR R/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:20 AM",
// // //     "endTime": "11:35 AM",
// // //     "ids": [
// // //       57,
// // //       56,
// // //       55,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "11:20 AM",
// // //         "id": 57
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "11:22 AM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "11:31 AM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "11:35 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-6-83",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:40 AM",
// // //     "endTime": "12:40 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "11:40 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "11:46 AM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "11:48 AM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "11:51 AM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "11:55 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "11:59 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "12:05 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:10 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "12:13 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "12:20 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "12:23 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "12:24 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "12:31 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "12:36 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "12:39 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-7-84",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:50 PM",
// // //     "endTime": "01:50 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       52,
// // //       53,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "12:50 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "12:53 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "12:58 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:05 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:06 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:09 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "01:16 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:19 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "01:24 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "01:30 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "01:34 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "01:38 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "01:41 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "01:43 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "01:50 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-8-85",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18U8",
// // //     "order": 8,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "KURUMBUR R/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:55 PM",
// // //     "endTime": "02:10 PM",
// // //     "ids": [
// // //       20,
// // //       55,
// // //       56,
// // //       57
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "01:55 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "01:58 PM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "02:07 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "02:10 PM",
// // //         "id": 57
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-9-86",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18D9",
// // //     "order": 9,
// // //     "direction": "D",
// // //     "from": "KURUMBUR R/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:30 PM",
// // //     "endTime": "02:45 PM",
// // //     "ids": [
// // //       57,
// // //       56,
// // //       55,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "02:30 PM",
// // //         "id": 57
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "02:32 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "02:41 PM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "02:45 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-10-87",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:50 PM",
// // //     "endTime": "03:50 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "02:50 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "02:56 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "02:58 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "03:01 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "03:05 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "03:09 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "03:15 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:20 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "03:23 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:30 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "03:33 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "03:34 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "03:41 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "03:46 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "03:49 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-11-88",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-1",
// // //     "tripCode": "52/P52G-152-GTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:00 PM",
// // //     "endTime": "05:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       8,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       30,
// // //       31,
// // //       32,
// // //       38,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:03 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:06 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:13 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:15 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:21 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:24 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIRUPADU JUNCTION",
// // //         "time": "04:26 PM",
// // //         "id": 8
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "04:31 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "04:35 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SALAI",
// // //         "time": "04:38 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:41 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:44 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:47 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTATTHI",
// // //         "time": "04:51 PM",
// // //         "id": 30
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANDARAVILAI",
// // //         "time": "04:55 PM",
// // //         "id": 31
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PERUNKULAM",
// // //         "time": "04:59 PM",
// // //         "id": 32
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MANGALAKURICHI",
// // //         "time": "05:03 PM",
// // //         "id": 38
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ERAL",
// // //         "time": "05:10 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-12-89",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18U12",
// // //     "order": 12,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "KURUMBUR R/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:15 PM",
// // //     "endTime": "05:30 PM",
// // //     "ids": [
// // //       20,
// // //       55,
// // //       56,
// // //       57
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "05:15 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "05:18 PM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "05:27 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "05:30 PM",
// // //         "id": 57
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-13-90",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18D13",
// // //     "order": 13,
// // //     "direction": "D",
// // //     "from": "KURUMBUR R/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:40 PM",
// // //     "endTime": "06:00 PM",
// // //     "ids": [
// // //       57,
// // //       56,
// // //       55,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "05:40 PM",
// // //         "id": 57
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "05:43 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "05:55 PM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "06:00 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-14-91",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:05 PM",
// // //     "endTime": "07:00 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "06:05 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "06:11 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "06:12 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "06:15 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "06:19 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "06:23 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "06:28 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:33 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:36 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:42 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:45 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:45 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:52 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:56 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:59 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-15-92",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 PM",
// // //     "endTime": "08:10 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       52,
// // //       53,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:10 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:13 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:18 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:25 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:26 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:29 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:36 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:39 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "07:44 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "07:50 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "07:54 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "07:58 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "08:01 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "08:03 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "08:10 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-16-93",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18U16",
// // //     "order": 16,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "KURUMBUR R/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       20,
// // //       55,
// // //       56,
// // //       57
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "08:15 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "08:18 PM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "08:27 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "08:30 PM",
// // //         "id": 57
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-17-94",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-3",
// // //     "tripCode": "52/P52G-352-GTORD18D17",
// // //     "order": 17,
// // //     "direction": "D",
// // //     "from": "KURUMBUR R/S",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:35 PM",
// // //     "endTime": "08:45 PM",
// // //     "ids": [
// // //       57,
// // //       56,
// // //       55,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 5,
// // //         "name": "KURUMBUR R/S",
// // //         "time": "08:35 PM",
// // //         "id": 57
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KURUMBUR",
// // //         "time": "08:36 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SETHUSUBRAMANIAPURAM",
// // //         "time": "08:42 PM",
// // //         "id": 55
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "08:45 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-G-18-95",
// // //     "routeNo": "52-G",
// // //     "code": "52/P52G-2",
// // //     "tripCode": "52/P52G-252-GTORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:50 PM",
// // //     "endTime": "06:50 AM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "08:50 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "09:56 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "10:15 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "10:45 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "11:25 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "12:07 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "01:07 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "02:28 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:34 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:06 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:13 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "05:27 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:13 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:45 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-1-96",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-1",
// // //     "tripCode": "52/P52K-152-KTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "THALAMUTHU NAGAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:20 AM",
// // //     "endTime": "06:30 AM",
// // //     "ids": [
// // //       1,
// // //       279,
// // //       58,
// // //       59,
// // //       60,
// // //       61,
// // //       62
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 2",
// // //         "time": "06:22 AM",
// // //         "id": 279
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 1",
// // //         "time": "06:24 AM",
// // //         "id": 58
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KEBI",
// // //         "time": "06:25 AM",
// // //         "id": 59
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MURUGAN THEATRE",
// // //         "time": "06:26 AM",
// // //         "id": 60
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAJA PALAIYAM",
// // //         "time": "06:28 AM",
// // //         "id": 61
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THALAMUTHU NAGAR",
// // //         "time": "06:30 AM",
// // //         "id": 62
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-2-97",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-2",
// // //     "tripCode": "52/P52K-252-KTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "THALAMUTHU NAGAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:40 AM",
// // //     "endTime": "07:10 AM",
// // //     "ids": [
// // //       62,
// // //       111,
// // //       64,
// // //       63,
// // //       58,
// // //       279,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 7,
// // //         "name": "THALAMUTHU NAGAR",
// // //         "time": "06:40 AM",
// // //         "id": 62
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:45 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:48 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:53 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 1",
// // //         "time": "06:59 AM",
// // //         "id": 58
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 2",
// // //         "time": "07:04 AM",
// // //         "id": 279
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-3-98",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-3",
// // //     "tripCode": "52/P52K-352-KTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 AM",
// // //     "endTime": "07:50 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:21 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:23 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:26 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:27 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:31 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:34 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:37 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:42 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:46 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:50 AM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-4-99",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-3",
// // //     "tripCode": "52/P52K-352-KTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 AM",
// // //     "endTime": "09:00 AM",
// // //     "ids": [
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:00 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:06 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:15 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:24 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:31 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:37 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:44 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:46 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:53 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:56 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-5-100",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-4",
// // //     "tripCode": "52/P52K-452-KTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 AM",
// // //     "endTime": "10:15 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:18 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:20 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:25 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:26 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:32 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:37 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:42 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:49 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:56 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:02 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:04 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:11 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:15 AM",
// // //         "id": 76
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-6-101",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-4",
// // //     "tripCode": "52/P52K-452-KTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 AM",
// // //     "endTime": "11:30 AM",
// // //     "ids": [
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:30 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:33 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:40 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:42 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:48 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:55 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:02 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:07 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:12 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:18 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:19 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:24 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:26 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-7-102",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-5",
// // //     "tripCode": "52/P52K-552-KTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "THOOTHUKUDI NEW B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:35 AM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       77
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:30 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI NEW B/S",
// // //         "time": "04:00 PM",
// // //         "id": 77
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-8-103",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-5",
// // //     "tripCode": "52/P52K-552-KTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "THOOTHUKUDI NEW B/S",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:50 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       77,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI NEW B/S",
// // //         "time": "11:50 AM",
// // //         "id": 77
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:53 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-9-104",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-6",
// // //     "tripCode": "52/P52K-652-KTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:10 PM",
// // //     "endTime": "12:55 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "12:13 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:16 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "12:18 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "12:21 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "12:24 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "12:26 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "12:31 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "12:34 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "12:40 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:42 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:46 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:47 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:52 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:55 PM",
// // //         "id": 76
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-10-105",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-7",
// // //     "tripCode": "52/P52K-752-KTORD18U10",
// // //     "order": 10,
// // //     "direction": "U",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "PARIVALLIKOTTAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:00 PM",
// // //     "endTime": "02:30 PM",
// // //     "ids": [
// // //       76,
// // //       85,
// // //       86,
// // //       87,
// // //       88,
// // //       89,
// // //       90,
// // //       91,
// // //       92,
// // //       93,
// // //       94,
// // //       95,
// // //       96
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "01:00 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "OSANOOTTHU",
// // //         "time": "01:14 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "KOMBADI",
// // //         "time": "01:21 PM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "PANDIAPURAM",
// // //         "time": "01:32 PM",
// // //         "id": 87
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "PARAIKUTTAM",
// // //         "time": "01:36 PM",
// // //         "id": 88
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "VADAMALAPURAM",
// // //         "time": "01:42 PM",
// // //         "id": 89
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MANIYACCHI",
// // //         "time": "01:46 PM",
// // //         "id": 90
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "OTTANATTHAM",
// // //         "time": "01:59 PM",
// // //         "id": 91
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KALLATTHIKINARU",
// // //         "time": "02:06 PM",
// // //         "id": 92
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "MALAIPATTI",
// // //         "time": "02:12 PM",
// // //         "id": 93
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "ILAVELANKAL",
// // //         "time": "02:20 PM",
// // //         "id": 94
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "IYRAVIPATTI",
// // //         "time": "02:25 PM",
// // //         "id": 95
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PARIVALLIKOTTAI",
// // //         "time": "02:30 PM",
// // //         "id": 96
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-11-106",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-7",
// // //     "tripCode": "52/P52K-752-KTORD18D11",
// // //     "order": 11,
// // //     "direction": "D",
// // //     "from": "PARIVALLIKOTTAI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:35 PM",
// // //     "endTime": "03:30 PM",
// // //     "ids": [
// // //       96,
// // //       95,
// // //       94,
// // //       93,
// // //       92,
// // //       91,
// // //       90,
// // //       89,
// // //       88,
// // //       87,
// // //       86,
// // //       85,
// // //       76
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "PARIVALLIKOTTAI",
// // //         "time": "02:35 PM",
// // //         "id": 96
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "IYRAVIPATTI",
// // //         "time": "02:37 PM",
// // //         "id": 95
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "ILAVELANKAL",
// // //         "time": "02:40 PM",
// // //         "id": 94
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "MALAIPATTI",
// // //         "time": "02:45 PM",
// // //         "id": 93
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KALLATTHIKINARU",
// // //         "time": "02:49 PM",
// // //         "id": 92
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "OTTANATTHAM",
// // //         "time": "02:53 PM",
// // //         "id": 91
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MANIYACCHI",
// // //         "time": "03:01 PM",
// // //         "id": 90
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "VADAMALAPURAM",
// // //         "time": "03:04 PM",
// // //         "id": 89
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "PARAIKUTTAM",
// // //         "time": "03:07 PM",
// // //         "id": 88
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "PANDIAPURAM",
// // //         "time": "03:09 PM",
// // //         "id": 87
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "KOMBADI",
// // //         "time": "03:16 PM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "OSANOOTTHU",
// // //         "time": "03:21 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:30 PM",
// // //         "id": 76
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-12-107",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-4",
// // //     "tripCode": "52/P52K-452-KTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:35 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:35 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "03:36 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "03:39 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "03:40 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "03:42 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "03:45 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "03:48 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:50 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:52 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:55 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:55 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:57 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:58 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-13-108",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-8",
// // //     "tripCode": "52/P52K-852-KTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KURUKKUSALAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:10 PM",
// // //     "endTime": "04:50 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:12 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:14 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "04:19 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "04:20 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "04:25 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "04:28 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "04:33 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "04:40 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "04:45 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "04:50 PM",
// // //         "id": 100
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-14-109",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-9",
// // //     "tripCode": "52/P52K-952-KTORD18U14",
// // //     "order": 14,
// // //     "direction": "U",
// // //     "from": "KURUKKUSALAI",
// // //     "to": "NORTH AARAIKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 PM",
// // //     "endTime": "05:50 PM",
// // //     "ids": [
// // //       100,
// // //       101,
// // //       102,
// // //       103,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       106,
// // //       110,
// // //       108
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "05:00 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "05:03 PM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "KAKKARAMPATTI JUNCTION",
// // //         "time": "05:08 PM",
// // //         "id": 102
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MEENAKSHIPURAM",
// // //         "time": "05:10 PM",
// // //         "id": 103
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "05:23 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "OTTAPIDARAM TALUK OFFICE",
// // //         "time": "05:24 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "05:27 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "OSANOOTTHU",
// // //         "time": "05:38 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "05:41 PM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THERKKU ARAIKULAM",
// // //         "time": "05:47 PM",
// // //         "id": 110
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "NORTH AARAIKULAM",
// // //         "time": "05:50 PM",
// // //         "id": 108
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-15-110",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-10",
// // //     "tripCode": "52/P52K-1052-KTORD18D15",
// // //     "order": 15,
// // //     "direction": "D",
// // //     "from": "NORTH AARAIKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:00 PM",
// // //     "endTime": "07:00 PM",
// // //     "ids": [
// // //       108,
// // //       110,
// // //       106,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "NORTH AARAIKULAM",
// // //         "time": "06:00 PM",
// // //         "id": 108
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "THERKKU ARAIKULAM",
// // //         "time": "06:01 PM",
// // //         "id": 110
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "06:05 PM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "06:07 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "06:14 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "TALUK OFFICE",
// // //         "time": "06:16 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:17 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "06:19 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "06:24 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "06:26 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:30 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:35 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:40 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:44 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:47 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:51 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:52 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:56 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:57 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-16-111",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-11",
// // //     "tripCode": "52/P52K-1152-KTORD18U16",
// // //     "order": 16,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 PM",
// // //     "endTime": "08:10 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       52,
// // //       53,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:10 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:13 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:18 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:25 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:26 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:29 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:36 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:39 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "07:44 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "07:50 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "07:54 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "07:58 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "08:01 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "08:03 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "08:10 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "52-K-17-112",
// // //     "routeNo": "52-K",
// // //     "code": "52/P52K-11",
// // //     "tripCode": "52/P52K-1152-KTORD18D17",
// // //     "order": 17,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:20 PM",
// // //     "endTime": "10:00 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "08:20 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "08:31 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "08:34 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "08:39 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "08:45 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "08:52 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:02 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:11 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:16 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:27 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:32 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:33 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:46 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:53 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:59 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-1-113",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-1",
// // //     "tripCode": "53/P53A-153-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 AM",
// // //     "endTime": "06:40 AM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       120,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:30 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "05:33 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:36 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:42 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "05:45 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "05:46 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "05:51 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "05:52 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:01 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "06:07 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "06:09 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "06:14 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "06:18 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "06:20 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "06:25 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 1",
// // //         "time": "06:31 AM",
// // //         "id": 120
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "06:35 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:40 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-2-114",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-2",
// // //     "tripCode": "53/P53A-253-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THULUKKANKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:40 AM",
// // //     "endTime": "06:50 AM",
// // //     "ids": [
// // //       122,
// // //       126,
// // //       125,
// // //       124,
// // //       285
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:40 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VAIPPAR",
// // //         "time": "06:44 AM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "06:47 AM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "KALAIGNANAPURAM",
// // //         "time": "06:49 AM",
// // //         "id": 124
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "06:50 AM",
// // //         "id": 285
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-3-115",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-2",
// // //     "tripCode": "53/P53A-253-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THULUKKANKULAM",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:05 AM",
// // //     "endTime": "07:15 AM",
// // //     "ids": [
// // //       285,
// // //       124,
// // //       125,
// // //       126,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "07:05 AM",
// // //         "id": 285
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "KALAIGNANAPURAM",
// // //         "time": "07:05 AM",
// // //         "id": 124
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "07:07 AM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VAIPPAR",
// // //         "time": "07:10 AM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "07:15 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-4-116",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-1",
// // //     "tripCode": "53/P53A-153-ATORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 AM",
// // //     "endTime": "08:35 AM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       120,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "07:20 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "07:25 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 1",
// // //         "time": "07:29 AM",
// // //         "id": 120
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "07:35 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "07:41 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "07:42 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "07:47 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "07:52 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "07:54 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "08:01 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:10 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:11 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:17 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:18 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:21 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:27 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:30 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:35 AM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-5-117",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-5",
// // //     "tripCode": "53/P53A-553-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KURUMBUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:50 AM",
// // //     "endTime": "10:00 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       127,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       129,
// // //       130,
// // //       131,
// // //       56
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:50 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:54 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:59 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:07 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:08 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:12 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "09:19 AM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:23 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:29 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "09:36 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "09:41 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "09:44 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "09:46 AM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "09:51 AM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// // //         "time": "09:56 AM",
// // //         "id": 131
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KURUMBUR",
// // //         "time": "10:00 AM",
// // //         "id": 56
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-6-118",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-5",
// // //     "tripCode": "53/P53A-553-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KURUMBUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:05 AM",
// // //     "endTime": "11:35 AM",
// // //     "ids": [
// // //       56,
// // //       131,
// // //       130,
// // //       129,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       127,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "KURUMBUR",
// // //         "time": "10:05 AM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// // //         "time": "10:09 AM",
// // //         "id": 131
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "10:16 AM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "10:22 AM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "10:24 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "10:29 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "10:35 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "10:44 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "10:52 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "10:57 AM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "11:06 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:10 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:11 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:22 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "11:29 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "11:34 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:35 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-7-119",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:40 AM",
// // //     "endTime": "12:25 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:41 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:43 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:46 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:46 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:50 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:53 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:56 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "12:00 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:04 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:07 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:14 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:20 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:25 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-8-120",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:30 PM",
// // //     "endTime": "01:20 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:30 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:34 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:41 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:49 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:52 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "12:57 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:01 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:05 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:08 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:12 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:13 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:16 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:18 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-9-121",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:40 PM",
// // //     "endTime": "02:30 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:41 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:43 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:46 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:47 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:51 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:54 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:58 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "02:02 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:07 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:10 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "02:18 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "02:25 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "02:30 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-10-122",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:45 PM",
// // //     "endTime": "03:35 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "02:45 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "02:49 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "02:56 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "03:04 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "03:07 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "03:12 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "03:16 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:20 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:23 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:27 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:28 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:31 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:33 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-11-123",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-3",
// // //     "tripCode": "53/P53A-353-ATORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:45 PM",
// // //     "endTime": "04:55 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       52,
// // //       53,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "03:45 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "03:49 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "03:54 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:03 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:04 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "04:07 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "04:15 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "04:18 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "04:24 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "04:31 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "04:36 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "04:41 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "04:45 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "04:47 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "04:55 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-12-124",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-3",
// // //     "tripCode": "53/P53A-353-ATORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:05 PM",
// // //     "endTime": "06:20 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       53,
// // //       52,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "05:05 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "05:13 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VAZHAVALLAN",
// // //         "time": "05:15 PM",
// // //         "id": 53
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKADU",
// // //         "time": "05:19 PM",
// // //         "id": 52
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "05:24 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "05:29 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "05:37 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "05:43 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "05:47 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "05:55 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "05:59 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:00 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:09 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:15 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:19 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-13-125",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:35 PM",
// // //     "endTime": "07:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:36 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:38 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:41 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:41 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:45 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:48 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:51 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:55 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:59 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:02 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "07:09 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:15 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:20 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-14-126",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:25 PM",
// // //     "endTime": "08:40 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:25 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:32 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "07:42 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:54 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:59 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:06 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:12 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:18 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:22 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:28 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:29 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:34 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:37 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-15-127",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:50 PM",
// // //     "endTime": "09:40 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:51 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:53 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:56 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:57 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:01 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:04 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:08 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:12 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:17 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:20 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:28 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "09:35 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "09:40 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-A-16-128",
// // //     "routeNo": "53-A",
// // //     "code": "53/P53A-4",
// // //     "tripCode": "53/P53A-453-ATORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 PM",
// // //     "endTime": "10:35 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "09:50 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "09:54 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:00 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:07 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:10 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:14 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:18 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:21 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:24 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "10:28 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "10:28 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "10:31 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:33 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-1-129",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:00 PM",
// // //     "endTime": "02:10 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "01:06 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "01:09 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "01:11 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "01:12 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "01:17 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "01:19 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "01:27 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "01:33 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "01:35 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "01:40 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "01:45 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "01:46 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "01:52 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "02:03 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "02:05 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "02:10 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-2-130",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:15 PM",
// // //     "endTime": "03:25 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "02:15 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "02:19 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "02:21 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "02:32 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "02:38 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "02:39 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "02:44 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "02:49 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "02:51 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "02:57 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "03:05 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "03:07 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "03:12 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "03:13 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "03:15 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "03:18 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:22 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-3-131",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:30 PM",
// // //     "endTime": "06:15 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:59 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "04:47 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:24 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "05:55 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:12 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "07:14 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "07:30 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "09:22 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "10:37 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "11:01 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "12:04 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "01:03 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "01:18 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "02:31 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "04:47 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "05:13 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:15 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-4-132",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-2",
// // //     "tripCode": "53/P53B-253-BTORD18U4",
// // //     "order": 4,
// // //     "direction": "U",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THULUKKANKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:20 PM",
// // //     "endTime": "04:55 PM",
// // //     "ids": [
// // //       122,
// // //       126,
// // //       125,
// // //       124,
// // //       285
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "04:20 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "VAIPPAR",
// // //         "time": "04:36 PM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "04:46 PM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALAIGNANAPURAM",
// // //         "time": "04:51 PM",
// // //         "id": 124
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "04:55 PM",
// // //         "id": 285
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-5-133",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-2",
// // //     "tripCode": "53/P53B-253-BTORD18D5",
// // //     "order": 5,
// // //     "direction": "D",
// // //     "from": "THULUKKANKULAM",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 PM",
// // //     "endTime": "05:35 PM",
// // //     "ids": [
// // //       285,
// // //       124,
// // //       125,
// // //       126,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "05:00 PM",
// // //         "id": 285
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALAIGNANAPURAM",
// // //         "time": "05:03 PM",
// // //         "id": 124
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "05:08 PM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "VAIPPAR",
// // //         "time": "05:18 PM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "05:35 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-6-134",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:40 PM",
// // //     "endTime": "06:30 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "05:40 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "05:43 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "05:44 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "05:52 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "05:56 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "05:57 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "06:00 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "06:04 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "06:05 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:10 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:16 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:17 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:20 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:21 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:23 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "06:25 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:28 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-7-135",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:35 PM",
// // //     "endTime": "07:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:37 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "06:42 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:45 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:48 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:49 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:55 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:56 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "07:06 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "07:13 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "07:15 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "07:21 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "07:26 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "07:28 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "07:34 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "07:47 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "07:49 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "07:55 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-8-136",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 PM",
// // //     "endTime": "09:05 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "08:00 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "08:04 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "08:06 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "08:16 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "08:21 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "08:22 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "08:27 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "08:31 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "08:33 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "08:39 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:47 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:48 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:53 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:54 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:56 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:59 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-9-137",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:20 PM",
// // //     "endTime": "11:50 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:23 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "10:27 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "10:31 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "10:34 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:36 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "10:42 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "10:44 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "10:55 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "11:03 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "11:05 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "11:12 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "11:18 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "11:19 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "11:27 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "11:41 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "11:43 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "11:50 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-10-138",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:20 AM",
// // //     "endTime": "06:30 AM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "05:20 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "05:24 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "05:26 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "05:37 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "05:43 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "05:44 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "05:49 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "05:54 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "05:56 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:02 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:10 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:12 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:17 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:18 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:20 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "06:23 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:27 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-11-139",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:45 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:47 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "06:51 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:54 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:57 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:58 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "07:04 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "07:05 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "07:14 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "07:21 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "07:23 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "07:28 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "07:33 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "07:34 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "07:41 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "07:52 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "07:54 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "08:00 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-12-140",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:30 AM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "08:15 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "08:20 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "08:22 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "08:33 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "08:40 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "08:41 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "08:46 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "08:51 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "08:53 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "09:00 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "09:09 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "09:10 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "09:16 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "09:17 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "09:20 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "09:23 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:27 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-13-141",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "10:50 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:37 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "09:41 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "09:44 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "09:47 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "09:48 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "09:54 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "09:55 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "10:04 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "10:11 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "10:13 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "10:18 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "10:23 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "10:24 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "10:31 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "10:42 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "10:44 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "10:50 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-B-14-142",
// // //     "routeNo": "53-B",
// // //     "code": "53/P53B-1",
// // //     "tripCode": "53/P53B-153-BTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:55 AM",
// // //     "endTime": "12:05 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "10:55 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "10:59 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "11:01 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "11:12 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "11:18 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "11:19 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "11:24 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "11:29 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "11:31 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "11:37 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "11:45 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "11:47 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "11:52 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "11:53 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "11:55 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "11:58 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "12:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-1-143",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:00 PM",
// // //     "endTime": "03:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "02:07 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "02:10 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "02:13 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "02:14 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "02:20 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "02:21 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "02:31 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "02:38 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "02:40 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "02:46 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "02:51 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "02:53 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "02:59 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "03:12 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "03:14 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "03:20 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-2-144",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:25 PM",
// // //     "endTime": "04:40 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "03:25 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "03:30 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "03:32 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "03:43 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "03:50 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "03:51 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "03:56 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "04:01 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "04:03 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "04:10 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "04:19 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "04:20 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "04:26 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "04:27 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "04:30 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "04:33 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:37 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-3-145",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 PM",
// // //     "endTime": "06:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "05:07 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:10 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "05:13 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "05:14 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "05:20 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "05:21 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "05:31 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "05:38 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "05:40 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "05:46 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "05:51 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "05:53 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "05:59 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "06:12 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "06:14 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:20 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-4-146",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 PM",
// // //     "endTime": "07:50 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:30 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "06:35 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "06:37 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "06:50 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "06:56 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "06:58 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "07:03 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "07:09 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "07:11 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "07:18 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "07:28 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "07:29 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "07:35 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "07:36 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "07:39 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "07:42 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:47 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-5-147",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 PM",
// // //     "endTime": "09:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:07 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:11 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:14 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:17 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:18 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:24 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:25 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "08:34 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "08:41 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "08:43 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "08:48 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "08:53 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "08:54 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "09:01 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "09:12 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "09:14 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "09:20 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-6-148",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:30 PM",
// // //     "endTime": "10:30 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "09:30 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "09:34 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "09:35 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "09:45 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "09:50 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "09:51 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "09:55 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "09:59 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "10:01 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "10:06 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "10:13 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "10:14 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:19 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "10:20 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "10:22 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "10:24 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:27 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-7-149",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:05 AM",
// // //     "endTime": "06:20 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:05 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:07 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "05:11 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:14 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "05:17 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "05:18 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "05:24 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "05:25 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "05:34 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "05:41 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "05:43 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "05:48 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "05:53 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "05:54 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "06:01 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "06:12 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "06:14 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:20 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-8-150",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 AM",
// // //     "endTime": "07:45 AM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "06:30 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "06:35 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "06:37 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "06:48 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "06:55 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "06:56 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "07:01 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "07:06 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "07:08 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "07:15 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "07:24 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "07:25 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "07:31 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "07:32 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "07:35 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "07:38 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:42 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-9-151",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 AM",
// // //     "endTime": "09:20 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:00 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:02 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:07 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:10 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:13 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:14 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:20 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:21 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "08:31 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "08:38 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "08:40 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "08:46 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "08:51 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "08:53 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "08:59 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "09:12 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "09:14 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "09:20 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-10-152",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:25 AM",
// // //     "endTime": "10:50 AM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "09:25 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "09:30 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "09:33 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "09:46 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "09:53 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "09:54 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "10:00 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "10:06 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "10:08 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "10:16 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "10:26 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "10:28 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:34 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "10:35 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "10:38 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "10:42 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:47 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:50 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-11-153",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:05 AM",
// // //     "endTime": "12:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       282,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:05 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:07 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "11:11 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "11:14 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "11:17 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "11:18 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "11:24 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "11:25 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "11:34 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "11:41 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "11:43 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "11:48 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "11:53 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "11:54 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "12:01 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "12:12 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "12:14 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "12:20 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-C-12-154",
// // //     "routeNo": "53-C",
// // //     "code": "53/P53C-1",
// // //     "tripCode": "53/P53C-153-CTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:30 PM",
// // //     "endTime": "01:50 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       282,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "12:30 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "12:35 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "12:37 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "12:50 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "12:56 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "12:58 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "01:03 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "01:09 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "01:11 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "01:18 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "01:28 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "01:29 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "01:35 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "01:36 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "01:39 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "01:42 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:47 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-1-155",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:20 PM",
// // //     "endTime": "01:45 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "12:20 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "12:24 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:28 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "12:34 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "12:37 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "12:39 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "12:44 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "12:46 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "12:56 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "01:03 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "01:05 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "01:11 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "01:16 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "01:18 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "01:24 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "01:37 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "01:39 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "01:45 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-2-156",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:50 PM",
// // //     "endTime": "03:05 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "01:50 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "01:54 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "01:57 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "02:07 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "02:13 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "02:15 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "02:19 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "02:24 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "02:26 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "02:32 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "02:41 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "02:43 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "02:48 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "02:49 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "02:51 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:57 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "03:01 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:05 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-3-157",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:20 PM",
// // //     "endTime": "04:15 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:20 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "03:22 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:25 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "03:29 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "03:31 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "03:32 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "03:36 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "03:37 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "03:43 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "03:48 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "03:49 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "03:53 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "03:56 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "03:57 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "04:01 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "04:09 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "04:11 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "04:15 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-4-158",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:20 PM",
// // //     "endTime": "05:30 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "04:20 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "04:24 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "04:26 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "04:36 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "04:42 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "04:43 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "04:47 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "04:52 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "04:54 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "04:59 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "05:08 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "05:09 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "05:14 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "05:15 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:17 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:23 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "05:26 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:30 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-5-159",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-2",
// // //     "tripCode": "53/P53D-253-DTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 PM",
// // //     "endTime": "07:00 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       133,
// // //       134,
// // //       135,
// // //       136,
// // //       287,
// // //       137,
// // //       138,
// // //       139,
// // //       118,
// // //       132,
// // //       140,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:45 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "05:48 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:52 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:58 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:00 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:02 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:07 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:08 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:17 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "AM PATTI",
// // //         "time": "06:22 PM",
// // //         "id": 133
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THERMAL STATION",
// // //         "time": "06:23 PM",
// // //         "id": 134
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "06:27 PM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "06:30 PM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "06:34 PM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "06:38 PM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SOUTH KALMEDU",
// // //         "time": "06:42 PM",
// // //         "id": 138
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "NORTH KALMEDU",
// // //         "time": "06:43 PM",
// // //         "id": 139
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "VEPPALODAI",
// // //         "time": "06:47 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "06:53 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "PANAIYOOR",
// // //         "time": "06:56 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "07:00 PM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-6-160",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-3",
// // //     "tripCode": "53/P53D-353-DTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "07:20 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "07:23 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "07:27 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "07:33 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "07:34 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "07:40 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "07:45 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "07:47 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "07:54 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:04 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:05 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:11 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:12 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:15 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:22 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:25 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:30 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-7-161",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:00 PM",
// // //     "endTime": "10:01 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:00 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "09:03 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "09:10 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "09:12 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "09:13 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "09:17 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "09:18 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "09:26 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "09:31 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "09:32 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "09:36 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "09:40 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "09:41 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "09:46 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "09:55 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "09:56 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "10:01 PM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-8-162",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:20 PM",
// // //     "endTime": "11:30 PM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "10:20 PM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "10:24 PM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "10:26 PM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "10:36 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "10:42 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "10:43 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "10:47 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "10:52 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "10:54 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "10:59 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "11:08 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "11:09 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "11:14 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "11:15 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "11:17 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:23 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "11:26 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:30 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-9-163",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-3",
// // //     "tripCode": "53/P53D-353-DTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:00 AM",
// // //     "endTime": "07:15 AM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       140,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:00 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "06:04 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:08 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:15 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:18 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:19 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:25 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:27 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:37 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "06:45 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "06:47 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "06:53 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "06:58 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "07:00 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "07:07 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "07:11 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "07:15 AM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-10-164",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-2",
// // //     "tripCode": "53/P53D-253-DTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 AM",
// // //     "endTime": "08:35 AM",
// // //     "ids": [
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       139,
// // //       138,
// // //       137,
// // //       287,
// // //       136,
// // //       135,
// // //       134,
// // //       133,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "07:20 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "PANAIYOOR",
// // //         "time": "07:23 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "07:26 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "VEPPALODAI",
// // //         "time": "07:32 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "NORTH KALMEDU",
// // //         "time": "07:36 AM",
// // //         "id": 139
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SOUTH KALMEDU",
// // //         "time": "07:37 AM",
// // //         "id": 138
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "07:41 AM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "07:45 AM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "07:49 AM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "07:52 AM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THERMAL STATION",
// // //         "time": "07:56 AM",
// // //         "id": 134
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "AM PATTI",
// // //         "time": "07:57 AM",
// // //         "id": 133
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "08:02 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:11 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:12 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:17 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:19 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:21 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:27 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:31 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:35 AM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-11-165",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA VAIPPAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:40 AM",
// // //     "endTime": "09:55 AM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       286,
// // //       284,
// // //       122
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:40 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "08:43 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:47 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "08:53 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:55 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:56 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "09:01 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "09:03 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "09:12 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "09:18 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "09:20 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "09:25 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "09:29 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "09:31 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "09:37 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "09:47 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "09:50 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "09:55 AM",
// // //         "id": 122
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-D-12-166",
// // //     "routeNo": "53-D",
// // //     "code": "53/P53D-1",
// // //     "tripCode": "53/P53D-153-DTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KEELA VAIPPAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:00 AM",
// // //     "endTime": "11:20 AM",
// // //     "ids": [
// // //       122,
// // //       284,
// // //       286,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA VAIPPAR",
// // //         "time": "10:00 AM",
// // //         "id": 122
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLOORANI",
// // //         "time": "10:05 AM",
// // //         "id": 284
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SALT FACTORY 2",
// // //         "time": "10:07 AM",
// // //         "id": 286
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "10:19 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "10:25 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "10:26 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "10:31 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "10:37 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "10:39 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "10:45 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "10:55 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "10:56 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "11:01 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "11:03 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "11:06 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:12 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "11:15 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:20 AM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-1-167",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-2",
// // //     "tripCode": "53/P53E-253-ETORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:35 PM",
// // //     "endTime": "02:00 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       140,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:35 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "01:36 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:37 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "01:40 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "01:41 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "01:41 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "01:43 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "01:44 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "01:47 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "01:50 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "01:50 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "01:52 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "01:54 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "01:55 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "01:57 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "01:58 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "02:00 PM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-2-168",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-2",
// // //     "tripCode": "53/P53E-253-ETORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:45 PM",
// // //     "endTime": "04:10 PM",
// // //     "ids": [
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "02:45 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "02:48 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "02:53 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "03:01 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "03:03 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "03:09 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "03:16 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "03:18 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "03:26 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "03:38 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "03:40 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "03:47 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "03:49 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "03:52 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "04:04 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:10 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-3-169",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:15 PM",
// // //     "endTime": "05:30 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       140,
// // //       141,
// // //       142,
// // //       288
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:15 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "04:18 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:22 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "04:28 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "04:31 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "04:32 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "04:37 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "04:38 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "04:48 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "04:54 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "04:56 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "05:01 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "05:06 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "05:07 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "05:13 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "05:17 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "05:20 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "05:23 PM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "05:30 PM",
// // //         "id": 288
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-4-170",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:35 PM",
// // //     "endTime": "06:50 PM",
// // //     "ids": [
// // //       288,
// // //       142,
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "05:35 PM",
// // //         "id": 288
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "05:41 PM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "05:44 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "05:47 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "05:51 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "05:57 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "05:58 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "06:03 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "06:08 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "06:10 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:16 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:26 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:27 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:32 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:33 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:36 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:42 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "06:46 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:50 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-5-171",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 PM",
// // //     "endTime": "06:00 AM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       140,
// // //       141,
// // //       142,
// // //       288
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:15 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "07:48 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:17 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "09:10 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "09:32 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "09:44 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "10:28 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "10:39 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "11:59 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "12:52 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "01:09 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "01:54 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "02:35 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "02:46 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "03:38 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "04:09 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "04:35 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "04:59 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "06:00 AM",
// // //         "id": 288
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-6-172",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:10 AM",
// // //     "endTime": "07:10 AM",
// // //     "ids": [
// // //       288,
// // //       142,
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "06:10 AM",
// // //         "id": 288
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "06:15 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "06:17 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "06:20 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "06:23 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "06:27 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "06:28 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "06:32 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "06:37 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "06:38 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "06:43 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "06:50 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "06:51 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "06:56 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "06:57 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "06:59 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:04 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "07:06 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:10 AM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-7-173",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:45 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       140,
// // //       141,
// // //       142,
// // //       288
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:45 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "07:49 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:52 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "07:59 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "08:02 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "08:03 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "08:09 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "08:10 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "08:20 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "08:26 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "08:28 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "08:34 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "08:39 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "08:41 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "08:47 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "08:51 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "08:54 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "08:57 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "09:05 AM",
// // //         "id": 288
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-8-174",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 AM",
// // //     "endTime": "10:30 AM",
// // //     "ids": [
// // //       288,
// // //       142,
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "09:10 AM",
// // //         "id": 288
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "09:17 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "09:20 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "09:23 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "09:27 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "09:33 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "09:35 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "09:40 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "09:46 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "09:48 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "09:54 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "10:04 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "10:05 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:11 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "10:12 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "10:15 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:22 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "10:25 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:30 AM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-9-175",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SUBRAMANIYAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:45 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       113,
// // //       114,
// // //       283,
// // //       115,
// // //       116,
// // //       117,
// // //       118,
// // //       132,
// // //       140,
// // //       141,
// // //       142,
// // //       288
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:45 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "10:48 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:52 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "10:58 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "11:01 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "11:02 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "11:07 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "11:08 AM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "11:18 AM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "11:24 AM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "11:26 AM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "11:31 AM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "11:36 AM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "11:37 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "11:43 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "11:47 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "11:50 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "11:53 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "12:00 PM",
// // //         "id": 288
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-E-10-176",
// // //     "routeNo": "53-E",
// // //     "code": "53/P53E-1",
// // //     "tripCode": "53/P53E-153-ETORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "SUBRAMANIYAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:10 PM",
// // //     "endTime": "01:30 PM",
// // //     "ids": [
// // //       288,
// // //       142,
// // //       141,
// // //       140,
// // //       132,
// // //       118,
// // //       117,
// // //       116,
// // //       115,
// // //       283,
// // //       114,
// // //       113,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "SUBRAMANIYAPURAM 3",
// // //         "time": "12:10 PM",
// // //         "id": 288
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "COLONY",
// // //         "time": "12:17 PM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "12:20 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANAIYOOR",
// // //         "time": "12:23 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "12:27 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VEPPALODAI",
// // //         "time": "12:33 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHEMICAL X",
// // //         "time": "12:35 PM",
// // //         "id": 117
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KALMEDU",
// // //         "time": "12:40 PM",
// // //         "id": 116
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PATTINAMARUTHUR",
// // //         "time": "12:46 PM",
// // //         "id": 115
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ZAKKAMMALPURAM 2",
// // //         "time": "12:48 PM",
// // //         "id": 283
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THARUVAIKULAM",
// // //         "time": "12:54 PM",
// // //         "id": 114
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "JOTHI SALT",
// // //         "time": "01:04 PM",
// // //         "id": 113
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "01:05 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "01:11 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "01:12 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "01:15 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:22 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "01:25 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:30 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-1-177",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-1",
// // //     "tripCode": "53/P53F-153-FTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 AM",
// // //     "endTime": "07:30 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       143,
// // //       144,
// // //       145,
// // //       135,
// // //       136,
// // //       287,
// // //       137,
// // //       146,
// // //       147,
// // //       148,
// // //       149,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:32 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:33 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:37 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:38 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:42 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "06:44 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "06:46 AM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "06:48 AM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "06:53 AM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "06:55 AM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "06:58 AM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "07:02 AM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "07:05 AM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 1",
// // //         "time": "07:07 AM",
// // //         "id": 146
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VEDANATTHAM",
// // //         "time": "07:11 AM",
// // //         "id": 147
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKATACHALAPURAM",
// // //         "time": "07:15 AM",
// // //         "id": 148
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUTHUKUMARAPURAM",
// // //         "time": "07:19 AM",
// // //         "id": 149
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "07:30 AM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-2-178",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-2",
// // //     "tripCode": "53/P53F-253-FTORD18U2",
// // //     "order": 2,
// // //     "direction": "U",
// // //     "from": "KULATTHOOR",
// // //     "to": "THULUKKANKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:35 AM",
// // //     "endTime": "07:45 AM",
// // //     "ids": [
// // //       141,
// // //       142,
// // //       150,
// // //       126,
// // //       125,
// // //       285
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "07:35 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "COLONY",
// // //         "time": "07:36 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "SUBRAMANIYAPURAM JUNCTION",
// // //         "time": "07:38 AM",
// // //         "id": 150
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VAIPPAR",
// // //         "time": "07:41 AM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "07:43 AM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "07:45 AM",
// // //         "id": 285
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-3-179",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-2",
// // //     "tripCode": "53/P53F-253-FTORD18D3",
// // //     "order": 3,
// // //     "direction": "D",
// // //     "from": "THULUKKANKULAM",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       285,
// // //       125,
// // //       126,
// // //       150,
// // //       142,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "07:50 AM",
// // //         "id": 285
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "07:51 AM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VAIPPAR",
// // //         "time": "07:53 AM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "SUBRAMANIYAPURAM JUNCTION",
// // //         "time": "07:56 AM",
// // //         "id": 150
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "COLONY",
// // //         "time": "07:58 AM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "08:00 AM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-4-180",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-1",
// // //     "tripCode": "53/P53F-153-FTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 AM",
// // //     "endTime": "09:25 AM",
// // //     "ids": [
// // //       141,
// // //       149,
// // //       148,
// // //       147,
// // //       146,
// // //       137,
// // //       287,
// // //       136,
// // //       135,
// // //       145,
// // //       144,
// // //       143,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "08:05 AM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUTHUKUMARAPURAM",
// // //         "time": "08:19 AM",
// // //         "id": 149
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKATACHALAPURAM",
// // //         "time": "08:24 AM",
// // //         "id": 148
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VEDANATTHAM",
// // //         "time": "08:29 AM",
// // //         "id": 147
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 1",
// // //         "time": "08:34 AM",
// // //         "id": 146
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "08:38 AM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "08:42 AM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "08:46 AM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "08:50 AM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "08:53 AM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "09:00 AM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "09:02 AM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "09:06 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:08 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:14 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:15 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:20 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:22 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-5-181",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-4",
// // //     "tripCode": "53/P53F-453-FTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA SEITHALAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "10:20 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       111,
// // //       155,
// // //       156
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:35 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:36 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:38 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:38 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:40 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "09:41 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "09:43 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "09:46 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "09:48 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "09:49 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:00 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEITHALAI JUNCTION",
// // //         "time": "10:17 AM",
// // //         "id": 155
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KEELA SEITHALAI",
// // //         "time": "10:20 AM",
// // //         "id": 156
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-6-182",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-4",
// // //     "tripCode": "53/P53F-453-FTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KEELA SEITHALAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 AM",
// // //     "endTime": "11:30 AM",
// // //     "ids": [
// // //       156,
// // //       155,
// // //       111,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "KEELA SEITHALAI",
// // //         "time": "10:30 AM",
// // //         "id": 156
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEITHALAI JUNCTION",
// // //         "time": "10:33 AM",
// // //         "id": 155
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:55 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "11:10 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "11:12 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "11:15 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "11:18 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "11:20 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:22 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:24 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:25 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:27 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:28 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-7-183",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-3",
// // //     "tripCode": "53/P53F-353-FTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KOLLAMPARAMBU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:35 AM",
// // //     "endTime": "12:15 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       152,
// // //       289,
// // //       154
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:36 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:38 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:41 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:42 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:45 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "11:47 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "11:51 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "11:56 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "11:59 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "12:02 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 1",
// // //         "time": "12:08 PM",
// // //         "id": 152
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHANDRAGIRI",
// // //         "time": "12:09 PM",
// // //         "id": 289
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KOLLAMPARAMBU",
// // //         "time": "12:15 PM",
// // //         "id": 154
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-8-184",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-3",
// // //     "tripCode": "53/P53F-353-FTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KOLLAMPARAMBU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:20 PM",
// // //     "endTime": "01:30 PM",
// // //     "ids": [
// // //       154,
// // //       289,
// // //       152,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "KOLLAMPARAMBU",
// // //         "time": "12:20 PM",
// // //         "id": 154
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHANDRAGIRI",
// // //         "time": "12:29 PM",
// // //         "id": 289
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 1",
// // //         "time": "12:31 PM",
// // //         "id": 152
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "12:41 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "12:46 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "12:52 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "01:01 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "01:07 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:10 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:17 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:18 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:24 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:26 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-9-185",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-4",
// // //     "tripCode": "53/P53F-453-FTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA SEITHALAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:35 PM",
// // //     "endTime": "02:30 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       111,
// // //       155,
// // //       156
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:36 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:37 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:39 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:39 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:42 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "01:43 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "01:45 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "01:48 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "01:51 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "01:52 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "02:06 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEITHALAI JUNCTION",
// // //         "time": "02:26 PM",
// // //         "id": 155
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KEELA SEITHALAI",
// // //         "time": "02:30 PM",
// // //         "id": 156
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-10-186",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-4",
// // //     "tripCode": "53/P53F-453-FTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KEELA SEITHALAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:40 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       156,
// // //       155,
// // //       111,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "KEELA SEITHALAI",
// // //         "time": "02:40 PM",
// // //         "id": 156
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SEITHALAI JUNCTION",
// // //         "time": "02:40 PM",
// // //         "id": 155
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "02:46 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "02:50 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "02:50 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "02:51 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "02:52 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "02:52 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:53 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:53 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:53 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:54 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:54 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-11-187",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-1",
// // //     "tripCode": "53/P53F-153-FTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:00 PM",
// // //     "endTime": "05:10 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       143,
// // //       144,
// // //       145,
// // //       135,
// // //       136,
// // //       287,
// // //       137,
// // //       146,
// // //       147,
// // //       148,
// // //       149,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:04 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "04:08 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "04:09 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "04:14 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "04:16 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "04:19 PM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "04:21 PM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "04:27 PM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "04:29 PM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "04:33 PM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "04:37 PM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "04:40 PM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 1",
// // //         "time": "04:44 PM",
// // //         "id": 146
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VEDANATTHAM",
// // //         "time": "04:48 PM",
// // //         "id": 147
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKATACHALAPURAM",
// // //         "time": "04:52 PM",
// // //         "id": 148
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUTHUKUMARAPURAM",
// // //         "time": "04:57 PM",
// // //         "id": 149
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "05:10 PM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-12-188",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-2",
// // //     "tripCode": "53/P53F-253-FTORD18U12",
// // //     "order": 12,
// // //     "direction": "U",
// // //     "from": "KULATTHOOR",
// // //     "to": "THULUKKANKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "03:50 PM",
// // //     "ids": [
// // //       141,
// // //       142,
// // //       150,
// // //       126,
// // //       125,
// // //       285
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "03:00 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "COLONY",
// // //         "time": "03:06 PM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "SUBRAMANIYAPURAM JUNCTION",
// // //         "time": "03:19 PM",
// // //         "id": 150
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VAIPPAR",
// // //         "time": "03:32 PM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "03:41 PM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "03:50 PM",
// // //         "id": 285
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-13-189",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-2",
// // //     "tripCode": "53/P53F-253-FTORD18D13",
// // //     "order": 13,
// // //     "direction": "D",
// // //     "from": "THULUKKANKULAM",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:15 PM",
// // //     "endTime": "05:25 PM",
// // //     "ids": [
// // //       285,
// // //       125,
// // //       126,
// // //       150,
// // //       142,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "THULUKKANKULAM",
// // //         "time": "05:15 PM",
// // //         "id": 285
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALAIGNANAPURAM JUNCTION",
// // //         "time": "05:16 PM",
// // //         "id": 125
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "VAIPPAR",
// // //         "time": "05:18 PM",
// // //         "id": 126
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "SUBRAMANIYAPURAM JUNCTION",
// // //         "time": "05:21 PM",
// // //         "id": 150
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "COLONY",
// // //         "time": "05:23 PM",
// // //         "id": 142
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "05:25 PM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-14-190",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-1",
// // //     "tripCode": "53/P53F-153-FTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 PM",
// // //     "endTime": "06:45 PM",
// // //     "ids": [
// // //       141,
// // //       149,
// // //       148,
// // //       147,
// // //       146,
// // //       137,
// // //       287,
// // //       136,
// // //       135,
// // //       145,
// // //       144,
// // //       143,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "05:30 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUTHUKUMARAPURAM",
// // //         "time": "05:43 PM",
// // //         "id": 149
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKATACHALAPURAM",
// // //         "time": "05:48 PM",
// // //         "id": 148
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VEDANATTHAM",
// // //         "time": "05:52 PM",
// // //         "id": 147
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 1",
// // //         "time": "05:57 PM",
// // //         "id": 146
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "06:01 PM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "06:04 PM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "06:09 PM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "06:12 PM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "06:15 PM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "06:21 PM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "06:23 PM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "06:27 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:29 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:34 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:36 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:40 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:42 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-15-191",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-1",
// // //     "tripCode": "53/P53F-153-FTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 PM",
// // //     "endTime": "08:05 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       143,
// // //       144,
// // //       145,
// // //       135,
// // //       136,
// // //       287,
// // //       137,
// // //       146,
// // //       147,
// // //       148,
// // //       149,
// // //       141
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:52 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:54 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:58 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:00 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:05 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "07:07 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "07:11 PM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "07:13 PM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "07:19 PM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "07:22 PM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "07:25 PM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "07:30 PM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "07:33 PM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 1",
// // //         "time": "07:37 PM",
// // //         "id": 146
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VEDANATTHAM",
// // //         "time": "07:42 PM",
// // //         "id": 147
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKATACHALAPURAM",
// // //         "time": "07:46 PM",
// // //         "id": 148
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUTHUKUMARAPURAM",
// // //         "time": "07:51 PM",
// // //         "id": 149
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "08:05 PM",
// // //         "id": 141
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "53-F-16-192",
// // //     "routeNo": "53-F",
// // //     "code": "53/P53F-1",
// // //     "tripCode": "53/P53F-153-FTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 PM",
// // //     "endTime": "09:20 PM",
// // //     "ids": [
// // //       141,
// // //       149,
// // //       148,
// // //       147,
// // //       146,
// // //       137,
// // //       287,
// // //       136,
// // //       135,
// // //       145,
// // //       144,
// // //       143,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "KULATTHOOR 1",
// // //         "time": "08:10 PM",
// // //         "id": 141
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUTHUKUMARAPURAM",
// // //         "time": "08:22 PM",
// // //         "id": 149
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKATACHALAPURAM",
// // //         "time": "08:27 PM",
// // //         "id": 148
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VEDANATTHAM",
// // //         "time": "08:31 PM",
// // //         "id": 147
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 1",
// // //         "time": "08:35 PM",
// // //         "id": 146
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "DURAISAMYPURAM 1",
// // //         "time": "08:39 PM",
// // //         "id": 137
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ZAKKAMMALPURAM 3",
// // //         "time": "08:42 PM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "08:46 PM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "08:50 PM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "08:52 PM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "08:58 PM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "09:00 PM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "09:03 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:05 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:10 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:11 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:15 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:17 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-1-193",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:15 PM",
// // //     "endTime": "03:15 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "02:15 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "02:21 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "02:30 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:43 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:45 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:51 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "03:03 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:08 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "03:08 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "03:15 PM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-2-194",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:20 PM",
// // //     "endTime": "04:20 PM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "03:20 PM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "03:26 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:26 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "03:31 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:43 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "03:49 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "03:51 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:04 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:13 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:19 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-3-195",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:25 PM",
// // //     "endTime": "05:15 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:25 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:25 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:30 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:37 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:49 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:50 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "04:55 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "05:05 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "05:09 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "05:09 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "05:15 PM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-4-196",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:20 PM",
// // //     "endTime": "06:20 PM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "05:20 PM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "05:26 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "05:26 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "05:31 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "05:43 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "05:49 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "05:51 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:04 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:13 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:19 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-5-197",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:25 PM",
// // //     "endTime": "07:25 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:25 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:25 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:31 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:40 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:53 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:55 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:01 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:13 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:18 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "07:18 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "07:25 PM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-6-198",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 PM",
// // //     "endTime": "08:55 PM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "07:30 PM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "07:38 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:38 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:46 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:03 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:12 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:13 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:33 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:45 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:53 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-7-199",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:00 PM",
// // //     "endTime": "09:50 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:00 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:05 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:12 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:24 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:25 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:30 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:40 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:44 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "09:44 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "09:50 PM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-8-200",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:55 PM",
// // //     "endTime": "06:10 AM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "09:55 PM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "10:46 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "10:46 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "11:30 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:10 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:59 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:11 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:04 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:14 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:02 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-11-201",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:15 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:20 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:27 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:39 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:40 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:45 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "08:55 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "08:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "08:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "09:05 AM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-12-202",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 AM",
// // //     "endTime": "10:10 AM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "09:10 AM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "09:16 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:16 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:21 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:33 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:39 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:41 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:54 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:03 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:09 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-13-203",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:15 AM",
// // //     "endTime": "11:05 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:15 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:20 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:27 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:39 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:40 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:45 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "10:55 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "10:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "10:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "11:05 AM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-14-204",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:10 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "11:10 AM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "11:15 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "11:15 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "11:19 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "11:29 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:34 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:35 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:47 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "11:54 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "11:59 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-15-205",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:05 PM",
// // //     "endTime": "12:55 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "12:05 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "12:10 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "12:17 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "12:29 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "12:30 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "12:35 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "12:45 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:49 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "12:49 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "12:55 PM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-A-16-206",
// // //     "routeNo": "54-A",
// // //     "code": "54/P54A-1",
// // //     "tripCode": "54/P54A-154-ATORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:00 PM",
// // //     "endTime": "02:10 PM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "01:00 PM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "01:07 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:07 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "01:13 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:27 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:34 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:36 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:52 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "02:02 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "02:08 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-1-207",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ARUMUGAMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:45 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       290,
// // //       159,
// // //       160,
// // //       161,
// // //       162
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "01:45 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "01:50 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:56 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:07 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:08 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:13 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "02:22 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "02:27 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "02:34 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "02:40 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "02:40 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "02:45 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "02:48 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "02:55 PM",
// // //         "id": 162
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-2-208",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "ARUMUGAMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "04:10 PM",
// // //     "ids": [
// // //       162,
// // //       161,
// // //       160,
// // //       159,
// // //       290,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "03:00 PM",
// // //         "id": 162
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "03:06 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "03:09 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "03:14 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "03:14 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "03:20 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:27 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "03:32 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:41 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "03:46 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "03:47 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "03:58 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:04 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:09 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-3-209",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ARUMUGAMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:20 PM",
// // //     "endTime": "05:35 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       290,
// // //       159,
// // //       160,
// // //       161,
// // //       162
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:20 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:25 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:32 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:44 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:45 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "04:50 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "05:00 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "05:05 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "05:13 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "05:19 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "05:19 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "05:25 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "05:27 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "05:35 PM",
// // //         "id": 162
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-4-210",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "ARUMUGAMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:40 PM",
// // //     "endTime": "07:05 PM",
// // //     "ids": [
// // //       162,
// // //       161,
// // //       160,
// // //       159,
// // //       290,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "05:40 PM",
// // //         "id": 162
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "05:48 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "05:51 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "05:57 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "05:57 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "06:04 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:13 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:18 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:30 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:36 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:37 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:50 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:58 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:04 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-5-211",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ARUMUGAMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       290,
// // //       159,
// // //       160,
// // //       161,
// // //       162
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:10 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:15 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:23 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:35 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:37 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:42 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:53 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:58 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "08:06 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "08:13 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "08:13 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "08:19 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "08:22 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "08:30 PM",
// // //         "id": 162
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-6-212",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ARUMUGAMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:35 PM",
// // //     "endTime": "05:20 AM",
// // //     "ids": [
// // //       162,
// // //       161,
// // //       160,
// // //       159,
// // //       290,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "08:35 PM",
// // //         "id": 162
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "09:25 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "09:44 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "10:25 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "10:26 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "11:06 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:04 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "12:35 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:46 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:21 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:29 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "03:50 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:40 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:14 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-7-213",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ARUMUGAMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:25 AM",
// // //     "endTime": "06:40 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       290,
// // //       159,
// // //       160,
// // //       161,
// // //       162
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:25 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:25 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:30 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "05:37 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "05:49 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "05:50 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "05:55 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:05 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:10 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "06:18 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "06:24 AM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "06:24 AM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "06:30 AM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "06:32 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "06:40 AM",
// // //         "id": 162
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-8-214",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "ARUMUGAMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:45 AM",
// // //     "endTime": "08:05 AM",
// // //     "ids": [
// // //       162,
// // //       161,
// // //       160,
// // //       159,
// // //       290,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "06:45 AM",
// // //         "id": 162
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "06:52 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "06:55 AM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "07:01 AM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "07:01 AM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "07:08 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:16 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:21 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:32 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:37 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:39 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:51 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:59 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:04 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:05 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-9-215",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ARUMUGAMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 AM",
// // //     "endTime": "09:25 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       290,
// // //       159,
// // //       160,
// // //       161,
// // //       162
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:10 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:15 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:22 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:34 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:35 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:40 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "08:50 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "08:55 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:03 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "09:09 AM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "09:09 AM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "09:15 AM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "09:17 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "09:25 AM",
// // //         "id": 162
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-10-216",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "ARUMUGAMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:30 AM",
// // //     "endTime": "10:45 AM",
// // //     "ids": [
// // //       162,
// // //       161,
// // //       160,
// // //       159,
// // //       290,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "09:30 AM",
// // //         "id": 162
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "09:37 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "09:39 AM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "09:45 AM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "09:45 AM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:51 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "10:04 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:14 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:19 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:20 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:32 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:39 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:44 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-11-217",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ARUMUGAMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:50 AM",
// // //     "endTime": "12:05 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       290,
// // //       159,
// // //       160,
// // //       161,
// // //       162
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:50 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:55 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:02 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:14 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:15 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "11:20 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "11:30 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "11:35 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "11:43 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "11:49 AM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "11:49 AM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "11:55 AM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "11:57 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "12:05 PM",
// // //         "id": 162
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-B-12-218",
// // //     "routeNo": "54-B",
// // //     "code": "54/P54B-1",
// // //     "tripCode": "54/P54B-154-BTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ARUMUGAMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:10 PM",
// // //     "endTime": "01:40 PM",
// // //     "ids": [
// // //       162,
// // //       161,
// // //       160,
// // //       159,
// // //       290,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ARUMUGAMANGALAM",
// // //         "time": "12:10 PM",
// // //         "id": 162
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MARAMANGALAM",
// // //         "time": "12:18 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "IDAYARKADU",
// // //         "time": "12:21 PM",
// // //         "id": 160
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMBADI",
// // //         "time": "12:29 PM",
// // //         "id": 159
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "WATER TANK 2",
// // //         "time": "12:29 PM",
// // //         "id": 290
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "12:35 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:45 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "12:51 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:03 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:09 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:10 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:24 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "01:33 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "01:39 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-1-219",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-2",
// // //     "tripCode": "54/P54C-254-CTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHETTIKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 AM",
// // //     "endTime": "07:40 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163,
// // //       34,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       168
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:30 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:34 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:41 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:51 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:52 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:56 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "07:01 AM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "07:10 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:14 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:20 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "07:24 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:27 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:32 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:35 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:37 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIKULAM",
// // //         "time": "07:40 AM",
// // //         "id": 168
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-2-220",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-2",
// // //     "tripCode": "54/P54C-254-CTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "CHETTIKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:55 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       168,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       34,
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIKULAM",
// // //         "time": "07:55 AM",
// // //         "id": 168
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:57 AM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:59 AM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:02 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:07 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "08:10 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "08:14 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "08:20 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "08:24 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "08:33 AM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:38 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:42 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:43 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:53 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:00 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:04 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:05 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-3-221",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-1",
// // //     "tripCode": "54/P54C-154-CTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "VAGAIKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:20 AM",
// // //     "endTime": "10:50 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163,
// // //       34,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       165,
// // //       166,
// // //       167
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:20 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:24 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:31 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:41 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:42 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:47 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "09:52 AM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "10:00 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:04 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "10:10 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "10:14 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "10:18 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "10:22 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "10:28 AM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "KATTALANKULAM",
// // //         "time": "10:32 AM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "M. PUDHUR",
// // //         "time": "10:40 AM",
// // //         "id": 165
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "10:44 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "VAGAIKULAM",
// // //         "time": "10:50 AM",
// // //         "id": 167
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-4-222",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-1",
// // //     "tripCode": "54/P54C-154-CTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "VAGAIKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:05 AM",
// // //     "endTime": "12:30 PM",
// // //     "ids": [
// // //       167,
// // //       166,
// // //       165,
// // //       164,
// // //       291,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       34,
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "VAGAIKULAM",
// // //         "time": "11:05 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "11:09 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "M. PUDHUR",
// // //         "time": "11:13 AM",
// // //         "id": 165
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "KATTALANKULAM",
// // //         "time": "11:21 AM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "11:25 AM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "11:30 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "11:34 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "11:38 AM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "11:42 AM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "11:47 AM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "11:51 AM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "11:59 AM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "12:04 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "12:08 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "12:09 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "12:19 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "12:25 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "12:29 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-5-223",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-3",
// // //     "tripCode": "54/P54C-354-CTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KOOTTAMPULI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:45 PM",
// // //     "endTime": "01:55 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163,
// // //       34,
// // //       9
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "12:46 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "12:52 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:02 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:18 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:20 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:27 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "01:35 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "01:48 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "01:55 PM",
// // //         "id": 9
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-6-224",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-3",
// // //     "tripCode": "54/P54C-354-CTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KOOTTAMPULI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:00 PM",
// // //     "endTime": "03:10 PM",
// // //     "ids": [
// // //       9,
// // //       34,
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "02:00 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "02:06 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "02:19 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:27 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:34 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:36 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "02:52 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "03:02 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "03:08 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-7-225",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-2",
// // //     "tripCode": "54/P54C-254-CTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHETTIKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:15 PM",
// // //     "endTime": "04:30 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163,
// // //       34,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       168
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "03:15 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "03:20 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "03:27 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "03:37 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "03:38 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:43 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "03:49 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "03:58 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "04:02 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "04:08 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "04:13 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:17 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:21 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:25 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "04:27 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIKULAM",
// // //         "time": "04:30 PM",
// // //         "id": 168
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-8-226",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-2",
// // //     "tripCode": "54/P54C-254-CTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CHETTIKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:35 PM",
// // //     "endTime": "05:50 PM",
// // //     "ids": [
// // //       168,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       34,
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIKULAM",
// // //         "time": "04:35 PM",
// // //         "id": 168
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "04:37 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "04:39 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "04:43 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "04:47 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "04:51 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "04:56 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "05:02 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "05:06 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "05:15 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "05:21 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "05:26 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "05:27 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "05:37 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:44 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:49 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-9-227",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-2",
// // //     "tripCode": "54/P54C-254-CTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHETTIKULAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:55 PM",
// // //     "endTime": "07:10 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163,
// // //       34,
// // //       9,
// // //       10,
// // //       37,
// // //       12,
// // //       13,
// // //       40,
// // //       17,
// // //       168
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:55 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:00 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:07 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:17 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:18 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:23 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "06:29 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "06:38 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "06:42 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "06:48 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "06:53 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "06:57 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:01 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:05 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:07 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIKULAM",
// // //         "time": "07:10 PM",
// // //         "id": 168
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-10-228",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-2",
// // //     "tripCode": "54/P54C-254-CTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "CHETTIKULAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:25 PM",
// // //     "endTime": "08:40 PM",
// // //     "ids": [
// // //       168,
// // //       17,
// // //       40,
// // //       13,
// // //       12,
// // //       37,
// // //       10,
// // //       9,
// // //       34,
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIKULAM",
// // //         "time": "07:25 PM",
// // //         "id": 168
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "RAMASAMYPURAM BRIDGE",
// // //         "time": "07:27 PM",
// // //         "id": 17
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SUBRAMANIAPURAM 1",
// // //         "time": "07:29 PM",
// // //         "id": 40
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAWYERPURAM",
// // //         "time": "07:33 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "07:37 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SALAI",
// // //         "time": "07:41 PM",
// // //         "id": 37
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SERVAIKARANMADAM",
// // //         "time": "07:46 PM",
// // //         "id": 10
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "07:52 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "07:56 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "08:05 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:11 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:16 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:17 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:27 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:34 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:39 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-11-229",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-3",
// // //     "tripCode": "54/P54C-354-CTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KOOTTAMPULI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:55 PM",
// // //     "endTime": "09:55 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163,
// // //       34,
// // //       9
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:55 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:01 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:10 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:23 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:25 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:31 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "09:38 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "09:49 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "09:55 PM",
// // //         "id": 9
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-C-12-230",
// // //     "routeNo": "54-C",
// // //     "code": "54/P54C-3",
// // //     "tripCode": "54/P54C-354-CTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KOOTTAMPULI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:00 PM",
// // //     "endTime": "11:00 PM",
// // //     "ids": [
// // //       9,
// // //       34,
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "KOOTTAMPULI",
// // //         "time": "10:00 PM",
// // //         "id": 9
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KULAIYANKARISAL",
// // //         "time": "10:05 PM",
// // //         "id": 34
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "10:16 PM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:23 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:29 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:31 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:44 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:53 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:59 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-1-231",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-3",
// // //     "tripCode": "54/P54D-354-DTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SOUTH KOVANKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 AM",
// // //     "endTime": "07:05 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       157,
// // //       158
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:15 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:20 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:27 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:39 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:40 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:45 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:55 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "06:59 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "07:05 AM",
// // //         "id": 158
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-2-232",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-3",
// // //     "tripCode": "54/P54D-354-DTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "SOUTH KOVANKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       158,
// // //       157,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SOUTH KOVANKADU",
// // //         "time": "07:10 AM",
// // //         "id": 158
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KOVANKADU",
// // //         "time": "07:15 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:15 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:19 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:29 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:34 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:35 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:47 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:54 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:59 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-3-233",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 AM",
// // //     "endTime": "09:00 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       169,
// // //       170,
// // //       161,
// // //       171,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:05 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:05 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:08 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:12 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:19 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:20 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:23 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "08:29 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "08:32 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "08:37 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "08:39 AM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "08:42 AM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "08:46 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "08:49 AM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "08:53 AM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "09:00 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-4-234",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-2",
// // //     "tripCode": "54/P54D-254-DTORD18U4",
// // //     "order": 4,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "SIRUTHONDANALLUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:05 AM",
// // //     "endTime": "09:00 AM",
// // //     "ids": [
// // //       20,
// // //       19
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "09:05 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "09:00 AM",
// // //         "id": 19
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-5-235",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-2",
// // //     "tripCode": "54/P54D-254-DTORD18D5",
// // //     "order": 5,
// // //     "direction": "D",
// // //     "from": "SIRUTHONDANALLUR",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 AM",
// // //     "endTime": "09:10 AM",
// // //     "ids": [
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 2,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "09:15 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "09:10 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-6-236",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-2",
// // //     "tripCode": "54/P54D-254-DTORD18U6",
// // //     "order": 6,
// // //     "direction": "U",
// // //     "from": "ERAL",
// // //     "to": "SIRUTHONDANALLUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:05 AM",
// // //     "endTime": "09:10 AM",
// // //     "ids": [
// // //       20,
// // //       19
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "09:05 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "09:10 AM",
// // //         "id": 19
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-7-237",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-2",
// // //     "tripCode": "54/P54D-254-DTORD18D7",
// // //     "order": 7,
// // //     "direction": "D",
// // //     "from": "SIRUTHONDANALLUR",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 AM",
// // //     "endTime": "09:20 AM",
// // //     "ids": [
// // //       19,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 2,
// // //         "name": "SIRUTHONDANALLUR",
// // //         "time": "09:15 AM",
// // //         "id": 19
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "ERAL",
// // //         "time": "09:20 AM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-8-238",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 AM",
// // //     "endTime": "11:25 AM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       171,
// // //       161,
// // //       170,
// // //       169,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "09:50 AM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "10:00 AM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "10:07 AM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "10:13 AM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "10:19 AM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "10:24 AM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "10:29 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "10:37 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "10:42 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:53 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:58 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:59 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:11 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "11:19 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "11:24 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-9-239",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:30 AM",
// // //     "endTime": "12:50 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       169,
// // //       170,
// // //       161,
// // //       171,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "11:30 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "11:34 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:41 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:51 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:52 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "11:56 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "12:05 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:09 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "12:16 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "12:20 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "12:24 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "12:29 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "12:35 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "12:40 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "12:50 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-10-240",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:55 PM",
// // //     "endTime": "01:40 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       171,
// // //       161,
// // //       170,
// // //       169,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "12:55 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "01:00 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "01:03 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "01:06 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "01:09 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "01:11 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "01:13 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:17 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "01:19 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:24 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:27 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:27 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:33 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "01:37 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "01:39 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-11-241",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:30 PM",
// // //     "endTime": "03:40 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       169,
// // //       170,
// // //       161,
// // //       171,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "02:30 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "02:34 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "02:39 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:48 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:49 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:53 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "03:01 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:04 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "03:11 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "03:14 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "03:17 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "03:22 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "03:27 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "03:32 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "03:40 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-12-242",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:45 PM",
// // //     "endTime": "05:05 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       171,
// // //       161,
// // //       170,
// // //       169,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "03:45 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "03:54 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "03:59 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "04:05 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "04:10 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "04:14 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "04:18 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "04:25 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "04:29 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "04:38 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:42 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:43 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:53 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:00 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:04 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-13-243",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:10 PM",
// // //     "endTime": "06:40 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       169,
// // //       170,
// // //       161,
// // //       171,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:10 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:15 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "05:22 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "05:34 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "05:35 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "05:40 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "05:50 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "05:54 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "06:02 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "06:07 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "06:11 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "06:17 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "06:23 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "06:29 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "06:40 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-14-244",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:45 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       171,
// // //       161,
// // //       170,
// // //       169,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "06:45 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "06:56 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "07:04 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "07:11 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "07:18 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "07:23 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "07:28 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:37 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:43 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:54 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:00 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:01 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:15 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:23 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:29 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-15-245",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ERAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:20 PM",
// // //     "endTime": "09:50 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       169,
// // //       170,
// // //       161,
// // //       171,
// // //       54,
// // //       20
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:20 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:25 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:32 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:44 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:45 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:50 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:00 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:04 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:12 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "09:17 PM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "09:21 PM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "09:27 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "09:33 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "09:39 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "09:50 PM",
// // //         "id": 20
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-D-16-246",
// // //     "routeNo": "54-D",
// // //     "code": "54/P54D-1",
// // //     "tripCode": "54/P54D-154-DTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "ERAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:00 PM",
// // //     "endTime": "05:45 AM",
// // //     "ids": [
// // //       20,
// // //       54,
// // //       171,
// // //       161,
// // //       170,
// // //       169,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "ERAL",
// // //         "time": "10:00 PM",
// // //         "id": 20
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "WATER TANK 1",
// // //         "time": "10:52 PM",
// // //         "id": 54
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KORKAI",
// // //         "time": "11:26 PM",
// // //         "id": 171
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MARAMANGALAM",
// // //         "time": "11:56 PM",
// // //         "id": 161
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGARAM",
// // //         "time": "12:26 AM",
// // //         "id": 170
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "AGARAM BRIDGE",
// // //         "time": "12:50 AM",
// // //         "id": 169
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "01:12 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:54 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "02:17 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:09 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "03:34 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "03:40 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:39 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:16 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:41 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-1-247",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUNNAKAYAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:15 PM",
// // //     "endTime": "02:30 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       173,
// // //       174,
// // //       175
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "01:15 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "01:19 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:25 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:34 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "01:35 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "01:39 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "01:47 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:51 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "01:58 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "02:05 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "02:10 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "02:14 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "02:21 PM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "02:25 PM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "02:30 PM",
// // //         "id": 175
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-2-248",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "PUNNAKAYAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:35 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       175,
// // //       174,
// // //       173,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "02:35 PM",
// // //         "id": 175
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "02:40 PM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "02:45 PM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "02:52 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "02:56 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "03:02 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "03:11 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:18 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "03:22 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "03:32 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "03:36 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "03:37 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "03:48 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "03:54 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "03:59 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-3-249",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUNNAKAYAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:05 PM",
// // //     "endTime": "05:20 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       173,
// // //       174,
// // //       175
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:05 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:09 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:15 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:24 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:25 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "04:29 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "04:37 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "04:41 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "04:48 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "04:55 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "05:00 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "05:04 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "05:11 PM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "05:15 PM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "05:20 PM",
// // //         "id": 175
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-4-250",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "PUNNAKAYAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:25 PM",
// // //     "endTime": "06:40 PM",
// // //     "ids": [
// // //       175,
// // //       174,
// // //       173,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "05:25 PM",
// // //         "id": 175
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "05:29 PM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "05:33 PM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "05:40 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "05:44 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "05:49 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "05:56 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:03 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:07 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:15 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:19 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:20 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:29 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:35 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:39 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-5-251",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-2",
// // //     "tripCode": "54/P54F-254-FTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ATTHIMARAPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:45 PM",
// // //     "endTime": "07:20 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       176,
// // //       177
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:45 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:51 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:59 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:11 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "07:12 PM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "07:20 PM",
// // //         "id": 177
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-6-252",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-2",
// // //     "tripCode": "54/P54F-254-FTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ATTHIMARAPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 PM",
// // //     "endTime": "10:00 PM",
// // //     "ids": [
// // //       177,
// // //       176,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "07:30 PM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "08:03 PM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:05 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:59 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:33 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:56 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-7-253",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUNNAKAYAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:15 PM",
// // //     "endTime": "05:40 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       173,
// // //       174,
// // //       175
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:18 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:41 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:16 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "12:11 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "12:16 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "12:40 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "01:29 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "01:51 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "02:30 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "03:14 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "03:45 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "04:08 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "04:47 AM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "05:12 AM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "05:40 AM",
// // //         "id": 175
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-8-254",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PUNNAKAYAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 AM",
// // //     "endTime": "07:25 AM",
// // //     "ids": [
// // //       175,
// // //       174,
// // //       173,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "05:45 AM",
// // //         "id": 175
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "05:51 AM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "05:56 AM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "06:05 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "06:10 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "06:17 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "06:27 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:36 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:41 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:52 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:57 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:58 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:11 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:18 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:24 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-9-255",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUNNAKAYAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 AM",
// // //     "endTime": "08:40 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       173,
// // //       174,
// // //       175
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:30 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:34 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:39 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:48 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:49 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:52 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "08:00 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "08:03 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "08:10 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "08:17 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "08:22 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "08:25 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "08:31 AM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "08:35 AM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "08:40 AM",
// // //         "id": 175
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-10-256",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "PUNNAKAYAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:50 AM",
// // //     "endTime": "10:25 AM",
// // //     "ids": [
// // //       175,
// // //       174,
// // //       173,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "08:50 AM",
// // //         "id": 175
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "08:55 AM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "09:01 AM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "09:09 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "09:14 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "09:21 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:30 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:38 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:43 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:53 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:58 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:00 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:11 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:19 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:24 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-11-257",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUNNAKAYAL",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 AM",
// // //     "endTime": "11:40 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       173,
// // //       174,
// // //       175
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:30 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:34 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:39 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:48 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:49 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:52 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "11:00 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "11:03 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "11:10 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "11:17 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "11:22 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "11:25 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "11:31 AM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "11:35 AM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "11:40 AM",
// // //         "id": 175
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-F-12-258",
// // //     "routeNo": "54-F",
// // //     "code": "54/P54F-1",
// // //     "tripCode": "54/P54F-154-FTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "PUNNAKAYAL",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:45 AM",
// // //     "endTime": "01:10 PM",
// // //     "ids": [
// // //       175,
// // //       174,
// // //       173,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PUNNAKAYAL",
// // //         "time": "11:45 AM",
// // //         "id": 175
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DCW COLONY",
// // //         "time": "11:50 AM",
// // //         "id": 174
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHERNTHAMARAM",
// // //         "time": "11:55 AM",
// // //         "id": 173
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "12:02 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "12:06 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "12:12 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "12:21 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:28 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "12:32 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "12:42 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "12:46 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "12:47 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "12:58 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "01:04 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "01:09 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-1-259",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-5",
// // //     "tripCode": "54/P54G-554-GTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KOLLAMPARAMBU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 AM",
// // //     "endTime": "06:25 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       152,
// // //       289,
// // //       154
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:46 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:48 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:51 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:52 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:55 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "05:57 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "06:01 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "06:06 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "06:09 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "06:12 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 1",
// // //         "time": "06:18 AM",
// // //         "id": 152
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHANDRAGIRI",
// // //         "time": "06:19 AM",
// // //         "id": 289
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KOLLAMPARAMBU",
// // //         "time": "06:25 AM",
// // //         "id": 154
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-2-260",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-6",
// // //     "tripCode": "54/P54G-654-GTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KOLLAMPARAMBU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 AM",
// // //     "endTime": "07:20 AM",
// // //     "ids": [
// // //       154,
// // //       289,
// // //       152,
// // //       100,
// // //       281,
// // //       99,
// // //       143,
// // //       292,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "KOLLAMPARAMBU",
// // //         "time": "06:30 AM",
// // //         "id": 154
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CHANDRAGIRI",
// // //         "time": "06:36 AM",
// // //         "id": 289
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHANDRAGIRI JUNCTION 1",
// // //         "time": "06:37 AM",
// // //         "id": 152
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "06:44 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "06:47 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "06:51 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "ARASADI 1",
// // //         "time": "07:00 AM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 2",
// // //         "time": "07:03 AM",
// // //         "id": 292
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "07:05 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:07 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:11 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:12 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:16 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:17 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-3-261",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-2",
// // //     "tripCode": "54/P54G-254-GTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MULLAKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 AM",
// // //     "endTime": "08:10 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:31 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:37 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:46 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:01 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:03 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:10 AM",
// // //         "id": 46
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-4-262",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-3",
// // //     "tripCode": "54/P54G-354-GTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "MULLAKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:15 AM",
// // //     "ids": [
// // //       46,
// // //       45,
// // //       184,
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 12,
// // //         "name": "MULLAKADU",
// // //         "time": "08:15 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:20 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "BULK",
// // //         "time": "08:22 AM",
// // //         "id": 184
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "08:37 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:39 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:44 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:51 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:54 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:01 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:09 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:14 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:15 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-5-263",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:20 AM",
// // //     "endTime": "09:50 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:24 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:28 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:34 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "09:37 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:40 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:45 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:48 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "09:50 AM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-6-264",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:00 AM",
// // //     "endTime": "10:40 AM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "10:00 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:02 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:06 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:13 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:16 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:20 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "10:28 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:33 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-7-265",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-1",
// // //     "tripCode": "54/P54G-154-GTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PON NAGAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:45 AM",
// // //     "endTime": "11:10 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       176,
// // //       177,
// // //       178
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:45 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:49 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:54 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:02 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "11:02 AM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "11:07 AM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PON NAGAR",
// // //         "time": "11:10 AM",
// // //         "id": 178
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-8-266",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-1",
// // //     "tripCode": "54/P54G-154-GTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PON NAGAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:20 AM",
// // //     "endTime": "11:40 AM",
// // //     "ids": [
// // //       178,
// // //       177,
// // //       176,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 8,
// // //         "name": "PON NAGAR",
// // //         "time": "11:20 AM",
// // //         "id": 178
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "11:21 AM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "11:25 AM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:25 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:32 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "11:36 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "11:39 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-9-267",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-8",
// // //     "tripCode": "54/P54G-854-GTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "VELLAPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:50 AM",
// // //     "endTime": "12:20 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       187
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:50 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "11:54 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:58 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "12:05 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "12:08 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "12:09 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "12:15 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VELLAPATTI",
// // //         "time": "12:20 PM",
// // //         "id": 187
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-10-268",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-8",
// // //     "tripCode": "54/P54G-854-GTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "VELLAPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:30 PM",
// // //     "endTime": "01:25 PM",
// // //     "ids": [
// // //       187,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 8,
// // //         "name": "VELLAPATTI",
// // //         "time": "12:30 PM",
// // //         "id": 187
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "12:37 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "12:48 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "12:51 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "12:56 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:09 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "01:16 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:25 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-11-269",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-1",
// // //     "tripCode": "54/P54G-154-GTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PON NAGAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:30 PM",
// // //     "endTime": "02:00 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       176,
// // //       177,
// // //       178
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "01:30 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "01:34 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "01:41 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "01:51 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "01:51 PM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "01:57 PM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PON NAGAR",
// // //         "time": "02:00 PM",
// // //         "id": 178
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-12-270",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-1",
// // //     "tripCode": "54/P54G-154-GTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "PON NAGAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:05 PM",
// // //     "endTime": "02:35 PM",
// // //     "ids": [
// // //       178,
// // //       177,
// // //       176,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 8,
// // //         "name": "PON NAGAR",
// // //         "time": "02:05 PM",
// // //         "id": 178
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "02:07 PM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "02:13 PM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:13 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "02:23 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "02:30 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "02:34 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-13-271",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:40 PM",
// // //     "endTime": "03:25 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "02:47 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "02:53 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "03:01 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "03:06 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "03:10 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "03:17 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "03:22 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "03:25 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-14-272",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:30 PM",
// // //     "endTime": "04:05 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "03:30 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "03:32 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "03:35 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "03:41 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "03:44 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "03:47 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "03:54 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "03:59 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-15-273",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-1",
// // //     "tripCode": "54/P54G-154-GTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PON NAGAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:15 PM",
// // //     "endTime": "04:55 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       176,
// // //       177,
// // //       178
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:15 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:21 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:29 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:43 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "04:43 PM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "04:51 PM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "PON NAGAR",
// // //         "time": "04:55 PM",
// // //         "id": 178
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-16-274",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-7",
// // //     "tripCode": "54/P54G-754-GTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "PON NAGAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 PM",
// // //     "endTime": "07:10 PM",
// // //     "ids": [
// // //       178,
// // //       177,
// // //       176,
// // //       44,
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "PON NAGAR",
// // //         "time": "05:00 PM",
// // //         "id": 178
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "05:05 PM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "05:19 PM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "05:19 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "05:48 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "05:53 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:01 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:15 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:21 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:30 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "06:46 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "06:57 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-17-275",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18U17",
// // //     "order": 17,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 PM",
// // //     "endTime": "07:55 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:25 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "07:30 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "07:37 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "07:40 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "07:43 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "07:49 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "07:52 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "07:55 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-18-276",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "08:00 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:01 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:04 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:09 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:12 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:15 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:21 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:25 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-19-277",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18U19",
// // //     "order": 19,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:40 PM",
// // //     "endTime": "09:05 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:43 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:47 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:52 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:54 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:56 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:01 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:03 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "09:05 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "54-G-20-278",
// // //     "routeNo": "54-G",
// // //     "code": "54/P54G-4",
// // //     "tripCode": "54/P54G-454-GTORD18D20",
// // //     "order": 20,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 PM",
// // //     "endTime": "10:00 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "09:10 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:12 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:17 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:26 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "09:30 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:35 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:45 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:52 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-1-279",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-3",
// // //     "tripCode": "55/P55A-355-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "GOVERNORGIRI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:30 PM",
// // //     "endTime": "01:35 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       191,
// // //       192,
// // //       193,
// // //       194,
// // //       195
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "12:32 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "12:34 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "12:38 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "12:40 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "12:45 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "12:47 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "12:52 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "12:59 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "01:03 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "01:07 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "01:12 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "01:17 PM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "01:24 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VELLARAM",
// // //         "time": "01:30 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "01:35 PM",
// // //         "id": 195
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-2-280",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-3",
// // //     "tripCode": "55/P55A-355-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "GOVERNORGIRI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:40 PM",
// // //     "endTime": "02:45 PM",
// // //     "ids": [
// // //       195,
// // //       194,
// // //       193,
// // //       192,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "01:40 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VELLARAM",
// // //         "time": "01:44 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "01:50 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "01:57 PM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "02:02 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "02:07 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "02:11 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "02:15 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "02:22 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "02:27 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:29 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:34 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:36 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:40 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:42 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-3-281",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-6",
// // //     "tripCode": "55/P55A-655-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "04:05 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       101,
// // //       188,
// // //       189,
// // //       190,
// // //       76
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:04 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:09 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:10 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:16 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "03:19 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "03:24 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "03:31 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "03:36 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "03:40 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "03:44 PM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "03:49 PM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "03:52 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "03:57 PM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "04:05 PM",
// // //         "id": 76
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-4-282",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-6",
// // //     "tripCode": "55/P55A-655-ATORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:10 PM",
// // //     "endTime": "05:20 PM",
// // //     "ids": [
// // //       76,
// // //       190,
// // //       189,
// // //       188,
// // //       101,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "04:10 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "04:17 PM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "04:23 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "04:26 PM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "04:32 PM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "04:35 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "04:40 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "04:46 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "04:53 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "04:59 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:02 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:08 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:09 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:14 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:16 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-5-283",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-2",
// // //     "tripCode": "55/P55A-255-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM TALUK OFFICE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:25 PM",
// // //     "endTime": "06:25 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       101,
// // //       188,
// // //       189,
// // //       190,
// // //       76,
// // //       109
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:25 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:27 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:29 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:33 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:34 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:39 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "05:42 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "05:47 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "05:53 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "05:58 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "06:02 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "06:05 PM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "06:10 PM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "06:12 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "06:17 PM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:24 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OTTAPIDARAM TALUK OFFICE",
// // //         "time": "06:25 PM",
// // //         "id": 109
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-6-284",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-2",
// // //     "tripCode": "55/P55A-255-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM TALUK OFFICE",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 PM",
// // //     "endTime": "07:30 PM",
// // //     "ids": [
// // //       109,
// // //       76,
// // //       190,
// // //       189,
// // //       188,
// // //       101,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "OTTAPIDARAM TALUK OFFICE",
// // //         "time": "06:30 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:30 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "06:37 PM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "06:42 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "06:44 PM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "06:49 PM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "06:52 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "06:56 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "07:01 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "07:07 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "07:12 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:15 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:20 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:21 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:25 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:27 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-7-285",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-3",
// // //     "tripCode": "55/P55A-355-ATORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "GOVERNORGIRI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:45 PM",
// // //     "endTime": "08:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       191,
// // //       192,
// // //       193,
// // //       194,
// // //       195
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:47 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:49 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:54 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:55 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:01 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "08:03 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "08:09 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "08:16 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "08:21 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "08:25 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "08:31 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "08:35 PM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "08:43 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VELLARAM",
// // //         "time": "08:50 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "08:55 PM",
// // //         "id": 195
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-8-286",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-3",
// // //     "tripCode": "55/P55A-355-ATORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "GOVERNORGIRI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:00 PM",
// // //     "endTime": "10:05 PM",
// // //     "ids": [
// // //       195,
// // //       194,
// // //       193,
// // //       192,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "09:00 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VELLARAM",
// // //         "time": "09:04 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "09:10 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "09:17 PM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "09:22 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "09:27 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "09:31 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "09:35 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "09:42 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "09:47 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:49 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:54 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:56 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "10:00 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-9-287",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-4",
// // //     "tripCode": "55/P55A-455-ATORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:00 PM",
// // //     "endTime": "12:15 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:01 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:03 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:05 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:06 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:09 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:12 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:15 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "11:19 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "11:23 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "11:26 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "11:42 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "11:59 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:03 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:04 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "12:12 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "12:15 AM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-10-288",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-5",
// // //     "tripCode": "55/P55A-555-ATORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 AM",
// // //     "endTime": "06:25 AM",
// // //     "ids": [
// // //       193,
// // //       192,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "05:30 AM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "05:37 AM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "05:41 AM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "05:46 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "05:50 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "05:55 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "06:02 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "06:07 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:09 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:14 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:16 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:20 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:22 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-11-289",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-6",
// // //     "tripCode": "55/P55A-655-ATORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       101,
// // //       188,
// // //       189,
// // //       190,
// // //       76
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:53 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:55 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:00 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:01 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:07 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "07:10 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "07:16 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "07:23 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "07:29 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "07:34 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "07:37 AM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "07:43 AM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "07:46 AM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "07:52 AM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:00 AM",
// // //         "id": 76
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-12-290",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-6",
// // //     "tripCode": "55/P55A-655-ATORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 AM",
// // //     "endTime": "09:20 AM",
// // //     "ids": [
// // //       76,
// // //       190,
// // //       189,
// // //       188,
// // //       101,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:05 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "08:13 AM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "08:19 AM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "08:22 AM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "08:29 AM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "08:32 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "08:37 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "08:43 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "08:51 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "08:58 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:01 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:07 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:09 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:14 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:16 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-13-291",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-2",
// // //     "tripCode": "55/P55A-255-ATORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM TALUK OFFICE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "10:30 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       101,
// // //       188,
// // //       189,
// // //       190,
// // //       76,
// // //       109
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:37 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:39 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:42 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:44 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:48 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "09:50 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "09:55 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "10:01 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "10:05 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "10:09 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "10:11 AM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "10:16 AM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "10:18 AM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "10:23 AM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:29 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OTTAPIDARAM TALUK OFFICE",
// // //         "time": "10:30 AM",
// // //         "id": 109
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-A-14-292",
// // //     "routeNo": "55-A",
// // //     "code": "55/P55A-2",
// // //     "tripCode": "55/P55A-255-ATORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM TALUK OFFICE",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:35 AM",
// // //     "endTime": "11:40 AM",
// // //     "ids": [
// // //       109,
// // //       76,
// // //       190,
// // //       189,
// // //       188,
// // //       101,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "OTTAPIDARAM TALUK OFFICE",
// // //         "time": "10:35 AM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:35 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "10:43 AM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "10:48 AM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KAKKARAMPATTI",
// // //         "time": "10:50 AM",
// // //         "id": 188
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM 1",
// // //         "time": "10:56 AM",
// // //         "id": 101
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "10:59 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "11:03 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "11:08 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "11:15 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "11:21 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:23 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:29 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:30 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:35 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:37 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-1-293",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-3",
// // //     "tripCode": "55/P55B-355-BTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MILAGU NATTHAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:40 PM",
// // //     "endTime": "01:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       191,
// // //       295,
// // //       200,
// // //       201,
// // //       202,
// // //       203,
// // //       204,
// // //       205,
// // //       206,
// // //       207
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "12:42 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "12:44 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "12:47 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "12:49 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "12:53 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "12:56 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "01:00 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "01:06 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "01:10 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "01:14 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "01:18 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 2",
// // //         "time": "01:23 PM",
// // //         "id": 295
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MELA SEITHALAI",
// // //         "time": "01:27 PM",
// // //         "id": 200
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "JEGAVEERAPANDIAPURAM",
// // //         "time": "01:30 PM",
// // //         "id": 201
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THANNEER MADAM",
// // //         "time": "01:37 PM",
// // //         "id": 202
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KAYATHAR JUNCTION",
// // //         "time": "01:38 PM",
// // //         "id": 203
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "EPPODHUMVENDRAN",
// // //         "time": "01:40 PM",
// // //         "id": 204
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KATTUNAICKENPATTI",
// // //         "time": "01:44 PM",
// // //         "id": 205
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ADHANOOR",
// // //         "time": "01:50 PM",
// // //         "id": 206
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "MILAGU NATTHAM",
// // //         "time": "01:55 PM",
// // //         "id": 207
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-2-294",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-3",
// // //     "tripCode": "55/P55B-355-BTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "MILAGU NATTHAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:00 PM",
// // //     "endTime": "03:10 PM",
// // //     "ids": [
// // //       207,
// // //       206,
// // //       205,
// // //       204,
// // //       203,
// // //       202,
// // //       201,
// // //       200,
// // //       295,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "MILAGU NATTHAM",
// // //         "time": "02:00 PM",
// // //         "id": 207
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ADHANOOR",
// // //         "time": "02:04 PM",
// // //         "id": 206
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KATTUNAICKENPATTI",
// // //         "time": "02:09 PM",
// // //         "id": 205
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "EPPODHUMVENDRAN",
// // //         "time": "02:13 PM",
// // //         "id": 204
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KAYATHAR JUNCTION",
// // //         "time": "02:15 PM",
// // //         "id": 203
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THANNEER MADAM",
// // //         "time": "02:16 PM",
// // //         "id": 202
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "JEGAVEERAPANDIAPURAM",
// // //         "time": "02:23 PM",
// // //         "id": 201
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MELA SEITHALAI",
// // //         "time": "02:25 PM",
// // //         "id": 200
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 2",
// // //         "time": "02:29 PM",
// // //         "id": 295
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "02:33 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "02:37 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "02:41 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "02:45 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "02:50 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "02:55 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:57 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:01 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:02 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:06 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:07 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-3-295",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-1",
// // //     "tripCode": "55/P55B-155-BTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:15 PM",
// // //     "endTime": "04:30 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "03:20 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:24 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "03:27 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "03:31 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "03:36 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "03:39 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "03:46 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "03:50 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "03:58 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "04:02 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:07 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "04:10 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "04:13 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "04:20 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "04:26 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "04:30 PM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-4-296",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-1",
// // //     "tripCode": "55/P55B-155-BTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:35 PM",
// // //     "endTime": "05:50 PM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       84,
// // //       83,
// // //       82,
// // //       81,
// // //       225,
// // //       79,
// // //       78,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "04:35 PM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "04:38 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "04:44 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "04:51 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "04:54 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:57 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:02 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "05:06 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "05:14 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "05:18 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "05:25 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "05:28 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "05:33 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "05:37 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:40 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:44 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-5-297",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-2",
// // //     "tripCode": "55/P55B-255-BTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MILAGU NATTHAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:00 PM",
// // //     "endTime": "07:10 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       191,
// // //       295,
// // //       200,
// // //       156,
// // //       201,
// // //       202,
// // //       203,
// // //       204,
// // //       205,
// // //       206,
// // //       207
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:01 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:03 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:06 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:07 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:11 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "06:13 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "06:17 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "06:22 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "06:25 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "06:28 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "06:32 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 2",
// // //         "time": "06:36 PM",
// // //         "id": 295
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MELA SEITHALAI",
// // //         "time": "06:40 PM",
// // //         "id": 200
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KEELA SEITHALAI",
// // //         "time": "06:43 PM",
// // //         "id": 156
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "JEGAVEERAPANDIAPURAM",
// // //         "time": "06:49 PM",
// // //         "id": 201
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "THANNEER MADAM",
// // //         "time": "06:55 PM",
// // //         "id": 202
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KAYATHAR JUNCTION",
// // //         "time": "06:56 PM",
// // //         "id": 203
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "EPPODHUMVENDRAN",
// // //         "time": "06:57 PM",
// // //         "id": 204
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "KATTUNAICKENPATTI",
// // //         "time": "07:01 PM",
// // //         "id": 205
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "ADHANOOR",
// // //         "time": "07:05 PM",
// // //         "id": 206
// // //       },
// // //       {
// // //         "no": 22,
// // //         "name": "MILAGU NATTHAM",
// // //         "time": "07:10 PM",
// // //         "id": 207
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-6-298",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-3",
// // //     "tripCode": "55/P55B-355-BTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "MILAGU NATTHAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       207,
// // //       206,
// // //       205,
// // //       204,
// // //       203,
// // //       202,
// // //       201,
// // //       200,
// // //       295,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "MILAGU NATTHAM",
// // //         "time": "07:15 PM",
// // //         "id": 207
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ADHANOOR",
// // //         "time": "07:19 PM",
// // //         "id": 206
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KATTUNAICKENPATTI",
// // //         "time": "07:25 PM",
// // //         "id": 205
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "EPPODHUMVENDRAN",
// // //         "time": "07:29 PM",
// // //         "id": 204
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KAYATHAR JUNCTION",
// // //         "time": "07:31 PM",
// // //         "id": 203
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THANNEER MADAM",
// // //         "time": "07:32 PM",
// // //         "id": 202
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "JEGAVEERAPANDIAPURAM",
// // //         "time": "07:39 PM",
// // //         "id": 201
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MELA SEITHALAI",
// // //         "time": "07:42 PM",
// // //         "id": 200
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 2",
// // //         "time": "07:46 PM",
// // //         "id": 295
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "07:51 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "07:55 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "07:59 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "08:03 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "08:09 PM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "08:13 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:16 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:20 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:22 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:25 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:27 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-7-299",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-1",
// // //     "tripCode": "55/P55B-155-BTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:00 PM",
// // //     "endTime": "11:15 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "10:05 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:09 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "10:12 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "10:16 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "10:21 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "10:24 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "10:31 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "10:35 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "10:43 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:47 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:52 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "10:55 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "10:58 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "11:05 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "11:11 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "11:15 PM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-8-300",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-1",
// // //     "tripCode": "55/P55B-155-BTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 AM",
// // //     "endTime": "06:15 AM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       84,
// // //       83,
// // //       82,
// // //       81,
// // //       225,
// // //       79,
// // //       78,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "05:00 AM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "05:03 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "05:09 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "05:16 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "05:19 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:22 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:27 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "05:31 AM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "05:39 AM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "05:43 AM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "05:50 AM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "05:53 AM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "05:58 AM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "06:02 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:05 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:09 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-9-301",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-3",
// // //     "tripCode": "55/P55B-355-BTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MILAGU NATTHAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:45 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       98,
// // //       99,
// // //       281,
// // //       100,
// // //       191,
// // //       295,
// // //       200,
// // //       201,
// // //       202,
// // //       203,
// // //       204,
// // //       205,
// // //       206,
// // //       207
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:47 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:49 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:52 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:54 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:58 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "07:01 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "07:05 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "07:11 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "07:15 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "07:19 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "07:23 AM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 2",
// // //         "time": "07:28 AM",
// // //         "id": 295
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MELA SEITHALAI",
// // //         "time": "07:32 AM",
// // //         "id": 200
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "JEGAVEERAPANDIAPURAM",
// // //         "time": "07:35 AM",
// // //         "id": 201
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THANNEER MADAM",
// // //         "time": "07:42 AM",
// // //         "id": 202
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KAYATHAR JUNCTION",
// // //         "time": "07:43 AM",
// // //         "id": 203
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "EPPODHUMVENDRAN",
// // //         "time": "07:45 AM",
// // //         "id": 204
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KATTUNAICKENPATTI",
// // //         "time": "07:49 AM",
// // //         "id": 205
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "ADHANOOR",
// // //         "time": "07:55 AM",
// // //         "id": 206
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "MILAGU NATTHAM",
// // //         "time": "08:00 AM",
// // //         "id": 207
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-10-302",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-2",
// // //     "tripCode": "55/P55B-255-BTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "MILAGU NATTHAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:25 AM",
// // //     "ids": [
// // //       207,
// // //       206,
// // //       205,
// // //       204,
// // //       203,
// // //       202,
// // //       201,
// // //       156,
// // //       200,
// // //       295,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       98,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 22,
// // //         "name": "MILAGU NATTHAM",
// // //         "time": "08:15 AM",
// // //         "id": 207
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "ADHANOOR",
// // //         "time": "08:19 AM",
// // //         "id": 206
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "KATTUNAICKENPATTI",
// // //         "time": "08:23 AM",
// // //         "id": 205
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "EPPODHUMVENDRAN",
// // //         "time": "08:27 AM",
// // //         "id": 204
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KAYATHAR JUNCTION",
// // //         "time": "08:28 AM",
// // //         "id": 203
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "THANNEER MADAM",
// // //         "time": "08:29 AM",
// // //         "id": 202
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "JEGAVEERAPANDIAPURAM",
// // //         "time": "08:35 AM",
// // //         "id": 201
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KEELA SEITHALAI",
// // //         "time": "08:41 AM",
// // //         "id": 156
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MELA SEITHALAI",
// // //         "time": "08:44 AM",
// // //         "id": 200
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHANDRAGIRI JUNCTION 2",
// // //         "time": "08:48 AM",
// // //         "id": 295
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "08:52 AM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "08:56 AM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "08:59 AM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "09:02 AM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 1",
// // //         "time": "09:07 AM",
// // //         "id": 98
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "09:11 AM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:13 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:17 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:18 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:21 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:23 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-11-303",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-1",
// // //     "tripCode": "55/P55B-155-BTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:30 AM",
// // //     "endTime": "10:45 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:35 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:39 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "09:42 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "09:46 AM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "09:51 AM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "09:54 AM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "10:01 AM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "10:05 AM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "10:13 AM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:17 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:22 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "10:25 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "10:28 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "10:35 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "10:41 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "10:45 AM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-B-12-304",
// // //     "routeNo": "55-B",
// // //     "code": "55/P55B-1",
// // //     "tripCode": "55/P55B-155-BTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:50 AM",
// // //     "endTime": "12:05 PM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       84,
// // //       83,
// // //       82,
// // //       81,
// // //       225,
// // //       79,
// // //       78,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "10:50 AM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "10:53 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "10:59 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "11:06 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "11:09 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "11:12 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "11:17 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "11:21 AM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "11:29 AM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "11:33 AM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "11:40 AM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "11:43 AM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "11:48 AM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "11:52 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:55 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "11:59 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-1-305",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-1",
// // //     "tripCode": "55/P55C-155-CTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:10 PM",
// // //     "endTime": "01:30 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "12:15 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:19 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "12:23 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "12:27 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "12:33 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "12:36 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "12:43 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "12:48 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "12:56 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:00 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:06 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "01:09 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "01:12 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "01:19 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "01:25 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "01:30 PM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-2-306",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-1",
// // //     "tripCode": "55/P55C-155-CTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:40 PM",
// // //     "endTime": "02:45 PM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       84,
// // //       83,
// // //       82,
// // //       81,
// // //       225,
// // //       79,
// // //       78,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "01:40 PM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "01:43 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "01:48 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "01:54 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "01:56 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:59 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:03 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "02:06 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "02:13 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "02:17 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "02:23 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "02:26 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "02:30 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "02:34 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:37 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "02:40 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-3-307",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-2",
// // //     "tripCode": "55/P55C-255-CTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SANGAMPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:50 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       106,
// // //       208,
// // //       209
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:52 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:53 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:57 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:58 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:02 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:06 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "03:10 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "03:15 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "03:20 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "03:24 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "03:25 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "03:31 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:33 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "TALUK OFFICE",
// // //         "time": "03:34 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "03:36 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "03:43 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "03:45 PM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "MURAMBAN",
// // //         "time": "03:55 PM",
// // //         "id": 208
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "SANGAMPATTI",
// // //         "time": "04:00 PM",
// // //         "id": 209
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-4-308",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-2",
// // //     "tripCode": "55/P55C-255-CTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SANGAMPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:05 PM",
// // //     "endTime": "05:35 PM",
// // //     "ids": [
// // //       209,
// // //       208,
// // //       106,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "SANGAMPATTI",
// // //         "time": "04:05 PM",
// // //         "id": 209
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "MURAMBAN",
// // //         "time": "04:10 PM",
// // //         "id": 208
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "04:23 PM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "04:26 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "04:35 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "TALUK OFFICE",
// // //         "time": "04:38 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "04:39 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "04:41 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "04:48 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:51 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "04:55 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "05:02 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "05:09 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "05:14 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:18 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:23 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:25 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:29 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:32 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-5-309",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-1",
// // //     "tripCode": "55/P55C-155-CTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 PM",
// // //     "endTime": "06:55 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:49 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:53 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "05:56 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "06:00 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "06:05 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "06:08 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "06:14 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "06:18 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "06:25 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:29 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "06:34 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "06:36 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "06:39 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "06:46 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "06:51 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "06:55 PM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-6-310",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-1",
// // //     "tripCode": "55/P55C-155-CTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 PM",
// // //     "endTime": "08:15 PM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       84,
// // //       83,
// // //       82,
// // //       81,
// // //       225,
// // //       79,
// // //       78,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "07:00 PM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "07:03 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "07:09 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "07:16 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "07:19 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:22 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:27 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "07:31 PM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "07:39 PM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "07:43 PM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "07:50 PM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "07:53 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "07:58 PM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "08:02 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:05 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:09 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-7-311",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-3",
// // //     "tripCode": "55/P55C-355-CTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "VELLARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 PM",
// // //     "endTime": "10:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:42 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:45 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:49 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:51 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:57 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:01 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:06 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:13 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:20 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:25 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:27 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:34 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:37 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "10:50 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VELLARAM",
// // //         "time": "10:55 PM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-8-312",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-3",
// // //     "tripCode": "55/P55C-355-CTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "VELLARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:30 AM",
// // //     "endTime": "05:40 AM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "VELLARAM",
// // //         "time": "04:30 AM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "04:34 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "04:46 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "04:49 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "04:55 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:57 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:02 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "05:08 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "05:15 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "05:19 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:24 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:29 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:30 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:35 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:37 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-9-313",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-1",
// // //     "tripCode": "55/P55C-155-CTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:20 AM",
// // //     "endTime": "07:35 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       78,
// // //       79,
// // //       225,
// // //       81,
// // //       82,
// // //       83,
// // //       84,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:25 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:29 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "06:32 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "06:36 AM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "06:41 AM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "06:44 AM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "06:51 AM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "06:55 AM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "07:03 AM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:07 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:12 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "07:15 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "07:18 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "07:25 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "07:31 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "07:35 AM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-10-314",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-1",
// // //     "tripCode": "55/P55C-155-CTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 AM",
// // //     "endTime": "09:10 AM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       84,
// // //       83,
// // //       82,
// // //       81,
// // //       225,
// // //       79,
// // //       78,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "07:50 AM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "07:54 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.PUTHUR",
// // //         "time": "08:00 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "08:07 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "08:10 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:13 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:19 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SAMYNATTHAM",
// // //         "time": "08:23 AM",
// // //         "id": 84
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KAYALOORANI",
// // //         "time": "08:31 AM",
// // //         "id": 83
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VEERAPANDIAPURAM",
// // //         "time": "08:36 AM",
// // //         "id": 82
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "RAILWAY GATE",
// // //         "time": "08:43 AM",
// // //         "id": 81
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "08:46 AM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR",
// // //         "time": "08:52 AM",
// // //         "id": 79
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "08:56 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:00 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:04 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-11-315",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-2",
// // //     "tripCode": "55/P55C-255-CTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SANGAMPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:20 AM",
// // //     "endTime": "10:40 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       106,
// // //       208,
// // //       209
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:22 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:24 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:28 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:29 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:34 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:38 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:43 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:48 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:54 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:58 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:01 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:07 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:09 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "TALUK OFFICE",
// // //         "time": "10:10 AM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "10:12 AM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "10:21 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "10:23 AM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "MURAMBAN",
// // //         "time": "10:34 AM",
// // //         "id": 208
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "SANGAMPATTI",
// // //         "time": "10:40 AM",
// // //         "id": 209
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-C-12-316",
// // //     "routeNo": "55-C",
// // //     "code": "55/P55C-2",
// // //     "tripCode": "55/P55C-255-CTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "SANGAMPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:45 AM",
// // //     "endTime": "11:55 AM",
// // //     "ids": [
// // //       209,
// // //       208,
// // //       106,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "SANGAMPATTI",
// // //         "time": "10:45 AM",
// // //         "id": 209
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "MURAMBAN",
// // //         "time": "10:49 AM",
// // //         "id": 208
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "10:59 AM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "11:01 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "11:08 AM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "TALUK OFFICE",
// // //         "time": "11:10 AM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "11:11 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "11:13 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "11:19 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "11:20 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "11:24 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "11:29 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:34 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:38 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:42 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:46 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:47 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:51 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:52 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:55 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-1-317",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-1",
// // //     "tripCode": "55/P55D-155-DTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 AM",
// // //     "endTime": "08:05 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:51 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:53 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:55 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:56 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:59 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:02 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:05 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:09 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:13 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:16 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "07:32 AM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:49 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:53 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "07:54 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "08:02 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "08:05 AM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-2-318",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-1",
// // //     "tripCode": "55/P55D-155-DTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 AM",
// // //     "endTime": "09:25 AM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       193,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "08:10 AM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "08:12 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:20 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:21 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:25 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "08:42 AM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:58 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:01 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:05 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:09 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:12 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:15 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:18 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:19 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:21 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:23 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-3-319",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-3",
// // //     "tripCode": "55/P55D-355-DTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 AM",
// // //     "endTime": "10:40 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:51 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:53 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:56 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:57 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:01 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:04 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:08 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:12 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:17 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:20 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:28 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:35 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:40 AM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-4-320",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-3",
// // //     "tripCode": "55/P55D-355-DTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:55 AM",
// // //     "endTime": "11:45 AM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:55 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:59 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "11:06 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "11:14 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "11:17 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "11:22 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:26 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:30 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:33 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:37 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:38 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:41 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:43 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-5-321",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-2",
// // //     "tripCode": "55/P55D-255-DTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "AGILANDAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:50 AM",
// // //     "endTime": "12:45 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       189,
// // //       280,
// // //       75,
// // //       76,
// // //       190
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:51 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:52 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:55 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:56 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:59 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "12:01 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "12:04 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "12:08 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:11 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:14 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "12:25 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:35 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:39 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:40 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "12:45 PM",
// // //         "id": 190
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-6-322",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-2",
// // //     "tripCode": "55/P55D-255-DTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "AGILANDAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:50 PM",
// // //     "endTime": "01:55 PM",
// // //     "ids": [
// // //       190,
// // //       76,
// // //       75,
// // //       280,
// // //       189,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "12:50 PM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:55 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:56 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "01:01 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "01:13 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:25 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:29 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:33 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:37 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:41 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:43 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:47 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:48 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:51 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:53 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-7-323",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-3",
// // //     "tripCode": "55/P55D-355-DTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:05 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:06 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:08 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:11 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:12 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:16 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "02:19 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "02:23 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "02:27 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:32 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:35 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "02:43 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "02:50 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "02:55 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-8-324",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-3",
// // //     "tripCode": "55/P55D-355-DTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:10 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "03:10 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "03:14 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:21 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "03:29 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "03:32 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "03:37 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "03:41 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:45 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:48 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:52 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:53 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:56 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:58 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-9-325",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-1",
// // //     "tripCode": "55/P55D-155-DTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:05 PM",
// // //     "endTime": "05:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:06 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:08 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "04:10 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "04:11 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "04:14 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "04:17 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "04:20 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "04:24 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "04:28 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:31 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "04:47 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "05:04 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "05:08 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "05:09 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "05:17 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "05:20 PM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-10-326",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-1",
// // //     "tripCode": "55/P55D-155-DTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:25 PM",
// // //     "endTime": "06:50 PM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       193,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "05:25 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "05:28 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "05:36 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "05:38 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "05:43 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "06:01 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "06:20 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:23 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:28 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:32 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:35 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:38 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:42 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:43 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:46 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:48 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-11-327",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-2",
// // //     "tripCode": "55/P55D-255-DTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "AGILANDAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:55 PM",
// // //     "endTime": "07:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       189,
// // //       280,
// // //       75,
// // //       76,
// // //       190
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:56 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:58 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:00 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:01 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:05 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:07 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:10 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:14 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:18 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:21 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "07:33 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:44 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:48 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "07:50 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "07:55 PM",
// // //         "id": 190
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-12-328",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-2",
// // //     "tripCode": "55/P55D-255-DTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "AGILANDAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 PM",
// // //     "endTime": "09:00 PM",
// // //     "ids": [
// // //       190,
// // //       76,
// // //       75,
// // //       280,
// // //       189,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PANCHALANKURICHI",
// // //         "time": "08:00 PM",
// // //         "id": 190
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:04 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:06 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:10 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AGILANDAPURAM",
// // //         "time": "08:21 PM",
// // //         "id": 189
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:33 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:36 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:40 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:44 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:47 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:49 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:53 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:54 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:56 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:58 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-13-329",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-3",
// // //     "tripCode": "55/P55D-355-DTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 PM",
// // //     "endTime": "10:00 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:11 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:13 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:16 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:17 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:21 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:24 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:28 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:32 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:37 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:40 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:48 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "09:55 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:00 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-D-14-330",
// // //     "routeNo": "55-D",
// // //     "code": "55/P55D-3",
// // //     "tripCode": "55/P55D-355-DTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:05 PM",
// // //     "endTime": "10:55 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:05 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:09 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:16 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:24 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:27 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:32 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:36 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:40 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:43 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "10:47 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "10:48 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "10:51 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:53 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-1-331",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:20 PM",
// // //     "endTime": "03:30 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:21 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:22 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:25 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:26 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:29 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "02:31 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "02:34 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "02:38 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:41 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:44 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "03:00 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "03:15 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "03:18 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:20 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "03:27 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "03:30 PM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-2-332",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:35 PM",
// // //     "endTime": "04:50 PM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       193,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "03:35 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "03:37 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:45 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "03:46 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "03:50 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "04:07 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:23 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "04:26 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "04:30 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "04:34 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "04:37 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "04:40 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "04:43 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "04:44 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:46 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:48 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-3-333",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:05 PM",
// // //     "endTime": "06:15 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:06 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:07 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:10 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:11 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:14 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "05:16 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "05:19 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "05:23 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:26 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:29 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "05:45 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "06:00 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "06:03 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:05 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "06:12 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "06:15 PM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-4-334",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:20 PM",
// // //     "endTime": "07:35 PM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       193,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "06:20 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "06:22 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:30 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "06:31 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "06:35 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "06:52 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:08 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:11 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:15 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:19 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:22 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:25 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:28 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:29 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:31 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:33 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-5-335",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-2",
// // //     "tripCode": "55/P55E-255-ETORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "VELLARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 PM",
// // //     "endTime": "09:10 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       194,
// // //       280,
// // //       75,
// // //       76,
// // //       195
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:51 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:53 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:56 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:57 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:01 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:04 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:07 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:11 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:16 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:19 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VELLARAM",
// // //         "time": "08:37 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:55 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:59 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:01 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "09:10 PM",
// // //         "id": 195
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-6-336",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-2",
// // //     "tripCode": "55/P55E-255-ETORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "VELLARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 AM",
// // //     "endTime": "08:25 AM",
// // //     "ids": [
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       194,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "07:10 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "07:17 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:19 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:23 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VELLARAM",
// // //         "time": "07:40 AM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:57 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:00 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:04 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:08 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:11 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:14 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:18 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:18 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:21 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:23 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-7-337",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:40 AM",
// // //     "endTime": "09:50 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:41 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:42 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:45 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:46 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:49 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:51 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:54 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:58 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:01 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:04 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "09:20 AM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "09:35 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "09:38 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:40 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "09:47 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "09:50 AM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-8-338",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:55 AM",
// // //     "endTime": "11:05 AM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       193,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "09:55 AM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "09:57 AM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:04 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "10:06 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:09 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "10:24 AM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:40 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:43 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:46 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:50 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:53 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:55 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "10:58 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "10:59 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:02 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:03 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:05 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-9-339",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KACCHERI THALAVAIPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:10 AM",
// // //     "endTime": "12:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       193,
// // //       280,
// // //       75,
// // //       76,
// // //       195,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:11 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:12 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:15 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:16 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:19 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:21 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:24 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "11:28 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "11:31 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "11:34 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "11:50 AM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:05 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:08 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:10 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "12:17 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "12:20 PM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-E-10-340",
// // //     "routeNo": "55-E",
// // //     "code": "55/P55E-1",
// // //     "tripCode": "55/P55E-155-ETORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KACCHERI THALAVAIPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:25 PM",
// // //     "endTime": "01:35 PM",
// // //     "ids": [
// // //       194,
// // //       195,
// // //       76,
// // //       75,
// // //       280,
// // //       193,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "VELLARAM",
// // //         "time": "12:25 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "GOVERNORGIRI",
// // //         "time": "12:27 PM",
// // //         "id": 195
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:34 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:36 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:39 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "12:54 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:10 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:13 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:16 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:20 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:23 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:25 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:28 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:29 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:32 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:33 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-1-341",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-1",
// // //     "tripCode": "55/P55F-155-FTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CEYLON COLONY",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:20 PM",
// // //     "endTime": "02:05 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       210
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:22 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:23 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:27 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:28 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:32 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:35 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:39 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:43 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:49 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:52 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "01:54 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "01:59 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "02:01 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "02:05 PM",
// // //         "id": 210
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-2-342",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-1",
// // //     "tripCode": "55/P55F-155-FTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "CEYLON COLONY",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:10 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "02:10 PM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "02:13 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "02:15 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "02:20 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:22 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:25 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "02:31 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "02:35 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "02:39 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:42 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:46 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:47 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:51 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:52 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-3-343",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-3",
// // //     "tripCode": "55/P55F-355-FTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA MUDIMAN",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:10 PM",
// // //     "endTime": "04:15 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       210,
// // //       211,
// // //       212,
// // //       213,
// // //       216
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:12 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:14 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:18 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:19 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:24 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:27 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "03:31 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "03:37 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "03:42 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "03:46 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "03:48 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "03:54 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "03:57 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "04:01 PM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "04:05 PM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "04:09 PM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "04:11 PM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "MELA MUDIMAN",
// // //         "time": "04:15 PM",
// // //         "id": 216
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-4-344",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-3",
// // //     "tripCode": "55/P55F-355-FTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "MELA MUDIMAN",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:40 PM",
// // //     "endTime": "05:45 PM",
// // //     "ids": [
// // //       216,
// // //       213,
// // //       212,
// // //       211,
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "MELA MUDIMAN",
// // //         "time": "04:40 PM",
// // //         "id": 216
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "04:43 PM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "04:45 PM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "04:49 PM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "04:53 PM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "04:57 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "05:00 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "05:06 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:08 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:12 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "05:17 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "05:23 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "05:27 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:30 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:35 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:36 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:40 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:42 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-5-345",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-1",
// // //     "tripCode": "55/P55F-155-FTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CEYLON COLONY",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:50 PM",
// // //     "endTime": "06:40 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       210
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:52 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:54 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:58 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:59 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:03 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:07 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:11 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:16 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:22 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "06:26 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "06:28 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "06:33 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:36 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "06:40 PM",
// // //         "id": 210
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-6-346",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-1",
// // //     "tripCode": "55/P55F-155-FTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "CEYLON COLONY",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:55 PM",
// // //     "endTime": "07:45 PM",
// // //     "ids": [
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "06:55 PM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:58 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:01 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:06 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:08 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:12 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:18 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:23 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:27 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:31 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:35 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:36 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:40 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:42 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-7-347",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-2",
// // //     "tripCode": "55/P55F-255-FTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PASUVANTHANAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 PM",
// // //     "endTime": "09:30 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       210,
// // //       211,
// // //       212,
// // //       213,
// // //       214,
// // //       215
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:12 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:14 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:18 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:19 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:24 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:28 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:33 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:38 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:45 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:49 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:51 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:57 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:00 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "09:04 PM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "09:09 PM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "09:13 PM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "09:15 PM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "POOLNAYAKKANOOR",
// // //         "time": "09:20 PM",
// // //         "id": 214
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "PASUVANTHANAI",
// // //         "time": "09:30 PM",
// // //         "id": 215
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-8-348",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-2",
// // //     "tripCode": "55/P55F-255-FTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PASUVANTHANAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:45 PM",
// // //     "endTime": "10:05 PM",
// // //     "ids": [
// // //       215,
// // //       214,
// // //       213,
// // //       212,
// // //       211,
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "PASUVANTHANAI",
// // //         "time": "09:45 PM",
// // //         "id": 215
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "POOLNAYAKKANOOR",
// // //         "time": "09:47 PM",
// // //         "id": 214
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "09:48 PM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "09:49 PM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "09:50 PM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "09:51 PM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:52 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "09:53 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "09:54 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:55 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:56 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:57 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:59 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:00 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:01 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "10:02 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "10:02 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "10:03 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:04 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-9-349",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-3",
// // //     "tripCode": "55/P55F-355-FTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA MUDIMAN",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:25 AM",
// // //     "endTime": "05:35 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       210,
// // //       211,
// // //       212,
// // //       213,
// // //       216
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:25 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:27 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:29 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "04:33 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "04:35 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "04:40 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "04:43 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "04:48 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "04:54 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:00 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:04 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "05:06 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "05:13 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "05:15 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "05:20 AM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "05:24 AM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "05:29 AM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "05:31 AM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "MELA MUDIMAN",
// // //         "time": "05:35 AM",
// // //         "id": 216
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-10-350",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-3",
// // //     "tripCode": "55/P55F-355-FTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "MELA MUDIMAN",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:05 AM",
// // //     "endTime": "06:40 AM",
// // //     "ids": [
// // //       216,
// // //       213,
// // //       212,
// // //       211,
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "MELA MUDIMAN",
// // //         "time": "05:05 AM",
// // //         "id": 216
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "05:10 AM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "05:12 AM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "05:18 AM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "05:25 AM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "05:31 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "05:34 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "05:43 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:46 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:51 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:00 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:08 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:14 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:19 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:26 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:28 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:33 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:36 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-11-351",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-4",
// // //     "tripCode": "55/P55F-455-FTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ATTHIMARAPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 AM",
// // //     "endTime": "07:15 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       176,
// // //       177
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:50 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:54 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:00 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:09 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "07:09 AM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "07:15 AM",
// // //         "id": 177
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-12-352",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-4",
// // //     "tripCode": "55/P55F-455-FTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ATTHIMARAPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 AM",
// // //     "endTime": "08:10 AM",
// // //     "ids": [
// // //       177,
// // //       176,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "07:20 AM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "07:31 AM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:31 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:49 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:01 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:08 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-13-353",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-1",
// // //     "tripCode": "55/P55F-155-FTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CEYLON COLONY",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76,
// // //       210
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:17 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:19 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:23 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:24 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:28 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:32 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:36 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:41 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:47 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:51 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:53 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:58 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:01 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "09:05 AM",
// // //         "id": 210
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-F-14-354",
// // //     "routeNo": "55-F",
// // //     "code": "55/P55F-1",
// // //     "tripCode": "55/P55F-155-FTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "CEYLON COLONY",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:20 AM",
// // //     "endTime": "12:10 PM",
// // //     "ids": [
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "CEYLON COLONY",
// // //         "time": "09:20 AM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "09:33 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "09:41 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "10:00 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:07 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:20 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:39 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:57 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:11 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:23 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:38 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:42 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:55 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "12:02 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-1-355",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-3",
// // //     "tripCode": "55/P55G-355-GTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:15 PM",
// // //     "endTime": "02:15 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:17 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:19 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:24 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:25 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:30 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:34 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:39 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:45 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:51 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:55 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "01:58 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "02:00 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "S.PUTHUR",
// // //         "time": "02:06 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "02:11 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "02:15 PM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-2-356",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-3",
// // //     "tripCode": "55/P55G-355-GTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:20 PM",
// // //     "endTime": "03:20 PM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "02:20 PM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "02:23 PM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "S.PUTHUR",
// // //         "time": "02:28 PM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "02:34 PM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "02:36 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:39 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:43 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "02:49 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "02:55 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:00 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:04 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:09 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:10 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:15 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:17 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:20 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-3-357",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-1",
// // //     "tripCode": "55/P55G-155-GTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KANTHASAMYPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:35 PM",
// // //     "endTime": "04:55 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       218,
// // //       280,
// // //       75,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       86,
// // //       217
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:36 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:38 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:41 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:42 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:45 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "03:48 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "03:51 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "03:55 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "04:00 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:03 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "04:19 PM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "04:34 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "04:38 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "04:40 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "04:41 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "04:42 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "04:49 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "04:53 PM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "04:55 PM",
// // //         "id": 217
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-4-358",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-1",
// // //     "tripCode": "55/P55G-155-GTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KANTHASAMYPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 PM",
// // //     "endTime": "06:15 PM",
// // //     "ids": [
// // //       217,
// // //       86,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       218,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "05:00 PM",
// // //         "id": 217
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "05:01 PM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "05:05 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "05:11 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "05:12 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "05:13 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "05:15 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "05:19 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "05:33 PM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:48 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:51 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "05:55 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "05:59 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:02 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:04 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:08 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:09 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:11 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:13 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-5-359",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-1",
// // //     "tripCode": "55/P55G-155-GTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KANTHASAMYPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 PM",
// // //     "endTime": "07:40 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       218,
// // //       280,
// // //       75,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       86,
// // //       217
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "06:31 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "06:32 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "06:35 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "06:36 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "06:39 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "06:41 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:44 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:48 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:52 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "06:54 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "07:08 PM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:21 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:25 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "07:27 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "07:27 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "07:29 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "07:34 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "07:38 PM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "07:40 PM",
// // //         "id": 217
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-6-360",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-1",
// // //     "tripCode": "55/P55G-155-GTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KANTHASAMYPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 PM",
// // //     "endTime": "09:15 PM",
// // //     "ids": [
// // //       217,
// // //       86,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       218,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "07:50 PM",
// // //         "id": 217
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "07:51 PM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "07:56 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "08:02 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "08:04 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:05 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:07 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:12 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "08:27 PM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:44 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:48 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:52 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:57 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:00 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:03 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:07 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:08 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:11 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:13 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-7-361",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-2",
// // //     "tripCode": "55/P55G-255-GTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PANDIAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 AM",
// // //     "endTime": "06:25 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       87,
// // //       280,
// // //       75,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       86,
// // //       217,
// // //       218
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:00 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:01 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:03 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:06 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:06 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:10 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "05:13 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "05:16 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "05:20 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "05:24 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:27 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PANDIAPURAM",
// // //         "time": "05:45 AM",
// // //         "id": 87
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "06:02 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "06:07 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:08 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "06:09 AM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "06:11 AM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "06:17 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "06:21 AM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "06:22 AM",
// // //         "id": 217
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "06:25 AM",
// // //         "id": 218
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-8-362",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-2",
// // //     "tripCode": "55/P55G-255-GTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PANDIAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:40 AM",
// // //     "endTime": "07:55 AM",
// // //     "ids": [
// // //       218,
// // //       217,
// // //       86,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       87,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "06:40 AM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "06:42 AM",
// // //         "id": 217
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "06:43 AM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "06:47 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "06:52 AM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "06:53 AM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "06:54 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "06:55 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "06:59 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PANDIAPURAM",
// // //         "time": "07:14 AM",
// // //         "id": 87
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:30 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:33 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:37 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:40 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:43 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:45 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:48 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:49 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:52 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:53 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:55 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-9-363",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-3",
// // //     "tripCode": "55/P55G-355-GTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SAVARIMANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 AM",
// // //     "endTime": "09:10 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       196,
// // //       197,
// // //       296,
// // //       198,
// // //       199
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:12 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:14 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:19 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:20 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "08:25 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:29 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:34 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:40 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:46 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:50 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "08:53 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "08:55 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "S.PUTHUR",
// // //         "time": "09:01 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "09:06 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "09:10 AM",
// // //         "id": 199
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-10-364",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-3",
// // //     "tripCode": "55/P55G-355-GTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "SAVARIMANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 AM",
// // //     "endTime": "10:15 AM",
// // //     "ids": [
// // //       199,
// // //       198,
// // //       296,
// // //       197,
// // //       196,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SAVARIMANGALAM",
// // //         "time": "09:15 AM",
// // //         "id": 199
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "S.KAILASAPURAM",
// // //         "time": "09:18 AM",
// // //         "id": 198
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "S.PUTHUR",
// // //         "time": "09:23 AM",
// // //         "id": 296
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "JAMBULINGAPURAM",
// // //         "time": "09:29 AM",
// // //         "id": 197
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "09:31 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:34 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:38 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:44 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:50 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:55 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:59 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "10:04 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "10:05 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "10:10 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:12 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:15 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-11-365",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-1",
// // //     "tripCode": "55/P55G-155-GTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KANTHASAMYPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 AM",
// // //     "endTime": "11:50 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       218,
// // //       280,
// // //       75,
// // //       76,
// // //       109,
// // //       105,
// // //       85,
// // //       86,
// // //       217
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:31 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "10:33 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "10:36 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "10:37 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:40 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:43 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "10:46 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "10:50 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "10:55 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:58 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "11:14 AM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "11:29 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "11:33 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "11:35 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "11:36 AM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "11:37 AM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "11:44 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "11:48 AM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "11:50 AM",
// // //         "id": 217
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-G-12-366",
// // //     "routeNo": "55-G",
// // //     "code": "55/P55G-1",
// // //     "tripCode": "55/P55G-155-GTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KANTHASAMYPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:55 AM",
// // //     "endTime": "01:10 PM",
// // //     "ids": [
// // //       217,
// // //       86,
// // //       85,
// // //       105,
// // //       109,
// // //       76,
// // //       75,
// // //       280,
// // //       218,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "THALAVAIPURAM 1",
// // //         "time": "11:55 AM",
// // //         "id": 217
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KOMBADI",
// // //         "time": "11:56 AM",
// // //         "id": 86
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "OSANOOTTHU",
// // //         "time": "12:00 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "AYYANAR KOVIL",
// // //         "time": "12:06 PM",
// // //         "id": 105
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "TALUK OFFICE",
// // //         "time": "12:07 PM",
// // //         "id": 109
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:08 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:10 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:14 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KANTHASAMYPURAM",
// // //         "time": "12:28 PM",
// // //         "id": 218
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:43 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:46 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "12:50 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "12:54 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "12:57 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "12:59 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:03 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:04 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:06 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:08 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-1-367",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-1",
// // //     "tripCode": "55/P55H-155-HTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:15 PM",
// // //     "endTime": "02:05 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:16 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "01:18 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:21 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:22 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:26 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:29 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:33 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:37 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:42 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:45 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "01:53 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "02:00 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "02:05 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-2-368",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-1",
// // //     "tripCode": "55/P55H-155-HTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:15 PM",
// // //     "endTime": "03:05 PM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "02:15 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "02:19 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "02:26 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:34 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "02:37 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "02:42 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "02:46 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "02:50 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "02:53 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "02:57 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "02:58 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:01 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:03 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-3-369",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-2",
// // //     "tripCode": "55/P55H-255-HTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "APC COLLEGE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:20 PM",
// // //     "endTime": "03:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       219
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:20 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:20 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "APC COLLEGE",
// // //         "time": "03:20 PM",
// // //         "id": 219
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-4-370",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-2",
// // //     "tripCode": "55/P55H-255-HTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "APC COLLEGE",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:30 PM",
// // //     "endTime": "03:45 PM",
// // //     "ids": [
// // //       219,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 4,
// // //         "name": "APC COLLEGE",
// // //         "time": "03:30 PM",
// // //         "id": 219
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:35 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:39 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-5-371",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-3",
// // //     "tripCode": "55/P55H-355-HTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "THOOTHUKUDI NEW B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:50 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       77
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:56 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI NEW B/S",
// // //         "time": "04:00 PM",
// // //         "id": 77
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-6-372",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-3",
// // //     "tripCode": "55/P55H-355-HTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "THOOTHUKUDI NEW B/S",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:05 PM",
// // //     "endTime": "04:25 PM",
// // //     "ids": [
// // //       77,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI NEW B/S",
// // //         "time": "04:05 PM",
// // //         "id": 77
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:11 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-7-373",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-4",
// // //     "tripCode": "55/P55H-455-HTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "VELLAPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:30 PM",
// // //     "endTime": "05:05 PM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       187
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:30 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "04:35 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:39 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "04:47 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "04:51 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "04:53 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "04:59 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VELLAPATTI",
// // //         "time": "05:05 PM",
// // //         "id": 187
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-8-374",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-4",
// // //     "tripCode": "55/P55H-455-HTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "VELLAPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:10 PM",
// // //     "endTime": "05:35 PM",
// // //     "ids": [
// // //       187,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 8,
// // //         "name": "VELLAPATTI",
// // //         "time": "05:10 PM",
// // //         "id": 187
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "05:13 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "05:18 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "05:19 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "05:22 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:28 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "05:31 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:35 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-9-375",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-7",
// // //     "tripCode": "55/P55H-755-HTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SIPCOT",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 PM",
// // //     "endTime": "06:15 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       220,
// // //       221,
// // //       222,
// // //       223,
// // //       224,
// // //       225
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:48 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "CHINNAKANNUPURAM",
// // //         "time": "05:51 PM",
// // //         "id": 220
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "SILVERPURAM",
// // //         "time": "05:54 PM",
// // //         "id": 221
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "PANDARAMPATTI",
// // //         "time": "06:00 PM",
// // //         "id": 222
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "MEELAVITTAN",
// // //         "time": "06:04 PM",
// // //         "id": 223
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "STERLITE",
// // //         "time": "06:10 PM",
// // //         "id": 224
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "06:15 PM",
// // //         "id": 225
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-10-376",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-8",
// // //     "tripCode": "55/P55H-855-HTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "SIPCOT",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:30 PM",
// // //     "endTime": "07:05 PM",
// // //     "ids": [
// // //       225,
// // //       226,
// // //       78,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "06:30 PM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR JUNCTION",
// // //         "time": "06:38 PM",
// // //         "id": 226
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "06:44 PM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:50 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:56 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-11-377",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-1",
// // //     "tripCode": "55/P55H-155-HTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 PM",
// // //     "endTime": "08:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       76,
// // //       280,
// // //       75
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:17 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:19 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:23 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:25 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:30 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:33 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:38 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:44 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:50 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:54 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:04 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:13 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:20 PM",
// // //         "id": 75
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-12-378",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-1",
// // //     "tripCode": "55/P55H-155-HTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:30 PM",
// // //     "endTime": "05:00 AM",
// // //     "ids": [
// // //       75,
// // //       280,
// // //       76,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:30 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "09:19 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "10:27 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "11:47 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:21 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:10 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:55 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "02:30 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "03:01 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "03:40 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "03:50 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:23 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:39 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-13-379",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-6",
// // //     "tripCode": "55/P55H-655-HTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "AUTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:10 AM",
// // //     "endTime": "05:45 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:10 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:12 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "05:16 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "05:21 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "05:22 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "05:24 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "05:29 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "05:31 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "05:35 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "05:39 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "05:42 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "05:45 AM",
// // //         "id": 172
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-14-380",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-6",
// // //     "tripCode": "55/P55H-655-HTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "AUTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:00 AM",
// // //     "endTime": "06:40 AM",
// // //     "ids": [
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "06:00 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "06:02 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "06:06 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "06:11 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "06:15 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "06:17 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:23 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:26 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:26 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:33 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:36 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:39 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-15-381",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-5",
// // //     "tripCode": "55/P55H-555-HTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA MUDIMAN",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 AM",
// // //     "endTime": "08:10 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       216,
// // //       280,
// // //       75,
// // //       76,
// // //       210,
// // //       211,
// // //       212,
// // //       213
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:01 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:02 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:05 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:06 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:09 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:11 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "07:14 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "07:17 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "07:21 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:24 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MUDIMAN",
// // //         "time": "07:40 AM",
// // //         "id": 216
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "07:55 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "07:58 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:00 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "CEYLON COLONY",
// // //         "time": "08:03 AM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "08:06 AM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "08:08 AM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "08:10 AM",
// // //         "id": 213
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-16-382",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-5",
// // //     "tripCode": "55/P55H-555-HTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "MELA MUDIMAN",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "09:35 AM",
// // //     "ids": [
// // //       213,
// // //       212,
// // //       211,
// // //       210,
// // //       76,
// // //       75,
// // //       280,
// // //       216,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "KEELA MUDIMAN",
// // //         "time": "08:15 AM",
// // //         "id": 213
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "VENKETESHVARAPURAM JUNCTION",
// // //         "time": "08:16 AM",
// // //         "id": 212
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PUTRU MURUGAN KOVIL",
// // //         "time": "08:19 AM",
// // //         "id": 211
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "CEYLON COLONY",
// // //         "time": "08:22 AM",
// // //         "id": 210
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "08:25 AM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MUPPULIPATI",
// // //         "time": "08:27 AM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "08:32 AM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MELA MUDIMAN",
// // //         "time": "08:48 AM",
// // //         "id": 216
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "09:07 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "09:10 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "09:14 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "09:18 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "09:21 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:24 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:27 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:28 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:31 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:33 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-17-383",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-9",
// // //     "tripCode": "55/P55H-955-HTORD18U17",
// // //     "order": 17,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "THOOTHUKUDI COLLECTORATE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 AM",
// // //     "endTime": "09:55 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       227
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:45 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:49 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "THOOTHUKUDI COLLECTORATE",
// // //         "time": "09:55 AM",
// // //         "id": 227
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-18-384",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-9",
// // //     "tripCode": "55/P55H-955-HTORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "THOOTHUKUDI COLLECTORATE",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:05 AM",
// // //     "endTime": "10:25 AM",
// // //     "ids": [
// // //       227,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 4,
// // //         "name": "THOOTHUKUDI COLLECTORATE",
// // //         "time": "10:05 AM",
// // //         "id": 227
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:12 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:17 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-19-385",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-10",
// // //     "tripCode": "55/P55H-1055-HTORD18U19",
// // //     "order": 19,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MULLAKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:35 AM",
// // //     "endTime": "11:20 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       180,
// // //       182,
// // //       183,
// // //       184,
// // //       45,
// // //       46
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:40 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "10:44 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:50 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:54 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:56 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP JUNCTION",
// // //         "time": "10:56 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "11:01 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "11:03 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "BULK",
// // //         "time": "11:14 AM",
// // //         "id": 184
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:16 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MULLAKADU",
// // //         "time": "11:20 AM",
// // //         "id": 46
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-H-20-386",
// // //     "routeNo": "55-H",
// // //     "code": "55/P55H-10",
// // //     "tripCode": "55/P55H-1055-HTORD18D20",
// // //     "order": 20,
// // //     "direction": "D",
// // //     "from": "MULLAKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:25 AM",
// // //     "endTime": "01:00 PM",
// // //     "ids": [
// // //       46,
// // //       45,
// // //       184,
// // //       183,
// // //       182,
// // //       180,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 12,
// // //         "name": "MULLAKADU",
// // //         "time": "11:25 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:33 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "BULK",
// // //         "time": "11:36 AM",
// // //         "id": 184
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "12:00 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "12:04 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP JUNCTION",
// // //         "time": "12:14 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "12:14 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "12:19 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "12:27 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "12:40 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "12:49 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-1-387",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-3",
// // //     "tripCode": "55/P55I-355-ITORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "OTTAPIDARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:40 AM",
// // //     "endTime": "12:20 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       280,
// // //       75,
// // //       76
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:42 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "11:43 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "11:46 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "11:47 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "11:51 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "11:54 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:58 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "12:03 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:07 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:11 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:13 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:17 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:20 PM",
// // //         "id": 76
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-2-388",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-3",
// // //     "tripCode": "55/P55I-355-ITORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "OTTAPIDARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:25 PM",
// // //     "endTime": "02:10 PM",
// // //     "ids": [
// // //       76,
// // //       75,
// // //       280,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "OTTAPIDARAM",
// // //         "time": "12:25 PM",
// // //         "id": 76
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MUPPULIPATI",
// // //         "time": "12:30 PM",
// // //         "id": 75
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "ST. ANN'S HOSPITAL",
// // //         "time": "12:43 PM",
// // //         "id": 280
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "12:47 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "12:56 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "01:09 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "01:21 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "01:30 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "01:38 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "01:49 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "01:51 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:00 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:04 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-3-389",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-2",
// // //     "tripCode": "55/P55I-255-ITORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NORTH SILUKKANPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:15 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       297,
// // //       235,
// // //       298,
// // //       237,
// // //       238
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:20 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:24 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:33 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "02:38 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "02:44 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "02:51 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "02:53 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "02:55 PM",
// // //         "id": 238
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-4-390",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-2",
// // //     "tripCode": "55/P55I-255-ITORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "NORTH SILUKKANPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "03:45 PM",
// // //     "ids": [
// // //       238,
// // //       237,
// // //       298,
// // //       235,
// // //       297,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "03:00 PM",
// // //         "id": 238
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "03:02 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "03:03 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "03:12 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "03:18 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:24 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:34 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:38 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-5-391",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-1",
// // //     "tripCode": "55/P55I-155-ITORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA MANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:10 PM",
// // //     "endTime": "05:40 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       228,
// // //       229,
// // //       230,
// // //       231,
// // //       232,
// // //       85,
// // //       106,
// // //       110,
// // //       108,
// // //       233,
// // //       234
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "04:13 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "04:15 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "04:20 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "04:22 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "04:28 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "04:33 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "04:39 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "04:46 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "04:54 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:59 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUPACCHERI COLONY",
// // //         "time": "05:07 PM",
// // //         "id": 228
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUPACCHERI",
// // //         "time": "05:09 PM",
// // //         "id": 229
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SIVALKULAM",
// // //         "time": "05:11 PM",
// // //         "id": 230
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PACCHAIPERUMALPURAM",
// // //         "time": "05:14 PM",
// // //         "id": 231
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SANKARARAJAPURAM",
// // //         "time": "05:15 PM",
// // //         "id": 232
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "05:18 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "05:21 PM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "THERKKU ARAIKULAM",
// // //         "time": "05:27 PM",
// // //         "id": 110
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "NORTH AARAIKULAM",
// // //         "time": "05:30 PM",
// // //         "id": 108
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KUPPANAPURAM",
// // //         "time": "05:33 PM",
// // //         "id": 233
// // //       },
// // //       {
// // //         "no": 22,
// // //         "name": "KEELA MANGALM",
// // //         "time": "05:40 PM",
// // //         "id": 234
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-6-392",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-1",
// // //     "tripCode": "55/P55I-155-ITORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KEELA MANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:55 PM",
// // //     "endTime": "07:25 PM",
// // //     "ids": [
// // //       234,
// // //       233,
// // //       108,
// // //       110,
// // //       106,
// // //       85,
// // //       232,
// // //       231,
// // //       230,
// // //       229,
// // //       228,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 22,
// // //         "name": "KEELA MANGALM",
// // //         "time": "05:55 PM",
// // //         "id": 234
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KUPPANAPURAM",
// // //         "time": "06:01 PM",
// // //         "id": 233
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "NORTH AARAIKULAM",
// // //         "time": "06:04 PM",
// // //         "id": 108
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "THERKKU ARAIKULAM",
// // //         "time": "06:07 PM",
// // //         "id": 110
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "06:13 PM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "06:16 PM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SANKARARAJAPURAM",
// // //         "time": "06:19 PM",
// // //         "id": 232
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PACCHAIPERUMALPURAM",
// // //         "time": "06:20 PM",
// // //         "id": 231
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SIVALKULAM",
// // //         "time": "06:23 PM",
// // //         "id": 230
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUPACCHERI",
// // //         "time": "06:25 PM",
// // //         "id": 229
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUPACCHERI COLONY",
// // //         "time": "06:27 PM",
// // //         "id": 228
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "06:35 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "06:40 PM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "06:48 PM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "06:55 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "07:01 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:06 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "07:12 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "07:14 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "07:19 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:21 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-7-393",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-1",
// // //     "tripCode": "55/P55I-155-ITORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KEELA MANGALAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:40 PM",
// // //     "endTime": "07:40 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       70,
// // //       71,
// // //       72,
// // //       73,
// // //       74,
// // //       228,
// // //       229,
// // //       230,
// // //       231,
// // //       232,
// // //       85,
// // //       106,
// // //       110,
// // //       108,
// // //       233,
// // //       234
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:05 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:25 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:07 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:20 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "10:10 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "10:48 PM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "11:34 PM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "12:31 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "01:32 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "02:15 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUPACCHERI COLONY",
// // //         "time": "03:22 AM",
// // //         "id": 228
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUPACCHERI",
// // //         "time": "03:39 AM",
// // //         "id": 229
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SIVALKULAM",
// // //         "time": "03:53 AM",
// // //         "id": 230
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PACCHAIPERUMALPURAM",
// // //         "time": "04:12 AM",
// // //         "id": 231
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SANKARARAJAPURAM",
// // //         "time": "04:27 AM",
// // //         "id": 232
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "04:50 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "05:11 AM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "THERKKU ARAIKULAM",
// // //         "time": "05:59 AM",
// // //         "id": 110
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "NORTH AARAIKULAM",
// // //         "time": "06:20 AM",
// // //         "id": 108
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KUPPANAPURAM",
// // //         "time": "06:45 AM",
// // //         "id": 233
// // //       },
// // //       {
// // //         "no": 22,
// // //         "name": "KEELA MANGALM",
// // //         "time": "07:40 AM",
// // //         "id": 234
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-8-394",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-1",
// // //     "tripCode": "55/P55I-155-ITORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "KEELA MANGALAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:55 AM",
// // //     "endTime": "09:20 AM",
// // //     "ids": [
// // //       234,
// // //       233,
// // //       108,
// // //       110,
// // //       106,
// // //       85,
// // //       232,
// // //       231,
// // //       230,
// // //       229,
// // //       228,
// // //       74,
// // //       73,
// // //       72,
// // //       71,
// // //       70,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 22,
// // //         "name": "KEELA MANGALM",
// // //         "time": "07:55 AM",
// // //         "id": 234
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KUPPANAPURAM",
// // //         "time": "08:01 AM",
// // //         "id": 233
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "NORTH AARAIKULAM",
// // //         "time": "08:04 AM",
// // //         "id": 108
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "THERKKU ARAIKULAM",
// // //         "time": "08:06 AM",
// // //         "id": 110
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "KULASEKARANALLOOR",
// // //         "time": "08:12 AM",
// // //         "id": 106
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "OSANOOTTHU",
// // //         "time": "08:15 AM",
// // //         "id": 85
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SANKARARAJAPURAM",
// // //         "time": "08:17 AM",
// // //         "id": 232
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PACCHAIPERUMALPURAM",
// // //         "time": "08:19 AM",
// // //         "id": 231
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SIVALKULAM",
// // //         "time": "08:21 AM",
// // //         "id": 230
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUPACCHERI",
// // //         "time": "08:23 AM",
// // //         "id": 229
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUPACCHERI COLONY",
// // //         "time": "08:25 AM",
// // //         "id": 228
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:33 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAJAVIN KOVIL",
// // //         "time": "08:38 AM",
// // //         "id": 73
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILLANATTHAM",
// // //         "time": "08:45 AM",
// // //         "id": 72
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "NAINAR PURAM",
// // //         "time": "08:52 AM",
// // //         "id": 71
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VELAYUTHAPURAM",
// // //         "time": "08:57 AM",
// // //         "id": 70
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "09:02 AM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "09:08 AM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "09:09 AM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "09:14 AM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "09:16 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-9-395",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-4",
// // //     "tripCode": "55/P55I-455-ITORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "THALAIVANVADALI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:25 AM",
// // //     "endTime": "10:55 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       127,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       129,
// // //       130,
// // //       239
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:25 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:30 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:37 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:49 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:50 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:55 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "10:04 AM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "10:10 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "10:19 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "10:28 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "10:35 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "10:39 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "10:42 AM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "10:49 AM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAIVANVADALI",
// // //         "time": "10:55 AM",
// // //         "id": 239
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-I-10-396",
// // //     "routeNo": "55-I",
// // //     "code": "55/P55I-4",
// // //     "tripCode": "55/P55I-455-ITORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "THALAIVANVADALI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:30 AM",
// // //     "endTime": "11:35 AM",
// // //     "ids": [
// // //       239,
// // //       130,
// // //       129,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       127,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "THALAIVANVADALI",
// // //         "time": "11:30 AM",
// // //         "id": 239
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "11:30 AM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "11:30 AM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "11:30 AM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "11:31 AM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "11:31 AM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "11:31 AM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "11:32 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "11:32 AM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "11:33 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "11:33 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "11:33 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "11:34 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "11:34 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "11:34 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:35 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-1-397",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-1",
// // //     "tripCode": "55/P55J-155-JTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "THOOTHUKUDI RAILWAY STATION",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 AM",
// // //     "endTime": "05:40 AM",
// // //     "ids": [
// // //       1,
// // //       240
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "THOOTHUKUDI RAILWAY STATION",
// // //         "time": "05:40 AM",
// // //         "id": 240
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-2-398",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-1",
// // //     "tripCode": "55/P55J-155-JTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "THOOTHUKUDI RAILWAY STATION",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 AM",
// // //     "endTime": "05:50 AM",
// // //     "ids": [
// // //       240,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 2,
// // //         "name": "THOOTHUKUDI RAILWAY STATION",
// // //         "time": "05:45 AM",
// // //         "id": 240
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-3-399",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-2",
// // //     "tripCode": "55/P55J-255-JTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MULLAKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:55 AM",
// // //     "endTime": "06:10 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:55 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:55 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "05:57 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:01 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:06 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:07 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:10 AM",
// // //         "id": 46
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-4-400",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-2",
// // //     "tripCode": "55/P55J-255-JTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "MULLAKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 AM",
// // //     "endTime": "06:30 AM",
// // //     "ids": [
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "06:15 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:17 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:18 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:23 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:27 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:29 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-5-401",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-3",
// // //     "tripCode": "55/P55J-355-JTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "POTTALKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:35 AM",
// // //     "endTime": "07:10 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       163
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:35 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:40 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:47 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:58 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:59 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:04 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "07:10 AM",
// // //         "id": 163
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-6-402",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-3",
// // //     "tripCode": "55/P55J-355-JTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "POTTALKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 AM",
// // //     "endTime": "08:10 AM",
// // //     "ids": [
// // //       163,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 8,
// // //         "name": "POTTALKADU",
// // //         "time": "07:15 AM",
// // //         "id": 163
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:24 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:31 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:33 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:50 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:01 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:08 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-7-403",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-4",
// // //     "tripCode": "55/P55J-455-JTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ATTHIMARAPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 AM",
// // //     "endTime": "08:45 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       176,
// // //       177
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:15 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:20 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:27 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:37 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "08:38 AM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "08:45 AM",
// // //         "id": 177
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-8-404",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-4",
// // //     "tripCode": "55/P55J-455-JTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "ATTHIMARAPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:50 AM",
// // //     "endTime": "09:25 AM",
// // //     "ids": [
// // //       177,
// // //       176,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 7,
// // //         "name": "ATTHIMARAPATTI",
// // //         "time": "08:50 AM",
// // //         "id": 177
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ATTHIMARAPATTI JUNCTION",
// // //         "time": "08:57 AM",
// // //         "id": 176
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:58 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:10 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:18 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:24 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-9-405",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-2",
// // //     "tripCode": "55/P55J-255-JTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MULLAKADU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "10:00 AM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "09:35 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "09:39 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "09:45 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "09:54 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "09:55 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:00 AM",
// // //         "id": 46
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-10-406",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-2",
// // //     "tripCode": "55/P55J-255-JTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "MULLAKADU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:05 AM",
// // //     "endTime": "10:30 AM",
// // //     "ids": [
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "10:05 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "10:09 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "10:10 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "10:19 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "10:25 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "10:29 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-11-407",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-5",
// // //     "tripCode": "55/P55J-555-JTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KULATTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:40 AM",
// // //     "endTime": "11:55 AM",
// // //     "ids": [
// // //       26,
// // //       282,
// // //       1,
// // //       63,
// // //       64,
// // //       111,
// // //       112,
// // //       299,
// // //       144,
// // //       300,
// // //       145,
// // //       135,
// // //       136,
// // //       287,
// // //       301,
// // //       138,
// // //       139,
// // //       118,
// // //       132,
// // //       140,
// // //       302
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "10:40 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "10:43 AM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:47 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "10:53 AM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "10:55 AM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "10:56 AM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "11:02 AM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 3",
// // //         "time": "11:05 AM",
// // //         "id": 299
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "11:12 AM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ARASADI 2",
// // //         "time": "11:14 AM",
// // //         "id": 300
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "11:20 AM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "11:22 AM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "11:25 AM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "ZAKKAMMALPURAM 4",
// // //         "time": "11:30 AM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DURAISAMYPURAM 2",
// // //         "time": "11:33 AM",
// // //         "id": 301
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SOUTH KALMEDU",
// // //         "time": "11:38 AM",
// // //         "id": 138
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "NORTH KALMEDU",
// // //         "time": "11:39 AM",
// // //         "id": 139
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "VEPPALODAI",
// // //         "time": "11:43 AM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "11:48 AM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "PANAIYOOR",
// // //         "time": "11:52 AM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 21,
// // //         "name": "KULATTHOOR 2",
// // //         "time": "11:55 AM",
// // //         "id": 302
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-12-408",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-5",
// // //     "tripCode": "55/P55J-555-JTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "KULATTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:05 PM",
// // //     "endTime": "01:20 PM",
// // //     "ids": [
// // //       302,
// // //       140,
// // //       132,
// // //       118,
// // //       139,
// // //       138,
// // //       301,
// // //       287,
// // //       136,
// // //       135,
// // //       145,
// // //       300,
// // //       144,
// // //       299,
// // //       112,
// // //       111,
// // //       64,
// // //       63,
// // //       1,
// // //       282,
// // //       26
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 21,
// // //         "name": "KULATTHOOR 2",
// // //         "time": "12:05 PM",
// // //         "id": 302
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "PANAIYOOR",
// // //         "time": "12:07 PM",
// // //         "id": 140
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "PANAIYOOR GATE",
// // //         "time": "12:11 PM",
// // //         "id": 132
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "VEPPALODAI",
// // //         "time": "12:16 PM",
// // //         "id": 118
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "NORTH KALMEDU",
// // //         "time": "12:20 PM",
// // //         "id": 139
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SOUTH KALMEDU",
// // //         "time": "12:21 PM",
// // //         "id": 138
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "DURAISAMYPURAM 2",
// // //         "time": "12:26 PM",
// // //         "id": 301
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "ZAKKAMMALPURAM 4",
// // //         "time": "12:29 PM",
// // //         "id": 287
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA MARUTHUR",
// // //         "time": "12:34 PM",
// // //         "id": 136
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "AM PATTI JUNCTION",
// // //         "time": "12:37 PM",
// // //         "id": 135
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KUMARAPURAM 1",
// // //         "time": "12:39 PM",
// // //         "id": 145
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ARASADI 2",
// // //         "time": "12:45 PM",
// // //         "id": 300
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KEELA ARASADI",
// // //         "time": "12:47 PM",
// // //         "id": 144
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI JUNCTION 3",
// // //         "time": "12:54 PM",
// // //         "id": 299
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "AYYANAR PURAM",
// // //         "time": "12:57 PM",
// // //         "id": 112
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THOMAS NAGAR",
// // //         "time": "01:03 PM",
// // //         "id": 111
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "SAVARAIYARPURAM",
// // //         "time": "01:04 PM",
// // //         "id": 64
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "AROCKIAPURAM",
// // //         "time": "01:06 PM",
// // //         "id": 63
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:12 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "AMERICAN HOSPITAL 2",
// // //         "time": "01:16 PM",
// // //         "id": 282
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "4TH GATE 1",
// // //         "time": "01:20 PM",
// // //         "id": 26
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-13-409",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-8",
// // //     "tripCode": "55/P55J-855-JTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KURUMBUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:30 PM",
// // //     "endTime": "03:40 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       127,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       129,
// // //       130,
// // //       131,
// // //       56
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "02:30 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "02:34 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "02:39 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:47 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:48 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:52 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "02:59 PM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "03:03 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "03:09 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "03:16 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "03:21 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "03:24 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "03:26 PM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "03:31 PM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// // //         "time": "03:36 PM",
// // //         "id": 131
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KURUMBUR",
// // //         "time": "03:40 PM",
// // //         "id": 56
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-14-410",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-8",
// // //     "tripCode": "55/P55J-855-JTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "KURUMBUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:45 PM",
// // //     "endTime": "05:00 PM",
// // //     "ids": [
// // //       56,
// // //       131,
// // //       130,
// // //       129,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       127,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "KURUMBUR",
// // //         "time": "03:45 PM",
// // //         "id": 56
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "MICHEAL NADAR KUDIYIRUPPU",
// // //         "time": "03:48 PM",
// // //         "id": 131
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "03:54 PM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "03:59 PM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "04:01 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "04:05 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "04:10 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "04:17 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "04:24 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "04:28 PM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "04:35 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "04:39 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "04:40 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:49 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:55 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "04:59 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-15-411",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-7",
// // //     "tripCode": "55/P55J-755-JTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:20 PM",
// // //     "endTime": "06:05 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       180,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:27 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "05:35 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "05:44 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "05:50 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "05:53 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP JUNCTION",
// // //         "time": "05:53 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:02 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "06:05 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-16-412",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-7",
// // //     "tripCode": "55/P55J-755-JTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:10 PM",
// // //     "endTime": "06:50 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       180,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "06:10 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:12 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP JUNCTION",
// // //         "time": "06:19 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:19 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:23 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:27 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "06:36 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "06:42 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-17-413",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-6",
// // //     "tripCode": "55/P55J-655-JTORD18U17",
// // //     "order": 17,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "AUTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 PM",
// // //     "endTime": "07:45 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "07:00 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "07:03 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "07:07 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:14 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:15 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:18 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "07:24 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:27 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "07:32 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "07:38 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "07:42 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "07:45 PM",
// // //         "id": 172
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-18-414",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-6",
// // //     "tripCode": "55/P55J-655-JTORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "AUTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 PM",
// // //     "endTime": "08:35 PM",
// // //     "ids": [
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "07:50 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "07:52 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "07:56 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "08:02 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "08:07 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "08:10 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "08:16 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:19 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:20 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:27 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:31 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:34 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-19-415",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-6",
// // //     "tripCode": "55/P55J-655-JTORD18U19",
// // //     "order": 19,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "AUTHOOR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:40 PM",
// // //     "endTime": "09:35 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       47,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "08:40 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "08:44 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "08:49 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "08:58 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "08:58 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "09:02 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "09:10 PM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "09:13 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "09:19 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "09:26 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "09:31 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "09:35 PM",
// // //         "id": 172
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "55-J-20-416",
// // //     "routeNo": "55-J",
// // //     "code": "55/P55J-6",
// // //     "tripCode": "55/P55J-655-JTORD18D20",
// // //     "order": 20,
// // //     "direction": "D",
// // //     "from": "AUTHOOR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 PM",
// // //     "endTime": "05:20 AM",
// // //     "ids": [
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       47,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "09:40 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "10:09 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "10:50 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "11:48 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:39 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADHIKETTAN ODAI",
// // //         "time": "01:06 AM",
// // //         "id": 47
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:10 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:41 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:48 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:00 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:45 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:15 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-1-417",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:50 PM",
// // //     "endTime": "03:00 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "01:54 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:58 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:05 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:08 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:15 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:20 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "02:25 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "02:25 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "02:33 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "02:39 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "02:41 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "02:47 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "02:53 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "02:57 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "03:00 PM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-2-418",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:05 PM",
// // //     "endTime": "04:25 PM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "03:05 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "03:08 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "03:12 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "03:19 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "03:26 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "03:28 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "03:35 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "03:44 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "03:44 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:50 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:55 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:04 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:06 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:15 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "04:19 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-3-419",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-2",
// // //     "tripCode": "56/P56A-256-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:30 PM",
// // //     "endTime": "05:40 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       23,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "04:34 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:37 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:44 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:46 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:53 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:57 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "05:02 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "05:02 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "05:12 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "05:16 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "05:18 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "05:24 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "05:29 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "05:33 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "05:35 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "05:40 PM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-4-420",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-2",
// // //     "tripCode": "56/P56A-256-ATORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 PM",
// // //     "endTime": "07:05 PM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "05:45 PM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "05:49 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "05:52 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "05:56 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "06:02 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "06:09 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "06:11 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "06:16 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "06:27 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:27 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:33 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:37 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:46 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:48 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:56 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:00 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-5-421",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 PM",
// // //     "endTime": "08:20 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:14 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:18 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:25 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:28 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:35 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:40 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:45 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "07:45 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "07:53 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "07:59 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "08:01 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "08:07 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "08:13 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "08:17 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "08:20 PM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-6-422",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:25 PM",
// // //     "endTime": "09:45 PM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "08:25 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "08:28 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "08:32 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "08:39 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "08:46 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "08:48 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "08:55 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "09:04 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:04 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:10 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:15 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:24 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:26 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:35 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:39 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-7-423",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-3",
// // //     "tripCode": "56/P56A-356-ATORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 PM",
// // //     "endTime": "05:40 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       248,
// // //       22,
// // //       23,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "10:18 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:41 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:28 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:42 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:31 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:56 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:30 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "ALLIKULAM JUNCTION",
// // //         "time": "02:09 AM",
// // //         "id": 248
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "02:18 AM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "02:40 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "02:56 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "03:30 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "03:45 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "04:22 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "04:57 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "05:22 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "05:40 AM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-8-424",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 AM",
// // //     "endTime": "07:00 AM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "05:45 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "05:48 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "05:52 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "05:58 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "06:04 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "06:07 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "06:13 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "06:21 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:21 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:27 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:32 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:40 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:43 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:51 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:55 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-9-425",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-2",
// // //     "tripCode": "56/P56A-256-ATORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:10 AM",
// // //     "endTime": "08:20 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       23,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:14 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:17 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:24 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:26 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:33 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:37 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:42 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "07:42 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "07:52 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "07:56 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "07:58 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "08:04 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "08:09 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "08:13 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "08:15 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "08:20 AM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-10-426",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-4",
// // //     "tripCode": "56/P56A-456-ATORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:25 AM",
// // //     "endTime": "09:45 AM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       23,
// // //       22,
// // //       248,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "08:25 AM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "08:29 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "08:32 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "08:36 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "08:41 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "08:47 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "08:50 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "08:55 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "08:58 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "09:01 AM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "ALLIKULAM JUNCTION",
// // //         "time": "09:03 AM",
// // //         "id": 248
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:09 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:15 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:19 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:26 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:29 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:36 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:40 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-11-427",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 AM",
// // //     "endTime": "11:00 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:54 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:58 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:05 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:08 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:15 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:20 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "10:25 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "10:25 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "10:33 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "10:39 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "10:41 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "10:47 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "10:53 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "10:57 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "11:00 AM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-A-12-428",
// // //     "routeNo": "56-A",
// // //     "code": "56/P56A-1",
// // //     "tripCode": "56/P56A-156-ATORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:05 AM",
// // //     "endTime": "01:45 PM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "11:05 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "11:11 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "11:20 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "11:33 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "11:47 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "11:52 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "12:05 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "12:23 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "12:23 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:36 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:45 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:03 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:08 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:26 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "01:34 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-1-429",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 AM",
// // //     "endTime": "07:00 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       22,
// // //       23,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:49 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:00 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:03 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:10 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:15 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:20 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "06:20 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "06:27 AM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "06:31 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "06:33 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "06:39 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "06:41 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "06:47 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "06:53 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "06:57 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "07:00 AM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-2-430",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:05 AM",
// // //     "endTime": "08:30 AM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       23,
// // //       22,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "07:05 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "07:08 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "07:12 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "07:19 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "07:25 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "07:28 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "07:34 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "07:37 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "07:41 AM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "07:49 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:49 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:55 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:00 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:09 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:12 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:20 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:24 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-3-431",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-3",
// // //     "tripCode": "56/P56B-356-BTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:35 AM",
// // //     "endTime": "10:10 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       253,
// // //       254,
// // //       196,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:40 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:44 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:53 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:56 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:05 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:10 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:15 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "09:21 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "09:34 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "09:41 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHETTIYOORANI",
// // //         "time": "09:48 AM",
// // //         "id": 253
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "09:53 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "10:06 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:10 AM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-4-432",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-3",
// // //     "tripCode": "56/P56B-356-BTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:15 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       74,
// // //       196,
// // //       254,
// // //       253,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "10:15 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "10:18 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "10:33 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHETTIYOORANI",
// // //         "time": "10:38 AM",
// // //         "id": 253
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "10:46 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "10:54 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "11:08 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:15 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:20 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:26 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:36 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:39 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:49 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:53 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-5-433",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:05 PM",
// // //     "endTime": "01:20 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       22,
// // //       23,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "12:09 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:13 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:20 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:23 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:30 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:35 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "12:40 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "12:40 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "12:47 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "12:51 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "12:53 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "12:59 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "01:01 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "01:07 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "01:13 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "01:17 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "01:20 PM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-6-434",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:25 PM",
// // //     "endTime": "02:40 PM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       23,
// // //       22,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "01:25 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "01:27 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "01:31 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "01:37 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "01:43 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "01:45 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "01:51 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "01:53 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "01:57 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "02:04 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "02:04 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:09 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:14 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:21 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:24 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:31 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "02:35 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-7-435",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:45 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       22,
// // //       23,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "02:49 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:53 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:00 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:03 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:10 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:15 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "03:20 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "03:20 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "03:27 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "03:31 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "03:33 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "03:39 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "03:41 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "03:47 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "03:53 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "03:57 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "04:00 PM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-8-436",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:05 PM",
// // //     "endTime": "05:30 PM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       23,
// // //       22,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "04:05 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "04:08 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "04:12 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "04:19 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "04:25 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "04:28 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "04:34 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "04:37 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "04:41 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "04:49 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "04:49 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:55 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:00 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:09 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:12 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:20 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:24 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-9-437",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-2",
// // //     "tripCode": "56/P56B-256-BTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "VELLARAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:35 PM",
// // //     "endTime": "06:50 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       67,
// // //       68,
// // //       69,
// // //       97,
// // //       143,
// // //       99,
// // //       281,
// // //       100,
// // //       191,
// // //       192,
// // //       193,
// // //       194
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "05:38 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "05:40 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "05:45 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "05:46 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "05:52 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "05:55 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "05:59 PM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "06:12 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "06:18 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "06:22 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "06:28 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "06:34 PM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "06:42 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VELLARAM",
// // //         "time": "06:50 PM",
// // //         "id": 194
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-10-438",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-2",
// // //     "tripCode": "56/P56B-256-BTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "VELLARAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:55 PM",
// // //     "endTime": "08:15 PM",
// // //     "ids": [
// // //       194,
// // //       193,
// // //       192,
// // //       191,
// // //       100,
// // //       281,
// // //       99,
// // //       143,
// // //       97,
// // //       69,
// // //       68,
// // //       67,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "VELLARAM",
// // //         "time": "06:55 PM",
// // //         "id": 194
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KACCHERI THALAVAIPURAM",
// // //         "time": "07:02 PM",
// // //         "id": 193
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VELLARAM JUNCTION",
// // //         "time": "07:11 PM",
// // //         "id": 192
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KUMARAPURAM JUNCTION",
// // //         "time": "07:17 PM",
// // //         "id": 191
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "KURUKKUSALAI",
// // //         "time": "07:23 PM",
// // //         "id": 100
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "SUBRAMANIYAPURAM 2",
// // //         "time": "07:28 PM",
// // //         "id": 281
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "VALASAMUTHIRAM",
// // //         "time": "07:34 PM",
// // //         "id": 99
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "ARASADI 1",
// // //         "time": "07:48 PM",
// // //         "id": 143
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "THANNEER PANDHAL",
// // //         "time": "07:52 PM",
// // //         "id": 97
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "ODAIPATTI PUDHUR",
// // //         "time": "07:56 PM",
// // //         "id": 69
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KALI KOVIL JUNCTION",
// // //         "time": "08:02 PM",
// // //         "id": 68
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MAPPILLAIYOORANI",
// // //         "time": "08:03 PM",
// // //         "id": 67
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "08:09 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:11 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-11-439",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:20 PM",
// // //     "endTime": "09:50 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       22,
// // //       23,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:25 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:29 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:38 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:41 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:51 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:56 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:02 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "09:02 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "09:11 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "09:15 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "09:18 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "09:24 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "09:27 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "09:35 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "09:41 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "09:46 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "09:50 PM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-B-12-440",
// // //     "routeNo": "56-B",
// // //     "code": "56/P56B-1",
// // //     "tripCode": "56/P56B-156-BTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:55 PM",
// // //     "endTime": "05:40 AM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       23,
// // //       22,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "09:55 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "10:12 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "10:37 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "11:11 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "11:49 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "12:04 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "12:37 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "12:54 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "01:16 AM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "01:59 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:59 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:33 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:59 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:47 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:01 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:48 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:11 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-1-441",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-1",
// // //     "tripCode": "56/P56C-156-CTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "04:35 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       256,
// // //       257,
// // //       258,
// // //       259,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "03:04 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:08 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:17 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:19 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:28 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:32 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "03:38 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "03:40 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "03:49 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "04:10 PM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "04:14 PM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "04:24 PM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "04:26 PM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "04:30 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "04:35 PM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-2-442",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-1",
// // //     "tripCode": "56/P56C-156-CTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:40 PM",
// // //     "endTime": "06:15 PM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       259,
// // //       258,
// // //       257,
// // //       256,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "04:40 PM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "04:44 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "04:48 PM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "04:50 PM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "05:00 PM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "05:04 PM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "05:25 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "05:34 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "05:36 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:42 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:46 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:55 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:57 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:06 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:10 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-3-443",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-2",
// // //     "tripCode": "56/P56C-256-CTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:20 PM",
// // //     "endTime": "07:40 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       23,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "06:24 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:28 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:36 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:38 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:47 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:51 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:57 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "06:57 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "07:08 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "07:13 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "07:15 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "07:22 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "07:28 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "07:32 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "07:35 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "07:40 PM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-4-444",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-2",
// // //     "tripCode": "56/P56C-256-CTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:45 PM",
// // //     "endTime": "09:10 PM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "07:45 PM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "07:50 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "07:53 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "07:57 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "08:03 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "08:10 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "08:13 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "08:18 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "08:30 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:30 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:36 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:41 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:49 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:52 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:00 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:04 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-5-445",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-1",
// // //     "tripCode": "56/P56C-156-CTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 PM",
// // //     "endTime": "06:10 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       256,
// // //       257,
// // //       258,
// // //       259,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:43 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:05 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:51 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:05 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:52 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "12:51 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "01:01 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "01:56 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "03:52 AM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "04:14 AM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "05:11 AM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "05:21 AM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "05:42 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "06:10 AM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-6-446",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-2",
// // //     "tripCode": "56/P56C-256-CTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 AM",
// // //     "endTime": "07:45 AM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "06:15 AM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "06:20 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "06:23 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "06:28 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "06:35 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "06:42 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "06:44 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "06:50 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "07:03 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:03 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:09 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:14 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:23 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:26 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:35 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:39 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-7-447",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-1",
// // //     "tripCode": "56/P56C-156-CTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 AM",
// // //     "endTime": "09:10 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       256,
// // //       257,
// // //       258,
// // //       259,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:54 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:57 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:04 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:06 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:13 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:22 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "08:23 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "08:32 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "08:49 AM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "08:52 AM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "09:01 AM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "09:02 AM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "09:05 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "09:10 AM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-8-448",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-1",
// // //     "tripCode": "56/P56C-156-CTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 AM",
// // //     "endTime": "10:45 AM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       259,
// // //       258,
// // //       257,
// // //       256,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "09:15 AM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "09:19 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "09:23 AM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "09:24 AM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "09:34 AM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "09:38 AM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "09:57 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "10:06 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "10:08 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:14 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:18 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:26 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:28 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:36 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "10:40 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-9-449",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-2",
// // //     "tripCode": "56/P56C-256-CTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:50 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       23,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "10:54 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:57 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:04 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:06 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:13 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "11:22 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "11:22 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "11:32 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "11:36 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "11:38 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "11:44 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "11:49 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "11:53 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "11:55 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "12:00 PM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-C-10-450",
// // //     "routeNo": "56-C",
// // //     "code": "56/P56C-2",
// // //     "tripCode": "56/P56C-256-CTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:05 PM",
// // //     "endTime": "03:15 PM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "12:05 PM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "12:16 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "12:23 PM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "12:33 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "12:47 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "01:02 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "01:08 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "01:20 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "01:46 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:46 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:00 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:10 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:29 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:35 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:54 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "03:03 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-1-451",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-1",
// // //     "tripCode": "56/P56D-156-DTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:10 PM",
// // //     "endTime": "03:30 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       256,
// // //       257,
// // //       258,
// // //       259,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "02:14 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:17 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:24 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:26 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:33 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:37 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "02:42 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "02:43 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "02:52 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "03:09 PM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "03:12 PM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "03:21 PM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "03:22 PM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "03:25 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "03:30 PM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-2-452",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-1",
// // //     "tripCode": "56/P56D-156-DTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:45 PM",
// // //     "endTime": "05:05 PM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       259,
// // //       258,
// // //       257,
// // //       256,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "03:45 PM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "03:49 PM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "03:52 PM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "03:53 PM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "04:02 PM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "04:05 PM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "04:22 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "04:31 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "04:32 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:37 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:41 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:48 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:50 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:57 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:00 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-3-453",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-2",
// // //     "tripCode": "56/P56D-256-DTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KALLAMPARAMBU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:20 PM",
// // //     "endTime": "06:35 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       22,
// // //       23,
// // //       249,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       260
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "05:24 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:28 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:36 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:39 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:47 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:51 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "05:57 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "05:57 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "06:04 PM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "06:08 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "06:11 PM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "06:16 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "06:19 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "06:25 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "06:31 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "KALLAMPARAMBU",
// // //         "time": "06:35 PM",
// // //         "id": 260
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-4-454",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-3",
// // //     "tripCode": "56/P56D-356-DTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "KALLAMPARAMBU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:40 PM",
// // //     "endTime": "07:55 PM",
// // //     "ids": [
// // //       260,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "KALLAMPARAMBU",
// // //         "time": "06:40 PM",
// // //         "id": 260
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "06:43 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "06:49 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "06:56 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "06:58 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "07:04 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "07:15 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:16 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:22 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:26 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:35 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:37 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:45 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "07:49 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-5-455",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-1",
// // //     "tripCode": "56/P56D-156-DTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MELA CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 PM",
// // //     "endTime": "07:15 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       256,
// // //       257,
// // //       258,
// // //       259,
// // //       245,
// // //       247
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:44 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:12 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:09 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:27 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:26 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:57 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "12:38 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "12:51 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "01:59 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "04:23 AM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "04:51 AM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "06:02 AM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "06:14 AM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "06:40 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "07:15 AM",
// // //         "id": 247
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-6-456",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-4",
// // //     "tripCode": "56/P56D-456-DTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "MELA CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:20 AM",
// // //     "endTime": "08:40 AM",
// // //     "ids": [
// // //       247,
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       249,
// // //       23,
// // //       22,
// // //       248,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "MELA CHEKKARAKUDI",
// // //         "time": "07:20 AM",
// // //         "id": 247
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "07:24 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "07:27 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "07:31 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "PUDHUR 2",
// // //         "time": "07:36 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "07:42 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PEROORANI",
// // //         "time": "07:45 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "THIRUVANANDHA PURAM JUNCTION",
// // //         "time": "07:50 AM",
// // //         "id": 249
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "07:53 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "ALLIKULAM",
// // //         "time": "07:56 AM",
// // //         "id": 22
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "ALLIKULAM JUNCTION",
// // //         "time": "07:58 AM",
// // //         "id": 248
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:04 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:10 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:14 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:21 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:24 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:31 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:35 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-7-457",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-5",
// // //     "tripCode": "56/P56D-556-DTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:55 AM",
// // //     "endTime": "10:05 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       256,
// // //       257,
// // //       258,
// // //       259,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:55 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "08:58 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:01 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:08 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:10 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:16 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:20 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:24 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "09:26 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "09:33 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "09:49 AM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "09:52 AM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "10:00 AM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "10:02 AM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "10:05 AM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-8-458",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-5",
// // //     "tripCode": "56/P56D-556-DTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:10 AM",
// // //     "endTime": "11:20 AM",
// // //     "ids": [
// // //       245,
// // //       259,
// // //       258,
// // //       257,
// // //       256,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "10:10 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "AZHAGAPURI",
// // //         "time": "10:12 AM",
// // //         "id": 259
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "NATTHAM",
// // //         "time": "10:14 AM",
// // //         "id": 258
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "POTTALOORANI VILLAGE",
// // //         "time": "10:22 AM",
// // //         "id": 257
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "POTTALOORANI JUNCTION",
// // //         "time": "10:25 AM",
// // //         "id": 256
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "10:41 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "10:48 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "10:50 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "10:54 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:58 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:04 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:06 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:13 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "11:16 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:20 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-9-459",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-3",
// // //     "tripCode": "56/P56D-356-DTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KALLAMPARAMBU",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:25 AM",
// // //     "endTime": "12:40 PM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       23,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       260
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:25 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "11:30 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:34 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:42 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:44 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:53 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:57 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "12:03 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "12:04 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "12:15 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "12:21 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "12:23 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "12:30 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "12:36 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "KALLAMPARAMBU",
// // //         "time": "12:40 PM",
// // //         "id": 260
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-D-10-460",
// // //     "routeNo": "56-D",
// // //     "code": "56/P56D-3",
// // //     "tripCode": "56/P56D-356-DTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KALLAMPARAMBU",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:45 PM",
// // //     "endTime": "01:55 PM",
// // //     "ids": [
// // //       260,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "KALLAMPARAMBU",
// // //         "time": "12:45 PM",
// // //         "id": 260
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "12:48 PM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "12:54 PM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "01:00 PM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "01:02 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "01:07 PM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "01:18 PM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:18 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:24 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:28 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:36 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:38 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:46 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "01:50 PM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-1-461",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:20 PM",
// // //     "endTime": "01:40 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       305,
// // //       255,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "12:25 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:30 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:39 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:42 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:52 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:57 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:04 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "01:08 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "01:10 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "01:22 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "01:25 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "01:35 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "01:40 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-2-462",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:45 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       305,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "01:45 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "01:48 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "01:58 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "02:00 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "02:10 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "02:12 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "02:16 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:22 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:26 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:35 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:37 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:46 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:49 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-3-463",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "04:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       305,
// // //       255,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:05 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:08 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:17 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:19 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:28 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:32 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "03:38 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "03:42 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "03:44 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "03:54 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "03:56 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "04:06 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "04:10 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-4-464",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:15 PM",
// // //     "endTime": "05:40 PM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       305,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "04:15 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "04:19 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "04:30 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "04:34 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "04:45 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "04:48 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "04:53 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:00 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:05 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:16 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:19 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:29 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:33 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-5-465",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 PM",
// // //     "endTime": "06:30 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       305,
// // //       255,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:48 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:50 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:56 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:57 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:03 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:06 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:09 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "06:12 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "06:13 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "06:19 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "06:21 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "06:27 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "06:30 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-6-466",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 PM",
// // //     "endTime": "07:50 PM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       305,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "06:50 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "06:53 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "07:01 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "07:03 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "07:11 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "07:13 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:16 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:21 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:25 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:33 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:35 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:42 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:45 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-7-467",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:00 PM",
// // //     "endTime": "09:05 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       305,
// // //       255,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:04 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:08 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:15 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:18 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:26 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:30 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:35 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "08:39 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "08:41 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "08:50 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "08:52 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "09:01 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "09:05 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-8-468",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 PM",
// // //     "endTime": "10:15 PM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       305,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "09:15 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "09:18 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "09:26 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "09:28 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "09:36 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "09:38 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:41 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:46 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:50 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:58 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:00 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:07 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:10 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-9-469",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 PM",
// // //     "endTime": "11:40 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       305,
// // //       255,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:35 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:38 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:47 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:49 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:58 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:02 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "11:08 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "11:12 PM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "11:14 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "11:24 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "11:26 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "11:36 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "11:40 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-10-470",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:25 AM",
// // //     "endTime": "07:30 AM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       305,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "06:25 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "06:28 AM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "06:37 AM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "06:39 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "06:48 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "06:50 AM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:54 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:59 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:03 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:11 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:14 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:25 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-11-471",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-1",
// // //     "tripCode": "56/P56E-156-ETORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:40 AM",
// // //     "endTime": "08:40 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       305,
// // //       255,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:44 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:47 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:54 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:56 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:04 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:08 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:13 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "08:16 AM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "08:18 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "08:26 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "08:28 AM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "08:36 AM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "08:40 AM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-12-472",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-2",
// // //     "tripCode": "56/P56E-256-ETORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:45 AM",
// // //     "endTime": "10:00 AM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       305,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1,
// // //       28,
// // //       27
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "PEROORANI",
// // //         "time": "08:45 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "08:48 AM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "08:57 AM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "VAGAIKULAM",
// // //         "time": "08:59 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "09:09 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "RAMACHANDRAPURAM 2",
// // //         "time": "09:11 AM",
// // //         "id": 305
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:14 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:20 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:24 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:32 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:34 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "3RD MILE",
// // //         "time": "09:42 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:46 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:56 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THRES PURAM",
// // //         "time": "10:00 AM",
// // //         "id": 27
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-E-13-473",
// // //     "routeNo": "56-E",
// // //     "code": "56/P56E-3",
// // //     "tripCode": "56/P56E-356-ETORD18D13",
// // //     "order": 13,
// // //     "direction": "D",
// // //     "from": "THRES PURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:10 AM",
// // //     "endTime": "12:10 PM",
// // //     "ids": [
// // //       27,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 2,
// // //         "name": "THRES PURAM",
// // //         "time": "10:10 AM",
// // //         "id": 27
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-1-474",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-1",
// // //     "tripCode": "56/P56F-156-FTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ADAIKKALAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:45 AM",
// // //     "endTime": "06:40 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       263,
// // //       264
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:48 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:51 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:58 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:59 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:06 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:09 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:14 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "06:15 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "06:22 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "06:26 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "06:36 AM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "ADAIKKALAPURAM",
// // //         "time": "06:40 AM",
// // //         "id": 264
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-2-475",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-1",
// // //     "tripCode": "56/P56F-156-FTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "ADAIKKALAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 AM",
// // //     "endTime": "07:40 AM",
// // //     "ids": [
// // //       264,
// // //       263,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "ADAIKKALAPURAM",
// // //         "time": "06:50 AM",
// // //         "id": 264
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "06:53 AM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "07:02 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "07:05 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "07:12 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:13 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:20 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:26 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:28 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:33 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:36 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-3-476",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-6",
// // //     "tripCode": "56/P56F-656-FTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "MEELAVITTAN",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 AM",
// // //     "endTime": "08:05 AM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       220,
// // //       221,
// // //       222,
// // //       223
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "07:52 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "CHINNAKANNUPURAM",
// // //         "time": "07:54 AM",
// // //         "id": 220
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "SILVERPURAM",
// // //         "time": "07:57 AM",
// // //         "id": 221
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "PANDARAMPATTI",
// // //         "time": "08:02 AM",
// // //         "id": 222
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "MEELAVITTAN",
// // //         "time": "08:05 AM",
// // //         "id": 223
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-4-477",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-6",
// // //     "tripCode": "56/P56F-656-FTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "MEELAVITTAN",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 AM",
// // //     "endTime": "08:10 AM",
// // //     "ids": [
// // //       223,
// // //       222,
// // //       221,
// // //       220,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "MEELAVITTAN",
// // //         "time": "08:10 AM",
// // //         "id": 223
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "PANDARAMPATTI",
// // //         "time": "08:10 AM",
// // //         "id": 222
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "SILVERPURAM",
// // //         "time": "08:10 AM",
// // //         "id": 221
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "CHINNAKANNUPURAM",
// // //         "time": "08:10 AM",
// // //         "id": 220
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "08:10 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-5-478",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-7",
// // //     "tripCode": "56/P56F-756-FTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ST. MARYS COLLEGE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:20 AM",
// // //     "endTime": "08:25 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       272
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:20 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:23 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ST. MARY'S COLLEGE",
// // //         "time": "08:25 AM",
// // //         "id": 272
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-6-479",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-7",
// // //     "tripCode": "56/P56F-756-FTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "ST. MARYS COLLEGE",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:45 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       272,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 3,
// // //         "name": "ST. MARY'S COLLEGE",
// // //         "time": "08:45 AM",
// // //         "id": 272
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:51 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:05 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-7-480",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-3",
// // //     "tripCode": "56/P56F-356-FTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "DEIVASEYALPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 AM",
// // //     "endTime": "10:25 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       263,
// // //       265,
// // //       266,
// // //       267,
// // //       268,
// // //       269,
// // //       270
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:19 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:28 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:30 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:36 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:40 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:44 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "09:46 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "09:53 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "09:57 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "10:07 AM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "ANIYABARANALLUR",
// // //         "time": "10:11 AM",
// // //         "id": 265
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUDHUPATTI",
// // //         "time": "10:17 AM",
// // //         "id": 266
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIMALLANPATTI",
// // //         "time": "10:19 AM",
// // //         "id": 267
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "RAMANATHAPURAM",
// // //         "time": "10:22 AM",
// // //         "id": 268
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "ELLANAICKENPATTI",
// // //         "time": "10:23 AM",
// // //         "id": 269
// // //       },
// // //       {
// // //         "no": 20,
// // //         "name": "DEIVASEYALPURAM",
// // //         "time": "10:25 AM",
// // //         "id": 270
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-8-481",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-3",
// // //     "tripCode": "56/P56F-356-FTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "DEIVASEYALPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:30 AM",
// // //     "endTime": "11:45 AM",
// // //     "ids": [
// // //       270,
// // //       269,
// // //       268,
// // //       267,
// // //       266,
// // //       265,
// // //       263,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 20,
// // //         "name": "DEIVASEYALPURAM",
// // //         "time": "10:30 AM",
// // //         "id": 270
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "ELLANAICKENPATTI",
// // //         "time": "10:31 AM",
// // //         "id": 269
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "RAMANATHAPURAM",
// // //         "time": "10:32 AM",
// // //         "id": 268
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHETTIMALLANPATTI",
// // //         "time": "10:35 AM",
// // //         "id": 267
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUDHUPATTI",
// // //         "time": "10:38 AM",
// // //         "id": 266
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "ANIYABARANALLUR",
// // //         "time": "10:44 AM",
// // //         "id": 265
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "10:48 AM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "10:59 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "11:03 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "11:11 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "11:12 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:21 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:28 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:30 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:37 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:40 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-9-482",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-9",
// // //     "tripCode": "56/P56F-956-FTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI OLD B/S",
// // //     "to": "THOOTHUKUDI NEW B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:50 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       77
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "11:56 AM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI NEW B/S",
// // //         "time": "12:00 PM",
// // //         "id": 77
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-10-483",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-9",
// // //     "tripCode": "56/P56F-956-FTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "THOOTHUKUDI NEW B/S",
// // //     "to": "THOOTHUKUDI OLD B/S",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:20 PM",
// // //     "endTime": "12:30 PM",
// // //     "ids": [
// // //       77,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 3,
// // //         "name": "THOOTHUKUDI NEW B/S",
// // //         "time": "12:20 PM",
// // //         "id": 77
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "12:23 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-11-484",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-1",
// // //     "tripCode": "56/P56F-156-FTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "ADAIKKALAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:50 PM",
// // //     "endTime": "01:40 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       263,
// // //       264
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "12:53 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:56 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:01 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:03 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:09 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:12 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:16 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "01:17 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "01:24 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "01:27 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "01:36 PM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "ADAIKKALAPURAM",
// // //         "time": "01:40 PM",
// // //         "id": 264
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-12-485",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-1",
// // //     "tripCode": "56/P56F-156-FTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "ADAIKKALAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:50 PM",
// // //     "endTime": "02:40 PM",
// // //     "ids": [
// // //       264,
// // //       263,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 15,
// // //         "name": "ADAIKKALAPURAM",
// // //         "time": "01:50 PM",
// // //         "id": 264
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "01:53 PM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "02:02 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "02:05 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "02:12 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "02:13 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:17 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:20 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:26 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:28 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:33 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:36 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-13-486",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-8",
// // //     "tripCode": "56/P56F-856-FTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "APC COLLEGE",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:50 PM",
// // //     "endTime": "03:00 PM",
// // //     "ids": [
// // //       1,
// // //       26,
// // //       66,
// // //       219
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "02:53 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "02:56 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "APC COLLEGE",
// // //         "time": "03:00 PM",
// // //         "id": 219
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-14-487",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-8",
// // //     "tripCode": "56/P56F-856-FTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "APC COLLEGE",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:05 PM",
// // //     "endTime": "03:40 PM",
// // //     "ids": [
// // //       219,
// // //       66,
// // //       26,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 4,
// // //         "name": "APC COLLEGE",
// // //         "time": "03:05 PM",
// // //         "id": 219
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "STATE BANK COLONY",
// // //         "time": "03:18 PM",
// // //         "id": 66
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "4TH GATE 1",
// // //         "time": "03:27 PM",
// // //         "id": 26
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-15-488",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-2",
// // //     "tripCode": "56/P56F-256-FTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUDHUPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:50 PM",
// // //     "endTime": "04:50 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       263,
// // //       265,
// // //       266
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:53 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:56 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:02 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:04 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:11 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:14 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "04:18 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "04:20 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "04:27 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "04:31 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "04:41 PM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "ANIYABARANALLUR",
// // //         "time": "04:44 PM",
// // //         "id": 265
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "PUDHUPATTI",
// // //         "time": "04:50 PM",
// // //         "id": 266
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-16-489",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-4",
// // //     "tripCode": "56/P56F-456-FTORD18U16",
// // //     "order": 16,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PEROORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 PM",
// // //     "endTime": "05:05 PM",
// // //     "ids": [
// // //       266,
// // //       265,
// // //       263,
// // //       166,
// // //       167,
// // //       261,
// // //       262,
// // //       24
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "PUDHUPATTI",
// // //         "time": "05:00 PM",
// // //         "id": 266
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "ANIYABARANALLUR",
// // //         "time": "05:00 PM",
// // //         "id": 265
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "MEENAKSHIPATTI",
// // //         "time": "05:01 PM",
// // //         "id": 263
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "05:02 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "VAGAIKULAM",
// // //         "time": "05:03 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "05:03 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "05:04 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PEROORANI",
// // //         "time": "05:05 PM",
// // //         "id": 24
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-17-490",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-5",
// // //     "tripCode": "56/P56F-556-FTORD18D17",
// // //     "order": 17,
// // //     "direction": "D",
// // //     "from": "PEROORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:55 PM",
// // //     "endTime": "06:00 PM",
// // //     "ids": [
// // //       24,
// // //       262,
// // //       261,
// // //       167,
// // //       255,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 14,
// // //         "name": "PEROORANI",
// // //         "time": "05:55 PM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "THIMMARAJAPURAM",
// // //         "time": "05:55 PM",
// // //         "id": 262
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "VARTHAGAREDDIPATTI",
// // //         "time": "05:55 PM",
// // //         "id": 261
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "VAGAIKULAM",
// // //         "time": "05:56 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "05:56 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "05:56 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "05:57 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:57 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:57 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:58 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:58 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:59 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:59 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-18-491",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-10",
// // //     "tripCode": "56/P56F-1056-FTORD18U18",
// // //     "order": 18,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "THALAIVANVADALI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 PM",
// // //     "endTime": "08:45 PM",
// // //     "ids": [
// // //       1,
// // //       41,
// // //       42,
// // //       43,
// // //       44,
// // //       45,
// // //       46,
// // //       127,
// // //       157,
// // //       49,
// // //       50,
// // //       51,
// // //       172,
// // //       129,
// // //       130,
// // //       239
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "06:16 PM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "06:24 PM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "06:36 PM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "06:56 PM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "06:58 PM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "07:06 PM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "07:21 PM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "07:31 PM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "07:45 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "08:00 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "08:11 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "08:19 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "08:24 PM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "08:35 PM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "THALAIVANVADALI",
// // //         "time": "08:45 PM",
// // //         "id": 239
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-F-19-492",
// // //     "routeNo": "56-F",
// // //     "code": "56/P56F-10",
// // //     "tripCode": "56/P56F-1056-FTORD18D19",
// // //     "order": 19,
// // //     "direction": "D",
// // //     "from": "THALAIVANVADALI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 PM",
// // //     "endTime": "05:30 AM",
// // //     "ids": [
// // //       239,
// // //       130,
// // //       129,
// // //       172,
// // //       51,
// // //       50,
// // //       49,
// // //       157,
// // //       127,
// // //       46,
// // //       45,
// // //       44,
// // //       43,
// // //       42,
// // //       41,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "THALAIVANVADALI",
// // //         "time": "07:30 PM",
// // //         "id": 239
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "AYYANKOVIL JUNCTION",
// // //         "time": "08:09 PM",
// // //         "id": 130
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "SOUTH AUTHOOR",
// // //         "time": "08:50 PM",
// // //         "id": 129
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "AUTHOOR",
// // //         "time": "09:10 PM",
// // //         "id": 172
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "MUKKANI",
// // //         "time": "09:42 PM",
// // //         "id": 51
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "CHAMBER",
// // //         "time": "10:26 PM",
// // //         "id": 50
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "PALAIYA KAYAL",
// // //         "time": "11:29 PM",
// // //         "id": 49
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOVANKADU",
// // //         "time": "12:24 AM",
// // //         "id": 157
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "SOUTHERN SALT",
// // //         "time": "01:03 AM",
// // //         "id": 127
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MULLAKADU",
// // //         "time": "02:03 AM",
// // //         "id": 46
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SPIC NAGAR",
// // //         "time": "02:37 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "02:45 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "UPPATTHU ODAI",
// // //         "time": "04:03 AM",
// // //         "id": 43
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "LEVANJIPURAM",
// // //         "time": "04:51 AM",
// // //         "id": 42
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MARKET",
// // //         "time": "05:24 AM",
// // //         "id": 41
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-1-493",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SEBATHAIAHPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:15 AM",
// // //     "endTime": "12:30 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       306,
// // //       164,
// // //       291,
// // //       13,
// // //       12
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "11:20 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:23 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:31 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:33 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:42 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:46 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "11:51 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "11:53 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "12:03 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "12:07 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "12:13 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "12:17 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "12:21 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:26 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:30 PM",
// // //         "id": 12
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-2-494",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "SEBATHAIAHPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:35 PM",
// // //     "endTime": "01:40 PM",
// // //     "ids": [
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       306,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "12:35 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "12:38 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "12:42 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "12:46 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "12:49 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "12:54 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "12:58 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "01:06 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "01:07 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "01:12 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:16 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:23 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:25 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:32 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:35 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-3-495",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SEBATHAIAHPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:45 PM",
// // //     "endTime": "02:50 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       306,
// // //       164,
// // //       291,
// // //       13,
// // //       12
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:49 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:52 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:59 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:01 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:08 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:12 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "02:17 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "02:18 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "02:26 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "02:30 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "02:35 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "02:38 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "02:42 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "02:46 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "02:50 PM",
// // //         "id": 12
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-4-496",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "SEBATHAIAHPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:55 PM",
// // //     "endTime": "04:00 PM",
// // //     "ids": [
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       306,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "02:55 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "02:58 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "03:02 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "03:06 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "03:09 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "03:14 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "03:18 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "03:26 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "03:27 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:32 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:36 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:43 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:45 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:52 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:55 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-5-497",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SEBATHAIAHPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:05 PM",
// // //     "endTime": "05:20 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       306,
// // //       164,
// // //       291,
// // //       13,
// // //       12
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:10 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:13 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:21 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:23 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:32 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:36 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "04:41 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "04:43 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "04:53 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "04:57 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "05:03 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "05:07 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "05:11 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "05:16 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:20 PM",
// // //         "id": 12
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-6-498",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "SEBATHAIAHPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:25 PM",
// // //     "endTime": "06:40 PM",
// // //     "ids": [
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       306,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:25 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "05:28 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "05:33 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "05:37 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "05:41 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "05:47 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "05:51 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "06:01 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:03 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:08 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:12 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:21 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:23 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:31 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:34 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:40 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-7-499",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SEBATHAIAHPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 PM",
// // //     "endTime": "08:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       306,
// // //       164,
// // //       291,
// // //       13,
// // //       12
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:04 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:08 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:15 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:17 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:25 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:29 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:34 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "07:36 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "07:44 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "07:49 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "07:54 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "07:57 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "08:01 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:06 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:10 PM",
// // //         "id": 12
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-8-500",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "SEBATHAIAHPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 PM",
// // //     "endTime": "09:25 PM",
// // //     "ids": [
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       306,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:15 PM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:18 PM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "08:23 PM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "08:27 PM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "08:30 PM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "08:35 PM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "08:40 PM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "08:48 PM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:50 PM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:55 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:59 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:07 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:09 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:16 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:20 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-9-501",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SEBATHAIAHPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:30 AM",
// // //     "endTime": "05:30 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       306,
// // //       164,
// // //       291,
// // //       13,
// // //       12
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:34 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:36 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:43 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:45 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:51 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:55 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "04:59 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "05:00 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "05:08 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "05:12 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "05:16 AM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "05:19 AM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "05:23 AM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "05:26 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:30 AM",
// // //         "id": 12
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-10-502",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "SEBATHAIAHPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:40 AM",
// // //     "endTime": "06:45 AM",
// // //     "ids": [
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       306,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "05:40 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "05:43 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "05:47 AM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "05:51 AM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "05:54 AM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "05:59 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "06:03 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "06:11 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "06:12 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:21 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:28 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:30 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:37 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:40 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-11-503",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SEBATHAIAHPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 AM",
// // //     "endTime": "08:15 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       255,
// // //       167,
// // //       166,
// // //       306,
// // //       164,
// // //       291,
// // //       13,
// // //       12
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:05 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:08 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:16 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:18 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:27 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:31 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "07:36 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "07:38 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "07:48 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "07:52 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "07:58 AM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "08:02 AM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "08:06 AM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:11 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:15 AM",
// // //         "id": 12
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-12-504",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-1",
// // //     "tripCode": "56/P56G-156-GTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "SEBATHAIAHPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:22 AM",
// // //     "endTime": "09:30 AM",
// // //     "ids": [
// // //       12,
// // //       13,
// // //       291,
// // //       164,
// // //       306,
// // //       166,
// // //       167,
// // //       255,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 16,
// // //         "name": "SEBATHAIAHPURAM",
// // //         "time": "08:22 AM",
// // //         "id": 12
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "SAWYERPURAM",
// // //         "time": "08:25 AM",
// // //         "id": 13
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "KUMARAPURAM 2",
// // //         "time": "08:29 AM",
// // //         "id": 291
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "KATTALANKULAM",
// // //         "time": "08:33 AM",
// // //         "id": 164
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "PUDHUR 3",
// // //         "time": "08:36 AM",
// // //         "id": 306
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MUDIVAITHANENDAL",
// // //         "time": "08:42 AM",
// // //         "id": 166
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "VAGAIKULAM",
// // //         "time": "08:46 AM",
// // //         "id": 167
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "RAMACHANDRAPURAM JUNCTION",
// // //         "time": "08:54 AM",
// // //         "id": 255
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "08:56 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:01 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:05 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:12 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:15 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:22 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:25 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-13-505",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-2",
// // //     "tripCode": "56/P56G-256-GTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NORTH SILUKKANPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:35 AM",
// // //     "endTime": "10:15 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       297,
// // //       235,
// // //       298,
// // //       237,
// // //       238
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:40 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:44 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:53 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "09:58 AM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "10:04 AM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "10:11 AM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "10:13 AM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "10:15 AM",
// // //         "id": 238
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "56-G-14-506",
// // //     "routeNo": "56-G",
// // //     "code": "56/P56G-2",
// // //     "tripCode": "56/P56G-256-GTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "NORTH SILUKKANPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:20 AM",
// // //     "endTime": "11:00 AM",
// // //     "ids": [
// // //       238,
// // //       237,
// // //       298,
// // //       235,
// // //       297,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "10:20 AM",
// // //         "id": 238
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "10:21 AM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "10:23 AM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "10:30 AM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "10:36 AM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:41 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:50 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:54 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-1-507",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-1",
// // //     "tripCode": "57/P57A-157-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SPIC NAGAR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 AM",
// // //     "endTime": "07:20 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183,
// // //       44,
// // //       45
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "06:22 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "06:28 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:37 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:42 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:46 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:54 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:59 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "07:01 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:18 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:20 AM",
// // //         "id": 45
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-2-508",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-1",
// // //     "tripCode": "57/P57A-157-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "SPIC NAGAR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:25 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       45,
// // //       44,
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 11,
// // //         "name": "SPIC NAGAR",
// // //         "time": "07:25 AM",
// // //         "id": 45
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "MUTHAIAHPURAM",
// // //         "time": "07:25 AM",
// // //         "id": 44
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "07:34 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "07:36 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "07:38 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "07:43 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "07:44 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "07:47 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "07:52 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:56 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-3-509",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-3",
// // //     "tripCode": "57/P57A-357-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:10 AM",
// // //     "endTime": "08:50 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:16 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:21 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:29 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:33 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:36 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:43 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "TTPP",
// // //         "time": "08:43 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:47 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "CAMP-II",
// // //         "time": "08:50 AM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-4-510",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:00 AM",
// // //     "endTime": "09:35 AM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "09:00 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:02 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:05 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:11 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "09:14 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:17 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:24 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:29 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-5-511",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-3",
// // //     "tripCode": "57/P57A-357-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 AM",
// // //     "endTime": "10:20 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:46 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:51 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:59 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:03 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:06 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:13 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "TTPP",
// // //         "time": "10:13 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:17 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "CAMP-II",
// // //         "time": "10:20 AM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-6-512",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:25 AM",
// // //     "endTime": "10:55 AM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "10:25 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:26 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:29 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:34 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:37 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:40 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "10:46 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:50 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:55 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-7-513",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:00 AM",
// // //     "endTime": "11:30 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:00 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "11:04 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "11:08 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "11:14 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "11:17 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "11:20 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "11:25 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "11:28 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "11:30 AM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-8-514",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:35 AM",
// // //     "endTime": "12:05 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "11:35 AM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "11:36 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "11:39 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "11:44 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "11:47 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "11:50 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "11:56 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "12:00 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-9-515",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:10 PM",
// // //     "endTime": "12:50 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "12:16 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "12:21 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "12:29 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "12:33 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "12:36 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "12:43 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "12:47 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "12:50 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-10-516",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:55 PM",
// // //     "endTime": "01:35 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "12:55 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "12:57 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "01:01 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "01:08 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "01:11 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "01:15 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "01:23 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "01:28 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-11-517",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:40 PM",
// // //     "endTime": "02:15 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "01:45 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "01:50 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "01:57 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "02:00 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "02:03 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "02:09 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "02:12 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "02:15 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-12-518",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:20 PM",
// // //     "endTime": "02:55 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "02:20 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "02:22 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "02:25 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "02:31 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "02:34 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "02:37 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "02:44 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "02:49 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-13-519",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:00 PM",
// // //     "endTime": "03:35 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "03:05 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "03:10 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "03:17 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "03:20 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "03:23 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "03:29 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "03:32 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "03:35 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-14-520",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:40 PM",
// // //     "endTime": "04:10 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "03:40 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "03:41 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "03:44 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "03:49 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "03:52 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "03:55 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "04:01 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "04:05 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-15-521",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:20 PM",
// // //     "endTime": "05:15 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "04:28 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "04:36 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "04:46 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "04:52 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "04:56 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "05:06 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "05:11 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "05:15 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-16-522",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-3",
// // //     "tripCode": "57/P57A-357-ATORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:20 PM",
// // //     "endTime": "05:55 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 10,
// // //         "name": "CAMP-II",
// // //         "time": "05:20 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "05:22 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "TTPP",
// // //         "time": "05:25 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "05:25 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "05:31 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "05:34 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "05:37 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "05:44 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:49 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-17-523",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U17",
// // //     "order": 17,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:00 PM",
// // //     "endTime": "06:35 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "06:05 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "06:10 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:17 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:20 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:23 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:29 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:32 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "06:35 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-18-524",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:40 PM",
// // //     "endTime": "07:45 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "06:40 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:43 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:50 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "07:01 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "07:06 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "07:13 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "07:25 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:34 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-19-525",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U19",
// // //     "order": 19,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:50 PM",
// // //     "endTime": "08:20 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:54 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "07:58 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:04 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:07 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:10 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:15 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:18 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "08:20 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-20-526",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D20",
// // //     "order": 20,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:25 PM",
// // //     "endTime": "08:55 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "08:25 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:26 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:29 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:34 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:37 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:40 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:46 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:50 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-21-527",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18U21",
// // //     "order": 21,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CAMP-II",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:00 PM",
// // //     "endTime": "09:35 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       183
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:05 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:10 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:17 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "09:20 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:23 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:29 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:32 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "09:35 PM",
// // //         "id": 183
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-A-22-528",
// // //     "routeNo": "57-A",
// // //     "code": "57/P57A-2",
// // //     "tripCode": "57/P57A-257-ATORD18D22",
// // //     "order": 22,
// // //     "direction": "D",
// // //     "from": "CAMP-II",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 PM",
// // //     "endTime": "10:30 PM",
// // //     "ids": [
// // //       183,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "CAMP-II",
// // //         "time": "09:40 PM",
// // //         "id": 183
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:42 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:47 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:56 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:00 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:05 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "10:15 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:22 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-1-529",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:10 PM",
// // //     "endTime": "01:45 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "01:14 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "01:18 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "01:24 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "01:27 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "01:30 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "01:35 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "01:38 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "01:45 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-2-530",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:50 PM",
// // //     "endTime": "02:25 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "01:50 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "01:56 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "01:59 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "02:04 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "02:07 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "02:10 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "02:16 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "02:20 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-3-531",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:30 PM",
// // //     "endTime": "03:15 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "02:36 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "02:41 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "02:48 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "02:53 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "02:55 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "03:02 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "03:06 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "03:15 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-4-532",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:20 PM",
// // //     "endTime": "03:50 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "03:20 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "03:25 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "03:28 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "03:32 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "03:34 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "03:37 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "03:42 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "03:45 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "03:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-5-533",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:10 PM",
// // //     "endTime": "04:45 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:10 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "04:14 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "04:18 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "04:24 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "04:27 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "04:30 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "04:35 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "04:38 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "04:45 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-6-534",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:50 PM",
// // //     "endTime": "05:25 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "04:50 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "04:56 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "04:59 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "05:04 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "05:07 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "05:10 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "05:16 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:20 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-7-535",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:40 PM",
// // //     "endTime": "06:15 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:44 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "05:48 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "05:54 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "05:57 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:00 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:05 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:08 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "06:15 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-8-536",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:20 PM",
// // //     "endTime": "06:55 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "06:20 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:26 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:29 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:34 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:37 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:40 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "06:46 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "06:50 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-9-537",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 PM",
// // //     "endTime": "07:50 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:19 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "07:23 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "07:29 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "07:32 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "07:35 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "07:40 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "07:43 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "07:50 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-10-538",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:55 PM",
// // //     "endTime": "08:30 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "07:55 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:01 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:04 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:09 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:12 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:15 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:21 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:25 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-11-539",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:35 PM",
// // //     "endTime": "09:10 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:35 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:39 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:43 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:49 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:52 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:55 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:00 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:03 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "09:10 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-12-540",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:15 PM",
// // //     "endTime": "09:45 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "09:15 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:20 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:23 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:27 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "09:29 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:32 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:37 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:40 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-13-541",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:00 PM",
// // //     "endTime": "10:30 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:04 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "10:07 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:12 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:15 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:17 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:21 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:24 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "10:30 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-14-542",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:35 PM",
// // //     "endTime": "11:00 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "10:35 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:39 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:41 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:45 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:47 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:49 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "10:53 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "10:56 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-15-543",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:50 AM",
// // //     "endTime": "06:20 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "05:54 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "05:57 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:02 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:05 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:07 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:11 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:14 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "06:20 AM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-16-544",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:25 AM",
// // //     "endTime": "07:00 AM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "06:25 AM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "06:31 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "06:34 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "06:39 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "06:42 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "06:45 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "06:51 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "06:55 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-17-545",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U17",
// // //     "order": 17,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 AM",
// // //     "endTime": "07:50 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:15 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "07:19 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "07:23 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "07:29 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "07:32 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "07:35 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "07:40 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "07:43 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "07:50 AM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-18-546",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D18",
// // //     "order": 18,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:55 AM",
// // //     "endTime": "08:25 AM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "07:55 AM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:00 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "08:03 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:07 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:09 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:12 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:17 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:20 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-19-547",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-2",
// // //     "tripCode": "57/P57D-257-DTORD18U19",
// // //     "order": 19,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:30 AM",
// // //     "endTime": "09:05 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "08:34 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "08:38 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "08:44 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "08:47 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "08:50 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP JUNCTION",
// // //         "time": "08:50 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "TTPP",
// // //         "time": "08:55 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "08:58 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "NEW HARBOUR",
// // //         "time": "09:05 AM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-20-548",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D20",
// // //     "order": 20,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 AM",
// // //     "endTime": "09:45 AM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "09:10 AM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "09:16 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "09:19 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "09:24 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "09:27 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "09:30 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:36 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:40 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-21-549",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U21",
// // //     "order": 21,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 AM",
// // //     "endTime": "10:25 AM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "09:54 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "09:58 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:04 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:07 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:10 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:15 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:18 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "10:25 AM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-22-550",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D22",
// // //     "order": 22,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:40 AM",
// // //     "endTime": "11:10 AM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "10:40 AM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "10:45 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "10:48 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "10:52 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "10:54 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "10:57 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "11:02 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "11:05 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:10 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-23-551",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18U23",
// // //     "order": 23,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NEW HARBOUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:25 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       1,
// // //       28,
// // //       185,
// // //       294,
// // //       293,
// // //       180,
// // //       181,
// // //       182,
// // //       273
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "11:25 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "11:29 AM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "11:33 AM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "11:39 AM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "11:42 AM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "11:45 AM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "11:50 AM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "11:53 AM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "12:00 PM",
// // //         "id": 273
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "57-D-24-552",
// // //     "routeNo": "57-D",
// // //     "code": "57/P57D-1",
// // //     "tripCode": "57/P57D-157-DTORD18D24",
// // //     "order": 24,
// // //     "direction": "D",
// // //     "from": "NEW HARBOUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:15 PM",
// // //     "endTime": "12:45 PM",
// // //     "ids": [
// // //       273,
// // //       182,
// // //       181,
// // //       180,
// // //       293,
// // //       294,
// // //       185,
// // //       28,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NEW HARBOUR",
// // //         "time": "12:15 PM",
// // //         "id": 273
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "CHILDREN'S PARK",
// // //         "time": "12:20 PM",
// // //         "id": 182
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "TTPP",
// // //         "time": "12:23 PM",
// // //         "id": 181
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THERMAL NAGAR JUNCTION",
// // //         "time": "12:27 PM",
// // //         "id": 180
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "THERMAL NAGAR",
// // //         "time": "12:29 PM",
// // //         "id": 293
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "CHEMICAL",
// // //         "time": "12:32 PM",
// // //         "id": 294
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "ROCH PARK",
// // //         "time": "12:37 PM",
// // //         "id": 185
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "SUB COLLECTOR OFFICE",
// // //         "time": "12:40 PM",
// // //         "id": 28
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-1-553",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-1",
// // //     "tripCode": "58/P58A-158-ATORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHETTIYOORANI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:20 PM",
// // //     "endTime": "02:30 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       253
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:26 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:30 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:39 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "01:42 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "01:52 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "01:59 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "02:13 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "02:21 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "02:25 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "CHETTIYOORANI",
// // //         "time": "02:30 PM",
// // //         "id": 253
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-2-554",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-1",
// // //     "tripCode": "58/P58A-158-ATORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "CHETTIYOORANI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:35 PM",
// // //     "endTime": "04:05 PM",
// // //     "ids": [
// // //       253,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 13,
// // //         "name": "CHETTIYOORANI",
// // //         "time": "02:35 PM",
// // //         "id": 253
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "02:41 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "02:46 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "02:56 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "03:14 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:23 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:35 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:39 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:51 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:57 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-3-555",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-4",
// // //     "tripCode": "58/P58A-458-ATORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:00 PM",
// // //     "endTime": "05:25 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:05 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:08 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:16 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:18 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:27 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "04:31 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:35 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "04:41 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "04:52 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "04:59 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "05:07 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "05:14 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "05:25 PM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-4-556",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-2",
// // //     "tripCode": "58/P58A-258-ATORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:30 PM",
// // //     "endTime": "07:05 PM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "05:30 PM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "05:42 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "05:51 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "06:01 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "06:10 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "06:24 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:31 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:41 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:44 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:54 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:58 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:05 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-5-557",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-6",
// // //     "tripCode": "58/P58A-658-ATORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KALANKARAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 PM",
// // //     "endTime": "07:25 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       277
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:05 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:09 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:17 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KALANKARAI",
// // //         "time": "07:25 PM",
// // //         "id": 277
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-6-558",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-6",
// // //     "tripCode": "58/P58A-658-ATORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "KALANKARAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:30 PM",
// // //     "endTime": "08:10 PM",
// // //     "ids": [
// // //       277,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "KALANKARAI",
// // //         "time": "07:30 PM",
// // //         "id": 277
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:41 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:55 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:01 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:10 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-7-559",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-2",
// // //     "tripCode": "58/P58A-258-ATORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:15 PM",
// // //     "endTime": "06:55 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:15 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:56 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:27 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:33 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "10:53 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:01 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "12:49 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "02:24 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "03:20 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "04:30 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "05:30 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "06:55 AM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-8-560",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-2",
// // //     "tripCode": "58/P58A-258-ATORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:00 AM",
// // //     "endTime": "08:25 AM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "07:00 AM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "07:11 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "07:19 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "07:28 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "07:35 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "07:48 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:54 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:03 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:06 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:15 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:19 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:25 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-9-561",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-6",
// // //     "tripCode": "58/P58A-658-ATORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "KALANKARAI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:30 AM",
// // //     "endTime": "08:55 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       277
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "08:30 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:35 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:39 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:47 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "KALANKARAI",
// // //         "time": "08:55 AM",
// // //         "id": 277
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-10-562",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-6",
// // //     "tripCode": "58/P58A-658-ATORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "KALANKARAI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:00 AM",
// // //     "endTime": "09:35 AM",
// // //     "ids": [
// // //       277,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "KALANKARAI",
// // //         "time": "09:00 AM",
// // //         "id": 277
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:10 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:21 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:27 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:35 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-11-563",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-5",
// // //     "tripCode": "58/P58A-558-ATORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "SIPCOT",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 AM",
// // //     "endTime": "10:05 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       78,
// // //       226,
// // //       225
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:46 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:50 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "09:54 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR JUNCTION",
// // //         "time": "09:58 AM",
// // //         "id": 226
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "10:05 AM",
// // //         "id": 225
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-12-564",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-5",
// // //     "tripCode": "58/P58A-558-ATORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "SIPCOT",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:10 AM",
// // //     "endTime": "10:40 AM",
// // //     "ids": [
// // //       225,
// // //       226,
// // //       78,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 6,
// // //         "name": "SIPCOT COMPLEX",
// // //         "time": "10:10 AM",
// // //         "id": 225
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "MADATTHOOR JUNCTION",
// // //         "time": "10:17 AM",
// // //         "id": 226
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "BYPASS",
// // //         "time": "10:22 AM",
// // //         "id": 78
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:27 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:32 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:40 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-13-565",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-3",
// // //     "tripCode": "58/P58A-358-ATORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:45 AM",
// // //     "endTime": "11:55 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "10:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "10:49 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:52 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:58 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:00 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:07 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "11:12 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "11:22 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "11:27 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "11:30 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "11:33 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "11:40 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "11:46 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "11:55 AM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-A-14-566",
// // //     "routeNo": "58-A",
// // //     "code": "58/P58A-3",
// // //     "tripCode": "58/P58A-358-ATORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:00 PM",
// // //     "endTime": "01:15 PM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "12:00 PM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "12:09 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "12:15 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "12:23 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "12:26 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "12:29 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "12:35 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "12:45 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:50 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:57 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:00 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:07 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:10 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-1-567",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NORTH SILUKKANPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:30 PM",
// // //     "endTime": "01:00 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       297,
// // //       235,
// // //       298,
// // //       237,
// // //       238
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "12:34 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:37 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:43 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "12:47 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "12:51 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "12:57 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "12:58 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "01:00 PM",
// // //         "id": 238
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-2-568",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "NORTH SILUKKANPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:15 PM",
// // //     "endTime": "01:55 PM",
// // //     "ids": [
// // //       238,
// // //       237,
// // //       298,
// // //       235,
// // //       297,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "01:15 PM",
// // //         "id": 238
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "01:16 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "01:18 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "01:25 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "01:31 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:36 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "01:45 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "01:49 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "01:55 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-3-569",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-1",
// // //     "tripCode": "58/P58B-158-BTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:00 PM",
// // //     "endTime": "03:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:00 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:04 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:07 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:15 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:17 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:24 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "02:30 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "02:40 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "02:46 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "02:54 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "03:00 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "03:10 PM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-4-570",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-1",
// // //     "tripCode": "58/P58B-158-BTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "03:15 PM",
// // //     "endTime": "04:35 PM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "03:15 PM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "03:25 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "03:33 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "03:41 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "03:48 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "04:00 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "04:06 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "04:15 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "04:17 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:25 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:29 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:35 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-5-571",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NORTH SILUKKANPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:45 PM",
// // //     "endTime": "05:30 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       297,
// // //       235,
// // //       298,
// // //       237,
// // //       238
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:45 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "04:51 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "04:55 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:05 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "05:11 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "05:17 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "05:26 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "05:27 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "05:30 PM",
// // //         "id": 238
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-6-572",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "NORTH SILUKKANPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:35 PM",
// // //     "endTime": "06:30 PM",
// // //     "ids": [
// // //       238,
// // //       237,
// // //       298,
// // //       235,
// // //       297,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "05:35 PM",
// // //         "id": 238
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "05:37 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "05:39 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "05:49 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "05:57 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:05 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:16 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:22 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:30 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-7-573",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-1",
// // //     "tripCode": "58/P58B-158-BTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:40 PM",
// // //     "endTime": "08:00 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:40 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:45 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:49 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:57 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:59 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:08 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "07:14 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "07:26 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "07:33 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "07:41 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "07:49 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "08:00 PM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-8-574",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-1",
// // //     "tripCode": "58/P58B-158-BTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 PM",
// // //     "endTime": "09:15 PM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "08:05 PM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "08:14 PM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "08:20 PM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "08:28 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "08:34 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "08:44 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:50 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:57 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:59 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:07 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:10 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-9-575",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NORTH SILUKKANPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:20 PM",
// // //     "endTime": "09:45 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       297,
// // //       235,
// // //       298,
// // //       237,
// // //       238
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:20 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:23 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:25 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:31 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "09:34 PM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "09:38 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "09:42 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "09:43 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "09:45 PM",
// // //         "id": 238
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-10-576",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "NORTH SILUKKANPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:50 PM",
// // //     "endTime": "04:55 AM",
// // //     "ids": [
// // //       238,
// // //       237,
// // //       298,
// // //       235,
// // //       297,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "09:50 PM",
// // //         "id": 238
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "10:09 PM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "10:27 PM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "11:44 PM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "12:40 AM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "01:42 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:14 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "03:56 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "04:55 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-11-577",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-2",
// // //     "tripCode": "58/P58B-258-BTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:00 AM",
// // //     "endTime": "06:10 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:00 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:04 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:07 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:13 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:15 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:22 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "05:27 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "05:37 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "05:42 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "05:45 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "05:48 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "05:55 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "06:01 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 19,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "06:10 AM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-12-578",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-2",
// // //     "tripCode": "58/P58B-258-BTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:15 AM",
// // //     "endTime": "07:35 AM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 19,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "06:15 AM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "06:24 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "06:31 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "06:39 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "06:42 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "06:46 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "06:52 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "07:03 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:08 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:16 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:19 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:26 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:30 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:35 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-13-579",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18U13",
// // //     "order": 13,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "NORTH SILUKKANPATTI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:45 AM",
// // //     "endTime": "08:20 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       297,
// // //       235,
// // //       298,
// // //       237,
// // //       238
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "07:45 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "07:49 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "07:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:00 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "08:05 AM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "08:10 AM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "08:16 AM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "08:18 AM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "08:20 AM",
// // //         "id": 238
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-14-580",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-3",
// // //     "tripCode": "58/P58B-358-BTORD18D14",
// // //     "order": 14,
// // //     "direction": "D",
// // //     "from": "NORTH SILUKKANPATTI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:25 AM",
// // //     "endTime": "09:30 AM",
// // //     "ids": [
// // //       238,
// // //       237,
// // //       298,
// // //       235,
// // //       297,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 9,
// // //         "name": "NORTH SILUKKANPATTI",
// // //         "time": "08:25 AM",
// // //         "id": 238
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MADATTHUPATTI",
// // //         "time": "08:28 AM",
// // //         "id": 237
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "MUTHUSAMYPURAM",
// // //         "time": "08:30 AM",
// // //         "id": 298
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "RAMANACCHIYARPURAM",
// // //         "time": "08:42 AM",
// // //         "id": 235
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "KAILASAPURAM",
// // //         "time": "08:51 AM",
// // //         "id": 297
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:00 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:14 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:21 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-15-581",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-1",
// // //     "tripCode": "58/P58B-158-BTORD18U15",
// // //     "order": 15,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHOCKALINGAPURAM",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:40 AM",
// // //     "endTime": "11:00 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       274,
// // //       275,
// // //       276
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:40 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:45 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:49 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:57 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:59 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "10:08 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "10:14 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "10:26 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "10:33 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "10:41 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "10:49 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "11:00 AM",
// // //         "id": 276
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-B-16-582",
// // //     "routeNo": "58-B",
// // //     "code": "58/P58B-1",
// // //     "tripCode": "58/P58B-158-BTORD18D16",
// // //     "order": 16,
// // //     "direction": "D",
// // //     "from": "CHOCKALINGAPURAM",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "11:10 AM",
// // //     "endTime": "12:15 PM",
// // //     "ids": [
// // //       276,
// // //       275,
// // //       274,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHOCKALINGAPURAM",
// // //         "time": "11:10 AM",
// // //         "id": 276
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "VARADHARAJAPURAM",
// // //         "time": "11:18 AM",
// // //         "id": 275
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "UMARIKOTTAI",
// // //         "time": "11:24 AM",
// // //         "id": 274
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "11:31 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "11:37 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "11:47 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:51 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:58 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:00 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:07 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "12:10 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:15 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-1-583",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18U1",
// // //     "order": 1,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "12:05 PM",
// // //     "endTime": "01:10 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       196,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:05 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "12:09 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "12:12 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "12:18 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "12:20 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:27 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:31 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:34 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "12:39 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "12:49 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "12:54 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "12:57 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "01:07 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:10 PM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-2-584",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18D2",
// // //     "order": 2,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "01:15 PM",
// // //     "endTime": "02:45 PM",
// // //     "ids": [
// // //       74,
// // //       196,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "01:15 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "01:18 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "01:32 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "01:36 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "01:43 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "01:57 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:03 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "02:08 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "02:13 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "02:23 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "02:25 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "02:35 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:39 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:45 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-3-585",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18U3",
// // //     "order": 3,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "02:50 PM",
// // //     "endTime": "04:30 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       196,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "02:50 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "02:56 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "03:01 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "03:11 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "03:14 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:24 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "03:30 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "03:35 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "03:43 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "03:57 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "04:06 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "04:10 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "04:26 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:30 PM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-4-586",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18D4",
// // //     "order": 4,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "04:35 PM",
// // //     "endTime": "05:50 PM",
// // //     "ids": [
// // //       74,
// // //       196,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "04:35 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "04:37 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "04:49 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "04:52 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "04:59 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "05:10 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:15 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "05:19 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "05:23 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "05:31 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "05:34 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "05:41 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:45 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:50 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-5-587",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18U5",
// // //     "order": 5,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:55 PM",
// // //     "endTime": "07:00 PM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       196,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "05:55 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "05:59 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:02 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:08 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:10 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:17 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:21 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:24 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "06:29 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "06:39 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "06:44 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "06:47 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "06:57 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:00 PM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-6-588",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18D6",
// // //     "order": 6,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "07:15 PM",
// // //     "endTime": "09:25 PM",
// // //     "ids": [
// // //       74,
// // //       196,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "07:15 PM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "07:19 PM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "07:40 PM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "07:45 PM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "07:56 PM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "08:15 PM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:25 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:32 PM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:39 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:53 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:57 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:10 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:16 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:25 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-7-589",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-2",
// // //     "tripCode": "58/P58C-258-CTORD18U7",
// // //     "order": 7,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:30 PM",
// // //     "endTime": "05:00 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       253,
// // //       254,
// // //       196,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:30 PM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "09:56 PM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "10:16 PM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "10:58 PM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:11 PM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:54 PM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "12:17 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "12:40 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "01:10 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "02:11 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "02:47 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHETTIYOORANI",
// // //         "time": "03:18 AM",
// // //         "id": 253
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "03:39 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "04:45 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 18,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:00 AM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-8-590",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-2",
// // //     "tripCode": "58/P58C-258-CTORD18D8",
// // //     "order": 8,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "05:15 AM",
// // //     "endTime": "06:45 AM",
// // //     "ids": [
// // //       74,
// // //       196,
// // //       254,
// // //       253,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 18,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "05:15 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "05:17 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "05:31 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CHETTIYOORANI",
// // //         "time": "05:35 AM",
// // //         "id": 253
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "05:41 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "05:48 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "06:00 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:06 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "06:11 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "06:16 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "06:24 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "06:27 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:35 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:39 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:45 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-9-591",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18U9",
// // //     "order": 9,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "PUTHIYAMPUTHUR",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "06:50 AM",
// // //     "endTime": "08:00 AM",
// // //     "ids": [
// // //       1,
// // //       29,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       6,
// // //       250,
// // //       251,
// // //       252,
// // //       254,
// // //       196,
// // //       74
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "06:50 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "06:54 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "06:57 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "07:04 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "07:07 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:14 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "07:18 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "07:22 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "07:27 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "07:37 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "07:43 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "07:46 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "07:57 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:00 AM",
// // //         "id": 74
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-10-592",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-1",
// // //     "tripCode": "58/P58C-158-CTORD18D10",
// // //     "order": 10,
// // //     "direction": "D",
// // //     "from": "PUTHIYAMPUTHUR",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "08:05 AM",
// // //     "endTime": "09:00 AM",
// // //     "ids": [
// // //       74,
// // //       196,
// // //       254,
// // //       252,
// // //       251,
// // //       250,
// // //       6,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       29,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "PUTHIYAMPUTHUR",
// // //         "time": "08:05 AM",
// // //         "id": 74
// // //       },
// // //       {
// // //         "no": 16,
// // //         "name": "VALLINAYAGIPURAM",
// // //         "time": "08:06 AM",
// // //         "id": 196
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "CAMP THATTAPARAI",
// // //         "time": "08:15 AM",
// // //         "id": 254
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "MELA THATTAPARAI",
// // //         "time": "08:17 AM",
// // //         "id": 252
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "KEELA THATTAPARAI",
// // //         "time": "08:22 AM",
// // //         "id": 251
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "SILUKKAN PATTI",
// // //         "time": "08:30 AM",
// // //         "id": 250
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:34 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "08:37 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "08:40 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "08:46 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "08:48 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "08:53 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "MILLER PURAM",
// // //         "time": "08:56 AM",
// // //         "id": 29
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:00 AM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-11-593",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-3",
// // //     "tripCode": "58/P58C-358-CTORD18U11",
// // //     "order": 11,
// // //     "direction": "U",
// // //     "from": "THOOTHUKUDI",
// // //     "to": "CHEKKARAKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "09:10 AM",
// // //     "endTime": "10:20 AM",
// // //     "ids": [
// // //       1,
// // //       2,
// // //       39,
// // //       4,
// // //       5,
// // //       6,
// // //       278,
// // //       21,
// // //       241,
// // //       23,
// // //       24,
// // //       243,
// // //       303,
// // //       304,
// // //       244,
// // //       245
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "09:10 AM",
// // //         "id": 1
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "09:14 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "09:18 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "09:25 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "09:27 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "09:35 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "09:39 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "09:44 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "09:44 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "09:54 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "09:59 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "10:02 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "10:07 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "10:13 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "10:17 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "10:20 AM",
// // //         "id": 245
// // //       }
// // //     ]
// // //   },
// // //   {
// // //     "id": "58-C-12-594",
// // //     "routeNo": "58-C",
// // //     "code": "58/P58C-3",
// // //     "tripCode": "58/P58C-358-CTORD18D12",
// // //     "order": 12,
// // //     "direction": "D",
// // //     "from": "CHEKKARAKUDI",
// // //     "to": "THOOTHUKUDI",
// // //     "service": "TOWN ORDINARY",
// // //     "startTime": "10:25 AM",
// // //     "endTime": "12:00 PM",
// // //     "ids": [
// // //       245,
// // //       244,
// // //       304,
// // //       303,
// // //       243,
// // //       24,
// // //       23,
// // //       241,
// // //       21,
// // //       278,
// // //       6,
// // //       5,
// // //       4,
// // //       39,
// // //       2,
// // //       1
// // //     ],
// // //     "stops": [
// // //       {
// // //         "no": 17,
// // //         "name": "CHEKKARAKUDI",
// // //         "time": "10:25 AM",
// // //         "id": 245
// // //       },
// // //       {
// // //         "no": 15,
// // //         "name": "MAHILAMPURAM",
// // //         "time": "10:28 AM",
// // //         "id": 244
// // //       },
// // //       {
// // //         "no": 14,
// // //         "name": "THALAVAIPURAM 2",
// // //         "time": "10:34 AM",
// // //         "id": 304
// // //       },
// // //       {
// // //         "no": 13,
// // //         "name": "PUDHUR 2",
// // //         "time": "10:41 AM",
// // //         "id": 303
// // //       },
// // //       {
// // //         "no": 12,
// // //         "name": "SAMATTHUVAPURAM",
// // //         "time": "10:49 AM",
// // //         "id": 243
// // //       },
// // //       {
// // //         "no": 11,
// // //         "name": "PEROORANI",
// // //         "time": "10:52 AM",
// // //         "id": 24
// // //       },
// // //       {
// // //         "no": 10,
// // //         "name": "THIRUVANANDHA PURAM",
// // //         "time": "10:59 AM",
// // //         "id": 23
// // //       },
// // //       {
// // //         "no": 9,
// // //         "name": "KOOTTUDANKADU",
// // //         "time": "11:13 AM",
// // //         "id": 241
// // //       },
// // //       {
// // //         "no": 8,
// // //         "name": "MANGALAGIRI",
// // //         "time": "11:13 AM",
// // //         "id": 21
// // //       },
// // //       {
// // //         "no": 7,
// // //         "name": "PUDHUKOTTAI 2",
// // //         "time": "11:20 AM",
// // //         "id": 278
// // //       },
// // //       {
// // //         "no": 6,
// // //         "name": "THATTAPARAI JUNCTION",
// // //         "time": "11:25 AM",
// // //         "id": 6
// // //       },
// // //       {
// // //         "no": 5,
// // //         "name": "ANTHONIYARPURAM",
// // //         "time": "11:36 AM",
// // //         "id": 5
// // //       },
// // //       {
// // //         "no": 4,
// // //         "name": "KORAMPALLAM",
// // //         "time": "11:39 AM",
// // //         "id": 4
// // //       },
// // //       {
// // //         "no": 3,
// // //         "name": "3RD MILE",
// // //         "time": "11:49 AM",
// // //         "id": 39
// // //       },
// // //       {
// // //         "no": 2,
// // //         "name": "VOC COLLEGE",
// // //         "time": "11:53 AM",
// // //         "id": 2
// // //       },
// // //       {
// // //         "no": 1,
// // //         "name": "THOOTHUKUDI OLD B/S",
// // //         "time": "12:00 PM",
// // //         "id": 1
// // //       }
// // //     ]
// // //   }
// // // ];

// // // const VEHICLES = Object.keys(VEHICLE_ROUTE_MAP);

// // // function normalizeVehicleNo(v) {
// // //   return String(v || "").trim().toUpperCase().replace(/\s+/g, "");
// // // }

// // // function normalizeRouteNo(v) {
// // //   const s = String(v || "").trim().toUpperCase().replace(/\s+/g, "");
// // //   if (!s) return "";
// // //   const detailed = s.match(/^(\d+)\/P\d+([A-Z])-\d+/);
// // //   if (detailed) return `${detailed[1]}-${detailed[2]}`;
// // //   const compact = s.match(/^(\d+)[-/]?([A-Z])$/);
// // //   if (compact) return `${compact[1]}-${compact[2]}`;
// // //   return s;
// // // }

// // // function canonicalRoute(code) {
// // //   return String(code || "").trim().toUpperCase().replace(/\s+/g, "");
// // // }

// // // const ROUTE_NO_BY_CODE = ROUTE_TRIPS.reduce((acc, trip) => {
// // //   if (trip.code && trip.routeNo) acc[trip.code] = trip.routeNo;
// // //   return acc;
// // // }, {});

// // // function routeNoFromRouteCode(code) {
// // //   const raw = String(code || "").trim().toUpperCase().replace(/\s+/g, "");
// // //   if (!raw) return "";
// // //   if (ROUTE_NO_BY_CODE[raw]) return ROUTE_NO_BY_CODE[raw];
// // //   return normalizeRouteNo(raw);
// // // }

// // // function getAssignedRouteValue(vehicleno, assignments = {}) {
// // //   const vehicleNo = normalizeVehicleNo(vehicleno);
// // //   return (
// // //     assignments?.[vehicleNo] ||
// // //     assignments?.[vehicleno] ||
// // //     VEHICLE_ROUTE_MAP[vehicleNo] ||
// // //     ""
// // //   );
// // // }

// // // function getBusRouteNo(vehicleno, assignments = {}) {
// // //   return routeNoFromRouteCode(getAssignedRouteValue(vehicleno, assignments));
// // // }

// // // function getRouteDisplayLabel(routeValue) {
// // //   const routeNo = routeNoFromRouteCode(routeValue);
// // //   const route = ROUTES.find((r) => r.code === routeNo);
// // //   return route?.label || routeNo || "Unassigned";
// // // }

// // // function routeCandidatesForValue(routeValue) {
// // //   const raw = String(routeValue || "").trim().toUpperCase().replace(/\s+/g, "");
// // //   const routeNo = routeNoFromRouteCode(raw);

// // //   const exactCodeMatches = ROUTE_TRIPS.filter((trip) => trip.code === raw);
// // //   if (exactCodeMatches.length) return exactCodeMatches;

// // //   return ROUTE_TRIPS.filter((trip) => trip.routeNo === routeNo);
// // // }

// // // // ---- Leaflet default icon fix ----
// // // delete L.Icon.Default.prototype._getIconUrl;
// // // L.Icon.Default.mergeOptions({
// // //   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
// // //   iconUrl: require('leaflet/dist/images/marker-icon.png'),
// // //   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// // // });

// // // // ---- Utility helpers ----
// // // const createCustomIcon = (iconUrl, size = [40, 40]) =>
// // //   L.icon({
// // //     iconUrl,
// // //     iconSize: size,
// // //     iconAnchor: [size[0] / 2, size[1]],
// // //     popupAnchor: [0, -size[1] / 2]
// // //   });

// // // const userIconInstance = createCustomIcon(userIcon, [40, 40]);

// // // const toHeading = (v) => {
// // //   const n = Number(v);
// // //   return Number.isFinite(n) ? ((n % 360) + 360) % 360 : null;
// // // };

// // // const toFiniteNumber = (value) => {
// // //   if (value === null || value === undefined || value === '') return null;
// // //   const n = Number(value);
// // //   return Number.isFinite(n) ? n : null;
// // // };

// // // function normalizeLatLng(latValue, lngValue) {
// // //   const lat = toFiniteNumber(latValue);
// // //   const lng = toFiniteNumber(lngValue);
// // //   if (lat === null || lng === null) return null;
// // //   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
// // //   return { lat, lng };
// // // }

// // // function hasValidLatLng(value) {
// // //   return !!normalizeLatLng(value?.lat, value?.lng);
// // // }

// // // // Exponential smoothing for latitude/longitude
// // // function smoothCoord(prev, next, alpha = SMOOTH_ALPHA) {
// // //   const safeNext = normalizeLatLng(next?.lat, next?.lng);
// // //   if (!safeNext) return normalizeLatLng(prev?.lat, prev?.lng);

// // //   const safePrev = normalizeLatLng(prev?.lat, prev?.lng);
// // //   if (!safePrev) return safeNext;

// // //   return {
// // //     lat: safePrev.lat + alpha * (safeNext.lat - safePrev.lat),
// // //     lng: safePrev.lng + alpha * (safeNext.lng - safePrev.lng)
// // //   };
// // // }



// // // // Circular smoothing for heading (degrees)
// // // function smoothHeading(prevDeg, nextDeg, alpha = HEADING_ALPHA) {
// // //   if (!Number.isFinite(prevDeg)) return nextDeg;
// // //   if (!Number.isFinite(nextDeg)) return prevDeg;
// // //   const p = (prevDeg * Math.PI) / 180;
// // //   const n = (nextDeg * Math.PI) / 180;
// // //   const x = (1 - alpha) * Math.cos(p) + alpha * Math.cos(n);
// // //   const y = (1 - alpha) * Math.sin(p) + alpha * Math.sin(n);
// // //   const ang = (Math.atan2(y, x) * 180) / Math.PI;
// // //   return (((ang % 360) + 360) % 360);
// // // }
// // // function mBetween(a, b) {
// // //   const aa = normalizeLatLng(a?.lat, a?.lng);
// // //   const bb = normalizeLatLng(b?.lat, b?.lng);
// // //   if (!aa || !bb) return Infinity;
// // //   return L.latLng(aa.lat, aa.lng).distanceTo(L.latLng(bb.lat, bb.lng));
// // // }

// // // // ---- Cart classification (case-insensitive "EV") ----
// // // function isCart(vehicleno) {
// // //   const s = String(vehicleno || '').trim();
// // //   return s.toUpperCase().startsWith('EV');
// // // }

// // // // Label: B for Bus, C for Cart
// // // // function vehicleLabel(vehicleno) { return isCart(vehicleno) ? 'C' : 'B'; }
// // // function vehicleLabel(vehicleno, routeCode) {
// // //   if (!isCart(vehicleno)) return "B";

// // //   const rc = canonicalRoute(routeCode || "");
// // //   if (rc === "RP_ED" || rc === "ED_RP") return "CR"; // 👈 cart on RP↔ED
// // //   return "C";
// // // }


// // // // ---- Block IDs starting with a digit ----
// // // function startsWithDigit(vehicleno) { return /^[0-9]/.test(String(vehicleno || '')); }

// // // // ---- Direction pointer “on the circle” DivIcon ----
// // // // function createVehicleDivIcon(label, headingDeg) {
// // // //   const circle = 20;
// // // //   const border = 3;
// // // //   const triH = 18;
// // // //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// // // //   const totalH = triH + circle;

// // // //   const html = `
// // // //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// // // //       <div style="
// // // //         position:absolute; left:0; right:0; bottom:0;
// // // //         width:${circle}px; height:${circle}px;
// // // //         border:${border}px solid #0D47A1; background:#ffffff; border-radius:50%;
// // // //         display:flex; align-items:center; justify-content:center;
// // // //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// // // //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // //         letter-spacing:0.6px; user-select:none;">
// // // //         <span style="font-size:16px; color:#0D47A1">${label}</span>
// // // //       </div>
// // // //       <div style="
// // // //         position:absolute; left:50%; top:0;
// // // //         transform: translateX(-250%) rotate(${rot}deg);
// // // //         transform-origin: 50% ${triH * 0.7}px;
// // // //         width:0; height:0;
// // // //         border-left:${triH / 4}px solid transparent;
// // // //         border-right:${triH / 4}px solid transparent;
// // // //         border-bottom:${triH}px solid #0D47A1;
// // // //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// // // //         z-index: 2; pointer-events: none;"></div>
// // // //     </div>
// // // //   `;

// // // //   return L.divIcon({
// // // //     className: 'veh-div-icon',
// // // //     html,
// // // //     iconSize: [circle, totalH],
// // // //     iconAnchor: [circle / 2, totalH - circle / 2],
// // // //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// // // //   });
// // // // }

// // // function createVehicleDivIcon(label, headingDeg, palette) {
// // //   const circle = 20;
// // //   const border = 3;
// // //   const triH = 18;
// // //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// // //   const totalH = triH + circle;

// // //   // default bus palette
// // //   const p = palette || {
// // //     stroke: "#0D47A1",
// // //     fill: "#ffffff",
// // //     text: "#0D47A1",
// // //     pointer: "#0D47A1",
// // //   };

// // //   const html = `
// // //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// // //       <div style="
// // //         position:absolute; left:0; right:0; bottom:0;
// // //         width:${circle}px; height:${circle}px;
// // //         border:${border}px solid ${p.stroke};
// // //         background:${p.fill};
// // //         border-radius:50%;
// // //         display:flex; align-items:center; justify-content:center;
// // //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// // //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // //         letter-spacing:0.6px; user-select:none;">
// // //         <span style="font-size:16px; color:${p.text}">${label}</span>
// // //       </div>
// // //       <div style="
// // //         position:absolute; left:50%; top:0;
// // //         transform: translateX(-250%) rotate(${rot}deg);
// // //         transform-origin: 50% ${triH * 0.7}px;
// // //         width:0; height:0;
// // //         border-left:${triH / 4}px solid transparent;
// // //         border-right:${triH / 4}px solid transparent;
// // //         border-bottom:${triH}px solid ${p.pointer};
// // //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// // //         z-index: 2; pointer-events: none;"></div>
// // //     </div>
// // //   `;

// // //   return L.divIcon({
// // //     className: 'veh-div-icon',
// // //     html,
// // //     iconSize: [circle, totalH],
// // //     iconAnchor: [circle / 2, totalH - circle / 2],
// // //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// // //   });
// // // }

// // // // const BUS_PALETTE = {
// // // //   stroke: "#0D47A1",
// // // //   fill: "#ffffff",
// // // //   text: "#0D47A1",
// // // //   pointer: "#0D47A1",
// // // // };

// // // // const BUS_PALETTE = {
// // // //   stroke: "#EA580C",   // orange bus border
// // // //   fill: "#FFF7ED",     // light orange fill
// // // //   text: "#9A3412",
// // // //   pointer: "#EA580C",
// // // // };

// // // // const CART_PALETTE = {
// // // //   stroke: "#0F766E",  // teal border
// // // //   fill: "#ECFEFF",    // light teal fill
// // // //   text: "#0F766E",
// // // //   pointer: "#0F766E",
// // // // };
// // // const CART_PALETTE = {
// // //   stroke: "#111827",   // near-black border
// // //   fill: "#FEF08A",   // bright yellow fill
// // //   text: "#111827",   // black text
// // //   pointer: "#111827",   // black pointer
// // // };

// // // const BUS_PALETTE = {
// // //   stroke: "#111827",   // near-black border
// // //   fill: "#FEF08A",   // bright yellow fill
// // //   text: "#111827",   // black text
// // //   pointer: "#111827",   // black pointer
// // // };



// // // function matchesFilter(vehicleno, filter, assignments) {
// // //   const cart = isCart(vehicleno);
// // //   if (filter === "cart") return cart;
// // //   if (filter === "bus") return !cart;

// // //   if (filter?.startsWith("route:")) {
// // //     const requested = normalizeRouteNo(filter.slice(6));
// // //     const actualRouteNo = normalizeRouteNo(getBusRouteNo(vehicleno, assignments));
// // //     const assignedRaw = getAssignedRouteValue(vehicleno, assignments);
// // //     const assignedRouteNo = normalizeRouteNo(routeNoFromRouteCode(assignedRaw));

// // //     return actualRouteNo === requested || assignedRouteNo === requested;
// // //   }
// // //   return true;
// // // }

// // // // ---- Filter helper ----
// // // // function matchesFilter(vehicleno, filter, assignments) {
// // // //   const cart = isCart(vehicleno);
// // // //   if (filter === 'cart') return cart;
// // // //   if (filter === 'bus')  return !cart;
// // // //   if (filter?.startsWith('route:')) {
// // // //     const code = filter.slice(6);
// // // //     return assignments[vehicleno] === code;
// // // //   }
// // // //   return true;
// // // // }

// // // // ---------------- Tiny router helpers (for /driver, /driverRoute) ----------------
// // // function usePath() {
// // //   const [path, setPath] = useState(window.location.pathname);
// // //   useEffect(() => {
// // //     const onPop = () => setPath(window.location.pathname);
// // //     window.addEventListener('popstate', onPop);
// // //     return () => window.removeEventListener('popstate', onPop);
// // //   }, []);
// // //   const navigate = (p) => { if (p !== window.location.pathname) { window.history.pushState({}, "", p); setPath(p); } };
// // //   return { path, navigate };
// // // }
// // // function getToken() { return localStorage.getItem("driverToken") || ""; }
// // // function setToken(t) { localStorage.setItem("driverToken", t || ""); }
// // // function getUsername() { return localStorage.getItem("driverUsername") || ""; }
// // // function setUsername(u) { localStorage.setItem("driverUsername", u || ""); }

// // // // --- Admin auth helpers (separate from driver) ---
// // // function getAdminToken() {
// // //   return localStorage.getItem("adminToken") || "";
// // // }
// // // function setAdminToken(t) {
// // //   localStorage.setItem("adminToken", t || "");
// // // }


// // // // ---------------- Driver pages ----------------
// // // // --- small responsive hook for narrow phones ---
// // // function useIsNarrow(bp = 380) {
// // //   const [isNarrow, setIsNarrow] = useState(window.innerWidth <= bp);
// // //   useEffect(() => {
// // //     const onResize = () => setIsNarrow(window.innerWidth <= bp);
// // //     window.addEventListener('resize', onResize);
// // //     return () => window.removeEventListener('resize', onResize);
// // //   }, [bp]);
// // //   return isNarrow;
// // // }

// // // function DriverLogin({ navigate }) {
// // //   const [username, setU] = useState("");
// // //   const [password, setP] = useState("");
// // //   const [err, setErr] = useState("");
// // //   const [busy, setBusy] = useState(false);
// // //   const isNarrow = useIsNarrow(380);

// // //   useEffect(() => {
// // //     if (getToken()) navigate("/driverRoute");
// // //   }, [navigate]);

// // //   const onSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setErr(""); setBusy(true);
// // //     try {
// // //       const r = await axios.post(`${BACKEND}/api/driver/login`, { username, password });
// // //       if (r.data?.success && r.data?.token) {
// // //         setToken(r.data.token);
// // //         setUsername(r.data.username);
// // //         navigate("/driverRoute");
// // //       } else setErr("Login failed");
// // //     } catch (e1) {
// // //       setErr(e1?.response?.data?.message || "Login failed");
// // //     } finally { setBusy(false); }
// // //   };

// // //   return (
// // //     <div
// // //       style={{
// // //         padding: isNarrow ? 12 : 20,
// // //         margin: isNarrow ? "16px auto" : "32px auto",
// // //         width: "min(100vw - 24px, 560px)",
// // //       }}
// // //     >
// // //       {/* Header with Home button */}
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           alignItems: "center",
// // //           gap: isNarrow ? 10 : 12,
// // //           marginBottom: isNarrow ? 10 : 14,
// // //           flexWrap: "wrap",
// // //         }}
// // //       >
// // //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // //           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Driver Login</h2>
// // //         </div>

// // //         <button
// // //           type="button"
// // //           onClick={() => navigate("/")}
// // //           style={{
// // //             marginLeft: "auto",
// // //             padding: isNarrow ? "6px 10px" : "8px 12px",
// // //             borderRadius: 10,
// // //             border: "1px solid #D1D5DB",
// // //             background: "#FFFFFF",
// // //             fontWeight: 700,
// // //             fontSize: isNarrow ? 13 : 14,
// // //             cursor: "pointer",
// // //           }}
// // //           title="Go to Home"
// // //         >
// // //           Home
// // //         </button>
// // //       </div>

// // //       {/* Card */}
// // //       <div
// // //         style={{
// // //           background: "#fff",
// // //           border: "1px solid #E5E7EB",
// // //           borderRadius: 12,
// // //           padding: isNarrow ? 12 : 16,
// // //         }}
// // //       >
// // //         <form onSubmit={onSubmit} style={{ display: "grid", gap: isNarrow ? 8 : 10 }}>
// // //           <input
// // //             value={username}
// // //             onChange={(e) => setU(e.target.value)}
// // //             placeholder="username"
// // //             required
// // //             style={{
// // //               padding: isNarrow ? 10 : 12,
// // //               borderRadius: 10,
// // //               border: "1px solid #D1D5DB",
// // //               fontWeight: 600,
// // //               fontSize: isNarrow ? 14 : 16,
// // //             }}
// // //           />
// // //           <input
// // //             value={password}
// // //             onChange={(e) => setP(e.target.value)}
// // //             placeholder="password"
// // //             type="password"
// // //             required
// // //             style={{
// // //               padding: isNarrow ? 10 : 12,
// // //               borderRadius: 10,
// // //               border: "1px solid #D1D5DB",
// // //               fontWeight: 600,
// // //               fontSize: isNarrow ? 14 : 16,
// // //             }}
// // //           />
// // //           <button
// // //             disabled={busy}
// // //             style={{
// // //               padding: isNarrow ? "10px 12px" : "12px 14px",
// // //               borderRadius: 10,
// // //               border: "1px solid #0D47A1",
// // //               background: "#0D47A1",
// // //               color: "#fff",
// // //               fontWeight: 800,
// // //               cursor: "pointer",
// // //               width: "100%",
// // //               minHeight: 40,
// // //               fontSize: "clamp(14px, 3.5vw, 16px)",
// // //             }}
// // //           >
// // //             {busy ? "Signing in..." : "Login"}
// // //           </button>
// // //           {err && <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>}
// // //         </form>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function DriverRoute({ navigate }) {
// // //   const [routeCode, setRouteCode] = useState("");
// // //   const [vehicleNo, setVehicleNo] = useState("");
// // //   const [autoPilot, setAutoPilot] = useState(false); // 👈 NEW: auto-pilot flag
// // //   const [saved, setSaved] = useState(false);
// // //   const [busy, setBusy] = useState(false);
// // //   const [err, setErr] = useState("");
// // //   const isNarrow = useIsNarrow(380);

// // //   useEffect(() => {
// // //     if (!getToken()) navigate("/driver");
// // //     (async () => {
// // //       try {
// // //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// // //           headers: { Authorization: `Bearer ${getToken()}` },
// // //         });
// // //         const row = r.data?.row;
// // //         if (row) {
// // //           setVehicleNo(row.vehicleNo);
// // //           setRouteCode(row.routeCode);
// // //           setAutoPilot(!!row.autopilotEnabled); // 👈 load auto-pilot state from backend
// // //           setSaved(true);
// // //         }
// // //       } catch { }
// // //     })();
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, []);

// // //   const onSave = async (e) => {
// // //     e.preventDefault();
// // //     setErr(""); setBusy(true);
// // //     try {
// // //       await axios.post(
// // //         `${BACKEND}/api/vehicle-route/assign`,
// // //         {
// // //           vehicleNo,
// // //           routeCode,
// // //           active: true,
// // //           autopilotEnabled: autoPilot, // 👈 send auto-pilot choice to backend
// // //         },
// // //         { headers: { Authorization: `Bearer ${getToken()}` } }
// // //       );
// // //       setSaved(true);
// // //     } catch (e1) {
// // //       setErr(e1?.response?.data?.message || "Save failed");
// // //     } finally {
// // //       setBusy(false);
// // //     }
// // //   };

// // //   return (
// // //     <div
// // //       style={{
// // //         padding: isNarrow ? 16 : 20,
// // //         maxWidth: 640,
// // //         margin: isNarrow ? "16px auto" : "32px auto",
// // //         width: "min(100vw - 24px, 640px)",
// // //       }}
// // //     >
// // //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// // //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// // //         </div>
// // //         <div
// // //           style={{
// // //             marginLeft: 'auto',
// // //             fontWeight: 700,
// // //             opacity: 0.8,
// // //             fontSize: "clamp(13px, 3.2vw, 16px)",
// // //             maxWidth: '60%',
// // //             overflow: 'hidden',
// // //             textOverflow: 'ellipsis',
// // //             whiteSpace: 'nowrap',
// // //           }}
// // //           title={`@${getUsername()}`}
// // //         >
// // //           @{getUsername()}
// // //         </div>
// // //       </div>

// // //       {/* Top-right actions */}
// // //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// // //         <div style={{ display: 'flex', gap: 8 }}>
// // //           <button
// // //             onClick={() => navigate('/')}
// // //             style={{
// // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // //               borderRadius: 10,
// // //               border: '1px solid #D1D5DB',
// // //               background: '#FFFFFF',
// // //               fontWeight: 700,
// // //               fontSize: isNarrow ? 13 : 14,
// // //               cursor: 'pointer'
// // //             }}
// // //             title="Go to Home"
// // //           >
// // //             Home
// // //           </button>
// // //           <button
// // //             type="button"
// // //             onClick={() => setSaved(false)}
// // //             disabled={!saved}
// // //             style={{
// // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // //               borderRadius: 10,
// // //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// // //               background: saved ? '#fff' : '#F9FAFB',
// // //               color: saved ? '#111' : '#9CA3AF',
// // //               fontWeight: 800,
// // //               fontSize: isNarrow ? 13 : 14,
// // //               cursor: saved ? 'pointer' : 'not-allowed'
// // //             }}
// // //             title="Edit selection"
// // //           >
// // //             Edit
// // //           </button>
// // //         </div>

// // //         <button
// // //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// // //           style={{
// // //             padding: isNarrow ? '6px 10px' : 8,
// // //             borderRadius: 10,
// // //             border: '1px solid #D1D5DB',
// // //             background: '#FFFFFF',
// // //             fontSize: isNarrow ? 13 : 14,
// // //             cursor: 'pointer'
// // //           }}
// // //           title="Logout"
// // //         >
// // //           Logout
// // //         </button>
// // //       </div>

// // //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// // //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// // //         <select
// // //           disabled={saved}
// // //           value={routeCode}
// // //           onChange={e => setRouteCode(e.target.value)}
// // //           required
// // //           style={{
// // //             padding: isNarrow ? 10 : 12,
// // //             borderRadius: 10,
// // //             border: '1px solid #D1D5DB',
// // //             fontSize: isNarrow ? 14 : 16
// // //           }}
// // //         >
// // //           <option value="">Select route…</option>
// // //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// // //         </select>

// // //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// // //         <select
// // //           disabled={saved}
// // //           value={vehicleNo}
// // //           onChange={e => setVehicleNo(e.target.value)}
// // //           required
// // //           style={{
// // //             padding: isNarrow ? 10 : 12,
// // //             borderRadius: 10,
// // //             border: '1px solid #D1D5DB',
// // //             fontSize: isNarrow ? 14 : 16
// // //           }}
// // //         >
// // //           <option value="">Select vehicle…</option>
// // //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>

// // //         {/* 👇 NEW: Auto-pilot toggle */}
// // //         <div
// // //           style={{
// // //             marginTop: isNarrow ? 6 : 8,
// // //             padding: isNarrow ? 8 : 10,
// // //             borderRadius: 10,
// // //             border: '1px solid #E5E7EB',
// // //             background: '#F9FAFB',
// // //             display: 'flex',
// // //             alignItems: 'flex-start',
// // //             gap: 8,
// // //           }}
// // //         >
// // //           <input
// // //             id="autoPilot"
// // //             type="checkbox"
// // //             checked={autoPilot}
// // //             disabled={saved}
// // //             onChange={(e) => setAutoPilot(e.target.checked)}
// // //             style={{ marginTop: 3, cursor: saved ? 'default' : 'pointer' }}
// // //           />
// // //           <label
// // //             htmlFor="autoPilot"
// // //             style={{ cursor: saved ? 'default' : 'pointer' }}
// // //           >
// // //             <div style={{ fontWeight: 700, fontSize: isNarrow ? 14 : 15 }}>
// // //               Auto-pilot (auto reverse at destination)
// // //             </div>
// // //             <div
// // //               style={{
// // //                 fontSize: isNarrow ? 12 : 13,
// // //                 color: '#6B7280',
// // //                 marginTop: 2,
// // //               }}
// // //             >
// // //               When enabled, once you reach the last stop of this route, your
// // //               assignment will automatically switch to the return leg.
// // //             </div>
// // //           </label>
// // //         </div>

// // //         <button
// // //           disabled={busy || saved}
// // //           style={{
// // //             padding: isNarrow ? '10px 12px' : '12px 14px',
// // //             borderRadius: 10,
// // //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// // //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// // //             color: busy || saved ? '#6B7280' : '#fff',
// // //             fontWeight: 800,
// // //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// // //             minHeight: 44,
// // //             fontSize: "clamp(14px, 3.5vw, 16px)"
// // //           }}
// // //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// // //         >
// // //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// // //         </button>

// // //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// // //       </form>
// // //     </div>
// // //   );
// // // }


// // // // function DriverRoute({ navigate }) {
// // // //   const [routeCode, setRouteCode] = useState("");
// // // //   const [vehicleNo, setVehicleNo] = useState("");
// // // //   const [saved, setSaved] = useState(false);
// // // //   const [busy, setBusy] = useState(false);
// // // //   const [err, setErr] = useState("");
// // // //   const isNarrow = useIsNarrow(380);

// // // //   useEffect(() => {
// // // //     if (!getToken()) navigate("/driver");
// // // //     (async () => {
// // // //       try {
// // // //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// // // //           headers: { Authorization: `Bearer ${getToken()}` },
// // // //         });
// // // //         const row = r.data?.row;
// // // //         if (row) { setVehicleNo(row.vehicleNo); setRouteCode(row.routeCode); setSaved(true); }
// // // //       } catch {}
// // // //     })();
// // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // //   }, []);

// // // //   const onSave = async (e) => {
// // // //     e.preventDefault();
// // // //     setErr(""); setBusy(true);
// // // //     try {
// // // //       await axios.post(
// // // //         `${BACKEND}/api/vehicle-route/assign`,
// // // //         { vehicleNo, routeCode, active: true },
// // // //         { headers: { Authorization: `Bearer ${getToken()}` } }
// // // //       );
// // // //       setSaved(true);
// // // //     } catch (e1) {
// // // //       setErr(e1?.response?.data?.message || "Save failed");
// // // //     } finally {
// // // //       setBusy(false);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div
// // // //       style={{
// // // //         padding: isNarrow ? 16 : 20,
// // // //         maxWidth: 640,
// // // //         margin: isNarrow ? "16px auto" : "32px auto",
// // // //         width: "min(100vw - 24px, 640px)",
// // // //       }}
// // // //     >
// // // //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// // // //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// // // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // // //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// // // //         </div>
// // // //         <div
// // // //           style={{
// // // //             marginLeft: 'auto',
// // // //             fontWeight: 700,
// // // //             opacity: 0.8,
// // // //             fontSize: "clamp(13px, 3.2vw, 16px)",
// // // //             maxWidth: '60%',
// // // //             overflow: 'hidden',
// // // //             textOverflow: 'ellipsis',
// // // //             whiteSpace: 'nowrap',
// // // //           }}
// // // //           title={`@${getUsername()}`}
// // // //         >
// // // //           @{getUsername()}
// // // //         </div>
// // // //       </div>

// // // //       {/* Top-right actions */}
// // // //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// // // //         <div style={{ display: 'flex', gap: 8 }}>
// // // //           <button
// // // //             onClick={() => navigate('/')}
// // // //             style={{
// // // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // // //               borderRadius: 10,
// // // //               border: '1px solid #D1D5DB',
// // // //               background: '#FFFFFF',
// // // //               fontWeight: 700,
// // // //               fontSize: isNarrow ? 13 : 14,
// // // //               cursor: 'pointer'
// // // //             }}
// // // //             title="Go to Home"
// // // //           >
// // // //             Home
// // // //           </button>
// // // //           <button
// // // //             type="button"
// // // //             onClick={() => setSaved(false)}
// // // //             disabled={!saved}
// // // //             style={{
// // // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // // //               borderRadius: 10,
// // // //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// // // //               background: saved ? '#fff' : '#F9FAFB',
// // // //               color: saved ? '#111' : '#9CA3AF',
// // // //               fontWeight: 800,
// // // //               fontSize: isNarrow ? 13 : 14,
// // // //               cursor: saved ? 'pointer' : 'not-allowed'
// // // //             }}
// // // //             title="Edit selection"
// // // //           >
// // // //             Edit
// // // //           </button>
// // // //         </div>

// // // //         <button
// // // //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// // // //           style={{
// // // //             padding: isNarrow ? '6px 10px' : 8,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #D1D5DB',
// // // //             background: '#FFFFFF',
// // // //             fontSize: isNarrow ? 13 : 14,
// // // //             cursor: 'pointer'
// // // //           }}
// // // //           title="Logout"
// // // //         >
// // // //           Logout
// // // //         </button>
// // // //       </div>

// // // //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// // // //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// // // //         <select
// // // //           disabled={saved}
// // // //           value={routeCode}
// // // //           onChange={e=>setRouteCode(e.target.value)}
// // // //           required
// // // //           style={{
// // // //             padding: isNarrow ? 10 : 12,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #D1D5DB',
// // // //             fontSize: isNarrow ? 14 : 16
// // // //           }}
// // // //         >
// // // //           <option value="">Select route…</option>
// // // //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// // // //         </select>

// // // //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// // // //         <select
// // // //           disabled={saved}
// // // //           value={vehicleNo}
// // // //           onChange={e=>setVehicleNo(e.target.value)}
// // // //           required
// // // //           style={{
// // // //             padding: isNarrow ? 10 : 12,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #D1D5DB',
// // // //             fontSize: isNarrow ? 14 : 16
// // // //           }}
// // // //         >
// // // //           <option value="">Select vehicle…</option>
// // // //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>

// // // //         <button
// // // //           disabled={busy || saved}
// // // //           style={{
// // // //             padding: isNarrow ? '10px 12px' : '12px 14px',
// // // //             borderRadius: 10,
// // // //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// // // //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// // // //             color: busy || saved ? '#6B7280' : '#fff',
// // // //             fontWeight: 800,
// // // //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// // // //             minHeight: 44,
// // // //             fontSize: "clamp(14px, 3.5vw, 16px)"
// // // //           }}
// // // //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// // // //         >
// // // //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// // // //         </button>

// // // //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// // // //       </form>
// // // //     </div>
// // // //   );
// // // // }

// // // /* ---------------------------- ADMIN PAGES ---------------------------- */

// // // function AdminLogin({ navigate }) {
// // //   const [username, setU] = useState("");
// // //   const [password, setP] = useState("");
// // //   const [err, setErr] = useState("");
// // //   const [busy, setBusy] = useState(false);
// // //   const isNarrow = useIsNarrow(380);

// // //   useEffect(() => {
// // //     if (getAdminToken()) navigate("/admin");
// // //   }, [navigate]);

// // //   const onSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setErr("");
// // //     setBusy(true);
// // //     try {
// // //       const r = await axios.post(`${BACKEND}/api/admin/login`, {
// // //         username,
// // //         password,
// // //       });
// // //       if (r.data?.success && r.data?.token) {
// // //         setAdminToken(r.data.token);
// // //         navigate("/admin");
// // //       } else {
// // //         setErr("Login failed");
// // //       }
// // //     } catch (e1) {
// // //       setErr(e1?.response?.data?.message || "Login failed");
// // //     } finally {
// // //       setBusy(false);
// // //     }
// // //   };

// // //   return (
// // //     <div
// // //       style={{
// // //         padding: isNarrow ? 12 : 20,
// // //         margin: isNarrow ? "16px auto" : "32px auto",
// // //         width: "min(100vw - 24px, 560px)",
// // //       }}
// // //     >
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           alignItems: "center",
// // //           gap: isNarrow ? 10 : 12,
// // //           marginBottom: isNarrow ? 10 : 14,
// // //           flexWrap: "wrap",
// // //         }}
// // //       >
// // //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// // //           <img
// // //             src={iitmLogo}
// // //             alt="IITM"
// // //             style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }}
// // //           />
// // //           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Admin Login</h2>
// // //         </div>
// // //         <button
// // //           type="button"
// // //           onClick={() => navigate("/")}
// // //           style={{
// // //             marginLeft: "auto",
// // //             padding: isNarrow ? "6px 10px" : "8px 12px",
// // //             borderRadius: 10,
// // //             border: "1px solid #D1D5DB",
// // //             background: "#FFFFFF",
// // //             fontWeight: 700,
// // //             fontSize: isNarrow ? 13 : 14,
// // //             cursor: "pointer",
// // //           }}
// // //           title="Go to Home"
// // //         >
// // //           Home
// // //         </button>
// // //       </div>
// // //       <div
// // //         style={{
// // //           background: "#fff",
// // //           border: "1px solid #E5E7EB",
// // //           borderRadius: 12,
// // //           padding: isNarrow ? 12 : 16,
// // //         }}
// // //       >
// // //         <form
// // //           onSubmit={onSubmit}
// // //           style={{ display: "grid", gap: isNarrow ? 8 : 10 }}
// // //         >
// // //           <input
// // //             value={username}
// // //             onChange={(e) => setU(e.target.value)}
// // //             placeholder="admin username"
// // //             required
// // //             style={{
// // //               padding: isNarrow ? 10 : 12,
// // //               borderRadius: 10,
// // //               border: "1px solid #D1D5DB",
// // //               fontWeight: 600,
// // //               fontSize: isNarrow ? 14 : 16,
// // //             }}
// // //           />
// // //           <input
// // //             value={password}
// // //             onChange={(e) => setP(e.target.value)}
// // //             placeholder="admin password"
// // //             type="password"
// // //             required
// // //             style={{
// // //               padding: isNarrow ? 10 : 12,
// // //               borderRadius: 10,
// // //               border: "1px solid #D1D5DB",
// // //               fontWeight: 600,
// // //               fontSize: isNarrow ? 14 : 16,
// // //             }}
// // //           />
// // //           <button
// // //             disabled={busy}
// // //             style={{
// // //               padding: isNarrow ? "10px 12px" : "12px 14px",
// // //               borderRadius: 10,
// // //               border: "1px solid #0D47A1",
// // //               background: "#0D47A1",
// // //               color: "#fff",
// // //               fontWeight: 800,
// // //               cursor: "pointer",
// // //               width: "100%",
// // //               minHeight: 40,
// // //               fontSize: "clamp(14px, 3.5vw, 16px)",
// // //             }}
// // //           >
// // //             {busy ? "Signing in..." : "Login"}
// // //           </button>
// // //           {err && (
// // //             <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>
// // //           )}
// // //         </form>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function AdminDashboard({ navigate }) {
// // //   const [tab, setTab] = useState("drivers"); // 'drivers' | 'routes' | 'live'
// // //   const [drivers, setDrivers] = useState([]);
// // //   const [assignments, setAssignments] = useState({}); // vehicleNo -> row
// // //   const [localAssign, setLocalAssign] = useState({}); // vehicleNo -> { routeCode, driverId, autopilotEnabled }
// // //   const [editing, setEditing] = useState({}); // vehicleNo -> true when row is in edit mode
// // //   const [newName, setNewName] = useState("");
// // //   const [newPhone, setNewPhone] = useState("");
// // //   const [err, setErr] = useState("");
// // //   const [busySave, setBusySave] = useState(null); // vehicleno while saving
// // //   const [liveBuses, setLiveBuses] = useState([]);
// // //   const adminToken = getAdminToken();
// // //   const isNarrow = useIsNarrow(480);

// // //   useEffect(() => {
// // //     if (!adminToken) navigate("/admin/login");
// // //   }, [adminToken, navigate]);

// // //   const authHeader = useMemo(
// // //     () => ({
// // //       headers: { Authorization: `Bearer ${adminToken}` },
// // //     }),
// // //     [adminToken]
// // //   );

// // //   async function loadDrivers() {
// // //     try {
// // //       const r = await axios.get(`${BACKEND}/api/admin/drivers`, authHeader);
// // //       setDrivers(r.data?.drivers || []);
// // //     } catch (e) {
// // //       console.warn("loadDrivers error", e?.message || e);
// // //     }
// // //   }

// // //   async function loadAssignments() {
// // //     try {
// // //       const r = await axios.get(`${BACKEND}/api/admin/assignments`, authHeader);
// // //       const rows = r.data?.rows || [];
// // //       const map = {};
// // //       for (const row of rows) {
// // //         map[row.vehicleNo] = row;
// // //       }
// // //       setAssignments(map);
// // //       // whenever we reload from backend, treat all as "saved" (not editing)
// // //       setEditing({});
// // //       setLocalAssign({});
// // //     } catch (e) {
// // //       console.warn("loadAssignments error", e?.message || e);
// // //     }
// // //   }

// // //   useEffect(() => {
// // //     if (!adminToken) return;
// // //     loadDrivers();
// // //     loadAssignments();
// // //   }, [adminToken]); // eslint-disable-line react-hooks/exhaustive-deps

// // //   // live tracking (simple polling)
// // //   useEffect(() => {
// // //     if (tab !== "live") return;
// // //     let cancelled = false;

// // //     async function loadLive() {
// // //       try {
// // //         const r = await axios.get(`${BACKEND}/api/vehicle-data`, {
// // //           timeout: 8000,
// // //         });
// // //         if (!cancelled) {
// // //           const arr = Array.isArray(r.data) ? r.data : [];
// // //           setLiveBuses(arr);
// // //         }
// // //       } catch (e) {
// // //         if (!cancelled) {
// // //           console.warn("admin live map error", e?.message || e);
// // //         }
// // //       }
// // //     }
// // //     loadLive();
// // //     const id = setInterval(loadLive, 5000);
// // //     return () => {
// // //       cancelled = true;
// // //       clearInterval(id);
// // //     };
// // //   }, [tab]);

// // //   const handleAddDriver = async (e) => {
// // //     e.preventDefault();
// // //     setErr("");
// // //     try {
// // //       const r = await axios.post(
// // //         `${BACKEND}/api/admin/drivers`,
// // //         { name: newName, phoneNumber: newPhone },
// // //         authHeader
// // //       );
// // //       if (r.data?.success && r.data?.driver) {
// // //         setDrivers((prev) => [...prev, r.data.driver]);
// // //         setNewName("");
// // //         setNewPhone("");
// // //       } else {
// // //         setErr("Failed to create driver");
// // //       }
// // //     } catch (e1) {
// // //       setErr(e1?.response?.data?.message || "Failed to create driver");
// // //     }
// // //   };

// // //   const handleRemoveDriver = async (id) => {
// // //     if (!window.confirm("Remove this driver?")) return;
// // //     try {
// // //       await axios.delete(`${BACKEND}/api/admin/drivers/${id}`, authHeader);
// // //       setDrivers((prev) => prev.filter((d) => d._id !== id));
// // //       // Note: assignments that still reference this driver will continue to exist until reassigned
// // //     } catch (e1) {
// // //       alert(e1?.response?.data?.message || "Failed to remove driver");
// // //     }
// // //   };

// // //   function getBaseAssignForVehicle(veh) {
// // //     const row = assignments[veh];
// // //     if (!row) {
// // //       return {
// // //         vehicleNo: veh,
// // //         routeCode: "",
// // //         driverId: "",
// // //         autopilotEnabled: false,
// // //       };
// // //     }
// // //     return {
// // //       vehicleNo: veh,
// // //       routeCode: row.routeCode || "",
// // //       driverId: row.driver?._id || "",
// // //       autopilotEnabled: !!row.autopilotEnabled,
// // //     };
// // //   }

// // //   function updateLocalAssign(veh, patch) {
// // //     setLocalAssign((prev) => ({
// // //       ...prev,
// // //       [veh]: { ...getBaseAssignForVehicle(veh), ...(prev[veh] || {}), ...patch },
// // //     }));
// // //   }

// // //   const handleSaveAssignment = async (veh) => {
// // //     const base = getBaseAssignForVehicle(veh);
// // //     const row = localAssign[veh] || base;
// // //     const hasAssignment = !!assignments[veh]; // vehicle currently has an active route?

// // //     // RESET error first
// // //     setErr("");

// // //     // ---- CASE 1: Admin cleared both fields and there *was* an assignment -> CLEAR MODE ----
// // //     if (!row.routeCode && !row.driverId && hasAssignment) {
// // //       setBusySave(veh);
// // //       try {
// // //         await axios.post(
// // //           `${BACKEND}/api/admin/vehicle-assign`,
// // //           {
// // //             vehicleNo: row.vehicleNo,
// // //             clear: true,              // 👈 tells backend: deactivate assignment
// // //           },
// // //           authHeader
// // //         );
// // //         await loadAssignments();      // refresh table
// // //         setEditing((prev) => ({ ...prev, [veh]: false }));
// // //       } catch (e1) {
// // //         setErr(e1?.response?.data?.message || "Failed to clear assignment");
// // //       } finally {
// // //         setBusySave(null);
// // //       }
// // //       return;
// // //     }

// // //     // ---- CASE 2: No assignment and still empty -> nothing to save ----
// // //     if (!row.routeCode || !row.driverId) {
// // //       setErr("Select both Route & Driver, or leave the row as-is.");
// // //       return;
// // //     }

// // //     // ---- CASE 3: Normal ASSIGN / UPDATE ----
// // //     setBusySave(veh);
// // //     try {
// // //       await axios.post(
// // //         `${BACKEND}/api/admin/vehicle-assign`,
// // //         {
// // //           vehicleNo: row.vehicleNo,
// // //           routeCode: row.routeCode,
// // //           driverId: row.driverId,
// // //           autopilotEnabled: !!row.autopilotEnabled,
// // //         },
// // //         authHeader
// // //       );
// // //       await loadAssignments();
// // //       setEditing((prev) => ({ ...prev, [veh]: false }));
// // //     } catch (e1) {
// // //       setErr(e1?.response?.data?.message || "Failed to save assignment");
// // //     } finally {
// // //       setBusySave(null);
// // //     }
// // //   };


// // //   const onLogout = () => {
// // //     setAdminToken("");
// // //     navigate("/admin/login");
// // //   };

// // //   // simple driver lookup for live map
// // //   const driverByVehicle = useMemo(() => {
// // //     const out = {};
// // //     Object.values(assignments).forEach((row) => {
// // //       if (row.vehicleNo && row.driver) {
// // //         out[row.vehicleNo] = row.driver;
// // //       }
// // //     });
// // //     return out;
// // //   }, [assignments]);

// // //   return (
// // //     <div className="admin-layout">
// // //       {/* left sidebar */}
// // //       <div
// // //         className="sidebar"
// // //         style={{
// // //           width: isNarrow ? 220 : 260, // responsive width override
// // //         }}
// // //       >
// // //         {/* top section: logo, back button, nav */}
// // //         <div>
// // //           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// // //             <img
// // //               src={iitmLogo}
// // //               alt="IITM"
// // //               style={{ width: 32, height: 32, borderRadius: 8 }}
// // //             />
// // //             <div>
// // //               <div style={{ fontWeight: 800, fontSize: 16 }}>Admin</div>
// // //               <div style={{ fontSize: 12, opacity: 0.8 }}>Thoothukudi Bus Tracking</div>
// // //             </div>
// // //           </div>
// // //           <button
// // //             onClick={() => navigate("/")}
// // //             style={{
// // //               marginTop: 8,
// // //               textAlign: "left",
// // //               padding: "6px 10px",
// // //               borderRadius: 10,
// // //               border: "1px solid #4b5563",
// // //               background: "transparent",
// // //               color: "#e5e7eb",
// // //               cursor: "pointer",
// // //               fontSize: 13,
// // //             }}
// // //           >
// // //             ← Back to map
// // //           </button>
// // //           <div
// // //             style={{
// // //               marginTop: 16,
// // //               display: "flex",
// // //               flexDirection: "column",
// // //               gap: 6,
// // //             }}
// // //           >
// // //             <button
// // //               onClick={() => setTab("drivers")}
// // //               style={{
// // //                 textAlign: "left",
// // //                 padding: "8px 10px",
// // //                 borderRadius: 10,
// // //                 border: "none",
// // //                 background: tab === "drivers" ? "#f9fafb" : "transparent",
// // //                 color: tab === "drivers" ? "#111827" : "#e5e7eb",
// // //                 fontWeight: 600,
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               + Add Driver
// // //             </button>
// // //             <button
// // //               onClick={() => setTab("routes")}
// // //               style={{
// // //                 textAlign: "left",
// // //                 padding: "8px 10px",
// // //                 borderRadius: 10,
// // //                 border: "none",
// // //                 background: tab === "routes" ? "#f9fafb" : "transparent",
// // //                 color: tab === "routes" ? "#111827" : "#e5e7eb",
// // //                 fontWeight: 600,
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               Route Allocation
// // //             </button>
// // //             <button
// // //               onClick={() => setTab("live")}
// // //               style={{
// // //                 textAlign: "left",
// // //                 padding: "8px 10px",
// // //                 borderRadius: 10,
// // //                 border: "none",
// // //                 background: tab === "live" ? "#f9fafb" : "transparent",
// // //                 color: tab === "live" ? "#111827" : "#e5e7eb",
// // //                 fontWeight: 600,
// // //                 cursor: "pointer",
// // //               }}
// // //             >
// // //               Live Tracking
// // //             </button>
// // //           </div>
// // //         </div>

// // //         {/* bottom logout – pinned to sidebar bottom */}
// // //         <button
// // //           onClick={onLogout}
// // //           style={{
// // //             marginTop: 12,
// // //             padding: "8px 10px",
// // //             borderRadius: 10,
// // //             border: "1px solid #6b7280",
// // //             background: "transparent",
// // //             color: "#e5e7eb",
// // //             cursor: "pointer",
// // //             fontSize: 13,
// // //           }}
// // //         >
// // //           Logout
// // //         </button>
// // //       </div>

// // //       {/* main content */}
// // //       <div className="content">
// // //         {tab === "drivers" && (
// // //           <div style={{ maxWidth: 800, margin: "0 auto" }}>
// // //             <h2 style={{ marginTop: 0 }}>Drivers</h2>
// // //             <form
// // //               onSubmit={handleAddDriver}
// // //               style={{
// // //                 display: "grid",
// // //                 gridTemplateColumns: "2fr 2fr auto",
// // //                 gap: 8,
// // //                 alignItems: "center",
// // //                 marginBottom: 16,
// // //               }}
// // //             >
// // //               <input
// // //                 value={newName}
// // //                 onChange={(e) => setNewName(e.target.value)}
// // //                 placeholder="Driver name"
// // //                 required
// // //                 style={{
// // //                   padding: 10,
// // //                   borderRadius: 10,
// // //                   border: "1px solid #D1D5DB",
// // //                   fontSize: 14,
// // //                 }}
// // //               />
// // //               <input
// // //                 value={newPhone}
// // //                 onChange={(e) => setNewPhone(e.target.value)}
// // //                 placeholder="Phone number (unique)"
// // //                 required
// // //                 style={{
// // //                   padding: 10,
// // //                   borderRadius: 10,
// // //                   border: "1px solid #D1D5DB",
// // //                   fontSize: 14,
// // //                 }}
// // //               />
// // //               <button
// // //                 type="submit"
// // //                 style={{
// // //                   padding: "10px 16px",
// // //                   borderRadius: 10,
// // //                   border: "1px solid #0D47A1",
// // //                   background: "#0D47A1",
// // //                   color: "#fff",
// // //                   fontWeight: 700,
// // //                   cursor: "pointer",
// // //                   fontSize: 14,
// // //                 }}
// // //               >
// // //                 Add
// // //               </button>
// // //             </form>
// // //             {err && (
// // //               <div
// // //                 style={{
// // //                   color: "#b00020",
// // //                   fontWeight: 600,
// // //                   marginBottom: 8,
// // //                 }}
// // //               >
// // //                 {err}
// // //               </div>
// // //             )}
// // //             <div
// // //               style={{
// // //                 display: "grid",
// // //                 gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
// // //                 gap: 12,
// // //               }}
// // //             >
// // //               {drivers.map((d) => (
// // //                 <div
// // //                   key={d._id}
// // //                   style={{
// // //                     background: "#fff",
// // //                     borderRadius: 12,
// // //                     border: "1px solid #e5e7eb",
// // //                     padding: 12,
// // //                     display: "flex",
// // //                     flexDirection: "column",
// // //                     gap: 4,
// // //                   }}
// // //                 >
// // //                   <div style={{ fontWeight: 700, fontSize: 15 }}>{d.name}</div>
// // //                   <div style={{ fontSize: 13, opacity: 0.8 }}>
// // //                     Phone: {d.phoneNumber || "—"}
// // //                   </div>
// // //                   <div style={{ fontSize: 12, opacity: 0.6 }}>
// // //                     username: <code>{d.username}</code>
// // //                   </div>
// // //                   <button
// // //                     onClick={() => handleRemoveDriver(d._id)}
// // //                     style={{
// // //                       marginTop: 8,
// // //                       alignSelf: "flex-start",
// // //                       padding: "6px 10px",
// // //                       borderRadius: 8,
// // //                       border: "1px solid #f97373",
// // //                       background: "#fef2f2",
// // //                       color: "#b91c1c",
// // //                       fontSize: 12,
// // //                       fontWeight: 600,
// // //                       cursor: "pointer",
// // //                     }}
// // //                   >
// // //                     Remove
// // //                   </button>
// // //                 </div>
// // //               ))}
// // //               {drivers.length === 0 && (
// // //                 <div style={{ fontSize: 14, opacity: 0.7 }}>
// // //                   No drivers yet. Add your first driver above.
// // //                 </div>
// // //               )}
// // //             </div>
// // //           </div>
// // //         )}

// // //         {tab === "routes" && (
// // //           <div style={{ maxWidth: 1100, margin: "0 auto" }}>
// // //             <h2 style={{ marginTop: 0 }}>Route Allocation</h2>
// // //             {err && (
// // //               <div
// // //                 style={{
// // //                   color: "#b00020",
// // //                   fontWeight: 600,
// // //                   marginBottom: 8,
// // //                 }}
// // //               >
// // //                 {err}
// // //               </div>
// // //             )}
// // //             <div style={{ overflowX: "auto" }}>
// // //               <table
// // //                 style={{
// // //                   width: "100%",
// // //                   borderCollapse: "collapse",
// // //                   background: "#fff",
// // //                   borderRadius: 12,
// // //                   overflow: "hidden",
// // //                 }}
// // //               >
// // //                 <thead>
// // //                   <tr
// // //                     style={{
// // //                       background: "#f9fafb",
// // //                       borderBottom: "1px solid #e5e7eb",
// // //                     }}
// // //                   >
// // //                     <th style={{ padding: 8, textAlign: "left" }}>#</th>
// // //                     <th style={{ padding: 8, textAlign: "left" }}>Vehicle</th>
// // //                     <th style={{ padding: 8, textAlign: "left" }}>Route</th>
// // //                     <th style={{ padding: 8, textAlign: "left" }}>Driver</th>
// // //                     <th style={{ padding: 8, textAlign: "left" }}>Auto-pilot</th>
// // //                     <th style={{ padding: 8, textAlign: "left" }} />
// // //                   </tr>
// // //                 </thead>
// // //                 <tbody>
// // //                   {VEHICLES.map((veh, idx) => {
// // //                     const base = getBaseAssignForVehicle(veh);
// // //                     const local = localAssign[veh] || base;
// // //                     const hasAssignment =
// // //                       !!base.routeCode && !!base.driverId; // existing saved row?
// // //                     const isEditing = !!editing[veh];
// // //                     const locked = hasAssignment && !isEditing;
// // //                     const saving = busySave === veh;

// // //                     return (
// // //                       <tr
// // //                         key={veh}
// // //                         style={{ borderBottom: "1px solid #f3f4f6" }}
// // //                       >
// // //                         <td style={{ padding: 8 }}>{idx + 1}</td>
// // //                         <td style={{ padding: 8, fontWeight: 600 }}>{veh}</td>
// // //                         <td style={{ padding: 8 }}>
// // //                           <select
// // //                             value={local.routeCode}
// // //                             onChange={(e) =>
// // //                               updateLocalAssign(veh, {
// // //                                 routeCode: e.target.value,
// // //                               })
// // //                             }
// // //                             disabled={locked || saving}
// // //                             style={{
// // //                               padding: 8,
// // //                               borderRadius: 8,
// // //                               border: "1px solid #d1d5db",
// // //                               fontSize: 13,
// // //                               minWidth: 180,
// // //                               backgroundColor: locked ? "#f9fafb" : "white",
// // //                             }}
// // //                           >
// // //                             <option value="">Select route…</option>
// // //                             {ADMIN_ROUTES.map((r) => (
// // //                               <option key={r.code} value={r.code}>
// // //                                 {r.label}
// // //                               </option>
// // //                             ))}
// // //                           </select>
// // //                         </td>
// // //                         <td style={{ padding: 8 }}>
// // //                           <select
// // //                             value={local.driverId}
// // //                             onChange={(e) =>
// // //                               updateLocalAssign(veh, {
// // //                                 driverId: e.target.value,
// // //                               })
// // //                             }
// // //                             disabled={locked || saving}
// // //                             style={{
// // //                               padding: 8,
// // //                               borderRadius: 8,
// // //                               border: "1px solid #d1d5db",
// // //                               fontSize: 13,
// // //                               minWidth: 180,
// // //                               backgroundColor: locked ? "#f9fafb" : "white",
// // //                             }}
// // //                           >
// // //                             <option value="">Select driver…</option>
// // //                             {drivers.map((d) => (
// // //                               <option key={d._id} value={d._id}>
// // //                                 {d.name} ({d.phoneNumber || d.username})
// // //                               </option>
// // //                             ))}
// // //                           </select>
// // //                         </td>
// // //                         <td style={{ padding: 8 }}>
// // //                           <label
// // //                             style={{
// // //                               display: "inline-flex",
// // //                               alignItems: "center",
// // //                               gap: 6,
// // //                               fontSize: 13,
// // //                               opacity: locked ? 0.6 : 1,
// // //                             }}
// // //                           >
// // //                             <input
// // //                               type="checkbox"
// // //                               checked={!!local.autopilotEnabled}
// // //                               onChange={(e) =>
// // //                                 updateLocalAssign(veh, {
// // //                                   autopilotEnabled: e.target.checked,
// // //                                 })
// // //                               }
// // //                               disabled={locked || saving}
// // //                             />
// // //                             On
// // //                           </label>
// // //                         </td>
// // //                         <td style={{ padding: 8 }}>
// // //                           <button
// // //                             onClick={() => {
// // //                               if (locked) {
// // //                                 // switch to edit mode
// // //                                 updateLocalAssign(veh, {}); // ensure local copy
// // //                                 setEditing((prev) => ({
// // //                                   ...prev,
// // //                                   [veh]: true,
// // //                                 }));
// // //                               } else {
// // //                                 // save current data
// // //                                 handleSaveAssignment(veh);
// // //                               }
// // //                             }}
// // //                             disabled={saving}
// // //                             style={{
// // //                               padding: "6px 12px",
// // //                               borderRadius: 8,
// // //                               border: "1px solid #0D47A1",
// // //                               background: saving
// // //                                 ? "#e5e7eb"
// // //                                 : locked
// // //                                   ? "#0D47A1"
// // //                                   : "#0D47A1",
// // //                               color: saving ? "#4b5563" : "#fff",
// // //                               fontSize: 13,
// // //                               fontWeight: 700,
// // //                               cursor: saving ? "not-allowed" : "pointer",
// // //                             }}
// // //                           >
// // //                             {saving
// // //                               ? "Saving…"
// // //                               : locked
// // //                                 ? "Edit"
// // //                                 : "Save"}
// // //                           </button>
// // //                         </td>
// // //                       </tr>
// // //                     );
// // //                   })}
// // //                 </tbody>
// // //               </table>
// // //             </div>
// // //           </div>
// // //         )}

// // //         {tab === "live" && (
// // //           <div style={{ height: "calc(100vh - 40px)" }}>
// // //             <h2 style={{ marginTop: 0 }}>Live Tracking</h2>
// // //             <div style={{ height: "calc(100% - 36px)" }}>
// // //               <MapContainer
// // //                 center={center}
// // //                 zoom={DEFAULT_ZOOM}
// // //                 maxZoom={22}
// // //                 style={{ width: "100%", height: "100%" }}
// // //               >
// // //                 <TileLayer
// // //                   attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
// // //                   url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// // //                   maxNativeZoom={19}
// // //                   maxZoom={22}
// // //                 />
// // //                 {liveBuses.map((bus) => {
// // //                   // const label = vehicleLabel(bus.vehicleno);
// // //                   const rc = assignments[bus.vehicleno]?.routeCode;   // admin assignments map is row objects
// // //                   const label = vehicleLabel(bus.vehicleno, rc);
// // //                   const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
// // //                   const drv = driverByVehicle[bus.vehicleno];
// // //                   return (
// // //                     <Marker
// // //                       key={bus.vehicleno}
// // //                       position={{
// // //                         lat: bus.latitude,
// // //                         lng: bus.longitude,
// // //                       }}
// // //                       // icon={createVehicleDivIcon(
// // //                       //   label,
// // //                       //   Number(bus.heading) || 0
// // //                       // )}
// // //                       icon={createVehicleDivIcon(label, Number(bus.heading) || 0, palette)}
// // //                     >
// // //                       <Popup>
// // //                         <div className="info-window">
// // //                           <h4>
// // //                             {bus.vehicleno} ({label})
// // //                           </h4>
// // //                           <p>
// // //                             <strong>Speed:</strong>{" "}
// // //                             {Number.isFinite(bus.speed)
// // //                               ? bus.speed.toFixed(1)
// // //                               : "N/A"}{" "}
// // //                             km/h
// // //                           </p>
// // //                           {drv && (
// // //                             <>
// // //                               <p>
// // //                                 <strong>Driver:</strong> {drv.name}</p>
// // //                               <p>
// // //                                 <strong>Phone:</strong>{" "}
// // //                                 {drv.phoneNumber || "—"}
// // //                               </p>
// // //                             </>
// // //                           )}
// // //                           {!drv && (
// // //                             <p style={{ fontSize: 13, opacity: 0.7 }}>
// // //                               No driver assigned
// // //                             </p>
// // //                           )}
// // //                         </div>
// // //                       </Popup>
// // //                     </Marker>
// // //                   );
// // //                 })}
// // //               </MapContainer>
// // //             </div>
// // //           </div>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function RecenterMap({ center, zoom }) {
// // //   const map = useMap();

// // //   useEffect(() => {
// // //     if (!center) return;
// // //     map.setView([center.lat, center.lng], zoom ?? map.getZoom(), { animate: true });
// // //   }, [center, zoom, map]);

// // //   return null;
// // // }



// // // /* ---------------------------- MAP PAGE ---------------------------- */
// // // function MapPage() {
// // //   const [buses, setBuses] = useState([]);
// // //   const [userLocation, setUserLocation] = useState(null);
// // //   const [socketStatus, setSocketStatus] = useState('disconnected');
// // //   const [roads, setRoads] = useState(null);
// // //   const [filterType, setFilterType] = useState('all');
// // //   const [mapCenter, setMapCenter] = useState(center);
// // //   const [routeSearch, setRouteSearch] = useState('');
// // //   const [routeSearchMsg, setRouteSearchMsg] = useState('');
// // //   const [locError, setLocError] = useState("");
// // //   const [geoState, setGeoState] = useState("unknown"); // "granted" | "prompt" | "denied" | "unknown"
// // //   const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true);

// // //   // maintenance banner state
// // //   const [maintenance, setMaintenance] = useState(false);
// // //   const [maintenanceReason, setMaintenanceReason] = useState('');
// // //   const lastUpdateRef = useRef(0);
// // //   // ---- Backend ETA (JWT) state ----
// // //   const [etaToken, setEtaToken] = useState(null);    // JWT for /api/eta/*
// // //   const [stopEtas, setStopEtas] = useState({});      // { [stopId]: { data, error } }

// // //   const etaTokenRef = useRef(null);
// // //   const etaTokenFetchingRef = useRef(false);

// // //   const flatRoadLinesRef = useRef([]);
// // //   const lastSmoothedRef = useRef(new Map());

// // //   // ---- Schedule Modal state ----
// // //   const [showSchedule, setShowSchedule] = useState(false);
// // //   const [activeTab, setActiveTab] = useState(0);

// // //   // --- responsive helpers ---
// // //   const [isNarrow, setIsNarrow] = useState(() => window.innerWidth <= 480);
// // //   const clamp = (min, pref, max) => `clamp(${min}, ${pref}, ${max})`;
// // //   const pad = isNarrow ? 12 : 16;
// // //   const gap = isNarrow ? 8 : 12;
// // //   const chipFS = isNarrow ? 12 : 13;

// // //   useEffect(() => {
// // //     const onResize = () => setIsNarrow(window.innerWidth <= 480);
// // //     window.addEventListener('resize', onResize);
// // //     return () => window.removeEventListener('resize', onResize);
// // //   }, []);

// // //   // ---- Helper: fetch / refresh JWT for ETA API ----
// // //   const fetchEtaToken = useCallback(async () => {
// // //     if (!BACKEND || !API_KEY) return null;

// // //     // Avoid spamming if many 401s come at once
// // //     if (etaTokenFetchingRef.current) {
// // //       return etaTokenRef.current;
// // //     }

// // //     etaTokenFetchingRef.current = true;
// // //     try {
// // //       const res = await axios.post(
// // //         `${BACKEND}/api/auth/token`,
// // //         {},
// // //         {
// // //           timeout: 5000,
// // //           headers: {
// // //             Authorization: `Bearer ${API_KEY}`, // apiKeyAuth middleware
// // //           },
// // //         }
// // //       );
// // //       const t = res.data?.token;
// // //       if (t) {
// // //         etaTokenRef.current = t;
// // //         setEtaToken(t);
// // //         return t;
// // //       }
// // //       return null;
// // //     } catch (e) {
// // //       console.warn('Failed to fetch ETA JWT token:', e?.message || e);
// // //       return null;
// // //     } finally {
// // //       etaTokenFetchingRef.current = false;
// // //     }
// // //   }, []);

// // //   // ---- Get initial JWT token for ETA API ----
// // //   useEffect(() => {
// // //     fetchEtaToken();
// // //   }, [fetchEtaToken]);

// // //   // ---- Poll backend ETA for every stop every 5 seconds ----
// // //   useEffect(() => {
// // //     if (!BACKEND) return;

// // //     let cancelled = false;

// // //     async function fetchAllStopEtas() {
// // //       // If we don't have a token yet, try to get one
// // //       if (!etaTokenRef.current) {
// // //         await fetchEtaToken();
// // //         if (!etaTokenRef.current || cancelled) return;
// // //       }

// // //       try {
// // //         const results = await Promise.all(
// // //           busStops.map(async (s) => {
// // //             try {
// // //               const res = await axios.get(
// // //                 `${BACKEND}/api/eta/stop/${s.id}`,
// // //                 {
// // //                   timeout: 8000,
// // //                   headers: {
// // //                     Authorization: `Bearer ${etaTokenRef.current}`,
// // //                   },
// // //                 }
// // //               );
// // //               return { stopId: s.id, data: res.data, error: null };
// // //             } catch (err) {
// // //               // If token expired, refresh in background
// // //               if (err?.response?.status === 401) {
// // //                 console.warn('ETA JWT expired for stop', s.id, '— refreshing token');
// // //                 fetchEtaToken().catch(() => { });
// // //               } else {
// // //                 console.warn(
// // //                   'ETA error for stop',
// // //                   s.id,
// // //                   err?.response?.status || '',
// // //                   err?.message || err
// // //                 );
// // //               }
// // //               return { stopId: s.id, data: null, error: true };
// // //             }
// // //           })
// // //         );

// // //         if (cancelled) return;

// // //         setStopEtas((prev) => {
// // //           const next = { ...prev };
// // //           for (const r of results) {
// // //             next[r.stopId] = { data: r.data, error: r.error };
// // //           }
// // //           return next;
// // //         });
// // //       } catch (e) {
// // //         if (!cancelled) {
// // //           console.warn('ETA batch fetch failed:', e?.message || e);
// // //         }
// // //       }
// // //     }

// // //     // first call + interval
// // //     fetchAllStopEtas();
// // //     const id = setInterval(fetchAllStopEtas, 5000);

// // //     return () => {
// // //       cancelled = true;
// // //       clearInterval(id);
// // //     };
// // //   }, [fetchEtaToken]);


// // //   // ---- stable socket + pause flag ----
// // //   const socketRef = useRef(null);
// // //   const ignoreUpdatesRef = useRef(false);

// // //   // ---- assignments (vehicle -> routeCode) ----
// // //   const [assignments, setAssignments] = useState({});
// // //   async function refreshAssignments() {
// // //     try {
// // //       const r = await axios.get(`${BACKEND}/api/vehicle-route/active`);
// // //       const map = {};
// // //       for (const row of r.data?.rows || []) {
// // //         const vehicleNo = normalizeVehicleNo(row.vehicleNo);
// // //         map[vehicleNo] = row.routeCode || row.routeNo || "";
// // //       }
// // //       setAssignments(map);
// // //     } catch { }
// // //   }
// // //   useEffect(() => { refreshAssignments(); const t = setInterval(refreshAssignments, 60000); return () => clearInterval(t); }, []);

// // //   // Load roads
// // //   useEffect(() => {
// // //     let cancelled = false;
// // //     (async () => {
// // //       try {
// // //         const r = await fetch(ROADS_URL);
// // //         if (!cancelled && r.ok) setRoads(await r.json());
// // //       } catch (e) {
// // //         if (!cancelled) console.warn('Failed to load roads:', e?.message || e);
// // //       }
// // //     })();
// // //     return () => { cancelled = true; };
// // //   }, []);

// // //   // Flatten roads to LineStrings
// // //   useEffect(() => {
// // //     if (!roads) return;
// // //     const lines = [];
// // //     turf.flattenEach(roads, (feat) => {
// // //       if (feat.geometry?.type === 'LineString') lines.push(feat);
// // //     });
// // //     flatRoadLinesRef.current = lines;
// // //   }, [roads]);

// // //   // // Geolocation
// // //   // useEffect(() => {
// // //   //   if ('geolocation' in navigator) {
// // //   //     navigator.geolocation.getCurrentPosition(
// // //   //       (pos) => setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
// // //   //       (err) => console.warn('Geolocation error:', err?.message),
// // //   //       { enableHighAccuracy: true, timeout: 5000 }
// // //   //     );
// // //   //   }
// // //   // }, []);

// // //   useEffect(() => {
// // //     let perm;
// // //     (async () => {
// // //       try {
// // //         if (!navigator.permissions?.query) return;
// // //         perm = await navigator.permissions.query({ name: "geolocation" });
// // //         setGeoState(perm.state);
// // //         perm.onchange = () => setGeoState(perm.state);
// // //       } catch {
// // //         // ignore
// // //       }
// // //     })();
// // //     return () => {
// // //       if (perm) perm.onchange = null;
// // //     };
// // //   }, []);


// // //   //   const requestUserLocation = useCallback(() => {
// // //   //   setLocError("");

// // //   //   if (!("geolocation" in navigator)) {
// // //   //     setLocError("Geolocation not supported on this device/browser.");
// // //   //     return;
// // //   //   }

// // //   //   navigator.geolocation.getCurrentPosition(
// // //   //     (pos) => {
// // //   //       const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
// // //   //       setUserLocation(loc);
// // //   //       setMapCenter(loc); // ✅ recenter map here
// // //   //       setLocError("");
// // //   //     },
// // //   //     (err) => {
// // //   //       console.warn("Geolocation error:", err?.message || err);
// // //   //       // If user didn't allow, browser will show prompt only if not blocked.
// // //   //       setLocError("Please allow location to center the map near you.");
// // //   //     },
// // //   //     { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
// // //   //   );
// // //   // }, []);

// // //   const requestUserLocation = useCallback(() => {
// // //     setLocError("");

// // //     if (!("geolocation" in navigator)) {
// // //       setLocError("Geolocation not supported on this device/browser.");
// // //       return;
// // //     }

// // //     navigator.geolocation.getCurrentPosition(
// // //       (pos) => {
// // //         const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
// // //         setUserLocation(loc);
// // //         setMapCenter(loc);
// // //         setLocError("");
// // //       },
// // //       (err) => {
// // //         // err.code === 1 => PERMISSION_DENIED
// // //         if (err?.code === 1) {
// // //           // If browser permission is truly "denied", it won't show popup again.
// // //           setLocError(
// // //             "Location is blocked in browser settings. Click the 🔒 icon near the URL → Site settings → Location → Allow (or Ask), then refresh."
// // //           );
// // //         } else {
// // //           setLocError(err?.message || "Unable to fetch location.");
// // //         }
// // //       },
// // //       { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
// // //     );
// // //   }, []);


// // //   useEffect(() => {
// // //     // ✅ On every page open (and after browser refresh), request location and recenter
// // //     requestUserLocation();
// // //   }, [requestUserLocation]);


// // //   // Initial fetch
// // //   useEffect(() => {
// // //     if (!BACKEND) {
// // //       setMaintenance(true);
// // //       setMaintenanceReason('Server URL not configured');
// // //       return;
// // //     }
// // //     axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 })
// // //       .then((res) => {
// // //         const arr = Array.isArray(res.data) ? res.data : [];
// // //         const byVeh = new Map();
// // //         for (const d of arr) {
// // //           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
// // //           byVeh.set(d.vehicleno, {
// // //             vehicleno: d.vehicleno,
// // //             latitude: d.latitude,
// // //             longitude: d.longitude,
// // //             speed: d.speed,
// // //             heading
// // //           });
// // //         }
// // //         const list = [...byVeh.values()];
// // //         setBuses(processVehicles(list));
// // //         lastUpdateRef.current = Date.now();
// // //       })
// // //       .catch((err) => {
// // //         console.error('Initial fetch error:', err?.message || err);
// // //         setMaintenance(true);
// // //         setMaintenanceReason('Unable to fetch live data');
// // //       });
// // //   }, []);

// // //   // ---- WebSocket packet handler ----
// // //   const onPacket = (data) => {
// // //     if (ignoreUpdatesRef.current) return;
// // //     const incoming = {
// // //       vehicleno: data.vehicleno,
// // //       latitude: data.latitude,
// // //       longitude: data.longitude,
// // //       speed: data.speed,
// // //       heading: Number.isFinite(data?.heading) ? toHeading(data.heading) : toHeading(data?.direction)
// // //     };

// // //     setBuses((prev) => {
// // //       const nextByVeh = new Map(prev.map((b) => [b.vehicleno, b]));
// // //       const processed = processVehicles([incoming], nextByVeh);
// // //       const merged = new Map(prev.map((b) => [b.vehicleno, b]));
// // //       for (const p of processed) merged.set(p.vehicleno, p);
// // //       return [...merged.values()];
// // //     });

// // //     lastUpdateRef.current = Date.now();
// // //   };

// // //   // Live updates (Socket.IO)
// // //   useEffect(() => {
// // //     if (!BACKEND) return;

// // //     setSocketStatus('connecting');
// // //     const socket = io(BACKEND, {
// // //       transports: ['websocket', 'polling'],
// // //       reconnection: true,
// // //       reconnectionAttempts: Infinity,
// // //       reconnectionDelay: 1000,
// // //       timeout: 10000,
// // //       withCredentials: false
// // //     });
// // //     socketRef.current = socket;

// // //     socket.on('connect', () => setSocketStatus('connected'));
// // //     socket.on('disconnect', () => setSocketStatus('disconnected'));
// // //     socket.on('connect_error', (e) => {
// // //       console.warn('Socket connect_error:', e?.message || e);
// // //       setSocketStatus('disconnected');
// // //     });

// // //     socket.on('new-bus-data', onPacket);

// // //     return () => {
// // //       socket.off('new-bus-data', onPacket);
// // //       socket.disconnect();
// // //       socketRef.current = null;
// // //     };
// // //   }, [roads]); // re-connect only if roads change

// // //   // Staleness / maintenance detector
// // //   useEffect(() => {
// // //     const t = setInterval(() => {
// // //       const sinceMs = Date.now() - lastUpdateRef.current;
// // //       const stale = sinceMs > STALE_MS;
// // //       const downAndEmpty = socketStatus === 'disconnected' && buses.length === 0;

// // //       if (stale || downAndEmpty) {
// // //         const mins = Math.floor(sinceMs / 60000);
// // //         const secs = Math.floor((sinceMs % 60000) / 1000);
// // //         setMaintenance(true);
// // //         setMaintenanceReason(
// // //           stale ? `No new data for ${mins}m ${secs}s` : 'Live connection unavailable'
// // //         );
// // //       } else {
// // //         setMaintenance(false);
// // //         setMaintenanceReason('');
// // //       }
// // //     }, 5000);
// // //     return () => clearInterval(t);
// // //   }, [socketStatus, buses.length]);

// // //   // ---- Processing pipeline: smooth then snap ----
// // //   function snapToRoad(coord, flatLines) {
// // //     const safeCoord = normalizeLatLng(coord?.lat, coord?.lng);
// // //     if (!safeCoord || !flatLines || flatLines.length === 0) return null;

// // //     let pt;
// // //     try {
// // //       pt = turf.point([safeCoord.lng, safeCoord.lat]);
// // //     } catch (err) {
// // //       console.warn('Skipping road snap because coordinates are invalid:', coord);
// // //       return null;
// // //     }

// // //     let best = null;
// // //     let bestDist = Infinity;

// // //     for (const line of flatLines) {
// // //       try {
// // //         const np = turf.nearestPointOnLine(line, pt, { units: 'meters' });
// // //         const dist = np?.properties?.dist;
// // //         if (Number.isFinite(dist) && dist < bestDist) {
// // //           bestDist = dist;
// // //           const [lng, lat] = np.geometry.coordinates;
// // //           const snapped = normalizeLatLng(lat, lng);
// // //           if (snapped) best = { ...snapped, distM: dist };
// // //         }
// // //       } catch (err) {
// // //         console.warn('Skipping invalid road line while snapping:', err?.message || err);
// // //       }
// // //     }
// // //     return best;
// // //   }

// // //   function processVehicles(list, prevMapOpt) {
// // //     const flatLines = flatRoadLinesRef.current;
// // //     const last = lastSmoothedRef.current;
// // //     const result = [];

// // //     for (const d of list) {
// // //       const id = String(d?.vehicleno || '').trim();
// // //       if (!id) continue;

// // //       const raw = normalizeLatLng(d.latitude, d.longitude);
// // //       if (!raw) {
// // //         console.warn('Skipping vehicle with invalid coordinates:', d?.vehicleno, d?.latitude, d?.longitude);
// // //         continue;
// // //       }

// // //       const prev = last.get(id);
// // //       const smoothedCoord = smoothCoord(prev?.coord, raw, SMOOTH_ALPHA);
// // //       if (!smoothedCoord) continue;

// // //       const smoothedHeading = smoothHeading(prev?.heading, d.heading, HEADING_ALPHA);
// // //       const snapped = snapToRoad(smoothedCoord, flatLines);

// // //       const use = snapped?.distM != null && snapped.distM <= SNAP_MAX_DIST_M
// // //         ? { lat: snapped.lat, lng: snapped.lng }
// // //         : smoothedCoord;

// // //       if (!hasValidLatLng(use)) continue;

// // //       last.set(id, { coord: use, heading: smoothedHeading });

// // //       result.push({
// // //         vehicleno: id,
// // //         latitude: use.lat,
// // //         longitude: use.lng,
// // //         speed: d.speed,
// // //         heading: smoothedHeading
// // //       });
// // //     }

// // //     if (prevMapOpt) {
// // //       for (const [id, b] of prevMapOpt) {
// // //         if (list.find(x => x.vehicleno === id)) continue;
// // //         const prev = last.get(id);
// // //         if (prev?.coord && hasValidLatLng(prev.coord)) {
// // //           result.push({
// // //             vehicleno: id,
// // //             latitude: prev.coord.lat,
// // //             longitude: prev.coord.lng,
// // //             speed: b.speed,
// // //             heading: prev.heading
// // //           });
// // //           continue;
// // //         }

// // //         const fallback = normalizeLatLng(b?.latitude, b?.longitude);
// // //         if (fallback) {
// // //           result.push({
// // //             ...b,
// // //             latitude: fallback.lat,
// // //             longitude: fallback.lng,
// // //           });
// // //         }
// // //       }
// // //     }

// // //     return result;
// // //   }

// // //   // ---------------- Route geometry + ETA helpers ----------------
// // //   const stopById = useMemo(() => Object.fromEntries(busStops.map(s => [s.id, s])), []);

// // //   function routePolyline(ids) {
// // //     return ids
// // //       .map((id) => stopById[id])
// // //       .filter(Boolean)
// // //       .map((s) => normalizeLatLng(s.lat, s.lng))
// // //       .filter(Boolean);
// // //   }

// // //   function cumDist(poly) {
// // //     const out = [0];
// // //     for (let i = 1; i < poly.length; i++) {
// // //       const d = mBetween(poly[i - 1], poly[i]);
// // //       out.push(out[i - 1] + (Number.isFinite(d) ? d : 0));
// // //     }
// // //     return out;
// // //   }

// // //   const routeGeom = useMemo(() => {
// // //     const g = {};
// // //     for (const trip of ROUTE_TRIPS) {
// // //       const validIds = trip.ids.filter((id) => !!stopById[id]);
// // //       const poly = routePolyline(validIds);
// // //       if (poly.length >= 2) {
// // //         g[trip.id] = { poly, cum: cumDist(poly), ids: validIds, trip };
// // //       }
// // //     }
// // //     return g;
// // //   }, [stopById]);

// // //   function projectOnRoute(pt, poly) {
// // //     const safePt = normalizeLatLng(pt?.lat, pt?.lng);
// // //     if (!safePt || !poly || poly.length < 2) return null;

// // //     let best = null;
// // //     let pointFeature = null;

// // //     try {
// // //       pointFeature = turf.point([safePt.lng, safePt.lat]);
// // //     } catch (err) {
// // //       console.warn('Skipping route projection because bus coordinates are invalid:', pt);
// // //       return null;
// // //     }

// // //     for (let i = 0; i < poly.length - 1; i++) {
// // //       const a = normalizeLatLng(poly[i]?.lat, poly[i]?.lng);
// // //       const b = normalizeLatLng(poly[i + 1]?.lat, poly[i + 1]?.lng);
// // //       if (!a || !b) continue;

// // //       try {
// // //         const seg = turf.lineString([[a.lng, a.lat], [b.lng, b.lat]]);
// // //         const p = turf.nearestPointOnLine(seg, pointFeature, { units: "meters" });
// // //         const d = p.properties?.dist ?? Infinity;
// // //         if (Number.isFinite(d) && (!best || d < best.dist)) {
// // //           const [lng, lat] = p.geometry.coordinates;
// // //           best = { idx: i, point: { lat, lng }, dist: d };
// // //         }
// // //       } catch (err) {
// // //         console.warn('Skipping invalid route segment while projecting bus:', err?.message || err);
// // //       }
// // //     }
// // //     return best;
// // //   }

// // //   function distanceAlong(poly, cum, proj, targetIndex) {
// // //     if (!proj || !poly || poly.length < 2 || !cum?.length) return Infinity;
// // //     const safeIdx = Math.max(0, Math.min(proj.idx, poly.length - 2));
// // //     const safeTarget = Math.max(0, Math.min(targetIndex, poly.length - 1));
// // //     const dHead = mBetween(proj.point, poly[safeIdx + 1]);
// // //     const dTail = (cum[safeTarget] ?? 0) - (cum[safeIdx + 1] ?? 0);
// // //     const total = dHead + Math.max(0, dTail);
// // //     return Number.isFinite(total) ? total : Infinity;
// // //   }

// // //   // ---- ETA constants: match backend ----
// // //   const AVG_SPEED_KMPH = 20;
// // //   const AVG_SPEED_MPS = (AVG_SPEED_KMPH * 1000) / 3600;
// // //   const WAIT_RADIUS_M = 25;
// // //   const WAIT_SPEED_KMPH_MAX = 1.0;

// // //   function etaFromMeters(distanceM) {
// // //     const seconds = distanceM / AVG_SPEED_MPS;
// // //     const minutes = Math.round(seconds / 60);
// // //     return minutes < 0 || !Number.isFinite(minutes) ? 0 : minutes;
// // //   }

// // //   function nextStopIndex(routeIds, projIdx) {
// // //     return Math.min(routeIds.length - 1, projIdx + 1);
// // //   }

// // //   function getBestRouteProjectionForBus(bus) {
// // //     const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
// // //     if (!routeValue) return null;

// // //     const candidates = routeCandidatesForValue(routeValue);
// // //     if (!candidates.length) return null;

// // //     const pt = normalizeLatLng(bus.latitude, bus.longitude);
// // //     if (!pt) return null;

// // //     let best = null;

// // //     for (const trip of candidates) {
// // //       const geom = routeGeom[trip.id];
// // //       if (!geom || geom.poly.length < 2) continue;

// // //       const proj = projectOnRoute(pt, geom.poly);
// // //       if (!proj) continue;

// // //       if (!best || proj.dist < best.proj.dist) {
// // //         best = { routeValue, trip, geom, proj };
// // //       }
// // //     }

// // //     return best;
// // //   }

// // //   function recentlyPassedStopForBus(bus) {
// // //     const best = getBestRouteProjectionForBus(bus);
// // //     if (!best) return null;

// // //     const passedIdx = Math.max(0, Math.min(best.proj.idx, best.geom.ids.length - 1));
// // //     const stopId = best.geom.ids[passedIdx];
// // //     const stop = stopById[stopId];

// // //     if (!stop) return null;

// // //     return {
// // //       stopId,
// // //       name: stop.name,
// // //       routeNo: best.trip.routeNo,
// // //       routeCode: best.trip.code,
// // //       distanceFromRouteM: best.proj.dist,
// // //     };
// // //   }

// // //   // For a given bus, find nearest upcoming stop on its route + ETA
// // //   function nearestStopEtaForBusOnItsRoute(bus) {
// // //     const best = getBestRouteProjectionForBus(bus);
// // //     if (!best) return null;

// // //     const { geom, proj, trip } = best;
// // //     const pt = normalizeLatLng(bus.latitude, bus.longitude);
// // //     if (!pt) return null;

// // //     const firstStopId = geom.ids[0];
// // //     const firstStop = stopById[firstStopId];
// // //     let waitingAtFirstStop = false;
// // //     if (firstStop) {
// // //       const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
// // //       const speed = Number(bus.speed);
// // //       if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
// // //         waitingAtFirstStop = true;
// // //       }
// // //     }

// // //     const nextIdx = nextStopIndex(geom.ids, proj.idx);
// // //     const distanceM = distanceAlong(geom.poly, geom.cum, proj, nextIdx);

// // //     let etaMin = undefined;
// // //     if (!waitingAtFirstStop) {
// // //       etaMin = etaFromMeters(distanceM);
// // //     }

// // //     return {
// // //       stopId: geom.ids[nextIdx],
// // //       distanceM,
// // //       etaMin,
// // //       routeCode: trip.code,
// // //       routeNo: trip.routeNo,
// // //       waitingAtFirstStop,
// // //     };
// // //   }

// // //   // For a given stop, find the best incoming vehicle + ETA
// // //   function nextArrivalAtStop(stopId) {
// // //     const candidates = [];

// // //     for (const bus of buses) {
// // //       if (startsWithDigit(bus.vehicleno)) continue;

// // //       const routeValue = getAssignedRouteValue(bus.vehicleno, assignments);
// // //       if (!routeValue) continue;

// // //       for (const trip of routeCandidatesForValue(routeValue)) {
// // //         const geom = routeGeom[trip.id];
// // //         if (!geom) continue;

// // //         const indexInRoute = geom.ids.indexOf(stopId);
// // //         if (indexInRoute < 0) continue;

// // //         const pt = normalizeLatLng(bus.latitude, bus.longitude);
// // //         if (!pt) continue;

// // //         const proj = projectOnRoute(pt, geom.poly);
// // //         if (!proj) continue;

// // //         const targetIndex = Math.max(indexInRoute, proj.idx + 1);
// // //         if (targetIndex >= geom.ids.length) continue;

// // //         const distanceM = distanceAlong(geom.poly, geom.cum, proj, targetIndex);

// // //         const firstStopId = geom.ids[0];
// // //         const firstStop = stopById[firstStopId];
// // //         let waitingAtFirstStop = false;
// // //         if (firstStop) {
// // //           const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
// // //           const speed = Number(bus.speed);
// // //           if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
// // //             waitingAtFirstStop = true;
// // //           }
// // //         }

// // //         let etaMin = undefined;
// // //         if (!waitingAtFirstStop) {
// // //           etaMin = etaFromMeters(distanceM);
// // //         }

// // //         candidates.push({
// // //           vehicle: bus.vehicleno,
// // //           routeCode: trip.code,
// // //           routeNo: trip.routeNo,
// // //           etaMin,
// // //           waitingAtFirstStop,
// // //           distanceM,
// // //         });
// // //       }
// // //     }

// // //     if (!candidates.length) return null;

// // //     const moving = candidates.filter(c => c.etaMin != null);
// // //     if (moving.length) {
// // //       return moving.reduce((a, b) => (a.etaMin <= b.etaMin ? a : b));
// // //     }

// // //     return candidates.reduce((a, b) => (a.distanceM <= b.distanceM ? a : b));
// // //   }


// // //   // ---- Derived lists ----
// // //   const visibleBuses = buses.filter(b => !startsWithDigit(b.vehicleno) && normalizeLatLng(b.latitude, b.longitude));
// // //   const filteredBuses = visibleBuses.filter(b => matchesFilter(b.vehicleno, filterType, assignments));

// // //   function handleRouteSearch() {
// // //     const requested = normalizeRouteNo(routeSearch);
// // //     if (!requested) {
// // //       setRouteSearchMsg("Enter a route number, for example 52-G.");
// // //       return;
// // //     }

// // //     const matching = visibleBuses.filter(
// // //       (bus) => normalizeRouteNo(getBusRouteNo(bus.vehicleno, assignments)) === requested
// // //     );

// // //     setFilterType(`route:${requested}`);

// // //     if (matching.length > 0) {
// // //       const bus = matching[0];
// // //       setMapCenter({ lat: bus.latitude, lng: bus.longitude });
// // //       setRouteSearchMsg(`Showing ${matching.length} vehicle(s) on route ${requested}.`);
// // //       return;
// // //     }

// // //     const fallbackTrip = routeCandidatesForValue(requested)[0];
// // //     const firstStopId = fallbackTrip?.ids?.[0];
// // //     const firstStop = firstStopId ? stopById[firstStopId] : null;

// // //     if (firstStop) {
// // //       setMapCenter({ lat: firstStop.lat, lng: firstStop.lng });
// // //       setRouteSearchMsg(`No live vehicle found on ${requested}. Zoomed to the first scheduled stop.`);
// // //     } else {
// // //       setRouteSearchMsg(`No live vehicle or schedule found for route ${requested}.`);
// // //     }
// // //   }


// // //   // -------------- SCHEDULE UI helpers --------------
// // //   const TABS = ROUTES.map((route) => ({
// // //     key: route.code,
// // //     title: route.label,
// // //     code: route.code,
// // //     trips: ROUTE_TRIPS.filter((trip) => trip.routeNo === route.code),
// // //   }));

// // //   function ScheduleBody({ tab }) {
// // //     const trips = tab.trips || [];

// // //     if (!trips.length) {
// // //       return (
// // //         <div className="schedule-empty">
// // //           Stop-wise schedule data is not available for this route in the uploaded ZIP.
// // //         </div>
// // //       );
// // //     }

// // //     return (
// // //       <div className="schedule-trip-list">
// // //         {trips
// // //           .slice()
// // //           .sort((a, b) => (a.order || 0) - (b.order || 0))
// // //           .map((trip) => (
// // //             <div className="schedule-trip-card" key={trip.id}>
// // //               <div className="schedule-trip-header">
// // //                 <div>
// // //                   <div className="schedule-trip-title">
// // //                     {trip.routeNo} / Trip {trip.order}
// // //                   </div>
// // //                   <div className="schedule-trip-subtitle">
// // //                     {trip.from} → {trip.to}
// // //                   </div>
// // //                 </div>

// // //                 <div className="schedule-trip-badges">
// // //                   <span>{trip.startTime} - {trip.endTime}</span>
// // //                   <span>{trip.service || "Town Ordinary"}</span>
// // //                   <span>{trip.direction === "U" ? "Up" : trip.direction === "D" ? "Down" : trip.direction}</span>
// // //                 </div>
// // //               </div>

// // //               <div className="schedule-stop-table-wrap">
// // //                 <table className="schedule-stop-table">
// // //                   <thead>
// // //                     <tr>
// // //                       <th>No.</th>
// // //                       <th>Bus stop</th>
// // //                       <th>Time</th>
// // //                     </tr>
// // //                   </thead>
// // //                   <tbody>
// // //                     {trip.stops.map((stop, index) => (
// // //                       <tr key={`${trip.id}-${stop.id}-${index}`}>
// // //                         <td>{index + 1}</td>
// // //                         <td>{stop.name}</td>
// // //                         <td>{stop.time}</td>
// // //                       </tr>
// // //                     ))}
// // //                   </tbody>
// // //                 </table>
// // //               </div>
// // //             </div>
// // //           ))}
// // //       </div>
// // //     );
// // //   }

// // //   function ScheduleModal() {
// // //     const tab = TABS[activeTab] || TABS[0];
// // //     const tabListRef = useRef(null);
// // //     const tabScrollRef = useRef(0);

// // //     useLayoutEffect(() => {
// // //       const el = tabListRef.current;
// // //       if (el && el.scrollLeft !== tabScrollRef.current) {
// // //         el.scrollLeft = tabScrollRef.current;
// // //       }
// // //     });

// // //     return (
// // //       <div
// // //         onClick={() => setShowSchedule(false)}
// // //         style={{
// // //           position: 'fixed',
// // //           inset: 0,
// // //           background: 'rgba(0,0,0,0.45)',
// // //           zIndex: 99999,
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           justifyContent: 'center',
// // //           padding: 16
// // //         }}
// // //       >
// // //         <div
// // //           onClick={(e) => e.stopPropagation()}
// // //           style={{
// // //             position: 'relative',
// // //             width: isNarrow ? '96vw' : 'min(1180px, 96vw)',
// // //             maxHeight: '90dvh',
// // //             background: '#ffffff',
// // //             borderRadius: 16,
// // //             boxShadow: '0 12px 30px rgba(0,0,0,0.3)',
// // //             display: 'flex',
// // //             flexDirection: 'column',
// // //             overflow: 'hidden'
// // //           }}
// // //         >
// // //           <div
// // //             style={{
// // //               padding: isNarrow ? '8px 10px' : '12px 16px',
// // //               borderBottom: '1px solid #eee',
// // //               display: 'flex',
// // //               alignItems: 'center',
// // //               gap: 12
// // //             }}
// // //           >
// // //             <img src={iitmLogo} alt="MiNT" style={{ width: isNarrow ? 26 : 32, height: isNarrow ? 26 : 32 }} />
// // //             <div>
// // //               <div style={{ fontWeight: 900, fontSize: clamp('14px', '2.8vw', '18px') }}>
// // //                 Thoothukudi Bus Schedule
// // //               </div>
// // //               <div style={{ color: '#64748b', fontSize: 12, fontWeight: 700 }}>
// // //                 Route-wise stop timings from the uploaded timesheet
// // //               </div>
// // //             </div>
// // //             <button
// // //               onClick={() => setShowSchedule(false)}
// // //               style={{
// // //                 marginLeft: 'auto',
// // //                 border: 'none',
// // //                 background: '#f4f4f5',
// // //                 borderRadius: 999,
// // //                 width: 34,
// // //                 height: 34,
// // //                 cursor: 'pointer',
// // //                 fontSize: 16
// // //               }}
// // //               title="Close"
// // //             >
// // //               ✕
// // //             </button>
// // //           </div>

// // //           <div
// // //             ref={tabListRef}
// // //             onScroll={(e) => { tabScrollRef.current = e.currentTarget.scrollLeft; }}
// // //             style={{
// // //               display: 'block',
// // //               padding: '8px 12px',
// // //               borderBottom: '1px solid #eee',
// // //               overflowX: 'auto',
// // //               overflowY: 'hidden',
// // //               whiteSpace: 'nowrap',
// // //               WebkitOverflowScrolling: 'touch',
// // //               scrollbarWidth: 'thin',
// // //               overscrollBehaviorX: 'contain',
// // //               touchAction: 'pan-x'
// // //             }}
// // //           >
// // //             <div style={{ display: 'inline-flex', gap: 8, minWidth: '100%', marginBottom: isNarrow ? '20px' : '10px' }}>
// // //               {TABS.map((t, i) => (
// // //                 <button
// // //                   key={t.key}
// // //                   onClick={() => setActiveTab(i)}
// // //                   style={{
// // //                     whiteSpace: 'nowrap',
// // //                     padding: isNarrow ? '8px 10px' : '8px 12px',
// // //                     borderRadius: 10,
// // //                     border: i === activeTab ? '1px solid #0D47A1' : '1px solid #ddd',
// // //                     background: i === activeTab ? '#eaf2ff' : '#ffffff',
// // //                     fontWeight: 800,
// // //                     cursor: 'pointer',
// // //                     flex: '0 0 auto'
// // //                   }}
// // //                 >
// // //                   {t.code}
// // //                 </button>
// // //               ))}
// // //             </div>
// // //           </div>

// // //           <div style={{ padding: isNarrow ? 10 : 14, overflow: 'auto' }}>
// // //             <div className="schedule-route-summary">
// // //               <div>
// // //                 <div className="schedule-route-title">{tab.title}</div>
// // //                 <div className="schedule-route-meta">
// // //                   {tab.trips?.length || 0} trip(s) · click a route tab to view stop-wise timings
// // //                 </div>
// // //               </div>
// // //             </div>
// // //             <ScheduleBody tab={tab} />
// // //           </div>
// // //         </div>
// // //       </div>
// // //     );
// // //   }


// // //   // Pause live updates when modal open; refresh once on close, then resume
// // //   useEffect(() => {
// // //     if (showSchedule) { ignoreUpdatesRef.current = true; return; }
// // //     (async () => {
// // //       try {
// // //         if (!BACKEND) return;
// // //         const res = await axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 });
// // //         const arr = Array.isArray(res.data) ? res.data : [];
// // //         const byVeh = new Map();
// // //         for (const d of arr) {
// // //           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
// // //           byVeh.set(d.vehicleno, {
// // //             vehicleno: d.vehicleno,
// // //             latitude: d.latitude,
// // //             longitude: d.longitude,
// // //             speed: d.speed,
// // //             heading
// // //           });
// // //         }
// // //         const list = [...byVeh.values()];
// // //         setBuses(processVehicles(list));
// // //         lastUpdateRef.current = Date.now();
// // //       } catch (e) {
// // //         console.warn('Refresh after modal close failed:', e?.message || e);
// // //       } finally {
// // //         ignoreUpdatesRef.current = false;
// // //       }
// // //     })();
// // //   }, [showSchedule]);

// // //   // Responsive stop icons (smaller on phones)
// // //   const stopIconInstance = useMemo(
// // //     () => createCustomIcon(stopIconImg, isNarrow ? [40, 40] : [50, 50]),
// // //     [isNarrow]
// // //   );

// // //   // --------------------------- RENDER ---------------------------
// // //   return (
// // //     <div className="map-container">
// // //       {/* Header */}
// // //       {/* <div
// // //         style={{
// // //           position: 'fixed',
// // //           top: 'max(8px, env(safe-area-inset-top))',
// // //           left: '50%',
// // //           transform: 'translateX(-50%)',
// // //           zIndex: 10000,
// // //           background: '#ffffff',
// // //           border: '1px solid #e6e6e7',
// // //           borderRadius: 16,
// // //           padding: pad,
// // //           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
// // //           width: isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))',
// // //           backdropFilter: 'blur(2px)'
// // //         }}
// // //       > */}
// // //       <div
// // //         style={{
// // //           position: 'fixed',
// // //           top: 'max(8px, env(safe-area-inset-top))',
// // //           left: '50%',
// // //           transform: 'translateX(-50%)',
// // //           zIndex: 10000,
// // //           background: '#ffffff',
// // //           border: '1px solid #e6e6e7',
// // //           borderRadius: 16,
// // //           padding: isHeaderCollapsed ? (isNarrow ? 8 : 10) : pad,
// // //           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
// // //           width: isHeaderCollapsed
// // //             ? (isNarrow ? 'calc(100vw - 16px)' : 'min(420px, calc(100vw - 32px))')
// // //             : (isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))'),
// // //           backdropFilter: 'blur(2px)',
// // //           transition: 'width 180ms ease, padding 180ms ease'
// // //         }}
// // //       >
// // //         {/* Title row */}
// // //         {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
// // //           <img src={iitmLogo} alt="IIT Madras" style={{ width: isNarrow ? 28 : 36, height: isNarrow ? 28 : 36 }} />
// // //           <h2
// // //             style={{
// // //               margin: 0,
// // //               fontSize: clamp('18px','3.2vw','28px'),
// // //               lineHeight: 1.1,
// // //               letterSpacing: 0.3,
// // //               fontWeight: 800
// // //             }}
// // //           >
// // //             Thoothukudi Bus Tracking
// // //           </h2>
// // //           <a href="/admin" style={{ marginLeft: 'auto', fontWeight: 700 }}>Admin ↗</a>
// // //         </div> */}

// // //         {/* Title row */}
// // //         <div style={{ display: 'flex', alignItems: 'center', gap: isNarrow ? 8 : 12 }}>
// // //           <img
// // //             src={iitmLogo}
// // //             alt="IIT Madras"
// // //             style={{
// // //               width: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
// // //               height: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
// // //               flex: '0 0 auto'
// // //             }}
// // //           />

// // //           <h2
// // //             style={{
// // //               margin: 0,
// // //               fontSize: isHeaderCollapsed
// // //                 ? clamp('15px', '3vw', '20px')
// // //                 : clamp('18px', '3.2vw', '28px'),
// // //               lineHeight: 1.1,
// // //               letterSpacing: 0.3,
// // //               fontWeight: 800,
// // //               whiteSpace: 'nowrap',
// // //               overflow: 'hidden',
// // //               textOverflow: 'ellipsis',
// // //               flex: 1
// // //             }}
// // //           >
// // //             Thoothukudi Bus Tracking
// // //           </h2>

// // //           {isHeaderCollapsed && (
// // //             <div
// // //               style={{
// // //                 fontSize: isNarrow ? 12 : 13,
// // //                 fontWeight: 800,
// // //                 color: '#111827',
// // //                 whiteSpace: 'nowrap'
// // //               }}
// // //               title="Visible vehicles / total vehicles"
// // //             >
// // //               {filteredBuses.length}/{buses.length}
// // //             </div>
// // //           )}

// // //           {!isHeaderCollapsed && (
// // //             <a
// // //               href="/admin"
// // //               style={{
// // //                 fontWeight: 700,
// // //                 whiteSpace: 'nowrap'
// // //               }}
// // //             >
// // //               Admin ↗
// // //             </a>
// // //           )}

// // //           <button
// // //             type="button"
// // //             onClick={() => setIsHeaderCollapsed((v) => !v)}
// // //             aria-label={isHeaderCollapsed ? 'Expand header' : 'Collapse header'}
// // //             title={isHeaderCollapsed ? 'Expand' : 'Collapse'}
// // //             style={{
// // //               border: '1px solid #D1D5DB',
// // //               background: '#ffffff',
// // //               color: '#111827',
// // //               borderRadius: 10,
// // //               padding: isNarrow ? '6px 8px' : '7px 10px',
// // //               fontWeight: 800,
// // //               fontSize: isNarrow ? 13 : 14,
// // //               lineHeight: 1,
// // //               cursor: 'pointer',
// // //               minWidth: isNarrow ? 34 : 38,
// // //               minHeight: isNarrow ? 32 : 36
// // //             }}
// // //           >
// // //             {isHeaderCollapsed ? '▾' : '▴'}
// // //           </button>
// // //         </div>

// // //         {!isHeaderCollapsed && (
// // //           <>

// // //             {/* Status row */}
// // //             <div
// // //               style={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 justifyContent: 'space-between',
// // //                 marginTop: 10,
// // //                 gap: 12,
// // //                 flexWrap: 'wrap'
// // //               }}
// // //             >
// // //               <span
// // //                 style={{
// // //                   display: 'inline-block',
// // //                   padding: '4px 10px',
// // //                   borderRadius: 999,
// // //                   fontSize: chipFS,
// // //                   fontWeight: 700,
// // //                   background:
// // //                     socketStatus === 'connected'
// // //                       ? '#E9F9EE'
// // //                       : socketStatus === 'connecting'
// // //                         ? '#FFF7E1'
// // //                         : '#FFECEC',
// // //                   color:
// // //                     socketStatus === 'connected'
// // //                       ? '#0A7A2A'
// // //                       : socketStatus === 'connecting'
// // //                         ? '#7A5D00'
// // //                         : '#B00020',
// // //                   border:
// // //                     socketStatus === 'connected'
// // //                       ? '1px solid #C6EBD1'
// // //                       : socketStatus === 'connecting'
// // //                         ? '1px solid #F4E3B0'
// // //                         : '1px solid #FFD0D0',
// // //                   textTransform: 'lowercase'
// // //                 }}
// // //                 title={`Socket: ${socketStatus}`}
// // //               >
// // //                 {socketStatus}
// // //               </span>

// // //               <div
// // //                 style={{
// // //                   fontSize: clamp('14px', '2.6vw', '18px'),
// // //                   fontWeight: 700,
// // //                   letterSpacing: 0.5,
// // //                   color: '#111827'
// // //                 }}
// // //               >
// // //                 {filteredBuses.length} / {buses.length}
// // //               </div>
// // //             </div>

// // //             {/* Controls row */}
// // //             <div
// // //               style={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 gap: gap,
// // //                 marginTop: gap,
// // //                 flexWrap: 'wrap'
// // //               }}
// // //             >
// // //               <div style={{ position: 'relative', flex: '1 1 200px' }}>
// // //                 <select
// // //                   value={filterType}
// // //                   onChange={(e) => setFilterType(e.target.value)}
// // //                   title="Filter vehicles"
// // //                   style={{
// // //                     width: '100%',
// // //                     padding: isNarrow ? '10px 34px 10px 12px' : '10px 40px 10px 14px',
// // //                     borderRadius: 10,
// // //                     border: '1px solid #D1D5DB',
// // //                     background: '#FFFFFF',
// // //                     fontWeight: 600,
// // //                     cursor: 'pointer',
// // //                     appearance: 'none',
// // //                     WebkitAppearance: 'none',
// // //                     MozAppearance: 'none'
// // //                   }}
// // //                 >
// // //                   <option value="all">All Vehicles</option>
// // //                   {/* <option value="cart">Cart</option> */}
// // //                   {/* <option value="bus">Bus</option> */}
// // //                   <optgroup label="Filter by Route">
// // //                     {ROUTES.map(r => (
// // //                       <option key={r.code} value={`route:${r.code}`}>{r.label}</option>
// // //                     ))}
// // //                   </optgroup>
// // //                 </select>

// // //                 <div
// // //                   style={{
// // //                     position: 'absolute',
// // //                     right: isNarrow ? 8 : 12,
// // //                     top: '50%',
// // //                     transform: 'translateY(-50%)',
// // //                     width: 0,
// // //                     height: 0,
// // //                     borderLeft: '6px solid transparent',
// // //                     borderRight: '6px solid transparent',
// // //                     borderTop: '7px solid #111',
// // //                     pointerEvents: 'none'
// // //                   }}
// // //                 />
// // //               </div>

// // //               <div className="route-search-box">
// // //                 <input
// // //                   value={routeSearch}
// // //                   onChange={(e) => setRouteSearch(e.target.value)}
// // //                   onKeyDown={(e) => {
// // //                     if (e.key === 'Enter') handleRouteSearch();
// // //                   }}
// // //                   placeholder="Search route e.g. 52-G"
// // //                   aria-label="Search by route number"
// // //                 />
// // //                 <button type="button" onClick={handleRouteSearch}>
// // //                   Search
// // //                 </button>
// // //               </div>

// // //               <button
// // //                 // onClick={() => window.location.reload()}
// // //                 // onClick={() => {
// // //                 //   requestUserLocation(); // ✅ recenter on refresh button click
// // //                 // }}

// // //                 // title="Reload the page"
// // //                 onClick={() => {
// // //                   requestUserLocation();          // ✅ recenter
// // //                   setTimeout(() => {
// // //                     window.location.reload();     // ✅ full reload
// // //                   }, 150);
// // //                 }}
// // //                 title="Recenter + Reload"
// // //                 style={{
// // //                   padding: '10px 14px',
// // //                   borderRadius: 10,
// // //                   border: '1px solid #D1D5DB',
// // //                   background: '#FFFFFF',
// // //                   fontWeight: 700,
// // //                   cursor: 'pointer',
// // //                   minHeight: isNarrow ? 36 : 40,
// // //                   fontSize: clamp('13px', '2.8vw', '14px')
// // //                 }}
// // //               >
// // //                 Refresh
// // //               </button>

// // //               <button
// // //                 onClick={() => setShowSchedule(true)}
// // //                 title="Show route schedules"
// // //                 style={{
// // //                   padding: '10px 16px',
// // //                   borderRadius: 10,
// // //                   border: '1px solid #0D47A1',
// // //                   background: '#0D47A1',
// // //                   color: '#FFFFFF',
// // //                   fontWeight: 800,
// // //                   cursor: 'pointer',
// // //                   boxShadow: '0 6px 16px rgba(13,71,161,0.25)',
// // //                   minHeight: isNarrow ? 36 : 40,
// // //                   fontSize: clamp('13px','2.8vw','14px')
// // //                 }}
// // //               >
// // //                 Schedule
// // //               </button>
// // //             </div>

// // //             {routeSearchMsg && (
// // //               <div className="route-search-message">
// // //                 {routeSearchMsg}
// // //               </div>
// // //             )}

// // //             {maintenance && (
// // //               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#fff8e1', border: '1px solid #f0d48a', fontWeight: 600 }}>
// // //                 Under maintenance — {maintenanceReason}
// // //               </div>
// // //             )}

// // //             {/* {locError && (
// // //         <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
// // //           {locError}
// // //           <button
// // //             onClick={requestUserLocation}
// // //             style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
// // //           >
// // //             Allow location
// // //           </button>
// // //         </div>
// // //         )} */}

// // //             {locError && (
// // //               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
// // //                 {locError}

// // //                 <button
// // //                   type="button"
// // //                   onClick={requestUserLocation}
// // //                   style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
// // //                   title={geoState === "denied" ? "Enable in site settings first, then try again" : "Try again"}
// // //                 >
// // //                   {geoState === "denied" ? "Open site settings" : "Allow location"}
// // //                 </button>
// // //               </div>
// // //             )}
// // //           </>
// // //         )}
// // //       </div>


// // //       {/* Schedule Modal */}
// // //       {showSchedule && <ScheduleModal />}

// // //       {/* Map uses dynamic viewport on mobile (100dvh) */}
// // //       {/* <MapContainer center={center} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}> */}
// // //       <MapContainer center={mapCenter} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}>
// // //         <RecenterMap center={mapCenter} zoom={DEFAULT_ZOOM} />

// // //         <TileLayer
// // //           attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
// // //           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// // //           maxNativeZoom={19}
// // //           maxZoom={22}
// // //         />

// // //         {userLocation && (
// // //           <Marker position={{ lat: userLocation.lat, lng: userLocation.lng }} icon={userIconInstance}>
// // //             <Popup>
// // //               <div className="info-window">
// // //                 <h4>You are here</h4>
// // //               </div>
// // //             </Popup>
// // //           </Marker>
// // //         )}
// // //         {/* here i have updated the backend eta */}
// // //         {/* Bus Stops with backend ETA (polled every 5s) */}
// // //         {busStops.map((stop) => {
// // //           const etaState = stopEtas[stop.id];           // { data, error } or undefined
// // //           const payload = etaState?.data;               // backend JSON
// // //           const next = payload?.next || null;           // { vehicle, goingTowards, etaMinutes } | null

// // //           return (
// // //             <Marker
// // //               key={stop.id}
// // //               position={{ lat: stop.lat, lng: stop.lng }}
// // //               icon={stopIconInstance}
// // //             >
// // //               <Popup>
// // //                 <div className="info-window">
// // //                   <h4>{stop.name}</h4>

// // //                   {/* 1) Still loading / first poll */}
// // //                   {!etaState && <p>Loading ETA…</p>}

// // //                   {/* 2) Request for this stop failed */}
// // //                   {etaState && !payload && <p>ETA not available.</p>}

// // //                   {/* 3) Backend says: no approaching assignment */}
// // //                   {payload && payload.success && !next && (
// // //                     <p>No assigned vehicle approaching.</p>
// // //                   )}

// // //                   {/* 4) We have a next arrival from backend */}
// // //                   {payload && payload.success && next && (
// // //                     <>
// // //                       {/* You said you may not need vehicle number/type, 
// // //                           so we only show direction + ETA. */}
// // //                       <p>
// // //                         Next Vehicle Details:
// // //                       </p>
// // //                       {next.vehicle && (
// // //                         <p>
// // //                           <strong>Vehicle Type:</strong> {next.vehicle}
// // //                         </p>
// // //                       )}
// // //                       {next.goingTowards && (
// // //                         <p>
// // //                           <strong>Direction:</strong> {next.goingTowards}
// // //                         </p>
// // //                       )}
// // //                       <p>
// // //                         <strong>ETA:</strong>{" "}
// // //                         {next.etaMinutes != null
// // //                           ? `${next.etaMinutes} min`
// // //                           : "— (has not departed yet)"}
// // //                       </p>
// // //                     </>
// // //                   )}
// // //                 </div>
// // //               </Popup>
// // //             </Marker>
// // //           );
// // //         })}



// // //         {/* Vehicles */}
// // //         {filteredBuses.map((bus) => {
// // //           const assignedRouteValue = getAssignedRouteValue(bus.vehicleno, assignments);
// // //           const routeNo = getBusRouteNo(bus.vehicleno, assignments);
// // //           const routeLabel = getRouteDisplayLabel(assignedRouteValue || routeNo);
// // //           const label = vehicleLabel(bus.vehicleno, assignedRouteValue);
// // //           const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
// // //           const info = nearestStopEtaForBusOnItsRoute(bus);
// // //           const recentlyPassed = recentlyPassedStopForBus(bus);
// // //           const nearestName = info ? (busStops.find(s => s.id === info.stopId)?.name) : null;
// // //           const eta =
// // //             info && info.etaMin != null
// // //               ? `${info.etaMin} min`
// // //               : info
// // //                 ? "—"
// // //                 : "Unknown";

// // //           return (
// // //             <Marker
// // //               key={bus.vehicleno}
// // //               position={{ lat: bus.latitude, lng: bus.longitude }}
// // //               // icon={createVehicleDivIcon(label, bus.heading)}
// // //               icon={createVehicleDivIcon(label, bus.heading, palette)}

// // //             >
// // //               <Popup>
// // //                 <div className="info-window">
// // //                   <h4>{bus.vehicleno} ({label})</h4>
// // //                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart</p> */}
// // //                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart, CR = Cart (RP↔ED)</p> */}
// // //                   <p><strong>Route No:</strong> {routeNo || 'Unassigned'}</p>
// // //                   <p><strong>Route:</strong> {routeLabel}</p>
// // //                   <p><strong>Recently Passed:</strong> {recentlyPassed?.name || 'Not available yet'}</p>
// // //                   {nearestName && <p><strong>Next Stop:</strong> {nearestName}</p>}
// // //                   <p><strong>Speed:</strong> {Number.isFinite(bus.speed) ? bus.speed.toFixed(1) : 'N/A'} km/h</p>
// // //                   {/* <p><strong>ETA:</strong> {eta}</p> */}
// // //                   {/* <p>
// // //                     <strong>ETA:</strong>{" "}
// // //                     {eta}
// // //                     {info && info.waitingAtFirstStop ? " (has not departed yet)" : ""}
// // //                   </p> */}
// // //                   {Number.isFinite(bus.heading) && <p><strong>Heading:</strong> {Math.round(bus.heading)}°</p>}
// // //                 </div>
// // //               </Popup>
// // //             </Marker>
// // //           );
// // //         })}
// // //       </MapContainer>

// // //       {/* Footer: Feedback link */}
// // //       <div
// // //         style={{
// // //           position: 'fixed',
// // //           left: 0,
// // //           right: 0,
// // //           bottom: -5,
// // //           display: 'flex',
// // //           justifyContent: 'center',
// // //           zIndex: 10000,
// // //           pointerEvents: 'none',
// // //           paddingBottom: 'max(6px, env(safe-area-inset-bottom))'
// // //         }}
// // //       >
// // //         <div
// // //           style={{
// // //             width: '100vw',
// // //             pointerEvents: 'auto',
// // //             display: 'flex',
// // //             alignItems: 'center',
// // //             justifyContent: 'space-between',
// // //             gap: 12,
// // //             padding: isNarrow ? '6px 10px' : '6px 16px',
// // //             borderRadius: 14,
// // //             background:
// // //               'linear-gradient(135deg, rgba(17,24,39,0.85), rgba(31,41,55,0.85))',
// // //             color: '#F9FAFB',
// // //             border: '1px solid rgba(255,255,255,0.14)',
// // //             boxShadow:
// // //               '0 12px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.06)',
// // //             backdropFilter: 'saturate(160%) blur(10px)',
// // //             WebkitBackdropFilter: 'saturate(160%) blur(10px)',
// // //             fontFamily:
// // //               '"SF Pro Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"',
// // //             fontSize: clamp('12px', '2.8vw', '14px'),
// // //             lineHeight: 1.4,
// // //             fontWeight: 500,
// // //             letterSpacing: '0.2px',
// // //           }}
// // //         >
// // //           <div
// // //             style={{
// // //               display: 'flex',
// // //               alignItems: 'center',
// // //               gap: 10,
// // //               flex: 1,
// // //               minWidth: 0,
// // //             }}
// // //           >
// // //             <div
// // //               style={{
// // //                 width: 8,
// // //                 height: 8,
// // //                 borderRadius: 9999,
// // //                 background:
// // //                   'radial-gradient(circle at 30% 30%, #34D399, #059669)',
// // //                 boxShadow: '0 0 0 3px rgba(16,185,129,0.25)',
// // //                 flex: '0 0 auto',
// // //               }}
// // //             />
// // //             <span
// // //               style={{
// // //                 opacity: 0.95,
// // //                 whiteSpace: 'nowrap',
// // //                 overflow: 'hidden',
// // //                 textOverflow: 'ellipsis',
// // //               }}
// // //             >
// // //               MInT Lab | IIT Madras | UkPact
// // //             </span>
// // //           </div>

// // //           {FEEDBACK_URL ? (
// // //             <a
// // //               href={FEEDBACK_URL}
// // //               target="_blank"
// // //               rel="noreferrer"
// // //               style={{
// // //                 display: 'inline-flex',
// // //                 alignItems: 'center',
// // //                 justifyContent: 'center',
// // //                 padding: '8px 12px',
// // //                 borderRadius: 10,
// // //                 border: '1px solid rgba(255,255,255,0.18)',
// // //                 background:
// // //                   'linear-gradient(180deg, rgba(128, 126, 126, 0.14), rgba(221, 212, 212, 0.06))',
// // //                 color: '#F9FAFB',
// // //                 textDecoration: 'none',
// // //                 fontWeight: 600,
// // //                 letterSpacing: '0.25px',
// // //                 transform: 'translateZ(0)',
// // //                 transition: 'transform 120ms ease, opacity 120ms ease',
// // //                 cursor: 'pointer',
// // //                 boxShadow:
// // //                   'inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 14px rgba(0,0,0,0.25)',
// // //               }}
// // //               onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-1px)')}
// // //               onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
// // //             >
// // //               Open feedback form ↗
// // //             </a>
// // //           ) : (
// // //             <span
// // //               style={{
// // //                 padding: '8px 12px',
// // //                 borderRadius: 10,
// // //                 border: '1px dashed rgba(255,255,255,0.25)',
// // //                 color: 'rgba(249,250,251,0.8)',
// // //                 fontWeight: 500,
// // //               }}
// // //             >
// // //               &lt;form-link&gt;
// // //             </span>
// // //           )}
// // //         </div>
// // //       </div>

// // //     </div>
// // //   );
// // // }

// // // /* ---------------------------- HOME PAGE ---------------------------- */

// // // const AIR_QUALITY_URL = "https://main.d2yil9slaoehou.amplifyapp.com/";

// // // function HomePage({ navigate }) {
// // //   const cards = [
// // //     {
// // //       title: "Bus Tracking",
// // //       subtitle: "Live vehicle location using WebSocket",
// // //       path: "/tracking",
// // //       icon: "🚌",
// // //       type: "internal",
// // //     },
// // //     {
// // //       title: "Air Quality Sensor",
// // //       subtitle: "View live air quality monitoring dashboard",
// // //       url: AIR_QUALITY_URL,
// // //       icon: "🌫️",
// // //       type: "external",
// // //     },
// // //     {
// // //       title: "Camera Data",
// // //       subtitle: "Vehicle count analytics from camera feed",
// // //       path: "/camera",
// // //       icon: "📷",
// // //       type: "internal",
// // //     },
// // //   ];

// // //   // const openCard = (card) => {
// // //   //   if (card.type === "external") {
// // //   //     window.location.href = card.url;
// // //   //     return;
// // //   //   }
// // //   //   navigate(card.path);
// // //   // };

// // //   const openCard = (card) => {
// // //   if (card.type === "external") {
// // //     window.open(card.url, "_blank", "noopener,noreferrer");
// // //     return;
// // //   }

// // //   window.open(card.path, "_blank", "noopener,noreferrer");
// // // };

// // //   return (
// // //     <div className="home-page">
// // //       <div className="home-bg-glow home-bg-glow-one" />
// // //       <div className="home-bg-glow home-bg-glow-two" />

// // //       <header className="home-navbar">
// // // <div className="home-brand">
// // //   <img
// // //     src={iitmLogo}
// // //     alt="MInT Lab Logo"
// // //     className="home-brand-logo-img"
// // //   />

// // //   <div className="home-brand-text">
// // //     <div className="home-brand-title">MInT Collaborative</div>
// // //     <div className="home-brand-subtitle">IIT Madras | UKPACT</div>
// // //   </div>
// // // </div>

// // //         <button className="home-nav-button" onClick={() => navigate("/tracking")}>
// // //           Open Tracking
// // //         </button>
// // //       </header>

// // //       <main className="home-main">
// // //         <section className="home-hero">
// // //           <div className="home-pill">Smart Mobility Dashboard</div>

// // //           <h1>
// // //             Real-time Transport, Sensor <br />
// // //             and Camera Intelligence
// // //           </h1>

// // //           <p>
// // //             A single access point for bus tracking, air quality monitoring,
// // //             and vehicle count analytics.
// // //           </p>
// // //         </section>

// // //         <section className="home-card-grid">
// // //           {cards.map((card) => (
// // //             <button
// // //               key={card.title}
// // //               className="home-feature-card"
// // //               onClick={() => openCard(card)}
// // //             >
// // //               <div className="home-card-icon">{card.icon}</div>

// // //               <div className="home-card-content">
// // //                 <h2>{card.title}</h2>
// // //                 <p>{card.subtitle}</p>
// // //               </div>

// // //               <div className="home-card-arrow">
// // //                 {card.type === "external" ? "↗" : "→"}
// // //               </div>
// // //             </button>
// // //           ))}
// // //         </section>
// // //       </main>
// // //     </div>
// // //   );
// // // }


// // // /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// // // const CAMERA_FALLBACK_DATA = [
// // //   {
// // //     timestamp: "2025-11-01 00:00:06",
// // //     auto: 0,
// // //     motorbike: 0,
// // //     bus: 0,
// // //     car: 0,
// // //     truck: 0,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:11",
// // //     auto: 0,
// // //     motorbike: 4,
// // //     bus: 1,
// // //     car: 4,
// // //     truck: 0,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:16",
// // //     auto: 0,
// // //     motorbike: 2,
// // //     bus: 0,
// // //     car: 0,
// // //     truck: 1,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:21",
// // //     auto: 0,
// // //     motorbike: 1,
// // //     bus: 0,
// // //     car: 1,
// // //     truck: 1,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:26",
// // //     auto: 0,
// // //     motorbike: 3,
// // //     bus: 0,
// // //     car: 0,
// // //     truck: 0,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:31",
// // //     auto: 0,
// // //     motorbike: 0,
// // //     bus: 0,
// // //     car: 0,
// // //     truck: 0,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:36",
// // //     auto: 0,
// // //     motorbike: 5,
// // //     bus: 0,
// // //     car: 1,
// // //     truck: 1,
// // //   },
// // //   {
// // //     timestamp: "2025-11-01 00:00:41",
// // //     auto: 0,
// // //     motorbike: 4,
// // //     bus: 1,
// // //     car: 5,
// // //     truck: 1,
// // //   },
// // // ];

// // // // function parseCameraCsv(csvText) {
// // // //   const lines = csvText
// // // //     .trim()
// // // //     .split(/\r?\n/)
// // // //     .filter(Boolean);

// // // //   if (lines.length < 2) return [];

// // // //   const headers = lines[0].split(",").map((h) => h.trim());

// // // //   return lines.slice(1).map((line) => {
// // // //     const values = line.split(",").map((v) => v.trim());
// // // //     const row = {};

// // // //     headers.forEach((header, index) => {
// // // //       if (header === "timestamp") {
// // // //         row[header] = values[index];
// // // //       } else {
// // // //         row[header] = Number(values[index] || 0);
// // // //       }
// // // //     });

// // // //     return row;
// // // //   });
// // // // }

// // // const CAMERA_LOCATIONS = [
// // //   {
// // //     id: "camera-site-1",
// // //     sno: 1,
// // //     place: "Ettayapuram Rd",
// // //     location: "Perison Plaza Signal",
// // //     boxes: 2,
// // //     cameras: 2,
// // //     lat: 8.81277,
// // //     lng: 78.13647,
// // //   },
// // //   {
// // //     id: "camera-site-2",
// // //     sno: 2,
// // //     place: "4th Gate",
// // //     location: "South side of Milavittan Road",
// // //     boxes: 1,
// // //     cameras: 1,
// // //     lat: 8.80967,
// // //     lng: 78.1335,
// // //   },
// // //   {
// // //     id: "camera-site-3",
// // //     sno: 3,
// // //     place: "International Furniture Park",
// // //     location: "Madurai - Tiruchendur Rd highway east side",
// // //     boxes: 1,
// // //     cameras: 1,
// // //     lat: 8.81624,
// // //     lng: 78.08118,
// // //   },
// // //   {
// // //     id: "camera-site-4",
// // //     sno: 4,
// // //     place: "3rd Mile",
// // //     location: "Near TVL-TUT-MDR Bypass Bridge",
// // //     boxes: 2,
// // //     cameras: 2,
// // //     lat: 8.789608,
// // //     lng: 78.11493,
// // //   },
// // //   {
// // //     id: "camera-site-5",
// // //     sno: 5,
// // //     place: "Alageshapuram Road",
// // //     location: "Roundana near St. Thomas School",
// // //     boxes: 1,
// // //     cameras: 2,
// // //     lat: 8.81705,
// // //     lng: 78.14797,
// // //   },
// // //   {
// // //     id: "camera-site-6",
// // //     sno: 6,
// // //     place: "Tiruchendur Rd",
// // //     location: "Muthiahpuram",
// // //     boxes: 1,
// // //     cameras: 1,
// // //     lat: 8.74541,
// // //     lng: 78.1253,
// // //   },
// // // ];

// // // const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// // // function parseCameraCsv(csvText) {
// // //   const lines = csvText
// // //     .trim()
// // //     .split(/\r?\n/)
// // //     .filter(Boolean);

// // //   if (lines.length < 2) return [];

// // //   const firstLine = lines[0].toLowerCase();
// // //   const hasHeader = firstLine.includes("timestamp");

// // //   const headers = hasHeader
// // //     ? lines[0].split(",").map((h) => h.trim().toLowerCase())
// // //     : ["timestamp", "auto", "motorbike", "bus", "car", "truck"];

// // //   const dataLines = hasHeader ? lines.slice(1) : lines;

// // //   return dataLines.map((line) => {
// // //     const values = line.split(",").map((v) => v.trim());
// // //     const row = {};

// // //     headers.forEach((header, index) => {
// // //       if (header === "timestamp") {
// // //         row.timestamp = values[index] || "";
// // //       } else if (
// // //         header === "cameraid" ||
// // //         header === "camera_id" ||
// // //         header === "camera" ||
// // //         header === "site"
// // //       ) {
// // //         row.cameraId = values[index] || "";
// // //       } else if (header === "direction") {
// // //         row.direction = values[index] || "All Directions";
// // //       } else {
// // //         row[header] = Number(values[index] || 0);
// // //       }
// // //     });

// // //     return {
// // //       timestamp: row.timestamp || "",
// // //       cameraId: row.cameraId || "ALL",
// // //       direction: row.direction || "All Directions",
// // //       auto: Number(row.auto || 0),
// // //       motorbike: Number(row.motorbike || 0),
// // //       bus: Number(row.bus || 0),
// // //       car: Number(row.car || 0),
// // //       truck: Number(row.truck || 0),
// // //     };
// // //   });
// // // }

// // // function sumRows(rows) {
// // //   return rows.reduce(
// // //     (acc, row) => {
// // //       acc.auto += Number(row.auto || 0);
// // //       acc.motorbike += Number(row.motorbike || 0);
// // //       acc.bus += Number(row.bus || 0);
// // //       acc.car += Number(row.car || 0);
// // //       acc.truck += Number(row.truck || 0);
// // //       return acc;
// // //     },
// // //     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // //   );
// // // }

// // // function totalFromCounts(counts) {
// // //   return VEHICLE_TYPES.reduce((sum, type) => sum + Number(counts[type] || 0), 0);
// // // }

// // // function getDateKey(timestamp) {
// // //   return String(timestamp || "").slice(0, 10);
// // // }

// // // function getWeekKey(timestamp) {
// // //   const datePart = getDateKey(timestamp);
// // //   if (!datePart) return "Unknown";

// // //   const date = new Date(`${datePart}T00:00:00`);
// // //   if (Number.isNaN(date.getTime())) return "Unknown";

// // //   const firstDay = new Date(date.getFullYear(), 0, 1);
// // //   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
// // //   const weekNumber = Math.ceil(dayNumber / 7);

// // //   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// // // }

// // // function buildChartData(rows, mode = "daily") {
// // //   const grouped = {};

// // //   rows.forEach((row) => {
// // //     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
// // //     if (!key) return;

// // //     if (!grouped[key]) {
// // //       grouped[key] = {
// // //         label: key,
// // //         auto: 0,
// // //         motorbike: 0,
// // //         bus: 0,
// // //         car: 0,
// // //         truck: 0,
// // //       };
// // //     }

// // //     VEHICLE_TYPES.forEach((type) => {
// // //       grouped[key][type] += Number(row[type] || 0);
// // //     });
// // //   });

// // //   return Object.values(grouped)
// // //     .map((item) => ({
// // //       ...item,
// // //       total: totalFromCounts(item),
// // //     }))
// // //     .sort((a, b) => a.label.localeCompare(b.label));
// // // }

// // // function buildDirectionData(rows) {
// // //   const grouped = {};

// // //   rows.forEach((row) => {
// // //     const direction = row.direction || "All Directions";

// // //     if (!grouped[direction]) {
// // //       grouped[direction] = {
// // //         direction,
// // //         auto: 0,
// // //         motorbike: 0,
// // //         bus: 0,
// // //         car: 0,
// // //         truck: 0,
// // //       };
// // //     }

// // //     VEHICLE_TYPES.forEach((type) => {
// // //       grouped[direction][type] += Number(row[type] || 0);
// // //     });
// // //   });

// // //   return Object.values(grouped).map((item) => ({
// // //     ...item,
// // //     total: totalFromCounts(item),
// // //   }));
// // // }

// // // function CameraMapFlyTo({ selectedLocation }) {
// // //   const map = useMap();

// // //   useEffect(() => {
// // //     if (!selectedLocation) return;

// // //     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
// // //       duration: 0.8,
// // //     });
// // //   }, [map, selectedLocation]);

// // //   return null;
// // // }

// // // function MiniBarChart({ title, data }) {
// // //   const maxValue = Math.max(...data.map((item) => item.total), 1);

// // //   return (
// // //     <div className="camera-chart-card">
// // //       <div className="camera-chart-header">
// // //         <h3>{title}</h3>
// // //       </div>

// // //       <div className="camera-bar-chart">
// // //         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

// // //         {data.map((item) => {
// // //           const height = Math.max(8, (item.total / maxValue) * 150);

// // //           return (
// // //             <div className="camera-bar-item" key={item.label}>
// // //               <div className="camera-bar-value">{item.total}</div>
// // //               <div className="camera-bar-track">
// // //                 <div
// // //                   className="camera-bar-fill"
// // //                   style={{ height: `${height}px` }}
// // //                 />
// // //               </div>
// // //               <div className="camera-bar-label">{item.label}</div>
// // //             </div>
// // //           );
// // //         })}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function CameraDataPage({ navigate }) {
// // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // //   const [loading, setLoading] = useState(true);
// // //   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
// // //   const [chartMode, setChartMode] = useState("daily");

// // //   const [page, setPage] = useState(1);
// // //   const [limit, setLimit] = useState(25);

// // //   useEffect(() => {
// // //     const csvUrl =
// // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // //     fetch(csvUrl)
// // //       .then((res) => {
// // //         if (!res.ok) throw new Error("CSV not found");
// // //         return res.text();
// // //       })
// // //       .then((text) => {
// // //         const parsed = parseCameraCsv(text);
// // //         if (parsed.length > 0) {
// // //           setRows(parsed.reverse());
// // //           setSourceLabel("CSV data");
// // //           setPage(1);
// // //         }
// // //       })
// // //       .catch(() => {
// // //         setRows(CAMERA_FALLBACK_DATA);
// // //         setSourceLabel("Static sample data");
// // //       })
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   const selectedRows = useMemo(() => {
// // //     const hasCameraSpecificRows = rows.some((row) => row.cameraId !== "ALL");

// // //     if (!hasCameraSpecificRows) {
// // //       return rows;
// // //     }

// // //     return rows.filter((row) => row.cameraId === selectedLocation.id);
// // //   }, [rows, selectedLocation]);

// // //   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
// // //   const totalVehicles = totalFromCounts(totals);

// // //   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
// // //   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
// // //   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

// // //   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

// // //   const totalRows = selectedRows.length;
// // //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// // //   const safePage = Math.min(page, totalPages);
// // //   const offset = (safePage - 1) * limit;

// // //   const paginatedRows = useMemo(() => {
// // //     return selectedRows.slice(offset, offset + limit);
// // //   }, [selectedRows, offset, limit]);

// // //   const latestRow = selectedRows[0];

// // //   const handleLocationClick = (location) => {
// // //     setSelectedLocation(location);
// // //     setPage(1);
// // //   };

// // //   const handleLimitChange = (e) => {
// // //     setLimit(Number(e.target.value));
// // //     setPage(1);
// // //   };

// // //   return (
// // //     <div className="camera-page">
// // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // //       <header className="camera-navbar">
// // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // //           ← Home
// // //         </button>

// // //         <div>
// // //           <h1>Camera Data</h1>
// // //           <p>Traffic counts by vehicle type and camera location</p>
// // //         </div>

// // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // //           Bus Tracking
// // //         </button>
// // //       </header>

// // //       <main className="camera-content">
// // //         <section className="camera-summary-grid">
// // //           <div className="camera-summary-card total">
// // //             <span>Total Vehicles</span>
// // //             <strong>{totalVehicles}</strong>
// // //             <small>{sourceLabel}</small>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Cars</span>
// // //             <strong>{totals.car}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Motorbikes</span>
// // //             <strong>{totals.motorbike}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Buses</span>
// // //             <strong>{totals.bus}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Trucks</span>
// // //             <strong>{totals.truck}</strong>
// // //           </div>

// // //           <div className="camera-summary-card">
// // //             <span>Autos</span>
// // //             <strong>{totals.auto}</strong>
// // //           </div>
// // //         </section>

// // //         <section className="camera-map-layout">
// // //           <aside className="camera-location-panel">
// // //             <div className="camera-location-header">
// // //               <h2>Camera Locations</h2>
// // //               <p>{CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across {CAMERA_LOCATIONS.length} locations</p>
// // //             </div>

// // //             <div className="camera-location-list">
// // //               {CAMERA_LOCATIONS.map((item) => (
// // //                 <button
// // //                   key={item.id}
// // //                   className={
// // //                     selectedLocation.id === item.id
// // //                       ? "camera-location-item active"
// // //                       : "camera-location-item"
// // //                   }
// // //                   onClick={() => handleLocationClick(item)}
// // //                 >
// // //                   <div>
// // //                     <strong>{item.place}</strong>
// // //                     <span>{item.location}</span>
// // //                   </div>

// // //                   <small>
// // //                     {item.cameras} camera{item.cameras > 1 ? "s" : ""}
// // //                   </small>
// // //                 </button>
// // //               ))}
// // //             </div>
// // //           </aside>

// // //           <section className="camera-map-card">
// // //             <MapContainer
// // //               center={[selectedLocation.lat, selectedLocation.lng]}
// // //               zoom={14}
// // //               className="camera-osm-map"
// // //               scrollWheelZoom={true}
// // //             >
// // //               <TileLayer
// // //                 attribution='&copy; OpenStreetMap contributors'
// // //                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// // //               />

// // //               <CameraMapFlyTo selectedLocation={selectedLocation} />

// // //               {CAMERA_LOCATIONS.map((item) => (
// // //                 <Marker
// // //                   key={item.id}
// // //                   position={[item.lat, item.lng]}
// // //                   eventHandlers={{
// // //                     click: () => handleLocationClick(item),
// // //                   }}
// // //                 >
// // //                   <Popup>
// // //                     <div className="camera-popup">
// // //                       <h3>{item.place}</h3>
// // //                       <p>{item.location}</p>
// // //                       <p>
// // //                         <strong>Cameras:</strong> {item.cameras}
// // //                       </p>
// // //                       <p>
// // //                         <strong>Total Vehicles:</strong>{" "}
// // //                         {selectedLocation.id === item.id ? totalVehicles : "Click location"}
// // //                       </p>
// // //                     </div>
// // //                   </Popup>
// // //                 </Marker>
// // //               ))}
// // //             </MapContainer>
// // //           </section>
// // //         </section>

// // //         <section className="camera-selected-panel">
// // //           <div>
// // //             <h2>{selectedLocation.place}</h2>
// // //             <p>{selectedLocation.location}</p>
// // //           </div>

// // //           <div className="camera-selected-meta">
// // //             <span>{selectedLocation.boxes} boxes</span>
// // //             <span>{selectedLocation.cameras} cameras</span>
// // //             <span>
// // //               {selectedLocation.lat}, {selectedLocation.lng}
// // //             </span>
// // //           </div>
// // //         </section>

// // //         {/* <section className="camera-direction-grid">
// // //           {directionData.map((item) => (
// // //             <div className="camera-direction-card" key={item.direction}>
// // //               <span>{item.direction}</span>
// // //               <strong>{item.total}</strong>
// // //               <small>
// // //                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
// // //               </small>
// // //             </div>
// // //           ))}
// // //         </section> */}

// // //         <section className="camera-chart-section">
// // //           <div className="camera-chart-toolbar">
// // //             <div>
// // //               <h2>Dashboard Analysis</h2>
// // //               <p>Daily and weekly traffic count trends</p>
// // //             </div>

// // //             <div className="camera-chart-toggle">
// // //               <button
// // //                 className={chartMode === "daily" ? "active" : ""}
// // //                 onClick={() => setChartMode("daily")}
// // //               >
// // //                 Daily
// // //               </button>
// // //               <button
// // //                 className={chartMode === "weekly" ? "active" : ""}
// // //                 onClick={() => setChartMode("weekly")}
// // //               >
// // //                 Weekly
// // //               </button>
// // //             </div>
// // //           </div>

// // //           <MiniBarChart
// // //             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
// // //             data={chartData}
// // //           />
// // //         </section>

// // //         <section className="camera-panel">
// // //           <div className="camera-panel-header">
// // //             <div>
// // //               <h2>Vehicle Count Table</h2>
// // //               <p>
// // //                 {loading
// // //                   ? "Loading camera data..."
// // //                   : latestRow
// // //                   ? `Latest timestamp: ${latestRow.timestamp}`
// // //                   : "No camera records available"}
// // //               </p>
// // //             </div>

// // //             <div className="camera-pagination-top">
// // //               <label>
// // //                 Limit
// // //                 <select value={limit} onChange={handleLimitChange}>
// // //                   <option value={10}>10</option>
// // //                   <option value={25}>25</option>
// // //                   <option value={50}>50</option>
// // //                   <option value={100}>100</option>
// // //                   <option value={200}>200</option>
// // //                 </select>
// // //               </label>
// // //             </div>
// // //           </div>

// // //           <div className="camera-table-info">
// // //             <span>
// // //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// // //               {Math.min(offset + limit, totalRows)} of {totalRows}
// // //             </span>

// // //             <span>
// // //               Offset: {offset} | Limit: {limit}
// // //             </span>
// // //           </div>

// // //           <div className="camera-table-wrap">
// // //             <table className="camera-table">
// // //               <thead>
// // //                 <tr>
// // //                   <th>Timestamp</th>
// // //                   <th>Direction</th>
// // //                   <th>Auto</th>
// // //                   <th>Motorbike</th>
// // //                   <th>Bus</th>
// // //                   <th>Car</th>
// // //                   <th>Truck</th>
// // //                 </tr>
// // //               </thead>

// // //               <tbody>
// // //                 {paginatedRows.map((row, index) => (
// // //                   <tr key={`${row.timestamp}-${index}`}>
// // //                     <td>{row.timestamp}</td>
// // //                     <td>{row.direction}</td>
// // //                     <td>{row.auto}</td>
// // //                     <td>{row.motorbike}</td>
// // //                     <td>{row.bus}</td>
// // //                     <td>{row.car}</td>
// // //                     <td>{row.truck}</td>
// // //                   </tr>
// // //                 ))}

// // //                 {!loading && paginatedRows.length === 0 && (
// // //                   <tr>
// // //                     <td colSpan="7" style={{ textAlign: "center", padding: "24px" }}>
// // //                       No camera data available
// // //                     </td>
// // //                   </tr>
// // //                 )}
// // //               </tbody>
// // //             </table>
// // //           </div>

// // //           <div className="camera-pagination-bottom">
// // //             <button onClick={() => setPage((prev) => Math.max(1, prev - 1))} disabled={safePage <= 1}>
// // //               ← Previous
// // //             </button>

// // //             <span>
// // //               Page {safePage} of {totalPages}
// // //             </span>

// // //             <button onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))} disabled={safePage >= totalPages}>
// // //               Next →
// // //             </button>
// // //           </div>
// // //         </section>
// // //       </main>
// // //     </div>
// // //   );
// // // }
// // // // function CameraDataPage({ navigate }) {
// // // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // // //   const [loading, setLoading] = useState(true);

// // // //   // Pagination states
// // // //   const [page, setPage] = useState(1);
// // // //   const [limit, setLimit] = useState(25);

// // // //   useEffect(() => {
// // // //     const csvUrl =
// // // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // // //     fetch(csvUrl)
// // // //       .then((res) => {
// // // //         if (!res.ok) throw new Error("CSV not found");
// // // //         return res.text();
// // // //       })
// // // //       .then((text) => {
// // // //         const parsed = parseCameraCsv(text);
// // // //         if (parsed.length > 0) {
// // // //           // latest data first
// // // //           setRows(parsed.reverse());
// // // //           setSourceLabel("CSV data");
// // // //           setPage(1);
// // // //         }
// // // //       })
// // // //       .catch(() => {
// // // //         setRows(CAMERA_FALLBACK_DATA);
// // // //         setSourceLabel("Static sample data");
// // // //       })
// // // //       .finally(() => setLoading(false));
// // // //   }, []);

// // // //   const totals = useMemo(() => {
// // // //     return rows.reduce(
// // // //       (acc, row) => {
// // // //         acc.auto += Number(row.auto || 0);
// // // //         acc.motorbike += Number(row.motorbike || 0);
// // // //         acc.bus += Number(row.bus || 0);
// // // //         acc.car += Number(row.car || 0);
// // // //         acc.truck += Number(row.truck || 0);
// // // //         return acc;
// // // //       },
// // // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // // //     );
// // // //   }, [rows]);

// // // //   const totalVehicles =
// // // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // // //   const totalRows = rows.length;
// // // //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// // // //   const safePage = Math.min(page, totalPages);

// // // //   const offset = (safePage - 1) * limit;

// // // //   const paginatedRows = useMemo(() => {
// // // //     return rows.slice(offset, offset + limit);
// // // //   }, [rows, offset, limit]);

// // // //   const latestRow = rows[0];

// // // //   const goToPreviousPage = () => {
// // // //     setPage((prev) => Math.max(1, prev - 1));
// // // //   };

// // // //   const goToNextPage = () => {
// // // //     setPage((prev) => Math.min(totalPages, prev + 1));
// // // //   };

// // // //   const handleLimitChange = (e) => {
// // // //     setLimit(Number(e.target.value));
// // // //     setPage(1);
// // // //   };

// // // //   return (
// // // //     <div className="camera-page">
// // // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // // //       <header className="camera-navbar">
// // // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // // //           ← Home
// // // //         </button>

// // // //         <div>
// // // //           <h1>Camera Data</h1>
// // // //           <p>Vehicle count analytics</p>
// // // //         </div>

// // // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // // //           Bus Tracking
// // // //         </button>
// // // //       </header>

// // // //       <main className="camera-content">
// // // //         <section className="camera-summary-grid">
// // // //           <div className="camera-summary-card total">
// // // //             <span>Total Vehicles</span>
// // // //             <strong>{totalVehicles}</strong>
// // // //             <small>{sourceLabel}</small>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Cars</span>
// // // //             <strong>{totals.car}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Motorbikes</span>
// // // //             <strong>{totals.motorbike}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Buses</span>
// // // //             <strong>{totals.bus}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Trucks</span>
// // // //             <strong>{totals.truck}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Autos</span>
// // // //             <strong>{totals.auto}</strong>
// // // //           </div>
// // // //         </section>

// // // //         <section className="camera-panel">
// // // //           <div className="camera-panel-header">
// // // //             <div>
// // // //               <h2>Vehicle Count Table</h2>
// // // //               <p>
// // // //                 {loading
// // // //                   ? "Loading camera data..."
// // // //                   : latestRow
// // // //                     ? `Latest timestamp: ${latestRow.timestamp}`
// // // //                     : "No camera records available"}
// // // //               </p>
// // // //             </div>

// // // //             <div className="camera-pagination-top">
// // // //               <label>
// // // //                 Limit
// // // //                 <select value={limit} onChange={handleLimitChange}>
// // // //                   <option value={10}>10</option>
// // // //                   <option value={25}>25</option>
// // // //                   <option value={50}>50</option>
// // // //                   <option value={100}>100</option>
// // // //                   <option value={200}>200</option>
// // // //                 </select>
// // // //               </label>
// // // //             </div>
// // // //           </div>

// // // //           <div className="camera-table-info">
// // // //             <span>
// // // //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// // // //               {Math.min(offset + limit, totalRows)} of {totalRows}
// // // //             </span>

// // // //             <span>
// // // //               Offset: {offset} | Limit: {limit}
// // // //             </span>
// // // //           </div>

// // // //           <div className="camera-table-wrap">
// // // //             <table className="camera-table">
// // // //               <thead>
// // // //                 <tr>
// // // //                   <th>Timestamp</th>
// // // //                   <th>Auto</th>
// // // //                   <th>Motorbike</th>
// // // //                   <th>Bus</th>
// // // //                   <th>Car</th>
// // // //                   <th>Truck</th>
// // // //                 </tr>
// // // //               </thead>

// // // //               <tbody>
// // // //                 {paginatedRows.map((row, index) => (
// // // //                   <tr key={`${row.timestamp}-${index}`}>
// // // //                     <td>{row.timestamp}</td>
// // // //                     <td>{row.auto}</td>
// // // //                     <td>{row.motorbike}</td>
// // // //                     <td>{row.bus}</td>
// // // //                     <td>{row.car}</td>
// // // //                     <td>{row.truck}</td>
// // // //                   </tr>
// // // //                 ))}

// // // //                 {!loading && paginatedRows.length === 0 && (
// // // //                   <tr>
// // // //                     <td colSpan="6" style={{ textAlign: "center", padding: "24px" }}>
// // // //                       No camera data available
// // // //                     </td>
// // // //                   </tr>
// // // //                 )}
// // // //               </tbody>
// // // //             </table>
// // // //           </div>

// // // //           <div className="camera-pagination-bottom">
// // // //             <button onClick={goToPreviousPage} disabled={safePage <= 1}>
// // // //               ← Previous
// // // //             </button>

// // // //             <span>
// // // //               Page {safePage} of {totalPages}
// // // //             </span>

// // // //             <button onClick={goToNextPage} disabled={safePage >= totalPages}>
// // // //               Next →
// // // //             </button>
// // // //           </div>
// // // //         </section>
// // // //       </main>
// // // //     </div>
// // // //   );
// // // // }
// // // // function CameraDataPage({ navigate }) {
// // // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // // //   const [loading, setLoading] = useState(true);

// // // //   useEffect(() => {
// // // //     const csvUrl =
// // // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // // //     fetch(csvUrl)
// // // //       .then((res) => {
// // // //         if (!res.ok) throw new Error("CSV not found");
// // // //         return res.text();
// // // //       })
// // // //       .then((text) => {
// // // //         const parsed = parseCameraCsv(text);
// // // //         if (parsed.length > 0) {
// // // //           setRows(parsed);
// // // //           setSourceLabel("CSV data");
// // // //         }
// // // //       })
// // // //       .catch(() => {
// // // //         setRows(CAMERA_FALLBACK_DATA);
// // // //         setSourceLabel("Static sample data");
// // // //       })
// // // //       .finally(() => setLoading(false));
// // // //   }, []);

// // // //   const totals = useMemo(() => {
// // // //     return rows.reduce(
// // // //       (acc, row) => {
// // // //         acc.auto += Number(row.auto || 0);
// // // //         acc.motorbike += Number(row.motorbike || 0);
// // // //         acc.bus += Number(row.bus || 0);
// // // //         acc.car += Number(row.car || 0);
// // // //         acc.truck += Number(row.truck || 0);
// // // //         return acc;
// // // //       },
// // // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // // //     );
// // // //   }, [rows]);

// // // //   const totalVehicles =
// // // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // // //   const latestRow = rows[rows.length - 1];

// // // //   return (
// // // //     <div className="camera-page">
// // // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // // //       <header className="camera-navbar">
// // // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // // //           ← Home
// // // //         </button>

// // // //         <div>
// // // //           <h1>Camera Data</h1>
// // // //           <p>Vehicle count analytics</p>
// // // //         </div>

// // // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // // //           Bus Tracking
// // // //         </button>
// // // //       </header>

// // // //       <main className="camera-content">
// // // //         <section className="camera-summary-grid">
// // // //           <div className="camera-summary-card total">
// // // //             <span>Total Vehicles</span>
// // // //             <strong>{totalVehicles}</strong>
// // // //             <small>{sourceLabel}</small>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Cars</span>
// // // //             <strong>{totals.car}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Motorbikes</span>
// // // //             <strong>{totals.motorbike}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Buses</span>
// // // //             <strong>{totals.bus}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Trucks</span>
// // // //             <strong>{totals.truck}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Autos</span>
// // // //             <strong>{totals.auto}</strong>
// // // //           </div>
// // // //         </section>

// // // //         <section className="camera-panel">
// // // //           <div className="camera-panel-header">
// // // //             <div>
// // // //               <h2>Vehicle Count Table</h2>
// // // //               <p>
// // // //                 {loading
// // // //                   ? "Loading camera data..."
// // // //                   : latestRow
// // // //                   ? `Latest timestamp: ${latestRow.timestamp}`
// // // //                   : "No camera records available"}
// // // //               </p>
// // // //             </div>
// // // //           </div>

// // // //           <div className="camera-table-wrap">
// // // //             <table className="camera-table">
// // // //               <thead>
// // // //                 <tr>
// // // //                   <th>Timestamp</th>
// // // //                   <th>Auto</th>
// // // //                   <th>Motorbike</th>
// // // //                   <th>Bus</th>
// // // //                   <th>Car</th>
// // // //                   <th>Truck</th>
// // // //                 </tr>
// // // //               </thead>

// // // //               <tbody>
// // // //                 {rows.map((row, index) => (
// // // //                   <tr key={`${row.timestamp}-${index}`}>
// // // //                     <td>{row.timestamp}</td>
// // // //                     <td>{row.auto}</td>
// // // //                     <td>{row.motorbike}</td>
// // // //                     <td>{row.bus}</td>
// // // //                     <td>{row.car}</td>
// // // //                     <td>{row.truck}</td>
// // // //                   </tr>
// // // //                 ))}
// // // //               </tbody>
// // // //             </table>
// // // //           </div>
// // // //         </section>
// // // //       </main>
// // // //     </div>
// // // //   );
// // // // }

// // // /* ---------------------------- APP (router) ---------------------------- */
// // // /* ---------------------------- APP (router) ---------------------------- */

// // // function App() {
// // //   const { path, navigate } = usePath();
// // //   const token = getToken();
// // //   const adminToken = getAdminToken();

// // //   // Track page views on bus tracking page for Prometheus
// // //   useEffect(() => {
// // //     if (!BACKEND) return;
// // //     if (path !== "/tracking") return;
// // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// // //   }, [path]);

// // //   // Forward /driver -> /driverRoute when logged in
// // //   useEffect(() => {
// // //     if (path === "/driver" && token) {
// // //       navigate("/driverRoute");
// // //     }
// // //   }, [path, token, navigate]);

// // //   // Admin redirects
// // //   useEffect(() => {
// // //     if (path === "/admin/login" && adminToken) {
// // //       navigate("/admin");
// // //     } else if (path === "/admin" && !adminToken) {
// // //       navigate("/admin/login");
// // //     }
// // //   }, [path, adminToken, navigate]);

// // //   // New public pages
// // //   if (path === "/") {
// // //     return <HomePage navigate={navigate} />;
// // //   }

// // //   if (path === "/tracking") {
// // //     return <MapPage />;
// // //   }

// // //   if (path === "/camera") {
// // //     return <CameraDataPage navigate={navigate} />;
// // //   }

// // //   // Existing driver pages
// // //   if (path === "/driver") {
// // //     if (token) return null;
// // //     return <DriverLogin navigate={navigate} />;
// // //   }

// // //   if (path === "/driverRoute") {
// // //     return <DriverRoute navigate={navigate} />;
// // //   }

// // //   // Existing admin pages
// // //   if (path === "/admin/login") {
// // //     if (adminToken) return null;
// // //     return <AdminLogin navigate={navigate} />;
// // //   }

// // //   if (path === "/admin") {
// // //     return <AdminDashboard navigate={navigate} />;
// // //   }

// // //   // Fallback
// // //   return <HomePage navigate={navigate} />;
// // // }

// // // // export default function App() {
// // // //   const { path, navigate } = usePath();
// // // //   const token = getToken();
// // // //   const adminToken = getAdminToken();

// // // //   // Track page views on main map for Prometheus
// // // //   useEffect(() => {
// // // //     if (!BACKEND) return;
// // // //     if (path !== "/") return;
// // // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// // // //   }, [path]);

// // // //   // Forward /driver -> /driverRoute when logged in
// // // //   useEffect(() => {
// // // //     if (path === "/driver" && token) {
// // // //       navigate("/driverRoute");
// // // //     }
// // // //   }, [path, token, navigate]);

// // // //   // Admin redirects
// // // //   useEffect(() => {
// // // //     if (path === "/admin/login" && adminToken) {
// // // //       navigate("/admin");
// // // //     } else if (path === "/admin" && !adminToken) {
// // // //       navigate("/admin/login");
// // // //     }
// // // //   }, [path, adminToken, navigate]);

// // // //   if (path === "/driver") {
// // // //     if (token) return null;
// // // //     return <DriverLogin navigate={navigate} />;
// // // //   }
// // // //   if (path === "/driverRoute") return <DriverRoute navigate={navigate} />;

// // // //   if (path === "/admin/login") {
// // // //     if (adminToken) return null;
// // // //     return <AdminLogin navigate={navigate} />;
// // // //   }
// // // //   if (path === "/admin") {
// // // //     return <AdminDashboard navigate={navigate} />;
// // // //   }

// // // //   return <MapPage />;
// // // // }

// // // // export default function App() {
// // // //   const { path, navigate } = usePath();
// // // //   const token = getToken();

// // // //   // Track page views on main map for Prometheus
// // // //   useEffect(() => {
// // // //     if (!BACKEND) return;
// // // //     if (path !== "/") return;
// // // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => {});
// // // //   }, [path]);

// // // //   // Forward /driver -> /driverRoute when logged in (no hooks called conditionally)
// // // //   useEffect(() => {
// // // //     if (path === '/driver' && token) {
// // // //       navigate('/driverRoute');
// // // //     }
// // // //   }, [path, token, navigate]);

// // // //   if (path === '/driver') {
// // // //     if (token) return null;
// // // //     return <DriverLogin navigate={navigate} />;
// // // //   }
// // // //   if (path === '/driverRoute') return <DriverRoute navigate={navigate} />;
// // // //   return <MapPage />;
// // // // }

// // // export { App };
// // // export default App;



// // // // // thoothukudi/frontend/src/App.js

// // // // // import React, { useEffect, useState, useRef, useLayoutEffect, useMemo } from 'react';
// // // // import React, {
// // // //   useEffect,
// // // //   useState,
// // // //   useRef,
// // // //   useLayoutEffect,
// // // //   useMemo,
// // // //   useCallback
// // // // } from 'react';

// // // // import axios from 'axios';
// // // // import { io } from 'socket.io-client';
// // // // import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
// // // // import L from 'leaflet';
// // // // import 'leaflet/dist/leaflet.css';
// // // // import './App.css';
// // // // import * as turf from '@turf/turf';

// // // // // ---- Assets in src/assets ----
// // // // import userIcon from './assets/user-icon.png';
// // // // import stopIconImg from './assets/bus-stop.png';
// // // // // import iitmLogo from './assets/iitm-logo.png';
// // // // import iitmLogo from './assets/mint_logo.png';

// // // // // ---- Backend base URL ----
// // // // const BACKEND = process.env.REACT_APP_BACKEND_URL;
// // // // const API_KEY = process.env.REACT_APP_API_KEY;


// // // // // ---- Static roads URL (public/roads.geojson) ----
// // // // const ROADS_URL = `${process.env.PUBLIC_URL || ''}/roads.geojson`;

// // // // // ---- Map zoom param ----
// // // // const DEFAULT_ZOOM = 16;

// // // // // ---- Smoothing / Snap params ----
// // // // const SMOOTH_ALPHA = 0.3;
// // // // const HEADING_ALPHA = 0.35;
// // // // const SNAP_MAX_DIST_M = 20;

// // // // // Staleness threshold for under-maintenance banner
// // // // const STALE_MS = 150_000; // ~2.5 minutes

// // // // // Initial center (fallback)
// // // // // const center = { lat: 12.9915, lng: 80.2336 };
// // // // const center = { lat: 8.7642, lng: 78.1348 };

// // // // // ---------------- STOPS WITH IDS (for route math) ----------------
// // // // // const busStops = [
// // // // //   { name: 'Velachery Gate IIT Campus Stop', lat: 12.988763557585395, lng: 80.22367960515129, id: 1 },
// // // // //   { name: 'NAC2 Stop Towards GC', lat: 12.990236, lng: 80.227548, id: 2 },
// // // // //   { name: 'Nac2 Towards Velachery Stop', lat: 12.9898636, lng: 80.2271109, id: 3 },
// // // // //   { name: 'CRC Towards GC Stop', lat: 12.99089, lng: 80.230274, id: 4 },
// // // // //   { name: 'CRC Towards Velachery Stop', lat: 12.99079680, lng: 80.23016660, id: 5 },  
// // // // //   { name: 'HSB Stop Towards Velachery Stop', lat: 12.99076780, lng: 80.23168950, id: 6},
// // // // //   { name: 'HSB Stop Towards GC', lat: 12.991037, lng: 80.232065, id: 7},
// // // // //   { name: 'KV Stop Towards Main Gate', lat: 12.991868573807471, lng: 80.23367454352295, id: 8 },
// // // // //   { name: 'KV Stop Towards GC', lat: 12.991910, lng: 80.233785, id: 9 },
// // // // //   { name: 'Postoffice Stop Towards Main Gate', lat: 12.99388680, lng: 80.23428760, id: 10 },
// // // // //   { name: 'Postoffice Stop Towards GC', lat: 12.99393340, lng: 80.23459350, id: 11 },
// // // // //   { name: 'E1 Stop Towards Main Gate', lat: 12.9960173, lng: 80.2359173, id: 12 },
// // // // //   { name: 'E1 Stop Towards GC', lat: 12.996117, lng: 80.236184, id: 13},
// // // // //   { name: 'Vana Vani Stop Towards Main Gate', lat: 12.998704, lng: 80.2391799, id: 14 },
// // // // //   { name: 'Vana Vani Stop Towards GC', lat: 12.999084,   lng:  80.239380, id: 15 },
// // // // //   { name: 'D1 Stop Towards Main Gate', lat:13.002546, lng: 80.240091, id: 16},
// // // // //   { name: 'D1 Stop Towards GC', lat: 13.002679,  lng: 80.240219, id: 17 },
// // // // //   { name: 'Main Gate', lat: 13.00612964850378, lng: 80.24191299117685, id: 18 },
// // // // //   { name: 'GC Stop Towards Hostel', lat: 12.991342, lng: 80.233637, id: 19 },
// // // // //   { name: 'Library Stop', lat: 12.9907517, lng: 80.2334554, id: 20 },
// // // // //   { name: 'OAT Stop Towards Hostel', lat: 12.989257,  lng: 80.233031, id: 21},
// // // // //   { name: 'Gymkhana Stop Towards GC', lat: 12.9866372, lng: 80.2332951, id: 22},
// // // // //   { name: 'Gymkhana Stop Towards Hostel', lat: 12.986615, lng: 80.233366, id: 23 },
// // // // //   { name: 'Narmada Stop Towards GC', lat: 12.9862759, lng: 80.2350107, id: 24 },
// // // // //   { name: 'Narmada Stop Towards Hostel', lat: 12.986546, lng: 80.235301, id: 25 },
// // // // //   { name: 'Jamuna and Ganga Stand', lat: 12.986566332825637, lng: 80.23855704439099, id: 26 },
// // // // //   { name: 'RP Stand', lat: 12.990088, lng: 80.241799, id: 28},
// // // // //   { name: 'ED Stand', lat: 12.989874633072303, lng: 80.22646042038593, id: 29},
// // // // // ];

// // // // const busStops = [
// // // //   { name: 'THOOTHUKUDI OLD B/S', lat: 8.803153, lng: 78.140603, id: 1 },
// // // //   { name: 'VOC COLLEGE', lat: 8.795628, lng: 78.126712, id: 2 },
// // // //   { name: '3RD MILE', lat: 8.790018, lng: 78.115506, id: 3 },
// // // //   { name: 'KORAMPALLAM', lat: 8.778041, lng: 78.092443, id: 4 },
// // // //   { name: 'ANTHONIYARPURAM', lat: 8.773973, lng: 78.085733, id: 5 },
// // // //   { name: 'THATTAPARAI JUNCTION', lat: 8.755951, lng: 78.06592, id: 6 },
// // // //   { name: 'PUDHUKOTTAI', lat: 8.745961, lng: 78.053331, id: 7 },
// // // //   { name: 'SIRUPADU JUNCTION', lat: 8.741241, lng: 78.057561, id: 8 },
// // // //   { name: 'KOOTTAMPULI', lat: 8.721905, lng: 78.065464, id: 9 },
// // // //   { name: 'SERVAIKARANMADAM', lat: 8.706851, lng: 78.055434, id: 10 },
// // // //   { name: 'JAKKAMMALPURAM', lat: 8.696665, lng: 78.048089, id: 11 },
// // // //   { name: 'SEBATHAIAHPURAM', lat: 8.685897, lng: 78.04382, id: 12 },
// // // //   { name: 'SAWYERPURAM', lat: 8.683487, lng: 78.031302, id: 13 },
// // // //   { name: 'SUBRAMANIYAPURAM', lat: 8.674211, lng: 78.026536, id: 14 },
// // // //   { name: 'RAMASAMYPURAM BRIDGE', lat: 8.669235, lng: 78.031267, id: 15 },
// // // //   { name: 'PERUMPADAI SASTHA KOVIL', lat: 8.671132, lng: 78.041593, id: 16 },
// // // //   { name: 'RAMASAMYPURAM', lat: 8.669235, lng: 78.031267, id: 17 },
// // // //   { name: 'ZAKKAMMALPURAM', lat: 8.653646, lng: 78.025552, id: 18 },
// // // //   { name: 'SIRUTHONDANALLUR', lat: 8.634397, lng: 78.019538, id: 19 },
// // // //   { name: 'ERAL', lat: 8.625024, lng: 78.02535, id: 20 },
// // // //   { name: 'MANGALAGIRI', lat: 8.740194, lng: 78.037454, id: 21 },
// // // //   { name: 'ALLIKULAM', lat: 8.761745, lng: 78.027343, id: 22 },
// // // //   { name: 'THIRUVANANDHA PURAM', lat: 8.770303, lng: 78.018599, id: 23 },
// // // //   { name: 'PEROORANI', lat: 8.766952, lng: 78.001463, id: 24 },
// // // //   { name: 'UZHAVAR SANTHAI', lat: 8.809685, lng: 78.137081, id: 25 },
// // // //   { name: '4TH GATE', lat: 8.809664, lng: 78.133561, id: 26 },
// // // //   { name: 'THRES PURAM', lat: 8.815399, lng: 78.160791, id: 27 },
// // // //   { name: 'SUB COLLECTOR OFFICE', lat: 8.803112, lng: 78.158268, id: 28 },
// // // //   { name: 'MILLER PURAM', lat: 8.795547, lng: 78.125969, id: 29 },
// // // //   { name: 'NATTATTHI', lat: 8.668795, lng: 78.009948, id: 30 },
// // // //   { name: 'PANDARAVILAI', lat: 8.65757, lng: 77.999515, id: 31 },
// // // //   { name: 'PERUNKULAM', lat: 8.642502, lng: 77.997765, id: 32 },
// // // //   { name: 'SIVAKALAI', lat: 8.640133, lng: 77.977687, id: 33 },
// // // //   { name: 'KULAIYANKARISAL', lat: 8.719266, lng: 78.077173, id: 34 },
// // // //   { name: 'SIRUPADU', lat: 8.739285, lng: 78.067272, id: 35 },
// // // //   { name: 'PEIKULAM', lat: 8.70684, lng: 78.055406, id: 36 },
// // // //   { name: 'SALAI', lat: 8.696664, lng: 78.048079, id: 37 },
// // // //   { name: 'MANGALAKURICHI', lat: 8.625375, lng: 77.997223, id: 38 },
// // // //   { name: 'THIRD MILE', lat: 8.790018, lng: 78.115506, id: 39 },
// // // //   { name: 'SUBRAMANIAPURAM', lat: 8.674211, lng: 78.026536, id: 40 },
// // // //   { name: 'MARKET', lat: 8.801757, lng: 78.139084, id: 41 },
// // // //   { name: 'LEVANJIPURAM', lat: 8.789036, lng: 78.141181, id: 42 },
// // // //   { name: 'UPPATTHU ODAI', lat: 8.771189, lng: 78.134295, id: 43 },
// // // //   { name: 'MUTHAIAHPURAM', lat: 8.742466, lng: 78.123763, id: 44 },
// // // //   { name: 'SPIC NAGAR', lat: 8.739716, lng: 78.122362, id: 45 },
// // // //   { name: 'MULLAKADU', lat: 8.727742, lng: 78.116493, id: 46 },
// // // //   { name: 'MADHIKETTAN ODAI', lat: 8.702375, lng: 78.106893, id: 47 },
// // // //   { name: 'KOVANKADU JUNCTION', lat: 8.690703, lng: 78.10397, id: 48 },
// // // //   { name: 'PALAIYA KAYAL', lat: 8.671247, lng: 78.094375, id: 49 },
// // // //   { name: 'CHAMBER', lat: 8.649106, lng: 78.083705, id: 50 },
// // // //   { name: 'MUKKANI', lat: 8.63453, lng: 78.073992, id: 51 },
// // // //   { name: 'UMARIKADU', lat: 8.626411, lng: 78.059076, id: 52 },
// // // //   { name: 'VAZHAVALLAN', lat: 8.631211, lng: 78.047511, id: 53 },
// // // //   { name: 'WATER TANK', lat: 8.625474, lng: 78.052962, id: 54 },
// // // //   { name: 'SETHUSUBRAMANIAPURAM', lat: 8.616498, lng: 78.029879, id: 55 },
// // // //   { name: 'KURUMBUR', lat: 8.591328, lng: 78.044404, id: 56 },
// // // //   { name: 'KURUMBUR R/S', lat: 8.585888, lng: 78.039294, id: 57 },
// // // //   { name: 'AMERICAN HOSPITAL', lat: 8.813731, lng: 78.146898, id: 58 },
// // // //   { name: 'KEBI', lat: 8.814688, lng: 78.151524, id: 59 },
// // // //   { name: 'MURUGAN THEATRE', lat: 8.819765, lng: 78.155648, id: 60 },
// // // //   { name: 'RAJA PALAIYAM', lat: 8.827343, lng: 78.153629, id: 61 },
// // // //   { name: 'THALAMUTHU NAGAR', lat: 8.834404, lng: 78.152257, id: 62 },
// // // //   { name: 'AROCKIAPURAM', lat: 8.825379, lng: 78.149005, id: 63 },
// // // //   { name: 'SAVARAIYARPURAM', lat: 8.834448, lng: 78.14485, id: 64 },
// // // //   { name: 'SAVARAIYARPURAM JUNCTION', lat: 8.83936, lng: 78.143028, id: 65 },
// // // //   { name: 'STATE BANK COLONY', lat: 8.817087, lng: 78.132907, id: 66 },
// // // //   { name: 'MAPPILLAIYOORANI', lat: 8.831674, lng: 78.127735, id: 67 },
// // // //   { name: 'KALI KOVIL JUNCTION', lat: 8.836141, lng: 78.126243, id: 68 },
// // // //   { name: 'ODAIPATTI PUDHUR', lat: 8.853648, lng: 78.1202, id: 69 },
// // // //   { name: 'VELAYUTHAPURAM', lat: 8.859844, lng: 78.107125, id: 70 },
// // // //   { name: 'NAINAR PURAM', lat: 8.866548, lng: 78.091527, id: 71 },
// // // //   { name: 'CHILLANATTHAM', lat: 8.873462, lng: 78.071265, id: 72 },
// // // //   { name: 'RAJAVIN KOVIL', lat: 8.873143, lng: 78.048237, id: 73 },
// // // //   { name: 'PUTHIYAMPUTHUR', lat: 8.872962, lng: 78.032288, id: 74 },
// // // //   { name: 'MUPPULIPATI', lat: 8.900392, lng: 78.02567, id: 75 },
// // // //   { name: 'OTTAPIDARAM', lat: 8.909341, lng: 78.022479, id: 76 },
// // // //   { name: 'THOOTHUKUDI NEW B/S', lat: 8.810793, lng: 78.138305, id: 77 },
// // // //   { name: 'BYPASS', lat: 8.785154, lng: 78.106127, id: 78 },
// // // //   { name: 'MADATTHOOR', lat: 8.79436, lng: 78.097304, id: 79 },
// // // //   { name: 'SIPCOT COMPLEX', lat: 8.804587, lng: 78.084655, id: 80 },
// // // //   { name: 'RAILWAY GATE', lat: 8.812567, lng: 78.080637, id: 81 },
// // // //   { name: 'VEERAPANDIAPURAM', lat: 8.827254, lng: 78.065695, id: 82 },
// // // //   { name: 'KAYALOORANI', lat: 8.840263, lng: 78.06139, id: 83 },
// // // //   { name: 'SAMYNATTHAM', lat: 8.864407, lng: 78.055924, id: 84 },
// // // //   { name: 'OSANOOTTHU', lat: 8.891915, lng: 77.982711, id: 85 },
// // // //   { name: 'KOMBADI', lat: 8.879422, lng: 77.963106, id: 86 },
// // // //   { name: 'PANDIAPURAM', lat: 8.862311, lng: 77.934601, id: 87 },
// // // //   { name: 'PARAIKUTTAM', lat: 8.858671, lng: 77.924877, id: 88 },
// // // //   { name: 'VADAMALAPURAM', lat: 8.860927, lng: 77.90675, id: 89 },
// // // //   { name: 'MANIYACCHI', lat: 8.863306, lng: 77.894711, id: 90 },
// // // //   { name: 'OTTANATTHAM', lat: 8.903988, lng: 77.898311, id: 91 },
// // // //   { name: 'KALLATTHIKINARU', lat: 8.919118, lng: 77.885396, id: 92 },
// // // //   { name: 'MALAIPATTI', lat: 8.936648, lng: 77.888163, id: 93 },
// // // //   { name: 'ILAVELANKAL', lat: 8.946648, lng: 77.864022, id: 94 },
// // // //   { name: 'IYRAVIPATTI', lat: 8.93203, lng: 77.864758, id: 95 },
// // // //   { name: 'PARIVALLIKOTTAI', lat: 8.923368, lng: 77.874054, id: 96 },
// // // //   { name: 'THANNEER PANDHAL', lat: 8.862521, lng: 78.116944, id: 97 },
// // // //   { name: 'ARASADI JUNCTION', lat: 8.879929, lng: 78.111422, id: 98 },
// // // //   { name: 'VALASAMUTHIRAM', lat: 8.902361, lng: 78.102086, id: 99 },
// // // //   { name: 'KURUKKUSALAI', lat: 8.93141, lng: 78.088196, id: 100 },
// // // //   { name: 'RAMACHANDRAPURAM', lat: 8.927895, lng: 78.077923, id: 101 },
// // // //   { name: 'KAKKARAMPATTI JUNCTION', lat: 8.925977, lng: 78.064895, id: 102 },
// // // //   { name: 'MEENAKSHIPURAM', lat: 8.923832, lng: 78.057035, id: 103 },
// // // //   { name: 'OTTAPIDARAM TALUK OFFICE', lat: 8.90652, lng: 78.02099, id: 104 },
// // // //   { name: 'AYYANAR KOVIL', lat: 8.902593, lng: 78.012899, id: 105 },
// // // //   { name: 'KULASEKARANALLOOR', lat: 8.899773, lng: 77.981243, id: 106 },
// // // //   { name: 'SOUTH AARAIKULAM', lat: 8.916444, lng: 77.974949, id: 107 },
// // // //   { name: 'NORTH AARAIKULAM', lat: 8.92394, lng: 77.973027, id: 108 },
// // // //   { name: 'TALUK OFFICE', lat: 8.90652, lng: 78.02099, id: 109 },
// // // //   { name: 'THERKKU ARAIKULAM', lat: 8.916444, lng: 77.974949, id: 110 },
// // // //   { name: 'THOMAS NAGAR', lat: 8.839335, lng: 78.143038, id: 111 },
// // // //   { name: 'AYYANAR PURAM', lat: 8.859083, lng: 78.145946, id: 112 },
// // // //   { name: 'JOTHI SALT', lat: 8.863746, lng: 78.147926, id: 113 },
// // // //   { name: 'THARUVAIKULAM', lat: 8.896085, lng: 78.162889, id: 114 },
// // // //   { name: 'PATTINAMARUTHUR', lat: 8.923039, lng: 78.179675, id: 115 },
// // // //   { name: 'KALMEDU', lat: 8.943135, lng: 78.180943, id: 116 },
// // // //   { name: 'CHEMICAL', lat: 8.961828, lng: 78.180195, id: 117 },
// // // //   { name: 'VEPPALODAI', lat: 8.966764, lng: 78.180558, id: 118 },
// // // //   { name: 'PANAIYOOR JUNCTION', lat: 8.979427, lng: 78.200198, id: 119 },
// // // //   { name: 'SALT FACTORY', lat: 8.993585, lng: 78.216936, id: 120 },
// // // //   { name: 'KALLOORANI', lat: 8.990696, lng: 78.231998, id: 121 },
// // // //   { name: 'KEELA VAIPPAR', lat: 8.999548, lng: 78.25141, id: 122 },
// // // //   { name: 'THULUKKANKULAM', lat: 9.03166, lng: 78.27264, id: 123 },
// // // //   { name: 'KALAIGNANAPURAM', lat: 9.032364, lng: 78.266939, id: 124 },
// // // //   { name: 'KALAIGNANAPURAM JUNCTION', lat: 9.035342, lng: 78.258363, id: 125 },
// // // //   { name: 'VAIPPAR', lat: 9.02594, lng: 78.245625, id: 126 },
// // // //   { name: 'SOUTHERN SALT', lat: 8.705618, lng: 78.108039, id: 127 },
// // // //   { name: 'NORTH AUTHOOR', lat: 8.622425, lng: 78.070322, id: 128 },
// // // //   { name: 'SOUTH AUTHOOR', lat: 8.614603, lng: 78.07071, id: 129 },
// // // //   { name: 'AYYANKOVIL JUNCTION', lat: 8.598784, lng: 78.072198, id: 130 },
// // // //   { name: 'MICHEAL NADAR KUDIYIRUPPU', lat: 8.601003, lng: 78.053355, id: 131 },
// // // //   { name: 'PANAIYOOR GATE', lat: 8.979427, lng: 78.200198, id: 132 },
// // // //   { name: 'AM PATTI', lat: 8.901119, lng: 78.144213, id: 133 },
// // // //   { name: 'THERMAL STATION', lat: 8.90232, lng: 78.138007, id: 134 },
// // // //   { name: 'AM PATTI JUNCTION', lat: 8.907276, lng: 78.126656, id: 135 },
// // // //   { name: 'MELA MARUTHUR', lat: 8.914773, lng: 78.137694, id: 136 },
// // // //   { name: 'DURAISAMYPURAM', lat: 8.938686, lng: 78.15632, id: 137 },
// // // //   { name: 'SOUTH KALMEDU', lat: 8.951746, lng: 78.168851, id: 138 },
// // // //   { name: 'NORTH KALMEDU', lat: 8.954783, lng: 78.170766, id: 139 },
// // // //   { name: 'PANAIYOOR', lat: 8.992923, lng: 78.196242, id: 140 },
// // // //   { name: 'KULATTHOOR', lat: 9.004578, lng: 78.194272, id: 141 },
// // // //   { name: 'COLONY', lat: 9.008341, lng: 78.204491, id: 142 },
// // // //   { name: 'ARASADI', lat: 8.870406, lng: 78.127151, id: 143 },
// // // //   { name: 'KEELA ARASADI', lat: 8.877666, lng: 78.127424, id: 144 },
// // // //   { name: 'KUMARAPURAM', lat: 8.899629, lng: 78.119815, id: 145 },
// // // //   { name: 'PUDHUR', lat: 8.949025, lng: 78.149634, id: 146 },
// // // //   { name: 'VEDANATTHAM', lat: 8.968335, lng: 78.145818, id: 147 },
// // // //   { name: 'VENKATACHALAPURAM', lat: 8.979063, lng: 78.157313, id: 148 },
// // // //   { name: 'MUTHUKUMARAPURAM', lat: 8.992612, lng: 78.145428, id: 149 },
// // // //   { name: 'SUBRAMANIYAPURAM JUNCTION', lat: 9.015801, lng: 78.225924, id: 150 },
// // // //   { name: 'THULUKKANKULAM JUNCTION', lat: 9.035332, lng: 78.258348, id: 151 },
// // // //   { name: 'CHANDRAGIRI JUNCTION', lat: 8.959742, lng: 78.092867, id: 152 },
// // // //   { name: 'CHANDRAGIRI', lat: 8.963758, lng: 78.074077, id: 153 },
// // // //   { name: 'KOLLAMPARAMBU', lat: 8.981801, lng: 78.119157, id: 154 },
// // // //   { name: 'SEITHALAI JUNCTION', lat: 8.979604, lng: 78.068883, id: 155 },
// // // //   { name: 'KEELA SEITHALAI', lat: 8.988456, lng: 78.09318, id: 156 },
// // // //   { name: 'KOVANKADU', lat: 8.690829, lng: 78.10406, id: 157 },
// // // //   { name: 'SOUTH KOVANKADU', lat: 8.69028, lng: 78.089963, id: 158 },
// // // //   { name: 'SAMBADI', lat: 8.669595, lng: 78.078838, id: 159 },
// // // //   { name: 'IDAYARKADU', lat: 8.664261, lng: 78.064077, id: 160 },
// // // //   { name: 'MARAMANGALAM', lat: 8.657852, lng: 78.06031, id: 161 },
// // // //   { name: 'ARUMUGAMANGALAM', lat: 8.649895, lng: 78.042699, id: 162 },
// // // //   { name: 'POTTALKADU', lat: 8.719686, lng: 78.102315, id: 163 },
// // // //   { name: 'KATTALANKULAM', lat: 8.698745, lng: 78.007, id: 164 },
// // // //   { name: 'M. PUDHUR', lat: 8.722007, lng: 78.002788, id: 165 },
// // // //   { name: 'MUDIVAITHANENDAL', lat: 8.723319, lng: 77.990336, id: 166 },
// // // //   { name: 'VAGAIKULAM', lat: 8.73473, lng: 78.001301, id: 167 },
// // // //   { name: 'CHETTIKULAM', lat: 8.662797, lng: 78.029329, id: 168 },
// // // //   { name: 'AGARAM BRIDGE', lat: 8.661354, lng: 78.088323, id: 169 },
// // // //   { name: 'AGARAM', lat: 8.659921, lng: 78.075828, id: 170 },
// // // //   { name: 'KORKAI', lat: 8.642078, lng: 78.058734, id: 171 },
// // // //   { name: 'AUTHOOR', lat: 8.622355, lng: 78.070341, id: 172 },
// // // //   { name: 'CHERNTHAMARAM', lat: 8.634982, lng: 78.087918, id: 173 },
// // // //   { name: 'DCW COLONY', lat: 8.632673, lng: 78.101623, id: 174 },
// // // //   { name: 'PUNNAKAYAL', lat: 8.634945, lng: 78.117073, id: 175 },
// // // //   { name: 'ATTHIMARAPATTI JUNCTION', lat: 8.741554, lng: 78.123287, id: 176 },
// // // //   { name: 'ATTHIMARAPATTI', lat: 8.742208, lng: 78.104441, id: 177 },
// // // //   { name: 'PON NAGAR', lat: 8.734551, lng: 78.104669, id: 178 },
// // // //   { name: 'THERMAL NAGAR', lat: 8.759198, lng: 78.147347, id: 179 },
// // // //   { name: 'THERMAL NAGAR JUNCTION', lat: 8.758436, lng: 78.155625, id: 180 },
// // // //   { name: 'TTPP', lat: 8.755276, lng: 78.175103, id: 181 },
// // // //   { name: 'CHILDREN\'S PARK', lat: 8.746429, lng: 78.168838, id: 182 },
// // // //   { name: 'CAMP-II', lat: 8.742206, lng: 78.163757, id: 183 },
// // // //   { name: 'BULK', lat: 8.745284, lng: 78.125352, id: 184 },
// // // //   { name: 'ROCH PARK', lat: 8.787746, lng: 78.15925, id: 185 },
// // // //   { name: 'TTPP JUNCTION', lat: 8.755763, lng: 78.170323, id: 186 },
// // // //   { name: 'VELLAPATTI', lat: 8.857643, lng: 78.160709, id: 187 },
// // // //   { name: 'KAKKARAMPATTI', lat: 8.928274, lng: 78.058146, id: 188 },
// // // //   { name: 'AGILANDAPURAM', lat: 8.933352, lng: 78.050208, id: 189 },
// // // //   { name: 'PANCHALANKURICHI', lat: 8.932598, lng: 78.032564, id: 190 },
// // // //   { name: 'KUMARAPURAM JUNCTION', lat: 8.9479, lng: 78.080564, id: 191 },
// // // //   { name: 'VELLARAM JUNCTION', lat: 8.963494, lng: 78.073969, id: 192 },
// // // //   { name: 'KACCHERI THALAVAIPURAM', lat: 8.965258, lng: 78.047346, id: 193 },
// // // //   { name: 'VELLARAM', lat: 8.964344, lng: 78.023572, id: 194 },
// // // //   { name: 'GOVERNORGIRI', lat: 8.950111, lng: 78.029486, id: 195 },
// // // //   { name: 'VALLINAYAGIPURAM', lat: 8.865224, lng: 78.027444, id: 196 },
// // // //   { name: 'JAMBULINGAPURAM', lat: 8.868732, lng: 78.018645, id: 197 },
// // // //   { name: 'KAILASAPURAM', lat: 8.852519, lng: 77.99135, id: 198 },
// // // //   { name: 'SAVARIMANGALAM', lat: 8.863055, lng: 77.985917, id: 199 },
// // // //   { name: 'MELA SEITHALAI', lat: 8.98161, lng: 78.077327, id: 200 },
// // // //   { name: 'JEGAVEERAPANDIAPURAM', lat: 8.98322, lng: 78.066958, id: 201 },
// // // //   { name: 'THANNEER MADAM', lat: 9.009252, lng: 78.052432, id: 202 },
// // // //   { name: 'KAYATHAR JUNCTION', lat: 9.012578, lng: 78.050241, id: 203 },
// // // //   { name: 'EPPODHUMVENDRAN', lat: 9.020908, lng: 78.047522, id: 204 },
// // // //   { name: 'KATTUNAICKENPATTI', lat: 9.014206, lng: 78.062348, id: 205 },
// // // //   { name: 'ADHANOOR', lat: 9.010078, lng: 78.084646, id: 206 },
// // // //   { name: 'MILAGU NATTHAM', lat: 9.012843, lng: 78.104929, id: 207 },
// // // //   { name: 'MURAMBAN', lat: 8.899828, lng: 77.937996, id: 208 },
// // // //   { name: 'SANGAMPATTI', lat: 8.917985, lng: 77.930898, id: 209 },
// // // //   { name: 'CEYLON COLONY', lat: 8.924832, lng: 78.018458, id: 210 },
// // // //   { name: 'PUTRU MURUGAN KOVIL', lat: 8.941288, lng: 78.011421, id: 211 },
// // // //   { name: 'VENKETESHVARAPURAM JUNCTION', lat: 8.955754, lng: 78.003576, id: 212 },
// // // //   { name: 'KEELA MUDIMAN', lat: 8.961449, lng: 77.999854, id: 213 },
// // // //   { name: 'POOLNAYAKKANOOR', lat: 8.97809, lng: 77.991323, id: 214 },
// // // //   { name: 'PASUVANTHANAI', lat: 8.999829, lng: 77.96264, id: 215 },
// // // //   { name: 'MELA MUDIMAN', lat: 8.956969, lng: 77.986192, id: 216 },
// // // //   { name: 'THALAVAIPURAM', lat: 8.87712, lng: 77.956196, id: 217 },
// // // //   { name: 'KANTHASAMYPURAM', lat: 8.867032, lng: 77.949334, id: 218 },
// // // //   { name: 'APC COLLEGE', lat: 8.827144, lng: 78.129349, id: 219 },
// // // //   { name: 'CHINNAKANNUPURAM', lat: 8.810596, lng: 78.125385, id: 220 },
// // // //   { name: 'SILVERPURAM', lat: 8.814569, lng: 78.115786, id: 221 },
// // // //   { name: 'PANDARAMPATTI', lat: 8.826827, lng: 78.104347, id: 222 },
// // // //   { name: 'MEELAVITTAN', lat: 8.816812, lng: 78.100737, id: 223 },
// // // //   { name: 'STERLITE', lat: 8.816372, lng: 78.081444, id: 224 },
// // // //   { name: 'SIPCOT', lat: 8.804587, lng: 78.084655, id: 225 },
// // // //   { name: 'MADATTHOOR JUNCTION', lat: 8.794126, lng: 78.097222, id: 226 },
// // // //   { name: 'THOOTHUKUDI COLLECTORATE', lat: 8.78247, lng: 78.100772, id: 227 },
// // // //   { name: 'PUDHUPACCHERI COLONY', lat: 8.87848, lng: 78.007704, id: 228 },
// // // //   { name: 'PUDHUPACCHERI', lat: 8.879461, lng: 78.0013, id: 229 },
// // // //   { name: 'SIVALKULAM', lat: 8.8798, lng: 77.995998, id: 230 },
// // // //   { name: 'PACCHAIPERUMALPURAM', lat: 8.885974, lng: 77.992908, id: 231 },
// // // //   { name: 'SANKARARAJAPURAM', lat: 8.891225, lng: 77.991277, id: 232 },
// // // //   { name: 'KUPPANAPURAM', lat: 8.93309, lng: 77.971928, id: 233 },
// // // //   { name: 'KEELA MANGALM', lat: 8.953179, lng: 77.969344, id: 234 },
// // // //   { name: 'RAMANACCHIYARPURAM', lat: 8.784893, lng: 78.061561, id: 235 },
// // // //   { name: 'MUTHUSAMYPURAM', lat: 8.804241, lng: 78.049425, id: 236 },
// // // //   { name: 'MADATTHUPATTI', lat: 8.807399, lng: 78.047393, id: 237 },
// // // //   { name: 'NORTH SILUKKANPATTI', lat: 8.81289, lng: 78.047949, id: 238 },
// // // //   { name: 'THALAIVANVADALI', lat: 8.60242, lng: 78.087655, id: 239 },
// // // //   { name: 'THOOTHUKUDI RAILWAY STATION', lat: 8.805524, lng: 78.1552, id: 240 },
// // // //   { name: 'KOOTTUDANKADU', lat: 8.740251, lng: 78.037525, id: 241 },
// // // //   { name: 'THIRUVANANTHAPURAM JUNCTION', lat: 8.76147, lng: 78.019308, id: 242 },
// // // //   { name: 'SAMATTHUVAPURAM', lat: 8.774679, lng: 77.998832, id: 243 },
// // // //   { name: 'MAHILAMPURAM', lat: 8.794964, lng: 77.961453, id: 244 },
// // // //   { name: 'CHEKKARAKUDI', lat: 8.79475, lng: 77.951655, id: 245 },
// // // //   { name: 'THIRUVANANTHAPURAM', lat: 8.770659, lng: 78.019169, id: 246 },
// // // //   { name: 'MELA CHEKKARAKUDI', lat: 8.801626, lng: 77.937492, id: 247 },
// // // //   { name: 'ALLIKULAM JUNCTION', lat: 8.757367, lng: 78.025019, id: 248 },
// // // //   { name: 'THIRUVANANDHA PURAM JUNCTION', lat: 8.76147, lng: 78.019308, id: 249 },
// // // //   { name: 'SILUKKAN PATTI', lat: 8.768811, lng: 78.052367, id: 250 },
// // // //   { name: 'KEELA THATTAPARAI', lat: 8.796529, lng: 78.027674, id: 251 },
// // // //   { name: 'MELA THATTAPARAI', lat: 8.815826, lng: 78.017498, id: 252 },
// // // //   { name: 'CHETTIYOORANI', lat: 8.832629, lng: 78.008857, id: 253 },
// // // //   { name: 'CAMP THATTAPARAI', lat: 8.826042, lng: 78.020524, id: 254 },
// // // //   { name: 'RAMACHANDRAPURAM JUNCTION', lat: 8.738491, lng: 78.031969, id: 255 },
// // // //   { name: 'POTTALOORANI JUNCTION', lat: 8.735812, lng: 77.93566, id: 256 },
// // // //   { name: 'POTTALOORANI VILLAGE', lat: 8.748338, lng: 77.936312, id: 257 },
// // // //   { name: 'NATTHAM', lat: 8.778333, lng: 77.946701, id: 258 },
// // // //   { name: 'AZHAGAPURI', lat: 8.783882, lng: 77.947625, id: 259 },
// // // //   { name: 'KALLAMPARAMBU', lat: 8.806659, lng: 77.98215, id: 260 },
// // // //   { name: 'VARTHAGAREDDIPATTI', lat: 8.734957, lng: 77.992819, id: 261 },
// // // //   { name: 'THIMMARAJAPURAM', lat: 8.763797, lng: 77.989995, id: 262 },
// // // //   { name: 'MEENAKSHIPATTI', lat: 8.690932, lng: 77.965207, id: 263 },
// // // //   { name: 'ADAIKKALAPURAM', lat: 8.678001, lng: 77.969954, id: 264 },
// // // //   { name: 'ANIYABARANALLUR', lat: 8.693574, lng: 77.950283, id: 265 },
// // // //   { name: 'PUDHUPATTI', lat: 8.710504, lng: 77.936336, id: 266 },
// // // //   { name: 'CHETTIMALLANPATTI', lat: 8.720235, lng: 77.9299, id: 267 },
// // // //   { name: 'RAMANATHAPURAM', lat: 8.728507, lng: 77.925542, id: 268 },
// // // //   { name: 'ELLANAICKENPATTI', lat: 8.733465, lng: 77.92195, id: 269 },
// // // //   { name: 'DEIVASEYALPURAM', lat: 8.737467, lng: 77.918961, id: 270 },
// // // //   { name: 'THATTAPARAI VILLAGE', lat: 8.755998, lng: 78.065854, id: 271 },
// // // //   { name: 'ST. MARY\'S COLLEGE', lat: 8.811006, lng: 78.161694, id: 272 },
// // // //   { name: 'NEW HARBOUR', lat: 8.754486, lng: 78.192477, id: 273 },
// // // //   { name: 'UMARIKOTTAI', lat: 8.822473, lng: 77.990482, id: 274 },
// // // //   { name: 'VARADHARAJAPURAM', lat: 8.843064, lng: 77.979707, id: 275 },
// // // //   { name: 'CHOCKALINGAPURAM', lat: 8.812871, lng: 77.966345, id: 276 },
// // // //   { name: 'KALANKARAI', lat: 8.7565, lng: 78.095112, id: 277 }
// // // // ];

// // // // // // Route sequences by stop id
// // // // // const Hostel_to_Main   = [26, 24, 22, 20, 6, 5, 3, 1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // // // // const Main_to_Hostel   = [18, 17, 15, 13, 11, 9, 6, 5, 3, 1, 2, 4, 7, 19, 21, 23, 25, 26];
// // // // // const Velachery_to_Main= [1, 2, 4, 7, 8, 10, 12, 14, 16, 18];
// // // // // const Velachery_to_Hostel=[1, 2, 4, 7, 19, 21, 23, 25, 26];
// // // // // const Hotel_to_Velachery=[26, 24, 22, 20, 6, 5, 3, 1];
// // // // // const Main_to_Velachery=[18, 17, 15, 13, 11, 9, 6, 5, 3, 1];
// // // // // const RP_to_ED         = [28, 22, 21, 20, 6, 5, 3, 29];
// // // // // const ED_to_RP         = [29, 2, 4, 7, 19, 21, 23, 28];

// // // // // const ROUTES = [
// // // // //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate", ids: Hostel_to_Main },
// // // // //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel", ids: Main_to_Hostel },
// // // // //   { code: "VG_MAIN",     label: "Velachery Gate → Main Gate", ids: Velachery_to_Main },
// // // // //   { code: "VG_HOSTEL",   label: "Velachery Gate → Hostel", ids: Velachery_to_Hostel },
// // // // //   { code: "MAIN_VG",     label: "Main Gate → Velachery Gate", ids: Main_to_Velachery },
// // // // //   { code: "HOSTEL_VG",   label: "Hostel → Velachery Gate", ids: Hotel_to_Velachery },
// // // // //   { code: "RP_ED",       label: "Research Park → ED", ids: RP_to_ED },
// // // // //   { code: "ED_RP",       label: "ED → Research Park", ids: ED_to_RP },
// // // // // ];

// // // // // // ---- Route aliases (frontend only) ----
// // // // // // Backend only knows canonical codes: HOSTEL_MAIN, MAIN_HOSTEL, RP_ED, ED_RP
// // // // // // But filters can still expose Velachery labels.
// // // // // // Aliases map to canonical backend codes.
// // // // // const ROUTE_ALIAS_TO_CANONICAL = {
// // // // //   VG_MAIN: "HOSTEL_MAIN",
// // // // //   HOSTEL_VG: "HOSTEL_MAIN",
// // // // //   MAIN_VG: "MAIN_HOSTEL",
// // // // //   VG_HOSTEL: "MAIN_HOSTEL",
// // // // // };

// // // // // function canonicalRoute(code) {
// // // // //   return ROUTE_ALIAS_TO_CANONICAL[code] || code;
// // // // // }
// // // // // // Routes the admin can assign in backend (only canonical codes)
// // // // // const ADMIN_ROUTES = [
// // // // //   { code: "HOSTEL_MAIN", label: "Hostel → Main Gate" },
// // // // //   { code: "MAIN_HOSTEL", label: "Main Gate → Hostel" },
// // // // //   { code: "RP_ED", label: "Research Park → ED" },
// // // // //   { code: "ED_RP", label: "ED → Research Park" },
// // // // // ];


// // // // // // ---- Vehicles for driverRoute select ----
// // // // // const VEHICLES = [
// // // // //   "TN07DH1368","TN07DH1317","TN07DH1315","EV09","TN07DH1360","TN07DH1391","EV08","TN07DD5574",
// // // // //   "TN07CX8698","TN07DD3376","TN07CX8200","TN07DD3360","EV-12","EV-14","EV-15","EV-10","EV-05",
// // // // //   "EV-07","EV-06","EV-02","EV-03","EV-11","EV-01","EV-13","TN07CX8119"
// // // // // ];

// // // // // Route sequences by stop id based on FARE_TABLE_CODE

// // // // const P52A_1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
// // // // const P52A_2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
// // // // const P52A_3 = [14, 17, 18, 19, 20];
// // // // const P52A_4 = [20, 19, 18, 17, 14, 13, 12, 11, 10, 9, 8, 7, 21, 22, 23, 24];
// // // // const P52A_5 = [14, 13, 12, 11, 10, 9, 8, 7, 21, 22, 23, 24];
// // // // const P52A_6 = [25, 26, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
// // // // const P52A_7 = [27, 28, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
// // // // const P52A_8 = [25, 26, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

// // // // const ROUTES = [
// // // //   { code: "52/P52A-1", label: "THOOTHUKUDI OLD B/S → PERUMPADAI SASTHA KOVIL", ids: P52A_1 },
// // // //   { code: "52/P52A-2", label: "THOOTHUKUDI OLD B/S → SUBRAMANIYAPURAM", ids: P52A_2 },
// // // //   { code: "52/P52A-3", label: "SUBRAMANIYAPURAM → ERAL", ids: P52A_3 },
// // // //   { code: "52/P52A-4", label: "ERAL → PEROORANI", ids: P52A_4 },
// // // //   { code: "52/P52A-5", label: "SUBRAMANIYAPURAM → PEROORANI", ids: P52A_5 },
// // // //   { code: "52/P52A-6", label: "UZHAVAR SANTHAI → PERUMPADAI SASTHA KOVIL", ids: P52A_6 },
// // // //   { code: "52/P52A-7", label: "THRES PURAM → SUBRAMANIYAPURAM", ids: P52A_7 },
// // // //   { code: "52/P52A-8", label: "UZHAVAR SANTHAI → SUBRAMANIYAPURAM", ids: P52A_8 },
// // // // ];

// // // // // No alias mapping needed now, because route codes are already the actual fare table codes.
// // // // function canonicalRoute(code) {
// // // //   return code;
// // // // }

// // // // // Routes admin can assign
// // // // const ADMIN_ROUTES = [
// // // //   { code: "52/P52A-1", label: "THOOTHUKUDI OLD B/S → PERUMPADAI SASTHA KOVIL" },
// // // //   { code: "52/P52A-2", label: "THOOTHUKUDI OLD B/S → SUBRAMANIYAPURAM" },
// // // //   { code: "52/P52A-3", label: "SUBRAMANIYAPURAM → ERAL" },
// // // //   { code: "52/P52A-4", label: "ERAL → PEROORANI" },
// // // //   { code: "52/P52A-5", label: "SUBRAMANIYAPURAM → PEROORANI" },
// // // //   { code: "52/P52A-6", label: "UZHAVAR SANTHAI → PERUMPADAI SASTHA KOVIL" },
// // // //   { code: "52/P52A-7", label: "THRES PURAM → SUBRAMANIYAPURAM" },
// // // //   { code: "52/P52A-8", label: "UZHAVAR SANTHAI → SUBRAMANIYAPURAM" },
// // // // ];

// // // // // ---- Vehicles for driverRoute select ----
// // // // const VEHICLES = [
// // // //   "TN72N0707",
// // // //   "TN72N1708",
// // // //   "TN72N1737",
// // // //   "TN72N1751",
// // // //   "TN72N1757",
// // // //   "TN72N1774",
// // // //   "TN72N1854",
// // // //   "TN72N1875",
// // // //   "TN72N1884",
// // // //   "TN72N1895",
// // // //   "TN72N1903",
// // // //   "TN72N1905",
// // // //   "TN72N1906",
// // // //   "TN72N1910",
// // // //   "TN72N1912",
// // // //   "TN72N1919",
// // // //   "TN72N1923",
// // // //   "TN72N2016",
// // // //   "TN72N2022",
// // // //   "TN72N2368",
// // // //   "TN72N2416",
// // // //   "TN72N2460",
// // // //   "TN72N2526",
// // // //   "TN72N2536",
// // // //   "TN72N2541",
// // // //   "TN72N2549",
// // // //   "TN72N2556",
// // // //   "TN72N2562",
// // // //   "TN72N2568",
// // // //   "TN72N2570",
// // // //   "TN72N2589",
// // // //   "TN72N2617",
// // // //   "TN72N2620",
// // // //   "TN72N2622",
// // // //   "TN72N2643",
// // // //   "TN72N2656",
// // // //   "TN72N2671",
// // // //   "TN72N2675",
// // // //   "TN72N2682",
// // // //   "TN72N2684",
// // // //   "TN72N2687",
// // // //   "TN72N2700",
// // // //   "TN72N2706",
// // // //   "TN63N1733",
// // // //   "TN67S3888",
// // // // ];

// // // // // ---- Leaflet default icon fix ----
// // // // delete L.Icon.Default.prototype._getIconUrl;
// // // // L.Icon.Default.mergeOptions({
// // // //   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
// // // //   iconUrl: require('leaflet/dist/images/marker-icon.png'),
// // // //   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// // // // });

// // // // // ---- Utility helpers ----
// // // // const createCustomIcon = (iconUrl, size = [40, 40]) =>
// // // //   L.icon({
// // // //     iconUrl,
// // // //     iconSize: size,
// // // //     iconAnchor: [size[0] / 2, size[1]],
// // // //     popupAnchor: [0, -size[1] / 2]
// // // //   });

// // // // const userIconInstance = createCustomIcon(userIcon, [40, 40]);

// // // // const toHeading = (v) => {
// // // //   const n = Number(v);
// // // //   return Number.isFinite(n) ? ((n % 360) + 360) % 360 : null;
// // // // };

// // // // // Exponential smoothing for latitude/longitude
// // // // function smoothCoord(prev, next, alpha = SMOOTH_ALPHA) {
// // // //   if (!prev) return next;
// // // //   return {
// // // //     lat: prev.lat + alpha * (next.lat - prev.lat),
// // // //     lng: prev.lng + alpha * (next.lng - prev.lng)
// // // //   };
// // // // }



// // // // // Circular smoothing for heading (degrees)
// // // // function smoothHeading(prevDeg, nextDeg, alpha = HEADING_ALPHA) {
// // // //   if (!Number.isFinite(prevDeg)) return nextDeg;
// // // //   if (!Number.isFinite(nextDeg)) return prevDeg;
// // // //   const p = (prevDeg * Math.PI) / 180;
// // // //   const n = (nextDeg * Math.PI) / 180;
// // // //   const x = (1 - alpha) * Math.cos(p) + alpha * Math.cos(n);
// // // //   const y = (1 - alpha) * Math.sin(p) + alpha * Math.sin(n);
// // // //   const ang = (Math.atan2(y, x) * 180) / Math.PI;
// // // //   return (((ang % 360) + 360) % 360);
// // // // }
// // // // function mBetween(a, b) { return L.latLng(a.lat, a.lng).distanceTo(L.latLng(b.lat, b.lng)); }

// // // // // ---- Cart classification (case-insensitive "EV") ----
// // // // function isCart(vehicleno) {
// // // //   const s = String(vehicleno || '').trim();
// // // //   return s.toUpperCase().startsWith('EV');
// // // // }

// // // // // Label: B for Bus, C for Cart
// // // // // function vehicleLabel(vehicleno) { return isCart(vehicleno) ? 'C' : 'B'; }
// // // // function vehicleLabel(vehicleno, routeCode) {
// // // //   if (!isCart(vehicleno)) return "B";

// // // //   const rc = canonicalRoute(routeCode || "");
// // // //   if (rc === "RP_ED" || rc === "ED_RP") return "CR"; // 👈 cart on RP↔ED
// // // //   return "C";
// // // // }


// // // // // ---- Block IDs starting with a digit ----
// // // // function startsWithDigit(vehicleno) { return /^[0-9]/.test(String(vehicleno || '')); }

// // // // // ---- Direction pointer “on the circle” DivIcon ----
// // // // // function createVehicleDivIcon(label, headingDeg) {
// // // // //   const circle = 20;
// // // // //   const border = 3;
// // // // //   const triH = 18;
// // // // //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// // // // //   const totalH = triH + circle;

// // // // //   const html = `
// // // // //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// // // // //       <div style="
// // // // //         position:absolute; left:0; right:0; bottom:0;
// // // // //         width:${circle}px; height:${circle}px;
// // // // //         border:${border}px solid #0D47A1; background:#ffffff; border-radius:50%;
// // // // //         display:flex; align-items:center; justify-content:center;
// // // // //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// // // // //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // // //         letter-spacing:0.6px; user-select:none;">
// // // // //         <span style="font-size:16px; color:#0D47A1">${label}</span>
// // // // //       </div>
// // // // //       <div style="
// // // // //         position:absolute; left:50%; top:0;
// // // // //         transform: translateX(-250%) rotate(${rot}deg);
// // // // //         transform-origin: 50% ${triH * 0.7}px;
// // // // //         width:0; height:0;
// // // // //         border-left:${triH / 4}px solid transparent;
// // // // //         border-right:${triH / 4}px solid transparent;
// // // // //         border-bottom:${triH}px solid #0D47A1;
// // // // //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// // // // //         z-index: 2; pointer-events: none;"></div>
// // // // //     </div>
// // // // //   `;

// // // // //   return L.divIcon({
// // // // //     className: 'veh-div-icon',
// // // // //     html,
// // // // //     iconSize: [circle, totalH],
// // // // //     iconAnchor: [circle / 2, totalH - circle / 2],
// // // // //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// // // // //   });
// // // // // }

// // // // function createVehicleDivIcon(label, headingDeg, palette) {
// // // //   const circle = 20;
// // // //   const border = 3;
// // // //   const triH = 18;
// // // //   const rot = Number.isFinite(headingDeg) ? headingDeg : 0;
// // // //   const totalH = triH + circle;

// // // //   // default bus palette
// // // //   const p = palette || {
// // // //     stroke: "#0D47A1",
// // // //     fill: "#ffffff",
// // // //     text: "#0D47A1",
// // // //     pointer: "#0D47A1",
// // // //   };

// // // //   const html = `
// // // //     <div style="position:relative;width:${circle}px;height:${totalH}px">
// // // //       <div style="
// // // //         position:absolute; left:0; right:0; bottom:0;
// // // //         width:${circle}px; height:${circle}px;
// // // //         border:${border}px solid ${p.stroke};
// // // //         background:${p.fill};
// // // //         border-radius:50%;
// // // //         display:flex; align-items:center; justify-content:center;
// // // //         box-shadow:0 2px 8px rgba(0,0,0,0.25);
// // // //         font-weight:800; font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // //         letter-spacing:0.6px; user-select:none;">
// // // //         <span style="font-size:16px; color:${p.text}">${label}</span>
// // // //       </div>
// // // //       <div style="
// // // //         position:absolute; left:50%; top:0;
// // // //         transform: translateX(-250%) rotate(${rot}deg);
// // // //         transform-origin: 50% ${triH * 0.7}px;
// // // //         width:0; height:0;
// // // //         border-left:${triH / 4}px solid transparent;
// // // //         border-right:${triH / 4}px solid transparent;
// // // //         border-bottom:${triH}px solid ${p.pointer};
// // // //         filter: drop-shadow(0 1px 2px rgba(0,0,0,0.35));
// // // //         z-index: 2; pointer-events: none;"></div>
// // // //     </div>
// // // //   `;

// // // //   return L.divIcon({
// // // //     className: 'veh-div-icon',
// // // //     html,
// // // //     iconSize: [circle, totalH],
// // // //     iconAnchor: [circle / 2, totalH - circle / 2],
// // // //     popupAnchor: [0, -(circle / 2 + triH / 2)]
// // // //   });
// // // // }

// // // // // const BUS_PALETTE = {
// // // // //   stroke: "#0D47A1",
// // // // //   fill: "#ffffff",
// // // // //   text: "#0D47A1",
// // // // //   pointer: "#0D47A1",
// // // // // };

// // // // // const BUS_PALETTE = {
// // // // //   stroke: "#EA580C",   // orange bus border
// // // // //   fill: "#FFF7ED",     // light orange fill
// // // // //   text: "#9A3412",
// // // // //   pointer: "#EA580C",
// // // // // };

// // // // // const CART_PALETTE = {
// // // // //   stroke: "#0F766E",  // teal border
// // // // //   fill: "#ECFEFF",    // light teal fill
// // // // //   text: "#0F766E",
// // // // //   pointer: "#0F766E",
// // // // // };
// // // // const CART_PALETTE = {
// // // //   stroke: "#111827",   // near-black border
// // // //   fill: "#FEF08A",   // bright yellow fill
// // // //   text: "#111827",   // black text
// // // //   pointer: "#111827",   // black pointer
// // // // };

// // // // const BUS_PALETTE = {
// // // //   stroke: "#111827",   // near-black border
// // // //   fill: "#FEF08A",   // bright yellow fill
// // // //   text: "#111827",   // black text
// // // //   pointer: "#111827",   // black pointer
// // // // };



// // // // function matchesFilter(vehicleno, filter, assignments) {
// // // //   const cart = isCart(vehicleno);
// // // //   if (filter === "cart") return cart;
// // // //   if (filter === "bus") return !cart;

// // // //   if (filter?.startsWith("route:")) {
// // // //     const requested = canonicalRoute(filter.slice(6));
// // // //     const assigned = canonicalRoute(assignments[vehicleno]);
// // // //     return assigned === requested;
// // // //   }
// // // //   return true;
// // // // }

// // // // // ---- Filter helper ----
// // // // // function matchesFilter(vehicleno, filter, assignments) {
// // // // //   const cart = isCart(vehicleno);
// // // // //   if (filter === 'cart') return cart;
// // // // //   if (filter === 'bus')  return !cart;
// // // // //   if (filter?.startsWith('route:')) {
// // // // //     const code = filter.slice(6);
// // // // //     return assignments[vehicleno] === code;
// // // // //   }
// // // // //   return true;
// // // // // }

// // // // // ---------------- SCHEDULE DATA (kept intact) ----------------
// // // // const HOSTEL_TO_MAIN = [
// // // //   '06:20 AM', '06:40 AM', '07:00 AM', '07:20 AM', '07:40 AM', '08:00 AM', '08:20 AM', '08:40 AM',
// // // //   '09:00 AM', '09:20 AM', '09:40 AM', '10:00 AM', '10:20 AM', '10:40 AM', '11:00 AM', '11:20 AM',
// // // //   '11:40 AM', '12:00 PM', '12:20 PM', '12:40 PM', '01:00 PM', '01:20 PM', '01:40 PM', '02:00 PM',
// // // //   '02:20 PM', '02:40 PM', '03:00 PM', '03:20 PM', '03:40 PM', '04:00 PM', '04:20 PM', '04:40 PM',
// // // //   '05:00 PM', '05:20 PM', '05:40 PM', '06:00 PM', '06:20 PM', '06:40 PM', '07:00 PM', '07:20 PM',
// // // //   '07:40 PM', '08:00 PM', '08:20 PM', '08:40 PM', '09:00 PM', '09:20 PM'
// // // // ];
// // // // const HOSTEL_NOTES = [
// // // //   { time: '09:30 PM', note: 'To Velachery Gate' },
// // // //   { time: 'bustransport@iitm.ac.in', note: 'For your feedback/complaints, please send a mail here.' }
// // // // ];
// // // // const MAIN_TO_HOSTEL = [...HOSTEL_TO_MAIN];
// // // // const MAIN_NOTES = [
// // // //   { time: '09:40 PM', note: 'To Velachery Gate' },
// // // //   { time: '10:00 PM', note: 'To Velachery Gate' },
// // // //   { time: 'bustransport@iitm.ac.in', note: 'For your feedback/complaints, please send a mail here.' }
// // // // ];
// // // // const VELACHERY_TO_MAIN = [
// // // //   '06:15 AM', '06:35 AM', '06:55 AM', '07:15 AM', '07:35 AM', '07:55 AM', '08:15 AM', '08:35 AM', '08:55 AM',
// // // //   '09:15 AM', '09:35 AM', '09:55 AM', '10:15 AM', '10:35 AM', '10:55 AM', '11:15 AM', '11:35 AM',
// // // //   '12:15 PM', '12:35 PM', '12:55 PM', '01:15 PM', '01:35 PM', '01:55 PM', '02:15 PM', '02:35 PM', '02:55 PM',
// // // //   '03:15 PM', '03:35 PM', '03:55 PM', '04:15 PM', '04:35 PM', '04:55 PM', '05:15 PM', '05:35 PM', '05:55 PM',
// // // //   '06:15 PM', '06:35 PM', '06:55 PM', '07:15 PM', '07:35 PM', '07:55 PM', '08:15 PM', '08:35 PM', '08:55 PM',
// // // //   '09:15 PM', '09:35 PM'
// // // // ];
// // // // const VELACHERY_TO_HOSTEL = [
// // // //   '06:25 AM', '06:45 AM', '07:05 AM', '07:25 AM', '07:45 AM', '08:05 AM', '08:25 AM', '08:45 AM', '09:05 AM',
// // // //   '09:25 AM', '09:45 AM', '10:05 AM', '10:25 AM', '10:45 AM', '11:05 AM', '11:25 AM', '11:45 AM',
// // // //   '12:05 PM', '12:25 PM', '12:45 PM', '01:05 PM', '01:25 PM', '01:45 PM', '02:05 PM', '02:25 PM', '02:45 PM',
// // // //   '03:05 PM', '03:25 PM', '03:45 PM', '04:05 PM', '04:25 PM', '04:45 PM', '05:05 PM', '05:25 PM', '05:45 PM',
// // // //   '06:05 PM', '06:25 PM', '06:45 PM', '07:05 PM', '07:25 PM', '07:45 PM', '08:05 PM', '08:25 PM', '08:45 PM',
// // // //   '09:05 PM', '09:15 PM'
// // // // ];
// // // // const VELACHERY_NOTES = [
// // // //   { time: 'bustransport@iitm.ac.in', note: 'For your feedback/complaints, please send a mail here.' }
// // // // ];
// // // // const RP_TO_ED_TIMES = [
// // // //   '07:30 AM', '08:05 AM', '08:40 AM', '09:00 AM', '09:15 AM', '09:35 AM', '09:45 AM',
// // // //   '10:15 AM', '10:25 AM', '10:45 AM', '11:20 AM', '11:40 AM',
// // // //   '12:05 PM', '12:45 PM', '01:40 PM', '02:20 PM', '02:35 PM', '03:00 PM', '03:15 PM', '03:45 PM',
// // // //   '04:15 PM', '04:50 PM', '05:05 PM', '05:50 PM', '06:25 PM', '07:05 PM'
// // // // ];
// // // // const ED_TO_RP_TIMES = [
// // // //   '07:50 AM', '08:25 AM', '09:00 AM', '09:15 AM', '09:30 AM', '10:00 AM', '10:05 AM', '10:30 AM',
// // // //   '11:00 AM', '11:15 AM', '11:45 AM',
// // // //   '12:00 PM', '12:25 PM', '01:05 PM', '02:00 PM', '02:40 PM', '03:00 PM', '03:20 PM', '03:30 PM',
// // // //   '04:05 PM', '04:45 PM', '05:10 PM', '05:30 PM', '06:10 PM', '06:45 PM', '07:20 PM'
// // // // ];
// // // // const Cart1 = [['07:30', '07:50'], ['08:05', '08:25'], ['08:40', '09:00'], ['09:15', '09:30'], ['09:45', '10:05'], ['10:25', '11:00'], ['11:20', '11:45'], ['12:05', '12:25'], ['13:40', '14:00'], ['14:20', '14:40'], ['15:00', '15:20'], ['15:45', '16:05'], ['16:50', '17:10']];
// // // // const Cart3 = [['09:00', '09:15'], ['09:35', '10:00'], ['10:15', '10:30'], ['10:45', '11:15'], ['11:40', '12:00'], ['12:45', '13:05'], ['14:35', '15:00'], ['15:15', '15:30'], ['16:15', '16:45'], ['17:05', '17:30'], ['17:50', '18:10'], ['18:25', '18:45'], ['19:05', '19:20']];

// // // // // ---- Feedback link ----
// // // // const FEEDBACK_URL = process.env.REACT_APP_FEEDBACK_URL || '';

// // // // // ---------------- Tiny router helpers (for /driver, /driverRoute) ----------------
// // // // function usePath() {
// // // //   const [path, setPath] = useState(window.location.pathname);
// // // //   useEffect(() => {
// // // //     const onPop = () => setPath(window.location.pathname);
// // // //     window.addEventListener('popstate', onPop);
// // // //     return () => window.removeEventListener('popstate', onPop);
// // // //   }, []);
// // // //   const navigate = (p) => { if (p !== window.location.pathname) { window.history.pushState({}, "", p); setPath(p); } };
// // // //   return { path, navigate };
// // // // }
// // // // function getToken() { return localStorage.getItem("driverToken") || ""; }
// // // // function setToken(t) { localStorage.setItem("driverToken", t || ""); }
// // // // function getUsername() { return localStorage.getItem("driverUsername") || ""; }
// // // // function setUsername(u) { localStorage.setItem("driverUsername", u || ""); }

// // // // // --- Admin auth helpers (separate from driver) ---
// // // // function getAdminToken() {
// // // //   return localStorage.getItem("adminToken") || "";
// // // // }
// // // // function setAdminToken(t) {
// // // //   localStorage.setItem("adminToken", t || "");
// // // // }


// // // // // ---------------- Driver pages ----------------
// // // // // --- small responsive hook for narrow phones ---
// // // // function useIsNarrow(bp = 380) {
// // // //   const [isNarrow, setIsNarrow] = useState(window.innerWidth <= bp);
// // // //   useEffect(() => {
// // // //     const onResize = () => setIsNarrow(window.innerWidth <= bp);
// // // //     window.addEventListener('resize', onResize);
// // // //     return () => window.removeEventListener('resize', onResize);
// // // //   }, [bp]);
// // // //   return isNarrow;
// // // // }

// // // // function DriverLogin({ navigate }) {
// // // //   const [username, setU] = useState("");
// // // //   const [password, setP] = useState("");
// // // //   const [err, setErr] = useState("");
// // // //   const [busy, setBusy] = useState(false);
// // // //   const isNarrow = useIsNarrow(380);

// // // //   useEffect(() => {
// // // //     if (getToken()) navigate("/driverRoute");
// // // //   }, [navigate]);

// // // //   const onSubmit = async (e) => {
// // // //     e.preventDefault();
// // // //     setErr(""); setBusy(true);
// // // //     try {
// // // //       const r = await axios.post(`${BACKEND}/api/driver/login`, { username, password });
// // // //       if (r.data?.success && r.data?.token) {
// // // //         setToken(r.data.token);
// // // //         setUsername(r.data.username);
// // // //         navigate("/driverRoute");
// // // //       } else setErr("Login failed");
// // // //     } catch (e1) {
// // // //       setErr(e1?.response?.data?.message || "Login failed");
// // // //     } finally { setBusy(false); }
// // // //   };

// // // //   return (
// // // //     <div
// // // //       style={{
// // // //         padding: isNarrow ? 12 : 20,
// // // //         margin: isNarrow ? "16px auto" : "32px auto",
// // // //         width: "min(100vw - 24px, 560px)",
// // // //       }}
// // // //     >
// // // //       {/* Header with Home button */}
// // // //       <div
// // // //         style={{
// // // //           display: "flex",
// // // //           alignItems: "center",
// // // //           gap: isNarrow ? 10 : 12,
// // // //           marginBottom: isNarrow ? 10 : 14,
// // // //           flexWrap: "wrap",
// // // //         }}
// // // //       >
// // // //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// // // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // // //           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Driver Login</h2>
// // // //         </div>

// // // //         <button
// // // //           type="button"
// // // //           onClick={() => navigate("/")}
// // // //           style={{
// // // //             marginLeft: "auto",
// // // //             padding: isNarrow ? "6px 10px" : "8px 12px",
// // // //             borderRadius: 10,
// // // //             border: "1px solid #D1D5DB",
// // // //             background: "#FFFFFF",
// // // //             fontWeight: 700,
// // // //             fontSize: isNarrow ? 13 : 14,
// // // //             cursor: "pointer",
// // // //           }}
// // // //           title="Go to Home"
// // // //         >
// // // //           Home
// // // //         </button>
// // // //       </div>

// // // //       {/* Card */}
// // // //       <div
// // // //         style={{
// // // //           background: "#fff",
// // // //           border: "1px solid #E5E7EB",
// // // //           borderRadius: 12,
// // // //           padding: isNarrow ? 12 : 16,
// // // //         }}
// // // //       >
// // // //         <form onSubmit={onSubmit} style={{ display: "grid", gap: isNarrow ? 8 : 10 }}>
// // // //           <input
// // // //             value={username}
// // // //             onChange={(e) => setU(e.target.value)}
// // // //             placeholder="username"
// // // //             required
// // // //             style={{
// // // //               padding: isNarrow ? 10 : 12,
// // // //               borderRadius: 10,
// // // //               border: "1px solid #D1D5DB",
// // // //               fontWeight: 600,
// // // //               fontSize: isNarrow ? 14 : 16,
// // // //             }}
// // // //           />
// // // //           <input
// // // //             value={password}
// // // //             onChange={(e) => setP(e.target.value)}
// // // //             placeholder="password"
// // // //             type="password"
// // // //             required
// // // //             style={{
// // // //               padding: isNarrow ? 10 : 12,
// // // //               borderRadius: 10,
// // // //               border: "1px solid #D1D5DB",
// // // //               fontWeight: 600,
// // // //               fontSize: isNarrow ? 14 : 16,
// // // //             }}
// // // //           />
// // // //           <button
// // // //             disabled={busy}
// // // //             style={{
// // // //               padding: isNarrow ? "10px 12px" : "12px 14px",
// // // //               borderRadius: 10,
// // // //               border: "1px solid #0D47A1",
// // // //               background: "#0D47A1",
// // // //               color: "#fff",
// // // //               fontWeight: 800,
// // // //               cursor: "pointer",
// // // //               width: "100%",
// // // //               minHeight: 40,
// // // //               fontSize: "clamp(14px, 3.5vw, 16px)",
// // // //             }}
// // // //           >
// // // //             {busy ? "Signing in..." : "Login"}
// // // //           </button>
// // // //           {err && <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>}
// // // //         </form>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // function DriverRoute({ navigate }) {
// // // //   const [routeCode, setRouteCode] = useState("");
// // // //   const [vehicleNo, setVehicleNo] = useState("");
// // // //   const [autoPilot, setAutoPilot] = useState(false); // 👈 NEW: auto-pilot flag
// // // //   const [saved, setSaved] = useState(false);
// // // //   const [busy, setBusy] = useState(false);
// // // //   const [err, setErr] = useState("");
// // // //   const isNarrow = useIsNarrow(380);

// // // //   useEffect(() => {
// // // //     if (!getToken()) navigate("/driver");
// // // //     (async () => {
// // // //       try {
// // // //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// // // //           headers: { Authorization: `Bearer ${getToken()}` },
// // // //         });
// // // //         const row = r.data?.row;
// // // //         if (row) {
// // // //           setVehicleNo(row.vehicleNo);
// // // //           setRouteCode(row.routeCode);
// // // //           setAutoPilot(!!row.autopilotEnabled); // 👈 load auto-pilot state from backend
// // // //           setSaved(true);
// // // //         }
// // // //       } catch { }
// // // //     })();
// // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // //   }, []);

// // // //   const onSave = async (e) => {
// // // //     e.preventDefault();
// // // //     setErr(""); setBusy(true);
// // // //     try {
// // // //       await axios.post(
// // // //         `${BACKEND}/api/vehicle-route/assign`,
// // // //         {
// // // //           vehicleNo,
// // // //           routeCode,
// // // //           active: true,
// // // //           autopilotEnabled: autoPilot, // 👈 send auto-pilot choice to backend
// // // //         },
// // // //         { headers: { Authorization: `Bearer ${getToken()}` } }
// // // //       );
// // // //       setSaved(true);
// // // //     } catch (e1) {
// // // //       setErr(e1?.response?.data?.message || "Save failed");
// // // //     } finally {
// // // //       setBusy(false);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div
// // // //       style={{
// // // //         padding: isNarrow ? 16 : 20,
// // // //         maxWidth: 640,
// // // //         margin: isNarrow ? "16px auto" : "32px auto",
// // // //         width: "min(100vw - 24px, 640px)",
// // // //       }}
// // // //     >
// // // //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// // // //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// // // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // // //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// // // //         </div>
// // // //         <div
// // // //           style={{
// // // //             marginLeft: 'auto',
// // // //             fontWeight: 700,
// // // //             opacity: 0.8,
// // // //             fontSize: "clamp(13px, 3.2vw, 16px)",
// // // //             maxWidth: '60%',
// // // //             overflow: 'hidden',
// // // //             textOverflow: 'ellipsis',
// // // //             whiteSpace: 'nowrap',
// // // //           }}
// // // //           title={`@${getUsername()}`}
// // // //         >
// // // //           @{getUsername()}
// // // //         </div>
// // // //       </div>

// // // //       {/* Top-right actions */}
// // // //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// // // //         <div style={{ display: 'flex', gap: 8 }}>
// // // //           <button
// // // //             onClick={() => navigate('/')}
// // // //             style={{
// // // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // // //               borderRadius: 10,
// // // //               border: '1px solid #D1D5DB',
// // // //               background: '#FFFFFF',
// // // //               fontWeight: 700,
// // // //               fontSize: isNarrow ? 13 : 14,
// // // //               cursor: 'pointer'
// // // //             }}
// // // //             title="Go to Home"
// // // //           >
// // // //             Home
// // // //           </button>
// // // //           <button
// // // //             type="button"
// // // //             onClick={() => setSaved(false)}
// // // //             disabled={!saved}
// // // //             style={{
// // // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // // //               borderRadius: 10,
// // // //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// // // //               background: saved ? '#fff' : '#F9FAFB',
// // // //               color: saved ? '#111' : '#9CA3AF',
// // // //               fontWeight: 800,
// // // //               fontSize: isNarrow ? 13 : 14,
// // // //               cursor: saved ? 'pointer' : 'not-allowed'
// // // //             }}
// // // //             title="Edit selection"
// // // //           >
// // // //             Edit
// // // //           </button>
// // // //         </div>

// // // //         <button
// // // //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// // // //           style={{
// // // //             padding: isNarrow ? '6px 10px' : 8,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #D1D5DB',
// // // //             background: '#FFFFFF',
// // // //             fontSize: isNarrow ? 13 : 14,
// // // //             cursor: 'pointer'
// // // //           }}
// // // //           title="Logout"
// // // //         >
// // // //           Logout
// // // //         </button>
// // // //       </div>

// // // //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// // // //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// // // //         <select
// // // //           disabled={saved}
// // // //           value={routeCode}
// // // //           onChange={e => setRouteCode(e.target.value)}
// // // //           required
// // // //           style={{
// // // //             padding: isNarrow ? 10 : 12,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #D1D5DB',
// // // //             fontSize: isNarrow ? 14 : 16
// // // //           }}
// // // //         >
// // // //           <option value="">Select route…</option>
// // // //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// // // //         </select>

// // // //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// // // //         <select
// // // //           disabled={saved}
// // // //           value={vehicleNo}
// // // //           onChange={e => setVehicleNo(e.target.value)}
// // // //           required
// // // //           style={{
// // // //             padding: isNarrow ? 10 : 12,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #D1D5DB',
// // // //             fontSize: isNarrow ? 14 : 16
// // // //           }}
// // // //         >
// // // //           <option value="">Select vehicle…</option>
// // // //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>

// // // //         {/* 👇 NEW: Auto-pilot toggle */}
// // // //         <div
// // // //           style={{
// // // //             marginTop: isNarrow ? 6 : 8,
// // // //             padding: isNarrow ? 8 : 10,
// // // //             borderRadius: 10,
// // // //             border: '1px solid #E5E7EB',
// // // //             background: '#F9FAFB',
// // // //             display: 'flex',
// // // //             alignItems: 'flex-start',
// // // //             gap: 8,
// // // //           }}
// // // //         >
// // // //           <input
// // // //             id="autoPilot"
// // // //             type="checkbox"
// // // //             checked={autoPilot}
// // // //             disabled={saved}
// // // //             onChange={(e) => setAutoPilot(e.target.checked)}
// // // //             style={{ marginTop: 3, cursor: saved ? 'default' : 'pointer' }}
// // // //           />
// // // //           <label
// // // //             htmlFor="autoPilot"
// // // //             style={{ cursor: saved ? 'default' : 'pointer' }}
// // // //           >
// // // //             <div style={{ fontWeight: 700, fontSize: isNarrow ? 14 : 15 }}>
// // // //               Auto-pilot (auto reverse at destination)
// // // //             </div>
// // // //             <div
// // // //               style={{
// // // //                 fontSize: isNarrow ? 12 : 13,
// // // //                 color: '#6B7280',
// // // //                 marginTop: 2,
// // // //               }}
// // // //             >
// // // //               When enabled, once you reach the last stop of this route, your
// // // //               assignment will automatically switch to the return leg.
// // // //             </div>
// // // //           </label>
// // // //         </div>

// // // //         <button
// // // //           disabled={busy || saved}
// // // //           style={{
// // // //             padding: isNarrow ? '10px 12px' : '12px 14px',
// // // //             borderRadius: 10,
// // // //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// // // //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// // // //             color: busy || saved ? '#6B7280' : '#fff',
// // // //             fontWeight: 800,
// // // //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// // // //             minHeight: 44,
// // // //             fontSize: "clamp(14px, 3.5vw, 16px)"
// // // //           }}
// // // //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// // // //         >
// // // //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// // // //         </button>

// // // //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// // // //       </form>
// // // //     </div>
// // // //   );
// // // // }


// // // // // function DriverRoute({ navigate }) {
// // // // //   const [routeCode, setRouteCode] = useState("");
// // // // //   const [vehicleNo, setVehicleNo] = useState("");
// // // // //   const [saved, setSaved] = useState(false);
// // // // //   const [busy, setBusy] = useState(false);
// // // // //   const [err, setErr] = useState("");
// // // // //   const isNarrow = useIsNarrow(380);

// // // // //   useEffect(() => {
// // // // //     if (!getToken()) navigate("/driver");
// // // // //     (async () => {
// // // // //       try {
// // // // //         const r = await axios.get(`${BACKEND}/api/vehicle-route/mine`, {
// // // // //           headers: { Authorization: `Bearer ${getToken()}` },
// // // // //         });
// // // // //         const row = r.data?.row;
// // // // //         if (row) { setVehicleNo(row.vehicleNo); setRouteCode(row.routeCode); setSaved(true); }
// // // // //       } catch {}
// // // // //     })();
// // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // //   }, []);

// // // // //   const onSave = async (e) => {
// // // // //     e.preventDefault();
// // // // //     setErr(""); setBusy(true);
// // // // //     try {
// // // // //       await axios.post(
// // // // //         `${BACKEND}/api/vehicle-route/assign`,
// // // // //         { vehicleNo, routeCode, active: true },
// // // // //         { headers: { Authorization: `Bearer ${getToken()}` } }
// // // // //       );
// // // // //       setSaved(true);
// // // // //     } catch (e1) {
// // // // //       setErr(e1?.response?.data?.message || "Save failed");
// // // // //     } finally {
// // // // //       setBusy(false);
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <div
// // // // //       style={{
// // // // //         padding: isNarrow ? 16 : 20,
// // // // //         maxWidth: 640,
// // // // //         margin: isNarrow ? "16px auto" : "32px auto",
// // // // //         width: "min(100vw - 24px, 640px)",
// // // // //       }}
// // // // //     >
// // // // //       <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: isNarrow ? 10 : 14, flexWrap: 'wrap' }}>
// // // // //         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// // // // //           <img src={iitmLogo} alt="IITM" style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }} />
// // // // //           <h2 style={{ margin: 0, fontSize: "clamp(20px, 6vw, 28px)" }}>Select Your Route</h2>
// // // // //         </div>
// // // // //         <div
// // // // //           style={{
// // // // //             marginLeft: 'auto',
// // // // //             fontWeight: 700,
// // // // //             opacity: 0.8,
// // // // //             fontSize: "clamp(13px, 3.2vw, 16px)",
// // // // //             maxWidth: '60%',
// // // // //             overflow: 'hidden',
// // // // //             textOverflow: 'ellipsis',
// // // // //             whiteSpace: 'nowrap',
// // // // //           }}
// // // // //           title={`@${getUsername()}`}
// // // // //         >
// // // // //           @{getUsername()}
// // // // //         </div>
// // // // //       </div>

// // // // //       {/* Top-right actions */}
// // // // //       <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap' }}>
// // // // //         <div style={{ display: 'flex', gap: 8 }}>
// // // // //           <button
// // // // //             onClick={() => navigate('/')}
// // // // //             style={{
// // // // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // // // //               borderRadius: 10,
// // // // //               border: '1px solid #D1D5DB',
// // // // //               background: '#FFFFFF',
// // // // //               fontWeight: 700,
// // // // //               fontSize: isNarrow ? 13 : 14,
// // // // //               cursor: 'pointer'
// // // // //             }}
// // // // //             title="Go to Home"
// // // // //           >
// // // // //             Home
// // // // //           </button>
// // // // //           <button
// // // // //             type="button"
// // // // //             onClick={() => setSaved(false)}
// // // // //             disabled={!saved}
// // // // //             style={{
// // // // //               padding: isNarrow ? '6px 10px' : '8px 12px',
// // // // //               borderRadius: 10,
// // // // //               border: '1px solid ' + (saved ? '#555' : '#E5E7EB'),
// // // // //               background: saved ? '#fff' : '#F9FAFB',
// // // // //               color: saved ? '#111' : '#9CA3AF',
// // // // //               fontWeight: 800,
// // // // //               fontSize: isNarrow ? 13 : 14,
// // // // //               cursor: saved ? 'pointer' : 'not-allowed'
// // // // //             }}
// // // // //             title="Edit selection"
// // // // //           >
// // // // //             Edit
// // // // //           </button>
// // // // //         </div>

// // // // //         <button
// // // // //           onClick={() => { setToken(""); setUsername(""); navigate("/driver"); }}
// // // // //           style={{
// // // // //             padding: isNarrow ? '6px 10px' : 8,
// // // // //             borderRadius: 10,
// // // // //             border: '1px solid #D1D5DB',
// // // // //             background: '#FFFFFF',
// // // // //             fontSize: isNarrow ? 13 : 14,
// // // // //             cursor: 'pointer'
// // // // //           }}
// // // // //           title="Logout"
// // // // //         >
// // // // //           Logout
// // // // //         </button>
// // // // //       </div>

// // // // //       <form onSubmit={onSave} style={{ display: 'grid', gap: isNarrow ? 10 : 12 }}>
// // // // //         <label style={{ fontWeight: 700, fontSize: isNarrow ? 15 : 16 }}>Route</label>
// // // // //         <select
// // // // //           disabled={saved}
// // // // //           value={routeCode}
// // // // //           onChange={e=>setRouteCode(e.target.value)}
// // // // //           required
// // // // //           style={{
// // // // //             padding: isNarrow ? 10 : 12,
// // // // //             borderRadius: 10,
// // // // //             border: '1px solid #D1D5DB',
// // // // //             fontSize: isNarrow ? 14 : 16
// // // // //           }}
// // // // //         >
// // // // //           <option value="">Select route…</option>
// // // // //           {ROUTES.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
// // // // //         </select>

// // // // //         <label style={{ fontWeight: 700, marginTop: 6, fontSize: isNarrow ? 15 : 16 }}>Vehicle</label>
// // // // //         <select
// // // // //           disabled={saved}
// // // // //           value={vehicleNo}
// // // // //           onChange={e=>setVehicleNo(e.target.value)}
// // // // //           required
// // // // //           style={{
// // // // //             padding: isNarrow ? 10 : 12,
// // // // //             borderRadius: 10,
// // // // //             border: '1px solid #D1D5DB',
// // // // //             fontSize: isNarrow ? 14 : 16
// // // // //           }}
// // // // //         >
// // // // //           <option value="">Select vehicle…</option>
// // // // //           {VEHICLES.map(v => <option key={v} value={v}>{v}</option>)}
// // // // //         </select>

// // // // //         <button
// // // // //           disabled={busy || saved}
// // // // //           style={{
// // // // //             padding: isNarrow ? '10px 12px' : '12px 14px',
// // // // //             borderRadius: 10,
// // // // //             border: '1px solid ' + (busy || saved ? '#D1D5DB' : '#0D47A1'),
// // // // //             background: busy || saved ? '#F3F4F6' : '#0D47A1',
// // // // //             color: busy || saved ? '#6B7280' : '#fff',
// // // // //             fontWeight: 800,
// // // // //             cursor: busy || saved ? 'not-allowed' : 'pointer',
// // // // //             minHeight: 44,
// // // // //             fontSize: "clamp(14px, 3.5vw, 16px)"
// // // // //           }}
// // // // //           title={saved ? 'Already saved. Click Edit to modify.' : 'Save selection'}
// // // // //         >
// // // // //           {busy ? "Saving…" : saved ? "Saved" : "Save"}
// // // // //         </button>

// // // // //         {err && <div style={{ color: '#b00020', fontWeight: 600 }}>{err}</div>}
// // // // //       </form>
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // /* ---------------------------- ADMIN PAGES ---------------------------- */

// // // // function AdminLogin({ navigate }) {
// // // //   const [username, setU] = useState("");
// // // //   const [password, setP] = useState("");
// // // //   const [err, setErr] = useState("");
// // // //   const [busy, setBusy] = useState(false);
// // // //   const isNarrow = useIsNarrow(380);

// // // //   useEffect(() => {
// // // //     if (getAdminToken()) navigate("/admin");
// // // //   }, [navigate]);

// // // //   const onSubmit = async (e) => {
// // // //     e.preventDefault();
// // // //     setErr("");
// // // //     setBusy(true);
// // // //     try {
// // // //       const r = await axios.post(`${BACKEND}/api/admin/login`, {
// // // //         username,
// // // //         password,
// // // //       });
// // // //       if (r.data?.success && r.data?.token) {
// // // //         setAdminToken(r.data.token);
// // // //         navigate("/admin");
// // // //       } else {
// // // //         setErr("Login failed");
// // // //       }
// // // //     } catch (e1) {
// // // //       setErr(e1?.response?.data?.message || "Login failed");
// // // //     } finally {
// // // //       setBusy(false);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div
// // // //       style={{
// // // //         padding: isNarrow ? 12 : 20,
// // // //         margin: isNarrow ? "16px auto" : "32px auto",
// // // //         width: "min(100vw - 24px, 560px)",
// // // //       }}
// // // //     >
// // // //       <div
// // // //         style={{
// // // //           display: "flex",
// // // //           alignItems: "center",
// // // //           gap: isNarrow ? 10 : 12,
// // // //           marginBottom: isNarrow ? 10 : 14,
// // // //           flexWrap: "wrap",
// // // //         }}
// // // //       >
// // // //         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// // // //           <img
// // // //             src={iitmLogo}
// // // //             alt="IITM"
// // // //             style={{ width: isNarrow ? 30 : 36, height: isNarrow ? 30 : 36 }}
// // // //           />
// // // //           <h2 style={{ margin: 0, fontSize: isNarrow ? 18 : 20 }}>Admin Login</h2>
// // // //         </div>
// // // //         <button
// // // //           type="button"
// // // //           onClick={() => navigate("/")}
// // // //           style={{
// // // //             marginLeft: "auto",
// // // //             padding: isNarrow ? "6px 10px" : "8px 12px",
// // // //             borderRadius: 10,
// // // //             border: "1px solid #D1D5DB",
// // // //             background: "#FFFFFF",
// // // //             fontWeight: 700,
// // // //             fontSize: isNarrow ? 13 : 14,
// // // //             cursor: "pointer",
// // // //           }}
// // // //           title="Go to Home"
// // // //         >
// // // //           Home
// // // //         </button>
// // // //       </div>
// // // //       <div
// // // //         style={{
// // // //           background: "#fff",
// // // //           border: "1px solid #E5E7EB",
// // // //           borderRadius: 12,
// // // //           padding: isNarrow ? 12 : 16,
// // // //         }}
// // // //       >
// // // //         <form
// // // //           onSubmit={onSubmit}
// // // //           style={{ display: "grid", gap: isNarrow ? 8 : 10 }}
// // // //         >
// // // //           <input
// // // //             value={username}
// // // //             onChange={(e) => setU(e.target.value)}
// // // //             placeholder="admin username"
// // // //             required
// // // //             style={{
// // // //               padding: isNarrow ? 10 : 12,
// // // //               borderRadius: 10,
// // // //               border: "1px solid #D1D5DB",
// // // //               fontWeight: 600,
// // // //               fontSize: isNarrow ? 14 : 16,
// // // //             }}
// // // //           />
// // // //           <input
// // // //             value={password}
// // // //             onChange={(e) => setP(e.target.value)}
// // // //             placeholder="admin password"
// // // //             type="password"
// // // //             required
// // // //             style={{
// // // //               padding: isNarrow ? 10 : 12,
// // // //               borderRadius: 10,
// // // //               border: "1px solid #D1D5DB",
// // // //               fontWeight: 600,
// // // //               fontSize: isNarrow ? 14 : 16,
// // // //             }}
// // // //           />
// // // //           <button
// // // //             disabled={busy}
// // // //             style={{
// // // //               padding: isNarrow ? "10px 12px" : "12px 14px",
// // // //               borderRadius: 10,
// // // //               border: "1px solid #0D47A1",
// // // //               background: "#0D47A1",
// // // //               color: "#fff",
// // // //               fontWeight: 800,
// // // //               cursor: "pointer",
// // // //               width: "100%",
// // // //               minHeight: 40,
// // // //               fontSize: "clamp(14px, 3.5vw, 16px)",
// // // //             }}
// // // //           >
// // // //             {busy ? "Signing in..." : "Login"}
// // // //           </button>
// // // //           {err && (
// // // //             <div style={{ color: "#b00020", fontWeight: 600 }}>{err}</div>
// // // //           )}
// // // //         </form>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // function AdminDashboard({ navigate }) {
// // // //   const [tab, setTab] = useState("drivers"); // 'drivers' | 'routes' | 'live'
// // // //   const [drivers, setDrivers] = useState([]);
// // // //   const [assignments, setAssignments] = useState({}); // vehicleNo -> row
// // // //   const [localAssign, setLocalAssign] = useState({}); // vehicleNo -> { routeCode, driverId, autopilotEnabled }
// // // //   const [editing, setEditing] = useState({}); // vehicleNo -> true when row is in edit mode
// // // //   const [newName, setNewName] = useState("");
// // // //   const [newPhone, setNewPhone] = useState("");
// // // //   const [err, setErr] = useState("");
// // // //   const [busySave, setBusySave] = useState(null); // vehicleno while saving
// // // //   const [liveBuses, setLiveBuses] = useState([]);
// // // //   const adminToken = getAdminToken();
// // // //   const isNarrow = useIsNarrow(480);

// // // //   useEffect(() => {
// // // //     if (!adminToken) navigate("/admin/login");
// // // //   }, [adminToken, navigate]);

// // // //   const authHeader = useMemo(
// // // //     () => ({
// // // //       headers: { Authorization: `Bearer ${adminToken}` },
// // // //     }),
// // // //     [adminToken]
// // // //   );

// // // //   async function loadDrivers() {
// // // //     try {
// // // //       const r = await axios.get(`${BACKEND}/api/admin/drivers`, authHeader);
// // // //       setDrivers(r.data?.drivers || []);
// // // //     } catch (e) {
// // // //       console.warn("loadDrivers error", e?.message || e);
// // // //     }
// // // //   }

// // // //   async function loadAssignments() {
// // // //     try {
// // // //       const r = await axios.get(`${BACKEND}/api/admin/assignments`, authHeader);
// // // //       const rows = r.data?.rows || [];
// // // //       const map = {};
// // // //       for (const row of rows) {
// // // //         map[row.vehicleNo] = row;
// // // //       }
// // // //       setAssignments(map);
// // // //       // whenever we reload from backend, treat all as "saved" (not editing)
// // // //       setEditing({});
// // // //       setLocalAssign({});
// // // //     } catch (e) {
// // // //       console.warn("loadAssignments error", e?.message || e);
// // // //     }
// // // //   }

// // // //   useEffect(() => {
// // // //     if (!adminToken) return;
// // // //     loadDrivers();
// // // //     loadAssignments();
// // // //   }, [adminToken]); // eslint-disable-line react-hooks/exhaustive-deps

// // // //   // live tracking (simple polling)
// // // //   useEffect(() => {
// // // //     if (tab !== "live") return;
// // // //     let cancelled = false;

// // // //     async function loadLive() {
// // // //       try {
// // // //         const r = await axios.get(`${BACKEND}/api/vehicle-data`, {
// // // //           timeout: 8000,
// // // //         });
// // // //         if (!cancelled) {
// // // //           const arr = Array.isArray(r.data) ? r.data : [];
// // // //           setLiveBuses(arr);
// // // //         }
// // // //       } catch (e) {
// // // //         if (!cancelled) {
// // // //           console.warn("admin live map error", e?.message || e);
// // // //         }
// // // //       }
// // // //     }
// // // //     loadLive();
// // // //     const id = setInterval(loadLive, 5000);
// // // //     return () => {
// // // //       cancelled = true;
// // // //       clearInterval(id);
// // // //     };
// // // //   }, [tab]);

// // // //   const handleAddDriver = async (e) => {
// // // //     e.preventDefault();
// // // //     setErr("");
// // // //     try {
// // // //       const r = await axios.post(
// // // //         `${BACKEND}/api/admin/drivers`,
// // // //         { name: newName, phoneNumber: newPhone },
// // // //         authHeader
// // // //       );
// // // //       if (r.data?.success && r.data?.driver) {
// // // //         setDrivers((prev) => [...prev, r.data.driver]);
// // // //         setNewName("");
// // // //         setNewPhone("");
// // // //       } else {
// // // //         setErr("Failed to create driver");
// // // //       }
// // // //     } catch (e1) {
// // // //       setErr(e1?.response?.data?.message || "Failed to create driver");
// // // //     }
// // // //   };

// // // //   const handleRemoveDriver = async (id) => {
// // // //     if (!window.confirm("Remove this driver?")) return;
// // // //     try {
// // // //       await axios.delete(`${BACKEND}/api/admin/drivers/${id}`, authHeader);
// // // //       setDrivers((prev) => prev.filter((d) => d._id !== id));
// // // //       // Note: assignments that still reference this driver will continue to exist until reassigned
// // // //     } catch (e1) {
// // // //       alert(e1?.response?.data?.message || "Failed to remove driver");
// // // //     }
// // // //   };

// // // //   function getBaseAssignForVehicle(veh) {
// // // //     const row = assignments[veh];
// // // //     if (!row) {
// // // //       return {
// // // //         vehicleNo: veh,
// // // //         routeCode: "",
// // // //         driverId: "",
// // // //         autopilotEnabled: false,
// // // //       };
// // // //     }
// // // //     return {
// // // //       vehicleNo: veh,
// // // //       routeCode: row.routeCode || "",
// // // //       driverId: row.driver?._id || "",
// // // //       autopilotEnabled: !!row.autopilotEnabled,
// // // //     };
// // // //   }

// // // //   function updateLocalAssign(veh, patch) {
// // // //     setLocalAssign((prev) => ({
// // // //       ...prev,
// // // //       [veh]: { ...getBaseAssignForVehicle(veh), ...(prev[veh] || {}), ...patch },
// // // //     }));
// // // //   }

// // // //   const handleSaveAssignment = async (veh) => {
// // // //     const base = getBaseAssignForVehicle(veh);
// // // //     const row = localAssign[veh] || base;
// // // //     const hasAssignment = !!assignments[veh]; // vehicle currently has an active route?

// // // //     // RESET error first
// // // //     setErr("");

// // // //     // ---- CASE 1: Admin cleared both fields and there *was* an assignment -> CLEAR MODE ----
// // // //     if (!row.routeCode && !row.driverId && hasAssignment) {
// // // //       setBusySave(veh);
// // // //       try {
// // // //         await axios.post(
// // // //           `${BACKEND}/api/admin/vehicle-assign`,
// // // //           {
// // // //             vehicleNo: row.vehicleNo,
// // // //             clear: true,              // 👈 tells backend: deactivate assignment
// // // //           },
// // // //           authHeader
// // // //         );
// // // //         await loadAssignments();      // refresh table
// // // //         setEditing((prev) => ({ ...prev, [veh]: false }));
// // // //       } catch (e1) {
// // // //         setErr(e1?.response?.data?.message || "Failed to clear assignment");
// // // //       } finally {
// // // //         setBusySave(null);
// // // //       }
// // // //       return;
// // // //     }

// // // //     // ---- CASE 2: No assignment and still empty -> nothing to save ----
// // // //     if (!row.routeCode || !row.driverId) {
// // // //       setErr("Select both Route & Driver, or leave the row as-is.");
// // // //       return;
// // // //     }

// // // //     // ---- CASE 3: Normal ASSIGN / UPDATE ----
// // // //     setBusySave(veh);
// // // //     try {
// // // //       await axios.post(
// // // //         `${BACKEND}/api/admin/vehicle-assign`,
// // // //         {
// // // //           vehicleNo: row.vehicleNo,
// // // //           routeCode: row.routeCode,
// // // //           driverId: row.driverId,
// // // //           autopilotEnabled: !!row.autopilotEnabled,
// // // //         },
// // // //         authHeader
// // // //       );
// // // //       await loadAssignments();
// // // //       setEditing((prev) => ({ ...prev, [veh]: false }));
// // // //     } catch (e1) {
// // // //       setErr(e1?.response?.data?.message || "Failed to save assignment");
// // // //     } finally {
// // // //       setBusySave(null);
// // // //     }
// // // //   };


// // // //   const onLogout = () => {
// // // //     setAdminToken("");
// // // //     navigate("/admin/login");
// // // //   };

// // // //   // simple driver lookup for live map
// // // //   const driverByVehicle = useMemo(() => {
// // // //     const out = {};
// // // //     Object.values(assignments).forEach((row) => {
// // // //       if (row.vehicleNo && row.driver) {
// // // //         out[row.vehicleNo] = row.driver;
// // // //       }
// // // //     });
// // // //     return out;
// // // //   }, [assignments]);

// // // //   return (
// // // //     <div className="admin-layout">
// // // //       {/* left sidebar */}
// // // //       <div
// // // //         className="sidebar"
// // // //         style={{
// // // //           width: isNarrow ? 220 : 260, // responsive width override
// // // //         }}
// // // //       >
// // // //         {/* top section: logo, back button, nav */}
// // // //         <div>
// // // //           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// // // //             <img
// // // //               src={iitmLogo}
// // // //               alt="IITM"
// // // //               style={{ width: 32, height: 32, borderRadius: 8 }}
// // // //             />
// // // //             <div>
// // // //               <div style={{ fontWeight: 800, fontSize: 16 }}>Admin</div>
// // // //               <div style={{ fontSize: 12, opacity: 0.8 }}>Thoothukudi Bus Tracking</div>
// // // //             </div>
// // // //           </div>
// // // //           <button
// // // //             onClick={() => navigate("/")}
// // // //             style={{
// // // //               marginTop: 8,
// // // //               textAlign: "left",
// // // //               padding: "6px 10px",
// // // //               borderRadius: 10,
// // // //               border: "1px solid #4b5563",
// // // //               background: "transparent",
// // // //               color: "#e5e7eb",
// // // //               cursor: "pointer",
// // // //               fontSize: 13,
// // // //             }}
// // // //           >
// // // //             ← Back to map
// // // //           </button>
// // // //           <div
// // // //             style={{
// // // //               marginTop: 16,
// // // //               display: "flex",
// // // //               flexDirection: "column",
// // // //               gap: 6,
// // // //             }}
// // // //           >
// // // //             <button
// // // //               onClick={() => setTab("drivers")}
// // // //               style={{
// // // //                 textAlign: "left",
// // // //                 padding: "8px 10px",
// // // //                 borderRadius: 10,
// // // //                 border: "none",
// // // //                 background: tab === "drivers" ? "#f9fafb" : "transparent",
// // // //                 color: tab === "drivers" ? "#111827" : "#e5e7eb",
// // // //                 fontWeight: 600,
// // // //                 cursor: "pointer",
// // // //               }}
// // // //             >
// // // //               + Add Driver
// // // //             </button>
// // // //             <button
// // // //               onClick={() => setTab("routes")}
// // // //               style={{
// // // //                 textAlign: "left",
// // // //                 padding: "8px 10px",
// // // //                 borderRadius: 10,
// // // //                 border: "none",
// // // //                 background: tab === "routes" ? "#f9fafb" : "transparent",
// // // //                 color: tab === "routes" ? "#111827" : "#e5e7eb",
// // // //                 fontWeight: 600,
// // // //                 cursor: "pointer",
// // // //               }}
// // // //             >
// // // //               Route Allocation
// // // //             </button>
// // // //             <button
// // // //               onClick={() => setTab("live")}
// // // //               style={{
// // // //                 textAlign: "left",
// // // //                 padding: "8px 10px",
// // // //                 borderRadius: 10,
// // // //                 border: "none",
// // // //                 background: tab === "live" ? "#f9fafb" : "transparent",
// // // //                 color: tab === "live" ? "#111827" : "#e5e7eb",
// // // //                 fontWeight: 600,
// // // //                 cursor: "pointer",
// // // //               }}
// // // //             >
// // // //               Live Tracking
// // // //             </button>
// // // //           </div>
// // // //         </div>

// // // //         {/* bottom logout – pinned to sidebar bottom */}
// // // //         <button
// // // //           onClick={onLogout}
// // // //           style={{
// // // //             marginTop: 12,
// // // //             padding: "8px 10px",
// // // //             borderRadius: 10,
// // // //             border: "1px solid #6b7280",
// // // //             background: "transparent",
// // // //             color: "#e5e7eb",
// // // //             cursor: "pointer",
// // // //             fontSize: 13,
// // // //           }}
// // // //         >
// // // //           Logout
// // // //         </button>
// // // //       </div>

// // // //       {/* main content */}
// // // //       <div className="content">
// // // //         {tab === "drivers" && (
// // // //           <div style={{ maxWidth: 800, margin: "0 auto" }}>
// // // //             <h2 style={{ marginTop: 0 }}>Drivers</h2>
// // // //             <form
// // // //               onSubmit={handleAddDriver}
// // // //               style={{
// // // //                 display: "grid",
// // // //                 gridTemplateColumns: "2fr 2fr auto",
// // // //                 gap: 8,
// // // //                 alignItems: "center",
// // // //                 marginBottom: 16,
// // // //               }}
// // // //             >
// // // //               <input
// // // //                 value={newName}
// // // //                 onChange={(e) => setNewName(e.target.value)}
// // // //                 placeholder="Driver name"
// // // //                 required
// // // //                 style={{
// // // //                   padding: 10,
// // // //                   borderRadius: 10,
// // // //                   border: "1px solid #D1D5DB",
// // // //                   fontSize: 14,
// // // //                 }}
// // // //               />
// // // //               <input
// // // //                 value={newPhone}
// // // //                 onChange={(e) => setNewPhone(e.target.value)}
// // // //                 placeholder="Phone number (unique)"
// // // //                 required
// // // //                 style={{
// // // //                   padding: 10,
// // // //                   borderRadius: 10,
// // // //                   border: "1px solid #D1D5DB",
// // // //                   fontSize: 14,
// // // //                 }}
// // // //               />
// // // //               <button
// // // //                 type="submit"
// // // //                 style={{
// // // //                   padding: "10px 16px",
// // // //                   borderRadius: 10,
// // // //                   border: "1px solid #0D47A1",
// // // //                   background: "#0D47A1",
// // // //                   color: "#fff",
// // // //                   fontWeight: 700,
// // // //                   cursor: "pointer",
// // // //                   fontSize: 14,
// // // //                 }}
// // // //               >
// // // //                 Add
// // // //               </button>
// // // //             </form>
// // // //             {err && (
// // // //               <div
// // // //                 style={{
// // // //                   color: "#b00020",
// // // //                   fontWeight: 600,
// // // //                   marginBottom: 8,
// // // //                 }}
// // // //               >
// // // //                 {err}
// // // //               </div>
// // // //             )}
// // // //             <div
// // // //               style={{
// // // //                 display: "grid",
// // // //                 gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
// // // //                 gap: 12,
// // // //               }}
// // // //             >
// // // //               {drivers.map((d) => (
// // // //                 <div
// // // //                   key={d._id}
// // // //                   style={{
// // // //                     background: "#fff",
// // // //                     borderRadius: 12,
// // // //                     border: "1px solid #e5e7eb",
// // // //                     padding: 12,
// // // //                     display: "flex",
// // // //                     flexDirection: "column",
// // // //                     gap: 4,
// // // //                   }}
// // // //                 >
// // // //                   <div style={{ fontWeight: 700, fontSize: 15 }}>{d.name}</div>
// // // //                   <div style={{ fontSize: 13, opacity: 0.8 }}>
// // // //                     Phone: {d.phoneNumber || "—"}
// // // //                   </div>
// // // //                   <div style={{ fontSize: 12, opacity: 0.6 }}>
// // // //                     username: <code>{d.username}</code>
// // // //                   </div>
// // // //                   <button
// // // //                     onClick={() => handleRemoveDriver(d._id)}
// // // //                     style={{
// // // //                       marginTop: 8,
// // // //                       alignSelf: "flex-start",
// // // //                       padding: "6px 10px",
// // // //                       borderRadius: 8,
// // // //                       border: "1px solid #f97373",
// // // //                       background: "#fef2f2",
// // // //                       color: "#b91c1c",
// // // //                       fontSize: 12,
// // // //                       fontWeight: 600,
// // // //                       cursor: "pointer",
// // // //                     }}
// // // //                   >
// // // //                     Remove
// // // //                   </button>
// // // //                 </div>
// // // //               ))}
// // // //               {drivers.length === 0 && (
// // // //                 <div style={{ fontSize: 14, opacity: 0.7 }}>
// // // //                   No drivers yet. Add your first driver above.
// // // //                 </div>
// // // //               )}
// // // //             </div>
// // // //           </div>
// // // //         )}

// // // //         {tab === "routes" && (
// // // //           <div style={{ maxWidth: 1100, margin: "0 auto" }}>
// // // //             <h2 style={{ marginTop: 0 }}>Route Allocation</h2>
// // // //             {err && (
// // // //               <div
// // // //                 style={{
// // // //                   color: "#b00020",
// // // //                   fontWeight: 600,
// // // //                   marginBottom: 8,
// // // //                 }}
// // // //               >
// // // //                 {err}
// // // //               </div>
// // // //             )}
// // // //             <div style={{ overflowX: "auto" }}>
// // // //               <table
// // // //                 style={{
// // // //                   width: "100%",
// // // //                   borderCollapse: "collapse",
// // // //                   background: "#fff",
// // // //                   borderRadius: 12,
// // // //                   overflow: "hidden",
// // // //                 }}
// // // //               >
// // // //                 <thead>
// // // //                   <tr
// // // //                     style={{
// // // //                       background: "#f9fafb",
// // // //                       borderBottom: "1px solid #e5e7eb",
// // // //                     }}
// // // //                   >
// // // //                     <th style={{ padding: 8, textAlign: "left" }}>#</th>
// // // //                     <th style={{ padding: 8, textAlign: "left" }}>Vehicle</th>
// // // //                     <th style={{ padding: 8, textAlign: "left" }}>Route</th>
// // // //                     <th style={{ padding: 8, textAlign: "left" }}>Driver</th>
// // // //                     <th style={{ padding: 8, textAlign: "left" }}>Auto-pilot</th>
// // // //                     <th style={{ padding: 8, textAlign: "left" }} />
// // // //                   </tr>
// // // //                 </thead>
// // // //                 <tbody>
// // // //                   {VEHICLES.map((veh, idx) => {
// // // //                     const base = getBaseAssignForVehicle(veh);
// // // //                     const local = localAssign[veh] || base;
// // // //                     const hasAssignment =
// // // //                       !!base.routeCode && !!base.driverId; // existing saved row?
// // // //                     const isEditing = !!editing[veh];
// // // //                     const locked = hasAssignment && !isEditing;
// // // //                     const saving = busySave === veh;

// // // //                     return (
// // // //                       <tr
// // // //                         key={veh}
// // // //                         style={{ borderBottom: "1px solid #f3f4f6" }}
// // // //                       >
// // // //                         <td style={{ padding: 8 }}>{idx + 1}</td>
// // // //                         <td style={{ padding: 8, fontWeight: 600 }}>{veh}</td>
// // // //                         <td style={{ padding: 8 }}>
// // // //                           <select
// // // //                             value={local.routeCode}
// // // //                             onChange={(e) =>
// // // //                               updateLocalAssign(veh, {
// // // //                                 routeCode: e.target.value,
// // // //                               })
// // // //                             }
// // // //                             disabled={locked || saving}
// // // //                             style={{
// // // //                               padding: 8,
// // // //                               borderRadius: 8,
// // // //                               border: "1px solid #d1d5db",
// // // //                               fontSize: 13,
// // // //                               minWidth: 180,
// // // //                               backgroundColor: locked ? "#f9fafb" : "white",
// // // //                             }}
// // // //                           >
// // // //                             <option value="">Select route…</option>
// // // //                             {ADMIN_ROUTES.map((r) => (
// // // //                               <option key={r.code} value={r.code}>
// // // //                                 {r.label}
// // // //                               </option>
// // // //                             ))}
// // // //                           </select>
// // // //                         </td>
// // // //                         <td style={{ padding: 8 }}>
// // // //                           <select
// // // //                             value={local.driverId}
// // // //                             onChange={(e) =>
// // // //                               updateLocalAssign(veh, {
// // // //                                 driverId: e.target.value,
// // // //                               })
// // // //                             }
// // // //                             disabled={locked || saving}
// // // //                             style={{
// // // //                               padding: 8,
// // // //                               borderRadius: 8,
// // // //                               border: "1px solid #d1d5db",
// // // //                               fontSize: 13,
// // // //                               minWidth: 180,
// // // //                               backgroundColor: locked ? "#f9fafb" : "white",
// // // //                             }}
// // // //                           >
// // // //                             <option value="">Select driver…</option>
// // // //                             {drivers.map((d) => (
// // // //                               <option key={d._id} value={d._id}>
// // // //                                 {d.name} ({d.phoneNumber || d.username})
// // // //                               </option>
// // // //                             ))}
// // // //                           </select>
// // // //                         </td>
// // // //                         <td style={{ padding: 8 }}>
// // // //                           <label
// // // //                             style={{
// // // //                               display: "inline-flex",
// // // //                               alignItems: "center",
// // // //                               gap: 6,
// // // //                               fontSize: 13,
// // // //                               opacity: locked ? 0.6 : 1,
// // // //                             }}
// // // //                           >
// // // //                             <input
// // // //                               type="checkbox"
// // // //                               checked={!!local.autopilotEnabled}
// // // //                               onChange={(e) =>
// // // //                                 updateLocalAssign(veh, {
// // // //                                   autopilotEnabled: e.target.checked,
// // // //                                 })
// // // //                               }
// // // //                               disabled={locked || saving}
// // // //                             />
// // // //                             On
// // // //                           </label>
// // // //                         </td>
// // // //                         <td style={{ padding: 8 }}>
// // // //                           <button
// // // //                             onClick={() => {
// // // //                               if (locked) {
// // // //                                 // switch to edit mode
// // // //                                 updateLocalAssign(veh, {}); // ensure local copy
// // // //                                 setEditing((prev) => ({
// // // //                                   ...prev,
// // // //                                   [veh]: true,
// // // //                                 }));
// // // //                               } else {
// // // //                                 // save current data
// // // //                                 handleSaveAssignment(veh);
// // // //                               }
// // // //                             }}
// // // //                             disabled={saving}
// // // //                             style={{
// // // //                               padding: "6px 12px",
// // // //                               borderRadius: 8,
// // // //                               border: "1px solid #0D47A1",
// // // //                               background: saving
// // // //                                 ? "#e5e7eb"
// // // //                                 : locked
// // // //                                   ? "#0D47A1"
// // // //                                   : "#0D47A1",
// // // //                               color: saving ? "#4b5563" : "#fff",
// // // //                               fontSize: 13,
// // // //                               fontWeight: 700,
// // // //                               cursor: saving ? "not-allowed" : "pointer",
// // // //                             }}
// // // //                           >
// // // //                             {saving
// // // //                               ? "Saving…"
// // // //                               : locked
// // // //                                 ? "Edit"
// // // //                                 : "Save"}
// // // //                           </button>
// // // //                         </td>
// // // //                       </tr>
// // // //                     );
// // // //                   })}
// // // //                 </tbody>
// // // //               </table>
// // // //             </div>
// // // //           </div>
// // // //         )}

// // // //         {tab === "live" && (
// // // //           <div style={{ height: "calc(100vh - 40px)" }}>
// // // //             <h2 style={{ marginTop: 0 }}>Live Tracking</h2>
// // // //             <div style={{ height: "calc(100% - 36px)" }}>
// // // //               <MapContainer
// // // //                 center={center}
// // // //                 zoom={DEFAULT_ZOOM}
// // // //                 maxZoom={22}
// // // //                 style={{ width: "100%", height: "100%" }}
// // // //               >
// // // //                 <TileLayer
// // // //                   attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
// // // //                   url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// // // //                   maxNativeZoom={19}
// // // //                   maxZoom={22}
// // // //                 />
// // // //                 {liveBuses.map((bus) => {
// // // //                   // const label = vehicleLabel(bus.vehicleno);
// // // //                   const rc = assignments[bus.vehicleno]?.routeCode;   // admin assignments map is row objects
// // // //                   const label = vehicleLabel(bus.vehicleno, rc);
// // // //                   const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
// // // //                   const drv = driverByVehicle[bus.vehicleno];
// // // //                   return (
// // // //                     <Marker
// // // //                       key={bus.vehicleno}
// // // //                       position={{
// // // //                         lat: bus.latitude,
// // // //                         lng: bus.longitude,
// // // //                       }}
// // // //                       // icon={createVehicleDivIcon(
// // // //                       //   label,
// // // //                       //   Number(bus.heading) || 0
// // // //                       // )}
// // // //                       icon={createVehicleDivIcon(label, Number(bus.heading) || 0, palette)}
// // // //                     >
// // // //                       <Popup>
// // // //                         <div className="info-window">
// // // //                           <h4>
// // // //                             {bus.vehicleno} ({label})
// // // //                           </h4>
// // // //                           <p>
// // // //                             <strong>Speed:</strong>{" "}
// // // //                             {Number.isFinite(bus.speed)
// // // //                               ? bus.speed.toFixed(1)
// // // //                               : "N/A"}{" "}
// // // //                             km/h
// // // //                           </p>
// // // //                           {drv && (
// // // //                             <>
// // // //                               <p>
// // // //                                 <strong>Driver:</strong> {drv.name}</p>
// // // //                               <p>
// // // //                                 <strong>Phone:</strong>{" "}
// // // //                                 {drv.phoneNumber || "—"}
// // // //                               </p>
// // // //                             </>
// // // //                           )}
// // // //                           {!drv && (
// // // //                             <p style={{ fontSize: 13, opacity: 0.7 }}>
// // // //                               No driver assigned
// // // //                             </p>
// // // //                           )}
// // // //                         </div>
// // // //                       </Popup>
// // // //                     </Marker>
// // // //                   );
// // // //                 })}
// // // //               </MapContainer>
// // // //             </div>
// // // //           </div>
// // // //         )}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // function RecenterMap({ center, zoom }) {
// // // //   const map = useMap();

// // // //   useEffect(() => {
// // // //     if (!center) return;
// // // //     map.setView([center.lat, center.lng], zoom ?? map.getZoom(), { animate: true });
// // // //   }, [center, zoom, map]);

// // // //   return null;
// // // // }



// // // // /* ---------------------------- MAP PAGE ---------------------------- */
// // // // function MapPage() {
// // // //   const [buses, setBuses] = useState([]);
// // // //   const [userLocation, setUserLocation] = useState(null);
// // // //   const [socketStatus, setSocketStatus] = useState('disconnected');
// // // //   const [roads, setRoads] = useState(null);
// // // //   const [filterType, setFilterType] = useState('all');
// // // //   const [mapCenter, setMapCenter] = useState(center);
// // // //   const [locError, setLocError] = useState("");
// // // //   const [geoState, setGeoState] = useState("unknown"); // "granted" | "prompt" | "denied" | "unknown"
// // // //   const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(true);

// // // //   // maintenance banner state
// // // //   const [maintenance, setMaintenance] = useState(false);
// // // //   const [maintenanceReason, setMaintenanceReason] = useState('');
// // // //   const lastUpdateRef = useRef(0);
// // // //   // ---- Backend ETA (JWT) state ----
// // // //   const [etaToken, setEtaToken] = useState(null);    // JWT for /api/eta/*
// // // //   const [stopEtas, setStopEtas] = useState({});      // { [stopId]: { data, error } }

// // // //   const etaTokenRef = useRef(null);
// // // //   const etaTokenFetchingRef = useRef(false);

// // // //   const flatRoadLinesRef = useRef([]);
// // // //   const lastSmoothedRef = useRef(new Map());

// // // //   // ---- Schedule Modal state ----
// // // //   const [showSchedule, setShowSchedule] = useState(false);
// // // //   const [activeTab, setActiveTab] = useState(0);

// // // //   // --- responsive helpers ---
// // // //   const [isNarrow, setIsNarrow] = useState(() => window.innerWidth <= 480);
// // // //   const clamp = (min, pref, max) => `clamp(${min}, ${pref}, ${max})`;
// // // //   const pad = isNarrow ? 12 : 16;
// // // //   const gap = isNarrow ? 8 : 12;
// // // //   const chipFS = isNarrow ? 12 : 13;

// // // //   useEffect(() => {
// // // //     const onResize = () => setIsNarrow(window.innerWidth <= 480);
// // // //     window.addEventListener('resize', onResize);
// // // //     return () => window.removeEventListener('resize', onResize);
// // // //   }, []);

// // // //   // ---- Helper: fetch / refresh JWT for ETA API ----
// // // //   const fetchEtaToken = useCallback(async () => {
// // // //     if (!BACKEND || !API_KEY) return null;

// // // //     // Avoid spamming if many 401s come at once
// // // //     if (etaTokenFetchingRef.current) {
// // // //       return etaTokenRef.current;
// // // //     }

// // // //     etaTokenFetchingRef.current = true;
// // // //     try {
// // // //       const res = await axios.post(
// // // //         `${BACKEND}/api/auth/token`,
// // // //         {},
// // // //         {
// // // //           timeout: 5000,
// // // //           headers: {
// // // //             Authorization: `Bearer ${API_KEY}`, // apiKeyAuth middleware
// // // //           },
// // // //         }
// // // //       );
// // // //       const t = res.data?.token;
// // // //       if (t) {
// // // //         etaTokenRef.current = t;
// // // //         setEtaToken(t);
// // // //         return t;
// // // //       }
// // // //       return null;
// // // //     } catch (e) {
// // // //       console.warn('Failed to fetch ETA JWT token:', e?.message || e);
// // // //       return null;
// // // //     } finally {
// // // //       etaTokenFetchingRef.current = false;
// // // //     }
// // // //   }, []);

// // // //   // ---- Get initial JWT token for ETA API ----
// // // //   useEffect(() => {
// // // //     fetchEtaToken();
// // // //   }, [fetchEtaToken]);

// // // //   // ---- Poll backend ETA for every stop every 5 seconds ----
// // // //   useEffect(() => {
// // // //     if (!BACKEND) return;

// // // //     let cancelled = false;

// // // //     async function fetchAllStopEtas() {
// // // //       // If we don't have a token yet, try to get one
// // // //       if (!etaTokenRef.current) {
// // // //         await fetchEtaToken();
// // // //         if (!etaTokenRef.current || cancelled) return;
// // // //       }

// // // //       try {
// // // //         const results = await Promise.all(
// // // //           busStops.map(async (s) => {
// // // //             try {
// // // //               const res = await axios.get(
// // // //                 `${BACKEND}/api/eta/stop/${s.id}`,
// // // //                 {
// // // //                   timeout: 8000,
// // // //                   headers: {
// // // //                     Authorization: `Bearer ${etaTokenRef.current}`,
// // // //                   },
// // // //                 }
// // // //               );
// // // //               return { stopId: s.id, data: res.data, error: null };
// // // //             } catch (err) {
// // // //               // If token expired, refresh in background
// // // //               if (err?.response?.status === 401) {
// // // //                 console.warn('ETA JWT expired for stop', s.id, '— refreshing token');
// // // //                 fetchEtaToken().catch(() => { });
// // // //               } else {
// // // //                 console.warn(
// // // //                   'ETA error for stop',
// // // //                   s.id,
// // // //                   err?.response?.status || '',
// // // //                   err?.message || err
// // // //                 );
// // // //               }
// // // //               return { stopId: s.id, data: null, error: true };
// // // //             }
// // // //           })
// // // //         );

// // // //         if (cancelled) return;

// // // //         setStopEtas((prev) => {
// // // //           const next = { ...prev };
// // // //           for (const r of results) {
// // // //             next[r.stopId] = { data: r.data, error: r.error };
// // // //           }
// // // //           return next;
// // // //         });
// // // //       } catch (e) {
// // // //         if (!cancelled) {
// // // //           console.warn('ETA batch fetch failed:', e?.message || e);
// // // //         }
// // // //       }
// // // //     }

// // // //     // first call + interval
// // // //     fetchAllStopEtas();
// // // //     const id = setInterval(fetchAllStopEtas, 5000);

// // // //     return () => {
// // // //       cancelled = true;
// // // //       clearInterval(id);
// // // //     };
// // // //   }, [fetchEtaToken]);


// // // //   // ---- stable socket + pause flag ----
// // // //   const socketRef = useRef(null);
// // // //   const ignoreUpdatesRef = useRef(false);

// // // //   // ---- assignments (vehicle -> routeCode) ----
// // // //   const [assignments, setAssignments] = useState({});
// // // //   async function refreshAssignments() {
// // // //     try {
// // // //       const r = await axios.get(`${BACKEND}/api/vehicle-route/active`);
// // // //       const map = {};
// // // //       for (const row of r.data?.rows || []) map[row.vehicleNo] = row.routeCode;
// // // //       setAssignments(map);
// // // //     } catch { }
// // // //   }
// // // //   useEffect(() => { refreshAssignments(); const t = setInterval(refreshAssignments, 60000); return () => clearInterval(t); }, []);

// // // //   // Load roads
// // // //   useEffect(() => {
// // // //     let cancelled = false;
// // // //     (async () => {
// // // //       try {
// // // //         const r = await fetch(ROADS_URL);
// // // //         if (!cancelled && r.ok) setRoads(await r.json());
// // // //       } catch (e) {
// // // //         if (!cancelled) console.warn('Failed to load roads:', e?.message || e);
// // // //       }
// // // //     })();
// // // //     return () => { cancelled = true; };
// // // //   }, []);

// // // //   // Flatten roads to LineStrings
// // // //   useEffect(() => {
// // // //     if (!roads) return;
// // // //     const lines = [];
// // // //     turf.flattenEach(roads, (feat) => {
// // // //       if (feat.geometry?.type === 'LineString') lines.push(feat);
// // // //     });
// // // //     flatRoadLinesRef.current = lines;
// // // //   }, [roads]);

// // // //   // // Geolocation
// // // //   // useEffect(() => {
// // // //   //   if ('geolocation' in navigator) {
// // // //   //     navigator.geolocation.getCurrentPosition(
// // // //   //       (pos) => setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
// // // //   //       (err) => console.warn('Geolocation error:', err?.message),
// // // //   //       { enableHighAccuracy: true, timeout: 5000 }
// // // //   //     );
// // // //   //   }
// // // //   // }, []);

// // // //   useEffect(() => {
// // // //     let perm;
// // // //     (async () => {
// // // //       try {
// // // //         if (!navigator.permissions?.query) return;
// // // //         perm = await navigator.permissions.query({ name: "geolocation" });
// // // //         setGeoState(perm.state);
// // // //         perm.onchange = () => setGeoState(perm.state);
// // // //       } catch {
// // // //         // ignore
// // // //       }
// // // //     })();
// // // //     return () => {
// // // //       if (perm) perm.onchange = null;
// // // //     };
// // // //   }, []);


// // // //   //   const requestUserLocation = useCallback(() => {
// // // //   //   setLocError("");

// // // //   //   if (!("geolocation" in navigator)) {
// // // //   //     setLocError("Geolocation not supported on this device/browser.");
// // // //   //     return;
// // // //   //   }

// // // //   //   navigator.geolocation.getCurrentPosition(
// // // //   //     (pos) => {
// // // //   //       const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
// // // //   //       setUserLocation(loc);
// // // //   //       setMapCenter(loc); // ✅ recenter map here
// // // //   //       setLocError("");
// // // //   //     },
// // // //   //     (err) => {
// // // //   //       console.warn("Geolocation error:", err?.message || err);
// // // //   //       // If user didn't allow, browser will show prompt only if not blocked.
// // // //   //       setLocError("Please allow location to center the map near you.");
// // // //   //     },
// // // //   //     { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
// // // //   //   );
// // // //   // }, []);

// // // //   const requestUserLocation = useCallback(() => {
// // // //     setLocError("");

// // // //     if (!("geolocation" in navigator)) {
// // // //       setLocError("Geolocation not supported on this device/browser.");
// // // //       return;
// // // //     }

// // // //     navigator.geolocation.getCurrentPosition(
// // // //       (pos) => {
// // // //         const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
// // // //         setUserLocation(loc);
// // // //         setMapCenter(loc);
// // // //         setLocError("");
// // // //       },
// // // //       (err) => {
// // // //         // err.code === 1 => PERMISSION_DENIED
// // // //         if (err?.code === 1) {
// // // //           // If browser permission is truly "denied", it won't show popup again.
// // // //           setLocError(
// // // //             "Location is blocked in browser settings. Click the 🔒 icon near the URL → Site settings → Location → Allow (or Ask), then refresh."
// // // //           );
// // // //         } else {
// // // //           setLocError(err?.message || "Unable to fetch location.");
// // // //         }
// // // //       },
// // // //       { enableHighAccuracy: true, timeout: 8000, maximumAge: 15000 }
// // // //     );
// // // //   }, []);


// // // //   useEffect(() => {
// // // //     // ✅ On every page open (and after browser refresh), request location and recenter
// // // //     requestUserLocation();
// // // //   }, [requestUserLocation]);


// // // //   // Initial fetch
// // // //   useEffect(() => {
// // // //     if (!BACKEND) {
// // // //       setMaintenance(true);
// // // //       setMaintenanceReason('Server URL not configured');
// // // //       return;
// // // //     }
// // // //     axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 })
// // // //       .then((res) => {
// // // //         const arr = Array.isArray(res.data) ? res.data : [];
// // // //         const byVeh = new Map();
// // // //         for (const d of arr) {
// // // //           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
// // // //           byVeh.set(d.vehicleno, {
// // // //             vehicleno: d.vehicleno,
// // // //             latitude: d.latitude,
// // // //             longitude: d.longitude,
// // // //             speed: d.speed,
// // // //             heading
// // // //           });
// // // //         }
// // // //         const list = [...byVeh.values()];
// // // //         setBuses(processVehicles(list));
// // // //         lastUpdateRef.current = Date.now();
// // // //       })
// // // //       .catch((err) => {
// // // //         console.error('Initial fetch error:', err?.message || err);
// // // //         setMaintenance(true);
// // // //         setMaintenanceReason('Unable to fetch live data');
// // // //       });
// // // //   }, []);

// // // //   // ---- WebSocket packet handler ----
// // // //   const onPacket = (data) => {
// // // //     if (ignoreUpdatesRef.current) return;
// // // //     const incoming = {
// // // //       vehicleno: data.vehicleno,
// // // //       latitude: data.latitude,
// // // //       longitude: data.longitude,
// // // //       speed: data.speed,
// // // //       heading: Number.isFinite(data?.heading) ? toHeading(data.heading) : toHeading(data?.direction)
// // // //     };

// // // //     setBuses((prev) => {
// // // //       const nextByVeh = new Map(prev.map((b) => [b.vehicleno, b]));
// // // //       const processed = processVehicles([incoming], nextByVeh);
// // // //       const merged = new Map(prev.map((b) => [b.vehicleno, b]));
// // // //       for (const p of processed) merged.set(p.vehicleno, p);
// // // //       return [...merged.values()];
// // // //     });

// // // //     lastUpdateRef.current = Date.now();
// // // //   };

// // // //   // Live updates (Socket.IO)
// // // //   useEffect(() => {
// // // //     if (!BACKEND) return;

// // // //     setSocketStatus('connecting');
// // // //     const socket = io(BACKEND, {
// // // //       transports: ['websocket', 'polling'],
// // // //       reconnection: true,
// // // //       reconnectionAttempts: Infinity,
// // // //       reconnectionDelay: 1000,
// // // //       timeout: 10000,
// // // //       withCredentials: false
// // // //     });
// // // //     socketRef.current = socket;

// // // //     socket.on('connect', () => setSocketStatus('connected'));
// // // //     socket.on('disconnect', () => setSocketStatus('disconnected'));
// // // //     socket.on('connect_error', (e) => {
// // // //       console.warn('Socket connect_error:', e?.message || e);
// // // //       setSocketStatus('disconnected');
// // // //     });

// // // //     socket.on('new-bus-data', onPacket);

// // // //     return () => {
// // // //       socket.off('new-bus-data', onPacket);
// // // //       socket.disconnect();
// // // //       socketRef.current = null;
// // // //     };
// // // //   }, [roads]); // re-connect only if roads change

// // // //   // Staleness / maintenance detector
// // // //   useEffect(() => {
// // // //     const t = setInterval(() => {
// // // //       const sinceMs = Date.now() - lastUpdateRef.current;
// // // //       const stale = sinceMs > STALE_MS;
// // // //       const downAndEmpty = socketStatus === 'disconnected' && buses.length === 0;

// // // //       if (stale || downAndEmpty) {
// // // //         const mins = Math.floor(sinceMs / 60000);
// // // //         const secs = Math.floor((sinceMs % 60000) / 1000);
// // // //         setMaintenance(true);
// // // //         setMaintenanceReason(
// // // //           stale ? `No new data for ${mins}m ${secs}s` : 'Live connection unavailable'
// // // //         );
// // // //       } else {
// // // //         setMaintenance(false);
// // // //         setMaintenanceReason('');
// // // //       }
// // // //     }, 5000);
// // // //     return () => clearInterval(t);
// // // //   }, [socketStatus, buses.length]);

// // // //   // ---- Processing pipeline: smooth then snap ----
// // // //   function snapToRoad(coord, flatLines) {
// // // //     if (!flatLines || flatLines.length === 0) return null;
// // // //     const pt = turf.point([coord.lng, coord.lat]);

// // // //     let best = null;
// // // //     let bestDist = Infinity;

// // // //     for (const line of flatLines) {
// // // //       const np = turf.nearestPointOnLine(line, pt, { units: 'meters' });
// // // //       const dist = np?.properties?.dist;
// // // //       if (Number.isFinite(dist) && dist < bestDist) {
// // // //         bestDist = dist;
// // // //         const [lng, lat] = np.geometry.coordinates;
// // // //         best = { lat, lng, distM: dist };
// // // //       }
// // // //     }
// // // //     return best;
// // // //   }

// // // //   function processVehicles(list, prevMapOpt) {
// // // //     const flatLines = flatRoadLinesRef.current;
// // // //     const last = lastSmoothedRef.current;
// // // //     const result = [];

// // // //     for (const d of list) {
// // // //       const id = d.vehicleno;
// // // //       const raw = { lat: d.latitude, lng: d.longitude };

// // // //       const prev = last.get(id);
// // // //       const smoothedCoord = smoothCoord(prev?.coord, raw, SMOOTH_ALPHA);
// // // //       const smoothedHeading = smoothHeading(prev?.heading, d.heading, HEADING_ALPHA);

// // // //       const snapped = snapToRoad(smoothedCoord, flatLines);

// // // //       const use = snapped?.distM != null && snapped.distM <= SNAP_MAX_DIST_M
// // // //         ? { lat: snapped.lat, lng: snapped.lng }
// // // //         : smoothedCoord;

// // // //       last.set(id, { coord: use, heading: smoothedHeading });

// // // //       result.push({
// // // //         vehicleno: d.vehicleno,
// // // //         latitude: use.lat,
// // // //         longitude: use.lng,
// // // //         speed: d.speed,
// // // //         heading: smoothedHeading
// // // //       });
// // // //     }

// // // //     if (prevMapOpt) {
// // // //       for (const [id, b] of prevMapOpt) {
// // // //         if (list.find(x => x.vehicleno === id)) continue;
// // // //         const prev = last.get(id);
// // // //         if (!prev) {
// // // //           result.push(b);
// // // //           continue;
// // // //         }
// // // //         result.push({
// // // //           vehicleno: id,
// // // //           latitude: prev.coord.lat,
// // // //           longitude: prev.coord.lng,
// // // //           speed: b.speed,
// // // //           heading: prev.heading
// // // //         });
// // // //       }
// // // //     }

// // // //     return result;
// // // //   }

// // // //   // ---------------- Route geometry + ETA helpers ----------------
// // // //   const stopById = useMemo(() => Object.fromEntries(busStops.map(s => [s.id, s])), []);
// // // //   function routePolyline(ids) {
// // // //     return ids.map(id => ({ lat: stopById[id].lat, lng: stopById[id].lng }));
// // // //   }
// // // //   function cumDist(poly) {
// // // //     const out = [0];
// // // //     for (let i = 1; i < poly.length; i++) out.push(out[i - 1] + mBetween(poly[i - 1], poly[i]));
// // // //     return out;
// // // //   }
// // // //   const routeGeom = useMemo(() => {
// // // //     const g = {};
// // // //     for (const r of ROUTES) {
// // // //       const poly = routePolyline(r.ids);
// // // //       g[r.code] = { poly, cum: cumDist(poly), ids: r.ids };
// // // //     }
// // // //     return g;
// // // //   }, [stopById]);

// // // //   function projectOnRoute(pt, poly) {
// // // //     if (!poly || poly.length < 2) return null;
// // // //     let best = null;
// // // //     for (let i = 0; i < poly.length - 1; i++) {
// // // //       const seg = turf.lineString([[poly[i].lng, poly[i].lat], [poly[i + 1].lng, poly[i + 1].lat]]);
// // // //       const p = turf.nearestPointOnLine(seg, turf.point([pt.lng, pt.lat]), { units: "meters" });
// // // //       const d = p.properties?.dist ?? Infinity;
// // // //       if (!best || d < best.dist) {
// // // //         const [lng, lat] = p.geometry.coordinates;
// // // //         best = { idx: i, point: { lat, lng }, dist: d };
// // // //       }
// // // //     }
// // // //     return best;
// // // //   }

// // // //   function distanceAlong(poly, cum, proj, targetIndex) {
// // // //     const dHead = mBetween(proj.point, poly[proj.idx + 1]);
// // // //     const dTail = cum[targetIndex] - cum[proj.idx + 1];
// // // //     return dHead + Math.max(0, dTail);
// // // //   }

// // // //   // ---- ETA constants: match backend ----
// // // //   const AVG_SPEED_KMPH = 20;
// // // //   const AVG_SPEED_MPS = (AVG_SPEED_KMPH * 1000) / 3600;
// // // //   const WAIT_RADIUS_M = 25;         // within 25m of first stop
// // // //   const WAIT_SPEED_KMPH_MAX = 1.0;  // consider "waiting" if <= 1 km/h

// // // //   // Constant-speed ETA (20 km/h), ignoring live speed
// // // //   function etaFromMeters(distanceM) {
// // // //     const seconds = distanceM / AVG_SPEED_MPS;
// // // //     const minutes = Math.round(seconds / 60);
// // // //     return minutes < 0 || !Number.isFinite(minutes) ? 0 : minutes;
// // // //   }

// // // //   function nextStopIndex(routeIds, projIdx) {
// // // //     return Math.min(routeIds.length - 1, projIdx + 1);
// // // //   }

// // // //   // For a given bus, find nearest upcoming stop on its route + ETA
// // // //   function nearestStopEtaForBusOnItsRoute(bus) {
// // // //     const routeCode = assignments[bus.vehicleno];
// // // //     if (!routeCode) return null;
// // // //     const geom = routeGeom[routeCode];
// // // //     if (!geom || geom.poly.length < 2) return null;

// // // //     const pt = { lat: bus.latitude, lng: bus.longitude };
// // // //     const proj = projectOnRoute(pt, geom.poly);
// // // //     if (!proj) return null;

// // // //     const firstStopId = geom.ids[0];
// // // //     const firstStop = stopById[firstStopId];
// // // //     let waitingAtFirstStop = false;
// // // //     if (firstStop) {
// // // //       const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
// // // //       const speed = Number(bus.speed);
// // // //       if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
// // // //         waitingAtFirstStop = true;
// // // //       }
// // // //     }

// // // //     const nextIdx = nextStopIndex(geom.ids, proj.idx);
// // // //     const distanceM = distanceAlong(geom.poly, geom.cum, proj, nextIdx);

// // // //     let etaMin = undefined;
// // // //     if (!waitingAtFirstStop) {
// // // //       etaMin = etaFromMeters(distanceM);
// // // //     }

// // // //     return {
// // // //       stopId: geom.ids[nextIdx],
// // // //       distanceM,
// // // //       etaMin,
// // // //       routeCode,
// // // //       waitingAtFirstStop,
// // // //     };
// // // //   }

// // // //   // For a given stop, find the best incoming vehicle + ETA
// // // //   function nextArrivalAtStop(stopId) {
// // // //     const candidates = [];

// // // //     for (const bus of buses) {
// // // //       if (startsWithDigit(bus.vehicleno)) continue;
// // // //       const rc = assignments[bus.vehicleno];
// // // //       if (!rc) continue;
// // // //       const geom = routeGeom[rc];
// // // //       if (!geom) continue;

// // // //       const indexInRoute = geom.ids.indexOf(stopId);
// // // //       if (indexInRoute < 0) continue;

// // // //       const pt = { lat: bus.latitude, lng: bus.longitude };
// // // //       const proj = projectOnRoute(pt, geom.poly);
// // // //       if (!proj) continue;

// // // //       const targetIndex = Math.max(indexInRoute, proj.idx + 1);
// // // //       if (targetIndex >= geom.ids.length) continue;

// // // //       const distanceM = distanceAlong(geom.poly, geom.cum, proj, targetIndex);

// // // //       // If bus is already past this stop, skip
// // // //       if (distanceM < 0) continue;

// // // //       const firstStopId = geom.ids[0];
// // // //       const firstStop = stopById[firstStopId];
// // // //       let waitingAtFirstStop = false;
// // // //       if (firstStop) {
// // // //         const distToFirst = mBetween(pt, { lat: firstStop.lat, lng: firstStop.lng });
// // // //         const speed = Number(bus.speed);
// // // //         if (distToFirst <= WAIT_RADIUS_M && (!Number.isFinite(speed) || speed <= WAIT_SPEED_KMPH_MAX)) {
// // // //           waitingAtFirstStop = true;
// // // //         }
// // // //       }

// // // //       let etaMin = undefined;
// // // //       if (!waitingAtFirstStop) {
// // // //         etaMin = etaFromMeters(distanceM);
// // // //       }

// // // //       candidates.push({
// // // //         vehicle: bus.vehicleno,
// // // //         routeCode: rc,
// // // //         etaMin,
// // // //         waitingAtFirstStop,
// // // //         distanceM,
// // // //       });
// // // //     }

// // // //     if (!candidates.length) return null;

// // // //     // Prefer moving vehicles (etaMin != null), then fallback to closest waiting one
// // // //     const moving = candidates.filter(c => c.etaMin != null);
// // // //     if (moving.length) {
// // // //       return moving.reduce((a, b) => (a.etaMin <= b.etaMin ? a : b));
// // // //     }

// // // //     // All are waiting at first stop: pick closest along-route
// // // //     return candidates.reduce((a, b) => (a.distanceM <= b.distanceM ? a : b));
// // // //   }


// // // //   // ---- Derived lists ----
// // // //   const visibleBuses = buses.filter(b => !startsWithDigit(b.vehicleno));
// // // //   const filteredBuses = visibleBuses.filter(b => matchesFilter(b.vehicleno, filterType, assignments));

// // // //   // -------------- SCHEDULE UI helpers --------------
// // // //   const TABS = [
// // // //     { key: 'hostel-main', title: 'Hostel → Main Gate', data: HOSTEL_TO_MAIN, notes: HOSTEL_NOTES, fmt: 'ampm' },
// // // //     { key: 'main-hostel', title: 'Main Gate → Hostel', data: MAIN_TO_HOSTEL, notes: MAIN_NOTES, fmt: 'ampm' },
// // // //     { key: 'vg-main', title: 'Velachery Gate → Main Gate', data: VELACHERY_TO_MAIN, notes: VELACHERY_NOTES, fmt: 'ampm' },
// // // //     { key: 'vg-hostel', title: 'Velachery Gate → Hostel', data: VELACHERY_TO_HOSTEL, notes: VELACHERY_NOTES, fmt: 'ampm' },
// // // //     { key: 'rp-ed', title: 'Research Park → ED', data: RP_TO_ED_TIMES, notes: VELACHERY_NOTES, fmt: '24' },
// // // //     { key: 'ed-rp', title: 'ED → Research Park', data: ED_TO_RP_TIMES, notes: VELACHERY_NOTES, fmt: '24' }
// // // //   ];

// // // //   function TimeChip({ t }) {
// // // //     return (
// // // //       <div
// // // //         style={{
// // // //           padding: '10px 12px',
// // // //           borderRadius: 12,
// // // //           border: '1px solid #e2e8f0',
// // // //           background: '#fff',
// // // //           textAlign: 'center',
// // // //           fontWeight: 700,
// // // //           fontSize: clamp('12px', '2.8vw', '14px')
// // // //         }}
// // // //       >
// // // //         {t}
// // // //       </div>
// // // //     );
// // // //   }

// // // //   function CartTable({ rows, title }) {
// // // //     const th = { textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee', fontWeight: 700 };
// // // //     const td = { textAlign: 'left', padding: '8px', borderBottom: '1px solid #f2f2f2' };

// // // //     return (
// // // //       <div style={{ marginTop: 8 }}>
// // // //         <div style={{ fontWeight: 700, margin: '8px 0' }}>{title}</div>
// // // //         <div style={{ overflowX: 'auto' }}>
// // // //           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
// // // //             <thead>
// // // //               <tr>
// // // //                 <th style={th}>Cart</th>
// // // //                 <th style={th}>RP → ED</th>
// // // //                 <th style={th}>ED → RP</th>
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //               {rows.map(([Cart, a, b], i) => (
// // // //                 <tr key={`${Cart}-${i}`}>
// // // //                   <td style={td}>{Cart}</td>
// // // //                   <td style={td}>{a}</td>
// // // //                   <td style={td}>{b}</td>
// // // //                 </tr>
// // // //               ))}
// // // //             </tbody>
// // // //           </table>
// // // //         </div>
// // // //       </div>
// // // //     );
// // // //   }

// // // //   function ScheduleBody({ tab }) {
// // // //     if (tab.fmt === 'table-Cart') {
// // // //       const rows1 = Cart1.map(([a, b]) => ['Cart1', a, b]);
// // // //       const rows3 = Cart3.map(([a, b]) => ['Cart3', a, b]);
// // // //       return (
// // // //         <>
// // // //           <CartTable rows={rows1} title="Cart1" />
// // // //           <CartTable rows={rows3} title="Cart3" />
// // // //         </>
// // // //       );
// // // //     }
// // // //     if (tab.fmt === 'table-overall') {
// // // //       const all = [
// // // //         ...Cart1.map(([a, b]) => ['Cart1', a, b]),
// // // //         ...Cart3.map(([a, b]) => ['Cart3', a, b])
// // // //       ];
// // // //       return <CartTable rows={all} title="Overall" />;
// // // //     }

// // // //     const times = tab.data;
// // // //     return (
// // // //       <>
// // // //         <div
// // // //           style={{
// // // //             display: 'grid',
// // // //             gridTemplateColumns: isNarrow ? 'repeat(2, minmax(0, 1fr))' : 'repeat(auto-fit, minmax(140px, 1fr))',
// // // //             gap: 8
// // // //           }}
// // // //         >
// // // //           {times.map((t) => <TimeChip key={t} t={t} />)}
// // // //         </div>

// // // //         {tab.notes && tab.notes.length > 0 && (
// // // //           <div style={{ marginTop: 12 }}>
// // // //             {tab.notes.map((n) => (
// // // //               <div
// // // //                 key={n.time}
// // // //                 style={{
// // // //                   fontSize: 13,
// // // //                   background: '#fff8e1',
// // // //                   border: '1px solid #f0d48a',
// // // //                   padding: '6px 10px',
// // // //                   borderRadius: 10,
// // // //                   marginTop: 6
// // // //                 }}
// // // //               >
// // // //                 <strong>{n.time}</strong> – {n.note}
// // // //               </div>
// // // //             ))}
// // // //           </div>
// // // //         )}
// // // //       </>
// // // //     );
// // // //   }

// // // //   function ScheduleModal() {
// // // //     const tab = TABS[activeTab];
// // // //     const tabListRef = useRef(null);
// // // //     const tabScrollRef = useRef(0);

// // // //     useLayoutEffect(() => {
// // // //       const el = tabListRef.current;
// // // //       if (el && el.scrollLeft !== tabScrollRef.current) {
// // // //         el.scrollLeft = tabScrollRef.current;
// // // //       }
// // // //     });

// // // //     return (
// // // //       <div
// // // //         onClick={() => setShowSchedule(false)}
// // // //         style={{
// // // //           position: 'fixed',
// // // //           inset: 0,
// // // //           background: 'rgba(0,0,0,0.45)',
// // // //           zIndex: 99999,
// // // //           display: 'flex',
// // // //           alignItems: 'center',
// // // //           justifyContent: 'center',
// // // //           padding: 16
// // // //         }}
// // // //       >
// // // //         <div
// // // //           onClick={(e) => e.stopPropagation()}
// // // //           style={{
// // // //             position: 'relative',
// // // //             width: isNarrow ? '96vw' : 'min(1100px, 96vw)',
// // // //             maxHeight: '90dvh',
// // // //             background: '#ffffff',
// // // //             borderRadius: 16,
// // // //             boxShadow: '0 12px 30px rgba(0,0,0,0.3)',
// // // //             display: 'flex',
// // // //             flexDirection: 'column',
// // // //             overflow: 'hidden'
// // // //           }}
// // // //         >
// // // //           {/* Header */}
// // // //           <div
// // // //             style={{
// // // //               padding: isNarrow ? '8px 10px' : '12px 16px',
// // // //               borderBottom: '1px solid #eee',
// // // //               display: 'flex',
// // // //               alignItems: 'center',
// // // //               gap: 12
// // // //             }}
// // // //           >
// // // //             <img src={iitmLogo} alt="IIT Madras" style={{ width: isNarrow ? 26 : 32, height: isNarrow ? 26 : 32 }} />
// // // //             <div style={{ fontWeight: 800, fontSize: clamp('14px', '2.8vw', '18px') }}>
// // // //               IIT Madras – Campus Bus &amp; Cart Schedule
// // // //             </div>
// // // //             <button
// // // //               onClick={() => setShowSchedule(false)}
// // // //               style={{
// // // //                 marginLeft: 'auto',
// // // //                 border: 'none',
// // // //                 background: '#f4f4f5',
// // // //                 borderRadius: 999,
// // // //                 width: 34,
// // // //                 height: 34,
// // // //                 cursor: 'pointer',
// // // //                 fontSize: 16
// // // //               }}
// // // //               title="Close"
// // // //             >
// // // //               ✕
// // // //             </button>
// // // //           </div>

// // // //           {/* Tab bar */}
// // // //           <div
// // // //             ref={tabListRef}
// // // //             onScroll={(e) => { tabScrollRef.current = e.currentTarget.scrollLeft; }}
// // // //             style={{
// // // //               display: 'block',
// // // //               padding: '8px 12px',
// // // //               borderBottom: '1px solid #eee',
// // // //               overflowX: 'auto',
// // // //               overflowY: 'hidden',
// // // //               whiteSpace: 'nowrap',
// // // //               WebkitOverflowScrolling: 'touch',
// // // //               scrollbarWidth: 'thin',
// // // //               overscrollBehaviorX: 'contain',
// // // //               touchAction: 'pan-x'
// // // //             }}
// // // //           >
// // // //             <div style={{ display: 'inline-flex', gap: 8, minWidth: '100%', marginBottom: isNarrow ? '45px' : '18px' }}>
// // // //               {TABS.map((t, i) => (
// // // //                 <button
// // // //                   key={t.key}
// // // //                   onClick={() => setActiveTab(i)}
// // // //                   style={{
// // // //                     whiteSpace: 'nowrap',
// // // //                     padding: isNarrow ? '8px 10px' : '8px 12px',
// // // //                     borderRadius: 10,
// // // //                     border: i === activeTab ? '1px solid #0D47A1' : '1px solid #ddd',
// // // //                     background: i === activeTab ? '#eaf2ff' : '#ffffff',
// // // //                     fontWeight: 600,
// // // //                     cursor: 'pointer',
// // // //                     flex: '0 0 auto'
// // // //                   }}
// // // //                 >
// // // //                   {t.title}
// // // //                 </button>
// // // //               ))}
// // // //             </div>
// // // //           </div>

// // // //           {/* Body */}
// // // //           <div style={{ padding: isNarrow ? 8 : 12, overflow: 'auto' }}>
// // // //             <div style={{ fontWeight: 700, marginBottom: 8 }}>{tab.title}</div>
// // // //             <ScheduleBody tab={tab} />
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //     );
// // // //   }

// // // //   // Pause live updates when modal open; refresh once on close, then resume
// // // //   useEffect(() => {
// // // //     if (showSchedule) { ignoreUpdatesRef.current = true; return; }
// // // //     (async () => {
// // // //       try {
// // // //         if (!BACKEND) return;
// // // //         const res = await axios.get(`${BACKEND}/api/vehicle-data`, { timeout: 10000 });
// // // //         const arr = Array.isArray(res.data) ? res.data : [];
// // // //         const byVeh = new Map();
// // // //         for (const d of arr) {
// // // //           const heading = Number.isFinite(d?.heading) ? toHeading(d.heading) : toHeading(d?.direction);
// // // //           byVeh.set(d.vehicleno, {
// // // //             vehicleno: d.vehicleno,
// // // //             latitude: d.latitude,
// // // //             longitude: d.longitude,
// // // //             speed: d.speed,
// // // //             heading
// // // //           });
// // // //         }
// // // //         const list = [...byVeh.values()];
// // // //         setBuses(processVehicles(list));
// // // //         lastUpdateRef.current = Date.now();
// // // //       } catch (e) {
// // // //         console.warn('Refresh after modal close failed:', e?.message || e);
// // // //       } finally {
// // // //         ignoreUpdatesRef.current = false;
// // // //       }
// // // //     })();
// // // //   }, [showSchedule]);

// // // //   // Responsive stop icons (smaller on phones)
// // // //   const stopIconInstance = useMemo(
// // // //     () => createCustomIcon(stopIconImg, isNarrow ? [40, 40] : [50, 50]),
// // // //     [isNarrow]
// // // //   );

// // // //   // --------------------------- RENDER ---------------------------
// // // //   return (
// // // //     <div className="map-container">
// // // //       {/* Header */}
// // // //       {/* <div
// // // //         style={{
// // // //           position: 'fixed',
// // // //           top: 'max(8px, env(safe-area-inset-top))',
// // // //           left: '50%',
// // // //           transform: 'translateX(-50%)',
// // // //           zIndex: 10000,
// // // //           background: '#ffffff',
// // // //           border: '1px solid #e6e6e7',
// // // //           borderRadius: 16,
// // // //           padding: pad,
// // // //           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
// // // //           width: isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))',
// // // //           backdropFilter: 'blur(2px)'
// // // //         }}
// // // //       > */}
// // // //       <div
// // // //         style={{
// // // //           position: 'fixed',
// // // //           top: 'max(8px, env(safe-area-inset-top))',
// // // //           left: '50%',
// // // //           transform: 'translateX(-50%)',
// // // //           zIndex: 10000,
// // // //           background: '#ffffff',
// // // //           border: '1px solid #e6e6e7',
// // // //           borderRadius: 16,
// // // //           padding: isHeaderCollapsed ? (isNarrow ? 8 : 10) : pad,
// // // //           boxShadow: '0 18px 40px rgba(0,0,0,0.25)',
// // // //           width: isHeaderCollapsed
// // // //             ? (isNarrow ? 'calc(100vw - 16px)' : 'min(420px, calc(100vw - 32px))')
// // // //             : (isNarrow ? 'calc(100vw - 16px)' : 'min(560px, calc(100vw - 32px))'),
// // // //           backdropFilter: 'blur(2px)',
// // // //           transition: 'width 180ms ease, padding 180ms ease'
// // // //         }}
// // // //       >
// // // //         {/* Title row */}
// // // //         {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
// // // //           <img src={iitmLogo} alt="IIT Madras" style={{ width: isNarrow ? 28 : 36, height: isNarrow ? 28 : 36 }} />
// // // //           <h2
// // // //             style={{
// // // //               margin: 0,
// // // //               fontSize: clamp('18px','3.2vw','28px'),
// // // //               lineHeight: 1.1,
// // // //               letterSpacing: 0.3,
// // // //               fontWeight: 800
// // // //             }}
// // // //           >
// // // //             Thoothukudi Bus Tracking
// // // //           </h2>
// // // //           <a href="/admin" style={{ marginLeft: 'auto', fontWeight: 700 }}>Admin ↗</a>
// // // //         </div> */}

// // // //         {/* Title row */}
// // // //         <div style={{ display: 'flex', alignItems: 'center', gap: isNarrow ? 8 : 12 }}>
// // // //           <img
// // // //             src={iitmLogo}
// // // //             alt="IIT Madras"
// // // //             style={{
// // // //               width: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
// // // //               height: isHeaderCollapsed ? 26 : (isNarrow ? 28 : 36),
// // // //               flex: '0 0 auto'
// // // //             }}
// // // //           />

// // // //           <h2
// // // //             style={{
// // // //               margin: 0,
// // // //               fontSize: isHeaderCollapsed
// // // //                 ? clamp('15px', '3vw', '20px')
// // // //                 : clamp('18px', '3.2vw', '28px'),
// // // //               lineHeight: 1.1,
// // // //               letterSpacing: 0.3,
// // // //               fontWeight: 800,
// // // //               whiteSpace: 'nowrap',
// // // //               overflow: 'hidden',
// // // //               textOverflow: 'ellipsis',
// // // //               flex: 1
// // // //             }}
// // // //           >
// // // //             Thoothukudi Bus Tracking
// // // //           </h2>

// // // //           {isHeaderCollapsed && (
// // // //             <div
// // // //               style={{
// // // //                 fontSize: isNarrow ? 12 : 13,
// // // //                 fontWeight: 800,
// // // //                 color: '#111827',
// // // //                 whiteSpace: 'nowrap'
// // // //               }}
// // // //               title="Visible vehicles / total vehicles"
// // // //             >
// // // //               {filteredBuses.length}/{buses.length}
// // // //             </div>
// // // //           )}

// // // //           {!isHeaderCollapsed && (
// // // //             <a
// // // //               href="/admin"
// // // //               style={{
// // // //                 fontWeight: 700,
// // // //                 whiteSpace: 'nowrap'
// // // //               }}
// // // //             >
// // // //               Admin ↗
// // // //             </a>
// // // //           )}

// // // //           <button
// // // //             type="button"
// // // //             onClick={() => setIsHeaderCollapsed((v) => !v)}
// // // //             aria-label={isHeaderCollapsed ? 'Expand header' : 'Collapse header'}
// // // //             title={isHeaderCollapsed ? 'Expand' : 'Collapse'}
// // // //             style={{
// // // //               border: '1px solid #D1D5DB',
// // // //               background: '#ffffff',
// // // //               color: '#111827',
// // // //               borderRadius: 10,
// // // //               padding: isNarrow ? '6px 8px' : '7px 10px',
// // // //               fontWeight: 800,
// // // //               fontSize: isNarrow ? 13 : 14,
// // // //               lineHeight: 1,
// // // //               cursor: 'pointer',
// // // //               minWidth: isNarrow ? 34 : 38,
// // // //               minHeight: isNarrow ? 32 : 36
// // // //             }}
// // // //           >
// // // //             {isHeaderCollapsed ? '▾' : '▴'}
// // // //           </button>
// // // //         </div>

// // // //         {!isHeaderCollapsed && (
// // // //           <>

// // // //             {/* Status row */}
// // // //             <div
// // // //               style={{
// // // //                 display: 'flex',
// // // //                 alignItems: 'center',
// // // //                 justifyContent: 'space-between',
// // // //                 marginTop: 10,
// // // //                 gap: 12,
// // // //                 flexWrap: 'wrap'
// // // //               }}
// // // //             >
// // // //               <span
// // // //                 style={{
// // // //                   display: 'inline-block',
// // // //                   padding: '4px 10px',
// // // //                   borderRadius: 999,
// // // //                   fontSize: chipFS,
// // // //                   fontWeight: 700,
// // // //                   background:
// // // //                     socketStatus === 'connected'
// // // //                       ? '#E9F9EE'
// // // //                       : socketStatus === 'connecting'
// // // //                         ? '#FFF7E1'
// // // //                         : '#FFECEC',
// // // //                   color:
// // // //                     socketStatus === 'connected'
// // // //                       ? '#0A7A2A'
// // // //                       : socketStatus === 'connecting'
// // // //                         ? '#7A5D00'
// // // //                         : '#B00020',
// // // //                   border:
// // // //                     socketStatus === 'connected'
// // // //                       ? '1px solid #C6EBD1'
// // // //                       : socketStatus === 'connecting'
// // // //                         ? '1px solid #F4E3B0'
// // // //                         : '1px solid #FFD0D0',
// // // //                   textTransform: 'lowercase'
// // // //                 }}
// // // //                 title={`Socket: ${socketStatus}`}
// // // //               >
// // // //                 {socketStatus}
// // // //               </span>

// // // //               <div
// // // //                 style={{
// // // //                   fontSize: clamp('14px', '2.6vw', '18px'),
// // // //                   fontWeight: 700,
// // // //                   letterSpacing: 0.5,
// // // //                   color: '#111827'
// // // //                 }}
// // // //               >
// // // //                 {filteredBuses.length} / {buses.length}
// // // //               </div>
// // // //             </div>

// // // //             {/* Controls row */}
// // // //             <div
// // // //               style={{
// // // //                 display: 'flex',
// // // //                 alignItems: 'center',
// // // //                 gap: gap,
// // // //                 marginTop: gap,
// // // //                 flexWrap: 'wrap'
// // // //               }}
// // // //             >
// // // //               <div style={{ position: 'relative', flex: '1 1 200px' }}>
// // // //                 <select
// // // //                   value={filterType}
// // // //                   onChange={(e) => setFilterType(e.target.value)}
// // // //                   title="Filter vehicles"
// // // //                   style={{
// // // //                     width: '100%',
// // // //                     padding: isNarrow ? '10px 34px 10px 12px' : '10px 40px 10px 14px',
// // // //                     borderRadius: 10,
// // // //                     border: '1px solid #D1D5DB',
// // // //                     background: '#FFFFFF',
// // // //                     fontWeight: 600,
// // // //                     cursor: 'pointer',
// // // //                     appearance: 'none',
// // // //                     WebkitAppearance: 'none',
// // // //                     MozAppearance: 'none'
// // // //                   }}
// // // //                 >
// // // //                   <option value="all">All Vehicles</option>
// // // //                   {/* <option value="cart">Cart</option> */}
// // // //                   {/* <option value="bus">Bus</option> */}
// // // //                   <optgroup label="Filter by Route">
// // // //                     {ROUTES.map(r => (
// // // //                       <option key={r.code} value={`route:${r.code}`}>{r.label}</option>
// // // //                     ))}
// // // //                   </optgroup>
// // // //                 </select>

// // // //                 <div
// // // //                   style={{
// // // //                     position: 'absolute',
// // // //                     right: isNarrow ? 8 : 12,
// // // //                     top: '50%',
// // // //                     transform: 'translateY(-50%)',
// // // //                     width: 0,
// // // //                     height: 0,
// // // //                     borderLeft: '6px solid transparent',
// // // //                     borderRight: '6px solid transparent',
// // // //                     borderTop: '7px solid #111',
// // // //                     pointerEvents: 'none'
// // // //                   }}
// // // //                 />
// // // //               </div>

// // // //               <button
// // // //                 // onClick={() => window.location.reload()}
// // // //                 // onClick={() => {
// // // //                 //   requestUserLocation(); // ✅ recenter on refresh button click
// // // //                 // }}

// // // //                 // title="Reload the page"
// // // //                 onClick={() => {
// // // //                   requestUserLocation();          // ✅ recenter
// // // //                   setTimeout(() => {
// // // //                     window.location.reload();     // ✅ full reload
// // // //                   }, 150);
// // // //                 }}
// // // //                 title="Recenter + Reload"
// // // //                 style={{
// // // //                   padding: '10px 14px',
// // // //                   borderRadius: 10,
// // // //                   border: '1px solid #D1D5DB',
// // // //                   background: '#FFFFFF',
// // // //                   fontWeight: 700,
// // // //                   cursor: 'pointer',
// // // //                   minHeight: isNarrow ? 36 : 40,
// // // //                   fontSize: clamp('13px', '2.8vw', '14px')
// // // //                 }}
// // // //               >
// // // //                 Refresh
// // // //               </button>

// // // //               {/* <button
// // // //             onClick={() => setShowSchedule(true)}
// // // //             title="Show schedule"
// // // //             style={{
// // // //               padding: '10px 16px',
// // // //               borderRadius: 10,
// // // //               border: '1px solid #0D47A1',
// // // //               background: '#0D47A1',
// // // //               color: '#FFFFFF',
// // // //               fontWeight: 800,
// // // //               cursor: 'pointer',
// // // //               boxShadow: '0 6px 16px rgba(13,71,161,0.25)',
// // // //               minHeight: isNarrow ? 36 : 40,
// // // //               fontSize: clamp('13px','2.8vw','14px')
// // // //             }}
// // // //           >
// // // //             Schedule
// // // //           </button> */}
// // // //             </div>

// // // //             {maintenance && (
// // // //               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#fff8e1', border: '1px solid #f0d48a', fontWeight: 600 }}>
// // // //                 Under maintenance — {maintenanceReason}
// // // //               </div>
// // // //             )}

// // // //             {/* {locError && (
// // // //         <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
// // // //           {locError}
// // // //           <button
// // // //             onClick={requestUserLocation}
// // // //             style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
// // // //           >
// // // //             Allow location
// // // //           </button>
// // // //         </div>
// // // //         )} */}

// // // //             {locError && (
// // // //               <div style={{ marginTop: 8, padding: 8, borderRadius: 10, background: '#FFECEC', border: '1px solid #FFD0D0', fontWeight: 600 }}>
// // // //                 {locError}

// // // //                 <button
// // // //                   type="button"
// // // //                   onClick={requestUserLocation}
// // // //                   style={{ marginLeft: 10, padding: '6px 10px', borderRadius: 10, border: '1px solid #D1D5DB', background: '#fff', fontWeight: 700, cursor: 'pointer' }}
// // // //                   title={geoState === "denied" ? "Enable in site settings first, then try again" : "Try again"}
// // // //                 >
// // // //                   {geoState === "denied" ? "Open site settings" : "Allow location"}
// // // //                 </button>
// // // //               </div>
// // // //             )}
// // // //           </>
// // // //         )}
// // // //       </div>


// // // //       {/* Schedule Modal */}
// // // //       {showSchedule && <ScheduleModal />}

// // // //       {/* Map uses dynamic viewport on mobile (100dvh) */}
// // // //       {/* <MapContainer center={center} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}> */}
// // // //       <MapContainer center={mapCenter} zoom={DEFAULT_ZOOM} maxZoom={22} style={{ width: '100vw', height: '100dvh' }}>
// // // //         <RecenterMap center={mapCenter} zoom={DEFAULT_ZOOM} />

// // // //         <TileLayer
// // // //           attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
// // // //           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// // // //           maxNativeZoom={19}
// // // //           maxZoom={22}
// // // //         />

// // // //         {userLocation && (
// // // //           <Marker position={{ lat: userLocation.lat, lng: userLocation.lng }} icon={userIconInstance}>
// // // //             <Popup>
// // // //               <div className="info-window">
// // // //                 <h4>You are here</h4>
// // // //               </div>
// // // //             </Popup>
// // // //           </Marker>
// // // //         )}
// // // //         {/* here i have updated the backend eta */}
// // // //         {/* Bus Stops with backend ETA (polled every 5s) */}
// // // //         {busStops.map((stop) => {
// // // //           const etaState = stopEtas[stop.id];           // { data, error } or undefined
// // // //           const payload = etaState?.data;               // backend JSON
// // // //           const next = payload?.next || null;           // { vehicle, goingTowards, etaMinutes } | null

// // // //           return (
// // // //             <Marker
// // // //               key={stop.id}
// // // //               position={{ lat: stop.lat, lng: stop.lng }}
// // // //               icon={stopIconInstance}
// // // //             >
// // // //               <Popup>
// // // //                 <div className="info-window">
// // // //                   <h4>{stop.name}</h4>

// // // //                   {/* 1) Still loading / first poll */}
// // // //                   {!etaState && <p>Loading ETA…</p>}

// // // //                   {/* 2) Request for this stop failed */}
// // // //                   {etaState && !payload && <p>ETA not available.</p>}

// // // //                   {/* 3) Backend says: no approaching assignment */}
// // // //                   {payload && payload.success && !next && (
// // // //                     <p>No assigned vehicle approaching.</p>
// // // //                   )}

// // // //                   {/* 4) We have a next arrival from backend */}
// // // //                   {payload && payload.success && next && (
// // // //                     <>
// // // //                       {/* You said you may not need vehicle number/type, 
// // // //                           so we only show direction + ETA. */}
// // // //                       <p>
// // // //                         Next Vehicle Details:
// // // //                       </p>
// // // //                       {next.vehicle && (
// // // //                         <p>
// // // //                           <strong>Vehicle Type:</strong> {next.vehicle}
// // // //                         </p>
// // // //                       )}
// // // //                       {next.goingTowards && (
// // // //                         <p>
// // // //                           <strong>Direction:</strong> {next.goingTowards}
// // // //                         </p>
// // // //                       )}
// // // //                       <p>
// // // //                         <strong>ETA:</strong>{" "}
// // // //                         {next.etaMinutes != null
// // // //                           ? `${next.etaMinutes} min`
// // // //                           : "— (has not departed yet)"}
// // // //                       </p>
// // // //                     </>
// // // //                   )}
// // // //                 </div>
// // // //               </Popup>
// // // //             </Marker>
// // // //           );
// // // //         })}



// // // //         {/* Vehicles */}
// // // //         {filteredBuses.map((bus) => {
// // // //           // const label = vehicleLabel(bus.vehicleno);
// // // //           const rc = assignments[bus.vehicleno];
// // // //           const label = vehicleLabel(bus.vehicleno, rc);
// // // //           const palette = isCart(bus.vehicleno) ? CART_PALETTE : BUS_PALETTE;
// // // //           const info = nearestStopEtaForBusOnItsRoute(bus);
// // // //           // const nearestName = info ? (busStops.find(s => s.id === info.stopId)?.name) : null;
// // // //           // const eta = info ? `${info.etaMin} min` : 'Unknown';
// // // //           const nearestName = info ? (busStops.find(s => s.id === info.stopId)?.name) : null;
// // // //           const eta =
// // // //             info && info.etaMin != null
// // // //               ? `${info.etaMin} min`
// // // //               : info
// // // //                 ? "—"
// // // //                 : "Unknown";

// // // //           return (
// // // //             <Marker
// // // //               key={bus.vehicleno}
// // // //               position={{ lat: bus.latitude, lng: bus.longitude }}
// // // //               // icon={createVehicleDivIcon(label, bus.heading)}
// // // //               icon={createVehicleDivIcon(label, bus.heading, palette)}

// // // //             >
// // // //               <Popup>
// // // //                 <div className="info-window">
// // // //                   <h4>{bus.vehicleno} ({label})</h4>
// // // //                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart</p> */}
// // // //                   {/* <p><strong>Legend:</strong> B = Bus, C = Cart, CR = Cart (RP↔ED)</p> */}
// // // //                   <p><strong>Speed:</strong> {Number.isFinite(bus.speed) ? bus.speed.toFixed(1) : 'N/A'} km/h</p>
// // // //                   {assignments[bus.vehicleno] && (
// // // //                     <p><strong>Route:</strong> {ROUTES.find(r => r.code === assignments[bus.vehicleno])?.label || assignments[bus.vehicleno]}</p>
// // // //                   )}
// // // //                   {nearestName && <p><strong>Next Stop:</strong> {nearestName}</p>}
// // // //                   {/* <p><strong>ETA:</strong> {eta}</p> */}
// // // //                   {/* <p>
// // // //                     <strong>ETA:</strong>{" "}
// // // //                     {eta}
// // // //                     {info && info.waitingAtFirstStop ? " (has not departed yet)" : ""}
// // // //                   </p> */}
// // // //                   {Number.isFinite(bus.heading) && <p><strong>Heading:</strong> {Math.round(bus.heading)}°</p>}
// // // //                 </div>
// // // //               </Popup>
// // // //             </Marker>
// // // //           );
// // // //         })}
// // // //       </MapContainer>

// // // //       {/* Footer: Feedback link */}
// // // //       <div
// // // //         style={{
// // // //           position: 'fixed',
// // // //           left: 0,
// // // //           right: 0,
// // // //           bottom: -5,
// // // //           display: 'flex',
// // // //           justifyContent: 'center',
// // // //           zIndex: 10000,
// // // //           pointerEvents: 'none',
// // // //           paddingBottom: 'max(6px, env(safe-area-inset-bottom))'
// // // //         }}
// // // //       >
// // // //         <div
// // // //           style={{
// // // //             width: '100vw',
// // // //             pointerEvents: 'auto',
// // // //             display: 'flex',
// // // //             alignItems: 'center',
// // // //             justifyContent: 'space-between',
// // // //             gap: 12,
// // // //             padding: isNarrow ? '6px 10px' : '6px 16px',
// // // //             borderRadius: 14,
// // // //             background:
// // // //               'linear-gradient(135deg, rgba(17,24,39,0.85), rgba(31,41,55,0.85))',
// // // //             color: '#F9FAFB',
// // // //             border: '1px solid rgba(255,255,255,0.14)',
// // // //             boxShadow:
// // // //               '0 12px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.06)',
// // // //             backdropFilter: 'saturate(160%) blur(10px)',
// // // //             WebkitBackdropFilter: 'saturate(160%) blur(10px)',
// // // //             fontFamily:
// // // //               '"SF Pro Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"',
// // // //             fontSize: clamp('12px', '2.8vw', '14px'),
// // // //             lineHeight: 1.4,
// // // //             fontWeight: 500,
// // // //             letterSpacing: '0.2px',
// // // //           }}
// // // //         >
// // // //           <div
// // // //             style={{
// // // //               display: 'flex',
// // // //               alignItems: 'center',
// // // //               gap: 10,
// // // //               flex: 1,
// // // //               minWidth: 0,
// // // //             }}
// // // //           >
// // // //             <div
// // // //               style={{
// // // //                 width: 8,
// // // //                 height: 8,
// // // //                 borderRadius: 9999,
// // // //                 background:
// // // //                   'radial-gradient(circle at 30% 30%, #34D399, #059669)',
// // // //                 boxShadow: '0 0 0 3px rgba(16,185,129,0.25)',
// // // //                 flex: '0 0 auto',
// // // //               }}
// // // //             />
// // // //             <span
// // // //               style={{
// // // //                 opacity: 0.95,
// // // //                 whiteSpace: 'nowrap',
// // // //                 overflow: 'hidden',
// // // //                 textOverflow: 'ellipsis',
// // // //               }}
// // // //             >
// // // //               MInT Lab | IIT Madras | UkPact
// // // //             </span>
// // // //           </div>

// // // //           {FEEDBACK_URL ? (
// // // //             <a
// // // //               href={FEEDBACK_URL}
// // // //               target="_blank"
// // // //               rel="noreferrer"
// // // //               style={{
// // // //                 display: 'inline-flex',
// // // //                 alignItems: 'center',
// // // //                 justifyContent: 'center',
// // // //                 padding: '8px 12px',
// // // //                 borderRadius: 10,
// // // //                 border: '1px solid rgba(255,255,255,0.18)',
// // // //                 background:
// // // //                   'linear-gradient(180deg, rgba(128, 126, 126, 0.14), rgba(221, 212, 212, 0.06))',
// // // //                 color: '#F9FAFB',
// // // //                 textDecoration: 'none',
// // // //                 fontWeight: 600,
// // // //                 letterSpacing: '0.25px',
// // // //                 transform: 'translateZ(0)',
// // // //                 transition: 'transform 120ms ease, opacity 120ms ease',
// // // //                 cursor: 'pointer',
// // // //                 boxShadow:
// // // //                   'inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 14px rgba(0,0,0,0.25)',
// // // //               }}
// // // //               onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-1px)')}
// // // //               onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
// // // //             >
// // // //               Open feedback form ↗
// // // //             </a>
// // // //           ) : (
// // // //             <span
// // // //               style={{
// // // //                 padding: '8px 12px',
// // // //                 borderRadius: 10,
// // // //                 border: '1px dashed rgba(255,255,255,0.25)',
// // // //                 color: 'rgba(249,250,251,0.8)',
// // // //                 fontWeight: 500,
// // // //               }}
// // // //             >
// // // //               &lt;form-link&gt;
// // // //             </span>
// // // //           )}
// // // //         </div>
// // // //       </div>

// // // //     </div>
// // // //   );
// // // // }

// // // // /* ---------------------------- HOME PAGE ---------------------------- */

// // // // const AIR_QUALITY_URL = "https://main.d2yil9slaoehou.amplifyapp.com/";

// // // // function HomePage({ navigate }) {
// // // //   const cards = [
// // // //     {
// // // //       title: "Bus Tracking",
// // // //       subtitle: "Live vehicle location using WebSocket",
// // // //       path: "/tracking",
// // // //       icon: "🚌",
// // // //       type: "internal",
// // // //     },
// // // //     {
// // // //       title: "Air Quality Sensor",
// // // //       subtitle: "View live air quality monitoring dashboard",
// // // //       url: AIR_QUALITY_URL,
// // // //       icon: "🌫️",
// // // //       type: "external",
// // // //     },
// // // //     {
// // // //       title: "Camera Data",
// // // //       subtitle: "Vehicle count analytics from camera feed",
// // // //       path: "/camera",
// // // //       icon: "📷",
// // // //       type: "internal",
// // // //     },
// // // //   ];

// // // //   // const openCard = (card) => {
// // // //   //   if (card.type === "external") {
// // // //   //     window.location.href = card.url;
// // // //   //     return;
// // // //   //   }
// // // //   //   navigate(card.path);
// // // //   // };

// // // //   const openCard = (card) => {
// // // //   if (card.type === "external") {
// // // //     window.open(card.url, "_blank", "noopener,noreferrer");
// // // //     return;
// // // //   }

// // // //   window.open(card.path, "_blank", "noopener,noreferrer");
// // // // };

// // // //   return (
// // // //     <div className="home-page">
// // // //       <div className="home-bg-glow home-bg-glow-one" />
// // // //       <div className="home-bg-glow home-bg-glow-two" />

// // // //       <header className="home-navbar">
// // // // <div className="home-brand">
// // // //   <img
// // // //     src={iitmLogo}
// // // //     alt="MInT Lab Logo"
// // // //     className="home-brand-logo-img"
// // // //   />

// // // //   <div className="home-brand-text">
// // // //     <div className="home-brand-title">MInT Collaborative</div>
// // // //     <div className="home-brand-subtitle">IIT Madras | UKPACT</div>
// // // //   </div>
// // // // </div>

// // // //         <button className="home-nav-button" onClick={() => navigate("/tracking")}>
// // // //           Open Tracking
// // // //         </button>
// // // //       </header>

// // // //       <main className="home-main">
// // // //         <section className="home-hero">
// // // //           <div className="home-pill">Smart Mobility Dashboard</div>

// // // //           <h1>
// // // //             Real-time Transport, Sensor <br />
// // // //             and Camera Intelligence
// // // //           </h1>

// // // //           <p>
// // // //             A single access point for bus tracking, air quality monitoring,
// // // //             and vehicle count analytics.
// // // //           </p>
// // // //         </section>

// // // //         <section className="home-card-grid">
// // // //           {cards.map((card) => (
// // // //             <button
// // // //               key={card.title}
// // // //               className="home-feature-card"
// // // //               onClick={() => openCard(card)}
// // // //             >
// // // //               <div className="home-card-icon">{card.icon}</div>

// // // //               <div className="home-card-content">
// // // //                 <h2>{card.title}</h2>
// // // //                 <p>{card.subtitle}</p>
// // // //               </div>

// // // //               <div className="home-card-arrow">
// // // //                 {card.type === "external" ? "↗" : "→"}
// // // //               </div>
// // // //             </button>
// // // //           ))}
// // // //         </section>
// // // //       </main>
// // // //     </div>
// // // //   );
// // // // }


// // // // /* ---------------------------- CAMERA DATA PAGE ---------------------------- */

// // // // const CAMERA_FALLBACK_DATA = [
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:06",
// // // //     auto: 0,
// // // //     motorbike: 0,
// // // //     bus: 0,
// // // //     car: 0,
// // // //     truck: 0,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:11",
// // // //     auto: 0,
// // // //     motorbike: 4,
// // // //     bus: 1,
// // // //     car: 4,
// // // //     truck: 0,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:16",
// // // //     auto: 0,
// // // //     motorbike: 2,
// // // //     bus: 0,
// // // //     car: 0,
// // // //     truck: 1,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:21",
// // // //     auto: 0,
// // // //     motorbike: 1,
// // // //     bus: 0,
// // // //     car: 1,
// // // //     truck: 1,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:26",
// // // //     auto: 0,
// // // //     motorbike: 3,
// // // //     bus: 0,
// // // //     car: 0,
// // // //     truck: 0,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:31",
// // // //     auto: 0,
// // // //     motorbike: 0,
// // // //     bus: 0,
// // // //     car: 0,
// // // //     truck: 0,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:36",
// // // //     auto: 0,
// // // //     motorbike: 5,
// // // //     bus: 0,
// // // //     car: 1,
// // // //     truck: 1,
// // // //   },
// // // //   {
// // // //     timestamp: "2025-11-01 00:00:41",
// // // //     auto: 0,
// // // //     motorbike: 4,
// // // //     bus: 1,
// // // //     car: 5,
// // // //     truck: 1,
// // // //   },
// // // // ];

// // // // // function parseCameraCsv(csvText) {
// // // // //   const lines = csvText
// // // // //     .trim()
// // // // //     .split(/\r?\n/)
// // // // //     .filter(Boolean);

// // // // //   if (lines.length < 2) return [];

// // // // //   const headers = lines[0].split(",").map((h) => h.trim());

// // // // //   return lines.slice(1).map((line) => {
// // // // //     const values = line.split(",").map((v) => v.trim());
// // // // //     const row = {};

// // // // //     headers.forEach((header, index) => {
// // // // //       if (header === "timestamp") {
// // // // //         row[header] = values[index];
// // // // //       } else {
// // // // //         row[header] = Number(values[index] || 0);
// // // // //       }
// // // // //     });

// // // // //     return row;
// // // // //   });
// // // // // }

// // // // const CAMERA_LOCATIONS = [
// // // //   {
// // // //     id: "camera-site-1",
// // // //     sno: 1,
// // // //     place: "Ettayapuram Rd",
// // // //     location: "Perison Plaza Signal",
// // // //     boxes: 2,
// // // //     cameras: 2,
// // // //     lat: 8.81277,
// // // //     lng: 78.13647,
// // // //   },
// // // //   {
// // // //     id: "camera-site-2",
// // // //     sno: 2,
// // // //     place: "4th Gate",
// // // //     location: "South side of Milavittan Road",
// // // //     boxes: 1,
// // // //     cameras: 1,
// // // //     lat: 8.80967,
// // // //     lng: 78.1335,
// // // //   },
// // // //   {
// // // //     id: "camera-site-3",
// // // //     sno: 3,
// // // //     place: "International Furniture Park",
// // // //     location: "Madurai - Tiruchendur Rd highway east side",
// // // //     boxes: 1,
// // // //     cameras: 1,
// // // //     lat: 8.81624,
// // // //     lng: 78.08118,
// // // //   },
// // // //   {
// // // //     id: "camera-site-4",
// // // //     sno: 4,
// // // //     place: "3rd Mile",
// // // //     location: "Near TVL-TUT-MDR Bypass Bridge",
// // // //     boxes: 2,
// // // //     cameras: 2,
// // // //     lat: 8.789608,
// // // //     lng: 78.11493,
// // // //   },
// // // //   {
// // // //     id: "camera-site-5",
// // // //     sno: 5,
// // // //     place: "Alageshapuram Road",
// // // //     location: "Roundana near St. Thomas School",
// // // //     boxes: 1,
// // // //     cameras: 2,
// // // //     lat: 8.81705,
// // // //     lng: 78.14797,
// // // //   },
// // // //   {
// // // //     id: "camera-site-6",
// // // //     sno: 6,
// // // //     place: "Tiruchendur Rd",
// // // //     location: "Muthiahpuram",
// // // //     boxes: 1,
// // // //     cameras: 1,
// // // //     lat: 8.74541,
// // // //     lng: 78.1253,
// // // //   },
// // // // ];

// // // // const VEHICLE_TYPES = ["auto", "motorbike", "bus", "car", "truck"];

// // // // function parseCameraCsv(csvText) {
// // // //   const lines = csvText
// // // //     .trim()
// // // //     .split(/\r?\n/)
// // // //     .filter(Boolean);

// // // //   if (lines.length < 2) return [];

// // // //   const firstLine = lines[0].toLowerCase();
// // // //   const hasHeader = firstLine.includes("timestamp");

// // // //   const headers = hasHeader
// // // //     ? lines[0].split(",").map((h) => h.trim().toLowerCase())
// // // //     : ["timestamp", "auto", "motorbike", "bus", "car", "truck"];

// // // //   const dataLines = hasHeader ? lines.slice(1) : lines;

// // // //   return dataLines.map((line) => {
// // // //     const values = line.split(",").map((v) => v.trim());
// // // //     const row = {};

// // // //     headers.forEach((header, index) => {
// // // //       if (header === "timestamp") {
// // // //         row.timestamp = values[index] || "";
// // // //       } else if (
// // // //         header === "cameraid" ||
// // // //         header === "camera_id" ||
// // // //         header === "camera" ||
// // // //         header === "site"
// // // //       ) {
// // // //         row.cameraId = values[index] || "";
// // // //       } else if (header === "direction") {
// // // //         row.direction = values[index] || "All Directions";
// // // //       } else {
// // // //         row[header] = Number(values[index] || 0);
// // // //       }
// // // //     });

// // // //     return {
// // // //       timestamp: row.timestamp || "",
// // // //       cameraId: row.cameraId || "ALL",
// // // //       direction: row.direction || "All Directions",
// // // //       auto: Number(row.auto || 0),
// // // //       motorbike: Number(row.motorbike || 0),
// // // //       bus: Number(row.bus || 0),
// // // //       car: Number(row.car || 0),
// // // //       truck: Number(row.truck || 0),
// // // //     };
// // // //   });
// // // // }

// // // // function sumRows(rows) {
// // // //   return rows.reduce(
// // // //     (acc, row) => {
// // // //       acc.auto += Number(row.auto || 0);
// // // //       acc.motorbike += Number(row.motorbike || 0);
// // // //       acc.bus += Number(row.bus || 0);
// // // //       acc.car += Number(row.car || 0);
// // // //       acc.truck += Number(row.truck || 0);
// // // //       return acc;
// // // //     },
// // // //     { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // // //   );
// // // // }

// // // // function totalFromCounts(counts) {
// // // //   return VEHICLE_TYPES.reduce((sum, type) => sum + Number(counts[type] || 0), 0);
// // // // }

// // // // function getDateKey(timestamp) {
// // // //   return String(timestamp || "").slice(0, 10);
// // // // }

// // // // function getWeekKey(timestamp) {
// // // //   const datePart = getDateKey(timestamp);
// // // //   if (!datePart) return "Unknown";

// // // //   const date = new Date(`${datePart}T00:00:00`);
// // // //   if (Number.isNaN(date.getTime())) return "Unknown";

// // // //   const firstDay = new Date(date.getFullYear(), 0, 1);
// // // //   const dayNumber = Math.floor((date - firstDay) / 86400000) + 1;
// // // //   const weekNumber = Math.ceil(dayNumber / 7);

// // // //   return `${date.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;
// // // // }

// // // // function buildChartData(rows, mode = "daily") {
// // // //   const grouped = {};

// // // //   rows.forEach((row) => {
// // // //     const key = mode === "weekly" ? getWeekKey(row.timestamp) : getDateKey(row.timestamp);
// // // //     if (!key) return;

// // // //     if (!grouped[key]) {
// // // //       grouped[key] = {
// // // //         label: key,
// // // //         auto: 0,
// // // //         motorbike: 0,
// // // //         bus: 0,
// // // //         car: 0,
// // // //         truck: 0,
// // // //       };
// // // //     }

// // // //     VEHICLE_TYPES.forEach((type) => {
// // // //       grouped[key][type] += Number(row[type] || 0);
// // // //     });
// // // //   });

// // // //   return Object.values(grouped)
// // // //     .map((item) => ({
// // // //       ...item,
// // // //       total: totalFromCounts(item),
// // // //     }))
// // // //     .sort((a, b) => a.label.localeCompare(b.label));
// // // // }

// // // // function buildDirectionData(rows) {
// // // //   const grouped = {};

// // // //   rows.forEach((row) => {
// // // //     const direction = row.direction || "All Directions";

// // // //     if (!grouped[direction]) {
// // // //       grouped[direction] = {
// // // //         direction,
// // // //         auto: 0,
// // // //         motorbike: 0,
// // // //         bus: 0,
// // // //         car: 0,
// // // //         truck: 0,
// // // //       };
// // // //     }

// // // //     VEHICLE_TYPES.forEach((type) => {
// // // //       grouped[direction][type] += Number(row[type] || 0);
// // // //     });
// // // //   });

// // // //   return Object.values(grouped).map((item) => ({
// // // //     ...item,
// // // //     total: totalFromCounts(item),
// // // //   }));
// // // // }

// // // // function CameraMapFlyTo({ selectedLocation }) {
// // // //   const map = useMap();

// // // //   useEffect(() => {
// // // //     if (!selectedLocation) return;

// // // //     map.flyTo([selectedLocation.lat, selectedLocation.lng], 16, {
// // // //       duration: 0.8,
// // // //     });
// // // //   }, [map, selectedLocation]);

// // // //   return null;
// // // // }

// // // // function MiniBarChart({ title, data }) {
// // // //   const maxValue = Math.max(...data.map((item) => item.total), 1);

// // // //   return (
// // // //     <div className="camera-chart-card">
// // // //       <div className="camera-chart-header">
// // // //         <h3>{title}</h3>
// // // //       </div>

// // // //       <div className="camera-bar-chart">
// // // //         {data.length === 0 && <p className="camera-empty-text">No data available</p>}

// // // //         {data.map((item) => {
// // // //           const height = Math.max(8, (item.total / maxValue) * 150);

// // // //           return (
// // // //             <div className="camera-bar-item" key={item.label}>
// // // //               <div className="camera-bar-value">{item.total}</div>
// // // //               <div className="camera-bar-track">
// // // //                 <div
// // // //                   className="camera-bar-fill"
// // // //                   style={{ height: `${height}px` }}
// // // //                 />
// // // //               </div>
// // // //               <div className="camera-bar-label">{item.label}</div>
// // // //             </div>
// // // //           );
// // // //         })}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // // function CameraDataPage({ navigate }) {
// // // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [selectedLocation, setSelectedLocation] = useState(CAMERA_LOCATIONS[0]);
// // // //   const [chartMode, setChartMode] = useState("daily");

// // // //   const [page, setPage] = useState(1);
// // // //   const [limit, setLimit] = useState(25);

// // // //   useEffect(() => {
// // // //     const csvUrl =
// // // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // // //     fetch(csvUrl)
// // // //       .then((res) => {
// // // //         if (!res.ok) throw new Error("CSV not found");
// // // //         return res.text();
// // // //       })
// // // //       .then((text) => {
// // // //         const parsed = parseCameraCsv(text);
// // // //         if (parsed.length > 0) {
// // // //           setRows(parsed.reverse());
// // // //           setSourceLabel("CSV data");
// // // //           setPage(1);
// // // //         }
// // // //       })
// // // //       .catch(() => {
// // // //         setRows(CAMERA_FALLBACK_DATA);
// // // //         setSourceLabel("Static sample data");
// // // //       })
// // // //       .finally(() => setLoading(false));
// // // //   }, []);

// // // //   const selectedRows = useMemo(() => {
// // // //     const hasCameraSpecificRows = rows.some((row) => row.cameraId !== "ALL");

// // // //     if (!hasCameraSpecificRows) {
// // // //       return rows;
// // // //     }

// // // //     return rows.filter((row) => row.cameraId === selectedLocation.id);
// // // //   }, [rows, selectedLocation]);

// // // //   const totals = useMemo(() => sumRows(selectedRows), [selectedRows]);
// // // //   const totalVehicles = totalFromCounts(totals);

// // // //   const dailyChartData = useMemo(() => buildChartData(selectedRows, "daily"), [selectedRows]);
// // // //   const weeklyChartData = useMemo(() => buildChartData(selectedRows, "weekly"), [selectedRows]);
// // // //   const directionData = useMemo(() => buildDirectionData(selectedRows), [selectedRows]);

// // // //   const chartData = chartMode === "weekly" ? weeklyChartData : dailyChartData;

// // // //   const totalRows = selectedRows.length;
// // // //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// // // //   const safePage = Math.min(page, totalPages);
// // // //   const offset = (safePage - 1) * limit;

// // // //   const paginatedRows = useMemo(() => {
// // // //     return selectedRows.slice(offset, offset + limit);
// // // //   }, [selectedRows, offset, limit]);

// // // //   const latestRow = selectedRows[0];

// // // //   const handleLocationClick = (location) => {
// // // //     setSelectedLocation(location);
// // // //     setPage(1);
// // // //   };

// // // //   const handleLimitChange = (e) => {
// // // //     setLimit(Number(e.target.value));
// // // //     setPage(1);
// // // //   };

// // // //   return (
// // // //     <div className="camera-page">
// // // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // // //       <header className="camera-navbar">
// // // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // // //           ← Home
// // // //         </button>

// // // //         <div>
// // // //           <h1>Camera Data</h1>
// // // //           <p>Traffic counts by vehicle type and camera location</p>
// // // //         </div>

// // // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // // //           Bus Tracking
// // // //         </button>
// // // //       </header>

// // // //       <main className="camera-content">
// // // //         <section className="camera-summary-grid">
// // // //           <div className="camera-summary-card total">
// // // //             <span>Total Vehicles</span>
// // // //             <strong>{totalVehicles}</strong>
// // // //             <small>{sourceLabel}</small>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Cars</span>
// // // //             <strong>{totals.car}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Motorbikes</span>
// // // //             <strong>{totals.motorbike}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Buses</span>
// // // //             <strong>{totals.bus}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Trucks</span>
// // // //             <strong>{totals.truck}</strong>
// // // //           </div>

// // // //           <div className="camera-summary-card">
// // // //             <span>Autos</span>
// // // //             <strong>{totals.auto}</strong>
// // // //           </div>
// // // //         </section>

// // // //         <section className="camera-map-layout">
// // // //           <aside className="camera-location-panel">
// // // //             <div className="camera-location-header">
// // // //               <h2>Camera Locations</h2>
// // // //               <p>{CAMERA_LOCATIONS.reduce((sum, item) => sum + item.cameras, 0)} cameras across {CAMERA_LOCATIONS.length} locations</p>
// // // //             </div>

// // // //             <div className="camera-location-list">
// // // //               {CAMERA_LOCATIONS.map((item) => (
// // // //                 <button
// // // //                   key={item.id}
// // // //                   className={
// // // //                     selectedLocation.id === item.id
// // // //                       ? "camera-location-item active"
// // // //                       : "camera-location-item"
// // // //                   }
// // // //                   onClick={() => handleLocationClick(item)}
// // // //                 >
// // // //                   <div>
// // // //                     <strong>{item.place}</strong>
// // // //                     <span>{item.location}</span>
// // // //                   </div>

// // // //                   <small>
// // // //                     {item.cameras} camera{item.cameras > 1 ? "s" : ""}
// // // //                   </small>
// // // //                 </button>
// // // //               ))}
// // // //             </div>
// // // //           </aside>

// // // //           <section className="camera-map-card">
// // // //             <MapContainer
// // // //               center={[selectedLocation.lat, selectedLocation.lng]}
// // // //               zoom={14}
// // // //               className="camera-osm-map"
// // // //               scrollWheelZoom={true}
// // // //             >
// // // //               <TileLayer
// // // //                 attribution='&copy; OpenStreetMap contributors'
// // // //                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
// // // //               />

// // // //               <CameraMapFlyTo selectedLocation={selectedLocation} />

// // // //               {CAMERA_LOCATIONS.map((item) => (
// // // //                 <Marker
// // // //                   key={item.id}
// // // //                   position={[item.lat, item.lng]}
// // // //                   eventHandlers={{
// // // //                     click: () => handleLocationClick(item),
// // // //                   }}
// // // //                 >
// // // //                   <Popup>
// // // //                     <div className="camera-popup">
// // // //                       <h3>{item.place}</h3>
// // // //                       <p>{item.location}</p>
// // // //                       <p>
// // // //                         <strong>Cameras:</strong> {item.cameras}
// // // //                       </p>
// // // //                       <p>
// // // //                         <strong>Total Vehicles:</strong>{" "}
// // // //                         {selectedLocation.id === item.id ? totalVehicles : "Click location"}
// // // //                       </p>
// // // //                     </div>
// // // //                   </Popup>
// // // //                 </Marker>
// // // //               ))}
// // // //             </MapContainer>
// // // //           </section>
// // // //         </section>

// // // //         <section className="camera-selected-panel">
// // // //           <div>
// // // //             <h2>{selectedLocation.place}</h2>
// // // //             <p>{selectedLocation.location}</p>
// // // //           </div>

// // // //           <div className="camera-selected-meta">
// // // //             <span>{selectedLocation.boxes} boxes</span>
// // // //             <span>{selectedLocation.cameras} cameras</span>
// // // //             <span>
// // // //               {selectedLocation.lat}, {selectedLocation.lng}
// // // //             </span>
// // // //           </div>
// // // //         </section>

// // // //         {/* <section className="camera-direction-grid">
// // // //           {directionData.map((item) => (
// // // //             <div className="camera-direction-card" key={item.direction}>
// // // //               <span>{item.direction}</span>
// // // //               <strong>{item.total}</strong>
// // // //               <small>
// // // //                 Car {item.car} | Bike {item.motorbike} | Bus {item.bus}
// // // //               </small>
// // // //             </div>
// // // //           ))}
// // // //         </section> */}

// // // //         <section className="camera-chart-section">
// // // //           <div className="camera-chart-toolbar">
// // // //             <div>
// // // //               <h2>Dashboard Analysis</h2>
// // // //               <p>Daily and weekly traffic count trends</p>
// // // //             </div>

// // // //             <div className="camera-chart-toggle">
// // // //               <button
// // // //                 className={chartMode === "daily" ? "active" : ""}
// // // //                 onClick={() => setChartMode("daily")}
// // // //               >
// // // //                 Daily
// // // //               </button>
// // // //               <button
// // // //                 className={chartMode === "weekly" ? "active" : ""}
// // // //                 onClick={() => setChartMode("weekly")}
// // // //               >
// // // //                 Weekly
// // // //               </button>
// // // //             </div>
// // // //           </div>

// // // //           <MiniBarChart
// // // //             title={chartMode === "weekly" ? "Weekly Vehicle Counts" : "Daily Vehicle Counts"}
// // // //             data={chartData}
// // // //           />
// // // //         </section>

// // // //         <section className="camera-panel">
// // // //           <div className="camera-panel-header">
// // // //             <div>
// // // //               <h2>Vehicle Count Table</h2>
// // // //               <p>
// // // //                 {loading
// // // //                   ? "Loading camera data..."
// // // //                   : latestRow
// // // //                   ? `Latest timestamp: ${latestRow.timestamp}`
// // // //                   : "No camera records available"}
// // // //               </p>
// // // //             </div>

// // // //             <div className="camera-pagination-top">
// // // //               <label>
// // // //                 Limit
// // // //                 <select value={limit} onChange={handleLimitChange}>
// // // //                   <option value={10}>10</option>
// // // //                   <option value={25}>25</option>
// // // //                   <option value={50}>50</option>
// // // //                   <option value={100}>100</option>
// // // //                   <option value={200}>200</option>
// // // //                 </select>
// // // //               </label>
// // // //             </div>
// // // //           </div>

// // // //           <div className="camera-table-info">
// // // //             <span>
// // // //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// // // //               {Math.min(offset + limit, totalRows)} of {totalRows}
// // // //             </span>

// // // //             <span>
// // // //               Offset: {offset} | Limit: {limit}
// // // //             </span>
// // // //           </div>

// // // //           <div className="camera-table-wrap">
// // // //             <table className="camera-table">
// // // //               <thead>
// // // //                 <tr>
// // // //                   <th>Timestamp</th>
// // // //                   <th>Direction</th>
// // // //                   <th>Auto</th>
// // // //                   <th>Motorbike</th>
// // // //                   <th>Bus</th>
// // // //                   <th>Car</th>
// // // //                   <th>Truck</th>
// // // //                 </tr>
// // // //               </thead>

// // // //               <tbody>
// // // //                 {paginatedRows.map((row, index) => (
// // // //                   <tr key={`${row.timestamp}-${index}`}>
// // // //                     <td>{row.timestamp}</td>
// // // //                     <td>{row.direction}</td>
// // // //                     <td>{row.auto}</td>
// // // //                     <td>{row.motorbike}</td>
// // // //                     <td>{row.bus}</td>
// // // //                     <td>{row.car}</td>
// // // //                     <td>{row.truck}</td>
// // // //                   </tr>
// // // //                 ))}

// // // //                 {!loading && paginatedRows.length === 0 && (
// // // //                   <tr>
// // // //                     <td colSpan="7" style={{ textAlign: "center", padding: "24px" }}>
// // // //                       No camera data available
// // // //                     </td>
// // // //                   </tr>
// // // //                 )}
// // // //               </tbody>
// // // //             </table>
// // // //           </div>

// // // //           <div className="camera-pagination-bottom">
// // // //             <button onClick={() => setPage((prev) => Math.max(1, prev - 1))} disabled={safePage <= 1}>
// // // //               ← Previous
// // // //             </button>

// // // //             <span>
// // // //               Page {safePage} of {totalPages}
// // // //             </span>

// // // //             <button onClick={() => setPage((prev) => Math.min(totalPages, prev + 1))} disabled={safePage >= totalPages}>
// // // //               Next →
// // // //             </button>
// // // //           </div>
// // // //         </section>
// // // //       </main>
// // // //     </div>
// // // //   );
// // // // }
// // // // // function CameraDataPage({ navigate }) {
// // // // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // // // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   // Pagination states
// // // // //   const [page, setPage] = useState(1);
// // // // //   const [limit, setLimit] = useState(25);

// // // // //   useEffect(() => {
// // // // //     const csvUrl =
// // // // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // // // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // // // //     fetch(csvUrl)
// // // // //       .then((res) => {
// // // // //         if (!res.ok) throw new Error("CSV not found");
// // // // //         return res.text();
// // // // //       })
// // // // //       .then((text) => {
// // // // //         const parsed = parseCameraCsv(text);
// // // // //         if (parsed.length > 0) {
// // // // //           // latest data first
// // // // //           setRows(parsed.reverse());
// // // // //           setSourceLabel("CSV data");
// // // // //           setPage(1);
// // // // //         }
// // // // //       })
// // // // //       .catch(() => {
// // // // //         setRows(CAMERA_FALLBACK_DATA);
// // // // //         setSourceLabel("Static sample data");
// // // // //       })
// // // // //       .finally(() => setLoading(false));
// // // // //   }, []);

// // // // //   const totals = useMemo(() => {
// // // // //     return rows.reduce(
// // // // //       (acc, row) => {
// // // // //         acc.auto += Number(row.auto || 0);
// // // // //         acc.motorbike += Number(row.motorbike || 0);
// // // // //         acc.bus += Number(row.bus || 0);
// // // // //         acc.car += Number(row.car || 0);
// // // // //         acc.truck += Number(row.truck || 0);
// // // // //         return acc;
// // // // //       },
// // // // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // // // //     );
// // // // //   }, [rows]);

// // // // //   const totalVehicles =
// // // // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // // // //   const totalRows = rows.length;
// // // // //   const totalPages = Math.max(1, Math.ceil(totalRows / limit));
// // // // //   const safePage = Math.min(page, totalPages);

// // // // //   const offset = (safePage - 1) * limit;

// // // // //   const paginatedRows = useMemo(() => {
// // // // //     return rows.slice(offset, offset + limit);
// // // // //   }, [rows, offset, limit]);

// // // // //   const latestRow = rows[0];

// // // // //   const goToPreviousPage = () => {
// // // // //     setPage((prev) => Math.max(1, prev - 1));
// // // // //   };

// // // // //   const goToNextPage = () => {
// // // // //     setPage((prev) => Math.min(totalPages, prev + 1));
// // // // //   };

// // // // //   const handleLimitChange = (e) => {
// // // // //     setLimit(Number(e.target.value));
// // // // //     setPage(1);
// // // // //   };

// // // // //   return (
// // // // //     <div className="camera-page">
// // // // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // // // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // // // //       <header className="camera-navbar">
// // // // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // // // //           ← Home
// // // // //         </button>

// // // // //         <div>
// // // // //           <h1>Camera Data</h1>
// // // // //           <p>Vehicle count analytics</p>
// // // // //         </div>

// // // // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // // // //           Bus Tracking
// // // // //         </button>
// // // // //       </header>

// // // // //       <main className="camera-content">
// // // // //         <section className="camera-summary-grid">
// // // // //           <div className="camera-summary-card total">
// // // // //             <span>Total Vehicles</span>
// // // // //             <strong>{totalVehicles}</strong>
// // // // //             <small>{sourceLabel}</small>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Cars</span>
// // // // //             <strong>{totals.car}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Motorbikes</span>
// // // // //             <strong>{totals.motorbike}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Buses</span>
// // // // //             <strong>{totals.bus}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Trucks</span>
// // // // //             <strong>{totals.truck}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Autos</span>
// // // // //             <strong>{totals.auto}</strong>
// // // // //           </div>
// // // // //         </section>

// // // // //         <section className="camera-panel">
// // // // //           <div className="camera-panel-header">
// // // // //             <div>
// // // // //               <h2>Vehicle Count Table</h2>
// // // // //               <p>
// // // // //                 {loading
// // // // //                   ? "Loading camera data..."
// // // // //                   : latestRow
// // // // //                     ? `Latest timestamp: ${latestRow.timestamp}`
// // // // //                     : "No camera records available"}
// // // // //               </p>
// // // // //             </div>

// // // // //             <div className="camera-pagination-top">
// // // // //               <label>
// // // // //                 Limit
// // // // //                 <select value={limit} onChange={handleLimitChange}>
// // // // //                   <option value={10}>10</option>
// // // // //                   <option value={25}>25</option>
// // // // //                   <option value={50}>50</option>
// // // // //                   <option value={100}>100</option>
// // // // //                   <option value={200}>200</option>
// // // // //                 </select>
// // // // //               </label>
// // // // //             </div>
// // // // //           </div>

// // // // //           <div className="camera-table-info">
// // // // //             <span>
// // // // //               Showing rows {totalRows === 0 ? 0 : offset + 1}-
// // // // //               {Math.min(offset + limit, totalRows)} of {totalRows}
// // // // //             </span>

// // // // //             <span>
// // // // //               Offset: {offset} | Limit: {limit}
// // // // //             </span>
// // // // //           </div>

// // // // //           <div className="camera-table-wrap">
// // // // //             <table className="camera-table">
// // // // //               <thead>
// // // // //                 <tr>
// // // // //                   <th>Timestamp</th>
// // // // //                   <th>Auto</th>
// // // // //                   <th>Motorbike</th>
// // // // //                   <th>Bus</th>
// // // // //                   <th>Car</th>
// // // // //                   <th>Truck</th>
// // // // //                 </tr>
// // // // //               </thead>

// // // // //               <tbody>
// // // // //                 {paginatedRows.map((row, index) => (
// // // // //                   <tr key={`${row.timestamp}-${index}`}>
// // // // //                     <td>{row.timestamp}</td>
// // // // //                     <td>{row.auto}</td>
// // // // //                     <td>{row.motorbike}</td>
// // // // //                     <td>{row.bus}</td>
// // // // //                     <td>{row.car}</td>
// // // // //                     <td>{row.truck}</td>
// // // // //                   </tr>
// // // // //                 ))}

// // // // //                 {!loading && paginatedRows.length === 0 && (
// // // // //                   <tr>
// // // // //                     <td colSpan="6" style={{ textAlign: "center", padding: "24px" }}>
// // // // //                       No camera data available
// // // // //                     </td>
// // // // //                   </tr>
// // // // //                 )}
// // // // //               </tbody>
// // // // //             </table>
// // // // //           </div>

// // // // //           <div className="camera-pagination-bottom">
// // // // //             <button onClick={goToPreviousPage} disabled={safePage <= 1}>
// // // // //               ← Previous
// // // // //             </button>

// // // // //             <span>
// // // // //               Page {safePage} of {totalPages}
// // // // //             </span>

// // // // //             <button onClick={goToNextPage} disabled={safePage >= totalPages}>
// // // // //               Next →
// // // // //             </button>
// // // // //           </div>
// // // // //         </section>
// // // // //       </main>
// // // // //     </div>
// // // // //   );
// // // // // }
// // // // // function CameraDataPage({ navigate }) {
// // // // //   const [rows, setRows] = useState(CAMERA_FALLBACK_DATA);
// // // // //   const [sourceLabel, setSourceLabel] = useState("Static sample data");
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   useEffect(() => {
// // // // //     const csvUrl =
// // // // //       process.env.REACT_APP_CAMERA_CSV_URL ||
// // // // //       `${process.env.PUBLIC_URL || ""}/camera-counts.csv`;

// // // // //     fetch(csvUrl)
// // // // //       .then((res) => {
// // // // //         if (!res.ok) throw new Error("CSV not found");
// // // // //         return res.text();
// // // // //       })
// // // // //       .then((text) => {
// // // // //         const parsed = parseCameraCsv(text);
// // // // //         if (parsed.length > 0) {
// // // // //           setRows(parsed);
// // // // //           setSourceLabel("CSV data");
// // // // //         }
// // // // //       })
// // // // //       .catch(() => {
// // // // //         setRows(CAMERA_FALLBACK_DATA);
// // // // //         setSourceLabel("Static sample data");
// // // // //       })
// // // // //       .finally(() => setLoading(false));
// // // // //   }, []);

// // // // //   const totals = useMemo(() => {
// // // // //     return rows.reduce(
// // // // //       (acc, row) => {
// // // // //         acc.auto += Number(row.auto || 0);
// // // // //         acc.motorbike += Number(row.motorbike || 0);
// // // // //         acc.bus += Number(row.bus || 0);
// // // // //         acc.car += Number(row.car || 0);
// // // // //         acc.truck += Number(row.truck || 0);
// // // // //         return acc;
// // // // //       },
// // // // //       { auto: 0, motorbike: 0, bus: 0, car: 0, truck: 0 }
// // // // //     );
// // // // //   }, [rows]);

// // // // //   const totalVehicles =
// // // // //     totals.auto + totals.motorbike + totals.bus + totals.car + totals.truck;

// // // // //   const latestRow = rows[rows.length - 1];

// // // // //   return (
// // // // //     <div className="camera-page">
// // // // //       <div className="camera-bg-glow camera-bg-glow-one" />
// // // // //       <div className="camera-bg-glow camera-bg-glow-two" />

// // // // //       <header className="camera-navbar">
// // // // //         <button className="camera-back-button" onClick={() => navigate("/")}>
// // // // //           ← Home
// // // // //         </button>

// // // // //         <div>
// // // // //           <h1>Camera Data</h1>
// // // // //           <p>Vehicle count analytics</p>
// // // // //         </div>

// // // // //         <button className="camera-track-button" onClick={() => navigate("/tracking")}>
// // // // //           Bus Tracking
// // // // //         </button>
// // // // //       </header>

// // // // //       <main className="camera-content">
// // // // //         <section className="camera-summary-grid">
// // // // //           <div className="camera-summary-card total">
// // // // //             <span>Total Vehicles</span>
// // // // //             <strong>{totalVehicles}</strong>
// // // // //             <small>{sourceLabel}</small>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Cars</span>
// // // // //             <strong>{totals.car}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Motorbikes</span>
// // // // //             <strong>{totals.motorbike}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Buses</span>
// // // // //             <strong>{totals.bus}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Trucks</span>
// // // // //             <strong>{totals.truck}</strong>
// // // // //           </div>

// // // // //           <div className="camera-summary-card">
// // // // //             <span>Autos</span>
// // // // //             <strong>{totals.auto}</strong>
// // // // //           </div>
// // // // //         </section>

// // // // //         <section className="camera-panel">
// // // // //           <div className="camera-panel-header">
// // // // //             <div>
// // // // //               <h2>Vehicle Count Table</h2>
// // // // //               <p>
// // // // //                 {loading
// // // // //                   ? "Loading camera data..."
// // // // //                   : latestRow
// // // // //                   ? `Latest timestamp: ${latestRow.timestamp}`
// // // // //                   : "No camera records available"}
// // // // //               </p>
// // // // //             </div>
// // // // //           </div>

// // // // //           <div className="camera-table-wrap">
// // // // //             <table className="camera-table">
// // // // //               <thead>
// // // // //                 <tr>
// // // // //                   <th>Timestamp</th>
// // // // //                   <th>Auto</th>
// // // // //                   <th>Motorbike</th>
// // // // //                   <th>Bus</th>
// // // // //                   <th>Car</th>
// // // // //                   <th>Truck</th>
// // // // //                 </tr>
// // // // //               </thead>

// // // // //               <tbody>
// // // // //                 {rows.map((row, index) => (
// // // // //                   <tr key={`${row.timestamp}-${index}`}>
// // // // //                     <td>{row.timestamp}</td>
// // // // //                     <td>{row.auto}</td>
// // // // //                     <td>{row.motorbike}</td>
// // // // //                     <td>{row.bus}</td>
// // // // //                     <td>{row.car}</td>
// // // // //                     <td>{row.truck}</td>
// // // // //                   </tr>
// // // // //                 ))}
// // // // //               </tbody>
// // // // //             </table>
// // // // //           </div>
// // // // //         </section>
// // // // //       </main>
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // /* ---------------------------- APP (router) ---------------------------- */
// // // // /* ---------------------------- APP (router) ---------------------------- */

// // // // export default function App() {
// // // //   const { path, navigate } = usePath();
// // // //   const token = getToken();
// // // //   const adminToken = getAdminToken();

// // // //   // Track page views on bus tracking page for Prometheus
// // // //   useEffect(() => {
// // // //     if (!BACKEND) return;
// // // //     if (path !== "/tracking") return;
// // // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// // // //   }, [path]);

// // // //   // Forward /driver -> /driverRoute when logged in
// // // //   useEffect(() => {
// // // //     if (path === "/driver" && token) {
// // // //       navigate("/driverRoute");
// // // //     }
// // // //   }, [path, token, navigate]);

// // // //   // Admin redirects
// // // //   useEffect(() => {
// // // //     if (path === "/admin/login" && adminToken) {
// // // //       navigate("/admin");
// // // //     } else if (path === "/admin" && !adminToken) {
// // // //       navigate("/admin/login");
// // // //     }
// // // //   }, [path, adminToken, navigate]);

// // // //   // New public pages
// // // //   if (path === "/") {
// // // //     return <HomePage navigate={navigate} />;
// // // //   }

// // // //   if (path === "/tracking") {
// // // //     return <MapPage />;
// // // //   }

// // // //   if (path === "/camera") {
// // // //     return <CameraDataPage navigate={navigate} />;
// // // //   }

// // // //   // Existing driver pages
// // // //   if (path === "/driver") {
// // // //     if (token) return null;
// // // //     return <DriverLogin navigate={navigate} />;
// // // //   }

// // // //   if (path === "/driverRoute") {
// // // //     return <DriverRoute navigate={navigate} />;
// // // //   }

// // // //   // Existing admin pages
// // // //   if (path === "/admin/login") {
// // // //     if (adminToken) return null;
// // // //     return <AdminLogin navigate={navigate} />;
// // // //   }

// // // //   if (path === "/admin") {
// // // //     return <AdminDashboard navigate={navigate} />;
// // // //   }

// // // //   // Fallback
// // // //   return <HomePage navigate={navigate} />;
// // // // }

// // // // // export default function App() {
// // // // //   const { path, navigate } = usePath();
// // // // //   const token = getToken();
// // // // //   const adminToken = getAdminToken();

// // // // //   // Track page views on main map for Prometheus
// // // // //   useEffect(() => {
// // // // //     if (!BACKEND) return;
// // // // //     if (path !== "/") return;
// // // // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => { });
// // // // //   }, [path]);

// // // // //   // Forward /driver -> /driverRoute when logged in
// // // // //   useEffect(() => {
// // // // //     if (path === "/driver" && token) {
// // // // //       navigate("/driverRoute");
// // // // //     }
// // // // //   }, [path, token, navigate]);

// // // // //   // Admin redirects
// // // // //   useEffect(() => {
// // // // //     if (path === "/admin/login" && adminToken) {
// // // // //       navigate("/admin");
// // // // //     } else if (path === "/admin" && !adminToken) {
// // // // //       navigate("/admin/login");
// // // // //     }
// // // // //   }, [path, adminToken, navigate]);

// // // // //   if (path === "/driver") {
// // // // //     if (token) return null;
// // // // //     return <DriverLogin navigate={navigate} />;
// // // // //   }
// // // // //   if (path === "/driverRoute") return <DriverRoute navigate={navigate} />;

// // // // //   if (path === "/admin/login") {
// // // // //     if (adminToken) return null;
// // // // //     return <AdminLogin navigate={navigate} />;
// // // // //   }
// // // // //   if (path === "/admin") {
// // // // //     return <AdminDashboard navigate={navigate} />;
// // // // //   }

// // // // //   return <MapPage />;
// // // // // }

// // // // // export default function App() {
// // // // //   const { path, navigate } = usePath();
// // // // //   const token = getToken();

// // // // //   // Track page views on main map for Prometheus
// // // // //   useEffect(() => {
// // // // //     if (!BACKEND) return;
// // // // //     if (path !== "/") return;
// // // // //     axios.post(`${BACKEND}/api/track/page-view`).catch(() => {});
// // // // //   }, [path]);

// // // // //   // Forward /driver -> /driverRoute when logged in (no hooks called conditionally)
// // // // //   useEffect(() => {
// // // // //     if (path === '/driver' && token) {
// // // // //       navigate('/driverRoute');
// // // // //     }
// // // // //   }, [path, token, navigate]);

// // // // //   if (path === '/driver') {
// // // // //     if (token) return null;
// // // // //     return <DriverLogin navigate={navigate} />;
// // // // //   }
// // // // //   if (path === '/driverRoute') return <DriverRoute navigate={navigate} />;
// // // // //   return <MapPage />;
// // // // // }